export const homeData = {
  "generated_at": "2026-06-16T13:19:00.643Z",
  "counts": {
    "cases": 5,
    "insights": 5,
    "total": 10
  },
  "links": {
    "github_repo": "https://github.com/kunhai-88/ai-podcast-radar",
    "author_x": "https://x.com/kunhai_88",
    "subscribe_email": "384037191@qq.com",
    "harness_dashboard": "/harness/"
  },
  "featured": [
    {
      "id": "case-whatsapp-cli-prototype",
      "type": "case",
      "title": "WhatsApp + cloud code 一小时做出可对话原型",
      "person": "Peter Steinberger, prototype builder",
      "org_or_role": "OpenClaw prototype",
      "summary": "Peter Steinberger, prototype builder · OpenClaw prototype",
      "episode_id": "491-openclaw-the-viral-ai-agent-that-broke-the-internet-peter-steinberger",
      "episode_label": "Openclaw The Viral AI Agent That",
      "tags": [
        "agent",
        "harness-smoke",
        "messaging",
        "prototype"
      ],
      "quote": "my search bar was literally just hooking up WhatsApp to cloud code. One shot. The CLI message comes in. I call the CLI with -p. It does its magic, I get the string back and I send it back to WhatsApp.",
      "timestamp": "00:10:52",
      "claim": "把 WhatsApp 输入直接接到 CLI `-p`，拿回字符串结果再发回 WhatsApp。"
    },
    {
      "id": "insight-agentic-engineering-over-wipe-coding",
      "type": "insight",
      "title": "Peter Steinberger 把持续可维护的做法叫做 agentic engineering",
      "person": "Peter Steinberger",
      "org_or_role": "OpenClaw creator and agent builder",
      "summary": "Peter Steinberger · OpenClaw creator and agent builder",
      "episode_id": "491-openclaw-the-viral-ai-agent-that-broke-the-internet-peter-steinberger",
      "episode_label": "Openclaw The Viral AI Agent That",
      "tags": [
        "agent",
        "engineering",
        "workflow"
      ],
      "quote": "I do agentic engineering, and then maybe after 3:00 AM, I switch to wipe coding, and then I have regrets on the next day.",
      "timestamp": "00:00:33",
      "claim": "更合理的工作方式是 agentic engineering；凌晨失控式的 wipe coding 往往会带来第二天的返工后悔。"
    },
    {
      "id": "case-openclaw-self-modifying-agent",
      "type": "case",
      "title": "OpenClaw 把 agent 做成可自我修改的软件体",
      "person": "Peter Steinberger, OpenClaw creator",
      "org_or_role": "OpenClaw",
      "summary": "Peter Steinberger, OpenClaw creator · OpenClaw",
      "episode_id": "491-openclaw-the-viral-ai-agent-that-broke-the-internet-peter-steinberger",
      "episode_label": "Openclaw The Viral AI Agent That",
      "tags": [
        "ai-coding",
        "agent",
        "harness"
      ],
      "quote": "It understands its own system that made it very easy for an agent to… Oh, you don’t like anything? You just prompted it to existence, and then the agent would just modify its own software.",
      "timestamp": "00:00:00",
      "claim": "把 source code、harness、documentation 和 model 信息暴露给 agent，让它能修改自己的软件。"
    },
    {
      "id": "insight-scaling-laws-need-all-three-reagents",
      "type": "insight",
      "title": "Dario Amodei 把 scaling law 讲成三个试剂必须一起放大",
      "person": "Dario Amodei",
      "org_or_role": "Anthropic CEO",
      "summary": "Dario Amodei · Anthropic CEO",
      "episode_id": "452-dario-amodei-anthropic-ceo-on-claude-agi-the-future-of-ai-humanity",
      "episode_label": "Dario Amodei Anthropic Ceo On Claude",
      "tags": [
        "scaling-laws",
        "training",
        "infrastructure"
      ],
      "quote": "you have three ingredients in the chemical reaction and you need to linearly scale up the three ingredients. If you scale up one, not the others, you run out of the other reagents and the reaction stops.",
      "timestamp": "00:07:17",
      "claim": "更大的网络、更多训练时间和更多数据必须协同放大，单独拉一项会先撞到其他瓶颈。"
    },
    {
      "id": "case-viptunnel-zig-refactor",
      "type": "case",
      "title": "Viptunnel 用 Codex 隔夜完成高内存架构段重写",
      "person": "Peter Steinberger, Viptunnel builder",
      "org_or_role": "Viptunnel",
      "summary": "Peter Steinberger, Viptunnel builder · Viptunnel",
      "episode_id": "491-openclaw-the-viral-ai-agent-that-broke-the-internet-peter-steinberger",
      "episode_label": "Openclaw The Viral AI Agent That",
      "tags": [
        "ai-coding",
        "refactoring",
        "performance"
      ],
      "quote": "Every terminal used like a node. And I wanted to change it to Rust and… I mean, I can do it. I can, I can manually figure it all out, but all my automated attempts failed miserably.",
      "timestamp": "00:09:41",
      "claim": "直接让 Codex 把高内存部分转换到更实验性的实现路径，并长时间自主运行。"
    },
    {
      "id": "insight-founders-should-stay-builders",
      "type": "insight",
      "title": "Pieter Levels 认为很多创业者更适合持续做 builder 而不是变成 manager",
      "person": "Pieter Levels",
      "org_or_role": "indie founder with 40+ shipped startups",
      "summary": "Pieter Levels · indie founder with 40+ shipped startups",
      "episode_id": "440-pieter-levels-programming-viral-ai-startups-and-digital-nomad-life",
      "episode_label": "Pieter Levels Programming Viral AI Startups",
      "tags": [
        "founders",
        "career",
        "indie"
      ],
      "quote": "they tell me, “Next time, if I’m going to do it, I’m going to do it like you, because it’s more fun, it’s more indie, it’s more chill, it’s more creative.”",
      "timestamp": "00:07:32",
      "claim": "不少创业者并不喜欢成为 CEO/manager，他们真正喜欢的是写代码和做 ground work。"
    },
    {
      "id": "case-anthropic-model-change-testing",
      "type": "case",
      "title": "Anthropic 用全流程测试和早期客户验证控制模型改动副作用",
      "person": "Dario Amodei, Anthropic CEO",
      "org_or_role": "Anthropic",
      "summary": "Dario Amodei, Anthropic CEO · Anthropic",
      "episode_id": "452-dario-amodei-anthropic-ceo-on-claude-agi-the-future-of-ai-humanity",
      "episode_label": "Dario Amodei Anthropic Ceo On Claude",
      "tags": [
        "model-ops",
        "evaluation",
        "customer-testing"
      ],
      "quote": "It’s difficult from an inference perspective and it’s actually hard to control all the consequences of changing the weights of the model.",
      "timestamp": "00:43:09",
      "claim": "把模型改动纳入正式流程，并结合内部测试和 early customer user testing。"
    },
    {
      "id": "insight-model-dumbing-down-is-often-a-perception-problem",
      "type": "insight",
      "title": "Dario Amodei 认为模型“变笨”投诉常混杂 A/B 测试、系统提示词和心理基线变化",
      "person": "Dario Amodei",
      "org_or_role": "Anthropic CEO",
      "summary": "Dario Amodei · Anthropic CEO",
      "episode_id": "452-dario-amodei-anthropic-ceo-on-claude-agi-the-future-of-ai-humanity",
      "episode_label": "Dario Amodei Anthropic Ceo On Claude",
      "tags": [
        "model-behavior",
        "ab-testing",
        "product-perception"
      ],
      "quote": "You actually end up changing 100 things as well. So we have a whole process for it and we have a whole process for modifying the model.",
      "timestamp": "00:43:09",
      "claim": "用户感知到的模型“变笨”并不等于权重被随机改坏，很多时候是实验流量、系统提示词变化或用户预期抬高造成的。"
    }
  ],
  "sections": {
    "business_tags": [
      {
        "slug": "agent",
        "label": "Agent",
        "href": "#content-list",
        "count": 2
      },
      {
        "slug": "ai-coding",
        "label": "AI Coding",
        "href": "#content-list",
        "count": 2
      },
      {
        "slug": "customer-testing",
        "label": "Customer Testing",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "evaluation",
        "label": "评估",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "guardrails",
        "label": "Guardrails",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "harness",
        "label": "Harness",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "harness-smoke",
        "label": "Harness Smoke",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "imaging",
        "label": "Imaging",
        "href": "#content-list",
        "count": 1
      }
    ],
    "insight_tags": [
      {
        "slug": "ab-testing",
        "label": "Ab Testing",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "agent",
        "label": "Agent",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "agi",
        "label": "AGI",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "capability-scaling",
        "label": "Capability Scaling",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "career",
        "label": "Career",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "engineering",
        "label": "工程方法",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "forecasting",
        "label": "Forecasting",
        "href": "#content-list",
        "count": 1
      },
      {
        "slug": "founders",
        "label": "Founders",
        "href": "#content-list",
        "count": 1
      }
    ]
  },
  "podcasts": {
    "configured": true,
    "total_sources": 34,
    "total_episodes": 5894,
    "selected_episodes": 4933,
    "items": [
      {
        "id": "latent-space",
        "title": "Latent Space: The AI Engineer Podcast",
        "feed_title": "Latent Space: The AI Engineer Podcast",
        "priority": "P0",
        "selection_mode": "all_ai",
        "focus": [
          "AI engineering",
          "agents",
          "LLM apps",
          "AI infra",
          "developer tools"
        ],
        "feed_url": "https://api.substack.com/feed/podcast/1084089.rss",
        "source_url": "https://api.substack.com/feed/podcast/1084089.rss",
        "detail_path": "/podcasts/latent-space/",
        "episode_count": 200,
        "selected_episode_count": 200,
        "latest_episode_title": "Reality: The Final Eval — Lukas Petersson and Axel Backlund of Andon Labs",
        "latest_pub_date": "2026-06-04T20:39:18.000Z",
        "latest_page_url": "https://www.latent.space/p/andon",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "substack:post:200614482",
            "index": 1,
            "title": "Reality: The Final Eval — Lukas Petersson and Axel Backlund of Andon Labs",
            "pub_date": "2026-06-04T20:39:18.000Z",
            "duration": "4539",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/andon",
            "audio_url": "https://api.substack.com/feed/podcast/200614482/b8155f27572ea1cda50b33bd50e67f32.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_catalog_embedded_transcript",
              "transcript_record_count": 478,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:199994886",
            "index": 2,
            "title": "🔬Scaling Past Informal AI - Carina Hong, Axiom Math",
            "pub_date": "2026-06-03T19:27:49.000Z",
            "duration": "5584",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "chatgpt",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/axiom",
            "audio_url": "https://api.substack.com/feed/podcast/199994886/ba6647aab39199a4ad19cb037e6a8011.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:200432443",
            "index": 3,
            "title": "⚡️Satya Nadella: No Priors x Latent Space Crossover Special at Microsoft Build",
            "pub_date": "2026-06-03T17:13:57.000Z",
            "duration": "2338",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "frontier model",
              "agent",
              "agents",
              "agentic",
              "openai",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/satya-2026",
            "audio_url": "https://api.substack.com/feed/podcast/200432443/dff0614ab10e21be66d39c4847157a18.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:200249307",
            "index": 4,
            "title": "GitHub's plan for Agents — Kyle Daigle, GitHub",
            "pub_date": "2026-06-02T16:48:21.000Z",
            "duration": "5007",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/github",
            "audio_url": "https://api.substack.com/feed/podcast/200249307/b006a03717ddcc40eb59c02b49063879.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_catalog_embedded_transcript",
              "transcript_record_count": 290,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:200078058",
            "index": 5,
            "title": "Why Video Agent models are next — Ethan He, xAI Grok Imagine",
            "pub_date": "2026-06-01T15:41:48.000Z",
            "duration": "6206",
            "duration_label": "1h 43m",
            "selected": true,
            "confidence": "high",
            "score": 34,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/video-agents",
            "audio_url": "https://api.substack.com/feed/podcast/200078058/56912def1d75ae2fd41c2c564dfe08cf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_catalog_embedded_transcript",
              "transcript_record_count": 482,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:199607874",
            "index": 6,
            "title": "The Age of Async Agents — Cognition's Walden Yan & OpenInspect's Cole Murray",
            "pub_date": "2026-05-28T18:41:24.000Z",
            "duration": "4082",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "frontier model",
              "agent",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/cognition",
            "audio_url": "https://api.substack.com/feed/podcast/199607874/583bc5ffc268ed91c9847c65cd631492.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_catalog_embedded_transcript",
              "transcript_record_count": 252,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:199487836",
            "index": 7,
            "title": "🔬ESM: The Bitter Lesson is Coming for Proteins - Alex Rives, BioHub",
            "pub_date": "2026-05-27T17:46:16.000Z",
            "duration": "4212",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gpu",
              "inference",
              "training"
            ],
            "page_url": "https://www.latent.space/p/esmfold2",
            "audio_url": "https://api.substack.com/feed/podcast/199487836/d44a44519bdf8c14dc458f47d0972ffc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:198688585",
            "index": 8,
            "title": "Giving Agents Computers — Ivan Burazin, Daytona",
            "pub_date": "2026-05-21T20:37:40.000Z",
            "duration": "4227",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 27,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/daytona",
            "audio_url": "https://api.substack.com/feed/podcast/198688585/e48f923a6fb4c7f822f1f5013a97c41d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_catalog_embedded_transcript",
              "transcript_record_count": 403,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:198575235",
            "index": 9,
            "title": "Railway: The Agent-Native Cloud — Jake Cooper",
            "pub_date": "2026-05-20T22:42:06.000Z",
            "duration": "5314",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/railway",
            "audio_url": "https://api.substack.com/feed/podcast/198575235/fbd2be59f0c8aad59a022f3709b9b930.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_catalog_embedded_transcript",
              "transcript_record_count": 307,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:198200418",
            "index": 10,
            "title": "The Autonomous Drone Tech Stack & Economics of Drones — Yaroslav Azhnyuk, The Fourth Law & Guest Host Noah Smith, Noahpinion",
            "pub_date": "2026-05-18T13:45:32.000Z",
            "duration": "7168",
            "duration_label": "1h 59m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "claude",
              "training",
              "safety",
              "robotics",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/the-fourth-law",
            "audio_url": "https://api.substack.com/feed/podcast/198200418/d911388480315e62363f89b6bb57a310.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:197417280",
            "index": 11,
            "title": "AI-Native Healthcare: 100M Doctor Visits, 10–20 Hours Saved, Prior Auth in Minutes — Janie Lee & Chai Asawa, Abridge",
            "pub_date": "2026-05-14T22:05:31.000Z",
            "duration": "3920",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/abridge",
            "audio_url": "https://api.substack.com/feed/podcast/197417280/2d79546fa3b8f67062f71fa1b134c52c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 276,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:196292432",
            "index": 12,
            "title": "🔬Doing Vibe Physics — Alex Lupsasca, OpenAI",
            "pub_date": "2026-05-05T20:34:11.000Z",
            "duration": "5511",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "chatgpt",
              "openai",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/lupsasca",
            "audio_url": "https://api.substack.com/feed/podcast/196292432/c069e965927403857341ef50a53384b8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:195677117",
            "index": 13,
            "title": "Physical AI that Moves the World — Qasar Younis & Peter Ludwig, Applied Intuition",
            "pub_date": "2026-04-27T23:02:37.000Z",
            "duration": "4341",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 27,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "generative ai",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/appliedintuition",
            "audio_url": "https://api.substack.com/feed/podcast/195677117/0b85e7d88c5122f9f3d7832c6c2fa38f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 410,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:195264855",
            "index": 14,
            "title": "AIE Europe Debrief + Agent Labs Thesis: Unsupervised Learning x Latent Space Crossover Special (2026)",
            "pub_date": "2026-04-23T19:37:19.000Z",
            "duration": "3292",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 30,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "frontier model",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/unsupervised-learning-2026",
            "audio_url": "https://api.substack.com/feed/podcast/195264855/e730559c6a6ef350c27ba6b333130c57.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 190,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:195067855",
            "index": 15,
            "title": "Shopify’s AI Phase Transition: 2026 Usage Explosion, Unlimited Opus-4.6 Token Budget, Tangle, Tangent, SimGym — with Mikhail Parakhin, Shopify CTO",
            "pub_date": "2026-04-22T19:33:00.000Z",
            "duration": "4345",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "frontier model",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/shopify",
            "audio_url": "https://api.substack.com/feed/podcast/195067855/708627edff5e672fd6cb54ad90b94b0c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 139,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:194810752",
            "index": 16,
            "title": "🔬 Training Transformers to solve 95% failure rate of Cancer Trials — Ron Alfa & Daniel Bear, Noetik",
            "pub_date": "2026-04-20T16:17:17.000Z",
            "duration": "5121",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "multimodal"
            ],
            "page_url": "https://www.latent.space/p/noetik",
            "audio_url": "https://api.substack.com/feed/podcast/194810752/1b92bce4d49858354007a47c48e4e6d4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:194195821",
            "index": 17,
            "title": "Notion’s Token Town: 5 Rebuilds, 100+ Tools, MCP vs CLIs and the Software Factory Future — Simon Last & Sarah Sachs of Notion",
            "pub_date": "2026-04-15T00:31:14.000Z",
            "duration": "4637",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "frontier model",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/notion",
            "audio_url": "https://api.substack.com/feed/podcast/194195821/10f31b379fbf657fd80757e3b4244e4f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 448,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:193478192",
            "index": 18,
            "title": "Extreme Harness Engineering for Token Billionaires: 1M LOC, 1B toks/day, 0% human code, 0% human review — Ryan Lopopolo, OpenAI Frontier & Symphony",
            "pub_date": "2026-04-07T17:14:26.000Z",
            "duration": "4363",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 19,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/harness-eng",
            "audio_url": "https://api.substack.com/feed/podcast/193478192/2c0fb135ac3f9193c58922fcaf1b81a8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 506,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:193082940",
            "index": 19,
            "title": "Marc Andreessen introspects on The Death of the Browser, Pi + OpenClaw, and Why \"This Time Is Different\"",
            "pub_date": "2026-04-03T16:57:46.000Z",
            "duration": "4580",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "openai",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/pmarca",
            "audio_url": "https://api.substack.com/feed/podcast/193082940/b98c45099bbe4f6e5ca15d48d02e7222.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 234,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:192967759",
            "index": 20,
            "title": "Moonlake: Causal World Models should be Multimodal, Interactive, and Efficient — with Chris Manning and Fan-yun Sun",
            "pub_date": "2026-04-02T17:55:29.000Z",
            "duration": "4007",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "large language model",
              "foundation model",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/moonlake",
            "audio_url": "https://api.substack.com/feed/podcast/192967759/1555edb9d5649c656d2244abc7f5eeff.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 458,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:192356063",
            "index": 21,
            "title": "Mistral: Voxtral TTS, Forge, Leanstral, & what's next for Mistral 4 — w/ Pavan Kumar Reddy & Guillaume Lample",
            "pub_date": "2026-03-30T19:25:21.000Z",
            "duration": "2928",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agent",
              "agents",
              "openai",
              "gemini",
              "mistral"
            ],
            "page_url": "https://www.latent.space/p/voxtral",
            "audio_url": "https://api.substack.com/feed/podcast/192356063/415e7523439ae30c5bb12cb913de9ee9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 214,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:191799646",
            "index": 22,
            "title": "🔬Why There Is No \"AlphaFold for Materials\" — AI for Materials Discovery with Heather Kulik",
            "pub_date": "2026-03-24T16:53:15.000Z",
            "duration": "2114",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "claude",
              "chip"
            ],
            "page_url": "https://www.latent.space/p/materials",
            "audio_url": "https://api.substack.com/feed/podcast/191799646/e5fd22546e0bfbe77cc829cd27c36415.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:191603783",
            "index": 23,
            "title": "Dreamer: the Personal Agent OS — David Singleton",
            "pub_date": "2026-03-20T21:03:23.000Z",
            "duration": "3815",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/dreamer",
            "audio_url": "https://api.substack.com/feed/podcast/191603783/4e2737f43fd32eff8a5975657f782aaa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 484,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:191097767",
            "index": 24,
            "title": "Why Anthropic Thinks AI Should Have Its Own Computer — Felix Rieseberg of Claude Cowork & Claude Code Desktop",
            "pub_date": "2026-03-17T21:39:16.000Z",
            "duration": "5219",
            "duration_label": "1h 26m",
            "selected": true,
            "confidence": "high",
            "score": 29,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/felix-anthropic",
            "audio_url": "https://api.substack.com/feed/podcast/191097767/72a8d1a77282f7fee0214a7442ccfd40.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 402,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:190777516",
            "index": 25,
            "title": "Retrieval After RAG: Hybrid Search, Agents, and Database Design — Simon Hørup Eskildsen of Turbopuffer",
            "pub_date": "2026-03-12T22:56:01.000Z",
            "duration": "3632",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "cursor"
            ],
            "page_url": "https://www.latent.space/p/turbopuffer",
            "audio_url": "https://api.substack.com/feed/podcast/190777516/3e8657eee5a6ccb27814143e15672fd5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 170,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:190477229",
            "index": 26,
            "title": "NVIDIA's AI Engineers: Agent Inference at Planetary Scale and \"Speed of Light\" — Nader Khalil (Brev), Kyle Kranen (Dynamo)",
            "pub_date": "2026-03-10T06:40:22.000Z",
            "duration": "5017",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "high",
            "score": 31,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "openai",
              "claude",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/nvidia-brev-dynamo",
            "audio_url": "https://api.substack.com/feed/podcast/190477229/547dbb1e74e5465c243c3af0599b15cd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 589,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:190063769",
            "index": 27,
            "title": "Cursor's Third Era: Cloud Agents",
            "pub_date": "2026-03-06T02:42:37.000Z",
            "duration": "3999",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "claude",
              "cursor"
            ],
            "page_url": "https://www.latent.space/p/cursor-third-era",
            "audio_url": "https://api.substack.com/feed/podcast/190063769/104adabca6129bf33af673e58934a2ba.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 422,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:189936942",
            "index": 28,
            "title": "Every Agent Needs a Box — Aaron Levie, Box",
            "pub_date": "2026-03-05T00:54:45.000Z",
            "duration": "4618",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "frontier model",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/box",
            "audio_url": "https://api.substack.com/feed/podcast/189936942/61bbb1aad83c5b1e92776435f97ac3f0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 535,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:189159777",
            "index": 29,
            "title": "METR’s Joel Becker on exponential Time Horizon Evals, Threat Models, and the Limits of AI Productivity",
            "pub_date": "2026-02-27T19:17:52.000Z",
            "duration": "3374",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "evals"
            ],
            "page_url": "https://www.latent.space/p/metr",
            "audio_url": "https://api.substack.com/feed/podcast/189159777/9da6fbe2f2d5b3d14c2227e41401719c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:189277598",
            "index": 30,
            "title": "[LIVE] Anthropic Distillation & How Models Cheat (SWE-Bench Dead) | Nathan Lambert & Sebastian Raschka",
            "pub_date": "2026-02-26T20:39:42.000Z",
            "duration": "3137",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/paid-anthropic-distillation-and-how",
            "audio_url": "https://api.substack.com/feed/podcast/189277598/36ab9328e1269f3111b0531cb589dc26.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:189149291",
            "index": 31,
            "title": "🔬Searching the Space of All Possible Materials — Prof. Max Welling, CuspAI",
            "pub_date": "2026-02-25T17:36:18.000Z",
            "duration": "2036",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "agentic",
              "gpu"
            ],
            "page_url": "https://www.latent.space/p/cuspai",
            "audio_url": "https://api.substack.com/feed/podcast/189149291/17fc201d8202018971be66d15a960624.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 54,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:189062462",
            "index": 32,
            "title": "Claude Code for Finance + The Global Memory Shortage: Doug O'Laughlin, SemiAnalysis",
            "pub_date": "2026-02-24T21:27:25.000Z",
            "duration": "7453",
            "duration_label": "2h 4m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "anthropic",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/valuemule",
            "audio_url": "https://api.substack.com/feed/podcast/189062462/654370814579f2242c870e8cb05b58a5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:188928663",
            "index": 33,
            "title": "⚡️The End of SWE-Bench Verified — Mia Glaese & Olivia Watkins, OpenAI Frontier Evals & Human Data",
            "pub_date": "2026-02-23T20:03:11.000Z",
            "duration": "1572",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "agent",
              "openai",
              "alignment",
              "evals",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/swe-bench-dead",
            "audio_url": "https://api.substack.com/feed/podcast/188928663/d1b8836e5d38b238ccf001345a411fc7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:188504140",
            "index": 34,
            "title": "Bitter Lessons in Venture vs Growth: Anthropic vs OpenAI, Noam Shazeer, World Labs, Thinking Machines, Cursor, ASIC Economics — Martin Casado & Sarah Wang of a16z",
            "pub_date": "2026-02-19T16:46:53.000Z",
            "duration": "3318",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 28,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "frontier model",
              "agent",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/a16z",
            "audio_url": "https://api.substack.com/feed/podcast/188504140/c66a34d6406cd1b378cffe52d8a8c00b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 484,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:187741497",
            "index": 35,
            "title": "Owning the AI Pareto Frontier — Jeff Dean",
            "pub_date": "2026-02-12T22:02:35.000Z",
            "duration": "5011",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "high",
            "score": 29,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "frontier model",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/jeffdean",
            "audio_url": "https://api.substack.com/feed/podcast/187741497/443b8df57e77c5522b031c52b1302c0d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 174,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:187696911",
            "index": 36,
            "title": "🔬Beyond AlphaFold: How Boltz is Open-Sourcing the Future of Drug Discovery",
            "pub_date": "2026-02-12T02:12:14.000Z",
            "duration": "4867",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "gpu"
            ],
            "page_url": "https://www.latent.space/p/boltz",
            "audio_url": "https://api.substack.com/feed/podcast/187696911/8242b1558c99b0e7e719726396b7f736.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 86,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:187000315",
            "index": 37,
            "title": "The First Mechanistic Interpretability Frontier Lab — Myra Deng & Mark Bissell of Goodfire AI",
            "pub_date": "2026-02-06T22:45:00.000Z",
            "duration": "4081",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "deepmind"
            ],
            "page_url": "https://www.latent.space/p/goodfire",
            "audio_url": "https://api.substack.com/feed/podcast/187000315/45fdd1fce3ff7c69d24a13281311b152.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 174,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:186586042",
            "index": 38,
            "title": "🔬 Automating Science: World Models, Scientific Taste, Agent Loops — Andrew White",
            "pub_date": "2026-01-28T15:00:00.000Z",
            "duration": "4436",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "gpu",
              "chips",
              "safety",
              "multimodal"
            ],
            "page_url": "https://www.latent.space/p/edison",
            "audio_url": "https://api.substack.com/feed/podcast/186586042/58687b03760c08bf74c668f939e1baf8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610590",
            "index": 39,
            "title": "Captaining IMO Gold, Deep Think, On-Policy RL, Feeling the AGI in Singapore — Yi Tay",
            "pub_date": "2026-01-23T16:00:00.000Z",
            "duration": "5525",
            "duration_label": "1h 32m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind",
              "gemini",
              "inference",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/captaining-imo-gold-deep-think-on",
            "audio_url": "https://api.substack.com/feed/podcast/186610590/b986ed2096ba7f55a1fbad46cd0076d2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610586",
            "index": 40,
            "title": "Brex’s AI Hail Mary — With CTO James Reggio",
            "pub_date": "2026-01-17T16:00:00.000Z",
            "duration": "4406",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/brexs-ai-hail-mary-with-cto-james",
            "audio_url": "https://api.substack.com/feed/podcast/186610586/17c83ea4bd7d172bca038b6f1e1166be.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:183902568",
            "index": 41,
            "title": "Artificial Analysis: Independent LLM Evals as a Service — with George Cameron and Micah-Hill Smith",
            "pub_date": "2026-01-08T15:08:15.000Z",
            "duration": "4704",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 26,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/artificialanalysis",
            "audio_url": "https://api.substack.com/feed/podcast/183902568/be200b54760e7673fbd7664d6ccaddae.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 204,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:186610584",
            "index": 42,
            "title": "[State of Evals] LMArena's $1.7B Vision — Anastasios Angelopoulos, LMArena",
            "pub_date": "2026-01-06T16:00:00.000Z",
            "duration": "1442",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "gemini",
              "inference",
              "evals",
              "multimodal"
            ],
            "page_url": "https://www.latent.space/p/state-of-evals-lmarenas-17b-vision",
            "audio_url": "https://api.substack.com/feed/podcast/186610584/7de81331ff68322b159c0782b75af74a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610577",
            "index": 43,
            "title": "[NeurIPS Best Paper] 1000 Layer Networks for Self-Supervised RL — Kevin Wang et al, Princeton",
            "pub_date": "2026-01-02T16:00:00.000Z",
            "duration": "1699",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "gpu",
              "inference",
              "robotics"
            ],
            "page_url": "https://www.latent.space/p/neurips-best-paper-1000-layer-networks",
            "audio_url": "https://api.substack.com/feed/podcast/186610577/1c67d698a72366b17c184a249d44225b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610569",
            "index": 44,
            "title": "[State of Code Evals] After SWE-bench, Code Clash & SOTA Coding Benchmarks recap — John Yang",
            "pub_date": "2025-12-31T16:00:00.000Z",
            "duration": "1065",
            "duration_label": "17m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "cursor",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/state-of-code-evals-after-swe-bench",
            "audio_url": "https://api.substack.com/feed/podcast/186610569/3c925296f32115c0d7354d7da15dcee7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610564",
            "index": 45,
            "title": "[State of Post-Training] From GPT-4.1 to 5.1: RLVR, Agent & Token Efficiency — Josh McGrath, OpenAI",
            "pub_date": "2025-12-31T14:00:00.000Z",
            "duration": "1654",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "agent",
              "agents",
              "openai",
              "training",
              "evals"
            ],
            "page_url": "https://www.latent.space/p/state-of-post-training-from-gpt-41",
            "audio_url": "https://api.substack.com/feed/podcast/186610564/4944e1f91a0d0d17e5525fb297469684.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610562",
            "index": 46,
            "title": "[State of RL/Reasoning] IMO/IOI Gold, OpenAI o3/GPT-5, and Cursor Composer — Ashvin Nair, Cursor",
            "pub_date": "2025-12-30T16:00:00.000Z",
            "duration": "2713",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "openai",
              "cursor",
              "training"
            ],
            "page_url": "https://www.latent.space/p/state-of-rlreasoning-imoioi-gold",
            "audio_url": "https://api.substack.com/feed/podcast/186610562/84a86ba6927f827c7d138818724a3e00.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610557",
            "index": 47,
            "title": "[State of AI Startups] Memory/Learning, RL Envs & DBT-Fivetran — Sarah Catanzaro, Amplify",
            "pub_date": "2025-12-30T14:00:00.000Z",
            "duration": "1722",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "cursor",
              "gpu",
              "inference",
              "training"
            ],
            "page_url": "https://www.latent.space/p/state-of-ai-startups-memorylearning",
            "audio_url": "https://api.substack.com/feed/podcast/186610557/c925c47e33b1d08b87213416fdb3b3b8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610556",
            "index": 48,
            "title": "One Year of MCP — with David Soria Parra and AAIF leads from OpenAI, Goose, Linux Foundation",
            "pub_date": "2025-12-27T16:00:00.000Z",
            "duration": "5958",
            "duration_label": "1h 39m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/one-year-of-mcp-with-david-soria",
            "audio_url": "https://api.substack.com/feed/podcast/186610556/9ed30d612f81bb17e94cb405191ffa79.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610547",
            "index": 49,
            "title": "Steve Yegge's Vibe Coding Manifesto: Why Claude Code Isn't It & What Comes After the IDE",
            "pub_date": "2025-12-26T16:00:00.000Z",
            "duration": "2244",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/steve-yegges-vibe-coding-manifesto",
            "audio_url": "https://api.substack.com/feed/podcast/186610547/d17eb2607b3ec0fe9e55ee580fb66bf0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610544",
            "index": 50,
            "title": "⚡️GPT5-Codex-Max: Training Agents with Personality, Tools & Trust — Brian Fioca + Bill Chen, OpenAI",
            "pub_date": "2025-12-26T14:00:00.000Z",
            "duration": "1665",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "github copilot",
              "training",
              "eval"
            ],
            "page_url": "https://www.latent.space/p/gpt5-codex-max-training-agents-with",
            "audio_url": "https://api.substack.com/feed/podcast/186610544/d7cc52ef2d7ba8c988231607113259fe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610536",
            "index": 51,
            "title": "SAM 3: The Eyes for AI — Nikhila & Pengchuan (Meta Superintelligence), ft. Joseph Nelson (Roboflow)",
            "pub_date": "2025-12-18T16:00:00.000Z",
            "duration": "4503",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "gemini",
              "llama",
              "gpu"
            ],
            "page_url": "https://www.latent.space/p/sam-3-the-eyes-for-ai-nikhila-and",
            "audio_url": "https://api.substack.com/feed/podcast/186610536/5ae34479547a797018eb92e7ffb4f660.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610530",
            "index": 52,
            "title": "⚡️Jailbreaking AGI: Pliny the Liberator & John V on Red Teaming, BT6, and the Future of AI Security",
            "pub_date": "2025-12-16T16:00:00.000Z",
            "duration": "2440",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "frontier model",
              "agents",
              "anthropic",
              "claude",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/jailbreaking-agi-pliny-the-liberator",
            "audio_url": "https://api.substack.com/feed/podcast/186610530/b6d27cf3994bd16bc2c97e0f4443dbb2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610524",
            "index": 53,
            "title": "AI to AE's: Grit, Glean, and Kleiner Perkins' next Enterprise AI hit — Joubin Mirzadegan, Roadrunner",
            "pub_date": "2025-12-12T16:00:00.000Z",
            "duration": "4183",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://www.latent.space/p/ai-to-aes-grit-glean-and-kleiner",
            "audio_url": "https://api.substack.com/feed/podcast/186610524/bdfff65c17adecdcdae276747b5cdbf7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610521",
            "index": 54,
            "title": "The Future of Email: Superhuman CTO on Your Inbox As the Real AI Agent (Not ChatGPT) — Loïc Houssier",
            "pub_date": "2025-12-11T16:00:00.000Z",
            "duration": "4262",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/the-future-of-email-superhuman-cto",
            "audio_url": "https://api.substack.com/feed/podcast/186610521/5ccb467673ea4d30a7463cd8d2c05255.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610516",
            "index": 55,
            "title": "World Models & General Intuition: Khosla's largest bet since LLMs & OpenAI",
            "pub_date": "2025-12-06T16:00:00.000Z",
            "duration": "3857",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "reasoning",
              "robotics",
              "model lab"
            ],
            "page_url": "https://www.latent.space/p/world-models-and-general-intuition",
            "audio_url": "https://api.substack.com/feed/podcast/186610516/549025ec6e575cd11565a6db9aeeb42f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610506",
            "index": 56,
            "title": "After LLMs: Spatial Intelligence and World Models — Fei-Fei Li & Justin Johnson, World Labs",
            "pub_date": "2025-11-25T16:00:00.000Z",
            "duration": "3638",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "gpu",
              "training",
              "reasoning",
              "multimodal",
              "robotics"
            ],
            "page_url": "https://www.latent.space/p/after-llms-spatial-intelligence-and",
            "audio_url": "https://api.substack.com/feed/podcast/186610506/d3b971129163b797253eaed907101f67.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186610493",
            "index": 57,
            "title": "⚡️ 10x AI Engineers with $1m Salaries — Alex Lieberman & Arman Hezarkhani, Tenex",
            "pub_date": "2025-11-19T16:00:00.000Z",
            "duration": "1631",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/10x-ai-engineers-with-1m-salaries",
            "audio_url": "https://api.substack.com/feed/podcast/186610493/f6f6d281aed060a08464e334e0966484.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186609751",
            "index": 58,
            "title": "Anthropic, Glean & OpenRouter: How AI Moats Are Built with Deedy Das of Menlo Ventures",
            "pub_date": "2025-11-14T16:00:00.000Z",
            "duration": "5127",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "training",
              "coding",
              "enterprise ai"
            ],
            "page_url": "https://www.latent.space/p/anthropic-glean-and-openrouter-how",
            "audio_url": "https://api.substack.com/feed/podcast/186609751/3c36737edc242b35eb746a763451bfb2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621816",
            "index": 59,
            "title": "⚡ Inside GitHub’s AI Revolution: Jared Palmer Reveals Agent HQ & The Future of Coding Agents",
            "pub_date": "2025-11-10T16:00:00.000Z",
            "duration": "2151",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "coding",
              "copilot"
            ],
            "page_url": "https://www.latent.space/p/inside-githubs-ai-revolution-jared",
            "audio_url": "https://api.substack.com/feed/podcast/186621816/b1a4f44d84fcba0682fb3a2fcc613b34.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621812",
            "index": 60,
            "title": "⚡ [AIE CODE Preview] Inside Google Labs: Building The Gemini Coding Agent — Jed Borovik, Jules",
            "pub_date": "2025-11-10T14:00:00.000Z",
            "duration": "2633",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "deepmind",
              "gemini",
              "rag"
            ],
            "page_url": "https://www.latent.space/p/aie-code-preview-inside-google-labs",
            "audio_url": "https://api.substack.com/feed/podcast/186621812/456c37988c3551b99ed9c2499e82031d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621804",
            "index": 61,
            "title": "⚡️ Ship AI recap: Agents, Workflows, and Python — w/ Vercel CTO Malte Ubl",
            "pub_date": "2025-10-31T15:00:00.000Z",
            "duration": "2522",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "mistral",
              "safety"
            ],
            "page_url": "https://www.latent.space/p/ship-ai-recap-agents-workflows-and",
            "audio_url": "https://api.substack.com/feed/podcast/186621804/eee921a9e6f09da380d9a6c756023e6d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621798",
            "index": 62,
            "title": "Why RL Won — Kyle Corbitt, OpenPipe (acq. CoreWeave)",
            "pub_date": "2025-10-16T15:00:00.000Z",
            "duration": "4103",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "frontier model",
              "agent",
              "agents",
              "openai",
              "mistral",
              "inference"
            ],
            "page_url": "https://www.latent.space/p/why-rl-won-kyle-corbitt-openpipe",
            "audio_url": "https://api.substack.com/feed/podcast/186621798/24731bd17b981bb97f76bae1e8c78d14.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621796",
            "index": 63,
            "title": "DevDay 2025: Apps SDK, Agent Kit, MCP, Codex and why Prompting is More Important than Ever",
            "pub_date": "2025-10-07T15:00:00.000Z",
            "duration": "2708",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "evals"
            ],
            "page_url": "https://www.latent.space/p/devday-2025-apps-sdk-agent-kit-mcp",
            "audio_url": "https://api.substack.com/feed/podcast/186621796/0a66667bca1f94b356c94afbea26300a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621791",
            "index": 64,
            "title": "Taste is your Moat (Dylan Field of Figma)",
            "pub_date": "2025-10-02T15:00:00.000Z",
            "duration": "3703",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "coding"
            ],
            "page_url": "https://www.latent.space/p/taste-is-your-moat-dylan-field-of",
            "audio_url": "https://api.substack.com/feed/podcast/186621791/cb79042cd52126082ad01bd94ba91f10.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621789",
            "index": 65,
            "title": "Amp: The Emperor Has No Clothes",
            "pub_date": "2025-09-25T15:00:00.000Z",
            "duration": "4813",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/amp-the-emperor-has-no-clothes",
            "audio_url": "https://api.substack.com/feed/podcast/186621789/3444ee6ad3188f9b3cc76d78cb63a9f4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621786",
            "index": 66,
            "title": "Context Engineering for Agents - Lance Martin, LangChain",
            "pub_date": "2025-09-11T15:00:00.000Z",
            "duration": "3453",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "claude",
              "rag"
            ],
            "page_url": "https://www.latent.space/p/context-engineering-for-agents-lance",
            "audio_url": "https://api.substack.com/feed/podcast/186621786/4c0898bc1806008a4e6d53f95c7f32bd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621779",
            "index": 67,
            "title": "Better Data is All You Need — Ari Morcos, Datology",
            "pub_date": "2025-08-29T15:00:00.000Z",
            "duration": "4723",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "inference",
              "training"
            ],
            "page_url": "https://www.latent.space/p/better-data-is-all-you-need-ari-morcos",
            "audio_url": "https://api.substack.com/feed/podcast/186621779/02cbea33ecbd1e1764dc8be8ad8bce9a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621771",
            "index": 68,
            "title": "The RLVR Revolution — with Nathan Lambert (AI2, Interconnects.ai)",
            "pub_date": "2025-07-31T15:00:00.000Z",
            "duration": "4739",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "inference"
            ],
            "page_url": "https://www.latent.space/p/the-rlvr-revolution-with-nathan-lambert",
            "audio_url": "https://api.substack.com/feed/podcast/186621771/524e0bea632d56947fcb7db8fc4c2238.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621835",
            "index": 69,
            "title": "AI is Eating Search",
            "pub_date": "2025-07-23T15:00:00.000Z",
            "duration": "3382",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "perplexity",
              "training"
            ],
            "page_url": "https://www.latent.space/p/ai-is-eating-search",
            "audio_url": "https://api.substack.com/feed/podcast/186621835/697c8104e67c3d923434446f54c76e41.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621833",
            "index": 70,
            "title": "Cline: the open source coding agent that doesn't cut costs",
            "pub_date": "2025-07-16T15:00:00.000Z",
            "duration": "4544",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "agent",
              "agents",
              "anthropic",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/cline-the-open-source-coding-agent",
            "audio_url": "https://api.substack.com/feed/podcast/186621833/55e8ce442d3947aba3a4903547bf3e2f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621831",
            "index": 71,
            "title": "Personalized AI Language Education — with Andrew Hsu, Speak",
            "pub_date": "2025-07-11T15:00:00.000Z",
            "duration": "3849",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/personalized-ai-language-education",
            "audio_url": "https://api.substack.com/feed/podcast/186621831/661bdfa367522289253180f433016280.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621826",
            "index": 72,
            "title": "AI Video Is Eating The World — Olivia and Justine Moore, a16z",
            "pub_date": "2025-07-09T15:00:00.000Z",
            "duration": "2968",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/ai-video-is-eating-the-world-olivia",
            "audio_url": "https://api.substack.com/feed/podcast/186621826/076f63ab4b36f6f5cf1002a7a172108a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186621824",
            "index": 73,
            "title": "Information Theory for Language Models: Jack Morris",
            "pub_date": "2025-07-02T15:00:00.000Z",
            "duration": "4693",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "chatgpt",
              "openai",
              "gpu",
              "training"
            ],
            "page_url": "https://www.latent.space/p/information-theory-for-language-models",
            "audio_url": "https://api.substack.com/feed/podcast/186621824/c63292046e9e1445fd5e67c0cc12c6ed.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632807",
            "index": 74,
            "title": "Scaling Test Time Compute to Multi-Agent Civilizations — Noam Brown, OpenAI",
            "pub_date": "2025-06-19T15:00:00.000Z",
            "duration": "4667",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "openai",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/scaling-test-time-compute-to-multi",
            "audio_url": "https://api.substack.com/feed/podcast/186632807/f77612a5c99afad47e4fa732a753d087.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632799",
            "index": 75,
            "title": "The Utility of Interpretability — Emmanuel Amiesen",
            "pub_date": "2025-06-06T15:00:00.000Z",
            "duration": "6782",
            "duration_label": "1h 53m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/the-utility-of-interpretability-emmanuel",
            "audio_url": "https://api.substack.com/feed/podcast/186632799/5f0d1a6cb0dc287bfa49b0f096ae08a9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632797",
            "index": 76,
            "title": "[AIEWF Preview] Containing Agent Chaos — Solomon Hykes",
            "pub_date": "2025-06-03T15:00:00.000Z",
            "duration": "1633",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "automation"
            ],
            "page_url": "https://www.latent.space/p/aiewf-preview-containing-agent-chaos",
            "audio_url": "https://api.substack.com/feed/podcast/186632797/9581c19c3af422bf3afe50d9fd428a06.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632795",
            "index": 77,
            "title": "[AIEWF Preview] Gemini in 2025 and Realtime Voice AI",
            "pub_date": "2025-06-02T15:00:00.000Z",
            "duration": "1469",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "chatgpt",
              "gemini"
            ],
            "page_url": "https://www.latent.space/p/aiewf-preview-gemini-in-2025-and",
            "audio_url": "https://api.substack.com/feed/podcast/186632795/6219c82c14be6f7988424c8ac481a81b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632792",
            "index": 78,
            "title": "[AIEWF Preview] CloudChef: Your Robot Chef - Michellin-Star food at $12/hr (w/ Kitchen tour!)",
            "pub_date": "2025-05-31T15:00:00.000Z",
            "duration": "1250",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "robotics"
            ],
            "page_url": "https://www.latent.space/p/aiewf-preview-cloudchef-your-robot",
            "audio_url": "https://api.substack.com/feed/podcast/186632792/8de61535981779bcbd60ce49b9960241.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632790",
            "index": 79,
            "title": "The AI Coding Factory",
            "pub_date": "2025-05-29T15:00:00.000Z",
            "duration": "3563",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "retrieval",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/the-ai-coding-factory",
            "audio_url": "https://api.substack.com/feed/podcast/186632790/5ffc5ab1b2ca2ba2749a2801acaa26ee.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632787",
            "index": 80,
            "title": "[AIEWF Preview] Multi-Turn RL for Multi-Hour Agents — with Will Brown, Prime Intellect",
            "pub_date": "2025-05-23T15:00:00.000Z",
            "duration": "2398",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "agentic",
              "openai",
              "claude",
              "gemini"
            ],
            "page_url": "https://www.latent.space/p/aiewf-preview-multi-turn-rl-for-multi",
            "audio_url": "https://api.substack.com/feed/podcast/186632787/ae482cf4d9bab37796013ff9a2c7b3b3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632776",
            "index": 81,
            "title": "⚡️The Rise and Fall of the Vector DB Category",
            "pub_date": "2025-05-01T15:00:00.000Z",
            "duration": "1636",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "rag",
              "retrieval",
              "embedding",
              "embeddings"
            ],
            "page_url": "https://www.latent.space/p/the-rise-and-fall-of-the-vector-db",
            "audio_url": "https://api.substack.com/feed/podcast/186632776/193fa42e4dddc26017e16830a71754fa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:186632768",
            "index": 82,
            "title": "⚡️GPT 4.1: The New OpenAI Workhorse",
            "pub_date": "2025-04-15T15:00:00.000Z",
            "duration": "2512",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "agent",
              "agentic",
              "openai",
              "gpu",
              "training",
              "reasoning",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/gpt-41-the-new-openai-workhorse",
            "audio_url": "https://api.substack.com/feed/podcast/186632768/3cc10438ec04e08b890b62b2b6f7d69f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:160956446",
            "index": 83,
            "title": "SF Compute: Commoditizing Compute to solve the GPU Bubble forever",
            "pub_date": "2025-04-11T19:22:00.000Z",
            "duration": "4321",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/sfcompute",
            "audio_url": "https://api.substack.com/feed/podcast/160956446/0e916bdb91f24e33561bffa51f5bc611.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 22,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:160464452",
            "index": 84,
            "title": "The Creators of Model Context Protocol",
            "pub_date": "2025-04-03T17:04:41.000Z",
            "duration": "4797",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/mcp",
            "audio_url": "https://api.substack.com/feed/podcast/160464452/e8c5634adb3ba8458e54738e718e88d5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 84,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:160102198",
            "index": 85,
            "title": "Unsupervised Learning x Latent Space Crossover Special",
            "pub_date": "2025-03-29T13:51:50.000Z",
            "duration": "3713",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/unsupervised-learning",
            "audio_url": "https://api.substack.com/feed/podcast/160102198/a635f4ecffb552b34ede0ca9e8be6518.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 441,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:159929627",
            "index": 86,
            "title": "The Agent Network — Dharmesh Shah",
            "pub_date": "2025-03-28T17:52:18.000Z",
            "duration": "5885",
            "duration_label": "1h 38m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/dharmesh",
            "audio_url": "https://api.substack.com/feed/podcast/159929627/8f691a234ab0ac55dee79df70a7932f3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 160,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:158077685",
            "index": 87,
            "title": "Building Snipd: The AI Podcast App for Learning",
            "pub_date": "2025-03-14T21:38:18.000Z",
            "duration": "4667",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "high",
            "score": 19,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "chatgpt",
              "openai",
              "claude",
              "gemini"
            ],
            "page_url": "https://www.latent.space/p/snipd",
            "audio_url": "https://api.substack.com/feed/podcast/158077685/cf790af676f939313b378c8bc28ad586.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 163,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:158852522",
            "index": 88,
            "title": "⚡️The new OpenAI Agents Platform",
            "pub_date": "2025-03-11T17:39:48.000Z",
            "duration": "1538",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/openai-agents-platform",
            "audio_url": "https://api.substack.com/feed/podcast/158852522/9fa235fc6424e36c9605b61dde99df5e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 63,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:158336279",
            "index": 89,
            "title": "⚡️How Claude 3.7 Plays Pokémon",
            "pub_date": "2025-03-04T01:00:45.000Z",
            "duration": "2258",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "anthropic",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/how-claude-plays-pokemon-was-made",
            "audio_url": "https://api.substack.com/feed/podcast/158336279/44c56477b72fe5fa793bd9101051ef04.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:158069581",
            "index": 90,
            "title": "Open Operator, Serverless Browsers and the Future of Computer-Using Agents",
            "pub_date": "2025-02-28T18:31:10.000Z",
            "duration": "3693",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/browserbase",
            "audio_url": "https://api.substack.com/feed/podcast/158069581/7563f30a23fe8c6f589d9f9688d7e035.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 124,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:157348543",
            "index": 91,
            "title": "The Inventors of Deep Research",
            "pub_date": "2025-02-18T15:51:28.000Z",
            "duration": "3718",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/gdr",
            "audio_url": "https://api.substack.com/feed/podcast/157348543/222559f0c15d49f93e15db33c56f8631.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 107,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:157072991",
            "index": 92,
            "title": "Bee AI: The Wearable Ambient Agent",
            "pub_date": "2025-02-13T18:07:10.000Z",
            "duration": "4132",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 19,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "inference"
            ],
            "page_url": "https://www.latent.space/p/bee",
            "audio_url": "https://api.substack.com/feed/podcast/157072991/43b4e5f3098ca29f82a68a2cf92a4ff3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 233,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:156886978",
            "index": 93,
            "title": "The AI Architect — Bret Taylor",
            "pub_date": "2025-02-11T01:32:44.000Z",
            "duration": "5779",
            "duration_label": "1h 36m",
            "selected": true,
            "confidence": "high",
            "score": 27,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "large language model",
              "foundation model",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/bret",
            "audio_url": "https://api.substack.com/feed/podcast/156886978/a019484a65bb9ac6e27d07c7cdcdcdb0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 487,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:156609115",
            "index": 94,
            "title": "Agent Engineering with Pydantic + Graphs — with Samuel Colvin",
            "pub_date": "2025-02-06T22:58:14.000Z",
            "duration": "3844",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 19,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/pydantic",
            "audio_url": "https://api.substack.com/feed/podcast/156609115/5dc5e86e5cc60a86b0e7fda726ff8b21.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 127,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:155459121",
            "index": 95,
            "title": "The Agent Reasoning Interface: o1/o3, Claude 3, ChatGPT Canvas, Tasks, and Operator — with Karina Nguyen of OpenAI",
            "pub_date": "2025-02-01T01:43:16.000Z",
            "duration": "4120",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 28,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/karina",
            "audio_url": "https://api.substack.com/feed/podcast/155459121/4ad689b3be07c7ed322e79d11a28b061.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 174,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:155708308",
            "index": 96,
            "title": "Outlasting Noam Shazeer, crowdsourcing Chai AI with >1.4m DAU, and becoming the \"Western DeepSeek\" — with William Beauchamp, Chai Research",
            "pub_date": "2025-01-26T03:17:43.000Z",
            "duration": "4546",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/chai",
            "audio_url": "https://api.substack.com/feed/podcast/155708308/1d25a5bc0b3b3c5d33950c3c298a7fce.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 90,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:155135149",
            "index": 97,
            "title": "Everything you need to run Mission Critical Inference (ft. DeepSeek v3 + SGLang)",
            "pub_date": "2025-01-19T04:00:15.000Z",
            "duration": "3604",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "gemini",
              "gpu",
              "inference"
            ],
            "page_url": "https://www.latent.space/p/baseten",
            "audio_url": "https://api.substack.com/feed/podcast/155135149/573a1b749e9ab7ea811cb6daf30c53e4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:154656957",
            "index": 98,
            "title": "[Ride Home] Simon Willison: Things we learned about LLMs in 2024",
            "pub_date": "2025-01-12T07:31:40.000Z",
            "duration": "4403",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/2024-simonw",
            "audio_url": "https://api.substack.com/feed/podcast/154656957/4097a95ced7c01d2f4e5d707978fede4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 430,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:154427658",
            "index": 99,
            "title": "Beating Google at Search with Neural PageRank and $5M of H200s — with Will Bryk of Exa.ai",
            "pub_date": "2025-01-10T19:25:51.000Z",
            "duration": "3360",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/exa",
            "audio_url": "https://api.substack.com/feed/podcast/154427658/f38671b3eca52d65f199535da82cc9dc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 128,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:154105963",
            "index": 100,
            "title": "AI Engineering for Art — with comfyanonymous, of ComfyUI",
            "pub_date": "2025-01-04T22:59:59.000Z",
            "duration": "3304",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "nvidia",
              "gpu",
              "inference",
              "training"
            ],
            "page_url": "https://www.latent.space/p/comfyui",
            "audio_url": "https://api.substack.com/feed/podcast/154105963/0411e065a5b8d299a4838ff6a24052ec.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 185,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:153836966",
            "index": 101,
            "title": "Latent.Space 2024 Year in Review",
            "pub_date": "2024-12-31T20:46:31.000Z",
            "duration": "6722",
            "duration_label": "1h 52m",
            "selected": true,
            "confidence": "high",
            "score": 34,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "frontier model",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/2024-review",
            "audio_url": "https://api.substack.com/feed/podcast/153836966/bf06742525de6beff985a8e1ad84ea94.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 656,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:153568377",
            "index": 102,
            "title": "2024 in Agents [LS Live! @ NeurIPS 2024]",
            "pub_date": "2024-12-25T16:30:00.000Z",
            "duration": "2939",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "large language model",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/2024-agents",
            "audio_url": "https://api.substack.com/feed/podcast/153568377/ababc688d9ec7a365826da591e168190.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 237,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:153567986",
            "index": 103,
            "title": "2024 in Synthetic Data and Smol Models [LS Live @ NeurIPS]",
            "pub_date": "2024-12-24T20:13:01.000Z",
            "duration": "1716",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/2024-syndata-smolmodels",
            "audio_url": "https://api.substack.com/feed/podcast/153567986/15b89ad8eca715fabe21b3d2bb80af59.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 120,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:153556680",
            "index": 104,
            "title": "2024 in Post-Transformers Architectures (State Space Models, RWKV) [LS Live @ NeurIPS]",
            "pub_date": "2024-12-24T02:43:31.000Z",
            "duration": "2582",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "agents",
              "openai",
              "gemini",
              "mistral"
            ],
            "page_url": "https://www.latent.space/p/2024-post-transformers",
            "audio_url": "https://api.substack.com/feed/podcast/153556680/a533cdc5470427fffd56fc773f1f0186.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 187,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:153509369",
            "index": 105,
            "title": "2024 in Open Models [LS Live @ NeurIPS]",
            "pub_date": "2024-12-23T04:29:08.000Z",
            "duration": "2544",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "openai",
              "anthropic",
              "claude",
              "mistral"
            ],
            "page_url": "https://www.latent.space/p/2024-open-models",
            "audio_url": "https://api.substack.com/feed/podcast/153509369/adcaf325218a8d4e0e3f2f3e31b113a4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 141,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:153472517",
            "index": 106,
            "title": "2024 in Vision [LS Live @ NeurIPS]",
            "pub_date": "2024-12-22T01:43:03.000Z",
            "duration": "3445",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "agents",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/2024-vision",
            "audio_url": "https://api.substack.com/feed/podcast/153472517/227f81d52240e88d5e3cb9e507ccd5a1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:153389370",
            "index": 107,
            "title": "2024 in AI Startups [LS Live @ NeurIPS]",
            "pub_date": "2024-12-21T02:11:51.000Z",
            "duration": "3143",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/2024-startups",
            "audio_url": "https://api.substack.com/feed/podcast/153389370/9ae7081ab7a3fb6fd70223dd9765f5c4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:152934915",
            "index": 108,
            "title": "Windsurf: The Enterprise AI IDE - with Varun and Anshul of Codeium AI",
            "pub_date": "2024-12-13T17:15:00.000Z",
            "duration": "3995",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "copilot",
              "enterprise ai"
            ],
            "page_url": "https://www.latent.space/p/windsurf",
            "audio_url": "https://api.substack.com/feed/podcast/152934915/eb391cc202bfd4223c2460ab903ec7e9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:152857207",
            "index": 109,
            "title": "Generative Video WorldSim, Diffusion, Vision, Reinforcement Learning and Robotics — ICML 2024 Part 1",
            "pub_date": "2024-12-10T00:52:55.000Z",
            "duration": "25667",
            "duration_label": "7h 7m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "foundation model",
              "openai",
              "deepmind",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/icml-2024-video-robots",
            "audio_url": "https://api.substack.com/feed/podcast/152857207/fc127b21fc9e1ce2b383d8ad7ca23903.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:152358099",
            "index": 110,
            "title": "Bolt.new, Flow Engineering for Code Agents, and >$8m ARR in 2 months as a Claude Wrapper",
            "pub_date": "2024-12-02T21:02:00.000Z",
            "duration": "5919",
            "duration_label": "1h 38m",
            "selected": true,
            "confidence": "high",
            "score": 27,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/bolt",
            "audio_url": "https://api.substack.com/feed/podcast/152358099/fe0f16fd6f4bdce05c60cc1645f10f16.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 142,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:151960189",
            "index": 111,
            "title": "The new Claude 3.5 Sonnet, Computer Use, and Building SOTA Agents — with Erik Schluntz, Anthropic",
            "pub_date": "2024-11-28T17:43:31.000Z",
            "duration": "4270",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 31,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/claude-sonnet",
            "audio_url": "https://api.substack.com/feed/podcast/151960189/c5311062cf8886b05166088cb6b9c6cc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 248,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:152075599",
            "index": 112,
            "title": "Why Compound AI + Open Source will beat Closed AI",
            "pub_date": "2024-11-25T16:40:31.000Z",
            "duration": "3505",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "generative ai",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://www.latent.space/p/fireworks",
            "audio_url": "https://api.substack.com/feed/podcast/152075599/cdee02a1e54d0d8d5cbf384f66c6ec8a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 110,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:151713576",
            "index": 113,
            "title": "Agents @ Work: Lindy.ai",
            "pub_date": "2024-11-15T18:10:25.000Z",
            "duration": "4193",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 30,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/lindy",
            "audio_url": "https://api.substack.com/feed/podcast/151713576/459d826546dc9380342bc73c87ea8533.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 274,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:151438391",
            "index": 114,
            "title": "Agents @ Work: Dust.tt",
            "pub_date": "2024-11-11T20:19:08.000Z",
            "duration": "3606",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/dust",
            "audio_url": "https://api.substack.com/feed/podcast/151438391/b87806d98b16e86fc78976269aeed03f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 201,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:151006734",
            "index": 115,
            "title": "In the Arena: How LMSys changed LLM Benchmarking Forever",
            "pub_date": "2024-11-01T15:31:00.000Z",
            "duration": "2462",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "claude",
              "deepmind",
              "gemini",
              "llama",
              "inference"
            ],
            "page_url": "https://www.latent.space/p/lmarena",
            "audio_url": "https://api.substack.com/feed/podcast/151006734/082d2861ca3091a565753fbd12603921.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 153,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:150638218",
            "index": 116,
            "title": "How NotebookLM Was Made",
            "pub_date": "2024-10-25T15:55:00.000Z",
            "duration": "4437",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/notebooklm",
            "audio_url": "https://api.substack.com/feed/podcast/150638218/42da069946133e769cb71fa1b926d32b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 532,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:150237951",
            "index": 117,
            "title": "Building the AI Engineer Nation — with Josephine Teo, Minister of Digital Development and Information, Singapore",
            "pub_date": "2024-10-19T20:04:49.000Z",
            "duration": "3399",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "foundation model",
              "generative ai",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/josephine-teo",
            "audio_url": "https://api.substack.com/feed/podcast/150237951/52b665f2e2a120c875d75559b6916628.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 98,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:150323118",
            "index": 118,
            "title": "Building the Silicon Brain - with Drew Houston of Dropbox",
            "pub_date": "2024-10-18T16:31:41.000Z",
            "duration": "4299",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "large language model",
              "foundation model",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/drew-houston",
            "audio_url": "https://api.substack.com/feed/podcast/150323118/dcd290755ff37ea4ebe7839fc8fd60b4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 68,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:150108358",
            "index": 119,
            "title": "Production AI Engineering starts with Evals — with Ankur Goyal of Braintrust",
            "pub_date": "2024-10-11T22:33:53.000Z",
            "duration": "7000",
            "duration_label": "1h 56m",
            "selected": true,
            "confidence": "high",
            "score": 34,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "large language model",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/braintrust",
            "audio_url": "https://api.substack.com/feed/podcast/150108358/8fcee7227fd5a8bf8a2bbc0aba532015.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 246,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:149739218",
            "index": 120,
            "title": "Building AGI in Real Time (OpenAI Dev Day 2024)",
            "pub_date": "2024-10-03T17:24:17.000Z",
            "duration": "7754",
            "duration_label": "2h 9m",
            "selected": true,
            "confidence": "high",
            "score": 28,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/devday-2024",
            "audio_url": "https://api.substack.com/feed/podcast/149739218/834a7b6f89c1dff5c0e1e43fbd57e79d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 803,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:148799665",
            "index": 121,
            "title": "Language Agents: From Reasoning to Acting",
            "pub_date": "2024-09-27T17:59:18.000Z",
            "duration": "5384",
            "duration_label": "1h 29m",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/shunyu",
            "audio_url": "https://api.substack.com/feed/podcast/148799665/b0d165ece4a3d971deedd7d1519d099a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 426,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:149105932",
            "index": 122,
            "title": "The Ultimate Guide to Prompting",
            "pub_date": "2024-09-20T18:59:26.000Z",
            "duration": "4141",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "foundation model",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/learn-prompting",
            "audio_url": "https://api.substack.com/feed/podcast/149105932/926fb999dc5e48fb70cb2c02a4d9142b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 97,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:148799668",
            "index": 123,
            "title": "From API to AGI: Structured Outputs, OpenAI API platform and O1 Q&A — with Michelle Pokrass & OpenAI Devrel + Strawberry team",
            "pub_date": "2024-09-13T23:29:44.000Z",
            "duration": "7455",
            "duration_label": "2h 4m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "chatgpt",
              "openai",
              "gemini",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/openai-api-and-o1",
            "audio_url": "https://api.substack.com/feed/podcast/148799668/14fa9523c5a7c4818f665ecdcbdad1e6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:148436407",
            "index": 124,
            "title": "Efficiency is Coming: 3000x Faster, Cheaper, Better AI Inference from Hardware Improvements, Quantization, and Synthetic Data Distillation",
            "pub_date": "2024-09-03T15:45:00.000Z",
            "duration": "3918",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 41,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "llm",
              "large language model",
              "foundation model",
              "generative ai"
            ],
            "page_url": "https://www.latent.space/p/nyla",
            "audio_url": "https://api.substack.com/feed/podcast/148436407/e30dcafb40b7db2a737f88d317f987f3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:148204151",
            "index": 125,
            "title": "Why you should write your own LLM benchmarks — with Nicholas Carlini, Google DeepMind",
            "pub_date": "2024-08-29T14:02:00.000Z",
            "duration": "4205",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "openai",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/carlini",
            "audio_url": "https://api.substack.com/feed/podcast/148204151/a532401515e7da6bd24e483c708bb8fd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 214,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:147970725",
            "index": 126,
            "title": "Is finetuning GPT4o worth it? — with Alistair Pullen, Cosine (Genie)",
            "pub_date": "2024-08-22T14:57:00.000Z",
            "duration": "3919",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 19,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/cosine",
            "audio_url": "https://api.substack.com/feed/podcast/147970725/ca4f0790095dd0742cfe982023fea9e3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:147753766",
            "index": 127,
            "title": "AI Magic: Shipping 1000s of successful products with no managers and a team of 12 — Jeremy Howard of Answer.ai",
            "pub_date": "2024-08-16T14:59:00.000Z",
            "duration": "3536",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 27,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/answerai",
            "audio_url": "https://api.substack.com/feed/podcast/147753766/fb31796ed3bd9746baa13a7bb8de65e5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 58,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:147418165",
            "index": 128,
            "title": "Segment Anything 2: Demo-first Model Development",
            "pub_date": "2024-08-07T21:18:17.000Z",
            "duration": "3810",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "deepmind",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/sam2",
            "audio_url": "https://api.substack.com/feed/podcast/147418165/89acd1fe0db26f14578c27572bfb68f6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 222,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:147252120",
            "index": 129,
            "title": "The Winds of AI Winter (Q2 Four Wars Recap) + ChatGPT Voice Mode Preview",
            "pub_date": "2024-08-02T15:20:30.000Z",
            "duration": "6901",
            "duration_label": "1h 55m",
            "selected": true,
            "confidence": "high",
            "score": 38,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "frontier model",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/q2-2024-recap",
            "audio_url": "https://api.substack.com/feed/podcast/147252120/544c11555832c7e4b315543d6d89f998.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 210,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:146879553",
            "index": 130,
            "title": "Llama 2, 3 & 4: Synthetic Data, RLHF, Agents on the path to Open Source AGI",
            "pub_date": "2024-07-23T16:03:04.000Z",
            "duration": "3907",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 33,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "large language model",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/llama-3",
            "audio_url": "https://api.substack.com/feed/podcast/146879553/ecabd026b417bc9c4e9fb2c09d3cb59c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 120,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:146497374",
            "index": 131,
            "title": "Benchmarks 201: Why Leaderboards > Arenas >> LLM-as-Judge",
            "pub_date": "2024-07-12T22:38:55.000Z",
            "duration": "3509",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/benchmarks-201",
            "audio_url": "https://api.substack.com/feed/podcast/146497374/41787c4a131f14d0e21bdc6eabffbcf2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 86,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:145606648",
            "index": 132,
            "title": "The 10,000x Yolo Researcher Metagame — with Yi Tay of Reka",
            "pub_date": "2024-07-05T16:12:17.000Z",
            "duration": "6278",
            "duration_label": "1h 44m",
            "selected": true,
            "confidence": "high",
            "score": 29,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/yitay",
            "audio_url": "https://api.substack.com/feed/podcast/145606648/21e95955cee4c386cba8b8615dbe92c7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 606,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:145986807",
            "index": 133,
            "title": "State of the Art: Training >70B LLMs on 10,000 H100 clusters",
            "pub_date": "2024-06-25T17:13:24.000Z",
            "duration": "4909",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "high",
            "score": 26,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "openai",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/llm-training-2024",
            "audio_url": "https://api.substack.com/feed/podcast/145986807/1ee2c16222fec203590375dde84d868c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 663,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:145970909",
            "index": 134,
            "title": "[High Agency] AI Engineer World's Fair Preview",
            "pub_date": "2024-06-25T05:06:54.000Z",
            "duration": "2982",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://www.latent.space/p/high-agency",
            "audio_url": "https://api.substack.com/feed/podcast/145970909/ac09b90582f11f2cd416b97b2c07afef.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:145870526",
            "index": 135,
            "title": "How To Hire AI Engineers — with James Brady & Adam Wiggins of Elicit",
            "pub_date": "2024-06-21T21:11:53.000Z",
            "duration": "3822",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "openai",
              "anthropic",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/hiring",
            "audio_url": "https://api.substack.com/feed/podcast/145870526/1d7df140eb64101a17e131f4e083e107.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 225,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:145472808",
            "index": 136,
            "title": "How AI is eating Finance — with Mike Conover of Brightwave",
            "pub_date": "2024-06-11T15:24:58.000Z",
            "duration": "3296",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "agent",
              "agentic",
              "gemini",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/brightwave",
            "audio_url": "https://api.substack.com/feed/podcast/145472808/637eadf07ac17d779a6cf0aa225713e3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:145010930",
            "index": 137,
            "title": "ICLR 2024 — Best Papers & Talks (Benchmarks, Reasoning & Agents) — ft. Graham Neubig, Aman Sanger, Moritz Hardt)",
            "pub_date": "2024-06-10T03:06:38.000Z",
            "duration": "16159",
            "duration_label": "4h 29m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/iclr-2024-benchmarks-agents",
            "audio_url": "https://api.substack.com/feed/podcast/145010930/5cbb7031e611f9aa7f38336430347ace.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:145118861",
            "index": 138,
            "title": "How to train a Million Context LLM — with Mark Huang of Gradient.ai",
            "pub_date": "2024-05-30T18:23:00.000Z",
            "duration": "3450",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 32,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "generative ai",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/gradient",
            "audio_url": "https://api.substack.com/feed/podcast/145118861/65e1226dbc53ca8df9d7994e2343f231.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 83,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:144493543",
            "index": 139,
            "title": "ICLR 2024 — Best Papers & Talks (ImageGen, Vision, Transformers, State Space Models) ft. Durk Kingma, Christian Szegedy, Ilya Sutskever",
            "pub_date": "2024-05-27T14:59:00.000Z",
            "duration": "13083",
            "duration_label": "3h 38m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "openai",
              "deepmind",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/iclr-2024-recap",
            "audio_url": "https://api.substack.com/feed/podcast/144493543/8b1ccbb1d4378186b6a86f1ced58323d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:144493224",
            "index": 140,
            "title": "Emulating Humans with NSFW Chatbots - with Jesse Silver",
            "pub_date": "2024-05-16T17:53:38.000Z",
            "duration": "3255",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "openai",
              "llama",
              "inference"
            ],
            "page_url": "https://www.latent.space/p/nsfw-chatbots",
            "audio_url": "https://api.substack.com/feed/podcast/144493224/a5241f3aa93be73e1b379ffa4279a834.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 67,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:144065954",
            "index": 141,
            "title": "WebSim, WorldSim, and The Summer of Simulative AI — with Joscha Bach of Liquid AI, Karan Malhotra of Nous Research, Rob Haisfield of WebSim.ai",
            "pub_date": "2024-04-27T11:39:15.000Z",
            "duration": "3210",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 27,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/sim-ai",
            "audio_url": "https://api.substack.com/feed/podcast/144065954/211db4860bdaf8433a005ad77de5bf04.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:143697169",
            "index": 142,
            "title": "High Agency Pydantic > VC Backed Frameworks — with Jason Liu of Instructor",
            "pub_date": "2024-04-19T19:07:36.000Z",
            "duration": "3140",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/instructor",
            "audio_url": "https://api.substack.com/feed/podcast/143697169/f060c975d3dc0ce0ea1ea5e658eed89f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 119,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:143400989",
            "index": 143,
            "title": "Supervise the Process of AI Research — with Jungwon Byun and Andreas Stuhlmüller of Elicit",
            "pub_date": "2024-04-11T20:15:27.000Z",
            "duration": "3380",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 31,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/elicit",
            "audio_url": "https://api.substack.com/feed/podcast/143400989/eda46c42a59e2d1d2ebd5758e813769e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 144,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:143334144",
            "index": 144,
            "title": "Latent Space Chats: NLW (Four Wars, GPT5), Josh Albrecht/Ali Rohde (TNAI), Dylan Patel/Semianalysis (Groq), Milind Naphade (Nvidia GTC), Personal AI (ft. Harrison Chase — LangFriend/LangMem)",
            "pub_date": "2024-04-06T18:46:10.000Z",
            "duration": "9914",
            "duration_label": "2h 45m",
            "selected": true,
            "confidence": "high",
            "score": 41,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "large language model",
              "foundation model",
              "frontier model",
              "agent"
            ],
            "page_url": "https://www.latent.space/p/weekend-special-5-chats",
            "audio_url": "https://api.substack.com/feed/podcast/143334144/04a32184eac93dbdab8148562e701041.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 641,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:143067206",
            "index": 145,
            "title": "Presenting the AI Engineer World's Fair — with Sam Schillace, Deputy CTO of Microsoft",
            "pub_date": "2024-03-29T15:00:00.000Z",
            "duration": "2578",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "agent",
              "agents",
              "openai",
              "gpu"
            ],
            "page_url": "https://www.latent.space/p/worlds-fair-2024",
            "audio_url": "https://api.substack.com/feed/podcast/143067206/7ed32c6142ddb539cd6d6137b7572740.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 218,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:142817627",
            "index": 146,
            "title": "Why Google failed to make GPT-3 + why Multimodal Agents are the path to AGI — with David Luan of Adept",
            "pub_date": "2024-03-22T19:08:16.000Z",
            "duration": "2512",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 28,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/adept",
            "audio_url": "https://api.substack.com/feed/podcast/142817627/feb9af168d739c23574154c1dc08a566.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:142602431",
            "index": 147,
            "title": "Making Transformers Sing - with Mikey Shulman of Suno",
            "pub_date": "2024-03-14T16:48:42.000Z",
            "duration": "3171",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "generative ai",
              "openai",
              "llama",
              "nvidia"
            ],
            "page_url": "https://www.latent.space/p/suno",
            "audio_url": "https://api.substack.com/feed/podcast/142602431/34b7aa85eb40a0368b1d984050d41a31.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:142431075",
            "index": 148,
            "title": "Top 5 Research Trends + OpenAI Sora, Google Gemini, Groq Math (Jan-Feb 2024 Audio Recap) + Latent Space Anniversary with Lindy.ai, RWKV, Pixee, Julius.ai, Listener Q&A!",
            "pub_date": "2024-03-09T22:55:15.000Z",
            "duration": "6532",
            "duration_label": "1h 48m",
            "selected": true,
            "confidence": "high",
            "score": 43,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "large language model",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/jan-feb-2024-recap-audio",
            "audio_url": "https://api.substack.com/feed/podcast/142431075/71caa2c915ad86d7c31b005d4d0ee4d8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 484,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:142310057",
            "index": 149,
            "title": "Open Source AI is AI we can Trust — with Soumith Chintala of Meta AI",
            "pub_date": "2024-03-06T18:40:59.000Z",
            "duration": "4800",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "high",
            "score": 29,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "openai",
              "claude",
              "deepmind"
            ],
            "page_url": "https://www.latent.space/p/soumith",
            "audio_url": "https://api.substack.com/feed/podcast/142310057/c20ff4dddefcd8a5d3da13a64cf2fffc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 139,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:142111901",
            "index": 150,
            "title": "A Brief History of the Open Source AI Hacker - with Ben Firshman of Replicate",
            "pub_date": "2024-02-28T18:04:08.000Z",
            "duration": "4204",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 19,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "openai",
              "mistral",
              "llama",
              "nvidia"
            ],
            "page_url": "https://www.latent.space/p/replicate",
            "audio_url": "https://api.substack.com/feed/podcast/142111901/061a6dced55096350748b338602246e9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 169,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:141683117",
            "index": 151,
            "title": "Truly Serverless Infra for AI Engineers - with Erik Bernhardsson of Modal",
            "pub_date": "2024-02-16T17:42:47.000Z",
            "duration": "3745",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "openai",
              "gemini",
              "gpu"
            ],
            "page_url": "https://www.latent.space/p/modal",
            "audio_url": "https://api.substack.com/feed/podcast/141683117/a97925bc56ccef4c06571d1d8e82fc0f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 166,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:141447889",
            "index": 152,
            "title": "Cloud Intelligence at the speed of 5000 tok/s - with Ce Zhang and Vipul Ved Prakash of Together AI",
            "pub_date": "2024-02-08T16:57:15.000Z",
            "duration": "3791",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "frontier model",
              "mistral",
              "llama",
              "nvidia"
            ],
            "page_url": "https://www.latent.space/p/together",
            "audio_url": "https://api.substack.com/feed/podcast/141447889/9dfc03f3219bb432b6c227d2eb8dd7ea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 142,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:140985865",
            "index": 153,
            "title": "Why StackOverflow usage is down 50% — with David Hsu of Retool",
            "pub_date": "2024-02-01T18:15:05.000Z",
            "duration": "3504",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "agents",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://www.latent.space/p/retool",
            "audio_url": "https://api.substack.com/feed/podcast/140985865/c49c4faf8eb5e688f683381006b4fec1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 73,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:141025154",
            "index": 154,
            "title": "The Four Wars of the AI Stack (Dec 2023 Audio Recap)",
            "pub_date": "2024-01-25T22:37:40.000Z",
            "duration": "4098",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "gpu",
              "inference",
              "rag"
            ],
            "page_url": "https://www.latent.space/p/dec-2023-audio",
            "audio_url": "https://api.substack.com/feed/podcast/141025154/d20ba7d17799fd035cc4776c36402cc2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:140820515",
            "index": 155,
            "title": "How to train your own Large Multimodal Model — with Hugo Laurençon & Leo Tronchon of HuggingFace M4",
            "pub_date": "2024-01-19T17:09:45.000Z",
            "duration": "4310",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "openai",
              "deepmind",
              "mistral",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/idefics",
            "audio_url": "https://api.substack.com/feed/podcast/140820515/391f812d878085f4538a316fbecf3cf0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:140498023",
            "index": 156,
            "title": "RLHF 201 - with Nathan Lambert of AI2 and Interconnects",
            "pub_date": "2024-01-11T19:22:50.000Z",
            "duration": "5130",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/rlhf-201",
            "audio_url": "https://api.substack.com/feed/podcast/140498023/123c87d5ab63626b70f035ec3dbb5480.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 159,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:140363662",
            "index": 157,
            "title": "The Accidental AI Canvas - with Steve Ruiz of tldraw",
            "pub_date": "2024-01-05T20:43:11.000Z",
            "duration": "3849",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://www.latent.space/p/tldraw",
            "audio_url": "https://api.substack.com/feed/podcast/140363662/933490664e48df958d799d7c5281abae.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 119,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:140188949",
            "index": 158,
            "title": "NeurIPS 2023 Recap — Top Startups",
            "pub_date": "2023-12-30T16:30:00.000Z",
            "duration": "9714",
            "duration_label": "2h 41m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "perplexity",
              "cursor"
            ],
            "page_url": "https://www.latent.space/p/neurips-2023-startups",
            "audio_url": "https://api.substack.com/feed/podcast/140188949/767b140a547ef05b86ecf161c4e56b98.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:139971607",
            "index": 159,
            "title": "NeurIPS 2023 Recap — Best Papers",
            "pub_date": "2023-12-23T23:44:13.000Z",
            "duration": "12026",
            "duration_label": "3h 20m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "openai",
              "anthropic",
              "claude",
              "deepmind"
            ],
            "page_url": "https://www.latent.space/p/neurips-2023-papers",
            "audio_url": "https://api.substack.com/feed/podcast/139971607/26b6512678ee9011a4167f5f11b6c908.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:139926717",
            "index": 160,
            "title": "The AI-First Graphics Editor - with Suhail Doshi of Playground AI",
            "pub_date": "2023-12-20T20:31:17.000Z",
            "duration": "3540",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "generative ai",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://www.latent.space/p/suhail-doshi",
            "audio_url": "https://api.substack.com/feed/podcast/139926717/58942d2bc40c1846f3ef1ad9c8d4ea86.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 164,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:139766004",
            "index": 161,
            "title": "The \"Normsky\" architecture for AI coding agents — with Beyang Liu + Steve Yegge of SourceGraph",
            "pub_date": "2023-12-14T18:48:22.000Z",
            "duration": "4777",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 37,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "agent",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/sourcegraph",
            "audio_url": "https://api.substack.com/feed/podcast/139766004/c0ad8bfde2971b1dffed911f471cecbe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 348,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:139607453",
            "index": 162,
            "title": "The Busy Person's Intro to Finetuning & Open Source AI - Wing Lian, Axolotl",
            "pub_date": "2023-12-08T16:16:07.000Z",
            "duration": "3858",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agentic",
              "chatgpt",
              "openai",
              "gemini",
              "mistral"
            ],
            "page_url": "https://www.latent.space/p/axolotl",
            "audio_url": "https://api.substack.com/feed/podcast/139607453/afd770993b7bc907e4751045f8e38f63.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 296,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:139219943",
            "index": 163,
            "title": "Notebooks = Chat++ and RAG = RecSys! — with Bryan Bischof of Hex Magic",
            "pub_date": "2023-11-29T21:10:00.000Z",
            "duration": "3114",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "perplexity"
            ],
            "page_url": "https://www.latent.space/p/bryan-bischof",
            "audio_url": "https://api.substack.com/feed/podcast/139219943/7f42cfa90813e2d04b79afc7436661c8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 58,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:138846476",
            "index": 164,
            "title": "The State of Silicon and the GPU Poors - with Dylan Patel of SemiAnalysis",
            "pub_date": "2023-11-17T19:32:06.000Z",
            "duration": "3181",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "agent",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/semianalysis",
            "audio_url": "https://api.substack.com/feed/podcast/138846476/6dbe9fc182e416c28fdc70bf9291829c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 63,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:138928216",
            "index": 165,
            "title": "AGI is Being Achieved Incrementally (DevDay Recap - cleaned audio)",
            "pub_date": "2023-11-08T07:27:00.000Z",
            "duration": "8500",
            "duration_label": "2h 21m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "agents",
              "nvidia"
            ],
            "page_url": "https://www.latent.space/p/devday-recap-clean",
            "audio_url": "https://api.substack.com/feed/podcast/138928216/d53af1811700412c52f98f4872d1a88f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:138678364",
            "index": 166,
            "title": "AGI is Being Achieved Incrementally (OpenAI DevDay w/ Simon Willison, Alex Volkov, Jim Fan, Raza Habib, Shreya Rajpal, Rahul Ligma, et al)",
            "pub_date": "2023-11-08T00:49:53.000Z",
            "duration": "8553",
            "duration_label": "2h 22m",
            "selected": true,
            "confidence": "high",
            "score": 35,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/devday",
            "audio_url": "https://api.substack.com/feed/podcast/138678364/b25ca34e7fe06eea04701649bd1d19d8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 857,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:138498146",
            "index": 167,
            "title": "Beating GPT-4 with Open Source LLMs — with Michael Royzen of Phind",
            "pub_date": "2023-11-03T16:04:49.000Z",
            "duration": "4041",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "mistral"
            ],
            "page_url": "https://www.latent.space/p/phind",
            "audio_url": "https://api.substack.com/feed/podcast/138498146/8dad855b3584915ec1771a3fb2f4bbb2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 197,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:138284391",
            "index": 168,
            "title": "Powering your Copilot for Data – with Artem Keydunov of Cube.dev",
            "pub_date": "2023-10-26T16:33:59.000Z",
            "duration": "2328",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "perplexity"
            ],
            "page_url": "https://www.latent.space/p/cube",
            "audio_url": "https://api.substack.com/feed/podcast/138284391/d5de3ed28a1d0ce1c6023a3f06653601.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 59,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:138050038",
            "index": 169,
            "title": "The End of Finetuning — with Jeremy Howard of Fast.ai",
            "pub_date": "2023-10-19T20:14:36.000Z",
            "duration": "4155",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 26,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "large language model",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/fastai",
            "audio_url": "https://api.substack.com/feed/podcast/138050038/80c92152442002d8002afad9e703db1b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 168,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:137874596",
            "index": 170,
            "title": "Why AI Agents Don't Work (yet) - with Kanjun Qiu of Imbue",
            "pub_date": "2023-10-14T21:15:58.000Z",
            "duration": "3902",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://www.latent.space/p/imbue",
            "audio_url": "https://api.substack.com/feed/podcast/137874596/1d4bb9d64416e350adf14925dad36d74.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 181,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:137740646",
            "index": 171,
            "title": "[AIE Summit Preview #2] The AI Horcrux — Swyx on Cognitive Revolution",
            "pub_date": "2023-10-08T07:30:08.000Z",
            "duration": "5388",
            "duration_label": "1h 29m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "agent",
              "agents",
              "openai",
              "safety"
            ],
            "page_url": "https://www.latent.space/p/cogrev-aies",
            "audio_url": "https://api.substack.com/feed/podcast/137740646/38e11d709d1655ccab3f3e308f9e3ce1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137745139",
            "index": 172,
            "title": "[AIE Summit Preview #1] Swyx on Software 3.0 and the Rise of the AI Engineer",
            "pub_date": "2023-10-07T07:00:44.000Z",
            "duration": "2329",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "openai",
              "claude",
              "gpu",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.latent.space/p/aies-podrocket",
            "audio_url": "https://api.substack.com/feed/podcast/137745139/8828ebd77be6d4579849f2307dabd95c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137668059",
            "index": 173,
            "title": "RAG Is A Hack - with Jerry Liu from LlamaIndex",
            "pub_date": "2023-10-05T16:26:00.000Z",
            "duration": "4086",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/llamaindex",
            "audio_url": "https://api.substack.com/feed/podcast/137668059/94e65c569e8fcf454463e3de10a24e1b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 299,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:137474557",
            "index": 174,
            "title": "Building the Foundation Model Ops Platform — with Raza Habib of Humanloop",
            "pub_date": "2023-09-29T19:08:10.000Z",
            "duration": "4877",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "deepmind",
              "evals",
              "multimodal"
            ],
            "page_url": "https://www.latent.space/p/humanloop",
            "audio_url": "https://api.substack.com/feed/podcast/137474557/633821313c316a54cafb7a9d0b34ebe2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137135173",
            "index": 175,
            "title": "Heralds of the AI Content Flippening — with Youssef Rizk of Wondercraft.ai",
            "pub_date": "2023-09-20T17:10:26.000Z",
            "duration": "3157",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "openai",
              "gpu",
              "multimodal"
            ],
            "page_url": "https://www.latent.space/p/wondercraft",
            "audio_url": "https://api.substack.com/feed/podcast/137135173/7f2c9b8769129fe1d93715a9da9f73d2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:136992893",
            "index": 176,
            "title": "Doing it the Hard Way: Making the AI engine and language 🔥 of the future — with Chris Lattner of Modular",
            "pub_date": "2023-09-14T16:12:13.000Z",
            "duration": "5362",
            "duration_label": "1h 29m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "openai",
              "llama",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://www.latent.space/p/modular",
            "audio_url": "https://api.substack.com/feed/podcast/136992893/0a9c32bc88c77dac5d97cd679b2e6b6e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 229,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:136578557",
            "index": 177,
            "title": "The Point of LangChain — with Harrison Chase of LangChain",
            "pub_date": "2023-09-06T14:59:00.000Z",
            "duration": "3650",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 23,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "frontier model",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/langchain",
            "audio_url": "https://api.substack.com/feed/podcast/136578557/50242c665a016dcc850f0f26b7cc1442.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 213,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:136547662",
            "index": 178,
            "title": "RWKV: Reinventing RNNs for the Transformer Era — with Eugene Cheah of UIlicious",
            "pub_date": "2023-08-30T16:04:19.000Z",
            "duration": "4331",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "openai",
              "gemini",
              "llama",
              "gpu",
              "inference"
            ],
            "page_url": "https://www.latent.space/p/rwkv",
            "audio_url": "https://api.substack.com/feed/podcast/136547662/4b893a10da528ef7318f1037387882c7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:136284642",
            "index": 179,
            "title": "Cursor.so: The AI-first Code Editor — with Aman Sanger of Anysphere",
            "pub_date": "2023-08-22T15:55:11.000Z",
            "duration": "3565",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 30,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.latent.space/p/cursor",
            "audio_url": "https://api.substack.com/feed/podcast/136284642/9d43e0e0ee1703ab27486797a8b1ffaa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 165,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:136047711",
            "index": 180,
            "title": "The Mathematics of Training LLMs — with Quentin Anthony of Eleuther AI",
            "pub_date": "2023-08-16T16:52:03.000Z",
            "duration": "3038",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 19,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "openai",
              "grok",
              "perplexity",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://www.latent.space/p/transformers-math",
            "audio_url": "https://api.substack.com/feed/podcast/136047711/48d981d835799b970867b03c1ec3ff2a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:135877261",
            "index": 181,
            "title": "LLMs Everywhere: Running 70B models in browsers and iPhones using MLC — with Tianqi Chen of CMU / OctoML",
            "pub_date": "2023-08-10T16:42:09.000Z",
            "duration": "3130",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agents",
              "openai",
              "llama",
              "nvidia"
            ],
            "page_url": "https://www.latent.space/p/llms-everywhere",
            "audio_url": "https://api.substack.com/feed/podcast/135877261/f3024f057f37fcc6256c27afadc02310.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 106,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:135723345",
            "index": 182,
            "title": "[AI Breakdown] Summer AI Technical Roundup: a Latent Space x AI Breakdown crossover pod!",
            "pub_date": "2023-08-04T18:38:07.000Z",
            "duration": "3542",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "https://www.latent.space/p/breakdown",
            "audio_url": "https://api.substack.com/feed/podcast/135723345/b6c4cbf45a8588066c87ecd81b07dc47.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 32,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:135410661",
            "index": 183,
            "title": "FlashAttention 2: making Transformers 800% faster w/o approximation - with Tri Dao of Together AI",
            "pub_date": "2023-07-26T16:46:04.000Z",
            "duration": "3271",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "chatgpt",
              "openai",
              "anthropic",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/flashattention",
            "audio_url": "https://api.substack.com/feed/podcast/135410661/0794db5093dcc5feeb1a0ffafb534713.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:135258128",
            "index": 184,
            "title": "Llama 2: The New Open LLM SOTA (ft. Nathan Lambert, Matt Bornstein, Anton Troynikov, Russell Kaplan, Whole Mars Catalog et al.)",
            "pub_date": "2023-07-19T14:00:00.000Z",
            "duration": "4793",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 30,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "foundation model",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/llama2",
            "audio_url": "https://api.substack.com/feed/podcast/135258128/b74fe631aa53269da0da12536f3057a7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 463,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:131136238",
            "index": 185,
            "title": "AI Fundamentals: Datasets 101",
            "pub_date": "2023-07-17T19:10:22.000Z",
            "duration": "3655",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "openai",
              "deepmind",
              "gpu",
              "training"
            ],
            "page_url": "https://www.latent.space/p/datasets-101",
            "audio_url": "https://api.substack.com/feed/podcast/131136238/3edb24c98ab70ab21e6e389bc37a6425.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:134257068",
            "index": 186,
            "title": "Code Interpreter == GPT 4.5 (w/ Simon Willison, Alex Volkov, Aravind Srinivas, Alex Graveley, et al.)",
            "pub_date": "2023-07-10T20:10:22.000Z",
            "duration": "7434",
            "duration_label": "2h 3m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "perplexity",
              "embedding",
              "multimodal",
              "coding"
            ],
            "page_url": "https://www.latent.space/p/code-interpreter",
            "audio_url": "https://api.substack.com/feed/podcast/134257068/f18eba36b1eaa0c8676c4cdc487cfe75.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:132591812",
            "index": 187,
            "title": "[Practical AI] AI Trends: a Latent Space x Practical AI crossover pod!",
            "pub_date": "2023-07-02T17:56:11.000Z",
            "duration": "3619",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.latent.space/p/practical-ai-trends",
            "audio_url": "https://api.substack.com/feed/podcast/132591812/6eaf91d9646025243c48e1973cbfc53d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:132399331",
            "index": 188,
            "title": "[Cognitive Revolution] The Tiny Model Revolution with Ronen Eldan and Yuanzhi Li of Microsoft Research",
            "pub_date": "2023-07-01T21:13:47.000Z",
            "duration": "7525",
            "duration_label": "2h 5m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "chatgpt",
              "openai",
              "llama",
              "perplexity"
            ],
            "page_url": "https://www.latent.space/p/cogrev-tinystories",
            "audio_url": "https://api.substack.com/feed/podcast/132399331/47ca48f934434093f800f28530bc5f20.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:129414110",
            "index": 189,
            "title": "Commoditizing the Petaflop — with George Hotz of the tiny corp",
            "pub_date": "2023-06-20T15:34:04.000Z",
            "duration": "4361",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/geohot",
            "audio_url": "https://api.substack.com/feed/podcast/129414110/89b9293d799ec4592ce76d5e9afd346b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 391,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:128128854",
            "index": 190,
            "title": "Emergency Pod: OpenAI's new Functions API, 75% Price Drop, 4x Context Length (w/ Alex Volkov, Simon Willison, Riley Goodside, Joshua Lochner, Stefania Druga, Eric Elliott, Mayo Oshin et al)",
            "pub_date": "2023-06-14T17:50:29.000Z",
            "duration": "5292",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "llm",
              "agents",
              "openai",
              "embedding"
            ],
            "page_url": "https://www.latent.space/p/function-agents",
            "audio_url": "https://api.substack.com/feed/podcast/128128854/10c005df9486c64d2f1a79a9afa77ae0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:126747491",
            "index": 191,
            "title": "From RLHF to RLHB: The Case for Learning from Human Behavior - with Jeffrey Wang and Joe Reeve of Amplitude",
            "pub_date": "2023-06-08T20:00:00.000Z",
            "duration": "2969",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/amplitude",
            "audio_url": "https://api.substack.com/feed/podcast/126747491/f9234256ee791775fcf937ea3ce9eef5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 88,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:125082085",
            "index": 192,
            "title": "Building the AI × UX Scenius — with Linus Lee of Notion AI",
            "pub_date": "2023-06-01T18:53:34.000Z",
            "duration": "4190",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://www.latent.space/p/ai-interfaces-and-notion",
            "audio_url": "https://api.substack.com/feed/podcast/125082085/7dae1e4168664caf814ade78b4146c64.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 155,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:123420423",
            "index": 193,
            "title": "Debugging the Internet with AI agents – with Itamar Friedman of Codium AI and AutoGPT",
            "pub_date": "2023-05-25T12:43:04.000Z",
            "duration": "3756",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "foundation model",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/codium-agents",
            "audio_url": "https://api.substack.com/feed/podcast/123420423/7aca68590895b550b64bd2a1d54bce55.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 120,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:122567124",
            "index": 194,
            "title": "MPT-7B and The Beginning of Context=Infinity — with Jonathan Frankle and Abhinav Venigalla of MosaicML",
            "pub_date": "2023-05-20T21:03:36.000Z",
            "duration": "4003",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "anthropic",
              "deepmind",
              "llama",
              "perplexity",
              "nvidia"
            ],
            "page_url": "https://www.latent.space/p/mosaic-mpt-7b",
            "audio_url": "https://api.substack.com/feed/podcast/122567124/6490b30865ec09f51496855a2fa0e862.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 220,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:121662773",
            "index": 195,
            "title": "Guaranteed quality and structure in LLM outputs - with Shreya Rajpal of Guardrails AI",
            "pub_date": "2023-05-16T00:14:01.000Z",
            "duration": "3748",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.latent.space/p/guaranteed-quality-and-structure",
            "audio_url": "https://api.substack.com/feed/podcast/121662773/fc743e67d55092558f14749949b9447c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 198,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:120093157",
            "index": 196,
            "title": "The AI Founder Gene: Being Early, Building Fast, and Believing in Greatness — with Sharif Shameem of Lexica",
            "pub_date": "2023-05-08T18:05:06.000Z",
            "duration": "3037",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 26,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://www.latent.space/p/sharif-shameem",
            "audio_url": "https://api.substack.com/feed/podcast/120093157/73b072b2a42695224ca81ddd79ea46ea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 167,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:119492812",
            "index": 197,
            "title": "No Moat: Closed AI gets its Open Source wakeup call — ft. Simon Willison",
            "pub_date": "2023-05-05T16:17:30.000Z",
            "duration": "2629",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "agentic",
              "openai",
              "deepmind",
              "google ai"
            ],
            "page_url": "https://www.latent.space/p/no-moat",
            "audio_url": "https://api.substack.com/feed/podcast/119492812/d3c7f540ad2c682c84eca545cce069c4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:118824331",
            "index": 198,
            "title": "Training a SOTA Code LLM in 1 week and Quantifying the Vibes — with Reza Shabani of Replit",
            "pub_date": "2023-05-03T15:16:12.000Z",
            "duration": "4171",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 25,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "openai",
              "llama",
              "perplexity"
            ],
            "page_url": "https://www.latent.space/p/reza-shabani",
            "audio_url": "https://api.substack.com/feed/podcast/118824331/e08c73e511d0ba5fe3b333c14f3a3774.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 332,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:117989100",
            "index": 199,
            "title": "Mapping the future of *truly* Open Models and Training Dolly for $30 — with Mike Conover of Databricks",
            "pub_date": "2023-04-29T01:15:21.000Z",
            "duration": "4559",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "foundation model",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://www.latent.space/p/mike-conover",
            "audio_url": "https://api.substack.com/feed/podcast/117989100/adcbc302672d7ea3b3f801ab2390696a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:116379427",
            "index": 200,
            "title": "AI-powered Search for the Enterprise — with Deedy Das of Glean",
            "pub_date": "2023-04-22T00:07:21.000Z",
            "duration": "3842",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 21,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agent",
              "chatgpt",
              "openai",
              "llama"
            ],
            "page_url": "https://www.latent.space/p/deedy-das",
            "audio_url": "https://api.substack.com/feed/podcast/116379427/7b13cd5cfbf87cf837ad90a02a053699.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rss_transcript",
              "transcript_record_count": 285,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          }
        ]
      },
      {
        "id": "no-priors",
        "title": "No Priors AI",
        "feed_title": "No Priors AI",
        "priority": "P0",
        "selection_mode": "all_ai",
        "focus": [
          "AI startups",
          "venture",
          "model companies",
          "AI products"
        ],
        "feed_url": "https://rss.art19.com/no-priors-ai",
        "source_url": "https://rss.art19.com/no-priors-ai",
        "detail_path": "/podcasts/no-priors/",
        "episode_count": 200,
        "selected_episode_count": 200,
        "latest_episode_title": "Challenges for Innovative AI IPOs",
        "latest_pub_date": "2026-06-05T21:19:29.000Z",
        "latest_page_url": "",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "gid://art19-episode-locator/V0/w893HSNavWVEunAiXiBjtHhj8aZKLk_jTwAHO0jVJyA",
            "index": 1,
            "title": "Challenges for Innovative AI IPOs",
            "pub_date": "2026-06-05T21:19:29.000Z",
            "duration": "00:12:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f798948d-8495-491c-bfaf-0f022b6849a6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/SEW8VQc2CNWhboOUwTGLgqzLO4fLEfG70f0twWI8BuY",
            "index": 2,
            "title": "Alphabet's Request for $80 Billion AI Funding",
            "pub_date": "2026-06-02T21:46:39.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "github copilot",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0c31d6b4-8fdb-416d-9c96-b82777038c6d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/rTQ8RS5tx_GXlA1P-lXkpr6FzGRbO_9P0aaQHKHP4nI",
            "index": 3,
            "title": "New Beginnings: Anthropic's IPO and Nvidia",
            "pub_date": "2026-06-01T20:43:20.000Z",
            "duration": "00:13:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia",
              "chip",
              "reasoning",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8635e2ca-2707-428a-94c5-3c8cf772e57e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ZN_xna1LhBqDB16FyElOdvbltBYhGMru0IT2oD2RzqA",
            "index": 4,
            "title": "Anthropic's Valuation Journey: From Zero to $965B",
            "pub_date": "2026-05-29T20:54:09.000Z",
            "duration": "00:15:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "grok",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0c53d166-e394-4841-9d5a-c25190dd5fc3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/8cYLVyWdna6tOTiRdgC6RYvMRgcjG4gyjHUIo932iFA",
            "index": 5,
            "title": "Understanding AI's Economic Impact",
            "pub_date": "2026-05-28T01:48:26.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/40b7b525-3394-40c4-b3b6-c4a38f0d5f26.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/JqLUZZDrDsK2OI9-UrzFij5eHNPuns7uMdp5SvYm71g",
            "index": 6,
            "title": "Uber's AI Spending, the Pope on AI, TikTok and Universal's AI Music Deal",
            "pub_date": "2026-05-26T21:24:05.000Z",
            "duration": "00:18:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/74a9a348-d3c0-4ea8-871d-dcd1dec53aee.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/bsEbJintvOWDYMHKxFAL4C7Npr9BVePTa2G-Z6zUsI8",
            "index": 7,
            "title": "AI Interaction Models without Bias",
            "pub_date": "2026-05-25T23:33:51.000Z",
            "duration": "00:13:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4ce09b88-d5cb-4530-bc6d-0380c2f47199.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/-GOIE5H5MJk30gVlBPQYegVmldfMOM8LO4D6jz1ssRU",
            "index": 8,
            "title": "SpaceX’s Vision for Future AI Valuations",
            "pub_date": "2026-05-22T22:18:47.000Z",
            "duration": "00:12:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b8525cd0-1e10-4ae4-8c4b-6ecf9be85722.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1uJFR9SNT7BdzkE37UAnv-QUKFpqdAn4jivj2bgqNwQ",
            "index": 9,
            "title": "Bridging the Gap: AI and Investments",
            "pub_date": "2026-05-22T00:14:16.000Z",
            "duration": "00:17:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3b41bb27-3d30-4718-a624-e93c83a54c0e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/wD_T-5K95MWmmKLk0gGBl1urGpBJwmv1msCQXjMGjzs",
            "index": 10,
            "title": "OpenAI and SpaceX are Racing to IPO First",
            "pub_date": "2026-05-20T22:11:40.000Z",
            "duration": "00:18:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d8c71f1a-e392-42d0-a197-24e58b144353.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/uZ2KQGYduSX2c1DitxZnbo7cRinOGalRbRyJ-xfjOso",
            "index": 11,
            "title": "Smart Glasses: The New Frontier",
            "pub_date": "2026-05-18T20:01:37.000Z",
            "duration": "00:15:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7757664e-95ff-4b58-931a-c1dd77dc5b8b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ktgV2lRIDcuE_nsBJmWD0mgZEX2NvK7UC-gs4jiTAVM",
            "index": 12,
            "title": "ChatGPT's in Your Bank, Google Spams the GEO Industry, Brockman Takes OpenAI Product",
            "pub_date": "2026-05-16T00:02:13.000Z",
            "duration": "00:19:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0eb5d812-41b5-4a47-93aa-e7549247c369.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/pRGeFTSWogX9aC0p5ON5TNZ3qaEcF3cTTnWPMV4mKvo",
            "index": 13,
            "title": "Anthropic + Gates Give $200M to Healthcare | Cerebras IPO Doubles",
            "pub_date": "2026-05-14T20:51:17.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/76e974ad-e443-4b97-950d-c789e1453fe9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/BP16WM8KTD92QeSoAx3T3kFNHbIvRC32rjI6qCUD2F4",
            "index": 14,
            "title": "Claude for Small Business ships | Altman Testifies He's 'truthful'",
            "pub_date": "2026-05-13T22:04:25.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "gemini",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/fb94f534-0b09-4c21-a1c8-096d3fe681cd.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/EENFsbodZZHqz9dynWmiQVE3G1mSzsJlH76gx74fZzU",
            "index": 15,
            "title": "Amazon Devs \"tokenmaxxing\", SpaceX & Google Collab, Anthropic Legal Fight",
            "pub_date": "2026-05-12T21:50:47.000Z",
            "duration": "00:17:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/25e0ef48-d10b-4cb9-aa80-519dc24c0298.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/xAV6PjUSQyNXJzHMUwuAVAD35onyEGJLxJPepnAAzi0",
            "index": 16,
            "title": "Google Stops AI Exploit, Nadella Testifies, OpenAI's New $4B Unit",
            "pub_date": "2026-05-11T22:30:52.000Z",
            "duration": "00:16:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9880bab4-9b0e-4404-ab34-9ded452dc176.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/-R993hwEDY0w0PyLFZkjq6JZl-apR3isrQdNbheZHB0",
            "index": 17,
            "title": "Anthropic Aiming for $1 Trillion Valuation",
            "pub_date": "2026-05-08T19:50:06.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/16f3bdbc-5731-48da-86c8-3eea4487fee9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/G7PfQ0k4oCFrPEkwdV4QhBJa3-Rahm6wAkS4gfuO8p8",
            "index": 18,
            "title": "Anthropic's Claude 'Dreaming' Enhancements",
            "pub_date": "2026-05-07T21:05:44.000Z",
            "duration": "00:15:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0b966c77-bf96-4266-8d2f-22c74b10b279.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/EYM5HOKlir8R9JBUveRPK2h6p_x__XW5kPlVh2a-nXY",
            "index": 19,
            "title": "Innovations in GPT 5.5 Explored",
            "pub_date": "2026-05-06T21:03:13.000Z",
            "duration": "00:11:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "claude",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/47b888ed-201e-47a2-8aee-ba4431760be8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/G_j_salXOUW5ZvqreyMRouVeYYEpJua1iReGEKD_-8U",
            "index": 20,
            "title": "The Significance of AI Unionization",
            "pub_date": "2026-05-05T21:02:28.000Z",
            "duration": "00:21:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7c14bea3-ba1c-4d36-a7d2-993661eaaf87.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/x8hiCaeAVrOak5B0Y5GDj0667nD1c5mC5gHpq3UklWQ",
            "index": 21,
            "title": "Examining AI's Funding without Bias",
            "pub_date": "2026-05-04T21:42:45.000Z",
            "duration": "00:19:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b1c18ee1-0342-4ff8-ac8d-0c1c11864798.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/8G5hmDDW3buWCLwKiPVliZncA_xe16R4u9ZuET1YP4M",
            "index": 22,
            "title": "Anthropic's $900 Billion Fundraising Endeavor",
            "pub_date": "2026-05-01T20:50:18.000Z",
            "duration": "00:12:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "anthropic",
              "grok"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/189efd15-204c-4724-b4ef-ad9b6536a057.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/cv-q1-DtNYKxoqIMd9fBeyhJ8w5SSRBe1bmAWYW6nZs",
            "index": 23,
            "title": "Unpacking Anthropic's $50 Billion Funding Goal",
            "pub_date": "2026-04-30T18:59:10.000Z",
            "duration": "00:23:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/47106958-27c9-417d-805a-d75606684589.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/UmcvG9DCAgk3BLzZf-PmAAQtVLUywoqD-KjDqk1YjvU",
            "index": 24,
            "title": "Musk and Altman's Legal Proceedings: Day 3",
            "pub_date": "2026-04-29T23:33:39.000Z",
            "duration": "00:14:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3adf1c33-b0b2-4ba1-9613-01646a671ca5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/BF9r6UYsuj3GmDqJK46hKhckHWMbDkSj0GMroGSfzBQ",
            "index": 25,
            "title": "Uncovering Conflict: Altman and CFO",
            "pub_date": "2026-04-28T19:37:13.000Z",
            "duration": "00:21:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/505b81ed-b479-4b14-bbb7-e5d9c50d84a9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/yiGfWBQS_kE7wF-1IEtY1JFnvIBmk_A1IQOAJFG8CZU",
            "index": 26,
            "title": "OpenAI's Separation from Microsoft: A New Era",
            "pub_date": "2026-04-27T20:53:21.000Z",
            "duration": "00:16:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2d87171e-b485-43af-b90d-10d87e8a8e47.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/6HlP4wgKYvY2i3t8_xXUIgoyRa7C3Zco6wrCA3o7Tgo",
            "index": 27,
            "title": "ChatGPT 5.5: Unpacking Key Changes",
            "pub_date": "2026-04-24T20:26:45.000Z",
            "duration": "00:16:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "chatgpt",
              "gpu"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6f2722fe-0be2-4d54-a218-7b5a14c4c5c8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1D3_R0slxEqCCqUf-H0TePJELpntdHUrYtJMALrpkec",
            "index": 28,
            "title": "Forget What You Know: Google’s AI Strategy",
            "pub_date": "2026-04-22T21:51:51.000Z",
            "duration": "00:16:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ca74c606-07d5-47a4-b23a-4b0015076f78.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_VS13qEv0dSxMYo4JdFMqcgKiXm2_pslR6Rzti_V1KE",
            "index": 29,
            "title": "New Apple CEO, OpenAI's New Image Model, Vercel AI Hack",
            "pub_date": "2026-04-21T21:42:21.000Z",
            "duration": "00:16:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ade23efd-fbd6-48c5-816c-bac9e7041485.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/aw5hCcQOcoFZ-X21ldZY6LKs-IWi1FD1ijxiT14ZHwo",
            "index": 30,
            "title": "Anthropic Financially Surpasses OpenAI",
            "pub_date": "2026-04-20T21:06:15.000Z",
            "duration": "00:14:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7e22bebd-ce48-4ba2-8e67-750f8b78d7ad.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/umdKaXqTBv-unD_zEG_928KuvxrlMDhk0NriBB7IOG8",
            "index": 31,
            "title": "Understanding the Upgrade Path for Codex",
            "pub_date": "2026-04-17T20:26:39.000Z",
            "duration": "00:14:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/41fd35fa-e5b5-48f1-a235-37feb6ed3152.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lCsarzzfLyneGkxnd4gjuHfX3PBsgq6u7yp9u_eHSH4",
            "index": 32,
            "title": "Opus 4.7 Launch: Anthropic's Strategic Growth",
            "pub_date": "2026-04-16T22:13:12.000Z",
            "duration": "00:14:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ffefbe2f-f466-47a4-8415-c048f5e1a757.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lNSsa1pT_Mkacp9tGgsEC39-XB4JErqCntpwegJ2-Lk",
            "index": 33,
            "title": "Non-Traditional Views on Anthropic's IPO",
            "pub_date": "2026-04-15T11:23:58.000Z",
            "duration": "00:15:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ddf81130-4a95-400b-935c-8bf3fdc4df7e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/fqK87X_EC8Vbu-ZJxUlggjPIz-1nDXgfWtr1MLcgx2U",
            "index": 34,
            "title": "Zeroing In on AI Clones' Impact",
            "pub_date": "2026-04-13T21:47:47.000Z",
            "duration": "00:15:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ced4e2f8-4ebe-4e6a-b0b8-84ab9214a9a9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/VuObIbBX1q1HpOvippAWU1nI4Kta6h9XRmo8cJpsB4E",
            "index": 35,
            "title": "Introducing Gemini 4 by Meta",
            "pub_date": "2026-04-09T19:16:51.000Z",
            "duration": "00:15:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/14ae5896-905d-4e73-b788-f06d956ed3a2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KhrakDWdtC0utFpea-suFN8nF1m0ArrE1S7H2vkkz7A",
            "index": 36,
            "title": "Anthropic's Mythos Found Millions of Security Vulnerabilities",
            "pub_date": "2026-04-07T19:37:29.000Z",
            "duration": "00:11:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/efaf9eea-283c-473c-b3e0-a4c67a237f99.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/NIR4_gzX7UuxuxcP02teqdMtu1O4S8tvmu9m45Y5dU0",
            "index": 37,
            "title": "Q1 2026 Venture Funding Hits $300B Record",
            "pub_date": "2026-04-06T19:12:05.000Z",
            "duration": "00:16:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a552d538-41fb-4722-a4e6-0cd2dda13ef9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/A8eRNvekhlN-iddBJGdoiG10O0bHvjJcFuEW6ts0X44",
            "index": 38,
            "title": "OpenAI Acquires TBPN: (yes the tech news podcast)",
            "pub_date": "2026-04-03T21:05:38.000Z",
            "duration": "00:09:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4738c2ba-2aff-45a9-abd5-148256cd2c64.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/d_3Gb1o9DEpgjN3aI6WokD8ZLmdrAAbtgZa4EjPy0_Q",
            "index": 39,
            "title": "OpenAI's $121B Funding Round Explained",
            "pub_date": "2026-04-03T19:12:26.000Z",
            "duration": "00:13:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3b9dfe87-8bb3-43e5-b79d-69efe2ec7dcc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4SiXsSpAZfgAZWPd15AMG4KVmyvvCQBw7GrGOCDzimA",
            "index": 40,
            "title": "OpenAI's $40 Billion Investment and AI Advances",
            "pub_date": "2026-04-03T16:37:07.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e5c89af9-9472-4a11-9b9b-db134336fd71.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/IK17sdha9_afz-j0DrJDuvnqHGYjqB-7PqYrpHgo1dE",
            "index": 41,
            "title": "SoftBank's $40B OpenAI Investment & Anthropic's Claude Mythos Leak",
            "pub_date": "2026-03-27T21:57:42.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/42f92431-7ae8-4835-99fa-93067d9e2b53.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9InmnA-cshffFOP3fs33ZpYWxsvVmY_-NQ1ioTss_pQ",
            "index": 42,
            "title": "Claude Co-Work can now Control Your Computer",
            "pub_date": "2026-03-25T11:19:47.000Z",
            "duration": "00:12:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e9f5dad6-4c2e-44e0-94f9-9e5943b00246.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/54EIJoRY-YpC1sx34ZD0XTp28gnYCYQIKcEPrX4Ob3I",
            "index": 43,
            "title": "OpenAI Kills Sora Video Model",
            "pub_date": "2026-03-24T21:40:13.000Z",
            "duration": "00:10:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a30f3979-87a8-4213-a4df-bc9e06bca660.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/b-A_SOCBGN5tvJaYQJEtHPSo7Yy9ivFuuQY2JCsDdZo",
            "index": 44,
            "title": "Bezos to Raise $100B for AI and Nvidia's Challenges",
            "pub_date": "2026-03-23T21:09:53.000Z",
            "duration": "00:10:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c3175473-9d46-43d8-9cd1-f4756daea71e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/TSvr8TXhHNBSC1xqFdBAZhLY_ptnVNUxvt5rnOx6wj4",
            "index": 45,
            "title": "AI Web Traffic to Exceed Humans by 2027, and Rogue AI Agents",
            "pub_date": "2026-03-19T21:29:59.000Z",
            "duration": "00:14:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d80ea685-8978-441f-8d1f-9c51d28708d6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/oOviGXHYPd8CqBsylR1mUqcAyKg0hZB8BTBgyX2wV9o",
            "index": 46,
            "title": "Meta Manus Desktop App, Anthropic Enterprise Lead, OpenAI AWS Deal",
            "pub_date": "2026-03-18T11:18:55.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "data center",
              "robotics",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0d72b741-03dd-45b0-bbe6-1254d2a27461.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Odcta0plzZYcF4K0G75egaBrLaeWafg1gw1syazVp1A",
            "index": 47,
            "title": "Senators Say \"Shut AI Down\", Mistral Forage, Pentagon AI, Google AI",
            "pub_date": "2026-03-17T21:54:27.000Z",
            "duration": "00:14:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "google ai",
              "mistral",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/920aacfd-9b17-4d60-9382-739120ce8698.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/6MYtdcY95SYxc8Ydiu7MnhiKdhIz7ornm_rRb8HWSQI",
            "index": 48,
            "title": "Meta to Layoff 20%, AI Cured Dogs Cancer, Nvidia's New Chip",
            "pub_date": "2026-03-16T15:10:52.000Z",
            "duration": "00:13:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "chip",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/93f59fb5-c1bf-49f1-af72-3bb1236996cb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/c9b6n89Al3HdoyTouEMc2snH15ophOHHuRaAU3gS_co",
            "index": 49,
            "title": "NanoClaw Creator Lands Docker Deal After Six Weeks",
            "pub_date": "2026-03-13T21:42:42.000Z",
            "duration": "00:10:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/83358044-5673-48f0-8b73-c614c2015b12.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Db3x0JexgjcDw1eSCnwjBAPFHoXYsF_3zFJy9NThpdY",
            "index": 50,
            "title": "Gumloop Raises $50M from Benchmark to Scale AI Agents",
            "pub_date": "2026-03-12T21:39:41.000Z",
            "duration": "00:11:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/93490c0e-23bc-4dd1-921d-8d042ee5fc1d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/iZHfIrf7Bv8_f74B_gtl1T_SrsT_COcoXdkgPNGbBOQ",
            "index": 51,
            "title": "AI App Crisis, OpenAI Does Math, Big Nvidia Deal",
            "pub_date": "2026-03-11T18:54:30.000Z",
            "duration": "00:18:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/81c048ee-daf7-415d-9a84-d1cf9564a934.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Lr4aONhW4aiG4xdeVsKnn10hHghkzAR1ihQR8oZsIsM",
            "index": 52,
            "title": "Meta Acquires Moltbook: Facebook for AI Bots",
            "pub_date": "2026-03-10T16:21:12.000Z",
            "duration": "00:10:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/968e0c1a-7826-44b1-8893-38e7fa1219c4.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9A4YcZUWp133NiYrGa0aQS2kSs2QTstZdXTKSVXL7_k",
            "index": 53,
            "title": "Anthropic Launches \"Code Review\" to Fix AI Code Security Issues",
            "pub_date": "2026-03-09T21:57:45.000Z",
            "duration": "00:13:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b18f618f-cac4-4a04-87dc-699fdfbd8f14.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/kyg8dnqCrKcFoPP-KtXVqu8ppXm3heuhctmKjbglWTo",
            "index": 54,
            "title": "Meta Faces Lawsuit Over Ray-Ban Smart Glasses Privacy",
            "pub_date": "2026-03-06T17:58:03.000Z",
            "duration": "00:11:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b17beabf-748a-412e-bffc-742d18dd6f13.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/MJeg7QlIlt8tm0YXLUJGV0MvWArkfBaeGXEtcHRFcAI",
            "index": 55,
            "title": "OpenAI Launches ChatGPT 5.4",
            "pub_date": "2026-03-06T01:37:05.000Z",
            "duration": "00:12:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/096cf68f-fce0-4670-8d2b-9ae381d9aa9b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_UyyY-yhwKeuAOYIWUyhbX4lQ6ofVOwgiAfxboTfyps",
            "index": 56,
            "title": "What VC's Are Looking For in AI Startups Today",
            "pub_date": "2026-03-03T16:48:50.000Z",
            "duration": "00:11:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a8ae9270-2c1d-4d67-a2e9-290dd9ffdfeb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/7L-0qJfbwXe92S-DC72EDfsnOsYLdXKXxp9YZEu0BZw",
            "index": 57,
            "title": "OpenAI Steals $200M Contract in Anthropic vs. Pentagon Battle",
            "pub_date": "2026-03-02T16:43:07.000Z",
            "duration": "00:12:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a074a5d8-700a-4bc0-bac8-fe2fb2558b7d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/uBSER7MewRENypDm0oDQEKM5PdZ-VRJeb50Coo-VbW8",
            "index": 58,
            "title": "Perplexity Max Debuts Multi-AI Agent Tool",
            "pub_date": "2026-03-01T20:45:40.000Z",
            "duration": "00:10:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d0d6371a-c0a7-447c-a197-89a5880a139d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4eEUCoRHeTVybMWQTbybqUbMoJHm0HLJts-lBBwc2VE",
            "index": 59,
            "title": "Suno Hits $300M ARR: AI's Impact on the Music Industry",
            "pub_date": "2026-02-28T14:00:00.000Z",
            "duration": "00:13:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5885f034-fca8-4191-9fad-638a5ffa394b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/DAiNFcRl2V9Vu-OSB1VpvlkYPu6npHjbrg3Q8Af1e14",
            "index": 60,
            "title": "OpenAI Raises Record $110B, Hits 900M Weekly Users",
            "pub_date": "2026-02-27T20:52:46.000Z",
            "duration": "00:10:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7f31b656-115e-4ace-afab-1b20db4cc309.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/U8RedRm1Z1i9AKbazca0JZRRBQQZ9jpeuJGGexNi4Ew",
            "index": 61,
            "title": "Anthropic Acquires Vercept Amidst Pentagon Standoff",
            "pub_date": "2026-02-26T17:05:13.000Z",
            "duration": "00:14:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/88827782-843c-4643-8b2e-d74c2e69e0f2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/eJ9QgaXRDyQbDf9gnhndj1b_Q_82la-tHgTG529UVVM",
            "index": 62,
            "title": "Anthropic and OpenAI Battle for Enterprise AI",
            "pub_date": "2026-02-24T19:24:12.000Z",
            "duration": "00:14:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5d438253-0731-40df-bcdd-c87c02900243.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/0iJ_UJUY6tRb19bgietk3IwjjS0jQsKAdBf7gTW7uLM",
            "index": 63,
            "title": "AI Audio Updates: Spotify, Particle, ElevenLabs",
            "pub_date": "2026-02-23T18:17:07.000Z",
            "duration": "00:12:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/fe5a5879-7312-410d-8a8a-fed2b36a2bb0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/dJV-XJBs2egljQfAzj0Gh-EgPqzgWxFKF4MB_KLbm24",
            "index": 64,
            "title": "Japanese Toilet Maker Toto's HUGE AI Windfall",
            "pub_date": "2026-02-22T14:00:00.000Z",
            "duration": "00:09:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/79bf28b0-9254-4f71-81fb-2aa1c214e1a2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/FOf0kB9EyoV2dL_9-cB3wgyRc5S01d5agVBuyEiRnjc",
            "index": 65,
            "title": "Reddit Steps into AI-Powered Commerce",
            "pub_date": "2026-02-21T14:00:00.000Z",
            "duration": "00:10:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cd5ef1c9-feb4-41c7-b7c2-29d100ae5f54.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/HrNZlNPGsXKXc5H5QrQD0L_W1oykchtUw9JqtYWbCmU",
            "index": 66,
            "title": "OpenAI's $100 Billion Funding + Sam Altman Refuses to Hold Darios Hand...",
            "pub_date": "2026-02-20T22:18:12.000Z",
            "duration": "00:12:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/02ea9cb8-0994-41c1-8b82-467c3ee4ce4e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4SaDY5CEfC4wIlKmO55XwzL4rV22iiidFc5-DUu135Y",
            "index": 67,
            "title": "Google Launches Gemini 3.1 and YouTube AI",
            "pub_date": "2026-02-20T02:36:18.000Z",
            "duration": "00:12:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/149f6c41-95c3-4224-b1d9-7d92fdc15946.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/xyfXDMO5fGlR1QJ6RuB166UynYZGTpX7dvcEcy4QU9k",
            "index": 68,
            "title": "Google Gemini Integrates AI Music Generation",
            "pub_date": "2026-02-18T22:32:02.000Z",
            "duration": "00:15:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/068677a6-85ac-4dd7-a40a-c73352b4a899.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/UNXGzUIaMruWBTALKPUWVIZUFz4Yimdy6Bz8rWxhKtc",
            "index": 69,
            "title": "Apple Wins The AI Hardware Race",
            "pub_date": "2026-02-17T21:52:38.000Z",
            "duration": "00:14:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/07acc763-05c2-4779-9ff4-e0d0a36bc6ef.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ciEx5RCbu8dgIKZOjHzu8TRFU1nBYzBREiKkxWzY3dI",
            "index": 70,
            "title": "OpenClaw Could Be 1st 1-Person $1B Company, OpenAI Buys",
            "pub_date": "2026-02-17T02:11:12.000Z",
            "duration": "00:16:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0b165639-9fd6-4bad-9ece-8b906ec69a2b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/yMPQT87UUezi6DbBI_N5bJChGV-e_3aUha8L-XRv9uw",
            "index": 71,
            "title": "XAI's Radical Plan: Data Centers In Space",
            "pub_date": "2026-02-12T14:47:02.000Z",
            "duration": "00:18:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/19926a84-de41-4e3e-93fb-23d33f42576b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1Q2MeNxL6hOaQ_Mpy3TUnyaG3Y83SIi4gxDXLVNlmwU",
            "index": 72,
            "title": "Runway Raises $315M for AI World Models",
            "pub_date": "2026-02-11T18:08:38.000Z",
            "duration": "00:13:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/28da57b5-262c-4930-a3cb-45a7f04cecc3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jeHZT-Q1f5af84WJ2hhJ5pUwp6ex8vr3Rjq6DaJS0Pg",
            "index": 73,
            "title": "Anthropic to Raise $20B at $350B Valuation",
            "pub_date": "2026-02-10T13:46:11.000Z",
            "duration": "00:10:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a1d3808f-a15b-426e-92a9-6c961c869cb9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Hfl4A83exZxBxmaNN7Jlck1_QjktyJIAxO86fDigu5Y",
            "index": 74,
            "title": "Amazon's $200B CapEx Spend Dominates AI Race",
            "pub_date": "2026-02-08T14:00:00.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/aba5e2d6-33da-4e65-9108-271dbfac83c5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ZrhzWv5UaHJsxQoxUPyJLInbzJZMjHWRTqpcnIlGKUQ",
            "index": 75,
            "title": "Reddit's AI Answers & Meta's Vibes App",
            "pub_date": "2026-02-07T14:00:00.000Z",
            "duration": "00:11:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ae43c95e-ab1d-4ddd-b4e3-ded6ae5ef11b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/l3NA5V4Zh3s8pJ1XUwx9YWC_Vc_Zozv5UCf7bEyGDuA",
            "index": 76,
            "title": "SpaceX Asks FCC for 1M AI Data Centers in Space",
            "pub_date": "2026-02-06T20:23:52.000Z",
            "duration": "00:11:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/41cd54e8-396d-450b-8f28-0489deeccf66.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/gSvWVYIZiE9kTt0Mn-ifNAI_FNXdoEf7uitFilUlQN8",
            "index": 77,
            "title": "Anthropic's Opus 4.6 and OpenAI's Codex: New AI Models Compete",
            "pub_date": "2026-02-05T21:43:57.000Z",
            "duration": "00:10:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/abff5fae-685f-4c63-9795-251d0810366c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_FiNN8gViwI5XM0EipckBw-5_Yptaxyodho8-TMLRVU",
            "index": 78,
            "title": "Lotus Health AI Doctor Raising $35M",
            "pub_date": "2026-02-04T12:14:10.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4e46b81e-1a62-4985-92b7-374c395a595d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/q2ZZO0HXEEAQMzOOzBf4yWp4xBp1xrKEKA1vxw-h9cE",
            "index": 79,
            "title": "SpaceX Acquires XAI for $1.25 Trillion",
            "pub_date": "2026-02-03T17:50:45.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b2ad054c-eb30-46fb-b209-3e89ca260498.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/rPMIEoBNa7FfMI2Yt7UW_2u0FO9dFrWLyBfjzmf1gzw",
            "index": 80,
            "title": "The History of AI",
            "pub_date": "2026-02-02T18:30:04.000Z",
            "duration": "00:12:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d14e6278-667e-490b-9841-acd2e41ea308.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/iRH-dSwnofXvETxuwzvUZpfGtYzx841xoZXhOTb3Cnw",
            "index": 81,
            "title": "Anthropic's New Plugins and $3 Billion Lawsuit",
            "pub_date": "2026-01-30T22:18:10.000Z",
            "duration": "00:10:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4c8e3747-0528-4746-bba0-560a1d65588a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/xwDqEArxD6sSylh6iRIncYqFCFbjBU_ZEMe5bMOuYPo",
            "index": 82,
            "title": "Meta's AI Surge: Smart Glasses & Billions",
            "pub_date": "2026-01-29T21:52:54.000Z",
            "duration": "00:12:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2cd1be5a-5c04-4eda-9aa1-5b6af74fd772.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/EyUC3zkEHA9lC_v3bRp7RVHRbDiVJj2Q_gCnpn9EOQM",
            "index": 83,
            "title": "Waabi Raises $1B from Uber and VCs",
            "pub_date": "2026-01-28T19:03:38.000Z",
            "duration": "00:12:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/67624966-0fcf-462f-bd7e-a7ec04d10411.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Xs3QFttcR-bhaifV4mhFmuThY5sTW2P4ldI0OO04Yhk",
            "index": 84,
            "title": "Anthropic's Cloud App Integrations and Hiring Challenges",
            "pub_date": "2026-01-28T18:38:38.000Z",
            "duration": "00:11:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/55a580e7-89b1-423a-afb8-24455d4cde21.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/91dzcnyWR1N8oTeKEuZEFI17dqTsI3u_vj3XBZI8HSs",
            "index": 85,
            "title": "HumansAnd Raises $480M Seed Round to Build AI for Human Collaboration",
            "pub_date": "2026-01-26T23:24:30.000Z",
            "duration": "00:15:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/187f883d-0ff1-43c9-a932-2d9552616410.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ouycJgH9lVzFUFX4n70JMdFrFq9UQMJfKoF6kXZsxAs",
            "index": 86,
            "title": "NVIDIA Invests $2B in CoreWeave",
            "pub_date": "2026-01-26T22:11:25.000Z",
            "duration": "00:10:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/59343f41-c904-49ba-b3dc-6b96fab201dd.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/bZw60rj-nsGCdxivb8kiPUzLyOP1Z-I76keM7P1rgcU",
            "index": 87,
            "title": "Microsoft Reveals Maya 200 AI Inference Chip",
            "pub_date": "2026-01-26T20:52:57.000Z",
            "duration": "00:11:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "inference",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/557ebf3f-9642-4b16-bdc7-d48016f9a466.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lfvwMKV4kZVktvBIwPLQPvm9biM_q9TqNSixO5Wp-7U",
            "index": 88,
            "title": "OpenAI Leadership Reshuffle, AI Unicorns, and White-Collar Work",
            "pub_date": "2026-01-26T16:55:31.000Z",
            "duration": "00:10:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/fff8c439-2f6b-4e7e-ae67-c149c34ef590.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/tL3oXmMHlNIj2BOj60S_nd9yigOLdpDbr7ayOhqlFEo",
            "index": 89,
            "title": "New Frontiers: AI in Education",
            "pub_date": "2026-01-22T22:34:01.000Z",
            "duration": "00:10:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e10ab8c8-18b9-4016-b162-8d72f4433008.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jjNC5nSCQX_yXdSB38itO8hUhkaU3UsWdUElmR0PAkc",
            "index": 90,
            "title": "Anthropic CEO Criticizes NVIDIA Over AI Chip Sales to China",
            "pub_date": "2026-01-21T20:30:01.000Z",
            "duration": "00:09:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "nvidia",
              "chip",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8ccbfef0-c6fa-4267-a6b3-00f973e6eb4f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/y70aWNR2pYd-ks5flIzHb-XDpEKxyosYpTYdL_QCZW0",
            "index": 91,
            "title": "RunPod: Breaking All Priors",
            "pub_date": "2026-01-21T02:00:00.000Z",
            "duration": "00:08:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/21a83279-e0f1-45f8-af81-fab4f196079d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KMucSvO-5WG5p8d3hyY__2A5R4yNhm3ncdevZi6jWvI",
            "index": 92,
            "title": "No Priors: AI Power Future",
            "pub_date": "2026-01-21T00:00:00.000Z",
            "duration": "00:11:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2f29b675-e5d7-47dd-a300-83e67a0f44c6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/kVlfXqATQLnvzWQCt-V1BcCeVSixjN3NNXastOc-1qI",
            "index": 93,
            "title": "Meta's AI Without Priors",
            "pub_date": "2026-01-20T22:18:12.000Z",
            "duration": "00:13:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e4930685-b5c4-40db-a194-9ef2017f44ed.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/d0IDCodKaAZNW0ZtlG52WF7s8jipuwqG_K7FclV6I1c",
            "index": 94,
            "title": "Elon Musk Seeks $134B from OpenAI and Microsoft",
            "pub_date": "2026-01-19T15:12:04.000Z",
            "duration": "00:12:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3720cd6b-b373-4f24-8469-092514ebe784.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/XwncXaciwQWY3PMEhMUPYs_EZ4vc6oyY3b4u2j5U0TM",
            "index": 95,
            "title": "Higgsfield's AI Video Breakout",
            "pub_date": "2026-01-15T20:58:34.000Z",
            "duration": "00:10:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1a28a639-470a-4733-8e42-0eab9b259670.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_oi6UEADumYlLJIAO9CP4HdrtzKRUSKIu3gVLREpxkc",
            "index": 96,
            "title": "No Priors: Brain Interface",
            "pub_date": "2026-01-15T18:37:03.000Z",
            "duration": "00:11:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a406ea0d-6943-4535-b081-cac3f4c1bd2c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/q7xRftleR1Vc1wjf9Dr4UkMNxjHJCIBcmL3pR7bRIGY",
            "index": 97,
            "title": "AI: Math Without Priors",
            "pub_date": "2026-01-15T16:26:59.000Z",
            "duration": "00:13:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e29dddaf-1623-4d66-a1c3-d7d06f7f6db8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Va5WETw-M41AxISovBdvHcOerXehTODqXWNOBxTVXrE",
            "index": 98,
            "title": "ChatGPT Medical Scale: 230M Weekly Consultations",
            "pub_date": "2026-01-09T01:30:00.000Z",
            "duration": "00:10:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ec62def9-e814-4e7a-9afb-d5042c632cc9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jMEZFpXq5wlcwRZZ9PJLJ6m89_T9RUohFxWP6_dMS3c",
            "index": 99,
            "title": "AI Cube Silence Master: CES Ice Appliance Oddity",
            "pub_date": "2026-01-08T00:00:00.000Z",
            "duration": "00:10:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ff297a47-4e80-4bea-9512-f6c9f81b7854.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/8E1oRqd_tBeUpL3V7uVGygaiolceCyJXQp3CXIkr8pU",
            "index": 100,
            "title": "LeCun Buries Meta's LLM Strategy: Dead End",
            "pub_date": "2026-01-07T01:00:00.000Z",
            "duration": "00:08:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cc7ee33b-77aa-42f6-b550-3c8323cbe88f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/K6QHK41C20a9IEpFvuV4LhvOtkFoIm9OZ8dbSzHzHvM",
            "index": 101,
            "title": "$1B+ AI Startup Strategic Web: Nvidia's Bets",
            "pub_date": "2026-01-07T00:00:00.000Z",
            "duration": "00:13:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "inference",
              "robotics",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b8129be9-06e9-4787-b660-bef210ab2d94.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/YZzljuTTYaISX90fGt0JiNTq2uRszUKexXpnzRWGtBA",
            "index": 102,
            "title": "OpenAI's Screenless Audio Revolution Bet",
            "pub_date": "2026-01-06T23:30:00.000Z",
            "duration": "00:10:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9a83592b-27fa-47cb-88f8-5db9cf51b9c8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/i5nhP1bW9DP_9gJrwwrpkxHk1LhzPt3i5htf23sSkBo",
            "index": 103,
            "title": "Nvidia's $20B Groq Gamble Pays Inference Dividends",
            "pub_date": "2026-01-06T01:30:00.000Z",
            "duration": "00:08:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia",
              "inference"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5dbb0bcf-c2f9-4fd3-b479-8f8b7b50a65d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ZIS2lit31UcPlfDXG2kbg-l2O9AeU6tqXN2tUhrbnOw",
            "index": 104,
            "title": "Peripheral Labs Nets $3.6M: Volumetric Sports Play",
            "pub_date": "2026-01-05T01:30:00.000Z",
            "duration": "00:07:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/94fe8c12-c4b6-4241-a6ce-0511be6d7466.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/iJVGOtOqbddkBet4iEr73KCwfI2D1HhKnkVfVYdbXik",
            "index": 105,
            "title": "Warning Wave Crashes: Claude's Chrome Agent",
            "pub_date": "2026-01-04T01:00:00.000Z",
            "duration": "00:12:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/02d721e8-2cf5-4ef3-98d8-106638963cf4.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5_Dsln3Ne0qIJHmCkHsiaX5MS8cayG4krFuyA1_VzoI",
            "index": 106,
            "title": "OpenAI: Agents Chained to Prompt Injection Hell",
            "pub_date": "2026-01-03T01:00:00.000Z",
            "duration": "00:14:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f041517f-125a-44f9-a795-50d17dfd23a4.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ImZKUbZXgjOyTrih_e1oOfSOGPRLl9SGv4A01NX4qHg",
            "index": 107,
            "title": "OpenAI's Eye-Watering $555K+ for Safety Lead",
            "pub_date": "2026-01-02T02:00:00.000Z",
            "duration": "00:10:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "alignment",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9d679fc3-2bc2-4657-88ce-4fbaf4720bcf.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Us6arSO0AyuZ6hcA76CiNR2PPxnXpyO1sDyugEGkqpE",
            "index": 108,
            "title": "$2 Billion Meta Prize: Secures Manus China",
            "pub_date": "2026-01-01T02:00:00.000Z",
            "duration": "00:10:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/96db53c6-bd9e-4b7f-bba2-eb0138052e84.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/TUqH_SqJgRE12oFama4Mt1QZxjUpIr4uMNbVLLev9I8",
            "index": 109,
            "title": "2026 AI Velocity: VC Accelerants",
            "pub_date": "2025-12-31T01:00:00.000Z",
            "duration": "00:08:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ae8d0d4d-8f61-49cf-9bdf-b5b13868eba4.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/uWDHe2GBVPPZ3n8Ddt4EuwceAYVRw7DATUsyu7W3ZaA",
            "index": 110,
            "title": "Fal Bags $140M Unveiling 10X Image Velocity",
            "pub_date": "2025-12-30T00:00:00.000Z",
            "duration": "00:09:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9ada87c6-5968-4e97-bacd-c90fcf4dc31b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/82Se1p5R0qgfOvVLzmXZ0UqsgBzSY6c6GymelKlx9T0",
            "index": 111,
            "title": "Zelensky to Meet Trump for Peace",
            "pub_date": "2025-12-28T18:30:00.000Z",
            "duration": "00:05:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6347dd44-21a3-45f5-8eb1-b49ac53d6d97.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_vdCP5uG435rilPgTAlNzjzndCXiMh3QYJFiDQaTlAE",
            "index": 112,
            "title": "Former Florida Officer Accused of Drowning Child",
            "pub_date": "2025-12-28T18:30:00.000Z",
            "duration": "00:05:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d919b05a-1855-485f-b1e8-ad7f6b88c222.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/C4nfoioOb5BLtjFII1ruSinygswk4Z9YdTEgohVjXy4",
            "index": 113,
            "title": "Inflation Crisis Hands Trump an Edge",
            "pub_date": "2025-12-28T18:30:00.000Z",
            "duration": "00:05:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/47ca4739-8015-483a-80d2-adb1a12ea3f8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/nba8Q1Xa_c7WS1zru0cBchvKgi0kK9vSzajbSo5Nmw8",
            "index": 114,
            "title": "Trump Secures Pacific Deportation Deal",
            "pub_date": "2025-12-28T18:30:00.000Z",
            "duration": "00:05:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b21621f6-a3aa-4869-bee4-3411196727cb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/b9nUBEfuDL1yGEPPtknDJ-5k4awo6VA8ZZ2_D_czCgE",
            "index": 115,
            "title": "U.S. Escalates Venezuela Oil Tanker Blockade",
            "pub_date": "2025-12-25T18:30:00.000Z",
            "duration": "00:04:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/585b697e-b4a4-406c-b1b1-9b5ba3a7f097.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1AKVVlylEdiK8fminr4_u1hUMpYODvULNVUvXv4eFoU",
            "index": 116,
            "title": "Zelensky and Trump Set Ukraine Peace Talks",
            "pub_date": "2025-12-25T18:30:00.000Z",
            "duration": "00:05:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c6fbd0d0-add2-41b1-9ec3-adfec73d310e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/EmGALDRX8ek635HQW7lwOysYB1evX7agzdnxaqzXi_A",
            "index": 117,
            "title": "Pro-Police Group Seeks DOJ Probe in Virginia",
            "pub_date": "2025-12-25T18:30:00.000Z",
            "duration": "00:05:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/99797a31-d141-4d67-8c6d-ce094f3438cb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9Y1yOP0kZrO4W036WLHhVarRbp9O-QE3TNkMPUqHZY0",
            "index": 118,
            "title": "US Airstrikes ISIS Targets in Nigeria",
            "pub_date": "2025-12-25T18:30:00.000Z",
            "duration": "00:03:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d3def330-d30d-4168-abcf-1e3ba6ba5687.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/YL6KlhbVcoUMU-X1CYF-BzkYEmT06rNlkE_RCQDO-Q8",
            "index": 119,
            "title": "Take “White Christmas” Tradition Seriously",
            "pub_date": "2025-12-24T18:30:00.000Z",
            "duration": "00:05:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/40024fc8-fc88-4034-af99-9b384b566c5a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lMJtBiNIsZNXcux7fsLdPaqR_nfNmILlTqNQg30GCtc",
            "index": 120,
            "title": "US Troops Celebrate Christmas While Deployed",
            "pub_date": "2025-12-24T18:30:00.000Z",
            "duration": "00:04:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/691207db-053a-4f28-a7b0-6ba5e90af621.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9HAynB3XJK9rWsclpwZkrOlTt2vlK3DnmLF72HLlFow",
            "index": 121,
            "title": "Trump Christmas Message Slams “Radical Left”",
            "pub_date": "2025-12-24T18:30:00.000Z",
            "duration": "00:05:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8b317b06-b314-4cfb-af94-2146aa406b1d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/K02zsSDoY7_MKyReI6wmSiBCbbcuJZ60uSIzygbMFuU",
            "index": 122,
            "title": "Gas Explosion Kills Two at Nursing Home",
            "pub_date": "2025-12-23T18:30:00.000Z",
            "duration": "00:05:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/34f754dd-6659-4490-ab98-eb4962d9bc9c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_jasSM2I1VT0gmT7BxX__Jxnr0oVF4VWHDsOwdF5STE",
            "index": 123,
            "title": "Federal Judge Strikes Down California Gender Secrecy",
            "pub_date": "2025-12-23T18:30:00.000Z",
            "duration": "00:05:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4ef880d1-14b3-4284-97fe-c166835ca961.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/6HEmuIqNgQDx2Lmvnh3UwM4WADrMlcHslkxdt9QBHCk",
            "index": 124,
            "title": "HOA Lawyer Wins Christmas Court Battle",
            "pub_date": "2025-12-23T18:30:00.000Z",
            "duration": "00:04:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/adbcafa3-82f9-497e-98ae-92f7ac1d4219.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/xN3cofkgJVS3B3l-Fsn_x5j7PoSVkuFQzeQUPnTUSSo",
            "index": 125,
            "title": "Illegal Immigrant “Naughty List” Sparks Border Debate",
            "pub_date": "2025-12-23T18:30:00.000Z",
            "duration": "00:05:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d64e2828-9cf8-4b4a-ba82-ddcc6a42abcb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Hpm83ZCCkUd4evbljVyXPk72FK6p4xqh8skYoYHf--k",
            "index": 126,
            "title": "DOJ Sues DC Over Unconstitutional Gun Laws",
            "pub_date": "2025-12-23T18:30:00.000Z",
            "duration": "00:05:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7385fd24-54e2-441f-8957-6cf87e948bb6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/psJN7iwmF1C4KAK5vxUH2xHcIAF4Z8U908TY5ohNXRs",
            "index": 127,
            "title": "Trump Unveils “Golden Fleet” Warships",
            "pub_date": "2025-12-23T18:30:00.000Z",
            "duration": "00:05:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cf69e42a-2e93-4720-a4f1-08bdb821838e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/EadP1t0hyOuO53wWuKhOICFA8_B2sbNuxvEuVBEn-wY",
            "index": 128,
            "title": "Hunter Biden Slams Afghanistan Withdrawal as “Failure”",
            "pub_date": "2025-12-23T18:30:00.000Z",
            "duration": "00:05:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f4f1db0d-775b-4333-8f46-a8dfa47a1169.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/UBS4KGwhDPta244wU5pStEVUL_vTJjVe_kbkDbqr0L8",
            "index": 129,
            "title": "Ben Sasse Reveals Stage Four Cancer Diagnosis",
            "pub_date": "2025-12-23T18:30:00.000Z",
            "duration": "00:04:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/dc9d3678-1af1-4a54-99b8-5f0d6b7cd86d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/3WdSohKV-t-U1L5RIbqj3tx3pkdW3HklQCpFwM4ps2A",
            "index": 130,
            "title": "Trump Triples Self-Deportation Payments",
            "pub_date": "2025-12-22T18:30:00.000Z",
            "duration": "00:05:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e06b0516-59fc-4105-9d01-9e5548586686.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/T3ui0-FVWgp9lb4gQIpBngSf3nSXd0IKT9hSTQqhFG4",
            "index": 131,
            "title": "Trump Pushes Greenland Deal, Denmark Pushes Back",
            "pub_date": "2025-12-22T18:30:00.000Z",
            "duration": "00:05:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4078f04f-ce3e-4ded-a840-8204a5fc01f2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/2cUO-eXatFkji34hig7mWY_UQn7jGYBqp91AEqoK1tA",
            "index": 132,
            "title": "Trump Halts Offshore Wind Construction",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/25edbd01-aadd-4841-85b0-edcc4a31bcb9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jHRdAKWgimtN47dY9vemhonOGGihgqFf56x4oNc1spM",
            "index": 133,
            "title": "Bernie Sanders Blocks Kids Cancer Research Bill",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3226e86b-3959-426e-aea4-6f976bedf527.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9ywCY0fiaUUDBihRwId1NRxVVwBjxdxcC1ABiIWm8XY",
            "index": 134,
            "title": "US Seizes Venezuelan Tanker After Blockade",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a8be729b-885e-4f43-b3c0-c6fc7f816bb8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/qamt4cl-uKbJ8BqReWYC6WiEYTg8pliLT9iop7I6QWw",
            "index": 135,
            "title": "Major Universities Divert Federal Science Grants to DEI Bureaucracy",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5abec5d0-c576-41a8-88cf-3c6d36c53dee.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/E31rshB59lycTTSAcjNCil_sE9wFi2MoC4PyyLkRNns",
            "index": 136,
            "title": "Congress Nears Stock Trading Ban Vote",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b74f8776-5d09-420c-b65a-a5b0880af036.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/s2OV9U3fJMmmLjMBDtJWNN4DVhfnYOG8P_rca1D_Evo",
            "index": 137,
            "title": "Tulsi Gabbard Warns of Islamist Ideology",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9cbaa093-3048-4220-992b-69f3bc3e5d55.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/YI1sHbyIBMUY8wHwQuuFbC6zErbBTk9iTvk4LojKBB4",
            "index": 138,
            "title": "Minnesota Fraud Scandal Nears $9B",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/86ab17ca-c938-44ee-af2e-d5564c516ed8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KdgiIIHNjL57dsr9EJvWlWt6oZLBLvKmgQKsTolj0IE",
            "index": 139,
            "title": "Allegations: O’Brien Discouraged 911 Call",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d0806c9b-59c5-4ecc-b13c-339ad19dc135.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ePxCdVckZ42GoMsHnXmRUONxdpIXz-nZ40HRYQws1EQ",
            "index": 140,
            "title": "White House Confirms Second Strike on Smugglers",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:03:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6365c094-ea84-45c7-8904-38007585ea0f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/IeuQ_chccJkl3_8rreNjb0LFLpJoTLLJi4Y1z6rfors",
            "index": 141,
            "title": "Gaza’s Power Vacuum Sparks Armed Gangs",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:04:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f3e68846-25be-47c2-91ec-19609e801753.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/N0LNaBJY74dE_5gfVmGLybn5YLEzvExGroa5mmJS7BE",
            "index": 142,
            "title": "Leaked University of Illinois Teacher Training Sparks Backlash",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e71e4c33-7003-4f90-9f01-15e60fa44d0c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/baRJr6Z8fl6acK5dC2mD4Wkh_bYA5K_z6D267OWZbqU",
            "index": 143,
            "title": "AmFest Attendees Back ICE Enforcement",
            "pub_date": "2025-12-21T18:30:00.000Z",
            "duration": "00:05:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4353f1e0-7354-404f-8ec7-a8976be559fa.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/uVqVZqPUvi6CKK_dygoQ9VfVf4DyW2K5DgjmjQXQq3o",
            "index": 144,
            "title": "Trump Won’t Rule Out War Venezuela",
            "pub_date": "2025-12-19T18:30:00.000Z",
            "duration": "00:05:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/946c467d-aef2-4f45-88f7-93978cacebb3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/nVYQS8BX23mzu-0YKFwmJFY5W-ZEAAdUERfty2hUTa4",
            "index": 145,
            "title": "Pentagon Reviews Covid Discharges, FCC Independence Questioned",
            "pub_date": "2025-12-19T18:30:00.000Z",
            "duration": "00:05:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5775d294-8936-4d47-a62f-ca9a0de7a111.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/kRPpmk8G1uAI64NhpgTsh--aOMsAECqk5fsoe0MY8GM",
            "index": 146,
            "title": "Chinese Researcher Charged With E. Coli Smuggling",
            "pub_date": "2025-12-19T18:30:00.000Z",
            "duration": "00:05:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f5f68dc2-51b4-4e1c-ba25-af116158a5f3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9Hz6rTA_U9T3yHoIx_Ed4PE8eC0rUnXEXB_dfF1c0E0",
            "index": 147,
            "title": "DHS Blasts County After Suspect Released",
            "pub_date": "2025-12-19T18:30:00.000Z",
            "duration": "00:05:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5e3f4fd2-6ca0-4a8c-b905-24a418cda0c1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/O425eCn_6GTtbMPhzer4o40G9h9ivRjHn_xF3Jddlm4",
            "index": 148,
            "title": "House Democrats Block GOP Funding Plan",
            "pub_date": "2025-12-18T18:30:00.000Z",
            "duration": "00:05:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/36266813-a747-4f75-a138-5781419441f1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/U4Kn7DmiNnYW-lF8fRhHRbPTO_CMTcIgoM7hOeLWu7c",
            "index": 149,
            "title": "Charlie Kirk Pushes “Impossible” Conservative Organizing",
            "pub_date": "2025-12-18T18:30:00.000Z",
            "duration": "00:05:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5a6ae287-ce9a-415f-ab49-96458214848d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/RoUxCb22MKtHPHviCjSmSpLvTtPVP8tNYBsWUdof7f0",
            "index": 150,
            "title": "Health Problems Surge After LA Wildfires, Study Finds",
            "pub_date": "2025-12-18T18:30:00.000Z",
            "duration": "00:05:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/41bd1d0c-f50e-4641-9706-8822bd9fa8ba.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/AVlJWjjWi4aPofX70tjmeFTYv_pTTYRNa7HciRC0c1U",
            "index": 151,
            "title": "Cardinal Dolan Resigns as New York Archbishop",
            "pub_date": "2025-12-18T18:30:00.000Z",
            "duration": "00:05:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/46ef24e8-0997-4c04-aa19-b3d64df01e8e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/eMjuf4GtVePWfDR3YAafsKy46g5cIt69XnLx3EzFzxI",
            "index": 152,
            "title": "Minnesota Autism Billing Fraud May Hit $2B",
            "pub_date": "2025-12-18T18:30:00.000Z",
            "duration": "00:05:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/793313e0-9c5d-4c70-86d1-84870a558931.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/R67o3rNdFHcTo47gnVuwf7QI-Rpyz5Ik-CP0whFgn6U",
            "index": 153,
            "title": "Putin Rejects Ukraine Peace Talks Again",
            "pub_date": "2025-12-17T18:30:00.000Z",
            "duration": "00:05:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c3b718a9-a972-4bf3-9671-3ffe5779f852.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_MxlijgDB7tJobD83IP9rARbG8P2js_3bJYh8-J7ePo",
            "index": 154,
            "title": "House GOP Pushes Vote on Obamacare Funding",
            "pub_date": "2025-12-17T18:30:00.000Z",
            "duration": "00:05:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5b942356-a636-4927-ae5e-36fb04d0049d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/WnmfFiafJ_exQK1UqPNgjCZzN7qIcJjCkwI0_4zPaYs",
            "index": 155,
            "title": "Trump Orders Sanctions Oil Tanker Blockade",
            "pub_date": "2025-12-17T18:30:00.000Z",
            "duration": "00:05:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/bc75a921-eee2-4c25-aa9d-b5f27cfa80c3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/IS-C7YgEjGKoyOhfsWIBIcSERvjMF6802i7lm16IjQ4",
            "index": 156,
            "title": "Nick Reiner Charged in Parents’ Deaths",
            "pub_date": "2025-12-17T18:30:00.000Z",
            "duration": "00:05:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6ab7e675-10b8-46d0-96a6-3d0f9625f533.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/pBeGCnt8reTbC_unNhVbByngCz6VlNLq2gKNJtt0nKw",
            "index": 157,
            "title": "NYC Stabbing Sparks Anti-Semitism Alarm",
            "pub_date": "2025-12-17T18:30:00.000Z",
            "duration": "00:05:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f4d9c1c0-bbcb-4138-9e4e-1f89b3385bc9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/YQ9wHfGJRAUAmqoVuCqtQSKyHCayWS9v_zyaSglJ_Eo",
            "index": 158,
            "title": "Bondi Beach Attack Tied to ISIS",
            "pub_date": "2025-12-16T18:30:00.000Z",
            "duration": "00:05:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/791ce3ab-1009-498a-92cb-1f81ec568305.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/AWQ7nF3U0FBNBtZTzalxzB1vFGKf5CU6hada3KhKK6s",
            "index": 159,
            "title": "AOC Faces Puerto Rico Luxury Trip Backlash",
            "pub_date": "2025-12-16T18:30:00.000Z",
            "duration": "00:05:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/75fd8452-e36e-448a-89e1-591c28754c4d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/IXmhnsX8RQzu1fr0Ca5i-6KNgBirktw0cEwVrC5fVBc",
            "index": 160,
            "title": "Trump’s 2025 Clemency Sparks Loyalty Debate",
            "pub_date": "2025-12-16T18:30:00.000Z",
            "duration": "00:04:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b97182f6-8adc-4d22-ad35-a17f42e2af46.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/wrNS0A_L3zJqwp1KfZJZZd5AiBYV_Dn59OIlSrTUuHk",
            "index": 161,
            "title": "Trump Sues BBC for $5B",
            "pub_date": "2025-12-16T18:30:00.000Z",
            "duration": "00:10:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c1ce155d-0d1d-496d-9700-68c1a3546e7e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KZPV8xJ4LuSIA4mq1aW4ilRwrZj-FzDzqKpkHKIr5yo",
            "index": 162,
            "title": "Ilhan Omar Says ICE Stopped Son",
            "pub_date": "2025-12-15T18:30:00.000Z",
            "duration": "00:04:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c8ea9f6f-baad-4514-81d0-f8d2dea9d5fe.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/UUlMGZG55OAmiYkW7shjBHitR_L2Kwkt2kZpLo0ZeGI",
            "index": 163,
            "title": "Media Politicizes Violence Before Facts Emerge",
            "pub_date": "2025-12-15T18:30:00.000Z",
            "duration": "00:04:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/48e9accd-c040-4ddd-9a90-162ba8dc4292.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Rn17Bbe4iUvybTL0JNkKB4eO4A6OV7KTSV0Layzrfto",
            "index": 164,
            "title": "Rob Reiner Found Dead, Privacy Debate Ignites",
            "pub_date": "2025-12-15T18:30:00.000Z",
            "duration": "00:04:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c448c8e2-7f8d-44d6-98f8-54e66598b198.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5ApIBWhr2lCLw8K7xwyQLvQsYrL7cWwDDDK-pExbt_A",
            "index": 165,
            "title": "Deadly Antisemitic Attack Shocks Australia",
            "pub_date": "2025-12-15T18:30:00.000Z",
            "duration": "00:04:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6a59eba0-7195-47a5-9d67-c5ef63585a50.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/or__NmSknSvMuGRcU7BAi0Zqtdo7IomFFLvXyhQqCdo",
            "index": 166,
            "title": "Erika Kirk and Candace Owens Talk Privately",
            "pub_date": "2025-12-15T18:30:00.000Z",
            "duration": "00:04:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/027d05c5-8e05-410a-8767-5dfe10b95164.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/M757e_dhTvJwdX5norDqPbPe7ssIOU7-Y7ckS4KyFh0",
            "index": 167,
            "title": "Thailand-Cambodia Border Clash Spurs Ceasefire Push",
            "pub_date": "2025-12-15T18:30:00.000Z",
            "duration": "00:04:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d550772a-60d7-4fa7-9b6d-f62382d1258b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/eOvJuJmVDgX-MCpMNETn_wSShk0a3c4QuIOcmdex2Oc",
            "index": 168,
            "title": "Active Shooter Response at Brown University",
            "pub_date": "2025-12-15T18:30:00.000Z",
            "duration": "00:04:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/28a3d787-53bd-42da-beb3-c77da54a29bc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KoMQKxfH0NgsM7oW_F_Et0hwI6jzx6qpcB8S1Xx_etw",
            "index": 169,
            "title": "Belarus Frees 123 Prisoners Amid Pressure",
            "pub_date": "2025-12-14T18:30:00.000Z",
            "duration": "00:04:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ff97ca84-12ed-4132-90c1-3bb850a09d76.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/h0drADaW425f5GwJcO3PE1VSbSnFtYcRBLtjsSrUSSM",
            "index": 170,
            "title": "Iowa Guard Killed in Syria Attack",
            "pub_date": "2025-12-14T18:30:00.000Z",
            "duration": "00:04:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4116ad0f-45fd-4c65-8d6c-60cdcdaa44ae.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/TlvsMwDK_OPxRH-G1hUPWK2b6MKVYmalHn_znCxDzEQ",
            "index": 171,
            "title": "Hanukkah Gathering Shooting Shocks Australia",
            "pub_date": "2025-12-14T18:30:00.000Z",
            "duration": "00:05:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/dcf0f91b-2b70-4c3c-b164-0cb6b24dcd8d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/62K23KQykyy8vwtZn8y89hcvOe2-D7mDaxhrs2Whfbk",
            "index": 172,
            "title": "Stanford-Linked Report Reignites Vaccine Myocarditis Debate",
            "pub_date": "2025-12-14T18:30:00.000Z",
            "duration": "00:05:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/bc421adf-ee7c-4644-b2b4-c8a91a745385.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/WcQ4aY0u0yo-nL9oDtLP_m53B3JrM9Eq4C2J-hUlFOU",
            "index": 173,
            "title": "North Korea Sends Troops to Aid Russia",
            "pub_date": "2025-12-14T18:30:00.000Z",
            "duration": "00:05:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2075d7b3-9d7a-4e1a-8601-7b46ad56227d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Cy6-pz1OkHY03IuE5GRJfUftRSTSCF4-LqC3JzUiz1Q",
            "index": 174,
            "title": "Belarus Frees 123 Prisoners for US Ties",
            "pub_date": "2025-12-14T18:30:00.000Z",
            "duration": "00:05:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8ef39be2-b3f0-456a-8aef-eb4afc7e697f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/DnsJsxnfrvzu7N-SbzdeBAIjU5rSTJeWEI5ZOr0xCRY",
            "index": 175,
            "title": "US Troops in Syria Face Fire",
            "pub_date": "2025-12-14T18:30:00.000Z",
            "duration": "00:05:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8a10f0d5-70a1-42ed-908d-e026eff6e017.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/r_zB5cq1b4_8-pcdGtleFdPsAeQshTAcuX7-bnGdeYE",
            "index": 176,
            "title": "America First Peace Plan for Ukraine",
            "pub_date": "2025-12-14T18:30:00.000Z",
            "duration": "00:05:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4a59f0ea-a77c-4483-8419-b638944f032d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jscQq-2iVfmz1DGtoIu6sCjqs7ZUcgyjT4X-ZJNnMBY",
            "index": 177,
            "title": "Trump Pushes Federal Control Over AI Rules",
            "pub_date": "2025-12-12T18:30:00.000Z",
            "duration": "00:05:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/457b8c48-9892-4caa-9933-270b3e55fa3b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/-K9psxaHFRi5Mvz8KJxqDFXrTsgfl6VJFi7aiosY5as",
            "index": 178,
            "title": "US Seizes Venezuelan Oil Tanker",
            "pub_date": "2025-12-12T18:30:00.000Z",
            "duration": "00:05:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2ce2b961-3d55-4b31-83b1-b9bd6ec464a0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5PMFrXOGm7cnMt5KD_P2ZGbx9U7NVGoZdIW6S64LGek",
            "index": 179,
            "title": "FDA Prepares Black Box Warning for COVID Vaccines",
            "pub_date": "2025-12-12T18:30:00.000Z",
            "duration": "00:05:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5f65c389-0cc8-4c95-bc80-8ab4047cd49a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lQJOro_0QqVqgDaagTNmnFmlONFTuw54rAXJkIv3jfE",
            "index": 180,
            "title": "Whistleblower Alleges Massive Welfare Fraud in Ohio",
            "pub_date": "2025-12-12T18:30:00.000Z",
            "duration": "00:05:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7d096658-6afb-470e-8a2d-291423962aed.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/B0GRDcME-A4EFP4wfhR2UThoWG37e9djJW8unifuwlc",
            "index": 181,
            "title": "Venezuelan Opposition Leader Credits Trump on Maduro Pressure",
            "pub_date": "2025-12-12T18:30:00.000Z",
            "duration": "00:04:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/50a731f8-07c4-4e0b-9d22-3aa066588bfb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/R73lsRwJ7h98bskvk3HNZ_2iYrD7vu2NL8iEimzWSlQ",
            "index": 182,
            "title": "Ilhan Omar Faces Minneapolis Welfare Fraud Backlash",
            "pub_date": "2025-12-12T18:30:00.000Z",
            "duration": "00:05:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6e6433b7-fe9b-48a9-8273-838f9fb1c5d3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/uucMNRpLrN37m6j_fo59iL9mWI0HM5B-GC5_5CCukHQ",
            "index": 183,
            "title": "US Seizes Venezuelan Tanker Amid Piracy Claims",
            "pub_date": "2025-12-11T18:30:00.000Z",
            "duration": "00:05:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8457aa10-ede8-43ef-9372-3dcf592fd1e3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/2SDmRTLwC4bhuRl4sni51O7oKh0rhoAIPW6xnz4zc4I",
            "index": 184,
            "title": "Alleged Charlie Kirk Assassin Appears in Court",
            "pub_date": "2025-12-11T18:30:00.000Z",
            "duration": "00:04:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/78295b7a-a436-458a-a749-c02db3c704dd.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/RnpIF9eUN4NoVccyfcyr4egAHo8YYBiPaJxsf7uYfls",
            "index": 185,
            "title": "Judge Orders ICE to Release Convicted Immigrant",
            "pub_date": "2025-12-11T18:30:00.000Z",
            "duration": "00:05:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/255b4820-2d8c-4c32-a245-46ce00d40530.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/oztunwl38sL19pcSV4lM2Zns_1wiRcg8UOpVlYs8SpI",
            "index": 186,
            "title": "Colorado Court Upholds Girls Sports Policy",
            "pub_date": "2025-12-11T18:30:00.000Z",
            "duration": "00:05:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/416c7fa6-6bb6-4adc-858e-26c2903e5b59.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Q23LOwK_Ixuq2F8jXuUZMSBMgU4tMWb4YbH4IrlXrfU",
            "index": 187,
            "title": "Historic Washington Flooding Exposes Infrastructure Failures",
            "pub_date": "2025-12-11T18:30:00.000Z",
            "duration": "00:05:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/765f619e-fd69-4313-9baf-2142067e927d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mXcLNpTIDdETmCMhxafMxd3PWE7b9Vm4Wu0FzpemVKk",
            "index": 188,
            "title": "US Fighter Jets Over Gulf of Venezuela",
            "pub_date": "2025-12-10T18:30:00.000Z",
            "duration": "00:04:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3efa2a32-91a4-4a0d-9575-651b595e6c6c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/MT8C9yZUB-fgdXRwpizV_3LpobU90Y2Fv-C_4YIXbTY",
            "index": 189,
            "title": "Tina Peters Reports Prison Attacks Amid Political Uproar",
            "pub_date": "2025-12-10T18:30:00.000Z",
            "duration": "00:02:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7a14714f-10fb-41eb-8628-f38c5eba6824.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/LunMUqmzKVeGl-ild8mwc-jPL9nXvdH6Itdd8Q2czu8",
            "index": 190,
            "title": "Minnesota Dean Accused of Shielding ICE Target",
            "pub_date": "2025-12-10T18:30:00.000Z",
            "duration": "00:04:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/99f4f509-2ac1-48cb-9abf-5ae86bd3b406.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/bPR6Wf5EvDzzBeqX4h4PnrCo4n6Q1ovrQ6cN-LzZFR0",
            "index": 191,
            "title": "Minnesota Fraud Scandal Sparks Federal Terror Probe",
            "pub_date": "2025-12-10T18:30:00.000Z",
            "duration": "00:04:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c3226329-24cb-44c4-a87a-dd3ae6a03414.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mQu9y2dwmJbSmNbMF1ngmGTO6LX7AjXa-2pqbWwEH1Q",
            "index": 192,
            "title": "KSU Shooting Fuels Campus Security Debate",
            "pub_date": "2025-12-10T18:30:00.000Z",
            "duration": "00:04:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2d09e7bc-1a22-42d6-a750-b99039323084.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/vRi606eXPK448536lKNUefgx1o79TzY6BVdFAlLsLfQ",
            "index": 193,
            "title": "Australia Bans Social Media for Under-16s",
            "pub_date": "2025-12-09T18:30:00.000Z",
            "duration": "00:05:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e92d477d-e6d8-4cf2-a86b-7e7a285f096c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/EvbEseCJxo-cwrXzIYvyNQuIRnJsOk-sUYkGUn1fIBA",
            "index": 194,
            "title": "Royal Caribbean Sued After Cruise Ship Death",
            "pub_date": "2025-12-09T18:30:00.000Z",
            "duration": "00:04:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f35505e9-f166-4d1a-afc4-980c4e3d61f7.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/sad8Pn8Z55C8A2UDqwIFSTXTZPyKF-moE7EOvJn5-fE",
            "index": 195,
            "title": "Florida Sues Medical Groups Over Trans Care",
            "pub_date": "2025-12-09T18:30:00.000Z",
            "duration": "00:04:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3d098076-cdd1-4084-9f75-92745cb71e15.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1gmpyvIRcEdKm-P270-8Jni9B9zwDaRWVE78oqKp-Bs",
            "index": 196,
            "title": "OU Removes Staff Over Christian Gender Essay",
            "pub_date": "2025-12-09T18:30:00.000Z",
            "duration": "00:05:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5295c06f-ba8f-4c34-a61a-a42771fe6c96.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/YtK2BDu4BAQ2ben7HKT-npjbTh5t7uKJNNk7IHis-9c",
            "index": 197,
            "title": "Trump Faces Scrutiny on Deportation Flight and Strike",
            "pub_date": "2025-12-09T18:30:00.000Z",
            "duration": "00:04:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6d4f2423-cf55-482e-8b60-ffb56ce2719a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/fX4HUZ9UX7P8JC22XuIv_PHKjEmW2afVpMgkxpXJykk",
            "index": 198,
            "title": "Federal Judge Denies Release for Tina Peters",
            "pub_date": "2025-12-09T18:30:00.000Z",
            "duration": "00:04:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0825a650-551c-4f6c-8a79-7426b15c88ab.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/piAms8jNUlTXBw2u4gTszannD_cMKzCMSuZw75fUjzE",
            "index": 199,
            "title": "Is Political Violence in America Rising?",
            "pub_date": "2025-12-09T18:30:00.000Z",
            "duration": "00:13:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8efabd2f-90cf-4cfa-8b3b-8fd2150ad41f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/zd5EC2X3PK8mpQAZM0v5ea6eH43mgmWbSIj0qRySQMQ",
            "index": 200,
            "title": "Trump Launches Naval Offensive on Drug Cartels",
            "pub_date": "2025-12-08T18:30:00.000Z",
            "duration": "00:05:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9e5d528c-890c-413e-8a13-7dfae4433e86.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "cognitive-revolution",
        "title": "The Cognitive Revolution",
        "feed_title": "Cognitive Revolution AI",
        "priority": "P0",
        "selection_mode": "all_ai",
        "focus": [
          "agents",
          "evals",
          "AI safety",
          "frontier labs",
          "AI builders"
        ],
        "feed_url": "https://rss.art19.com/cognitive-revolution-ai",
        "source_url": "https://rss.art19.com/cognitive-revolution-ai",
        "detail_path": "/podcasts/cognitive-revolution/",
        "episode_count": 200,
        "selected_episode_count": 200,
        "latest_episode_title": "S&P 500 and AI Companies’ Future IPOs",
        "latest_pub_date": "2026-06-05T21:14:53.000Z",
        "latest_page_url": "",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "gid://art19-episode-locator/V0/znrvey8jh23Xo1VveDpiJWxkny9WfeVRHg2P7XqtNWI",
            "index": 1,
            "title": "S&P 500 and AI Companies’ Future IPOs",
            "pub_date": "2026-06-05T21:14:53.000Z",
            "duration": "00:12:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/80a58d85-9d74-43a1-be09-144fbf0c0cea.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5fAY3-z44Im2eEi_chakAseGHyj2XbZpg1XGjBX44oo",
            "index": 2,
            "title": "Alphabet Seeks $80 Billion for AI Advances",
            "pub_date": "2026-06-02T21:40:40.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "github copilot",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a651ef3f-1dee-4e23-b8b0-35d8371ca15e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/CwWxH9fHAVKqnoMIFpCayaRaa75ArTXGtnLigFUef8A",
            "index": 3,
            "title": "The Impact of Anthropic's IPO on AI",
            "pub_date": "2026-06-01T20:38:28.000Z",
            "duration": "00:13:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia",
              "chip",
              "reasoning",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/28872311-a57f-495b-bca3-bd6698666566.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/wlxSjDAAUwIq_v0HpgQqga37HgP6HXJC6XI8Lyv3poE",
            "index": 4,
            "title": "Exploring Anthropic's $965B Valuation Surge",
            "pub_date": "2026-05-29T20:49:56.000Z",
            "duration": "00:15:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "grok",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f0a493d0-b84a-4079-baeb-e515fc8b9cbd.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/VL2QrrjTjH89MVkrNVQd5Kg6es4rnansof-jjGICngE",
            "index": 5,
            "title": "AI's Role in Profit Maximization",
            "pub_date": "2026-05-28T01:41:20.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/81c96ab0-20bc-4e9c-b261-586b2d6cd42d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/nlROsIVKogTDmq_qlsl8Z0ghYKenh3I18FUTJrcUeL8",
            "index": 6,
            "title": "Uber's AI Spending, the Pope on AI, TikTok and Universal's AI Music Deal",
            "pub_date": "2026-05-26T21:17:33.000Z",
            "duration": "00:18:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/33b5591d-5dfb-4447-84d3-5deddc2648a6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/QQtyQm-uq9PVeKSgzrHv0LINIp_qfHFkX4ZcamMl5yI",
            "index": 7,
            "title": "The Cognitive Shift in AI Interaction",
            "pub_date": "2026-05-25T23:24:04.000Z",
            "duration": "00:13:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8ed29c37-de50-4b8d-b8af-0cfb168fe786.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/RgtJ9JV9Gl15d0SPl6bV0-Hvz3tEG4X_3FnUoXnOjuw",
            "index": 8,
            "title": "Is the AI Market Worth $26.5T?",
            "pub_date": "2026-05-22T22:23:58.000Z",
            "duration": "00:12:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6b656416-aa73-4130-aeba-67ce6f807b69.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/uZeeTdiwpxm1glGHrzu5uSnxoOjeMaP0EJjpHORZiHg",
            "index": 9,
            "title": "Turning Point: Trump’s Delay on AI Orders",
            "pub_date": "2026-05-22T00:09:05.000Z",
            "duration": "00:17:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f16c82ba-f89d-4a6d-bd23-4febe0114bed.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/rof7jy2ehphJwWU20q7lzbbbEndpf4iIjNl73wEWCCQ",
            "index": 10,
            "title": "OpenAI and SpaceX are Racing to IPO First",
            "pub_date": "2026-05-20T22:11:07.000Z",
            "duration": "00:18:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b17b4592-10f1-44b5-b345-c549f416d0df.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lTUVonHdfXimRZ4v9i-XWmtb8NIXCo-Tr2-EfE8b45I",
            "index": 11,
            "title": "Exploring the Glasses Collaboration",
            "pub_date": "2026-05-18T19:56:27.000Z",
            "duration": "00:15:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d22aa7aa-693f-47a8-91a0-fd2739d21040.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ykHStqF2w2vUBZ7ky9s8Dy4GuHsK1COttu5uijWb6Hw",
            "index": 12,
            "title": "ChatGPT's in Your Bank, Google Spams the GEO Industry, Brockman Takes OpenAI Product",
            "pub_date": "2026-05-15T23:57:27.000Z",
            "duration": "00:19:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/23d353a0-35c3-42b4-9a3e-329e46d4723b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/vfbfTV8_acXqX5d-mX_jucG98sLoXCgMIHn360UGu_w",
            "index": 13,
            "title": "Anthropic + Gates Give $200M to Healthcare | Cerebras IPO Doubles",
            "pub_date": "2026-05-14T20:46:20.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6df7da22-c722-4dab-a968-4ca5a5f86d29.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/RSRHnd2oyRZgmirhXd--aKvKWaIezUMoIaTE4h01cXc",
            "index": 14,
            "title": "Claude for Small Business ships | Altman Testifies He's 'truthful'",
            "pub_date": "2026-05-13T22:00:01.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "gemini",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1dbbfc9e-03c4-490e-abb2-09e8d1c384db.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/8g1ePrZ8OTDXFNomziu41JBCGEWyVQEn0zwCP-04NTs",
            "index": 15,
            "title": "Amazon Devs \"tokenmaxxing\", SpaceX & Google Collab, Anthropic Legal Fight",
            "pub_date": "2026-05-12T21:46:09.000Z",
            "duration": "00:17:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ab60bcd5-9974-4ca7-9417-caccf4bdb769.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/TCsPPHgxZr6kiLT4pplJQDl5COfGcGjfcQjqadKxB1U",
            "index": 16,
            "title": "Google Stops AI Exploit, Nadella Testifies, OpenAI's New $4B Unit",
            "pub_date": "2026-05-11T22:23:32.000Z",
            "duration": "00:16:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/eb09e740-a929-411b-8437-ce7a5925e1e1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Xwk6zQYtALgZaCmnywQwURQUyX5UYLw7hnfBK2tM6VA",
            "index": 17,
            "title": "Anthropic Aiming for $1 Trillion Valuation",
            "pub_date": "2026-05-08T19:43:19.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9c6dd2c1-f536-469d-b662-15ef3ec4dbf6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ZEm74Gioq2_BUk0he6sZMJiezfaj8SnUrD4MPO9gelU",
            "index": 18,
            "title": "Claude 'Dreaming': A Leap Forward by Anthropic",
            "pub_date": "2026-05-07T20:59:36.000Z",
            "duration": "00:15:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3d6f1e85-854a-4a79-baac-9e146e68ce02.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/tO7hBJXsRoafN1Q80z1t8BeW_s2MMm1xdIVoVIKNCkc",
            "index": 19,
            "title": "AI Innovations: GPT 5.5 Explained",
            "pub_date": "2026-05-06T20:57:43.000Z",
            "duration": "00:11:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "claude",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/295f6067-9b91-46ad-a4b8-4b27fa8909e1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/AEKpbvyHeSmqeAqBb92sWJ81VUsAjq8B_SFoEQVprss",
            "index": 20,
            "title": "The Importance of AI Unionization Explained",
            "pub_date": "2026-05-05T21:07:25.000Z",
            "duration": "00:21:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/eb375b4a-37df-4b44-a5e4-ffefc12b31bc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/CcLO0oHsoWAzJQeSTksu53hxhsV1O-2d1keFw5VDMjY",
            "index": 21,
            "title": "Unpacking the AI Giants' Billion-Dollar Deals",
            "pub_date": "2026-05-04T21:36:09.000Z",
            "duration": "00:19:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c94d7805-ab53-4f7d-b935-3722c876591e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/JIEhbHbIwdsrAPeFeRCh7xIH5T9f4uRs4NhGhmnUdpg",
            "index": 22,
            "title": "Unpacking Musk's Grok Training Revelation",
            "pub_date": "2026-05-01T20:44:10.000Z",
            "duration": "00:12:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "openai",
              "anthropic",
              "grok",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/77e61cc9-6483-47db-b47f-f593db2fe713.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/iIk_0Be4P8kiTINJKm0T9JFzOwuPwToBnSOladoIDEI",
            "index": 23,
            "title": "Anthropic's Bold $50 Billion Funding Vision",
            "pub_date": "2026-04-30T18:53:59.000Z",
            "duration": "00:23:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e09a4606-da32-4cf5-9281-7eddff6166cb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9GpW0W1aC1kqklCXcIJq4A53yVDgj5NqS-6qo3I8Gd0",
            "index": 24,
            "title": "Musk-Altman Trial Insights and Updates",
            "pub_date": "2026-04-29T23:32:31.000Z",
            "duration": "00:14:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b23ce6db-ee66-4f22-bccf-aa6343759229.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/3SJ_tO3mVwDMcKYoWuSkRNf4wcRPB9uWoROFuPsA0gs",
            "index": 25,
            "title": "Unpacking Altman's Disagreements with CFO",
            "pub_date": "2026-04-28T19:32:47.000Z",
            "duration": "00:21:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6064bd02-4397-42aa-8fe0-327b19870eeb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/o_Mn_g1u8i0b71RNzFi4yvHFENJvc5uGccm7w5roDHg",
            "index": 26,
            "title": "OpenAI Discontinues Microsoft Partnership",
            "pub_date": "2026-04-27T20:49:15.000Z",
            "duration": "00:16:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3effd4b0-e3f4-4f0c-be29-0f2e20e67914.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mRly8gWnmkpphYFFZur2csBKUMJcOhQhhPCKShS9kS0",
            "index": 27,
            "title": "ChatGPT 5.5: Impact and Implications",
            "pub_date": "2026-04-24T20:22:43.000Z",
            "duration": "00:16:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "chatgpt",
              "gpu"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/08aa5e3c-c261-4251-a5df-c12b136d17c1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Yoha0f0zgEAGesHOrRhx9CEkGlHnn7nb3XRJGIQdO_U",
            "index": 28,
            "title": "Revolutionizing AI: Google’s Multi-Layered Strategy",
            "pub_date": "2026-04-22T21:47:35.000Z",
            "duration": "00:16:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7df2ddfe-1d2c-4853-bbbc-c96bc0ea7deb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/A28eIXHsvUZ7wZFuo9Vbkai4RBRXRAzMvHQp3dTSV9c",
            "index": 29,
            "title": "New Apple CEO, OpenAI's New Image Model, Vercel AI Hack",
            "pub_date": "2026-04-21T21:38:13.000Z",
            "duration": "00:16:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/58c43159-2040-46c5-9402-b88173c34701.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/QIQd0Y53CBhJpKFOZGT5gqHcCsUZJpBOj8g0ZcGsVUE",
            "index": 30,
            "title": "Revenue Wars: Anthropic vs. OpenAI",
            "pub_date": "2026-04-20T20:55:39.000Z",
            "duration": "00:14:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2d860711-3dc5-4ce1-9a05-e1f45538bd86.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/chzy-a4fwAOVCdW9Y1VxeSk751NI4QIDz_wyGki6U6U",
            "index": 31,
            "title": "Revolutionizing AI: Claude’s New Features",
            "pub_date": "2026-04-17T20:22:00.000Z",
            "duration": "00:14:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e5ab0988-7708-40da-ad79-235b9956eee9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mWR-unmMZuIPhvgaUsznFJZ7RcURNsnNX5Vo7kYPfC8",
            "index": 32,
            "title": "Understanding Anthropic's New Opus 4.7 Model",
            "pub_date": "2026-04-16T22:08:51.000Z",
            "duration": "00:14:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/98cd5ca3-2a85-4250-bafc-78f18ea40007.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/u6e8WohzAR4RdsNESPa93FzH0964kETq0NLoy6tX7wI",
            "index": 33,
            "title": "Anthropic's IPO: Shaping the Future",
            "pub_date": "2026-04-15T11:19:33.000Z",
            "duration": "00:15:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/91a54afb-ff7e-4fa6-b352-7681b26f16d8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/pfciUGE6WEvxZeSbSUs2EBCfSFSL1waZ3JSl712U0mI",
            "index": 34,
            "title": "AI Clones: Shifting Cognitive Boundaries",
            "pub_date": "2026-04-13T21:43:45.000Z",
            "duration": "00:15:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b1173895-8ebd-4c7f-b147-4c319c2a5129.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/2TCW818YiCLy8diStzH7cT90zOj47yPzBSvHvcpAkBk",
            "index": 35,
            "title": "The Significance of Gemini 4 Launch",
            "pub_date": "2026-04-09T19:12:29.000Z",
            "duration": "00:15:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9a370a6e-a185-43d9-8115-7cae5f57ffcb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/WjL0Ssmy7ilZzNFH5Is25iOhbZ2gTlaeOEgPivH9LlM",
            "index": 36,
            "title": "Anthropic's Mythos Found Millions of Security Vulnerabilities",
            "pub_date": "2026-04-07T19:33:50.000Z",
            "duration": "00:11:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f70f1bac-001f-4c38-b15a-cfc40f1623ef.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/80400m-wauqw4LsnHgXpK19ya2S4miReAkNKoFDRoq0",
            "index": 37,
            "title": "Q1 2026 Venture Funding Hits $300B Record",
            "pub_date": "2026-04-06T19:06:39.000Z",
            "duration": "00:16:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/004f1847-e436-4164-b4a3-c5e2c6f3320b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/y68pu0ymdEIweXLH0H482dXmhE5rTTYGUKPjRnSf-Uc",
            "index": 38,
            "title": "OpenAI Acquires TBPN: (yes the tech news podcast)",
            "pub_date": "2026-04-03T21:01:28.000Z",
            "duration": "00:09:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8bb0d318-f00c-4f25-8177-69e480f42665.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/V5HDM6CN47xnVSzVYkQuKgjbSrmvruZf-uiEAn_iTjg",
            "index": 39,
            "title": "OpenAI's $121B Funding Round Explained",
            "pub_date": "2026-04-03T19:08:06.000Z",
            "duration": "00:13:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7db827df-a37d-4d19-9b8f-a83fd8761de2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/y3pOFMHqAkvwK-HnYDUlVY_mO25lbtlJjIyEHQDHp3k",
            "index": 40,
            "title": "OpenAI's $40 Billion Investment and AI Advances",
            "pub_date": "2026-04-03T16:33:09.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/aed1dec2-5f9d-40a6-ad28-ae080bc11816.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/CtFRtL1pPFPvRK-d2TosQTcv_133Y4f3SRTaIl1TGHE",
            "index": 41,
            "title": "SoftBank's $40B OpenAI Investment & Anthropic's Claude Mythos Leak",
            "pub_date": "2026-03-27T21:55:10.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/fca1e904-a3ab-4f46-aae8-4b01fa7905d8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/6-uEU4FTTgbG86wAxzk79TtGnraBTt1DRFHkl6B8upM",
            "index": 42,
            "title": "Claude Co-Work can now Control Your Computer",
            "pub_date": "2026-03-25T11:17:56.000Z",
            "duration": "00:12:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/97af2bad-23a6-4d43-b95a-2b9474c6a477.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/NKjIaZnSQ5i1tq_l32HMLDeeZLO-0HOetJ3L5oEgfQE",
            "index": 43,
            "title": "OpenAI Kills Sora Video Model",
            "pub_date": "2026-03-24T21:38:08.000Z",
            "duration": "00:10:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/bb500d0f-be01-439d-bd72-f6fcc5822e70.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1Hf_Vl_dr3RbX6jIuDHQV57GdTfaxMiDM5GHbmpuhyc",
            "index": 44,
            "title": "Bezos to Raise $100B for AI and Nvidia's Challenges",
            "pub_date": "2026-03-23T21:07:47.000Z",
            "duration": "00:10:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ca1b68e7-3183-4384-9ce0-86fff9102023.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/soY_JfjTSg1iYJhWKUIvoADPshFCCrRNAuxm05RjxvY",
            "index": 45,
            "title": "AI Web Traffic to Exceed Humans by 2027, and Rogue AI Agents",
            "pub_date": "2026-03-19T21:27:57.000Z",
            "duration": "00:14:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/311dec78-29d4-4f13-a2da-9f347076a9f8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/zy_EijhvGYkKy45RSpIoGsuKkTFevMGNHgqI4mHS7Gk",
            "index": 46,
            "title": "Meta Manus Desktop App, Anthropic Enterprise Lead, OpenAI AWS Deal",
            "pub_date": "2026-03-18T11:15:57.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "data center",
              "robotics",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/47c39f43-bc49-407a-962a-2ae5754063f0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/U9VWA8TYTmmYE-6sgi3FSU8dU8MswfWa_DJ7fhv29v4",
            "index": 47,
            "title": "Senators Say \"Shut AI Down\", Mistral Forage, Pentagon AI, Google AI",
            "pub_date": "2026-03-17T21:51:13.000Z",
            "duration": "00:14:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "google ai",
              "mistral",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b920e8a4-3911-4517-b61d-49478480521e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5fZZJQvrKL9g1e_OMondAeu5_g_8XDYq14BLLg4fOro",
            "index": 48,
            "title": "Meta to Layoff 20%, AI Cured Dogs Cancer, Nvidia's New Chip",
            "pub_date": "2026-03-16T15:03:54.000Z",
            "duration": "00:13:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "chip",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/91c67246-5c74-4e64-840a-735cc327d980.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/oF44OQXhhjOGcPCb6ugRbp0swWstH39Hq3Um-fY9j3c",
            "index": 49,
            "title": "NanoClaw Creator Lands Docker Deal After Six Weeks",
            "pub_date": "2026-03-13T21:39:41.000Z",
            "duration": "00:10:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/aaf07c22-8c33-406e-8d61-ad58e8ff6c80.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/JnU4WIsEcuoJySM4TP2d3CYedACmtPTm5zQTUpId5fc",
            "index": 50,
            "title": "Gumloop Raises $50M from Benchmark to Scale AI Agents",
            "pub_date": "2026-03-12T21:36:39.000Z",
            "duration": "00:11:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2a3e956b-55bc-4927-8ed7-78797c4819b5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/g1X6bTHw_PwQcQtOo4xhEmwMxH7JyL3dLTDpWdNSb5A",
            "index": 51,
            "title": "AI App Crisis, OpenAI Does Math, Big Nvidia Deal",
            "pub_date": "2026-03-11T18:50:39.000Z",
            "duration": "00:18:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e6d006b8-c5de-488f-abcc-62ec8daff387.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5Geeq9zQ7HPQpnWWYU9GmxabgtxoJsLH7T3EoYq6zCk",
            "index": 52,
            "title": "Meta Acquires Moltbook: Facebook for AI Bots",
            "pub_date": "2026-03-10T16:18:13.000Z",
            "duration": "00:10:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8436e96f-22ea-40a4-b683-e31951a4188b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mA4kwKwYNH3W6YKdr-WClTmVJXE3k-OaZAGCfPaPNU0",
            "index": 53,
            "title": "Anthropic Launches \"Code Review\" to Fix AI Code Security Issues",
            "pub_date": "2026-03-09T21:54:40.000Z",
            "duration": "00:13:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/09652167-6341-46c4-aaba-e02c74ffc4df.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9nfdUymS0mR98t77Ii4sWkdbACCiRYBTKh9Loa0Q3mQ",
            "index": 54,
            "title": "Meta Faces Lawsuit Over Ray-Ban Smart Glasses Privacy",
            "pub_date": "2026-03-06T17:55:01.000Z",
            "duration": "00:11:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/93b45dd9-00d2-4b9d-acdc-6c70a59c4cd0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/bHXj2WZ11v9F5DLC1A6Te0xwqaYyPbgUWwAKMqKr-o4",
            "index": 55,
            "title": "OpenAI Launches ChatGPT 5.4",
            "pub_date": "2026-03-06T01:34:13.000Z",
            "duration": "00:12:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/98f497d7-0b37-45c9-941c-461a8df04ed9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mJtqus5rze14m1CSF1MzXCMntL-rWNfTTNYcCAjMuz8",
            "index": 56,
            "title": "What VC's Are Looking For in AI Startups Today",
            "pub_date": "2026-03-03T16:44:37.000Z",
            "duration": "00:11:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/813b2457-3178-43dc-8991-92435ffe0c4e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/RznBK_DxHdii9HjO4q4Si_F3AXuSqOEW_Z24HvFGL_k",
            "index": 57,
            "title": "OpenAI Steals $200M Contract in Anthropic vs. Pentagon Battle",
            "pub_date": "2026-03-02T16:36:38.000Z",
            "duration": "00:12:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3387f42b-0503-4528-ac24-706a48dc7704.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/T6lSjSOojdbdbLe8iB6IzDp3S5KbqaJTBAmB727-uCc",
            "index": 58,
            "title": "Perplexity Max Debuts Multi-AI Agent Tool",
            "pub_date": "2026-03-01T20:42:45.000Z",
            "duration": "00:10:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/df62424a-c26f-4183-a836-c19aace91d4d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/-dKdsm_nexgxjNJZ32KHyvQgU9AWkzmgImmx_7PUWfM",
            "index": 59,
            "title": "Suno Hits $300M ARR: AI's Impact on the Music Industry",
            "pub_date": "2026-02-28T14:00:00.000Z",
            "duration": "00:13:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cd211bae-93e3-4183-ae17-e9a4e1de221b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/0HyFljDCeyNTAARRqRrcUT85J3oqWUNKp2Q936Yy3kM",
            "index": 60,
            "title": "OpenAI Raises Record $110B, Hits 900M Weekly Users",
            "pub_date": "2026-02-27T20:49:45.000Z",
            "duration": "00:10:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e385626e-9ad5-455e-9a28-db37282a7a68.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/yghp1NZof1X0O_tlCUY6_MrPv4xy8l3LZcsCz6BYUg0",
            "index": 61,
            "title": "Anthropic Acquires Vercept Amidst Pentagon Standoff",
            "pub_date": "2026-02-26T16:59:50.000Z",
            "duration": "00:14:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/361f57be-4d81-4780-9f7d-aaf8a1bbf057.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/xRbU5ihQZTjqZDL_VLF2b9L2EjQx5gLSBv94MGdcKGU",
            "index": 62,
            "title": "Anthropic and OpenAI Battle for Enterprise AI",
            "pub_date": "2026-02-24T19:21:01.000Z",
            "duration": "00:14:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c1488c95-bb12-4d68-9853-f4b9f6d0e273.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/OQCDpLaI9JaqmbeQnfAxx04vJ1Ob5xnj9TiEmI2ckdQ",
            "index": 63,
            "title": "AI Audio Updates: Spotify, Particle, ElevenLabs",
            "pub_date": "2026-02-23T18:17:36.000Z",
            "duration": "00:12:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/06e7331a-5868-4b73-840a-e810fa694100.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ZrTGMVpfWylwtOX7ElzYi2-AQ-9fDdZDa9zheIGlZz8",
            "index": 64,
            "title": "Japanese Toilet Maker Toto's HUGE AI Windfall",
            "pub_date": "2026-02-22T14:00:00.000Z",
            "duration": "00:09:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/49260288-fec4-4771-8a2f-2af528b2cf93.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/VXnPhGMZcM5NozxHH36cgkJNr3qZj8t-EmdLbu6sSnI",
            "index": 65,
            "title": "Reddit Steps into AI-Powered Commerce",
            "pub_date": "2026-02-21T14:00:00.000Z",
            "duration": "00:10:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9b10b8f4-1b20-4baf-8087-d48139057869.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/HetnZEjKwndHvOAZkY2wny1LswFLUQwPI_8huHJ6RD4",
            "index": 66,
            "title": "OpenAI's $100 Billion Funding + Sam Altman Refuses to Hold Darios Hand...",
            "pub_date": "2026-02-20T22:11:57.000Z",
            "duration": "00:12:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/203d7264-46ce-4797-80ea-dc8a5baf774b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5X1B4W88DMpgay5Z-V68joe1sc0a60cTkK2NtBYmqWU",
            "index": 67,
            "title": "Google Launches Gemini 3.1 and YouTube AI",
            "pub_date": "2026-02-20T02:33:00.000Z",
            "duration": "00:12:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c64b50d7-0680-4bf6-a689-8f3e604796b3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4SKzDQtYUefNLDqyG1hSJL3fOTDxCEaoIOKNnVfjVy0",
            "index": 68,
            "title": "Google Gemini Integrates AI Music Generation",
            "pub_date": "2026-02-18T22:28:05.000Z",
            "duration": "00:15:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/dea40f08-d75e-45e7-8eb3-c8655f95194a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/LncBjJzwZPuZhM5hCrvWpzQnSkK3jVJ7tSCNDAZAB-Q",
            "index": 69,
            "title": "Apple Wins The AI Hardware Race",
            "pub_date": "2026-02-17T21:49:08.000Z",
            "duration": "00:14:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cff6b8f6-1f30-43ed-91fc-9355a66f0d26.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/qQLh9KlpoafqgdgY119vu3PsOUUQL2-md5pymEnsiTY",
            "index": 70,
            "title": "OpenClaw Could Be 1st 1-Person $1B Company, OpenAI Buys",
            "pub_date": "2026-02-17T02:07:39.000Z",
            "duration": "00:16:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f0a26754-200d-48d3-9799-dcd935034e47.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9jLGt6QqgruQviMwNLLjk4lHWWrBOjjJ5NCYIodfm0c",
            "index": 71,
            "title": "XAI's Radical Plan: Data Centers In Space",
            "pub_date": "2026-02-12T14:43:00.000Z",
            "duration": "00:18:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/bcd16e71-0c34-41a9-8a88-6f20fec43809.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/hdN1OvAFH06Y5dsk-iMavntq9CmXZ455CNh7qtRbDRQ",
            "index": 72,
            "title": "Runway Raises $315M for AI World Models",
            "pub_date": "2026-02-11T18:05:06.000Z",
            "duration": "00:13:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/fe9ddc71-7968-49d7-be78-e13e8db9ab92.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/V0m31B7cJ8WxMntDSMDdOSUmSyWBL23s7bVQDKOfAAk",
            "index": 73,
            "title": "Anthropic to Raise $20B at $350B Valuation",
            "pub_date": "2026-02-10T13:48:08.000Z",
            "duration": "00:10:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/154a0b94-960a-4dee-a8e2-5b46a1585f89.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/7MkMPoY6nZs0ycHO6cJuc5a50CShDUBKzuvbqsSXvkM",
            "index": 74,
            "title": "Amazon's $200B CapEx Spend Dominates AI Race",
            "pub_date": "2026-02-08T14:00:00.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/40e5a5c7-4ade-43bc-a590-81752f415569.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ZbKjgF-iC64_lWxfkk0feu2g3KwNBSzLmP5TuEgjGCA",
            "index": 75,
            "title": "Reddit's AI Answers & Meta's Vibes App",
            "pub_date": "2026-02-07T14:00:00.000Z",
            "duration": "00:11:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/bf22de96-9045-4946-9d6b-fab95846033f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/fv9t76QEa7sH_I0nDFe2sWikeLAhteudQqZfZt9xcMI",
            "index": 76,
            "title": "Reddit's AI Answers & Meta's Vibes App",
            "pub_date": "2026-02-07T14:00:00.000Z",
            "duration": "00:11:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/718d552d-932a-4677-82c7-4bce396c1eb2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/QGG_1O5xQRxQ4cDzsUokjLRm3b-yTUxyvUH62zJlflI",
            "index": 77,
            "title": "SpaceX Asks FCC for 1M AI Data Centers in Space",
            "pub_date": "2026-02-06T20:16:48.000Z",
            "duration": "00:11:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/56a55dfa-78a0-474f-be14-177deda68cf5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/zC2g2AJ-YtXswzqBANgv4HMkAgdWlELlv0cn_EIbNx0",
            "index": 78,
            "title": "Anthropic's Opus 4.6 and OpenAI's Codex: New AI Models Compete",
            "pub_date": "2026-02-05T21:40:48.000Z",
            "duration": "00:10:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/23929966-f317-4232-86b7-d51f86a354d9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/oAxkAdn9yvaN0SQrtqgl1c6ACymKOXVVGhtMhvlDTBQ",
            "index": 79,
            "title": "Lotus Health AI Doctor Raising $35M",
            "pub_date": "2026-02-04T12:08:34.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/22f6c569-34b1-4819-9146-02508f403026.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/hECzXOUAtx_whq8vyUM1NzXR4Uj1aflluqkuKh6VX9o",
            "index": 80,
            "title": "SpaceX Acquires XAI for $1.25 Trillion",
            "pub_date": "2026-02-03T17:48:04.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6ddeacf3-18a8-46c1-b7c4-c6cf23240581.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/PBe3B0Q45hbnBxxXsop3bHaZAUumzV6QCorL8u4xvIk",
            "index": 81,
            "title": "SpaceX Acquires XAI for $1.25 Trillion",
            "pub_date": "2026-02-03T17:46:54.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/59df7242-e8de-4f6a-a31a-3cb98ed6d5ec.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Svvs8UUV7YOlfPKQFk34_2o8BF9RZrVGZna-LhdvtSY",
            "index": 82,
            "title": "The History of AI",
            "pub_date": "2026-02-02T18:27:57.000Z",
            "duration": "00:12:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f55649c0-0ba8-4202-bde3-d5414504186b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Q1Q7DLlnDGWdYAS4y_eqnidREMaxnmeZTkNJfT-wzi8",
            "index": 83,
            "title": "The History of AI",
            "pub_date": "2026-02-02T18:26:15.000Z",
            "duration": "00:12:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/65626157-c5cc-43f3-bd12-4511251fd28b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/xMREgIV5pIsSQRJnOpKJX8F0ygwyWe4n4VuB0nbhw_c",
            "index": 84,
            "title": "Anthropic's New Plugins and $3 Billion Lawsuit",
            "pub_date": "2026-01-30T22:14:59.000Z",
            "duration": "00:10:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5e3bbd18-d7a4-4560-905e-a15ff6eb02dc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/U8BtJWaKETYevcxm-pW8B65vjst4FU-yEYh0lM1OJK8",
            "index": 85,
            "title": "Meta's AI Surge: Smart Glasses & Billions",
            "pub_date": "2026-01-29T21:48:49.000Z",
            "duration": "00:12:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/32a1e0c2-ed0c-4083-8a6c-352565b48a13.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jzzg_uk8hRwEj7JRoAN5rJZrziQ1rRtnIdnIooo_2KM",
            "index": 86,
            "title": "Meta's AI Surge: Smart Glasses & Billions",
            "pub_date": "2026-01-29T21:48:41.000Z",
            "duration": "00:12:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1be74c60-6243-4313-8205-e5515ac7f1a5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Cw2JPfLRFSxoT7J-b0E-27iMpSwfF00V8sT6n0C3f3c",
            "index": 87,
            "title": "Waabi Raises $1B from Uber and VCs",
            "pub_date": "2026-01-28T12:06:14.000Z",
            "duration": "00:12:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ee3ea351-7bb1-4b18-8d55-8b95d769e850.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/BpDV89tiq6lztg3RrCV8cprKjX3_8xU-udpklCDPGrI",
            "index": 88,
            "title": "Anthropic's Cloud App Integrations and Hiring Challenges",
            "pub_date": "2026-01-28T12:01:22.000Z",
            "duration": "00:11:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/caa5458a-e2ad-4bb5-a3c9-a781d3856982.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/irrgeM8uTqu2xDzWs8S9R26l13CZ8NHG_mcoOvRvaco",
            "index": 89,
            "title": "HumansAnd Raises $480M Seed Round to Build AI for Human Collaboration",
            "pub_date": "2026-01-26T23:20:48.000Z",
            "duration": "00:15:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/84d998f2-9d89-4fef-93cd-7cb48e42e440.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/84iHvLXn2XgaWXcRKNf-HwQDAVwtx4FEzmCgJ7t9dLg",
            "index": 90,
            "title": "NVIDIA Invests $2B in CoreWeave",
            "pub_date": "2026-01-26T22:08:09.000Z",
            "duration": "00:10:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2c2875c9-78c0-4f80-b12e-373e4f9c7639.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/IuQhADVoyDRAGiEJWQndCcdlH84E7_hFHr3bfHD_m0c",
            "index": 91,
            "title": "Microsoft Reveals Maya 200 AI Inference Chip",
            "pub_date": "2026-01-26T20:55:27.000Z",
            "duration": "00:11:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "inference",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5b26ae7e-0bb1-475b-bb66-3c7fe6c72fde.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ptDlUQqrVtweUgP6hjwFQpJ5WHj5BHcGamOx8zuCB5g",
            "index": 92,
            "title": "OpenAI Leadership Reshuffle, AI Unicorns, and White-Collar Work",
            "pub_date": "2026-01-23T22:13:36.000Z",
            "duration": "00:10:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/62525c3a-0a52-46de-83d2-2f7db9f0b2a6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/BtoBX4h6RuFpR1CTa5_05ADSc7ZMZEW5koxAkxhsM-I",
            "index": 93,
            "title": "Cognition and AI in Education",
            "pub_date": "2026-01-22T22:29:47.000Z",
            "duration": "00:10:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2f56e915-e487-4a90-b7dc-2f81efbbaa96.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mS6XZbclfK269bSFsJGTyTTrcq06aZr7vFEKD4yYi-w",
            "index": 94,
            "title": "Anthropic CEO Criticizes NVIDIA Over AI Chip Sales to China",
            "pub_date": "2026-01-21T20:25:41.000Z",
            "duration": "00:09:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "nvidia",
              "chip",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c68c8a56-cbe4-4696-be10-ad2f542cd0ab.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/-TLo3_ercNoWPuXKg-8Vf2CedDcr8J4ww-WIXnydECc",
            "index": 95,
            "title": "Cognitive AI's Energy Footprint",
            "pub_date": "2026-01-21T00:00:00.000Z",
            "duration": "00:11:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2bc09610-aece-4ae5-81ff-42220cee364d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/kJpuoBL6Dz3dcEB8EZQnLpSXA98xgY2O0JFxz303Zuw",
            "index": 96,
            "title": "Meta's AI Mind Shift",
            "pub_date": "2026-01-20T22:23:08.000Z",
            "duration": "00:13:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/934b4d38-db19-44c7-890b-eb3ebfb17f44.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Djuxkf61kyOeRDJ_Ry7d4hkSIHjuRpdOujg7xceXspU",
            "index": 97,
            "title": "Elon Musk Seeks $134B from OpenAI and Microsoft",
            "pub_date": "2026-01-19T15:07:35.000Z",
            "duration": "00:12:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0d8f1d77-51d1-48bb-8350-34e03d3c810b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Sw-t_-NbDpClhPR0NS_Qrp5JNVhxclKjGWvSmyUR3-U",
            "index": 98,
            "title": "Higgsfield: Cognitive Video Leap",
            "pub_date": "2026-01-15T20:54:02.000Z",
            "duration": "00:10:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/240a922f-7500-4338-981a-79204863cace.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/dML0G7ZaAFICJ1aCBJzTObPWn1RRHPCO8QrDXXYmDuU",
            "index": 99,
            "title": "Cognition Meets AI Directly",
            "pub_date": "2026-01-15T18:32:33.000Z",
            "duration": "00:11:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e4957c3d-6910-40d8-a6e4-bfaccaae3cca.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/vTavpVQ1OOakS-2RYBCmbwxrJxXHCE-GF6iKudW0GQw",
            "index": 100,
            "title": "AI's Cognitive Math Shift",
            "pub_date": "2026-01-15T16:19:28.000Z",
            "duration": "00:13:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c4326ea4-a7a9-48d2-b258-8e29b317d994.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/CPyVe0PpB3uxgLe6ie_Sri55Z2jS3Ini3wD57I5XtPM",
            "index": 101,
            "title": "230 Million ChatGPT Health Chats Weekly",
            "pub_date": "2026-01-09T02:30:00.000Z",
            "duration": "00:10:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8e07bf2b-1a5f-40e1-bdf3-c728d4794ac6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/C2uYV9SCDWBrfkoRe9OxXbAFFyuVSdzYkCEaJd4CALg",
            "index": 102,
            "title": "Honor Spy Phone: CES Gimbal Follower",
            "pub_date": "2026-01-08T00:00:00.000Z",
            "duration": "00:10:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6d46fad4-fa26-4e7f-8c4e-f682824d63a9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5Bk5jl8PJ-DwXH7LWdjsXQX8Vmmq_XEPUVvfBImQgPE",
            "index": 103,
            "title": "Yann LeCun Verdict: Meta AI LLMs Fundamentally Broken",
            "pub_date": "2026-01-07T01:00:00.000Z",
            "duration": "00:08:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7a9b03fa-0705-4fc7-a4cf-d3c35a19553c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/XoQmL6EiriW-c6xUfv0rQu-j-wusd4gjSDcP46WG11I",
            "index": 104,
            "title": "Nvidia's $1B+ AI Startup Supremacy Network",
            "pub_date": "2026-01-07T00:00:00.000Z",
            "duration": "00:13:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "inference",
              "reasoning",
              "multimodal",
              "robotics",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/09feaa2d-c3f6-4c30-bb6f-8d9fdc3f91ac.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/XIxJ0GETDmajkk51-GseDKQTbI0NdoxjsbyqB9QyTyc",
            "index": 105,
            "title": "$20 Billion Voice Gambit: OpenAI Screens Vanish",
            "pub_date": "2026-01-06T23:00:00.000Z",
            "duration": "00:10:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0ec7078c-5685-4391-ac1d-decf86556b4a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KmC6mp0ASxvrt5UfZxXbI8hWLq_hoTY7HVP7Pza1oC8",
            "index": 106,
            "title": "Nvidia's $20B Groq Conquest: LPUs + Power Duo",
            "pub_date": "2026-01-06T00:30:00.000Z",
            "duration": "00:08:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2737e093-0b55-4128-9743-b388b9f2e6ae.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/nkwTf_Y1Dy7iU626FN20F4H9LQwpt14jy2DCXC-LMjo",
            "index": 107,
            "title": "$3.6M Funds Peripheral Labs' Sports Holographic",
            "pub_date": "2026-01-05T02:30:00.000Z",
            "duration": "00:07:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/06385827-a7d1-46db-af2f-247032c7c9d0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/sCFGH95g_G3tHPnGywhPcX315X7aK8KyZ7L4TgpMz40",
            "index": 108,
            "title": "Claude Launches Chrome Agent—Security Caveat",
            "pub_date": "2026-01-04T03:00:00.000Z",
            "duration": "00:12:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c6a744f0-89ec-4207-883c-c3f4d9f64327.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Z-wanF8Sb11BqCApD7yw75VQQod_In_062zd5PDGEIU",
            "index": 109,
            "title": "OpenAI: Agent Era's Prompt Injection Curse",
            "pub_date": "2026-01-03T03:00:00.000Z",
            "duration": "00:14:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/45a2aadc-1a4d-424c-88a4-8854cb4e5d00.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/BjD2TLKCQHJUQ6PVRgs0Tn0o1stbGjT1tqb8sO_w3gI",
            "index": 110,
            "title": "$555K+ Package Blitz: OpenAI Safety Talent War",
            "pub_date": "2026-01-02T03:00:00.000Z",
            "duration": "00:10:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "safety",
              "evals"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/946566f4-b60e-46b5-9415-ab1147f61ff4.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/2WBGx_B_rhKoco8Ybi74sTajphcbKXFYqMEBmJSreKM",
            "index": 111,
            "title": "Manus Joins Meta Empire: $2B from China",
            "pub_date": "2026-01-01T03:00:00.000Z",
            "duration": "00:10:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/069381e6-e26c-43da-83e4-448aaf5b1f6b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/N00CrPbtuNZ0W8Gx-6MeGF65PbFKgyq4e1HeePwoi5M",
            "index": 112,
            "title": "2026 AI Investment Guide: VC Wisdom",
            "pub_date": "2025-12-31T00:30:00.000Z",
            "duration": "00:08:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/208fabd3-366c-4b7f-afee-281f46406938.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/nYRw7P2c4LwfQRVE3RSbFzFttH7DONJKW49h4hfPvqg",
            "index": 113,
            "title": "Fal's $140M Win Spotlights 10X Image Mastery",
            "pub_date": "2025-12-30T01:30:00.000Z",
            "duration": "00:09:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f4fab156-e199-4516-a878-98304cfe9f1d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/-sJbSGs9T_Lft3YM3zkWSx8LqKC-5-sG1dYWRLLtfIA",
            "index": 114,
            "title": "$3B ChatGPT Glory Powers OpenAI $100B Ambition",
            "pub_date": "2025-12-26T01:00:00.000Z",
            "duration": "00:10:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a10428e1-f387-4c55-a5e6-bf24fcd07590.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lbMag4o_EC9xLOCfV81FC9_Ak244I5-ACzmTSJwEicw",
            "index": 115,
            "title": "Video AI Alert: Luma AI's $900M and Features",
            "pub_date": "2025-12-26T00:00:00.000Z",
            "duration": "00:10:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0dd5e4d8-b422-4bfc-aaab-1c170a7bc51e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/emmmpU4_Xk791dQkVTn-qn0WY0TmLY2cg1dzCbsI5aI",
            "index": 116,
            "title": "Spotify Enhances Meta Glasses Hearing",
            "pub_date": "2025-12-22T07:00:00.000Z",
            "duration": "00:08:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d1137f1f-c536-4704-98f4-f8facad7cb42.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/xtMYpQF8-V41fpKTeCqMM0RWyJOrWC4b3S1l2U2TCs8",
            "index": 117,
            "title": "OpenAI Evolves Visual Creation",
            "pub_date": "2025-12-22T06:00:00.000Z",
            "duration": "00:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9882e7bf-a57a-4309-9b98-1e3fee0e0164.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/o13Rfo3MpVfCXCN50SPnSOVG04SMErHtuaaKd7wsv74",
            "index": 118,
            "title": "Galactic Databricks $4B $134B",
            "pub_date": "2025-12-22T05:00:00.000Z",
            "duration": "00:07:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f560873b-9af3-428e-afdf-807ae99bc870.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/R_2XHCx9dZJ3S1z8XRjYVmHiElKO8_KvqYRRLuU0Fj8",
            "index": 119,
            "title": "Video by Prompt: Firefly's New Trick",
            "pub_date": "2025-12-22T04:30:00.000Z",
            "duration": "00:07:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/84de63ed-cfc4-4eb9-ad05-440029efefe6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jr2RlSxOXfyTuQVbMmGZ1mAZjcQws9KMGtnopDJS5kA",
            "index": 120,
            "title": "CC Gmail AI Tests Hit Prime Time",
            "pub_date": "2025-12-22T03:00:00.000Z",
            "duration": "00:09:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2e51031d-8fec-4183-860a-2d6fda0b4c03.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/OmiiWRF9v5yPlIMkZwqE0Oo9OPnhUpDj2gIsXqfjDRA",
            "index": 121,
            "title": "Lovable Valuation Moonshot: $330M Raise",
            "pub_date": "2025-12-22T02:00:00.000Z",
            "duration": "00:08:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/45966424-d27b-40f1-9d98-55672f233311.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4VXidYvFsUm_-Gl_-YJrTMSXVPU04ExnBiqrtUFu8sQ",
            "index": 122,
            "title": "$10 Billion Talks: Amazon OpenAI",
            "pub_date": "2025-12-22T01:00:00.000Z",
            "duration": "00:09:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "inference"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5cc5d97f-fd01-4a38-b7d0-881170aab6ee.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/cjp1_c_ud_UyQFsQE8bRrP8K710-N4FSMYWzA-12N4k",
            "index": 123,
            "title": "Yann LeCun’s Bet Challenges Today’s AI Leaders",
            "pub_date": "2025-12-22T00:00:00.000Z",
            "duration": "00:07:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a0ce2d01-7af9-461e-891e-c0610df38602.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lnjHEUpcu_kAZvO5dVIXb_ArxiAARywMlIWmDLHp_8o",
            "index": 124,
            "title": "$1B Valuation: Resolve AI's $4M ARR Secret",
            "pub_date": "2025-12-21T23:00:00.000Z",
            "duration": "00:06:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cb16ad8d-fe5a-4e4b-9906-47fb1f93638a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/u6H-V6QCXskY0OgcvT-Way4tnQXEGWiBWjNu5SEG5mk",
            "index": 125,
            "title": "OpenAI’s Image Generator Becomes More Creator-Friendly",
            "pub_date": "2025-12-17T01:00:00.000Z",
            "duration": "00:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e897bd35-aa4d-4e23-9bff-2a76cfb42312.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/XDNr0bOjqMlk5cRsPiqQnYp5zeH4S_msrH1mwzQi63o",
            "index": 126,
            "title": "Meta’s Hearing Boost Could Improve Safety Awareness",
            "pub_date": "2025-12-17T00:00:00.000Z",
            "duration": "00:08:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f9271e33-5511-4a9b-a852-3f20782fa7a5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/140Wj_xDc0UVo8OOS9gsjAVqhLg5Jr7sx26fTu-e60Y",
            "index": 127,
            "title": "Zesty Combines Discovery, Expression, and Commerce",
            "pub_date": "2025-12-16T23:00:00.000Z",
            "duration": "00:08:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/54bab49e-4854-4a86-991d-3cbe912531fc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ANQSTMP3rIdwn9TyqZfwOUr-jrxIog-i8BNSZqakxW4",
            "index": 128,
            "title": "Mirelo’s Funding Suggests Audio Is Finally Catching Up",
            "pub_date": "2025-12-16T01:00:00.000Z",
            "duration": "00:08:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/63c7c6e2-87fc-40ca-aef1-744c50e958c0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/O02XaiZB9h_5WcqTbBYcVJjAzcImZQ0u2AJ2YZ1zOvY",
            "index": 129,
            "title": "AI Hiring Could Redefine Public Sector Innovation",
            "pub_date": "2025-12-16T00:00:00.000Z",
            "duration": "00:07:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/740dbeb1-8807-4b2d-a297-f0184741bee5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ioUOd6KZahCGDT4Vw7aGPt73wqhC3iDq2vj02FXLFgc",
            "index": 130,
            "title": "The Risk of One-Size-Fits-All AI Rules",
            "pub_date": "2025-12-15T23:00:00.000Z",
            "duration": "00:11:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/69d475a2-038b-4009-9420-94ebde4f9ebe.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Pwd4XGrFgLlrSkCpYhXkHDByiWGdzYi3rt60gvNlLqI",
            "index": 131,
            "title": "OpenAI’s GPT-5.2 Arrives as Google Reassesses Everything",
            "pub_date": "2025-12-13T02:00:00.000Z",
            "duration": "00:10:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ff5ae59f-3101-4da5-9226-5b877c3e298d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/n3Uh6xjfaMl5xWdRBJ5s-2JFFDUZASxh3IHF6jUlgOQ",
            "index": 132,
            "title": "Disco Shows Google’s Long-Term Web Strategy",
            "pub_date": "2025-12-13T01:00:00.000Z",
            "duration": "00:09:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/77ce6755-db0d-46b1-b428-dc094f354f05.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Kjctic58YDjMArkLcjLlDWNE1iFjylm8GAIBZ0PLJiw",
            "index": 133,
            "title": "Autonomous Driving Meets Medical Reality",
            "pub_date": "2025-12-12T23:30:00.000Z",
            "duration": "00:07:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/df3e5b6c-0f5f-4816-a788-ae80cbd620ed.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/oP8DH4QUVP8UEc1G1wC6bLY8k1DnaAA8Y6_Ro0aCDp8",
            "index": 134,
            "title": "Episode 1,001: AI Lessons You Only Learn Over Time",
            "pub_date": "2025-12-12T00:00:00.000Z",
            "duration": "00:08:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/61c8e68c-a461-4a3b-9dfb-94c280dbd729.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Dv0lC2vEm95OIbDtaqD-kyvVglMpytonDxN76xNi2bw",
            "index": 135,
            "title": "Google Introduces AI-Driven Fact Summaries to News Sites",
            "pub_date": "2025-12-12T00:00:00.000Z",
            "duration": "00:09:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9233ea32-423b-498a-9077-40a37a4917a9.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Rfs99F0sidBPDjU68LnRoepxuC8yaJeylUCIGbwbjXo",
            "index": 136,
            "title": "Ring Rolls Out Biometric Recognition for Homeowners Seeking Better Security",
            "pub_date": "2025-12-10T00:30:00.000Z",
            "duration": "00:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/763141eb-06ad-4a7b-8526-c4a4c88d660d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/8nsRKHFr6vKC1GFpyWBRRVoE33DdU_OaoZJ6DrUYOm4",
            "index": 137,
            "title": "AI Agents Help Chrome Block Zero-Day Threats Faster",
            "pub_date": "2025-12-09T00:00:00.000Z",
            "duration": "00:14:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/573ab30a-879d-4644-a58c-d4a292e6441e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/yT8iUXnP-YMz7jjsm3dMwXCxQs3XovYD2alw_wMOicY",
            "index": 138,
            "title": "OpenAI Multi-Billion Investments Prompt Sector Discussions",
            "pub_date": "2025-12-07T01:00:00.000Z",
            "duration": "00:10:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f9f7fb52-e537-4951-aed7-6841ad711709.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/sy71LWdEMa-nhH6X6PAMuiUiER_XbKKPp90uPcviQ0s",
            "index": 139,
            "title": "AWS Silicon Becomes Core Revenue Engine in AI Era",
            "pub_date": "2025-12-06T01:30:00.000Z",
            "duration": "00:09:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b7d1b029-726b-4cc4-978f-4e9fedb6ffc5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/8RIrexNtoKnmr7FIlJvvn_TSOKPzeZgqT_ew8weUgVw",
            "index": 140,
            "title": "Black Forest Labs Attracts $300M From Global Backers",
            "pub_date": "2025-12-05T07:00:00.000Z",
            "duration": "00:08:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0d2151bf-1f17-49d7-ab21-1891b5bae421.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Rrxn2mP4MwS-pRCrd5KQVwnxUEgnWQ0CLaJiRt4qT1s",
            "index": 141,
            "title": "Anthropic & IBM Build $190M Platform for Future AI",
            "pub_date": "2025-12-05T06:00:00.000Z",
            "duration": "00:10:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "training",
              "safety",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/afeb24ef-cf16-4d8b-8963-e7aff53cf886.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/GERImttvAGU1QdO5qRVLiWqcHma7122wmptQZLzl1zs",
            "index": 142,
            "title": "xAI Invests in New Solar Hub to Improve Grok Efficiency at Colossus",
            "pub_date": "2025-12-05T05:00:00.000Z",
            "duration": "00:12:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "grok",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e447f6eb-0058-4095-9cda-80d4088d4db6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/m0LIG6y5yq_Te_2EZd28Qrfa7RKxgU-Ay1yvIw2LkWE",
            "index": 143,
            "title": "Google Unifies AI Search Architecture",
            "pub_date": "2025-12-05T02:00:00.000Z",
            "duration": "00:08:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e64f5de5-0c17-4948-8cef-a47b8dbdb267.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/UkUxQP529m36DM55oU89H6g45RxTs55IFS7cs0IAcgU",
            "index": 144,
            "title": "Meta’s Strategic Budget Shift Moves Toward AI",
            "pub_date": "2025-12-05T01:00:00.000Z",
            "duration": "00:10:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8b307542-c849-48f5-9ef8-5aed83b6d22c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_4bn_czwlId9NhtzrLQ_6rq5KIekpSeVNr8diIAIwSo",
            "index": 145,
            "title": "Mistral 3 Debuts Ten Models With Huge Efficiency Gains",
            "pub_date": "2025-12-05T00:00:00.000Z",
            "duration": "00:12:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "mistral"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4ea1faae-d572-48b8-8862-6c780298d6ba.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/QILfXk0uzYX01VUtj558nQhiQ_XSDQ6wqsPDaIUa7TE",
            "index": 146,
            "title": "Nvidia Says Its New Chips Leave Google’s TPUs a Generation Back",
            "pub_date": "2025-11-27T00:00:00.000Z",
            "duration": "00:07:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/170513e8-ea5b-41ca-ab76-e6bf88bd23a4.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/d2hUDc6jazyjojS0yb7QHr73mo0zq_A87Mr_5bRHTjo",
            "index": 147,
            "title": "Momentic’s Funding Round Supports Smarter Testing",
            "pub_date": "2025-11-26T08:00:00.000Z",
            "duration": "00:08:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/619d63f7-e001-45bc-bc36-ea9af90dbc29.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/2o55wAn10cQ1N6Z4ZyVgsEUrJcPLRDNn1-EnKI3V4yM",
            "index": 148,
            "title": "AWS Delivers $50B Initiative for Federal AI Scalability",
            "pub_date": "2025-11-26T07:00:00.000Z",
            "duration": "00:07:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0f4de7fc-1e07-4a85-bf88-27821aadb048.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/PWgQmhXS3lDxQLScHnHWrrS5Mtdi59y423GWIlCfys4",
            "index": 149,
            "title": "Anthropic Pushes Memory Innovation in Opus 4.5",
            "pub_date": "2025-11-26T06:00:00.000Z",
            "duration": "00:07:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/91ca3d2a-fcc6-4e09-97cf-782fa67efd20.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/lfdqZxL-op_wY66kYjGmX3AkJ97jPjLyf8SHtYha74E",
            "index": 150,
            "title": "Google’s 1,000X Compute Ambition in Detail",
            "pub_date": "2025-11-24T00:00:00.000Z",
            "duration": "00:12:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8e5c396a-d5f4-4a84-9bfe-cc232daea94a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ZMtOFz2-KgbTnl2TNC6gOgtOxX8skew-7uSyj3_LUh0",
            "index": 151,
            "title": "Is Federal AI Preemption the Future?",
            "pub_date": "2025-11-23T00:00:00.000Z",
            "duration": "00:10:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/55b02fdd-b94d-49db-b903-b76859578a0c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/vP-R6lq57P5ZReS0Cj8zo-vQFCafXkLBIEx4CIfmVSM",
            "index": 152,
            "title": "Gmail Now Powers Google’s Contextual AI",
            "pub_date": "2025-11-22T00:00:00.000Z",
            "duration": "00:09:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1572efef-8bd7-4fe7-aecb-2515809e09ac.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/X6VM_Km3ySlT3JcrgnvsubMMyt0QdqhNzleU79-GfDg",
            "index": 153,
            "title": "TikTok Debuts AI Content Blocker for Teens",
            "pub_date": "2025-11-21T07:00:00.000Z",
            "duration": "00:09:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ff1e9760-7785-4bd3-81cc-4f4bf35a4b27.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/bb0Glwzjbp9_aBrtRIS9_rR1H7PEKuriCHRb__j7ETA",
            "index": 154,
            "title": "NestAI Raises €100M, Extends Nokia Collaboration Into Defense AI",
            "pub_date": "2025-11-21T06:00:00.000Z",
            "duration": "00:08:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3680f70b-2d0f-4049-9a7f-c395e4aca893.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_vrG4lfdVHmzwNN8F8haQjiTWfsxdgFYJ2EDwcdtM5A",
            "index": 155,
            "title": "Function Health’s Growth Accelerates With $298M Backing",
            "pub_date": "2025-11-21T05:00:00.000Z",
            "duration": "00:08:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5a47abcc-a841-4d81-8842-f19ad2622619.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/uamxEBOFOtNLyvosay1czD4zSIkoDgp69yNjV01vr4o",
            "index": 156,
            "title": "Nvidia Surges to $57B Revenue Amid AI Chip Shortage",
            "pub_date": "2025-11-20T08:00:00.000Z",
            "duration": "00:09:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2af9ee17-95b5-4bb2-b736-4b3c10fa6133.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/dwHCbHQ-DuVdS15zeAcshkWxNVCjty77Cw613vo49ts",
            "index": 157,
            "title": "Suno Raises $200M as Warner Finally Settles",
            "pub_date": "2025-11-20T07:00:00.000Z",
            "duration": "00:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a23a9a6b-5249-49ba-b5cd-86d78082558f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/MeO5jLiyy1tLbYa4j00lnwnNNeoY3B0GUfVKATLffBA",
            "index": 158,
            "title": "Google Launches Gemini 3: Redefining Intelligent Systems",
            "pub_date": "2025-11-19T03:00:00.000Z",
            "duration": "00:09:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3ed7fd5a-aeaf-42fa-8ce7-222604d86280.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ZbbPdVXKs4FnpedoCa-Koambyj7JLYwY3biZkbTc0OE",
            "index": 159,
            "title": "Stack Overflow Becomes a Strategic Partner for AI Developers",
            "pub_date": "2025-11-19T02:30:00.000Z",
            "duration": "00:09:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a68da9ad-7177-4ad7-8fda-0cc75b405796.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KvhHpyiPxLHFgi-DzsruMN3yRqadQHWenqzdPiUaJ3A",
            "index": 160,
            "title": "Bezos’ $6.2B AI Expansion Stuns Silicon Valley",
            "pub_date": "2025-11-19T02:00:00.000Z",
            "duration": "00:10:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ca679265-3f4c-4223-b444-5d7674c1323c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/cur5pC9G209cVCYz784gLZ1QXQXayUx5jIddUkHk7xY",
            "index": 161,
            "title": "OpenAI Paying Unprecedented Cloud Bills to Microsoft, Leak Shows",
            "pub_date": "2025-11-18T02:30:00.000Z",
            "duration": "00:09:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/749d0f8b-7657-42a7-b489-efa898494432.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Ty3FirBauOrefOzgutrUD7OuHTHN5qo4LmY5caAWL20",
            "index": 162,
            "title": "Wonderful’s AI Agents Receive $100M for Expansion",
            "pub_date": "2025-11-16T00:00:00.000Z",
            "duration": "00:09:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/785e198f-3229-4b57-ba54-902bdede6cca.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/qhk8dQQM_WTV5LZdK2amjTvSSk158OnzZFubHvnZ9x4",
            "index": 163,
            "title": "Google Adds Store-Calling Feature to Reinvent Shopping",
            "pub_date": "2025-11-15T15:30:00.000Z",
            "duration": "00:12:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ac422580-ba59-40f7-a00f-e56ffba877a2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/41AYguCZvInqanQGL0AybNNz6-_lfC3z8BT0iifj5CI",
            "index": 164,
            "title": "Cursor Scores $2.3B as It Becomes Developer Favorite",
            "pub_date": "2025-11-15T15:30:00.000Z",
            "duration": "00:06:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/41302c4e-fae6-45c6-9404-3398a3d8edc5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/UdN5mWa6_UKU6fm_7m1o8-2OfJcGQ1OqFy_ZnDmzxQ0",
            "index": 165,
            "title": "ChatGPT 5.1 Debuts With Enhanced Team Chat Support",
            "pub_date": "2025-11-15T15:30:00.000Z",
            "duration": "00:07:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3a8d2b29-f29e-4668-86a0-3f790408a6e4.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "630073b5-8dd2-46b1-83b3-01231af9125d",
            "index": 166,
            "title": "Nvidia Becomes the Apple of AI",
            "pub_date": "2025-11-04T23:00:00.000Z",
            "duration": "00:12:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Nvidia-Becomes-the-Apple-of-AI-e3abket",
            "audio_url": "https://rss.art19.com/episodes/2fd9527f-2da0-421d-9292-b01d26ee2b56.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d9d347d7-d4fb-4905-baa8-2b2cf3fecefa",
            "index": 167,
            "title": "ChatGPT Can Now Access Your Company’s Internal Files",
            "pub_date": "2025-11-03T22:00:00.000Z",
            "duration": "00:13:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/ChatGPT-Can-Now-Access-Your-Companys-Internal-Files-e3abiln",
            "audio_url": "https://rss.art19.com/episodes/8764e80d-0135-444d-b60f-5a77078bcc84.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "884d3b8c-7d00-4e2e-ae9c-3f94ba45c02d",
            "index": 168,
            "title": "OpenAI Buys Sky to Give AI Real-World Power",
            "pub_date": "2025-11-02T22:00:00.000Z",
            "duration": "00:11:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/OpenAI-Buys-Sky-to-Give-AI-Real-World-Power-e3abiis",
            "audio_url": "https://rss.art19.com/episodes/1d30bed2-7631-4d79-b3a7-e1b2413d8707.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36dd988d-b2f9-401e-a213-2046a8dd6ccc",
            "index": 169,
            "title": "Exploring Atlas: OpenAI’s Next-Gen AI Browser",
            "pub_date": "2025-11-01T22:00:00.000Z",
            "duration": "00:18:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Exploring-Atlas-OpenAIs-Next-Gen-AI-Browser-e3aa6ui",
            "audio_url": "https://rss.art19.com/episodes/52f89c18-cb9a-4b0a-ae33-eb888e12253a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b65a2b01-789d-4da6-aa1f-9d8d0377879d",
            "index": 170,
            "title": "$134M Boost for General Intuition to Train AI in Spatial Awareness",
            "pub_date": "2025-10-31T22:00:00.000Z",
            "duration": "00:18:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/134M-Boost-for-General-Intuition-to-Train-AI-in-Spatial-Awareness-e3aa6o4",
            "audio_url": "https://rss.art19.com/episodes/dd87ae49-94d0-42e6-99af-cd41c12f38ae.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b58b91b-e4f7-4f0e-991f-e97587e706b9",
            "index": 171,
            "title": "Reflection AI’s $2B Move to Rival DeepSeek",
            "pub_date": "2025-10-21T00:00:00.000Z",
            "duration": "00:13:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Reflection-AIs-2B-Move-to-Rival-DeepSeek-e39nmis",
            "audio_url": "https://rss.art19.com/episodes/d726b1f3-0c5c-428c-aa10-b24f3e99e200.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5f1bf9c-9e12-4f04-8923-015e40b6a92c",
            "index": 172,
            "title": "How to Join Sora: OpenAI’s App Just Reached 1M Downloads",
            "pub_date": "2025-10-20T00:00:00.000Z",
            "duration": "00:12:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/How-to-Join-Sora-OpenAIs-App-Just-Reached-1M-Downloads-e39nm8u",
            "audio_url": "https://rss.art19.com/episodes/f866e617-dd20-42cb-9ce1-a7be8e5f0aef.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d3e3eff-50f5-4adb-a63a-b61c4e253616",
            "index": 173,
            "title": "Google Alumni Back Supermemory’s Next Move",
            "pub_date": "2025-10-09T00:00:00.000Z",
            "duration": "00:10:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Google-Alumni-Back-Supermemorys-Next-Move-e3972il",
            "audio_url": "https://rss.art19.com/episodes/bb314805-410e-4c24-84fb-16cda3e9f4b4.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3353eba7-70d7-4135-943a-8e3e8de88e2d",
            "index": 174,
            "title": "AMD Partners with OpenAI for AI Chip Revolution",
            "pub_date": "2025-10-08T00:00:00.000Z",
            "duration": "00:09:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "chip"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/AMD-Partners-with-OpenAI-for-AI-Chip-Revolution-e3971pi",
            "audio_url": "https://rss.art19.com/episodes/4b7a14a6-9abb-41b7-b84d-e349181404fd.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa56f17c-645f-4988-9d0b-1b76216ca5e2",
            "index": 175,
            "title": "AI News You Need: Grok Layoffs, OpenAI Lockdown",
            "pub_date": "2025-10-06T00:00:00.000Z",
            "duration": "00:05:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "grok"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/AI-News-You-Need-Grok-Layoffs--OpenAI-Lockdown-e392sn1",
            "audio_url": "https://rss.art19.com/episodes/b25bd399-1e96-4322-ac11-9855c15fd946.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8795f795-183f-46ef-8af3-24d976b8212d",
            "index": 176,
            "title": "Top 10 Stories from the AI Industry",
            "pub_date": "2025-10-05T00:00:00.000Z",
            "duration": "00:11:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Top-10-Stories-from-the-AI-Industry-e392sjd",
            "audio_url": "https://rss.art19.com/episodes/002e1515-67f6-4d86-9ce2-e145df9d054e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "998459c2-569a-487c-ad0a-a2bfbb9600d6",
            "index": 177,
            "title": "Sora 2 Expands Creative Freedom",
            "pub_date": "2025-10-03T00:00:00.000Z",
            "duration": "00:12:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Sora-2-Expands-Creative-Freedom-e38v084",
            "audio_url": "https://rss.art19.com/episodes/6311e08f-a522-46c4-b3c2-c53a38f4276f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "434b69f4-b88a-4419-83dd-435d3cdee592",
            "index": 178,
            "title": "OpenAI Infrastructure Update",
            "pub_date": "2025-10-02T00:00:00.000Z",
            "duration": "00:10:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "data center"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/OpenAI-Infrastructure-Update-e38v01f",
            "audio_url": "https://rss.art19.com/episodes/e0cab471-0569-4304-a824-9409b3c952e5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5035b27-415e-4585-ac2e-f381142e67e8",
            "index": 179,
            "title": "Cohere Teams Up with AMD",
            "pub_date": "2025-09-27T00:00:00.000Z",
            "duration": "00:09:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Cohere-Teams-Up-with-AMD-e38o81j",
            "audio_url": "https://rss.art19.com/episodes/cb01d0d0-7dd6-4b7a-91fa-c8ac4bbbed3e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c254e18d-db06-4293-a8f1-4fce558d58f3",
            "index": 180,
            "title": "The AI Backstory You Missed",
            "pub_date": "2025-09-26T00:00:00.000Z",
            "duration": "00:10:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/The-AI-Backstory-You-Missed-e38mp5n",
            "audio_url": "https://rss.art19.com/episodes/a8503618-bcf8-4218-ac9d-701698cad502.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "217cebf7-e1e3-4907-8f78-f82587335c69",
            "index": 181,
            "title": "AI Box App Builder for Non-Techies",
            "pub_date": "2025-09-23T00:00:00.000Z",
            "duration": "00:14:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/AI-Box-App-Builder-for-Non-Techies-e389tvc",
            "audio_url": "https://rss.art19.com/episodes/a967a609-2137-4837-92dd-1cbc179d4787.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b4d9eca7-b94b-4d3e-8988-d0f3dc191078",
            "index": 182,
            "title": "Anthropic Raises $13B: What Investors See",
            "pub_date": "2025-09-22T00:00:00.000Z",
            "duration": "00:10:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Anthropic-Raises-13B-What-Investors-See-e385tje",
            "audio_url": "https://rss.art19.com/episodes/00416a81-8ecc-4844-8507-aa2e86664c94.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e4fae55-fe67-4955-9e5b-59a9c5b20d45",
            "index": 183,
            "title": "ChatGPT’s Safety Updates for Creators",
            "pub_date": "2025-09-21T00:00:00.000Z",
            "duration": "00:12:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/ChatGPTs-Safety-Updates-for-Creators-e385tgq",
            "audio_url": "https://rss.art19.com/episodes/dfc93a2d-8274-4f32-b3e8-bc0104ee0fc6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2cb45a30-12e3-4eb3-9959-924c7431e93e",
            "index": 184,
            "title": "The Politics of AI Copyright",
            "pub_date": "2025-09-20T00:00:00.000Z",
            "duration": "00:10:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/The-Politics-of-AI-Copyright-e385tf3",
            "audio_url": "https://rss.art19.com/episodes/c80ec181-6d97-4856-abdf-9960ad38afe5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7617f615-0114-4b60-9877-6cb43933d962",
            "index": 185,
            "title": "OpenAI’s Smartest Acquisition Yet?",
            "pub_date": "2025-09-19T00:00:00.000Z",
            "duration": "00:08:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/OpenAIs-Smartest-Acquisition-Yet-e385tbh",
            "audio_url": "https://rss.art19.com/episodes/b8a763f7-c040-422a-bf0a-afe4d417a126.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68c9edd7-36a9-4811-9bff-3af91cecf813",
            "index": 186,
            "title": "Meta’s Hypernova Uncovered",
            "pub_date": "2025-09-18T00:00:00.000Z",
            "duration": "00:11:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Metas-Hypernova-Uncovered-e383ai8",
            "audio_url": "https://rss.art19.com/episodes/2a36074b-0124-4226-b4f8-b5687301d666.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8dbea58a-f3a0-4adf-8351-0798171959b0",
            "index": 187,
            "title": "Musk and Meta: Covert Collaborators?",
            "pub_date": "2025-09-17T00:00:00.000Z",
            "duration": "00:06:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Musk-and-Meta-Covert-Collaborators-e383aeq",
            "audio_url": "https://rss.art19.com/episodes/f75e294e-2cb8-42c2-8351-1d3a1c85f1b3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cf26201a-ac75-4a11-9437-93c178e40de6",
            "index": 188,
            "title": "The Grok Leak Timeline: What Really Happened",
            "pub_date": "2025-09-16T00:00:00.000Z",
            "duration": "00:06:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "grok"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/The-Grok-Leak-Timeline-What-Really-Happened-e37ledp",
            "audio_url": "https://rss.art19.com/episodes/f0ee2867-22c8-4a1b-b782-8f42cfa2c766.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3188970a-73c9-4a45-89ec-2a525ebf9b08",
            "index": 189,
            "title": "Inside Meta’s AI Overhaul and Beyond",
            "pub_date": "2025-09-15T00:00:00.000Z",
            "duration": "00:07:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Inside-Metas-AI-Overhaul-and-Beyond-e37lea8",
            "audio_url": "https://rss.art19.com/episodes/598cf0e4-2f1b-4cd7-98ae-5d4775b9053c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2ac18e8-eff8-4aa6-b30d-fa50169f1d8a",
            "index": 190,
            "title": "The Four Hundred Million Dollar Bet on Field AI and Beyond",
            "pub_date": "2025-09-14T00:00:00.000Z",
            "duration": "00:04:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/The-Four-Hundred-Million-Dollar-Bet-on-Field-AI-and-Beyond-e37le6l",
            "audio_url": "https://rss.art19.com/episodes/cdf2525a-a71f-463a-9cb9-83a7ef015f80.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1518e1d1-201b-4abc-9224-9660ab30f9dd",
            "index": 191,
            "title": "Google's Nano Banana Changes AI Creativity Deep Dive",
            "pub_date": "2025-09-13T00:00:00.000Z",
            "duration": "00:18:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Googles-Nano-Banana-Changes-AI-Creativity-Deep-Dive-e37le30",
            "audio_url": "https://rss.art19.com/episodes/a81e1dfa-6e4a-4bce-853d-a66a90a6e112.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eae01f95-b730-45fa-8071-df1325abf9cc",
            "index": 192,
            "title": "The Science of Sleep Meets AI at Eight Sleep Uncovered",
            "pub_date": "2025-09-12T00:00:00.000Z",
            "duration": "00:13:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/The-Science-of-Sleep-Meets-AI-at-Eight-Sleep-Uncovered-e37lduj",
            "audio_url": "https://rss.art19.com/episodes/82e9ce80-09a2-4363-aa08-e621b39e1745.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "df0ac8e6-6c91-45a8-9f5d-53b691e37e58",
            "index": 193,
            "title": "11 Labs API: Where AI Meets Creativity",
            "pub_date": "2025-09-11T00:00:00.000Z",
            "duration": "00:13:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/11-Labs-API-Where-AI-Meets-Creativity-e37ldq1",
            "audio_url": "https://rss.art19.com/episodes/dc22fe9d-683a-4889-bb31-4e6d13306981.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a5ea9edf-482b-4b2f-ab1b-1dae54b10340",
            "index": 194,
            "title": "Rethinking Perplexity Bids To Buy Google!: The hidden motives driving this audacious play",
            "pub_date": "2025-09-10T00:00:00.000Z",
            "duration": "00:09:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Rethinking-Perplexity-Bids-To-Buy-Google--The-hidden-motives-driving-this-audacious-play-e37ldm5",
            "audio_url": "https://rss.art19.com/episodes/1b38197a-497f-4389-b336-2dffd7f2d8a5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "784b83aa-d9fb-4ba3-8087-20ea2a57a3e7",
            "index": 195,
            "title": "New Updates to GPT-5: Lessons from Deployment",
            "pub_date": "2025-09-09T23:00:00.000Z",
            "duration": "00:09:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/New-Updates-to-GPT-5-Lessons-from-Deployment-e37ld38",
            "audio_url": "https://rss.art19.com/episodes/8bceec9d-114f-4ed4-bfc8-530f3c085cde.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "60cb3390-53ea-4519-981b-11e73387a5e1",
            "index": 196,
            "title": "What Datumo’s Entry Means for Scale AI",
            "pub_date": "2025-09-09T00:00:00.000Z",
            "duration": "00:09:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/What-Datumos-Entry-Means-for-Scale-AI-e37lctn",
            "audio_url": "https://rss.art19.com/episodes/d4732930-a8a7-400b-a094-caccdc067d0a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "44e52a05-8d0b-42a2-b3ab-e2847089ed2f",
            "index": 197,
            "title": "The Cultural Impact of OpenArt’s AI Creations",
            "pub_date": "2025-09-08T23:00:00.000Z",
            "duration": "00:09:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/The-Cultural-Impact-of-OpenArts-AI-Creations-e37lcpr",
            "audio_url": "https://rss.art19.com/episodes/871805a1-b53e-48a4-aa15-a811e1ed4bf3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2dac6b7b-b713-47d0-8fd2-852d54100295",
            "index": 198,
            "title": "Why Nvidia’s Cosmos Could Change AI Forever",
            "pub_date": "2025-09-08T00:00:00.000Z",
            "duration": "00:08:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Why-Nvidias-Cosmos-Could-Change-AI-Forever-e37lcl7",
            "audio_url": "https://rss.art19.com/episodes/e58ff251-0b48-472c-b020-0c139b1d1153.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3cb6186-2f08-4179-b357-5dbc9f62f56c",
            "index": 199,
            "title": "Inside Pinterest Says There Is No Future For AI Shopping: The surprising stance shaking up e-commerce",
            "pub_date": "2025-09-07T23:00:00.000Z",
            "duration": "00:09:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Inside-Pinterest-Says-There-Is-No-Future-For-AI-Shopping-The-surprising-stance-shaking-up-e-commerce-e37lch8",
            "audio_url": "https://rss.art19.com/episodes/bd46e6e7-3e63-4005-b62c-287ed1448b2d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ffa26481-53a9-4de1-a4aa-83cf91dad095",
            "index": 200,
            "title": "Meta Acquires WaveForms: From Music to Machine Learning",
            "pub_date": "2025-09-07T01:00:00.000Z",
            "duration": "00:08:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/cognitive-revolution-ai/episodes/Meta-Acquires-WaveForms-From-Music-to-Machine-Learning-e374mm6",
            "audio_url": "https://rss.art19.com/episodes/af326f26-6ef1-4733-abfe-5aa56889b048.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "ai-a16z",
        "title": "AI + a16z",
        "feed_title": "AI + a16z",
        "priority": "P0",
        "selection_mode": "all_ai",
        "focus": [
          "AI startups",
          "venture",
          "industry structure",
          "infrastructure"
        ],
        "feed_url": "https://feeds.simplecast.com/Hb_IuXOo",
        "source_url": "https://feeds.simplecast.com/Hb_IuXOo",
        "detail_path": "/podcasts/ai-a16z/",
        "episode_count": 99,
        "selected_episode_count": 99,
        "latest_episode_title": "Building Search for AI Agents with Exa CEO Will Bryk",
        "latest_pub_date": "2026-06-04T14:53:51.000Z",
        "latest_page_url": "https://ai-a16z.simplecast.com/episodes/building-search-for-ai-agents-with-exa-ceo-will-bryk-O7xRJK9R",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "9e9a7a5e-543a-4d73-9e83-701618ee79dd",
            "index": 1,
            "title": "Building Search for AI Agents with Exa CEO Will Bryk",
            "pub_date": "2026-06-04T14:53:51.000Z",
            "duration": "00:49:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "retrieval",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/building-search-for-ai-agents-with-exa-ceo-will-bryk-O7xRJK9R",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/78646531-28f3-4402-a559-37b1fa935fb4/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=78646531-28f3-4402-a559-37b1fa935fb4&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5fd274ea-09c1-4350-9615-c1f1a86ed328",
            "index": 2,
            "title": "AI Agents and the Fight for Customer Data",
            "pub_date": "2026-06-02T16:50:49.000Z",
            "duration": "00:50:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "coding",
              "enterprise ai"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ai-agents-and-the-fight-for-customer-data-oTfoFpTX",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/934c03fb-9788-4898-a8a3-50cf647ed4ef/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=934c03fb-9788-4898-a8a3-50cf647ed4ef&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5c3b7292-53d5-4e1b-9c1a-d47e7815f789",
            "index": 3,
            "title": "Ben Horowitz on AI Infrastructure, Economics and The New Laws of Software",
            "pub_date": "2026-05-19T10:00:00.000Z",
            "duration": "00:29:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ben-horowitz-on-ai-infrastructure-economics-and-the-new-laws-of-software-_Hn2wUAY",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/47a38451-67ad-4645-a1f5-b2e7d6b09676/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=47a38451-67ad-4645-a1f5-b2e7d6b09676&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5989354b-c3fe-4aad-aa08-fb20e5f33656",
            "index": 4,
            "title": "AI Infrastructure, Distribution, and the Next Wave of Software",
            "pub_date": "2026-05-12T10:00:00.000Z",
            "duration": "00:38:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ai-infrastructure-distribution-and-the-next-wave-of-software-4cCBe_Mt",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/fcf69858-2a4d-4d12-8ea2-50a933d95760/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=fcf69858-2a4d-4d12-8ea2-50a933d95760&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 381,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "957a732a-981b-43d9-8a1d-bc4a0fe1e151",
            "index": 5,
            "title": "From Vector Databases to Knowledge Engines: The Next Layer of AI",
            "pub_date": "2026-05-05T15:39:14.000Z",
            "duration": "00:46:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "agentic",
              "reasoning",
              "retrieval"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/from-vector-databases-to-knowledge-engines-the-next-layer-of-ai-8KtL2DHx",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/cbceed02-e629-4f00-9a55-05e478595b97/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=cbceed02-e629-4f00-9a55-05e478595b97&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0fae2a53-0d5a-4a3d-a58a-6921dd0249a3",
            "index": 6,
            "title": "Why We Need Continual Learning",
            "pub_date": "2026-04-28T10:00:00.000Z",
            "duration": "00:18:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/why-we-need-continual-learning-xKmXoC4Y",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/153ddfe2-39ec-4e30-bd0d-e1fb8030dd19/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=153ddfe2-39ec-4e30-bd0d-e1fb8030dd19&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2f551b1d-9baf-4861-b1ba-01422b837920",
            "index": 7,
            "title": "The Agent Era: Building Software Beyond Chat with Box CEO Aaron Levie",
            "pub_date": "2026-04-21T17:15:00.000Z",
            "duration": "00:59:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-agent-era-building-software-beyond-chat-with-box-ceo-aaron-levie-z_bSca3O",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/ee267e08-6bc8-4a47-92d3-941767b7f712/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=ee267e08-6bc8-4a47-92d3-941767b7f712&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 1093,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "ec46c1a8-63d9-4c52-a3ed-3d54d0e7ba3b",
            "index": 8,
            "title": "Rethinking Git for the Age of Coding Agents with GitHub Cofounder Scott Chacon",
            "pub_date": "2026-04-08T15:00:00.000Z",
            "duration": "00:47:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/rethinking-git-for-the-age-of-coding-agents-with-github-cofounder-scott-chacon-DAVGh_qe",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/2ae63099-a469-4b62-bede-e43f35685492/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=2ae63099-a469-4b62-bede-e43f35685492&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "921579e0-e8d0-45e9-b04b-7385f5b57620",
            "index": 9,
            "title": "How AI Is Reshaping IT Services from the Inside",
            "pub_date": "2026-04-01T10:00:00.000Z",
            "duration": "00:34:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "automation"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-ai-is-reshaping-it-services-from-the-inside-6zsGh8Aa",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/90b8686e-b84a-4ec1-bb32-06d6690a9f10/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=90b8686e-b84a-4ec1-bb32-06d6690a9f10&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 386,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 10,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "d87eb61a-181f-46a2-abbb-c7ed638956ed",
            "index": 10,
            "title": "Patrick Collison on Stripe’s Early Choices, Smalltalk, and What Comes After Coding",
            "pub_date": "2026-03-24T10:00:00.000Z",
            "duration": "00:52:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "cursor",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/patrick-collison-on-stripes-early-choices-smalltalk-and-what-comes-after-coding-7LptsAv9",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/93ff753b-a772-44de-9669-02441ba657ae/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=93ff753b-a772-44de-9669-02441ba657ae&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 855,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "9f0cc270-8126-435b-b3c8-866aeb99257f",
            "index": 11,
            "title": "OpenClaw: Why the Internet Isn't Built for AI Agents",
            "pub_date": "2026-03-19T10:00:00.000Z",
            "duration": "00:47:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/openclaw-why-the-internet-isnt-built-for-ai-agents-E2iKRigA",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/d02fa4dd-e598-4095-915d-cd55b20a0b5d/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=d02fa4dd-e598-4095-915d-cd55b20a0b5d&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 816,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "51b10f8c-13d1-4366-bb72-432c01aa2bbd",
            "index": 12,
            "title": "What's Missing Between LLMs and AGI - Vishal Misra & Martin Casado",
            "pub_date": "2026-03-17T11:05:00.000Z",
            "duration": "00:47:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "training"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/whats-missing-between-llms-and-agi-vishal-misra-martin-casado-fr0HSPWZ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/ee9cbcb0-7302-445e-b996-a42f69092340/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=ee9cbcb0-7302-445e-b996-a42f69092340&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 678,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "8beebac5-d54e-43f1-ac2e-dbfb233fbd2e",
            "index": 13,
            "title": "Replit's CEO on Vibe Coding, Wealth Building, and What Most People Get Wrong About AI",
            "pub_date": "2026-03-10T17:18:25.000Z",
            "duration": "01:39:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "replit",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/replits-ceo-on-vibe-coding-wealth-building-and-what-most-people-get-wrong-about-ai-R0OFd5Wq",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/63461b45-bb0e-4f52-9816-3d196ee194ff/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=63461b45-bb0e-4f52-9816-3d196ee194ff&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 1050,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "1c9f6a89-1949-4073-bd9b-cdbc9fed660a",
            "index": 14,
            "title": "Jack Altman & Martin Casado on the Future of VC",
            "pub_date": "2026-03-03T11:00:00.000Z",
            "duration": "00:53:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/jack-altman-martin-casado-on-the-future-of-vc-4Vfal3nk",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/a84c11c1-ec2d-418a-9f52-dd43262e7d0f/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=a84c11c1-ec2d-418a-9f52-dd43262e7d0f&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 857,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "4dfc689a-b1b3-4ef5-af9f-427689a3bd67",
            "index": 15,
            "title": "AI’s Capital Flywheel: Models, Money, and the Future of Power",
            "pub_date": "2026-02-24T11:00:00.000Z",
            "duration": "00:57:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "frontier model"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ais-capital-flywheel-models-money-and-the-future-of-power-mPUpgt9I",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/837b12b2-8c93-4a61-86aa-0f04c347496d/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=837b12b2-8c93-4a61-86aa-0f04c347496d&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1286e4d6-4e66-48f4-a651-fe5f7ef37a52",
            "index": 16,
            "title": "Durable Execution and the Infrastructure Powering AI Agents",
            "pub_date": "2026-02-19T11:00:00.000Z",
            "duration": "01:03:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "openai"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/durable-execution-and-the-infrastructure-powering-ai-agents-edrnjoca-sPuB7Zdw",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/246f01f7-e84a-4731-bdcb-f716706157fd/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=246f01f7-e84a-4731-bdcb-f716706157fd&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 752,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "cc549030-ea11-4021-83eb-84cc1eacc686",
            "index": 17,
            "title": "Evals, Feedback Loops, and the Engineering That Makes AI Work",
            "pub_date": "2026-02-17T17:15:00.000Z",
            "duration": "00:43:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "evals"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/evals-feedback-loops-and-the-engineering-that-makes-ai-work-cqU91fWY",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/0a4f8869-211c-4465-91aa-860173e18e94/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=0a4f8869-211c-4465-91aa-860173e18e94&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "43efd0a1-d1f3-4741-97d6-d5a2234b563c",
            "index": 18,
            "title": "Sam Altman on Sora, Energy, and Building an AI Empire",
            "pub_date": "2026-02-10T11:00:00.000Z",
            "duration": "00:48:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "evals"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/sam-altman-on-sora-energy-and-building-an-ai-empire-puFFZpYc",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/5355925a-3b53-4ed2-ab5d-c23c600f9046/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=5355925a-3b53-4ed2-ab5d-c23c600f9046&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 928,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "7b6738ca-a088-449f-9ea9-72419b1e28a3",
            "index": 19,
            "title": "Why This Isn't the Dot-Com Bubble | Martin Casado on WSJ's BOLD NAMES",
            "pub_date": "2026-02-03T11:00:00.000Z",
            "duration": "00:29:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/why-this-isnt-the-dot-com-bubble-martin-casado-on-wsjs-bold-names-u9crQXPt",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/b017fabc-401a-4ff5-8cf3-61ea7570b6ad/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=b017fabc-401a-4ff5-8cf3-61ea7570b6ad&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 358,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 10,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "8d8890fb-8134-466a-a2e4-c01457fda77e",
            "index": 20,
            "title": "Martin Casado on the Demand Forces Behind AI",
            "pub_date": "2026-01-27T11:00:00.000Z",
            "duration": "00:27:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/martin-casado-on-the-demand-forces-behind-ai-Fhnnsaf9",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/8c4469ba-3123-4e06-9b2e-8d077a487a0e/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=8c4469ba-3123-4e06-9b2e-8d077a487a0e&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b822fc1b-008a-4066-80aa-a11045f9ba30",
            "index": 21,
            "title": "How Mintlify Is Rebuilding Documentation for Coding Agents",
            "pub_date": "2026-01-23T16:00:00.000Z",
            "duration": "00:44:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-mintlify-is-rebuilding-documentation-for-coding-agents-Ff1_k4er",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/020bb5e5-0e46-4f54-8e87-bb7b411673e8/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=020bb5e5-0e46-4f54-8e87-bb7b411673e8&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d4e9c5e9-0606-47fb-8af4-adaa4375bdad",
            "index": 22,
            "title": "Inferact: Building the Infrastructure That Runs Modern AI",
            "pub_date": "2026-01-22T16:00:00.000Z",
            "duration": "00:43:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chip",
              "inference"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/inferact-building-the-infrastructure-that-runs-modern-ai-huLj_36z",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/f6d42d55-3e7d-4d92-8517-8d84c18386af/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=f6d42d55-3e7d-4d92-8517-8d84c18386af&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8474773e-02ef-430f-91c6-fe0caaddd871",
            "index": 23,
            "title": "How Should AI Be Regulated? Use vs. Development",
            "pub_date": "2026-01-20T11:00:00.000Z",
            "duration": "00:46:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-should-ai-be-regulated-use-vs-development-9YvBYr3S",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/0616329d-8f47-4de8-b5bd-05e52029655f/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=0616329d-8f47-4de8-b5bd-05e52029655f&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "052d02a1-8bdd-4166-a154-76b666e38908",
            "index": 24,
            "title": "Michael Truell: How Cursor Builds at the Speed of AI",
            "pub_date": "2026-01-13T11:00:00.000Z",
            "duration": "00:27:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "cursor"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/michael-truell-how-cursor-builds-at-the-speed-of-ai-8Zb4fXEF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/904b2891-7c14-48c4-b93e-7b580f875bbe/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=904b2891-7c14-48c4-b93e-7b580f875bbe&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1303bd08-d46d-4d66-929b-1e0e4d9b7507",
            "index": 25,
            "title": "Dylan Patel on the AI Chip Race - NVIDIA, Intel & the US Government",
            "pub_date": "2026-01-06T11:00:00.000Z",
            "duration": "01:40:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia",
              "chip",
              "data center"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/dylan-patel-on-the-ai-chip-race-nvidia-intel-the-us-government-PKksIyQr",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/ef093598-d7d7-4a3d-9eef-69782861d289/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=ef093598-d7d7-4a3d-9eef-69782861d289&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33e5ce92-78fa-4754-8dcd-dea0f774955f",
            "index": 26,
            "title": "Feed Drop from The Generalist: Why a16z's Martin Casado believes the AI boom still has years to run",
            "pub_date": "2025-12-30T11:00:00.000Z",
            "duration": "01:21:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/feed-drop-from-the-generalist-why-a16zs-martin-casado-believes-the-ai-boom-still-has-years-to-run-hxD0__xD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/b6e2a8ae-2696-4cb4-9083-aeb2c627b604/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=b6e2a8ae-2696-4cb4-9083-aeb2c627b604&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 1181,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "skip_already_indexed",
              "blocking_reason": ""
            }
          },
          {
            "id": "937a7df8-1678-446f-8867-3ead35f27ddc",
            "index": 27,
            "title": "Fei-Fei Li: World Models and the Multiverse",
            "pub_date": "2025-12-23T11:00:00.000Z",
            "duration": "00:22:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "robotics"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/fei-fei-li-world-models-and-the-multiverse-99R4vwsV",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/921937a0-2f98-4912-b49d-323e2699f84a/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=921937a0-2f98-4912-b49d-323e2699f84a&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c153ef7d-4a32-4785-ab5d-3af44a1f3c0b",
            "index": 28,
            "title": "Building the “See Something, Say Something” AI for Every Camera",
            "pub_date": "2025-12-16T11:00:00.000Z",
            "duration": "00:39:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agentic",
              "reasoning"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/building-the-see-something-say-something-ai-for-every-camera-4M9cVflB",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/de9c40ad-98ba-4194-9d55-0298b24c0e60/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=de9c40ad-98ba-4194-9d55-0298b24c0e60&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d096c359-619b-4f61-b311-46f0b84c9952",
            "index": 29,
            "title": "The AI That Found A Bug In The World’s Most Audited Code",
            "pub_date": "2025-12-10T11:00:00.000Z",
            "duration": "00:39:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "openai"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-ai-that-found-a-bug-in-the-worlds-most-audited-code-TRFCalxK",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/653732df-3623-41b8-9da1-df83ef4e5b8b/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=653732df-3623-41b8-9da1-df83ef4e5b8b&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1b700ed0-a049-4e5d-bdf2-6e6b4295644d",
            "index": 30,
            "title": "The Death of Data Gatekeeping: AI Makes Everyone An Analyst | Hex Cofounder",
            "pub_date": "2025-12-05T11:00:00.000Z",
            "duration": "01:22:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-death-of-data-gatekeeping-ai-makes-everyone-an-analyst-hex-cofounder-N4Bdzn4C",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/6045c456-944d-457d-9b1d-167731db91a6/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=6045c456-944d-457d-9b1d-167731db91a6&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b1832d51-2043-4210-a2cd-b39441ba11f7",
            "index": 31,
            "title": "Why Social Engineering Now Works on Machines",
            "pub_date": "2025-12-02T11:00:00.000Z",
            "duration": "00:25:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/why-social-engineering-now-works-on-machines-eMF4lNc_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/c882b32c-2d1e-423d-804b-35b16834ca71/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=c882b32c-2d1e-423d-804b-35b16834ca71&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6bcb2562-1751-41ce-b763-196bcaf43799",
            "index": 32,
            "title": "“Anyone Can Code Now” - Netlify CEO Talks AI Agents",
            "pub_date": "2025-11-28T11:00:00.000Z",
            "duration": "00:57:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "chatgpt",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/anyone-can-code-now-netlify-ceo-talks-ai-agents-9ytKvFrH",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/f088add1-c287-46da-820e-d6463feca9cc/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=f088add1-c287-46da-820e-d6463feca9cc&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bae3af73-d598-497e-a344-d741bdee81a1",
            "index": 33,
            "title": "From Code Search to AI Agents: Inside Sourcegraph's Transformation with CTO Beyang Liu",
            "pub_date": "2025-11-25T11:00:00.000Z",
            "duration": "00:46:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "agents",
              "llama",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/from-code-search-to-ai-agents-inside-sourcegraphs-transformation-with-cto-beyang-liu-49BSQYot",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/a6a54de2-c2ec-443f-87f7-47ec584e35c6/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=a6a54de2-c2ec-443f-87f7-47ec584e35c6&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aff161d9-54ff-450c-ab38-20eb246e8dc3",
            "index": 34,
            "title": "Ryo Lu (Cursor): AI Turns Designers to Developers",
            "pub_date": "2025-11-21T11:00:00.000Z",
            "duration": "00:52:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "cursor"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ryo-lu-cursor-ai-turns-designers-to-developers-X5LMtncw",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/b457ab58-0f72-4130-b3a4-655e45740d25/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=b457ab58-0f72-4130-b3a4-655e45740d25&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d3fea472-77d8-41af-945f-059857a43451",
            "index": 35,
            "title": "How Foundation Models Evolved: A PhD Journey Through AI's Breakthrough Era",
            "pub_date": "2025-11-18T11:00:00.000Z",
            "duration": "00:57:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-foundation-models-evolved-a-phd-journey-through-ais-breakthrough-era-ZtII13tI",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/b52bbbe3-3ed5-412b-b014-d174f3ef47ff/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=b52bbbe3-3ed5-412b-b014-d174f3ef47ff&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "783f683e-d217-4bf4-8236-662b5dd65469",
            "index": 36,
            "title": "TruffleHog Creator: You Can’t Have AI Agents Without Secrets",
            "pub_date": "2025-11-11T11:00:00.000Z",
            "duration": "00:28:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/trufflehog-creator-you-cant-have-ai-agents-without-secrets-t7dDFmLO",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/36ee607b-e419-4b1e-bba5-94a2b5359dba/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=36ee607b-e419-4b1e-bba5-94a2b5359dba&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19241f14-0b09-48c0-b767-2868b691f4ed",
            "index": 37,
            "title": "Tigris Data CEO on Building Your Own Datacenters",
            "pub_date": "2025-11-07T11:00:00.000Z",
            "duration": "00:38:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/tigris-data-ceo-on-building-your-own-datacenters-DlDdk8Ze",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/aa646040-64da-4b87-8ee4-142a560e7f38/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=aa646040-64da-4b87-8ee4-142a560e7f38&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0cdbe65-1ff8-417f-b67c-80fbf1bdc9bf",
            "index": 38,
            "title": "Pylon: Reimagining B2B Customer Support",
            "pub_date": "2025-10-31T13:00:00.000Z",
            "duration": "00:47:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/pylon-reimagining-b2b-customer-support-FvlnyIhs",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/26bc3c99-5f1f-4b1f-9f8e-4933e6a8ea99/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=26bc3c99-5f1f-4b1f-9f8e-4933e6a8ea99&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d268add1-950c-4972-ac82-50e57c6c5519",
            "index": 39,
            "title": "Keycard: 2026 is the Year of Agents",
            "pub_date": "2025-10-22T13:00:00.000Z",
            "duration": "00:32:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/keycard-2026-is-the-year-of-agents-rFx2QSzx",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/3ff855dd-74ac-4fd2-9c88-91e3986a81d6/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=3ff855dd-74ac-4fd2-9c88-91e3986a81d6&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "258b0279-a6cc-4efe-b58e-8b2676fe63f1",
            "index": 40,
            "title": "The Trillion Dollar AI Software Development Stack",
            "pub_date": "2025-10-10T16:00:00.000Z",
            "duration": "00:38:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-trillion-dollar-ai-software-development-stack-xYS2_Aw3",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/2b7d4a58-6d6d-4807-93f1-7b616c9f1028/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=2b7d4a58-6d6d-4807-93f1-7b616c9f1028&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f9ef3e4-78a8-4b74-84e2-89fc9409eba3",
            "index": 41,
            "title": "Material Security CEO: How To Find Your Ideal Customer",
            "pub_date": "2025-10-06T16:00:00.000Z",
            "duration": "00:34:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/material-security-ceo-how-to-find-your-ideal-customer-zZVrL5A6",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/b55d8acb-6bf4-45af-bab6-81b24683243f/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=b55d8acb-6bf4-45af-bab6-81b24683243f&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "49f41c6e-5562-4a1b-8766-80fe5562fe16",
            "index": 42,
            "title": "When Deepfakes Steal $30M: The New Edge of Cybercrime",
            "pub_date": "2025-09-26T10:00:00.000Z",
            "duration": "00:22:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/when-deepfakes-steal-30m-the-new-edge-of-cybercrime-Ju51B3Oj",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/434070b4-65fd-40b5-a903-d3ddb011e8da/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=434070b4-65fd-40b5-a903-d3ddb011e8da&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9d7dfa2c-58a4-4622-9a8e-30eb08796603",
            "index": 43,
            "title": "How AI Will Change Photography Forever",
            "pub_date": "2025-09-17T16:19:37.000Z",
            "duration": "00:51:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-ai-will-change-photography-forever-VipBASBk",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/cb83d0ab-0b23-42a3-924d-8c88e1cbf51d/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=cb83d0ab-0b23-42a3-924d-8c88e1cbf51d&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "656975c0-f5b1-407a-a0c3-3d404d7a2ac3",
            "index": 44,
            "title": "How OpenAI Built Its Coding Agent",
            "pub_date": "2025-08-29T10:00:00.000Z",
            "duration": "01:19:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "openai",
              "safety",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-openai-built-its-coding-agent-C6frUqag",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/cfdfe07b-1500-4818-9b8c-30c981c65901/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=cfdfe07b-1500-4818-9b8c-30c981c65901&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd00402f-116a-48a5-8dc2-043bf3c28ff4",
            "index": 45,
            "title": "Models, Modalities, and Memes: Creating Compelling AI Characters",
            "pub_date": "2025-08-14T14:00:00.000Z",
            "duration": "00:47:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/models-modalities-and-memes-creating-compelling-ai-characters-_sIjegvt",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/46489d2e-cef5-4728-ac6b-378a98168e10/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=46489d2e-cef5-4728-ac6b-378a98168e10&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d3d79fb-98c4-4879-9e49-60ab67aae5e0",
            "index": 46,
            "title": "Performance and Passion: Fal's Approach to AI Inference",
            "pub_date": "2025-08-01T14:00:00.000Z",
            "duration": "00:40:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "gpu",
              "inference"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/speed-performance-and-passion-fals-approach-to-ai-inference-nBeW8e4u",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/b57be34e-3e3d-494f-9fa7-38ff0ceb8876/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=b57be34e-3e3d-494f-9fa7-38ff0ceb8876&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "587c0129-f6f5-4c33-b245-ef10a9357a78",
            "index": 47,
            "title": "How to Vibe Code Securely",
            "pub_date": "2025-07-25T14:02:56.000Z",
            "duration": "00:26:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-to-vibe-code-securely-Zoh0MO54",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/b96a6a88-6318-45a4-afdf-8260f22e3156/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=b96a6a88-6318-45a4-afdf-8260f22e3156&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c371c026-a60a-47ef-a079-905c2ee86bfe",
            "index": 48,
            "title": "AI Is Upending SaaS Pricing",
            "pub_date": "2025-07-18T14:00:00.000Z",
            "duration": "00:42:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ai-is-upending-saas-pricing-2YHTA0_S",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/62ee5a37-37e5-461a-9194-fd45f0fb58fa/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=62ee5a37-37e5-461a-9194-fd45f0fb58fa&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "925edefb-8c51-4cca-912f-c32b577c9174",
            "index": 49,
            "title": "The AI Infrastructure Stack with Jennifer Li",
            "pub_date": "2025-07-11T14:00:00.000Z",
            "duration": "00:45:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-ai-infrastructure-stack-with-jennifer-li-GlVBpQy4",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/ccead9b1-e439-4fd8-939b-bb128253b0d8/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=ccead9b1-e439-4fd8-939b-bb128253b0d8&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8400320-aa98-403e-aeb5-19a0fe06c5ec",
            "index": 50,
            "title": "AI's Unsung Hero: Data Labeling and Expert Evals",
            "pub_date": "2025-06-27T14:00:00.000Z",
            "duration": "00:46:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "generative ai",
              "training",
              "evals",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ais-unsung-hero-data-labeling-and-expert-evals-FiUonGPv",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/40ca798b-67e1-4250-9e43-fd534039b966/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=40ca798b-67e1-4250-9e43-fd534039b966&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "299245d1-de5e-4908-b191-b5cae20730a1",
            "index": 51,
            "title": "AI, Data Engineering, and the Modern Data Stack",
            "pub_date": "2025-06-20T14:00:00.000Z",
            "duration": "00:35:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "automation"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ai-data-engineering-and-the-modern-data-stack-wXXhHLo7",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/27863aa4-9767-4c51-a1b9-7d220bb0af69/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=27863aa4-9767-4c51-a1b9-7d220bb0af69&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e7bd91b4-ee1f-4bd2-bd83-7dc5f471ca88",
            "index": 52,
            "title": "Enabling Agents and Battling Bots on an AI-Centric Web",
            "pub_date": "2025-06-13T14:00:00.000Z",
            "duration": "00:26:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "inference"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/enabling-agents-and-battling-bots-on-an-ai-centric-web-LysFuQCF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/de183c8a-5038-4a0c-adc0-ecaacee35533/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=de183c8a-5038-4a0c-adc0-ecaacee35533&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ec03c8b-6789-4080-9097-a69f43bff972",
            "index": 53,
            "title": "Giving New Life to Unstructured Data with LLMs and Agents",
            "pub_date": "2025-06-06T14:00:00.000Z",
            "duration": "00:35:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "agents",
              "automation"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/giving-new-life-to-unstructured-data-with-llms-and-agents-uk2KZglN",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/fdc66310-c7e9-408f-b9de-9c0deacb56c8/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=fdc66310-c7e9-408f-b9de-9c0deacb56c8&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9426e567-aad4-4b8a-aa43-5c7795ecfcf6",
            "index": 54,
            "title": "Beyond Leaderboards: LMArena’s Mission to Make AI Reliable",
            "pub_date": "2025-05-30T15:46:18.000Z",
            "duration": "01:41:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/beyond-leaderboards-lmarenas-mission-to-make-ai-reliable-FXSI58J_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/2de38043-a555-4028-90e4-89014628d728/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=2de38043-a555-4028-90e4-89014628d728&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d898c1af-15ba-4d9b-9616-7820f99bcc7f",
            "index": 55,
            "title": "Building AI Systems You Can Trust",
            "pub_date": "2025-05-23T14:00:00.000Z",
            "duration": "00:47:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "enterprise ai"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/building-ai-systems-you-can-trust-AEtnbIY6",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/5a75f867-78df-453a-9698-5190fff73f97/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=5a75f867-78df-453a-9698-5190fff73f97&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "09173876-d309-466f-b524-5dc4c21c6960",
            "index": 56,
            "title": "Who's Coding Now? AI and the Future of Software Development",
            "pub_date": "2025-05-16T14:00:00.000Z",
            "duration": "00:44:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/whos-coding-now-ai-and-the-future-of-software-development-kII71_li",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/7fa364b7-1a84-4448-a605-110217d7fba3/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=7fa364b7-1a84-4448-a605-110217d7fba3&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7cfcf8fd-9213-4c5a-9b2d-9769c64fce3e",
            "index": 57,
            "title": "MCP Co-Creator on the Next Wave of LLM Innovation",
            "pub_date": "2025-05-02T14:30:00.000Z",
            "duration": "00:53:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "agent",
              "agents",
              "anthropic",
              "claude"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/mcp-creator-on-the-next-wave-of-llm-innovation-RBH9eGzD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/a1a907ae-0c13-4cc3-984c-f7d8a21b63cd/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=a1a907ae-0c13-4cc3-984c-f7d8a21b63cd&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34bc9137-cd0a-403b-b2a2-ae25e2740bfc",
            "index": 58,
            "title": "What Is an AI Agent?",
            "pub_date": "2025-04-28T20:00:00.000Z",
            "duration": "00:36:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "reasoning",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/what-is-an-ai-agent-PIccwshu",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/2d89d785-a779-461d-8ad2-9be79e23cd8f/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=2d89d785-a779-461d-8ad2-9be79e23cd8f&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f044b72b-55d8-465a-9afa-1965b9e8240d",
            "index": 59,
            "title": "Benchmarking AI Agents on Full-Stack Coding",
            "pub_date": "2025-03-28T14:00:00.000Z",
            "duration": "00:33:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "safety",
              "eval",
              "evals"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/benchmarking-ai-agents-on-full-stack-coding-QGpiWJ91",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/8d45a574-ae4a-494e-846f-18d238b2850f/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=8d45a574-ae4a-494e-846f-18d238b2850f&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e65c6423-f891-4032-accf-7cc256ea954e",
            "index": 60,
            "title": "Automating Developer Email with MCP and Al Agents",
            "pub_date": "2025-03-21T14:00:00.000Z",
            "duration": "00:44:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/automating-developer-email-with-mcp-and-al-agents-cDVmKE0u",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/a44ad6c4-8db4-4b47-8ad1-fdcbc7b9b06e/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=a44ad6c4-8db4-4b47-8ad1-fdcbc7b9b06e&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "973e96d6-5331-4597-b337-305cbf4caec6",
            "index": 61,
            "title": "The Future of Digital Workers",
            "pub_date": "2025-03-20T17:00:00.000Z",
            "duration": "00:26:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "agentic",
              "multimodal",
              "automation"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-future-of-digital-workers-x2kUEf_N",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/3b96c967-9367-4e4d-a162-cd851754b902/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=3b96c967-9367-4e4d-a162-cd851754b902&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02ecf2c3-b3f8-48af-8110-e97a42b1b1c3",
            "index": 62,
            "title": "Building the Next Generation of Conversational AI",
            "pub_date": "2025-03-14T16:00:00.000Z",
            "duration": "01:41:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "multimodal"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/building-the-next-generation-of-conversational-ai-gN5BfFT9",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/da821d5f-f7b7-41d6-a979-771c8e5bf5d4/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=da821d5f-f7b7-41d6-a979-771c8e5bf5d4&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa96d88b-0261-43ac-9b56-b07abef23f63",
            "index": 63,
            "title": "Agent Experience: Building an Open Web for the AI Era",
            "pub_date": "2025-03-07T15:00:00.000Z",
            "duration": "00:40:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/agent-experience-building-an-open-web-for-the-ai-era-ssRRM1rQ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/9733bcdf-b3e3-4e7d-b75b-896f32d9e906/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=9733bcdf-b3e3-4e7d-b75b-896f32d9e906&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9df42864-e6ea-4c1a-acda-f8ed9614c0c2",
            "index": 64,
            "title": "What DeepSeek Means for Cybersecurity",
            "pub_date": "2025-02-28T15:00:00.000Z",
            "duration": "00:52:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "agents",
              "training",
              "reasoning",
              "alignment"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/what-deepseek-means-for-cybersecurity-bzFt_hoW",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/0a928bae-cad8-4bbd-b520-485baefe3d60/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=0a928bae-cad8-4bbd-b520-485baefe3d60&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc376253-ca3c-4432-8251-671823201be2",
            "index": 65,
            "title": "Agents, Lawyers, and LLMs",
            "pub_date": "2025-02-21T15:00:00.000Z",
            "duration": "00:40:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/agents-lawyers-and-llms-CV33MiPf",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/62b3993f-4c95-4d9e-9bee-1fa26f41211d/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=62b3993f-4c95-4d9e-9bee-1fa26f41211d&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c1c22bc-2e12-4b9f-ba31-bb61f8692638",
            "index": 66,
            "title": "Reasoning Models Are Remaking Professional Services",
            "pub_date": "2025-02-14T18:38:36.000Z",
            "duration": "00:37:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "reasoning"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/reasoning-models-are-remaking-professional-services-Kt3C1oXU",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/c34f4dad-9d16-455a-9593-1fb0224a6de0/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=c34f4dad-9d16-455a-9593-1fb0224a6de0&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cfb6bb26-7fe0-4d7c-996d-9a0e3a65fa3b",
            "index": 67,
            "title": "Data Management for Enterprise LLMs",
            "pub_date": "2025-02-07T15:00:00.000Z",
            "duration": "00:38:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/data-management-for-enterprise-llms-qbA99Sv6",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/cc86bd42-1ba0-4509-a9ec-da5e73287cd4/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=cc86bd42-1ba0-4509-a9ec-da5e73287cd4&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7544421e-e7e3-4fe2-9654-d7846054a191",
            "index": 68,
            "title": "From NLP to LLMs: The Quest for a Reliable Chatbot",
            "pub_date": "2025-01-10T17:30:00.000Z",
            "duration": "00:38:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "agents"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/from-nlp-to-llms-the-quest-for-a-reliable-chatbot-3iZNGUgQ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/93f356bf-cdfc-4adf-bdc6-42ffe41c7dd9/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=93f356bf-cdfc-4adf-bdc6-42ffe41c7dd9&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1bfcc384-ae14-4659-8642-50e2d668fcc6",
            "index": 69,
            "title": "Best of the Year: Building AI Companies",
            "pub_date": "2024-12-27T17:00:00.000Z",
            "duration": "00:46:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "model labs"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/best-of-the-year-building-ai-companies-i0QzGcKn",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/c3c8210f-72bc-4239-a4f3-4adb40271ecc/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=c3c8210f-72bc-4239-a4f3-4adb40271ecc&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac9904e4-0950-4c7c-86e9-767174fb2c4a",
            "index": 70,
            "title": "Can AI Agents Finally Fix Customer Support?",
            "pub_date": "2024-12-18T17:00:00.000Z",
            "duration": "00:44:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "automation"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/can-ai-agents-finally-fix-customer-support-Gsu0K0AX",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/1a73d06e-0d7c-4c39-aef8-b6be315a55e0/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=1a73d06e-0d7c-4c39-aef8-b6be315a55e0&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a0070e9-c9a3-4c90-b4f2-90842ac08b3f",
            "index": 71,
            "title": "REPLAY: Scoping the Enterprise LLM Market",
            "pub_date": "2024-11-30T15:00:46.000Z",
            "duration": "00:43:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/replay-scoping-the-enterprise-llm-market-AkytHnbF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/21f6e2f2-86c8-4b36-829f-f6c4306f1e44/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=21f6e2f2-86c8-4b36-829f-f6c4306f1e44&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b5b3e6ce-4683-4c9c-89d4-b2b52db0014e",
            "index": 72,
            "title": "Building Developers Tools, From Docker to Diffusion Models",
            "pub_date": "2024-11-15T15:00:00.000Z",
            "duration": "00:41:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/building-developers-tools-from-docker-to-diffusion-models-XJC7uYVj",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/43767f7b-31f3-441f-8628-7f55150fd7f3/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=43767f7b-31f3-441f-8628-7f55150fd7f3&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7a5d9cd6-8331-400c-b90c-4edcb08cc695",
            "index": 73,
            "title": "The Best Way to Achieve AGI Is to Invent It",
            "pub_date": "2024-11-04T15:30:00.000Z",
            "duration": "00:38:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "generative ai"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-best-way-to-achieve-agi-is-to-invent-it-IOxN7syq",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/956722fc-aa85-4efd-bab0-d098de2e0fa3/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=956722fc-aa85-4efd-bab0-d098de2e0fa3&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8088377e-db43-4e1f-ba18-879b0719668d",
            "index": 74,
            "title": "Neural Nets and Nobel Prizes: AI's 40-Year Journey from the Lab to Ubiquity",
            "pub_date": "2024-10-25T18:30:00.000Z",
            "duration": "00:40:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llama",
              "training"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/neural-nets-and-nobel-prizes-9z3A0pnK",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/9d1e2204-1fa8-4038-b34a-eb3cf0e3ce42/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=9d1e2204-1fa8-4038-b34a-eb3cf0e3ce42&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a238f049-c33a-4939-9df4-e3319c4a4cc7",
            "index": 75,
            "title": "How GPU Access Helps AI Startups Be Agile",
            "pub_date": "2024-10-23T14:00:00.000Z",
            "duration": "00:39:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia",
              "gpu",
              "chips",
              "inference",
              "training"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-gpu-access-helps-ai-startups-be-agile-kyoI6Qvk",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/14056164-378f-4d5e-9c00-4941686dbe82/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=14056164-378f-4d5e-9c00-4941686dbe82&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8de37443-4990-4027-9fc3-3f14328f1b93",
            "index": 76,
            "title": "DisTrO and the Quest for Community-Trained AI Models",
            "pub_date": "2024-09-27T18:39:16.000Z",
            "duration": "01:12:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llama"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/distro-and-the-quest-for-community-trained-ai-models-vRIP4M42",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/e59f4957-319b-468b-a457-bf917e9eeb04/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=e59f4957-319b-468b-a457-bf917e9eeb04&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "23e24a91-e831-4849-95ea-c54b06e87325",
            "index": 77,
            "title": "Balancing AI Expertise and Industry Acumen in Vertical Applications",
            "pub_date": "2024-09-13T16:15:00.000Z",
            "duration": "00:42:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/balancing-ai-expertise-and-industry-acumen-when-building-vertical-applications-B9iQiL0o",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/20ff9545-60ea-4d1d-ae4c-61726b3daafc/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=20ff9545-60ea-4d1d-ae4c-61726b3daafc&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f47a257-9f46-46a2-a606-39dc5b230808",
            "index": 78,
            "title": "AI, SQL, and the End of Big Data",
            "pub_date": "2024-08-30T14:00:00.000Z",
            "duration": "00:33:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "coding",
              "copilot"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/ai-sql-and-the-end-of-big-data-1f3hQwYf",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/2d7a2c9d-2d24-4054-b4cb-66f92e776212/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=2d7a2c9d-2d24-4054-b4cb-66f92e776212&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cdd9816d-99ad-4121-a06f-5c2e565b478e",
            "index": 79,
            "title": "The Researcher to Founder Journey, and the Power of Open Models",
            "pub_date": "2024-08-16T23:51:40.000Z",
            "duration": "00:37:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-researcher-to-founder-journey-and-the-power-of-open-models-dPtNB0So",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/2706c7c1-5f62-47cd-8cf1-707007a5a41e/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=2706c7c1-5f62-47cd-8cf1-707007a5a41e&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f222824-bd51-4b1a-960b-08840ed4a8ac",
            "index": 80,
            "title": "Why Computer Science Subsumed Biotech",
            "pub_date": "2024-08-09T14:00:00.000Z",
            "duration": "00:47:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/why-computer-science-subsumed-biotech-xfxkSRNU",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/cd5df37d-2712-41a5-955e-cb1714a91ed1/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=cd5df37d-2712-41a5-955e-cb1714a91ed1&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dd0f530c-89c2-4229-955b-a6c166ebf4ec",
            "index": 81,
            "title": "Democratizing Generative AI Red Teams",
            "pub_date": "2024-08-02T14:00:00.000Z",
            "duration": "00:44:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "large language model",
              "foundation model",
              "generative ai",
              "openai",
              "anthropic"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/securing-ai-by-democratizing-red-teams-ML60QMBJ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/ad5eb780-51f4-499d-b15d-cfa1b900529b/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=ad5eb780-51f4-499d-b15d-cfa1b900529b&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "511b8d61-deee-41c1-b5d2-3990799da73f",
            "index": 82,
            "title": "Augmenting Incident Response with LLMs",
            "pub_date": "2024-07-26T14:00:00.000Z",
            "duration": "00:40:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/augmenting-incident-response-with-llms-h7juJCvd",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/1888cea2-74eb-42d2-8216-b2b4e8ae180a/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=1888cea2-74eb-42d2-8216-b2b4e8ae180a&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f79e5084-030b-4c07-a357-a1cccd31b5fc",
            "index": 83,
            "title": "Scaling AI for the Coming Data Deluge",
            "pub_date": "2024-07-19T14:00:00.000Z",
            "duration": "00:37:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "training"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/scaling-ai-for-the-coming-data-deluge-5F5qykAS",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/5bedf3c3-5533-4a3f-94ed-66c179d6125a/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=5bedf3c3-5533-4a3f-94ed-66c179d6125a&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e9bb0d0-581c-484d-a954-9465e512732d",
            "index": 84,
            "title": "ARCHIVE: The Dream of AI Is Alive in AlphaGo",
            "pub_date": "2024-07-05T14:00:00.000Z",
            "duration": "00:33:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "deepmind"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/archive-the-dream-of-ai-is-alive-in-alphago-0MEOO8xc",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/4e3a6928-9316-4199-a18f-fea52595f1cb/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=4e3a6928-9316-4199-a18f-fea52595f1cb&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "26632793-5fc6-4cb7-ae3d-8e76c277640d",
            "index": 85,
            "title": "Beyond Language: Inside a Hundred-Trillion-Token Video Model",
            "pub_date": "2024-07-03T23:06:22.000Z",
            "duration": "01:05:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training",
              "reasoning",
              "multimodal"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/beyond-language-inside-a-hundred-trillion-token-video-model-48FKpX9k",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/c4d20aa4-03f6-4b64-8535-2b8216e56d35/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=c4d20aa4-03f6-4b64-8535-2b8216e56d35&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a61e5b6a-7e6c-441a-868f-35c2f320869e",
            "index": 86,
            "title": "Developer Tool UX in the Age of Generative AI",
            "pub_date": "2024-06-21T14:00:00.000Z",
            "duration": "00:37:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "generative ai",
              "coding"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/developer-tool-ux-in-the-age-of-generative-ai-ylZ7o5cj",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/c5c6aeea-3dee-4b29-a5d9-13fd84410a6e/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=c5c6aeea-3dee-4b29-a5d9-13fd84410a6e&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d850ad98-40bf-4658-b7b5-fb49cfc20231",
            "index": 87,
            "title": "Building Production Workflows for AI Applications",
            "pub_date": "2024-06-14T19:25:45.000Z",
            "duration": "00:43:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "generative ai",
              "agents",
              "gpu"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/building-production-workflows-for-ai-applications-mw_yqRkR",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/9e405d17-1a79-407d-a334-6cce39d47fdc/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=9e405d17-1a79-407d-a334-6cce39d47fdc&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "525a4e61-f7cd-4a77-b216-ce6c6bc1413a",
            "index": 88,
            "title": "The Future of Image Models Is Multimodal",
            "pub_date": "2024-06-07T16:00:00.000Z",
            "duration": "00:37:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training",
              "multimodal"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/the-future-of-image-models-is-multimodal-gSij1jNf",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/506819d3-eb50-4544-b3fd-ee38a8a5b919/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=506819d3-eb50-4544-b3fd-ee38a8a5b919&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98a31230-a5cc-43b4-b48e-bedbd786a44c",
            "index": 89,
            "title": "ARCHIVE: Open Models (with Arthur Mensch) and Video Models (with Stefano Ermon)",
            "pub_date": "2024-05-24T14:00:00.000Z",
            "duration": "01:05:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "large language model",
              "openai",
              "mistral",
              "safety"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/archive-open-models-with-arthur-mensch-and-video-models-with-stefano-ermon-Gyvsu16j",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/834172e2-0d2e-429b-8a96-0238fce82346/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=834172e2-0d2e-429b-8a96-0238fce82346&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5bb00edf-4622-4978-afec-5818e00e5739",
            "index": 90,
            "title": "Open Models and Maturation: Assessing the Generative AI Market",
            "pub_date": "2024-05-17T14:00:00.000Z",
            "duration": "00:40:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/open-models-and-maturation-assessing-the-generative-ai-market-DvN9dXg6",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/bdce7e44-2090-45e2-91e5-e7e5fee5c081/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=bdce7e44-2090-45e2-91e5-e7e5fee5c081&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a92a5fb5-96e5-4522-a530-0f53e56724e8",
            "index": 91,
            "title": "Security Founders Talk Shop About Generative AI",
            "pub_date": "2024-05-15T14:00:00.000Z",
            "duration": "00:22:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "large language model",
              "generative ai",
              "inference"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/security-founders-talk-shop-about-generative-ai-JeSoaIOH",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/3cfec823-1c99-4b68-afe1-224583ff1ec8/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=3cfec823-1c99-4b68-afe1-224583ff1ec8&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2d2d73c9-189a-44d2-85dd-c55ecf5c729a",
            "index": 92,
            "title": "How to Think About Foundation Models for Cybersecurity",
            "pub_date": "2024-05-10T14:00:00.000Z",
            "duration": "00:37:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/how-to-think-about-foundation-models-for-cybersecurity-MOVCREQh",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/cbcad1cc-5698-4370-9283-bc87743697a2/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=cbcad1cc-5698-4370-9283-bc87743697a2&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "94a44d54-1757-4d9b-8acc-33023955c1cd",
            "index": 93,
            "title": "Securing the Software Supply Chain with LLMs",
            "pub_date": "2024-05-03T14:00:00.000Z",
            "duration": "00:38:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/securing-the-software-supply-chain-with-llms-3552jvU_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/016a8ebd-f786-4d9c-93e6-3a458bfc816c/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=016a8ebd-f786-4d9c-93e6-3a458bfc816c&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17ff6959-c9b1-4c9e-9121-765483f4ffb3",
            "index": 94,
            "title": "ARCHIVE: GPT-3 Hype",
            "pub_date": "2024-05-01T14:00:00.000Z",
            "duration": "00:33:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "openai",
              "multimodal"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/archive-gpt-3-hype-KhECv3pm",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/bf6c7ec6-5533-4b64-a11a-b236d4afce14/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=bf6c7ec6-5533-4b64-a11a-b236d4afce14&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "452b487a-b980-45ae-82aa-403bccfb24c9",
            "index": 95,
            "title": "Vector Databases and the Power of RAG",
            "pub_date": "2024-04-26T14:00:00.000Z",
            "duration": "00:36:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "rag",
              "retrieval"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/vector-databases-and-the-power-of-rag-5cAv48Af",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/3248c4c4-1e56-4cb9-89f2-fe0f6da51544/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=3248c4c4-1e56-4cb9-89f2-fe0f6da51544&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9d7fc21d-d3e2-44b1-854e-40e8cf441390",
            "index": 96,
            "title": "Remaking the UI for AI",
            "pub_date": "2024-04-19T14:00:00.000Z",
            "duration": "00:38:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "nvidia",
              "chips",
              "inference",
              "training"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/remaking-the-ui-for-ai-fjtNyoWs",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/d24e8f3e-f5f6-4b34-a6bf-ec17b7223d5a/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=d24e8f3e-f5f6-4b34-a6bf-ec17b7223d5a&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "531fe7a0-94a9-46b1-8dc0-0d73160516da",
            "index": 97,
            "title": "Making the Most of Open Source in AI",
            "pub_date": "2024-04-12T14:00:00.000Z",
            "duration": "00:40:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/making-the-most-of-open-source-in-ai-tGGTz6m_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/15933aa3-2155-40dd-988f-205fe19ac008/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=15933aa3-2155-40dd-988f-205fe19ac008&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "403ed693-4b94-4102-81b3-ae0540ec29c1",
            "index": 98,
            "title": "Scoping the Enterprise LLM Market",
            "pub_date": "2024-04-12T14:00:00.000Z",
            "duration": "00:44:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "generative ai",
              "chip",
              "chips"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/scoping-the-enterprise-llm-market-9d41HJPD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/f7b6d81a-5e78-4c8c-8f0b-3aeef459130e/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=f7b6d81a-5e78-4c8c-8f0b-3aeef459130e&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f1b90b59-6039-4650-bec6-ca2149eaea9a",
            "index": 99,
            "title": "Welcome to the AI + a16z podcast",
            "pub_date": "2024-04-08T19:17:33.000Z",
            "duration": "00:02:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://ai-a16z.simplecast.com/episodes/welcome-to-the-ai-a16z-podcast-XkLsxrUq",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/112866f3-1a50-4a8d-b12e-850b73e71b33/episodes/c2c34a28-964e-4572-a29e-33c43bfe78f6/audio/128/default.mp3?aid=rss_feed&awCollectionId=112866f3-1a50-4a8d-b12e-850b73e71b33&awEpisodeId=c2c34a28-964e-4572-a29e-33c43bfe78f6&feed=Hb_IuXOo",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "dwarkesh",
        "title": "Dwarkesh Podcast",
        "feed_title": "Dwarkesh Podcast",
        "priority": "P0",
        "selection_mode": "keyword",
        "focus": [
          "frontier AI",
          "AGI",
          "scaling",
          "AI economics",
          "policy"
        ],
        "feed_url": "https://api.substack.com/feed/podcast/69345.rss",
        "source_url": "https://api.substack.com/feed/podcast/69345.rss",
        "detail_path": "/podcasts/dwarkesh/",
        "episode_count": 128,
        "selected_episode_count": 92,
        "latest_episode_title": "Alex Imas and Phil Trammell – What remains scarce after AGI?",
        "latest_pub_date": "2026-06-04T16:14:49.000Z",
        "latest_page_url": "https://www.dwarkesh.com/p/alex-imas-phil-trammell",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "substack:post:200613353",
            "index": 1,
            "title": "Alex Imas and Phil Trammell – What remains scarce after AGI?",
            "pub_date": "2026-06-04T16:14:49.000Z",
            "duration": "4568",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "gemini",
              "cursor",
              "multimodal"
            ],
            "page_url": "https://www.dwarkesh.com/p/alex-imas-phil-trammell",
            "audio_url": "https://api.substack.com/feed/podcast/200613353/da820d19eca949d5e111f641ab5e378d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:198847047",
            "index": 2,
            "title": "Reiner Pope – Chip design from the bottom up",
            "pub_date": "2026-05-22T15:38:34.000Z",
            "duration": "4830",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor",
              "gpu",
              "chip",
              "chips",
              "training",
              "coding"
            ],
            "page_url": "https://www.dwarkesh.com/p/reiner-pope-2",
            "audio_url": "https://api.substack.com/feed/podcast/198847047/4554a355fabc7d08073d273fc9f192d4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:197852876",
            "index": 3,
            "title": "Eric Jang – Building AlphaGo from scratch",
            "pub_date": "2026-05-15T16:04:58.000Z",
            "duration": "9449",
            "duration_label": "2h 37m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "cursor",
              "training"
            ],
            "page_url": "https://www.dwarkesh.com/p/eric-jang",
            "audio_url": "https://api.substack.com/feed/podcast/197852876/5642f97b323e24b00efd0d89ace15d58.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 396,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:196892360",
            "index": 4,
            "title": "David Reich – Why the Bronze Age was an inflection point in human evolution",
            "pub_date": "2026-05-08T16:38:22.000Z",
            "duration": "8000",
            "duration_label": "2h 13m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "cursor",
              "coding"
            ],
            "page_url": "https://www.dwarkesh.com/p/david-reich-2",
            "audio_url": "https://api.substack.com/feed/podcast/196892360/60c5fc38586fe814f5fd91f0895a59c1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 318,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:195859978",
            "index": 5,
            "title": "Reiner Pope – The math behind how LLMs are trained and served",
            "pub_date": "2026-04-29T17:07:03.000Z",
            "duration": "8030",
            "duration_label": "2h 13m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "cursor",
              "gpu",
              "chip"
            ],
            "page_url": "https://www.dwarkesh.com/p/reiner-pope",
            "audio_url": "https://api.substack.com/feed/podcast/195859978/d0ec0edfef14862f0fc2e095a1ee64b0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 423,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:194289889",
            "index": 6,
            "title": "Jensen Huang – TPU competition, why we should sell chips to China, & Nvidia’s supply chain moat",
            "pub_date": "2026-04-15T15:45:23.000Z",
            "duration": "6192",
            "duration_label": "1h 43m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "cursor",
              "nvidia",
              "gpu",
              "chip"
            ],
            "page_url": "https://www.dwarkesh.com/p/jensen-huang",
            "audio_url": "https://api.substack.com/feed/podcast/194289889/4ad9f4582dd59f13b5a5cc452125b1f6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 287,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:193466212",
            "index": 7,
            "title": "Michael Nielsen – How science actually progresses",
            "pub_date": "2026-04-07T15:49:28.000Z",
            "duration": "7383",
            "duration_label": "2h 3m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "nvidia",
              "gpu",
              "training",
              "safety"
            ],
            "page_url": "https://www.dwarkesh.com/p/michael-nielsen",
            "audio_url": "https://api.substack.com/feed/podcast/193466212/e5343bce6cf37efafa778abc5594aa67.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 267,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:191582481",
            "index": 8,
            "title": "Terence Tao – Kepler, Newton, and the true nature of mathematical discovery",
            "pub_date": "2026-03-20T16:00:55.000Z",
            "duration": "5024",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "evals"
            ],
            "page_url": "https://www.dwarkesh.com/p/terence-tao",
            "audio_url": "https://api.substack.com/feed/podcast/191582481/09bfc20781f3d248e53c5f3350823514.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 187,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:190839917",
            "index": 9,
            "title": "Dylan Patel — Deep dive on the 3 big bottlenecks to scaling AI compute",
            "pub_date": "2026-03-13T16:00:42.000Z",
            "duration": "9044",
            "duration_label": "2h 30m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "nvidia"
            ],
            "page_url": "https://www.dwarkesh.com/p/dylan-patel",
            "audio_url": "https://api.substack.com/feed/podcast/190839917/e3c75a06762af10f374661e8af1d1af6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 430,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:190633588",
            "index": 10,
            "title": "The most important question nobody's asking about AI",
            "pub_date": "2026-03-11T18:55:20.000Z",
            "duration": "1478",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/dow-anthropic",
            "audio_url": "https://api.substack.com/feed/podcast/190633588/94a1857634f9ebd3857e20d95893ec75.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_caption",
              "transcript_record_count": 722,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:190118311",
            "index": 11,
            "title": "Why Leonardo was a saboteur, Gutenberg went broke, and Florence was weird – Ada Palmer",
            "pub_date": "2026-03-06T17:14:20.000Z",
            "duration": "7339",
            "duration_label": "2h 2m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "agent",
              "agents"
            ],
            "page_url": "https://www.dwarkesh.com/p/ada-palmer",
            "audio_url": "https://api.substack.com/feed/podcast/190118311/8c3433af58d7b7ad7ee60c28c569017a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 315,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:187852154",
            "index": 12,
            "title": "Dario Amodei — \"We are near the end of the exponential\"",
            "pub_date": "2026-02-13T16:46:36.000Z",
            "duration": "8540",
            "duration_label": "2h 22m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "anthropic",
              "datacenter",
              "data center"
            ],
            "page_url": "https://www.dwarkesh.com/p/dario-amodei-2",
            "audio_url": "https://api.substack.com/feed/podcast/187852154/cecdbe38125e2786cbfebe31dd083d4f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 354,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:186967347",
            "index": 13,
            "title": "Elon Musk — \"In 36 months, the cheapest place to put AI will be space”",
            "pub_date": "2026-02-05T16:45:08.000Z",
            "duration": "10185",
            "duration_label": "2h 49m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "grok",
              "alignment",
              "robotics"
            ],
            "page_url": "https://www.dwarkesh.com/p/elon-musk",
            "audio_url": "https://api.substack.com/feed/podcast/186967347/7e1421b0bbe8243af32f70dda75bef63.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 726,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:182960540",
            "index": 14,
            "title": "Adam Marblestone — AI is missing something fundamental about the brain",
            "pub_date": "2025-12-30T17:07:17.000Z",
            "duration": "6593",
            "duration_label": "1h 49m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "deepmind",
              "gemini",
              "inference"
            ],
            "page_url": "https://www.dwarkesh.com/p/adam-marblestone",
            "audio_url": "https://api.substack.com/feed/podcast/182960540/b1d297278a7f613027bddbaa7f0efcb7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 271,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:182443852",
            "index": 15,
            "title": "Thoughts on AI progress (Dec 2025)",
            "pub_date": "2025-12-23T20:24:48.000Z",
            "duration": "748",
            "duration_label": "12m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/thoughts-on-ai-progress-dec-2025-video",
            "audio_url": "https://api.substack.com/feed/podcast/182443852/96b56036528bac04a698ae3a0a775b6c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_caption",
              "transcript_record_count": 377,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:182083324",
            "index": 16,
            "title": "Sarah Paine — Why Russia Lost the Cold War",
            "pub_date": "2025-12-19T17:41:19.000Z",
            "duration": "6895",
            "duration_label": "1h 54m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "training",
              "coding"
            ],
            "page_url": "https://www.dwarkesh.com/p/sarah-paine-cold-war",
            "audio_url": "https://api.substack.com/feed/podcast/182083324/a9228654256b25131ba83e82fb0db5da.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 228,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:179924094",
            "index": 17,
            "title": "Ilya Sutskever — We're moving from the age of scaling to the age of research",
            "pub_date": "2025-11-25T17:04:02.000Z",
            "duration": "5763",
            "duration_label": "1h 36m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "gemini",
              "training"
            ],
            "page_url": "https://www.dwarkesh.com/p/ilya-sutskever-2",
            "audio_url": "https://api.substack.com/feed/podcast/179924094/8fff4c8da77eff5a44fad5d13ae599e2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 224,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:178688356",
            "index": 18,
            "title": "Satya Nadella — How Microsoft is preparing for AGI",
            "pub_date": "2025-11-12T17:03:08.000Z",
            "duration": "5267",
            "duration_label": "1h 27m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "openai",
              "chip",
              "datacenter"
            ],
            "page_url": "https://www.dwarkesh.com/p/satya-nadella-2",
            "audio_url": "https://api.substack.com/feed/podcast/178688356/17d73f3abbe37253ebebe0113754e6d5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 214,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:177641179",
            "index": 19,
            "title": "Sarah Paine — How Russia sabotaged China's rise",
            "pub_date": "2025-10-31T15:01:37.000Z",
            "duration": "5436",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://www.dwarkesh.com/p/sarah-paine-russo-chinese",
            "audio_url": "https://api.substack.com/feed/podcast/177641179/7438c63434262b0f316c17d347d058c1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 194,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:176425744",
            "index": 20,
            "title": "Andrej Karpathy — AGI is still a decade away",
            "pub_date": "2025-10-17T16:54:33.000Z",
            "duration": "8719",
            "duration_label": "2h 25m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "gemini",
              "google ai",
              "training"
            ],
            "page_url": "https://www.dwarkesh.com/p/andrej-karpathy",
            "audio_url": "https://api.substack.com/feed/podcast/176425744/3127b612a1604474d2b28ab4e9b658f4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 397,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:175802370",
            "index": 21,
            "title": "Nick Lane – Life as we know it is chemically inevitable",
            "pub_date": "2025-10-10T15:29:40.000Z",
            "duration": "4808",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "cursor"
            ],
            "page_url": "https://www.dwarkesh.com/p/nick-lane",
            "audio_url": "https://api.substack.com/feed/podcast/175802370/c028b32e59c5aa77bd9373146025979b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 201,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:175283310",
            "index": 22,
            "title": "Some thoughts on the Sutton interview",
            "pub_date": "2025-10-04T17:45:00.000Z",
            "duration": "699",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/thoughts-on-sutton",
            "audio_url": "https://api.substack.com/feed/podcast/175283310/64bc9b781df688895e748ab6d0d0554b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:174609513",
            "index": 23,
            "title": "Richard Sutton – Father of RL thinks LLMs are a dead end",
            "pub_date": "2025-09-26T14:48:59.000Z",
            "duration": "3982",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "gemini",
              "training"
            ],
            "page_url": "https://www.dwarkesh.com/p/richard-sutton",
            "audio_url": "https://api.substack.com/feed/podcast/174609513/9ef910c6173bfc95dcec01b4b5ff7201.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 182,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:173427890",
            "index": 24,
            "title": "Fully autonomous robots are much closer than you think – Sergey Levine",
            "pub_date": "2025-09-12T15:03:02.000Z",
            "duration": "5308",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "training",
              "robotics"
            ],
            "page_url": "https://www.dwarkesh.com/p/sergey-levine",
            "audio_url": "https://api.substack.com/feed/podcast/173427890/41edf014292b368eebd99d78a2882c3c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 213,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:172873013",
            "index": 25,
            "title": "How Hitler almost starved Britain – Sarah Paine",
            "pub_date": "2025-09-05T15:05:14.000Z",
            "duration": "5717",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "agent",
              "agents",
              "robotics",
              "coding"
            ],
            "page_url": "https://www.dwarkesh.com/p/sarah-paine-ww2",
            "audio_url": "https://api.substack.com/feed/podcast/172873013/3cbe3fc31893cd5a94731db265b3d784.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 183,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:171561010",
            "index": 26,
            "title": "Evolution designed us to die fast; we can change that — Jacob Kimmel",
            "pub_date": "2025-08-21T16:29:18.000Z",
            "duration": "6280",
            "duration_label": "1h 44m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "gemini",
              "gpu",
              "coding"
            ],
            "page_url": "https://www.dwarkesh.com/p/jacob-kimmel",
            "audio_url": "https://api.substack.com/feed/podcast/171561010/726c799e23e6cf9e4dbd687a63df92f0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 299,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:171017457",
            "index": 27,
            "title": "China is killing the US on energy. Does that mean they’ll win AGI? — Casey Handmer",
            "pub_date": "2025-08-15T14:54:54.000Z",
            "duration": "4102",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "cursor"
            ],
            "page_url": "https://www.dwarkesh.com/p/casey-handmer",
            "audio_url": "https://api.substack.com/feed/podcast/171017457/4991ca408c5cf1f5e560e4959af26f8b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 301,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:170334851",
            "index": 28,
            "title": "Artificial meat is harder than artificial intelligence — Lewis Bollard",
            "pub_date": "2025-08-07T15:58:01.000Z",
            "duration": "4085",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://www.dwarkesh.com/p/lewis-bollard",
            "audio_url": "https://api.substack.com/feed/podcast/170334851/63948709cf48a0755de2fe85f3c99f22.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 209,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:169236978",
            "index": 29,
            "title": "Sarah Paine — How Imperial Japan defeated Tsarist Russia & Qing China",
            "pub_date": "2025-07-25T17:06:52.000Z",
            "duration": "6937",
            "duration_label": "1h 55m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "google ai"
            ],
            "page_url": "https://www.dwarkesh.com/p/sarah-paine-east-asia",
            "audio_url": "https://api.substack.com/feed/podcast/169236978/6466a0a3c43a7b200a6652b1372aec38.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 241,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:167987999",
            "index": 30,
            "title": "Stephen Kotkin — How Stalin became the most powerful dictator in history",
            "pub_date": "2025-07-10T16:11:28.000Z",
            "duration": "7961",
            "duration_label": "2h 12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/stephen-kotkin",
            "audio_url": "https://api.substack.com/feed/podcast/167987999/340589cef7974cbc3e3e5607de57a6bc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:167473378",
            "index": 31,
            "title": "Why I don’t think AGI is right around the corner",
            "pub_date": "2025-07-03T21:19:05.000Z",
            "duration": "841",
            "duration_label": "14m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://www.dwarkesh.com/p/why-i-dont-think-agi-is-right-around",
            "audio_url": "https://api.substack.com/feed/podcast/167473378/f0f9396353d538833aa6e64a05e4ad0b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_caption",
              "transcript_record_count": 449,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:166888604",
            "index": 32,
            "title": "A billion years of evolution in a single afternoon — George Church",
            "pub_date": "2025-06-26T15:55:45.000Z",
            "duration": "5625",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "gemini"
            ],
            "page_url": "https://www.dwarkesh.com/p/george-church",
            "audio_url": "https://api.substack.com/feed/podcast/166888604/5a254acbc40ab34721da104898bd356b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 237,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:166313955",
            "index": 33,
            "title": "Why China's manufacturing economy is dominating — Arthur Kroeber",
            "pub_date": "2025-06-19T16:03:16.000Z",
            "duration": "8803",
            "duration_label": "2h 26m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "perplexity",
              "cursor",
              "safety"
            ],
            "page_url": "https://www.dwarkesh.com/p/arthur-kroeber",
            "audio_url": "https://api.substack.com/feed/podcast/166313955/a4bce04767cd0e7a53bdf85d3967e668.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 299,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:165778647",
            "index": 34,
            "title": "\"China is digging out of a crisis. And America’s luck is wearing thin.\" — Ken Rogoff",
            "pub_date": "2025-06-12T16:32:58.000Z",
            "duration": "5764",
            "duration_label": "1h 36m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "gemini"
            ],
            "page_url": "https://www.dwarkesh.com/p/ken-rogoff",
            "audio_url": "https://api.substack.com/feed/podcast/165778647/828be3bc823e49e6f9cca2f33be4427a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 260,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:164717983",
            "index": 35,
            "title": "Xi Jinping’s paranoid approach to AGI, debt crisis, & Politburo politics — Victor Shih",
            "pub_date": "2025-05-29T15:47:29.000Z",
            "duration": "5349",
            "duration_label": "1h 29m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://www.dwarkesh.com/p/victor-shih",
            "audio_url": "https://api.substack.com/feed/podcast/164717983/17fe6f2977ba82db3a321e40cf8328e1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 291,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:164189186",
            "index": 36,
            "title": "Is RL + LLMs enough for AGI? — Sholto Douglas & Trenton Bricken",
            "pub_date": "2025-05-22T20:53:36.000Z",
            "duration": "8641",
            "duration_label": "2h 24m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "openai",
              "anthropic",
              "cursor",
              "replit"
            ],
            "page_url": "https://www.dwarkesh.com/p/sholto-trenton-2",
            "audio_url": "https://api.substack.com/feed/podcast/164189186/f8b9e3b318b615e15a807aae787fce46.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 572,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:162651762",
            "index": 37,
            "title": "What will automated firms look like?",
            "pub_date": "2025-05-01T23:00:27.000Z",
            "duration": "618",
            "duration_label": "10m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "https://www.dwarkesh.com/p/ai-firms-narration",
            "audio_url": "https://api.substack.com/feed/podcast/162651762/c485711d53ca0e0a1e4234e7860d865e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_caption",
              "transcript_record_count": 222,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:162392947",
            "index": 38,
            "title": "Mark Zuckerberg — AI will write most Meta code in 18 months",
            "pub_date": "2025-04-29T15:46:54.000Z",
            "duration": "4503",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "llama",
              "perplexity",
              "cursor",
              "nvidia"
            ],
            "page_url": "https://www.dwarkesh.com/p/mark-zuckerberg-2",
            "audio_url": "https://api.substack.com/feed/podcast/162392947/a5f867e1c642abdc7992727112751d56.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 195,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:162037097",
            "index": 39,
            "title": "Why Rome actually fell: plagues, slavery, & ice age — Kyle Harper",
            "pub_date": "2025-04-24T15:53:57.000Z",
            "duration": "5008",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "perplexity",
              "cursor",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.dwarkesh.com/p/kyle-harper",
            "audio_url": "https://api.substack.com/feed/podcast/162037097/3b11ee7cc0e4faa7c9f826e9ff6a2b4c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 170,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:161532341",
            "index": 40,
            "title": "AGI is still 30 years away — Ege Erdil & Tamay Besiroglu",
            "pub_date": "2025-04-17T16:06:32.000Z",
            "duration": "11308",
            "duration_label": "3h 8m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "gemini",
              "training",
              "reasoning",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/ege-tamay",
            "audio_url": "https://api.substack.com/feed/podcast/161532341/f6ffe3df67e38cb6cf4f90907ca0205a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 13,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:160495909",
            "index": 41,
            "title": "AI 2027: month-by-month model of intelligence explosion — Scott Alexander & Daniel Kokotajlo",
            "pub_date": "2025-04-03T15:05:11.000Z",
            "duration": "11066",
            "duration_label": "3h 4m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "perplexity",
              "cursor",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.dwarkesh.com/p/scott-daniel",
            "audio_url": "https://api.substack.com/feed/podcast/160495909/bdd3acc7cd18a69c68ad250654009252.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 473,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:159824609",
            "index": 42,
            "title": "AMA: career advice given AGI, how I research ft. Sholto & Trenton",
            "pub_date": "2025-03-25T15:25:59.000Z",
            "duration": "2973",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://www.dwarkesh.com/p/scaling-ama",
            "audio_url": "https://api.substack.com/feed/podcast/159824609/0bac935902421be8d52c90f379040d82.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 497,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:158922207",
            "index": 43,
            "title": "Joseph Henrich — Humans defeated smarter species with cultural evolution",
            "pub_date": "2025-03-12T16:40:31.000Z",
            "duration": "6779",
            "duration_label": "1h 52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "deepmind",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.dwarkesh.com/p/joseph-henrich",
            "audio_url": "https://api.substack.com/feed/podcast/158922207/b23d821cdff073ca1e853d6e093f1507.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 274,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:158452931",
            "index": 44,
            "title": "Notes on China",
            "pub_date": "2025-03-05T18:12:42.000Z",
            "duration": "1171",
            "duration_label": "19m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/notes-on-china-narration",
            "audio_url": "https://api.substack.com/feed/podcast/158452931/f1c5d59174a7dae76593e7eca4f7cf69.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_caption",
              "transcript_record_count": 487,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:157454089",
            "index": 45,
            "title": "Satya Nadella — Microsoft’s AGI plan & quantum breakthrough",
            "pub_date": "2025-02-19T15:51:23.000Z",
            "duration": "4570",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "deepmind",
              "training",
              "reasoning",
              "safety"
            ],
            "page_url": "https://www.dwarkesh.com/p/satya-nadella",
            "audio_url": "https://api.substack.com/feed/podcast/157454089/ad0bede01d7521be271998fd85df4743.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 241,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:157004096",
            "index": 46,
            "title": "Jeff Dean & Noam Shazeer — 25 years at Google: from PageRank to AGI",
            "pub_date": "2025-02-12T19:56:43.000Z",
            "duration": "8083",
            "duration_label": "2h 14m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "openai",
              "deepmind",
              "gemini",
              "chip"
            ],
            "page_url": "https://www.dwarkesh.com/p/jeff-dean-and-noam-shazeer",
            "audio_url": "https://api.substack.com/feed/podcast/157004096/bf67f6f7bf8a80249342e029f1721628.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 479,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:156094021",
            "index": 47,
            "title": "Sarah Paine — How Mao conquered China (lecture & interview)",
            "pub_date": "2025-01-30T14:45:25.000Z",
            "duration": "6494",
            "duration_label": "1h 48m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama"
            ],
            "page_url": "https://www.dwarkesh.com/p/sarah-paine-china",
            "audio_url": "https://api.substack.com/feed/podcast/156094021/cf2b3277bb7f12a75bfc02d7b747ba01.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 456,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:155541767",
            "index": 48,
            "title": "Sarah Paine — Why Japan lost WWII (lecture & interview)",
            "pub_date": "2025-01-23T16:43:16.000Z",
            "duration": "7693",
            "duration_label": "2h 8m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama"
            ],
            "page_url": "https://www.dwarkesh.com/p/sarah-paine-japan",
            "audio_url": "https://api.substack.com/feed/podcast/155541767/ab3361fa8d130990b1d934aeefbc9855.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 482,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:154955657",
            "index": 49,
            "title": "Sarah Paine — The war for India (lecture & interview)",
            "pub_date": "2025-01-16T20:12:01.000Z",
            "duration": "7978",
            "duration_label": "2h 12m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llama",
              "training"
            ],
            "page_url": "https://www.dwarkesh.com/p/sarah-paine-india",
            "audio_url": "https://api.substack.com/feed/podcast/154955657/55cd353db80178d17f4128431680ce22.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 214,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:154483840",
            "index": 50,
            "title": "Tyler Cowen — The #1 bottleneck to AI progress is humans",
            "pub_date": "2025-01-09T16:25:21.000Z",
            "duration": "3585",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/tyler-cowen-4",
            "audio_url": "https://api.substack.com/feed/podcast/154483840/6e088a229aae40b1d8cbb681d01758be.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 297,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:153641659",
            "index": 51,
            "title": "Adam Brown — Bubble universes, space elevators, & AdS/CFT",
            "pub_date": "2024-12-26T16:29:59.000Z",
            "duration": "9817",
            "duration_label": "2h 43m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "anthropic",
              "deepmind",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.dwarkesh.com/p/adam-brown",
            "audio_url": "https://api.substack.com/feed/podcast/153641659/253d82d37d72d74bd975bcbfef0aaa96.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 578,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:151435243",
            "index": 52,
            "title": "Gwern — Anonymous writer who predicted AI trajectory on $12K/year salary",
            "pub_date": "2024-11-13T18:42:28.000Z",
            "duration": "5803",
            "duration_label": "1h 36m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "llm",
              "openai",
              "anthropic",
              "gemini"
            ],
            "page_url": "https://www.dwarkesh.com/p/gwern-branwen",
            "audio_url": "https://api.substack.com/feed/podcast/151435243/ba9f31a8bd619e80ecfce8d8c695788f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 317,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:149705443",
            "index": 53,
            "title": "@Asianometry & Dylan Patel — How the semiconductor industry actually works",
            "pub_date": "2024-10-02T14:19:08.000Z",
            "duration": "7797",
            "duration_label": "2h 9m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "anthropic",
              "chip",
              "datacenter"
            ],
            "page_url": "https://www.dwarkesh.com/p/dylan-jon",
            "audio_url": "https://api.substack.com/feed/podcast/149705443/382c5a96958ff9321fa6e64c1904d9b6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 564,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:149019792",
            "index": 54,
            "title": "Daniel Yergin — Oil destroyed Hitler, fracking destroyed Putin",
            "pub_date": "2024-09-18T14:02:31.000Z",
            "duration": "5257",
            "duration_label": "1h 27m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://www.dwarkesh.com/p/daniel-yergin",
            "audio_url": "https://api.substack.com/feed/podcast/149019792/d8e4cd14fc908c29c6d42902ddc5c1bf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 199,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:148257189",
            "index": 55,
            "title": "David Reich — How one small tribe conquered the world 70,000 years ago",
            "pub_date": "2024-08-29T15:38:44.000Z",
            "duration": "6966",
            "duration_label": "1h 56m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.dwarkesh.com/p/david-reich",
            "audio_url": "https://api.substack.com/feed/podcast/148257189/332d1a034da2e416fa79d1a7b293548a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 232,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:148002360",
            "index": 56,
            "title": "Joe Carlsmith — Preventing an AI takeover",
            "pub_date": "2024-08-22T15:09:45.000Z",
            "duration": "9035",
            "duration_label": "2h 30m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "anthropic",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/joe-carlsmith",
            "audio_url": "https://api.substack.com/feed/podcast/148002360/a8c91e06d3fbd60a244ad9db6c60cd54.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_caption",
              "transcript_record_count": 3699,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:146935176",
            "index": 57,
            "title": "Patrick McKenzie — Money laundering, big tech censorship, SBF & Japan",
            "pub_date": "2024-07-24T13:57:59.000Z",
            "duration": "7294",
            "duration_label": "2h 1m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.dwarkesh.com/p/patrick-mckenzie",
            "audio_url": "https://api.substack.com/feed/podcast/146935176/802d9285d725af5d7e1b593c30d9fb94.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 367,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:146005940",
            "index": 58,
            "title": "Tony Blair — Why political leaders keep failing at major change",
            "pub_date": "2024-06-26T13:41:20.000Z",
            "duration": "3172",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "automation"
            ],
            "page_url": "https://www.dwarkesh.com/p/tony-blair",
            "audio_url": "https://api.substack.com/feed/podcast/146005940/8635bcf36687b7730033a69c6b9c7c75.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 138,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:145543832",
            "index": 59,
            "title": "Francois Chollet — Why the biggest AI models can't solve simple puzzles",
            "pub_date": "2024-06-11T17:03:59.000Z",
            "duration": "5633",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://www.dwarkesh.com/p/francois-chollet",
            "audio_url": "https://api.substack.com/feed/podcast/145543832/63ab0e61493cb9bf83fa6531475beb4f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 323,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:145136502",
            "index": 60,
            "title": "Leopold Aschenbrenner — 2027 AGI, China/US super-intelligence race, & the return of history",
            "pub_date": "2024-06-04T15:39:37.000Z",
            "duration": "16278",
            "duration_label": "4h 31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/leopold-aschenbrenner",
            "audio_url": "https://api.substack.com/feed/podcast/145136502/b6609c35f40275bdb3dcaa8ac8dc1053.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 1006,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:144657191",
            "index": 61,
            "title": "John Schulman (OpenAI Cofounder) — Reasoning, RLHF, & plan for 2027 AGI",
            "pub_date": "2024-05-15T13:57:36.000Z",
            "duration": "5726",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "openai",
              "training",
              "reasoning"
            ],
            "page_url": "https://www.dwarkesh.com/p/john-schulman",
            "audio_url": "https://api.substack.com/feed/podcast/144657191/554d2f480b3484beb252af891fec57e6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 224,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:143705335",
            "index": 62,
            "title": "Mark Zuckerberg — Llama 3, $10B models, Caesar Augustus, & 1 GW datacenters",
            "pub_date": "2024-04-18T15:49:17.000Z",
            "duration": "4674",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "anthropic",
              "llama",
              "multimodal",
              "coding"
            ],
            "page_url": "https://www.dwarkesh.com/p/mark-zuckerberg",
            "audio_url": "https://api.substack.com/feed/podcast/143705335/f974048d73ef1df4da82b4d919747af3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 150,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:143040987",
            "index": 63,
            "title": "Sholto Douglas & Trenton Bricken — How LLMs actually think",
            "pub_date": "2024-03-28T15:10:09.000Z",
            "duration": "11541",
            "duration_label": "3h 12m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning"
            ],
            "page_url": "https://www.dwarkesh.com/p/sholto-douglas-trenton-bricken",
            "audio_url": "https://api.substack.com/feed/podcast/143040987/926b16a86b7e2d6bca66a6eaef8fbbde.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 613,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:142112869",
            "index": 64,
            "title": "Demis Hassabis — Scaling, superhuman AIs, AlphaZero atop LLMs, AlphaFold",
            "pub_date": "2024-02-28T15:49:28.000Z",
            "duration": "3694",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "deepmind",
              "gemini",
              "training",
              "alignment",
              "safety",
              "multimodal"
            ],
            "page_url": "https://www.dwarkesh.com/p/demis-hassabis",
            "audio_url": "https://api.substack.com/feed/podcast/142112869/4f69c0aff2bcca246a175d306712c1cc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 95,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:141895788",
            "index": 65,
            "title": "Patrick Collison — Why Silicon Valley's most talented should leave",
            "pub_date": "2024-02-21T15:25:58.000Z",
            "duration": "6887",
            "duration_label": "1h 54m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://www.dwarkesh.com/p/patrick-collison",
            "audio_url": "https://api.substack.com/feed/podcast/141895788/6542097c3ffa97e31d24255ef5cac7e0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 217,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:141221777",
            "index": 66,
            "title": "Tyler Cowen — Hayek, Keynes, & Smith on AI, animal spirits, anarchy, & growth",
            "pub_date": "2024-01-31T15:00:00.000Z",
            "duration": "6142",
            "duration_label": "1h 42m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/tyler-cowen-3",
            "audio_url": "https://api.substack.com/feed/podcast/141221777/ab775ec2bb85dd32a949e02f61f9358a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 326,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:140840711",
            "index": 67,
            "title": "Lessons from The Years of Lyndon Johnson by Robert Caro [Narration]",
            "pub_date": "2024-01-23T15:00:00.000Z",
            "duration": "2192",
            "duration_label": "36m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/lyndon-johnson-narration",
            "audio_url": "https://api.substack.com/feed/podcast/140840711/3a27face257f28dbbf9e6778f21408c1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:140840266",
            "index": 68,
            "title": "Will scaling work? [Narration]",
            "pub_date": "2024-01-19T15:25:56.000Z",
            "duration": "1543",
            "duration_label": "25m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/will-scaling-work-narration",
            "audio_url": "https://api.substack.com/feed/podcast/140840266/94497e717210b836edd1fc0461edd95a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:139258732",
            "index": 69,
            "title": "Jung Chang (Wild Swans author) — Living through history's largest man-made famine",
            "pub_date": "2023-11-29T15:01:22.000Z",
            "duration": "5475",
            "duration_label": "1h 31m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/jung-chang",
            "audio_url": "https://api.substack.com/feed/podcast/139258732/f88e73bf0c3432b2323c9a914202e5ad.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:139067801",
            "index": 70,
            "title": "Andrew Roberts — Why Hitler lost WWII, Churchill as applied historian, & Napoleon as startup founder",
            "pub_date": "2023-11-22T15:06:19.000Z",
            "duration": "4729",
            "duration_label": "1h 18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/andrew-roberts",
            "audio_url": "https://api.substack.com/feed/podcast/139067801/807a8334be523ac832d5a82c99d189dd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:138879824",
            "index": 71,
            "title": "Dominic Cummings - COVID, Brexit, & Fixing Western Governance",
            "pub_date": "2023-11-15T15:14:34.000Z",
            "duration": "9253",
            "duration_label": "2h 34m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/dominic-cummings",
            "audio_url": "https://api.substack.com/feed/podcast/138879824/cb7094dfbe5651766480c0929f0cf7a5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 413,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:138448008",
            "index": 72,
            "title": "Paul Christiano — Preventing an AI takeover",
            "pub_date": "2023-10-31T13:56:24.000Z",
            "duration": "11221",
            "duration_label": "3h 7m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "nvidia",
              "alignment",
              "safety"
            ],
            "page_url": "https://www.dwarkesh.com/p/paul-christiano",
            "audio_url": "https://api.substack.com/feed/podcast/138448008/598c2ea7ddbe4fe5da5c646cde2c898f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 318,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:138292315",
            "index": 73,
            "title": "Shane Legg (DeepMind Founder) — 2028 AGI, superhuman alignment, new architectures",
            "pub_date": "2023-10-26T15:12:11.000Z",
            "duration": "2659",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "agi",
              "deepmind",
              "alignment",
              "safety"
            ],
            "page_url": "https://www.dwarkesh.com/p/shane-legg",
            "audio_url": "https://api.substack.com/feed/podcast/138292315/5d4f1295897e4d1e009a7add210ca576.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 126,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:137883930",
            "index": 74,
            "title": "Grant Sanderson (@3blue1brown) — Past, present, & future of mathematics",
            "pub_date": "2023-10-12T12:49:00.000Z",
            "duration": "5480",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://www.dwarkesh.com/p/grant-sanderson",
            "audio_url": "https://api.substack.com/feed/podcast/137883930/783986fa0502822bbfb1fa4aa418b849.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 267,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:137641992",
            "index": 75,
            "title": "Sarah C. M. Paine — Why dictators keep making the same fatal mistake",
            "pub_date": "2023-10-04T13:43:27.000Z",
            "duration": "8673",
            "duration_label": "2h 24m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/sarah-paine",
            "audio_url": "https://api.substack.com/feed/podcast/137641992/93da5db2ad653b2635fc6da19c6e1fcd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:135814349",
            "index": 76,
            "title": "Dario Amodei (Anthropic CEO) — The hidden pattern behind every AI breakthrough",
            "pub_date": "2023-08-08T13:40:07.000Z",
            "duration": "7123",
            "duration_label": "1h 58m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "training",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/dario-amodei",
            "audio_url": "https://api.substack.com/feed/podcast/135814349/b2eb329d905cd62c66e0a8a3367a745a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 513,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:134213434",
            "index": 77,
            "title": "Andy Matuschak — The reason most learning tools fail",
            "pub_date": "2023-07-12T13:12:00.000Z",
            "duration": "8560",
            "duration_label": "2h 22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/andy-matuschak",
            "audio_url": "https://api.substack.com/feed/podcast/134213434/463435c7e1f71b2fb8da7a138134566f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:130214147",
            "index": 78,
            "title": "Carl Shulman (Pt 2) — AI Takeover, bio & cyber attacks, detecting deception, & humanity's far future",
            "pub_date": "2023-06-26T15:07:38.000Z",
            "duration": "11227",
            "duration_label": "3h 7m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/carl-shulman-2",
            "audio_url": "https://api.substack.com/feed/podcast/130214147/b3950ae1004838abe1e7e876904acc3c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 181,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:128144047",
            "index": 79,
            "title": "Carl Shulman (Pt 1) — Intelligence explosion, primate evolution, robot doublings, & alignment",
            "pub_date": "2023-06-14T07:50:32.000Z",
            "duration": "9856",
            "duration_label": "2h 44m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/carl-shulman",
            "audio_url": "https://api.substack.com/feed/podcast/128144047/6983fcb20ca59b6b904f811447d2558a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 138,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:122974454",
            "index": 80,
            "title": "Richard Rhodes — The making of the atomic bomb",
            "pub_date": "2023-05-23T09:19:29.000Z",
            "duration": "9456",
            "duration_label": "2h 37m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/richard-rhodes",
            "audio_url": "https://api.substack.com/feed/podcast/122974454/eae1c76441e2f6dcc3051e3e8759da10.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 144,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:112763732",
            "index": 81,
            "title": "Eliezer Yudkowsky — Why AI will kill us, aligning LLMs, nature of intelligence, SciFi, & rationality",
            "pub_date": "2023-04-06T13:57:41.000Z",
            "duration": "14605",
            "duration_label": "4h 3m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/eliezer-yudkowsky",
            "audio_url": "https://api.substack.com/feed/podcast/112763732/5d2b7520104901e1a953f5582b8df42c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 635,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:106731655",
            "index": 82,
            "title": "Ilya Sutskever (OpenAI Chief Scientist) — Why next-token prediction could surpass human intelligence",
            "pub_date": "2023-03-27T13:57:39.000Z",
            "duration": "2861",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "alignment"
            ],
            "page_url": "https://www.dwarkesh.com/p/ilya-sutskever",
            "audio_url": "https://api.substack.com/feed/podcast/106731655/5f091a029a1338b560bb4f2140bd66a2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 185,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:109629822",
            "index": 83,
            "title": "Nat Friedman (Github CEO) — Reading ancient scrolls, open source, & AI",
            "pub_date": "2023-03-22T11:15:00.000Z",
            "duration": "5903",
            "duration_label": "1h 38m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "copilot"
            ],
            "page_url": "https://www.dwarkesh.com/p/nat-friedman",
            "audio_url": "https://api.substack.com/feed/podcast/109629822/b6813c3f3dbf019905c91c0a2fa66e43.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 132,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:108062468",
            "index": 84,
            "title": "Brett Harrison — FTX US former president speaks out",
            "pub_date": "2023-03-13T15:15:00.000Z",
            "duration": "9458",
            "duration_label": "2h 37m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/brett-harrison",
            "audio_url": "https://api.substack.com/feed/podcast/108062468/76cac0335b99e5289cb079a14a084597.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:99489876",
            "index": 85,
            "title": "Marc Andreessen — AI, crypto, 1000 Elon Musks, regrets, vulnerabilities, & managerial revolution",
            "pub_date": "2023-02-01T16:00:00.000Z",
            "duration": "4771",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/marc-andreessen",
            "audio_url": "https://api.substack.com/feed/podcast/99489876/e6ebd4458b184d9a61752e775ecfd370.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 171,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:92618940",
            "index": 86,
            "title": "Garett Jones — Immigration, national IQ, & less democracy",
            "pub_date": "2023-01-24T13:00:00.000Z",
            "duration": "4441",
            "duration_label": "1h 14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/garett-jones",
            "audio_url": "https://api.substack.com/feed/podcast/92618940/051cef580f7ab4fb1432e26e468c07cf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:90244342",
            "index": 87,
            "title": "Lars Doucet — Progress, poverty, Georgism, & why rent is too damn high",
            "pub_date": "2023-01-09T13:00:00.000Z",
            "duration": "6023",
            "duration_label": "1h 40m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/lars-doucet",
            "audio_url": "https://api.substack.com/feed/podcast/90244342/d4f246709267b103acdca400dbd62f50.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:88869530",
            "index": 88,
            "title": "Holden Karnofsky — History's most important century",
            "pub_date": "2023-01-03T13:00:00.000Z",
            "duration": "6970",
            "duration_label": "1h 56m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "https://www.dwarkesh.com/p/holden-karnofsky",
            "audio_url": "https://api.substack.com/feed/podcast/88869530/00870fc811b222e23755e4986ae8a266.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 211,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:92018753",
            "index": 89,
            "title": "Bethany McLean — Enron, FTX, 2008, Musk, frauds, & visionaries",
            "pub_date": "2022-12-21T12:30:00.000Z",
            "duration": "5158",
            "duration_label": "1h 25m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/bethany-mclean",
            "audio_url": "https://api.substack.com/feed/podcast/92018753/be526633a48c4433a91c8e49447cca50.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:90766393",
            "index": 90,
            "title": "Nadia Asparouhova — Tech elites, democracy, open source, & philanthropy",
            "pub_date": "2022-12-15T12:00:00.000Z",
            "duration": "4930",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/nadia-asparouhova",
            "audio_url": "https://api.substack.com/feed/podcast/90766393/10970fde2b95c6345960a3602ac3d578.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:87816399",
            "index": 91,
            "title": "Byrne Hobart - FTX, Drugs, Twitter, Taiwan, & Monasticism",
            "pub_date": "2022-12-01T11:00:00.000Z",
            "duration": "5408",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/byrne-hobart-2",
            "audio_url": "https://api.substack.com/feed/podcast/87816399/88a1fc201ae581e1ef33cd034bb4dd43.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:87260678",
            "index": 92,
            "title": "Edward Glaeser - Cities, Terrorism, Housing, & Remote Work",
            "pub_date": "2022-11-28T13:03:00.000Z",
            "duration": "3428",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "automation"
            ],
            "page_url": "https://www.dwarkesh.com/p/edward-glaeser",
            "audio_url": "https://api.substack.com/feed/podcast/87260678/e4645f03b385ec03bdd8d2e8a01dc6bb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 117,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:82375941",
            "index": 93,
            "title": "Kenneth T. Jackson - Robert Moses, Hero of New York?",
            "pub_date": "2022-11-08T13:00:00.000Z",
            "duration": "5597",
            "duration_label": "1h 33m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/kenneth-jackson",
            "audio_url": "https://api.substack.com/feed/podcast/82375941/9051622d23bb323875381c4c9701de7d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:80970088",
            "index": 94,
            "title": "Brian Potter - Future of Construction, Ugly Modernism, & Environmental Review",
            "pub_date": "2022-10-27T12:09:43.000Z",
            "duration": "8757",
            "duration_label": "2h 25m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://www.dwarkesh.com/p/brian-potter",
            "audio_url": "https://api.substack.com/feed/podcast/80970088/8f22da87fdf3705df053f4fe8b9402d5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 204,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:76694048",
            "index": 95,
            "title": "Bryan Caplan - Feminists, Billionaires, and Demagogues",
            "pub_date": "2022-10-20T11:10:25.000Z",
            "duration": "7511",
            "duration_label": "2h 5m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/bryan-caplan-3",
            "audio_url": "https://api.substack.com/feed/podcast/76694048/531adb71a208539cd4dbb6dff5db3eed.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:75408365",
            "index": 96,
            "title": "Tyler Cowen - Talent, Collapse, & Pessimism of Sex",
            "pub_date": "2022-09-28T13:21:06.000Z",
            "duration": "5679",
            "duration_label": "1h 34m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/tyler-cowen-2",
            "audio_url": "https://api.substack.com/feed/podcast/75408365/c28e0038cd8ef1ac484dad7aac4422f6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 371,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:73016865",
            "index": 97,
            "title": "Charles C. Mann - Americas Before Columbus & Scientific Wizardry",
            "pub_date": "2022-09-14T09:38:32.000Z",
            "duration": "5488",
            "duration_label": "1h 31m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/charles-mann",
            "audio_url": "https://api.substack.com/feed/podcast/73016865/119fc5b9dbd10a1e98ffe77aa424a3f7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:71396938",
            "index": 98,
            "title": "Austin Vernon - Energy Superabundance, Starship Missiles, & Finding Alpha",
            "pub_date": "2022-09-08T11:00:00.000Z",
            "duration": "8611",
            "duration_label": "2h 23m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/austin-vernon",
            "audio_url": "https://api.substack.com/feed/podcast/71396938/d7411d1afde5664f853a4298e3db4864.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:69097775",
            "index": 99,
            "title": "Steve Hsu - Intelligence, Embryo Selection, & The Future of Humanity",
            "pub_date": "2022-08-23T05:56:00.000Z",
            "duration": "8449",
            "duration_label": "2h 20m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/steve-hsu",
            "audio_url": "https://api.substack.com/feed/podcast/69097775/8ff5fe7b963d8d0637d6fbb2759d82b9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:67808980",
            "index": 100,
            "title": "Will MacAskill - Longtermism, Altruism, History, & Technology",
            "pub_date": "2022-08-09T04:02:00.000Z",
            "duration": "3367",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://www.dwarkesh.com/p/will-macaskill",
            "audio_url": "https://api.substack.com/feed/podcast/67808980/2b7c6d883aa8bb18f80ab15bd7bcb821.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 131,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:66734020",
            "index": 101,
            "title": "Joseph Carlsmith - Utopia, AI, & Infinite Ethics",
            "pub_date": "2022-08-03T05:00:00.000Z",
            "duration": "5481",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://www.dwarkesh.com/p/joseph-carlsmith",
            "audio_url": "https://api.substack.com/feed/podcast/66734020/ee584025c3528cfeb18d13999e2f2257.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:65843276",
            "index": 102,
            "title": "Fin Moorhouse - Longtermism, Space, & Entrepreneurship",
            "pub_date": "2022-07-27T05:00:00.000Z",
            "duration": "8388",
            "duration_label": "2h 19m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://www.dwarkesh.com/p/fin-moorhouse",
            "audio_url": "https://api.substack.com/feed/podcast/65843276/5c668d023c9b146a5281db0a47ac4541.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:63827201",
            "index": 103,
            "title": "Alexander Mikaberidze - Napoleon, War, Progress, and Global Order",
            "pub_date": "2022-07-13T06:43:00.000Z",
            "duration": "4990",
            "duration_label": "1h 23m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/alexander-mikaberidze",
            "audio_url": "https://api.substack.com/feed/podcast/63827201/da9447f9539be07501ad0f4f91d1ead2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 770,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:61927464",
            "index": 104,
            "title": "Sam Bankman-Fried - Crypto, Altruism, and Leadership",
            "pub_date": "2022-07-05T06:55:22.000Z",
            "duration": "2716",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning",
              "alignment",
              "safety",
              "coding"
            ],
            "page_url": "https://www.dwarkesh.com/p/sbf",
            "audio_url": "https://api.substack.com/feed/podcast/61927464/ddb8afb251d253b5d0f7abad2765232f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 87,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:58484687",
            "index": 105,
            "title": "Agustin Lebron - Trading, Crypto, and Adverse Selection",
            "pub_date": "2022-06-23T05:00:00.000Z",
            "duration": "3844",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://www.dwarkesh.com/p/agustin-lebron",
            "audio_url": "https://api.substack.com/feed/podcast/58484687/1030e1bf9d275dc564c1aa2831375322.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:54281341",
            "index": 106,
            "title": "Ananyo Bhattacharya - John von Neumann, Jewish Genius, and Nuclear War",
            "pub_date": "2022-05-11T05:00:00.000Z",
            "duration": "3284",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/ananyo-bhattacharya",
            "audio_url": "https://api.substack.com/feed/podcast/54281341/8f1d3f56a13b3afef8852f2066e8d272.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 244,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:53416271",
            "index": 107,
            "title": "Stephen Grugett (Manifold Markets Founder) - Predictions Markets & Revolutionizing Governance",
            "pub_date": "2022-05-05T05:04:41.000Z",
            "duration": "3053",
            "duration_label": "50m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/stephen-grugett",
            "audio_url": "https://api.substack.com/feed/podcast/53416271/20af6ceca21eed802b3a0af6ebed5ea6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 710,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:53132223",
            "index": 108,
            "title": "Pradyu Prasad - Imperial Japan, the God Emperor, and Militarization in the Modern World",
            "pub_date": "2022-04-27T14:13:00.000Z",
            "duration": "5940",
            "duration_label": "1h 39m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/pradyu-prasad",
            "audio_url": "https://api.substack.com/feed/podcast/53132223/9360b4c122b75d7907f143c8658300ef.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 1182,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "substack:post:53132062",
            "index": 109,
            "title": "Razib Khan - Genomics, Intelligence, and The Church of Science",
            "pub_date": "2022-04-20T10:05:00.000Z",
            "duration": "3798",
            "duration_label": "1h 3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/razib-khan",
            "audio_url": "https://api.substack.com/feed/podcast/53132062/2f56e6086eb35233c6e04de37e4e496a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ffd226de-c3cc-4ace-b774-6ab0014a4831",
            "index": 110,
            "title": "Jimmy Soni - Peter Thiel, Elon Musk, and the Paypal Mafia",
            "pub_date": "2022-04-16T10:00:00.000Z",
            "duration": "4069",
            "duration_label": "1h 7m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/jimmy-soni",
            "audio_url": "https://api.substack.com/feed/podcast/52511221/09bf762a3c89cba4b0897ca15001371c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 821,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f8b35dae-5bb0-4f87-92ad-a5a3c6d46233",
            "index": 111,
            "title": "Bryan Caplan - Discrimination, Poverty, & Mental Illness",
            "pub_date": "2022-04-12T06:00:00.000Z",
            "duration": "3822",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://www.dwarkesh.com/p/bryan-caplan-2",
            "audio_url": "https://api.substack.com/feed/podcast/52511222/7efcc611ae7dbf3a210ee4e6cf9e6b88.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 545,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_zh_transcript_then_episode_knowledge",
              "blocking_reason": ""
            }
          },
          {
            "id": "32d37eb3-6dbf-48fa-bd7a-0267c37f696b",
            "index": 112,
            "title": "Richard Hanania - Foreign Policy, Fertility, and Wokeness",
            "pub_date": "2022-02-24T06:00:00.000Z",
            "duration": "3722",
            "duration_label": "1h 2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/richard-hanania",
            "audio_url": "https://api.substack.com/feed/podcast/52511223/264093616c60e3b1c48584c8048226b9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 639,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1ffe9a59-d756-48ca-b87a-192259f43ca2",
            "index": 113,
            "title": "David Deutsch - AI, America, Fun, & Bayes",
            "pub_date": "2022-01-31T15:55:20.000Z",
            "duration": "5052",
            "duration_label": "1h 24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://www.dwarkesh.com/p/david-deutsch",
            "audio_url": "https://api.substack.com/feed/podcast/52511224/c32c22a9d2c5737aa08be0ef635603e2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_html_transcript",
              "transcript_record_count": 94,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "85904519-0ca8-4521-b066-d2122436f7a1",
            "index": 114,
            "title": "Byrne Hobart - Optionality, Stagnation, and Secret Societies",
            "pub_date": "2021-10-05T05:00:00.000Z",
            "duration": "4292",
            "duration_label": "1h 11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/byrne-hobart",
            "audio_url": "https://api.substack.com/feed/podcast/52511227/a6310d765391ec14dfa134a1411e4cc6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 688,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2b997491-6b70-49b2-93de-c03c88c76597",
            "index": 115,
            "title": "David Friedman - Dating Markets, Legal Systems, Bitcoin, and Automation",
            "pub_date": "2021-08-09T15:08:06.000Z",
            "duration": "5033",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://www.dwarkesh.com/p/david-friedman",
            "audio_url": "https://api.substack.com/feed/podcast/52511229/549f495e3948eee6c2f0f644aa5ed544.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 995,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_zh_transcript_then_episode_knowledge",
              "blocking_reason": ""
            }
          },
          {
            "id": "ecb713ac-42ba-4559-8658-52f07e7f8890",
            "index": 116,
            "title": "Sarah Fitz-Claridge - Taking Children Seriously",
            "pub_date": "2021-06-04T16:26:22.000Z",
            "duration": "3494",
            "duration_label": "58m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/sarah-fitz",
            "audio_url": "https://api.substack.com/feed/podcast/52511230/61da6a8dcff984e9f4b808df787c924b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 413,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e3005a16-7cd3-4e5f-9226-4f987c767799",
            "index": 117,
            "title": "Michael Huemer - Anarchy, Capitalism, and Progress",
            "pub_date": "2021-05-28T22:02:41.000Z",
            "duration": "5824",
            "duration_label": "1h 37m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/michael-huemer",
            "audio_url": "https://api.substack.com/feed/podcast/52511231/5a5c80a623d1ccd5c866a01f2ad6dd3e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 1131,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e4203d6a-12bf-488a-a3e8-8d9385395c20",
            "index": 118,
            "title": "Uncle Bob - The Long Reach of Code",
            "pub_date": "2020-11-28T01:12:45.000Z",
            "duration": "2750",
            "duration_label": "45m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "coding"
            ],
            "page_url": "https://www.dwarkesh.com/p/uncle-bob",
            "audio_url": "https://api.substack.com/feed/podcast/52511232/46c52a20c88cb49c22839eab607fe1ed.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 492,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_zh_transcript_then_episode_knowledge",
              "blocking_reason": ""
            }
          },
          {
            "id": "15793f76-92ce-4970-ac60-bb3efdaa9333",
            "index": 119,
            "title": "Scott Aaronson - Quantum Computing, Complexity, and Creativity",
            "pub_date": "2020-11-20T23:31:16.000Z",
            "duration": "5225",
            "duration_label": "1h 27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/scott-aaronson",
            "audio_url": "https://api.substack.com/feed/podcast/52511233/ffca19c182785775bc13edc540f275b7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 590,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c668856b-1679-44c0-bd9f-3276455766e4",
            "index": 120,
            "title": "Scott Young - Ultralearning",
            "pub_date": "2020-11-16T20:25:33.000Z",
            "duration": "5937",
            "duration_label": "1h 38m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/scott-young",
            "audio_url": "https://api.substack.com/feed/podcast/52511234/1538564d1fc486efbaeccb24dc07dd58.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9374f6f9-3713-44e2-95b9-01860a885e1f",
            "index": 121,
            "title": "Charles Murray - Human Accomplishment and the Future of Liberty",
            "pub_date": "2020-10-28T13:50:45.000Z",
            "duration": "6738",
            "duration_label": "1h 52m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/charles-murray",
            "audio_url": "https://api.substack.com/feed/podcast/52511235/0bf4e47a6c2ba98a0365ccca4e48917b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 1210,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "98ce85bb-85a4-4e8f-bb02-568ae1e2cb0a",
            "index": 122,
            "title": "Alex Tabarrok - Prizes, Prices, and Public Goods",
            "pub_date": "2020-10-19T19:23:34.000Z",
            "duration": "5161",
            "duration_label": "1h 26m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/alex-tabarrok",
            "audio_url": "https://api.substack.com/feed/podcast/52511236/41f9371f8d7c2492da683c68eb4905dd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 1021,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b7f28c5f-6deb-4949-9f7f-4634da5b54e7",
            "index": 123,
            "title": "Caleb Watney - America's Innovation Engine",
            "pub_date": "2020-09-04T13:53:32.000Z",
            "duration": "3306",
            "duration_label": "55m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.dwarkesh.com/p/caleb-watney",
            "audio_url": "https://api.substack.com/feed/podcast/52511237/12cf6a6c57358f4e6869450a4026f732.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 480,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_zh_transcript_then_episode_knowledge",
              "blocking_reason": ""
            }
          },
          {
            "id": "da2e9579-d282-4e06-a7ce-f3fe565a7cf4",
            "index": 124,
            "title": "Robin Hanson - The Long View",
            "pub_date": "2020-08-31T14:41:39.000Z",
            "duration": "6029",
            "duration_label": "1h 40m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/robin-hanson",
            "audio_url": "https://api.substack.com/feed/podcast/52511238/2222cec79858121c258ad21494ac0cf1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 1231,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a2472ffc-32fe-45a9-96f2-7b3e55dd7138",
            "index": 125,
            "title": "Jason Crawford - The Roots of Progress",
            "pub_date": "2020-08-25T18:32:55.000Z",
            "duration": "2917",
            "duration_label": "48m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/jason-crawford",
            "audio_url": "https://api.substack.com/feed/podcast/52511239/4e482b4b009f1d41b66127eaefc8b197.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 731,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "4c6063da-3fa3-4319-83df-a0bad562c718",
            "index": 126,
            "title": "Matjaž Leonardis - Science, Identity, and Probability",
            "pub_date": "2020-08-22T00:36:27.000Z",
            "duration": "2072",
            "duration_label": "34m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/matjaz-leonardis",
            "audio_url": "https://api.substack.com/feed/podcast/52511240/997c99e1523570640f4b2bd447f35baa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 373,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b7c107f0-86ed-487f-93e8-7cc95963ae1c",
            "index": 127,
            "title": "Tyler Cowen - The Great Reset",
            "pub_date": "2020-07-10T16:55:22.000Z",
            "duration": "2824",
            "duration_label": "47m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/tyler-cowen",
            "audio_url": "https://api.substack.com/feed/podcast/52511241/e063961bd1d265600f97b9050d7b1be8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "whisper_cpp_raw_json",
              "transcript_record_count": 608,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "33a8e3ea-1481-415c-a2d8-dc399032e7d2",
            "index": 128,
            "title": "Bryan Caplan - Nurturing Orphaned Ideas",
            "pub_date": "2020-05-22T18:31:47.000Z",
            "duration": "3599",
            "duration_label": "59m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.dwarkesh.com/p/bryan-caplan",
            "audio_url": "https://api.substack.com/feed/podcast/52511244/8c72aa4bd79b2f11e6b1d003a0017bf4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "eye-on-ai",
        "title": "Eye on AI",
        "feed_title": "Eye On A.I.",
        "priority": "P1",
        "selection_mode": "all_ai",
        "focus": [
          "AI industry",
          "research",
          "policy",
          "company interviews"
        ],
        "feed_url": "https://rss.libsyn.com/shows/123267/destinations/727317.xml",
        "source_url": "https://rss.libsyn.com/shows/123267/destinations/727317.xml",
        "detail_path": "/podcasts/eye-on-ai/",
        "episode_count": 250,
        "selected_episode_count": 250,
        "latest_episode_title": "Every Enterprise Is About to Have a 100,000 Agent Problem | Oren Michaels of Barndoor AI",
        "latest_pub_date": "2026-06-06T04:00:00.000Z",
        "latest_page_url": "https://aneyeonai.libsyn.com/every-enterprise-is-about-to-have-a-100000-agent-problem-oren-michaels-of-barndoor-ai",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "5b5395f7-fd75-4643-a864-5ae237888dc5",
            "index": 1,
            "title": "Every Enterprise Is About to Have a 100,000 Agent Problem | Oren Michaels of Barndoor AI",
            "pub_date": "2026-06-06T04:00:00.000Z",
            "duration": "59:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/every-enterprise-is-about-to-have-a-100000-agent-problem-oren-michaels-of-barndoor-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS_-354__LA_V3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "57f8b485-177c-4460-8f0d-f435e4f20ce1",
            "index": 2,
            "title": "More Customers Chose the AI Agent Than Anyone Expected | Tom Chen, Aircall",
            "pub_date": "2026-06-04T14:39:00.000Z",
            "duration": "56:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/more-customers-chose-the-ai-agent-than-anyone-expected-tom-chen-aircall",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS-351-_LA_V1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "331afa24-c39d-4998-8ecb-a5a2721d1f0b",
            "index": 3,
            "title": "Why the Future of AI Isn't Just Bigger Models. It's Models That Evolve | Risto Miikkulainen of Cognizant",
            "pub_date": "2026-06-02T18:45:00.000Z",
            "duration": "01:04:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/why-the-future-of-ai-isnt-just-bigger-models-its-models-that-evolve-risto-miikkulainen-of-cognizant",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS-339-_LA_V1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4511d644-93a3-4924-906c-47a13c6dad4b",
            "index": 4,
            "title": "How AI Is Reinventing Elder Care | Chia-Lin Simmons of LogicMark",
            "pub_date": "2026-06-01T13:18:00.000Z",
            "duration": "53:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/how-ai-is-reinventing-elder-care-chia-lin-simmons-of-logicmark",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS-349-_LA_V1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3da8eec9-7435-43e2-a76e-92f55feafc66",
            "index": 5,
            "title": "The App of the Future Is Voice — Not a Screen. Mitel's CTO Luiz Domingos Explains Why.",
            "pub_date": "2026-05-28T20:00:00.000Z",
            "duration": "54:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/the-app-of-the-future-is-voice-not-a-screen-mitels-cto-luiz-domingos-explains-why",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS-345-_LA_V1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef63970a-0cfb-4ba4-8d9d-85c936fc60e3",
            "index": 6,
            "title": "Is ChatGPT Conscious? A Pioneer of AI Explains | Dr. Terry Sejnowski",
            "pub_date": "2026-05-28T18:20:00.000Z",
            "duration": "56:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://aneyeonai.libsyn.com/is-chatgpt-conscious-a-pioneer-of-ai-explains-dr-terry-sejnowski",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/12_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2617ab71-ddd7-4ac6-bf53-1e8e39990d58",
            "index": 7,
            "title": "Your Child's Data Profile Starts Before They're Born | Eamonn Maguire of Proton",
            "pub_date": "2026-05-28T15:46:00.000Z",
            "duration": "55:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/your-childs-data-profile-starts-before-theyre-born-eamonn-maguire-of-proton",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS-362_LA_V1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f9f0f49-89ac-44d9-abe8-cf49943208f7",
            "index": 8,
            "title": "Training AI Models Without a Billion-Dollar Data Center | Steffen Cruz of Macrocosmos",
            "pub_date": "2026-05-25T16:06:00.000Z",
            "duration": "47:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "data center",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/training-ai-models-without-a-billion-dollar-data-center-steffen-cruz-of-macrocosmos",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS-342-LAudio_V1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7b3771ae-6aab-4a2e-a922-0839203d1fe9",
            "index": 9,
            "title": "The Single Biggest Barrier to AI Adoption Isn't the Technology — It's This | Errol Gardner of EY",
            "pub_date": "2026-05-22T13:33:00.000Z",
            "duration": "54:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/the-single-biggest-barrier-to-ai-adoption-isnt-the-technology-its-this-errol-gardner-of-ey",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CSSE-348-A_V4.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7febddea-5a0c-4bc4-a4bb-28463584b0b5",
            "index": 10,
            "title": "Oliver Dial of IBM: Quantum Advantage Is Happening This Year",
            "pub_date": "2026-05-19T19:26:00.000Z",
            "duration": "50:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/oliver-dial-of-ibm-quantum-advantage-is-happening-this-year",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS-02-A_V1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4cf1ad9a-82ec-4b40-a49b-5bc9682b87d5",
            "index": 11,
            "title": "Why Agentic-First Startups Won't Disrupt Enterprises as Fast as Everyone Thinks | Kris Lovejoy",
            "pub_date": "2026-05-15T17:04:00.000Z",
            "duration": "56:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/why-agentic-first-startups-wont-disrupt-enterprises-as-fast-as-everyone-thinks-kris-lovejoy",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_Ai_344.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "09579504-1c95-4c1d-bd63-ee309642c600",
            "index": 12,
            "title": "Loris Degioanni: Why AI Is Breaking Cybersecurity, and What Comes Next",
            "pub_date": "2026-05-06T17:22:00.000Z",
            "duration": "51:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "claude",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/loris-degioanni-why-ai-is-breaking-cybersecurity-and-what-comes-next",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CS-01-A_V2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e9a2bfb-8837-42f0-8cdf-ac3dd299db5a",
            "index": 13,
            "title": "#342 Andrew Thangaraj: The $5,000 IIT Degree: Can India Fix Its Broken Education System?",
            "pub_date": "2026-05-01T14:00:00.000Z",
            "duration": "48:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/339-andrew-thangaraj-the-5000-iit-degree-can-india-fix-its-broken-education-system",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/eye_on_ai_andrew_thana.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "906c1b10-de7e-4629-8287-ea7a93395bc3",
            "index": 14,
            "title": "#341  Celia Merzbacher: Beyond the Buzzword: The Real State of Quantum Computing, Sensing, and AI in 2025",
            "pub_date": "2026-04-30T20:00:00.000Z",
            "duration": "44:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/342-celia-merzbacher-beyond-the-buzzword-the-real-state-of-quantum-computing-sensing-and-ai-in-2025",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/FINAL_AUDIO.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5c37e6c-d02f-4267-9cd5-b4192a237f56",
            "index": 15,
            "title": "#340 Steffen Cruz: Training AI Without Data Centres",
            "pub_date": "2026-04-29T20:00:00.000Z",
            "duration": "46:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gpu",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/340-steffen-cruz-training-ai-without-data-centres",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_342__IO_NET_f2_audio_.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cab8ef3c-fe90-44ed-851c-12e93fb7a6e4",
            "index": 16,
            "title": "#339 Eamonn Maguire: Your Child Has a Data Profile Before They're Born",
            "pub_date": "2026-04-28T20:00:00.000Z",
            "duration": "45:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/339-eamonn-maguire-your-child-has-a-data-profile-before-theyre-born",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_362_-_Eamonn_Maguire.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ac1c30e-8f7d-4379-8681-ab3c468c481d",
            "index": 17,
            "title": "#338 Amith Singhee: Can India Catch Up in AI? IBM's Amith Singhee on What It Will Take",
            "pub_date": "2026-04-24T14:00:55.000Z",
            "duration": "46:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/338-amith-singhee-can-india-catch-up-in-ai-ibms-amith-singhee-on-what-it-will-take",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/eye_on_ai_amit_singhee.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "643cff25-657d-4ed8-be30-cdc4f066df6d",
            "index": 18,
            "title": "#337 Debdas Sen: Why AI Without ROI Will Die (Again)",
            "pub_date": "2026-04-23T20:00:00.000Z",
            "duration": "51:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "inference",
              "reasoning",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/337-debdas-sen-why-ai-without-roi-will-die-again",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_341_-_Debdas_TCG_f1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9886de7b-8ba8-472b-af4d-22199443e36c",
            "index": 19,
            "title": "#336 Professor Mausam: Why India Is Losing the AI Race and What It Will Take to Catch Up",
            "pub_date": "2026-04-20T14:00:00.000Z",
            "duration": "01:00:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/336-professor-mausam-iit-delhi-why-india-is-losing-the-ai-race-and-what-it-will-take-to-catch-up",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/0416.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d872c485-163b-4ef6-a528-a0cb275870c7",
            "index": 20,
            "title": "#335 Sriram Raghavan: Why IBM Is Betting Everything on Small AI Models",
            "pub_date": "2026-04-19T20:00:00.000Z",
            "duration": "01:00:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "claude",
              "inference",
              "alignment",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/335-sriram-raghavan-why-ibm-is-betting-everything-on-small-ai-models",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_340_-_IBM_-_Sri_Raghavan_audio_.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3786ea1f-eb25-4573-8569-e96b9dd7da05",
            "index": 21,
            "title": "#334 Abhishek Singh: The $1.2 Billion Plan to Turn India Into an AI Superpower",
            "pub_date": "2026-04-16T13:00:00.000Z",
            "duration": "34:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "foundation model",
              "data center",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/334-abhishek-singh-the-12-billion-plan-to-turn-india-into-an-ai-superpower",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_7_audio_f3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "269ad07d-7f2e-48bb-b559-fcefe6df799b",
            "index": 22,
            "title": "#333 Adi Kuruganti: Why Your AI Pilot Is Failing and What It Takes to Reach Production",
            "pub_date": "2026-04-15T13:00:00.000Z",
            "duration": "58:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "training",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/333-adi-kuruganti-why-your-ai-pilot-is-failing-and-what-it-takes-to-reach-production",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_337_-_Automation_Everywhere_-_Adi_audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f39300a-5fc1-44c5-8231-3673a845b086",
            "index": 23,
            "title": "#332 Dan Faulkner: The Code Is Clean. The App Is Broken. Why AI Development Has an Integrity Problem",
            "pub_date": "2026-04-14T20:00:00.000Z",
            "duration": "54:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "claude",
              "automation",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/332-dan-faulkner-the-code-is-clean-the-app-is-broken-why-ai-development-has-an-integrity-problem",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Final_audio_eye_on_ai.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9ac6c5f8-6a3e-43ff-9496-5633bfdac852",
            "index": 24,
            "title": "#331 Sergey Levine: The Robot Revolution Nobody Is Talking About",
            "pub_date": "2026-04-12T20:00:00.000Z",
            "duration": "58:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "chatgpt",
              "training",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/331-sergey-levine-the-robot-revolution-nobody-is-talking-about",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_11_f999_audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5e1808b8-bf79-451a-9640-24b1d6b60515",
            "index": 25,
            "title": "#330 Sebastian Risi: Why AI Should Be Grown, Not Trained",
            "pub_date": "2026-04-06T20:00:00.000Z",
            "duration": "01:00:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/330-sebastian-risi-why-ai-should-be-grown-not-trained",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/eye_on_ai_sebastian_rishi_mp3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f258f2c-3bed-4e7b-a8a8-23d419d02094",
            "index": 26,
            "title": "#329 Izhar Medalsy: How AI Solves Quantum Computing's Biggest Problem",
            "pub_date": "2026-03-31T20:00:00.000Z",
            "duration": "01:01:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/329-izhar-medalsy-how-ai-solves-quantum-computings-biggest-problem",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_12_audio_f3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "72a1aa43-faa0-4e37-9759-01a60b814099",
            "index": 27,
            "title": "#328 Kevin Tian: Exploring Doppel's AI-Native Social Engineering Defense Platform",
            "pub_date": "2026-03-27T15:00:00.000Z",
            "duration": "48:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/328-kevin-tian-exploring-doppels-ai-native-social-engineering-defense-platform",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/eye_on_ai_POD_audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3305af4-b99d-45bc-aa26-ae76f19c2383",
            "index": 28,
            "title": "#327 Baris Gultekin: The Next Phase of AI - Agents That Understand Your Company's Data",
            "pub_date": "2026-03-19T20:00:00.000Z",
            "duration": "42:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning",
              "retrieval",
              "automation",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/327-baris-gultekin-the-next-phase-of-ai-agents-that-understand-your-companys-data",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/final_poadcast.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "677767ff-c543-42fd-82eb-d4562caed74f",
            "index": 29,
            "title": "#326 Zuzanna Stamirowska: Inside Pathway's Post-Transformer Architecture Designed for Memory and On-the-Fly Learning",
            "pub_date": "2026-03-11T20:00:00.000Z",
            "duration": "01:07:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "reasoning",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/326-zuzanna-stamirowska-inside-pathways-ai-systems-that-work-with-live-real-time-data",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/v2eye_on_ai_8f2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48383e22-3075-4a40-a31b-d646e6370581",
            "index": 30,
            "title": "#325 Phelim Brady: Why AI's Future Depends on Human Judgement",
            "pub_date": "2026-03-09T20:00:00.000Z",
            "duration": "47:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/325-phelim-brady-why-ais-future-depends-on-human-judgement",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Sequence_21_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f16b0f0-6bd1-451f-befe-91404dacff46",
            "index": 31,
            "title": "#324 Sharon Zhou: Inside AMD's Plan to Build Self-Improving AI",
            "pub_date": "2026-02-27T21:00:00.000Z",
            "duration": "46:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "gpu",
              "chip",
              "inference",
              "training",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/324-sharon-zhou",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EYE_On_AI_Sharon_Zhou_F3__1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "abdecc1a-ed68-42b2-bbe2-5cb3c03ec445",
            "index": 32,
            "title": "#323 David Ha: Why Model Merging Could Be the Next AI Breakthrough",
            "pub_date": "2026-02-24T14:00:00.000Z",
            "duration": "57:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "agent",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/323-david-ha-why-model-merging-could-be-the-next-ai-breakthrough",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/327_EYE_ON_AI_F1_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d78cbd6b-5f52-4deb-984e-c79250355ea6",
            "index": 33,
            "title": "#322 Amanda Luther: The Widening AI Value Gap (Inside BCG's AI Research)",
            "pub_date": "2026-02-19T14:00:00.000Z",
            "duration": "54:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "training",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/323-amanda-luther-the-widening-ai-value-gap-inside-bcgs-ai-research",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/326_Eye_On_AI_Amanda_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8257f133-23f7-4590-b384-a36b4679377b",
            "index": 34,
            "title": "#321 Nick Frosst: Why Cohere Is Betting on Enterprise AI, Not AGI",
            "pub_date": "2026-02-17T21:00:00.000Z",
            "duration": "01:01:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agents",
              "agentic",
              "inference",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/321-nick-frosst-why-cohere-is-betting-on-enterprise-ai-not-agi",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/322_Eye_on_AI_Nick_Frost_F6_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "16b9c994-b3f0-40ab-837e-32999549f115",
            "index": 35,
            "title": "#320 Carter Huffman: Exploring The Architecture Behind Modulate's Next-Gen Voice AI",
            "pub_date": "2026-02-11T21:00:00.000Z",
            "duration": "01:08:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/322-carter-huffman-exploring-the-architecture-behind-modulates-next-gen-voice-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_320_-_Carter_Huffman.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "32c9cb13-258e-4d68-9812-9fe52c5e9cc5",
            "index": 36,
            "title": "#319 Subho Halder: Why Traditional App Security Fails in the Age of AI",
            "pub_date": "2026-02-01T21:00:00.000Z",
            "duration": "57:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "chatgpt"
            ],
            "page_url": "https://aneyeonai.libsyn.com/319-subho-halder-why-traditional-app-security-fails-in-the-age-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Final.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "54b13a33-0060-4f52-976a-eec07fee2283",
            "index": 37,
            "title": "#318 Olek Paraska: How AI Is Fixing the Biggest Bottleneck in Construction",
            "pub_date": "2026-01-29T14:00:00.000Z",
            "duration": "53:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/318-olek-paraska-how-ai-is-fixing-the-biggest-bottleneck-in-construction",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/fix.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1442ecb1-6090-42c0-8901-be03bbfbaeef",
            "index": 38,
            "title": "#317 Steven Brown: Why Modern Medicine Needs AI-Assisted Decision Making",
            "pub_date": "2026-01-25T21:00:00.000Z",
            "duration": "01:00:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "rag"
            ],
            "page_url": "https://aneyeonai.libsyn.com/317-steve-brown-why-modern-medicine-needs-ai-assisted-decision-making",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/poadcast_3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3f187bb-8bca-43ea-9c4b-e274464c89b0",
            "index": 39,
            "title": "#316 Robbie Goldfarb: Why the Future of AI Depends on Better Judgment",
            "pub_date": "2026-01-23T21:00:00.000Z",
            "duration": "01:03:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training",
              "alignment",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/316-robbie-goldfarb-why-the-future-of-ai-depends-on-better-judgment",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/V3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e592dc9e-2718-4783-8721-7df7349c44be",
            "index": 40,
            "title": "#315 Jarrod Johnson: How Agentic AI Is Impacting Modern Customer Service",
            "pub_date": "2026-01-21T14:00:00.000Z",
            "duration": "57:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "training",
              "safety",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/315-jarrod-johnson-how-agentic-ai-is-impacting-modern-customer-service",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/poadcast_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cf2a7dff-be34-4824-8333-385f9efe9b3e",
            "index": 41,
            "title": "#314 Nick Pandher: How Inference-First Infrastructure Is Powering the Next Wave of AI",
            "pub_date": "2026-01-17T14:48:00.000Z",
            "duration": "56:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "inference",
              "training",
              "automation",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/313-nick-pandher-how-inference-first-infrastructure-is-powering-the-next-wave-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Sequence_05.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dcdf314a-b294-47e0-85bf-12478d1c9b37",
            "index": 42,
            "title": "#313 Evan Reiser: How Abnormal AI Protects Humans with Behavioral AI",
            "pub_date": "2026-01-16T13:47:00.000Z",
            "duration": "49:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/313-evan-reiser-how-abnormal-ai-protects-humans-with-behavioural-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Abnormal_AI_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3bd54191-cf81-4a15-adf3-462769b04119",
            "index": 43,
            "title": "#312 Jonathan Wall: AI Agents Are Reshaping the Future of Compute Infrastructure",
            "pub_date": "2026-01-11T21:02:00.000Z",
            "duration": "52:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/313-jonathan-wall-ai-agents-are-reshaping-the-future-of-compute-infrastructure",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Craig_And_Jonathan_Wall_Podcast.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "24c6ed05-96a5-4628-b19b-927991d17a39",
            "index": 44,
            "title": "#311 Anurag Dhingra: Inside Cisco's Vision for AI-Powered Enterprise Systems",
            "pub_date": "2026-01-07T21:00:00.000Z",
            "duration": "47:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "robotics",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/312-anurag-dhingra-inside-ciscos-vision-for-ai-powered-enterprise-systems",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Craig_with_anurag_podcast_mp3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa3bed48-4487-4ab8-8f98-5624145c6820",
            "index": 45,
            "title": "#310 Stefano Ermon: Why Diffusion Language Models Will Define the Next Generation of LLMs",
            "pub_date": "2026-01-04T21:00:00.000Z",
            "duration": "52:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "inference",
              "training",
              "reasoning",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/311-stefano-ermon-why-diffusion-language-models-will-define-the-next-generation-of-llms",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_312_.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "821b983f-6864-46a3-9513-886222c4eeb9",
            "index": 46,
            "title": "#309 Jamie Metzl: Why Gene Editing Needs Governance Or We Lose Control",
            "pub_date": "2025-12-24T14:00:00.000Z",
            "duration": "01:10:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/309-jamie-metzl-why-gene-editing-needs-governance-or-we-lose-control",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_311_-_Audio_.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a36ab363-51b6-485d-b19c-64156f542842",
            "index": 47,
            "title": "#308 Christopher Bergey: How Arm Enables AI to Run Directly on Devices",
            "pub_date": "2025-12-19T14:00:00.000Z",
            "duration": "51:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/308-christopher-bergey-how-arm-enables-ai-to-run-directly-on-devices",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_310_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b9c9880b-cc7a-414b-ae65-55fd106c4bd7",
            "index": 48,
            "title": "#307 Steven Brightfield: How Neuromorphic Computing Cuts Inference Power by 10x",
            "pub_date": "2025-12-16T21:00:00.000Z",
            "duration": "59:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "gpu",
              "inference",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/307-steven-brightfield-how-neuromorphic-computing-cuts-inference-power-by-10x",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_309_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d3c11b0e-d1f7-43c0-bf06-8192be15ca24",
            "index": 49,
            "title": "#306 Jeffrey Ladish: What Shutdown-Avoiding AI Agents Mean for Future Safety",
            "pub_date": "2025-12-07T14:00:00.000Z",
            "duration": "58:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "alignment",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/306-jeffrey-ladish-what-shutdown-avoiding-ai-agents-mean-for-future-safety",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_307_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3ca08c8-aa63-43de-92e8-c90cd08caf92",
            "index": 50,
            "title": "#305 Rakshit Ghura: How Lenovo Is Turning AI Agents Into Digital Coworkers",
            "pub_date": "2025-12-03T14:00:00.000Z",
            "duration": "46:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/305-rakshit-ghura-how-lenovo-is-turning-ai-agents-into-digital-coworkers",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_305_-_Video_v3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "40689ca8-d60f-4df3-979c-aaa13701d1dc",
            "index": 51,
            "title": "#304 Matt Zeiler: Why Government And Enterprises Choose Clarifai For AI Ops",
            "pub_date": "2025-11-28T21:00:00.000Z",
            "duration": "55:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "gpu",
              "inference",
              "training",
              "multimodal"
            ],
            "page_url": "https://aneyeonai.libsyn.com/304-matt-zeiler-why-government-and-enterprises-choose-clarifai-for-ai-ops",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_306_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a7595ad-c94f-4bf5-8631-e94a588c7446",
            "index": 52,
            "title": "#303 Fei-Fei Li: Spatial Intelligence, World Models & the Future of AI",
            "pub_date": "2025-11-23T14:00:00.000Z",
            "duration": "01:00:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "training",
              "reasoning",
              "multimodal",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/303-fei-fei-li-spatial-intelligence-world-models-the-future-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_with_Fei-Fei_Li_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "627992c2-cee7-4d38-be2d-0399df7e65a4",
            "index": 53,
            "title": "#302 Karl Friston: How the Free Energy Principle Could Rewrite AI",
            "pub_date": "2025-11-19T14:00:00.000Z",
            "duration": "01:03:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "inference",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/302-karl-friston-how-the-free-energy-principle-could-rewrite-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EOA_300_-_Audio_v5.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42b796c5-bc86-4c60-ba5b-6c5041bf99ae",
            "index": 54,
            "title": "#301 Hemant Banavar & Ryan Ennis: The AI Safety System Driving Toward Zero Harm",
            "pub_date": "2025-11-16T14:00:00.000Z",
            "duration": "48:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/301-hemant-banavar-ryan-paulson-the-ai-safety-system-driving-toward-zero-harm",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EOA_296_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e7109cfb-58c6-426d-a118-d08cd27ac329",
            "index": 55,
            "title": "#300 Fred Laluyaux: How Decision Intelligence & AI Agents Are Redefining Enterprise Operations",
            "pub_date": "2025-11-13T03:00:00.000Z",
            "duration": "57:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/300-fred-laluyaux-how-decision-intelligence-ai-agents-are-redefining-enterprise-operations",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_303_-_Audio_v4.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f6045ed0-1e22-4534-8b49-d208d859c3e9",
            "index": 56,
            "title": "#299 Jacob Buckman: Why the Future of AI Won't Be Built on Transformers",
            "pub_date": "2025-11-09T21:00:00.000Z",
            "duration": "57:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "rag",
              "retrieval"
            ],
            "page_url": "https://aneyeonai.libsyn.com/299-jacob-buckman-why-the-future-of-ai-wont-be-built-on-transformers",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_302_-_Audio_New.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba100d79-e5fa-4432-884b-a0061abef9b3",
            "index": 57,
            "title": "#298 Ryan Kolln: How Appen Trains the World's Most Powerful AI Models",
            "pub_date": "2025-11-06T14:00:00.000Z",
            "duration": "51:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "training",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/298-ryan-kolln-how-appen-trains-the-worlds-most-powerful-ai-models",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_with_Ryan_Kolln_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f8b92f63-9c22-4895-9c7b-70a5f9ee8f26",
            "index": 58,
            "title": "#297 Jeff Lunsford: How Agentic AI Will Redefine Every Digital Interaction",
            "pub_date": "2025-10-30T14:00:00.000Z",
            "duration": "47:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "inference",
              "reasoning",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/297-jeff-lunsford-how-agentic-ai-will-redefine-every-digital-interaction",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_298_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "31e2d2c5-eb54-42ac-8133-7f2e1c36e7cb",
            "index": 59,
            "title": "#296 Yeop Lee: How Coxwave is Redefining AI Evaluation",
            "pub_date": "2025-10-26T14:00:00.000Z",
            "duration": "43:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/296-yeop-lee-how-coxwave-is-redefining-ai-evaluation",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_297_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b6a7bb8c-6fc3-48f6-9e42-f56c43865acc",
            "index": 60,
            "title": "#295 Fergal Reid: Why Your Bots Fail and How Agents Fix Your Customer Support",
            "pub_date": "2025-10-19T14:00:00.000Z",
            "duration": "43:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/295-fergal-reid-why-your-bots-fail-and-how-agents-fix-your-customer-support",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_295_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cce6cbca-a0c8-4497-814e-3cd3f4e72fc8",
            "index": 61,
            "title": "#294 Bhaskar Roy: How Workato Is Building the Rise of the Agentic Enterprise",
            "pub_date": "2025-10-16T14:00:00.000Z",
            "duration": "57:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/294-bhaskar-roy-how-workato-is-building-the-rise-of-the-agentic-enterprise",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_294_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a41bea6-65ae-4519-b562-25afdc7efdcd",
            "index": 62,
            "title": "#293 Greg Shewmaker: How Enterprises Can Implement and Scale with Agentic AI",
            "pub_date": "2025-10-13T14:00:00.000Z",
            "duration": "43:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/293-greg-shewmaker-how-enterprises-can-implement-and-scale-with-agentic-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_293_-_Audio_v2_cisco_ad.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "819a7279-d152-44df-9028-5a0ec3181113",
            "index": 63,
            "title": "#292 Peeyush Ranjan: How Nurix Is Redefining Voice AI for the Enterprise",
            "pub_date": "2025-10-09T14:00:00.000Z",
            "duration": "45:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/292-peeyush-ranjan-how-nurix-is-redefining-voice-ai-for-the-enterprise",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_292_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "571bc620-93d6-494e-acd8-c104fbabf6cf",
            "index": 64,
            "title": "#291 Naveen Jain: How AI Predicts Cancer, Diabetes & Chronic Illness",
            "pub_date": "2025-10-06T13:00:00.000Z",
            "duration": "52:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/293-naveen-jain-how-ai-predicts-cancer-diabetes-chronic-illness",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_291_-_Audio_v3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6b8095a2-d162-4181-9b2b-2c4b3125b4c3",
            "index": 65,
            "title": "#290 Joel Hron: How Thomson Reuters is Approaching The Next Era of AI",
            "pub_date": "2025-09-29T13:00:00.000Z",
            "duration": "59:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "agents",
              "agentic",
              "reasoning",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/290-joel-hron-how-thomson-reuters-is-approaching-the-next-era-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_290_-_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e84f608c-4cd3-42fc-be73-27879b18af35",
            "index": 66,
            "title": "#289 Eiso Kant: How Reinforcement Learning and Coding Could Unlock Human-Level AI",
            "pub_date": "2025-09-24T20:00:00.000Z",
            "duration": "54:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "agentic",
              "training",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/289-eiso-kant-how-reinforcement-learning-and-coding-could-unlock-human-level-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_289_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a7eb90c-c649-495f-bb3f-ac7b7e160923",
            "index": 67,
            "title": "#288 Florian Douetteau: How Enterprises Can Scale and Adopt Agentic AI",
            "pub_date": "2025-09-21T20:00:00.000Z",
            "duration": "55:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "nvidia",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/288-florian-douetteau-how-enterprises-can-scale-and-adopt-agentic-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_288_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "57b99b22-f207-471f-954a-9d863814471f",
            "index": 68,
            "title": "#287 Sahil Bansal: Why Developers Are Switching to CodeRabbit's AI Code Reviews",
            "pub_date": "2025-09-17T20:00:00.000Z",
            "duration": "48:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://aneyeonai.libsyn.com/287-sahil-bansal-why-developers-are-switching-to-coderabbits-ai-code-reviews",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_287_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b8e882ed-8b2e-47db-9b96-ffdf1d7e04a2",
            "index": 69,
            "title": "#286 Ram Venkatesh: How to Build, Operate & Scale Enterprise AI Agents (Sema4.ai)",
            "pub_date": "2025-09-14T09:06:00.000Z",
            "duration": "46:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/286-ram-venkatesh-how-to-build-operate-scale-enterprise-ai-agents-sema4ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_286_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d15e909b-fc68-4d4a-8f9b-1c387ec3872a",
            "index": 70,
            "title": "#285 Raj Koneru: How Kore.ai is Building No Code Enterprise-Grade Agentic AI",
            "pub_date": "2025-09-10T20:00:00.000Z",
            "duration": "52:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "rag",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/285-raj-koneru-how-koreai-is-building-no-code-enterprise-grade-agentic-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_285_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da29a1da-a23d-4bd8-821e-78922fd7eaf5",
            "index": 71,
            "title": "#284 Pat Utz: Inside Abstract, The AI That Decodes Laws and Regulations",
            "pub_date": "2025-09-07T20:00:00.000Z",
            "duration": "47:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "rag",
              "retrieval",
              "ai startup"
            ],
            "page_url": "https://aneyeonai.libsyn.com/284-pat-utz-inside-abstract-the-ai-that-decodes-laws-and-regulations",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_284_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "61914f7e-b1bf-42f9-9c0c-ab3bf80389de",
            "index": 72,
            "title": "#283 Andrei Danescu: How Dexory Uses AI & Robotics for Warehouse Management",
            "pub_date": "2025-09-03T20:00:00.000Z",
            "duration": "48:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "robotics",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/283-andrei-danescu-how-dexory-uses-ai-robotics-for-warehouse-management",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_283_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5909279-b6a6-4d2c-b953-3c2e0ee3baa6",
            "index": 73,
            "title": "#282 Chris O'Neill: How GrowthLoop is Using Agentic AI for Real-Time, Personalized Marketing",
            "pub_date": "2025-09-02T21:56:00.000Z",
            "duration": "53:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/282-chris-oneill-how-growthloop-is-using-agentic-ai-for-real-time-personalized-marketing",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/282_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b589d636-c04e-4ecd-b56f-25b039a5eea4",
            "index": 74,
            "title": "#281 Leon Song: The Research Driving Next-Gen Open-Source Models (Together AI)",
            "pub_date": "2025-08-25T20:00:00.000Z",
            "duration": "50:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "llama",
              "inference"
            ],
            "page_url": "https://aneyeonai.libsyn.com/281-leon-song-the-research-driving-next-gen-open-source-models-together-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_282_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "738a1f60-431f-4f4d-bfa2-56fecbf1e32b",
            "index": 75,
            "title": "#280 Aytekin Tank: How to Fully Automate Your Customer Service with AI Agents",
            "pub_date": "2025-08-17T20:00:00.000Z",
            "duration": "45:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "training",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/280-aytekin-tank-how-to-fully-automate-your-customer-service-with-ai-agents",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_280_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef84a8ee-34ee-448f-a8be-21e920976719",
            "index": 76,
            "title": "#279 Matthew Carroll: Immuta's Approach to Secure, Scalable Data Access in the Age of AI",
            "pub_date": "2025-08-14T07:02:00.000Z",
            "duration": "53:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/279-matthew-carroll-immutas-approach-to-secure-scalable-data-access-in-the-age-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_279_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f933df9-5440-4916-a73b-97b48eed91cb",
            "index": 77,
            "title": "#278 Julia Peyre: How Schneider Electric is Pioneering Enterprise AI at Scale",
            "pub_date": "2025-08-10T20:00:00.000Z",
            "duration": "55:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "embedding",
              "robotics",
              "automation",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/278-julia-peyre-how-schneider-electric-is-pioneering-enterprise-ai-at-scale",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_278_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11084b5e-05f2-4df4-a945-c2393a431c0a",
            "index": 78,
            "title": "#277 Alex Salazar: Arcade's Vision to Make AI Agents Secure and Scalable",
            "pub_date": "2025-08-06T20:00:00.000Z",
            "duration": "52:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "claude",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/277-alex-salazar-arcades-vision-to-make-ai-agents-secure-and-scalable",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_277_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ea3e456a-d73f-43f8-bf06-f4d0e3db3639",
            "index": 79,
            "title": "#276 Ryan Wang: How Assembled is Building the Future of AI-Powered Customer Support",
            "pub_date": "2025-08-03T20:00:00.000Z",
            "duration": "59:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "claude",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/276-ryan-wang-how-assembled-is-building-the-future-of-ai-powered-customer-support",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_276_-_Audio_V2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2f5a9ba-56f7-42ef-b453-d07cf5973e42",
            "index": 80,
            "title": "#275 Nandan Nayampally: How Baya Systems is Fixing the Biggest Bottleneck in AI Chips (Data Flow)",
            "pub_date": "2025-07-31T20:00:00.000Z",
            "duration": "46:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "chip",
              "chips"
            ],
            "page_url": "https://aneyeonai.libsyn.com/275-nandan-nayampally-how-baya-systems-is-fixing-the-biggest-bottleneck-in-ai-chips-data-flow",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_275_-_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "929ccd20-69e9-4d17-a121-764f72d4eb8b",
            "index": 81,
            "title": "#274 Luke Behnke: Why Grammarly Is Going All In on AI Agents",
            "pub_date": "2025-07-28T20:00:00.000Z",
            "duration": "57:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "copilot",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/274-luke-behnke-why-grammarly-is-going-all-in-on-ai-agents",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_274_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f0cbe61-68e5-4de3-9151-1bf9600374e8",
            "index": 82,
            "title": "#273 Benjamin Encz: How Ashby is Building the Future of Hiring with AI",
            "pub_date": "2025-07-24T13:00:00.000Z",
            "duration": "47:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/273-benjamin-encz-the-ai-startup-disrupting-the-650b-recruiting-industry-ashby",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_273_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "63256a6a-7795-4c00-af89-5f7cf1a3a204",
            "index": 83,
            "title": "#272 Andrew Blum: Inside The Most Important AI Event Of The Year (HumanX)",
            "pub_date": "2025-07-20T13:00:00.000Z",
            "duration": "24:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "mistral"
            ],
            "page_url": "https://aneyeonai.libsyn.com/272-andrew-blum-inside-the-most-important-ai-event-of-the-year-humanx",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_272_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5034b4dc-d9cd-42d1-8913-480e45078494",
            "index": 84,
            "title": "#271 Steve Lucas: Why AI Agents Will Automate 75% of Business Operations by 2026",
            "pub_date": "2025-07-17T20:00:00.000Z",
            "duration": "41:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/271-steve-lucas-why-ai-agents-will-power-75-of-business-operations-by-2026",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_271_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af76118a-1cbd-47ed-843f-e1e43f8a9f62",
            "index": 85,
            "title": "#270 Thomas Dohmke: GitHub CEO Reveals How AI Will Change Coding Forever",
            "pub_date": "2025-07-15T13:00:00.000Z",
            "duration": "52:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "github copilot",
              "coding",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/269-thomas-dohmke-github-ceo-reveals-how-ai-will-change-coding-forever",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_270_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa57c671-17ae-453f-a90c-b0c0de90b0b9",
            "index": 86,
            "title": "#269 Jason Hardy: How Hitachi Vantara Is Powering the Future of Enterprise AI",
            "pub_date": "2025-07-11T20:00:00.000Z",
            "duration": "55:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agents",
              "agentic",
              "nvidia",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/268-jason-hardy-how-hitachi-vantara-is-powering-the-future-of-enterprise-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_269_-_Audio_v4.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "663f733f-d49c-4be2-91fc-2757e04e5362",
            "index": 87,
            "title": "#268 Kiren Sekar: The Future of Physical Operations Is AI-Powered (Here's Why)",
            "pub_date": "2025-07-06T20:00:00.000Z",
            "duration": "56:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/268-kiren-sekar-the-future-of-physical-operations-is-ai-powered-heres-why",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_268_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4816fd0-80ac-4127-ac6e-2a8953f371ca",
            "index": 88,
            "title": "#267 Nabil Bukhari: Exploring the Future of AI-Powered Enterprise Networking with Extreme Networks",
            "pub_date": "2025-07-02T13:00:00.000Z",
            "duration": "54:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/267-nabil-bukhari-exploring-the-future-of-ai-powered-enterprise-networking-with-extreme-networks",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_267_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f45e0d1-4a93-4e70-a7c8-3c2313a33f26",
            "index": 89,
            "title": "#266 Andy Kurtzig: How Pearl Uses AI + Human Experts In Professional Services",
            "pub_date": "2025-06-29T20:00:00.000Z",
            "duration": "48:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/266-andy-kurtzig-how-pearl-combines-ai-human-experts-in-professional-services",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EyeOnAI266-Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f8c5364-a577-480e-be5d-6033f0aafb95",
            "index": 90,
            "title": "#265 Jeff Lu: How Akool Uses Gen AI to Make Live AI Avatars & Voices",
            "pub_date": "2025-06-27T20:00:00.000Z",
            "duration": "45:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/264-jeff-lu-how-akool-uses-gen-ai-to-make-live-ai-avatars-voices",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_265_final_audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66424342-065b-43db-9482-c22af5c92980",
            "index": 91,
            "title": "#264 Amr Awadallah: Vectara's Mission To Make AI Hallucination-Free & Enterprise Ready",
            "pub_date": "2025-06-22T20:00:00.000Z",
            "duration": "38:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "rag",
              "retrieval"
            ],
            "page_url": "https://aneyeonai.libsyn.com/264-amr-awadallah-vectaras-mission-to-make-ai-hallucination-free-enterprise-ready",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_-_264_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "37a69192-54ee-4093-ac2a-f1aa46629dd3",
            "index": 92,
            "title": "#263 Jarek Kutylowski: How DeepL Is Using AI to Break Language Barriers",
            "pub_date": "2025-06-18T20:00:00.000Z",
            "duration": "53:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/263-jarekkutylowski-how-deepl-is-using-ai-to-break-language-barriers",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_263_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e096c2e-1ab5-4970-999e-279ac0e27978",
            "index": 93,
            "title": "#262 Deepak Chopra: How to Use AI to Expand Human Consciousness",
            "pub_date": "2025-06-15T20:00:00.000Z",
            "duration": "53:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/262-deepak-chopra-how-to-use-ai-to-expand-human-consciousness",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_262_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42ca8ec7-15b8-4d6f-97e4-86d5637f505b",
            "index": 94,
            "title": "#261 Jonathan Frankle: How Databricks is Disrupting AI Model Training",
            "pub_date": "2025-06-12T13:00:00.000Z",
            "duration": "52:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "training",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/261-jonathan-frankle-how-databricks-is-disrupting-ai-model-training",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_-_Jonathan_Frankel_-_Audio_V2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75538d8f-c195-4a7f-8c39-cc6104cf0bdc",
            "index": 95,
            "title": "#260 Ash Anwar: How Molecular You Uses AI for Early Disease Detection",
            "pub_date": "2025-06-09T20:00:00.000Z",
            "duration": "49:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/260-ash-anwar-how-molecular-you-uses-ai-for-early-disease-detection",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_-_260_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e0dc4416-d3ba-4ee5-a7d6-345829c7a798",
            "index": 96,
            "title": "#259 Anjney Midha: a16z's Strategy to Turn AI Startups into Unicorns",
            "pub_date": "2025-06-02T13:00:00.000Z",
            "duration": "56:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agents",
              "anthropic",
              "mistral"
            ],
            "page_url": "https://aneyeonai.libsyn.com/259-anjney-midha-a16zs-strategy-to-turn-ai-startups-into-unicorns",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EYE_ON_AI_-_259_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "511b0c99-c03a-4c2a-a9b5-9b96b8a0cc87",
            "index": 97,
            "title": "#258 Brian Peterson: How Dialpad is Building the Future of AI-Powered Communication",
            "pub_date": "2025-05-29T13:00:00.000Z",
            "duration": "36:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/258-brian-peterson-how-dialpad-is-building-the-future-of-ai-powered-communication",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_-_258_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "30200999-8308-4686-b2fc-4aedccb648cb",
            "index": 98,
            "title": "#257 Ankur Banerjee: How cheqd.io Is Building Trust for AI Agents with Decentralized Identity",
            "pub_date": "2025-05-25T20:00:00.000Z",
            "duration": "58:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/257-ankur-banerjee-how-cheqdio-is-building-trust-for-ai-agents-with-decentralized-identity",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_257_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6676725a-637e-4d7b-a350-b16e9447056a",
            "index": 99,
            "title": "#256 Stephen Schmidt: Inside Amazon's AI-Powered Cybersecurity Strategy",
            "pub_date": "2025-05-22T20:00:00.000Z",
            "duration": "53:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agent",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/258-stephen-schmidt-inside-amazons-ai-powered-cybersecurity-strategy",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_256_-_Audio_V2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "673e0842-0c5c-45a4-abe7-bf0a8042c4aa",
            "index": 100,
            "title": "#255 Eric Topol: Why AI is the Most Powerful Tool in Healthcare Now",
            "pub_date": "2025-05-18T22:00:00.000Z",
            "duration": "48:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "multimodal"
            ],
            "page_url": "https://aneyeonai.libsyn.com/255-eric-topol-why-ai-is-the-most-powerful-tool-in-healthcare-now",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_255_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fdede6ec-a71f-4915-825d-49e09d24ce15",
            "index": 101,
            "title": "#254 Prashanth: Why Developers Still Trust Stack Overflow in the Age of AI",
            "pub_date": "2025-05-14T13:00:00.000Z",
            "duration": "49:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agents",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://aneyeonai.libsyn.com/254-prashanth-why-developers-still-trust-stack-overflow-in-the-age-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EyeOnAI_254_-_Audio_V2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c9d07c4e-7b14-4a5c-a04b-26ebb5018014",
            "index": 102,
            "title": "#253 Ivan Shkvarun: Inside the Fight Against AI-Driven Cybercrime",
            "pub_date": "2025-05-11T13:00:00.000Z",
            "duration": "47:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/253-ivan-shkvarun-inside-the-fight-against-ai-driven-cybercrime",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_-_253final.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c1edf49-f8de-48bb-9a6d-e140723ce206",
            "index": 103,
            "title": "#252 Jeffrey Hammond: How to Build Scalable GenAI Products (AWS Strategy)",
            "pub_date": "2025-05-09T13:00:00.000Z",
            "duration": "53:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/253-jeffery-hammond-how-to-build-scalable-genai-products-aws-strategy",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_252_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6aedb60e-a29a-45ac-b2b1-5b90d6715fde",
            "index": 104,
            "title": "#251 Sid Sheth: How d-Matrix is Disrupting AI Inference in 2025",
            "pub_date": "2025-04-30T13:00:00.000Z",
            "duration": "54:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "llama",
              "nvidia",
              "chip",
              "chips",
              "inference"
            ],
            "page_url": "https://aneyeonai.libsyn.com/252-sid-sheth-how-d-matrix-is-disrupting-ai-inference-in-2025",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_251_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "077955b3-8066-46d1-a906-8d9c728c85df",
            "index": 105,
            "title": "#250 Pedro Domingos on the Real Path to AGI",
            "pub_date": "2025-04-24T13:00:00.000Z",
            "duration": "01:08:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/250-pedro-domingos-on-the-real-path-to-agi",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_250_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a813fc27-b39d-4405-826c-9dc162634684",
            "index": 106,
            "title": "#249 Brice Challamel: How Moderna is Using AI to Disrupt Modern Healthcare",
            "pub_date": "2025-04-20T13:00:00.000Z",
            "duration": "49:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "embedding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/249-brice-challamel-how-moderna-is-using-ai-to-disrupt-modern-healthcare",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_249_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0cfb06b1-c85d-4a6d-a234-af11c8ed2e33",
            "index": 107,
            "title": "#248 Pedro Domingos: How Connectionism Is Reshaping the Future of Machine Learning",
            "pub_date": "2025-04-17T13:23:00.000Z",
            "duration": "59:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://aneyeonai.libsyn.com/248-pedro-domingos-how-connectionism-is-reshaping-the-future-of-machine-learning",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_248_-_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "382860d7-2d4a-49cb-823c-b9d09a0853f9",
            "index": 108,
            "title": "#247 Barr Moses: Why Reliable Data is Key to Building Good AI Systems",
            "pub_date": "2025-04-13T21:00:00.000Z",
            "duration": "55:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "https://aneyeonai.libsyn.com/247-barr-moses-why-reliable-data-is-key-to-building-good-ai-systems",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_247_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90d55501-6105-4be0-a9a5-964d14ed861f",
            "index": 109,
            "title": "#246 Will Granis: How Google Cloud is Powering the Future of Agentic AI",
            "pub_date": "2025-04-09T13:00:00.000Z",
            "duration": "57:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "agent",
              "agents",
              "agentic",
              "gemini"
            ],
            "page_url": "https://aneyeonai.libsyn.com/246-will-granis-how-google-cloud-is-powering-the-future-of-agentic-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_246_-_Audio_v4.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29494fcd-fd92-4e62-9139-a8a22a3b8119",
            "index": 110,
            "title": "#245 Rajat Taneja: Visa's President of Technology Reveals Their $3.3 Billion AI Strategy",
            "pub_date": "2025-04-02T22:30:00.000Z",
            "duration": "24:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/245-rajat-taneja-visas-president-of-technology-reveals-their-33-billion-ai-strategy",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_245_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3aafb9ea-9207-4c8e-a802-e913fc52572d",
            "index": 111,
            "title": "#244 Yoav Shoham on Jamba Models, Maestro and The Future of Enterprise AI",
            "pub_date": "2025-03-27T13:00:00.000Z",
            "duration": "52:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/244-yoav-shoham-on-jamba-models-maestro-and-the-future-of-enterprise-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_244_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f1fa623-84d2-4c4e-825b-80227464935f",
            "index": 112,
            "title": "#243 Greg Osuri: Why the Future of AI Depends on Decentralized Cloud Platforms",
            "pub_date": "2025-03-18T05:30:00.000Z",
            "duration": "59:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/273-greg-osuri-why-the-future-of-ai-depends-on-decentralized-cloud-platforms",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_243_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11486ee7-a2a4-4130-ac63-a047d87c7757",
            "index": 113,
            "title": "#242 Dylan Arena: The AI Education Revolution: How AI is Changing the Way We Learn",
            "pub_date": "2025-03-12T23:00:00.000Z",
            "duration": "57:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/242-dylan-arena-the-ai-education-revolution-how-ai-is-changing-the-way-we-learn",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_242_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "73dc29be-76cb-4702-a7ad-308ba9b295da",
            "index": 114,
            "title": "#241 Patrick M. Pilarski: The Alberta Plan's Roadmap to AI and AGI",
            "pub_date": "2025-03-07T23:00:00.000Z",
            "duration": "01:01:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "robotics",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/241-patrick-m-pilarski-the-alberta-plans-roadmap-to-ai-and-agi",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_241_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5c923802-925f-4bf4-b5ff-7210e3d6f950",
            "index": 115,
            "title": "#240 Manos Koukoumidis: Why The Future of AI is Open-Source",
            "pub_date": "2025-03-04T21:00:00.000Z",
            "duration": "01:06:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/240-manos-koukoumidis-why-the-future-of-ai-is-open-source",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_240_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3479b4e6-5b4e-4580-828a-b1ba9f93a0ed",
            "index": 116,
            "title": "#239 Tuhin Srivatsa: How Baseten is Disrupting AI Deployment & Scaling in 2025",
            "pub_date": "2025-02-26T14:00:00.000Z",
            "duration": "46:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "nvidia",
              "chips",
              "inference",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/270-tuhin-srivatsa-how-baseten-is-disrupting-ai-deployment-scaling-in-2025",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_240_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65e03dd8-38bf-435f-9e18-28d3e8bc3054",
            "index": 117,
            "title": "#238 Dominic Williams Reveals His Vision for the Internet Computer (ICP)",
            "pub_date": "2025-02-20T23:00:00.000Z",
            "duration": "01:14:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/240-dominic-williams-reveals-his-vision-for-the-internet-computer-icp",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_239_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48bf46e0-a073-4324-ac26-2f103f44aa4c",
            "index": 118,
            "title": "#237 Pedro Domingos Breaks Down The Symbolist Approach to AI",
            "pub_date": "2025-02-17T23:00:00.000Z",
            "duration": "48:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/239-pedro-domingos-breaks-down-the-symbolist-approach-to-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_238_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "119d0a9a-6a8b-4d76-9adb-b97a8f46bd46",
            "index": 119,
            "title": "#236 Pedro Domingo's on Bayesians and Analogical Learning in AI",
            "pub_date": "2025-02-09T23:00:00.000Z",
            "duration": "56:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "inference",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/237-pedro-domingos-on-the-five-tribes-of-machine-learning",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_236_-_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5eccf762-eb65-4f0f-9abf-08d7d77b7619",
            "index": 120,
            "title": "#235 Vall Herard: The Future of AI-Driven Compliance (Saifr.ai)",
            "pub_date": "2025-02-03T18:36:00.000Z",
            "duration": "51:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/236-vall-herard-the-future-of-ai-driven-compliance-saifrai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_235_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f316a8a5-9dfd-4cfc-9ab0-48d9ddd9bc6a",
            "index": 121,
            "title": "#234 Tyler Xuan Saltsman: How AI is Shaping the Future of Combat & Warfare",
            "pub_date": "2025-01-29T17:27:00.000Z",
            "duration": "38:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "rag",
              "retrieval"
            ],
            "page_url": "https://aneyeonai.libsyn.com/235-tyler-xuan-saltsman-how-ai-is-shaping-the-future-of-combat-warfare",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_234_-_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8c3f817-e66d-4527-9a95-14d136aef3a0",
            "index": 122,
            "title": "#233 Matt Price: How Crescendo is Disrupting Customer Service with Gen AI",
            "pub_date": "2025-01-26T14:26:00.000Z",
            "duration": "44:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "agents",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/234-matt-price-how-crescendo-is-disrupting-customer-service-with-gen-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_233_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b488059c-556c-4406-b0ab-6f93d884faa0",
            "index": 123,
            "title": "#232 Sepp Hochreiter: How LSTMs Power Modern AI System's",
            "pub_date": "2025-01-22T23:00:00.000Z",
            "duration": "51:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "inference",
              "training",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/232-sepp-hochreiter-how-lstms-power-modern-ai-systems",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_232_-_Audioo.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75eb2ba9-a9da-4cb9-b42d-3c691a30e326",
            "index": 124,
            "title": "#231 Paras Jain: The Future of AI Video Generation with Genmo",
            "pub_date": "2025-01-16T23:00:00.000Z",
            "duration": "47:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/231-paras-jain-the-future-of-ai-video-generation-with-genmo",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_231_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "180357dc-465b-4404-9c97-b30e3309c711",
            "index": 125,
            "title": "#230 Jamie Lerner: How Quantum Solves AI's Need for Unstructured Data Solutions",
            "pub_date": "2025-01-13T21:00:00.000Z",
            "duration": "53:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/230-jamie-lerner-how-quantum-tackles-ais-growing-need-for-unstructured-data-solutions",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_230_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa4dc863-f929-4eac-9d72-728f32ca6f1d",
            "index": 126,
            "title": "#229 Mitesh Agrawal: Why Lambda Labs' AI Cloud Is a Game-Changer for Developers",
            "pub_date": "2025-01-08T14:00:00.000Z",
            "duration": "56:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "inference",
              "training",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/229-mitesh-agrawal-why-lambda-labs-ai-cloud-is-a-game-changer-for-developers",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_229_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "16992316-784e-4900-a5f5-3aa314a79c06",
            "index": 127,
            "title": "#228 Rodrigo Liang: How SambaNova Systems Is Disrupting AI Inference",
            "pub_date": "2025-01-01T23:00:00.000Z",
            "duration": "23:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "inference",
              "training",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/228-rodrigo-liang-how-sambanova-systems-is-disrupting-ai-inference",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_225_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac7a0774-b58d-4831-b8ff-6dcc38780285",
            "index": 128,
            "title": "#227 Sedarius Tekara Perrotta: The Importance of Data Quality in AI Systems",
            "pub_date": "2024-12-29T23:00:00.000Z",
            "duration": "45:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training",
              "rag",
              "retrieval",
              "automation",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/227-sedarius-tekara-perrotta-the-importance-of-data-quality-in-ai-systems",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_227_-_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b2b8f81a-500a-4cb9-a1ac-ecea65fa7c41",
            "index": 129,
            "title": "#226 Nathan Michael: The Future of AI-Powered Drones and Autonomous Warfare (with Shield AI)",
            "pub_date": "2024-12-23T23:00:00.000Z",
            "duration": "58:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/226-nathan-michael-the-future-of-ai-powered-drones-and-autonomous-warfare-with-shield-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_227_-_Audio_v3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "74610fd0-95b7-4e0f-89c7-6dc4791d9466",
            "index": 130,
            "title": "#225 Christian Marek: How AI is Shaping the Future of Product Management",
            "pub_date": "2024-12-18T23:00:00.000Z",
            "duration": "50:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/225-christian-marek-how-ai-is-shaping-the-future-of-product-management",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_226_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e868d703-6166-406d-b0b8-f74488567a19",
            "index": 131,
            "title": "#224 Tariq Shaukat: How Safe Is AI-Assisted Coding?",
            "pub_date": "2024-12-11T14:00:00.000Z",
            "duration": "53:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "coding",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/224-tariq-shaukat-how-safe-is-ai-assisted-coding",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_224_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "81a9f272-00bd-475e-ac43-a66292715a97",
            "index": 132,
            "title": "#224 Matt Panousis: How AI Is Disrupting The Dubbing Industry (LipDub AI)",
            "pub_date": "2024-12-08T07:18:00.000Z",
            "duration": "52:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/how-ai-is-disrupting-the-dubbing-industry-lipdub-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Revolutionizing_Dubbing__How_LipDub_is_Making_Content_Accessible_Worldwide.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7aa31955-67f3-4110-8cf4-313190df4d76",
            "index": 133,
            "title": "#224 Matt Panousis: How AI Is Disrupting The Dubbing Industry (LipDub AI) | Chinese Version",
            "pub_date": "2024-12-08T07:16:00.000Z",
            "duration": "49:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/224-matt-panousis-how-ai-is-disrupting-the-dubbing-industry-lipdub-ai-chinese-version",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/How_AI_Is_Disrupting_The_Dubbing_Industry_LipDub_AI__Chinese_Version_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "155d2916-63d6-488a-aa21-98c9c221ca9b",
            "index": 134,
            "title": "#223 Kai Beckmann: Why Next-Gen Chips Are Critical for AI's Future",
            "pub_date": "2024-12-04T14:00:00.000Z",
            "duration": "44:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chip",
              "chips"
            ],
            "page_url": "https://aneyeonai.libsyn.com/223-kai-beckmann-why-next-gen-chips-are-critical-for-ais-future",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_223_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "85a60932-04bf-42d5-861d-4b732107a89a",
            "index": 135,
            "title": "#222 Andrew Feldman: How Cerebras Systems Is Disrupting AI Inference",
            "pub_date": "2024-11-28T14:00:00.000Z",
            "duration": "42:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "llama",
              "nvidia",
              "inference",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/222-andrew-feldman-how-cerebras-systems-is-disrupting-ai-inference-technology",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_222_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f848bcf4-6e6a-4ed9-9cd1-9c42c23315dc",
            "index": 136,
            "title": "#221 Varun Mohan: The AI Tool That's Changing How Code is Written (Codeium)",
            "pub_date": "2024-11-25T23:00:00.000Z",
            "duration": "23:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "reasoning",
              "automation",
              "coding",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/221-varun-mohan-the-ai-tool-thats-changing-how-code-is-written-codeium",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_221_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c96d05dd-7120-4087-b2ae-5dd181e88361",
            "index": 137,
            "title": "#220 Terry Sejnowski:  The Future of AI, ChatGPT & Deep Learning",
            "pub_date": "2024-11-22T14:00:00.000Z",
            "duration": "01:00:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "chatgpt",
              "training",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/220-terry-sejnowski-the-future-of-ai-chatgpt-deep-learning",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_220_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68dfb228-915a-4661-82b3-de51869f5c92",
            "index": 138,
            "title": "#219 Avthar Sewrathan: How to Build Smarter AI Applications with PostgreSQL",
            "pub_date": "2024-11-18T14:00:00.000Z",
            "duration": "51:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "rag",
              "retrieval",
              "embedding",
              "embeddings"
            ],
            "page_url": "https://aneyeonai.libsyn.com/219-avthar-sewrathan-how-to-build-smarter-ai-applications-with-postgresql",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_219_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3dfa709e-dfce-455a-938c-f16a63eb89c1",
            "index": 139,
            "title": "#218 Jeff Boudier: The Future of Open Source AI Development (Hugging Face)",
            "pub_date": "2024-11-13T14:00:00.000Z",
            "duration": "49:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://aneyeonai.libsyn.com/218-jeff-boudier-the-future-of-open-source-ai-development-hugging-face",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_218_-_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d999a995-d9d4-43e7-9866-8c467d16f426",
            "index": 140,
            "title": "#217 Ben Goertzel: The Path to Artificial General Intelligence, Decentralized AI and AI Consciousness",
            "pub_date": "2024-11-06T23:00:00.000Z",
            "duration": "56:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/217-ben-goertzel-the-path-to-artificial-general-intelligence-decentralized-ai-and-ai-consciousness",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_217_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95e2d3a4-f6d9-40d9-a7fd-3185e9a3696b",
            "index": 141,
            "title": "#216 Nenshad Bardoliwalla: Inside Vertex AI - The Ultimate AI Toolkit by Google Cloud",
            "pub_date": "2024-10-30T13:00:00.000Z",
            "duration": "51:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "agents",
              "gpu",
              "safety",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/216-nenshad-bardoliwalla-inside-vertex-ai-the-ultimate-ai-toolkit-by-google-cloud",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_215_-_Audio_v2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5d2d0f4-bd66-4efb-a549-4779b1a46ed9",
            "index": 142,
            "title": "#215 Manuel Haug: How Celonis Uses AI to Optimize Business Processes",
            "pub_date": "2024-10-23T09:00:00.000Z",
            "duration": "44:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "agents",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/215-manuel-haug-how-celonis-uses-ai-to-optimize-business-processes",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_216_-_Audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa6cb08b-eb3f-4e05-a11d-279c8060bb92",
            "index": 143,
            "title": "#214 Ece Kamar: Why AI Agents Are the Next Big Thing in Tech (Microsoft Research)",
            "pub_date": "2024-10-17T13:00:00.000Z",
            "duration": "01:00:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "reasoning",
              "safety",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/214-ece-kamar-why-ai-agents-are-the-next-big-thing-in-tech-microsoft-research",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_214_-_Audio_v3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7eb0946-fbe6-4c1b-b159-224ebe797f70",
            "index": 144,
            "title": "#213 Mark Surman: How Mozilla Is Shaping the Future of Open-Source AI",
            "pub_date": "2024-10-13T13:00:00.000Z",
            "duration": "47:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "llama",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/213-mark-surman-how-mozilla-is-shaping-the-future-of-open-source-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_22.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5ece4890-438a-4272-a86d-8b87f5801535",
            "index": 145,
            "title": "#212 Thomas Dietterich: The Future of Machine Learning, Deep Learning and Computer Vision",
            "pub_date": "2024-10-09T14:00:00.000Z",
            "duration": "56:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "foundation model",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/212-thomas-dietterich-the-future-of-machine-learning-deep-learning-and-computer-vision",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_212_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f116c892-9e6a-48f0-8ea9-7d8409e2bb56",
            "index": 146,
            "title": "#211 Stuart Hameroff: Why AI Will Never Fully Replicate Human Consciousness",
            "pub_date": "2024-10-06T22:00:00.000Z",
            "duration": "01:15:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/211-stuart-hameroff-exploring-ai-consciousness-and-quantum-states",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_211_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bfcfc149-7c00-4e1c-b750-b7241b761da7",
            "index": 147,
            "title": "#210 Pedro Domingos: Exploring AI's Impact on Politics and Society",
            "pub_date": "2024-09-30T07:30:00.000Z",
            "duration": "57:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "safety",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/210-pedro-domingos-exploring-ais-impact-on-politics-and-society",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_20.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c9c6bfec-086c-4673-82b4-bd6b6380c233",
            "index": 148,
            "title": "#209 Bill Moore: How BCG Created a Conversational AI Co-Host (Inside the Development of GENE)",
            "pub_date": "2024-09-25T13:18:00.000Z",
            "duration": "39:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/209-bill-moore-how-bcg-created-a-conversational-ai-co-host-inside-the-development-of-gene",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_13.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "61a37133-911d-4559-841e-50e3deab4a09",
            "index": 149,
            "title": "#208 Michael Martin: How AI is Saving Lives Every Day (Inside RapidSOS's Groundbreaking Tech)",
            "pub_date": "2024-09-18T13:00:00.000Z",
            "duration": "54:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/208-michael-martin-how-ai-is-saving-lives-every-day-inside-rapidsoss-groundbreaking-tech",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_v3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0517151f-8114-4d18-bb2d-9349a1e90a58",
            "index": 150,
            "title": "#207 Noa Srebrnik: How to Mitigate AI Risk in High-Stakes Industries",
            "pub_date": "2024-09-15T22:00:00.000Z",
            "duration": "47:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/207-noa-srebrnik-how-to-mitigate-ai-risk-in-high-stakes-industries",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Noa.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2eb2da8-b3a8-41b3-93ec-5f97251ba4da",
            "index": 151,
            "title": "#206 Krishna Rangasayee: Why Edge AI is the Next Big Thing in Tech",
            "pub_date": "2024-09-04T22:00:00.000Z",
            "duration": "50:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "chips",
              "robotics",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/206-krishna-rangasayee-why-edge-ai-is-the-next-big-thing-in-tech",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_206_-_AudioFixed.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "767a09be-92a1-46ab-9040-80bd87b50406",
            "index": 152,
            "title": "#205 Randall Degges: The Biggest Risks of AI-Generated Code (What Developers Need to Know!)",
            "pub_date": "2024-08-28T13:00:00.000Z",
            "duration": "53:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "automation",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/205-randall-degges-the-biggest-risks-of-ai-generated-code-what-developers-need-to-know",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_205_-_Audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7795c29c-c613-46de-a774-58eb75d565aa",
            "index": 153,
            "title": "#204 Peter Guagenti: How AI Will Change the Way Developers Work (Tabnine's Vision Explained)",
            "pub_date": "2024-08-21T13:00:00.000Z",
            "duration": "55:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/204-peter-guagenti-how-ai-will-change-the-way-developers-work-tabnines-vision-explained",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_204_-_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "504dcbad-7cbb-429d-84ef-3e4462a38299",
            "index": 154,
            "title": "#203 Xun Wang: How Bloomreach is Shaping the Future of AI-Powered E-Commerce",
            "pub_date": "2024-08-14T13:00:00.000Z",
            "duration": "56:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://aneyeonai.libsyn.com/203-xun-wang-how-bloomreach-is-shaping-the-future-of-ai-powered-e-commerce",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_203_-_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca9e63e2-f454-4e8d-bac9-163e8623f660",
            "index": 155,
            "title": "#202 Raphael Townshend: How AI and RNA Tech is Transforming Drug Discovery (Inside Atomic AI)",
            "pub_date": "2024-08-07T13:00:00.000Z",
            "duration": "59:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/202-raphael-townshend-how-ai-and-rna-tech-is-transforming-drug-discovery-inside-atomic-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_On_AI_202_MP3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "229fa866-2bea-4489-b842-481e3de64c1b",
            "index": 156,
            "title": "#201 Danny Halawi: The Science Behind AI Predictions - Accuracy, Challenges, and Innovations",
            "pub_date": "2024-08-05T01:00:00.000Z",
            "duration": "54:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/201-danny-halawi-the-science-behind-ai-predictions-accuracy-challenges-and-innovations",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Eye_on_AI_201_-_Audio_.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eaf0d6e7-1f61-4553-be6f-cb3775c8e2ba",
            "index": 157,
            "title": "#200 Trevor Back: How Speechmatics is Shaping the Future of Conversational AI",
            "pub_date": "2024-08-01T13:00:00.000Z",
            "duration": "56:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/200-trevor-back-how-speechmatics-is-shaping-the-future-of-conversational-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_Shopify_Mid.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4dcb337-9f98-4344-98ef-6d9dee8ace3b",
            "index": 158,
            "title": "#199 Shub Bhowmick: How Gen AI is Transforming Modern Data Science and Management",
            "pub_date": "2024-07-25T13:00:00.000Z",
            "duration": "52:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/199-shub-bhowmick-how-gen-ai-is-transforming-modern-data-science-and-management",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EOA_199.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8cc2ac01-4b84-4d7c-8786-f781ee858f30",
            "index": 159,
            "title": "#198 Sethuraman Panchanathan: How The U.S. National Science Foundation is Shaping the Future of AI",
            "pub_date": "2024-07-17T13:00:00.000Z",
            "duration": "52:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/198-sethuraman-panchanathan-how-the-us-national-science-foundation-is-shaping-the-future-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/198.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad5fb80b-f4de-4798-9179-7263ec2e02eb",
            "index": 160,
            "title": "#197: AI, Fusion, and National Security with Lawrence Livermore's Brian Spears",
            "pub_date": "2024-07-13T13:00:00.000Z",
            "duration": "56:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/197-ai-fusion-and-national-security-with-lawrence-livermores-brian-spears",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Brian.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e89fefd-93e5-4c98-b6da-e721a300f46b",
            "index": 161,
            "title": "#196 Avi Kedmi: How SysAid Uses AI to Redefine IT Service Management",
            "pub_date": "2024-07-05T13:00:00.000Z",
            "duration": "56:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "automation",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/196-avi-kedmi-how-sysaid-uses-ai-to-redefine-it-service-management",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EIA_197.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a45ee11-5848-40af-8d9d-cdd0edabff6b",
            "index": 162,
            "title": "#195 Mrinal Manohar: Building Secure AI Systems with Blockchain",
            "pub_date": "2024-06-30T13:00:00.000Z",
            "duration": "59:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/195-mrinal-monohar-how-casper-labs-is-disrupting-ai-compliance-with-blockchain-technology",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/195.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f37edc40-2bbb-4b68-adf7-8495c0edb77a",
            "index": 163,
            "title": "#194 Russell Palmer: How AI is Taking Over Hollywood and Changing Filmmaking Forever",
            "pub_date": "2024-06-26T13:10:00.000Z",
            "duration": "48:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/194-russel-palmer-how-ai-is-taking-over-hollywood-and-changing-filmmaking-forever",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_1updated.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dbbe189b-d5cf-4335-9d2c-b357e48811d0",
            "index": 164,
            "title": "#193 Itamar Friedman: How CodiumAI is Making Bug-Free Code a Reality",
            "pub_date": "2024-06-13T13:00:00.000Z",
            "duration": "53:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "deepmind",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/193-itamar-friedman-how-codiumai-is-making-bug-free-code-a-reality",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_New_Intro_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "50f459e9-949a-48e2-ad67-a616a696f24d",
            "index": 165,
            "title": "#192 Lukas Biewald: How Weights and Biases Supercharges Machine Learning",
            "pub_date": "2024-06-09T13:00:00.000Z",
            "duration": "42:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/192-lukas-biewald-the-ultimate-ai-toolkit-how-weights-and-biases-can-boost-your-machine-learning",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_39.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d16db1dd-38c7-4910-a3a1-24e9a70527ee",
            "index": 166,
            "title": "#191 Jonathan Gillham: AI or Human? Exploring Originality AI's Detection Technology",
            "pub_date": "2024-06-05T13:00:00.000Z",
            "duration": "56:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/191-jonathan-gillham-ai-or-human-exploring-originality-ais-detection-technology",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_new_3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d9a5d36d-ab77-43f4-b063-2940d21c73a7",
            "index": 167,
            "title": "#190 Peter Cousins: Fighting Financial Crimes with AI",
            "pub_date": "2024-05-29T13:00:00.000Z",
            "duration": "44:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/190-peter-cousins-ais-role-in-anti-financial-crime",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_New_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e64198f-42ef-4c34-8777-13c46ed93d10",
            "index": 168,
            "title": "#189 Rahul Sonwalkar: The Future of Programming, AI-Powered Code Generation with Julius AI",
            "pub_date": "2024-05-24T13:00:00.000Z",
            "duration": "59:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/189-rahul-sonwalkar-the-future-of-programming-ai-powered-code-generation-with-julius-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_29.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52456530-3585-4c15-ac48-872a3dad93ff",
            "index": 169,
            "title": "#188 Edward Balassanian: The Evolution of AI Music",
            "pub_date": "2024-05-20T13:00:00.000Z",
            "duration": "50:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/188-edward-balassanian-the-evolution-of-ai-music",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_With_Music_By_AIMI.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8fccdf69-ae85-4acc-a032-4d5391bd3575",
            "index": 170,
            "title": "#187 Mohamed Elgendy: Systematic Testing for Generative AI Models with Kolena",
            "pub_date": "2024-05-18T13:00:00.000Z",
            "duration": "57:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/197-mohamed-elgendy-systematic-testing-for-generative-ai-models-with-kolena",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_18.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "716db128-bf10-41f9-b212-5bd5f781c1d0",
            "index": 171,
            "title": "#186 Ronen Dar: Maximizing GPU Utilization for AI with Run:ai",
            "pub_date": "2024-05-12T13:00:00.000Z",
            "duration": "01:10:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "inference"
            ],
            "page_url": "https://aneyeonai.libsyn.com/186-ronen-dar-maximizing-gpu-utilization-for-ai-with-runai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Audio_11.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f0737c2-7d35-4093-adbc-72824e92a7f5",
            "index": 172,
            "title": "#185 Damon Rasheed & Saurabh Jain: Achieving Up to 90% Accuracy in Predicting Drug Clinical Trial Outcomes with Opyl's Trialkey.ai",
            "pub_date": "2024-05-06T13:00:00.000Z",
            "duration": "51:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://aneyeonai.libsyn.com/185-damon-rasheed-saurabh-jain-achieving-up-to-90-accuracy-in-predicting-drug-clinical-trial-outcomes-with-opyls-trialkeyai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/185_updated_audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f8516c43-718d-4b85-a3bc-39ae4a55e861",
            "index": 173,
            "title": "#184 André van Schaik: Building An Artificial Brain With 100 Billion Neurons",
            "pub_date": "2024-05-01T13:00:00.000Z",
            "duration": "46:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/184-andr-van-schaik-building-an-artificial-brain-with-100-billion-neurons",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/183_MP3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e6d2071f-4dac-4ac7-b876-16d48f0f056c",
            "index": 174,
            "title": "#183 Will Falcon: Lightning Studio, an iOS for AI Developers?",
            "pub_date": "2024-04-29T13:00:00.000Z",
            "duration": "50:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/183-william-falcon-how-lightning-studio-transforms-ml-model-deployment-at-scale",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/184_audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97006d24-57a9-4e48-ac71-a44296f1d02a",
            "index": 175,
            "title": "#182 Dragomir Anguelov: The Role of AI and Machine Learning in Waymo's Self-Driving Cars",
            "pub_date": "2024-04-21T13:00:00.000Z",
            "duration": "01:03:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/182-dragomir-anguelov-the-future-of-transportation-waymos-vision-for-autonomous-driving",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/render_182_needs_music_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34f7595b-8c5d-4d17-9c2c-b200a2e7cd72",
            "index": 176,
            "title": "#181 Nick Bostrom: The Meaning of Life in a World where AI can do Everything for Us",
            "pub_date": "2024-04-14T13:50:00.000Z",
            "duration": "55:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "anthropic",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/181-nick-bostrom-the-meaning-of-life-in-a-world-where-ai-can-do-everything-for-us",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/eoa_updated.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29d87878-6132-4601-8952-f8e069549c06",
            "index": 177,
            "title": "#180 Thomas Lah: Navigating AI Adoption in Tech Businesses",
            "pub_date": "2024-04-08T05:44:00.000Z",
            "duration": "53:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/180-thomas-lah-navigating-ai-adoption-in-tech-businesses",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/180.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2fc957f4-6ab1-42e1-8262-142fd2cef69f",
            "index": 178,
            "title": "#179 Ylli Bajraktari: AI and National Security - The Race with China",
            "pub_date": "2024-04-03T13:00:00.000Z",
            "duration": "49:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chips"
            ],
            "page_url": "https://aneyeonai.libsyn.com/179-ylli-bajraktari-ai-and-national-security-the-race-with-china",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd63ca48-6af6-4e53-a6a7-e9a9f630c068",
            "index": 179,
            "title": "#178 Terry Sejnowski on Integrating Human Development Principles into AI Models",
            "pub_date": "2024-03-27T16:00:00.000Z",
            "duration": "52:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "alignment",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/178-terry-sejnowski-is-neuromorphic-engineering-crucial-for-ais-next-leap",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/audio_only_updated_EOA_178.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e074918-51fc-43f1-95cf-a6c4b9a8801f",
            "index": 180,
            "title": "#177 Björn Ommer:  Diffusion Mods Explained By Stable Diffusion's Creator",
            "pub_date": "2024-03-22T13:00:00.000Z",
            "duration": "45:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/177-bjrn-ommer-are-diffusion-models-the-key-to-unlocking-ais-potential",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/audio_EOA_177.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "790d7530-3344-4634-9f91-698f91970ac6",
            "index": 181,
            "title": "#176 Sergey Levine: Decoding The Evolution of AI in Robotics",
            "pub_date": "2024-03-17T16:00:00.000Z",
            "duration": "42:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/176-sergey-levine-decoding-the-evolution-of-ai-controlled-robots",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/eoa_176_audio_finished.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d36e96a4-05ae-40f9-90c0-edad0bee28b1",
            "index": 182,
            "title": "#175 Aravind Srinivas: Revolutionizing Search with Perplexity AI",
            "pub_date": "2024-03-14T13:00:00.000Z",
            "duration": "53:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "perplexity",
              "retrieval"
            ],
            "page_url": "https://aneyeonai.libsyn.com/175-aravind-srinivas-revolutionizing-search-with-perplexity-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/175_audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f62f7b0f-3115-40c1-a8c8-1e436d86fbb9",
            "index": 183,
            "title": "#174 Tianmin Shu: How World Models are Shaping The Future of AI",
            "pub_date": "2024-03-10T13:27:00.000Z",
            "duration": "48:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "reasoning"
            ],
            "page_url": "https://aneyeonai.libsyn.com/174-tianmin-shu-how-world-models-are-shaping-the-future-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/mp3_174.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc6c4e2b-295f-45bd-9416-98cb98869b54",
            "index": 184,
            "title": "#173 Vincent Vanhoucke: How Is AI Helping Advance Robotics?",
            "pub_date": "2024-03-09T19:34:00.000Z",
            "duration": "32:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "robotics",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/173-vincent-vanhoucke-how-is-ai-helping-advance-robotics",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/mp3_eoa_173.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69694e0f-4d93-45ff-8968-398a507307e2",
            "index": 185,
            "title": "#172 Cristóbal Valenzuela: Can AI Revolutionize How We Create Art?",
            "pub_date": "2024-03-03T13:30:00.000Z",
            "duration": "45:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/172-cristbal-valenzuela-can-ai-revolutionize-how-we-create-art",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/AUDIO_FOR_172.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7661a99a-6095-4db8-9ebf-9f631b70a1e0",
            "index": 186,
            "title": "#171 Anna Marie Wagner: Harnessing AI for Synthetic Biology",
            "pub_date": "2024-02-27T14:49:00.000Z",
            "duration": "54:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://aneyeonai.libsyn.com/171-anna-marie-wagner-harnessing-ai-for-synthetic-biology",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/eye_on_ai_171_updated_audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04b29001-16a7-4f7b-a38c-c73ececc213c",
            "index": 187,
            "title": "#170 Richard Sutton on Pursuing AGI Through Reinforcement Learning",
            "pub_date": "2024-02-22T17:00:00.000Z",
            "duration": "55:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://aneyeonai.libsyn.com/170-richard-sutton-on-pursuing-agi-through-reinforcement-learning",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/audio_new.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e95fe9c-299a-4ee7-9404-db3da625846a",
            "index": 188,
            "title": "#169 Guillermo Rauch: How To Use AI to Improve Web Development",
            "pub_date": "2024-02-14T14:00:00.000Z",
            "duration": "59:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "coding",
              "copilot"
            ],
            "page_url": "https://aneyeonai.libsyn.com/169-guillermo-rauch-how-to-use-ai-to-improve-web-development",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/PODCAST_1_VF_audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "78f8ec08-b5e3-47c2-9477-625b758c507f",
            "index": 189,
            "title": "#168 Ian Bremmer on Regulating AI for a Safer Future",
            "pub_date": "2024-02-07T17:34:00.000Z",
            "duration": "54:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://aneyeonai.libsyn.com/168-ian-bremmer-on-regulating-ai-for-a-safer-future",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/IAN_BREMMER_INTRO_OUTRO-Craig-webcam-00h_00m_00s_281ms-StreamYard_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "448a398b-02c0-406b-af67-4dd20fbbd5d0",
            "index": 190,
            "title": "#167 Matt Powell: The Impact of AI on Security and Surveillance",
            "pub_date": "2024-02-02T13:18:00.000Z",
            "duration": "01:05:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/167-matt-powell-the-impact-of-ai-on-security-and-surveillance",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/167_Audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "49670b61-482a-491f-b3f5-8181718b2434",
            "index": 191,
            "title": "#166 Itamar Arel: Is Voice AI the Future of Customer Service?",
            "pub_date": "2024-01-24T14:00:00.000Z",
            "duration": "45:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://aneyeonai.libsyn.com/166-itamar-arel-is-voice-ai-the-future-of-customer-service",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f36ed7b-930c-4e71-bda1-e1e548054fe5",
            "index": 192,
            "title": "#165 Andy Hock: Will AI Revolutionize How We Do Business?",
            "pub_date": "2024-01-17T15:06:00.000Z",
            "duration": "01:06:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gpu",
              "chip",
              "inference",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/165-andy-hock-can-ai-fully-automate-your-business",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EYE_ON_AI_165_AUDIO.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d407a29c-1b8b-4d39-8abe-07b0d4f518de",
            "index": 193,
            "title": "#164 Hrant Khachatrian: Deep Dive Into The Breakthroughs & Challenges of AI Research",
            "pub_date": "2024-01-08T15:36:00.000Z",
            "duration": "01:01:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/164-hrant-khachatrian-deep-dive-into-the-breakthroughs-challenges-of-ai-research",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/IMG_7293.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89b69f20-124d-4c6a-9833-6f21201d04ad",
            "index": 194,
            "title": "#163 Rem Darbinyan: Inside The Armenia's Tech Revolution & Rise of AI Startups",
            "pub_date": "2024-01-03T11:55:00.000Z",
            "duration": "51:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://aneyeonai.libsyn.com/163-rem-darbinyan-inside-the-armenias-tech-revolution-rise-of-ai-startups",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/EYE_ON_AI_-_AUDIO.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "03c1d477-178f-4659-8cc6-4f25a384fb81",
            "index": 195,
            "title": "#162 Vasi Philomin: Behind the Scenes of Amazon's AI Breakthroughs",
            "pub_date": "2023-12-29T12:12:00.000Z",
            "duration": "39:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "automation",
              "enterprise ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/162-vasi-philomin-behind-the-scenes-of-amazons-ai-breakthroughs",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/162_Audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4a36a47-dad0-41cd-80ac-fdf745e12876",
            "index": 196,
            "title": "#161 Harut Martirosyan: What Secrets Lie Behind Armenia's AI Surge?",
            "pub_date": "2023-12-20T13:22:00.000Z",
            "duration": "44:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/161-harut-martirosyan-what-secrets-lie-behind-armenias-ai-surge",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/161_Audio_1_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4511f388-f052-49fe-a882-3d02cf87e6c8",
            "index": 197,
            "title": "#160 Atul Deo: The Future of Generative AI at Amazon",
            "pub_date": "2023-12-06T15:00:00.000Z",
            "duration": "49:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "gpu",
              "rag",
              "retrieval",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/160-atul-deo-the-future-of-generative-ai-at-amazon",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/160__Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c9e1fb48-23be-480a-aa8f-f6b2dcc8a041",
            "index": 198,
            "title": "#159 Peter Chen: Building the AI-Driven Future of Robotics",
            "pub_date": "2023-12-03T14:00:00.000Z",
            "duration": "51:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "generative ai",
              "agents",
              "openai",
              "training",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/159-peter-chen-building-the-ai-driven-future-of-robotics",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/159_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7ab9d162-38a4-483e-8d7b-684f1c4d4df3",
            "index": 199,
            "title": "#158 Connor Leahy: The Unspoken Risks of Centralizing AI Power",
            "pub_date": "2023-11-29T14:00:00.000Z",
            "duration": "01:05:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/158-connor-leahy",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/158_Audio_3.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48ec8405-3379-43eb-9677-cabb5a26370c",
            "index": 200,
            "title": "#157 Karen Hao: Inside OpenAI's Tumultuous Saga",
            "pub_date": "2023-11-23T14:00:00.000Z",
            "duration": "41:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "openai",
              "chip",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/157-karen-hao-the-untold-truth-behind-openai-sam-altmans-drama",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/157_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c28dfaa-00c0-4b1e-8606-00054015da0a",
            "index": 201,
            "title": "#156 Gordon Crovitz: Will AI SPREAD Misinformation & Fake News?",
            "pub_date": "2023-11-22T14:00:00.000Z",
            "duration": "48:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/156-gordon-crovitz-will-ai-spread-misinformation-fake-news",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/156_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1b113b8b-c5e3-481f-b369-ac62edf1437e",
            "index": 202,
            "title": "#155 Alex Wiltschko: From Molecules to Memories & The AI Approach to Scent Detection",
            "pub_date": "2023-11-19T11:44:00.000Z",
            "duration": "01:03:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/155-alex-wiltschko-from-molecules-to-memories-the-ai-approach-to-scent-detection",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/155_Audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48b42eda-f860-40be-a145-71ef222ec551",
            "index": 203,
            "title": "#154 Sal Khan: Revolutionizing Education with AI",
            "pub_date": "2023-11-15T14:00:00.000Z",
            "duration": "45:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/154-sal-khan-revolutionizing-education-with-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/154_intro_2_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "033fa24d-3a56-4aad-b52d-3d8d91d71257",
            "index": 204,
            "title": "#153 Ed Anuff: Unpacking AI's Role in Data Management",
            "pub_date": "2023-11-12T14:00:00.000Z",
            "duration": "59:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "retrieval",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/153-ed-enuff-unpacking-ais-role-in-data-management",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/153_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d10acfe-027c-4ad6-86b3-dcf745174972",
            "index": 205,
            "title": "#152 Alex Kendall: How Close Is AI to Taking the Wheel?",
            "pub_date": "2023-11-08T13:47:00.000Z",
            "duration": "56:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/152-alex-kendall-how-close-is-ai-to-taking-the-wheel",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/AI_152_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d50b81c6-687d-43d8-ac65-68b9d105b0f7",
            "index": 206,
            "title": "#151 Asa Cooper: How Will We Know If AI Is Fooling Us?",
            "pub_date": "2023-11-05T14:00:00.000Z",
            "duration": "59:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "safety",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/151-asa-cooper-does-ai-even-know-what-its-talking-about",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/151_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f39ecfd-d871-4fc1-bd38-3c36223c126d",
            "index": 207,
            "title": "#150: Yann LeCun on World Models, AI Threats and Open-Sourcing",
            "pub_date": "2023-11-02T13:00:00.000Z",
            "duration": "55:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/150-yann-lecun-on-world-models-ai-threats-and-open-sourcing",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/150_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f36a6f32-1832-42d6-9b9f-f63ce88b9347",
            "index": 208,
            "title": "#149 Alex Klein: The Next Wave of AI To Rock The Music Industry",
            "pub_date": "2023-10-30T17:41:00.000Z",
            "duration": "55:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/149-alex-klein-the-next-wave-of-ai-to-rock-the-music-industry",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/149_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8adb1f54-fe78-4845-bacf-279d2db372fc",
            "index": 209,
            "title": "#148 Ahmed Imtiaz: Exploring AI Generative Models, Model Autophagy Disorder & Open-Source Challenges",
            "pub_date": "2023-10-26T17:46:00.000Z",
            "duration": "01:00:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/148-ahmed-imtiaz-exploring-ai-generative-models-model-autophagy-disorder-open-source-challenges",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/148_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42cf23f2-7c0f-4106-8a64-18e13bcdc17c",
            "index": 210,
            "title": "#147 Yilun Du: AI Debates, Reinforcement Learning, & The Power of Generative Models",
            "pub_date": "2023-10-22T12:54:00.000Z",
            "duration": "55:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "agents",
              "openai",
              "deepmind",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/147-yilun-du-ai-debates-reinforcement-learning-the-power-of-generative-models",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/147_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5fc87d65-6c3e-45e5-b508-987e21d28d1d",
            "index": 211,
            "title": "#146 Viren Jain: How Google's AI is Pioneering Brain Mapping Research",
            "pub_date": "2023-10-18T13:00:00.000Z",
            "duration": "01:03:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/146-viren-jain-how-googles-ai-is-pioneering-brain-mapping-research",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/146_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "78b82d6c-bd2c-471a-a6e7-efeaf3a270bf",
            "index": 212,
            "title": "#145 Riley McComrack: Digimarc's CEO on Digital Watermarking in the Age of AI",
            "pub_date": "2023-10-15T14:00:00.000Z",
            "duration": "01:03:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/145-riley-mccomrack-digimarcs-ceo-on-digital-watermarking-in-the-age-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/145_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5b6532cc-319a-4e49-9646-6d8eeee0fed3",
            "index": 213,
            "title": "#144 Matt Hicks: Red Hat's CEO on Open Source, Linux, and the AI Revolution",
            "pub_date": "2023-10-11T13:00:00.000Z",
            "duration": "56:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/144-matt-hicks-red-hats-ceo-on-open-source-linux-and-the-ai-revolution",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/144_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef696f20-4e5c-4149-b373-f3be975739f1",
            "index": 214,
            "title": "#143 Scott Aaronson: Revealing the Truth About Quantum Computing",
            "pub_date": "2023-10-09T09:14:00.000Z",
            "duration": "01:09:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/143-scott-aaronson-revealing-the-truth-about-quantum-computing",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/143_Cut_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c6e0e006-467a-45d8-a529-8611bac4efa3",
            "index": 215,
            "title": "#142 Arjun Subramonian: The Intersection of AI, Diversity, and Ethics",
            "pub_date": "2023-10-04T13:00:00.000Z",
            "duration": "46:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/142-arjun-subramonian-the-intersection-of-ai-diversity-and-ethics",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/142_Audio_5.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46aa4f40-4f3d-4c24-8556-bc2f2bdeb801",
            "index": 216,
            "title": "#141 Peter Voss Reveals the Future of Artificial General Intelligence",
            "pub_date": "2023-10-01T12:00:00.000Z",
            "duration": "01:02:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/141-peter-voss-reveals-the-future-of-artificial-general-intelligence",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/141.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "638a12e6-ecdc-4cf4-a159-4d5d3bb58d25",
            "index": 217,
            "title": "#140 Isabelle Guyon: The Future of AI and Support Vector Machines",
            "pub_date": "2023-09-27T22:00:00.000Z",
            "duration": "47:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/140-isabelle-guyon-the-future-of-ai-and-support-vector-machines",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/140_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7a11d70d-52af-4894-93d7-744a74516311",
            "index": 218,
            "title": "#139 Dmitry Shapiro: Breaking Barriers with No Code AI",
            "pub_date": "2023-09-20T12:00:00.000Z",
            "duration": "57:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/139-dmitry-shapiro-breaking-barriers-with-no-code-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/139_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca572c89-3db8-4228-a4d4-9b8d695107b9",
            "index": 219,
            "title": "#138 Dan O'Connell: How AI is Disrupting Business Communications",
            "pub_date": "2023-09-13T13:59:00.000Z",
            "duration": "30:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "agents",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/138-dan-oconnell-how-ai-is-disrupting-business-communications",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/138_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6aef719e-4197-413f-a761-1e898c35e982",
            "index": 220,
            "title": "#137 Raul Martynek: How AI Will Change Data Centers Forever",
            "pub_date": "2023-09-06T06:52:00.000Z",
            "duration": "47:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "data center"
            ],
            "page_url": "https://aneyeonai.libsyn.com/137-raul-martynek-how-ai-will-change-data-centers-forever",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/137_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a25076b2-9e14-4c00-b006-894cc4daa423",
            "index": 221,
            "title": "#135 Diaa El All: How AI Could Change Music Forever",
            "pub_date": "2023-08-23T09:41:00.000Z",
            "duration": "38:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "coding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/135-diaa-el-all-how-ai-could-change-music-forever",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/135_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a9c54fc-94c6-40ee-881e-fc538eea63a4",
            "index": 222,
            "title": "#134 Alex Zhavoronkov: Unraveling AI's Crucial Role in Pharma",
            "pub_date": "2023-08-16T22:10:00.000Z",
            "duration": "01:23:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/134-alex-zhavoronkov-unraveling-ais-crucial-role-in-pharma",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/134_Audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "24330ba1-b85c-428f-b07f-f2003c567d0c",
            "index": 223,
            "title": "#133 Michael Jordan: How Deep Learning Has Completely Changed Industries",
            "pub_date": "2023-08-09T07:53:00.000Z",
            "duration": "01:06:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent"
            ],
            "page_url": "https://aneyeonai.libsyn.com/133-michael-jordan-how-deep-learning-has-completely-changed-industries",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/133_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22cfd3cb-2bf4-4bf0-a56f-d0d5aef59d08",
            "index": 224,
            "title": "#132 Scott Downes: Navigating the Language of AI & Large Language Models",
            "pub_date": "2023-08-02T12:40:00.000Z",
            "duration": "01:04:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/132-scott-downes-navigating-the-language-of-ai-large-language-models",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/132_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "31e67fbd-872d-4e9d-9d4e-00a6117ee1df",
            "index": 225,
            "title": "#131 Andrew Ng: Exploring Artificial Intelligence's Potential & Threats",
            "pub_date": "2023-07-26T21:52:00.000Z",
            "duration": "33:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/131-andrew-ng-exploring-artificial-intelligences-potential-threats",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/131_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5150ae6-6652-4fcd-a52d-32e2b88c6f74",
            "index": 226,
            "title": "#130 Mathew Lodge: The Future of Large Language Models in AI",
            "pub_date": "2023-07-19T21:00:00.000Z",
            "duration": "49:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/130-mathew-lodge-the-future-of-large-language-models-in-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/130_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a47d73e5-18b6-4ea0-9240-1b6b7c7f2d1e",
            "index": 227,
            "title": "#129 Alexandra Geese: Demystifying AI Regulations in Europe & Beyond",
            "pub_date": "2023-07-12T05:36:00.000Z",
            "duration": "58:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/tbc-2",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/129_Audio.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac354676-c2e6-43b1-8db7-7e93fa906e7e",
            "index": 228,
            "title": "#128 Yoshua Bengio: Dissecting The Extinction Threat of AI",
            "pub_date": "2023-07-06T04:00:00.000Z",
            "duration": "48:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "large language model",
              "safety"
            ],
            "page_url": "https://aneyeonai.libsyn.com/tbc-1",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/128_Audionew.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b8a7012f-68ec-400a-8fb1-a8bf522680c3",
            "index": 229,
            "title": "#127 Clemens Mewald: Redefining the Boundaries of Artificial Intelligence & GPT-4",
            "pub_date": "2023-06-29T00:26:00.000Z",
            "duration": "01:02:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "reasoning",
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/127-clemens-mewald-redefining-the-boundaries-of-artificial-intelligence-gpt-4",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/127_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e829e078-3774-457d-a980-a7d3acadc0cd",
            "index": 230,
            "title": "#126 Noam Chomsky: Decoding the Human Mind & Neural Nets",
            "pub_date": "2023-06-22T22:56:00.000Z",
            "duration": "58:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/126-noam-chomsky-decoding-the-human-mind",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/126_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d773f7ea-61b6-482e-83cb-fa1b7b41b53c",
            "index": 231,
            "title": "#125 Pascal Weinberger: Harnessing the Power of Generative AI for Creativity & Productivity",
            "pub_date": "2023-06-15T00:17:00.000Z",
            "duration": "57:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai"
            ],
            "page_url": "https://aneyeonai.libsyn.com/tbc-0",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/125_Audio_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1b9ca70c-f55b-42cd-9b00-ec35fc0d8fcb",
            "index": 232,
            "title": "#124 Sina Kian: Reshaping Privacy in the AI & Machine Learning Revolution",
            "pub_date": "2023-06-08T08:13:00.000Z",
            "duration": "57:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://aneyeonai.libsyn.com/tbc",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/124_Audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f876d0f-1928-4cc7-9330-e8b66f973127",
            "index": 233,
            "title": "#123 Aidan Gomez: How AI Language Models Will Shape The Future",
            "pub_date": "2023-05-24T23:17:00.000Z",
            "duration": "01:02:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://aneyeonai.libsyn.com/aidan-gomez-tbc",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/123_Audio_2.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cbeadabd-e4af-4c8e-a7e3-589b62dbc429",
            "index": 234,
            "title": "#122 Connor Leahy: Unveiling the Darker Side of AI",
            "pub_date": "2023-05-10T13:15:00.000Z",
            "duration": "56:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "chatgpt",
              "openai",
              "alignment"
            ],
            "page_url": "https://aneyeonai.libsyn.com/122-conor-leahy-unveiling-the-darker-side-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/connor.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6816adc1-f590-4717-9e0f-c178fddc80d9",
            "index": 235,
            "title": "Danny Tobey: At the Intersection of Law and Artificial Intelligence",
            "pub_date": "2023-04-28T03:17:00.000Z",
            "duration": "55:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://aneyeonai.libsyn.com/is-that-legal-danny-tobey-on-ai-law",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Danny_Tobey_1.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "60dfef77-72d3-495d-bb28-b7ce2ead39ea",
            "index": 236,
            "title": "Yoshua Bengio: Pausing More Powerful AI Models and His Work on World Models",
            "pub_date": "2023-04-13T00:13:00.000Z",
            "duration": "40:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "robotics"
            ],
            "page_url": "https://aneyeonai.libsyn.com/yoshua-bengio-on-pausing-more-powerful-ai-models-and-his-work-on-world-models",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Yoshua.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "31ad276b-91b4-425b-92ce-18b119c4d91c",
            "index": 237,
            "title": "Edo Liberty: Solving ChatGPT Hallucinations With Vector Embeddings",
            "pub_date": "2023-03-30T15:07:00.000Z",
            "duration": "35:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "embeddings"
            ],
            "page_url": "https://www.eye-on.ai/podcast-archive",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/edo_final.m4a?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "faf71c9c-bd2c-43a9-85ae-e5810609c258",
            "index": 238,
            "title": "Ilya Sutskever: The Mastermind Behind GPT-4 and the Future of AI",
            "pub_date": "2023-03-15T19:38:00.000Z",
            "duration": "43:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "training",
              "multimodal"
            ],
            "page_url": "https://aneyeonai.libsyn.com/ilya-sutskever",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/ILYA_SUTSKEVER_FINAL_FINAL.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f1601ff3-e396-43ea-b438-e6741cc630c8",
            "index": 239,
            "title": "Ben Sorscher: Data Pruning for Efficient Machine Learning",
            "pub_date": "2023-03-02T02:54:00.000Z",
            "duration": "34:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://aneyeonai.libsyn.com/data-pruning",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Ben_Sorscher_FINAL.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "801e8954-3ef1-48dc-972b-127eea4c17e0",
            "index": 240,
            "title": "Yann LeCun: Filling the Gap in Large Language Models",
            "pub_date": "2023-02-16T01:45:00.000Z",
            "duration": "55:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embedding"
            ],
            "page_url": "https://aneyeonai.libsyn.com/yann-lecun",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Yann_final.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1e319a19-9d93-455e-b1a1-44976fe9345f",
            "index": 241,
            "title": "Terry Sejnowski: NeurIPS and the Future of AI",
            "pub_date": "2023-02-01T17:25:00.000Z",
            "duration": "37:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://aneyeonai.libsyn.com/terry-sejnowski-on-neurips-and-the-future-of-ai",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Terr_Sejnowski_episode.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dde3e1cd-ab46-472e-be06-86e20162c6d4",
            "index": 242,
            "title": "Geoffrey Hinton: Unpacking The Forward-Forward Algorithm",
            "pub_date": "2023-01-19T08:11:00.000Z",
            "duration": "58:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://aneyeonai.libsyn.com/geoff-hinton-on-forward-forward",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Geoff_Hinton_Final.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "93684829-2f5b-4898-b16e-2b34d59f009e",
            "index": 243,
            "title": "Setting the stage for 2023",
            "pub_date": "2023-01-02T04:51:00.000Z",
            "duration": "01:00:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://aneyeonai.libsyn.com/setting-the-stage-for-2023",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Terry_Geoff_Yann_Andrew.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4bea0c06-5d19-472a-886a-3b42267153e7",
            "index": 244,
            "title": "AI Supply Chain Optimization",
            "pub_date": "2022-11-09T05:39:00.000Z",
            "duration": "40:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/ai-supply-chain-optimization",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Supply_Chains.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4a21fb3f-364d-408a-b506-338ecae1b03d",
            "index": 245,
            "title": "NO-CODE WITH AKKIO",
            "pub_date": "2022-10-20T16:00:00.000Z",
            "duration": "45:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/no-code-with-akkio",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/akkio_episode.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "92c731cf-f1e5-4eb6-bbaf-2fc7e1013839",
            "index": 246,
            "title": "MLOps with ClearML",
            "pub_date": "2022-10-05T12:18:00.000Z",
            "duration": "42:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://aneyeonai.libsyn.com/mlops-with-clearml",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/CLEARML.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2a42c511-52f2-4cc4-ae3b-cde8eaaf7fc6",
            "index": 247,
            "title": "Amazon's Sagemaker",
            "pub_date": "2022-09-21T14:23:12.000Z",
            "duration": "19:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/amazons-sagemaker",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Saha.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02088d2e-26e7-4060-90fc-ab646c5b3d6f",
            "index": 248,
            "title": "AUTOMATED CODE GENERATION",
            "pub_date": "2022-09-08T15:58:57.000Z",
            "duration": "29:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://aneyeonai.libsyn.com/automated-code-generation",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/shrammel.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4d281459-3b87-4886-96c2-c8f725b74ca7",
            "index": 249,
            "title": "Michael Kearns on Privacy",
            "pub_date": "2022-08-25T14:21:13.000Z",
            "duration": "30:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://aneyeonai.libsyn.com/michael-kearns-on-privacy",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/Michael_Kearns.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f69bccaa-45c4-4bfa-a4ec-b607a9ab0fa2",
            "index": 250,
            "title": "XPRIZE TELEPORTATION",
            "pub_date": "2022-08-10T15:16:10.000Z",
            "duration": "36:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://aneyeonai.libsyn.com/xprize-teleportation",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pscrb.fm/rss/p/pdst.fm/e/arttrk.com/p/VI4CS/prfx.byspotify.com/e/mgln.ai/e/p58841/pscrb.fm/rss/p/traffic.libsyn.com/secure/aneyeonai/XPRIZE.mp3?dest-id=727317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "ai-in-business",
        "title": "The AI in Business Podcast",
        "feed_title": "The AI in Business Podcast",
        "priority": "P1",
        "selection_mode": "all_ai",
        "focus": [
          "enterprise AI",
          "ROI",
          "vertical use cases",
          "executive adoption"
        ],
        "feed_url": "https://rss.libsyn.com/shows/45920/destinations/151434.xml",
        "source_url": "https://rss.libsyn.com/shows/45920/destinations/151434.xml",
        "detail_path": "/podcasts/ai-in-business/",
        "episode_count": 250,
        "selected_episode_count": 250,
        "latest_episode_title": "How AI Is Reshaping the Way Enterprises Build Software - With Tim Sears of HTEC",
        "latest_pub_date": "2026-06-05T06:00:00.000Z",
        "latest_page_url": "https://podcast.emerj.com/how-ai-is-reshaping-the-way-enterprises-build-software-with-tim-sears-of-htec",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "ce62903c-2e3c-429d-af43-9763ec3af5a1",
            "index": 1,
            "title": "How AI Is Reshaping the Way Enterprises Build Software - With Tim Sears of HTEC",
            "pub_date": "2026-06-05T06:00:00.000Z",
            "duration": "21:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-ai-is-reshaping-the-way-enterprises-build-software-with-tim-sears-of-htec",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Tim_Sears.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc74b47b-ec28-454b-ba6c-8768fb044636",
            "index": 2,
            "title": "How Industrial Service Leaders Are Closing the Knowledge Gap Before It's Too Late with Mike Hughes of Peak International Group",
            "pub_date": "2026-06-04T06:00:00.000Z",
            "duration": "26:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-industrial-service-leaders-are-closing-the-knowledge-gap-before-its-too-late-with-mike-hughes-of-peak-international-group",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Mike_Hughes.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6744d97f-0605-4061-9eac-0a0db1e22970",
            "index": 3,
            "title": "Human-Centered AI Development Strategies for CPG Leaders - with Shaje Ganny of Procter & Gamble",
            "pub_date": "2026-06-02T06:00:00.000Z",
            "duration": "29:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/human-centered-ai-development-strategies-for-cpg-leaders-with-shaje-ganny-of-procter-gamble",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Shaje_Ganny_PG_6.2.2026.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "150d00ba-41cc-4790-b8fd-be8ecb28f8e7",
            "index": 4,
            "title": "The Pricing Shift Reshaping Enterprise AI Spend  - with Adam Mansfield of UpperEdge",
            "pub_date": "2026-06-01T06:00:00.000Z",
            "duration": "37:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/the-pricing-shift-reshaping-enterprise-ai-spend-with-adam-mansfield-of-upperedge",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB__Adam_Mansfield.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "539aeadc-351a-4693-91d5-7a30e7aef6d7",
            "index": 5,
            "title": "Why the Way AI Feels Is as Important as How It Works - with Carsten Wierwille of HTEC",
            "pub_date": "2026-05-29T06:00:00.000Z",
            "duration": "25:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/why-the-way-ai-feels-is-as-important-as-how-it-works-with-carsten-wierwille-of-htec",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Carsten_Wierwille_5.27.2026.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1928b69d-45ac-470d-8d21-f7b4cf589154",
            "index": 6,
            "title": "How Vision AI Scales Across a Manufacturing Network - with Jeff Witt",
            "pub_date": "2026-05-28T06:00:00.000Z",
            "duration": "23:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-vision-ai-scales-across-a-manufacturing-network-with-jeff-witt",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Jeff_Witt_5.27.2026.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "df122aaa-96f9-4724-96c7-986e61449359",
            "index": 7,
            "title": "AI Improving Dose Decisions and Patient Outcomes in Oncology- with Shefali Kakar of Novartis",
            "pub_date": "2026-05-26T06:00:00.000Z",
            "duration": "18:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/ai-improving-dose-decisions-and-patient-outcomes-in-oncology-with-shefali-kakar-of-novartis",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Shefali_Kakar_Final_Audio_5.26.2026.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13bd2514-0e3c-4dba-a879-51ff30f354f6",
            "index": 8,
            "title": "Breaking Free from AI Overwhelm in Banking and Financial Services - with Art Shectman of Elephant Ventures",
            "pub_date": "2026-05-25T06:00:00.000Z",
            "duration": "33:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/breaking-free-from-ai-overwhelm-in-banking-and-financial-services-with-art-shectman-of-elephant-ventures",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Art_Shectman.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2013ca83-04b9-4aa2-9b15-fa5dc5c3de4f",
            "index": 9,
            "title": "Fixing the Pilot‑to‑Production Gap in Enterprise AI - with Ronny Fehling of HTEC",
            "pub_date": "2026-05-22T06:00:00.000Z",
            "duration": "28:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/fixing-the-pilottoproduction-gap-in-enterprise-ai-with-ronny-fehling-of-htec",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Ronnie_Fehling.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f6bdce3-427e-4936-ac48-4911edc09bb4",
            "index": 10,
            "title": "Why Deepfake Fraud Beats Your Workflows, Not Your Technology - with Jon-Rav Shende of Thales Group",
            "pub_date": "2026-05-21T06:00:00.000Z",
            "duration": "28:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://podcast.emerj.com/why-deepfake-fraud-beats-your-workflows-not-your-technology-with-jon-rav-shende-of-thales-group",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Jon-Rav_Shende.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a226453-3fb6-42d0-90a1-bc9fca4dee48",
            "index": 11,
            "title": "Scaling Scientific R&D with AI Supercomputing Infrastructure — with Thomas Fuchs of Eli Lilly",
            "pub_date": "2026-05-19T06:00:00.000Z",
            "duration": "25:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/scaling-scientific-rd-with-ai-supercomputing-infrastructure-with-thomas-fuchs-of-eli-lilly",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AIB_Thomas_Fuchs.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c112005-3a0b-46f4-8828-33c82a3595d0",
            "index": 12,
            "title": "The Hidden Risk in Every Enterprise AI Vendor Contract - with John Belden of UpperEdge",
            "pub_date": "2026-05-18T06:00:00.000Z",
            "duration": "28:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/the-hidden-risk-in-every-enterprise-ai-vendor-contract-with-john-belden-of-upperedge",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Ed_Upper_Edge_Final_Audio_Internal_Episode1_John_Belden.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "375c5524-ae0c-4a46-9e75-c85d5aa185a5",
            "index": 13,
            "title": "The Architecture Shift Behind Reliable Enterprise AI - with Ravi Marwaha of Arango",
            "pub_date": "2026-05-14T06:00:00.000Z",
            "duration": "37:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/the-architecture-shift-behind-reliable-enterprise-ai-with-ravi-marwaha-of-arango",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Ed_Arango_Internal_Podcast_1_Final_Audio_Ravi_Marwaha.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fe4d7fc9-1435-430f-ab70-68983a91b110",
            "index": 14,
            "title": "Why Manufacturing's Most Valuable Data Isn't in Any System — with Anand Gnanamoorthy of Ingersoll Rand",
            "pub_date": "2026-05-13T15:00:00.000Z",
            "duration": "31:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/why-manufacturings-most-valuable-data-isnt-in-any-system-with-anand-gnanamoorthy-of-ingersoll-rand",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.13.26_-_Anand_Gnanamoorthy.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "39d17d8c-6577-48c9-bf7c-c5d109c7cd09",
            "index": 15,
            "title": "Why Predictive AI in Service Only Works on the Right Foundation - with Niken Patel of Neuron7.ai",
            "pub_date": "2026-05-13T06:00:00.000Z",
            "duration": "28:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/why-predictive-ai-in-service-only-works-on-the-right-foundation-with-niken-patel-of-neuron7ai",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Niken_Patel.05.07.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02c99b1b-fff0-4245-abfc-14015910050f",
            "index": 16,
            "title": "Building Predictive Safety Systems in Energy Operations - with Patricio Rivera of Oxy",
            "pub_date": "2026-05-12T06:00:00.000Z",
            "duration": "23:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/building-predictive-safety-systems-in-energy-operations-with-patricio-rivera-of-oxy",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_Patricio_Rivera_5.11.2026.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5de5f4c0-6665-4c4c-8bf1-e8050297e641",
            "index": 17,
            "title": "Fixing the Pilot‑to‑Production Gap in Enterprise AI - with Lawrence Whittle of HTEC Group",
            "pub_date": "2026-05-11T06:00:00.000Z",
            "duration": "37:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/fixing-the-pilottoproduction-gap-in-enterprise-ai-with-lawrence-whittle-of-htec-group",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.11.26_-_Lawrence_Whittle_.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a7c227c0-4868-41f8-bc2f-8988981449ff",
            "index": 18,
            "title": "From Experimentation to Clinical-grade AI in Healthcare - with Alex Tyrrell of Wolters Kluwer",
            "pub_date": "2026-05-05T06:00:00.000Z",
            "duration": "30:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/from-experimentation-to-clinical-grade-ai-in-healthcare-with-alex-tyrrell-of-wolters-kluwer",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Alex_Tyrrell.05.01.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4ee4f1d2-d44b-4450-8c7c-5ab61f41495e",
            "index": 19,
            "title": "Capturing Tribal Knowledge to Solve the Manufacturing Skills Gap - with Sebastian Dykas of Smith+Nephew",
            "pub_date": "2026-05-01T06:00:00.000Z",
            "duration": "34:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://podcast.emerj.com/capturing-tribal-knowledge-to-solve-the-manufacturing-skills-gap-with-sebastian-dykas-of-smithnephew",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_Sebastian_Dykas_-_05.01.26_mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e18bd8a1-d19a-4e1f-b16d-7e6a4881d76d",
            "index": 20,
            "title": "Designing Supply Chains for Volatility - with Dr. Gopalendu Pal of Target",
            "pub_date": "2026-04-28T06:00:00.000Z",
            "duration": "26:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/how-digital-transformation-shortens-the-path-to-clinical-trials-with-dr-gopalendu-pal-of-target",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Dr_Gopalendu_Pal.04.25.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0ac0a478-6526-4d46-b422-f21a2b90af40",
            "index": 21,
            "title": "Operationalizing Real-Time Voice Intelligence for FinServ and CX - with Ken Morino of Modulate",
            "pub_date": "2026-04-24T06:00:00.000Z",
            "duration": "37:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/operationalizing-real-time-voice-intelligence-for-finserv-and-cx-with-ken-morino-of-modulate",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Ken_Morino.04.19.26_Remaster.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e0460e4-e8f9-428c-a771-716c27d4de65",
            "index": 22,
            "title": "Building Trustworthy AI for Enterprise Workflows - with Amar Akshat of PaySafe",
            "pub_date": "2026-04-21T06:00:00.000Z",
            "duration": "20:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "embedding",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/building-trustworthy-ai-for-enterprise-workflows-with-amar-akshat-of-paysafe",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Amar-Akshat04.18.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e58e9ad1-eeef-429e-840c-da2d68e2fd31",
            "index": 23,
            "title": "Scaling Regulated Data Workflows Without Lock‑In - with Juan Orlandini of Insight",
            "pub_date": "2026-04-17T06:00:00.000Z",
            "duration": "22:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/scaling-regulated-data-workflows-without-lockin-with-juan-orlandini-of-insight",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Juan_Orlandini.04.13.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5f59d61-1259-4f96-9d16-e24e41a7a408",
            "index": 24,
            "title": "Breaking Bottlenecks in Life Sciences R&D with AI Innovation - with Aziz Nazha of Incyte Pharmaceuticals",
            "pub_date": "2026-04-16T15:00:00.000Z",
            "duration": "30:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/breaking-bottlenecks-in-life-sciences-rd-with-ai-innovation-with-aziz-nazha-of-incyte-pharmaceuticals",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_4.16.26_-_Aziz_Nazha.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "435fa4df-d463-413e-946f-55adc2fb0d1d",
            "index": 25,
            "title": "Scaling Customer Experience with Operationalized Agentic AI - with Shezan Kazi of Dialpad",
            "pub_date": "2026-04-16T06:00:00.000Z",
            "duration": "29:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/scaling-customer-experience-with-operationalized-agentic-ai-with-shezan-kazi-of-dialpad",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Shezan_Kazi.04.13.26_1.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e4b785d0-7840-4b32-ba37-22dbde4e0a13",
            "index": 26,
            "title": "Turning Computer Vision Into Real‑World Value at Enterprise Scale – with Joseph Nelson of Roboflow",
            "pub_date": "2026-04-15T06:00:00.000Z",
            "duration": "39:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/turning-computer-vision-into-realworld-value-at-enterprise-scale-with-joseph-nelson-of-roboflow",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Joseph_Nelson.04.12.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1da8af14-8840-4b24-ae9e-60b5a0a2eb99",
            "index": 27,
            "title": "Making Workforce Training Affordable with Tiered Storage - with Aaron Demory of Fearlus",
            "pub_date": "2026-04-14T06:00:00.000Z",
            "duration": "21:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training"
            ],
            "page_url": "https://podcast.emerj.com/making-workforce-training-affordable-with-tiered-storage-with-aaron-demory-of-fearlus",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Aaron_Demory-AI_in_Business_04.11.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d1adc3d2-59c2-43d8-9cb3-8baa321c1fca",
            "index": 28,
            "title": "Connecting Forecasting and Warehouse Decisions at Scale  - with Jerod Hamilton of Tyson Foods",
            "pub_date": "2026-04-08T06:00:00.000Z",
            "duration": "24:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcast.emerj.com/connecting-forecasting-and-warehouse-decisions-at-scale-with-jerod-hamilton-of-tyson-foods",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Jerod_Hamilton.04.06.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89b445f1-0fd1-46bf-864f-5b77886d2934",
            "index": 29,
            "title": "Decentralized Trials That Scale Globally Without Compliance Risks - with Emma Vitalini of Amgen",
            "pub_date": "2026-04-07T06:00:00.000Z",
            "duration": "30:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/decentralized-trials-that-scale-globally-without-compliance-risks-with-emma-vitalini-of-amgen",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_4.7.26_-_Emma_Vitalini.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "81cd33b0-d311-41db-8e1c-2e94cf6414b9",
            "index": 30,
            "title": "Solving the Expertise Gap with AI in Manufacturing  - with Antoine Bisson of Poka",
            "pub_date": "2026-04-06T06:00:00.000Z",
            "duration": "29:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://podcast.emerj.com/solving-the-expertise-gap-with-ai-in-manufacturing-with-antoine-bisson-of-poka",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Antoine_Bisson.03.29.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da5ed9d1-0f00-4612-a3d6-f5e737fa1539",
            "index": 31,
            "title": "How Digital K‑1 Data Changes Tax Workflow Maturity - with Ken Powell and Neal Schneider",
            "pub_date": "2026-04-02T06:00:00.000Z",
            "duration": "30:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcast.emerj.com/how-digital-k1-data-changes-tax-workflow-maturity-with-ken-powell-and-neal-schneider",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Ken_Neal.03.29.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd10ef49-fbb7-4532-901a-d0dcfaab0381",
            "index": 32,
            "title": "Closing the Customer Service Gap: How AI Is Redefining Scale, Speed, and Satisfaction - with Philipp Heltewig of NiCE",
            "pub_date": "2026-04-01T06:00:00.000Z",
            "duration": "40:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/closing-the-customer-service-gap-how-ai-is-redefining-scale-speed-and-satisfaction-with-philipp-heltewig-of-nice",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Philipp_Heltewig.03.30.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4cbf5d77-6a93-43f8-a552-d8b29feb05f0",
            "index": 33,
            "title": "Creating a Single Source of Truth for Enterprise Legal Work - with Christo Siebrits of AbbVie",
            "pub_date": "2026-03-31T06:00:00.000Z",
            "duration": "21:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "training"
            ],
            "page_url": "https://podcast.emerj.com/creating-a-single-source-of-truth-for-enterprise-legal-work-with-christo-siebrits-of-abbvie",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.31.26_-_Christo_Siebrits.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3259fd2c-1952-42a1-8263-fdab09291d44",
            "index": 34,
            "title": "What Global Tariff Uncertainty Means for Supply Chain Leaders - with Edmund Zagorin of Arkestro and Michael Shin of Trinity Rail Industries",
            "pub_date": "2026-03-27T06:00:00.000Z",
            "duration": "46:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/what-global-tariff-uncertainty-means-for-supply-chain-leaders-with-edmund-zagorin-of-arkestro-and-michael-shin-of-trinity-rail-industries",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Edmund_Michael.03.23.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "31465b0e-2d1c-48a2-8443-f5e42f92c422",
            "index": 35,
            "title": "Managing Third-Party Risk at Scale Without Drowning in Surveys - with Carey Smith",
            "pub_date": "2026-03-26T06:00:00.000Z",
            "duration": "14:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/managing-third-party-risk-at-scale-without-drowning-in-surveys-with-carey-smith",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.26.26_-_Carey_Smith.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d2115757-800e-4ba1-a884-8fe88858172c",
            "index": 36,
            "title": "Why Enterprise AI Fails Without a Context Engine - with Eran Yahav of Tabnine",
            "pub_date": "2026-03-25T06:00:00.000Z",
            "duration": "30:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/why-enterprise-ai-fails-without-a-context-engine-with-eran-yahav-of-tabnine",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Eran_Yahav.03.22.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d1a51ecc-4cfe-4478-abc4-862574dc4ace",
            "index": 37,
            "title": "From AI Experiments to Enterprise Value Driving Real Business ROI - with Dan Diasio of EY",
            "pub_date": "2026-03-24T06:00:00.000Z",
            "duration": "39:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/from-ai-experiments-to-enterprise-value-driving-real-business-roi-with-dan-diasio-of-ey",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Dan_Diaso_03.19.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52bea516-4737-4569-b7f2-da36a74a3e01",
            "index": 38,
            "title": "Why Ensemble Architectures Win Against Real-Time Voice Risk - with Mike Pappas of Modulate",
            "pub_date": "2026-03-20T06:00:00.000Z",
            "duration": "28:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/why-ensemble-architectures-win-against-real-time-voice-risk-with-mike-pappas-of-modulate",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Ed_Modulate_Mike_pappas_03.19.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff8f9bc9-0229-4116-afcc-db9e9dade742",
            "index": 39,
            "title": "From Multi Agent Systems to Institutional Learning in the Enterprise - with Papi Menon of Outshift by Cisco",
            "pub_date": "2026-03-19T06:00:00.000Z",
            "duration": "31:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcast.emerj.com/from-multi-agent-systems-to-institutional-learning-in-the-enterprise-with-papi-menon-of-outshift-by-cisco",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.19.26_-_Papi_Menon.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83bc3af9-63d9-4e88-817f-db3cfe48fadb",
            "index": 40,
            "title": "Why Financial AI Can't Scale Without Unified Governance with James Dean of Google and Mark Crean of Securiti",
            "pub_date": "2026-03-18T14:00:00.000Z",
            "duration": "35:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/why-financial-ai-cant-scale-without-unified-governance-with-james-dean-of-google-and-mark-crean-of-securiti",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_03.18.26_-_James_Dean__Mark_Crean.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f39e512e-ab55-4891-912b-5f3d0ad4e198",
            "index": 41,
            "title": "How Digital Workers Are Changing Industrial Performance  - with Somya Kapoor of IFS Loops",
            "pub_date": "2026-03-18T06:00:00.000Z",
            "duration": "26:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/how-digital-workers-are-changing-industrial-performance-with-somya-kapoor-of-ifs-loops",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.18.26_-_Somya_Kapoor.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d92dfd5f-ef56-487f-a43c-9893cd58b613",
            "index": 42,
            "title": "How Walmart Is Reengineering AI Delivery Speed - with David Glick of Walmart",
            "pub_date": "2026-03-17T06:00:00.000Z",
            "duration": "18:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "safety",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/how-walmart-is-reengineering-ai-delivery-speed-with-david-glick-of-walmart",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.17.26_-_David_Glick.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "816d5cdf-fe7d-4b7f-b0d2-593d91661104",
            "index": 43,
            "title": "Why Supply Chain Design Becomes the Differentiator as AI Automates Planning - with Don Hicks of Optilogic",
            "pub_date": "2026-03-16T06:00:00.000Z",
            "duration": "47:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://podcast.emerj.com/why-supply-chain-design-becomes-the-differentiator-as-ai-automates-planning-with-don-hicks-of-optilogic",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.16.26_-_Don_Hicks.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "78196a51-deb4-4e9d-8b69-cc755df814bb",
            "index": 44,
            "title": "Turning Market Shifts into Field Action for Medtech Commercial Teams - with Mike Monovoukas & Alex Wakefield of AcuityMD",
            "pub_date": "2026-03-13T06:00:00.000Z",
            "duration": "39:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/turning-market-shifts-into-field-action-for-medtech-commercial-teams-with-mike-monovoukas-alex-wakefield-of-acuitymd",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-._3.13.26_-_Mike_Monovoukas__Alex_Wakefield.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f0d294e9-71f5-4609-8f52-cb5628100f39",
            "index": 45,
            "title": "Why Manual K-1 Workflows Are Breaking Under Modern Tax Complexity - with Ken Powell of K1x",
            "pub_date": "2026-03-12T06:00:00.000Z",
            "duration": "33:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/why-manual-k-1-workflows-are-breaking-under-modern-tax-complexity-with-ken-powell-of-k1x",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.12.26_-_Ken_Powell.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5479cb2a-f5c4-483c-9059-c19c105425e2",
            "index": 46,
            "title": "Building a Virtuous Cycle of Analytics in Global Enterprises - with Barry McCardel of Hex",
            "pub_date": "2026-03-11T06:00:00.000Z",
            "duration": "38:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/building-a-virtuous-cycle-of-analytics-in-global-enterprises-with-barry-mccardel-of-hex",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.11.26_-_Barry_McCardel.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75b8520d-401c-409c-9449-05244051af21",
            "index": 47,
            "title": "AI Use Cases, Deployment, and Measuring Real-World ROI - with Ylan Kazi of Blue Cross Blue Shield of North Dakota",
            "pub_date": "2026-03-10T06:00:00.000Z",
            "duration": "19:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embedding",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/ai-use-cases-deployment-and-measuring-real-world-roi-with-ylan-kazi-of-blue-cross-blue-shield-of-north-dakota",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_03.10.26_-_Ylan_Kazi_1.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d29478b-ee5b-4a95-abd6-6cb0b45ccaf3",
            "index": 48,
            "title": "Operationalizing Customer Service at Scale with Outcome-Driven Agentic AI - with Craig Walker of Dialpad",
            "pub_date": "2026-03-09T07:00:00.000Z",
            "duration": "35:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/operationalizing-customer-service-at-scale-with-outcome-driven-agentic-ai-with-craig-walker-of-dialpad",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.9.26_-_Craig_Walker.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cffebd07-8e63-4159-85e4-151b8b1fa790",
            "index": 49,
            "title": "Pricing Changes in Small Commercial Without Governance Debt - with Barbara Stacer of Utica National Insurance Group",
            "pub_date": "2026-03-06T16:00:00.000Z",
            "duration": "16:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/pricing-changes-in-small-commercial-without-governance-debt-with-barbara-stacer-of-utica-national-insurance-group",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.6.26_-_Barbra_Sstacer_FINAL.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7c293eab-fa66-491c-8f51-807a267ff8fa",
            "index": 50,
            "title": "Funding Agentic AI in HR Without Losing Control - with Carey Smith of Blue Cross and Blue Shield",
            "pub_date": "2026-03-06T07:00:00.000Z",
            "duration": "14:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/funding-agentic-ai-in-hr-without-losing-control-with-carey-smith-of-blue-cross-and-blue-shield",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.6.26_-_Carey_Smith.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77b2014c-948b-476d-8267-9da19709aca1",
            "index": 51,
            "title": "Rethinking Pharma Commercial Targeting with AI - with Philip Poulidis of ODAIA",
            "pub_date": "2026-03-04T07:00:00.000Z",
            "duration": "29:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/rethinking-pharma-commercial-targeting-with-ai-with-philip-poulidis-of-odaia",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_03.04.26_-_Philip_Poulidis.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90f5a89e-1b4b-45de-befc-83a8e8b5aee7",
            "index": 52,
            "title": "How AI Is Reshaping Shutdown and Turnaround Operations - with Raghu Ahobilam of NOV",
            "pub_date": "2026-03-03T07:00:00.000Z",
            "duration": "24:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-ai-is-reshaping-shutdown-and-turnaround-operations-with-raghu-ahobilam-of-nov",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.3.26_-_Raghu_Ahobilam_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eb9e4199-e7f5-430b-bad4-8ede37ec3728",
            "index": 53,
            "title": "Trusted AI Architectures for Risk and Compliance Leaders - with Dean Alms & Eric Hensley of Aravo",
            "pub_date": "2026-03-02T07:00:00.000Z",
            "duration": "19:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/trusted-ai-architectures-for-risk-and-compliance-leaders-with-dean-alms-eric-hensley-of-aravo",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_03.02.26_-_Dean_Alms_Eric_Hensley_1.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70e7bd64-5102-4791-bb45-a1569732f3d2",
            "index": 54,
            "title": "AI for Better Customer Connections in CX - with Joe Atamian of Comcast",
            "pub_date": "2026-02-27T07:00:00.000Z",
            "duration": "23:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://podcast.emerj.com/ai-for-better-customer-connections-in-cx-with-joe-atamian-of-comcast",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.26.26_-_Joe_Atamian.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9bc725af-e2d8-43be-9b72-916bbf9c5faa",
            "index": 55,
            "title": "Turning Real World Data into Safer Outcomes for Fleets and Physical Operations - with Hemant Banavar of Motive",
            "pub_date": "2026-02-25T07:00:00.000Z",
            "duration": "18:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/turning-real-world-data-into-safer-outcomes-for-fleets-and-physical-operations-with-hemant-banavar-of-motive",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.25.26_-_Hemant_Banavar.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fb280684-cf49-4412-bb2f-7110415e9f31",
            "index": 56,
            "title": "Overcoming Skepticism and Driving AI Adoption - with Umesh Rustogi of Microsoft",
            "pub_date": "2026-02-24T07:00:00.000Z",
            "duration": "27:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/overcoming-skepticism-and-driving-ai-adoption-with-umesh-rustogi-of-microsoft",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.24.26_-_Umesh_Rustogi.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "717fd154-abc2-4868-9399-4e16bd488425",
            "index": 57,
            "title": "Improving Warehouse Efficiency with Unified Data and AI-Driven Visibility - with Dan Keto of Easy Metrics",
            "pub_date": "2026-02-19T07:00:00.000Z",
            "duration": "18:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/improving-warehouse-efficiency-with-unified-data-and-ai-driven-visibility-with-dan-keto-of-easy-metrics",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.19.26_-_Dan_Keto.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d80b416a-f383-4079-8ca0-d43f7d3ff66f",
            "index": 58,
            "title": "Enterprise AI Adoption at a Moment of Maximum Skepticism - with Nishtha Jain",
            "pub_date": "2026-02-17T07:00:00.000Z",
            "duration": "30:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/enterprise-ai-adoption-at-a-moment-of-maximum-skepticism-with-nishtha-jain-of-takeda-pharmaceuticals",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.17.25_-_Nishtha_Jain.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "05c4c42e-c4ac-4648-9e91-2f5e9ba49f93",
            "index": 59,
            "title": "In a Sea of Complexity, Does a \"Successor\" Exist? - with Stephen Wolfram of Wolfram Research",
            "pub_date": "2026-02-14T07:00:00.000Z",
            "duration": "02:04:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/in-a-sea-of-complexity-does-a-successor-exist-with-stephen-wolfram-of-wolfram-research",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Stephen_Wolfram_-_AIB_02.14.26.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e82310dd-646e-4a45-9849-bd0266f27391",
            "index": 60,
            "title": "From Demos to Defensible in Financial Services Copyright & Compliance for Enterprise AI - Naveen Kumar of TD Bank",
            "pub_date": "2026-02-10T07:00:00.000Z",
            "duration": "19:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/from-demos-to-defensible-in-financial-services-copyright-compliance-for-enterprise-ai-naveen-kumar-of-td-bank",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_2.10.26_-_Naveen_Kumar.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a5982e8e-28c3-41e4-9338-8325052e2411",
            "index": 61,
            "title": "Managing Third-Party Risk When You Have 10,000 Suppliers - with Dean Alms of Aravo",
            "pub_date": "2026-02-06T07:00:00.000Z",
            "duration": "22:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/managing-third-party-risk-when-you-have-10000-suppliers-with-dean-alms-of-aravo",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_2.27.26_-_Dean_Alms_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7deccf81-8cb9-4e92-9436-f8fd8bebb5d1",
            "index": 62,
            "title": "The Internet of Agents and What It Means for Enterprise Leaders - with Vijoy Pandey of Outshift by Cisco",
            "pub_date": "2026-02-05T07:00:00.000Z",
            "duration": "31:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcast.emerj.com/the-internet-of-agents-and-what-it-means-for-enterprise-leaders-with-vijoy-pandey-of-outshift-by-cisco",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.05.26_-_Vijoy_Pandey.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b1acb71-906f-4353-9eac-08e963b4c687",
            "index": 63,
            "title": "Fixing Shadow AI and Tool Sprawl in Enterprise Marketing - with Gillian Hinkle of Salesforce",
            "pub_date": "2026-02-03T07:00:00.000Z",
            "duration": "29:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/fixing-shadow-ai-and-tool-sprawl-in-enterprise-marketing-with-gillian-hinkle-of-salesforce",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.03.26-_Gillian_Hinkle.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89965110-a323-4317-9ff5-f88eeae5cf0e",
            "index": 64,
            "title": "Transforming R&D with AI and Quantum Computing - with David Carmona of Microsoft",
            "pub_date": "2026-01-29T07:00:00.000Z",
            "duration": "27:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning"
            ],
            "page_url": "https://podcast.emerj.com/transforming-rd-with-ai-and-quantum-computing-with-david-carmona-of-microsoft",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.29.26_-_.David_Carmona.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "50ec9c73-9287-467c-80dc-4e086a863d9b",
            "index": 65,
            "title": "AI Adoption and Skepticism in Regulated Industries - with Ylan Kazi of Blue Cross Blue Shield of North Dakota",
            "pub_date": "2026-01-27T07:00:00.000Z",
            "duration": "21:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/ai-adoption-and-skepticism-in-regulated-industries-with-ylan-kazi-of-blue-cross-blue-shield-of-north-dakota",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.27.26_-_Ylan_Kazi_mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3911d2af-a844-48bb-b27d-8afd569840dd",
            "index": 66,
            "title": "What Executives Need to Know About Quantum Computing and AI - with Daniel Lidar of the University of Southern California and Izhar Medalsy of Quantum Elements Inc.",
            "pub_date": "2026-01-23T07:00:00.000Z",
            "duration": "37:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/what-executives-need-to-know-about-quantum-computing-and-ai-with-daniel-lidar-of-the-university-of-southern-california-and-izhar-medalsy-of-quantum-elements-inc",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.23.26_-_Daniel_Lidar_Izhar_Medalsy.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95a0d7b7-da27-4d86-bff4-a1807668fcad",
            "index": 67,
            "title": "Copyright & Compliance for Enterprise AI From Demos to Defensible - Nina Edwards of Prudential Insurance",
            "pub_date": "2026-01-22T07:00:00.000Z",
            "duration": "31:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/copyright-compliance-for-enterprise-ai-from-demos-to-defensible-nina-edwards-of-prudential-insurance",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.22.26_-__Nina_edwards.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "76153419-89bd-44e1-9e8f-6f4408336328",
            "index": 68,
            "title": "Translating AI Models into Business Value From Governance to Deployment - Thomas Holmes of Akur8",
            "pub_date": "2026-01-21T07:00:00.000Z",
            "duration": "26:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/translating-ai-models-into-business-value-from-governance-to-deployment-thomas-holmes-of-akur8",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business__01.21.26_-_Thomas_Holmes.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7ac19510-aeb8-44fc-9749-d543db4880c4",
            "index": 69,
            "title": "Transforming Trial Design and Patient Data with Deterministic AI - with Emma Vitalini of Amgen",
            "pub_date": "2026-01-20T07:00:00.000Z",
            "duration": "26:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/transforming-trial-design-and-patient-data-with-deterministic-ai-with-emma-vitalini-of-amgen",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.20.26_-_Emma_Vitalini.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9bcff33b-aa4d-4aa6-a02e-655dd42b3e64",
            "index": 70,
            "title": "Stop Asking and Start Solving with AI for Proactive CX - with Vasili Triant of UJET",
            "pub_date": "2026-01-19T07:00:00.000Z",
            "duration": "20:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/stop-asking-and-start-solving-with-ai-for-proactive-cx-with-vasili-triant-of-ujet",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.19.26_-_Vasili_Triant.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7ec23b36-68d5-4a10-bb07-2cb47de2f836",
            "index": 71,
            "title": "Workforce Solutions for Field Services with AI - with Rommel Ong of Belimed",
            "pub_date": "2026-01-13T07:00:00.000Z",
            "duration": "21:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/workforce-solutions-for-field-services-with-ai-with-rommel-ong-of-belimed",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.13.26_-_Rommel_Ong.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9859fb0a-8b0b-4994-86c5-2e7723900a39",
            "index": 72,
            "title": "Modernizing Insurance Pricing From Excel to Explainable AI  - Thomas Holmes of Akur8",
            "pub_date": "2026-01-12T07:00:00.000Z",
            "duration": "17:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/modernizing-insurance-pricing-from-excel-to-explainable-ai-thomas-holmes-of-akur8",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_1.12.26-_Thomas_Holmes__mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bb12415c-dbc0-4c21-8dc7-8789ca70b86b",
            "index": 73,
            "title": "How Open Context Layers Help Enterprises Build, Govern, & Scale Agentic AI - with Prukalpa Sankar of Atlan",
            "pub_date": "2026-01-08T07:00:00.000Z",
            "duration": "24:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/how-an-open-context-layers-help-enterprises-build-govern-scale-agentic-ai-with-prukalpa-sankar-of-atlan",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.08.26_-_Prukalpa_Sankar.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f3875771-03db-4af5-8eb5-f8fdb94f34a7",
            "index": 74,
            "title": "Reducing R&D Cycle Time in Pharma Without Increasing Regulatory Risk - with Vaithi Bharath of Bayer",
            "pub_date": "2026-01-07T07:00:00.000Z",
            "duration": "38:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/reducing-rd-cycle-time-in-pharma-without-increasing-regulatory-risk-with-vaithi-bharath-of-bayer",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.07.26_-_Vaithi_Bharath.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "caca704f-9f4b-4587-8f6b-3f8dd1fdcbd1",
            "index": 75,
            "title": "Data Solutions for Tailoring Agronomic Support to Meet Regional Needs - with Tami Craig Schilling of Bayer Crop Science",
            "pub_date": "2026-01-06T07:00:00.000Z",
            "duration": "34:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/data-solutions-for-tailoring-agronomic-support-to-meet-regional-needs-with-tami-craig-schilling-of-bayer-crop-science",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.06.26_-_Tami_Craig_Schilling_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bb0eed49-f2b1-472e-83f5-bb4e211c1d2d",
            "index": 76,
            "title": "Why Agentic and Conversational AI Products Are Not What CX Leaders Think - with Baker Johnson of UJET",
            "pub_date": "2026-01-05T07:00:00.000Z",
            "duration": "33:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/why-agentic-and-conversational-ai-products-are-not-what-cx-leaders-think-with-baker-johnson-of-uje",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.05.26_-_Baker_Johnson.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02a355f8-1994-4897-bc77-b09fc3c66730",
            "index": 77,
            "title": "Why Post-Merger Integrations Fail Without Data Governance - Sandro Venturini of UBS",
            "pub_date": "2025-12-30T07:00:00.000Z",
            "duration": "17:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/why-post-merger-integrations-fail-without-data-governance-sandro-venturini-of-ubs",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.30.25_-_Sandro_Venturini.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "252220eb-4207-4ffe-b604-5b81dfe0fd6f",
            "index": 78,
            "title": "Scaling Enterprise Productivity Through Agentic AI and Workflow Automation - with Kuo Zhang of Alibaba.com",
            "pub_date": "2025-12-23T07:00:00.000Z",
            "duration": "21:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/scaling-enterprise-productivity-through-agentic-ai-and-workflow-automation-with-kuo-zhang-of-alibabacom",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/BUSINESS_Kuo_Zhang_-_Alibaba_-_12.23.25.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4a0beaad-5224-4753-b99a-83a3c5179e2b",
            "index": 79,
            "title": "Rewiring Systems to Scale AI From Demos to Deliverables - Nina Edwards of Prudential Insurance",
            "pub_date": "2025-12-19T07:00:00.000Z",
            "duration": "28:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/rewiring-systems-to-scale-ai-from-demos-to-deliverables-nina-edwards-of-prudential-insurance",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-__12.19.25_-_Nina_Edwards.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d606097c-42d9-477a-b146-c415d147f3c4",
            "index": 80,
            "title": "Accelerating Speed to Value through Agentic Systems and Intelligent Automation in Life Sciences - with Robert Wenier of AstraZeneca",
            "pub_date": "2025-12-18T07:00:00.000Z",
            "duration": "35:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/accelerating-speed-to-value-through-agentic-systems-and-intelligent-automation-in-life-sciences-with-robert-wenier-of-astrazeneca",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.18.25_-_Robert_Wenier.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5886b54-cfd8-4813-96d7-b92b30e353a3",
            "index": 81,
            "title": "Governing AI for Fraud, Compliance, and Automation at Scale - with Naveen Kumar of TD Bank",
            "pub_date": "2025-12-17T07:00:00.000Z",
            "duration": "22:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/governing-ai-for-fraud-compliance-and-automation-at-scale-with-naveen-kumar-of-td-bank",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/BUSINESS_-_12.17.25_-_Naveen_Kumar_-_TD_Bank_-_MDEd.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5b33c205-8ec0-434c-a78c-c91483673097",
            "index": 82,
            "title": "Transparency for AI Systems, Regulations, and Humans in Agricultural Manufacturing - with Kun He of Bayer",
            "pub_date": "2025-12-16T07:00:00.000Z",
            "duration": "35:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/transparency-for-ai-systems-regulations-and-humans-in-agricultural-manufacturing-with-kun-he-of-bayer",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.16.25_-_Kun_He_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f55d906b-de9f-4fd5-865f-5012cfdc90da",
            "index": 83,
            "title": "Why Granular Visibility and Data Control Determines AI Success in Financial Services - with Chris Joynt of Securiti",
            "pub_date": "2025-12-15T07:00:00.000Z",
            "duration": "30:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/why-granular-visibility-and-data-control-determines-ai-success-in-financial-services-with-chris-joynt-of-securiti",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.15.25_-_Christ_Joynt.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da2d96f4-058b-433f-97b8-07b7b7f8d5d6",
            "index": 84,
            "title": "Rethinking Clinical Trials with Faster AI-Driven Decision Making - with Shefali Kakar of Novartis",
            "pub_date": "2025-12-09T08:00:00.000Z",
            "duration": "20:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/rethinking-clinical-trials-with-faster-ai-driven-decision-making-with-shefali-kakar-of-novartis",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.09.25_-_Shefali_Kakar.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48c5d61e-790a-4789-96de-15fe92f68e62",
            "index": 85,
            "title": "Human-Centered Innovation Driving Better Nurse Experiences - with Umesh Rustogi of Microsoft",
            "pub_date": "2025-12-09T07:00:00.000Z",
            "duration": "27:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/human-centered-innovation-driving-better-nurse-experiences-with-umesh-rustogi-of-microsoft",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_Umesh_Rustogi_-_12.10.25_-_MdEd.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1684762-730c-4ae3-ae98-050ab214c088",
            "index": 86,
            "title": "The Biggest Cybersecurity Challenges Facing Regulated and Mid-Market Sectors - with Cody Barrow of EclecticIQ",
            "pub_date": "2025-12-05T07:00:00.000Z",
            "duration": "18:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/the-biggest-cybersecurity-challenges-facing-regulated-and-mid-market-sectors-with-cody-barrow-of-eclecticiq",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.5.25_-_Cody_Barrow.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f3c6eb9-74ad-4c74-89d9-515c259caaf1",
            "index": 87,
            "title": "Overcoming Cloud Complexity in Mid Market Operations - with Dirk Michiels of Savaco",
            "pub_date": "2025-12-04T07:00:00.000Z",
            "duration": "22:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/overcoming-cloud-complexity-in-mid-market-operations-with-dirk-michiels-of-savaco",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.04.25_-_Dirk_Michiels.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f2e8e8a-70fb-44bc-9a94-21abdeac860d",
            "index": 88,
            "title": "From Hiring to Growth and the Future of Workforce Strategy - with Meghna Punhani of Eightfold AI",
            "pub_date": "2025-12-03T07:00:00.000Z",
            "duration": "35:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/from-hiring-to-growth-and-the-future-of-workforce-strategy-with-meghna-punhani-of-eightfold-ai",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.02.25_-_Meghna_Punhani.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22197f87-d38d-463e-9f6d-a9517fa4e5a0",
            "index": 89,
            "title": "\"Waking Up\" Data in Clinical Workflows with AI - with Mathew Paruthickal of Sanofi",
            "pub_date": "2025-12-02T07:00:00.000Z",
            "duration": "18:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/waking-up-data-in-clinical-workflows-with-ai-with-mathew-paruthickal-of-sanofi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.2.25_-_Mathew_Paruthickal.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e50fbb6-5e7b-45dc-80da-dcc34b6c4a29",
            "index": 90,
            "title": "Copyright Risk in Financial Services and the Rise of Responsible AI – with Lauren Tulloch of CCC",
            "pub_date": "2025-12-01T07:00:00.000Z",
            "duration": "14:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/copyright-risk-in-financial-services-and-the-rise-of-responsible-ai-with-lauren-tulloch-of-ccc",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.01.25_-_Lauren_Tulloch.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29cd68f8-1967-4ebe-9b3b-50a1965b4531",
            "index": 91,
            "title": "Why False Positives Are Costing Banks More Than Fraud - with Suvaleena Paul of Bank of America",
            "pub_date": "2025-11-25T07:00:00.000Z",
            "duration": "24:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/why-false-positives-are-costing-banks-more-than-fraud-with-suvaleena-paul-of-bank-of-america",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.25.25_-_Suvaleena_Paul.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "85967687-aa5f-4193-87a4-579b421be4ce",
            "index": 92,
            "title": "Using Artificial Intelligence to Unlock Hidden Insights in Genomic Research - with Dr. Mark Kiel of Genomenon",
            "pub_date": "2025-11-24T07:00:00.000Z",
            "duration": "27:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcast.emerj.com/using-artificial-intelligence-to-unlock-hidden-insights-in-genomic-research-with-dr-mark-kiel-of-genomenon",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.24.25_-_Mark_Kiel_-MDed.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36faea3b-d424-4464-bd31-bc0a37a56464",
            "index": 93,
            "title": "Driving the Systemic Change for AI – with Deborah Golden of Deloitte",
            "pub_date": "2025-11-22T07:00:00.000Z",
            "duration": "39:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/driving-the-systemic-change-for-ai-with-deborah-golden-of-deloitte",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.22.25_-_Deborah_Golden.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2276495-9b22-4e39-a7ee-ced4194d4d1e",
            "index": 94,
            "title": "Strategic AI Adoption for Asset Managers and Enterprise Decision Makers - with Robert Kubin of Amundi",
            "pub_date": "2025-11-21T07:00:00.000Z",
            "duration": "24:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embedding"
            ],
            "page_url": "https://podcast.emerj.com/strategic-ai-adoption-for-asset-managers-and-enterprise-decision-makers-with-robert-kubin-of-amundi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.21.25_-_Robert_Kubin_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c81a63e1-bfe8-4fcb-a3a6-074fe642be76",
            "index": 95,
            "title": "Why Architecture Determines the Future of AI Innovation - with Aaron Levie of Box",
            "pub_date": "2025-11-20T07:00:00.000Z",
            "duration": "37:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/why-architecture-determines-the-future-of-ai-innovation-with-aaron-levie-of-box",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.20.25_-_Aaron_Levie.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8ddfd6a7-3aec-44b5-9925-e23c4a1f2f1e",
            "index": 96,
            "title": "Turning Consumer Goods Data into Real-Time Business Decisions - with Michael Finley of AnswerRocket",
            "pub_date": "2025-11-19T07:00:00.000Z",
            "duration": "26:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/turning-consumer-goods-data-into-real-time-business-decisions-with-michael-finley-of-answerrocket",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.19.25_-_Michael_Finley_.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c62a2584-4639-4c88-958b-883d34def556",
            "index": 97,
            "title": "Looking at Retail Challenges from a Data Perspective - with Nick Masca of Marks and Spencer",
            "pub_date": "2025-11-18T07:00:00.000Z",
            "duration": "20:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/looking-at-retail-challenges-from-a-data-perspective-with-nick-masca-of-marks-and-spencer",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.18.25_-_Nick_Masca_mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db15b15e-41de-4298-b0c8-83dde2890345",
            "index": 98,
            "title": "Solving Hard Industrial Problems with Fast AI Deployment - with Kriti Sharma of IFS Nexus Black",
            "pub_date": "2025-11-17T07:00:00.000Z",
            "duration": "19:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/solving-hard-industrial-problems-with-fast-ai-deployment-with-kriti-sharma-of-ifs-nexus-black",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_Kriti_Sharma_-_AIB_11.17.25.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d14142e-758d-4d9e-9879-642f6be8a53d",
            "index": 99,
            "title": "Turning Operational Data into AI Ready Assets - with Andrew Deutsch of RR Donnelly and the Fangled Group",
            "pub_date": "2025-11-15T07:00:00.000Z",
            "duration": "30:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/turning-operational-data-into-ai-ready-assets-with-andrew-deutsch-of-rr-donnelly-and-the-fangled-group",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/BUSINESS_-_11.15.25_-_Andrew_Deutsch.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6d0699ae-cfd9-4ac4-8734-e11b8ef49d05",
            "index": 100,
            "title": "Why Regulated Industries Must Rethink Copyright and AI - with Roanie Levy of CCC",
            "pub_date": "2025-11-14T07:00:00.000Z",
            "duration": "24:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/why-regulated-industries-must-rethink-copyright-and-ai-with-roanie-levy-of-ccc",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.14.25_-_Roanie_Levy_FINAL_FIX.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d31f798e-2c36-4069-9f68-05ea4d027397",
            "index": 101,
            "title": "A Practical Path from Roles to Skills for AI-Ready Teams - with Trish Vassar of Coca-Cola",
            "pub_date": "2025-11-13T07:00:00.000Z",
            "duration": "22:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://podcast.emerj.com/a-practical-path-from-roles-to-skills-for-ai-ready-teams-with-trish-vassar-of-coca-cola",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.13.25_-_Trish_Vassar.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d9275e57-d9ed-47b6-8a7a-e2a7853627ee",
            "index": 102,
            "title": "Turning AI Ambition into Infrastructure Reality – with Julian Tang of BlackRock",
            "pub_date": "2025-11-12T07:00:00.000Z",
            "duration": "17:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/turning-ai-ambition-into-infrastructure-reality-with-julian-tang-of-blackrock",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_11.12.15_-_Julian_Tang_FINAL.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3e3b8d37-a49a-4f26-93e0-c51e498f4855",
            "index": 103,
            "title": "Challenges HR Leaders Face in Adopting Enterprise AI - with Raúl Monroig of Bristol Myers Squibb",
            "pub_date": "2025-11-11T07:00:00.000Z",
            "duration": "29:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/challenges-hr-leaders-face-in-adopting-enterprise-ai-with-ral-monroig-of-bristol-myers-squibb",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.11.25_-_Raul_Monroig_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2420bccc-da61-4b75-ab1f-d45b949c0123",
            "index": 104,
            "title": "How to Leverage AI for Skill Verification - with Taylor Sullivan of Workera",
            "pub_date": "2025-11-10T07:00:00.000Z",
            "duration": "19:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/how-to-leverage-ai-for-skill-verification-with-taylor-sullivan-of-workera",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.10.25_-_Taylor_Sullivan.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f66add75-ea37-43bd-a2c6-a8e0c2bf7298",
            "index": 105,
            "title": "Agentic AI and the Strategy Behind Smarter Talent Decisions - with Sachit Kamat of Eightfold AI",
            "pub_date": "2025-11-07T07:00:00.000Z",
            "duration": "24:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/agentic-ai-and-the-strategy-behind-smarter-talent-decisions-with-sachit-kamat-of-eightfold-ai",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.7.25_-_Sachit_Kamat.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22bfb2d0-6d14-470f-9bb3-85d559896514",
            "index": 106,
            "title": "Scaling GenAI Without Burdening the Data Center - with Greg Ratcliff of Vertiv",
            "pub_date": "2025-11-06T07:00:00.000Z",
            "duration": "24:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "data center"
            ],
            "page_url": "https://podcast.emerj.com/scaling-genai-without-burdening-the-data-center-with-greg-ratcliff-of-vertiv",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.6.25_-_Greg_Ratcliff._mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b05abcf3-df28-43bb-94c5-0914dbb44ca6",
            "index": 107,
            "title": "CPG Data Challenges to Business Value with Agentic AI  - with Jim Johnson of AnswerRocket",
            "pub_date": "2025-11-05T08:00:00.000Z",
            "duration": "26:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/cpg-data-challenges-to-business-value-with-agentic-ai-with-jim-johnson-of-answerrocket",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.5.25_-_Jim_Johnson-_MDedit.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29cb4837-2d26-42ba-a436-475f500da887",
            "index": 108,
            "title": "Making Microsoft Copilot and ChatGPT Enterprise Work for You - with Matt Berseth and Russell Dixon of NLP Logix",
            "pub_date": "2025-11-05T07:00:00.000Z",
            "duration": "31:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "embedding",
              "copilot"
            ],
            "page_url": "https://podcast.emerj.com/making-microsoft-copilot-and-chatgpt-enterprise-work-for-you-with-matt-berseth-and-russell-dixon-of-nlp-logix",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.5.25_-_Matt_Berseth_Russell_Dixon.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5cc6f54-27fd-4119-a0b7-584631b85c00",
            "index": 109,
            "title": "How Enterprise Industrial Leaders Are Applying AI to Systemic Manufacturing Problems - with Emily Nguyen of Palantir Technologies",
            "pub_date": "2025-11-04T07:00:00.000Z",
            "duration": "27:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-enterprise-industrial-leaders-are-applying-ai-to-systemic-manufacturing-problems-with-emily-nguyen-of-palantir-technologies",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.4.25_-_Emily_Nguyen_mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "49b5f0df-6ea2-4a88-bdd4-edd1890dbb21",
            "index": 110,
            "title": "Building an AI Ready Data Foundation for CPG Success - with Dag Liodden of Crisp",
            "pub_date": "2025-11-03T06:00:00.000Z",
            "duration": "23:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/building-an-ai-ready-data-foundation-for-cpg-success-with-dag-liodden-of-crisp",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_11.3.25_-_Dag_Liodden.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a6d7e973-1f09-4a22-944c-4a17885bd328",
            "index": 111,
            "title": "Architecting Enterprise AI for Generative and Agentic Systems - with Ranjan Sinha of IBM",
            "pub_date": "2025-10-30T06:00:00.000Z",
            "duration": "44:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "chip",
              "automation",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/architecting-enterprise-ai-for-generative-and-agentic-systems-with-ranjan-sinha-of-ibm",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-__10.30.25_-_Ranjan_Sinha.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "098a91f7-bd2c-4fe4-bb7b-c6281a409a95",
            "index": 112,
            "title": "Rethinking Clinical Trial Operations with AI and Remote Monitoring - with Scott Bradley of Novartis",
            "pub_date": "2025-10-28T06:00:00.000Z",
            "duration": "29:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcast.emerj.com/rethinking-clinical-trial-operations-with-ai-and-remote-monitoring-with-scott-bradley-of-novartis",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.28.25_-_Scott_Bradley.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b172c6d9-ca3b-459e-8657-9b36fa34cdae",
            "index": 113,
            "title": "Building AI-Ready Cultures in Life Sciences R&D - with Xiong Liu of Novartis",
            "pub_date": "2025-10-21T06:00:00.000Z",
            "duration": "30:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/building-ai-ready-cultures-in-life-sciences-rd-with-xiong-liu-of-novartis",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.21.25_-_Xiong_Liu.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a451581d-8417-4848-8423-1b76942c759c",
            "index": 114,
            "title": "Rethinking How Life Sciences Organizations Approach AI - Mathias Cousin of Deloitte",
            "pub_date": "2025-10-15T06:00:00.000Z",
            "duration": "38:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/rethinking-how-life-sciences-organizations-approach-ai-mathias-cousin-of-deloitte",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.15.25_-_Mathias_Cousin.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "075081a8-7929-41d6-9c14-d10badb6e0a7",
            "index": 115,
            "title": "Streamlining Fund Compliance with AI-Ready Data - Sandro Venturini of UBS",
            "pub_date": "2025-10-14T06:00:00.000Z",
            "duration": "21:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://podcast.emerj.com/streamlining-fund-compliance-with-ai-ready-data-sandro-venturini-of-ubs",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.14.25_-_Sandro_Venturini_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c08001f-da7a-4f81-a871-f5a86b17b62b",
            "index": 116,
            "title": "From Tool Sprawl to Defensible Value in AI for Legal - with Christo Siebrits of AbbVie",
            "pub_date": "2025-10-13T06:00:00.000Z",
            "duration": "27:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/from-tool-sprawl-to-defensible-value-in-ai-for-legal-with-christo-siebrits-of-abbvie",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.13.25_-_Christo_Siebrits.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b34b3437-5b7c-450c-aab9-e8c0a7d2eff9",
            "index": 117,
            "title": "Connecting the Dots Across Discovery - with Ben Ninio of Deloitte",
            "pub_date": "2025-10-10T06:00:00.000Z",
            "duration": "22:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/connecting-the-dots-across-discovery-with-ben-ninio-of-deloitte",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.10.25_-_Ben_Ninio.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e163aea2-c928-4261-8007-e3db3bec15ef",
            "index": 118,
            "title": "Enabling Strategic Procurement with AI, From Frustration to Foresight - with Rob DeSantis of Arkestro",
            "pub_date": "2025-10-10T06:00:00.000Z",
            "duration": "28:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/enabling-strategic-procurement-with-ai-from-frustration-to-foresight-with-rob-desantis-of-arkestro",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.10.25_-_Rob_DeSantis.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "94458446-d521-4a08-9131-26dfbf79d9b3",
            "index": 119,
            "title": "Fixing Ticket Noise with AI in Enterprise MSP Operations - with Steve Taczala of Impact Networking",
            "pub_date": "2025-10-09T07:00:00.000Z",
            "duration": "18:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/fixing-ticket-noise-with-ai-in-enterprise-msp-operations-with-steve-taczala-of-impact-networking",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business-10.9.25_-_Steve_Taczala.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "503beb47-7807-46cd-9f7e-09d52568e7c5",
            "index": 120,
            "title": "Data Volume, Quality, and Model Degradation for AI at Scale - with Sunitha Rao of Hitachi Vantara",
            "pub_date": "2025-10-09T06:00:00.000Z",
            "duration": "21:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/data-volume-quality-and-model-degradation-for-ai-at-scale-with-sunitha-rao-of-hitachi-vantara",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business---10.9.25_-Sunitha_Rao.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d322772-57b7-4825-a83a-b8f5fd6d5cca",
            "index": 121,
            "title": "The Future of AI Agents in Consumer Goods Operations - with Padma Hari of Nestlé Purina",
            "pub_date": "2025-10-08T07:00:00.000Z",
            "duration": "26:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://podcast.emerj.com/the-future-of-ai-agents-in-consumer-goods-operations-with-padma-hari-of-nestl-purina",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.08.25_-_Padma_Hari.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "500ff10a-4db6-4eca-a7af-d0f2627ab7e5",
            "index": 122,
            "title": "Practical AI for In-House Patent Legal - with Kevin Ahlstrom of Meta",
            "pub_date": "2025-10-08T06:00:00.000Z",
            "duration": "18:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/practical-ai-for-in-house-patent-legal-with-kevin-ahlstrom-of-meta",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.8.25_-_Kevin_Alhstrom.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc744ec4-b46c-4154-9e18-e16cdc37d9ce",
            "index": 123,
            "title": "The Expanding Role of Video and Visual Data From Footage to Forensics in Retail  - with Naveen Kumar of Walmart",
            "pub_date": "2025-10-07T06:00:00.000Z",
            "duration": "16:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "embedding"
            ],
            "page_url": "https://podcast.emerj.com/the-expanding-role-of-video-and-visual-data-from-footage-to-forensics-in-retail-with-naveen-kumar-of-walmart",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_10.7.25_-_Naveen_Kumar.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bf8289ed-50db-4b2a-9395-50929c8c78ae",
            "index": 124,
            "title": "How AI Is Reshaping Patent Strategy and Portfolio Management - with Shandon Quinn of Clarivate",
            "pub_date": "2025-10-02T06:00:00.000Z",
            "duration": "22:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/how-ai-is-reshaping-patent-strategy-and-portfolio-management-with-shandon-quinn-of-clarivate",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business-_10.2.25_-_Shandon_Quinn.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b353acba-72b0-4985-8ae7-5b27dfa0688d",
            "index": 125,
            "title": "Achieving Personalization and Compliance in Med Tech Solutions - with Faithe Toomy of Insulet",
            "pub_date": "2025-09-30T06:00:00.000Z",
            "duration": "22:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "training"
            ],
            "page_url": "https://podcast.emerj.com/achieving-personalization-and-compliance-in-med-tech-solutions-with-faithe-toomy-of-insulet",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.30.25_-Faithe_Toomy.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f65d682-a5d1-403e-a3d4-6718f56f2087",
            "index": 126,
            "title": "Human Compatible AI and AGI Risks - with Stuart Russell of the University of California",
            "pub_date": "2025-09-27T06:00:00.000Z",
            "duration": "01:03:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/human-compatible-ai-and-agi-risks-with-stuart-russell-of-the-university-of-california",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AI_in_Business_-_Stuart_Russell_-_9.26.25.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "51559df7-eecd-4ba6-b9ef-f79cdfab5e3a",
            "index": 127,
            "title": "Lessons from Running Massive Online Degrees at Scale - with Aaron Demory of Fearlus",
            "pub_date": "2025-09-23T06:00:00.000Z",
            "duration": "27:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/lessons-from-running-massive-online-degrees-at-scale-with-aaron-demory-of-fearlus",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.23.25_-_Aaron_Demory_FINAL_.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6411ffda-0556-42f3-9796-b0a90d9ae37c",
            "index": 128,
            "title": "Scaling Global Trade with AI Powered Tools for SMBs - with Kuo Zhang of Alibaba.com",
            "pub_date": "2025-09-18T06:00:00.000Z",
            "duration": "28:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "embedding"
            ],
            "page_url": "https://podcast.emerj.com/scaling-global-trade-with-ai-powered-tools-for-smbs-with-kuo-zhang-of-alibabacom",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.18.25_-_Kuo_Zhang_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9fe4a492-4b12-404a-ae2a-a55c5c07ee03",
            "index": 129,
            "title": "Reducing Errors and Improving Compliance in Global Oncology Programs - with Anthony Mikulaschek at IQVIA Technologies",
            "pub_date": "2025-09-16T06:00:00.000Z",
            "duration": "32:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/reducing-errors-and-improving-compliance-in-global-oncology-programs-with-anthony-mikulaschek-at-iqvia-technologies",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.16.25_-_Anthony_Mikulaschek.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2e020c7-6faa-4a1e-8a66-bb436b5d85cd",
            "index": 130,
            "title": "From Manual Reports to Generative and Agentic AI Automation in Finance - with Pavlé Sabic of Moody's",
            "pub_date": "2025-09-11T06:00:00.000Z",
            "duration": "28:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/from-manual-reports-to-generative-and-agentic-ai-automation-in-finance-with-pavl-sabic-of-moodys",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.11.25_-_Pavle_Sabic.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef214c0f-6e07-43e9-8092-52f882ab6fd4",
            "index": 131,
            "title": "Why Human Oversight and Management Will Still Matter in AI-Driven Pharma Operations - with Yunke Xiang of Sanofi",
            "pub_date": "2025-09-09T06:00:00.000Z",
            "duration": "20:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agentic",
              "reasoning",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/why-human-oversight-and-management-will-still-matter-in-ai-driven-pharma-operations-with-yunke-xiang-of-sanofi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.9.25_-_Yunke_Xiang.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a7914f0-cf52-4f08-92ca-9c59e6e92b18",
            "index": 132,
            "title": "The Future of Customer Experience in Financial Services with Agentic AI - with Abhii Parakh of Prudential Financial",
            "pub_date": "2025-09-05T07:00:00.000Z",
            "duration": "26:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/the-future-of-customer-experience-in-financial-services-with-agentic-ai-with-abhii-parakh-of-prudential-financial",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.5.25_-_Abhii_Parakh.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c26a6964-9675-40ad-89c3-7383b0a27587",
            "index": 133,
            "title": "Aligning Innovation with Oversight in AI Governance for Data Teams - with Shane Wiggins of OneTrust",
            "pub_date": "2025-09-05T06:00:00.000Z",
            "duration": "23:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embedding"
            ],
            "page_url": "https://podcast.emerj.com/aligning-innovation-with-oversight-in-ai-governance-for-data-teams-with-shane-wiggins-of-onetrust",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.5.25_-_Shane_Wiggins.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "250775f6-5ec0-4f0d-b354-2d2d7157090a",
            "index": 134,
            "title": "Predicting System Failures with AI in Banking - with Dale Skeen of Vitria Technology",
            "pub_date": "2025-09-04T07:00:00.000Z",
            "duration": "24:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/predicting-system-failures-with-ai-in-banking-with-dale-skeen-of-vitria-technology",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.4.25_-_Dale_Skeen.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c563f2dc-383b-4b50-b87f-a04f65493c5a",
            "index": 135,
            "title": "Balancing Trade-Offs in Hybrid Cloud and the Infrastructure behind Scalable AI - with Jason Hardy of Hitachi Vantara",
            "pub_date": "2025-09-04T06:00:00.000Z",
            "duration": "25:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/balancing-trade-offs-in-hybrid-cloud-and-the-infrastructure-behind-scalable-ai-with-jason-hardy-of-hitachi-vantara",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.4.25_-_Jason_Hardy.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0842bb5-90bc-4a54-8f31-e0370aa32f7c",
            "index": 136,
            "title": "Data Pipelines that Support Globalized Education and Training Programs - with Norma Scagnoli of the Illinois Institute of Technology",
            "pub_date": "2025-09-03T07:00:00.000Z",
            "duration": "32:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://podcast.emerj.com/data-pipelines-that-support-globalized-education-and-training-programs-with-norma-scagnoli-of-the-illinois-institute-of-technology",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.3.25_-_Norma_Scagnoli.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d6637a46-4922-4088-a3bc-908417351950",
            "index": 137,
            "title": "Turning CPG Complexity into Real-Time Decisions with AI - with Henrique Wakil Moyses of Crisp",
            "pub_date": "2025-09-03T06:00:00.000Z",
            "duration": "26:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/turning-cpg-complexity-into-real-time-decisions-with-ai-with-henrique-wakil-moyses-of-crisp",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.3.25_-_Henrique_Moyses.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "40241323-f420-42c4-9fcd-01444ec9f409",
            "index": 138,
            "title": "How Financial Institutions Can Prepare for the Future of Fraud with Responsible AI Deployments - with JoAnn Stonier of Mastercard",
            "pub_date": "2025-09-02T06:00:00.000Z",
            "duration": "29:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/how-financial-institutions-can-prepare-for-the-future-of-fraud-with-responsible-ai-deployments-with-joann-stonier-of-mastercard",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_9.2.25_-_JoAnn_Stonier.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d281fa31-97f0-458a-94fd-91945efdae2b",
            "index": 139,
            "title": "Unlocking Infrastructure as the Engine of Transformation – with Deborah Golden from Deloitte",
            "pub_date": "2025-09-02T06:00:00.000Z",
            "duration": "38:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/unlocking-infrastructure-as-the-engine-of-transformation-with-deborah-golden-from-deloitte",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.23.25_-_Deborah_Golden_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e00d545c-680e-4b6e-a75f-80fa47ef6092",
            "index": 140,
            "title": "Balancing Efficiency and Trust in Field Service Operations - with Eric Rivas of Electrolux",
            "pub_date": "2025-08-28T06:00:00.000Z",
            "duration": "23:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/balancing-efficiency-and-trust-in-field-service-operations-with-eric-rivas-of-electrolux-0",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_Eric_Rivas_-_Electrolux_-_8.28.25_AIB_-MD0826ed.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c092633f-de26-4217-b593-cde4ea802705",
            "index": 141,
            "title": "Why System Integrators Are Key to AI Success - with Pallab Deb of Google",
            "pub_date": "2025-08-27T07:00:00.000Z",
            "duration": "44:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "multimodal"
            ],
            "page_url": "https://podcast.emerj.com/why-system-integrators-are-key-to-ai-success-with-pallab-deb-of-google",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.27.25_-_Pallab_Deb.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5ec1c0ae-8467-4afa-b5c4-1c35c9e9c9e4",
            "index": 142,
            "title": "How Data Ownership Drives Trustworthy AI Models - with Joe Lang of Comfort Systems",
            "pub_date": "2025-08-27T06:00:00.000Z",
            "duration": "16:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-data-ownership-drives-trustworthy-ai-models-with-joe-lang-of-comfort-systems",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.27.25_-_Joe_Lang.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c69dd061-3d74-4445-9809-892cdce0a5ee",
            "index": 143,
            "title": "GenAI, Trust and Talent in Modern Loss-Prevention - with Joe Troy of Amazon",
            "pub_date": "2025-08-26T06:00:00.000Z",
            "duration": "15:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/genai-trust-and-talent-in-modern-loss-prevention-with-joe-troy-of-amazon",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.26.25_-_Joe_Troy.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "85407926-8a4c-481d-bcfc-ce5fc4b8e9cf",
            "index": 144,
            "title": "Operationalizing Portfolio Decisions at Speed and Scale - with Madhav Madaboosi of bp",
            "pub_date": "2025-08-25T08:57:00.000Z",
            "duration": "25:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/operationalizing-portfolio-decisions-at-speed-and-scale-with-madhav-madaboosi-of-bp",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.25.25_-_Madhav_Madaboosi.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5528c46-8d6d-4ee3-980b-83866fb66ade",
            "index": 145,
            "title": "Turning Legacy Service Contracts into First Time Fix Wins - with Joe Lang of Comfort Systems",
            "pub_date": "2025-08-21T06:00:00.000Z",
            "duration": "25:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/turning-legacy-service-contracts-into-first-time-fix-wins-with-joe-lang-of-comfort-systems",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.21.25_-_Joe_Lang.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4462513-5cc0-4b5b-8f99-63ba4b34d74f",
            "index": 146,
            "title": "Storage Strategies That Keep GenAI on Budget - with Amit Gupta of Danaher",
            "pub_date": "2025-08-20T09:05:00.000Z",
            "duration": "16:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/storage-strategies-that-keep-genai-on-budget-with-amit-gupta-of-danaher",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.20.25_-_Amit_Gupta.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33c64139-3a58-4ecf-9235-47f7e5f7fc9a",
            "index": 147,
            "title": "AI Use Cases Streamlining Commercial Insurance Operations - with Sidharth Ojha of AXA XL",
            "pub_date": "2025-08-19T06:00:00.000Z",
            "duration": "21:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://podcast.emerj.com/ai-use-cases-streamlining-commercial-insurance-operations-with-sidharth-ojha-of-axa-xl",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/BUSINESS_-_8.19.25_-_Sidharth_Ojha.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f17b4b3-aa70-47ee-8be5-7604803570bc",
            "index": 148,
            "title": "Moving from Pilot to Profit in Service AI Deployments - with Amit Gupta of Danaher",
            "pub_date": "2025-08-14T06:00:00.000Z",
            "duration": "15:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/moving-from-pilot-to-profit-in-service-ai-deployments-with-amit-gupta-of-danaher",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business-_8.14.25_-_Amit_Gupta.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "05ad2f22-d578-467f-beae-2f02f98ba38d",
            "index": 149,
            "title": "Turning AI Vision Into Value in Financial Services - with Kelly Dempski of Turing",
            "pub_date": "2025-08-12T07:00:00.000Z",
            "duration": "17:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "frontier model"
            ],
            "page_url": "https://podcast.emerj.com/turning-ai-vision-into-value-in-financial-services-with-kelly-dempski-of-turing",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.12.25_-_Kelly_Dempski_-_Turing_-_MD0811ed.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bc642356-062e-4b4f-8bed-8c88da51aa9d",
            "index": 150,
            "title": "Ethical AI Solutions and Their Impact on Life Sciences and Beyond - with Dr. Steffen Hoffmann of Bosch",
            "pub_date": "2025-08-12T06:00:00.000Z",
            "duration": "17:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/ethical-ai-solutions-and-their-impact-on-life-sciences-and-beyond-with-dr-steffen-hoffmann-of-bosch",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.12.25_-_Dr._Steffen_Hoffmann.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eb8ebda8-2b71-4730-b344-4e68dc6efdc3",
            "index": 151,
            "title": "Scaling Growth in Asset Management with AI-Ready Data - with Frank Hattann of Ocorian",
            "pub_date": "2025-08-08T06:00:00.000Z",
            "duration": "24:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/scaling-growth-in-asset-management-with-ai-ready-data-with-frank-hattann-of-ocorian",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_Frank_Hattan_-_Ocorian_-_8.8.25_AIB__MD0807-1108ed.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4aef3c17-3224-41a0-a74b-ac4dd6080341",
            "index": 152,
            "title": "Overcoming Compliance Challenges in Legal AI Adoption - with Ryan Anderson at Filevine",
            "pub_date": "2025-08-06T06:00:00.000Z",
            "duration": "26:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/overcoming-compliance-challenges-in-legal-ai-adoption-with-ryan-anderson-at-filevine",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.6.25_-_Ryan_Anderson.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d0899e13-8ecb-47be-9ac4-686ed6cf894e",
            "index": 153,
            "title": "Enhancing Clinical Workflows and Optimizing Efficiencies - with Patricio La Rosa at Bayer",
            "pub_date": "2025-08-05T06:00:00.000Z",
            "duration": "29:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://podcast.emerj.com/enhancing-clinical-workflows-and-optimizing-efficiencies-with-patricio-la-rosa-at-bayer",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_8.5.25_-_Patricio_LaRosa.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4d948701-1c3f-4e45-ad7b-2f604e8df1af",
            "index": 154,
            "title": "Accelerating Retail & CPG Transformation through AI Solutions - with Dwight Hill of Turing and Joe Troy of Amazon",
            "pub_date": "2025-08-04T06:00:00.000Z",
            "duration": "29:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "frontier model",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/accelerating-retail-cpg-transformation-through-ai-solutions-with-dwight-hill-of-turing-and-joe-troy-of-amazon",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_Joe_Troy_Dwight_Hill_-_8.4.25_AIB_-_MD0801ed.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "905207b4-f4d4-46c9-901c-7a6acb5bc95e",
            "index": 155,
            "title": "Transforming Manufacturing with AI-Powered 3D Digital Twins and Remote Monitoring - with Rad Desiraju of Microsoft and Mike Geyer of NVIDIA",
            "pub_date": "2025-07-31T06:00:00.000Z",
            "duration": "33:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://podcast.emerj.com/transforming-manufacturing-with-ai-powered-3d-digital-twins-and-remote-monitoring-with-rad-desiraju-of-microsoft-and-mike-geyer-of-nvidia",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_Rad_Desiraju__Mike_Geyer_-_7.31.25_-_MD-0730.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0901499e-f1f8-4dcf-8cf6-1a05a9d326bf",
            "index": 156,
            "title": "Building Storage Strategies That Scale with AI Workloads - with Bryan Willett of Lexmark",
            "pub_date": "2025-07-30T06:00:00.000Z",
            "duration": "17:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/building-storage-strategies-that-scale-with-ai-workloads-with-bryan-willett-of-lexmark",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.30.25_-_Bryan_Willett.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0910c111-d363-43d3-816b-253cf25b9241",
            "index": 157,
            "title": "Enhancing Drug Safety with AI and Automation Technologies - with Marie Flanagan of IQVIA",
            "pub_date": "2025-07-29T06:00:00.000Z",
            "duration": "22:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "safety",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/enhancing-drug-safety-with-ai-and-automation-technologies-with-marie-flanagan-of-iqvia",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.29.25_-_Marie_Flanagan.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9ed83d18-dfb1-4ba8-872b-cbbe182e8034",
            "index": 158,
            "title": "Building Trusted AI Systems in Financial Services From Strategy to Scale - with Zar Toolan of Edward Jones",
            "pub_date": "2025-07-28T08:49:00.000Z",
            "duration": "27:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/building-trusted-ai-systems-in-financial-services-from-strategy-to-scale-with-zar-toolan-of-edward-jones",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.28.25_-_Zar_Toolan.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "edf15549-bdc8-432f-b9f3-d7038bbc069e",
            "index": 159,
            "title": "How AI Partnerships Make Security a Strategic Advantage - with Bryan Willett of Lexmark",
            "pub_date": "2025-07-23T06:00:00.000Z",
            "duration": "19:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-ai-partnerships-make-security-a-strategic-advantage-with-bryan-willett-of-lexmark",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.23.25_-_Bryan_Willett.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f28a2ef3-ab62-4585-ae4e-2fc86ee04053",
            "index": 160,
            "title": "Responsible AI That Scales Across Customer Workflows - with Miranda Jones of Emprise Bank",
            "pub_date": "2025-07-22T06:00:00.000Z",
            "duration": "22:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "alignment"
            ],
            "page_url": "https://podcast.emerj.com/responsible-ai-that-scales-across-customer-workflows-with-miranda-jones-of-emprise-bank",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.22.25_-_Miranda_Jones.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9e8322c-7ad4-4015-a958-26426c9ebcb0",
            "index": 161,
            "title": "Why Service Teams Outgrow DIY AI Solutions - with Neil Bhandar of Generac",
            "pub_date": "2025-07-17T06:00:00.000Z",
            "duration": "36:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "alignment"
            ],
            "page_url": "https://podcast.emerj.com/why-service-teams-outgrow-diy-ai-solutions-with-neil-bhandar-of-generac",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.17.25_-_Neil_Bhandar.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6d424560-c801-4930-9786-49b6f1ebebc6",
            "index": 162,
            "title": "Inside the AI Playbook for Scientific Discovery and Optimization - with Brian Lutz of Corteva",
            "pub_date": "2025-07-16T06:00:00.000Z",
            "duration": "27:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/inside-the-ai-playbook-for-scientific-discovery-and-optimization-with-brian-lutz-of-corteva",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Brian_Lutz-Corteva_-_AIB_7.16.25_-_FIN-MD.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2213691-f77a-4df8-bae4-4e094d61983d",
            "index": 163,
            "title": "Why Immutable Snapshots Matter for Compliance and AI - with Neil Bhandar of Generac",
            "pub_date": "2025-07-15T08:00:00.000Z",
            "duration": "30:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/why-immutable-snapshots-matter-for-compliance-and-ai-with-neil-bhandar-of-generac",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.15.25_-_Neil_Bhandar_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa2f7d29-d9be-4f79-bce3-cb821b4d5cc9",
            "index": 164,
            "title": "AI for Driving Quality Customer Interactions in Distributor Models - with Joshua Haddock of Herbalife",
            "pub_date": "2025-07-15T07:00:00.000Z",
            "duration": "27:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/ai-for-driving-quality-customer-interactions-in-distributor-models-with-joshua-haddock-of-herbalife",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.15.25_-_Josh_Haddock.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68c81c3e-9dad-40a0-9b64-9ad9fb0a7db7",
            "index": 165,
            "title": "Breaking the Doom Loop in IT Service Management - with Phil Christianson of Xurrent",
            "pub_date": "2025-07-15T06:00:00.000Z",
            "duration": "30:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/breaking-the-doom-loop-in-it-service-management-with-phil-christianson-of-xurrent",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.15.25_-_Phil_Christianson_1.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13bd7025-fb57-42b7-b6ff-c7ec3ed45765",
            "index": 166,
            "title": "Turning Healthcare Innovation into Real Patient Impact - with Brad Kennedy of Orlando Health",
            "pub_date": "2025-07-14T09:00:00.000Z",
            "duration": "24:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/turning-healthcare-innovation-into-real-patient-impact-with-brad-kennedy-of-orlando-health",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Brad_Kennedy_-_7.14.25_-_AIB_-_Productive_Edge_-_MdEd.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f0b4077-ca78-46c9-a2ab-0fa6d98ab6d9",
            "index": 167,
            "title": "From Control Checks to Enterprise Strategy with AI in Audit - with Itumeleng Masunyane of Amicorp",
            "pub_date": "2025-07-11T06:00:00.000Z",
            "duration": "18:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/from-control-checks-to-enterprise-strategy-with-ai-in-audit-with-itumeleng-masunyane-of-amicorp",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.11.25_-_Itumeleng_Masunyane_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3db002e0-903c-4425-8c7b-70038cf32a75",
            "index": 168,
            "title": "How Domain-Specific GenAI-Driven Orchestration Unlocks Value in Secure and Siloed Data Environments - with Arun Subramaniyan of Articul8",
            "pub_date": "2025-07-10T07:00:00.000Z",
            "duration": "29:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-domain-specific-genai-driven-orchestration-unlocks-value-in-secure-and-siloed-data-environments-with-arun-subramaniyan-of-articul8",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.1025_-_Arun_Subramaniyan.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48c227dd-7f7c-4230-8331-bea490b46a25",
            "index": 169,
            "title": "Inside the New Era of Loss Prevention with Video Intelligence - with Joe Troy of Amazon",
            "pub_date": "2025-07-10T06:00:00.000Z",
            "duration": "19:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/inside-the-new-era-of-loss-prevention-with-video-intelligence-with-joe-troy-of-amazon",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.10.25_-_Joe_Troy.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "03a7270f-6f82-4f3e-81a0-12d426f6fff3",
            "index": 170,
            "title": "AI ROI for Patient Insights and Better Eligibility Rates in Clinical Trials - with Michael Zaiac of Daiichi Sankyo",
            "pub_date": "2025-07-09T07:00:00.000Z",
            "duration": "25:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "alignment"
            ],
            "page_url": "https://podcast.emerj.com/ai-roi-for-faster-recruitment-and-better-eligibility-rates-in-clinical-trials-with-michael-zaiac-of-daiichi-sankyo",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.9.25_-_Michael_Zaiac.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f08ada7f-4d84-4993-964d-ce9c1dc4ed59",
            "index": 171,
            "title": "Smarter Compliance Through Transparent AI Deployment - with Miranda Jones of Emprise Bank",
            "pub_date": "2025-07-09T06:00:00.000Z",
            "duration": "19:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embedding"
            ],
            "page_url": "https://podcast.emerj.com/smarter-compliance-through-transparent-ai-deployment-with-miranda-jones-of-emprise-bank",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.9.25_-_Miranda_Jones.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "44e40e95-e70d-428c-bc1d-fdadfddb9c4a",
            "index": 172,
            "title": "How AI is Orchestrating the Insurance Supply Chain - with Marc Fredman of CCC Intelligent Solutions",
            "pub_date": "2025-07-08T06:00:00.000Z",
            "duration": "23:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/how-ai-is-orchestrating-the-insurance-supply-chain-with-mark-fredman-of-ccc-intelligent-solutions",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.8.25_-_Marc_Fredman_.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "826f0d2a-383b-4daa-b177-a539adbe651f",
            "index": 173,
            "title": "Keeping the Patient Voice in De-Identified Data Models - with Brad Kennedy of Orlando Health",
            "pub_date": "2025-07-07T06:00:00.000Z",
            "duration": "24:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/keeping-the-patient-voice-in-de-identified-data-models-with-brad-kennedy-of-orlando-health",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.7.25_-_Brad_Kennedy_.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f5ce058-9fdf-45ed-b5f1-25f411a5947a",
            "index": 174,
            "title": "Transforming Care Management and Disease Management Workflows with Agentic AI - with Raheel Retiwalla of Productive Edge",
            "pub_date": "2025-07-03T06:00:00.000Z",
            "duration": "24:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/transforming-care-management-and-disease-management-workflows-with-agentic-ai-with-raheel-retiwalla-of-productive-edge",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.3.25_-_Raheel_Retiwalla.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89e18e9e-f3c0-4acd-a57f-0cd61032a159",
            "index": 175,
            "title": "Lessons from Project Warp Speed in How High-Velocity Partners Are Scaling AI in Manufacturing - with Emily Nguyen of Palantir Technologies",
            "pub_date": "2025-07-01T06:00:00.000Z",
            "duration": "24:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/lessons-from-project-warp-speed-in-how-high-velocity-partners-are-scaling-ai-in-manufacturing-with-emily-nguyen-of-palantir-technologies",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_7.1.25_-_Emily_Nguyen_-_MDedFIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "62746386-8249-4363-ab2a-1d7906dbbe28",
            "index": 176,
            "title": "Unlocking Enterprise Efficiency Through AI Orchestration - Kevin Kiley of Airia",
            "pub_date": "2025-06-27T06:00:00.000Z",
            "duration": "20:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/unlocking-enterprise-efficiency-through-ai-orchestration-kevin-kiley-of-airia",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.27.25_-Kevin_Kiley.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7208c79-e0c6-4110-8c61-246fbbe39345",
            "index": 177,
            "title": "AI in Healthcare Devices and the Challenge of Data Privacy - with Dr. Ankur Sharma at Bayer",
            "pub_date": "2025-06-24T06:00:00.000Z",
            "duration": "19:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/ai-in-healthcare-devices-and-the-challenge-of-data-privacy-with-dr-ankur-sharma-at-bayer",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.24.25_-_Ankur_Sharma.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f085b50-9545-46a6-9a7d-934a95deed57",
            "index": 178,
            "title": "Lessons from Walmart in Building AI at Scale - with David Glick of Walmart",
            "pub_date": "2025-06-19T06:00:00.000Z",
            "duration": "28:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://podcast.emerj.com/lessons-from-walmart-in-building-ai-at-scale-with-david-glick-of-walmart",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.19.25_-_David_Glick.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e54a333-48ef-4327-aab2-799b1656bd15",
            "index": 179,
            "title": "Building AI Systems That Think Like Scientists in Life Sciences - Annabel Romero of Deloitte",
            "pub_date": "2025-06-18T06:00:00.000Z",
            "duration": "31:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://podcast.emerj.com/building-ai-systems-that-think-like-scientists-in-life-sciences-annabel-romero-of-deloitte",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.18.25_-_Annabel_Romero_.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8207f464-3e72-4ea9-b157-321a09436540",
            "index": 180,
            "title": "Challenges Slowing AI Adoption in Life Sciences Manufacturing - with Yunke Xiang of Sanofi",
            "pub_date": "2025-06-17T06:00:00.000Z",
            "duration": "20:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/challenges-slowing-ai-adoption-in-life-sciences-manufacturing-with-yunke-xiang-of-sanofi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/BUSINESS_-__6.17.25_-Yunke_Xiang_mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1b30e8b4-6224-4e27-83af-fec091ccad1d",
            "index": 181,
            "title": "What Smart Manufacturing Leaders Consider Before Adopting AI - with Tim Burge of Aquant",
            "pub_date": "2025-06-12T07:00:00.000Z",
            "duration": "28:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/what-smart-manufacturing-leaders-consider-before-adopting-ai-with-tim-burge-of-aquant",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.12.25_-_Tim_Burge.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c0ff51e-8a46-4601-9ffa-641a03537ba9",
            "index": 182,
            "title": "Shaping the Future of Healthcare with AI - with Lyndi Wu of NVIDIA and Will Guyman of Microsoft",
            "pub_date": "2025-06-12T06:00:00.000Z",
            "duration": "39:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "nvidia",
              "gpu",
              "data center"
            ],
            "page_url": "https://podcast.emerj.com/shaping-the-future-of-healthcare-with-ai-with-lyndi-wu-of-nvidia-and-will-guyman-of-microsoft",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.26.25_-_Will_Guyman_and_Lyndi_Wu_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b3b32288-92b5-4874-bfd6-fe79bcb15ed2",
            "index": 183,
            "title": "The AI Minded Path to Scalable and Responsible Innovation Across the Enterprise - with James Raybould of Turing Intelligence",
            "pub_date": "2025-06-11T06:00:00.000Z",
            "duration": "31:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "frontier model",
              "alignment",
              "automation",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/the-ai-minded-path-to-scalable-and-responsible-innovation-across-the-enterprise-with-james-raybould-of-turing-intelligence",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-__6.11.25_-_James_Raybould._FIN_mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bc7c9dec-4f17-4666-8c68-85fc7b5dcb40",
            "index": 184,
            "title": "Driving AI in Fraud and AML Compliance for Financial Services - with Nick Lewis of Standard Chartered Bank",
            "pub_date": "2025-06-10T06:00:00.000Z",
            "duration": "20:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/driving-ai-in-fraud-and-aml-compliance-for-financial-services-with-nick-lewis-of-standard-chartered-bank",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.10.25_-_Nick_Lewis.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2b9db037-9bf3-4efb-a856-0dfe5ff183aa",
            "index": 185,
            "title": "Evolving Expectations in Fraud and Risk Response from Dispute to Detection - with Naveen Kumar of Walmart",
            "pub_date": "2025-06-09T06:00:00.000Z",
            "duration": "16:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/evolving-expectations-in-fraud-and-risk-response-from-dispute-to-detection-with-naveen-kumar-of-walmart",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.9.25_-_Naveen_Kumar.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2adf8fb1-8946-4cf6-9c6d-ea5ad0cf4742",
            "index": 186,
            "title": "Building Better PCB Layouts with AI Driven Optimization - with Alain-Sam Cohen of InstaDeep",
            "pub_date": "2025-06-06T06:00:00.000Z",
            "duration": "23:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/building-better-pcb-layouts-with-ai-driven-optimization-with-alain-sam-cohen-of-instadeep",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.6.25_-_Alain-Sam_Cohen_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1763be14-ed44-4c71-8047-77c53b760a6f",
            "index": 187,
            "title": "Leveraging Data to Scale Drug Development Globally - with Damion Nero of Takeda",
            "pub_date": "2025-06-05T07:00:00.000Z",
            "duration": "29:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/leveraging-data-to-scale-drug-development-globally-with-damion-nero-of-takeda",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.5.25_-_Damion_Nero.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5dad4637-733e-4c0a-bf51-158fe4423075",
            "index": 188,
            "title": "Rethinking Customer Experiences with AI-Driven Conversations - with Alan Ranger of Cognigy",
            "pub_date": "2025-06-05T06:00:00.000Z",
            "duration": "29:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/rethinking-customer-experiences-with-ai-driven-conversations-with-alan-ranger-of-cognigy",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.5.25_-_Alan_Ranger.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "283a377f-f989-4091-94e5-bfe84d20e101",
            "index": 189,
            "title": "The Evolving Role of AI in Modernizing Clinical Trials - with Xiong Liu of Novartis",
            "pub_date": "2025-06-04T06:00:00.000Z",
            "duration": "28:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/the-evolving-role-of-ai-in-modernizing-clinical-trials-with-xiong-liu-of-novartis",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.4.25_-_Xiong_Liu.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f949f32-6e6a-4960-93b9-96ae7a8fcca6",
            "index": 190,
            "title": "Driving Data Security in Unstructured and Structured Data for Customer Analytics - with Jiaxi Zhu of Google",
            "pub_date": "2025-06-03T07:27:00.000Z",
            "duration": "26:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/driving-data-security-in-unstructured-and-structured-data-for-customer-analytics-with-jiaxi-zhu-of-google",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_6.3.25_-_Jiaxi_Zhu.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3cfe15d5-af35-4a5e-bce3-972746ef3cb5",
            "index": 191,
            "title": "Laying the Groundwork for Enterprise AI in Banking and Finance - with Chris Tapley of EPAM",
            "pub_date": "2025-05-30T06:00:00.000Z",
            "duration": "42:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment",
              "enterprise ai"
            ],
            "page_url": "https://podcast.emerj.com/laying-the-groundwork-for-enterprise-ai-in-banking-and-finance-with-chris-tapley-of-epam",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.30.25_-_Chris_Tapley.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "421c55a0-8fa8-413c-9fac-29c09b8df16e",
            "index": 192,
            "title": "Scaling Drug Manufacturing from Clinical Trials to Commercial Production - with Shreyas Becker of Sanofi",
            "pub_date": "2025-05-29T06:00:00.000Z",
            "duration": "24:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/scaling-drug-manufacturing-from-clinical-trials-to-commercial-production-with-shreyas-becker-of-sanofi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.29.25_-_Shreyas_Becker.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fcf5338a-f3fa-4ee2-adcd-f4ee55edd126",
            "index": 193,
            "title": "AI Data Strategies for Life Sciences Agriculture and Materials Science - with Daniel Ferrante of Deloitte",
            "pub_date": "2025-05-28T07:00:00.000Z",
            "duration": "40:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://podcast.emerj.com/ai-data-strategies-for-life-sciences-agriculture-and-materials-science-with-daniel-ferrante-of-deloitte",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.28.25_-_Daniel_Ferrante_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "08d58828-ec1a-4630-98dc-041df43b2abc",
            "index": 194,
            "title": "Unlocking Operational Efficiency with AI in Accounting Departments - with Greg Cucino of RoundTable",
            "pub_date": "2025-05-28T06:00:00.000Z",
            "duration": "24:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/unlocking-operational-efficiency-with-ai-in-accounting-departments-with-greg-cucino-of-roundtable",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.28.25_-__Greg_Cucino.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70cfb6d3-0c27-470d-b5f2-0cb76e6fc050",
            "index": 195,
            "title": "How AI is Reshaping Commercial Insurance and Risk Assessment - with Sidharth Ojha of AXA XL",
            "pub_date": "2025-05-27T06:00:00.000Z",
            "duration": "26:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-ai-is-reshaping-commercial-insurance-and-risk-assessment-with-sidharth-ojha-of-axa-xl",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.27.25_-_Sidharth_Ojha.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "57026928-6bfa-490e-99aa-8ad62f52d7fc",
            "index": 196,
            "title": "How Integrated Systems Are Reshaping Global Risk Oversight - with Kandie Ibaka of Citi",
            "pub_date": "2025-05-26T07:00:00.000Z",
            "duration": "17:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/how-integrated-systems-are-reshaping-global-risk-oversight-with-kandie-ibaka-of-citi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.26.25_-_Kandie_Ibaka_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4abfacb8-0c71-4693-8eb7-0f9ebd71d476",
            "index": 197,
            "title": "Breaking Complexity in Banking Risk Operations With AI - with Nathaniel Bell of Wells Fargo",
            "pub_date": "2025-05-26T06:00:00.000Z",
            "duration": "19:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/breaking-complexity-in-banking-risk-operations-with-ai-with-nathaniel-bell-of-wells-fargo",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.26.25_-_Nathaniel_Bell_EP_2.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11cf0c34-ef02-42cb-b1ba-ea5dc953c666",
            "index": 198,
            "title": "Reducing Sanctions Compliance Pressure with Smarter Tools - with Kandie Ibaka of Citi",
            "pub_date": "2025-05-24T06:00:00.000Z",
            "duration": "17:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://podcast.emerj.com/reducing-sanctions-compliance-pressure-with-smarter-tools-with-kandie-ibaka-of-citi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.24.25_-_Kandie_Ibaka_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af3c2975-52b3-4301-a8ec-9443cd427f6f",
            "index": 199,
            "title": "Driving AI Adoption in Wealth and Asset Management - with Deep Srivastav of Franklin Templeton",
            "pub_date": "2025-05-23T06:00:00.000Z",
            "duration": "32:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/driving-ai-adoption-in-wealth-and-asset-management-with-deep-srivastav-of-franklin-templeton",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.23.25_-_Deep_Srivastav_FIX.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "040a2531-66e1-465e-a3c3-3aa1c105e2fd",
            "index": 200,
            "title": "Building Agile R&D Strategies Through Predictive Analytics - with Scott Bradley of Novartis",
            "pub_date": "2025-05-22T06:00:00.000Z",
            "duration": "19:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/building-agile-rd-strategies-through-predictive-analytics-with-scott-bradley-of-novartis",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.22.25_-_Scott_Bradley.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "691a266f-91d4-4d83-a8b3-e6a4908df761",
            "index": 201,
            "title": "How AI Is Transforming Clinical Trials and Data Access - with Mathew Paruthickal of Sanofi",
            "pub_date": "2025-05-21T06:00:00.000Z",
            "duration": "20:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/how-ai-is-transforming-clinical-trials-and-data-access-with-mathew-paruthickal-of-sanofi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.21.25_-_Mathew_Paruthickal.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f5250b4-beac-4d77-9b9a-ad6ce1695d9b",
            "index": 202,
            "title": "Neurobiological and Cybernetic AI for Manufacturing, Part 2 - with Oleg Savin of Unilever",
            "pub_date": "2025-05-20T06:00:00.000Z",
            "duration": "29:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/neurobiological-and-cybernetic-ai-for-manufacturing-part-2-with-oleg-savin-of-unilever",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.20.25_-_Oleg_Savin.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ee4cf8e9-f907-4dbb-86ab-f9e7ece628d1",
            "index": 203,
            "title": "Scaling AI with Storage Efficiency - with Shawn Rosemarin of Pure Storage",
            "pub_date": "2025-05-19T06:00:00.000Z",
            "duration": "33:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/scaling-ai-with-storage-efficiency-with-shawn-rosemarin-of-pure-storage",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.19.25_-_Shawn_Rosemarin.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3cef4b2b-4f8f-4c66-9211-43e87a10c5fd",
            "index": 204,
            "title": "Where AI Can Reduce Risk and Cost in Audit Processes - with Nathaniel Bell of Wells Fargo",
            "pub_date": "2025-05-16T06:00:00.000Z",
            "duration": "29:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/where-ai-can-reduce-risk-and-cost-in-audit-processes-with-nathaniel-bell-of-wells-fargo",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.16.25_-_Nathaniel_Bell_Ep_1.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ebb5c081-641f-4b29-9cd3-b6593ac694b6",
            "index": 205,
            "title": "The Future of IT Operations with Automation and Real-Time Insights - with Troy Felix of BigPanda",
            "pub_date": "2025-05-15T07:00:00.000Z",
            "duration": "22:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/the-future-of-it-operations-with-automation-and-real-time-insights-with-troy-felix-of-bigpanda",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_Troy_Felix_-_5.15.25_MDedit.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dda3f75a-352e-4651-89a8-3b5847049491",
            "index": 206,
            "title": "Fraud Prevention in the Digital Age from KYC to Chargebacks - with Matt DeLauro of SEON",
            "pub_date": "2025-05-15T06:00:00.000Z",
            "duration": "24:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/fraud-prevention-in-the-digital-age-from-kyc-to-chargebacks-with-matt-delauro-of-seon",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/BUSINESS_-_5.15.25_-_Matt_DeLauro.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b7369c69-3971-4ccf-a719-f145c0c29109",
            "index": 207,
            "title": "Leveraging AI for Better Outcomes Across Drug Development - with Patricio La Rosa of Bayer",
            "pub_date": "2025-05-13T06:00:00.000Z",
            "duration": "33:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/leveraging-ai-for-better-outcomes-across-drug-development-with-patricio-la-rosa-of-bayer",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.13.25_-_Patricio_La_Rosa.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1741de42-fa91-49a9-acc3-03d0a4f9e8f2",
            "index": 208,
            "title": "How Financial Services Are Building Safer Customer-Facing AI - with Akhil Khunger of Barclays",
            "pub_date": "2025-05-12T07:00:00.000Z",
            "duration": "19:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "embedding"
            ],
            "page_url": "https://podcast.emerj.com/how-financial-services-are-building-safer-customer-facing-ai-with-akhil-khunger-of-barclays",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.12.25_-_Akhil_Khunger.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1e9b3ec-efa6-4073-8c60-4e0532ec59c5",
            "index": 209,
            "title": "Navigating Challenges and Solutions in Data Security with AI - with Dimitri Sirota of BigID",
            "pub_date": "2025-05-08T06:00:00.000Z",
            "duration": "29:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/navigating-challenges-and-solutions-in-data-security-with-ai-with-dimitri-sirota-of-bigid",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.8.25_-_Dimitri_Sirota.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "25b34f9a-b953-41aa-b389-19932fe61ebe",
            "index": 210,
            "title": "Scaling AI for Clinical Trials - with Damion Nero of Takeda",
            "pub_date": "2025-05-07T06:00:00.000Z",
            "duration": "26:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/scaling-ai-for-clinical-trials-with-damion-nero-of-takeda",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.7.25_-_Damion_Nero.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b73c6aa2-862c-472b-a117-aeed1fe63c33",
            "index": 211,
            "title": "The Future of Adverse Event Detection in Healthcare and Life Sciences - with Marie Flanagan of IQVIA",
            "pub_date": "2025-05-06T06:00:00.000Z",
            "duration": "21:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/the-future-of-adverse-event-detection-in-healthcare-and-life-sciences-with-marie-flanagan-of-iqvia",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_5.6.25_-_Marie_Flanagan.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b1a70eac-1c95-4c94-99ce-5f063dc15d3f",
            "index": 212,
            "title": "How Financial Services Are Balancing Automation and Flexibility - with Akhil Khunger of Barclays",
            "pub_date": "2025-05-05T09:36:00.000Z",
            "duration": "20:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/how-financial-services-are-balancing-automation-and-flexibility-with-akhil-khunger-of-barclays",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/AI_in_Business_-_5.5.25_-_Akhil_Khunger.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f66deab2-0f34-4e29-b0d5-115ce1b4b8ba",
            "index": 213,
            "title": "Building Readiness for AI Agents in Healthcare Systems - with Raheel Retiwalla of Productive Edge",
            "pub_date": "2025-05-01T06:00:00.000Z",
            "duration": "33:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/building-readiness-for-ai-agents-in-healthcare-systems-with-raheel-retiwalla-of-productive-edge",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/BUSINESS_-_5.1.25_-_Raheel_Rentiwalla.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "96b5805a-ad21-43d4-afc5-6fda42fedb75",
            "index": 214,
            "title": "How Responsible AI is Shaping the Future of Banking and Finance - with Shub Agarwal of U.S. Bank and USC",
            "pub_date": "2025-04-29T06:00:00.000Z",
            "duration": "21:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/how-responsible-ai-is-shaping-the-future-of-banking-and-finance-with-shub-agarwal-of-us-bank-and-usc",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_04.29.25_-_Shub_Agarwal.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83ad76e5-f546-4b6d-b592-7155f9576b7b",
            "index": 215,
            "title": "Driving Multi-Modal Retail and Healthcare CX - with Brett Kiley of CVS Health",
            "pub_date": "2025-04-22T06:00:00.000Z",
            "duration": "18:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/driving-multi-modal-retail-and-healthcare-cx-with-brett-kiley-of-cvs-health",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_04.22.25_-_Brett_Kiley__1.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7bc083f-5e03-4def-90cf-9c36a8401804",
            "index": 216,
            "title": "Global AI Regulations and Their Impact on Industry Leaders - with Micheal Berger of Munich Re",
            "pub_date": "2025-04-15T12:23:00.000Z",
            "duration": "21:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/global-ai-regulations-and-their-impact-on-industry-leaders-with-micheal-berger-of-munich-re",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-._4.15.25_-_Michael_Berger_ep_2.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "55e80a25-1123-4c51-a277-2f451649157a",
            "index": 217,
            "title": "GenAI Efficiencies in Manufacturing, Smart Farming, and Beyond - with Steffen Hoffmann of Bosch",
            "pub_date": "2025-04-08T13:07:00.000Z",
            "duration": "21:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/genai-efficiencies-in-manufacturing-smart-farming-and-beyond-with-steffen-hoffmann-of-bosch",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_4.8.25_-_Steffen_Hoffmann_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f22ce63-76e5-4478-b14a-f79b84b1d870",
            "index": 218,
            "title": "How AI is Transforming Asset & Wealth Management From Data to Decisions - with Paul Ronan of FE fundinfo",
            "pub_date": "2025-04-02T06:00:00.000Z",
            "duration": "33:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-ai-is-transforming-asset-wealth-management-from-data-to-decisions-with-paul-ronan-of-fe-fundinfo",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business._-_4.2.25_-_Paul_RonanREDO.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5b906047-a27a-471b-8105-f20a3c9e07c5",
            "index": 219,
            "title": "Breaking Down AI's Role in Genomics and Polygenic Risk Prediction - with Dan Elton of the National Human Genome Research Institute",
            "pub_date": "2025-04-01T06:00:00.000Z",
            "duration": "20:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind"
            ],
            "page_url": "https://podcast.emerj.com/breaking-down-ais-role-in-genomics-and-polygenic-risk-prediction-with-dan-elton-of-the-national-human-genome-research-institute",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_04.01.25_-_Dan_Elton.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d9c4c0f-3b4c-4b55-9dac-8f96fe3b0371",
            "index": 220,
            "title": "De-Identified Data and AI Adoption in Healthcare - with Ben Webster of NLP Logix",
            "pub_date": "2025-03-26T06:00:00.000Z",
            "duration": "20:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/de-identified-data-and-ai-adoption-in-healthcare-with-ben-webster-of-nlp-logix",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_03.26.25_-_Ben_Webster.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dbb9ebae-0fc5-4bbb-ba85-d3eaba4f29b5",
            "index": 221,
            "title": "AI in Biopharma Innovation and Regulatory Challenges - with Nishtha Jain of Takeda Pharmaceuticals",
            "pub_date": "2025-03-25T06:00:00.000Z",
            "duration": "26:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind"
            ],
            "page_url": "https://podcast.emerj.com/ai-in-biopharma-innovation-and-regulatory-challenges-with-nishtha-jain-of-takeda-pharmaceuticals",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_03.25.25_-_Nishtha_Jain.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "25dd816a-e34d-432f-9f79-cd0188b57256",
            "index": 222,
            "title": "The Evolving Role of Banks in Fraud Detection and AML Compliance - with Nick Lewis of Standard Chartered Bank",
            "pub_date": "2025-03-18T06:00:00.000Z",
            "duration": "30:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/the-evolving-role-of-banks-in-fraud-detection-and-aml-compliance-with-nick-lewis-of-standard-chartered-bank",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.18.25_-_Nick_Lewis.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ddf95fae-1a5f-49cb-b267-3d5bd54c00cc",
            "index": 223,
            "title": "Tackling Retail Crime and Loss Prevention with AI Driven Video Security - with Mike Matta of Solink",
            "pub_date": "2025-03-17T10:29:00.000Z",
            "duration": "27:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/tackling-retail-crime-and-loss-prevention-with-ai-driven-video-security-with-mike-matta-of-solink",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Mike_Matta_-_Business_FIN.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "87315bc5-7893-4c6e-b992-968c5123fe5d",
            "index": 224,
            "title": "AI and Agentic Systems in Healthcare Workflow Optimization - with Ylan Kazi of Blue Cross Blue Shield of North Dakota",
            "pub_date": "2025-03-13T06:00:00.000Z",
            "duration": "21:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/ai-and-agentic-systems-in-healthcare-workflow-optimization-with-ylan-kazi-of-blue-cross-blue-shield-of-north-dakota",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.13.25_-_Ylan_Kazi.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d9d23d83-2633-4927-8a53-33a983f35bf8",
            "index": 225,
            "title": "Why Red Teaming is Critical for AI Security - with Tomer Poran of ActiveFence",
            "pub_date": "2025-03-12T15:39:00.000Z",
            "duration": "28:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://podcast.emerj.com/why-red-teaming-is-critical-for-ai-security-with-tomer-poran-of-activefence",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.12.25_-_Tomer_Poran.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9cfd936e-70dd-4287-8a20-a5fb8e30b2ca",
            "index": 226,
            "title": "Enhancing Customer Engagement with AI-Driven Solutions - with Robert Rose of Adobe",
            "pub_date": "2025-03-11T06:00:00.000Z",
            "duration": "20:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/enhancing-customer-engagement-with-ai-driven-solutions-with-robert-rose-of-adobe",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_.03.11.25_-_Robert_Rose.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5e4c7580-c854-4ae9-97de-7fa9ccfe4ffb",
            "index": 227,
            "title": "Accelerate and Mitigate Risk in Clinical Development  - with Panos Karelis of Intelligencia AI",
            "pub_date": "2025-03-10T07:00:00.000Z",
            "duration": "21:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/accelerate-and-mitigate-risk-in-clinical-development-with-panos-karelis-of-intelligencia-ai",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.6.25_-_Panos_Karelis_FIX.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b30e42ba-aace-4c2d-aa62-a2f85c9ce481",
            "index": 228,
            "title": "Model Development Best Practices for Insurance - with Mark McLaughlin of IBM",
            "pub_date": "2025-03-04T14:57:00.000Z",
            "duration": "19:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/model-development-best-practices-for-insurance-with-mark-mclaughlin-of-ibm",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_3.4.25_-_Mark_McLaughlin.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a5124aa-40aa-4ae6-8efc-ebac4888facf",
            "index": 229,
            "title": "Understanding AI's Expanding Role in Drug Discovery and Life Sciences R&D - Liran Belenzon of BenchSci",
            "pub_date": "2025-02-26T07:00:00.000Z",
            "duration": "19:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://podcast.emerj.com/understanding-ais-expanding-role-in-drug-discovery-and-life-sciences-rd-liran-belenzon-of-benchsci",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_2.26.25_-_Liran_Belenzon_FIX.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cf017542-b072-4fd2-923c-1e35c9c8c067",
            "index": 230,
            "title": "Neurobiological and Cybernetic AI for Manufacturing, Part 1 - with Oleg Savin of Unilever",
            "pub_date": "2025-02-25T13:41:00.000Z",
            "duration": "17:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/neurobiological-and-cybernetic-ai-for-manufacturing-part-1-with-oleg-savin-of-unilever",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_2.25.25_-_Oleg_Savin.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7d4e0998-3d0c-43e0-93a0-65b51d4ad488",
            "index": 231,
            "title": "The Advantages of Agentic Process Automation in Financial Services - with Ken Mertzel of Automation Anywhere",
            "pub_date": "2025-02-20T08:46:00.000Z",
            "duration": "20:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/the-advantages-of-agentic-process-automation-in-financial-services-with-ken-mertzel",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_2.20.25_-_Ken_Mertzel.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2bb52f4-680d-4cf4-b37c-3091ab663569",
            "index": 232,
            "title": "Tackling Chargeback Challenges at Scale with Machine Learning and Dynamic Arguments - with Roenen Ben-Ami at Justt",
            "pub_date": "2025-02-19T07:00:00.000Z",
            "duration": "24:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/tackling-chargeback-challenges-at-scale-with-machine-learning-and-dynamic-arguments-with-roenen-ben-ami-at-justt",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_2.19.25_-_Roenen_Ben-Ami_FIX.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d808473-8959-463b-b761-6e6a584529ca",
            "index": 233,
            "title": "New Use Cases for GenAI and Beyond in Healthcare Patient Support - with Kimberly Powell of NVIDIA",
            "pub_date": "2025-02-18T07:00:00.000Z",
            "duration": "20:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://podcast.emerj.com/new-use-cases-for-genai-and-beyond-in-healthcare-patient-support-with-kimberly-powell-of-nvidia",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_2.18.25_-_Kimberly_Powell_mp3.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ccc1cf24-d713-4558-a525-14d5c6f6f502",
            "index": 234,
            "title": "Essential Infrastructure Solutions for Life Sciences Manufacturing and Supply Chain Workflows - with Kartik Pant and Shreyas Becker of Sanofi",
            "pub_date": "2025-02-11T07:00:00.000Z",
            "duration": "21:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/essential-infrastructure-solutions-for-life-sciences-manufacturing-and-supply-chain-workflows-with-kartik-pant-and-shreyas-becker-of-sanofi",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_2.11.25_-_Shreyas_Becker__Kartik_Pant.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95fd2d64-c70a-4260-acf4-9847ea55d2de",
            "index": 235,
            "title": "Reducing Costs and Improving CX with Hyperautomation - with Paul Cuglietta of Simplyhealth",
            "pub_date": "2025-02-05T07:00:00.000Z",
            "duration": "18:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/reducing-costs-and-improving-cx-with-hyperautomation-with-paul-cuglietta-of-simplyhealth",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.05.24_-_Paul_Cuglietta.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4d2d56ad-1659-4370-aa7b-90ccbbd5333f",
            "index": 236,
            "title": "Managing End Point Storage in Hybrid Data Strategies for Financial Services - with Yonas Yohannes of Oracle",
            "pub_date": "2025-02-04T09:00:00.000Z",
            "duration": "22:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/managing-end-point-storage-in-hybrid-data-strategies-for-financial-services-with-yonas-yohannes-of-oracle",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_02.04.25_-_Yonas_Yohannes.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b8c0e9a-ab28-45ec-abb5-8a61e9823430",
            "index": 237,
            "title": "AI Risk Management and Governance Strategies for the Future - with Duncan Cass-Beggs of Center for International Governance Innovation",
            "pub_date": "2025-02-01T20:27:00.000Z",
            "duration": "01:17:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://podcast.emerj.com/ai-risk-management-and-governance-strategies-for-the-future-with-duncan-cass-beggs-of-center-for-international-governance-innovation",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-__02.01.25-Duncan_Cass-Beggs.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "50a4ff07-7003-4025-96cb-a08d9e80cbd2",
            "index": 238,
            "title": "A Blueprint for AI-Driven Process Optimization for Regulated Industries - with Vrinda Khurjekar and Paul Pallath at Searce",
            "pub_date": "2025-01-30T07:00:00.000Z",
            "duration": "29:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/a-blueprint-for-ai-driven-process-optimization-for-regulated-industries-with-vrinda-khurjekar-and-paul-pallath-at-searce",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business._-_01.30.25_-_Vrinda_Khurjeka_Paul_Pallath_FIX.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42a75386-7c30-4a3d-bc78-5a33170c222a",
            "index": 239,
            "title": "Driving Automated Workflows & Accelerating Drug Development with AI-Powered Trials - with Michelle Longmire of Medable",
            "pub_date": "2025-01-29T07:00:00.000Z",
            "duration": "22:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/driving-immunology-workflows-with-ai-across-clinical-trials-processes-in-drug-development-with-michelle-longmire-of-medable",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.29.25_-_Michelle_Longmire.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2a64f1c4-e1d2-4617-8e94-fa331962b71a",
            "index": 240,
            "title": "Fraud Risk Solutions for Retail Experiences in Grocery, Banking, and Beyond - with Vivek Khindria of Loblaw",
            "pub_date": "2025-01-28T12:25:00.000Z",
            "duration": "21:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/fraud-risk-solutions-for-retail-experiences-in-grocery-banking-and-beyond-with-vivek-khindria-of-loblaw",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_1.28.25_-_Vivek_Khindria.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "976b1d60-4231-44c9-901d-d848680761fd",
            "index": 241,
            "title": "Overcoming Barriers to AI Adoption in Telecom and Beyond - with Moutie Wali of TELUS",
            "pub_date": "2025-01-27T08:56:00.000Z",
            "duration": "19:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/overcoming-barriers-to-ai-adoption-in-telecom-and-beyond-with-moutie-wali-of-telus",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.27.24_-_Moutie_Wali.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "58ac2024-d6d5-4d72-9b6a-d5f5f1516402",
            "index": 242,
            "title": "Understanding AGI Alignment Challenges and Solutions - with Eliezer Yudkowsky of the Machine Intelligence Research Institute",
            "pub_date": "2025-01-25T19:39:00.000Z",
            "duration": "43:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "alignment"
            ],
            "page_url": "https://podcast.emerj.com/understanding-agi-alignment-challenges-and-solutions-with-eliezer-yudkowsky-of-the-machine-intelligence-research-institute",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_1.24.25_-_Eliezer_Yudkowsky.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0ab13a15-6e4b-4750-8a5e-c0faab1fb88e",
            "index": 243,
            "title": "Driving Automation Throughout Insurance, from a Tech-First Perspective - with Tim Nguyen of Cloud Insurance",
            "pub_date": "2025-01-22T07:00:00.000Z",
            "duration": "20:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "agents",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/driving-automation-throughout-insurance-from-a-tech-first-perspective-with-tim-nguyen-of-cloud-insurance",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.08.25_-_Tim_Nguyen.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dfd11500-34e2-482d-bed4-1ca720dd4731",
            "index": 244,
            "title": "AI Regulation and Risk Management in 2024 - with Micheal Berger of Munich Re",
            "pub_date": "2025-01-21T07:00:00.000Z",
            "duration": "21:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://podcast.emerj.com/ai-regulation-and-risk-management-in-2024-with-micheal-berger-of-munich-re",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.21.25_-_Michael_Berger.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3d24ee12-ee7e-4584-9335-ef11e1ae1336",
            "index": 245,
            "title": "Driving Procurement Efficiencies for Oil & Gas - with Faraz Shahid of Cheniere Energy",
            "pub_date": "2025-01-14T14:58:00.000Z",
            "duration": "26:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://podcast.emerj.com/driving-procurement-efficiencies-for-oil-gas-with-faraz-shahid-of-cheniere-energy",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.14.25_-_Faraz_Shahid.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9917846e-9e04-4014-bf43-59da87f81fdb",
            "index": 246,
            "title": "The Future of Customer Support in Agentic and Business Intelligence AI - with Alex Khoroshchak of CoSupport AI",
            "pub_date": "2025-01-13T09:32:00.000Z",
            "duration": "19:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://podcast.emerj.com/the-future-of-customer-support-in-agentic-and-business-intelligence-ai-with-alex-khoroshchak-of-cosupport-ai",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.13.24_-_Alex_Khoroshchak_fix.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0eae1448-8811-4b35-8728-bb360cb843b8",
            "index": 247,
            "title": "Sustainable Supply Chains in O&G with AI - with Salamatu Mahamudu of Baker Hughes",
            "pub_date": "2025-01-09T09:31:00.000Z",
            "duration": "16:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/sustainable-supply-chains-in-og-with-ai-with-salamatu-mahamudu-of-baker-hughes",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.09.24_-_Salamatu_Mahamudu.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bfa2be92-f9a4-467a-8b8e-938f0c17a0ec",
            "index": 248,
            "title": "Driving Disease Risk Prediction and Preventative Healthcare with AI - with Dan Elton of the National Human Genome Research Institute",
            "pub_date": "2025-01-07T09:52:00.000Z",
            "duration": "15:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/driving-disease-risk-prediction-and-preventative-healthcare-with-ai-with-dan-elton-of-the-national-human-genome-research-institute",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_01.07.25-_Dan_Elton.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a949f8b-504c-4c59-b510-81556b44f3dd",
            "index": 249,
            "title": "How Cloud Computing and AI are Shaping Life Sciences - with Pranav Joshi of Merck",
            "pub_date": "2024-12-31T07:00:00.000Z",
            "duration": "27:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/how-cloud-computing-and-ai-are-shaping-life-sciences-with-pranav-joshi-of-merck",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.31.24_-_Pranav_Joshi.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e8eadec8-35e8-417d-8a7c-77d799e036eb",
            "index": 250,
            "title": "AI Governance and Strategy for Long-Term Impact - with Steven Eliuk of IBM",
            "pub_date": "2024-12-24T07:00:00.000Z",
            "duration": "21:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcast.emerj.com/ai-governance-and-strategy-for-long-term-impact-with-steven-eliuk-of-ibm",
            "audio_url": "https://traffic.libsyn.com/secure/techemergence/Business_-_12.24.24_-_Steven_Eliuk.mp3?dest-id=151434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "twenty-vc",
        "title": "20VC",
        "feed_title": "The Twenty Minute VC (20VC): Venture Capital | Startup Funding | The Pitch",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "venture",
          "founders",
          "AI startups"
        ],
        "feed_url": "https://rss.libsyn.com/shows/61840/destinations/240976.xml",
        "source_url": "https://rss.libsyn.com/shows/61840/destinations/240976.xml",
        "detail_path": "/podcasts/twenty-vc/",
        "episode_count": 300,
        "selected_episode_count": 224,
        "latest_episode_title": "20VC: Nebius Co-Founder on AI Infrastructure Bubbles | The Real Impact of Open Source on OpenAI & Anthropic | How Price Elastic is Demand for Compute | Could Nebius Sell 10x More Compute If They Had It & more with Roman Chernin",
        "latest_pub_date": "2026-06-08T07:07:00.000Z",
        "latest_page_url": "https://thetwentyminutevc.libsyn.com/20vc-nebius-co-founder-on-ai-infrastructure-bubbles-the-real-impact-of-open-source-on-openai-anthropic-how-price-elastic-is-demand-for-compute-could-nebius-sell-10x-more-compute-if-they-had-it-more-with-roman-chernin",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "22c7f238-4fe6-471f-900e-5bfb2f75b721",
            "index": 1,
            "title": "20VC: Nebius Co-Founder on AI Infrastructure Bubbles | The Real Impact of Open Source on OpenAI & Anthropic | How Price Elastic is Demand for Compute | Could Nebius Sell 10x More Compute If They Had It & more with Roman Chernin",
            "pub_date": "2026-06-08T07:07:00.000Z",
            "duration": "01:06:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "inference",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-nebius-co-founder-on-ai-infrastructure-bubbles-the-real-impact-of-open-source-on-openai-anthropic-how-price-elastic-is-demand-for-compute-could-nebius-sell-10x-more-compute-if-they-had-it-more-with-roman-chernin",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Roman_Chernin__Nebius.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd62f510-667f-45b7-bd5e-ea4e0506522e",
            "index": 2,
            "title": "20Product: Inside Legora's Tech Stack: Why Token Maxing is Failing Enterprise Startups with Jacob Lauritzen, CTO @ Legora",
            "pub_date": "2026-06-06T07:07:00.000Z",
            "duration": "54:31",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20productinside-legoras-tech-stack-why-token-maxing-is-failing-enterprise-startups-with-jacob-lauritzen-cto-legora",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product__Jacob_Lauritzen__Legora.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "99266aae-e346-454f-9d38-92624231e45e",
            "index": 3,
            "title": "20VC: Anthropic Files to Go Public | Token Budgeting Panic Hits Corporate America | Cognition Raises $1BN at $26BN Valuation | Apollo Warns PE Software Returns Will be Disastrous | The 9-9-6 Work Ethic: Performative Theatre or Startup Reality?",
            "pub_date": "2026-06-04T07:07:00.000Z",
            "duration": "01:34:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-files-to-go-public-token-budgeting-panic-hits-corporate-america-cognition-raises-1bn-at-26bn-valuation-apollo-warns-pe-software-returns-will-be-disastrous-the-9-9-6-work-ethic-performative-theatre-or-startup-reality",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.59-Updated.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77f713a1-8bc7-44b3-a33d-6d9eaa0d4ea0",
            "index": 4,
            "title": "20VC: Mercor CEO on Why Application Layer Companies Have No Defensibility, The Model is the Product | Token Spend Will Exceed Headcount Spend in 5 Years | The True Cost of Hiring AI Researchers in the Valley Today with Brendan Foody",
            "pub_date": "2026-06-01T07:07:00.000Z",
            "duration": "01:15:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-mercor-ceo-on-why-application-layer-companies-have-no-defensibility-the-model-is-the-product-token-spend-will-exceed-headcount-spend-in-5-years-the-true-cost-of-hiring-ai-researchers-in-the-valley-today-with-brendan-foody",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Brendan_Foody__Mercor_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8beb0b39-60b0-4a9c-afd8-40fe9d4e6f55",
            "index": 5,
            "title": "20VC: Corgi Insurance: The Most Intense Workplace Culture in America: 7 Days Per Week, Founder Sleeps in Office, Corgi Cafe Open 24 Hours a Day, 60% of First 30 Employees Have Corgi Tattoos | The Journey from $0 to $2.6BN Valuation in Just 2 Years",
            "pub_date": "2026-05-30T07:07:00.000Z",
            "duration": "53:18",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-corgi-insurance-the-most-intense-workplace-culture-in-america-7-days-per-week-founder-sleeps-in-office-corgi-cafe-open-24-hours-a-day-60-of-first-30-employees-have-corgi-tattoos-the-journey-from-0-to-26bn-valuation-in-just-2-years",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Memo__Nico_Laqua__Corgi.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "12c758cb-94a6-47e4-83ce-9b93a62de034",
            "index": 6,
            "title": "20VC: OpenAI & SpaceX S1 Drops | NVIDIA's $81BN Revenue Quarter | Cloudflare and ClickUp Do Controversial Layoffs | Exa, OpenRouter and Polsia Raise Mega Rounds | Uber and Microsoft Declare AI ROI for Developers is Questionable",
            "pub_date": "2026-05-28T07:07:00.000Z",
            "duration": "01:25:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "nvidia",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-openai-spacex-s1-drops-nvidias-81bn-revenue-quarter-cloudlfare-and-clickup-do-controversial-layoffs-exa-openrouter-and-polsia-raise-mega-rounds-uber-and-microsoft-declare-ai-roi-for-developers-is-questionable",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.58.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5de91af6-e9d5-4f32-af81-37c51f646ffc",
            "index": 7,
            "title": "20VC: Cerebras CEO on the Future of Data Centres, Token Costs and Memory | We are Not in an Infra Bubble & Dario Got a Bad Deal with Elon for Compute | Should US Companies Sell to China & Why Most Layoffs are AI Washed with Andrew Feldman",
            "pub_date": "2026-05-26T07:07:00.000Z",
            "duration": "01:01:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia",
              "chips",
              "enterprise ai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-cerebras-ceo-on-the-future-of-data-centres-token-costs-and-memory-we-are-not-in-an-infra-bubble-dario-got-a-bad-deal-with-elon-for-compute-should-us-companies-sell-to-china-why-most-layoffs-are-ai-washed-with-andrew-feldman",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Andrew_Feldman_FINAL__Cerebras_3.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fb065f5d-f4bc-4c67-8970-0293297d3453",
            "index": 8,
            "title": "20Sales: The $100M CRO Bubble: Why Anthropic Are Causing a Comp Crisis | Why You Should Never Hire From Salesforce or Service Now | How to Hire, Train and Forecase in a World of AI with Chad Peets and Chris Degnan",
            "pub_date": "2026-05-23T07:07:00.000Z",
            "duration": "01:19:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-the-100m-cro-bubble-why-anthropic-are-causing-a-comp-crisis-why-you-should-never-hire-from-salesforce-or-service-now-how-to-hire-train-and-forecase-in-a-world-of-ai-with-chad-peets-and-chris-degnan",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales__Chad_Peets__Chris_Degnan.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8127bd74-801c-4e81-90d2-979fc45e7cf6",
            "index": 9,
            "title": "20VC: Andrej Karpathy Joins Anthropic & Anthropic Raises $30BN at $900BN Price | SpaceX Files S1: How Does it Trade | Cerebras Smashes Day 1: What it Means for IPOs | Why Mass Layoffs Are More Worrying Than Anyone Sees",
            "pub_date": "2026-05-21T07:07:00.000Z",
            "duration": "01:21:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-andrej-karpathy-joins-anthropic-anthropic-raises-30bn-at-900bn-price-spacex-files-s1-how-does-it-trade-cerebras-smashes-day-1-what-it-means-for-ipos-why-mass-layoffs-are-more-worrying-than-anyone-sees",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.57.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a92d7d1e-62cd-40de-91e6-073377928eeb",
            "index": 10,
            "title": "20VC: Turning Peter Thiel's $100K into $10M Angel Portfolio | The One Man Accelerator at The Four Seasons | Why VCs Can Be Sharks and What Founders Need to Know | Why Stocks and Cash are BS and You Should Invest in Land with Josh Browder",
            "pub_date": "2026-05-18T07:07:00.000Z",
            "duration": "01:29:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-turning-peter-thiels-100k-into-10m-angel-portfolio-the-one-man-accelerator-at-the-four-seasons-why-vcs-can-be-sharks-and-what-founders-need-to-know-why-stocks-and-cash-are-bs-and-you-should-invest-in-land-with-josh-browder",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Joshua_Browder__Browder_Capital-Updated.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "155827ca-1d52-461f-abff-fa4455c11e75",
            "index": 11,
            "title": "20VC: Lessons from Jensen Huang on \"Founder Mode\" | How to Know if OpenAI or Anthropic Will Kill your Company | How USV Liking Music Made Them $1BN on an Investment | The Five Year Desert to Product Market Fit & a $5.3BN Valuation with Shiv Rao @ Abridge",
            "pub_date": "2026-05-16T07:07:00.000Z",
            "duration": "01:04:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-lessons-from-jensen-huang-on-founder-mode-how-to-know-if-openai-or-anthropic-will-kill-your-company-how-usv-liking-music-made-them-1bn-on-an-investment-the-five-year-desert-to-product-market-fit-a-53bn-valuation-with-shiv-rao-abridge",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth__Shiv_Rao__Abridge-Final.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4261e118-eb3e-4277-8aff-b37d1dd11e91",
            "index": 12,
            "title": "20VC: Anthropic Buys Compute From Elon & Commits $200BN to Google | Cerebras IPO: The Breakdown | Ramp's $40BN Latest Valuation | Hubspot Tanks, Monday Rockets: WTF is Happening in Public Markets",
            "pub_date": "2026-05-14T07:07:00.000Z",
            "duration": "01:18:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-buys-compute-from-elon-commits-200bn-to-google-cerebras-ipo-the-breakdown-ramps-40bn-latest-valuation-hubspot-tanks-monday-rockets-wtf-is-happening-in-public-markets",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.56.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "327313bf-91b8-4b18-b0fe-dd4a4ed454f3",
            "index": 13,
            "title": "20VC: Inside Legora: $100M ARR in 18 Months | Jude Law Generated $50M in Sales Pipeline: The Economics Broken Down | Competing Against Harvey, the 800 Pound Gorilla | Why Legora is Undervalued at $5.5BN with Patrick Forquer, CRO @ Legora",
            "pub_date": "2026-05-11T07:07:00.000Z",
            "duration": "01:14:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-inside-legora-100m-arr-in-18-months-jude-law-generated-50m-in-sales-pipeline-the-economics-broken-down-competing-against-harvey-the-800-pound-gorilla-why-legora-is-undervalued-at-55bn-with-patrick-forquer-cro-legora",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Patrick_Forquer__Legora.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5c68204-8009-46c2-90c5-03e38f1c578c",
            "index": 14,
            "title": "20VC: What I Learned from 100 of the Best CEOs in the World | What I Learned from Staying with Mr Beast for 3 Weeks | How We Will Spend More on Tokens than Salaries with Cliff Weitzman, Speechify",
            "pub_date": "2026-05-09T07:07:00.000Z",
            "duration": "01:46:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-what-i-learned-from-100-of-the-best-ceos-in-the-world-what-i-learned-from-staying-with-mr-beast-for-3-weeks-how-we-will-spend-more-on-tokens-than-salaries-with-cliff-weitzman-speechify",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Memo__Cliff_Weitzman__Speechify-Updated_V2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ae3f7c14-d752-4fd7-bef6-aec4f156aa8c",
            "index": 15,
            "title": "20VC: Mag7 Earnings: Google & Amazon Win - Meta and Microsoft Falter | Anthropic's $50BN Raise & What it Means for a Potential IPO | Atlassian, Twilio and Five9 Beat: The SaaS Apocalypse Over? | Sierra's $15B Valuation: Peak or Potential",
            "pub_date": "2026-05-07T07:07:00.000Z",
            "duration": "01:31:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "chips"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-mag7-earnings-google-amazon-win-meta-and-microsoft-falter-anthropics-50bn-raise-what-it-means-for-a-potential-ipo-atlassian-twilio-and-five9-beat-the-saas-apocalypse-over-sierras-15b-valuation-peak-or-potential",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.55.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1bfcfa3-379a-4725-be89-570513c73820",
            "index": 16,
            "title": "20VC: Shopify's Tobi Lütke on How AI is a Scapegoat for Mass Layoffs & What Will Labour Markets Be in the Future | Why We Need More Scrutiny on Charitable Giving, Governments are Bad at What They Do and Trump Derangement Syndrome in Canada",
            "pub_date": "2026-05-04T07:07:00.000Z",
            "duration": "01:13:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-shopifys-tobi-ltke-on-how-ai-is-a-scapegoat-for-mass-layoffs-what-will-labour-markets-be-in-the-future-why-we-need-more-scrutiny-on-charitable-giving-governments-are-bad-at-what-they-do-and-trump-derangement-syndrome-in-canada",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Tobi_Lutke__Shopify_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e1c41a42-4203-4b07-80f5-d5140bb1390e",
            "index": 17,
            "title": "20VC: Inside Clay's Sales Playbook Scaling to $100M ARR | How to Set Sales Comp Plans | How to Read Sales Talent Linkedin Profiles | What Profiles to Hire & Fire | How to Increase Performance and Speed in Sales Teams with Becca Lindquist",
            "pub_date": "2026-05-02T07:07:00.000Z",
            "duration": "01:13:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-inside-clays-sales-playbook-scaling-to-100m-arr-how-to-set-sales-comp-plans-how-to-read-sales-talent-linkedin-profiles-what-profiles-to-hire-fire-how-to-increase-performance-and-speed-in-sales-teams-with-becca-lindquist",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales__Becca_Lindquist__Clay.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4d04864-e653-4000-9516-a09531f2a4e3",
            "index": 18,
            "title": "20VC: Anthropic Raises $45BN but Falls Short on Compute | OpenAI Crushes with GPT5.5 and Codex: Back in the Game? | China Blocks Manus $2BN Deal to Meta | Thoma Bravo Hand Back Medallia Keys to Creditors | Why Google is a Bigger Buy Than Ever Before",
            "pub_date": "2026-04-30T07:07:00.000Z",
            "duration": "01:25:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-raises-45bn-but-falls-short-on-compute-openai-crushes-with-gpt55-and-codex-back-in-the-game-china-blocks-manus-2bn-deal-to-meta-thoma-bravo-hand-back-medallia-keys-to-creditors-why-google-is-a-bigger-buy-than-ever-before",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.54.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0cd6aee2-1bf3-47d8-9297-f8911bdb4331",
            "index": 19,
            "title": "20VC: Applovin: $160BN Market Cap, $5.48BN Revenue, $10M EBITDA Per Head | Why the Best Do Not Need Mentorship | Why Founders Should Not Angel Invest | Why Kindness in Business Will Slow You Down with Adam Foroughi",
            "pub_date": "2026-04-27T07:07:00.000Z",
            "duration": "01:20:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-applovin-160bn-market-cap-548bn-revenue-10m-ebitda-per-head-why-the-best-do-not-need-mentorship-why-founders-should-not-angel-invest-why-kindness-in-business-will-slow-you-down-with-adam-foroughi",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Adam_Foroughi__AppLovin.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "59056d4a-ff4e-468b-8734-dff06f0b076e",
            "index": 20,
            "title": "20Product: Replit CEO on Why Coding Models Are Plateauing | Why the SaaS Apocalypse is Justified: Will Incumbents Be Replaced? | Why IDEs Are Dead and Do PMs Survive the Next 3-5 Years with Amjad Masad",
            "pub_date": "2026-04-25T07:07:00.000Z",
            "duration": "46:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "anthropic",
              "cursor",
              "replit",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-replit-ceo-on-why-coding-models-are-plateauing-why-the-saas-apocalypse-is-justified-will-incumbents-be-replaced-why-ides-are-dead-and-do-pms-survive-the-next-3-5-years-with-amjad-masad",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product__Amjad_Masad__Replit.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fec0fbb7-dd29-42c3-9eea-a44b22ca1fdb",
            "index": 21,
            "title": "20VC: Cursor Acquired for $60BN by xAI | Anthropic Hits $1TRN in Secondary Markets | Did Anthropic Just Kill Figma, Adobe and Canva | Rippling Hits $1BN in ARR | Salesforce Goes Headless: Smart or Stupid | Cerebras IPO 2.0",
            "pub_date": "2026-04-23T07:07:00.000Z",
            "duration": "01:40:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "claude",
              "xai",
              "cursor",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-cursor-acquired-for-60bn-by-xai-anthropic-hits-1trn-in-secondary-markets-did-anthropic-just-kill-figma-adobe-and-canva-rippling-hits-1bn-in-arr-salesforce-goes-headless-smart-or-stupid-cerebras-ipo-20",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.53_-_V2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "32733be5-83de-4618-8778-7fd9ec37d5df",
            "index": 22,
            "title": "20VC: Everyone is Wrong; We Will Have More Developers in Five Years | Why Frontier Labs Will Be Way More Valuable Than They Are Today | Are SaaS Companies Cooked: Which Thrive & Which Die with Aaron Levie, Founder at Box",
            "pub_date": "2026-04-20T07:07:00.000Z",
            "duration": "53:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-everyone-is-wrong-we-will-have-more-developers-in-five-years-why-frontier-labs-will-be-way-more-valuable-than-they-are-today-are-saas-companies-cooked-which-thrive-which-die-with-aaron-levie-founder-at-box",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Aaron_Levie__Box_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f438221e-0c5f-4e00-a717-e47ed625af1a",
            "index": 23,
            "title": "20VC: Jake Paul on Why Traditional VC is Toast and Attention is More Valuable Than Cash | Politics: Will Jake Paul Actually Run for President? | Inside the Payday of Fighting Anthony Joshua and Mike Tyson | with Geoffrey Wu, Co-Founder at Anti-Fund",
            "pub_date": "2026-04-18T12:36:00.000Z",
            "duration": "01:00:26",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-jake-paul-on-why-traditional-vc-is-toast-and-attention-is-more-valuable-than-cash-politics-willjake-paul-actually-run-for-president-inside-the-payday-of-fighting-anthony-joshua-and-mike-tyson-with-geoffrey-wu-co-founder-at-anti-fund",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth__Jake_Paul__Geoffrey_Woo__Anti_Fund.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3eda5df1-c058-4365-bd99-a761aecf4c87",
            "index": 24,
            "title": "20VC: Anthropic Unveils Mythos | SpaceX's Financials Leaked: Is it Worth $2TRN | Meta Debuts Muse Spark: Are They Back in the AI Race | Jason's Critique of Dario Amodei & How OpenAI Could Win the Enterprise Game",
            "pub_date": "2026-04-16T07:07:00.000Z",
            "duration": "01:26:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "replit",
              "nvidia",
              "chip"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-unveils-mythos-spacexs-financials-leaked-is-it-worth-2trn-meta-debuts-muse-spark-are-they-back-in-the-ai-race-jasons-critique-of-dario-amodei-how-openai-could-win-the-enterprise-game",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.52.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "efc641d1-d5b0-4a01-8b5d-a81181005a79",
            "index": 25,
            "title": "20VC: Anj Midha on Investing $300M into Anthropic | The Early Days of Anthropic & How 21 of 22 VCs Turned it Down | The Four Bottlenecks to Compute | What the China Has Smashed and Why We Should Be Worried",
            "pub_date": "2026-04-14T09:24:00.000Z",
            "duration": "01:08:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "mistral",
              "gpu"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anj-midha-on-investing-300m-into-anthropic-the-early-days-of-anthropic-how-21-of-22-vcs-turned-it-down-the-four-bottlenecks-to-compute-what-the-china-has-smashed-and-why-we-should-be-worried",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Anjney_Midha__AMP-Edited.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eb2184ac-e95e-4551-bc9e-030de6ac632b",
            "index": 26,
            "title": "20Sales: ElevenLabs: Why We Set a 20x Sales Quota | How to Structure Sales Compensation Plans | Customer Success: 'Total BS' or Growth Engine? | Building an AI Sales Machine: What Tools & Tactics Must CROs Adopt Today with Carles Reina",
            "pub_date": "2026-04-11T07:07:00.000Z",
            "duration": "01:25:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-elevenlabs-why-we-set-a-20x-sales-quota-how-to-structure-sales-compensation-plans-customer-success-total-bs-or-growth-engine-building-an-ai-sales-machine-what-tools-tactics-must-cros-adopt-today-with-carles-reina",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales__Carles_Reina__ElevenLabs_2_Updated.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35054b5c-28d6-497d-8d1c-cf770f9922c5",
            "index": 27,
            "title": "20VC: Anthropic Surpasses OpenAI Revenue | OpenAI Acquisition of TBPN: Analysed | OpenAI Management Team Reboot | YC Kicks Delve Out | Mercor Hack and Why Now is the Time for Cyber | Supabase Raising at $10BN & Doug Leone Returns to Sequoia",
            "pub_date": "2026-04-09T07:07:00.000Z",
            "duration": "01:27:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-surpasses-openai-revenue-openai-acquisition-of-tbpn-analysed-openai-management-team-reboot-yc-kicks-delve-out-mercor-hack-and-why-now-is-the-time-for-cyber-supabase-raising-at-10bn-doug-leone-returns-to-sequoia",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_Episode_51.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "25fbf200-afed-456f-a54c-5ef6621b7b55",
            "index": 28,
            "title": "20VC: DeepMind's Demis Hassabis on Why AGI is Bigger than the Industrial Revolution | Why LLMs Will Not Commoditise & We Have Not Hit Scaling Laws | Bottlenecks in AI & The Energy Crisis Caused By AI | Whether AI Will Do More to Harm or Help Inequality",
            "pub_date": "2026-04-07T07:07:00.000Z",
            "duration": "35:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "deepmind",
              "safety"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-deepminds-demis-hassabis-on-why-agi-is-bigger-than-the-industrial-revolution-why-llms-will-not-commoditise-we-have-not-hit-scaling-laws-bottlenecks-in-ai-the-energy-crisis-caused-by-ai-whether-ai-will-do-more-to-harm-or-help-inequality",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Demis_Hassabis__Google_DeepMind.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f84804a-9102-4a7c-84d1-6ee990b5c1cf",
            "index": 29,
            "title": "20VC: Hims & Hers: $4.3BN Market Cap on $2.3BN of Revenue: The Comeback | Why Being Public is 10x Better | The Death of the \"Strategy\" Hire | Why Performance Marketing is Worse than Brand Marketing with Andrew Dudum",
            "pub_date": "2026-04-04T09:25:00.000Z",
            "duration": "59:18",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-hims-hers-43bn-market-cap-on-23bn-of-revenue-the-comeback-why-being-public-is-10x-better-the-death-of-the-strategy-hire-why-performance-marketing-is-worse-than-brand-marketing-with-andrew-dudum",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Memo__Andrew_Dudum__Hims.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa195ce2-819c-429d-9085-56e3a18f82e8",
            "index": 30,
            "title": "20VC: Anthropic's $6BN Revenue Month | OpenAI Kills Sora & Hits $100M ARR on Ads | Oura Going Public & Whoop Raises at $10BN | Manus Founders Trapped in China & The Billionaire Tax: Anyone Left in California?",
            "pub_date": "2026-04-02T08:55:00.000Z",
            "duration": "01:09:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropics-6bn-revenue-month-openai-kills-sora-hits-100m-arr-on-ads-oura-going-public-whoop-raises-at-10bn-manus-founders-trapped-in-china-the-billionaire-tax-anyone-left-in-california",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.50-Fixed_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2552a785-92cb-475a-8926-605c322e791c",
            "index": 31,
            "title": "20VC: Marc Andreessen on The Future of Venture Capital: Will a16z Go Public | Why Labour Displacement with AI is Wrong | Why Introspection is Dangerous | Why \"Diamonds in the Rough\" is BS in VC | Why a16z Invested $300M into Adam Neumann",
            "pub_date": "2026-03-30T07:07:00.000Z",
            "duration": "01:12:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-marc-andreessen-on-the-future-of-venture-capital-will-a16z-go-public-why-labour-displacement-with-ai-is-wrong-why-introspection-is-dangerous-why-diamonds-in-the-rough-is-bs-in-vc-why-a16z-invested-300m-into-adam-neumann",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Marc_Andreesen__a16z.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "18b1ebd3-39c0-4141-8afd-f39e88b68199",
            "index": 32,
            "title": "20VC: The Venture Model is Broken | You Need to be Greedy and Selfish to Win Early Stage Investing | Why Margins Do Not Matter for Early-Stage Startups | The Growth Rate that is Required in a World of AI with Gili Raanan, Founder @ Cyberstarts",
            "pub_date": "2026-03-28T07:07:00.000Z",
            "duration": "52:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-venture-model-is-broken-you-need-to-be-greedy-and-selfish-to-win-early-stage-investing-why-margins-do-not-matter-for-early-stage-startups-the-growth-rate-that-is-required-in-a-world-of-ai-with-gili-raanan-founder-cyberstarts",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-Gili_Raanan__Cyberstarts_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "874dfd7e-d4a6-417d-9b95-257ce135ff2d",
            "index": 33,
            "title": "20VC: Why You Need a $1BN Fund To Do Series A Today | OpenAI vs Anthropic: Who Wins Enterprise | SpaceX at $2TRN and Data Centers in Space | The $20BN Groq Deal Broken Down | Jeff Bezos' $100BN New Fund",
            "pub_date": "2026-03-26T07:08:00.000Z",
            "duration": "01:18:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-you-need-1bn-to-do-series-a-today-openai-vs-anthropic-who-wins-enterprise-spacex-at-2trn-and-data-centers-in-space-the-20bn-groq-deal-broken-down-jeff-bezos-100bn-new-fund",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.49.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4738d3f7-3c75-40c9-bc41-df68185a6756",
            "index": 34,
            "title": "20VC: Inside Anduril's $20BN Army Contract & Why Anduril Must Go Public | Why 99% of Drone Companies Will Die | Why There is Never an Ethical Question of How Anduril Products are Used with Matthew Steckman, President @ Anduril",
            "pub_date": "2026-03-23T07:07:00.000Z",
            "duration": "53:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-inside-andurils-20bn-army-contract-why-anduril-must-go-public-why-99-of-drone-companies-will-die-why-there-is-never-an-ethical-question-of-how-anduril-products-are-used-with-matthew-steckman-president-anduril",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Matthew_Steckman__Anduril.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4a6ae7fa-6409-47d5-aae4-07c949ab88d4",
            "index": 35,
            "title": "20Sales: Inside Figma's $1BN ARR Revenue Machine | Why We Do Not Have Customer Success or SDRs | Why I Do Not Believe in Sales Quotas with Shaunt Voskanian, CRO @ Figma",
            "pub_date": "2026-03-21T07:07:00.000Z",
            "duration": "01:02:50",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-inside-figmas-1bn-arr-revenue-machine-why-we-do-not-have-customer-success-or-sdrs-why-i-do-not-believe-in-sales-quotas-with-shaunt-voskanian-cro-figma",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Shaunt_Voskanian__Figma.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9972d9a1-6537-455e-a5f8-faa2434f296d",
            "index": 36,
            "title": "20VC: The Return of Travis Kalanick: Uber Would Be $1TRN Today With Him | NVIDIA Predicts $1TRN in Revenue: Everything You Need to Know From GTC | Anduril Lands $20BN Army Contract | Adobe CEO Shock Exit: The Dominos Falling",
            "pub_date": "2026-03-19T07:07:00.000Z",
            "duration": "01:15:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-return-of-travis-kalanick-uber-would-be-1trn-today-with-him-nvidia-predicts-1trn-in-revenue-everything-you-need-to-know-from-gtc-anduril-lands-20bn-army-contract-adobe-ceo-shock-exit-the-dominos-falling",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.48.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "326beaf8-a403-4117-9c3d-09ffd1b3178d",
            "index": 37,
            "title": "20VC: The 8 Moats of Enduring Software Companies: How to Analyse for Durability and Defensibility in a World of AI | Why Dropouts are \"AI Maxing\" the World & Remote Early-Stage Companies are Dying with Gokul Rajaram",
            "pub_date": "2026-03-16T07:07:00.000Z",
            "duration": "01:18:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-8-moats-of-enduring-software-companies-how-to-analyse-for-durability-and-defensibility-in-a-world-of-ai-why-dropouts-are-ai-maxing-the-world-remote-early-stage-companies-are-dying-with-gokul-rajaram",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Gokul_Rajaram__Marathon.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "450944f1-9d63-4ebf-936d-685c4deb1e57",
            "index": 38,
            "title": "20Growth: Inside Lovable's $400M ARR Growth Machine | How Lovable Does Product Launches | How Lovable Hacks Social To Make Posts Go Viral | How Lovable Makes Every Employee a Brand with Elena Verna",
            "pub_date": "2026-03-14T07:07:00.000Z",
            "duration": "01:09:21",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-inside-lovables-400m-arr-growth-machine-how-lovable-does-product-launches-how-lovable-hacks-social-to-make-posts-go-viral-how-lovable-makes-every-employee-a-brand-with-elena-verna",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Elena_Verna__Lovable.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f85d3f79-b959-418c-bdc9-d190d40528eb",
            "index": 39,
            "title": "20VC: Anthropic vs The Pentagon: Who Wins | The Ultimate Stock Picks: What to Buy | The Data Centre Arms Race: Is the Capex War Stalling | The Era of Public Company Deceleration is Dead",
            "pub_date": "2026-03-12T07:07:00.000Z",
            "duration": "01:14:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "data center"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-vs-the-pentagon-who-wins-the-ultimate-stock-picks-what-to-buy-the-data-centre-arms-race-is-the-capex-war-stalling-the-era-of-public-company-deceleration-is-dead",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.47.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8472033f-93c0-4c3b-b136-fae60807b6ee",
            "index": 40,
            "title": "20VC: Inside Accel's $4BN Growth Investing Machine | Cursor is Dead is Total BS: Here is Why | What Missing Rippling and ElevenLabs Taught Us | Are $2BN-$10BN IPOs Dead | Why Now is a Great Time to be Thoma Bravo with Miles Clements",
            "pub_date": "2026-03-09T07:07:00.000Z",
            "duration": "01:03:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "cursor",
              "chips"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-inside-accels-4bn-growth-investing-machine-cursor-is-dead-is-total-bs-here-is-why-what-missing-rippling-and-elevenlabs-taught-us-are-2bn-10bn-ipos-dead-why-now-is-a-great-time-to-be-thoma-bravo-with-miles-clements",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Miles_Clement__Accel.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "abd178a5-cb83-436f-93d9-8399a4cecd73",
            "index": 41,
            "title": "20VC: Why the SaaS Apocalypse is BS | Why China Will Win the AI War | Why 50% of VCs Should Not Exist and are Tourists | Why Stock-Based Comp is the Hidden Sin of the Valley with Mitchell Green, Lead Edge Capital",
            "pub_date": "2026-03-07T07:07:00.000Z",
            "duration": "01:00:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-the-saas-apocalypse-is-bs-why-china-will-win-the-ai-war-why-50-of-vcs-should-not-exist-and-are-tourists-why-stock-based-comp-is-the-hidden-sin-of-the-valley-with-mitchell-green-lead-edge-capital",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Memo__Mitchell_Green__Lead_Edge_Capital_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc3ed2ae-2f78-4159-aaa4-f06fae8d3661",
            "index": 42,
            "title": "20VC: Anthropic vs The Pentagon: Who Wins | OpenAI's $110BN Mega Round | Cursor Hits $2BN in ARR | Block's 40% Headcount Reduction: AI or Overhiring",
            "pub_date": "2026-03-05T07:07:00.000Z",
            "duration": "01:23:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-vs-the-pentagon-who-wins-openais-110bn-mega-round-cursor-hits-2bn-in-arr-blocks-40-headcount-reduction-ai-or-overhiring",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.46.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9fd61311-a76f-48ce-9eec-495c428ebede",
            "index": 43,
            "title": "20VC: Monday.com CEO on Is SaaS Dead: Will Everything Be Vibe Coded | Will Systems of Record Become Valueless Databases in an Agentic World | Will LLMs Own the Value in the Application Layer with Eran Zinman",
            "pub_date": "2026-03-02T07:07:00.000Z",
            "duration": "01:09:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "google ai",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-mondaycom-ceo-on-is-saas-dead-will-everything-be-vibe-coded-will-systems-of-record-become-valueless-databases-in-an-agentic-world-will-llms-own-the-value-in-the-application-layer-with-eran-zinman",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Eran_Zinman__Monday_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bbef9ea6-885d-4a36-a29e-d6248cf31813",
            "index": 44,
            "title": "20VC: Why Cursor is Dead | An AI Tsunami is Coming & You Need to Prepare | Systems of Record Become Valueless Databases with Agents | Is This The End of Tech Private Equity with Jerry Murdock, Co-Founder of Insight Partners",
            "pub_date": "2026-02-28T07:07:00.000Z",
            "duration": "01:01:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "cursor",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-cursor-is-dead-an-ai-tsunami-is-coming-you-need-to-prepare-systems-of-record-become-valueless-databases-with-agents-is-this-the-end-of-tech-private-equity-with-jerry-murdock-co-founder-of-insight-partners",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth__Jerry_Murdock__Insight_Partners.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c818eea-0a02-44ab-b287-5577dfca87a6",
            "index": 45,
            "title": "20VC: Anthropic Wipes Billions Off Markets | Citrini Research: The Ultimate Breakdown: Agents, \"Ghost GDP\", Consumer Spend etc. | Figma Earnings Beat & Four Public Stocks to Buy | Jack Altman Joins Benchmark",
            "pub_date": "2026-02-26T07:07:00.000Z",
            "duration": "01:20:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "agent",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-wipes-billions-off-markets-citrini-research-the-ultimate-breakdown-agents-ghost-gdp-consumer-spend-etc-figma-earnings-beat-four-public-stocks-to-buy-jack-altman-joins-benchmark",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.45.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "313d9b32-68dd-4ecb-9ea9-aeb8bcfe1bcc",
            "index": 46,
            "title": "20VC: Inside Coatue's $70BN Machine: Why Price Matters Least | Why Mega Markets are the Most Important | How to Assess Durability of Revenue and Margins in AI with Lucas Swisher",
            "pub_date": "2026-02-23T20:38:00.000Z",
            "duration": "01:06:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-inside-coatues-7bn-growth-fund-why-price-matters-least-why-mega-markets-are-the-most-important-how-mega-funds-can-still-do-5x-returns-how-to-assess-durability-of-revenue-and-margins-in-ai-with-lucas-swisher",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-Lucas_Swisher__Coatue.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d17984e0-08fe-4718-97bf-ec0ab8ca94e8",
            "index": 47,
            "title": "20VC: Codex vs Claude Code vs Cursor: Who Wins, Who Loses | Will All Coding Be Automated - Do We Need PMs | The Real Bottleneck to AGI | The Three Phases of Agents and What You Need to Know with Alex Embiricos, Head of Codex at OpenAI",
            "pub_date": "2026-02-21T07:07:00.000Z",
            "duration": "01:03:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "agentic",
              "openai",
              "claude"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-codex-vs-claude-code-vs-cursor-who-wins-who-loses-will-all-coding-be-automated-do-we-need-pms-the-real-bottleneck-to-agi-the-three-phases-of-agents-and-what-you-need-to-know-with-alex-embiricos-head-of-codex-at-openai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product_Alexander_Embiricos__OpenAI-Revised.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7313609-e0d6-4c4d-ab91-b548c5b0153b",
            "index": 48,
            "title": "20VC: Anthropic Raises $30BN at $380BN Valuation | Thrive Raises New $10BN Fund | OpenAI Buys OpenClaw | Stripe Raises at $140BN: Is Adyen Wildly Undervalued? | Monday, Figma, Shopify: Which are Buys vs Sells?",
            "pub_date": "2026-02-19T07:07:00.000Z",
            "duration": "01:34:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "replit"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-raises-30bn-at-380bn-valuation-thrive-raises-new-10bn-fund-openai-buys-openclaw-stripe-raises-at-140bn-is-adyen-wildly-undervalued-monday-figma-shopify-which-are-buys-vs-sells",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.44.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2397b72d-a318-4d82-9f78-962c081fd66d",
            "index": 49,
            "title": "20VC: SaaS is Dead: Why Systems of Record Will Die in an Agentic World | What Revenue Multiple Will Software Companies Trade At? | From 7,000 to 3,000: We Need Less People Than Ever with Sebastian Siemiatkowski",
            "pub_date": "2026-02-16T07:07:00.000Z",
            "duration": "01:27:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-saas-is-dead-why-systems-of-record-will-die-in-an-agentic-world-what-revenue-multiple-will-software-companies-trade-at-from-7000-to-3000-we-need-less-people-than-ever-with-sebastian-siemiatkowski",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Sebastian_Siemiatkowski__Klarna.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "687c0955-b38a-481b-a7a2-de681c1aea50",
            "index": 50,
            "title": "20Sales: Inside ElevenLabs $330M ARR Sales Machine | The 20x Sales Comp Plan Reps Must Hit | How to Land and Expand in a World of AI | Why Product-Market-Fit is BS, Reps Should Not Be in the Office and Outbound is King with Carles Reina",
            "pub_date": "2026-02-14T12:48:00.000Z",
            "duration": "01:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-inside-elevenlabs-330m-arr-sales-machine-the-20x-sales-comp-plan-reps-must-hit-how-to-land-and-expand-in-a-world-of-ai-why-product-market-fit-is-bs-reps-should-not-be-in-the-office-and-outbound-is-king-with-carles-reina",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales__Carles_Reina__ElevenLabs.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c4ce5ff-c537-4c9e-aafe-7ebd136f6d3b",
            "index": 51,
            "title": "20VC: Anthropic's Superbowl Ad: Who Won - Who Lost | Harvey Raises $200M at $11BN Valuation | Sierra Hits $150M in ARR: Is Customer Support Too Crowded",
            "pub_date": "2026-02-12T07:07:00.000Z",
            "duration": "01:21:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropics-superbowl-ad-who-won-who-lost-harvey-raises-200m-at-11bn-valuation-sierra-hits-150m-in-arr-is-customer-support-too-crowded",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.43.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "106ba913-b552-4ddb-9f01-18d485fc74a7",
            "index": 52,
            "title": "20VC: Is SaaS Dead in a World of AI | Do Margins Matter Anymore | Is Triple, Triple, Double, Double Dead Today? | Who Wins the Dev Market: Cursor or Claude Code | Why We Are Not in an AI Bubble with Anish Acharya @ a16z",
            "pub_date": "2026-02-09T07:07:00.000Z",
            "duration": "01:24:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "claude",
              "cursor",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-is-saas-dead-in-a-world-of-ai-do-margins-matter-anymore-is-triple-triple-double-double-dead-today-who-wins-the-dev-market-cursor-or-claude-code-why-we-are-not-in-an-ai-bubble-with-anish-acharya-a16z",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Anish_Acharya__a16z.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3afc316c-bae2-43be-a079-51659db7d7e0",
            "index": 53,
            "title": "20VC: From $6.2BN Market Cap to $2.8BN: What Is Not Translating About Navan's Public Story | Are Any Public Company CEOs Actually Happy? | Why Navan Built It's Own Customer Service AI and What it Could Mean For Customer Service AI with Ariel Cohen",
            "pub_date": "2026-02-07T23:19:00.000Z",
            "duration": "54:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-from-62bn-market-cap-to-28bn-what-is-not-translating-about-navans-public-story-are-any-public-company-ceos-actually-happy-why-navan-built-its-own-customer-service-ai-and-what-it-could-mean-for-customer-service-ai-with-ariel-cohen",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Memo__Ariel_Cohen__Navan-Updated-2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e386a8d2-e49f-470e-a0f5-926c66d73685",
            "index": 54,
            "title": "20VC: SpaceX Completes Acquisition of xAI | The 2026 SaaS Massacre: Public Market Collapse | Microsoft's $360 Billion Market Cap Loss | NVIDIA's $100BN Investment Dispute with OpenAI | Waymo Raises $16 Billion at a $110 Billion Valuation",
            "pub_date": "2026-02-05T07:07:00.000Z",
            "duration": "01:34:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "xai",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-spacex-completes-acquisition-of-xai-the-2026-saas-massacre-public-market-collapse-microsofts-360-billion-market-cap-loss-nvidias-100bn-investment-dispute-with-openai-waymo-raises-16-billion-at-a-110-billion-valuation",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.42.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6683adf6-9641-4fae-bc27-d202a53d2365",
            "index": 55,
            "title": "20VC: 50% of Funds Will Go Out of Business | Why Growth Expectations Today are BS and Will Not Last | Why Oren Zeev Takes $0 Management Fees But 30% Carry | Why GPs Should Not Tell LPs Their Strategy",
            "pub_date": "2026-02-02T07:07:00.000Z",
            "duration": "01:08:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-50-of-funds-will-go-out-of-business-why-growth-expectations-today-are-bs-and-will-not-last-why-oren-zeev-takes-0-management-fees-but-30-carry-why-gps-should-not-tell-lps-their-strategy",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Oren_Zeev__Zeev_Ventures.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "59a5f55f-4343-4666-bcc6-600e2efd67ef",
            "index": 56,
            "title": "20Growth: How Wix Built a $100M Marketing Machine | Why LTV is BS and Why Time Return On Investment is the Most Important Metric | How to 10x Your Growth: What is the Next Great Channel with Omer Shai, CMO @ Wix",
            "pub_date": "2026-01-31T07:07:00.000Z",
            "duration": "01:01:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "automation"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-how-wix-built-a-100m-marketing-machine-why-ltv-is-bs-and-why-time-return-on-investment-is-the-most-important-metric-how-to-10x-your-growth-what-is-the-next-great-channel-with-omer-shai-cmo-wix",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth__Omer_Shai__Wix.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "64b7b72b-e32f-4c93-bb78-dc80ed0e5125",
            "index": 57,
            "title": "20VC: Brex Acquired for $5.15BN | a16z Companies are 2/3 AI Revenues | Anthropic Inference Costs Skyrocket | OpenEvidence Raises at $12BN Valuation | The IPO Market: EquipmentShare, Wealthfront and Ethos Insurance",
            "pub_date": "2026-01-29T07:07:00.000Z",
            "duration": "01:15:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "inference"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-brex-acquired-for-515bn-a16z-companies-are-23-ai-revenues-anthropic-inference-costs-skyrocket-openevidence-raises-at-12bn-valuation-the-ipo-market-equipmentshare-wealthfront-and-ethos-insurance",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.41.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff80f94a-2267-44fc-b2de-c47f65605970",
            "index": 58,
            "title": "20VC: From Only OpenAI to Die-Hard Anthropic: The Downfall of OpenAI in Enterprise | Harvey vs Legora: Legal AI is a Winner Take All | $7M ARR in a Single Day and Raising $200M Across 3 Rounds with No Deck with Max Junestrand, CEO @ Legora",
            "pub_date": "2026-01-26T14:19:00.000Z",
            "duration": "01:03:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-from-only-openai-to-die-hard-anthropic-the-downfall-of-openai-in-enterprise-harvey-vs-legora-legal-ai-is-a-winner-take-all-7m-arr-in-a-single-day-and-raising-200m-across-3-rounds-with-no-deck-with-max-junestrand-ceo-legora",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Max_Junestrand__Legora_2_Updated.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9567ed16-bd79-436d-a8f4-ada40be968e9",
            "index": 59,
            "title": "20VC: Raising $400M for 20VC: Fundraising Lessons | Getting Marc Benioff Through 53 Cold Emails: How to Master Cold Outbound | 7 Lessons from 101 Decacorn Founders with Harry Stebbings (Simon Squibb Edition)",
            "pub_date": "2026-01-24T13:40:00.000Z",
            "duration": "42:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-raising-400m-for-20vc-fundraising-lessons-getting-marc-benioff-through-53-cold-emails-how-to-master-cold-outbound-7-lessons-from-101-decacorn-founders-with-harry-stebbings-simon-squibb-edition",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Memo__20VC_x_Simon_Squibb.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa2b309b-e55b-43a6-bbd4-f9bacaaf0168",
            "index": 60,
            "title": "20VC: Sam Altman vs Elon Musk: The $100BN Battle | The Implosion of Thinking Machines | Can VC Survive Public Market Pricing Today? | ClickHouse and Replit's New Rounds: Analysed",
            "pub_date": "2026-01-22T07:07:00.000Z",
            "duration": "01:18:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "openai",
              "replit"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-sam-altman-vs-elon-musk-the-100bn-battle-the-implosion-of-thinking-machines-can-vc-survive-public-market-pricing-today-clickhouse-and-replits-new-rounds-analysed",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.40.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d0a666f7-72da-4241-8130-bec34011f63d",
            "index": 61,
            "title": "20VC: How Model Performance is Plateauing | Two Key Rules for Effective Deal-Making | Company Building Lessons from Keith Rabois, Brian Halligan and Pat Grady | Why Enterprise AI Adoption is Years Off with Harvey CEO Winston Weinberg",
            "pub_date": "2026-01-19T07:07:00.000Z",
            "duration": "01:13:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "enterprise ai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-how-model-performance-is-plateauing-two-key-rules-for-effective-deal-making-company-building-lessons-from-keith-rabois-brian-halligan-and-pat-grady-why-enterprise-ai-adoption-is-years-off-withharvey-ceo-winston-weinberg",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Winston_Weinberg__Harvey.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d329558-aefe-4785-adf0-ddb419673fac",
            "index": 62,
            "title": "20Product: Is the Design Phase Dead in a World of AI | Has Claude Code Crushed Anthropic Already | What Roles of a PM Are Less and More Important with AI | How the Best Product Leaders Tell Stories with Noam Lovinsky, CPO @ Superhuman",
            "pub_date": "2026-01-16T07:07:00.000Z",
            "duration": "45:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-is-the-design-phase-dead-in-a-world-of-ai-has-claude-code-crushed-anthropic-already-what-roles-of-a-pm-are-less-and-more-important-with-ai-how-the-best-product-leaders-tell-stories-with-noam-lovinsky-cpo-superhuman",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product__Noam_Lovinsky__Grammarly.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6aa3aa3c-ad57-40c8-bd16-8222b4f6f1ba",
            "index": 63,
            "title": "20VC: Anthropic's $10BN Fundraise: Have They Beaten Cursor Already | a16z's $15BN Fundraise: Is the Middle Dead in VC Today? | How OpenAI Could Go to Zero and ElevenLabs at $11BN: Buy or Not?",
            "pub_date": "2026-01-15T07:07:00.000Z",
            "duration": "01:28:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "openai",
              "anthropic",
              "claude",
              "cursor"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropics-10bn-fundraise-have-they-beaten-cursor-already-a16zs-15bn-fundraise-is-the-middle-dead-in-vc-today-how-openai-could-go-to-zero-and-elevenlabs-at-11bn-buy-or-not",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_-_Ep.39.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac2ec117-9429-4231-a491-ee764afb966c",
            "index": 64,
            "title": "20VC: a16z's $15BN Fundraise with Alex Rampell | The Best Companies Have Hostages Not Customers | The Best Founders Materialise Capital, Customers and Labour | Mid-Sized Funds with Die and The Future of Venture Capital",
            "pub_date": "2026-01-12T07:07:00.000Z",
            "duration": "01:17:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-a16zs-15bn-fundraise-with-alex-rampell-the-best-companies-have-hostages-not-customers-the-best-founders-materialise-capital-customers-and-labour-mid-sized-funds-with-die-and-the-future-of-venture-capital",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Alex_Rampell__a16z.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e72fb04-b283-4488-9b30-3054ae330bc2",
            "index": 65,
            "title": "20Growth: The $6.6B Growth Engine Behind ElevenLabs | Why ElevenLabs Do Not Have PMs | The 7 Part Launch Playbook to Crush All Launches with Luke Harries, Head of Growth @ ElevenLabs",
            "pub_date": "2026-01-11T14:34:00.000Z",
            "duration": "01:13:34",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-the-66b-growth-engine-behind-elevenlabs-why-elevenlabs-do-not-have-pms-the-7-part-launch-playbook-to-crush-all-launches-with-luke-harries-head-of-growth-elevenlabs",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Luke_Harries__ElevenLabs_copy.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2940c9a0-9918-4d76-9372-536eb9c78cb6",
            "index": 66,
            "title": "20Sales: Why the Best Sales People are F**** in the Head | Why Remote Work is BS | Why Europe is a Nightmare for Recruiting Sales Teams | How to Build a Sales Machine | What Everyone Gets Wrong Today in Sales with Chad Peets",
            "pub_date": "2026-01-09T07:07:00.000Z",
            "duration": "01:09:28",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-why-the-best-sales-people-are-f-in-the-head-why-remote-work-is-bs-why-europe-is-a-nightmare-for-recruiting-sales-teams-how-to-build-a-sales-machine-what-everyone-gets-wrong-today-in-sales-with-chad-peets",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Chad_Peets__Riverpoint_Capital_-_Jan_2026.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b2a846b-62ca-4bdd-93c2-a772ca796e94",
            "index": 67,
            "title": "20VC: Groq's $20BN NVIDIA Acquisition | Manus Acquired by Meta for $2BN | Why Sam Altman Does Not Care About Dilution | Navan Trading at 4x ARR & Why Going Public Does Not Make Sense Anymore | The Rise of Invisible Unemployment and Labour Markets in 2026",
            "pub_date": "2026-01-08T07:07:00.000Z",
            "duration": "01:23:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-groqs-20bn-nvidia-acquisition-manus-acquired-by-meta-for-2bn-why-sam-altman-does-not-care-about-dilution-navan-trading-at-4x-arr-why-going-public-does-not-make-sense-anymore-the-rise-of-invisible-unemployment-and-labour-markets-in-2026",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_Ep.38.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c44dd8a4-e5c1-4598-a5f0-ac27b5e5deef",
            "index": 68,
            "title": "20VC: $0-$260M in Revenue in Three Years: How We Did It | You Need to Work Weekends to Win — Most Founders Aren't Ambitious Enough | The Revolut Playbook: Speed, Urgency, Extreme Ownership, and Zero Excuses with Alan Chang @ Fuse Energy",
            "pub_date": "2026-01-05T07:07:00.000Z",
            "duration": "56:51",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-0-260m-in-revenue-in-three-years-how-we-did-it-you-need-to-work-weekends-to-win-most-founders-arent-ambitious-enough-the-revolut-playbook-speed-urgency-extreme-ownership-and-zero-excuses-with-alan-chang-fuse-energy",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Alan_Chang__Fuse_Energy.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef325a17-2f20-40ae-b63c-5cea1452b243",
            "index": 69,
            "title": "20VC: Enterprises Will Not Adopt AI without Forward-Deployed Engineers | Who Wins the Data Labelling Race: How Does it Shake Out? | How Synthetic Data Threatens the Future of Human-Generated Data with Matt Fitzpatrick, CEO of Invisible Technologies",
            "pub_date": "2025-12-31T17:36:00.000Z",
            "duration": "01:23:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-enterprises-will-not-adopt-ai-without-forward-deployed-engineers-who-wins-the-data-labelling-race-how-does-it-shake-out-lessons-learned-hitting-200m-arr-with-matt-fitzpatrick-ceo-of-invisible-technologies",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Matthew_Fitzpatrick__Invisible_Technologies.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "79574f60-ad65-4826-8d74-d793699324ac",
            "index": 70,
            "title": "20VC's Big Fat Quiz of the Year: Founder, Fund and Breakout Company of 2025 | Predictions for 2026: The Company to Buy, The Biggest Short | Why Salesforce Could Win 2026 and The Tailwinds NVIDIA Will Face",
            "pub_date": "2025-12-22T07:07:00.000Z",
            "duration": "01:09:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vcs-big-fat-quiz-of-the-year-founder-fund-and-breakout-company-of-2025-predictions-for-2026-the-company-to-buy-the-biggest-short-why-salesforce-could-win-2026-and-the-tailwinds-nvidia-will-face",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_-_EP37.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a16d52e-1aa2-401f-82cd-140798d25e31",
            "index": 71,
            "title": "20Product: On Running's CPO on How to Create Emotion Through Product | Why 99% of Products Fail and How to Create Cults Around Products | The Biggest Product Mistakes On Have Made & Lessons Learned with Gérald Marolf",
            "pub_date": "2025-12-19T07:07:00.000Z",
            "duration": "56:00",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-on-runnings-cpo-on-how-to-create-emotion-through-product-why-99-of-products-fail-and-how-to-create-cults-around-products-the-biggest-product-mistakes-on-have-made-lessons-learned-with-grald-marolf",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product_TheMemo__Gerald_Marolf__On.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "43ed4352-7b4c-4381-aca9-c6d5bc44e609",
            "index": 72,
            "title": "20VC: Will SpaceX IPO at $1.5TRN | Will Cursor Kill Figma | Lightspeed Raises $9BN | OpenAI: $1BN from Disney, New CRO & #1 App in App Store | Oracle and Broadcom Hit: Now the Time to Buy?",
            "pub_date": "2025-12-18T07:07:00.000Z",
            "duration": "01:22:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "cursor",
              "chip",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-will-spacex-ipo-at-15trn-will-cursor-kill-figma-lightspeed-raises-9bn-openai-1bn-from-disney-new-cro-1-app-in-app-store-oracle-and-broadcom-hit-now-the-time-to-buy",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP36.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "476d8725-5040-4f3f-96ed-0942a21d2238",
            "index": 73,
            "title": "20VC: a16z's David George on How $BN Funds Can 5×, Do Margins & Revenue Matter in AI & the Most Controversial Bet at a16z",
            "pub_date": "2025-12-15T07:07:00.000Z",
            "duration": "01:06:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-a16zs-david-george-on-how-bn-funds-can-5-do-margins-revenue-matter-in-ai-the-most-controversial-bet-at-a16z",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/David_George__a16z.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6dc1080b-506a-4f3f-9d27-c3c25b02a159",
            "index": 74,
            "title": "20Growth: How Wiz Built a $30BN Brand in Enterprise | What Worked vs What Was a Mega Failure: Lessons Learned | Why Marketers Make the Worst CMOs & What To Look for in Growth with Raaz Herzberg",
            "pub_date": "2025-12-12T07:07:00.000Z",
            "duration": "01:16:10",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-how-wiz-built-a-30bn-brand-in-enterprise-what-worked-vs-what-was-a-mega-failure-lessons-learned-why-marketers-make-the-worst-cmos-what-to-look-for-in-growth-with-raaz-herzberg",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth__Raaz_Herzberg__Wiz.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f1732d57-a1d2-487d-9531-aee88bcc2777",
            "index": 75,
            "title": "20VC OGs: SpaceX Valued at $800BN & Harvey Raises $160M at an $8BN Price | Airwallex Raises $330M and The Battle with Keith Rabois | Netflix Acquires Warner Brothers | IPO Market Predictions for 2026: Anthropic, Stripe, Databricks and SpaceX",
            "pub_date": "2025-12-11T07:07:00.000Z",
            "duration": "01:31:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-ogs-spacex-valued-at-800bn-harvey-raises-160m-at-an-8bn-price-airwallex-raises-330m-and-the-battle-with-keith-rabois-netflix-acquires-warner-brothers-ipo-market-predictions-for-2026-anthropic-stripe-databricks-and-spacex",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.35.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9ad2a82d-9a37-4bcc-ae00-c8adaefab508",
            "index": 76,
            "title": "20VC: Kalshi's $1BN Raise, the Polymarket Feud, and the Battle to Replace Traditional Media",
            "pub_date": "2025-12-08T07:07:00.000Z",
            "duration": "47:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-kalshis-1bn-raise-the-polymarket-feud-and-the-battle-to-replace-traditional-media",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Tarek_Mansour__Kalshi.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2623d65-ea6e-40ae-b4d4-39c9754dc6da",
            "index": 77,
            "title": "20VC: Inside Bending Spoons Acquisition Machine: Evernote, Eventbrite, Vimeo | How Evernote Evaluates Acquisitions and New Product Ideas | How Evernote Mastered Product Launches, User Retention and Monetisation with Federico Simionato",
            "pub_date": "2025-12-05T07:07:00.000Z",
            "duration": "01:05:28",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-inside-bending-spoons-acquisition-machine-evernote-eventbrite-vimeo-how-evernote-evaluates-acquisitions-and-new-product-ideas-how-evernote-mastered-product-launches-user-retention-and-monetisation-with-federico-simionato",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product__Federico_Simionato__Bending_Spoons.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5ced49d3-ee9a-4eed-965a-70587cf1fa77",
            "index": 78,
            "title": "20VC: Thrive & OpenAI Partnership | Eventbrite Acquired for $500M | Databricks Raising $5BN at $134BN Valuation: Cheap or Not? | Why SaaS is Like Japan and The TAM Trap in Software",
            "pub_date": "2025-12-04T07:07:00.000Z",
            "duration": "01:12:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-thrive-openai-partnership-eventbrite-acquired-for-500m-databricks-raising-5bn-at-134bn-valuation-cheap-or-not-why-saas-is-like-japan-and-the-tam-trap-in-software",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP34.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a46f24be-6e35-40e7-8d2d-8dc96e52b108",
            "index": 79,
            "title": "20VC: Scale, Surge, Turing, Mercor: Who Wins & Who Loses in Data Labelling | Is Revenue in Data Labelling Real or GMV? | Why 99% of Knowledge Work Will Go and What Happens Then? | Why SaaS is Dead in a World of AI with Jonathan Siddharth @ Turing",
            "pub_date": "2025-12-01T07:07:00.000Z",
            "duration": "01:08:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-scale-surge-turing-mercor-who-wins-who-loses-in-data-labelling-is-revenue-in-data-labelling-real-or-gmv-why-99-of-knowledge-work-will-go-and-what-happens-then-why-saas-is-dead-in-a-world-of-ai-with-jonathan-siddharth-turing",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Jonathan_Siddarth__Turing.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a290c82-b368-4833-8987-b1e3f5df8026",
            "index": 80,
            "title": "20Sales: John McMahon on How to Hire, Train & Retain the Best Sales Reps | How Sales Changes in a World of AI | Sales Lessons from Snowflake and MongoDB | How to Create and Drive a Sales Process with Urgency",
            "pub_date": "2025-11-28T08:08:00.000Z",
            "duration": "01:08:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-john-mcmahon-on-how-to-hire-train-retain-the-best-sales-reps-how-sales-changes-in-a-world-of-ai-sales-lessons-from-snowflake-and-mongodb-how-to-create-and-drive-a-sales-process-with-urgency",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales__John_Mcmahon.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a0713a7-b4d6-483c-be45-d7098cf1fdbe",
            "index": 81,
            "title": "20VC: Anthropic Raises $30BN from Microsoft and NVIDIA | NVIDIA Core Business Threatened by TPU | Sam Altman's \"War Mode\" Analysed | Sierra Hits $100M ARR: Justifies $10BN Price? | Lovable Hits $200M ARR & Rumoured $6BN Round",
            "pub_date": "2025-11-27T15:09:00.000Z",
            "duration": "01:30:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "openai",
              "anthropic",
              "nvidia",
              "enterprise ai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-raises-30bn-from-microsoft-and-nvidia-nvidia-core-business-threatened-by-tpu-sam-altmans-war-mode-analysed-sierra-hits-100m-arr-justifies-10bn-price-lovable-hits-200m-arr-rumoured-6bn-round",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.33-Fixed.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fcaea344-b04b-414c-ada3-d96dc82d4944",
            "index": 82,
            "title": "20VC: Base44's Maor Shlomo on How Vibe Coding Will Kill SaaS and Salesforce | Why it is BS that Vibe Coding Platforms Do Not Have Defensibility and Bad Margins | Why He Worries About Google, Not Replit and Lovable | Why Long Anthropic, Not OpenAI?",
            "pub_date": "2025-11-24T07:07:00.000Z",
            "duration": "01:11:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "cursor",
              "replit",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-base44s-maor-shlomo-on-how-vibe-coding-will-kill-saas-and-salesforce-why-it-is-bs-that-vibe-coding-platforms-do-not-have-defensibility-and-bad-margins-why-he-worries-about-google-not-replit-and-lovable-why-long-anthropic-not-openai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Maor_Shlomo__Base44.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a46b8eb1-ec36-4c36-8aa2-ffbfa9d690fd",
            "index": 83,
            "title": "20VC: Max Altman on The New Seed War: Can Anyone Compete with Sequoia and a16z | Leaving $2BN on the Table with Reddit | Lessons from Backing Rippling at $25M Post | Why Climate Tech is a Mirage and Disaster",
            "pub_date": "2025-11-21T07:07:00.000Z",
            "duration": "01:19:22",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-max-altman-on-the-new-seed-war-can-anyone-compete-with-sequoia-and-a16z-leaving-2bn-on-the-table-with-reddit-lessons-from-backing-rippling-at-25m-post-why-climate-tech-is-a-mirage-and-disaster",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Max_Altman__Saga_Ventures.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f424b508-7926-4eaa-af96-4f8aa5d7ec08",
            "index": 84,
            "title": "20VC: Cursor Raises $2.3BN: Who Wins the Coding War | Peter Thiel and Softbank Sell NVIDIA: Analysed | Why Venture Capital Will Hit $1TRN and the Opening of Retail | Why Stripe and the Best Companies Will Never Go Public",
            "pub_date": "2025-11-20T07:07:00.000Z",
            "duration": "01:22:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "gemini",
              "cursor",
              "replit",
              "nvidia",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-cursor-raises-23bn-who-wins-the-coding-war-peter-thiel-and-softbank-sell-nvidia-analysed-why-venture-capital-will-hit-1trn-and-the-opening-of-retail-why-stripe-and-the-best-companies-will-never-go-public",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.32.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6fbca92d-05ec-4b37-8144-66d3a109cadd",
            "index": 85,
            "title": "20VC: Andrew NG on The Biggest Bottlenecks in AI | How LLMs Can Be Used as a Geopolitical Weapon | Do Margins Matter in a World of AI? | Is Defensibility Dead in a World of AI? | Will AI Deliver Masa Son's Predictions of 5% GDP Growth?",
            "pub_date": "2025-11-17T07:07:00.000Z",
            "duration": "01:02:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-andrew-ng-on-the-biggest-bottlenecks-in-ai-how-llms-can-be-used-as-a-geopolitical-weapon-do-margins-matter-in-a-world-of-ai-is-defensibility-dead-in-a-world-of-ai-will-ai-deliver-masa-sons-predictions-of-5-gdp-growth",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Andrew_NG_General_Partner__AI_Fund.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a689f0a-ceae-4ee3-99e3-73c549fd370d",
            "index": 86,
            "title": "20Product: How AI Changes Product Design | Does the Design Phase Become Irrelevant in a World of Vibe Coding | The Five Pillars of Truly Great Product Design with Carl Rivera, Chief Design Officer at Shopify",
            "pub_date": "2025-11-14T14:18:00.000Z",
            "duration": "01:11:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-how-ai-changes-product-design-does-the-design-phase-become-irrelevant-in-a-world-of-vibe-coding-the-five-pillars-of-truly-great-product-design-with-carl-rivera-chief-design-officer-at-shopify",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Carl_Rivera__Shopify.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dca44eda-6ddb-4607-9973-3c50bdee2802",
            "index": 87,
            "title": "20VC: Sequoia's Leadership Transition | Michael Burry Shorts NVIDIA and Palantir | Gamma Raises $100M at $2BN | Has Defensibility Died in a World of AI | Datadog Surges as Duolingo Plummets: What is Happening",
            "pub_date": "2025-11-13T07:07:00.000Z",
            "duration": "01:15:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-sequoias-leadership-transition-michael-burry-shorts-nvidia-and-palantir-gamma-raises-100m-at-2bn-has-defensibility-died-in-a-world-of-ai-datadog-surges-as-duolingo-plummets-what-is-happening",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.31.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc4a4ef4-be80-4d70-9917-449dccac90bf",
            "index": 88,
            "title": "20VC: Benchmark's Newest General Partner Ev Randle on Why Margins Matter Less in AI | Why Mega Funds Will Not Produce Good Returns | OpenAI vs Anthropic: What Happens and Who Wins Coding | Investing Lessons from Peter Thiel and Mamoon Hamid",
            "pub_date": "2025-11-10T07:07:00.000Z",
            "duration": "01:25:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-benchmarks-newest-general-partner-ev-randle-on-why-margins-matter-less-in-ai-why-mega-funds-will-not-produce-good-returns-openai-vs-anthropic-what-happens-and-who-wins-coding-investing-lessons-from-peter-thiel-and-mamoon-hamid",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Everett_Randle__Benchmark.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4875f797-2e6e-461a-aef9-74e3a82463fa",
            "index": 89,
            "title": "20Sales: Why You Need a CRO Pre-Product | Why Remote Sales Teams Do Not Work | How Snowflake Built a Sales Machine with Chad Peets",
            "pub_date": "2025-11-07T15:45:00.000Z",
            "duration": "01:09:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-why-you-need-a-cro-pre-product-why-remote-sales-teams-do-not-work-how-snowflake-built-a-sales-machine-with-chad-peets",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Chad_Peets__Riverpoint_Capital.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8de4ab7b-1b47-4e80-9433-2a5e256e0068",
            "index": 90,
            "title": "20VC: Navan IPO: Winners, Losers and is a $4.5BN Exit Enough in VC Today | Harvey Raises $150M at $8BN Price | Why Google is a Buy and Amazon is a Sell | Meta Down 10%, Is Zuck Struggling?",
            "pub_date": "2025-11-06T07:07:00.000Z",
            "duration": "01:16:23",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-navan-ipo-winners-losers-and-is-a-45bn-exit-enough-in-vc-today-harvey-raises-150m-at-8bn-price-why-google-is-a-buy-and-amazon-is-a-sell-meta-down-10-is-zuck-struggling",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP30.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1580e73e-ea6c-45d2-bebf-2bc6ffa97a88",
            "index": 91,
            "title": "20VC: Cohere's Chief AI Officer on Why Scaling Laws Will Continue | Whether You Can Buy Success in AI with Talent Acquisitions | The Future of Synthetic Data & What It Means for Models | Why AI Coding is Akin to Image Generation in 2015 with Joelle Pineau",
            "pub_date": "2025-11-03T07:07:00.000Z",
            "duration": "57:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "meta ai",
              "robotics",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-coheres-chief-scientist-on-why-scaling-laws-will-continue-whether-you-can-buy-success-in-ai-with-talent-acquisitions-the-future-of-synthetic-data-what-it-means-for-models-why-ai-coding-is-akin-to-image-generation-in-2015-with-joelle-pineau",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Joelle_Pineau__Cohere.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b5d9999-8b4b-4e89-93f9-73ee8c6986a7",
            "index": 92,
            "title": "20VC: Tim Ferriss: Why I Walked Away From Angel Investing After Uber | How I Accidentally Lost $150 Million | Money Fixed My Problems—Then Made Me Miserable",
            "pub_date": "2025-10-31T07:07:00.000Z",
            "duration": "01:31:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-tim-ferriss-why-i-walked-away-from-angel-investing-after-uber-how-i-accidentally-lost-150-million-money-fixed-my-problemsthen-made-me-miserable",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Tim_Ferriss.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7174512c-53ab-4918-9c6a-9ddc3af5da13",
            "index": 93,
            "title": "20VC: a16z Raises $10BN in New Funds | Mercor Raises $350M at a $10BN Valuation | OpenAI Restructuring: Who Wins and Who Loses | Why IRR is a BS Metric and Three Ways to Win in VC Today",
            "pub_date": "2025-10-30T07:07:00.000Z",
            "duration": "01:24:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-a16z-raises-10bn-in-new-funds-mercor-raises-350m-at-a-10bn-valuation-openai-restructuring-who-wins-and-who-loses-why-irr-is-a-bs-metric-and-three-ways-to-win-in-vc-today",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.29.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd9054bc-6e06-4acb-b5c8-935ed6d73d71",
            "index": 94,
            "title": "20VC: Sequoia's David Cahn on The Winners and Losers in AI | The $0-$100M Revenue Club: Is Triple, Triple, Double, Double Dead? | The Future of Defence: Who Wins and Who Loses | How to Analyse Margins and Growth Rates in a World of AI",
            "pub_date": "2025-10-27T07:07:00.000Z",
            "duration": "01:14:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-sequoias-david-cahn-on-the-winners-and-losers-in-ai-the-0-100m-revenue-club-is-triple-triple-double-double-dead-the-future-of-defence-who-wins-and-who-loses-how-to-analyse-margins-and-growth-rates-in-a-world-of-ai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/David_Cahn__Sequoia_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a8ae8b0-88df-4d1f-9b71-2046c36554dd",
            "index": 95,
            "title": "20Growth: How to Build a Paid Marketing Machine: ROAS (Return on Ad Spend) 101 | The Rise of User Generated Content and How to Use It | TikTok Ads: Expectations vs. Reality | Hiring for Growth: When and Who with Sandy Diao",
            "pub_date": "2025-10-24T10:36:00.000Z",
            "duration": "01:16:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-how-to-build-a-paid-marketing-machine-roas-return-on-ad-spend-101-the-rise-of-user-generared-content-and-how-to-use-it-tiktok-ads-expectations-vs-reality-hiring-for-growth-when-and-who-with-sandy-diao",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Sandy_Diao__Drift_International.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "39255d38-58e8-45c0-9411-4b8a11285541",
            "index": 96,
            "title": "20VC: Why VC Today is Worse Than 2021 | Why Vertical SaaS is a Bad Investment Today | Why We Are Deluding Ourselves on Growth Expectations | Revolut Raises $3BN at a $75BN Valuation | Benchmark Adds Their Newest General Partner",
            "pub_date": "2025-10-23T17:36:00.000Z",
            "duration": "01:28:58",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-vc-today-is-worse-than-2021-why-vertical-saas-is-a-bad-investment-today-why-we-are-deluding-ourselves-on-growth-expectations-revolut-raises-3bn-at-a-75bn-valuation-benchmark-adds-their-newest-general-partner",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.28.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7bd2c04c-9cc2-4d02-aa2e-05a21810fd1a",
            "index": 97,
            "title": "20VC: Deel CEO Alex Bouaziz on Raising $300M+ at a $17BN Valuation | Deel vs Rippling: WTF is Going On | Management Lessons from Ben Horowitz and Nik Storonsky | Deel's M&A Playbook: Lessons from 13 Acquisitions: What Works & What Doesn't",
            "pub_date": "2025-10-22T23:00:00.000Z",
            "duration": "01:15:23",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-deel-ceo-alex-bouaziz-on-raising-300m-at-a-17bn-valuation-deel-vs-rippling-wtf-is-going-on-management-lessons-from-ben-horowitz-and-nik-storonsky-deels-ma-playbook-lessons-from-13-acquisitions-what-works-what-doesnt",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Alex_Bouaziz__Deel_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b924cbe3-729a-4a07-a497-4eebce3b4914",
            "index": 98,
            "title": "20VC: The Startup Adding $1M ARR Every Week | Competing Against OpenAI's Codex and Claude Code: Who Wins | Why Gemini is Failing and GPT-5 Is Winning | Do Margins Matter in a World of AI | The Ugly Truth About AI Coding with Zach Lloyd, Warp",
            "pub_date": "2025-10-17T07:07:00.000Z",
            "duration": "01:13:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 19,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "gemini",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-startup-adding-1m-arr-every-week-competing-against-openais-codex-and-claude-code-who-wins-why-gemini-is-failing-and-gpt-5-is-winning-do-margins-matter-in-a-world-of-ai-the-ugly-truth-about-ai-coding-with-zach-lloyd-warp",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product__Zach_Lloyd__Warp.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "703a357f-9c99-4d7a-abd2-e11f97c6c1dd",
            "index": 99,
            "title": "20VC: $3.5BN - The Price Zuck Paid for Thinking Machines Co-Founder | Goldman Sachs Acquires Industry Ventures for $665M | Softbank Borrows $5BN Against ARM Holding to Invest More Into OpenAI",
            "pub_date": "2025-10-16T07:07:00.000Z",
            "duration": "01:19:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-35bn-the-price-zuck-paid-for-thinking-machines-co-founder-goldman-sachs-acquires-industry-ventures-for-665m-softbank-borrows-5bn-against-arm-holding-to-invest-more-into-openai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.27.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c980d67a-bbf6-486c-857a-a3fb6afa414a",
            "index": 100,
            "title": "20VC: Atlassian CEO on Why Everything is Overvalued & Are We in an AI Bubble | Do Margins Matter & Does Defensibility Exist in an AI World | Is Per Seat Pricing Dead & The Future of Vibe Coding with Mike Cannon-Brookes",
            "pub_date": "2025-10-13T07:07:00.000Z",
            "duration": "01:03:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-atlassian-ceo-on-why-everything-is-overvalued-are-we-in-an-ai-bubble-do-margins-matter-does-defensibility-exist-in-an-ai-world-is-per-seat-pricing-dead-the-future-of-vibe-coding-with-mike-cannon-brookes",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Mike_Cannon-Brookes__Atlassian.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46c73913-d14c-42cb-b956-af8fa191118b",
            "index": 101,
            "title": "20Sales: Scaling Snowflake from $0-$3BN in ARR | Snowflake vs Databricks: My Biggest Lessons | Why Customer Success is BS and What Replaces It with Chris Chris Degnan",
            "pub_date": "2025-10-10T13:09:00.000Z",
            "duration": "01:02:22",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-scaling-snowflake-from-0-3bn-in-arr-snowflake-vs-databricks-my-biggest-lessons-why-customer-success-is-bs-and-what-replaces-it-with-chris-chris-degnan",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Chris_Degnan__Snowflake_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9bb79f9e-6447-4af3-b135-0c5206bd84ef",
            "index": 102,
            "title": "20VC: OpenAI's Multi $BN Deal with AMD | Polymarket, Vercel and Supabase Raise Mega Rounds | Does King Making Really Work in Venture Capital: Harvey vs Legora | Chamath is Back: The SPAC is Back",
            "pub_date": "2025-10-09T07:07:00.000Z",
            "duration": "01:24:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-openais-multi-bn-deal-with-amd-polymarket-vercel-and-supabase-raise-mega-rounds-does-king-making-really-work-in-venture-capital-harvey-vs-legora-chamath-is-back-the-spac-is-back",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP26.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7bff88b9-90c1-4529-96ab-3b981470c38f",
            "index": 103,
            "title": "20VC: Cerebras CEO on Why Raise $1BN and Delay the IPO | NVIDIA Showing Signs They Are Worried About Growth | Concentration of Value in Mag7: Will the AI Train Come to a Halt | Can the US Supply the Energy for AI with Andrew Feldman",
            "pub_date": "2025-10-06T07:07:00.000Z",
            "duration": "01:04:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "chip",
              "inference",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-cerebras-ceo-on-why-raise-1bn-and-delay-the-ipo-nvidia-showing-signs-they-are-worried-about-growth-concentration-of-value-in-mag7-will-the-ai-train-come-to-a-halt-can-the-us-supply-the-energy-for-ai-with-andrew-feldman",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Andrew_Feldman__Cerebras_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a08e11f9-440f-4187-bf5b-08d1164267ae",
            "index": 104,
            "title": "20Growth: How to Use Influencers to Scale Growth Insanely Fast | How to Optimise User Onboaring for Growth | How the Best Growth Teams Create Organic Growth and Community | Why LTV/CAC Models are BS with Ketty Slonimsky",
            "pub_date": "2025-10-03T07:07:00.000Z",
            "duration": "01:00:32",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-how-to-use-influencers-to-scale-growth-insanely-fast-how-to-optimise-user-onboaring-for-growth-how-the-best-growth-teams-create-organic-growth-and-community-why-ltvcac-models-are-bs-with-ketty-slonimsky",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth__Ketty_Slominsky__Palta.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e2fae55d-8ba2-4c0f-bcca-ef25e172df54",
            "index": 105,
            "title": "20VC: Are Burn Multiples BS in an AI World | Sam Altman Needs $1TRN of Energy | Klarna, Figma, Stubhub, all Down: Are Public Markets Turning? | FiveTran and DBT: Is the Wave of Consolidation About to Begin?",
            "pub_date": "2025-10-02T07:07:00.000Z",
            "duration": "01:16:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-are-burn-multiples-bs-in-an-ai-world-sam-altman-needs-1trn-of-energy-klarna-figma-stubhub-all-down-are-public-markets-turning-fivetran-and-dbt-is-the-wave-of-consolidation-about-to-begin",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_25.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02e534a4-dba6-4d11-9f96-a74edf53a301",
            "index": 106,
            "title": "20VC: OpenAI and Anthropic Will Build Their Own Chips | NVIDIA Will Be Worth $10TRN | How to Solve the Energy Required for AI... Nuclear | Why China is Behind the US in the Race for AGI with Jonathan Ross, Groq Founder",
            "pub_date": "2025-09-29T07:07:00.000Z",
            "duration": "01:21:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 24,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "anthropic",
              "nvidia",
              "chip",
              "chips"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-openai-and-anthropic-will-build-their-own-chips-nvidia-will-be-worth-10trn-how-to-solve-the-energy-required-for-ai-nuclear-why-china-is-behind-the-us-in-the-race-for-agi-with-jonathan-ross-groq-founder",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Jonathan_Ross__Groq_3.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3898aa76-e96e-4ac8-bd18-bee8985ea04e",
            "index": 107,
            "title": "20Product: Revolut Business $1BN Revenue: Five of the Biggest Product Lessons | How Revolut Structures Product and Design Teams | How Revolut Experiments and Invests in New Product Bets | How Revolut Ships Product So Fast with James Gibson",
            "pub_date": "2025-09-26T11:40:00.000Z",
            "duration": "54:15",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-revolut-business-1bn-revenue-five-of-the-biggest-product-lessons-how-revolut-structures-product-and-design-teams-how-revolut-experiments-and-invests-in-new-product-bets-how-revolut-ships-product-so-fast-with-james-gibson",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/James_Gibson__Revolut.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fbf2fb81-8155-4af2-9be8-acea13833657",
            "index": 108,
            "title": "20VC: NVIDIA Invests $100BN Into OpenAI | Is Triple, Triple, Double, Double Dead | Navan Files to go Public & Notion Hits $500M ARR | The Impact of H1B Visas on Startups in the US",
            "pub_date": "2025-09-25T07:07:00.000Z",
            "duration": "01:19:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-nvidia-invests-100bn-into-openai-is-triple-triple-double-double-dead-navan-files-to-go-public-notion-hits-500m-arr-the-impact-of-h1b-visas-on-startups-in-the-us",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP.24.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cfa28b5b-acb5-4d9a-9882-8760bb7d18ff",
            "index": 109,
            "title": "20VC: General Catalyst CEO Hemant Taneja on The Future of Venture Capital: Chanel vs Walmart | Lessons Scaling GC to $40BN in AUM | Investing $5BN+ Into Stripe Over 14 Rounds | Investing Hundreds of Millions into Anthropic at $60BN Valuation",
            "pub_date": "2025-09-22T07:07:00.000Z",
            "duration": "01:27:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-general-catalyst-ceo-hemant-taneja-on-the-future-of-venture-capital-chanel-vs-walmart-lessons-scaling-gc-to-40bn-in-aum-investing-5bn-into-stripe-over-14-rounds-investing-hundreds-of-millions-into-anthropic-at-60bn-valuation",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Hemant_Taneja__General_Catalyst.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de8c1f47-f73a-44eb-b516-dc85b4dfeb21",
            "index": 110,
            "title": "20VC: Why 90% of Founders Build Startups Wrong | Why AI Growth Rates are Sustainable & Remote Work is BS and the AI Talent War | Competing with Brett Taylor and Sierra: Who Wins the Customer Service War with Jesse Zhang, Decagon",
            "pub_date": "2025-09-19T07:08:00.000Z",
            "duration": "59:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-90-of-founders-build-startups-wrong-why-ai-growth-rates-are-sustainable-remote-work-is-bs-and-the-ai-talent-war-competing-with-brett-taylor-and-sierra-who-wins-the-customer-service-war-with-jesse-zhang-decagon",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Jesse_Zhang__Decagon_V2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6427d35e-d950-4954-a8d8-3ee253ce6ad5",
            "index": 111,
            "title": "20VC: Opendoor's CEO on The Greatest Turnaround in Tech | OpenAI and Oracle: How Can Either Afford to Do This | How Anthropic Could Lose 50% of Their Revenue Overnight | Replit Raises at $3BN | Figure, Gemini & VIA IPOs Broken Down",
            "pub_date": "2025-09-18T07:07:00.000Z",
            "duration": "01:24:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "gemini",
              "replit"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-opendoors-ceo-on-the-greatest-turnaround-in-tech-openai-and-oracle-how-can-either-afford-to-do-this-how-anthropic-could-lose-50-of-their-revenue-overnight-replit-raises-at-3bn-figure-gemini-via-ipos-broken-down",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/UPDATED_-_The_Trio_EP.23_ft._Kaz__Opendoor.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6fd5518b-b7a5-4953-9f5a-41db46e5cc7c",
            "index": 112,
            "title": "20VC: Mercor: From $1M to $500M in 17 Months: The Fastest Growing Company in the World | How to Think About Margins and Revenue Sustainability in AI | Why Evaluation Benchmarks in AI are BS Today with Brendan Foody",
            "pub_date": "2025-09-15T07:07:00.000Z",
            "duration": "01:01:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-mercor-from-1m-to-500m-in-17-months-the-fastest-growing-company-in-the-world-how-to-think-about-margins-and-revenue-sustainability-in-ai-why-evaluation-benchmarks-in-ai-are-bs-today-with-brendan-foody",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Brendan_Foody__Mercor.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bde39f62-1403-4064-a777-da2009c93035",
            "index": 113,
            "title": "20VC: Why AI SDRs are BS and Do Not Work | How to Use AI in Your Sales Team and Process to Win Today | What Skills Do All New Reps Need to Have in an AI First World with Amit Bendov, CEO @ Gong",
            "pub_date": "2025-09-12T07:07:00.000Z",
            "duration": "01:06:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-ai-sdrs-are-bs-and-do-not-work-how-to-use-ai-in-your-sales-team-and-process-to-win-today-what-skills-do-all-new-reps-need-to-have-in-an-ai-first-world-with-amit-bendov-ceo-gong",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Amit_Bendov__Gong.io.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "28db5614-a168-4cc7-8b05-12467b17b575",
            "index": 114,
            "title": "20VC: Musk's $TRN Pay Package Broken Down | Ramp Hits $1BN ARR and Brex Hits $700M: Who Wins | OpenAI's $10BN Secondary Sale | Atlassian Buys The Browser Company for $610M | ASML Lead Roun into Mistral at $14BN Valuation",
            "pub_date": "2025-09-11T07:07:00.000Z",
            "duration": "01:27:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "mistral"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-musks-trn-pay-package-broken-down-ramp-hits-1bn-arr-and-brex-hits-700m-who-wins-openais-10bn-secondary-sale-atlassian-buys-the-browser-company-for-610m-asml-lead-roun-into-mistral-at-14bn-valuation",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_Ep.22.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a82e976-dc16-48d0-9fd9-bb41d82c1549",
            "index": 115,
            "title": "20VC: ElevenLabs Hits $200M ARR: The Untold Story of Europe's Fastest Growing AI Startup | The Real Cost of AI from Talent to Data Centres | How US VCs are in a Different League to Europeans | The Future of Foundation Models with Mati Staniszewski",
            "pub_date": "2025-09-08T07:07:00.000Z",
            "duration": "01:14:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agents",
              "openai",
              "anthropic",
              "ai startup"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-elevenlabs-hits-200m-arr-the-untold-story-of-europes-fastest-growing-ai-startup-the-real-cost-of-ai-from-talent-to-data-centres-how-us-vcs-are-in-a-different-league-to-europeans-the-future-of-foundation-models-with-mati-staniszewski",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Updated-Mati_Staniszewski__ElevenLabs.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8b7aa62a-a35b-4967-9648-5897c8bad3da",
            "index": 116,
            "title": "20Growth: Meta CMO Alex Schultz on How All Founders Have to Change Their Marketing Playbook in a World of AI | Is AI Plateauing, What it Means if China Wins the AI Race and Why Zuck is a Generational Leader",
            "pub_date": "2025-09-05T22:35:00.000Z",
            "duration": "01:10:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-meta-cmo-alex-schultz-on-how-all-founders-have-to-change-their-marketing-playbook-in-a-world-of-ai-is-ai-plateauing-what-it-means-if-china-wins-the-ai-race-and-why-zuck-is-a-generational-leader",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Alex_Schultz__Meta_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3b8f560e-87dd-43fc-887c-2aabf058ff36",
            "index": 117,
            "title": "20VC: Anthropic Raises $13BN | Why Canva Will Not Direct List | OpenAI Buys Statsig for $1.1BN All Stock | Lovable Raising at $4BN + Vercel at $9BN: Justified or Not | Quarterly Results from SNOW, Mongo, ZOOM and more",
            "pub_date": "2025-09-04T07:07:00.000Z",
            "duration": "01:14:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "gpu"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-raises-13bn-why-canva-will-not-direct-list-openai-buys-statsig-for-11bn-all-stock-lovable-raising-at-4bn-vercel-at-9bn-justified-or-not-quarterly-results-from-snow-mongo-zoom-and-more",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP21.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ddb9a535-a544-4e4b-9333-3fbaf46d6758",
            "index": 118,
            "title": "20VC: Cohere Founder on How Cohere Compete with OpenAI and Anthropic $BNs | Why Counties Should Fund Their Own Models & the Need for Model Sovereignty | How Sam Altman Has Done a Disservice to AI with Nick Frosst",
            "pub_date": "2025-09-01T07:07:00.000Z",
            "duration": "01:07:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-cohere-founder-on-how-cohere-compete-with-openai-and-anthropic-bns-why-counties-should-fund-their-own-models-the-need-for-model-sovereignty-how-sam-altman-has-done-a-disservice-to-ai-with-nick-frosst",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Nick_Frosst__Cohere.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "85380a1f-4a90-4dd2-92ad-359100efb1bf",
            "index": 119,
            "title": "20Product: Why Most CPOs are Bad | Why You Do Not Need PMs in a World of AI | Why the Design Stage is Dead and How to Use Vibe Coding to Replace It | The Three Roles All Founders End Up Firing on Repeat with Jason James @ Tezi",
            "pub_date": "2025-08-29T07:07:00.000Z",
            "duration": "53:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-why-most-cpos-are-bad-why-you-do-not-need-pms-in-a-world-of-ai-why-the-design-stage-is-dead-and-how-to-use-vibe-coding-to-replace-it-the-three-roles-all-founders-end-up-firing-on-repeat-with-jason-james-tezi",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Jason_James__Tezi_AI.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c1602f5-fb8e-41a3-857a-e5c7aec9f77e",
            "index": 120,
            "title": "20VC: Anthropic's $10BN Round | Klarna's IPO Broken Down | Inside a16z's 72 Deal Seed Investment Machine | Martin Casado: Is Consensus Investing the Only Game | Why Satya is Chatting S*** on SaaS Apps Disappearing featuring Marc Benioff",
            "pub_date": "2025-08-28T07:07:00.000Z",
            "duration": "01:11:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropics-10bn-round-klarnas-ipo-broken-down-inside-a16zs-72-deal-seed-investment-machine-martin-casado-is-consensus-investing-the-only-game-why-satya-is-chatting-s-on-saas-apps-disappearing-featuring-marc-benioff",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_Ep.20.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98de975b-d969-416e-b7ce-a11ae92cc58e",
            "index": 121,
            "title": "20VC: Do Margins Matter in AI? | Is Defensibility Gone For Good? | Is Vertical SaaS Dead in a World of AI | What SaaS Rules Are BS and No Longer Apply in a World of AI | The Future of Venture: Why Chanel vs Walmart is BS with Byron Deeter",
            "pub_date": "2025-08-25T07:07:00.000Z",
            "duration": "01:21:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "perplexity"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-do-margins-matter-in-ai-is-defensibility-gone-for-good-is-vertical-saas-dead-in-a-world-of-ai-what-saas-rules-are-bs-and-no-longer-apply-in-a-world-of-ai-the-future-of-venture-why-chanel-vs-walmart-is-bs-with-byron-deeter",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Byron_Deeter__Bessemer_Venture_Partners.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bf37aad6-804c-43bb-9cd1-69faf9113fa7",
            "index": 122,
            "title": "20VC: Databricks at $100BN | Chamath's SPAC Revival: Peak Mania? | OpenAI Staff Cash Out Billions & Sam Altman Will Spend Trillions | CoreWeave's $11B Debt Bet & Nubank's $2.5B Profit Shocker",
            "pub_date": "2025-08-21T07:07:00.000Z",
            "duration": "01:27:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-databricks-at-100bn-chamaths-spac-revival-peak-mania-openai-staff-cash-out-billions-sam-altman-will-spend-trillions-coreweaves-11b-debt-bet-nubanks-25b-profit-shocker",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_Ep.19_1.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6343e4c6-f5e0-498a-aecb-666d06fa33b7",
            "index": 123,
            "title": "20VC: Lovable CEO Anton Osika on $120M in ARR in 7 Months | The Honest Truth About Defensibility and Unit Economics for AI Startups | The State of Foundation Models: Long Grok, Short OpenAI, Why | Replit vs Lovable vs Bolt: What Happens",
            "pub_date": "2025-08-18T07:07:00.000Z",
            "duration": "01:08:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "grok",
              "replit"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-lovable-ceo-anton-osika-on-120m-in-arr-in-7-months-the-honest-truth-about-defensibility-and-unit-economics-for-ai-startups-the-state-of-foundation-models-long-grok-short-openai-why-replit-vs-lovable-vs-bolt-what-happens",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Anton_Osika__Lovable_2.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7ee3c3a-2008-4082-9e90-e943f1d97432",
            "index": 124,
            "title": "20VC: 15 Term Sheets in 7 Days and Choosing Benchmark | Harvey vs Legora: Who Wins Legal and How to Play When You Have $600M Less Funding | Are AI Models Plateauing Today | Building a 9-9-6 Culture From Stockholm with Max Junestrand",
            "pub_date": "2025-08-15T07:07:00.000Z",
            "duration": "01:20:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-15-term-sheets-in-7-days-and-choosing-benchmark-harvey-vs-legora-who-wins-legal-and-how-to-play-when-you-have-600m-less-funding-are-ai-models-plateauing-today-building-a-9-9-6-culture-from-stockholm-with-max-junestrand",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Max_Junestrand__Legora.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "408dbf1a-926a-499d-8d6c-81e72bd05052",
            "index": 125,
            "title": "20VC: GPT5: Sam Altman's Masterplan or a Gift To Anthropic | Palantir & Shopify Crush Earnings | Monday & Datadog Perform But Hit Hard by Wall St | Should Perplexity Buy Chrome for $34.5BN |",
            "pub_date": "2025-08-14T07:07:00.000Z",
            "duration": "01:22:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "perplexity"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-gpt5-sam-altmans-masterplan-or-a-gift-to-anthropic-palantir-shopify-crush-earnings-monday-datadog-perform-but-hit-hard-by-wall-st-should-perplexity-buy-chrome-for-345bn",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_18.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed3eff7d-496a-469d-8ae8-ef9880c3560b",
            "index": 126,
            "title": "20VC: Figma, Scale, Wiz: Inside Index's Decacorn Factory | Decision-Making, Investment Process, Biggest Lessons, Biggest Misses | Why Gross Margin is a Fallacy at Seed | Never Turn Down a Deal on Price with Martin Mignot, Partner @ Index Ventures",
            "pub_date": "2025-08-11T07:07:00.000Z",
            "duration": "01:19:50",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-figma-scale-wiz-inside-indexs-decacorn-factory-decision-making-investment-process-biggest-lessons-biggest-misses-why-gross-margin-is-a-fallacy-at-seed-never-turn-down-a-deal-on-price-with-martin-mignot-partner-index-ventures",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Martin_Mignot__Index_Ventures.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8b2e3af0-0bc3-40a2-8339-6b486f3581a7",
            "index": 127,
            "title": "20VC: The $BN Greenoaks Backed Protein Bar | Hitting $100M Revenues in David's First Year: Lessons & Mistakes | $0 to $600M: The Untold RXBAR Story | Product-Market-Fit, Pricing, Branding: What Every Founder Gets Wrong Today with Peter Rahal",
            "pub_date": "2025-08-08T07:07:00.000Z",
            "duration": "01:06:15",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-bn-greenoaks-backed-protein-bar-hitting-100m-revenues-in-davids-first-year-lessons-mistakes-0-to-600m-the-untold-rxbar-story-product-market-fit-pricing-branding-what-every-founder-gets-wrong-today-with-peter-rahal",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Peter_Rahal__David_Protein.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f1dc2e88-c2d3-4a85-8e70-002c470ef0a5",
            "index": 128,
            "title": "20VC: Figma's 250% Pop - The Greatest IPO Mispricing Ever | Meta and Microsoft Blowout Quarters: Broken Down | Cognition Raises at $15BN and Ramp at $22BN | CRV Downsizing and What It Means for LPs and GPs",
            "pub_date": "2025-08-07T07:07:00.000Z",
            "duration": "01:20:30",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-figmas-250-pop-the-greatest-ipo-mispricing-ever-meta-and-microsoft-blowout-quarters-broken-down-cognition-raises-at-15bn-and-ramp-at-22bn-crv-downsizing-and-what-it-means-for-lps-and-gps",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP17.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2800696a-bb55-47d0-a9ef-24bf56f8e4da",
            "index": 129,
            "title": "20Sales: $0-$3.7BN: The Databricks CRO's Playbook to Build the Fastest GTM Engine in SaaS History | How Databricks Beat Snowflake | How To Build a Sales Org of 5,000 and Close $190M Deals with Ron Gabrisko",
            "pub_date": "2025-08-04T18:13:00.000Z",
            "duration": "01:15:36",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-0-4bn-the-databricks-cros-playbook-to-build-the-fastest-gtm-engine-in-saas-history-how-databricks-beat-snowflake-how-to-build-a-sales-org-of-5000-and-close-190m-deals-with-ron-gabrisko",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Ron_Gabrisko__Databricks.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f454def3-f13e-4e7d-8278-36e315161a2a",
            "index": 130,
            "title": "20VC: Inside Carnegie Mellon's $4BN Endowment | Why 90% of LPs Shouldn't Invest in VC | The $140BN Problem with Multi-Stage Funds | The Hidden Math Behind DPI, TVPI, and Illiquidity with Miles Dieffenbach",
            "pub_date": "2025-08-04T07:07:00.000Z",
            "duration": "01:27:17",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-inside-carnegie-mellons-4bn-endowment-why-90-of-lps-shouldnt-invest-in-vc-the-140bn-problem-with-multi-stage-funds-the-hidden-math-behind-dpi-tvpi-and-illiquidity-with-miles-dieffenbach",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Miles_Dieffenbach__Carnegie_Mellon_University.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d863c4f-431c-42e6-80be-c4e3a5719488",
            "index": 131,
            "title": "20VC: Benchmark Loses Another Partner | Elad Gil Raises a Monster $1.5BN Solo GP Fund | Why Apple Need a Management Overhaul | Why Google is the Best Performing Hyperscaler | Will Cursor Hit $4BN ARR & Lovable $400M ARR by EOY 2026?",
            "pub_date": "2025-07-31T07:07:00.000Z",
            "duration": "01:21:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "cursor",
              "github copilot",
              "coding",
              "copilot"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-benchmark-loses-another-partner-elad-gil-raises-a-monster-15bn-solo-gp-fund-why-apple-need-a-management-overhaul-why-google-is-the-best-performing-hyperscaler-will-cursor-hit-4bn-arr-lovable-400m-arr-by-eoy-2026",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP16_Releveled.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "116ccff5-9336-4d72-8501-8a0a5205b3e7",
            "index": 132,
            "title": "20VC: a16z's Martin Casado on Anthropic vs OpenAI: Where Value Accrues | Cursor vs Replit vs Lovable: Who Wins and Who Loses | The One Sin in AI Investing | Why Open Source is a National Security Risk with China",
            "pub_date": "2025-07-28T07:07:00.000Z",
            "duration": "01:10:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "cursor",
              "replit"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-a16zs-martin-casado-on-anthropic-vs-openai-where-value-accrues-cursor-vs-replit-vs-lovable-who-wins-and-who-loses-the-one-sin-in-ai-investing-why-open-source-is-a-national-security-risk-with-china",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Martin_Casado__a16z.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3ee781b-376f-4b76-8ec6-c7f519f05ae0",
            "index": 133,
            "title": "20Product: Should We Kill the PM Role Entirely | How Does Product Design Change Most in a World of AI | How Do Monzo Build Product Today: What Works, What Does Not | Why Most Product Sucks and What Makes Truly Great Product",
            "pub_date": "2025-07-27T09:49:00.000Z",
            "duration": "01:07:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-should-we-kill-the-pm-role-entirely-how-does-product-design-change-most-in-a-world-of-ai-how-do-monzo-build-product-today-what-works-what-does-not-why-most-product-sucks-and-what-makes-truly-great-product",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Fernando_Fanton__Monzo_-_20Product.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66363053-5963-4ae8-892c-9cc2a279fcef",
            "index": 134,
            "title": "20VC: Lovable Raises at $2BN & Hits $100M ARR | Is Cursor Worth $28BN at $1BN in ARR | How Do All Providers Deal with Anthropic Dependency Risk | Are Seed Funds F******: Have Mega Funds Won | Figma IPO Breakdown: Where Does it Price?",
            "pub_date": "2025-07-24T07:07:00.000Z",
            "duration": "01:21:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "perplexity",
              "cursor",
              "replit"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-lovable-raises-at-2bn-hits-100m-arr-is-cursor-worth-28bn-at-1bn-in-arr-how-do-all-providers-deal-with-anthropic-dependency-risk-are-seed-funds-f-have-mega-funds-won-figma-ipo-breakdown-where-does-it-price",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Trio_EP15.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5316d3e-1a4e-494f-9a98-58983b5c3085",
            "index": 135,
            "title": "20VC: Scaling to $1BN+ in Revenue with No Funding: Surge AI | The Most Insane Scaling Story in Tech |",
            "pub_date": "2025-07-21T07:07:00.000Z",
            "duration": "01:06:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-scaling-to-1bn-in-revenue-with-no-funding-surge-ai-the-most-insane-scaling-story-in-tech",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Edwin_Chen__Surge_AI.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "202de0c8-b809-48ec-a578-0bce3faab04e",
            "index": 136,
            "title": "20VC: Cognition CEO Scott Wu on Acquiring Windsurf: The Process, The Deal, The Rationale | Did Google Overlook a Goldmine in the Core Asset and Did Founders Leave a Sinking Ship | How Cursor and Cognition Deal with Ever Increasing Reliance on Anthropic",
            "pub_date": "2025-07-18T07:07:00.000Z",
            "duration": "48:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agents",
              "openai",
              "anthropic",
              "cursor",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-cognition-ceo-scott-wu-on-acquiring-windsurf-the-process-the-deal-the-rationale-did-google-overlook-a-goldmine-in-the-core-asset-and-did-founders-leave-a-sinking-ship-how-cursor-and-cognition-deal-with-ever-increasing-reliance-on-anthropic",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Scott_Wu__Cognition_AI.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4d7e89e2-e2c1-463e-9eb7-4817028bbbfa",
            "index": 137,
            "title": "20VC: Windsurf x Google x Cognition: Full Breakdown: Who Made Money, Who Did Not | Lovable vs Replit: Will These Be $100BN Businesses | Why Elon Could Beat Sam Altman with the New Grok | Why Every S&P 500 Company Will Buy Bitcoin?",
            "pub_date": "2025-07-17T07:07:00.000Z",
            "duration": "01:21:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "llama",
              "grok",
              "cursor",
              "replit"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-windsurf-x-google-x-cognition-full-breakdown-who-made-money-who-did-not-lovable-vs-replit-will-these-be-100bn-businesses-why-elon-could-beat-sam-altman-with-the-new-grok-why-every-sp-500-company-will-buy-bitcoin",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP14.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d6807c3c-1e30-41f4-83eb-d653e5f20e64",
            "index": 138,
            "title": "20VC: Vlad Tenev on Robinhood's $85BN Resurgence | Tokenizing SpaceX & OpenAI | Building Nine Revenue Lines Over $100M | Why Crypto Will Be Robinhood's Biggest Revenue Line | Why Stablecoins Will Replace Banking Rails",
            "pub_date": "2025-07-14T07:07:00.000Z",
            "duration": "57:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-vlad-tenev-on-robinhoods-85bn-resurgence-tokenizing-spacex-openai-building-nine-revenue-lines-over-100m-why-crypto-will-be-robinhoods-biggest-revenue-line-why-stablecoins-will-replace-banking-rails",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Vlad_Tenev__Robinhood.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "008cebf4-46ee-471a-9d61-c18bdca7035e",
            "index": 139,
            "title": "20Growth: The Death of Growth Teams? | How Hubspot Use AI to Triple Email Conversion | The Future of AI SEO | Why Prompt Engineering is the New Coding | What Every CMO Needs to Know About AI in 2025",
            "pub_date": "2025-07-11T12:54:00.000Z",
            "duration": "01:15:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-the-death-of-growth-teams-how-hubspot-use-ai-to-triple-email-conversion-the-future-of-ai-seo-why-prompt-engineering-is-the-new-coding-what-every-cmo-needs-to-know-about-ai-in-2025",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Kieran_Flanagan__Hubspot.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52cf2b5c-4c63-46ec-ae8d-774f3a519e9d",
            "index": 140,
            "title": "20VC: Daniel Gross and Nat Friedman: Acquired by Meta | OpenAI's SBC Bombshell: More Stock Comp Than Revenue | Privat Equity is Back: Olo Bought for $2BN | Microsoft Lays Off 9,000 People: Is This Just the Start | Will Sequoia Part with Shaun Maguire",
            "pub_date": "2025-07-10T07:07:00.000Z",
            "duration": "01:07:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "cursor"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-daniel-gross-and-nat-friedman-acquired-by-meta-openais-sbc-bombshell-more-stock-comp-than-revenue-privat-equity-is-back-olo-bought-for-2bn-microsoft-lays-off-9000-people-is-this-just-the-start-will-sequoia-part-with-shaun-maguire",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP13.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b3ded063-ad06-4748-a865-2559da1e196b",
            "index": 141,
            "title": "20VC: Scott Galloway on Are Billionaires Happy & The Impact of Money on Psychology and Self-Worth | Becoming a Better Father & Husband | Why We Should Drink More and Not Work From Home | The Tinder Effect & How it Makes Young Men Radical",
            "pub_date": "2025-07-07T07:07:00.000Z",
            "duration": "01:10:50",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-scott-galloway-on-are-billionaires-happy-the-impact-of-money-on-psychology-and-self-worth-becoming-a-better-father-husband-why-we-should-drink-more-and-not-work-from-home-the-tinder-effect-how-it-makes-young-men-radical",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Scott_Galloway.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "08faf5d4-77f2-41f9-be6a-016363327147",
            "index": 142,
            "title": "20VC: Figma's IPO: The Full Breakdown | Index Returns $3.5BN on Two Deals | Why Melio's $2.5BN Acquisition is \"Discouraging\" | Asana's New CEO and the Great Founder Exodus | Oracle's $30BN AI Deal and What it Means for Incumbents",
            "pub_date": "2025-07-03T07:07:00.000Z",
            "duration": "01:11:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-figmas-ipo-the-full-breakdown-index-returns-35bn-on-two-deals-why-melios-25bn-acquisition-is-discouraging-asanas-new-ceo-and-the-great-founder-exodus-oracles-30bn-ai-deal-and-what-it-means-for-incumbents",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP12.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2639671f-4f99-4561-a987-9ddcb4032a3a",
            "index": 143,
            "title": "20VC: Inside KKR's Monster $8BN European Fund | The $500M Turkey Gamble That Went Wrong | Do Andreessen & General Catalyst Scare KKR? | Will AI Kill the PE Model? | Can The PE Model Survive without IPOs and Where is the Liquidity with Philip Freise",
            "pub_date": "2025-06-30T07:07:00.000Z",
            "duration": "01:01:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-inside-kkrs-monster-8bn-european-fund-the-500m-turkey-gamble-that-went-wrong-do-andreessen-general-catalyst-scare-kkr-will-ai-kill-the-pe-model-can-the-pe-model-survive-without-ipos-and-where-is-the-liquidity-with-philip-freise",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Philipp_Freise__KKR.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bf5fa78e-df4c-45d4-b0d3-d3f0d2a6be40",
            "index": 144,
            "title": "20Sales: How to Layer Enterprise Sales on PLG | How to Sell AI Tools To Enterprises That Are Scared | Should Reps Own Their Own Pipeline | Mistakes All Founders Make When Moving From Founder-Led to Rep-Led Sales with Kim Graves",
            "pub_date": "2025-06-27T17:32:00.000Z",
            "duration": "01:17:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-how-to-layer-enterprise-sales-on-plg-how-to-sell-ai-tools-to-enterprises-that-are-scared-should-reps-own-their-own-pipeline-mistakes-all-founders-make-when-moving-from-founder-led-to-rep-led-sales-with-kim-graves",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Kim_Graves3.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66dfbcf5-0ecf-42a0-bc0a-ccd70c71f2d9",
            "index": 145,
            "title": "20VC: Nat Friedman and Daniel Gross Bought with Zuck's $100BN AI Budget | Navan Files to Go Public and Canva Pulls the Brakes: Why and What Happens | Why Larry Ellison is the Smartest Man in Tech | Substance or Sizzle: What is Real and What is BS in AI",
            "pub_date": "2025-06-26T07:07:00.000Z",
            "duration": "01:13:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-nat-friedman-and-daniel-gross-bought-with-zucks-100bn-ai-budget-navan-files-to-go-public-and-canva-pulls-the-brakes-why-and-what-happens-why-larry-ellison-is-the-smartest-man-in-tech-substance-or-sizzle-what-is-real-and-what-is-bs-in-ai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP11.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "92ddc757-8a62-4c0c-a831-d4da0272bc42",
            "index": 146,
            "title": "20VC: The Wild Story Raising $450M From Masa and Softbank | Why My Biggest Mistakes Came From Listening to VCs | Why 100 VCs Turned Us Down | Why European Founders Are Tougher Than US Founders with Johannes Reck, GetYourGuide",
            "pub_date": "2025-06-23T10:53:00.000Z",
            "duration": "01:16:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-wild-story-raising-450m-from-masa-and-softbank-why-my-biggest-mistakes-came-from-listening-to-vcs-why-100-vcs-turned-us-down-why-european-founders-are-tougher-than-us-founders-with-johannes-reck-getyourguide",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Johannes_Reck__GetYourGuide.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "693c2982-8f7a-4919-8bb4-a43e5ecfc8e9",
            "index": 147,
            "title": "20Product: How Duolingo Build Product 10x Faster with AI | Duolingo's Biggest Lessons on Paywalls, Push Notifications and In-App Purchases | Why Small Teams are the Future of Product | Why PMs Will Become Extinct with Cem Kansu, CPO @ Duolingo",
            "pub_date": "2025-06-20T13:41:00.000Z",
            "duration": "01:19:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-how-duolingo-build-product-10x-faster-with-ai-duolingos-biggest-lessons-on-paywalls-push-notifications-and-in-app-purchases-why-small-teams-are-the-future-of-product-why-pms-will-become-extinct-with-cem-kansu-cpo-duolingo",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Cem_Kansu__Duolingo.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af29fce8-580f-4ebc-b026-3d25eb3e4081",
            "index": 148,
            "title": "20VC: Scale's $14.8BN Acquisition: Is Scale a Dead Man Walking / What Did Meta Buy | Chime IPO: Are IPOs Hotter Than Ever | Ramp Hits $16BN Diluting Only 1% | Salesforce, Slack and Dropbox Falling Behind: Are Incumbents Losing Ground",
            "pub_date": "2025-06-19T07:07:00.000Z",
            "duration": "01:06:44",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-scales-148bn-acquisition-is-scale-a-dead-man-walking-what-did-meta-buy-chime-ipo-are-ipos-hotter-than-ever-ramp-hits-16bn-diluting-only-1-salesforce-slack-and-dropbox-falling-behind-are-incumbents-losing-ground",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP10.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc83ec90-c2e5-440b-b27d-c9714b2c8f2f",
            "index": 149,
            "title": "20VC: How We Made $800M on Coursera | We Lost Money on Uber and Made Money on Lyft | We Did 3x on Postmates in 18 Months | DPI is King, MOIC is BS | We Dodged Theranos and I Still Lost Millions with Larry Aschebrook @ G Squared",
            "pub_date": "2025-06-16T07:07:00.000Z",
            "duration": "01:34:40",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-how-we-made-800m-on-coursera-we-lost-money-on-uber-and-made-money-on-lyft-we-did-3x-on-postmates-in-18-months-dpi-is-king-moic-is-bs-we-dodged-theranos-and-i-still-lost-millions-with-larry-aschebrook-g-squared",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Larry__GSquared.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d679fb2c-3f84-4521-996c-9444c89ca5ee",
            "index": 150,
            "title": "20VC: SpaceX, Tesla, Neuralink: Elon's Empire After the Firestorm | Are Circle and Coreweave Meme Stocks: IPO Analysis | Anduril Raises $2.6BN & Becomes Founders Fund's 1st and 2nd Largest Check Ever | Cursor Now 20% of SaaS Spend and the SaaS Slowdown",
            "pub_date": "2025-06-12T07:07:00.000Z",
            "duration": "01:16:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-spacex-tesla-neuralink-elons-empire-after-the-firestorm-are-circle-and-coreweave-meme-stocks-ipo-analysis-anduril-raises-26bn-becomes-founders-funds-1st-and-2nd-largest-check-ever-cursor-now-20-of-saas-spend-and-the-saas-slowdown",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP09.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3741fdcc-f8e2-405f-956a-99ca4ecd6879",
            "index": 151,
            "title": "20VC: Fiverr CEO: 'If You're Not Adapting to AI, F* You. You're Done | Why \"Time to Copy\" is the Most Important Metric in Startups Today | Why 99% of AI Companies Today Will Die | Why Governments Will Take Control of AI with Micha Kauffman",
            "pub_date": "2025-06-09T07:07:00.000Z",
            "duration": "01:06:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-fiverr-ceo-if-youre-not-adapting-to-ai-f-you-youre-done-why-time-to-copy-is-the-most-important-metric-in-startups-today-why-99-of-ai-companies-today-will-die-why-governments-will-take-control-of-ai-with-micha-kauffman",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Micha_Kaufman__Fiverr.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "81e3dd8a-7dc8-4373-b7ce-8a89f0540277",
            "index": 152,
            "title": "20VC: The Science of Storytelling: Three Steps to Master the Perfect Story | From Near Death Experience to Unicorn Startup: The Untold Story of Omaze with Matt Pohlson",
            "pub_date": "2025-06-06T07:07:00.000Z",
            "duration": "01:25:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-science-of-storytelling-three-steps-to-master-the-perfect-story-from-near-death-experience-to-unicorn-startup-the-untold-story-of-omaze-with-matt-pohlson",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Matthew_Pohlson__Omaze.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5aa2fa9-1a38-4783-9252-c873520d1cac",
            "index": 153,
            "title": "20VC: Is Chamath Right: Is DPI The Only Thing That Matters | Does OpenAI Even Matter | Mary Meekers AI Report: The Analysis| IPO Breakdown: Chime, Circle & Thoma Bravo's New Fund",
            "pub_date": "2025-06-05T07:07:00.000Z",
            "duration": "01:23:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-is-chamath-right-is-dpi-the-only-thing-that-matters-does-openai-even-matter-mary-meekers-ai-report-the-analysis-ipo-breakdown-chime-circle-thoma-bravos-new-fund",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP08.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68995989-d201-4b4d-84ff-15f02810b096",
            "index": 154,
            "title": "20VC: Windsurf Founder on Will Model Companies Own the App Layer | Why Moats Do Not Exist in a World of AI | Why the Notion of Single Person $BN Companies is BS | Lovable vs Bolt & Cursor vs Windsurf: How Does it All End with Varun Mohan",
            "pub_date": "2025-06-02T07:07:00.000Z",
            "duration": "01:05:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-windsurf-founder-on-will-model-companies-own-the-app-layer-why-moats-do-not-exist-in-a-world-of-ai-why-the-notion-of-single-person-bn-companies-is-bs-lovable-vs-bolt-cursor-vs-windsurf-how-does-it-all-end-with-varun-mohan",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Varun_Mohan__Windsurf.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "773eeaf0-3c43-4bd7-97b0-9f8c8bd68647",
            "index": 155,
            "title": "20Sales: From $2M ARR to $40M ARR: The Playbook | How to Use AI To Supercharge Your Sales Team | Why Pipeline Reviews are BS | The Sales Call Script that Closes 99% of Prospects and How to Hire the Best Sales Reps with Kyle Norton, CRO @ Owner",
            "pub_date": "2025-05-30T07:07:00.000Z",
            "duration": "01:18:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-from-2m-arr-to-40m-arr-the-playbook-how-to-use-ai-to-supercharge-your-sales-team-why-pipeline-reviews-are-bs-the-sales-call-script-that-closes-99-of-prospects-and-how-to-hire-the-best-sales-reps-with-kyle-norton-cro-owner",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Kyle_Norton__Owner.com.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75957c13-9d99-47c3-ad24-7b15ebe6de2f",
            "index": 156,
            "title": "20VC: OpenAI's $6BN Jony Ive Deal | YC Is Both Chanel and Walmart—and Has Officially Won | Builder.ai Implodes and Hinge IPOs: Who Wins & Who Loses | Seed Is Easy. Series A Is Brutal & The Dirty Truth About Late-Stage Venture",
            "pub_date": "2025-05-29T07:07:00.000Z",
            "duration": "01:19:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-openais-6bn-jony-ive-deal-yc-is-both-chanel-and-walmartand-has-officially-won-builderai-implodes-and-hinge-ipos-who-wins-who-loses-seed-is-easy-series-a-is-brutal-the-dirty-truth-about-late-stage-venture",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP07.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "296d0e1d-6ff1-4e31-9177-02fb33a79d2f",
            "index": 157,
            "title": "20VC: The Most Insane Story in Startups: Airwallex: The Angel That Turned $1M into $1BN | The Fund That Pulled a Term Sheet & Lost $1BN | Rejecting Stripe's $1.2BN Offer | Scaling to $1BN in Revenue & 100% YoY Growth for 8 Years with Jack Zhang",
            "pub_date": "2025-05-27T11:09:00.000Z",
            "duration": "01:26:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-most-insane-story-in-startups-airwallex-the-angel-that-turned-1m-into-1bn-the-fund-that-pulled-a-term-sheet-lost-1bn-rejecting-stripes-12bn-offer-scaling-to-1bn-in-revenue-100-yoy-growth-for-8-years-with-jack-zhang",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Jack_Zhang__Airwallex.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5d84440-eb8e-4d9c-a108-116c1a1f48a1",
            "index": 158,
            "title": "20VC: ElevenLabs Head of Growth on Why You Do Not Need PMs | The 7-Part Launch Playbook That Gets 700K+ Views Per Product | The Truth About CAC, Payback & Performance Marketing in AI with Luke Harries",
            "pub_date": "2025-05-23T07:07:00.000Z",
            "duration": "01:15:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-elevenlabs-head-of-growth-on-why-you-do-not-need-pms-the-7-part-launch-playbook-that-gets-700k-views-per-product-the-truth-about-cac-payback-performance-marketing-in-ai-with-luke-harries",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Luke_Harries__ElevenLabs.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b0207d1-8b6b-4874-a808-aa9168eb0e69",
            "index": 159,
            "title": "20VC: Chime IPO: The Breakdown | Why Fund Returners Are Not Enough & Seed is for Suckers | Are IPOs Dead & The Future of the Late Stage Private Market | Rippling vs. Deel Lawsuit: WTF Happens Now?",
            "pub_date": "2025-05-22T07:07:00.000Z",
            "duration": "01:17:53",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-chime-ipo-the-breakdown-why-fund-returners-are-not-enough-seed-is-for-suckers-are-ipos-dead-the-future-of-the-late-stage-private-market-rippling-vs-deel-lawsuit-wtf-happens-now",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_FINAL_EP06.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b1e9e00-9377-4165-afd7-64dd87d29468",
            "index": 160,
            "title": "20VC: Duolingo Co-Founder on Why $3M is Harder than $100M to Raise | Why You Should Always Take Tier 1 VCs Even at Worse Terms | Why Europe Can't Win Unless the US Screws Up | How AI Impacts the Future of Work and Education with Severin Hacker",
            "pub_date": "2025-05-19T07:07:00.000Z",
            "duration": "01:31:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "cursor"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-duolingo-co-founder-on-why-3m-is-harder-than-100m-to-raise-why-you-should-always-take-tier-1-vcs-even-at-worse-terms-why-europe-cant-win-unless-the-us-screws-up-how-ai-impacts-the-future-of-work-and-education-with-severin-hacker",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Severin_Hacker__Duolingo.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3b1562ad-0772-46e0-aab2-21aa289c4c57",
            "index": 161,
            "title": "20Product: Figma CPO on How Figma Builds Products: What Works, What Does Not | How Figma Does Testing and Product Reviews | The Future of Design, Engineering and Product with Yuhki Yamashita",
            "pub_date": "2025-05-16T07:07:00.000Z",
            "duration": "01:01:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor",
              "coding"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-figma-cpo-on-how-figma-builds-products-what-works-what-does-not-how-figma-does-testing-and-product-reviews-the-future-of-design-engineering-and-product-with-yuhki-yamashita",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Yuhki_Yamashita__Figma.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8d0ea45-0536-41b9-aeff-cb2998c488f8",
            "index": 162,
            "title": "20VC: Tiger Global Saved by OpenAI | Coatue's New Fund: Hype or Substance | Why SBF is the Greatest Investor of the Last 5 Years | Why Big Funds are Investing in Perplexity",
            "pub_date": "2025-05-15T07:07:00.000Z",
            "duration": "01:14:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "perplexity"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-tiger-global-saved-by-openai-coatues-new-fund-hype-or-substance-why-sbf-is-the-greatest-investor-of-the-last-5-years-why-big-funds-are-investing-in-perplexity",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP05__Jason_Rory_Harry.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d01cd86-1462-4691-928d-3d16f9a5c1c9",
            "index": 163,
            "title": "20VC Exclusive: Mercury Founder Launches First $26M Fund | Why Founders Should Take the Highest Price | Why Serial Entrepreneurs are Better | Why AI Is So Overhyped | The Future of Venture Capital with Immad Akhund",
            "pub_date": "2025-05-12T07:07:00.000Z",
            "duration": "01:02:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-exclusive-mercury-founder-launches-first-26m-fund-why-founders-should-take-the-highest-price-why-serial-entrepreneurs-are-better-why-ai-is-so-overhyped-the-future-of-venture-capital-with-immad-akhund",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Immad_Akhund_Founder__Mercury.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c91ce4bc-1735-417a-a3e8-25c9c964c65e",
            "index": 164,
            "title": "20VC: Four Traits of the Most Successful Founders | How to Hunt and Close Talent Like a Pro and Where All Founders Go Wrong | Lessons Raising $397M From the Best Investors in the World with Eléonore Crespo @ Pigment",
            "pub_date": "2025-05-09T11:28:00.000Z",
            "duration": "01:09:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-four-traits-of-the-most-successful-founders-how-to-hunt-and-close-talent-like-a-pro-and-where-all-founders-go-wrong-lessons-raising-397m-from-the-best-investors-in-the-world-with-elonore-crespo-pigment",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Eleonore_Crespo__Pigment.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "557213a4-3c4e-4f7b-888b-b1e1de54d6c6",
            "index": 165,
            "title": "20VC: Benchmark vs a16z: Why Stage Specific Firms Win | Windsurf Sells For $3BN | Decagon Raises at 100x ARR | Do Mega Funds Win the Future of VC | What Does Harvard's Losing Their For-Profit Status Mean for VC",
            "pub_date": "2025-05-07T07:07:00.000Z",
            "duration": "01:11:34",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-benchmark-vs-a16z-why-stage-specific-firms-win-windsurf-sells-for-3bn-decagon-raises-at-100x-arr-do-mega-funds-win-the-future-of-vc-what-does-harvards-losing-their-for-profit-status-mean-for-vc",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP04-_Mega_Funds_Windsurf_Ai_Future.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b1a67d3f-50db-4a8e-abcb-666b423c074e",
            "index": 166,
            "title": "20VC Exclusive: Why Mega Platforms Will Win in VC | Why You Cannot Do VC If You Do Not Do Pre-Seed | Why Market Sizing is BS | Where Will Foundation Models Build/Buy Apps vs Where Will They Not with Bucky Moore",
            "pub_date": "2025-05-05T13:10:00.000Z",
            "duration": "01:05:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-mega-platforms-will-win-in-vc-why-you-cannot-do-vc-if-you-do-not-do-pre-seed-why-market-sizing-is-bs-where-will-foundation-models-buildbuy-apps-vs-where-will-they-not-with-bucky-moore",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Bucky_Moore_General_Partner__Lightspeed_Venture_Partners.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6fd9fd1d-16af-462d-9d3b-f29553d82a90",
            "index": 167,
            "title": "20Sales: Sierra: Inside Silicon Valley's Fastest Growing Sales Machine & How to Prospect, Outbound and Close Enterprise Deals in AI",
            "pub_date": "2025-05-02T17:58:00.000Z",
            "duration": "01:07:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-sierra-inside-silicon-valleys-fastest-growing-sales-machine-how-to-prospect-outbound-and-close-enterprise-deals-in-ai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Updated-Reggie_Marable__Sierra.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9122312-2c97-45e4-828d-e53471c791c1",
            "index": 168,
            "title": "20VC: Why Fund Returners Are Not Enough Anymore | Why Sequoia Had the Best Strategy at the Worst Time | What it Takes to Be Good at Series A and B Today | Benchmark Leads Manus Round: Should US Funds Invest in Chinese AI",
            "pub_date": "2025-05-01T07:07:00.000Z",
            "duration": "01:24:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-fund-returners-are-not-enough-anymore-why-sequoia-had-the-best-strategy-at-the-worst-time-what-it-takes-to-be-good-at-series-a-and-b-today-benchmark-leads-manus-round-should-us-funds-invest-in-chinese-ai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Trio_EP03__Jason_Rory_Fabrice.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "caf842f5-9d5c-4483-9cdd-d51a06c67c64",
            "index": 169,
            "title": "20VC: VCs are Spreadsheet Monkeys and are Commoditised | Why Fees and Carry Misalign GPs and LPs | Why Founders Will Realise Multi-Stage Funds Damage Seed Rounds | Why We Need European Sovereignty More Than Ever with Taavet Hinrikus",
            "pub_date": "2025-04-28T07:07:00.000Z",
            "duration": "58:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-vcs-are-spreadsheet-monkeys-and-are-commoditised-why-fees-and-carry-misalign-gps-and-lps-why-founders-will-realise-multi-stage-funds-damage-seed-rounds-why-we-need-european-sovereignty-more-than-ever-with-taavet-hinrikus",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Taavet_Hinrikus__Plural.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d78c64ea-a310-46c8-8c9d-5071674cb574",
            "index": 170,
            "title": "20Growth: Inside Kraken's $1.5BN Growth Playbook: What Works, What Doesn't and What No Founders Understand About Growth That Will Change Their Company with Mayur Gupta",
            "pub_date": "2025-04-25T07:07:00.000Z",
            "duration": "52:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-inside-krakens-15bn-growth-playbook-what-works-what-doesnt-and-what-no-founders-understand-about-growth-that-will-change-their-company-with-mayur-gupta",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_Mayur_Gupta__Kraken.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ee3e19b8-cab1-4a4b-bd34-60e297215438",
            "index": 171,
            "title": "20VC: OpenAI's $3BN Acquisition of Windsurf: The Breakdown | Are Endowment Funds F******* & How LP Deployment to Venture Will Change in 2025 | Why Revenue Multiples are BS, The Rise of AI Rollups and Multi-Stage Funds Destroying Seed Investing",
            "pub_date": "2025-04-24T07:07:00.000Z",
            "duration": "01:25:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-openais-3bn-acquisition-of-windsurf-the-breakdown-are-endowment-funds-f-how-lp-deployment-to-venture-will-change-in-2025-why-revenue-multiples-are-bs-the-rise-of-ai-rollups-and-multi-stage-funds-destroying-seed-investing",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_The_Trio_EP02-_Rory_Jason_Harry.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5fc5f03a-99bf-4fc5-9eb6-a0ee077ce531",
            "index": 172,
            "title": "20VC: Do Rich Founders Make Better Founders | The Best Performing Fund Would Only Back YC Founders on Their Second Time | Why SPACs Will Come Back | Why Short Sellers Should Be Banned | Is Trump Better for Business than Biden with Jason Wilk @ Dave",
            "pub_date": "2025-04-21T12:45:00.000Z",
            "duration": "58:35",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-do-rich-founders-make-better-founders-the-best-performing-fund-would-only-back-yc-founders-on-their-second-time-why-spacs-will-come-back-why-short-sellers-should-be-banned-is-trump-better-for-business-than-biden-with-jason-wilk-dave",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Jason_Wilk_Founder__CEO__Dave.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "219390e0-e576-44c5-ba4a-d1db19c44c41",
            "index": 173,
            "title": "20VC: Foundation Models: Who Wins & Who Loses | How Economies and Labour Markets Need to Change in a World of AI | China vs the US in an AI Race: What You Need to Know | Rich Socher, Founder @ You.com",
            "pub_date": "2025-04-18T14:40:00.000Z",
            "duration": "01:03:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "claude",
              "gemini",
              "ai startup"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-foundation-models-who-wins-who-loses-how-economies-and-labour-markets-need-to-change-in-a-world-of-ai-china-vs-the-us-in-an-ai-race-what-you-need-to-know-rich-socher-founder-youcom",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Richard_Socher__You.com.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6fc39600-c352-4201-9d39-99a9cf11ebf4",
            "index": 174,
            "title": "20VC: Why Seed is for Suckers | a16z's $20BN Fund & Founders Fund's $4.6BN: What Makes Them So Good | Why Josh Kushner Is the Master of Venture Capital Strategy | Why Extended Private Markets Screw US Citizens with Jason Lemkin and Rory O'Driscoll",
            "pub_date": "2025-04-17T07:07:00.000Z",
            "duration": "01:29:27",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "openai",
              "cursor"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-seed-is-for-suckers-a16zs-20bn-fund-founders-funds-46bn-what-makes-them-so-good-why-josh-kushner-is-the-master-of-venture-capital-strategy-why-extended-private-markets-screw-us-citizens-with-jason-lemkin-and-rory-odriscoll",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Rory__ScaleVP__Jason__SaaStr.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "394664e7-f3b0-4cac-a7ec-7543e2396559",
            "index": 175,
            "title": "20VC: Benchmark's Victor Lazarte on Why Portfolio Construction is BS| Why SaaS Spreadsheet Investing is Dead | Why China is a Stabilising Force for the US | Three Traits All the Best Founders Have & The Lie All Big Tech Companies Have Been Telling",
            "pub_date": "2025-04-14T07:07:00.000Z",
            "duration": "01:07:13",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-benchmarks-victor-lazarte-on-why-portfolio-construction-why-saas-spreadsheet-investing-is-dead-why-china-is-a-stabailising-force-for-the-us-three-traits-all-the-best-founders-have-the-lie-all-big-tech-companies-have-been-telling",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Victor_Lazarte__Benchmark.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8dc9c7ab-0e63-4136-a889-1d5161a17a4a",
            "index": 176,
            "title": "20Product: How Scale AI and Harvey Build Product | Why PMs Are Wrong: They are not the CEOs of the Product | How to do Pre and Post Mortems Effectively and How to Nail PRDs | The Future of Product Management in a World of AI with Aatish Nayak",
            "pub_date": "2025-04-11T07:07:00.000Z",
            "duration": "01:05:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-how-scale-ai-and-harvey-build-product-why-pms-are-wrong-they-are-not-the-ceos-of-the-product-how-to-do-pre-and-post-mortems-effectively-and-how-to-nail-prds-the-future-of-product-management-in-a-world-of-ai-with-aatish-nayak",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product-_Aatish_Nayak__Harvey.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "43cf1b10-3585-4741-bf93-e3dbc4ad440c",
            "index": 177,
            "title": "20VC: How to Fix the UK Tech Ecosystem | Why We Need to Flood the UK with Venture Capital | What the UK Can Learn From Sequoia, Stripe and Norway | Why Now is the Time to be Bullish on China & Lessons from Jensen Huang with Tom Hulme & Stan Boland",
            "pub_date": "2025-04-10T07:07:00.000Z",
            "duration": "01:24:58",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-how-to-fix-the-uk-tech-ecosystem-why-we-need-to-flood-the-uk-with-venture-capital-what-the-uk-can-learn-from-sequoia-stripe-and-norway-why-now-is-the-time-to-be-bullish-on-china-lessons-from-jensen-huang-with-tom-hulme-stan-boland",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Stan_Boland__Icera__Tom_Hulme.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2645a72-be4a-4a93-8ca9-5817505b4395",
            "index": 178,
            "title": "20VC: Carvana CEO on Buiding a $50B Company, Losing 99% and Coming Back | Ernest Garcia: Inside the Mind of the Most Misunderstood CEO in America",
            "pub_date": "2025-04-07T07:07:00.000Z",
            "duration": "01:06:41",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-carvana-ceo-on-buiding-a-50b-company-losing-99-and-coming-back-ernest-garcia-inside-the-mind-of-the-most-misunderstood-ceo-in-america",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Ernest_Garcia__Carvana.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "47e591c5-b2e6-4ea9-b8d2-32bda0bf2278",
            "index": 179,
            "title": "20VC: Why To Win in AI, Investors Need to Change Their Approach | Why VC is Run by Principals and Associates and is a Broken System | The Bull Case for Anthropic & Whether Deepseek Changes Their Strategy with Nabeel Hyatt @ Spark Capital",
            "pub_date": "2025-04-04T10:01:00.000Z",
            "duration": "01:15:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-to-win-in-ai-investors-need-to-change-their-approach-why-vc-is-run-by-principals-and-associates-and-is-a-broken-system-the-bull-case-for-anthropic-whether-deepseek-changes-their-strategy-with-nabeel-hyatt-spark-capital",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Updated_-0_Nabeel_Hyatt__Spark.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c6ac6760-4306-400b-9709-1519145c2d45",
            "index": 180,
            "title": "20Sales: How the Best Sales Teams Use AI to Win Enterprise Deals | Sales Teams Will Be Dramatically Smaller | How to Ramps Sales Reps Way Faster | Why Unpaid Design Partners are BS | Why this Generation of Sales is Soft with Ishan Mukherjee @ Rox",
            "pub_date": "2025-04-04T07:07:00.000Z",
            "duration": "01:09:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics",
              "enterprise ai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-how-the-best-sales-teams-use-ai-to-win-enterprise-deals-sales-teams-will-be-dramatically-smaller-how-to-ramps-sales-reps-way-faster-why-unpaid-design-partners-are-bs-why-this-generation-of-sales-is-soft-with-ishan-mukherjee-rox",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales-_Ishan_Mukherjee__Rox.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69018bc0-4d51-44c1-885d-75b2113a1c55",
            "index": 181,
            "title": "20VC: The Daily Deal: Coreweave IPO | Scale Hits $25BN on $2BN EOY Revenue | Sequoia's 25x Return on Wiz | Tech Stocks Tank with Tariffs | Cursor: Defensible or Dangerous Example of Lost Moats in Tech",
            "pub_date": "2025-04-03T18:02:00.000Z",
            "duration": "01:27:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "cursor",
              "replit",
              "chips"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-daily-deal-coreweave-ipo-scale-hits-25bn-on-2bn-eoy-revenue-sequoias-25x-return-on-wiz-tech-stocks-tank-with-tariffs-cursor-defensible-or-dangerous-example-of-lost-moats-in-tech",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/The_Daily_Deal_Ep.01.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "55c39cb3-bd2c-4996-b7fa-49b53444b093",
            "index": 182,
            "title": "20VC: Microsoft CTO on Where Value Accrues in an AI World | Why Scaling Laws are BS | An Evaluation of Deepseek and How We Underestimate the Chinese | The Future of Software Development and The Future of Agents with Kevin Scott",
            "pub_date": "2025-03-31T07:07:00.000Z",
            "duration": "45:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-microsoft-cto-on-where-value-accrues-in-an-ai-world-why-scaling-laws-are-bs-an-evaluation-of-deepseek-and-how-we-underestimate-the-chinese-the-future-of-software-development-and-the-future-of-agents-with-kevin-scott",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Kevin_Scott_CTO__Microsoft.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e8f02dc0-f4ac-4d65-98f8-1b1c33e9498f",
            "index": 183,
            "title": "20VC: Will Revolut and Monzo List in the UK | How Does London Compete Against the US To Win The Best UK IPOs | Are UK Public Companies Punished on Price for Listing in London | The Myths and the Reality of The London Stock Exchange with CEO, Julia Hoggett",
            "pub_date": "2025-03-28T07:07:00.000Z",
            "duration": "50:14",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-will-revolut-and-monzo-list-in-the-uk-how-does-london-compete-against-the-us-to-win-the-best-uk-ipos-are-uk-public-companies-punished-on-price-for-listing-in-london-the-myths-and-the-reality-of-the-london-stock-exchange-with-ceo-julia-hoggett",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-Julia_Hoggett_CEO_of_The_London_Stock_Exchange.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "924ce159-bfea-4966-b3b5-9eb7e89fc9d4",
            "index": 184,
            "title": "20VC: Why Traditional VC is Broken: How VCs Learned Nothing from 2021 | Why LPs are More Important than Founders & Advice to Emerging Managers | Bull Case for Bytedance & Why TikTok's Ban Doesn't Matter with Mitchell Green, Lead Edge Capital",
            "pub_date": "2025-03-28T00:00:00.000Z",
            "duration": "01:19:26",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-traditional-vc-is-broken-how-vcs-learned-nothing-from-2021-why-lps-are-more-important-than-founders-advice-to-emerging-managers-bull-case-for-bytedance-why-tiktoks-ban-doesnt-matter-with-mitchell-green-lead-edge-capital",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Updated_-_Mitchell_Green__Lead_Edge_Capital.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc224d88-16b7-4388-8d15-8b8730917801",
            "index": 185,
            "title": "20VC: The Insane Story of DeliveryHero: Losing $200M on a Gorillas Investment | Winning the Emerging Markets Delivery War with 35 Acquisitions | Competing with Uber and Doordash in a Capital Arms Race with Niklas Östberg",
            "pub_date": "2025-03-27T23:55:00.000Z",
            "duration": "01:01:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-insane-story-of-deliveryhero-losing-200m-on-a-gorillas-investment-winning-the-emerging-markets-delivery-war-with-35-acquisitions-competing-with-uber-and-doordash-in-a-capital-arms-race-with-niklas-stberg",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Updated_-_Niklas_Ostberg__Delivery_Hero.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5389c360-81c5-41bc-92b0-00795f7e1d50",
            "index": 186,
            "title": "20VC: AI Chip Wars: How Cerebras Plans to Topple NVIDIA's Dominance | Why We Have Not Reached Scaling Laws in AI | What Happens to the Cost of Inference | How We Underestimate China and Shouldn't Sell To Them with Andrew Feldman",
            "pub_date": "2025-03-24T07:07:00.000Z",
            "duration": "01:03:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "chip",
              "inference",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-ai-chip-wars-how-cerebras-plans-to-topple-nvidias-dominance-why-we-have-not-reached-scaling-laws-in-ai-what-happens-to-the-cost-of-inference-how-we-underestimate-china-and-shouldnt-sell-to-them-with-andrew-feldman",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Andrew_Feldman__Cerebras.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1245e859-52b8-4420-b51e-764b8c9dd836",
            "index": 187,
            "title": "20VC: Selling Drift for $1.2BN is the Biggest Failure: What No One Tells You About Selling Your Company | Why Incumbents Are Slower & Worse Than Ever | Why the Most Valuable Companies in a World of AI Will Not Have More Than 100 People with Elias Torres",
            "pub_date": "2025-03-21T11:37:00.000Z",
            "duration": "01:07:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-selling-drift-for-12bn-is-the-biggest-failure-what-no-one-tells-you-about-selling-your-company-why-incumbents-are-slower-worse-than-ever-why-the-most-valuable-companies-in-a-world-of-ai-will-not-have-more-than-100-people-with-elias-torres",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Elias_Torres__Agency.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5ee6691-6181-4cb9-a1be-fa98963976fa",
            "index": 188,
            "title": "20VC: The 10 Question Framework a $217BN Manager Uses to Make Investment Decisions | Lessons from Turning Down Stripe, Coinbase and Losing Money on Northvault | The Bull Case for Bytedance | How Anduril Could Be a $200BN Company with Peter Singlehurst",
            "pub_date": "2025-03-19T07:07:00.000Z",
            "duration": "01:11:40",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-10-question-framework-a-217bn-manager-uses-to-make-investment-decisions-lessons-from-turning-down-stripe-coinbase-and-losing-money-on-northvault-the-bull-case-for-bytedance-how-anduril-could-be-a-200bn-company-with-peter-singlehurst",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Peter_Singlehurst__Baillie_Gifford.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f0ee6bd3-5a7d-4d62-8bc2-60bd530a3f18",
            "index": 189,
            "title": "20VC: HubSpot CEO on Where Value Accrues in SaaS AI | How HubSpot Competes Against Salesforce | Why B2B Is Not a Winner Take All Market | How to Go From SMB to Enterprise an Win | How SEO Dying Changes HubSpot's Business with Yamini Rangan",
            "pub_date": "2025-03-18T16:11:00.000Z",
            "duration": "55:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-hubspot-ceo-on-where-value-accrues-in-saas-ai-how-hubspot-competes-against-salesforce-why-b2b-is-not-a-winner-take-all-market-how-to-go-from-smb-to-enterprise-an-win-how-seo-dying-changes-hubspots-business-with-yamini-rangan",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Yamini_Rangan__HubSpot.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "93e8619c-6bed-44ae-96e5-61bea44fd2ae",
            "index": 190,
            "title": "20Product: How to Design and Build Products in a World of Agents | Why AI Will Kill Many SaaS Products | What Products Will Thrive and Die in a World of 100M Developers with Matt Biilmann, Co-Founder and CEO @ Netlify",
            "pub_date": "2025-03-14T07:07:00.000Z",
            "duration": "49:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-how-to-design-and-build-products-in-a-world-of-agents-why-ai-will-kill-many-saas-products-what-products-will-thrive-and-die-in-a-world-of-100m-developers-with-matt-biilmann-co-founder-and-ceo-netlify",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Matt_Biilmann__Netlify.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65e181b8-711b-40fa-851a-c9b2eedd8198",
            "index": 191,
            "title": "20VC: Lessons from Investing $2BN and Returning $8BN in Cash | Why Most Venture Partnerships are Broken | We Sold Salesforce Early and Lost Out on Billions | Are The Best Deals Always Expensive and Competitive with Jake Saper @ Emergence Capital",
            "pub_date": "2025-03-10T07:07:00.000Z",
            "duration": "01:28:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "grok"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-lessons-from-investing-2bn-and-returning-8bn-in-cash-why-most-venture-partnerships-are-broken-we-sold-salesforce-early-and-lost-out-on-billions-are-the-best-deals-always-expensive-and-competitive-with-jake-saper-emergence-capital",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Jake_Saper__Emergence_Capital.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17087847-da5b-4734-b1ea-b981ec040b02",
            "index": 192,
            "title": "20Sales: Everything You Know About Sales Playbooks is Wrong | How to Hire and Train Your First Sales Hires | How to Crush Pipeline and Deal Reviews as a Team | How to Structure Sales Teams and Sales Comp Plans with Julian Teixeira, CRO @ 1Password",
            "pub_date": "2025-03-07T07:07:00.000Z",
            "duration": "51:52",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-everything-you-know-about-sales-playbooks-is-wrong-how-to-hire-and-train-your-first-sales-hires-how-to-crush-pipeline-and-deal-reviews-as-a-team-how-to-structure-sales-teams-and-sales-comp-plans-with-julian-teixeira-cro-1password",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales-_Julian_Teixeira_CRO__1Password.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c07ecbf1-50e6-446d-82d0-13c87c0c3199",
            "index": 193,
            "title": "20VC: Lovable on Hitting $17.5M in ARR in 3 Months | Adding $2.1M ARR Every Week | Hitting 85% Day 30 Retention: Better than ChatGPT | The Story of Europe's Fastest Scaling Company with Anton Osika",
            "pub_date": "2025-03-05T07:07:00.000Z",
            "duration": "50:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "grok"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-lovable-on-hitting-175m-in-arr-in-3-months-adding-21m-arr-every-week-hitting-85-day-30-retention-better-than-chatgpt-the-story-of-europes-fastest-scaling-company-with-anton-osika",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Anton_Osika__Lovable.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1e774a37-8112-4c0b-b52e-71b49767fc87",
            "index": 194,
            "title": "20VC: Anthropic CPO Mike Krieger: Where Will Value Be Created in a World of AI | Have Foundation Models Commoditized | When Do Model Providers Become Application Providers | What Anthropic Learned from Deepseek",
            "pub_date": "2025-03-03T07:07:00.000Z",
            "duration": "01:06:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anthropic-cpo-mike-krieger-where-will-value-be-created-in-a-world-of-ai-have-foundation-models-commoditized-when-do-model-providers-become-application-providers-what-anthropic-learned-from-deepseek",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Mike_Krieger__Anthropic.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22849d95-e211-404f-aa84-e4802835d2e1",
            "index": 195,
            "title": "20Growth: Inside Ramp's Growth Engine: How Ramp Became the Fastest Growing SaaS Company Ever | What Worked & What Did Not Work | How to Hire for Growth | How to Find Alpha in Channels Where No One Else Can with George Bonaci",
            "pub_date": "2025-02-28T07:07:00.000Z",
            "duration": "55:21",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-inside-ramps-growth-engine-how-ramp-became-the-fastest-growing-saas-company-ever-what-worked-what-did-not-work-how-to-hire-for-growth-how-to-find-alpha-in-channels-where-no-one-else-can-with-george-bonaci",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_George_Bonaci__Ramp.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c3e647f-ef82-4187-9cc0-d7b56a356039",
            "index": 196,
            "title": "20VC: The Insane Story of Glovo: Selling 30% of the Company for €100K | The McDonalds Deal That Saved Them | Running out of Money Three Times | Burning $1M Per Day | Being Acquired for $2.2BN with Oscar Pierre, Founder @ Glovo",
            "pub_date": "2025-02-26T07:07:00.000Z",
            "duration": "01:07:27",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-insane-story-of-glovo-selling-30-of-the-company-for-100k-the-mcdonalds-deal-that-saved-them-running-out-of-money-three-times-burning-1m-per-day-being-acquired-for-22bn-with-oscar-pierre-founder-glovo",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Oscar_Pierre__Glovo.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8364959-7c73-44fd-bfb1-975253371be3",
            "index": 197,
            "title": "20VC: Why Google Will Win the AI Arms Race & OpenAI Will Not | NVIDIA vs AMD: Who Wins and Why | The Future of Inference vs Training | The Economics of Compute & Why To Win You Must Have Product, Data & Compute with Steeve Morin @ ZML",
            "pub_date": "2025-02-24T07:07:00.000Z",
            "duration": "01:12:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "chips",
              "data center",
              "inference",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-google-will-win-the-ai-arms-race-openai-will-not-nvidia-vs-amd-who-wins-and-why-the-future-of-inference-vs-training-the-economics-of-compute-why-to-win-you-must-have-product-data-compute-with-steeve-morin-zml",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Steeve_Morin_Founder__ZML.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e0c4c807-7859-46c1-95ff-4a35d1a8fd73",
            "index": 198,
            "title": "20VC Exclusive: Mercor Raises $100M at a $2BN Valuation: Scaling to $70M in ARR in 24 Months | 9-9-6: 9AM-9PM - 6 Days Per Week: The Most Intense Culture in Silicon Valley | The Future of Programming, Models and Data with Adarsh Hiremath",
            "pub_date": "2025-02-20T07:07:00.000Z",
            "duration": "45:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-exclusive-mercor-raises-100m-at-a-2bn-valuation-scaling-to-70m-in-arr-in-24-months-9-9-6-9am-9pm-6-days-per-week-the-most-intense-culture-in-silicon-valley-the-future-of-programming-models-and-data-with-adarsh-hiremath",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Adarsh_Hiremath__Mercor.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9d5ffd7e-42a4-4ec0-8192-8f8657b36a2b",
            "index": 199,
            "title": "20VC: NVIDIA vs Groq: The Future of Training vs Inference | Meta, Google, and Microsoft's Data Center Investments: Who Wins | Data, Compute, Models: The Core Bottlenecks in AI & Where Value Will Distribute with Jonathan Ross, Founder @ Groq",
            "pub_date": "2025-02-17T07:07:00.000Z",
            "duration": "01:20:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "data center",
              "inference",
              "training",
              "eval"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-nvidia-vs-groq-the-future-of-training-vs-inference-meta-google-and-microsofts-data-center-investments-who-wins-data-compute-models-the-core-bottlenecks-in-ai-where-value-will-distribute-with-jonathan-ross-founder-groq",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Jonathan_Ross_Founder__CEO__Groq.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d2e27119-b76c-401d-9990-6468be0cea36",
            "index": 200,
            "title": "20VC: From Penniless Printing Shop Offices to Public Company and One of the Largest Entertainment Companies: The Story of LADbible | The Future of Content & Social Media | US vs Europe: Is Europe F****** with Solly Solomou",
            "pub_date": "2025-02-14T07:07:00.000Z",
            "duration": "59:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-from-penniless-printing-shop-offices-to-public-company-and-one-of-the-largest-entertainment-companies-the-story-of-ladbible-the-future-of-content-social-media-us-vs-europe-is-europe-f-with-solly-solomou",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Solly_Solomou_Founder__CEO__LADbible.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "74ac815d-6274-4b46-9065-0b63c58e5beb",
            "index": 201,
            "title": "20VC: Monzo: The Greatest Turnaround in Tech: From £40M Revenues, Layoffs, Downrounds and Low Employee NPS to $1BN in Revenue, Profitable and 10M Customers with TS Anil, CEO @ Monzo",
            "pub_date": "2025-02-13T17:54:00.000Z",
            "duration": "56:15",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-monzo-the-greatest-turnaround-in-tech-from-40m-revenues-layoffs-downrounds-and-low-employee-nps-to-1bn-in-revenue-profitable-and-10m-customers-with-ts-anil-ceo-monzo",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/TS_FINAL.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd38f9ff-08af-4b05-a5a4-dd52dc01b159",
            "index": 202,
            "title": "20VC: The $5BN Company Built from the Belgian Countryside | The Story of Odoo: The Company with No Plans to Sell, IPO & Their Billionaire Founder Who Does Not Care About Money with Fabien Pinckaers, Founder & CEO @ Odoo",
            "pub_date": "2025-02-12T07:07:00.000Z",
            "duration": "01:15:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-5bn-company-built-from-the-belgian-countryside-the-story-of-odoo-the-company-with-no-plans-to-sell-ipo-their-billionaire-founder-who-does-not-care-about-money-with-fabien-pinckaers-founder-ceo-odoo",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Fabien_Pinckaers_Founder__CEO__Odoo.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b2acf0c1-4162-4d56-aa0e-517178d92cbf",
            "index": 203,
            "title": "20VC: Why Model Providers Will Kill Many Startups Moving into the Application Layer | Why Deepseek is not a Threat to OpenAI & Why OpenAI Beats Anthropic | Apps vs Models vs Infrastructure: Where is Value in AI with Sridhar Ramaswamy, Snowflake CEO",
            "pub_date": "2025-02-10T07:07:00.000Z",
            "duration": "55:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-model-providers-will-kill-many-startups-moving-into-the-application-layer-why-deepseek-is-not-a-threat-to-openai-why-openai-beats-anthropic-apps-vs-models-vs-infrastructure-where-is-value-in-ai-with-sridhar-ramaswamy-snowflake-ceo",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Sridhar_Ramaswamy_CEO__Snowflake.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a5241b1a-68b1-4f5c-a0aa-b382e0570ae1",
            "index": 204,
            "title": "20Product: Product Secrets Behind Uber and Opendoor | How AI Changes the Role of the PM & The Product Development Process | How to Hire the Best Product Teams & What No One Does That Everyone Should Do with Brian Tolkin",
            "pub_date": "2025-02-07T07:07:00.000Z",
            "duration": "44:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-product-secrets-behind-uber-and-opendoor-how-ai-changes-the-role-of-the-pm-the-product-development-process-how-to-hire-the-best-product-teams-what-no-one-does-that-everyone-should-do-with-brian-tolkin",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Prouct-_Brian_Tolkin_Head_of_Product__Opendoor.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0cf64684-a208-4ba5-add5-bcf67bf11907",
            "index": 205,
            "title": "20VC: Affirm Max Levchin on Why Grading Talent by Letter (A or B) is Total BS | How to Create a Culture of Post Mortems and Writing | Why You Should Only Study Failure Not Success & The Biggest Surprises Scaling to $18.7BN Market Cap",
            "pub_date": "2025-02-05T11:55:00.000Z",
            "duration": "01:02:25",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-affirm-max-levchin-on-why-grading-talent-by-letter-a-or-b-is-total-bs-how-to-create-a-culture-of-post-mortems-and-writing-why-you-should-only-study-failure-not-success-the-biggest-surprises-scaling-to-187bn-market-cap",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Max_Levchin__Affirm.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90fae46b-72ca-4772-a837-fc29bef49249",
            "index": 206,
            "title": "20VC: Lime's CEO on Going from Losing $3 on Every $1 to $90M in EBITDA | How Lime Built the Global Leader in Micromobility When Competitors Went Bust | Losing 90% of Revenues in COVID and The Uber Deal That Saved the Company with Wayne Ting",
            "pub_date": "2025-01-30T12:10:00.000Z",
            "duration": "01:06:14",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-limes-ceo-on-going-from-losing-3-on-every-1-to-90m-in-ebitda-how-lime-built-the-global-leader-in-micromobility-when-competitors-went-bust-losing-90-of-revenues-in-covid-and-the-uber-deal-that-saved-the-company-with-wayne-ting",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Wayne_Ting__Lime.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66f6e80e-2881-4510-b7ed-df557e3d5bda",
            "index": 207,
            "title": "20VC: Deepseek Special: Is Deepseek a Weapon of the CCP | How Should OpenAI and the US Government Respond | Why $500BN for Stargate is Not Enough | The Future of Inference, NVIDIA and Foundation Models with Jonathan Ross @ Groq",
            "pub_date": "2025-01-30T12:06:00.000Z",
            "duration": "55:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "chip",
              "inference",
              "eval"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-deepseek-special-is-deepseek-a-weapon-of-the-ccp-how-should-openai-and-the-us-government-respond-why-500bn-for-stargate-is-not-enough-the-future-of-inference-nvidia-and-foundation-models-with-jonathan-ross-groq",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Deepseek_Special_with_Jonathan_Ross.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9f43e2f-f074-4256-a05f-acdb5ac505df",
            "index": 208,
            "title": "20Sales: Why Every Sales Rep Should Do Pipeline Generation & How to Teach Them | Verticalised Sales Playbooks: When and How | How the Best Sales Reps and Leaders Structure Their Time with Carlos Delatorre, CRO @ Harness",
            "pub_date": "2025-01-24T07:07:00.000Z",
            "duration": "01:08:24",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-why-every-sales-rep-should-do-pipeline-generation-how-to-teach-them-verticalised-sales-playbooks-when-and-how-how-the-best-sales-reps-and-leaders-structure-their-time-with-carlos-delatorre-cro-harness",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales-_Carlos_Delatorre_CRO__Harness.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48b4a59d-e12c-4fe0-a37a-a06ebf39ce0a",
            "index": 209,
            "title": "20VC: Why All AI Companies Are Under-Valued | The Future of Foundation Models: Scaling Laws, Generalised vs Specialised, Commoditised? | From Unable to Afford Rent to Raising $130M From Index and Peter Thiel with George Sivulka @ Hebbia",
            "pub_date": "2025-01-22T07:08:00.000Z",
            "duration": "01:06:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-all-ai-companies-are-under-valued-the-future-of-foundation-models-scaling-laws-generalised-vs-specialised-commoditised-from-unable-to-afford-rent-to-raising-130m-from-index-and-peter-thiel-with-george-sivulka-hebbia",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_George_Sivulka__Hebbia.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77ba2e1f-cebf-427d-bb5a-9b79e357ae3d",
            "index": 210,
            "title": "20VC: Why Large Seed Rounds Increase the Chances of Success | When to Sell in Venture | Why Multi-Stage Firms Do Not Do The Work | Is Europe Totally F****** and Why AI Means London Can Compete with the US with Hussein Kanji",
            "pub_date": "2025-01-20T07:07:00.000Z",
            "duration": "01:17:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-large-seed-rounds-increase-the-chances-of-success-when-to-sell-in-venture-why-multi-stage-firms-do-not-do-the-work-is-europe-totally-f-and-why-ai-means-london-can-compete-with-the-us-with-hussein-kanji",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Hussein_Kanji__Hoxton_Ventures.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ccda9df6-7cce-4d62-8759-1cd9aa92f77c",
            "index": 211,
            "title": "20VC: Monday.com: Scaling from $6M to $120M in ARR in 3 Years | How Monday Have Built the Best Performance Marketing Engine in SaaS | Going Upmarket, International and Multi-Product; The Biggest Lessons and Mistakes with Eran Zinman",
            "pub_date": "2025-01-17T07:07:00.000Z",
            "duration": "55:15",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-mondaycom-scaling-from-6m-to-120m-in-arr-in-3-years-how-monday-have-built-the-best-performance-marketing-engine-in-saas-going-upmarket-international-and-multi-product-the-biggest-lessons-and-mistakes-with-eran-zinman",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Eran_Zinman_Co-Founder__Co-CEO__Monday.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "206947be-80bc-4538-bf81-d76b7a39393e",
            "index": 212,
            "title": "20VC: Why Scaling Laws Will Not Continue | OpenAI vs Anthropic vs X.ai: Who Wins and Why | How Far Will Model Providers Go Into the Application Layer | The End State for Models: Many Specialised or Few Generalised with Victor Riparbelli @ Synthesia",
            "pub_date": "2025-01-15T07:07:00.000Z",
            "duration": "01:11:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-scaling-laws-will-not-continue-openai-vs-anthropic-vs-xai-who-wins-and-why-how-far-will-model-providers-go-into-the-application-layer-the-end-state-for-models-many-specialised-or-few-generalised-with-victor-riparbelli-synthesia",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Victor_Riparbelli__Synthesia.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "150c8a9f-eade-4fb2-821a-f768db2a49d9",
            "index": 213,
            "title": "20VC: Shervin Pishevar on The Epic Uber War and What Really Happened in the Firing of Travis Kalanick | Raising $15BN to Win China | Why The Traditional Venture Capital Model is Dead | The Future of Quantum and How We Will Cure All Diseases in 10 Years",
            "pub_date": "2025-01-13T07:07:00.000Z",
            "duration": "01:12:44",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-shervin-pishevar-on-the-epic-uber-war-and-what-really-happened-in-the-firing-of-travis-kalanick-raising-15bn-to-win-china-why-the-traditional-venture-capital-model-is-dead-the-future-of-quantum-and-how-we-will-cure-all-diseases-in-10-years",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Shervin_Pishevar.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3663af49-0223-4786-a9f0-ae370ebf8f12",
            "index": 214,
            "title": "20VC: The Future of Foundation Models | The Future of AI Consumer Apps and Why OpenAI Did a Disservice to Them | The Future of Music: Spotify vs YouTube & Spotify vs TikTok: What Happens with Mikey Shulman @ Suno",
            "pub_date": "2025-01-10T07:07:00.000Z",
            "duration": "57:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-future-of-foundation-models-the-future-of-ai-consumer-apps-and-why-openai-did-a-disservice-to-them-the-future-of-music-spotify-vs-youtube-spotify-vs-tiktok-what-happens-with-mikey-shulman-suno",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Mikey_Shulman_Co-Founder__CEO__Suno.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35b523e7-b4d4-42cc-aac7-c7ecd8fdf8c0",
            "index": 215,
            "title": "20VC: Carvana: The Most Wild Story in Public Markets: From $60BN to $400M and Back to $40BN | The Biggest Opportunities, Mistakes and Challenges Ahead for One of the Public Market's Only 100x Investments",
            "pub_date": "2025-01-08T17:39:00.000Z",
            "duration": "01:02:43",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-carvana-the-most-wild-story-in-public-markets-from-60bn-to-400m-and-back-to-40bn-the-biggest-opportunities-mistakes-and-challenges-ahead-for-one-of-the-public-markets-only-100x-investments",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/FINAL_Dan_Gill__Carvana.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e18776ac-0169-477c-9158-54f720666962",
            "index": 216,
            "title": "20VC: How To Do a 10x Seed Fund in 2025 | Three Frameworks to Evaluate Startups an Founders | Lessons from Losing Billions Missing Airbnb and Pinterest & Investing Lessons from Charlie Munger with Mike Maples @ Floodgate",
            "pub_date": "2025-01-06T07:07:00.000Z",
            "duration": "01:10:00",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-how-to-do-a-10x-seed-fund-in-2025-three-frameworks-to-evaluate-startups-an-founders-lessons-from-losing-billions-missing-airbnb-and-pinterest-investing-lessons-from-charlie-munger-with-mike-maples-floodgate",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Mike_Maples__Floodgate.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da5f72f9-982b-4f3e-82fb-2ab85abd0a62",
            "index": 217,
            "title": "20Sales: Rippling's CRO on Why Founders Should Not Create Sales Playbooks | Why Discounting is BS and How to Create Urgency in Deals | The Biggest Lessons on Pricing and How to Win the Pricing Game with Matt Plank",
            "pub_date": "2024-12-20T07:07:00.000Z",
            "duration": "01:10:15",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-ripplings-cro-on-why-founders-should-not-create-sales-playbooks-why-discounting-is-bs-and-how-to-create-urgency-in-deals-the-biggest-lessons-on-pricing-and-how-to-win-the-pricing-game-with-matt-plank",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales-_Matt_Plank_CRO__Rippling.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "96c19486-27d2-4aa5-921e-1bf8151dad7d",
            "index": 218,
            "title": "20VC: UiPath's Daniel Dines on Why Agents Do Not Mean RPA is F***** | Why We Have Reached the Upper End of Scaling Laws | The Future of Work in an Agent World and What Everyone Misunderstands About Enterprise AI",
            "pub_date": "2024-12-18T09:41:00.000Z",
            "duration": "58:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "xai",
              "enterprise ai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-uipaths-daniel-dines-on-why-agents-do-not-mean-rpa-is-f-why-we-have-reached-the-upper-end-of-scaling-laws-the-future-of-work-in-an-agent-world-and-what-everyone-misunderstands-about-enterprise-ai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Daniel_Dines__UiPath.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7f2e771-4484-4c2c-87aa-216f890dc6d7",
            "index": 219,
            "title": "20VC: Reid Hoffman on The Trump Administration | Elon Musk and DOGE | The US Defence Budget, NATO and The War in Ukraine | China, Tariffs and TikTok | The Future of Chips, Nuclear Energy, Quantum Computing and Climate",
            "pub_date": "2024-12-16T07:07:00.000Z",
            "duration": "58:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "chips"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-reid-hoffman-on-the-trump-administration-elon-musk-and-doge-the-us-defence-budget-nato-and-the-war-in-ukraine-china-tariffs-and-tiktok-the-future-of-chips-nuclear-energy-quantum-computing-and-climate",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Reid_Hoffman.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1dce5eee-b098-4843-9243-305d0ab766d7",
            "index": 220,
            "title": "20Growth: How to Scale to $30M ARR Bootstrapped through Content and Brand | The Ultimate Equation to Success in Sales and Why Most Founders Suck at Sales | Why You Should Overpay People and What That Means with Guillaume Moubeche @ Lempire",
            "pub_date": "2024-12-13T07:07:00.000Z",
            "duration": "01:12:03",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-how-to-scale-to-30m-arr-bootstrapped-through-content-and-brand-the-ultimate-equation-to-success-in-sales-and-why-most-founders-suck-at-sales-why-you-should-overpay-people-and-what-that-means-with-guillaume-moubeche-lempire",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_Guillaume_Moubeche__lempire.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1e1b981c-fefa-48c6-8720-96a900cdf112",
            "index": 221,
            "title": "20VC: The Future of War: Are We Ready & What Needs to Be Done | China, Russia and Trump: What Happens Now | Raising $828M to Build the Defence Champion of Europe | Torsten Reil, Co-Founder @ Helsing",
            "pub_date": "2024-12-11T10:03:00.000Z",
            "duration": "01:12:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-future-of-war-are-we-ready-what-needs-to-be-done-china-russia-and-trump-what-happens-now-raising-828m-to-build-the-defence-champion-of-europe-torsten-reil-co-founder-helsing",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Final.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0466dc8d-ee48-4eaa-8273-5a7c67a2d9b1",
            "index": 222,
            "title": "20VC: Salesforce Founder Marc Benioff on The Future of LLMs | The Future of Agents | The Future of Labour | Management Lessons from Steve Jobs",
            "pub_date": "2024-12-09T07:07:00.000Z",
            "duration": "43:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "xai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-salesforce-founder-marc-benioff-on-the-future-of-llms-the-future-of-agents-the-future-of-labour-management-lessons-from-steve-jobs",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Marc_Benioff_Founder__CEO__Salesforce.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "57c8383e-0925-4253-935b-6f88df95f49b",
            "index": 223,
            "title": "20VC: From Unsexy Startup to $1.8BN Acquisition | Why VCs and Founders are Fundamentally Misaligned | Why Valuations and Fundraising are BS | Lessons from Josh Kushner and Marc Andreesen | Zac Bookman, OpenGov",
            "pub_date": "2024-12-06T17:59:00.000Z",
            "duration": "01:08:06",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-from-unsexy-startup-to-18bn-acquisition-with-150m-in-arr-why-vcs-and-founders-are-fundamentally-misaligned-why-valuations-and-fundraising-are-bs-lessons-from-josh-kushner-and-marc-andreesen-zac-bookman-opengov",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Zachary_Bookman__OpenGov.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a8f0010-0ccd-40f5-88e8-d8375727a7ee",
            "index": 224,
            "title": "20VC: Revolut Founder Nik Storonsky on When and Where Revolut Will IPO & What Revolut Need to Do to Hit $100BN Valuation",
            "pub_date": "2024-12-04T17:30:00.000Z",
            "duration": "45:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-revolut-founder-nik-storonsky-on-when-and-where-revolut-will-ipo-what-revolut-need-to-do-to-hit-100bn-valuation",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/New_Ads_Nik.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "59131250-c8f1-410d-8b81-52a54149fe9f",
            "index": 225,
            "title": "20VC: Grindr: The Most Insane Story in Startups | How the Chinese Bought and Lost Grindr | The Successful IPO with $300M Revenues and 40% EBITDA Margins | How Grindr Built a Free Cash Flow Machine",
            "pub_date": "2024-12-04T07:07:00.000Z",
            "duration": "56:36",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-grindr-the-most-insane-story-in-startups-how-the-chinese-bought-and-lost-grindr-the-successful-ipo-with-300m-revenues-and-40-ebitda-margins-how-grindr-built-a-free-cash-flow-machine",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_George_Arison_CEO__Grindr.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "434d2e78-7fb9-4dc3-b4e9-eb62a62df823",
            "index": 226,
            "title": "20Product: Is an AI Winter Approaching | The Future of AI Software Development: What is Real & What is BS | OpenAI: WTF is Going on & How Far Into Application Layer Do They Go | The Future Role of Software Engineers with Guy Podjarny",
            "pub_date": "2024-11-29T09:37:00.000Z",
            "duration": "46:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-is-an-ai-winter-approaching-the-future-of-ai-software-development-what-is-real-what-is-bs-openai-wtf-is-going-on-how-far-into-application-layer-do-they-go-the-future-role-of-software-engineers-with-guy-podjarny",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Guy_Podjarny__TesslFinal.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d3930e4b-217c-441d-8eaf-2a59d9a3cf1a",
            "index": 227,
            "title": "20VC: Why Price Sensitivity is BS | Why \"Portfolios\" are Merely a Construct to Make LPs Happy | Why the Best Investment Never Happen in \"Fundraising Rounds\" | What Europe Needs to do to Become a Superpower Again | Klaus Hommels, Lakestar",
            "pub_date": "2024-11-27T07:07:00.000Z",
            "duration": "01:09:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-price-sensitivity-is-bs-why-portfolios-are-merely-a-construct-to-make-lps-happy-why-the-best-investment-never-happen-in-fundraising-rounds-what-europe-needs-to-do-to-become-a-superpower-again-klaus-hommels-lakestar",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Klaus_Hommels_Founder__Lakestar.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a51626fe-c3e7-474d-aa75-f5662fe369c9",
            "index": 228,
            "title": "20VC: Discord's Jason Citron on Why Everything We are Taught About Hiring & Management is BS | Do Richer Founders & Gamer Founders Make Better Founders? | Never Before Told Moments Behind Scaling to 200M Users",
            "pub_date": "2024-11-25T18:14:00.000Z",
            "duration": "50:33",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "alignment"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-discords-jason-citron-on-why-everything-we-are-taught-about-hiring-management-is-bs-do-richer-founders-gamer-founders-make-better-founders-never-before-told-moments-behind-scaling-to-145bn",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Jason_Citron_Co-Founder__CEO__Discord.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a477656-2a1f-4432-b5ca-cf519e5cc3f0",
            "index": 229,
            "title": "20Sales: What I Learned Scaling Datadog from $60M to $1BN in ARR | How to do Outbound in 2024 | Why Discounting is Dangerous and Contract Sizes are Misleading with Dan Fougere",
            "pub_date": "2024-11-22T07:07:00.000Z",
            "duration": "01:10:05",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-what-i-learned-scaling-datadog-from-60m-to-1bn-in-arr-how-to-do-outbound-in-2024-why-discounting-is-dangerous-and-contract-sizes-are-misleading-with-dan-fougere",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales-_Dan_Fougere_Former_CRO__Datadog.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8828d9c-3e7f-495c-8414-7d391a5b4655",
            "index": 230,
            "title": "20VC: Turning $16.5M into $2.1BN; Lessons from the Greatest Venture Investment in European History: UiPath | Why VC is Not Being Commoditised | Why Price Does Not Matter | Lessons on Loss Ratio, Selling and Signalling with Cem Sertoglu",
            "pub_date": "2024-11-20T07:07:00.000Z",
            "duration": "01:03:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-turning-165m-into-21bn-lessons-from-the-greatest-venture-investment-in-european-history-uipath-why-vc-is-not-being-commoditised-why-price-does-not-matter-lessons-on-loss-ratio-selling-and-signalling-with-cem-sertoglu",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Cem_Sertoglu_Founder__Bek_Ventures.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d6369a7-30ce-43a2-8ed7-3b89934b66c1",
            "index": 231,
            "title": "20VC Alain De Botton on Why Companies Are Not Families | Why Status is Making You Miserable | Why Parents Want Their Kids to Fail | Why We Are Richer Yet More Anxious Than Ever & Why You Should Not Always \"Be Yourself\"",
            "pub_date": "2024-11-18T07:07:00.000Z",
            "duration": "01:12:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-alain-de-botton-on-why-companies-are-not-families-why-status-is-making-you-miserable-why-parents-want-their-kids-to-fail-why-we-are-richer-yet-more-anxious-than-ever-why-you-should-not-always-be-yourself",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Alain_De_Botton.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75ff1648-cee0-4ab2-b458-b682c0c6d4d8",
            "index": 232,
            "title": "20Growth: Inside Perplexity's Growth Machine: What Worked, What Did Not Work | Why Paid Acquisition is a Drug and Brand Marketing is BS | The Good, Bad and Ugly of A/B Tests and Why Micro-Optimisations are Under-Rated with Raman Malik",
            "pub_date": "2024-11-15T07:07:00.000Z",
            "duration": "59:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "perplexity"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-inside-perplexitys-growth-machine-what-worked-what-did-not-work-why-paid-acquisition-is-a-drug-and-brand-marketing-is-bs-the-good-bad-and-ugly-of-ab-tests-and-why-micro-optimisations-are-under-rated-with-raman-malik",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_Raman_MalikHead_of_Growth__Perplexity.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3b4b693d-46c4-42fc-9f26-767ca316b63c",
            "index": 233,
            "title": "20VC: Bolt; The Most Insane Story in Startups | Turning a $5K Loan into an $8BN Company | Why Every VC Turned Down One of Europe's Biggest Winners | Competing with Uber & The Future of Micromobility and Self-Driving",
            "pub_date": "2024-11-13T07:17:00.000Z",
            "duration": "01:29:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-bolt-the-most-insane-story-in-startups-turning-a-5k-loan-into-an-8bn-company-why-every-vc-turned-down-one-of-europes-biggest-winners-competing-with-uber-the-future-of-micromobility-and-self-driving",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Markus_Villig_Co-Founder__CEO__Bolt.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a953c370-1f7d-410a-a073-cfec5e85ab0b",
            "index": 234,
            "title": "20VC: Anduril Co-Founder on How a Trump Administration Changes the Defence Industry | What Happens Between China vs Taiwan, Israel vs Palestine, Russia vs Ukraine | How Software Changes War & Why TikTok Should Be Banned with Matt Grimm",
            "pub_date": "2024-11-11T07:00:00.000Z",
            "duration": "01:23:27",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-anduril-co-founder-on-how-a-trump-administration-changes-the-defence-industry-what-happens-between-china-vs-taiwan-israel-vs-palestine-russia-vs-ukraine-how-software-changes-war-why-tiktok-should-be-banned-with-matt-grimm",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Matt_Grimm_Co-Founder__Anduril_Industries.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e1de9300-34c5-4761-b654-d17c4f6854bb",
            "index": 235,
            "title": "20VC: Sam Altman on The Trajectory of Model Capability Improvements: Will Scaling Laws Continue | Semi-Conductor Supply Chains | What Startups Will be Steamrolled by OpenAI and Where is Opportunity",
            "pub_date": "2024-11-04T07:07:00.000Z",
            "duration": "39:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agents",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-sam-altman-on-the-trajectory-of-model-capability-improvements-will-scaling-laws-continue-semi-conductor-supply-chains-what-startups-will-be-steamrolled-by-openai-and-where-is-opportunity",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Sam_Altman__OpenAI_DevDay.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "88af0143-8c3f-443e-bcb5-6a84ba3a68b3",
            "index": 236,
            "title": "20VC: Robinhood's Vlad Tenev on Founder Mode | Building 8x $100M Revenue Lines | Lessons from Raising $5BN and the Gamestop Saga | The Future of Artificial Intelligence, Wealth Management and Home Ownership",
            "pub_date": "2024-11-01T07:07:00.000Z",
            "duration": "52:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-robinhoods-vlad-tenev-on-founder-mode-building-8x-100m-revenue-lines-lessons-from-raising-5bn-and-the-gamestop-saga-the-future-of-artificial-intelligence-wealth-management-and-home-ownership",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Vladimir_Tenev__Robinhood.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ecba9619-4219-4688-8d6c-6922903cc882",
            "index": 237,
            "title": "20VC: Linear's Karri Saarinen How to be Grow Capital Efficiently in a World of BS Growth | How to Fundraise with Leverage | How to Select Investors and How to Give Them Homework in the Raise Process & Growth Lessons from Airbnb and Coinbase",
            "pub_date": "2024-10-30T07:07:00.000Z",
            "duration": "47:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-linears-karri-saarinen-how-to-be-grow-capital-efficiently-in-a-world-of-bs-growth-how-to-fundraise-with-leverage-how-to-select-investors-and-how-to-give-them-homework-in-the-raise-process-growth-lessons-from-airbnb-and-coinbase",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Karri_Saarinen__Linear.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bba96adc-5702-43d7-a107-bc2ade94bf01",
            "index": 238,
            "title": "20VC: Why SaaS is Dead | Why AI First Companies Will Win | We are in the Middle of a Cold War for AI Talent | Why Europe is F******* and We Need to Stop Whining with Daniel Khachab, Co-Founder @ Choco",
            "pub_date": "2024-10-28T14:05:00.000Z",
            "duration": "01:13:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "chip",
              "chips"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-saas-is-dead-why-ai-first-companies-will-win-we-are-in-the-middle-of-a-cold-war-for-ai-talent-why-europe-is-f-and-we-need-to-stop-whining-with-daniel-khachab-co-founder-choco",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Final_-_Daniel_Khachab__Choco.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "759723e4-4392-49b5-9561-52e504131cdf",
            "index": 239,
            "title": "20VC: The Truth About Multi-Stage Firms; Why Portfolio Services are for VCs not Founders | Why Politics is Rife & Decision-Making is Broken in Large VCs | Why Reserves are Bad for Founders & How Boutique Firms Will Win with Mark Goldberg @ Chemistry",
            "pub_date": "2024-10-25T07:07:00.000Z",
            "duration": "56:21",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-truth-about-multi-stage-firms-why-portfolio-services-are-for-vcs-not-founders-why-politics-is-rife-decision-making-is-broken-in-large-vcs-why-reserves-are-bad-for-founders-how-boutique-firms-will-win-with-mark-goldberg-chemistry",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Mark_Goldberg_Managing_Partner__Chemistry.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "07b6da84-e1c1-430f-a86d-7db2a34ee1fe",
            "index": 240,
            "title": "20Sales: Biggest Lessons Scaling Slack from $6M to $1BN in ARR | How to Build a Customer Success Machine and Where Most Go Wrong | The Framework to Hire All Sales Reps: Take-Home Assignments, Hiring Panels and more with AJ Tennant @ Glean",
            "pub_date": "2024-10-23T09:33:00.000Z",
            "duration": "01:00:40",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-biggest-lessons-scaling-slack-from-6m-to-1bn-in-arr-how-to-build-a-customer-success-machine-and-where-most-go-wrong-the-framework-to-hire-all-sales-reps-take-home-assignments-hiring-panels-and-more-with-aj-tennant-glean",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/FINAL-AJ_Tennant__Glean_SALES.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b798b144-3512-47d2-9b81-0467a89224b2",
            "index": 241,
            "title": "20VC: Kleiner Perkins' Mamoon Hamid on Investing Lessons from Leading Rounds in Figma, Slack and Rippling | Lessons Building a Generational Defining Firm with Kleiner Perkins | AI: Where Value Accrues, Startups vs Incumbents & Scaling Laws",
            "pub_date": "2024-10-21T07:08:00.000Z",
            "duration": "59:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-kleiner-perkins-mamoon-hamid-on-investing-lessons-from-leading-rounds-in-figma-slack-and-rippling-lessons-building-a-generational-defining-firm-with-kleiner-perkins-ai-where-value-accrues-startups-vs-incumbents-scaling-laws",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Mamoon_Hamid_General_Partner__Kleiner_Perkins.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "faa6d408-2cdd-4f60-b009-7a6b558f2857",
            "index": 242,
            "title": "20Growth: Revolut's Chief Growth Officer on The Growth Playbook Revolut Used to Scale to $2.2BN in Revenue | How Revolut Launch and Grow Products | Why the Best PMs Don't Need A/B Tests & Why CAC is a BS Metric with Antoine Le Nel",
            "pub_date": "2024-10-18T07:06:00.000Z",
            "duration": "56:41",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-revoluts-chief-growth-officer-on-the-growth-playbook-revolut-used-to-scale-to-22bn-in-revenue-how-revolut-launch-and-grow-products-why-the-best-pms-dont-need-ab-tests-why-cac-is-a-bs-metric-with-antoine-le-nel",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_Antoine_Le_Nel__Chief_Growth_Officer__Revolut.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "237861d3-0628-41c8-b5f5-cb2d78d04cbe",
            "index": 243,
            "title": "20VC: Why Founder Mode is Dangerous & Could Encourage Bad Behaviour | Why Fundraising is a Waste of Time & OKRs are BS | Why Angel Investing is Bad for Founders to Do and the VC Model is on it's Last Legs with Zach Perret @ Plaid",
            "pub_date": "2024-10-16T16:18:00.000Z",
            "duration": "50:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-founder-mode-is-dangerous-could-encourage-bad-behaviour-why-fundraising-is-a-waste-of-time-okrs-are-bs-why-angel-investing-is-bad-for-founders-to-do-and-the-vc-model-is-on-its-last-legs-with-zach-perret-plaid",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Final_For_Real_-_Zach_Perret__Plaid.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a7affdb1-140e-414a-a534-7ef8654584a4",
            "index": 244,
            "title": "20VC: Investing Lessons from FC Seeding Uber, Airtable and Coupang | Why Pro Rata is the Original Sin in VC | Why Liquidity Has Died in 2024 | Why LPs are Pissed with VCs | The Hard Truth About Seed Fund Economics with David Frankel @ Founder Collective",
            "pub_date": "2024-10-14T07:05:00.000Z",
            "duration": "01:27:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-investing-lessons-from-seeding-uber-airtable-and-coupang-why-pro-rata-is-the-original-sin-in-vc-why-liquidity-has-died-in-2024-why-lps-are-pissed-with-vcs-the-hard-truth-about-seed-fund-economics-with-david-frankel-founder-collective",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_David_Frankel__Founder_Collective.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e61fe0dd-2099-427a-84c1-30dd6050fb10",
            "index": 245,
            "title": "20VC: Why Most AI Investments Will Do Worse than the S&P 500 | Why Early Stage VC is F******* | The Danger of Kamala Harris and Why Trump and Vance are Best | Freedom of Speech, Censorship and Government Control with Eoghan McCabe @ Intercom",
            "pub_date": "2024-10-11T07:08:00.000Z",
            "duration": "46:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-most-ai-investments-will-do-worse-than-the-sp-500-why-early-stage-vc-is-f-the-danger-of-kamala-harris-and-why-trump-and-vance-are-best-freedom-of-speech-censorship-and-government-control-with-eoghan-mccabe-intercom",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Updated_ADS_Eoghan_McCabe__Intercom.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e40c74b8-d5ba-42b3-8268-b1c9f1340430",
            "index": 246,
            "title": "20VC: Sequoia Capital's $9BN Global Equities Fund on The Future for NVIDIA, Google & Meta | How to Play AI in the Public Markets | China & Europe: Is the Future Bleak | The Opportunity for Crossover Funds with Jeff Wang, Managing Partner @ SCGE",
            "pub_date": "2024-10-09T07:03:00.000Z",
            "duration": "01:12:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-sequoia-capitals-9bn-global-equities-fund-on-the-future-for-nvidia-google-meta-how-to-play-ai-in-the-public-markets-china-europe-is-the-future-bleak-the-opportunity-for-crossover-funds-with-jeff-wang-managing-partner-scge",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Jefff_Wang_Managing_Partner__Sequoia_Capital_Global_Equities_.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a28f3118-c1fb-428e-b6d7-ffe3346ab3a7",
            "index": 247,
            "title": "20VC: Raising $500M To Compete in the Race for AGI | Will Scaling Laws Continue: Is Access to Compute Everything | Will Nvidia Continue To Dominate | The Biggest Bottlenecks in the Race for AGI with Eiso Kant, CTO @ Poolside",
            "pub_date": "2024-10-07T13:31:00.000Z",
            "duration": "01:10:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "foundation model",
              "frontier model",
              "openai",
              "anthropic"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-raising-500m-to-compete-in-the-race-for-agi-will-scaling-laws-continue-is-access-to-compute-everything-will-nvidia-continue-to-dominate-the-biggest-bottlenecks-in-the-race-for-agi-with-eiso-kant-ceo-poolside",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Eiso_Kant_Co-Founder__Poolside.ai.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bf4cb491-5e32-47a9-9cd4-0ab2cafdd7af",
            "index": 248,
            "title": "20Product: How the Best Teams Do Product Reviews | What Everyone Gets Wrong in Hiring Product Teams | Product Lessons Leading Facebook App Monetisation Team to Billions in Revenue with Maria Angelidou, CPO @ Personio",
            "pub_date": "2024-10-04T07:15:00.000Z",
            "duration": "50:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-how-the-best-teams-do-product-reviews-what-everyone-gets-wrong-in-hiring-product-teams-product-lessons-leading-facebook-app-monetisation-team-to-billions-in-revenue-with-maria-angelidou-cpo-personio",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product-_Maria_Angelidou_CPO__Personio.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34b96e51-ca6d-4741-995a-7bf9fc9b1322",
            "index": 249,
            "title": "20VC: Bret Taylor: The AI Bubble and What Happens Now | How the Cost of Chips and Models Will Change in AI | Will Companies Build Their Own Software | Why Pre-Training is for Morons | Leaderships Lessons from Mark Zuckerberg",
            "pub_date": "2024-10-02T07:09:00.000Z",
            "duration": "01:10:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "openai",
              "chips",
              "training"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-bret-taylor-the-ai-bubble-and-what-happens-now-how-the-cost-of-chips-and-models-will-change-in-ai-will-companies-build-their-own-software-why-pre-training-is-for-morons-leaderships-lessons-from-mark-zuckerberg",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Bret_Taylor_Co-Founder__Sierra.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "49c66f03-c697-40ad-becd-c8235c4b1494",
            "index": 250,
            "title": "20VC: How SHEIN Got So Big So Fast: Behind the Scenes at One of the Fastest Growing Companies in History with Donald Tang, Executive Chairman @ SHEIN",
            "pub_date": "2024-09-30T07:10:00.000Z",
            "duration": "55:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-how-shein-got-so-big-so-fast-behind-the-scenes-at-one-of-the-fastest-growing-companies-in-history-with-donald-tang-executive-chairman-shein",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Donald_Tang_Executive_Chairman__SHEIN.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a4525cf-07f1-4630-8305-17867fafec89",
            "index": 251,
            "title": "20Sales: Scaling Hubspot from $3M to $1BN in ARR | How to Hire and Ramp Sales Teams | How to Scale Customer Success Successfully | How and When to Go International and Crush It with Jeetu Mahtani",
            "pub_date": "2024-09-27T07:15:00.000Z",
            "duration": "56:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-scaling-hubspot-from-3m-to-1bn-in-arr-how-to-hire-and-ramp-sales-teams-how-to-scale-customer-success-successfully-how-and-when-to-go-international-and-crush-it-with-jeetu-mahtani",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales-_Jeetu_Mahtani__Hubspot.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2845c8e6-c335-4b01-8e27-e04faf459ec2",
            "index": 252,
            "title": "20VC: Benchmark's Eric Vishria on Where is the Value in AI: Chips, Models or Apps | Why Nvidia Will Not Be The Only Game in Town | The Commoditisation of Foundation Models | Which AI Apps Have Sustaining Value vs Hype and Short Term Revenue",
            "pub_date": "2024-09-25T07:14:00.000Z",
            "duration": "01:02:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "nvidia",
              "chips"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-benchmarks-eric-vishria-on-where-is-the-value-in-ai-chips-models-or-apps-why-nvidia-will-not-be-the-only-game-in-town-the-commoditisation-of-foundation-models-which-ai-apps-have-sustaining-value-vs-hype-and-short-term-revenue",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Eric_Vishria_General_Partner__Benchmark_Capital.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e9812d9-9f7e-4e44-bc6d-432c09ef30f5",
            "index": 253,
            "title": "20VC: From Potato Farm to $200M in Revenue: The Never-Before-Told Story of Flo Health: Scaling to $1BN Valuation, 75M Users & Getting 100s of No's From Investors Along the Way with Dmitry Gurski",
            "pub_date": "2024-09-23T07:09:00.000Z",
            "duration": "01:25:36",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-from-potato-farm-to-200m-in-revenue-the-never-before-told-story-of-flo-health-scaling-to-1bn-valuation-75m-users-getting-100s-of-nos-from-investors-along-the-way-with-dmitry-gurski",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Dmitry_Gurski_Founder__Flo_Health.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b8ed234e-5869-47ca-90a0-a182c2ad7f72",
            "index": 254,
            "title": "20Growth: The 7 Core Levers to Win at Consumer Subscription: Growth Loops, CAC + LTV Benchmarks, Pricing, Packaging, Notifications, Discounts, Paywalls | The Breakdown with Phil Carter",
            "pub_date": "2024-09-20T07:08:00.000Z",
            "duration": "01:19:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-the-7-core-levers-to-win-at-consumer-subscription-growth-loops-cac-ltv-benchmarks-pricing-packaging-notifications-discounts-paywalls-the-breakdown-with-phil-carter",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_Phil_Carter_Faire__Ibotta.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3444dfc3-1bb8-4d09-abcb-31b8abccc8ab",
            "index": 255,
            "title": "20VC: Notion's Founder on \"Founder Mode\": When it Works & When it Doesn't | Why The Way Startups Fundraise & Construct Boards is Broken | Raising at a $10BN Valuation in Peak Bubble Times and How Notion Has More Money Than Ever Before with Akshay Kothari",
            "pub_date": "2024-09-18T07:08:00.000Z",
            "duration": "49:04",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-notions-founder-on-founder-mode-when-it-works-when-it-doesnt-why-the-way-startups-fundraise-construct-boards-is-broken-raising-at-a-10bn-valuation-in-peak-bubble-times-and-how-notion-has-more-money-than-ever-before-with-akshay-kothari",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Akshay_Kothari_Co-Founder__Notion.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "300ab8bd-15e3-4ecb-b7c0-6c03426163f9",
            "index": 256,
            "title": "20VC: Index's Shardul Shah on Why Market Size is a Trap | Biggest Lessons on Pricing from Leading Rounds in Wiz & Datadog | Why Benchmarks & Averages in VC are BS | How Index Makes Decisions and Why Growth & Early are the Same Investing Style",
            "pub_date": "2024-09-16T07:05:00.000Z",
            "duration": "50:32",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-indexs-shardul-shah-on-why-market-size-is-a-trap-biggest-lessons-on-pricing-from-leading-rounds-in-wiz-datadog-why-benchmarks-averages-in-vc-are-bs-how-index-makes-decisions-and-why-growth-early-are-the-same-investing-style",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/FINAL_-_Shardul_Shah__Index_Ventures.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2106f28-b599-42ee-9264-2c79bd8a475b",
            "index": 257,
            "title": "20Product: What Facebook, Monzo and Deliveroo Do and Do Not Do To Build Great Products | How to Structure Product Teams For Success | Is Simple Always Better in Product and The Art vs Science of Product Design with Mike Hudack",
            "pub_date": "2024-09-13T07:05:00.000Z",
            "duration": "01:06:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-what-facebook-monzo-and-deliveroo-do-and-do-not-do-to-build-great-products-how-to-structure-product-teams-for-success-is-simple-always-better-in-product-and-the-art-vs-science-of-product-design-with-mike-hudack",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product-_Mike_Hudack_Co-Founder__Sling.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8b85a828-2127-420d-9a19-2fc23e620d0c",
            "index": 258,
            "title": "20VC: Scaling ServiceNow to $5BN in ARR | Leadership Lessons from Doug Leone, Frank Slootman and Bill McDermott | VC Value Add: Is it Real and Why the Worst VCs are \"Seagull VCs\"",
            "pub_date": "2024-09-11T13:55:00.000Z",
            "duration": "01:06:23",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-scaling-servicenow-to-5bn-in-arr-leadership-lessons-from-doug-leone-frank-slootman-and-bill-mcdermott-vc-value-add-is-it-real-and-why-the-worst-vcs-are-seagull-vcs",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_David_Schneider_General_Partner__Coatue.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cbb992a8-42d9-44b5-8a87-b67c5f404afb",
            "index": 259,
            "title": "20VC: Tinder Founder Sean Rad on Lessons Scaling Tinder to the Fastest Growing Consumer Social App in History | Leadership Lessons Scaling Tinder | The Future of Love, Dating and Social Media | The Secret to Your Relationship with Money and Marriage",
            "pub_date": "2024-09-09T07:12:00.000Z",
            "duration": "01:04:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-tinder-founder-sean-rad-on-lessons-scaling-tinder-to-the-fastest-growing-consumer-social-app-in-history-leadership-lessons-scaling-tinder-the-future-of-love-dating-and-social-media-the-secret-to-your-relationship-with-money-and-marriage",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Final-Sean_Rad__Rad_Fund.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "903bab8c-c4ed-4fc6-98ea-0b8caef2bb3d",
            "index": 260,
            "title": "20VC: Why VC is a Ponzi Scheme Today | Why Most VCs are Bankers | Why Big VCs Ruin Startups | Why Incentives in VC are Broken | Why American Dynamism is a Tool for VCs to Raise Money with Nick Chirls, Asylum Ventures",
            "pub_date": "2024-09-06T07:15:00.000Z",
            "duration": "01:00:47",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-vc-is-a-ponzi-scheme-today-why-most-vcs-are-bankers-why-big-vcs-ruin-startups-why-incentives-in-vc-are-broken-why-american-dyamism-is-a-tool-for-vcs-to-raise-money-with-nick-chirls-asylum-ventures",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Nick_Chirls__Asylum_Ventures.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f0159e81-9d5e-4324-8cbe-41e68b73562e",
            "index": 261,
            "title": "20VC: OpenAI's Newest Board Member, Zico Colter on The Biggest Bottlenecks to the Performance of Foundation Models | The Biggest Questions and Concerns in AI Safety | How to Regulate an AI-Centric World",
            "pub_date": "2024-09-04T07:12:00.000Z",
            "duration": "01:00:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "frontier model",
              "openai",
              "safety"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-openais-newest-board-member-zico-colter-on-the-biggest-bottlenecks-to-the-performance-of-foundation-models-the-biggest-questions-and-concerns-in-ai-safety-how-to-regulate-an-ai-centric-world",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Zico_Colter__Carnegie_Mellon.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6156b8b4-7e04-4a03-952b-07b334f1e8b0",
            "index": 262,
            "title": "20Growth: Uber's Expansion Playbook for Scaling from 10 Cities to $10BN in Revenue | How Uber Acquired 1M Drivers | How Uber Solved the Chicken and The Egg Problem in New Markets and What Uber Would Be Like with Travis Still There with Scott Gorlick",
            "pub_date": "2024-08-30T07:10:00.000Z",
            "duration": "41:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-ubers-expansion-playbook-for-scaling-from-10-cities-to-10bn-in-revenue-how-uber-acquired-1m-drivers-how-uber-solved-the-chicken-and-the-egg-problem-in-new-markets-and-what-uber-would-be-like-with-travis-still-there-with-scott-gorlick",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/OUTGROW_UPDATE_FINAL.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3ddc4b24-7cd8-449d-9480-c0c7f78a9d7a",
            "index": 263,
            "title": "20VC: AI Scaling Myths: More Compute is not the Answer | The Core Bottlenecks in AI Today: Data, Algorithms and Compute | The Future of Models: Open vs Closed, Small vs Large with Arvind Narayanan, Professor of Computer Science @ Princeton",
            "pub_date": "2024-08-28T07:10:00.000Z",
            "duration": "51:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-ai-scaling-myths-more-compute-is-not-the-answer-the-core-bottlenecks-in-ai-today-data-algorithms-and-compute-the-future-of-models-open-vs-closed-small-vs-large-with-arvind-narayanan-professor-of-computer-science-princeton",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Arvind_Narayanan__Princeton.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aaf3c17b-50fb-4bfb-845d-44e40b57bf9f",
            "index": 264,
            "title": "20VC: Why the IPO Market is not Closed | Why Revenue Multiples are BS and Founders Need to Change | Advice From Jack Ma, Jamie Dimon and Evan Spiegel | Lessons from Taking Snap & Alibaba Public with Imran Khan",
            "pub_date": "2024-08-26T07:13:00.000Z",
            "duration": "01:04:38",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-the-ipo-market-is-not-closed-why-revenue-multiples-are-bs-and-founders-need-to-change-advice-from-jack-ma-jamie-dimon-and-evan-spiegel-lessons-from-taking-snap-alibaba-public-with-imran-khan",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Imran_Khan_Founder__Proem_Asset_Management.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1facbfbe-b955-4bbf-809f-5e2e4c870b53",
            "index": 265,
            "title": "20Sales: How Snowflake Built a Sales Machine | Why You Have to Hire a CRO Pre-Product | Why Most Sales Reps Do Not Perform | Why Hiring Panels are BS in Interviews | Why Remote Sales Reps Do Not Care About Their Development with Chad Peets",
            "pub_date": "2024-08-23T08:51:00.000Z",
            "duration": "01:03:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-how-snowflake-built-a-sales-machine-why-you-have-to-hire-a-cro-pre-product-why-most-sales-reps-do-not-perform-why-hiring-panels-are-bs-in-interviews-why-remote-sales-reps-do-not-care-about-their-development-with-chad-peets",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales-_Chad_Peets.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7c969e5-a907-4c83-99ad-5058f90d3912",
            "index": 266,
            "title": "20VC: Five Lessons Scaling Toast to $14BN Market Cap | The Biggest Mistakes Founders Make in Fundraising, Hiring and Selling with Aman Narang, CEO @ Toast",
            "pub_date": "2024-08-21T13:14:00.000Z",
            "duration": "01:03:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-five-lessons-scaling-toast-to-14bn-market-cap-the-biggest-mistakes-founders-make-in-fundraising-hiring-and-selling-with-aman-narang-ceo-toast",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Aman_Narang_Co-Founder__CEO__Toast.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b0851a0-9ff0-4d79-b7c9-4c78c3400300",
            "index": 267,
            "title": "20VC: Chips, Models or Applications; Where is the Value in AI | Is Compute the Answer to All Model Performance Questions | Why Open AI Shelved AGI & Is There Any Value in Models with OpenAI Price Dumping with Aidan, Gomez, Co-Founder @ Cohere",
            "pub_date": "2024-08-19T07:08:00.000Z",
            "duration": "58:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "chips",
              "enterprise ai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-chips-models-or-applications-where-is-the-value-in-ai-is-compute-the-answer-to-all-model-performance-questions-why-open-ai-shelved-agi-is-there-any-value-in-models-with-openai-price-dumping-with-aidan-gomez-co-founder-cohere",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Aidan_Gomez_Co-Founder__CEO__Cohere.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0894044-82ed-4d0f-b7e9-3dc35b8e16b4",
            "index": 268,
            "title": "20VC: Capital G's Laela Sturdy on What Stripe, UiPath and Duolingo Taught Me About Company Building and Investing | How to Analyse Valuation, Market Timing, Sizing and Exiting | Life Inside Alphabet's $7BN Growth Fund",
            "pub_date": "2024-08-16T07:01:00.000Z",
            "duration": "55:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-capital-gs-laela-sturdy-on-what-stripe-uipath-and-duolingo-taught-me-about-company-building-and-investing-how-to-analyse-valuation-market-timing-sizing-and-exiting-life-inside-alphabets-7bn-growth-fund",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Laela_Sturdy_Managing_Partner__CapitalG.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a20e2b90-de84-47e6-8140-d7495322963f",
            "index": 269,
            "title": "20VC: Lessons from Mark Zuckerberg, Keith Rabois & Tobi Lütke | Why Remote is a Bad Idea for 90% of Companies | The Framework for How Shopify Builds Product Today | What Humans Get Wrong About Marriage and Kids with Kaz Nejatian, COO @ Shopify",
            "pub_date": "2024-08-14T07:04:00.000Z",
            "duration": "01:03:05",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-lessons-from-mark-zuckerberg-keith-rabois-tobi-ltke-why-remote-is-a-bad-idea-for-90-of-companies-the-framework-for-how-shopify-builds-product-today-what-humans-get-wrong-about-marriage-and-kids-with-kaz-nejatian-coo-shopify",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Kaz_Nejatian_COO__Shopify.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5086dd75-2694-47bd-ae63-c935e0006aa5",
            "index": 270,
            "title": "20VC: Sequoia's Shaun Maguire: Will We See WW3 Shortly | Why DEI is a Cancer for Society | Why Iran is the World's Greatest Evil | Why Trump is the Only Hope for Peace in the Middle East | Trump vs Harris: Who Wins & What Happens",
            "pub_date": "2024-08-12T07:05:00.000Z",
            "duration": "01:03:07",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-sequoias-shaun-maguire-will-we-see-ww3-shortly-why-dei-is-a-cancer-for-society-why-iran-is-the-worlds-greatest-evil-why-trump-is-the-only-hope-for-peace-in-the-middle-east-trump-vs-harris-who-wins-what-happens",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Shaun_Maguire_Partner__Sequoia.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2c5675f3-0cb2-4cdf-b5cd-eda49d61d0a7",
            "index": 271,
            "title": "20VC: Why VC is Distorting a Generation of SaaS Companies & With $900M in ARR and a Market Cap of $2.6BN is Lightspeed the Most Misunderstood Public Company with Dax Dasilva, Founder & CEO @ Lightspeed",
            "pub_date": "2024-08-09T07:10:00.000Z",
            "duration": "46:12",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-vc-is-distorting-a-generation-of-saas-companies-with-900m-in-arr-and-a-market-cap-of-26bn-is-lightspeed-the-most-misunderstood-public-company-with-dax-dasilva-founder-ceo-lightspeed",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Dax_Dasilva_Co-Founder__CEO__Lightspeed.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bc61ffa6-a637-4744-9109-35cfca067df1",
            "index": 272,
            "title": "20VC: How a Angel City Makes $31M per Season | How Sports Teams Can and Should Be Better Businesses | Why Every Sports Team Will Look Like a Media Agency and Founding The Most Valuable Women's Sports Team with Alexis Ohanian",
            "pub_date": "2024-08-07T07:15:00.000Z",
            "duration": "01:13:14",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-how-a-angel-city-makes-31m-per-season-how-sports-teams-can-and-should-be-better-businesses-why-every-sports-team-will-look-like-a-media-agency-and-founding-the-most-valuable-womens-sports-team-with-alexis-ohanian",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Alexis_Ohanian_Angel_City_Memo.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b91447bc-9a34-4e0c-b606-356b04bef41f",
            "index": 273,
            "title": "20VC: Sequoia's David Cahn on AI's $600BN Question | Why the Data Centre is the Most Important Asset | Servers, Steel and Power: The Core Pillars Powering the Future of AI",
            "pub_date": "2024-08-05T07:13:00.000Z",
            "duration": "01:13:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "frontier model",
              "replit"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-sequoias-david-cahn-on-ais-600bn-question-why-the-data-centre-is-the-most-important-asset-servers-steel-and-power-the-core-pillars-powering-the-future-of-ai",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_David_Cahn_General_Partner__Sequoia_Capital.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "45e28996-88fa-4b8d-9766-db1c208dd4b1",
            "index": 274,
            "title": "20Sales: 12-Week Step-by-Step Framework to Crush Every Sales Quarter | Moving from SMB to Enterprise: How and When | Verticalised Sales Teams: Why They are a Gamechanger and How to Build Them with Ben Fiechtner, CRO @ Clari",
            "pub_date": "2024-08-02T07:00:00.000Z",
            "duration": "55:04",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-12-week-step-by-step-framework-to-crush-every-sales-quarter-moving-from-smb-to-enterprise-how-and-when-verticalised-sales-teams-why-they-are-a-gamechanger-and-how-to-build-them-with-ben-fiechtner-cro-clari",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Test_5_Ben_Fiechtner__Clari.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3bfa21f1-c026-4937-92ea-4885b27bd234",
            "index": 275,
            "title": "20VC: Is More Compute the Answer to Model Performance | Why OpenAI Abandons Products, The Biggest Opportunities They Have Not Taken & Analysing Their Race for AGI | What Companies, AI Labs and Startups Get Wrong About AI with Ethan Mollick",
            "pub_date": "2024-07-31T07:08:00.000Z",
            "duration": "01:08:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "generative ai",
              "openai"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-is-more-compute-the-answer-to-model-performance-why-openai-abandons-products-the-biggest-opportunities-they-have-not-taken-analysing-their-race-for-agi-what-companies-ai-labs-and-startups-get-wrong-about-ai-with-ethan-mollick",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Test_6_Ethan_Mollick__Wharton.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "965acb8f-d26a-4a86-8730-a9c34509c231",
            "index": 276,
            "title": "20VC: Twitter's Most Controversial VC Delian Asparouhov on Inside the Walls of Founders Fund: What the World Does Not See | Why Western Europe Will Be Like the Third World | Why SaaS as an Industry Might Be Dead",
            "pub_date": "2024-07-29T07:20:00.000Z",
            "duration": "01:15:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-twitters-most-controversial-vc-delian-asparouhov-on-inside-the-walls-of-founders-fund-what-the-world-does-not-see-why-western-europe-will-be-like-the-third-world-why-saas-as-an-industry-might-be-dead",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Test_5_Delian_Asparouhov__Founders_Fund.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3d4737bb-2045-49b5-b84b-c8a96f21fc2c",
            "index": 277,
            "title": "20Growth: How Transferwise Acquired Their First 5M Customers: The Two Types of Content All Companies Must Create, How to Crush Competition With Performance Marketing, What Growth Hacks Worked and Did Not with Nilan Peiris, CPO @ Wise",
            "pub_date": "2024-07-26T08:21:00.000Z",
            "duration": "48:12",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-how-transferwise-acquired-their-first-5m-customers-the-two-types-of-content-all-companies-must-create-how-to-crush-competition-with-performance-marketing-what-growth-hacks-worked-and-did-not-with-nilan-peiris-cpo-wise",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_Nilan_Peiris_CPO__Wise.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "54aab489-2eb0-416c-bc04-410f5bb667e6",
            "index": 278,
            "title": "This Week in SaaS: Should Wiz Have Accepted Google's $23BN Acquisition Offer, Crowdstrike: WTF Happens From Here: The Bull and the Bear Case & $1BN into Legal Tech in a Day with Clio and Harvey with Jason Lemkin",
            "pub_date": "2024-07-24T08:02:00.000Z",
            "duration": "50:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/this-week-in-saas-should-wiz-have-accepted-googles-23bn-acquisition-offer-crowdstrike-wtf-happens-from-here-the-bull-and-the-bear-case-1bn-into-legal-tech-in-a-day-with-clio-and-harvey-with-jason-lemkin",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/This_Week_in_SaaS-_Wiz_Crowdstrike_Clio_and_Harvey.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f4a50fd-7cda-43b5-8657-8ff9ef70a54d",
            "index": 279,
            "title": "20VC: How I Lost Airbnb at Seed Because of an Exploding Term Sheet | Investing Lessons from Roelof Botha & Peter Thiel | Why VC is Less Collaborative Than Ever and Great Companies Are Being Destroyed by Too Much Cash with Kevin Hartz @ A*",
            "pub_date": "2024-07-22T07:08:00.000Z",
            "duration": "01:02:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-how-i-lost-airbnb-at-seed-because-of-an-exploding-term-sheet-investing-lessons-from-roelof-botha-peter-thiel-why-vc-is-less-collaborative-than-ever-and-great-companies-are-being-destroyed-by-too-much-cash-with-kevin-hartz-a",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Kevin_Hartz_Co-Founder__General_Partner__A.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "422bbb46-ef59-4ade-b168-645a5a7079dc",
            "index": 280,
            "title": "20Product: How Canva Builds Products: Lessons Learned, What Works? What Flopped? The Top 5 Product Lessons in Scaling to 185M Monthly Active Users with Canva Co-Founder and Chief Product Officer, Cameron Adams",
            "pub_date": "2024-07-19T07:10:00.000Z",
            "duration": "49:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-how-canva-builds-products-lessons-learned-what-works-what-flopped-the-top-5-product-lessons-in-scaling-to-185m-monthly-active-users-with-canva-co-founder-and-chief-product-officer-cameron-adams",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product-_Cameron_Adams-enhanced-24p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e877182-e8d7-4069-bd20-93e50b6a7778",
            "index": 281,
            "title": "20VC: Brex CEO Pedro Franceschi on What Brex Needs to do to be a Public Company | Brex vs Ramp: Who Wins and How Does it Play Out | Battling Founder Mental Health and The Importance of Secondaries for Founders",
            "pub_date": "2024-07-17T15:21:00.000Z",
            "duration": "50:15",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-brex-ceo-pedro-franceschi-on-what-brex-needs-to-do-to-be-a-public-company-brex-vs-ramp-who-wins-and-how-does-it-play-out-battling-founder-mental-health-and-the-importance-of-secondaries-for-founders",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Pedro_Franceschi__BrexUPDATED.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b1034ad4-02ef-493e-9ac4-bd3ce780b08a",
            "index": 282,
            "title": "20VC: Why We Are in a Bubble & Now is Frothier Than 2021 | Why $1M ARR is a BS Milestone for Series A | Why Seed Pricing is Rational & Large Seed Rounds Have Less Risk | Why Many AI Apps Have BS Revenue & Are Not Sustainable with Saam Motamedi @ Greylock",
            "pub_date": "2024-07-15T07:18:00.000Z",
            "duration": "01:06:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-we-are-in-a-bubble-now-is-frothier-than-2021-why-1m-arr-is-a-bs-milestone-for-series-a-why-seed-pricing-is-rational-large-seed-rounds-have-less-risk-why-many-ai-apps-have-bs-revenue-are-not-sustainable-with-saam-motamedi-greylock",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-Saam_Motamedi_General_Partner__Greylock.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f8648b0e-1091-4f11-a2d7-b6a04c9dd0de",
            "index": 283,
            "title": "20Sales: Biggest Lessons Scaling Hubspot from $0-$100M in ARR, The Framework for How Startups Should Scale into the Enterprise, How to do Channel Partnerships Right and How to Construct Sales Comp Plans Early On with Mark Roberge",
            "pub_date": "2024-07-12T07:07:00.000Z",
            "duration": "40:00",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-biggest-lessons-scaling-hubspot-from-0-100m-in-arr-the-framework-for-how-startups-should-scale-into-the-enterprise-how-to-do-channel-partnerships-right-and-how-to-construct-sales-comp-plans-early-on-with-mark-roberge",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Mark_Roberge_Levelled.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ea8dc02b-3273-43d8-93ea-2e6e6a7c9a6a",
            "index": 284,
            "title": "20VC: ServiceTitan Would Not Be the Success if We Raised VC Earlier: How to Build a Dominant Vertical SaaS Business, How to Master Going Into Enterprise, When & How to Launch Second Products with Ara Mahdessian, Co-Founder @ServiceTitan",
            "pub_date": "2024-07-10T17:13:00.000Z",
            "duration": "51:07",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-servicetitan-the-7bn-company-that-did-not-want-to-raise-vc-funding-how-to-build-a-7bn-vertical-saas-business-how-to-master-going-into-enterprise-when-how-to-launch-second-products-with-ara-mahdessian-co-founder-servicetitan",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Ara_Mahdessian_Co-Founder__ServiceTitan.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b4ce18f-f8be-4bf6-9c2d-db191f14c17f",
            "index": 285,
            "title": "20VC: The Sequoia Investment Process | Investing Lessons from Doug Leone, Roelof Botha & Alfred Lin | Sequoia's Framework for Analysing Founders | The True Benefit of Having Sequoia on a Cap Table & Sequoia's Biggest Threat with Pat Grady",
            "pub_date": "2024-07-08T08:23:00.000Z",
            "duration": "01:08:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-the-sequoia-investment-process-investing-lessons-from-doug-leone-roelof-botha-and-alfred-lin-sequoias-framework-for-analysing-founders-the-true-benefit-of-having-sequoia-on-a-cap-table-sequoias-biggest-threat-with-pat-grady",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Pat_Grady_Partner__Sequoia_Capital-enhanced-20p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0af98b22-c573-44b5-8e4e-2fdc51cb7779",
            "index": 286,
            "title": "20VC: Turning a $15M Investment in Monday into $1.5BN in Cash | The Strategy Behind a 37x DPI $45M Fund | The Three Step Process to Selling Positions that has Netted Top Percentile Returns with Avi Eyal, Co-Founder @ Entrée Capital",
            "pub_date": "2024-07-03T07:09:00.000Z",
            "duration": "58:34",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-turning-a-15m-investment-in-monday-into-15bn-in-cash-the-strategy-behind-a-37x-dpi-45m-fund-the-three-step-process-to-selling-positions-that-has-netted-top-percentile-returns-with-avi-eyal-co-founder-entre-capital",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Avi_Eyal_Co-Founder__Entree_Capital-enhanced-31p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4143bd65-8cfc-47b1-aade-51e3c35337c4",
            "index": 287,
            "title": "20VC: LLMs Are Reaching a Stage of Diminishing Returns: What is the Next S Curve | The Bull & Bear Case for China's Ability to Challenge the US' AI Capabilities | How AI Changes the Future of War & How Agents Will Reshape Society with Matt Clifford @ EF",
            "pub_date": "2024-07-01T07:09:00.000Z",
            "duration": "01:02:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "chips",
              "safety"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-llms-are-reaching-a-stage-of-diminishing-returns-what-is-the-next-s-curve-the-bull-bear-case-for-chinas-ability-to-challenge-the-us-ai-capabilities-how-ai-changes-the-future-of-war-how-agents-will-reshape-society-with-matt-clifford-ef",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/Matt_Levelled-enhanced-.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "199a794f-b329-4cb5-ab68-a957f286c949",
            "index": 288,
            "title": "20VC: Raising $126M Across 3 Rounds in Just 6 Months, Being the Youngest Founder of a Unicorn Company | But Everything Was Not as it Seemed: The Real Story of Vise: The Regrets, Mistakes and Mis-Hires with Vise's Samir Vasavada",
            "pub_date": "2024-06-28T07:14:00.000Z",
            "duration": "59:16",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-raising-126m-across-3-rounds-in-just-6-months-being-the-youngest-founder-of-a-unicorn-company-but-everything-was-not-as-it-seemed-the-real-story-of-vise-the-regrets-mistakes-and-mis-hires-with-vises-samir-vasavada",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-Samir_Vasavada_Co-Founder__Vise-enhanced-26p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4af5ef8-7508-41f9-a0a5-2454d75eac27",
            "index": 289,
            "title": "20VC: Klaviyo's Andrew Bialecki on Going Public in an IPO Winter, Is Klaviyo Under-Priced in Public Markets and Why, Why Every VC Turned Klaviyo Down in the Early Days & How Shopify's Partnership Changed the Game",
            "pub_date": "2024-06-26T07:10:00.000Z",
            "duration": "51:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-klaviyos-andrew-bialecki-on-going-public-in-an-ipo-winter-is-klaviyo-under-priced-in-public-markets-and-why-why-every-vc-turned-klaviyo-down-in-the-early-days-how-shopifys-partnership-changed-the-game",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Andrew_Bialecki__Klaviyo-enhanced-27p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36fb4d60-d09e-4c48-bf5c-5aa6904fd8ae",
            "index": 290,
            "title": "20VC: Why Foundation Model Performance is Not Diminishing But Models Are Commoditising, Why Nvidia Will Enter the Model Space and Models Will Enter the Chip Space & The Right Business Model for AI Software with David Luan, Co-Founder @ Adept",
            "pub_date": "2024-06-24T07:10:00.000Z",
            "duration": "56:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 22,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-why-foundation-model-performance-is-not-diminishing-but-models-are-commoditising-why-nvidia-will-enter-the-model-space-and-models-will-enter-the-chip-space-the-right-business-model-for-ai-software-with-david-luan-co-founder-adept",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_David_Luan_Co-Founder__Adept-enhanced-30p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b5c97d9d-89f1-4f15-a3be-782bdf0952b3",
            "index": 291,
            "title": "20Growth: How Revolut Acquired Their First 10M Users: Tips, Tactics and Strategies From the Revolut Product & Growth Playbook with Val Scholz, Former Head of Growth @ Revolut",
            "pub_date": "2024-06-21T07:01:00.000Z",
            "duration": "53:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-how-revolut-acquired-their-first-10m-users-tips-tactics-and-strategies-from-the-revolut-product-growth-playbook-with-val-scholz-former-head-of-growth-revolut",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_Val_Scholz_Former_Head_of_Growth__Revolut-enhanced-22p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fcf2530b-c59a-45e2-8f4c-845ee54ae773",
            "index": 292,
            "title": "20VC: Foundation Models are the Fastest Depreciating Asset in History, Lina Kahn is a Threat to American Capitalism, PE is Not Coming to Save the M&A Market & How China Could Overtake the US in the AI Race with Michael Eisenberg",
            "pub_date": "2024-06-19T07:01:00.000Z",
            "duration": "56:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-foundation-models-are-the-fastest-depreciating-asset-in-history-lina-kahn-is-a-threat-to-american-capitalism-pe-is-not-coming-to-save-the-ma-market-how-china-could-overtake-the-us-in-the-ai-race-with-michael-eisenberg",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Michael_Eisenberg_Co-Founder__Aleph-enhanced-30p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "414f0dc3-334f-4a72-98b5-daa0cc0c1bdb",
            "index": 293,
            "title": "20VC: Index's Danny Rimer on Investing Lessons from Hits like Figma, Discord and Etsy to Missing Snapchat, Airbnb, Facebook & Spotify | Why Valuation is a Trap and Market Sizing, Signalling and Sector/Geo-Specific Funds are all Noise",
            "pub_date": "2024-06-17T07:08:00.000Z",
            "duration": "01:13:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-indexs-danny-rimer-on-investing-lessons-from-hits-like-figma-discord-and-etsy-to-missing-snapchat-airbnb-facebook-spotify-why-valuation-is-a-trap-and-market-sizing-signalling-and-sectorgeo-specific-funds-are-all-noise",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Danny_Rimer-_Partner__Index_Ventures-enhanced-16p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36f2d5c7-9c4b-4dfa-bc89-c92eac68ed2c",
            "index": 294,
            "title": "20Product: Loom CPO Janie Lee on Three Core Skills that Make the Best PMs, How to Find, Pick and Train the Best PM Talent and Lessons from OpenDoor and Rippling on Product Breadth, Pricing and Talent Density",
            "pub_date": "2024-06-14T07:02:00.000Z",
            "duration": "01:02:38",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20product-loom-cpo-janie-lee-on-three-core-skills-that-make-the-best-pms-how-to-find-pick-and-train-the-best-pm-talent-and-lessons-from-opendoor-and-rippling-on-product-breadth-pricing-and-talent-density",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Product-_Janie_Lee_CPO__Loom-enhanced-30p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de73744d-3415-4399-914c-3538c2d920a0",
            "index": 295,
            "title": "20VC: Scale's Alex Wang on Why Data Not Compute is the Bottleneck to Foundation Model Performance, Why AI is the Greatest Military Asset Ever, Is China Really Two Years Behind the US in AI and Why the CCPs Industrial Approach is Better than Anyone Else's",
            "pub_date": "2024-06-12T07:05:00.000Z",
            "duration": "59:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "nvidia"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-scales-alex-wang-on-why-data-not-compute-is-the-bottleneck-to-foundation-model-performance-why-ai-is-the-greatest-military-asset-ever-is-china-really-two-years-behind-the-us-in-ai-and-why-the-ccps-industrial-approach-is-better-than-anyone-elses",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Alex_Wang_Founder__CEO__Scale-enhanced-28p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "812d2045-0883-4d96-aee9-453f107ab1dd",
            "index": 296,
            "title": "20VC: Reid Hoffman on Foundation Models: Who Wins & How Do Incumbents Respond | The Inflection AI Deal: How it Went Down | Why Trump is a Threat to Democracy | The Future of TikTok | Lessons from Sam Altman, Brian Chesky and the OpenAI Board",
            "pub_date": "2024-06-10T07:00:00.000Z",
            "duration": "01:15:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "alignment"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-reid-hoffman-on-foundation-models-who-wins-how-do-incumbents-respond-the-inflection-ai-deal-how-it-went-down-why-trump-is-a-threat-to-democracy-the-future-of-tiktok-lessons-from-sam-altman-brian-chesky-and-the-openai-board",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Reid_Hoffman-enhanced-35p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "263993b3-4afb-413d-9a96-8c8a8ea6351d",
            "index": 297,
            "title": "20Sales: How Rippling Built Their Sales Machine: How to Hire, Train and Manage the Best SDRs, What is the Right Comp Package for Sales Teams & The Playbook to Start and Scale Your SDR Team",
            "pub_date": "2024-06-07T07:04:00.000Z",
            "duration": "53:43",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20sales-how-rippling-built-their-sales-machine-how-to-hire-train-and-manage-the-best-sdrs-what-is-the-right-comp-package-for-sales-teams-the-playbook-to-start-and-scale-your-sdr-team",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Sales-_Ashley_Kelly__Rippling-enhanced-41p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e677b2e-3fbe-4177-9a97-201361b6cdee",
            "index": 298,
            "title": "20VC: Perplexity's Aravind Srinivas on Will Foundation Models Commoditise, Diminishing Returns in Model Performance, OpenAI vs Anthropic: Who Wins & Why the Next Breakthrough in Model Performance will be in Reasoning",
            "pub_date": "2024-06-05T07:24:00.000Z",
            "duration": "55:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "deepmind",
              "perplexity",
              "reasoning"
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20vc-perplexitys-aravind-srinivas-on-will-foundation-models-commoditise-diminishing-returns-in-model-performance-openai-vs-anthropic-who-wins-why-the-next-breakthrough-in-model-performance-will-be-in-reasoning",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20VC-_Aravind_Srinivas_Co-Founder__CEO__Perplexity-enhanced-31p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "47615d14-5c15-4551-8289-ca82ca37a623",
            "index": 299,
            "title": "This Week in SaaS: PluralSight Goes to Zero, Salesforce and Mongo Hit Hard, The Next IPO Candidates and How Do We Solve the Problem of Liquidity in Venture Capital",
            "pub_date": "2024-06-03T06:30:00.000Z",
            "duration": "01:09:11",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thetwentyminutevc.libsyn.com/this-week-in-saas-pluralsight-goes-to-zero-salesforce-and-mongo-hit-hard-the-next-ipo-candidates-and-how-do-we-solve-the-problem-of-liquidity-in-venture-capital",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/This_Week_in_SaaS_01-_Salesforce_Mongo_and_UiPath-enhanced-30p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa6d7706-0a67-4b89-a991-12669e2ae0c7",
            "index": 300,
            "title": "20Growth: The Six Channels Startups Need to Dominate to Grow, Why the Best Growth Talent Never Comes from Marketing or Product, Who and How to Hire Growth Leaders and Teams and Why in a World of AI, Growth is More Science than Art with Matt Lerner",
            "pub_date": "2024-05-31T07:32:00.000Z",
            "duration": "55:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thetwentyminutevc.libsyn.com/20growth-the-six-channels-startups-need-to-dominate-to-grow-why-the-best-growth-talent-never-comes-from-marketing-or-product-who-and-how-to-hire-growth-leaders-and-teams-and-why-in-a-world-of-ai-growth-is-more-science-than-art-with-matt-lerner",
            "audio_url": "https://traffic.libsyn.com/secure/thetwentyminutevc/20Growth-_Matt_Lerner_Growth_OG__PayPal-enhanced-40p.mp3?dest-id=240976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "twiml",
        "title": "The TWIML AI Podcast",
        "feed_title": "The TWIML AI Podcast (formerly This Week in Machine Learning & Artificial Intelligence)",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "ML engineering",
          "LLM",
          "enterprise AI",
          "MLOps"
        ],
        "feed_url": "https://feeds.megaphone.fm/MLN2155636147",
        "source_url": "https://feeds.megaphone.fm/MLN2155636147",
        "detail_path": "/podcasts/twiml/",
        "episode_count": 250,
        "selected_episode_count": 215,
        "latest_episode_title": "Relational Foundation Models for Enterprise Data with Jure Leskovec - #768",
        "latest_pub_date": "2026-05-21T19:38:00.000Z",
        "latest_page_url": "https://twimlai.com/podcast/twimlai/relational-foundation-models-enterprise-data",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "ab0875ce-554c-11f1-b770-9fac1c70deab",
            "index": 1,
            "title": "Relational Foundation Models for Enterprise Data with Jure Leskovec - #768",
            "pub_date": "2026-05-21T19:38:00.000Z",
            "duration": "3983",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agentic",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/relational-foundation-models-enterprise-data",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3747054711.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fe683000-4a62-11f1-9d2a-bb86847dabe1",
            "index": 2,
            "title": "How to Find the Agent Failures Your Evals Miss with Scott Clark - #767",
            "pub_date": "2026-05-07T22:46:00.000Z",
            "duration": "3199",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "llm",
              "agent",
              "agents",
              "training",
              "evals"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/how-find-agent-failures-your-evals-miss",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7498240745.mp3?updated=1778194521",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2cda57c4-44d2-11f1-95c8-ab75b1de5228",
            "index": 3,
            "title": "How to Engineer AI Inference Systems with Philip Kiely - #766",
            "pub_date": "2026-04-30T20:21:00.000Z",
            "duration": "3291",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "gpu",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/how-engineer-ai-inference-systems",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3829343846.mp3?updated=1777581088",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cadef49a-39d1-11f1-b82d-432e91561808",
            "index": 4,
            "title": "How Capital One Delivers Multi-Agent Systems with Rashmi Shetty - #765",
            "pub_date": "2026-04-16T23:48:00.000Z",
            "duration": "3258",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "agents",
              "agentic",
              "evals",
              "embedding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/how-capital-one-delivers-multi-agent-systems",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9114691307.mp3?updated=1776383902",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc328cfe-2291-11f1-a563-779fae43b6fb",
            "index": 5,
            "title": "The Race to Production-Grade Diffusion LLMs with Stefano Ermon - #764",
            "pub_date": "2026-03-26T22:35:00.000Z",
            "duration": "3798",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "llm",
              "agentic",
              "inference",
              "training",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/race-production-grade-diffusion-llms",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4110108991.mp3?updated=1774564986",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ebebd774-1cd1-11f1-89d3-7b12c2607b16",
            "index": 6,
            "title": "Agent Swarms and Knowledge Graphs for Autonomous Software Development with Siddhant Pardeshi - #763",
            "pub_date": "2026-03-10T23:25:00.000Z",
            "duration": "4574",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "evals",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/agent-swarms-knowledge-graphs-autonomous-software-development",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3982555965.mp3?updated=1773185885",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "21a9ae12-1364-11f1-aebe-ef6add9ebd14",
            "index": 7,
            "title": "AI Trends 2026: OpenClaw Agents, Reasoning LLMs, and More with Sebastian Raschka - #762",
            "pub_date": "2026-02-26T23:52:00.000Z",
            "duration": "4735",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "inference",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-trends-2026-openclaw-agents-reasoning-llms",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2274417899.mp3?updated=1772147656",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c04aea68-f5ff-11f0-84ca-7b3e7abcd413",
            "index": 8,
            "title": "The Evolution of Reasoning in Small Language Models with Yejin Choi - #761",
            "pub_date": "2026-01-29T21:48:00.000Z",
            "duration": "3981",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning",
              "alignment"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/the-evolution-of-reasoning-in-small-language-models/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2256483849.mp3?updated=1769723982",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cb993398-ebe1-11f0-b374-c771cf052009",
            "index": 9,
            "title": "Intelligent Robots in 2026: Are We There Yet? with Nikita Rudin - #760",
            "pub_date": "2026-01-08T21:27:00.000Z",
            "duration": "3997",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "training",
              "robotics"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/intelligent-robots-in-2026-are-we-there-yet/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2537286465.mp3?updated=1767908138",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "406aa9be-dac0-11f0-b6d1-9f7af6c840cc",
            "index": 10,
            "title": "Rethinking Pre-Training for Agentic AI with Aakanksha Chowdhery - #759",
            "pub_date": "2025-12-17T19:24:00.000Z",
            "duration": "3174",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "gemini",
              "training",
              "reasoning",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/rethinking-pretraining-for-agentic-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3462034138.mp3?updated=1766003076",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "37743782-d532-11f0-b1cb-f3d8510d225d",
            "index": 11,
            "title": "Why Vision Language Models Ignore What They See with Munawar Hayat - #758",
            "pub_date": "2025-12-09T19:46:00.000Z",
            "duration": "3460",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "inference",
              "alignment",
              "retrieval",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/why-vision-language-models-ignore-what-they-see/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7251543598.mp3?updated=1765310086",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "23fdac48-cb0e-11f0-ac58-d3c8d8f2415d",
            "index": 12,
            "title": "Scaling Agentic Inference Across Heterogeneous Compute with Zain Asgar - #757",
            "pub_date": "2025-12-02T22:29:00.000Z",
            "duration": "2924",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "agentic",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/scaling-agentic-inference-across-heterogeneous-compute/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2686987005.mp3?updated=1764715926",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1125741e-c4bc-11f0-9627-5778e42202ee",
            "index": 13,
            "title": "Proactive Agents for the Web with Devi Parikh - #756",
            "pub_date": "2025-11-19T01:49:00.000Z",
            "duration": "3364",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agents",
              "training",
              "automation"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/proactive-agents-for-the-web/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8999995371.mp3?updated=1763502496",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9064a8be-bf42-11f0-ad9f-cfafdc065d55",
            "index": 14,
            "title": "AI Orchestration for Smart Cities and the Enterprise with Robin Braun and Luke Norris - #755",
            "pub_date": "2025-11-12T20:05:00.000Z",
            "duration": "3286",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-orchestration-for-smart-cities-and-the-enterprise/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7553368301.mp3?updated=1762978440",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e04b8fe2-b9ba-11f0-990d-af2986245169",
            "index": 15,
            "title": "Building an AI Mathematician with Carina Hong - #754",
            "pub_date": "2025-11-04T21:30:00.000Z",
            "duration": "3352",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/building-an-ai-mathematician/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1309151606.mp3?updated=1762355698",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8c8047a-b42f-11f0-9481-a33e51219ade",
            "index": 16,
            "title": "High-Efficiency Diffusion Models for On-Device Image Generation and Editing with Hung Bui - #753",
            "pub_date": "2025-10-28T20:26:00.000Z",
            "duration": "3143",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "inference",
              "training",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/high-efficiency-diffusion-models-for-on-device-image-generation-and-editing/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6593247207.mp3?updated=1761682149",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eeccbe2e-aeb1-11f0-b0bb-8b05df40f43e",
            "index": 17,
            "title": "Vibe Coding's Uncanny Valley with Alexandre Pesant - #752",
            "pub_date": "2025-10-22T15:45:00.000Z",
            "duration": "4356",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/vibe-codings-uncanny-valley/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2745909763.mp3?updated=1761149815",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d2513fac-a92c-11f0-b5a1-ff89f119b8ad",
            "index": 18,
            "title": "Dataflow Computing for AI Inference with Kunle Olukotun - #751",
            "pub_date": "2025-10-14T19:39:00.000Z",
            "duration": "3457",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "agentic",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/dataflow-computing-for-ai-inference/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9142835882.mp3?updated=1762292412",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66615bf6-a391-11f0-a2a7-6b02f2fc0440",
            "index": 19,
            "title": "Recurrence and Attention for Long-Context Transformers with Jacob Buckman - #750",
            "pub_date": "2025-10-07T17:37:00.000Z",
            "duration": "3443",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gpu",
              "inference",
              "training",
              "reasoning",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/recurrence-and-attention-for-long-context-transformers/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7068202936.mp3?updated=1759858524",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "831f9e1c-9e12-11f0-884b-e72cdbfb66a3",
            "index": 20,
            "title": "The Decentralized Future of Private AI with Illia Polosukhin - #749",
            "pub_date": "2025-09-30T16:22:00.000Z",
            "duration": "3903",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "inference",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/the-decentralized-future-of-private-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2189764781.mp3?updated=1762292711",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e2479ca-98aa-11f0-8659-ff329450734a",
            "index": 21,
            "title": "Inside Nano Banana 🍌 and the Future of Vision-Language Models with Oliver Wang - #748",
            "pub_date": "2025-09-23T21:45:00.000Z",
            "duration": "3819",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "deepmind",
              "gemini",
              "training",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/inside-nano-banana-%f0%9f%8d%8c-and-the-future-of-vision-language-models/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7289124073.mp3?updated=1758664779",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e96b61a4-931a-11f0-a2a8-3bcaf6a01846",
            "index": 22,
            "title": "Is It Time to Rethink LLM Pre-Training? with Aditi Raghunathan - #747",
            "pub_date": "2025-09-16T18:08:00.000Z",
            "duration": "3506",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "llm",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/is-it-time-to-rethink-llm-pre-training/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5916308473.mp3?updated=1758046985",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f6fbd3b2-8dc5-11f0-9233-afac45e8d917",
            "index": 23,
            "title": "Building an Immune System for AI Generated Software with Animesh Koratana - #746",
            "pub_date": "2025-09-09T22:18:00.000Z",
            "duration": "3911",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/building-an-immune-system-for-ai-generated-software/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6993481718.mp3?updated=1757456846",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aeb3128a-8827-11f0-bde2-038c4673fae8",
            "index": 24,
            "title": "Autoformalization and Verifiable Superintelligence with Christian Szegedy - #745",
            "pub_date": "2025-09-02T20:31:00.000Z",
            "duration": "4308",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning",
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/autoformalization-and-verifiable-superintelligence/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7915517336.mp3?updated=1756837327",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9be320a4-8297-11f0-a7c2-a3b945ad5e7d",
            "index": 25,
            "title": "Multimodal AI Models on Apple Silicon with MLX with Prince Canuma - #744",
            "pub_date": "2025-08-26T16:55:00.000Z",
            "duration": "4220",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "gpu",
              "inference",
              "embeddings",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/multimodal-ai-models-on-apple-silicon-with-mlx/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1859645173.mp3?updated=1756231100",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5c874d28-7d14-11f0-add0-63adb93cac66",
            "index": 26,
            "title": "Genie 3: A New Frontier for World Models with Jack Parker-Holder and Shlomi Fruchter - #743",
            "pub_date": "2025-08-19T17:57:00.000Z",
            "duration": "3661",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "deepmind",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/genie-3-a-new-frontier-for-world-models/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4297409814.mp3?updated=1755626878",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e3df0136-77aa-11f0-9715-ff676f931d90",
            "index": 27,
            "title": "Closing the Loop Between AI Training and Inference with Lin Qiao - #742",
            "pub_date": "2025-08-12T19:00:00.000Z",
            "duration": "3671",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "inference",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/closing-the-loop-between-ai-training-and-inference/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4252780923.mp3?updated=1755024730",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "267d0706-6caf-11f0-beab-6355b28dea24",
            "index": 28,
            "title": "Context Engineering for Productive AI Agents with Filip Kozera - #741",
            "pub_date": "2025-07-29T19:37:00.000Z",
            "duration": "2761",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/context-engineering-for-productive-ai-agents/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9863568954.mp3?updated=1753817752",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b262691a-665a-11f0-8e69-472891e5cf1e",
            "index": 29,
            "title": "Infrastructure Scaling and Compound AI Systems with Jared Quincy Davis - #740",
            "pub_date": "2025-07-22T16:00:00.000Z",
            "duration": "4382",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/infrastructure-scaling-and-compound-ai-systems/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2657285858.mp3?updated=1753151737",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a1eb49a-61b1-11f0-a767-ab14001687e1",
            "index": 30,
            "title": "Building Voice AI Agents That Don’t Suck with Kwindla Kramer - #739",
            "pub_date": "2025-07-15T21:04:00.000Z",
            "duration": "4382",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/building-voice-ai-agents-that-dont-suck/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9079687304.mp3?updated=1752614441",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d70cbc8a-575e-11f0-9728-abd35ebb5cc0",
            "index": 31,
            "title": "Distilling Transformers and Diffusion Models for Robust Edge Use Cases with Fatih Porikli - #738",
            "pub_date": "2025-07-09T15:53:00.000Z",
            "duration": "3629",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/distilling-transformers-and-diffusion-models-for-robust-edge-use-cases/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4056797871.mp3?updated=1752077099",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1b24bf3c-510e-11f0-979c-6f659e2e29e6",
            "index": 32,
            "title": "Building the Internet of Agents with Vijoy Pandey - #737",
            "pub_date": "2025-06-24T15:15:00.000Z",
            "duration": "3373",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/building-the-internet-of-agents/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6554854566.mp3?updated=1750778902",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e7a27954-4bb0-11f0-992a-4be6ee67394b",
            "index": 33,
            "title": "LLMs for Equities Feature Forecasting at Two Sigma with Ben Wellington - #736",
            "pub_date": "2025-06-17T19:33:00.000Z",
            "duration": "3571",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/llms-for-equities-feature-forecasting-at-two-sigma/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1374470913.mp3?updated=1750189327",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13f0a338-460b-11f0-8c5d-4fe017b9585e",
            "index": 34,
            "title": "Zero-Shot Auto-Labeling: The End of Annotation for Computer Vision with Jason Corso - #735",
            "pub_date": "2025-06-10T16:54:00.000Z",
            "duration": "3405",
            "duration_label": "56m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "agentic"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/zero-shot-auto-labeling-the-end-of-annotation-for-computer-vision/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5226479586.mp3?updated=1749575933",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5a155f6-4196-11f0-a319-8b003675a9c3",
            "index": 35,
            "title": "Grokking, Generalization Collapse, and the Dynamics of Training Deep Neural Networks with Charles Martin - #734",
            "pub_date": "2025-06-05T00:10:00.000Z",
            "duration": "5121",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training",
              "rag"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/grokking-generalization-collapse-and-the-dynamics-of-training-deep-neural-networks/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4861884526.mp3?updated=1749083459",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "39a3d21e-3bfa-11f0-9f87-23c9304c52e7",
            "index": 36,
            "title": "Google I/O 2025 Special Edition - #733",
            "pub_date": "2025-05-28T20:59:00.000Z",
            "duration": "1581",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "deepmind",
              "gemini"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/google-i-o-2025-special-edition/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4033526197.mp3?updated=1748466377",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8baec9a-366d-11f0-b3cd-cfa03f7fbfbe",
            "index": 37,
            "title": "RAG Risks: Why Retrieval-Augmented LLMs are Not Safer with Sebastian Gehrmann - #732",
            "pub_date": "2025-05-21T18:14:00.000Z",
            "duration": "3429",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety",
              "rag",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/rag-risks-why-retrieval-augmented-llms-are-not-safer/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9960265469.mp3?updated=1747852071",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ce537fdc-3041-11f0-a38b-1f8a0aa52e0f",
            "index": 38,
            "title": "From Prompts to Policies: How RL Builds Better AI Agents with Mahesh Sathiamoorthy - #731",
            "pub_date": "2025-05-13T22:10:00.000Z",
            "duration": "3685",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/from-prompts-to-policies-how-rl-builds-better-ai-agents/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2707985480.mp3?updated=1747175429",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c6eb696-2abe-11f0-9e04-0768f0fe95f2",
            "index": 39,
            "title": "How OpenAI Builds AI Agents That Think and Act with Josh Tobin - #730",
            "pub_date": "2025-05-06T22:50:00.000Z",
            "duration": "4047",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "agentic",
              "openai",
              "reasoning",
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/how-openai-builds-ai-agents-that-think-and-act/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6458824254.mp3?updated=1746809590",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e3e35aac-2538-11f0-8261-9b987302e363",
            "index": 40,
            "title": "CTIBench: Evaluating LLMs in Cyber Threat Intelligence with Nidhi Rastogi - #729",
            "pub_date": "2025-04-30T07:21:00.000Z",
            "duration": "3378",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "rag",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ctibench-evaluating-llms-in-cyber-threat-intelligence/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6726544546.mp3?updated=1746051537",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "870e33c6-2054-11f0-bcd7-6be99e3e06db",
            "index": 41,
            "title": "Generative Benchmarking with Kelly Hong - #728",
            "pub_date": "2025-04-23T22:09:00.000Z",
            "duration": "3257",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "llm",
              "rag",
              "retrieval",
              "embedding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/generative-benchmarking/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1226891394.mp3?updated=1745421739",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e1b47e8-1968-11f0-981f-ab6b34bc3918",
            "index": 42,
            "title": "Exploring the Biology of LLMs with Circuit Tracing with Emmanuel Ameisen - #727",
            "pub_date": "2025-04-14T19:40:00.000Z",
            "duration": "5646",
            "duration_label": "1h 34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "anthropic",
              "claude",
              "reasoning",
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/exploring-the-biology-of-llms-with-circuit-tracing/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9142792837.mp3?updated=1744660777",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13c0079c-13f6-11f0-b371-5f9286ba2701",
            "index": 43,
            "title": "Teaching LLMs to Self-Reflect with Reinforcement Learning with Maohao Shen - #726",
            "pub_date": "2025-04-08T07:38:00.000Z",
            "duration": "3105",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "llm",
              "training",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/teaching-llms-to-self-reflect-with-reinforcement-learning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2559598700.mp3?updated=1744061785",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c13d297a-0e67-11f0-ae82-bf5e34aafff0",
            "index": 44,
            "title": "Waymo's Foundation Model for Autonomous Driving with Drago Anguelov - #725",
            "pub_date": "2025-03-31T19:46:00.000Z",
            "duration": "4147",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "generative ai",
              "safety",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/waymos-foundation-model-for-autonomous-driving/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6369365749.mp3?updated=1743451085",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3bee63c8-08e6-11f0-9b9c-670926e7c0c0",
            "index": 45,
            "title": "Dynamic Token Merging for Efficient Byte-level Language Models with Julie Kallini - #724",
            "pub_date": "2025-03-24T19:42:00.000Z",
            "duration": "3032",
            "duration_label": "50m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/dynamic-token-merging-for-efficient-byte-level-language-models/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6993632573.mp3?updated=1742845563",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75faa452-0344-11f0-8e79-1fe3636bd481",
            "index": 46,
            "title": "Scaling Up Test-Time Compute with Latent Reasoning with Jonas Geiping - #723",
            "pub_date": "2025-03-17T15:37:00.000Z",
            "duration": "3518",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/scaling-up-test-time-compute-with-latent-reasoning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5952508288.mp3?updated=1742226663",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "396e69e2-fdd6-11ef-82ab-87ca2358621d",
            "index": 47,
            "title": "Imagine while Reasoning in Space: Multimodal Visualization-of-Thought with Chengzu Li - #722",
            "pub_date": "2025-03-10T17:44:00.000Z",
            "duration": "2531",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "training",
              "reasoning",
              "embeddings",
              "multimodal",
              "robotics",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/imagine-while-reasoning-in-space-multimodal-visualization-of-thought/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3172764469.mp3?updated=1741629167",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "38f2bdb6-f885-11ef-b7ce-8f85e73103b8",
            "index": 48,
            "title": "Inside s1: An o1-Style Reasoning Model That Cost Under $50 to Train with Niklas Muennighoff - #721",
            "pub_date": "2025-03-03T23:56:03.000Z",
            "duration": "2969",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "openai",
              "gemini",
              "training",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/inside-s1-an-o1-style-reasoning-model-that-cost-under-50-to-train/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4321517135.mp3?updated=1741045497",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "49fb6a42-f2d4-11ef-87ac-53e9229ffa78",
            "index": 49,
            "title": "Accelerating AI Training and Inference with AWS Trainium2 with Ron Diamant - #720",
            "pub_date": "2025-02-24T18:01:00.000Z",
            "duration": "4025",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chip",
              "inference",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/accelerating-ai-training-and-inference-with-aws-trainium2/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1031417331.mp3?updated=1740420711",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af625406-ed82-11ef-ba20-478ca757bf5d",
            "index": 50,
            "title": "π0: A Foundation Model for Robotics with Sergey Levine - #719",
            "pub_date": "2025-02-18T07:46:21.000Z",
            "duration": "3150",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "foundation model",
              "training",
              "robotics"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/%cf%800-a-foundation-model-for-robotics/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2066349156.mp3?updated=1739834128",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a6ae728-e7d8-11ef-901c-5bc62f6435fd",
            "index": 51,
            "title": "AI Trends 2025: AI Agents and Multi-Agent Systems with Victor Dibia - #718",
            "pub_date": "2025-02-10T18:12:00.000Z",
            "duration": "6299",
            "duration_label": "1h 44m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "claude",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-trends-2025-ai-agents-and-multi-agent-systems/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9635186515.mp3?updated=1739211936",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dbc81efc-e271-11ef-83d6-fba112900069",
            "index": 52,
            "title": "Speculative Decoding and Efficient LLM Inference with Chris Lott - #717",
            "pub_date": "2025-02-04T07:23:33.000Z",
            "duration": "4590",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "agentic",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/speculative-decoding-and-efficient-llm-inference/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3928866342.mp3?updated=1738618160",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3432674-ddbc-11ef-8779-6385e7f8227c",
            "index": 53,
            "title": "Ensuring Privacy for Any LLM with Patricia Thaine - #716",
            "pub_date": "2025-01-28T22:31:50.000Z",
            "duration": "3093",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "training",
              "embeddings",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ensuring-privacy-for-any-llm/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9741894801.mp3?updated=1738101399",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "72ed2c20-d843-11ef-b622-cb0636c63cf3",
            "index": 54,
            "title": "AI Engineering Pitfalls with Chip Huyen - #715",
            "pub_date": "2025-01-21T22:26:00.000Z",
            "duration": "3457",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chip"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-engineering-pitfalls/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3302347327.mp3?updated=1737498763",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7d236e30-d1f8-11ef-bb2f-377df2276ee8",
            "index": 55,
            "title": "Evolving MLOps Platforms for Generative AI and Agents with Abhijit Bose - #714",
            "pub_date": "2025-01-13T22:25:00.000Z",
            "duration": "3488",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "agentic",
              "openai",
              "llama",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/evolving-mlops-platforms-for-generative-ai-and-agents/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4141194502.mp3?updated=1736914659",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa266980-bbed-11ef-9c84-8f9a4ef2523f",
            "index": 56,
            "title": "Why Agents Are Stupid & What We Can Do About It with Dan Jeffries - #713",
            "pub_date": "2024-12-16T20:47:07.000Z",
            "duration": "4129",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "agentic",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/why-agents-are-stupid-what-we-can-do-about-it/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8293963679.mp3?updated=1734382445",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d21e3458-b662-11ef-ab6a-cbeec55dd22e",
            "index": 57,
            "title": "Automated Reasoning to Prevent LLM Hallucination with Byron Cook - #712",
            "pub_date": "2024-12-09T20:18:32.000Z",
            "duration": "3408",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "reasoning",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/automated-reasoning-to-prevent-llm-hallucination/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7157710802.mp3?updated=1733775633",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ee78d2c4-b19f-11ef-ab17-5f637e959dd5",
            "index": 58,
            "title": "AI at the Edge: Qualcomm AI Research at NeurIPS 2024 with Arash Behboodi - #711",
            "pub_date": "2024-12-03T18:13:00.000Z",
            "duration": "3287",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-at-the-edge-qualcomm-ai-research-at-neurips-2024/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6480318768.mp3?updated=1733249837",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cae3bc6c-a604-11ef-9055-bba90df3e25c",
            "index": 59,
            "title": "AI for Network Management with Shirley Wu - #710",
            "pub_date": "2024-11-19T10:53:53.000Z",
            "duration": "3224",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-for-network-management/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4238471231.mp3?updated=1731974193",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc282120-a062-11ef-9927-3fc53c6945a7",
            "index": 60,
            "title": "Why Your RAG System Is Broken, and How to Fix It with Jason Liu - #709",
            "pub_date": "2024-11-11T15:55:00.000Z",
            "duration": "3483",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "rag",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/why-your-rag-pipeline-is-broken-and-how-to-fix-it/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3653850871.mp3?updated=1731384027",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29b7cf32-9aeb-11ef-a4ec-9b42fce72343",
            "index": 61,
            "title": "An Agentic Mixture of Experts for DevOps with Sunil Mallya - #708",
            "pub_date": "2024-11-04T13:53:00.000Z",
            "duration": "4509",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "agent",
              "agentic"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/an-agentic-mixture-of-experts-for-devops/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8491913296.mp3?updated=1730753189",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ee4e0d7a-9569-11ef-943c-171f6bdb5df9",
            "index": 62,
            "title": "Building AI Voice Agents with Scott Stephenson - #707",
            "pub_date": "2024-10-28T16:36:00.000Z",
            "duration": "3704",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/building-ai-voice-agents/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6815731992.mp3?updated=1730147923",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4fae9adc-8feb-11ef-9d1b-cf47215ab0d2",
            "index": 63,
            "title": "Is Artificial Superintelligence Imminent? with Tim Rocktäschel - #706",
            "pub_date": "2024-10-21T21:25:14.000Z",
            "duration": "3352",
            "duration_label": "55m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "artificial intelligence",
              "deepmind"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/is-artificial-superintelligence-imminent/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1506929068.mp3?updated=1729546190",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a8c504c-8a5d-11ef-9b67-7fed48f2e92d",
            "index": 64,
            "title": "ML Models for Safety-Critical Systems with Lucas García - #705",
            "pub_date": "2024-10-14T19:29:00.000Z",
            "duration": "4566",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ml-models-for-safety-critical-systems/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4250685356.mp3?updated=1728934919",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0e55b32-84da-11ef-8cb1-f78eb269474c",
            "index": 65,
            "title": "AI Agents: Substance or Snake Oil with Arvind Narayanan - #704",
            "pub_date": "2024-10-07T15:32:00.000Z",
            "duration": "3262",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-agents-substance-or-snake-oil/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2654619504.mp3?updated=1728326821",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de00d4be-7f77-11ef-9313-37ce3680f955",
            "index": 66,
            "title": "AI Agents for Data Analysis with Shreya Shankar - #703",
            "pub_date": "2024-09-30T13:09:00.000Z",
            "duration": "2904",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "agentic",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-agents-for-data-analysis/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9363051879.mp3?updated=1727745514",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "41409b92-79e0-11ef-a827-27086b3859e9",
            "index": 67,
            "title": "Stealing Part of a Production Language Model with Nicholas Carlini - #702",
            "pub_date": "2024-09-23T19:21:00.000Z",
            "duration": "3810",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "deepmind",
              "embedding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/stealing-part-of-a-production-language-model/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7516431304.mp3?updated=1727119766",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d552de32-7466-11ef-b401-7b4884349685",
            "index": 68,
            "title": "Supercharging Developer Productivity with ChatGPT and Claude with Simon Willison - #701",
            "pub_date": "2024-09-16T22:24:00.000Z",
            "duration": "4455",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "chatgpt",
              "anthropic",
              "claude"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/supercharging-developer-productivity-with-chatgpt-and-claude/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2990950712.mp3?updated=1726528312",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "008aea54-6a2b-11ef-b146-4b66c854276c",
            "index": 69,
            "title": "Automated Design of Agentic Systems with Shengran Hu - #700",
            "pub_date": "2024-09-02T20:30:00.000Z",
            "duration": "3570",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "agent",
              "agentic"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/automated-design-of-agentic-systems/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6045931233.mp3?updated=1725394223",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6b0e1d62-63cb-11ef-8767-c7ba9752b5ed",
            "index": 70,
            "title": "The EU AI Act and Mitigating Bias in Automated Decisioning with Peter van der Putten - #699",
            "pub_date": "2024-08-27T00:22:50.000Z",
            "duration": "2734",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/the-eu-ai-act-and-mitigating-bias-in-automated-decisioning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9777212790.mp3?updated=1724695240",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "162e2ec8-5e61-11ef-bf7c-8fa3a5707ee5",
            "index": 71,
            "title": "The Building Blocks of Agentic Systems with Harrison Chase - #698",
            "pub_date": "2024-08-19T19:54:00.000Z",
            "duration": "3557",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "llm",
              "agents",
              "agentic",
              "rag"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7661308388.mp3?updated=1724098102",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a6197916-58d0-11ef-849e-c3a490092203",
            "index": 72,
            "title": "Simplifying On-Device AI for Developers with Siddhika Nevrekar - #697",
            "pub_date": "2024-08-12T18:07:00.000Z",
            "duration": "2797",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "chips",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/simplifying-on-device-ai-for-developers/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7180381574.mp3?updated=1723486873",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ca627d4-534c-11ef-b45e-bb3dbb8e5a71",
            "index": 73,
            "title": "Genie: Generative Interactive Environments with Ashley Edwards - #696",
            "pub_date": "2024-08-05T17:14:00.000Z",
            "duration": "2811",
            "duration_label": "46m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "agents",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/genie-generative-interactive-environments/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9110516542.mp3?updated=1722879160",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "127a64b4-4e98-11ef-9e7d-2fe7cb569a82",
            "index": 74,
            "title": "Bridging the Sim2real Gap in Robotics with Marius Memmel - #695",
            "pub_date": "2024-07-30T18:11:00.000Z",
            "duration": "3441",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agents",
              "training",
              "robotics"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/bridging-the-sim2real-gap-in-robotics/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8822996431.mp3?updated=1722363990",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22148926-4935-11ef-a53a-17eb44d86b5f",
            "index": 75,
            "title": "Building Real-World LLM Products with Fine-Tuning and More with Hamel Husain - #694",
            "pub_date": "2024-07-23T21:02:00.000Z",
            "duration": "4805",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/building-real-world-llm-products-with-fine-tuning-and-more/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5252789067.mp3?updated=1721769728",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "03d385c8-439c-11ef-875f-d7608101a7e6",
            "index": 76,
            "title": "Mamba, Mamba-2 and Post-Transformer Architectures for Generative AI with Albert Gu - #693",
            "pub_date": "2024-07-17T10:27:00.000Z",
            "duration": "3474",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/mamba-mamba-2-and-post-transformer-architectures-for-generative-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7483766778.mp3?updated=1721154194",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "61173786-3d69-11ef-8758-e7ac9a0ec8cb",
            "index": 77,
            "title": "Decoding Animal Behavior to Train Robots with EgoPet with Amir Bar - #692",
            "pub_date": "2024-07-09T14:00:00.000Z",
            "duration": "2596",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning",
              "robotics"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/decoding-animal-behavior-to-train-robots-with-egopet/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3784001197.mp3?updated=1720473918",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95ab2718-37c0-11ef-af82-c70430fbb683",
            "index": 78,
            "title": "How Microsoft Scales Testing and Safety for Generative AI with Sarah Bird - #691",
            "pub_date": "2024-07-01T16:23:22.000Z",
            "duration": "3432",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/how-microsoft-scales-testing-and-safety-for-generative-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3542757284.mp3?updated=1719851928",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "79dd630e-3322-11ef-8dca-a709e63b1ef1",
            "index": 79,
            "title": "Long Context Language Models and their Biological Applications with Eric Nguyen - #690",
            "pub_date": "2024-06-25T18:54:00.000Z",
            "duration": "2741",
            "duration_label": "45m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "foundation model",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/long-context-language-models-and-their-biological-applications/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4558723289.mp3?updated=1719342347",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca24c8ee-2ce6-11ef-9e64-e32db5b93fe2",
            "index": 80,
            "title": "Accelerating Sustainability with AI with Andres Ravinet - #689",
            "pub_date": "2024-06-18T15:49:00.000Z",
            "duration": "2866",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/accelerating-sustainability-with-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5510514731.mp3?updated=1718655822",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f964f46-2773-11ef-b6fc-372167d98b47",
            "index": 81,
            "title": "Gen AI at the Edge: Qualcomm AI Research at CVPR 2024 with Fatih Porikli - #688",
            "pub_date": "2024-06-10T22:25:00.000Z",
            "duration": "4241",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "inference",
              "training",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/gen-ai-at-the-edge-qualcomm-ai-research-at-cvpr-2024/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9153067232.mp3?updated=1718056549",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f44e2c0c-21f9-11ef-ac1a-3b2162227cac",
            "index": 82,
            "title": "Energy Star Ratings for AI Models with Sasha Luccioni - #687",
            "pub_date": "2024-06-03T23:47:00.000Z",
            "duration": "2906",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/energy-star-ratings-for-ai-models/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5181927287.mp3?updated=1717565807",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7083fe8e-1c53-11ef-b216-bb722023938b",
            "index": 83,
            "title": "Language Understanding and LLMs with Christopher Manning - #686",
            "pub_date": "2024-05-27T18:53:00.000Z",
            "duration": "3370",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "reasoning",
              "embeddings"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/language-understanding-and-llms/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7587334756.mp3?updated=1716953241",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19218ecc-16cc-11ef-a05c-b3ea5ac3adcc",
            "index": 84,
            "title": "Chronos: Learning the Language of Time Series with Abdul Fatir Ansari - #685",
            "pub_date": "2024-05-20T17:21:00.000Z",
            "duration": "2585",
            "duration_label": "43m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/chronos-learning-the-language-of-time-series/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6204603914.mp3?updated=1716947469",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2fd98ae4-1162-11ef-adba-335ccb0b0eae",
            "index": 85,
            "title": "Powering AI with the World's Largest Computer Chip with Joel Hestness - #684",
            "pub_date": "2024-05-13T19:58:23.000Z",
            "duration": "3306",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/powering-ai-with-the-worlds-largest-computer-chip/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6928791405.mp3?updated=1715630189",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a8bd062-0bcc-11ef-8496-cf59a26926f0",
            "index": 86,
            "title": "AI for Power & Energy with Laurent Boinot - #683",
            "pub_date": "2024-05-07T02:39:14.000Z",
            "duration": "2981",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-for-power-energy/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9631523506.mp3?updated=1715049563",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "32f9c516-0665-11ef-8476-3ff537c44b1b",
            "index": 87,
            "title": "Controlling Fusion Reactor Instability with Deep Reinforcement Learning with Aza Jalalvand - #682",
            "pub_date": "2024-04-29T20:22:00.000Z",
            "duration": "2529",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/controlling-fusion-reactor-instability-with-deep-reinforcement-learning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3018125522.mp3?updated=1714422019",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a60a397a-00d7-11ef-b8b8-93c07e331d9b",
            "index": 88,
            "title": "GraphRAG: Knowledge Graphs for AI Applications with Kirk Marple - #681",
            "pub_date": "2024-04-22T18:58:00.000Z",
            "duration": "2828",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/graphrag-knowledge-graphs-for-ai-applications/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3405997576.mp3?updated=1713836204",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b36e32d8-fc27-11ee-bfdf-57f6ac6bb460",
            "index": 89,
            "title": "Teaching Large Language Models to Reason with Reinforcement Learning with Alex Havrilla - #680",
            "pub_date": "2024-04-16T22:58:00.000Z",
            "duration": "2784",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "training",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/teaching-large-language-models-to-reason-with-reinforcement-learning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2131262000.mp3?updated=1713836624",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "780e2eac-f5e5-11ee-b38e-8fa6069fe5ed",
            "index": 90,
            "title": "Localizing and Editing Knowledge in LLMs with Peter Hase - #679",
            "pub_date": "2024-04-08T21:03:00.000Z",
            "duration": "2986",
            "duration_label": "49m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/localizing-and-editing-knowledge-in-llms/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6128348451.mp3?updated=1712607942",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a6bcb64-f05a-11ee-ae98-07e6d7c6cc02",
            "index": 91,
            "title": "Coercing LLMs to Do and Reveal (Almost) Anything with Jonas Geiping - #678",
            "pub_date": "2024-04-01T19:15:00.000Z",
            "duration": "2907",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/coercing-llms-to-do-and-reveal-almost-anything/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1896604137.mp3?updated=1711998329",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c44498fe-eabb-11ee-a41e-778a2261e343",
            "index": 92,
            "title": "V-JEPA, AI Reasoning from a Non-Generative Architecture with Mido Assran - #677",
            "pub_date": "2024-03-25T16:00:00.000Z",
            "duration": "2867",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning",
              "embedding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/v-jepa-ai-reasoning-from-a-non-generative-architecture/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9999482985.mp3?updated=1711380866",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "63cdcb8a-e548-11ee-802e-2f8fd5ac7461",
            "index": 93,
            "title": "Video as a Universal Interface for AI Reasoning with Sherry Yang - #676",
            "pub_date": "2024-03-18T17:09:00.000Z",
            "duration": "2974",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "deepmind",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/video-as-a-universal-interface-for-ai-reasoning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1270874992.mp3?updated=1710918505",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ce887312-dfd0-11ee-8cbd-d7a1f661569b",
            "index": 94,
            "title": "Assessing the Risks of Open AI Models with Sayash Kapoor - #675",
            "pub_date": "2024-03-11T18:09:00.000Z",
            "duration": "2426",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/assessing-the-risks-of-open-ai-models/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8468113294.mp3?updated=1710180142",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fe9fa270-da56-11ee-ad1d-df46df0f9a30",
            "index": 95,
            "title": "OLMo: Everything You Need to Train an Open Source LLM with Akshita Bhagia - #674",
            "pub_date": "2024-03-04T20:10:00.000Z",
            "duration": "1932",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "mistral"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/olmo-everything-you-need-to-train-an-open-source-llm/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6116602529.mp3?updated=1709582779",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff82aa00-d4c2-11ee-b34a-1f8b85a82301",
            "index": 96,
            "title": "Training Data Locality and Chain-of-Thought Reasoning in LLMs with Ben Prystawski - #673",
            "pub_date": "2024-02-26T19:17:00.000Z",
            "duration": "1503",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "llm",
              "training",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/training-data-locality-and-chain-of-thought-reasoning-in-llms/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1845606139.mp3?updated=1708975551",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70a34026-cf48-11ee-9db5-1b8931c14a1d",
            "index": 97,
            "title": "Reasoning Over Complex Documents with DocLLM with Armineh Nourbakhsh - #672",
            "pub_date": "2024-02-19T19:07:00.000Z",
            "duration": "2738",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "training",
              "reasoning",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/reasoning-over-complex-documents-with-docllm/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8614358492.mp3?updated=1708370325",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "597dabe0-ca05-11ee-be6f-3b2fe540d05d",
            "index": 98,
            "title": "Are Emergent Behaviors in LLMs an Illusion? with Sanmi Koyejo - #671",
            "pub_date": "2024-02-12T18:40:00.000Z",
            "duration": "3940",
            "duration_label": "1h 5m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/are-emergent-behaviors-in-llms-an-illusion-2/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9383356698.mp3?updated=1707838967",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "479c107a-c45a-11ee-8ffa-5f78fd40b0af",
            "index": 99,
            "title": "AI Trends 2024: Reinforcement Learning in the Age of LLMs with Kamyar Azizzadenesheli - #670",
            "pub_date": "2024-02-05T19:14:00.000Z",
            "duration": "4225",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "nvidia",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-trends-2024-reinforcement-learning-in-the-age-of-llms/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7496446704.mp3?updated=1707160554",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da7fc99e-bec0-11ee-88da-e7a32b2c147e",
            "index": 100,
            "title": "Building and Deploying Real-World RAG Applications with Ram Sriharsha - #669",
            "pub_date": "2024-01-29T19:19:00.000Z",
            "duration": "2129",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "rag",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/building-and-deploying-real-world-rag-applications/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5047897251.mp3?updated=1706556580",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f400200-b94a-11ee-adb1-d396ea25b51e",
            "index": 101,
            "title": "Nightshade: Data Poisoning to Fight Generative AI with Ben Zhao - #668",
            "pub_date": "2024-01-22T18:06:00.000Z",
            "duration": "2385",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/nightshade-data-poisoning-to-fight-generative-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5848483126.mp3?updated=1705944285",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1bdfbbba-b3d6-11ee-a62e-23b473a44dc3",
            "index": 102,
            "title": "Learning Transformer Programs with Dan Friedman - #667",
            "pub_date": "2024-01-15T19:28:59.000Z",
            "duration": "2328",
            "duration_label": "38m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/learning-transformer-programs/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9132550809.mp3?updated=1705344567",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "44eb19bc-ae42-11ee-bad3-f3226e194437",
            "index": 103,
            "title": "AI Trends 2024: Machine Learning & Deep Learning with Thomas Dietterich - #666",
            "pub_date": "2024-01-08T16:50:03.000Z",
            "duration": "3918",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "rag"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-trends-2024-machine-learning-deep-learning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6485051406.mp3?updated=1704731315",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ffb25d7a-a98b-11ee-bf82-ff5ff5e8268a",
            "index": 104,
            "title": "AI Trends 2024: Computer Vision with Naila Murray - #665",
            "pub_date": "2024-01-02T21:07:00.000Z",
            "duration": "3121",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-trends-2024-computer-vision/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4141143494.mp3?updated=1704213226",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a13e9df6-a5aa-11ee-97f7-db91d4125aa4",
            "index": 105,
            "title": "Are Vector DBs the Future Data Platform for AI? with Ed Anuff - #664",
            "pub_date": "2023-12-28T20:23:00.000Z",
            "duration": "2893",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gpu",
              "rag",
              "retrieval",
              "embedding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/are-vector-dbs-the-future-data-platform-for-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7800032744.mp3?updated=1703786577",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d0de6e16-a419-11ee-82fc-bb527f7496ce",
            "index": 106,
            "title": "Quantizing Transformers by Helping Attention Heads Do Nothing with Markus Nagel - #663",
            "pub_date": "2023-12-26T20:07:54.000Z",
            "duration": "2809",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "training",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/quantizing-transformers-by-helping-attention-heads-do-nothing/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8515758475.mp3?updated=1703614428",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c19b684a-a05f-11ee-bfbc-8fb79d03af82",
            "index": 107,
            "title": "Responsible AI in the Generative Era with Michael Kearns - #662",
            "pub_date": "2023-12-22T01:37:00.000Z",
            "duration": "2164",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/responsible-ai-in-the-generative-era/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9941029015.mp3?updated=1703204663",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa71afe8-9dbd-11ee-a32a-d758d9dd4c76",
            "index": 108,
            "title": "Edutainment for AI and AWS PartyRock with Mike Miller - #661",
            "pub_date": "2023-12-18T16:46:00.000Z",
            "duration": "1786",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/edutainment-for-ai-and-aws-partyrock/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6922555491.mp3?updated=1703041712",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8abc0030-9ac1-11ee-8cbb-6b7829060994",
            "index": 109,
            "title": "Data, Systems and ML for Visual Understanding with Cody Coleman - #660",
            "pub_date": "2023-12-14T22:25:00.000Z",
            "duration": "2307",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "embeddings",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/data-systems-and-ml-for-visual-understanding/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1255105858.mp3?updated=1702592679",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6eb639fa-9855-11ee-9c6e-9fe469d915da",
            "index": 110,
            "title": "Patterns and Middleware for LLM Applications with Kyle Roche - #659",
            "pub_date": "2023-12-11T23:15:23.000Z",
            "duration": "2158",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "llm",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/patterns-and-middleware-for-llm-applications/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3085803991.mp3?updated=1702334494",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc649446-92dc-11ee-b1da-0b9f4f24eacb",
            "index": 111,
            "title": "AI Access and Inclusivity as a Technical Challenge with Prem Natarajan - #658",
            "pub_date": "2023-12-04T20:08:41.000Z",
            "duration": "2506",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-access-and-inclusivity-as-a-technical-challenge/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2258208342.mp3?updated=1701719133",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0a345ffa-8e2f-11ee-bb22-4b695f4987e0",
            "index": 112,
            "title": "Building LLM-Based Applications with Azure OpenAI with Jay Emery - #657",
            "pub_date": "2023-11-28T21:24:07.000Z",
            "duration": "2603",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "openai",
              "inference",
              "rag"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/building-llm-based-applications-with-azure-openai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6677515809.mp3?updated=1701204619",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5911989a-87c7-11ee-aa1b-0f9cbc2bf4eb",
            "index": 113,
            "title": "Visual Generative AI Ecosystem Challenges with Richard Zhang - #656",
            "pub_date": "2023-11-20T17:27:00.000Z",
            "duration": "2440",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/visual-generative-ai-ecosystem-challenges/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6292733087.mp3?updated=1700600746",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f479e01e-824d-11ee-ba99-e71412bbf4a8",
            "index": 114,
            "title": "Deploying Edge and Embedded AI Systems with Heather Gorr - #655",
            "pub_date": "2023-11-13T18:56:00.000Z",
            "duration": "2316",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/deploying-edge-and-embedded-ai-systems/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1711734166.mp3?updated=1699977362",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "20f661ba-7cdd-11ee-969e-bb6a498d86f0",
            "index": 115,
            "title": "AI Sentience, Agency and Catastrophic Risk with Yoshua Bengio - #654",
            "pub_date": "2023-11-06T20:50:59.000Z",
            "duration": "2880",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-sentience-agency-and-catastrophic-risk/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5856512799.mp3?updated=1699300269",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "14df513c-774e-11ee-bdbc-bf4a65187c4a",
            "index": 116,
            "title": "Delivering AI Systems in Highly Regulated Environments with Miriam Friedel - #653",
            "pub_date": "2023-10-30T18:27:45.000Z",
            "duration": "2645",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/delivering-ai-systems-in-highly-regulated-environments/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1495243177.mp3?updated=1698690252",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c5b9aca-71c3-11ee-8277-33e19c3b0b79",
            "index": 117,
            "title": "Mental Models for Advanced ChatGPT Prompting with Riley Goodside - #652",
            "pub_date": "2023-10-23T19:44:00.000Z",
            "duration": "2398",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/mental-models-for-advanced-chatgpt-prompting/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4797963163.mp3?updated=1698091963",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d5c066a-6c56-11ee-97e9-5394e9a0c8b4",
            "index": 118,
            "title": "Multilingual LLMs and the Values Divide in AI with Sara Hooker - #651",
            "pub_date": "2023-10-16T19:51:30.000Z",
            "duration": "4719",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "safety"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/multilingual-llms-and-the-values-divide-in-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2669421148.mp3?updated=1697483035",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b9aac532-66d4-11ee-9286-abb818e2c795",
            "index": 119,
            "title": "Scaling Multi-Modal Generative AI with Luke Zettlemoyer - #650",
            "pub_date": "2023-10-09T18:54:09.000Z",
            "duration": "2324",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training",
              "alignment",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/scaling-multi-modal-generative-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3862469127.mp3?updated=1696877735",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d9131fe-6158-11ee-80f5-83d1aad696f0",
            "index": 120,
            "title": "Pushing Back on AI Hype with Alex Hanna - #649",
            "pub_date": "2023-10-02T20:37:00.000Z",
            "duration": "2966",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/pushing-back-on-ai-hype/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2669084010.mp3?updated=1696274432",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a6abe2bc-5bb8-11ee-8112-43f506bb342b",
            "index": 121,
            "title": "Personalization for Text-to-Image Generative AI with Nataniel Ruiz - #648",
            "pub_date": "2023-09-25T16:24:00.000Z",
            "duration": "2662",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/personalization-for-text-to-image-generative-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9429073065.mp3?updated=1695659369",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8e382422-563e-11ee-9669-d73fcdd12156",
            "index": 122,
            "title": "Ensuring LLM Safety for Production Applications with Shreya Rajpal - #647",
            "pub_date": "2023-09-18T18:17:11.000Z",
            "duration": "2452",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "safety",
              "rag",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ensuring-llm-safety-for-production-applications/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8492343705.mp3?updated=1695059716",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65dedab4-50c8-11ee-8bd4-134e82c5904e",
            "index": 123,
            "title": "What’s Next in LLM Reasoning? with Roland Memisevic - #646",
            "pub_date": "2023-09-11T18:38:00.000Z",
            "duration": "3540",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "agents",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/whats-next-in-llm-reasoning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8628716738.mp3?updated=1695064477",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4be1eb1c-4914-11ee-af46-3fa07a3549f6",
            "index": 124,
            "title": "Is ChatGPT Getting Worse? with James Zou - #645",
            "pub_date": "2023-09-04T16:00:00.000Z",
            "duration": "2537",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "chatgpt",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/is-chatgpt-getting-worse/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8011459966.mp3?updated=1693938099",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "031b39f0-436b-11ee-a9c0-fbd0cdd6d344",
            "index": 125,
            "title": "Why Deep Networks and Brains Learn Similar Features with Sophia Sanborn - #644",
            "pub_date": "2023-08-28T18:13:14.000Z",
            "duration": "2715",
            "duration_label": "45m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/why-deep-networks-and-brains-learn-similar-features/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4765432477.mp3?updated=1693246375",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "16a2d432-3f52-11ee-a6e6-e7b527e8ba03",
            "index": 126,
            "title": "Inverse Reinforcement Learning Without RL with Gokul Swamy - #643",
            "pub_date": "2023-08-21T17:59:05.000Z",
            "duration": "2035",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "inference",
              "safety",
              "robotics"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/inverse-reinforcement-learning-without-rl/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3531803742.mp3?updated=1692641394",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "55401f80-378f-11ee-b037-9b9ed253b112",
            "index": 127,
            "title": "Explainable AI for Biology and Medicine with Su-In Lee - #642",
            "pub_date": "2023-08-14T17:36:00.000Z",
            "duration": "2294",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/explainable-ai-for-biology-and-medicine-2/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4264085375.mp3?updated=1692034960",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f98ff378-326a-11ee-a021-37a41cc7f33f",
            "index": 128,
            "title": "Transformers On Large-Scale Graphs with Bayan Bruss - #641",
            "pub_date": "2023-08-07T16:15:00.000Z",
            "duration": "2316",
            "duration_label": "38m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "embedding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/transformers-on-large-scale-graphs/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2074874022.mp3?updated=1691426537",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "885eee8e-2d65-11ee-a181-a7fbec69bd56",
            "index": 129,
            "title": "The Enterprise LLM Landscape with Atul Deo - #640",
            "pub_date": "2023-07-31T16:00:00.000Z",
            "duration": "2228",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "training",
              "rag",
              "retrieval"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/the-enterprise-llm-landscape/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5755736749.mp3?updated=1690583051",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "57fefc38-282a-11ee-a15b-bb46dba09abc",
            "index": 130,
            "title": "BloombergGPT - an LLM for Finance with David Rosenberg - #639",
            "pub_date": "2023-07-24T17:36:22.000Z",
            "duration": "2212",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "llm"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/bloomberggpt-an-llm-for-finance/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4234088173.mp3?updated=1690217245",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b8f61d80-2269-11ee-b0cc-23b8916b6f90",
            "index": 131,
            "title": "Are LLMs Good at Causal Reasoning? with Robert Osazuwa Ness - #638",
            "pub_date": "2023-07-17T17:24:57.000Z",
            "duration": "2901",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/are-llms-good-at-causal-reasoning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5479815893.mp3?updated=1689615122",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d4f21632-1f40-11ee-901b-97f3f0dcd753",
            "index": 132,
            "title": "Privacy vs Fairness in Computer Vision with Alice Xiang - #637",
            "pub_date": "2023-07-10T17:22:32.000Z",
            "duration": "2261",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/privacy-vs-fairness-in-computer-vision/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4883886561.mp3?updated=1689007680",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83e0fc14-19cc-11ee-a963-a3887e95959a",
            "index": 133,
            "title": "Unifying Vision and Language Models with Mohit Bansal - #636",
            "pub_date": "2023-07-03T18:06:00.000Z",
            "duration": "2888",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/unifying-vision-and-language-models",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9407594028.mp3?updated=1688409213",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd40c150-1445-11ee-aac7-3361ecb50957",
            "index": 134,
            "title": "Data Augmentation and Optimized Architectures for Computer Vision with Fatih Porikli - #635",
            "pub_date": "2023-06-26T18:06:00.000Z",
            "duration": "3151",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/data-augmentation-and-optimized-architectures-for-computer-vision/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4204176868.mp3?updated=1687800352",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9cbe4c08-0ebb-11ee-9bd8-136284bd0aa0",
            "index": 135,
            "title": "Mojo: A Supercharged Python for AI with Chris Lattner - #634",
            "pub_date": "2023-06-19T17:31:22.000Z",
            "duration": "3442",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/mojo-a-supercharged-python-for-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2486721769.mp3?updated=1687193251",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f513566-0949-11ee-94e9-dfd491f5b00c",
            "index": 136,
            "title": "Stable Diffusion and LLMs at the Edge with Jilei Hou - #633",
            "pub_date": "2023-06-12T18:24:11.000Z",
            "duration": "2409",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/stable-diffusion-and-llms-at-the-edge",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6925422585.mp3?updated=1686592503",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77fc48a6-fb20-11ed-9afe-e72392b7749c",
            "index": 137,
            "title": "Modeling Human Behavior with Generative Agents with Joon Sung Park - #632",
            "pub_date": "2023-06-05T17:17:34.000Z",
            "duration": "2798",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/modeling-human-behavior-with-generative-agents/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2527292991.mp3?updated=1685035539",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2c8e7682-fb16-11ed-82c7-f3c9812c0b94",
            "index": 138,
            "title": "Towards Improved Transfer Learning with Hugo Larochelle - #631",
            "pub_date": "2023-05-29T16:00:00.000Z",
            "duration": "2332",
            "duration_label": "38m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "deepmind"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/towards-improved-transfer-learning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8279020353.mp3?updated=1685031117",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b92dac7c-f8ad-11ed-b724-5bc7bb5391c7",
            "index": 139,
            "title": "Language Modeling With State Space Models with Dan Fu - #630",
            "pub_date": "2023-05-22T18:10:36.000Z",
            "duration": "1695",
            "duration_label": "28m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "inference",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/language-modeling-with-state-space-models/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9167975697.mp3?updated=1684766354",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f70525c-f34a-11ed-aac8-bb043d92c3c6",
            "index": 140,
            "title": "Building Maps and Spatial Awareness in Blind AI Agents with Dhruv Batra - #629",
            "pub_date": "2023-05-15T18:03:41.000Z",
            "duration": "2604",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/learning-maps-and-spatial-awareness-in-blind-ai-agents/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2694586028.mp3?updated=1684174034",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42a858ba-edca-11ed-8a41-9ffd90f2be31",
            "index": 141,
            "title": "AI Agents and Data Integration with GPT and LLaMa with Jerry Liu - #628",
            "pub_date": "2023-05-08T18:04:29.000Z",
            "duration": "2486",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "llama",
              "reasoning",
              "automation"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-agents-and-data-integration-with-gpt-and-llama/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7752871709.mp3?updated=1683569397",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "37a1b5a6-e528-11ed-ad04-c325ebe25424",
            "index": 142,
            "title": "Hyperparameter Optimization through Neural Network Partitioning with Christos Louizos - #627",
            "pub_date": "2023-05-01T19:34:00.000Z",
            "duration": "1991",
            "duration_label": "33m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/hyperparameter-optimization-through-neural-network-partitioning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5763417634.mp3?updated=1682969802",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f1d2f3d8-e2ba-11ed-b543-d370a31fa296",
            "index": 143,
            "title": "Are LLMs Overhyped or Underappreciated? with Marti Hearst - #626",
            "pub_date": "2023-04-24T20:08:00.000Z",
            "duration": "2276",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "copilot"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/are-llms-overhyped-or-under-appreciated/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5101605789.mp3?updated=1682369086",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e97b2df2-dd3f-11ed-b18c-4be82067ab18",
            "index": 144,
            "title": "Are Large Language Models a Path to AGI? with Ben Goertzel - #625",
            "pub_date": "2023-04-17T17:50:44.000Z",
            "duration": "3575",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/are-large-language-models-a-path-to-agi/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3896122141.mp3?updated=1681750509",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cb147d04-d7d7-11ed-bb60-1b1936bc2474",
            "index": 145,
            "title": "Open Source Generative AI at Hugging Face with Jeff Boudier - #624",
            "pub_date": "2023-04-11T17:28:40.000Z",
            "duration": "2031",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/open-source-generative-ai-at-hugging-face-2/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9712166154.mp3?updated=1681156034",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c443eba0-d24a-11ed-bc83-779f9cda3c30",
            "index": 146,
            "title": "Generative AI at the Edge with Vinesh Sukumar - #623",
            "pub_date": "2023-04-03T18:44:16.000Z",
            "duration": "2346",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/generative-ai-at-the-edge/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3295427970.mp3?updated=1680545708",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9ee78650-ccf0-11ed-81f1-ef07fe65f025",
            "index": 147,
            "title": "Runway Gen-2: Generative AI for Video Creation with Anastasis Germanidis - #622",
            "pub_date": "2023-03-27T22:41:18.000Z",
            "duration": "2961",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "alignment",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/runway-gen-2-generative-ai-for-video-creation/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7930027272.mp3?updated=1719841192",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3ad8f0e-c755-11ed-87ec-17129fa6ca35",
            "index": 148,
            "title": "Watermarking Large Language Models to Fight Plagiarism with Tom Goldstein - 621",
            "pub_date": "2023-03-20T20:04:48.000Z",
            "duration": "3087",
            "duration_label": "51m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "llm"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/watermarking-large-language-models-to-fight-plagiarism/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6246048702.mp3?updated=1679343089",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a0a95d8-c1cc-11ed-8212-fbdfaff267a0",
            "index": 149,
            "title": "Does ChatGPT “Think”? A Cognitive Neuroscience Perspective with Anna Ivanova - #620",
            "pub_date": "2023-03-13T19:04:36.000Z",
            "duration": "2705",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agi",
              "llm",
              "chatgpt"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/does-chatgpt-think-a-cognitive-neuroscience-perspective/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6946758983.mp3?updated=1678732194",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6d552bec-bc51-11ed-ace6-63563d2995e9",
            "index": 150,
            "title": "Robotic Dexterity and Collaboration with Monroe Kennedy III - #619",
            "pub_date": "2023-03-06T19:07:37.000Z",
            "duration": "3169",
            "duration_label": "52m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/robotic-dexterity-and-collaboration/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3901987359.mp3?updated=1678129643",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eaac5bb4-b6c1-11ed-99f5-37a13417ed67",
            "index": 151,
            "title": "Privacy and Security for Stable Diffusion and LLMs with Nicholas Carlini - #618",
            "pub_date": "2023-02-27T18:26:50.000Z",
            "duration": "2591",
            "duration_label": "43m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/privacy-and-security-for-stable-diffusion-and-llms/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1458183436.mp3?updated=1677518250",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5c68531c-b158-11ed-a504-036326a570c1",
            "index": 152,
            "title": "Understanding AI’s Impact on Social Disparities with Vinodkumar Prabhakaran - #617",
            "pub_date": "2023-02-20T20:12:00.000Z",
            "duration": "1874",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/understanding-ais-impact-on-social-disparities/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5105361031.mp3?updated=1676926562",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "79305c56-ac3f-11ed-9e52-1b10509cd8de",
            "index": 153,
            "title": "AI Trends 2023: Causality and the Impact on Large Language Models with Robert Osazuwa Ness - #616",
            "pub_date": "2023-02-14T12:00:00.000Z",
            "duration": "4920",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-trends-2023-causality-and-the-impact-on-large-language-models/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4478555625.mp3?updated=1676362713",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c999f7a-a647-11ed-84c2-83d6fd7fcf3b",
            "index": 154,
            "title": "Data-Centric Zero-Shot Learning for Precision Agriculture with Dimitris Zermas - #615",
            "pub_date": "2023-02-06T19:11:56.000Z",
            "duration": "1953",
            "duration_label": "32m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/data-centric-zero-shot-learning-for-precision-agriculture/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7212631212.mp3?updated=1675706368",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9bc828b0-a0ce-11ed-9427-ef74dbfdba82",
            "index": 155,
            "title": "How LLMs and Generative AI are Revolutionizing AI for Science with Anima Anandkumar - #614",
            "pub_date": "2023-01-30T19:02:26.000Z",
            "duration": "3704",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "nvidia"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/how-llms-and-generative-ai-are-revolutionizing-ai-for-science/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5251465738.mp3?updated=1675105620",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c411159e-9b4b-11ed-a9f3-df9befa5a620",
            "index": 156,
            "title": "AI Trends 2023: Natural Language Proc - ChatGPT, GPT-4 and Cutting Edge Research with Sameer Singh - #613",
            "pub_date": "2023-01-23T18:52:00.000Z",
            "duration": "6345",
            "duration_label": "1h 45m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "reasoning",
              "copilot"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-trends-2023-natural-language-proc-chatgpt-gpt-4-and-cutting-edge-research/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8614692045.mp3?updated=1674500282",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8f612b6-95c4-11ed-a87f-43f2babccc15",
            "index": 157,
            "title": "AI Trends 2023: Reinforcement Learning - RLHF, Robotic Pre-Training, and Offline RL with Sergey Levine - #612",
            "pub_date": "2023-01-16T17:49:21.000Z",
            "duration": "3580",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "training",
              "robotics"
            ],
            "page_url": "https://twimlai.com/go/612",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4574115607.mp3?updated=1673891120",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "76dce686-9056-11ed-b93f-cbca02783e69",
            "index": 158,
            "title": "Supporting Food Security in Africa Using ML with Catherine Nakalembe - #611",
            "pub_date": "2023-01-09T20:17:00.000Z",
            "duration": "3969",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/supporting-food-security-in-africa-using-ml/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5075227108.mp3?updated=1673295883",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3b1871c8-8abc-11ed-9e50-677d7c62bc1d",
            "index": 159,
            "title": "Service Cards and ML Governance with Michael Kearns - #610",
            "pub_date": "2023-01-02T17:05:00.000Z",
            "duration": "2348",
            "duration_label": "39m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/service-cards-and-ml-governance/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4416407284.mp3?updated=1672679454",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c418dd8-87a4-11ed-8ddf-f73f5b4174cc",
            "index": 160,
            "title": "Reinforcement Learning for Personalization at Spotify with Tony Jebara - #609",
            "pub_date": "2022-12-29T18:46:00.000Z",
            "duration": "2487",
            "duration_label": "41m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/reinforcement-learning-lifetime-value-at-spotify/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3651994906.mp3?updated=1672350192",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ce92c6c-8569-11ed-8617-a38c5199edcc",
            "index": 161,
            "title": "Will ChatGPT take my job? - #608",
            "pub_date": "2022-12-26T22:31:44.000Z",
            "duration": "2248",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt"
            ],
            "page_url": "https://twimlai.com/go/608",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2711691846.mp3?updated=1672094095",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "783972c6-8221-11ed-9ead-eb3641508ce5",
            "index": 162,
            "title": "Geospatial Machine Learning at AWS with Kumar Chellapilla - #607",
            "pub_date": "2022-12-22T17:55:00.000Z",
            "duration": "2206",
            "duration_label": "36m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/go/607",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4649651173.mp3?updated=1671731878",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f428ab5c-7fd0-11ed-af30-e319330d7368",
            "index": 163,
            "title": "Real-Time ML Workflows at Capital One with Disha Singla - #606",
            "pub_date": "2022-12-19T19:37:06.000Z",
            "duration": "2616",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/real-time-ml-workflows-at-capital-one/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5019407142.mp3?updated=1671477394",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6185d33a-7ca9-11ed-9bff-df9b83be9642",
            "index": 164,
            "title": "Weakly Supervised Causal Representation Learning with Johann Brehmer - #605",
            "pub_date": "2022-12-15T18:57:13.000Z",
            "duration": "2804",
            "duration_label": "46m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/go/605",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6256253212.mp3?updated=1671130544",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4ddea916-7a5f-11ed-b9de-43f2d1422a7a",
            "index": 165,
            "title": "Stable Diffusion & Generative AI with Emad Mostaque - #604",
            "pub_date": "2022-12-12T21:12:27.000Z",
            "duration": "2571",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety"
            ],
            "page_url": "https://twimlai.com/go/604",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6770658893.mp3?updated=1670879179",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70f69bea-76ac-11ed-ae30-8fd7607708f2",
            "index": 166,
            "title": "Exploring Large Language Models with ChatGPT - #603",
            "pub_date": "2022-12-08T16:28:00.000Z",
            "duration": "2190",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "large language model",
              "chatgpt",
              "training"
            ],
            "page_url": "https://twimlai.com/go/603",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8308128115.mp3?updated=1670517462",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a505286-74d1-11ed-9541-9f0536d9b69d",
            "index": 167,
            "title": "Accelerating Intelligence with AI-Generating Algorithms with Jeff Clune - #602",
            "pub_date": "2022-12-05T19:16:00.000Z",
            "duration": "3401",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "safety"
            ],
            "page_url": "https://twimlai.com/go/602",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1486446010.mp3?updated=1670267996",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b131132c-6f52-11ed-b860-371b3abf2a28",
            "index": 168,
            "title": "Programmatic Labeling and Data Scaling for Autonomous Commercial Aviation with Cedric Cocaud - #601",
            "pub_date": "2022-11-28T19:34:00.000Z",
            "duration": "3280",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/go/601",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1769464053.mp3?updated=1669837775",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6383f07c-69d5-11ed-9284-63321b2b4185",
            "index": 169,
            "title": "Engineering Production NLP Systems at T-Mobile with Heather Nolis - #600",
            "pub_date": "2022-11-21T19:49:40.000Z",
            "duration": "2633",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/go/600",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6930154670.mp3?updated=1669060374",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52f2334c-644c-11ed-868d-43cf9bf574ef",
            "index": 170,
            "title": "Sim2Real and Optimus, the Humanoid Robot with Ken Goldberg - #599",
            "pub_date": "2022-11-14T19:11:32.000Z",
            "duration": "2831",
            "duration_label": "47m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://twimlai.com/go/599",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5044224980.mp3?updated=1668453151",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a5fb4c4-5edb-11ed-b887-f7b803cc0320",
            "index": 171,
            "title": "The Evolution of the NLP Landscape with Oren Etzioni - #598",
            "pub_date": "2022-11-07T20:37:54.000Z",
            "duration": "3195",
            "duration_label": "53m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/go/598",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7359885583.mp3?updated=1667853796",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "41e47772-56dc-11ed-94f1-b3cc9ec67e39",
            "index": 172,
            "title": "Live from TWIMLcon! The Great MLOps Debate: End-to-End ML Platforms vs Specialized Tools - #597",
            "pub_date": "2022-10-31T19:22:33.000Z",
            "duration": "2879",
            "duration_label": "47m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/the-great-mlops-debate-end-to-end-ml-platforms-vs-specialized-tools/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4359601730.mp3?updated=1667243800",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e675856-53a3-11ed-9678-13021d801ef0",
            "index": 173,
            "title": "Live from TWIMLcon! You're not Facebook. Architecting MLOps for B2B Use Cases with Jacopo Tagliabue - #596",
            "pub_date": "2022-10-24T17:37:00.000Z",
            "duration": "2982",
            "duration_label": "49m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/youre-not-facebook-architecting-mlops-for-b2b-use-cases-with-jacopo-tagliabue/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6913215986.mp3?updated=1667243776",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d52414d4-4e26-11ed-af68-13b3f8b0406b",
            "index": 174,
            "title": "Building Foundational ML Platforms with Kubernetes and Kubeflow with Ali Rodell - #595",
            "pub_date": "2022-10-17T16:57:57.000Z",
            "duration": "2604",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/building-foundational-ml-platforms-with-kubernetes-and-kubeflow-with-ali-rodell/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3593135305.mp3?updated=1666025886",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dbcf889c-489d-11ed-b702-1b6b64e24184",
            "index": 175,
            "title": "AI-Powered Peer Programming with Vasi Philomin - #594",
            "pub_date": "2022-10-10T16:58:58.000Z",
            "duration": "2153",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "github copilot",
              "training",
              "coding",
              "copilot"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-powered-peer-programming-with-vasi-philomin/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9749131712.mp3?updated=1665420057",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90e35eaa-435a-11ed-8a48-eb8016a57d44",
            "index": 176,
            "title": "The Top 10 Reasons to Register for TWIMLcon: AI Platforms 2022!",
            "pub_date": "2022-10-03T21:26:15.000Z",
            "duration": "243",
            "duration_label": "4m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlcon.com",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5908005502.mp3?updated=1664829616",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d32f4826-3da3-11ed-8a0d-9bc92209a1d9",
            "index": 177,
            "title": "Applied AI/ML Research at PayPal with Vidyut Naware - #593",
            "pub_date": "2022-09-26T20:02:00.000Z",
            "duration": "1909",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/applied-ai-ml-research-at-paypal-with-vidyut-naware/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9579201730.mp3?updated=1664210836",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b8868b52-3825-11ed-8139-a76ebd2eed22",
            "index": 178,
            "title": "Assessing Data Quality at Shopify with Wendy Foster - #592",
            "pub_date": "2022-09-19T16:48:26.000Z",
            "duration": "2189",
            "duration_label": "36m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/assessing-data-quality-at-shopify-with-wendy-foster/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9843111618.mp3?updated=1663602973",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c938dce-32ac-11ed-8d82-ef0e71360142",
            "index": 179,
            "title": "Transformers for Tabular Data at Capital One with Bayan Bruss - #591",
            "pub_date": "2022-09-12T18:20:46.000Z",
            "duration": "2815",
            "duration_label": "46m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/transformers-for-tabular-data-at-capital-one-with-bayan-bruss/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5255571464.mp3?updated=1662995412",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6bb64696-2c72-11ed-8e18-a788b665f662",
            "index": 180,
            "title": "Understanding Collective Insect Communication with ML, w/ Orit Peleg - #590",
            "pub_date": "2022-09-05T16:00:00.000Z",
            "duration": "2233",
            "duration_label": "37m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/understanding-collective-insect-communication-with-ml-w-orig-peleg/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2203349859.mp3?updated=1662386514",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd0086a0-27a1-11ed-bb43-0b53ac3031a3",
            "index": 181,
            "title": "Multimodal, Multi-Lingual NLP at Hugging Face with John Bohannon and Douwe Kiela - #589",
            "pub_date": "2022-08-29T15:59:56.000Z",
            "duration": "3192",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/multimodal-multi-lingual-nlp-at-hugging-face-with-john-bohannon-and-douwe-kiela/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1809197965.mp3?updated=1661781520",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "faedcda0-2238-11ed-bc35-178e4332fa33",
            "index": 182,
            "title": "Synthetic Data Generation for Robotics with Bill Vass - #588",
            "pub_date": "2022-08-22T18:02:15.000Z",
            "duration": "2177",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/synthetic-data-generation-for-robotics-with-bill-vass/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3680125629.mp3?updated=1661186664",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5e2743f0-1ca4-11ed-bcd8-0f6a4c96d5f6",
            "index": 183,
            "title": "Multi-Device, Multi-Use-Case Optimization with Jeff Gehlhaar - #587",
            "pub_date": "2022-08-15T18:17:25.000Z",
            "duration": "2610",
            "duration_label": "43m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/multi-device-multi-use-case-optimization-with-jeff-gehlhaar/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9167325985.mp3?updated=1660573080",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c9092da2-1725-11ed-9472-035d8ba1f039",
            "index": 184,
            "title": "Causal Conceptions of Fairness and their Consequences with Sharad Goel - #586",
            "pub_date": "2022-08-08T16:57:58.000Z",
            "duration": "2237",
            "duration_label": "37m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/causal-conceptions-of-fairness-and-their-consequences-with-sharad-goel/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2714753035.mp3?updated=1659976341",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11b3f74e-11a4-11ed-a60b-03c84b0bddf8",
            "index": 185,
            "title": "Brain-Inspired Hardware and Algorithm Co-Design with Melika Payvand - #585",
            "pub_date": "2022-08-01T18:01:25.000Z",
            "duration": "2640",
            "duration_label": "44m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/brain-inspired-hardware-and-algorithm-co-design-with-melika-payvand/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6945094266.mp3?updated=1659367900",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fb00227a-0c21-11ed-b351-7b0ee305a5e2",
            "index": 186,
            "title": "Equivariant Priors for Compressed Sensing with Arash Behboodi - #584",
            "pub_date": "2022-07-25T17:26:00.000Z",
            "duration": "2370",
            "duration_label": "39m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/equivariant-priors-for-compressed-sensing-with-arash-behboodi/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3343945308.mp3?updated=1658766769",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9f7cc4a-06b1-11ed-b695-079edc0cdf95",
            "index": 187,
            "title": "Managing Data Labeling Ops for Success with Audrey Smith - #583",
            "pub_date": "2022-07-18T17:18:28.000Z",
            "duration": "2846",
            "duration_label": "47m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/managing-data-labeling-ops-for-success-with-audrey-smith/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2169604639.mp3?updated=1658160205",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "673e73fc-0122-11ed-b8ea-97a77182534a",
            "index": 188,
            "title": "Engineering an ML-Powered Developer-First Search Engine with Richard Socher - #582",
            "pub_date": "2022-07-11T17:09:00.000Z",
            "duration": "2792",
            "duration_label": "46m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/engineering-an-ml-powered-developer-first-search-engine-with-richard-socher/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6476385861.mp3?updated=1657816487",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "392c1a38-fba4-11ec-9efc-9b39834f8698",
            "index": 189,
            "title": "On The Path Towards Robot Vision with Aljosa Osep - #581",
            "pub_date": "2022-07-04T14:55:42.000Z",
            "duration": "2853",
            "duration_label": "47m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/on-the-path-towards-robot-vision-with-aljosa-osep/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5601181899.mp3?updated=1656944629",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f74f4d50-f62c-11ec-870a-479f9506d8d8",
            "index": 190,
            "title": "More Language, Less Labeling with Kate Saenko - #580",
            "pub_date": "2022-06-27T16:30:45.000Z",
            "duration": "2821",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/more-language-less-labeling-with-kate-saenko/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1978141586.mp3?updated=1656343653",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aab69e3c-f0ad-11ec-9f09-1b7537a718da",
            "index": 191,
            "title": "Optical Flow Estimation, Panoptic Segmentation, and Vision Transformers with Fatih Porikli - #579",
            "pub_date": "2022-06-20T17:18:00.000Z",
            "duration": "3077",
            "duration_label": "51m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/optical-flow-estimation-panoptic-segmentation-and-vision-transformers-with-fatih-porikli/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7412560198.mp3?updated=1656004317",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f31fff22-eb1e-11ec-b791-6b716e5f2dbe",
            "index": 192,
            "title": "Data Governance for Data Science with Adam Wood - #578",
            "pub_date": "2022-06-13T16:38:42.000Z",
            "duration": "2390",
            "duration_label": "39m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/podcast/twimlai/data-governance-for-data-science-with-adam-wood/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6420733548.mp3?updated=1655131926",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "78a141bc-e5a5-11ec-b74c-d7b1ae07956f",
            "index": 193,
            "title": "Feature Platforms for Data-Centric AI with Mike Del Balso - #577",
            "pub_date": "2022-06-06T19:28:59.000Z",
            "duration": "2763",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/feature-platforms-for-data-centric-ai-mike-del-balso/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1943469301.mp3?updated=1654531488",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af8cc574-e024-11ec-ac97-df971b319981",
            "index": 194,
            "title": "The Fallacy of \"Ground Truth\" with Shayan Mohanty - #576",
            "pub_date": "2022-05-30T19:21:51.000Z",
            "duration": "3070",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/the-fallacy-of-ground-turth-with-shayan-mohanty/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3166472959.mp3?updated=1653938198",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "df5aeac4-daac-11ec-963f-67ce2b6e0070",
            "index": 195,
            "title": "Principle-centric AI with Adrien Gaidon - #575",
            "pub_date": "2022-05-23T18:49:46.000Z",
            "duration": "2862",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/principal-centric-ai/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6448544023.mp3?updated=1653319957",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "102cf3c6-d789-11ec-b799-679b3b5a7051",
            "index": 196,
            "title": "Data Debt in Machine Learning with D. Sculley - #574",
            "pub_date": "2022-05-19T19:31:00.000Z",
            "duration": "2215",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/data-debt-in-machine-learning/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9846508088.mp3?updated=1652989017",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5472c68-d521-11ec-a690-9feac6c2665f",
            "index": 197,
            "title": "AI for Enterprise Decisioning at Scale with Rob Walker - #573",
            "pub_date": "2022-05-16T15:36:00.000Z",
            "duration": "2356",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/ai-for-enterprise-decisioning-at-scale/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2318949961.mp3?updated=1652715169",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9df273e-d20f-11ec-b834-1b5f8fc44474",
            "index": 198,
            "title": "Data Rights, Quantification and Governance for Ethical AI with Margaret Mitchell - #572",
            "pub_date": "2022-05-12T16:43:39.000Z",
            "duration": "2516",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/data-rights-quantification-and-governance-for-ethical-ai-with-margaret-mitchell/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3630063058.mp3?updated=1652373889",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fca24638-cfa1-11ec-9040-bf1ee1eeafee",
            "index": 199,
            "title": "Studying Machine Intelligence with Been Kim - #571",
            "pub_date": "2022-05-09T15:59:00.000Z",
            "duration": "3163",
            "duration_label": "52m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/studying-machine-intelligence-with-been-kim/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4267556716.mp3?updated=1652106035",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5069bdf8-c72a-11ec-af81-9391e70b46cd",
            "index": 200,
            "title": "Advances in Neural Compression with Auke Wiggers - #570",
            "pub_date": "2022-05-02T16:00:00.000Z",
            "duration": "2259",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://twimlai.com/podcast/twimlai/advances-in-neural-compression-with-auke-wiggers/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4995340338.mp3?updated=1653338112",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "16725c28-c49a-11ec-8d33-0344711978a8",
            "index": 201,
            "title": "Mixture-of-Experts and Trends in Large-Scale Language Modeling with Irwan Bello - #569",
            "pub_date": "2022-04-25T16:55:00.000Z",
            "duration": "2782",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "alignment",
              "retrieval",
              "ai startup"
            ],
            "page_url": "https://twimlai.com/mixture-of-experts-and-trends-in-large-scale-language-modeling-with-irwan-bello",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8997480332.mp3?updated=1650905108",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "21ee40f8-bc16-11ec-a489-5b97557dd51e",
            "index": 202,
            "title": "Daring to DAIR: Distributed AI Research with Timnit Gebru - #568",
            "pub_date": "2022-04-18T16:00:00.000Z",
            "duration": "3091",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://twimlai.com/daring-to-dair-distributed-ai-research-with-timnit-gebru",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4393614459.mp3?updated=1650294617",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cacfd330-b9a0-11ec-9c82-63f526d39084",
            "index": 203,
            "title": "Hierarchical and Continual RL with Doina Precup - #567",
            "pub_date": "2022-04-11T16:38:00.000Z",
            "duration": "3014",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "agent",
              "agents",
              "deepmind"
            ],
            "page_url": "https://twimlai.com/hierarchical-and-continual-rl-with-doina-precup",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8692483452.mp3?updated=1649695228",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ffcbc766-b42c-11ec-950b-3f09f7b9d1ef",
            "index": 204,
            "title": "Open-Source Drug Discovery with DeepChem with Bharath Ramsundar - #566",
            "pub_date": "2022-04-04T16:01:00.000Z",
            "duration": "1781",
            "duration_label": "29m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/open-source-drug-discovery-with-deepchem-with-bharath-ramsundar",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN1027529188.mp3?updated=1649088203",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8360f79c-aea4-11ec-8f34-8389704d0219",
            "index": 205,
            "title": "Advancing Hands-On Machine Learning Education with Sebastian Raschka - #565",
            "pub_date": "2022-03-28T16:18:00.000Z",
            "duration": "2456",
            "duration_label": "40m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/advancing-hands-on-machine-learning-education-with-sebastian-raschka",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2914060869.mp3?updated=1648478514",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "43caa848-a923-11ec-8852-47b78ede9717",
            "index": 206,
            "title": "Big Science and Embodied Learning at Hugging Face 🤗 with Thomas Wolf - #564",
            "pub_date": "2022-03-21T16:00:00.000Z",
            "duration": "2844",
            "duration_label": "47m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/big-science-and-embodied-learning-at-hugging-face-%F0%9F%A4%97-with-thomas-wolf",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3025083723.mp3?updated=1647874472",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bca1d8bc-a3a2-11ec-a086-1b5661e80123",
            "index": 207,
            "title": "Full-Stack AI Systems Development with Murali Akula - #563",
            "pub_date": "2022-03-14T16:07:00.000Z",
            "duration": "2641",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chips",
              "training"
            ],
            "page_url": "https://twimlai.com/full-stack-ai-systems-development-with-murali-akula",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6447919312.mp3?updated=1647274353",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2b4b2140-9e23-11ec-8fcb-4f9cdabe554b",
            "index": 208,
            "title": "100x Improvements in Deep Learning Performance with Sparsity, w/ Subutai Ahmad - #562",
            "pub_date": "2022-03-07T17:08:00.000Z",
            "duration": "3057",
            "duration_label": "50m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/100x-improvements-in-deep-learning-performance-with-sparsity-with-subutai-ahmad",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8969271295.mp3?updated=1646757287",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "39979608-98a0-11ec-9782-af0ff7ea19dc",
            "index": 209,
            "title": "Scaling BERT and GPT for Financial Services with Jennifer Glore - #561",
            "pub_date": "2022-02-28T16:55:00.000Z",
            "duration": "2650",
            "duration_label": "44m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/scaling-bert-and-gpt-3-for-financial-services-with-jennifer-glore",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2647368573.mp3?updated=1647457811",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5ac42dd0-9320-11ec-86f9-57751217a757",
            "index": 210,
            "title": "Trends in Deep Reinforcement Learning with Kamyar Azizzadenesheli - #560",
            "pub_date": "2022-02-21T17:05:54.000Z",
            "duration": "4677",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://twimlai.com/trends-in-deep-reinforcement-learning-with-kamyar-azizzadenesheli",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8379623439.mp3?updated=1645456168",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9dc4502-8db7-11ec-b3ab-07b979d35e07",
            "index": 211,
            "title": "Deep Reinforcement Learning at the Edge of the Statistical Precipice with Rishabh Agarwal - #559",
            "pub_date": "2022-02-14T17:57:14.000Z",
            "duration": "3111",
            "duration_label": "51m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/deep-reinforcement-learning-at-the-edge-of-the-statistical-precipice-with-rishabh-agarwal",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2730828604.mp3?updated=1644861670",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "229e87de-8826-11ec-8c0c-1fb77dcd59dc",
            "index": 212,
            "title": "Designing New Energy Materials with Machine Learning with Rafael Gomez-Bombarelli - #558",
            "pub_date": "2022-02-07T17:00:00.000Z",
            "duration": "3209",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://twimlai.com/designing-new-energy-materials-with-machine-learning-with-rafael-gomez-bombarelli",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3976996749.mp3?updated=1644246268",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ae51d752-82b0-11ec-a29b-1717865a83a0",
            "index": 213,
            "title": "Differentiable Programming for Oceanography with Patrick Heimbach - #557",
            "pub_date": "2022-01-31T17:42:00.000Z",
            "duration": "2050",
            "duration_label": "34m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/differentiable-programming-for-oceanography-with-patrick-heimbach",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2566750606.mp3?updated=1643646243",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5659bd54-7edb-11ec-a5f0-13168b49f394",
            "index": 214,
            "title": "Trends in Machine Learning & Deep Learning with Zachary Lipton - #556",
            "pub_date": "2022-01-27T17:31:53.000Z",
            "duration": "4127",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/trends-in-machine-learning-deep-learning-with-zachary-lipton",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2239640387.mp3?updated=1643304907",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f9558cde-7d34-11ec-a52b-23992b739957",
            "index": 215,
            "title": "Solving the Cocktail Party Problem with Machine Learning, w/ ‪Jonathan Le Roux - #555",
            "pub_date": "2022-01-24T17:14:00.000Z",
            "duration": "2136",
            "duration_label": "35m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/solving-the-cocktail-party-problem-with-machine-learning-w-jonathan-le-roux/",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8311241228.mp3?updated=1643044781",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "715579cc-7a0d-11ec-8e27-4f4c4b400248",
            "index": 216,
            "title": "Machine Learning for Earthquake Seismology with Karianne Bergen - #554",
            "pub_date": "2022-01-20T17:12:57.000Z",
            "duration": "2145",
            "duration_label": "35m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/machine-learning-for-earthquake-seismology-with-karianne-bergen",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6724353404.mp3?updated=1642696550",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d169c12a-77af-11ec-a563-87fb602f1e11",
            "index": 217,
            "title": "The New DBfication of ML/AI with Arun Kumar - #553",
            "pub_date": "2022-01-17T17:22:40.000Z",
            "duration": "2768",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/the-new-dbfication-of-ml-ai-with-arun-kumar",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5271518840.mp3?updated=1642440195",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3430854c-7485-11ec-b7f7-1b9c82558ca0",
            "index": 218,
            "title": "Building Public Interest Technology with Meredith Broussard - #552",
            "pub_date": "2022-01-13T18:05:00.000Z",
            "duration": "1816",
            "duration_label": "30m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://twimlai.com/building-public-interest-technology-with-meredith-broussard",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9824697941.mp3?updated=1642088065",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "473e2380-7235-11ec-b316-57b5d5fb5114",
            "index": 219,
            "title": "A Universal Law of Robustness via Isoperimetry with Sebastien Bubeck - #551",
            "pub_date": "2022-01-10T17:23:00.000Z",
            "duration": "2344",
            "duration_label": "39m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/a-universal-law-of-robustness-via-isoperimetry-with-sebastien-bubeck",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4474024742.mp3?updated=1641836796",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac1448d2-6f17-11ec-899b-7f1f4f7f0f1f",
            "index": 220,
            "title": "Trends in NLP with John Bohannon - #550",
            "pub_date": "2022-01-06T18:07:55.000Z",
            "duration": "4706",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/trends-in-nlp-with-john-bohannon",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6865397821.mp3?updated=1641491337",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca95e0ce-6cc2-11ec-91bc-fb5c84eb9e0f",
            "index": 221,
            "title": "Trends in Computer Vision with Georgia Gkioxari - #549",
            "pub_date": "2022-01-03T20:09:00.000Z",
            "duration": "3497",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai"
            ],
            "page_url": "https://twimlai.com/trends-in-computer-vision-with-georgia-gkioxari",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6045719325.mp3?updated=1641235093",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1920c30e-64c5-11ec-ac22-eb223aaad2ce",
            "index": 222,
            "title": "Kids Run the Darndest Experiments: Causal Learning in Children with Alison Gopnik - #548",
            "pub_date": "2021-12-27T17:10:00.000Z",
            "duration": "2214",
            "duration_label": "36m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "inference",
              "training"
            ],
            "page_url": "https://twimlai.com/kids-run-the-darndest-experiments-causal-learning-in-children-with-alison-gopnik",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9628929497.mp3?updated=1640368884",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff3ddd26-6412-11ec-84ee-fbd59697abd4",
            "index": 223,
            "title": "Hypergraphs, Simplicial Complexes and Graph Representations of Complex Systems with Tina Eliassi-Rad - #547",
            "pub_date": "2021-12-23T17:46:34.000Z",
            "duration": "2140",
            "duration_label": "35m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/hypergraphs-simplicial-complexes-and-graph-representations-of-complex-systems-with-tina-eliassi-rad",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4465302159.mp3?updated=1640279981",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "27d24614-61b1-11ec-8b02-738e831bf079",
            "index": 224,
            "title": "Deep Learning, Transformers, and the Consequences of Scale with Oriol Vinyals - #546",
            "pub_date": "2021-12-20T16:29:33.000Z",
            "duration": "3163",
            "duration_label": "52m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "deepmind",
              "multimodal"
            ],
            "page_url": "https://twimlai.com/deep-learning-transformers-and-the-consequences-of-scale-with-oriol-vinyals",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8066118479.mp3?updated=1640018051",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8ed3cca-5e90-11ec-9f73-43f0d5a8d2b3",
            "index": 225,
            "title": "Optimization, Machine Learning and Intelligent Experimentation with Michael McCourt - #545",
            "pub_date": "2021-12-16T17:49:07.000Z",
            "duration": "2757",
            "duration_label": "45m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/optimization-machine-learning-and-intelligent-experimentation-with-michael-mccourt",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8341176772.mp3?updated=1639674802",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8fcd2492-5c2e-11ec-9d2c-4f4ff466eeb3",
            "index": 226,
            "title": "Jupyter and the Evolution of ML Tooling with Brian Granger - #544",
            "pub_date": "2021-12-13T17:00:00.000Z",
            "duration": "3429",
            "duration_label": "57m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/jupyter-and-the-evolution-of-ml-tooling-with-brian-granger",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8689987287.mp3?updated=1639412134",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fcb5480a-5904-11ec-928b-bfb9249deb0d",
            "index": 227,
            "title": "Creating a Data-Driven Culture at ADP with Jack Berkowitz - #543",
            "pub_date": "2021-12-09T16:46:00.000Z",
            "duration": "2084",
            "duration_label": "34m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/creating-a-data-driven-culture-at-adp-with-jack-berkowitz",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2746439881.mp3?updated=1639172238",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e12bd87c-56b8-11ec-9aa2-3fa9bf4c220a",
            "index": 228,
            "title": "re:Invent Roundup 2021 with Bratin Saha - #542",
            "pub_date": "2021-12-06T18:33:35.000Z",
            "duration": "2494",
            "duration_label": "41m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "http://twimlai.com/reinvent-roundup-2021-with-bratin-saha",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4464933497.mp3?updated=1638814479",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89b906de-537d-11ec-80c8-4719b6ad8285",
            "index": 229,
            "title": "Multi-modal Deep Learning for Complex Document Understanding with Doug Burdick - #541",
            "pub_date": "2021-12-02T16:31:39.000Z",
            "duration": "2732",
            "duration_label": "45m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "multimodal"
            ],
            "page_url": "https://twimlai.com/multi-modal-deep-learning-for-complex-document-understanding-with-doug-burdick",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7086620209.mp3?updated=1638463010",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8e28c1f8-5131-11ec-9d9d-ab8430aca506",
            "index": 230,
            "title": "Predictive Maintenance Using Deep Learning and Reliability Engineering with Shayan Mortazavi - #540",
            "pub_date": "2021-11-29T18:58:41.000Z",
            "duration": "2941",
            "duration_label": "49m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/predictive-maintenance-using-deep-learning-and-reliability-engineering-with-shayan-mortazavi",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9126478953.mp3?updated=1638204336",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90aa51d2-4d3d-11ec-8ea4-cf0b586ab568",
            "index": 231,
            "title": "Building a Deep Tech Startup in NLP with Nasrin Mostafazadeh - #539",
            "pub_date": "2021-11-24T17:17:27.000Z",
            "duration": "3080",
            "duration_label": "51m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/building-a-deep-tech-startup-in-nlp-with-nasrin-mostafazadeh",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2316771707.mp3?updated=1637772968",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a592886-4bb0-11ec-8e96-6bb0ace874c6",
            "index": 232,
            "title": "Models for Human-Robot Collaboration with Julie Shah - #538",
            "pub_date": "2021-11-22T19:07:30.000Z",
            "duration": "2531",
            "duration_label": "42m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "training",
              "robotics"
            ],
            "page_url": "https://twimlai.com/models-for-human-robot-collaboration-with-julie-shah",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7932649064.mp3?updated=1637608300",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "907241a4-488b-11ec-a926-9bcb15a8c105",
            "index": 233,
            "title": "Four Key Tools for Robust Enterprise NLP with Yunyao Li - #537",
            "pub_date": "2021-11-18T18:29:49.000Z",
            "duration": "3481",
            "duration_label": "58m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/four-key-tools-for-robust-enterprise-nlp-with-yunyao-li",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4167430111.mp3?updated=1637254403",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de4fad7e-4630-11ec-a4fb-a3891b78d907",
            "index": 234,
            "title": "Machine Learning at GSK with Kim Branson - #536",
            "pub_date": "2021-11-15T19:30:00.000Z",
            "duration": "3636",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://twimlai.com/machine-learning-at-gsk-with-kim-branson",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6932992097.mp3?updated=1645156627",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f04379fc-4310-11ec-9f39-233e1b20cafc",
            "index": 235,
            "title": "The Benefit of Bottlenecks in Evolving Artificial Intelligence with David Ha - #535",
            "pub_date": "2021-11-11T17:57:25.000Z",
            "duration": "3544",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "artificial intelligence",
              "agents",
              "training"
            ],
            "page_url": "https://twimlai.com/the-benefit-of-bottlenecks-in-evolving-artificial-intelligence-with-david-ha",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8752647669.mp3?updated=1636651092",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6ad0be54-40ba-11ec-a1a1-cbf12806a313",
            "index": 236,
            "title": "Facebook Abandons Facial Recognition. Should Everyone Else Follow Suit? With Luke Stark - #534",
            "pub_date": "2021-11-08T18:24:53.000Z",
            "duration": "2528",
            "duration_label": "42m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://twimlai.com/facebook-abandons-facial-recognition-should-everyone-else-follow-suit-with-luke-stark",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6837127374.mp3?updated=1636394075",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c29a2f6-3d83-11ec-a0e9-5b573385faa6",
            "index": 237,
            "title": "Building Blocks of Machine Learning at LEGO with Francesc Joan Riera - #533",
            "pub_date": "2021-11-04T17:05:18.000Z",
            "duration": "2593",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/building-blocks-of-machine-learning-at-lego-with-francesc-joan-riera",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN7096052689.mp3?updated=1636039752",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ced936fc-3b1e-11ec-91ef-736f64d9a9d8",
            "index": 238,
            "title": "Exploring the FastAI Tooling Ecosystem with Hamel Husain - #532",
            "pub_date": "2021-11-01T18:33:00.000Z",
            "duration": "2378",
            "duration_label": "39m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/exploring-the-fastai-tooling-ecosystem-with-hamel-husain",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8772542123.mp3?updated=1635790862",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc4d06f2-380c-11ec-bdba-4fc07800e8f6",
            "index": 239,
            "title": "Multi-task Learning for Melanoma Detection with Julianna Ianni - #531",
            "pub_date": "2021-10-28T18:50:00.000Z",
            "duration": "2253",
            "duration_label": "37m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/multi-task-learning-for-melanoma-detection-with-julianna-ianni",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8690549328.mp3?updated=1635444920",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "82fd5bf8-35a3-11ec-a477-5bb6c9524d0c",
            "index": 240,
            "title": "House Hunters: Machine Learning at Redfin with Akshat Kaul - #530",
            "pub_date": "2021-10-26T06:20:00.000Z",
            "duration": "2674",
            "duration_label": "44m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/house-hunters-ml-at-redfin-with-akshat-kaul",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8521017012.mp3?updated=1635436308",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89313ace-3280-11ec-8e02-33fbec9be05a",
            "index": 241,
            "title": "Attacking Malware with Adversarial Machine Learning, w/ Edward Raff - #529",
            "pub_date": "2021-10-21T16:36:00.000Z",
            "duration": "2798",
            "duration_label": "46m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/attacking-malware-with-adversarial-machine-learning-w-edward-raff",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9823997975.mp3?updated=1634835318",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a448156-3033-11ec-a3f1-5771a93dda7b",
            "index": 242,
            "title": "Learning to Ponder: Memory in Deep Neural Networks with Andrea Banino - #528",
            "pub_date": "2021-10-18T17:47:25.000Z",
            "duration": "2232",
            "duration_label": "37m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "deepmind"
            ],
            "page_url": "https://twimlai.com/learning-to-ponder-memory-in-deep-neural-networks-with-andrea-banino",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN9695778611.mp3?updated=1634577579",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "23edb710-2c53-11ec-b3b4-f3ad924a8c17",
            "index": 243,
            "title": "Advancing Deep Reinforcement Learning with NetHack, w/ Tim Rocktäschel - #527",
            "pub_date": "2021-10-14T15:51:00.000Z",
            "duration": "2577",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "training"
            ],
            "page_url": "https://twimlai.com/advancing-deep-reinforcement-learning-with-nethack-w-tim-rocktaschel",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN8105888186.mp3?updated=1634307872",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ea99980-291a-11ec-898b-bf6e6ce44d14",
            "index": 244,
            "title": "Building Technical Communities at Stack Overflow with Prashanth Chandrasekar - #526",
            "pub_date": "2021-10-11T17:58:14.000Z",
            "duration": "2445",
            "duration_label": "40m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/building-technical-communities-at-stack-overflow-with-prashanth-chandrasekar",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN2244964253.mp3?updated=1633967726",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cba3e77c-277b-11ec-aed7-0b96f3d110a2",
            "index": 245,
            "title": "Deep Learning is Eating 5G. Here’s How, w/ Joseph Soriaga - #525",
            "pub_date": "2021-10-07T16:21:00.000Z",
            "duration": "2378",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://twimlai.com/deep-learning-is-eating-5g-heres-how-w-joseph-soriaga",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4672052420.mp3?updated=1633627195",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d3fd4c1e-24ca-11ec-b7d4-2b0a979b1967",
            "index": 246,
            "title": "Modeling Human Cognition with RNNs and Curriculum Learning, w/ Kanaka Rajan - #524",
            "pub_date": "2021-10-04T16:36:00.000Z",
            "duration": "2828",
            "duration_label": "47m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://twimlai.com/modeling-memory-with-rnns-and-curriculum-learning-w-kanaka-rajan",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3653817139.mp3?updated=1633627174",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d08bbc52-2158-11ec-8a0f-777ea641a9d1",
            "index": 247,
            "title": "Do You Dare Run Your ML Experiments in Production? with Ville Tuulos - #523",
            "pub_date": "2021-09-30T16:15:24.000Z",
            "duration": "2441",
            "duration_label": "40m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/do-you-dare-run-your-ml-experiments-in-production-with-ville-tuulos",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN6878174259.mp3?updated=1633018232",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "addaa4c0-1faf-11ec-8dae-ffe557d8f82e",
            "index": 248,
            "title": "Delivering Neural Speech Services at Scale with Li Jiang - #522",
            "pub_date": "2021-09-27T17:32:30.000Z",
            "duration": "2960",
            "duration_label": "49m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://twimlai.com/delivering-neural-speech-services-at-scale-with-li-jiang",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN5772250958.mp3?updated=1632761970",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aad717da-1bc3-11ec-b732-93e625d38f23",
            "index": 249,
            "title": "AI’s Legal and Ethical Implications with Sandra Wachter - #521",
            "pub_date": "2021-09-23T16:27:16.000Z",
            "duration": "2967",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://twimlai.com/ais-legal-and-ethical-implications-with-sandra-wachter",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN4579692160.mp3?updated=1632414266",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ace387c-1a28-11ec-801f-ef3d9460527c",
            "index": 250,
            "title": "Compositional ML and the Future of Software Development with Dillon Erb - #520",
            "pub_date": "2021-09-20T19:46:36.000Z",
            "duration": "2474",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://twimlai.com/compositional-ml-and-the-future-of-software-development-with-dillon-erb",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/MLN3219202242.mp3?updated=1632157746",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "acquired",
        "title": "Acquired",
        "feed_title": "Acquired",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "company history",
          "strategy",
          "AI companies"
        ],
        "feed_url": "https://feeds.transistor.fm/acquired",
        "source_url": "https://feeds.transistor.fm/acquired",
        "detail_path": "/podcasts/acquired/",
        "episode_count": 214,
        "selected_episode_count": 207,
        "latest_episode_title": "Vanguard",
        "latest_pub_date": "2026-05-18T03:26:52.000Z",
        "latest_page_url": "https://www.acquired.fm/episodes/vanguard",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "465f9bb3-6d71-49ed-a233-de82bc41b034",
            "index": 1,
            "title": "Vanguard",
            "pub_date": "2026-05-18T03:26:52.000Z",
            "duration": "13685",
            "duration_label": "3h 48m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.acquired.fm/episodes/vanguard",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ee9d0817/c12627bd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5ad38cec-40ac-43e1-bc70-1c32617e4573",
            "index": 2,
            "title": "Ferrari",
            "pub_date": "2026-04-13T03:33:59.000Z",
            "duration": "14360",
            "duration_label": "3h 59m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.acquired.fm/episodes/ferrari",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/9ca1df08/e400ba0d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "82044eb3-e350-42c5-a799-2a2afc150e99",
            "index": 3,
            "title": "Formula 1",
            "pub_date": "2026-03-02T22:18:59.000Z",
            "duration": "16171",
            "duration_label": "4h 29m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://www.acquired.fm/episodes/formula-1",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/93e7bac7/9d4b12b6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 1013,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "772a1689-5d6a-4d66-8469-95b8eb41dfd3",
            "index": 4,
            "title": "The NFL",
            "pub_date": "2026-01-27T02:50:40.000Z",
            "duration": "15438",
            "duration_label": "4h 17m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.acquired.fm/episodes/the-nfl",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/87d6503d/b2af8272.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "94dbf581-80c8-4b90-aff2-fa649cd90edd",
            "index": 5,
            "title": "Rolex",
            "pub_date": "2026-01-03T04:34:00.000Z",
            "duration": "17952",
            "duration_label": "4h 59m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/rolex",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/7bea4e45/0aa48fa3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 1195,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "14ef00c6-30ba-44cc-9869-33d3d92828a3",
            "index": 6,
            "title": "Costco",
            "pub_date": "2026-01-02T05:46:00.000Z",
            "duration": "10876",
            "duration_label": "3h 1m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/costco",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/fcf31c71/acf1c31d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 543,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c9b69067-78a8-43f4-9a12-b4522af47d1b",
            "index": 7,
            "title": "10 Years of Acquired (with Michael Lewis)",
            "pub_date": "2025-12-15T04:19:45.000Z",
            "duration": "10057",
            "duration_label": "2h 47m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.acquired.fm/episodes/10-years-of-acquired-with-michael-lewis",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/0f470567/18269289.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4537f61d-0ec1-4837-92e0-9270d140e6d2",
            "index": 8,
            "title": "Coca-Cola",
            "pub_date": "2025-11-24T03:00:17.000Z",
            "duration": "14482",
            "duration_label": "4h 1m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "https://www.acquired.fm/episodes/coca-cola",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/95f9fcf7/68ea94eb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 954,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9602cea2-2491-4587-90f6-7bf7f7988dd7",
            "index": 9,
            "title": "Trader Joe’s",
            "pub_date": "2025-10-27T03:07:10.000Z",
            "duration": "12336",
            "duration_label": "3h 25m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/trader-joes",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/8d72cb9c/19650029.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 908,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "b0014fa0-de13-4d3e-b5f3-cbe3fc463bb1",
            "index": 10,
            "title": "Google Part III: The AI Company",
            "pub_date": "2025-10-06T01:35:54.000Z",
            "duration": "14632",
            "duration_label": "4h 3m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "deepmind",
              "gemini"
            ],
            "page_url": "https://www.acquired.fm/episodes/google-the-ai-company",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/701dc613/9f822931.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 318,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 1,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "f936519e-86fa-4621-9f05-523aa77ab2f3",
            "index": 11,
            "title": "Acquired Live at Radio City Music Hall (Presented by J.P. Morgan)",
            "pub_date": "2025-10-01T03:08:00.000Z",
            "duration": "78",
            "duration_label": "1m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.acquired.fm/episodes/acquired-live-at-radio-city-music-hall-presented-by-j-p-morgan",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6f730593/d29fa674.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ab5cd9d1-109d-49fd-9dc7-e01238da38ea",
            "index": 12,
            "title": "Google Part II: Alphabet",
            "pub_date": "2025-08-26T10:19:06.000Z",
            "duration": "15001",
            "duration_label": "4h 10m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "https://www.acquired.fm/episodes/alphabet-inc",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/8296b628/7f670b87.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 925,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "2a660c44-6ee2-4c68-b107-9c4a1e1704f3",
            "index": 13,
            "title": "The Jamie Dimon Interview",
            "pub_date": "2025-07-16T14:18:04.000Z",
            "duration": "4081",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/the-jamie-dimon-interview",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/621b1ddd/5b08fc34.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 161,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 6,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "3c13a02f-2836-484e-a29e-c6829e462e8f",
            "index": 14,
            "title": "Google Part I: Origins of Search",
            "pub_date": "2025-06-30T03:11:14.000Z",
            "duration": "13027",
            "duration_label": "3h 37m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://www.acquired.fm/episodes/google",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d927288f/d5b2a4ff.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 1061,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "d1855fd5-833e-4ec3-8e2f-c610be0aa6ca",
            "index": 15,
            "title": "The Steve Ballmer Interview",
            "pub_date": "2025-06-02T01:54:06.000Z",
            "duration": "10587",
            "duration_label": "2h 56m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/the-steve-ballmer-interview",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6a598848/caeda411.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 595,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "a9bc0cf6-824d-4e9d-86cb-532734a3b2a3",
            "index": 16,
            "title": "Epic Systems (MyChart)",
            "pub_date": "2025-04-21T02:04:52.000Z",
            "duration": "14067",
            "duration_label": "3h 54m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/epic-systems-mychart",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/da990430/4c8bb4df.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 777,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 1,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "d7c80edb-6b20-493c-9362-1f2d94f5df4b",
            "index": 17,
            "title": "Indian Premier League Cricket",
            "pub_date": "2025-03-24T01:39:34.000Z",
            "duration": "15942",
            "duration_label": "4h 25m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/indian-premier-league-cricket",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c5d05bfb/3bc12ad7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 922,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 3,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "a2fe3257-19eb-48f1-b08e-b815af25cc28",
            "index": 18,
            "title": "TSMC Founder Morris Chang",
            "pub_date": "2025-01-27T02:35:00.000Z",
            "duration": "10540",
            "duration_label": "2h 55m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "anthropic",
              "nvidia",
              "chip"
            ],
            "page_url": "https://www.acquired.fm/episodes/tsmc-founder-morris-chang",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/9a264053/327df5d5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 377,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 9,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "9ab7f5fd-7774-4c48-8d0b-001b8c682c9d",
            "index": 19,
            "title": "Mars Inc. (the chocolate story)",
            "pub_date": "2024-12-16T01:57:15.000Z",
            "duration": "13918",
            "duration_label": "3h 51m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/mars-inc-the-chocolate-story",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/65646a4e/4312fe62.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 492,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a5b37145-4d48-4f26-8861-36153ac02fdd",
            "index": 20,
            "title": "IKEA",
            "pub_date": "2024-11-18T04:42:39.000Z",
            "duration": "12039",
            "duration_label": "3h 20m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/ikea",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/51775457/5b90483f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 543,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8ec77b67-4efc-4c62-80b2-05476897d2f2",
            "index": 21,
            "title": "Meta",
            "pub_date": "2024-10-28T00:34:11.000Z",
            "duration": "22727",
            "duration_label": "6h 18m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://www.acquired.fm/episodes/meta",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/e7afa25f/df59e4a6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "99d7dbec-4709-40d8-acf1-645d2b9e65e6",
            "index": 22,
            "title": "Acquired LIVE from Chase Center (with Daniel Ek, Emily Chang, Jensen Huang and Mark Zuckerberg)",
            "pub_date": "2024-09-30T05:27:52.000Z",
            "duration": "8706",
            "duration_label": "2h 25m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/acquired-live-from-chase-center-with-daniel-ek-emily-chang-jensen-huang-and-mark-zuckerberg",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5e2176c1/21583c01.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 475,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "672f2993-b496-4d4b-968f-49f663807244",
            "index": 23,
            "title": "The Mark Zuckerberg Interview",
            "pub_date": "2024-09-18T05:46:38.000Z",
            "duration": "5346",
            "duration_label": "1h 29m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/the-mark-zuckerberg-interview",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/edc5c37f/ed90b432.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 206,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 11,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "4baddc5c-0bbc-4315-9b27-63ab9e88dabf",
            "index": 24,
            "title": "Chase Center + Summer Update",
            "pub_date": "2024-08-08T20:39:49.000Z",
            "duration": "1313",
            "duration_label": "21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/db73bbc2",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/db73bbc2/d569819b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9f28baa-853a-47bb-a600-059d0067691e",
            "index": 25,
            "title": "Microsoft Volume II",
            "pub_date": "2024-07-22T02:43:05.000Z",
            "duration": "17368",
            "duration_label": "4h 49m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/microsoft-volume-ii",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/54402842/6376d479.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 878,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "5bb96f28-43cb-4e0d-909a-f1ff11a5d881",
            "index": 26,
            "title": "Starbucks (with Howard Schultz)",
            "pub_date": "2024-06-04T05:32:06.000Z",
            "duration": "11660",
            "duration_label": "3h 14m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/starbucks-with-howard-schultz",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d666b03b/9d34db72.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 710,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "c4a8c088-76af-4a04-b6ab-db7bad44cf04",
            "index": 27,
            "title": "Microsoft Volume I",
            "pub_date": "2024-04-22T00:54:18.000Z",
            "duration": "15831",
            "duration_label": "4h 23m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/microsoft",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/9096dcf8/9f4e0983.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 805,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 1,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "88f34088-9b5d-43fe-ac5f-d5a233647de5",
            "index": 28,
            "title": "Renaissance Technologies",
            "pub_date": "2024-03-18T00:54:40.000Z",
            "duration": "11280",
            "duration_label": "3h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "artificial intelligence",
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/renaissance-technologies",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/fb475478/8b97c4da.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 585,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "7fa2f476-fe1f-4c73-916a-6db4c935a47b",
            "index": 29,
            "title": "Hermès",
            "pub_date": "2024-02-20T01:56:41.000Z",
            "duration": "14921",
            "duration_label": "4h 8m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "perplexity"
            ],
            "page_url": "https://www.acquired.fm/episodes/hermes",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/2955b2d1/eddac77d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 862,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5a2c6c1e-c7d4-4434-817c-b1669bb5792a",
            "index": 30,
            "title": "Novo Nordisk (Ozempic)",
            "pub_date": "2024-01-22T01:59:45.000Z",
            "duration": "13414",
            "duration_label": "3h 43m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/novo-nordisk-ozempic",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/79c99c63/252e4ab9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 580,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "7a8cf2b1-8262-4e5b-bfc2-5d275d3d81f6",
            "index": 31,
            "title": "Holiday Special 2023",
            "pub_date": "2023-12-18T04:02:31.000Z",
            "duration": "8265",
            "duration_label": "2h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/holiday-special-2023",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d8b4b416/a0d7e492.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 441,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "dcbc5a22-0354-420a-879d-634c236ad5df",
            "index": 32,
            "title": "Visa",
            "pub_date": "2023-11-27T00:24:25.000Z",
            "duration": "13452",
            "duration_label": "3h 44m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/visa",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/e6dc5879/6c10261a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 625,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "eb856085-2330-4cdb-8d6d-eb6ec9948791",
            "index": 33,
            "title": "Charlie Munger",
            "pub_date": "2023-10-30T01:49:26.000Z",
            "duration": "4006",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.acquired.fm/episodes/charlie-munger",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c100f364/6ce4bb67.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1be0cf12-72b7-4bdb-827f-0fe38425ffa3",
            "index": 34,
            "title": "NVIDIA CEO Jensen Huang",
            "pub_date": "2023-10-16T03:09:44.000Z",
            "duration": "5475",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "anthropic",
              "nvidia",
              "datacenter"
            ],
            "page_url": "https://www.acquired.fm/episodes/jensen-huang",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f7c6423c/8aafaefd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 241,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "09424666-1111-43fc-8355-1d162efc3631",
            "index": 35,
            "title": "Nvidia Part III: The Dawn of the AI Era (2022-2023)",
            "pub_date": "2023-09-06T06:47:30.000Z",
            "duration": "10502",
            "duration_label": "2h 55m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://www.acquired.fm/episodes/nvidia-the-dawn-of-the-ai-era",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d24a9a1c/c02fb7eb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 469,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 7,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "1b6f99a2-dcf5-4adb-9b59-269902b1bcb3",
            "index": 36,
            "title": "Nike",
            "pub_date": "2023-07-25T04:15:18.000Z",
            "duration": "14511",
            "duration_label": "4h 1m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/nike",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/0e9e01b4/8e365040.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 649,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1e63c28d-d179-47a6-8f4d-254f51e477bf",
            "index": 37,
            "title": "Porsche (with Doug DeMuro)",
            "pub_date": "2023-06-27T04:10:27.000Z",
            "duration": "12187",
            "duration_label": "3h 23m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/porsche-with-doug-demuro",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ac97c21d/a169f6b6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 766,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 1,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "81cfd12f-dff9-46b4-8512-16f6807c8f5e",
            "index": 38,
            "title": "Uber CEO Dara Khosrowshahi",
            "pub_date": "2023-06-13T02:35:07.000Z",
            "duration": "5879",
            "duration_label": "1h 37m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/uber-ceo-dara-khosrowshahi",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/fa52efad/b2335129.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 299,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "8b8a5e98-b290-4edd-8e3c-e105cccebe9b",
            "index": 39,
            "title": "Lockheed Martin",
            "pub_date": "2023-05-30T05:02:40.000Z",
            "duration": "13115",
            "duration_label": "3h 38m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/lockheed-martin",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/8575303c/3721964e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 618,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "76a5df5d-600f-493b-9b8e-791cb6ee53b3",
            "index": 40,
            "title": "Spotify CEO Daniel Ek",
            "pub_date": "2023-05-18T00:32:18.000Z",
            "duration": "5942",
            "duration_label": "1h 39m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/spotify-ceo-daniel-ek",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/dbac46e7/fe7c29a7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 218,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 12,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "0b8a26c2-fa99-44ba-8b5b-456dad9a00ce",
            "index": 41,
            "title": "Benchmark’s Mitch Lasky and Blake Robbins on The Art of Business in Gaming",
            "pub_date": "2023-04-26T06:45:10.000Z",
            "duration": "8204",
            "duration_label": "2h 16m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/benchmarks-mitch-lasky-and-blake-robbins-on-the-art-of-business-in-gaming",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/29d247e0/61e4c958.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 405,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "65be8a2d-5913-4c2b-9757-2c96be470dd3",
            "index": 42,
            "title": "Short: The Death of Sega",
            "pub_date": "2023-04-18T04:17:18.000Z",
            "duration": "4150",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/short-the-death-of-sega",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c298df87/4bdf3f6a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 180,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "02a5c009-e940-4a26-9044-c313caf9e279",
            "index": 43,
            "title": "Nintendo: The Console Wars",
            "pub_date": "2023-04-11T08:12:54.000Z",
            "duration": "11918",
            "duration_label": "3h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/nintendo-the-console-wars",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d4795154/5889c3ae.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 441,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "87edab21-9406-493c-b10b-16d23dccde62",
            "index": 44,
            "title": "Interview: Hamilton Helmer & Chenyi Shi on How to Build an AWS-Like Second Business",
            "pub_date": "2023-04-04T04:19:31.000Z",
            "duration": "5451",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://www.acquired.fm/episodes/interview-hamilton-helmer-chenyi-shi-on-how-to-build-an-aws-like-second-business",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5e462b9f/7e641cd2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 216,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "79762840-c356-4dbd-8412-f4d1fec926e8",
            "index": 45,
            "title": "Sessions: David Senra (Founders Podcast)",
            "pub_date": "2023-03-29T14:00:00.000Z",
            "duration": "12013",
            "duration_label": "3h 20m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/sessions-david-senra-founders-podcast",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a17248f3/0065823c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 660,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "3834bd3b-2948-48b7-b23f-aa19bf62026a",
            "index": 46,
            "title": "Nintendo's Origins",
            "pub_date": "2023-03-16T02:46:59.000Z",
            "duration": "12409",
            "duration_label": "3h 26m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/nintendo",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5b04d0f9/6651c330.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 650,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "038682f8-cc60-4cbb-a5bb-9b18aa312d1b",
            "index": 47,
            "title": "LVMH",
            "pub_date": "2023-02-21T13:16:53.000Z",
            "duration": "12771",
            "duration_label": "3h 32m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/lvmh",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/61a15c45/248323a6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 593,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "da5cfcd6-dd0e-4ad6-a14b-803c6e52eebd",
            "index": 48,
            "title": "Holiday Special 2022",
            "pub_date": "2022-12-19T07:22:28.000Z",
            "duration": "8461",
            "duration_label": "2h 21m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/holiday-special-2022",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ad439712/d5de2a69.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 683,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "1eaf9d2e-0bf7-4238-8c91-cf7a9506b958",
            "index": 49,
            "title": "Stratechery (with Ben Thompson)",
            "pub_date": "2022-12-06T03:16:57.000Z",
            "duration": "6950",
            "duration_label": "1h 55m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/stratechery-with-ben-thompson",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a307230d/d034ff40.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 276,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "699a9625-cc14-42e6-a01b-70ef4862e6b3",
            "index": 50,
            "title": "Enron",
            "pub_date": "2022-11-29T04:32:01.000Z",
            "duration": "12803",
            "duration_label": "3h 33m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/enron",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/16b8263b/0e40fd93.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 706,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "652f4916-c682-4b7d-b0e5-6dcd339ff5f7",
            "index": 51,
            "title": "Qualcomm",
            "pub_date": "2022-11-15T05:36:32.000Z",
            "duration": "8891",
            "duration_label": "2h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://www.acquired.fm/episodes/qualcomm",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/03645d7c/6c250e9e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 423,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ef596ea4-bbbd-4b18-9a4a-e9318f7e0554",
            "index": 52,
            "title": "Benchmark Part II: The Dinner",
            "pub_date": "2022-10-17T09:43:10.000Z",
            "duration": "7250",
            "duration_label": "2h 0m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/benchmark-part-ii-the-dinner",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/51e21680/a762dd60.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 399,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 3,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "d7bd9263-aea3-4726-94c9-61f5d251f478",
            "index": 53,
            "title": "ACQ Sessions: Jason Calacanis",
            "pub_date": "2022-10-04T10:30:32.000Z",
            "duration": "8362",
            "duration_label": "2h 19m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/acq-sessions-jason-calacanis",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/55d82a19/84cb57a9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 791,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "859f2520-f375-42ab-8078-ee5000359735",
            "index": 54,
            "title": "Benchmark Part I",
            "pub_date": "2022-09-28T01:30:29.000Z",
            "duration": "13453",
            "duration_label": "3h 44m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/benchmark-capital",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f53ac626/a75b0628.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 704,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "9b64ddfd-231e-4958-bbb8-68e9a4883667",
            "index": 55,
            "title": "Amazon Web Services",
            "pub_date": "2022-09-06T03:33:46.000Z",
            "duration": "9891",
            "duration_label": "2h 44m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/amazon-web-services",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/61ff443d/95c10c5e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 455,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "83ed7817-900d-4f18-8fbc-fe4e9496f416",
            "index": 56,
            "title": "Howard Marks & Andrew Marks: Something of Value",
            "pub_date": "2022-08-30T00:00:08.000Z",
            "duration": "5452",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/howard-marks-andrew-marks-something-of-value",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a6f236ed/c5202f89.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 200,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "4a0f8cdb-dc05-498e-8e28-f7b1647168ea",
            "index": 57,
            "title": "Amazon.com",
            "pub_date": "2022-08-16T08:26:01.000Z",
            "duration": "15477",
            "duration_label": "4h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/amazon-com",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/32442704/abd5dbba.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 563,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "cc2d2884-3a78-4af1-88d3-ff63461689ab",
            "index": 58,
            "title": "From NFL to Startup COO to Congressman Regulating Crypto (with Rep. Anthony Gonzalez)",
            "pub_date": "2022-08-02T00:35:11.000Z",
            "duration": "7005",
            "duration_label": "1h 56m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/from-nfl-to-startup-coo-to-congressman-regulating-crypto-with-rep-anthony-gonzalez",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/8064abac/8c3d88d7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 271,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "890bcbd1-8a1a-4cca-bac2-f669fa9b4693",
            "index": 59,
            "title": "Walmart",
            "pub_date": "2022-07-19T03:54:19.000Z",
            "duration": "10871",
            "duration_label": "3h 1m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://www.acquired.fm/episodes/walmart",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/7652e058/2d855bd6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 563,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b238a9be-c8c9-405c-bc62-510442b9bfea",
            "index": 60,
            "title": "The Playbook: Lessons from 200+ Company Stories",
            "pub_date": "2022-06-20T02:09:33.000Z",
            "duration": "3871",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "nvidia"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/7746810c/0203d764.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "7850c275-85b3-4b6c-a016-c1974eaaf8a8",
            "index": 61,
            "title": "American Dynamism (with Katherine Boyle)",
            "pub_date": "2022-06-06T01:15:57.000Z",
            "duration": "4708",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/3d5a628d/fddc4e9c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6bc30ee3-d6eb-427d-aca5-cd6e94200f5c",
            "index": 62,
            "title": "Capital-Efficient Growth (with Zoom CEO Eric Yuan & Veeva CEO Peter Gassner)",
            "pub_date": "2022-05-19T07:42:11.000Z",
            "duration": "4101",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/8b79f6b0/b15969fc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d296e42b-2a10-4be5-bfa3-d9cf77f2eb77",
            "index": 63,
            "title": "Arena Show Part II: Brooks Running (with CEO Jim Weber)",
            "pub_date": "2022-05-16T01:34:44.000Z",
            "duration": "4298",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/54a75322/cfbebecc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2ce6e362-5907-4498-873e-21972ae41077",
            "index": 64,
            "title": "Arena Show Part I: Idea Dinner + YC Continuity",
            "pub_date": "2022-05-12T07:47:16.000Z",
            "duration": "5266",
            "duration_label": "1h 27m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/24f7988e/fce794c4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f2b6e655-8342-4b10-a1e4-30c7f3146639",
            "index": 65,
            "title": "Nvidia Part II: The Machine Learning Company (2006-2022)",
            "pub_date": "2022-04-20T10:48:30.000Z",
            "duration": "7958",
            "duration_label": "2h 12m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "anthropic",
              "nvidia"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/36525d01/c1f87649.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "89d27263-b204-45d6-98a0-d5e152cc64fd",
            "index": 66,
            "title": "Platforms and Power (with Hamilton Helmer and Chenyi Shi)",
            "pub_date": "2022-04-06T05:46:55.000Z",
            "duration": "5062",
            "duration_label": "1h 24m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/dc8f5bb4/50621f29.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "363db577-da31-496d-ab2f-d68c085c226e",
            "index": 67,
            "title": "Nvidia Part I: The GPU Company (1993-2006)",
            "pub_date": "2022-03-28T05:09:56.000Z",
            "duration": "7234",
            "duration_label": "2h 0m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "anthropic",
              "nvidia",
              "gpu"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/7ae32087/df85fec1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "897829ee-7af2-4359-a1cc-3cf240a950ff",
            "index": 68,
            "title": "Altimeter (with Brad Gerstner)",
            "pub_date": "2022-03-15T05:47:19.000Z",
            "duration": "6824",
            "duration_label": "1h 53m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6f47a2f6/9eac70fe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1686cb41-3387-4a14-b6f1-7792dfcd0adb",
            "index": 69,
            "title": "SONY",
            "pub_date": "2022-03-07T10:47:25.000Z",
            "duration": "10988",
            "duration_label": "3h 3m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/fe785706/74f0210f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6841583f-2b0f-4645-a5df-2012ac6765ce",
            "index": 70,
            "title": "Super Pumped (with Brian Koppelman and Joseph Gordon-Levitt)",
            "pub_date": "2022-02-22T03:15:11.000Z",
            "duration": "3829",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/b62c8dea/16564134.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3cdaa7f4-b5b8-4d0c-8596-4e42aec3117d",
            "index": 71,
            "title": "The Browser (with Brendan Eich, Chief Architect of Netscape + Mozilla and CEO of Brave)",
            "pub_date": "2022-02-15T01:45:12.000Z",
            "duration": "6183",
            "duration_label": "1h 43m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/77f34e0e/815498be.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3607e4d4-851a-4f3a-90af-752b2778f0b9",
            "index": 72,
            "title": "Peloton",
            "pub_date": "2022-02-10T18:02:33.000Z",
            "duration": "8383",
            "duration_label": "2h 19m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5517501f/a25df55a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8e6dd85a-bbc5-439d-ae93-c6e9a22c78c4",
            "index": 73,
            "title": "Taylor Swift (Acquired’s Version)",
            "pub_date": "2022-01-23T16:00:00.000Z",
            "duration": "9524",
            "duration_label": "2h 38m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c82451cf/38202c2b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2e7adf3b-1761-4c82-b108-b199c314076c",
            "index": 74,
            "title": "CAA (with Michael Ovitz)",
            "pub_date": "2021-12-21T20:13:09.000Z",
            "duration": "6698",
            "duration_label": "1h 51m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/606092fa/cd3a0fb8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d3273936-2ea7-4904-b725-2b5e263d59de",
            "index": 75,
            "title": "FTX (with Sam Bankman-Fried & Mario Gabriele)",
            "pub_date": "2021-12-15T03:21:46.000Z",
            "duration": "5779",
            "duration_label": "1h 36m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c5c5b578/9148ff9d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "39f78858-446c-4049-91aa-3029b1a75190",
            "index": 76,
            "title": "7 Powers with Hamilton Helmer",
            "pub_date": "2021-12-08T05:46:20.000Z",
            "duration": "3816",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/eed24a19/e927d442.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "57fa2b5b-e5c3-428e-9eaf-31b8f920c832",
            "index": 77,
            "title": "Not Boring (with Packy McCormick)",
            "pub_date": "2021-12-03T03:03:08.000Z",
            "duration": "10036",
            "duration_label": "2h 47m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/39647cf9/3a85e9f5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "fdd30042-cb45-4f23-bbbd-b146aa7e3a80",
            "index": 78,
            "title": "Complexity Investing & Semiconductors (with NZS Capital)",
            "pub_date": "2021-11-03T01:25:18.000Z",
            "duration": "6235",
            "duration_label": "1h 43m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/0944fa70/6dc20604.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5a09bd0e-e307-4e42-8c4e-2a0621965153",
            "index": 79,
            "title": "Standard Oil Part II",
            "pub_date": "2021-10-18T20:28:06.000Z",
            "duration": "8578",
            "duration_label": "2h 22m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/751ad56b/83b09169.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "89bedd4f-cf18-46b3-9df1-9e8568b13398",
            "index": 80,
            "title": "Michael Mauboussin Master Class — Moats, Skill, Luck, Decision Making and a Whole Lot More",
            "pub_date": "2021-10-05T14:20:27.000Z",
            "duration": "5106",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/56cca4dc/8b8879fe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "89c59c1e-fda8-4505-8cb3-3d712915a3b5",
            "index": 81,
            "title": "Standard Oil Part I",
            "pub_date": "2021-09-22T01:37:51.000Z",
            "duration": "8061",
            "duration_label": "2h 14m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/523ca027/d34f7123.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "7c9d39b8-5982-4705-9707-2a422f68cb2a",
            "index": 82,
            "title": "TSMC",
            "pub_date": "2021-09-07T01:23:06.000Z",
            "duration": "8950",
            "duration_label": "2h 29m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "anthropic",
              "nvidia",
              "chips"
            ],
            "page_url": "https://www.acquired.fm/episodes/tsmc",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/39c90a45/b8b18290.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 647,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "93f2e610-3b84-4524-ba79-50f306ddbb49",
            "index": 83,
            "title": "Kevin Rose from Web 2.0 to Web3",
            "pub_date": "2021-08-30T04:16:21.000Z",
            "duration": "6047",
            "duration_label": "1h 40m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/401eb2a0/67a17a7f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ef45c8a2-f059-4db5-a577-b4004383e039",
            "index": 84,
            "title": "Andreessen Horowitz Part II",
            "pub_date": "2021-08-10T01:42:36.000Z",
            "duration": "10499",
            "duration_label": "2h 54m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/b4e1868a/e68c0000.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "094a7dee-99c5-4adc-9996-40eec032ad51",
            "index": 85,
            "title": "Andreessen Horowitz Part I",
            "pub_date": "2021-07-27T01:45:29.000Z",
            "duration": "7588",
            "duration_label": "2h 6m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/963ebf74/e67b257c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3f718efd-12a9-480b-a95c-684383464b21",
            "index": 86,
            "title": "Special: Solana (with CEO Anatoly Yakovenko)",
            "pub_date": "2021-07-19T04:51:26.000Z",
            "duration": "4436",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/87d42142/be697c75.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "dcc1bf7d-439f-4927-aa87-62540ad55374",
            "index": 87,
            "title": "Ethereum",
            "pub_date": "2021-07-06T05:57:44.000Z",
            "duration": "11060",
            "duration_label": "3h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6d75dcd7/d1a32aba.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "86529c0a-1f25-491e-a371-c986e74a0f85",
            "index": 88,
            "title": "Special: Ho Nam from Altos Ventures — A Different Approach to VC",
            "pub_date": "2021-06-21T02:06:02.000Z",
            "duration": "6708",
            "duration_label": "1h 51m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/20368ca0/5302d21a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0f09141e-2ef7-4d72-8cd3-2fba73e45500",
            "index": 89,
            "title": "Berkshire Hathaway Part III",
            "pub_date": "2021-06-07T04:14:00.000Z",
            "duration": "10690",
            "duration_label": "2h 58m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/30c47652/7dfc71a7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "80977241-26a0-49bf-b506-0b10ec8006ae",
            "index": 90,
            "title": "Special: Amazon Unbound (with Brad Stone)",
            "pub_date": "2021-05-27T04:02:57.000Z",
            "duration": "4721",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/243c04bb/bda69d6a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "689d82ea-dd2e-4934-ac4d-bbaa8a3b63ea",
            "index": 91,
            "title": "Berkshire Hathaway Part II",
            "pub_date": "2021-05-12T15:51:09.000Z",
            "duration": "10950",
            "duration_label": "3h 2m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/98c5cf0d/98151a4d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 1,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "a10b378f-2753-40ba-a12a-a83898082557",
            "index": 92,
            "title": "Special: 2021 China Tech Trends (with Tech Buzz China)",
            "pub_date": "2021-05-05T19:53:00.000Z",
            "duration": "4826",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/19028f0f/6c30df3f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "482065d7-cc39-4b8c-af32-3cf2795cdbdb",
            "index": 93,
            "title": "Berkshire Hathaway Part I",
            "pub_date": "2021-04-21T02:02:32.000Z",
            "duration": "11507",
            "duration_label": "3h 11m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/200d61ee/bdf473cd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 1,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "f870b6bd-f5b3-47b2-b2b1-7d67e30a6e51",
            "index": 94,
            "title": "Special: \"Why Now\" for Digital Health (with Levels founder Josh Clemente)",
            "pub_date": "2021-04-06T03:57:07.000Z",
            "duration": "5299",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/2b448027/69f24e6c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "f5c2d6cc-1d6c-4f27-8fd5-5b4fbde2fe23",
            "index": 95,
            "title": "Rec Room Part II (with CEO Nick Fajt)",
            "pub_date": "2021-03-24T05:08:35.000Z",
            "duration": "7060",
            "duration_label": "1h 57m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/cb27a797/5ae3c435.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "e93cd0b0-a686-450f-abdf-3c00d9102036",
            "index": 96,
            "title": "Meituan",
            "pub_date": "2021-03-10T23:09:05.000Z",
            "duration": "8595",
            "duration_label": "2h 23m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/39595bfd/e95beb17.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "cc94959d-f42a-4531-86f6-500838d8da12",
            "index": 97,
            "title": "The New York Times Company",
            "pub_date": "2021-02-18T05:52:02.000Z",
            "duration": "11322",
            "duration_label": "3h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "safety"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/0dcc65a4/421a6301.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 4,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "e981ea00-0605-4844-92a4-cc3ff4c5fb25",
            "index": 98,
            "title": "Special: Sequoia Capital's Investment Playbook (with Alfred Lin)",
            "pub_date": "2021-02-01T01:49:01.000Z",
            "duration": "3450",
            "duration_label": "57m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/94566475/05fc9627.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 9,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "d44194af-92ff-4b40-94a6-d5b48153579b",
            "index": 99,
            "title": "Bitcoin",
            "pub_date": "2021-01-19T02:15:21.000Z",
            "duration": "11654",
            "duration_label": "3h 14m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d61763cc/36b14d05.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b01c6e84-a611-4e44-aa16-8e54c6978347",
            "index": 100,
            "title": "Special: Acquired x Indie Hackers",
            "pub_date": "2020-12-17T06:08:13.000Z",
            "duration": "6655",
            "duration_label": "1h 50m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6107cae5/b8e5d84e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "94c5bedb-f60e-4f12-ac9e-8f6da4fce3e0",
            "index": 101,
            "title": "Airbnb",
            "pub_date": "2020-12-11T06:14:31.000Z",
            "duration": "9617",
            "duration_label": "2h 40m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/562826ed/dfa1cb43.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "79438add-9a91-438f-87dc-61c54c59af55",
            "index": 102,
            "title": "DoorDash",
            "pub_date": "2020-12-10T05:56:57.000Z",
            "duration": "10805",
            "duration_label": "3h 0m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/13bd6c3b/17097573.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b2758461-c12e-448e-9afe-5c71a5dd852b",
            "index": 103,
            "title": "Slack + Salesforce Emergency Pod with Packy McCormick of Not Boring",
            "pub_date": "2020-12-02T05:47:36.000Z",
            "duration": "5511",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/00cc4917/c2f1a562.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "4116e16b-8386-42a3-8780-fd12f77f331c",
            "index": 104,
            "title": "Virgin Galactic",
            "pub_date": "2020-11-23T06:26:51.000Z",
            "duration": "6507",
            "duration_label": "1h 48m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5b60c13a/a6b94682.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "904da83a-f3ba-479a-91cc-8bf48890d654",
            "index": 105,
            "title": "Special: Superhuman Part II - Designing Software to Feel like a Game (with Rahul Vohra)",
            "pub_date": "2020-11-12T15:18:26.000Z",
            "duration": "3402",
            "duration_label": "56m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/cc0da03f/0a043b89.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "779a9cc5-7338-4754-8986-375fb33790f9",
            "index": 106,
            "title": "Twitter (with Dick Costolo)",
            "pub_date": "2020-10-28T16:28:49.000Z",
            "duration": "5100",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/38ada207/767a5382.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "eb0d094e-84a2-4446-8fa3-73bf53ecd81d",
            "index": 107,
            "title": "Special: Invest Like the Best on Acquired",
            "pub_date": "2020-10-07T02:49:25.000Z",
            "duration": "6594",
            "duration_label": "1h 49m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f8ae3745/0d334546.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9737acd9-4f9b-488c-aba6-39d0bed28406",
            "index": 108,
            "title": "The NBA",
            "pub_date": "2020-09-30T23:38:31.000Z",
            "duration": "10024",
            "duration_label": "2h 47m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/741a0c8f/c43df40b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5180c82e-a792-4e3c-87d6-e28994064250",
            "index": 109,
            "title": "Special: Acquired x My First Million",
            "pub_date": "2020-09-09T16:01:59.000Z",
            "duration": "5756",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/4570d352/d3d47ee9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "21306962-9052-4069-a856-0eeabcf25ef2",
            "index": 110,
            "title": "Epic Games",
            "pub_date": "2020-09-02T01:41:27.000Z",
            "duration": "8935",
            "duration_label": "2h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/1789c0e8/62163c26.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b481fb9d-927d-479e-ac34-4fc321c53a2a",
            "index": 111,
            "title": "Eventbrite (with Julia & Kevin Hartz)",
            "pub_date": "2020-08-25T23:35:53.000Z",
            "duration": "5643",
            "duration_label": "1h 34m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c8f6b13f/583c1af3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "39f7c4b0-bb54-49cc-9844-d5b33579e9ec",
            "index": 112,
            "title": "Pinduoduo",
            "pub_date": "2020-07-16T19:51:06.000Z",
            "duration": "6902",
            "duration_label": "1h 55m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5b2685d1/f1f89ecb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "845274d4-a3e8-4098-b87c-f5dfc0206525",
            "index": 113,
            "title": "Oprah (Harpo Studios)",
            "pub_date": "2020-06-25T15:50:54.000Z",
            "duration": "8039",
            "duration_label": "2h 13m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a8fa13dc/6efeb85f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "94da96be-e1d6-40e9-9f9e-6b49cfab79e0",
            "index": 114,
            "title": "SpaceX",
            "pub_date": "2020-05-26T14:07:00.000Z",
            "duration": "9929",
            "duration_label": "2h 45m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/57eb63db/796d7fa4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f4cbce86-7bbb-4c63-9320-c470ffd6301c",
            "index": 115,
            "title": "Adapting Episode 3: Intel",
            "pub_date": "2020-05-12T01:00:51.000Z",
            "duration": "5130",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f971fa78/2052014f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "74f0613b-6e0f-4fb7-9864-b7d23688e479",
            "index": 116,
            "title": "Special Episode: Jason Calacanis",
            "pub_date": "2020-04-29T03:41:44.000Z",
            "duration": "5897",
            "duration_label": "1h 38m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6755d9aa/77395755.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "191af3f4-6722-4a24-a6e0-81be5274d704",
            "index": 117,
            "title": "Adapting Episode 2: Sequoia’s Black Swan Memo (with Roelof Botha)",
            "pub_date": "2020-03-31T04:14:03.000Z",
            "duration": "2613",
            "duration_label": "43m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://share.transistor.fm/s/02875aa1",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/02875aa1/54b8aa52.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d9e60557-828e-41a7-b8de-2caf997c0fec",
            "index": 118,
            "title": "Adapting Episode 1: Canlis",
            "pub_date": "2020-03-20T14:59:33.000Z",
            "duration": "2949",
            "duration_label": "49m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/18731f75/49d31d23.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "58a5c74d-2eef-4631-9231-3c485a812718",
            "index": 119,
            "title": "The Top 10 Acquisitions of All-Time",
            "pub_date": "2020-03-17T17:16:26.000Z",
            "duration": "6669",
            "duration_label": "1h 51m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/33f43e22/4058d5b3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "4b508c22-2ba3-4e1e-936c-9031e1082682",
            "index": 120,
            "title": "Sequoia Capital Part II (with Doug Leone)",
            "pub_date": "2020-02-18T05:50:01.000Z",
            "duration": "4033",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c8aaf764/94b0a17a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "68e93747-1bbf-479e-98e3-1b7f7d2478a2",
            "index": 121,
            "title": "WhatsApp",
            "pub_date": "2020-01-29T04:48:30.000Z",
            "duration": "6743",
            "duration_label": "1h 52m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/af2cab93/bc877db5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8627ee40-4ffc-4380-82c5-393db59b4b58",
            "index": 122,
            "title": "The Lean Startup and the Long-Term Stock Exchange (with Eric Ries)",
            "pub_date": "2019-12-30T05:11:41.000Z",
            "duration": "5128",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "alignment"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/96b41af3/3e197d80.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "57d6d0e3-6060-4103-aac9-bd3a71dc18be",
            "index": 123,
            "title": "Convoy (with CEO Dan Lewis)",
            "pub_date": "2019-12-19T14:34:12.000Z",
            "duration": "6064",
            "duration_label": "1h 41m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/732d28a5/1850d297.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5801e589-b6cf-4fe9-9cd6-f16da7cac595",
            "index": 124,
            "title": "TikTok",
            "pub_date": "2019-12-09T05:54:05.000Z",
            "duration": "6144",
            "duration_label": "1h 42m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/58cf7ab6/65b2ccf1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "825958f0-e4c5-43b8-b281-8d71eef1721b",
            "index": 125,
            "title": "Disney, Plus",
            "pub_date": "2019-11-25T14:37:23.000Z",
            "duration": "8298",
            "duration_label": "2h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/045f2ed5/affdd9aa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f8fe9512570642a0a28e2a64ce5dc3c7",
            "index": 126,
            "title": "The WeWork “Acquisition” (with Dan Primack)",
            "pub_date": "2019-10-25T02:02:30.000Z",
            "duration": "6008",
            "duration_label": "1h 40m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/84f7c9f9/b91f9c5d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b46b08930e1e4de3875c476108c74615",
            "index": 127,
            "title": "Season 5, Episode 5: Atari (with Nolan Bushnell)",
            "pub_date": "2019-10-15T14:40:07.000Z",
            "duration": "6103",
            "duration_label": "1h 41m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d9ad26dc/ddc53886.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "84861cd6330b4273a4662cb8ab497021",
            "index": 128,
            "title": "Sequoia Capital (Part 1)",
            "pub_date": "2019-09-26T14:58:22.000Z",
            "duration": "6769",
            "duration_label": "1h 52m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/49e04fba/bb06c453.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "38dc0771dbb24bcda353f484b4a91fcf",
            "index": 129,
            "title": "Google Maps",
            "pub_date": "2019-08-26T13:46:54.000Z",
            "duration": "6104",
            "duration_label": "1h 41m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f09ada4e/70e5e8bb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "05871ea2eb724bba975ffb99110f0982",
            "index": 130,
            "title": "The Shopify IPO",
            "pub_date": "2019-08-06T17:27:52.000Z",
            "duration": "5487",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ae4104f2/6c516896.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "10f4e9fe70624496a3ea193dc5269679",
            "index": 131,
            "title": "Huawei",
            "pub_date": "2019-07-22T15:04:04.000Z",
            "duration": "4118",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/db5e7e30/b3171b94.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3d39c874d3de4e02acdd8b2eb1c3e42b",
            "index": 132,
            "title": "Superhuman (with CEO Rahul Vohra)",
            "pub_date": "2019-06-27T15:20:40.000Z",
            "duration": "4930",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/50673760/731bf571.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ed721f700455499c82d6f3de7b2a481f",
            "index": 133,
            "title": "The Slack DPO",
            "pub_date": "2019-06-25T03:59:05.000Z",
            "duration": "7199",
            "duration_label": "1h 59m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/7438e9f3/ea452399.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "bdb8c15d1bd44109b239a542a6b53663",
            "index": 134,
            "title": "The Zoom IPO (with Santi Subotovsky)",
            "pub_date": "2019-06-19T02:19:36.000Z",
            "duration": "4952",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a1928710/1c992d75.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8f32e09693174bd9af5aa459dc9b2f4d",
            "index": 135,
            "title": "The Electronic Arts IPO (with Trip Hawkins)",
            "pub_date": "2019-05-27T17:25:56.000Z",
            "duration": "7481",
            "duration_label": "2h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/fa3602d3/58920763.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5825b12d317d40c9a8d08785f82bf967",
            "index": 136,
            "title": "The Uber IPO",
            "pub_date": "2019-05-11T20:27:39.000Z",
            "duration": "8779",
            "duration_label": "2h 26m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/4be03ef6/4072a57e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "264d445c9295435b87192d974742aa81",
            "index": 137,
            "title": "The Pinterest IPO",
            "pub_date": "2019-04-24T01:04:46.000Z",
            "duration": "6242",
            "duration_label": "1h 44m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/78dfc484/1f15d98a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e479bdfcc7b443f38c0c39299f04e024",
            "index": 138,
            "title": "The Lyft IPO",
            "pub_date": "2019-03-30T23:32:45.000Z",
            "duration": "8525",
            "duration_label": "2h 22m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5f2721d4/f3e288a3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2713f0278e51430cb495d101b2ca0c87",
            "index": 139,
            "title": "Season 4, Episode 3: Instagram Revisited (with Emily White)",
            "pub_date": "2019-02-26T03:28:52.000Z",
            "duration": "4592",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/58adc75f/aaaebdd3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9ba675bb405141ec90ea475dc7a3c05d",
            "index": 140,
            "title": "Spotify + Gimlet/Anchor Quick Take + Worldwide Meetup Details!",
            "pub_date": "2019-02-19T02:26:46.000Z",
            "duration": "2436",
            "duration_label": "40m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://share.transistor.fm/s/9183cdee",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/9183cdee/64b90804.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6cf59ea131164992bc6985aea47406b5",
            "index": 141,
            "title": "Season 4, Episode 2: ARM & SoftBank",
            "pub_date": "2019-02-03T23:55:34.000Z",
            "duration": "5313",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/64c3fabd/0094f991.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f2baaa8cbef34daa88149339eeaafe7f",
            "index": 142,
            "title": "Season 4, Episode 1: ESPN",
            "pub_date": "2019-01-21T18:21:43.000Z",
            "duration": "5296",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/03434469/0558295f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "09d848d83bd24bda8c7c3ea23fa0d089",
            "index": 143,
            "title": "Season 3, Episode 10: Tencent",
            "pub_date": "2018-12-17T04:52:13.000Z",
            "duration": "6915",
            "duration_label": "1h 55m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/2990d678/9937553a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6808e80dfff54a88912e018fab0f819e",
            "index": 144,
            "title": "Season 3, Episode 9: Netflix (Part 2)",
            "pub_date": "2018-11-25T20:24:30.000Z",
            "duration": "5443",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/91e0b8c5/05bcb3d6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "37b576f582544f25908ce410e348285c",
            "index": 145,
            "title": "Season 3, Episode 8: Netflix (Part 1)",
            "pub_date": "2018-11-12T03:50:18.000Z",
            "duration": "5542",
            "duration_label": "1h 32m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/92d667e1/490d0a9a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "083f08d557744bdc8d2a65c78ab3b3c0",
            "index": 146,
            "title": "Acquired Season 3 Episode 7: Venmo (live with Andrew Kortina)",
            "pub_date": "2018-10-29T16:42:16.000Z",
            "duration": "4505",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/98fcb7d0/6c00eff2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f3678bd234784d05bb3973073226fb1c",
            "index": 147,
            "title": "Season 3, Episode 6: Behance (with Scott Belsky)",
            "pub_date": "2018-10-02T04:46:20.000Z",
            "duration": "4634",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/fd0f1189/964b58e6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2f1c3158978c42d39dc9957bd3280bee",
            "index": 148,
            "title": "Season 3, Episode 5: Alibaba",
            "pub_date": "2018-09-24T01:28:55.000Z",
            "duration": "5991",
            "duration_label": "1h 39m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/8919e636/f3eb986d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "24cbfc0b88cf455bbcd903bd2c27fe92",
            "index": 149,
            "title": "Season 3, Episode 4: Recode (with Kara Swisher)",
            "pub_date": "2018-09-11T04:07:20.000Z",
            "duration": "5334",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/86e9c911/9329497b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f9e170df33df4c58afb3bc0fb3dd44c8",
            "index": 150,
            "title": "Season 3, Episode 3: The Sonos IPO",
            "pub_date": "2018-08-20T16:20:37.000Z",
            "duration": "6024",
            "duration_label": "1h 40m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d058a651/4ccef8d0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "97e465b8bf2a450bbbef2fec8c12b8de",
            "index": 151,
            "title": "Season 3, Episode 2: The Xiaomi IPO",
            "pub_date": "2018-08-06T01:15:03.000Z",
            "duration": "4784",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/56543adf/e89accbf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "7a666af33ab2487ca253acd953450ffa",
            "index": 152,
            "title": "Season 3, Episode 1: Tesla",
            "pub_date": "2018-07-17T04:40:56.000Z",
            "duration": "7512",
            "duration_label": "2h 5m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a8089f84/7c3ca651.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8e429cbfcedc4606b2e7021aff14e97a",
            "index": 153,
            "title": "Season 2, Episode 10: The Rover-DogVacay Merger (with Rover CEO Aaron Easterly)",
            "pub_date": "2018-06-18T03:03:59.000Z",
            "duration": "4372",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/93206d9c/6cb71161.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "fbcf6c2338e041759182dc10eb2ba636",
            "index": 154,
            "title": "Season 2, Episode 9: GitHub",
            "pub_date": "2018-06-06T05:52:05.000Z",
            "duration": "5406",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/1ffc22b3/8251489e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "092c25ed46df4a0caafb58211b98dd5c",
            "index": 155,
            "title": "Season 2, Episode 8: T-Mobile / Sprint",
            "pub_date": "2018-05-21T14:34:11.000Z",
            "duration": "5240",
            "duration_label": "1h 27m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/12ac889e/109d7a9c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "83a574e9c0d1c2d993e472343fcc0cfd",
            "index": 156,
            "title": "Season 2, Episode 7: PowerPoint",
            "pub_date": "2018-05-04T14:39:35.000Z",
            "duration": "4837",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/cfb86b60/8d53f522.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3f987c8a5468b2a8806dc70282791593",
            "index": 157,
            "title": "Season 2, Episode 6: Spotify’s Direct Listing",
            "pub_date": "2018-04-06T05:31:00.000Z",
            "duration": "6653",
            "duration_label": "1h 50m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c3ace4cd/28d2d239.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8e11397c526638c079fa96333ec21953",
            "index": 158,
            "title": "Season 2, Episode 5: The Dropbox IPO",
            "pub_date": "2018-03-26T04:49:07.000Z",
            "duration": "6222",
            "duration_label": "1h 43m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/bf5c3924/8fa448c1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "107c7dae2e16c6e20a020ab191137f30",
            "index": 159,
            "title": "Season 2, Episode 4: SoftBank, Fortress and the Vision Fund",
            "pub_date": "2018-03-23T03:28:02.000Z",
            "duration": "5649",
            "duration_label": "1h 34m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/b962ed86/e5755e41.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "00654835b39d313df6aa75d4ccd5047f",
            "index": 160,
            "title": "Season 2, Episode 3: Nest",
            "pub_date": "2018-02-20T03:59:27.000Z",
            "duration": "5927",
            "duration_label": "1h 38m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/14604e41/a7ecdaa2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3d6f7518de2acdd8bc11266682f8b0ce",
            "index": 161,
            "title": "Season 2, Episode 2: Raising a Seed Round with Against Gravity CEO Nick Fajt",
            "pub_date": "2018-02-07T02:59:24.000Z",
            "duration": "4845",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a6f0c234/5dcb5967.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "027c18474b83745d260d76641d39f841",
            "index": 162,
            "title": "Season 2, Episode 1: Zappos (with Alfred Lin)",
            "pub_date": "2018-01-23T03:46:42.000Z",
            "duration": "4747",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://share.transistor.fm/s/6476b194",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6476b194/f4336201.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "25461cff3b3df1cafc569f8ff22bf79b",
            "index": 163,
            "title": "Episode 51: 2017 Holiday Special",
            "pub_date": "2017-12-18T14:50:52.000Z",
            "duration": "4959",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d0a18f1a/0585f7c9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "94203e82153143bb13c33652772ba18c",
            "index": 164,
            "title": "Episode 50: Apple - Beats",
            "pub_date": "2017-12-11T15:13:49.000Z",
            "duration": "4821",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/404d0e04/95f85461.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "949d97c80354b9f25088c71bef4952ec",
            "index": 165,
            "title": "Episode 49: The Stitch Fix IPO",
            "pub_date": "2017-12-04T14:39:37.000Z",
            "duration": "4678",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5f887ea7/d8d128bc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "17b282957ae2aface09464d9f27b2080",
            "index": 166,
            "title": "Episode 48: Qualcomm - Broadcom",
            "pub_date": "2017-11-20T14:54:59.000Z",
            "duration": "3482",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "chip"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c8ea9e00/82aee685.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9e31c6530f559e3bc5f47367a4bb57f7",
            "index": 167,
            "title": "Episode 47: The Atlassian IPO",
            "pub_date": "2017-11-07T00:30:05.000Z",
            "duration": "4307",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ed73b7fa/13963ad8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ce2d97784d15b96f23bea5b5e67bdaab",
            "index": 168,
            "title": "Episode 46: Blue Bottle Coffee",
            "pub_date": "2017-10-08T03:16:21.000Z",
            "duration": "4162",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/63d4b59c/3afc0003.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "07ecf09f9495b32c42ef13e0bce4b9cd",
            "index": 169,
            "title": "Episode 45: HTC, Google and the Future of Mobile",
            "pub_date": "2017-09-21T14:23:18.000Z",
            "duration": "5132",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/4b62da2c/8d176b8b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "569044e65797645aab2d567103eb86d1",
            "index": 170,
            "title": "Episode 44: AOL - Time Warner (with the Internet History Podcast)",
            "pub_date": "2017-09-18T01:13:53.000Z",
            "duration": "6501",
            "duration_label": "1h 48m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "claude"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/77ca39a6/d435642b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "292f038fae4ada71ef78c03a7901fade",
            "index": 171,
            "title": "Episode 43: The Square IPO",
            "pub_date": "2017-08-16T21:59:53.000Z",
            "duration": "4904",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/0dbedb84/f4dd823d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "534543aa021937948e841f1aadad648e",
            "index": 172,
            "title": "Episode 42: Opsware (with special guest Michel Feaster)",
            "pub_date": "2017-08-05T00:33:28.000Z",
            "duration": "4822",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "datacenter"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/75ce4e80/16bb8b72.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1e7c62859076f3599addc29c4b8a556a",
            "index": 173,
            "title": "Episode 41: Booking.com with Jetsetter & Room 77 CEO Drew Patterson",
            "pub_date": "2017-07-26T04:25:31.000Z",
            "duration": "4882",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/3fda8d59/123a5199.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "47b59f963dbd24d97ae0c221dd06dbbf",
            "index": 174,
            "title": "Episode 40: Activision Blizzard",
            "pub_date": "2017-07-13T00:54:09.000Z",
            "duration": "4675",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a31fc9f2/fe8f6815.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6110817b7a307f71e006c185957e748d",
            "index": 175,
            "title": "Acquired Episode 39: Whole Foods Market",
            "pub_date": "2017-06-21T00:03:39.000Z",
            "duration": "4718",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/3c709496/0d306944.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "228041908b7dc87ea04acd97689e86f7",
            "index": 176,
            "title": "Acquired Episode 38: SoundJam (iTunes)",
            "pub_date": "2017-05-31T14:19:39.000Z",
            "duration": "4913",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/5bd1ed41/931d93de.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c9e049094f6acfdcda0758567b3562f2",
            "index": 177,
            "title": "Episode 37: BAMTech, Disney and \"the Biggest Media Company You've Never Heard Of”",
            "pub_date": "2017-05-10T15:41:48.000Z",
            "duration": "4886",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/054d8d6e/04ce8b32.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "363897dbca765a8a322ebec4e942d117",
            "index": 178,
            "title": "Episode 36: The LA Clippers",
            "pub_date": "2017-04-24T06:30:20.000Z",
            "duration": "4303",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/40edb0a4/d39b9cd1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e09d7e108acd1da5b24960bd1bc9c0da",
            "index": 179,
            "title": "Episode 35: Oculus",
            "pub_date": "2017-04-11T21:58:06.000Z",
            "duration": "5045",
            "duration_label": "1h 24m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/77f5ab33/9a3638b8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1c82fdabf576907bdb180a3a9c76cb2b",
            "index": 180,
            "title": "Episode 34: The Starbucks IPO with Dan Levitan",
            "pub_date": "2017-04-03T16:28:46.000Z",
            "duration": "4725",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/b6075581/de590cbe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "fd0f4766b1d58a916974432c83e006ed",
            "index": 181,
            "title": "Episode 33: Overture (with the Internet History Podcast!)",
            "pub_date": "2017-03-13T16:33:00.000Z",
            "duration": "5638",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "anthropic",
              "alignment"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/1330002a/2846af35.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "dddc14e15f5ec36c881d8c4f8dea253f",
            "index": 182,
            "title": "Episode 32: The Snap Inc. IPO",
            "pub_date": "2017-03-04T11:25:03.000Z",
            "duration": "5391",
            "duration_label": "1h 29m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/0279308b/253d7838.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8a8864e11e522d3a575e983edf8514e9",
            "index": 183,
            "title": "Episode 31: The Uber - Didi Chuxing Merger with Brad Stone, author of The Upstarts & The Everything Store",
            "pub_date": "2017-03-01T07:45:29.000Z",
            "duration": "4602",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ca71a7d2/27ac15f7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9f9fae79191f018c9b046e80aa5c8f08",
            "index": 184,
            "title": "Episode 30: P.A. Semi + AuthenTec",
            "pub_date": "2017-01-24T14:39:34.000Z",
            "duration": "4562",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "anthropic",
              "chip",
              "chips"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/c1d79480/d67773b6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "07ab28f3ad805b7c3da7f73d54ee6ff6",
            "index": 185,
            "title": "Episode 29: Special—2016 Review and 2017 Predictions",
            "pub_date": "2017-01-11T14:58:51.000Z",
            "duration": "4796",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/9f728129/a6c9b711.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ce0f631b88279373f58d2e4da4c63130",
            "index": 186,
            "title": "Episode 28: The Amazon IPO with original Amazon Board Member Tom Alberg",
            "pub_date": "2016-12-31T13:08:19.000Z",
            "duration": "4476",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ffcb93db/3565fd26.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "48489fc999f2bed317b70af394ab81aa",
            "index": 187,
            "title": "Episode 27: Special—A Conversation with Microsoft's Head of Strategic Investments Brian Schultz",
            "pub_date": "2016-12-16T14:56:53.000Z",
            "duration": "4706",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/e55477bc/f95dc658.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1258283aa330be78a9f27907377a499e",
            "index": 188,
            "title": "Episode 26: Marvel",
            "pub_date": "2016-12-05T23:16:34.000Z",
            "duration": "5196",
            "duration_label": "1h 26m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/1d974b72/c9091d00.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "47835eb18a0c70fa1eaf5690e186fb9c",
            "index": 189,
            "title": "Episode 25: The Facebook IPO",
            "pub_date": "2016-11-11T19:35:36.000Z",
            "duration": "5333",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f5a4ecd9/64378ed7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1c93f39fb8953d06e7049fc015271a67",
            "index": 190,
            "title": "Episode 24: Skype",
            "pub_date": "2016-11-02T05:28:38.000Z",
            "duration": "5194",
            "duration_label": "1h 26m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f8e5e9d9/7ad99132.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8f5833ea04c81885fc1c4cf10e6a4a18",
            "index": 191,
            "title": "Episode 23: NeXT (Live show at the GeekWire Summit)",
            "pub_date": "2016-10-23T15:33:35.000Z",
            "duration": "4242",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/eed4bc3d/6092caa9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "559d8432a44217b12157efdf50b3485f",
            "index": 192,
            "title": "Episode 22: Zillow + Trulia (with Zillow Group CFO Kathleen Philips)",
            "pub_date": "2016-10-14T00:23:42.000Z",
            "duration": "4734",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f4faf27e/487c18d0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0892e3d76c8e4e1591f9b2c695106589",
            "index": 193,
            "title": "Episode 21: Inside the M&A Press with Bloomberg's Alex Sherman",
            "pub_date": "2016-09-27T21:33:55.000Z",
            "duration": "5174",
            "duration_label": "1h 26m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/57c683a0/54f8e6d5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "063b9a9232c2b2ac46faa9960dc5288f",
            "index": 194,
            "title": "Episode 20: Android",
            "pub_date": "2016-09-16T13:10:52.000Z",
            "duration": "4911",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ed607234/c2ae42b1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "bd91e1672954bd92af237c84787c8ec4",
            "index": 195,
            "title": "Episode 19: Jet",
            "pub_date": "2016-08-29T13:00:55.000Z",
            "duration": "4393",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/7ef80bef/97af0846.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "456e8967279ba511a9db49283cbb92d6",
            "index": 196,
            "title": "Episode 18: Special—An Acquirer’s View into M&A with Taylor Barada, head of Corp Dev at Adobe",
            "pub_date": "2016-08-22T12:48:13.000Z",
            "duration": "4312",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f33b2d54/8c86022a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9b046e7c1d8038f83d04161597933347",
            "index": 197,
            "title": "Acquired Episode 17: Waze",
            "pub_date": "2016-08-03T22:57:49.000Z",
            "duration": "4117",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/1184dea9/a6b58a3e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f59fb0d63ec187c0409fe9d82c003964",
            "index": 198,
            "title": "Acquired Episode 16: Midroll + Stitcher (acquired by Scripps)",
            "pub_date": "2016-07-12T13:37:37.000Z",
            "duration": "3826",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f20022b1/b220c6bc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "985823cf8bee8f13f9511c184af852c2",
            "index": 199,
            "title": "Acquired Episode 15: ExactTarget (acquired by Salesforce) with Scott Dorsey",
            "pub_date": "2016-07-05T15:49:38.000Z",
            "duration": "4639",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/df55c869/c9a11818.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b844f25d48ba472fa009277bb46b336d",
            "index": 200,
            "title": "Episode 14: LinkedIn",
            "pub_date": "2016-06-16T21:11:47.000Z",
            "duration": "4149",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/f75febdd/bf647467.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "aed73a50c078b6fca7a205c239ac0a8f",
            "index": 201,
            "title": "Episode 13: Push Pop Press (Facebook Instant Articles) with Todd Bishop",
            "pub_date": "2016-06-06T06:19:56.000Z",
            "duration": "3883",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d79ad1e8/f89a4320.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8a793886869b7eea87ecc186db8525f6",
            "index": 202,
            "title": "Episode 12: Snapchat",
            "pub_date": "2016-05-23T01:06:53.000Z",
            "duration": "3848",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/b0bf76d2/71920b83.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ea5c32a13d18d098b8b76f4e33853535",
            "index": 203,
            "title": "Episode 11: PayPal",
            "pub_date": "2016-05-09T04:55:44.000Z",
            "duration": "3615",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/a1373862/e5e15ddc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b7caa0b30fc0a2536a1a2feab5f95fbf",
            "index": 204,
            "title": "Acquired Episode 10: Virgin America",
            "pub_date": "2016-04-27T05:47:22.000Z",
            "duration": "3384",
            "duration_label": "56m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/ec0e10ba/58d43243.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e2a1607ed8a140c2b3cec43e3aeb3deb",
            "index": 205,
            "title": "Episode 9: Writely (Google Docs)",
            "pub_date": "2016-03-29T16:00:00.000Z",
            "duration": "3055",
            "duration_label": "50m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6ffff3ee/90316599.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "769092593be74c249d88e96189f0d105",
            "index": 206,
            "title": "Episode 8: Acompli, Sunrise, and Wunderlist (w/ Kurt DelBene)",
            "pub_date": "2016-02-29T17:00:00.000Z",
            "duration": "3862",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/bae97e40/2f88071a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "23a8377b2bde49b88abc56c9ba1502da",
            "index": 207,
            "title": "Episode 7: YouTube",
            "pub_date": "2016-02-03T17:00:00.000Z",
            "duration": "3146",
            "duration_label": "52m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/844dd918/029974dc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "41de9a1f06ec4e5c8e80df4d05dc7ce3",
            "index": 208,
            "title": "Episode 6: Lucasfilm",
            "pub_date": "2016-01-19T17:00:00.000Z",
            "duration": "2508",
            "duration_label": "41m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6694334c/b8b4f512.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f5f8c5af7f8444f595929d8e1a74b54d",
            "index": 209,
            "title": "Episode 5: Siri",
            "pub_date": "2015-12-14T17:00:00.000Z",
            "duration": "2769",
            "duration_label": "46m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/92b1673c/1b1dda16.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d77bb7b9cdad4292b2831def25aa1d90",
            "index": 210,
            "title": "Episode 4: Bungie (with Xbox Co-Founder Ed Fries)",
            "pub_date": "2015-11-30T17:00:00.000Z",
            "duration": "4146",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/7c84baa0/569b7b03.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "755f4e36a056482aaca897fde45a9989",
            "index": 211,
            "title": "Episode 3: Twitch",
            "pub_date": "2015-11-16T17:00:00.000Z",
            "duration": "3309",
            "duration_label": "55m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/d0377ea9/c8a6fc38.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "242a738f9c0c4acf81edc6b22287a95c",
            "index": 212,
            "title": "Episode 2: Instagram",
            "pub_date": "2015-11-01T17:00:00.000Z",
            "duration": "2656",
            "duration_label": "44m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/9fb9bbae/6be6c481.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c42b01bab0f14dfc8ed136c3066bbffc",
            "index": 213,
            "title": "Episode 1: Pixar",
            "pub_date": "2015-10-15T16:00:00.000Z",
            "duration": "2366",
            "duration_label": "39m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "http://acquired.fm/",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/6aa182f7/47c03291.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0c20089b-5bd7-490f-bf8a-31361cf1a073",
            "index": 214,
            "title": "Trailer: What is Acquired?",
            "pub_date": "2015-10-01T17:00:00.000Z",
            "duration": "152",
            "duration_label": "2m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "nvidia"
            ],
            "page_url": "https://share.transistor.fm/s/860cafa1",
            "audio_url": "https://pscrb.fm/rss/p/media.transistor.fm/860cafa1/4437e77b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "a16z-show",
        "title": "The a16z Show",
        "feed_title": "The a16z Show",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "venture",
          "tech industry",
          "AI business"
        ],
        "feed_url": "https://feeds.simplecast.com/JGE3yC0V",
        "source_url": "https://feeds.simplecast.com/JGE3yC0V",
        "detail_path": "/podcasts/a16z-show/",
        "episode_count": 250,
        "selected_episode_count": 205,
        "latest_episode_title": "Building Search for AI Agents with Exa CEO Will Bryk",
        "latest_pub_date": "2026-06-06T10:00:00.000Z",
        "latest_page_url": "https://a16z.simplecast.com/episodes/building-search-for-ai-agents-with-exa-ceo-will-bryk-_pk3FHt0",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "2c5e645f-ab34-4cf2-bcfb-e00915af1c58",
            "index": 1,
            "title": "Building Search for AI Agents with Exa CEO Will Bryk",
            "pub_date": "2026-06-06T10:00:00.000Z",
            "duration": "00:49:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "retrieval",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-search-for-ai-agents-with-exa-ceo-will-bryk-_pk3FHt0",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c48ce585-3138-4686-bb9c-eaf4d247dee4/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c48ce585-3138-4686-bb9c-eaf4d247dee4&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e150c62-3071-4955-a4a0-77e7b7c982f9",
            "index": 2,
            "title": "AI Agents and the Fight for Customer Data",
            "pub_date": "2026-06-05T10:00:00.000Z",
            "duration": "00:50:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding",
              "enterprise ai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ai-agents-and-the-fight-for-customer-data-tpVVdpfj",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d887845c-81f2-4dc0-b162-5549e089aafd/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d887845c-81f2-4dc0-b162-5549e089aafd&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0efb210b-f2bb-46ca-a785-98c4b831fad5",
            "index": 3,
            "title": "Balaji and Steven Glinert on Network States, Supply Chains, and Allied Coalition Strategy",
            "pub_date": "2026-06-03T10:00:00.000Z",
            "duration": "00:55:14",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/balaji-and-steven-glinert-on-network-states-supply-chains-and-allied-coalition-strategy-C5bm4k5z",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a3c3971e-e2e4-41a6-bb93-addb227d9187/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a3c3971e-e2e4-41a6-bb93-addb227d9187&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc07d92d-1c17-43d4-b106-f2dfc460e3b9",
            "index": 4,
            "title": "Steven Sinofsky on AI PCs, NVIDIA, and the Future of Computing",
            "pub_date": "2026-06-02T17:16:55.000Z",
            "duration": "00:29:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "inference"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/steven-sinofsky-on-apple-at-50-microsoft-and-the-future-of-computing-qxp8eLCX",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6de42287-1fdf-427f-a5bd-f5ff8936238b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6de42287-1fdf-427f-a5bd-f5ff8936238b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0de90798-284e-449f-8940-f9968f01dcfe",
            "index": 5,
            "title": "Building AI Agents for Enterprise Operations",
            "pub_date": "2026-06-01T10:00:00.000Z",
            "duration": "00:46:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-ai-agents-for-enterprise-operations-g19Ldybr",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/be8b0422-dfff-4b0b-9e12-5697084036fd/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=be8b0422-dfff-4b0b-9e12-5697084036fd&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6eb845ef-3075-4858-9dbf-4dda8eca28fd",
            "index": 6,
            "title": "Why $1B Exits are Dead",
            "pub_date": "2026-05-29T10:00:00.000Z",
            "duration": "00:33:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "data center",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/why-1b-exits-are-dead-CeTnSS_y",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d4666782-9b3c-4009-b35f-467ecb47e57b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d4666782-9b3c-4009-b35f-467ecb47e57b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f785186b-12b9-4336-95e5-4242cc0b6ddb",
            "index": 7,
            "title": "Stablecoins, AI Agents, and The Future of Global Banking",
            "pub_date": "2026-05-28T10:00:00.000Z",
            "duration": "00:37:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/stablecoins-ai-agents-and-the-future-of-global-banking-bZkqdwxO",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/515fb10a-7c5e-40bd-8f9e-a4011de86c40/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=515fb10a-7c5e-40bd-8f9e-a4011de86c40&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7cc1133c-61a7-4acb-8a73-6e4b7ba6228a",
            "index": 8,
            "title": "Marc Rowan on Private Markets, Software Repricing, and Capital Allocation",
            "pub_date": "2026-05-27T10:00:00.000Z",
            "duration": "00:56:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-rowan-on-private-markets-software-repricing-and-capital-allocation-5Tq0zQ_D",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/67a33bdb-c390-41fd-82a6-c5525f62bf4f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=67a33bdb-c390-41fd-82a6-c5525f62bf4f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f41bb8a-925a-4d3e-95fc-f3790db1619e",
            "index": 9,
            "title": "Robin Hanson on Prediction Markets, Gambling, and the Future of Forecasting",
            "pub_date": "2026-05-26T17:28:08.000Z",
            "duration": "00:27:55",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/robin-hanson-on-prediction-markets-gambling-and-the-future-of-forecasting-9J5N0AFw",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/263b6030-a3fe-4ccf-a163-64dce9786b86/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=263b6030-a3fe-4ccf-a163-64dce9786b86&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0ca27533-0b5b-48e3-ac68-a89322634b7e",
            "index": 10,
            "title": "Why AI Isn’t Killing SaaS Yet",
            "pub_date": "2026-05-25T10:00:00.000Z",
            "duration": "00:40:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/why-ai-isnt-killing-saas-yet-FHixHn5O",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/4d27f71b-0d5c-4dc2-9cdc-ce3d422a600e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=4d27f71b-0d5c-4dc2-9cdc-ce3d422a600e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7434b425-1ef3-4c4a-ad10-0bcac505d89d",
            "index": 11,
            "title": "Hugging Face's Clem Delangue on Open Source AI and the LLM Bubble | MTS Live",
            "pub_date": "2026-05-22T10:00:00.000Z",
            "duration": "00:15:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "safety",
              "robotics"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/hugging-faces-clem-delangue-on-open-source-ai-and-the-llm-bubble-mts-live-ptSZ3KKP",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/223749fd-c1f7-4cc8-a580-94f4466b9896/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=223749fd-c1f7-4cc8-a580-94f4466b9896&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e11be957-5f77-4879-96bf-a549c3a256e4",
            "index": 12,
            "title": "How Superhuman Took Over Silicon Valley Email",
            "pub_date": "2026-05-21T10:00:00.000Z",
            "duration": "00:55:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/how-superhuman-took-over-silicon-valley-email-2C9E09yT",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/ab3abb7b-4e34-443e-9f91-d46955af42a0/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=ab3abb7b-4e34-443e-9f91-d46955af42a0&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a99b5b50-2b58-4dc2-b98c-d11e97cf0d43",
            "index": 13,
            "title": "Marc Andreessen on AI, California, and the Future of America | Joe Rogan",
            "pub_date": "2026-05-20T10:00:00.000Z",
            "duration": "03:04:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "automation",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-on-ai-california-and-the-future-of-america-joe-rogan-eafbidR1",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/4a072981-3a68-4409-add8-a246659aa077/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=4a072981-3a68-4409-add8-a246659aa077&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dbad563d-e6d7-43c8-a2b7-f27d374aae82",
            "index": 14,
            "title": "Rebuilding The American Shipyard",
            "pub_date": "2026-05-19T10:00:00.000Z",
            "duration": "00:12:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/rebuilding-the-american-shipyard-fSxcCyxZ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/22c5e11b-72bd-4b6f-ab5b-e2a7767925e3/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=22c5e11b-72bd-4b6f-ab5b-e2a7767925e3&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eebe9ade-ac88-4ffd-ae76-2264c608941e",
            "index": 15,
            "title": "The Plan to Make American Crime Obsolete",
            "pub_date": "2026-05-18T10:00:00.000Z",
            "duration": "00:11:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-plan-to-make-american-crime-obsolete-kFoaNrAU",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0a48e90e-2555-4245-b3b9-3957c98ab2c4/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0a48e90e-2555-4245-b3b9-3957c98ab2c4&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0e8b831-2dee-4ce8-ab97-f4fc3bdcb864",
            "index": 16,
            "title": "Vitalik Buterin on Human Agency in the AI Era",
            "pub_date": "2026-05-15T19:04:28.000Z",
            "duration": "00:26:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/vitalik-buterin-on-human-agency-in-the-ai-era-DY1OPgHD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/56d4795d-2fc6-4d36-8563-fa8debbd61b4/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=56d4795d-2fc6-4d36-8563-fa8debbd61b4&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9002c2b2-d702-4fae-bf65-397a11bc660a",
            "index": 17,
            "title": "Ben Horowitz - \"Your ONLY job is Right Product, Right Time\"",
            "pub_date": "2026-05-14T10:00:00.000Z",
            "duration": "00:18:43",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-your-only-job-is-right-product-right-time-PYh1Iyev",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5fbaa8b4-f1fd-4bea-8a14-275788549f9a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5fbaa8b4-f1fd-4bea-8a14-275788549f9a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7e042ace-f75b-44fb-9f14-0e9e7495761f",
            "index": 18,
            "title": "Energy, Minerals, and the Physical Stack Behind AI",
            "pub_date": "2026-05-13T10:00:00.000Z",
            "duration": "00:24:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/energy-minerals-and-the-physical-stack-behind-ai-9rkc7PLj",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f2eabf57-0e65-4d82-92e2-749593773033/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f2eabf57-0e65-4d82-92e2-749593773033&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c55fa8e8-5ff2-46b4-b041-17ae132ab32f",
            "index": 19,
            "title": "Lloyd Blankfein on Risk, Crisis, and Leadership",
            "pub_date": "2026-05-12T10:00:00.000Z",
            "duration": "01:12:33",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/lloyd-blankfein-on-risk-crisis-and-leadership-v0_nsi13",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/2bc4fcae-05a4-4e7d-a65b-04d73504c05a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=2bc4fcae-05a4-4e7d-a65b-04d73504c05a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa623b1d-d41e-4f8e-892e-c8f1b5f30833",
            "index": 20,
            "title": "Marc Andreessen on Builder Culture in the Age of AI",
            "pub_date": "2026-05-11T10:22:39.000Z",
            "duration": "01:04:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-on-builder-culture-in-the-age-of-ai-oE9pV1uI",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7bedca20-be12-4911-be38-915e0f5a742b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7bedca20-be12-4911-be38-915e0f5a742b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca4bf93b-3611-4a7c-bc33-c5a6fdd629ac",
            "index": 21,
            "title": "Ben Horowitz on the Next Technology Era",
            "pub_date": "2026-05-08T16:19:02.000Z",
            "duration": "00:29:29",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-on-the-next-technology-era-aoL5sxwd",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/ddaa2bb3-7e85-40b7-a124-89b8e4ae0935/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=ddaa2bb3-7e85-40b7-a124-89b8e4ae0935&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad90636a-9076-42e0-86dd-97d5abc916bd",
            "index": 22,
            "title": "Crypto Fund 5: We Raised $2.2B. Here’s Why.",
            "pub_date": "2026-05-07T10:00:00.000Z",
            "duration": "01:02:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/crypto-fund-5-we-raised-22b-heres-why-___CC391",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6b916643-4256-4a9d-9496-a74f5adaeea9/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6b916643-4256-4a9d-9496-a74f5adaeea9&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5071aa4a-a2d8-4595-8602-e9ab3952bd54",
            "index": 23,
            "title": "The New Space Race: NASA, Artemis, and the Race to the Moon",
            "pub_date": "2026-05-06T10:00:00.000Z",
            "duration": "00:29:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/the-new-space-race-nasa-artemis-and-the-race-to-the-moon-PgJ89xUm",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c117ce85-ebf5-4d7d-a4ff-a55a17ee3289/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c117ce85-ebf5-4d7d-a4ff-a55a17ee3289&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04b68d0e-7b20-4fb2-b604-444f5dcb4a73",
            "index": 24,
            "title": "Building Blackstone, Backing Costco, with Tony James",
            "pub_date": "2026-05-05T10:00:12.000Z",
            "duration": "01:23:48",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "alignment"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-blackstone-backing-costco-with-tony-james-TqmmrXcA",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/293642ae-8e65-440d-8a75-d6a3c9ed0eca/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=293642ae-8e65-440d-8a75-d6a3c9ed0eca&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c32cb02-ac0b-4745-bfd9-bb18dac80c91",
            "index": 25,
            "title": "Sarah Rogers: Free Speech, AI Diplomacy, and What America Owes Its Allies",
            "pub_date": "2026-05-04T10:00:00.000Z",
            "duration": "00:24:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/sarah-rogers-free-speech-ai-diplomacy-and-what-america-owes-its-allies-DE_Sv7Ni",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7e076b03-439a-4988-8be9-21f14b82236c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7e076b03-439a-4988-8be9-21f14b82236c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "80623c8b-f312-4532-8149-458a50621a43",
            "index": 26,
            "title": "Balaji and Taylor Lorenz on AI and Media",
            "pub_date": "2026-05-01T10:00:21.000Z",
            "duration": "00:51:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/balaji-and-taylor-lorenz-on-ai-and-media-MLvSb1Kh",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/8a9a758e-ce50-477f-8bb2-7ff14e38e5d6/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=8a9a758e-ce50-477f-8bb2-7ff14e38e5d6&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ae9505b-b2bb-46d9-a2e5-d861db549ba8",
            "index": 27,
            "title": "Workday’s Last Workday? AI and the Future of Enterprise Software",
            "pub_date": "2026-04-30T10:00:00.000Z",
            "duration": "00:29:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/workdays-last-workday-ai-and-the-future-of-enterprise-software-wLoOJbG1",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/fb2d2c68-4c48-447a-99da-a36675154f3e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=fb2d2c68-4c48-447a-99da-a36675154f3e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9c09545-4c76-4210-bf00-214b1f7f7ba9",
            "index": 28,
            "title": "The Shift in Global Drug Development",
            "pub_date": "2026-04-29T10:00:00.000Z",
            "duration": "00:57:43",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/the-shift-in-global-drug-development-Ch15YbK8",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f506f927-9c0e-4e5d-8005-df1f5036948f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f506f927-9c0e-4e5d-8005-df1f5036948f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "083c3e43-8148-45ec-87d5-cf2046094650",
            "index": 29,
            "title": "John and Patrick Collison on Stripe's Growth, Agent Commerce, and the Future of Software",
            "pub_date": "2026-04-28T10:00:00.000Z",
            "duration": "00:20:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "agent"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/john-and-patrick-collison-on-stripes-growth-agent-commerce-and-the-future-of-software-qL68mjfo",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a6e456c8-68ae-4d00-8b72-79de34d2d284/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a6e456c8-68ae-4d00-8b72-79de34d2d284&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e834a2c7-4ca4-428a-a07b-121d3f63c6a9",
            "index": 30,
            "title": "Ben Horowitz on Venture Capital and AI",
            "pub_date": "2026-04-27T10:05:18.000Z",
            "duration": "01:09:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-on-venture-capital-and-ai-ciXyFDLc",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/31435315-18af-4cb0-98d7-6f167b0058d2/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=31435315-18af-4cb0-98d7-6f167b0058d2&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f16c3a2-1ec5-45ee-b043-3e16b2b6b297",
            "index": 31,
            "title": "AI Inside the Enterprise",
            "pub_date": "2026-04-24T10:00:00.000Z",
            "duration": "01:00:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ai-inside-the-enterprise-0LPmCf9V",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7c7cd773-39fc-4cd0-bf8e-ccaeffbb7c44/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7c7cd773-39fc-4cd0-bf8e-ccaeffbb7c44&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0bf6bdf6-fce2-42be-90f4-2d52cd2b4777",
            "index": 32,
            "title": "Martin Shkreli on AI, Pharma, and What Actually Matters",
            "pub_date": "2026-04-23T15:34:18.000Z",
            "duration": "00:48:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/martin-shkreli-on-ai-pharma-and-what-actually-matters-MrpwiybP",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/011ea58b-9a75-4aad-853c-d5c569fece78/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=011ea58b-9a75-4aad-853c-d5c569fece78&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d557b656-099d-4e03-9e76-28b9c21afa67",
            "index": 33,
            "title": "Balaji Srinivasan: Prove Correct, Not Just Go Direct",
            "pub_date": "2026-04-22T10:00:00.000Z",
            "duration": "02:01:33",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/balaji-srinivasan-prove-correct-not-just-go-direct-2mZ_Tjdd",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/1e6606c2-cbc3-4a0a-b145-13c48efb1f7d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=1e6606c2-cbc3-4a0a-b145-13c48efb1f7d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b895718f-a269-4f64-a065-41cc3748fffe",
            "index": 34,
            "title": "Marc Andreessen: Monitoring the Situation and the Future of Media",
            "pub_date": "2026-04-21T10:00:00.000Z",
            "duration": "01:07:18",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-monitoring-the-situation-and-the-future-of-media-SNdO3OIF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/590cf677-77bd-47f3-9d3c-2dfab1b263b9/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=590cf677-77bd-47f3-9d3c-2dfab1b263b9&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6bdfde4c-b260-4c7b-a908-8e01d19cabbc",
            "index": 35,
            "title": "Rethinking Git for the Age of Coding Agents with GitHub Cofounder Scott Chacon",
            "pub_date": "2026-04-20T21:10:00.000Z",
            "duration": "00:47:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/rethinking-git-for-the-age-of-coding-agents-with-github-cofounder-scott-chacon-LGXF9DcJ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/2736fb62-e3e5-470f-8605-bfaa482f658b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=2736fb62-e3e5-470f-8605-bfaa482f658b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9148c04f-7a04-4ddf-b5aa-6881fc66c43e",
            "index": 36,
            "title": "Network Effects, AI Costs, and the Future of Consumer Investing with Anish Acharya on The Kevin Rose Show",
            "pub_date": "2026-04-19T10:00:00.000Z",
            "duration": "00:58:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/network-effects-ai-costs-and-the-future-of-consumer-investing-with-anish-acharya-on-the-kevin-rose-show-qd4UBcAL",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6f38fea3-e941-4051-bfd6-80bd914c6aaf/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6f38fea3-e941-4051-bfd6-80bd914c6aaf&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "18f25f54-7b66-4555-a89e-0c252393bf5a",
            "index": 37,
            "title": "The System Behind Self-Driving: Waymo’s Dmitri Dolgov",
            "pub_date": "2026-04-17T10:00:00.000Z",
            "duration": "01:04:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/from-models-to-mobility-building-waymo-with-dmitri-dolgov-p2z80L_O",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b3ac800f-ccb5-40d9-b6d5-c2a4754889ca/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b3ac800f-ccb5-40d9-b6d5-c2a4754889ca&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "efed1cab-0c14-4883-88d0-4cad841892b5",
            "index": 38,
            "title": "Technology, Culture, and the Next AI Interface with signüll",
            "pub_date": "2026-04-16T10:00:00.000Z",
            "duration": "00:34:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/technology-culture-and-the-next-ai-interface-with-signull-4oQgR1i2",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5cc92ccc-a12f-4e83-ab57-cd81cc87677a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5cc92ccc-a12f-4e83-ab57-cd81cc87677a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98191957-2a28-4016-a98e-8b2eb5cd560b",
            "index": 39,
            "title": "Replit's CEO on Vibe Coding, Wealth Building, and What Most People Get Wrong About AI",
            "pub_date": "2026-04-15T10:00:00.000Z",
            "duration": "01:39:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "replit",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/replits-ceo-on-vibe-coding-wealth-building-and-what-most-people-get-wrong-about-ai-YIXmaTPH",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/dc572800-5a58-4735-914b-1c5ab147f8d5/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=dc572800-5a58-4735-914b-1c5ab147f8d5&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4bc19c15-b1de-46d2-a029-dd6c127d9de2",
            "index": 40,
            "title": "Ben Horowitz on AI Infrastructure, Economics and The New Laws of Software",
            "pub_date": "2026-04-14T10:00:00.000Z",
            "duration": "00:29:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-on-ai-infrastructure-economics-and-the-new-laws-of-software-UjwFC_OO",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/9234f8b9-ba6f-483a-a874-8adb89da2c30/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=9234f8b9-ba6f-483a-a874-8adb89da2c30&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8fefea30-3f8a-409c-afd8-27ece805b5d2",
            "index": 41,
            "title": "Building Agents at Home: Parenting, Work, and Benevolent Neglect",
            "pub_date": "2026-04-13T10:00:00.000Z",
            "duration": "00:54:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-agents-at-home-parenting-work-and-benevolent-neglect-mKYG4LEo",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e654bac0-32fb-4d22-b867-d0ee6163ab2d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e654bac0-32fb-4d22-b867-d0ee6163ab2d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ec590915-7051-45fb-8ba6-e827fe358b8b",
            "index": 42,
            "title": "What Running Windows at Microsoft Taught Steven Sinofsky About Apple",
            "pub_date": "2026-04-10T10:00:00.000Z",
            "duration": "00:31:23",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/what-running-windows-at-microsoft-taught-steven-sinofsky-about-apple-hDzslODI",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5de42868-ae79-4841-9ce4-08f116d99f84/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5de42868-ae79-4841-9ce4-08f116d99f84&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af3040b3-5ee3-4ac4-88ee-e87d07fdf0d4",
            "index": 43,
            "title": "Who Controls AI Acceleration? Vitalik Buterin and Guillaume Verdon Debate",
            "pub_date": "2026-04-09T10:00:00.000Z",
            "duration": "01:39:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/who-controls-ai-acceleration-vitalik-buterin-and-guillaume-verdon-debate-KT8QsnrV",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/caaf9b73-450b-4c2e-8548-e122bafb96e6/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=caaf9b73-450b-4c2e-8548-e122bafb96e6&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8e62120-c865-428e-b1c2-1d965406f293",
            "index": 44,
            "title": "The Agent Era: Building Software Beyond Chat with Box CEO Aaron Levie",
            "pub_date": "2026-04-08T10:00:00.000Z",
            "duration": "00:59:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-agent-era-building-software-beyond-chat-with-box-ceo-aaron-levie-_HvhmObj",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/78b49179-3322-4bee-b3b9-7117831ba9cd/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=78b49179-3322-4bee-b3b9-7117831ba9cd&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75e53232-5a14-46f7-bf87-3d3a4857a60b",
            "index": 45,
            "title": "Balaji on Why AI Raises the Cost of Verification",
            "pub_date": "2026-04-07T10:00:00.000Z",
            "duration": "01:07:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/balaji-on-why-ai-raises-the-cost-of-verification-zv_t3DDF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e307c3fa-77d2-4d43-98e6-a56da75f619c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e307c3fa-77d2-4d43-98e6-a56da75f619c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6d5897df-44c5-4ca1-a6d3-a38c9c6e6977",
            "index": 46,
            "title": "Peter Yang on Small Teams, Coding Agents, and Why Human Ambition Has No Ceiling",
            "pub_date": "2026-04-06T15:45:00.000Z",
            "duration": "00:28:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/peter-yang-on-small-teams-coding-agents-and-why-human-ambition-has-no-ceiling-SscRoe6s",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/cfbbfafd-5701-40cb-9c79-2a8c04fe77ec/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=cfbbfafd-5701-40cb-9c79-2a8c04fe77ec&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd960df5-9d0a-4630-b24a-fdfa37583be1",
            "index": 47,
            "title": "Marc Andreessen on AI Winters and Agent Breakthroughs",
            "pub_date": "2026-04-03T17:30:00.000Z",
            "duration": "01:17:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "claude",
              "reasoning",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-on-ai-winters-and-agent-breakthroughs-fsdC0VvN",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/49988fe6-d35d-40a3-9709-0576315fd18e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=49988fe6-d35d-40a3-9709-0576315fd18e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d6577408-6c78-41e9-9803-3725e5b31eef",
            "index": 48,
            "title": "Alex Blania on Proof of Human and Building World's Identity Network",
            "pub_date": "2026-04-02T10:00:00.000Z",
            "duration": "00:42:27",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/alex-blania-on-proof-of-human-and-building-worlds-identity-network-7K52fNFN",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0aaeffbf-2114-465a-9fd1-6417d9cb9740/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0aaeffbf-2114-465a-9fd1-6417d9cb9740&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36dd6e38-bd6d-4283-975a-b386e4a2f86c",
            "index": 49,
            "title": "What Happens When a Public Company Goes All In on AI",
            "pub_date": "2026-04-01T10:00:00.000Z",
            "duration": "00:27:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/what-happens-when-a-public-company-goes-all-in-on-ai-cUCWrP64",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/01039473-10d8-42eb-8894-b736a613aa14/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=01039473-10d8-42eb-8894-b736a613aa14&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5599dec-87e3-42aa-a4d8-13035ed10d2c",
            "index": 50,
            "title": "How Radiant and Heron Are Rethinking Power Generation and Delivery",
            "pub_date": "2026-03-31T10:04:03.000Z",
            "duration": "00:49:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/how-radiant-and-heron-are-rethinking-power-generation-and-delivery-M1HRtAN7",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/1f58eddc-8ef4-463e-9be7-5fc1f3f7f06f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=1f58eddc-8ef4-463e-9be7-5fc1f3f7f06f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c92af97-4596-4752-b03c-eb0acba6ee58",
            "index": 51,
            "title": "Marc Andreessen on Evaluating Founders and AI's Consumer Surplus",
            "pub_date": "2026-03-30T13:00:00.000Z",
            "duration": "01:07:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-on-evaluating-founders-and-ais-consumer-surplus-Gu808y3s",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6aebc59f-f776-4312-ab95-8e3b20f4d19f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6aebc59f-f776-4312-ab95-8e3b20f4d19f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e782201-44f6-4ff3-99b0-ffc1a86a764b",
            "index": 52,
            "title": "The SpaceX and Tesla Playbook for Hard Tech Startups",
            "pub_date": "2026-03-27T10:00:00.000Z",
            "duration": "00:50:58",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/the-spacex-and-tesla-playbook-for-hard-tech-startups-1wPtKHVt",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a4eb08f0-5707-4a2c-b7c6-728b4e5ae186/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a4eb08f0-5707-4a2c-b7c6-728b4e5ae186&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d895626e-79f5-47dc-9655-ac3085860003",
            "index": 53,
            "title": "Security, Resilience, and the Future of Mobile Infrastructure",
            "pub_date": "2026-03-26T15:28:55.000Z",
            "duration": "00:41:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/security-resilience-and-the-future-of-mobile-infrastructure-FE05DDD_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/cbd6f188-7d5d-4787-b251-39c8fbea6e89/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=cbd6f188-7d5d-4787-b251-39c8fbea6e89&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be0495c3-f14a-446b-8eb9-afa200c44581",
            "index": 54,
            "title": "Submarines and the Future of Defense Manufacturing",
            "pub_date": "2026-03-25T10:00:00.000Z",
            "duration": "00:23:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/submarines-and-the-future-of-defense-manufacturing-KGko_EJ6",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/4e2a0753-e935-434c-972e-dcfc5819a2a4/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=4e2a0753-e935-434c-972e-dcfc5819a2a4&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f3b05bf0-1952-46a7-8a05-23946f55f67a",
            "index": 55,
            "title": "The Missing Power Layer of Modern Warfare",
            "pub_date": "2026-03-24T10:00:55.000Z",
            "duration": "00:50:34",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/the-missing-power-layer-of-modern-warfare-tbo9oBnG",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/bd5c383e-1d2b-4fa7-a189-ac4e4fe869a5/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=bd5c383e-1d2b-4fa7-a189-ac4e4fe869a5&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6cadc4a7-084f-42d7-900b-567c96cb425b",
            "index": 56,
            "title": "Why Every Satellite Needs Earth | Northwood CEO on a16z",
            "pub_date": "2026-03-23T20:02:21.000Z",
            "duration": "00:40:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/why-every-satellite-needs-earth-northwood-ceo-on-a16z-sPoRUFws",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/2267a36c-34cb-46b4-b7bf-a22d2eadc73c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=2267a36c-34cb-46b4-b7bf-a22d2eadc73c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5f117324-ba75-4af2-b75f-a419a177b639",
            "index": 57,
            "title": "Inside Palantir: Building Software That Matters with Shyam Sankar",
            "pub_date": "2026-03-20T10:00:00.000Z",
            "duration": "00:54:51",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/inside-palantir-building-software-that-matters-with-shyam-sankar-mSRYC1eQ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/424ce8dd-ed62-4972-a5cb-cfa0cf910ab1/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=424ce8dd-ed62-4972-a5cb-cfa0cf910ab1&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1e92a9dd-78da-4417-b1ce-4b4318d1f8c4",
            "index": 58,
            "title": "AI Just Gave You Superpowers — Now What?",
            "pub_date": "2026-03-19T10:00:00.000Z",
            "duration": "01:06:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "automation"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ai-just-gave-you-superpowers-now-what-w1BZEEnu",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0911ade7-ebb7-42bd-9dc0-25e9d5bb9181/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0911ade7-ebb7-42bd-9dc0-25e9d5bb9181&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a933596-ade2-4914-b13e-375c5ac0fa41",
            "index": 59,
            "title": "AI, Supply Chains, and the Future of Economic Power",
            "pub_date": "2026-03-18T10:00:00.000Z",
            "duration": "00:37:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/jacob-helberg-draft-6EvVv6rO",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c909109d-ee0e-4f17-ae99-622f1fc627f7/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c909109d-ee0e-4f17-ae99-622f1fc627f7&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6d0a2893-0cf5-47c4-87f9-7bf5db7a7888",
            "index": 60,
            "title": "What's Missing Between LLMs and AGI - Vishal Misra & Martin Casado",
            "pub_date": "2026-03-17T11:05:23.000Z",
            "duration": "00:47:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "agi",
              "training"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/whats-missing-between-llms-and-agi-vishal-misra-martin-casado-YRValfqT",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/69d41c00-0963-4d43-9837-7a8718959ebc/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=69d41c00-0963-4d43-9837-7a8718959ebc&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29966786-4785-47fc-8117-d99b7841077a",
            "index": 61,
            "title": "AI Startups vs. Big Chatbots — With Olivia Moore",
            "pub_date": "2026-03-16T10:00:00.000Z",
            "duration": "00:56:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "chatgpt",
              "claude",
              "gemini"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ai-startups-vs-big-chatbots-with-olivia-moore-h3P18Yyl",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/3e22bf60-cfa4-4419-8077-6d7837a648f7/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=3e22bf60-cfa4-4419-8077-6d7837a648f7&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ae94cef0-be60-44f9-8716-02f7423973b5",
            "index": 62,
            "title": "Marc Andreessen on the Mindset of Great Founders — with David Senra",
            "pub_date": "2026-03-15T17:10:12.000Z",
            "duration": "01:49:07",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-on-the-mindset-of-great-founders-with-david-senra-2nzQS_kD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e67bdf23-557e-4e44-a677-3dc01d8d8bf6/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e67bdf23-557e-4e44-a677-3dc01d8d8bf6&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dff14c3b-d224-499c-90fc-e6477f6737da",
            "index": 63,
            "title": "Emil Michael: Iran, Anthropic and the Future of AI at the Pentagon",
            "pub_date": "2026-03-13T10:00:00.000Z",
            "duration": "00:27:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/emil-michael-iran-anthropic-and-the-future-of-ai-at-the-pentagon-Ng4jELx1",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/1765b7fa-a030-460f-83d9-727b7b09c413/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=1765b7fa-a030-460f-83d9-727b7b09c413&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83d9dbc0-d0fc-4194-abb3-69af14656090",
            "index": 64,
            "title": "Palantir CEO Alex Karp on the Zero-Sum AI Race",
            "pub_date": "2026-03-12T10:00:00.000Z",
            "duration": "00:32:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/palantir-ceo-alex-karp-on-the-zero-sum-ai-race-39f_cNL_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5bf76ad2-6419-4ff0-937a-9da0331ff16f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5bf76ad2-6419-4ff0-937a-9da0331ff16f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ae881697-54e2-4449-921c-2958a262fb5f",
            "index": 65,
            "title": "What It Takes to Clear a Million Crimes a Year with Flock Safety's CEO",
            "pub_date": "2026-03-11T10:00:00.000Z",
            "duration": "01:46:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/what-it-takes-to-clear-a-million-crimes-a-year-with-flock-safetys-ceo-E0aARCdV",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/921493d6-1591-4a65-91b0-359c2aa20ee4/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=921493d6-1591-4a65-91b0-359c2aa20ee4&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f3ac321-8823-4c4e-bb85-97812d54b4f3",
            "index": 66,
            "title": "The Top 100 Gen AI Consumer Apps",
            "pub_date": "2026-03-10T10:00:00.000Z",
            "duration": "00:40:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "claude"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-top-100-gen-ai-consumer-apps-Z5knOdcs",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/9424752a-b4fe-4802-b9bc-bbb03d81fd25/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=9424752a-b4fe-4802-b9bc-bbb03d81fd25&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b7ea7a42-8b62-472f-aa70-ddfddd17f652",
            "index": 67,
            "title": "Andrew Huberman: Peptides, Sleep Tech, and the End of Obesity",
            "pub_date": "2026-03-09T10:00:00.000Z",
            "duration": "00:51:36",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/andrew-huberman-peptides-sleep-tech-and-the-end-of-obesity-LKFcXxTU",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/59bda1a2-918a-4dc9-a167-05fcd6c5355f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=59bda1a2-918a-4dc9-a167-05fcd6c5355f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3614cc37-b64d-47e9-88da-51eda0e6bca7",
            "index": 68,
            "title": "Atlassian CEO on the SaaS Apocalypse, AI Agents & What Comes Next",
            "pub_date": "2026-03-06T16:24:02.000Z",
            "duration": "00:55:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/atlassian-ceo-on-the-saas-apocalypse-ai-agents-what-comes-next-h71NBdHW",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c39605ee-6196-4c03-85ca-91ed76d88ac7/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c39605ee-6196-4c03-85ca-91ed76d88ac7&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3aa76b43-5b12-4795-b892-1daa6ebbcca4",
            "index": 69,
            "title": "Ben Thompson: Anthropic, the Pentagon, and the Limits of Private Power",
            "pub_date": "2026-03-05T11:00:00.000Z",
            "duration": "00:36:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "alignment"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-thompson-x-tbpn-draft-Ul1bevvC",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b5969866-c81b-4bc0-b162-d8939d43852b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b5969866-c81b-4bc0-b162-d8939d43852b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3513b51-9365-489a-8ddb-1b8ad40c4b4c",
            "index": 70,
            "title": "Deploying AI in Healthcare",
            "pub_date": "2026-03-04T18:45:00.000Z",
            "duration": "00:49:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ambience-ceo-nikhil-buduma-on-ai-in-clinical-workflows-4Vm_QgbN",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/2b2a2d50-0774-4d7e-b71b-703e83dcd6cc/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=2b2a2d50-0774-4d7e-b71b-703e83dcd6cc&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a279dc13-f308-4f57-aaa6-9fad2fbdad00",
            "index": 71,
            "title": "Ben Horowitz On What Makes a Great Founder",
            "pub_date": "2026-03-03T11:00:00.000Z",
            "duration": "00:50:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-on-what-makes-a-great-founder-y8Mditkj",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/56351af2-62bb-4895-af4e-2b75d4e29909/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=56351af2-62bb-4895-af4e-2b75d4e29909&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a7873e6-52cf-493d-a1a1-360a49324923",
            "index": 72,
            "title": "Chris Dixon: From Quant Trading to Building a16z Crypto",
            "pub_date": "2026-03-02T11:00:00.000Z",
            "duration": "00:59:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/chris-dixon-from-quant-trading-to-building-a16z-crypto-kaofpaaQ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/570e2e70-58d1-4291-aa63-e4512d6e78cf/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=570e2e70-58d1-4291-aa63-e4512d6e78cf&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1fef29af-b0f4-4bb6-bf2c-a74b31dc1d36",
            "index": 73,
            "title": "a16z's New Media Playbook",
            "pub_date": "2026-02-27T11:00:00.000Z",
            "duration": "00:48:28",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/a16zs-new-media-playbook-yf8qklrr",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0ca265e2-712a-48c7-8528-4e55ab9ca062/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0ca265e2-712a-48c7-8528-4e55ab9ca062&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "58b545a2-c4fa-4ada-a1f9-c7c0156839ae",
            "index": 74,
            "title": "When Giants Don’t Go Public: Inside the $5 Trillion Private Tech Market",
            "pub_date": "2026-02-26T11:00:00.000Z",
            "duration": "00:47:01",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/when-giants-dont-go-public-inside-the-5-trillion-private-tech-market-d4i96jsJ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/23acb9fc-cbfd-41d8-a836-2afe18587ffe/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=23acb9fc-cbfd-41d8-a836-2afe18587ffe&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd4d3a2e-9e08-40e1-840f-a6044c15e33b",
            "index": 75,
            "title": "Ben Horowitz: RSI, Crypto as AI Money, & Classified Physics",
            "pub_date": "2026-02-23T11:00:00.000Z",
            "duration": "01:48:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-rsi-crypto-as-ai-money-classified-physics-7haZIfGq",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/4c413c01-fc04-4304-b163-43b73ce81260/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=4c413c01-fc04-4304-b163-43b73ce81260&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f944d6b7-48a1-4278-a0eb-2f8355b02e3f",
            "index": 76,
            "title": "Patrick Collison on Stripe’s Early Choices, Smalltalk, and What Comes After Coding",
            "pub_date": "2026-02-20T11:00:00.000Z",
            "duration": "00:52:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/patrick-collison-on-stripes-early-choices-smalltalk-and-what-comes-after-coding-hsXebQ3K",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/cacee14f-c50b-4b98-b476-597e2376f945/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=cacee14f-c50b-4b98-b476-597e2376f945&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6d83105b-d121-4216-8b8d-4797fbc81bd2",
            "index": 77,
            "title": "AI’s Capital Flywheel: Models, Money, and the Future of Power",
            "pub_date": "2026-02-19T16:30:00.000Z",
            "duration": "00:57:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "frontier model"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/capital-compute-and-the-fight-for-ai-dominance-Qb96oXgu",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/59e995ea-faf7-4728-93a9-154634ad965f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=59e995ea-faf7-4728-93a9-154634ad965f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c23f5093-52e6-41db-ac58-96ccc55fa9df",
            "index": 78,
            "title": "From Copilots to Agents: Rebuilding the Company Around AI",
            "pub_date": "2026-02-18T11:00:00.000Z",
            "duration": "00:59:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "copilot"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/from-copilots-to-agents-rebuilding-the-company-around-ai-_07WiWQy",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b5bf0610-aafd-451b-8a21-18bc56cfc9ce/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b5bf0610-aafd-451b-8a21-18bc56cfc9ce&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42450fa1-df77-4982-98a9-6b5721bc42a3",
            "index": 79,
            "title": "WSJ x a16z: The Next 25 Years of Defense Innovation",
            "pub_date": "2026-02-17T11:00:00.000Z",
            "duration": "00:30:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/wsj-x-a16z-the-next-25-years-of-defense-innovation-7fNyoZyd",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6a2e13fe-e97e-4ee5-ad39-1f88e924b794/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6a2e13fe-e97e-4ee5-ad39-1f88e924b794&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e1b9385-cfed-4abd-aa74-5cbd3298b4e8",
            "index": 80,
            "title": "Novartis CEO Vasant Narasimhan on Transforming a 250-Year-Old Company",
            "pub_date": "2026-02-16T11:17:06.000Z",
            "duration": "00:58:12",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/novartis-ceo-vasant-narasimhan-on-transforming-a-250-year-old-company-5kBHPRUC",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/13a3e677-8fcd-4c33-9bbf-f4668f4e02a6/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=13a3e677-8fcd-4c33-9bbf-f4668f4e02a6&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5251fdf5-69d3-4850-8252-56760f480509",
            "index": 81,
            "title": "Balaji and Dan Wang: The Engineering State vs Lawyerly State",
            "pub_date": "2026-02-13T11:23:31.000Z",
            "duration": "01:03:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/balaji-and-dan-wang-the-engineering-state-vs-lawyerly-state-geekCvPy",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7b22756b-ffa4-43b9-8cb2-bf62af811621/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7b22756b-ffa4-43b9-8cb2-bf62af811621&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5796236a-325c-49ab-8225-dd6c50874eb6",
            "index": 82,
            "title": "Anish Acharya: Is SaaS Dead in a World of AI?",
            "pub_date": "2026-02-12T11:00:00.000Z",
            "duration": "01:21:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/anish-acharya-is-saas-dead-in-a-world-of-ai-O8HbgCYl",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0ffd06f6-771a-477f-9314-6bbb8172b91d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0ffd06f6-771a-477f-9314-6bbb8172b91d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ecd9fc72-7490-4ada-a5d0-8b4e8fcec43c",
            "index": 83,
            "title": "How Magic Johnson Built a Billion-Dollar Portfolio in 30 Years",
            "pub_date": "2026-02-11T11:00:00.000Z",
            "duration": "01:05:35",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/how-magic-johnson-built-a-billion-dollar-portfolio-in-30-years-FMsfMARC",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/90d60d3c-94bb-4cbe-b9c0-538255e21abf/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=90d60d3c-94bb-4cbe-b9c0-538255e21abf&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1154671d-6397-480c-a05b-088c9e506e91",
            "index": 84,
            "title": "Marc Andreessen: Who Runs the World’s AI?",
            "pub_date": "2026-02-10T18:48:36.000Z",
            "duration": "00:26:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-who-runs-the-worlds-ai-hCEmBXHZ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c23e2c6c-3eb2-4d9c-9cc1-ac18929a1f7f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c23e2c6c-3eb2-4d9c-9cc1-ac18929a1f7f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5dc32af1-cc35-40bd-8bb9-74efdff4f30b",
            "index": 85,
            "title": "The State of Markets",
            "pub_date": "2026-02-09T19:52:46.000Z",
            "duration": "00:47:59",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-state-of-markets-uuopmdKY",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/70b0fd5c-17ea-46d4-9ac7-b1e55121c0db/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=70b0fd5c-17ea-46d4-9ac7-b1e55121c0db&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c0abdbe-9c6a-4a2c-bafa-8c3e03d7dc32",
            "index": 86,
            "title": "Balaji & Benedict Evans: When Tech Breaks Industries",
            "pub_date": "2026-02-06T23:00:40.000Z",
            "duration": "02:06:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/balaji-x-benedict-evans-draft-szho1EJ4",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0de39d7e-d09c-4b27-b09d-d19e87c41793/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0de39d7e-d09c-4b27-b09d-d19e87c41793&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "769463f1-78f9-431e-9f63-ba152a15e6f5",
            "index": 87,
            "title": "Why This Isn't the Dot-Com Bubble | Martin Casado on WSJ's BOLD NAMES",
            "pub_date": "2026-02-05T11:00:00.000Z",
            "duration": "00:29:29",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/why-this-isnt-the-dot-com-bubble-martin-casado-on-wsjs-bold-names-lpintmla",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6cfdc313-5477-4e89-b7ff-0e005f8cfc5e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6cfdc313-5477-4e89-b7ff-0e005f8cfc5e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5a5eb8a-5880-40fd-9269-e533869ace15",
            "index": 88,
            "title": "Why America’s Health Crisis Is an Incentive Problem",
            "pub_date": "2026-02-04T11:00:00.000Z",
            "duration": "00:41:58",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/why-americas-health-crisis-is-an-incentive-problem-vC_d0tuj",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d05e9cd9-a199-450d-adde-e5b929f1a089/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d05e9cd9-a199-450d-adde-e5b929f1a089&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "85b8fc71-10d0-405f-b831-a02c27fb555e",
            "index": 89,
            "title": "Palmer Luckey on Hardware, Building, and the Next Frontiers of Innovation",
            "pub_date": "2026-02-03T15:01:24.000Z",
            "duration": "01:02:20",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/palmer-luckey-on-hardware-building-and-the-next-frontiers-of-innovation-mfXdU3h7",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/bb4ae8d4-5a66-4119-bbc7-4a788904455c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=bb4ae8d4-5a66-4119-bbc7-4a788904455c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d408dfa2-d32f-4e26-9d63-2e27aaa0778f",
            "index": 90,
            "title": "David Solomon & Ben Horowitz on Building Organizational Resilience & Navigating Macro Uncertainty",
            "pub_date": "2026-02-02T15:21:43.000Z",
            "duration": "00:36:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "enterprise ai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-dh-goldman-draft-R3q1UeKb",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/9480b53f-480d-472b-83ab-d4959d7dee82/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=9480b53f-480d-472b-83ab-d4959d7dee82&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "359216a5-6ac0-4002-bae0-d2355f3751d5",
            "index": 91,
            "title": "“Anyone Can Code Now” - Netlify CEO Talks AI Agents",
            "pub_date": "2026-01-30T11:00:00.000Z",
            "duration": "00:57:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/anyone-can-code-now-netlify-ceo-talks-ai-agents-L9FlDni9",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5250566f-c4cc-4ec7-a6fc-7f862c961dd5/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5250566f-c4cc-4ec7-a6fc-7f862c961dd5&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0995bd48-a03e-48ee-802e-df5f2e088cfb",
            "index": 92,
            "title": "Marc Andreessen on Why This Is the Most Important Moment in Tech History",
            "pub_date": "2026-01-29T11:00:00.000Z",
            "duration": "01:41:13",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-on-why-this-is-the-most-important-moment-in-tech-history-LKmC5VRE",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5bcfa146-ec73-4bc3-b34c-e098af3a29ab/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5bcfa146-ec73-4bc3-b34c-e098af3a29ab&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5b2af47-ae19-4c79-bc0f-d57bb929ed59",
            "index": 93,
            "title": "Ben Horowitz and Balaji Srinivasan on Netscape and Network States",
            "pub_date": "2026-01-28T11:00:00.000Z",
            "duration": "00:42:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-and-balaji-srinivasan-on-netscape-and-network-states-LvyrSCPK",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7e55f94a-38d9-4da8-9da8-366b1b15ba0d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7e55f94a-38d9-4da8-9da8-366b1b15ba0d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46533040-31a3-4344-a0b7-788182ae6a60",
            "index": 94,
            "title": "Healthcare 2026: AI Doctors, GLP-1s, and Insurance Defection",
            "pub_date": "2026-01-27T11:00:00.000Z",
            "duration": "01:34:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-consumer-behavior-is-rewiring-us-healthcare-5Ex9w8F7",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b9597c4d-7ff6-4f3e-ba0c-47acfa6044a9/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b9597c4d-7ff6-4f3e-ba0c-47acfa6044a9&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "133759ee-e8c4-4575-926e-277e2614ef00",
            "index": 95,
            "title": "The Hidden Economics Powering AI",
            "pub_date": "2026-01-26T17:33:24.000Z",
            "duration": "01:04:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-real-economics-behind-the-al-boom-7LNh86AD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/af415817-3460-4941-a334-89a749bd99f5/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=af415817-3460-4941-a334-89a749bd99f5&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2252f286-8fab-44db-8e78-bef36f0f0650",
            "index": 96,
            "title": "How Mintlify Is Rebuilding Documentation for Coding Agents",
            "pub_date": "2026-01-23T14:00:00.000Z",
            "duration": "00:44:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-mintlify-is-rebuilding-documentation-for-coding-agents-5mrEd7Xm",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0e4db3e7-1a19-4ce6-869c-15e4ca16d262/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0e4db3e7-1a19-4ce6-869c-15e4ca16d262&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "54d9317f-a8bc-47db-8fe0-2ddb4dadbe4c",
            "index": 97,
            "title": "Inferact: Building the Infrastructure That Runs Modern AI",
            "pub_date": "2026-01-22T16:21:37.000Z",
            "duration": "00:43:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "inference"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/inferact-building-the-infrastructure-that-runs-modern-ai-baPx6f5v",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/381c9763-240f-4f93-a12d-b017c2b736a2/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=381c9763-240f-4f93-a12d-b017c2b736a2&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a267bc4-6fa3-45be-993b-0733ec4ab10a",
            "index": 98,
            "title": "Martin Casado on the Demand Forces Behind AI",
            "pub_date": "2026-01-21T11:00:00.000Z",
            "duration": "00:27:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/martin-casado-on-the-demand-forces-behind-ai-pUTZS22R",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/82fbd510-9181-41e8-998d-16fd576a0282/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=82fbd510-9181-41e8-998d-16fd576a0282&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ca9d13c-af63-4344-ab68-75a2915e664a",
            "index": 99,
            "title": "From Code Search to AI Agents: Inside Sourcegraph's Transformation with CTO Beyang Liu",
            "pub_date": "2026-01-20T11:00:00.000Z",
            "duration": "00:46:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "llama",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/from-code-search-to-ai-agents-inside-sourcegraphs-transformation-with-cto-beyang-liu-68cORVQD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/3a904a55-f518-4de0-8d97-16017d9fcd66/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=3a904a55-f518-4de0-8d97-16017d9fcd66&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65c7ce56-aeb1-4b2c-b8b3-9474ee6c0117",
            "index": 100,
            "title": "The AI Opportunity That Goes Beyond Models",
            "pub_date": "2026-01-19T11:00:00.000Z",
            "duration": "01:10:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-ai-opportunity-that-goes-beyond-models-f9t5aXG0",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b607f062-f20b-4754-8a4c-a5a97da69bd3/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b607f062-f20b-4754-8a4c-a5a97da69bd3&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de8dbf2a-1dc3-4515-8735-b7441aa0779d",
            "index": 101,
            "title": "How Foundation Models Evolved: A PhD Journey Through AI's Breakthrough Era",
            "pub_date": "2026-01-16T11:00:00.000Z",
            "duration": "00:57:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-foundation-models-evolved-a-phd-journey-through-ais-breakthrough-era-7PGAXSBb",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/396a3570-4447-4184-8b5d-3ddc76236f37/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=396a3570-4447-4184-8b5d-3ddc76236f37&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b0278e95-8ec8-4f9b-9f8b-1d55c60bba44",
            "index": 102,
            "title": "Ben & Marc: Why Everything Is About to Get 10x Bigger",
            "pub_date": "2026-01-15T16:27:54.000Z",
            "duration": "00:58:08",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-marc-why-everything-is-about-to-get-10x-bigger-N5Nvq7Wf",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b0ebe535-260f-4f98-a224-a815d024ddd9/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b0ebe535-260f-4f98-a224-a815d024ddd9&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dbe59032-8f18-4d57-ad9a-59dd97386a93",
            "index": 103,
            "title": "Alex Rampell on TBPN: Revenge, Redemption, and Founder Drive",
            "pub_date": "2026-01-14T11:00:00.000Z",
            "duration": "00:17:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/alex-rampell-on-tbpn-revenge-redemption-and-founder-drive-mAJy8JDE",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6cd4401d-9cf9-4160-a270-1a927afc3b95/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6cd4401d-9cf9-4160-a270-1a927afc3b95&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b204a64-3d7d-44c5-9359-4240ace4bfba",
            "index": 104,
            "title": "Ben Horowitz on Investing in AI: AI Bubbles, Economic Impact, and VC Acceleration",
            "pub_date": "2026-01-13T11:00:00.000Z",
            "duration": "00:34:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-on-investing-in-ai-ai-bubbles-economic-impact-and-vc-acceleration-GG9lt_tr",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/1c4e2f60-c5c8-42af-af94-c6f2f87d57a8/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=1c4e2f60-c5c8-42af-af94-c6f2f87d57a8&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1a88c3d-d51e-4f30-8c1e-cacbeacad53f",
            "index": 105,
            "title": "Alex Rampell on Venture at Scale and Founder Incentives",
            "pub_date": "2026-01-12T21:10:00.000Z",
            "duration": "01:11:21",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/alex-rampell-on-venture-at-scale-and-founder-incentives-m0n2Jb9j",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/cdec6991-d55f-4f21-ae95-842762ca022d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=cdec6991-d55f-4f21-ae95-842762ca022d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "193af70c-7d9b-4206-a6d3-3253913fa14a",
            "index": 106,
            "title": "Ben Horowitz on TBPN: Three Decades with Marc and Building for the Long Game",
            "pub_date": "2026-01-11T11:00:00.000Z",
            "duration": "00:24:03",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-on-tbpn-three-decades-with-marc-and-building-for-the-long-game-pxsceypR",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7c1908c2-7925-48b8-ac97-2aa39794da33/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7c1908c2-7925-48b8-ac97-2aa39794da33&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1619774b-8856-4abf-bdf2-938543a33e7b",
            "index": 107,
            "title": "Ben Horowitz on Raising a New Fund and How Venture Firms Scale",
            "pub_date": "2026-01-09T17:43:53.000Z",
            "duration": "00:59:10",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-on-raising-a-new-fund-and-how-venture-firms-scale-hbJKzBdX",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/9f06ffa3-e75f-4b58-a3ac-1134538fb1b5/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=9f06ffa3-e75f-4b58-a3ac-1134538fb1b5&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2120306d-e6b8-425e-b1bb-c72784ed7ae7",
            "index": 108,
            "title": "Keycard: 2026 is the Year of Agents",
            "pub_date": "2026-01-08T11:00:00.000Z",
            "duration": "00:32:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/keycard-2026-is-the-year-of-agents-U4tyBiJL",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/ddde89b1-8424-4a80-9a51-09d9a6b98199/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=ddde89b1-8424-4a80-9a51-09d9a6b98199&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "330f24c4-b06d-46e3-8bd1-3a73adef1dbb",
            "index": 109,
            "title": "Marc Andreessen's 2026 Outlook: AI Timelines, US vs. China, and The Price of AI",
            "pub_date": "2026-01-07T11:00:00.000Z",
            "duration": "01:21:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessens-2026-outlook-ai-timelines-us-vs-china-and-the-price-of-ai-vLiGj_5o",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d785567b-2c62-4f79-aa54-95e98ef5d55d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d785567b-2c62-4f79-aa54-95e98ef5d55d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6ae44aed-4cf3-44eb-8f38-6f24be4f831c",
            "index": 110,
            "title": "Figma’s Dylan Field on the Future of Design",
            "pub_date": "2026-01-06T11:00:00.000Z",
            "duration": "00:58:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/figmas-dylan-field-on-the-future-of-design-S9iwhdXk",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/95aa1161-5172-43d7-90f6-7f24f0c6aaad/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=95aa1161-5172-43d7-90f6-7f24f0c6aaad&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9bf581be-a17b-44d2-b3dc-e174cf030541",
            "index": 111,
            "title": "AI Will Save The World with Marc Andreessen and Martin Casado",
            "pub_date": "2026-01-05T11:00:00.000Z",
            "duration": "01:03:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ai-will-save-the-world-with-marc-andreessen-and-martin-casado-bra-dqi2-AydQxUTD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5fd8a7f5-c1d0-4f86-bba5-33e60ffb71a6/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5fd8a7f5-c1d0-4f86-bba5-33e60ffb71a6&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8b296b62-2b62-4fa9-9271-5f34f4fdb1e5",
            "index": 112,
            "title": "Wartime vs Peacetime: Ben Horowitz on Leadership",
            "pub_date": "2026-01-02T11:00:00.000Z",
            "duration": "00:35:02",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/wartime-vs-peacetime-ben-horowitz-on-leadership-uhaaybsk-5UIRv479",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/fc0afdfd-2750-4475-9838-601c77b424fd/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=fc0afdfd-2750-4475-9838-601c77b424fd&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff50a1c5-a406-49ea-bd39-988b1af03eaf",
            "index": 113,
            "title": "The Techno-Optimist Manifesto with Marc Andreessen and Ben Horowitz",
            "pub_date": "2026-01-01T11:00:00.000Z",
            "duration": "01:06:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/the-techno-optimist-manifesto-with-marc-andreessen-and-ben-horowitz-1b5mv8pi-gna9iB8R",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c1dd25ea-67b2-4057-b295-294b5e41be16/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c1dd25ea-67b2-4057-b295-294b5e41be16&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "72051a15-30b1-4987-8252-dbd80d52d822",
            "index": 114,
            "title": "The Inside Story of Growth Investing at a16z",
            "pub_date": "2025-12-31T11:00:00.000Z",
            "duration": "00:28:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/the-inside-story-of-growth-investing-at-a16z-F7_Z134S",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/26ecc464-7ad8-4bf8-9462-58528397eb67/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=26ecc464-7ad8-4bf8-9462-58528397eb67&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "812dd050-747e-4645-ba06-82238ed8bdf6",
            "index": 115,
            "title": "Why a16z's Martin Casado Believes the AI Boom Still Has Years to Run",
            "pub_date": "2025-12-30T11:00:00.000Z",
            "duration": "01:22:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/why-a16zs-martin-casado-believes-the-ai-boom-still-has-years-to-run-XxCz1OYF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/84b68524-3d31-4fc0-b584-87e0cbae7d2b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=84b68524-3d31-4fc0-b584-87e0cbae7d2b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "18949b9a-ef34-4e34-9b0d-664b61474163",
            "index": 116,
            "title": "Where Does Consumer AI Stand at the End of 2025?",
            "pub_date": "2025-12-29T11:00:00.000Z",
            "duration": "00:44:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/where-does-consumer-ai-stand-at-the-end-of-2025-tEyfJBlw",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/af082805-62ee-4409-be93-0eaa17e4c45d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=af082805-62ee-4409-be93-0eaa17e4c45d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eaaeca0f-8f01-4e0b-bfe9-eefbe3667bbf",
            "index": 117,
            "title": "Big Ideas 2026: New Infrastructure Primitives",
            "pub_date": "2025-12-26T11:00:00.000Z",
            "duration": "00:20:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning",
              "robotics",
              "automation"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/big-ideas-2026-new-infrastructure-primitives-uhuC1TnI",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f778e7aa-91bc-4786-9f8f-43a665d999e8/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f778e7aa-91bc-4786-9f8f-43a665d999e8&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5cfef65a-f38b-4dde-a78c-7244b4359da9",
            "index": 118,
            "title": "Big Ideas 2026: Physical AI and the Industrial Stack",
            "pub_date": "2025-12-25T11:00:00.000Z",
            "duration": "00:21:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/big-ideas-2026-physical-ai-and-the-industrial-stack-_jUvmWaM",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/9f088dcb-d3ce-4226-9a89-73f300d46a61/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=9f088dcb-d3ce-4226-9a89-73f300d46a61&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4fb9cb0-7c7a-41ff-9219-5285f4626b8a",
            "index": 119,
            "title": "Big Ideas 2026: Voice Agents and High-Stakes Trust",
            "pub_date": "2025-12-24T11:00:00.000Z",
            "duration": "00:17:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/big-ideas-2026-voice-agents-and-high-stakes-trust-01thYDH5",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/43d9b06d-1a20-4861-9ca9-92d425c1c375/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=43d9b06d-1a20-4861-9ca9-92d425c1c375&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cb99fb37-18df-4883-b53c-054472733677",
            "index": 120,
            "title": "Big Ideas 2026: The Enterprise Orchestration Layer",
            "pub_date": "2025-12-23T11:00:00.000Z",
            "duration": "00:22:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/big-ideas-the-enterprise-orchestration-layer-o_PmcPc_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/bb49c5a5-894a-48a4-9805-5f1fa205f026/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=bb49c5a5-894a-48a4-9805-5f1fa205f026&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "776d64cd-057d-44e4-b5e0-8b93d8029b3f",
            "index": 121,
            "title": "Big Ideas 2026: The Agentic Interface",
            "pub_date": "2025-12-22T11:00:00.000Z",
            "duration": "00:14:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/big-ideas-2026-the-agentic-interface-3tUCqeJv",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f9c0e6b2-af64-4a25-a90f-1905807c987c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f9c0e6b2-af64-4a25-a90f-1905807c987c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8393ee21-9911-410a-a940-1702337a0f89",
            "index": 122,
            "title": "The Rise, Fall & Reset of The Fintech Industry",
            "pub_date": "2025-12-19T14:01:25.000Z",
            "duration": "00:45:14",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-rise-fall-reset-of-the-fintech-industry-7NpSaKiR",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/2f129198-7de7-40f3-a8ce-eb2c6bea253e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=2f129198-7de7-40f3-a8ce-eb2c6bea253e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b914ded-85c7-43c6-9466-0f64ea32e2bf",
            "index": 123,
            "title": "Do Revenue and Margins Still Matter in AI?",
            "pub_date": "2025-12-18T11:00:00.000Z",
            "duration": "01:02:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/do-revenue-and-margins-still-matter-in-ai-fH83AB_n",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7406fa93-7695-466d-8527-6d87f3ee6a25/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7406fa93-7695-466d-8527-6d87f3ee6a25&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a18a59c-04bb-4877-b228-a2e6fa4d2b1d",
            "index": 124,
            "title": "The Crime Crisis In America and How Technology Fixes It",
            "pub_date": "2025-12-17T15:51:46.000Z",
            "duration": "00:59:30",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-crime-crisis-in-america-how-technology-fixes-it-_8hsRCbO",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/22fe230f-a273-4cb0-a547-6fe2554ca77e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=22fe230f-a273-4cb0-a547-6fe2554ca77e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42d12dac-4992-4c98-a583-b84e3751d1d4",
            "index": 125,
            "title": "Ryo Lu (Cursor): AI Turns Designers to Developers",
            "pub_date": "2025-12-16T11:00:00.000Z",
            "duration": "00:52:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ryo-lu-cursor-ai-turns-designers-to-developers-iKxTG20j",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/87830803-b05e-4096-83cc-d8c540a73711/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=87830803-b05e-4096-83cc-d8c540a73711&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cbb1d859-ee8f-4436-8f7a-b3d4e5b13a5b",
            "index": 126,
            "title": "AI Eats the World: Benedict Evans on the Next Platform Shift",
            "pub_date": "2025-12-12T19:00:28.000Z",
            "duration": "01:02:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "enterprise ai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ai-eats-the-world-benedict-evans-on-the-next-platform-shift-ASo5Vq3f",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e57339f5-579a-478b-a3fa-91fabff72829/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e57339f5-579a-478b-a3fa-91fabff72829&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "81a68347-b354-4590-b177-7bb8e7f5817f",
            "index": 127,
            "title": "How the Best CEOs Delegate",
            "pub_date": "2025-12-10T17:42:02.000Z",
            "duration": "00:57:34",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-the-best-ceos-delegate-Pnh3gU21",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/77bff740-424b-4fc5-bf06-c89d0dafcdf3/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=77bff740-424b-4fc5-bf06-c89d0dafcdf3&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2de42365-24ed-402e-8dbd-cf188f18ba3e",
            "index": 128,
            "title": "The $3 Trillion AI Coding Opportunity",
            "pub_date": "2025-12-09T11:00:00.000Z",
            "duration": "00:37:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-3-trillion-ai-coding-opportunity-7plojNqE",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/787e3c30-3bce-4150-bf13-0ba6d96eacee/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=787e3c30-3bce-4150-bf13-0ba6d96eacee&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c835e38a-d0dc-42b1-8446-e1fbdd508aa6",
            "index": 129,
            "title": "The 80-Year Bet: Why Naveen Rao Is Rebuilding the Computer from Scratch",
            "pub_date": "2025-12-08T15:05:00.000Z",
            "duration": "00:30:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chip"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-80-year-bet-why-naveen-rao-is-rebuilding-the-computer-from-scratch-wLonZe7I",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/64e06111-8410-4646-8739-eb8cccbb5850/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=64e06111-8410-4646-8739-eb8cccbb5850&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db699518-5236-4413-b52f-37bb6a047665",
            "index": 130,
            "title": "What Comes After ChatGPT? The Mother of ImageNet Predicts The Future",
            "pub_date": "2025-12-05T11:00:00.000Z",
            "duration": "01:01:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "artificial intelligence",
              "chatgpt"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/what-comes-after-chatgpt-the-mother-of-imagenet-predicts-the-future-N6cF4ZpS",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b81c1a3a-8e28-4833-a50a-478cc634a7f5/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b81c1a3a-8e28-4833-a50a-478cc634a7f5&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da170f1c-5629-45f3-8416-65e3c118eb9d",
            "index": 131,
            "title": "How AI Created the Fastest Product Cycle in History",
            "pub_date": "2025-12-04T11:00:00.000Z",
            "duration": "00:50:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-psychology-every-founder-needs-right-now-a16z-gp-reveals-secrets-to-success-MQMWIdcC",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b7f72e79-ad23-4c0e-8690-8b3353aa1f65/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b7f72e79-ad23-4c0e-8690-8b3353aa1f65&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d967af45-25df-41ef-8bb5-5395284921c9",
            "index": 132,
            "title": "Why AI Moats Still Matter (And How They've Changed)",
            "pub_date": "2025-12-03T11:00:00.000Z",
            "duration": "00:51:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/why-ai-moats-still-matter-and-how-theyve-changed-eTFWb__9",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/ed0b2c8d-8037-4a81-9c22-49c7159d9971/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=ed0b2c8d-8037-4a81-9c22-49c7159d9971&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dd51a79b-35f6-45e9-b673-83a17269c32b",
            "index": 133,
            "title": "How To Lead | Ben Horowitz on My First Million",
            "pub_date": "2025-12-02T11:00:00.000Z",
            "duration": "01:10:40",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/how-to-lead-ben-horowitz-on-my-first-million-hZ9jj4__",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f87e6fe0-fe6b-4ff4-841d-26dbbdf3a4ca/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f87e6fe0-fe6b-4ff4-841d-26dbbdf3a4ca&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "81f5c5b5-b916-4420-b56b-14c9e9e5838c",
            "index": 134,
            "title": "The $700 Billion AI Productivity Problem No One's Talking About",
            "pub_date": "2025-12-01T11:00:00.000Z",
            "duration": "00:58:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "enterprise ai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-700-billion-ai-productivity-problem-no-ones-talking-about-Teh8ToO6",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/bcd7a3cc-6cb7-4483-8b2e-f3e27c9601ae/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=bcd7a3cc-6cb7-4483-8b2e-f3e27c9601ae&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "16fb3141-6dc4-4fe6-ab2f-cbd8682c98cf",
            "index": 135,
            "title": "How OpenAI Builds for 800 Million Weekly Users: Model Specialization and Fine-Tuning",
            "pub_date": "2025-11-28T11:00:00.000Z",
            "duration": "00:53:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agent",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-openai-builds-for-800-million-weekly-users-model-specialization-and-fine-tuning-v_5pBldU",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/2f4239c2-bdde-4afb-a888-ba828f152e91/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=2f4239c2-bdde-4afb-a888-ba828f152e91&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a533bc60-4cbf-4b9c-aaea-3f632a257963",
            "index": 136,
            "title": "Ben Horowitz: Why Open Source AI Will Determine America's Future",
            "pub_date": "2025-11-27T11:00:00.000Z",
            "duration": "00:46:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-why-open-source-ai-will-determine-americas-future-kn8ZWyJb",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f71e4ac8-6e51-4db2-86ad-913210f65c24/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f71e4ac8-6e51-4db2-86ad-913210f65c24&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9dc3de75-21e0-4071-8acf-6e81ad35279b",
            "index": 137,
            "title": "The Secret Marketing Strategy That Built a16z: From Zero to Legendary VC Firm",
            "pub_date": "2025-11-26T11:00:00.000Z",
            "duration": "00:59:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/the-secret-marketing-strategy-that-built-a16z-from-zero-to-legendary-vc-firm-PXH21e_P",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/88820423-1ecd-4f94-93b5-1cfbf8485757/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=88820423-1ecd-4f94-93b5-1cfbf8485757&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b01b1aa1-d499-40ef-a930-1c88d11f2fc9",
            "index": 138,
            "title": "How Marc Andreessen Actually Uses AI",
            "pub_date": "2025-11-25T11:00:00.000Z",
            "duration": "00:34:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-marc-andreessen-actually-uses-ai-Se9zgnOK",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e95dec9a-374f-47df-a3f7-e83a7615506a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e95dec9a-374f-47df-a3f7-e83a7615506a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a4a6698c-a63c-4276-b7c8-555f4b019a5b",
            "index": 139,
            "title": "The 2045 Superintelligence Timeline: Epoch AI’s Data-Driven Forecast",
            "pub_date": "2025-11-24T11:00:00.000Z",
            "duration": "01:00:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "datacenter"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-2045-superintelligence-timeline-epoch-ais-data-driven-forecast-RWynVxSF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/46c8f00d-a672-4165-93f8-ff7b1e20a243/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=46c8f00d-a672-4165-93f8-ff7b1e20a243&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dba87b3d-cadd-4360-b69f-bf9624624d30",
            "index": 140,
            "title": "Robinhood CEO: Making Everyone An Owner",
            "pub_date": "2025-11-21T11:00:00.000Z",
            "duration": "01:05:02",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/robinhood-ceo-how-we-survived-gamestop-built-11-100m-businesses-d5kXUtHt",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/3ec4e550-3360-4887-b2c5-5e8d3810dd49/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=3ec4e550-3360-4887-b2c5-5e8d3810dd49&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "00c66fc3-36c6-4fd0-aab5-c3d6145432b2",
            "index": 141,
            "title": "Can Community Banks Survive the Next SVB? | ModernFi CEO Paolo Bertolotti and Former Comptroller Gene Ludwig",
            "pub_date": "2025-11-20T11:00:00.000Z",
            "duration": "00:43:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/can-community-banks-survive-the-next-svb-modernfi-ceo-paolo-bertolotti-and-former-comptroller-gene-ludwig-pmFbDbSP",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c928868e-e028-4d52-bcf7-86b60444113b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c928868e-e028-4d52-bcf7-86b60444113b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "418343ff-773b-449d-92e5-a7b0d161e323",
            "index": 142,
            "title": "Ben Horowitz & Marc Andreessen: Why Silicon Valley Turned Against Defense (And How We’re Fixing It)",
            "pub_date": "2025-11-19T11:00:00.000Z",
            "duration": "01:16:13",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-marc-andreessen-why-silicon-valley-turned-against-defense-and-how-were-fixing-it-aVPjuWj8",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/27ebdf0a-f946-4c9b-822e-8c77cf241136/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=27ebdf0a-f946-4c9b-822e-8c77cf241136&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be6f3985-bf86-417b-b81e-ba6724287d3e",
            "index": 143,
            "title": "Emmett Shear on Building AI That Actually Cares: Beyond Control and Steering",
            "pub_date": "2025-11-17T11:00:00.000Z",
            "duration": "01:10:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "openai",
              "alignment"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/emmett-shear-on-building-ai-that-actually-cares-beyond-control-and-steering-TRwfxH0r",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b980aa72-711f-4141-ab10-8f09500e4376/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b980aa72-711f-4141-ab10-8f09500e4376&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a87d9f18-f4b9-4840-8b1f-87f8d54d8571",
            "index": 144,
            "title": "Can America Win The AI Biotech Race Against China? | Lada Nuzhna & Elliot Hershberg",
            "pub_date": "2025-11-14T11:00:00.000Z",
            "duration": "01:02:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-brutal-truth-about-biotech-why-2b-per-drug-is-killing-innovation-T3mrzJXR",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/229da354-2ff1-4a24-974f-f5edd6287c74/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=229da354-2ff1-4a24-974f-f5edd6287c74&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "82404a63-db08-402b-a107-e621cf8659a7",
            "index": 145,
            "title": "The Frontier of Spatial Intelligence with Fei-Fei Li",
            "pub_date": "2025-11-13T11:00:00.000Z",
            "duration": "00:44:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "multimodal"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-frontier-of-spatial-intelligence-with-fei-fei-li-hady-3ht-X2ETxojd",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/cee24934-56f9-449a-81c6-cce650034230/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=cee24934-56f9-449a-81c6-cce650034230&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5f12bc59-51ff-4dc2-8c96-2d19575098a0",
            "index": 146,
            "title": "Rocket Companies CEO: Here’s How to Fix the Housing Crisis",
            "pub_date": "2025-11-12T11:00:00.000Z",
            "duration": "00:55:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/rocket-mortgage-ceo-heres-how-to-fix-the-housing-crisis-XneG8bDL",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/52e4a103-de48-4ad8-a9fe-e64a814e17b1/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=52e4a103-de48-4ad8-a9fe-e64a814e17b1&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f9f8f78-3cef-491e-9df5-24f1f0f96f08",
            "index": 147,
            "title": "Grant Lee: Building Gamma’s AI Presentation Company to 100 Million Users",
            "pub_date": "2025-11-11T11:00:00.000Z",
            "duration": "00:53:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/grant-lee-building-gammas-ai-presentation-company-to-100-million-users-v_Sxqjj_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/2266a5e0-db18-4f26-bfca-70d2a6bf1bdc/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=2266a5e0-db18-4f26-bfca-70d2a6bf1bdc&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4fc182c3-9cac-4d03-a70b-fa7dda26423b",
            "index": 148,
            "title": "Michael Truell: How Cursor Builds at the Speed of AI",
            "pub_date": "2025-11-10T15:30:00.000Z",
            "duration": "00:27:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "cursor"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/michael-truell-how-cursor-builds-at-the-speed-of-ai-Vxy6kxbi",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/392745ef-b8af-4f61-8539-c5944790f6ac/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=392745ef-b8af-4f61-8539-c5944790f6ac&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c6d5cf08-82ad-4ef4-a7a4-449f8491de7a",
            "index": 149,
            "title": "a16z's State of Crypto: The $4 Trillion Milestone and What's Next'",
            "pub_date": "2025-11-09T11:00:00.000Z",
            "duration": "01:38:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/a16zs-state-of-crypto-the-4-trillion-milestone-and-whats-next-EtsxSLNq",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/2c67f5ec-f245-47f9-a510-870fac6a6645/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=2c67f5ec-f245-47f9-a510-870fac6a6645&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46eab340-2eab-4055-8ac2-dbe1046d8b18",
            "index": 150,
            "title": "Amjad Masad & Adam D’Angelo: How Far Are We From AGI?",
            "pub_date": "2025-11-07T11:00:00.000Z",
            "duration": "01:02:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "replit",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/amjad-masad-adam-dangelo-how-far-are-we-from-agi-HC6s4wvT",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/3838f4ce-71b7-4894-a12b-c1427908e204/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=3838f4ce-71b7-4894-a12b-c1427908e204&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "26de6ea7-2c8f-4a42-b5f3-9d534e7a20e0",
            "index": 151,
            "title": "Mark Zuckerberg & Priscilla Chan: How AI Will Cure All Disease",
            "pub_date": "2025-11-06T14:45:00.000Z",
            "duration": "00:45:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/mark-zuckerberg-priscilla-chan-how-ai-will-cure-all-disease-6i78kGXq",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/abda01e0-5f56-4035-88ec-3704ec3e19ae/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=abda01e0-5f56-4035-88ec-3704ec3e19ae&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "26e4e0ad-add6-44ec-af0a-87384b37c53c",
            "index": 152,
            "title": "Seeing The Future from AI Companions to Personal Software",
            "pub_date": "2025-11-05T11:00:00.000Z",
            "duration": "00:50:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "training"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/seeing-the-future-from-ai-companions-to-personal-software-Fj9VrDbk",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/9d2269fb-d33f-4254-963c-f43128304124/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=9d2269fb-d33f-4254-963c-f43128304124&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af42459c-c191-49d3-ba03-306b2f66b036",
            "index": 153,
            "title": "ElevenLabs CEO: Why Voice is the Next AI Interface",
            "pub_date": "2025-11-05T05:36:25.000Z",
            "duration": "00:31:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/elevenlabs-ceo-why-voice-is-the-next-ai-interface-2A6c6cKy",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/07456c27-b90a-4cca-94d7-9ab3c714bc02/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=07456c27-b90a-4cca-94d7-9ab3c714bc02&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b5cb8c5a-586c-489f-85d9-50308419601a",
            "index": 154,
            "title": "David Sacks: AI, Crypto, China, Dems, and SF",
            "pub_date": "2025-11-03T11:00:00.000Z",
            "duration": "01:16:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/david-sacks-ai-crypto-china-dems-and-sf-wwUHZW8B",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c5015699-17a1-4607-8e3d-5546db0e2bba/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c5015699-17a1-4607-8e3d-5546db0e2bba&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d974537-e40d-412e-877a-23521a324acc",
            "index": 155,
            "title": "Why Speed, Not Size, Will Define the Next War",
            "pub_date": "2025-11-01T14:09:20.000Z",
            "duration": "00:39:25",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/why-speed-not-size-will-define-the-next-war-6x7my1yF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/61b2e8f4-a70b-4003-83ac-4383a6fbe70c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=61b2e8f4-a70b-4003-83ac-4383a6fbe70c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "239b4ffa-4105-4e8b-8f9e-60548a25c988",
            "index": 156,
            "title": "Beyond Chatbots: Marc Andreessen and Ben Horowitz on AI's Future",
            "pub_date": "2025-10-31T10:00:00.000Z",
            "duration": "00:38:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/beyond-chatbots-marc-andreessen-and-ben-horowitz-on-ais-future-DVbodeVS",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7953cfca-fbdb-4ea3-85ea-e5edaf0b3724/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7953cfca-fbdb-4ea3-85ea-e5edaf0b3724&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98b27463-d862-4d0e-9607-cdc2903b09a0",
            "index": 157,
            "title": "\"Is there an AI bubble?” Gavin Baker and David George",
            "pub_date": "2025-10-30T10:00:00.000Z",
            "duration": "00:31:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "data center"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/is-there-an-ai-bubble-gavin-baker-and-david-george-C_TUUPIF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/aeb1298d-dc3d-47b5-8ec0-646643c65ba2/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=aeb1298d-dc3d-47b5-8ec0-646643c65ba2&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "21f4d29a-ea9e-4608-a1fb-2359a3fe53be",
            "index": 158,
            "title": "Building the Real-World Infrastructure for AI, with Google, Cisco & a16z",
            "pub_date": "2025-10-29T10:00:00.000Z",
            "duration": "00:32:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "chips",
              "data center",
              "inference"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-the-real-world-infrastructure-for-ai-with-google-cisco-a16z-e4GM5oUx",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f76fb8d5-98d5-4202-8813-1e54e861448d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f76fb8d5-98d5-4202-8813-1e54e861448d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "261a1e6a-adaf-4e7d-800c-642d618c72db",
            "index": 159,
            "title": "Google DeepMind Developers: How Nano Banana Was Made",
            "pub_date": "2025-10-28T17:54:32.000Z",
            "duration": "00:54:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "deepmind"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/google-deepmind-developers-how-nano-banana-was-made-a7_2lrXS",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/02f425e4-6ce7-429b-98a2-7975ab27e89e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=02f425e4-6ce7-429b-98a2-7975ab27e89e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b217477-585e-4482-bb6b-ddec5b653164",
            "index": 160,
            "title": "Raghu Raghuram: AI, Robotics, and the Rebirth of Infrastructure",
            "pub_date": "2025-10-27T10:00:00.000Z",
            "duration": "00:30:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/raghu-raghuram-ai-robotics-and-the-rebirth-of-infrastructure-sz8xjgwv",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7e9eb439-1de0-49e4-8596-6b8505025399/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7e9eb439-1de0-49e4-8596-6b8505025399&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e8e69e3-0431-4da2-af22-1ddfe60ef1b9",
            "index": 161,
            "title": "Marc Andreessen: How Movies Explain America",
            "pub_date": "2025-10-24T18:11:33.000Z",
            "duration": "01:15:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-how-movies-explain-america-XoKIrqcd",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7b9a0d38-6476-495e-a28f-c155b2153dd2/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7b9a0d38-6476-495e-a28f-c155b2153dd2&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f0f175c-0e15-4c4d-b343-37a24c026e7b",
            "index": 162,
            "title": "Marc Andreessen and Amjad Masad: English As the New Programming Language",
            "pub_date": "2025-10-23T10:00:00.000Z",
            "duration": "01:11:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "replit",
              "reasoning"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-and-amjad-masad-english-as-the-new-programming-language-wgFI3xCk",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/8c6d42f1-aaeb-47a4-b8c2-4dedc7778c58/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=8c6d42f1-aaeb-47a4-b8c2-4dedc7778c58&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42c22224-5341-4ae5-82b8-5e1f5ff5ae4a",
            "index": 163,
            "title": "Why Creativity Will Matter More Than Code",
            "pub_date": "2025-10-22T10:00:00.000Z",
            "duration": "01:25:15",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/why-creativity-will-matter-more-than-code-dGd3RSOB",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a860e397-781a-4531-9eba-a1cb2f885745/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a860e397-781a-4531-9eba-a1cb2f885745&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "899f586f-9d6e-4b23-b75b-985a479bd7e2",
            "index": 164,
            "title": "How Kong Was Born: APIs, Hustle, and the Future of AI Infrastructure",
            "pub_date": "2025-10-21T10:00:00.000Z",
            "duration": "00:37:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-kong-was-born-apis-hustle-and-the-future-of-ai-infrastructure-HGhWZI7r",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/998304f6-7946-4ace-b636-62b62a840274/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=998304f6-7946-4ace-b636-62b62a840274&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "41887040-288b-4d23-b33b-9b9912e81101",
            "index": 165,
            "title": "Reid Hoffman on AI, Consciousness, and the Future of Humanity",
            "pub_date": "2025-10-20T15:51:10.000Z",
            "duration": "00:53:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "reasoning"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/reid-hoffman-on-ai-consciousness-and-the-future-of-humanity-jXX5cVct",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/08869aa2-5070-4051-be83-bc45f7c36ad4/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=08869aa2-5070-4051-be83-bc45f7c36ad4&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "91ed4b6b-f8a6-4e31-8846-50def746ba70",
            "index": 166,
            "title": "Marc Andreessen on the State of Film and Hollywood",
            "pub_date": "2025-10-17T10:00:00.000Z",
            "duration": "01:07:46",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-hollywoods-reset-and-why-ai-will-spark-a-filmmaking-renaissance-Besu1VOM",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d3bebc70-88c3-43c9-8da6-e93286933fee/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d3bebc70-88c3-43c9-8da6-e93286933fee&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e958fe3-e3ef-4a70-80eb-871217b68aae",
            "index": 167,
            "title": "Keith Rabois: Israel, OpenAI, Opendoor, and DOGE",
            "pub_date": "2025-10-16T10:00:00.000Z",
            "duration": "00:49:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/keith-rabois-israel-openai-opendoor-and-doge-YdzfhpPo",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/70d051e6-c543-4dab-a69b-b87939e92815/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=70d051e6-c543-4dab-a69b-b87939e92815&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95b0fe09-b5f8-4093-ae19-e420d54a686d",
            "index": 168,
            "title": "Ben Horowitz and Ali Ghodsi: How to Run a Billion-Dollar Business",
            "pub_date": "2025-10-15T10:00:00.000Z",
            "duration": "01:04:36",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-and-ali-ghodsi-how-to-run-a-billion-dollar-business-GvrkQR3X",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a5a6403c-8291-415a-b589-f01482206b39/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a5a6403c-8291-415a-b589-f01482206b39&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c54adbc-75ed-4830-92ff-6d5f5bc79153",
            "index": 169,
            "title": "Is AI Slowing Down? Nathan Labenz Says We're Asking the Wrong Question",
            "pub_date": "2025-10-14T13:52:46.000Z",
            "duration": "01:31:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning",
              "automation"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/is-ai-slowing-down-nathan-labenz-says-were-asking-the-wrong-question-fBZj_7FC",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/783c7830-628a-4cf9-970d-3b364b7b8c6a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=783c7830-628a-4cf9-970d-3b364b7b8c6a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "976f91ea-e074-410f-bbb1-f4ca1aa43a5e",
            "index": 170,
            "title": "Columbia CS Professor: Why LLMs Can’t Discover New Science",
            "pub_date": "2025-10-13T10:00:00.000Z",
            "duration": "00:50:54",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "agi",
              "reasoning"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/columbia-cs-professor-why-llms-cant-discover-new-science-k7v4Jxpr",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/ba04cc09-9eb8-4f48-9b80-f88e229ba42d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=ba04cc09-9eb8-4f48-9b80-f88e229ba42d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a354f9b2-7e9d-4c46-b239-441b8edc3292",
            "index": 171,
            "title": "Monitoring the Situation #3: Who Is Nick Land?",
            "pub_date": "2025-10-12T18:45:07.000Z",
            "duration": "00:52:44",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "data center"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/monitoring-the-situation-3-who-is-nick-land-zV3Lr5Ku",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/49dc6048-afeb-46ad-83f1-a49af0c376e1/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=49dc6048-afeb-46ad-83f1-a49af0c376e1&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a50983a-ce4d-4bdf-b771-6939acad3afd",
            "index": 172,
            "title": "Sam Altman on Sora, Energy, and Building an AI Empire",
            "pub_date": "2025-10-08T10:00:00.000Z",
            "duration": "00:48:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "evals"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/sam-altman-on-sora-energy-and-building-an-ai-empire-chh8r2SY",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/fa569bec-4f77-4487-a48e-50b8b9a17b77/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=fa569bec-4f77-4487-a48e-50b8b9a17b77&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "82b09c02-366c-44d5-a573-8230698320ac",
            "index": 173,
            "title": "How to Build a Real Estate Marketplace - Kaz Nejatian, Opendoor CEO",
            "pub_date": "2025-10-07T10:00:00.000Z",
            "duration": "00:55:44",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/how-to-build-a-real-estate-marketplace-kaz-nejatian-opendoor-ceo-nhwUt_5o",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e61ab427-f00e-40bc-911d-95eabc21782f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e61ab427-f00e-40bc-911d-95eabc21782f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "411e9bbd-9d5f-4bef-823b-f01f14378f90",
            "index": 174,
            "title": "Can the US Beat China’s Engineering State?",
            "pub_date": "2025-10-06T10:00:00.000Z",
            "duration": "01:03:10",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/can-the-us-beat-chinas-engineering-state-AxmVOq0h",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d90324f5-e318-41d4-a119-de2c323a54f5/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d90324f5-e318-41d4-a119-de2c323a54f5&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5eb1b67d-2558-414f-9662-c22603dc3d06",
            "index": 175,
            "title": "Monitoring the Situation #2: Alana Newhouse",
            "pub_date": "2025-10-05T18:10:19.000Z",
            "duration": "00:58:58",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/monitoring-the-situation-2-alana-newhouse-vGaR2PUT",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e08e3620-443c-4c7a-a828-ed58a1e53b7b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e08e3620-443c-4c7a-a828-ed58a1e53b7b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04b77e10-b0bc-4140-83f5-bcfbfa9f6337",
            "index": 176,
            "title": "Software is Eating Labor",
            "pub_date": "2025-10-03T10:00:00.000Z",
            "duration": "00:26:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/software-is-eating-labor-h9Z7PqQI",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/9e5801ab-333e-42bb-9128-7e36419ceee5/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=9e5801ab-333e-42bb-9128-7e36419ceee5&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be3a9a59-4801-4e6a-b51a-b6a59ca7c0f7",
            "index": 177,
            "title": "The Ben & Marc Show: China Has Scale. Can America Catch Up?",
            "pub_date": "2025-10-02T16:43:31.000Z",
            "duration": "00:57:16",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/china-has-scale-can-america-catch-up-7tGcqvzl",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6cee627c-360b-44a9-bfe7-2c13c6002978/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6cee627c-360b-44a9-bfe7-2c13c6002978&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e4758b3-e78c-4a28-bf1b-a095f8937615",
            "index": 178,
            "title": "Cheeky Pint: Marc Andreessen, John Collison & Charlie Songhurst on Tech’s Big Questions",
            "pub_date": "2025-10-01T10:00:00.000Z",
            "duration": "02:09:12",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/cheeky-pint-marc-andreessen-john-collison-charlie-songhurst-on-techs-big-questions-Fc1oD2vp",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7ff71691-8e4d-4545-844e-a0f610bbb0be/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7ff71691-8e4d-4545-844e-a0f610bbb0be&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "92e94b04-c8c2-48e7-976c-0e64ba5653b5",
            "index": 179,
            "title": "Building an AI Physicist: ChatGPT Co-Creator’s Next Venture",
            "pub_date": "2025-09-30T17:00:00.000Z",
            "duration": "00:54:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "deepmind",
              "training"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-an-ai-physicist-chatgpt-co-creators-next-venture-2WTEZE_4",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/1621ab71-2bcf-454f-8c75-d19dfb194a71/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=1621ab71-2bcf-454f-8c75-d19dfb194a71&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e1cebfaa-967f-4259-80e4-e01da4b2e5f5",
            "index": 180,
            "title": "Meta CMO: How Advertising Works Under the Hood",
            "pub_date": "2025-09-29T10:00:00.000Z",
            "duration": "01:02:52",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/meta-cmo-how-advertising-works-under-the-hood-uMvpRjt4",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5ca1138a-08e1-4dd4-ab5c-22ec15105a5d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5ca1138a-08e1-4dd4-ab5c-22ec15105a5d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd4e7ac8-918f-4879-aaf9-cd3fae22089a",
            "index": 181,
            "title": "The Common Thread of All Technology: Monitoring the Situation, Ep.1",
            "pub_date": "2025-09-27T10:00:00.000Z",
            "duration": "01:00:02",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-common-thread-of-all-technology-monitoring-the-situation-ep1-q2pAELns",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/4c2441e7-2a3a-4aa3-8aa7-5d5506f4cd10/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=4c2441e7-2a3a-4aa3-8aa7-5d5506f4cd10&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "607e9419-03c8-45a4-a181-bd6d6ec0b875",
            "index": 182,
            "title": "From Vibe Coding to Vibe Researching: OpenAI’s Mark Chen and Jakub Pachocki",
            "pub_date": "2025-09-25T10:00:00.000Z",
            "duration": "00:52:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "openai",
              "reasoning",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/from-vibe-coding-to-vibe-researching-openais-mark-chen-and-jakub-pachocki-zbD4hi4V",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/8eb7117c-1a78-4b60-ab9e-b048e53946c9/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=8eb7117c-1a78-4b60-ab9e-b048e53946c9&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a67bb250-8f6d-4756-ac1c-f2f8f21ac164",
            "index": 183,
            "title": "Software finally eats services - Aaron Levie",
            "pub_date": "2025-09-24T14:27:53.000Z",
            "duration": "00:59:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/software-finally-eats-services-aaron-levie-QfttkMkC",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0075e2fe-d932-4e06-8e2d-f4ba6816b91e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0075e2fe-d932-4e06-8e2d-f4ba6816b91e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "415e8cae-1a86-4d0a-a1ff-19f33783cafe",
            "index": 184,
            "title": "America's Autism Crisis and How AI Can Fix Science with NIH Director Jay Bhattacharya",
            "pub_date": "2025-09-23T16:35:20.000Z",
            "duration": "00:58:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/jay-bhattacharya-jX3n4Tqk",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/fcd4f163-a95f-47a3-b204-6ff87229d82f/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=fcd4f163-a95f-47a3-b204-6ff87229d82f&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1e7816cc-a535-4499-9d05-db62f94d8222",
            "index": 185,
            "title": "Dylan Patel on the AI Chip Race - NVIDIA, Intel & the US Government vs. China",
            "pub_date": "2025-09-22T10:00:00.000Z",
            "duration": "01:40:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "data center"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/dylan-patel-on-the-ai-chip-race-nvidia-intel-the-us-government-vs-china-ysQ4XbwO",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/300c90fa-9d13-42fd-8306-12785c87f555/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=300c90fa-9d13-42fd-8306-12785c87f555&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "169ae0b8-9e87-4cee-b5fc-3a3c9d49d384",
            "index": 186,
            "title": "Charlie Kirk and the Rise of Political Violence",
            "pub_date": "2025-09-21T10:00:00.000Z",
            "duration": "00:23:39",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/charlie-kirk-and-the-rise-of-political-violence-8m1Qba_N",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/771bdf88-365e-48ae-9304-113d7d1a832d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=771bdf88-365e-48ae-9304-113d7d1a832d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e46b6382-4d0c-4977-bc83-8951fcc9a6eb",
            "index": 187,
            "title": "The Death of Search: How Shopping Will Work In The Age of AI",
            "pub_date": "2025-09-17T10:00:00.000Z",
            "duration": "00:45:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-death-of-search-how-shopping-will-work-in-the-age-of-ai-CISpNns0",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/bc3ec02d-9eb8-42aa-bf14-73a3817b9f70/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=bc3ec02d-9eb8-42aa-bf14-73a3817b9f70&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a4bc6e82-ee8d-488b-bf07-1a43c8ba7408",
            "index": 188,
            "title": "How OpenAI Built Its Coding Agent",
            "pub_date": "2025-09-16T10:00:00.000Z",
            "duration": "01:20:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "safety",
              "automation",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-openai-built-its-coding-agent-NOUFQQuR",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/4cd031a1-3a7d-425f-b835-d9c3502440df/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=4cd031a1-3a7d-425f-b835-d9c3502440df&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "647b0348-e843-4c15-9d5e-09eccd718c8c",
            "index": 189,
            "title": "Faster Science, Better Drugs",
            "pub_date": "2025-09-15T10:00:00.000Z",
            "duration": "00:56:26",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/faster-science-better-drugs-NRHoBzMD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/4e60e19b-c763-43dc-9896-e599e750d4ec/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=4e60e19b-c763-43dc-9896-e599e750d4ec&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c50776f1-5d21-4e79-836b-603f44c6c09e",
            "index": 190,
            "title": "Ben Horowitz: Why Hesitation is a CEO’s Worst Enemy",
            "pub_date": "2025-09-12T10:00:00.000Z",
            "duration": "01:35:38",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-why-hesitation-is-a-ceos-worst-enemy-6GnfdtC3",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/24cd4e1b-cca9-413b-bd9e-ac540ea433d2/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=24cd4e1b-cca9-413b-bd9e-ac540ea433d2&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c137efd5-3b4f-4d24-b947-0a487e8d8719",
            "index": 191,
            "title": "Inside the $13T Mortgage Machine",
            "pub_date": "2025-09-11T10:00:00.000Z",
            "duration": "00:54:48",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/inside-the-13t-mortgage-machine-IBWHROiO",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b0806957-5a2d-42a7-aa30-ab4cfc4f9dbb/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b0806957-5a2d-42a7-aa30-ab4cfc4f9dbb&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77fd3d01-162c-43cd-919d-811c60701019",
            "index": 192,
            "title": "Chris Dixon on How to Build Networks, Movements, and AI-Native Products",
            "pub_date": "2025-09-10T10:00:00.000Z",
            "duration": "00:42:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/chris-dixon-on-how-to-build-networks-movements-and-ai-native-products-8oICzjH3",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/59564bfe-eb2f-46f5-8f23-acc781257d11/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=59564bfe-eb2f-46f5-8f23-acc781257d11&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c0112bc-fcc4-4c40-b92a-d6ec007b8722",
            "index": 193,
            "title": "Mark Cuban on the NBA, Cost Plus Drugs, and How to Fix Politics",
            "pub_date": "2025-09-09T10:00:00.000Z",
            "duration": "01:01:04",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/mark-cuban-on-sports-healthcare-and-social-media-vv_ZHrbG",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/5c15e022-2ba9-415b-b8b8-bf483a1aacf8/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=5c15e022-2ba9-415b-b8b8-bf483a1aacf8&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a45b042-850d-4e43-a709-605037f4ca62",
            "index": 194,
            "title": "The Little Tech Agenda for AI",
            "pub_date": "2025-09-08T10:00:00.000Z",
            "duration": "00:57:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-little-tech-agenda-for-ai-vYqbLSQ7",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d2b80e98-0297-4856-9568-46da3cba955e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d2b80e98-0297-4856-9568-46da3cba955e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "df09ea91-4026-4482-9a83-cc2ff4bb9fe9",
            "index": 195,
            "title": "Building APIs for Developers and AI Agents",
            "pub_date": "2025-09-06T10:00:00.000Z",
            "duration": "00:26:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-apis-for-developers-and-ai-agents-c3KgOhfE",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/dc2c9660-7280-4587-b6e3-6d6d2336f558/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=dc2c9660-7280-4587-b6e3-6d6d2336f558&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "56120247-76cd-4d05-a40b-3527454c4821",
            "index": 196,
            "title": "How to Be Free: Shaka Senghor, Oprah Winfrey, Ben Horowitz",
            "pub_date": "2025-09-05T10:00:00.000Z",
            "duration": "00:36:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/how-to-be-free-shaka-senghor-oprah-winfrey-ben-horowitz-P8Lid43v",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f0d84e8a-3501-447c-aab2-a5c1557872dc/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f0d84e8a-3501-447c-aab2-a5c1557872dc&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "26c0a763-4a2d-436c-be8a-22341e87604c",
            "index": 197,
            "title": "Is Non-Consensus Investing Overrated?",
            "pub_date": "2025-09-04T10:00:00.000Z",
            "duration": "00:54:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/is-non-consensus-investing-overrated-ew2khfV1",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/768831f6-5750-455f-ad3d-95253e96dc31/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=768831f6-5750-455f-ad3d-95253e96dc31&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65510d59-66c0-4bfb-9027-1f9390d30247",
            "index": 198,
            "title": "Jack Altman & Martin Casado on the Future of VC",
            "pub_date": "2025-09-03T15:24:55.000Z",
            "duration": "00:53:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/tbc-plus-timecodes-jGkdR2aF",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/ac6fc175-2685-49b6-b64b-1d66e87b4ae4/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=ac6fc175-2685-49b6-b64b-1d66e87b4ae4&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "51be36c4-bf16-478e-9ac1-5e46fa78f233",
            "index": 199,
            "title": "Chris Best of Substack on the Future of Media",
            "pub_date": "2025-09-02T16:35:04.000Z",
            "duration": "00:46:23",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/chris-best-of-substack-on-the-future-of-media-oKTMpYVg",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/bbe7b7ac-86f0-4f91-a2cb-da1132ddbcba/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=bbe7b7ac-86f0-4f91-a2cb-da1132ddbcba&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1b6260b4-623e-4691-af88-40dff1ed531d",
            "index": 200,
            "title": "Katherine Boyle on Shawn Ryan",
            "pub_date": "2025-08-30T10:00:00.000Z",
            "duration": "02:51:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/katherine-boyle-on-shawn-ryan-3o5qffoI",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7bdb2ff2-cd21-4d56-bee4-5d0d7eee80e2/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7bdb2ff2-cd21-4d56-bee4-5d0d7eee80e2&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0db91c08-5d3b-4f84-b5a1-3e301817e4a9",
            "index": 201,
            "title": "Monopolies vs Oligopolies in AI",
            "pub_date": "2025-08-28T10:00:00.000Z",
            "duration": "01:17:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/a16zs-martin-casado-breaks-down-the-ai-investing-landscape-w-harry-stebbings-from-20vc-UkM0cJtX",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f0811877-b86d-4180-89b1-2831d1f054b9/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f0811877-b86d-4180-89b1-2831d1f054b9&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e405f5b-aad4-4e0c-86ff-05a4f1ae89b2",
            "index": 202,
            "title": "The Top 100 Most Used AI Apps in 2025",
            "pub_date": "2025-08-27T10:00:00.000Z",
            "duration": "00:25:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "grok"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-top-100-most-used-ai-apps-in-2025-vdzbthvn",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/9249486f-5726-4b6d-a83d-32c05cb7bf47/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=9249486f-5726-4b6d-a83d-32c05cb7bf47&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98e81eff-019f-40e8-9e56-1bbcc256a68f",
            "index": 203,
            "title": "Aaron Levie and Steven Sinofsky on the AI-Worker Future",
            "pub_date": "2025-08-25T10:00:00.000Z",
            "duration": "00:55:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/aaron-levie-and-steven-sinofsky-on-the-ai-worker-future-_LFktcaE",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/eecde388-1563-472a-a452-7dbdf728d358/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=eecde388-1563-472a-a452-7dbdf728d358&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "10722dfb-2dd3-4cc7-a5d9-644e53ca3171",
            "index": 204,
            "title": "Ben Horowitz on How a16z Was Built",
            "pub_date": "2025-08-23T10:00:00.000Z",
            "duration": "00:43:34",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-on-how-a16z-was-built-SVNIIDt1",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d15840f1-84e2-4d27-890c-174118e574ed/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d15840f1-84e2-4d27-890c-174118e574ed&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5c3cda5a-f2b0-4a82-b095-70ccf33ad827",
            "index": 205,
            "title": "AI and Accelerationism with Marc Andreessen",
            "pub_date": "2025-08-22T10:00:00.000Z",
            "duration": "01:09:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ai-and-accelerationism-with-marc-andreessen-h1v9_3XC",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b7080786-6506-4e72-96ce-46e0d344e787/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b7080786-6506-4e72-96ce-46e0d344e787&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bb2f6f67-4087-4402-9ba2-5cceb071ff9c",
            "index": 206,
            "title": "Can AI Fix Housing and Healthcare Affordability?",
            "pub_date": "2025-08-21T10:00:00.000Z",
            "duration": "00:39:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics",
              "automation"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-ai-can-solve-the-real-estate-and-healthcare-affordability-problem-mVOZojyW",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/54726cce-6fd6-4843-b845-e21447feedf3/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=54726cce-6fd6-4843-b845-e21447feedf3&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c46ecc1f-716d-45ac-864b-ea38ee54d681",
            "index": 207,
            "title": "Oren Cass & Noah Smith Debate the True Impact of Tariffs",
            "pub_date": "2025-08-20T10:00:00.000Z",
            "duration": "01:12:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/oren-cass-noah-smith-debate-the-true-impact-of-tariffs-jRT7BGGu",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/dea06f79-b329-4e60-ac28-4ecb1fce648a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=dea06f79-b329-4e60-ac28-4ecb1fce648a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d0aeeb24-ce80-45f9-bffb-05b78f50fd72",
            "index": 208,
            "title": "Dylan Patel: GPT-5, NVIDIA, Intel, Meta, Apple",
            "pub_date": "2025-08-18T16:33:44.000Z",
            "duration": "01:04:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "chips"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/dylan-patel-B_VCGn95",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d330e790-8ef3-497e-bd65-72474a03b2c2/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d330e790-8ef3-497e-bd65-72474a03b2c2&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "099e0b65-16f5-423a-89c4-13c680417038",
            "index": 209,
            "title": "Google DeepMind Lead Researchers on Genie 3 & the Future of World-Building",
            "pub_date": "2025-08-16T10:00:00.000Z",
            "duration": "00:41:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "robotics"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/google-deepmind-lead-researchers-on-genie-3-the-future-of-world-building-87KUzeOE",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/4ec24f41-90af-4250-a9cd-e20d0d576ae1/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=4ec24f41-90af-4250-a9cd-e20d0d576ae1&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0a6ddaa8-6e43-483f-9438-2ed462e59817",
            "index": 210,
            "title": "The State of American AI Policy: From ‘Pause AI’ to ‘Build’",
            "pub_date": "2025-08-15T10:00:00.000Z",
            "duration": "00:42:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-state-of-american-ai-policy-from-pause-ai-to-build-SN6YKjnq",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/7b0c14a0-e574-47cc-8383-98719c2f1e6a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=7b0c14a0-e574-47cc-8383-98719c2f1e6a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d247e4a3-a533-46de-8a64-ae1a0dcf177f",
            "index": 211,
            "title": "H20s to China + 15% with Chris Miller and Lennart Heim",
            "pub_date": "2025-08-14T19:21:51.000Z",
            "duration": "01:06:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "chips"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/h20s-to-china-15-with-chris-miller-and-lennart-heim-lEbv8o_0",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f3df7ef5-54fd-4deb-aafa-5e0b548cff0a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f3df7ef5-54fd-4deb-aafa-5e0b548cff0a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd6c4b28-e817-4ebd-815e-124565f44d0e",
            "index": 212,
            "title": "Grok, Genie 3, GPT-5 & the Rise of Vibe Coding",
            "pub_date": "2025-08-13T16:59:53.000Z",
            "duration": "00:27:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "grok",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/grok-genie-3-gpt-5-the-rise-of-vibe-coding-SPhY0RsE",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/85454b20-862c-4296-9fe5-d7fdd3ec5370/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=85454b20-862c-4296-9fe5-d7fdd3ec5370&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b9fedc8b-83af-4598-a54e-539591be91fa",
            "index": 213,
            "title": "Alex Danco on Speechwriting, Blogging, and Giving Founders Power",
            "pub_date": "2025-08-13T04:29:53.000Z",
            "duration": "00:15:00",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/alex-danco-on-speechwriting-blogging-and-giving-founders-power-EuL5Jr_h",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/342ddebe-2db6-499c-9615-a37c52a6b787/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=342ddebe-2db6-499c-9615-a37c52a6b787&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e7e0090-2732-4ce0-8e9d-e221b3ed09dd",
            "index": 214,
            "title": "Steven Sinofsky & Balaji Srinivasan on the Future of AI, Tech, & the Global World Order",
            "pub_date": "2025-08-11T10:00:00.000Z",
            "duration": "01:17:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/steven-sinofsky-balaji-srinivasan-on-the-future-of-ai-tech-the-global-world-order-5JhyRyCt",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6ec7229e-a4d1-48a8-aac2-e6bbbdbddf9c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6ec7229e-a4d1-48a8-aac2-e6bbbdbddf9c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "00e3c22f-7585-4c1d-ba64-cfb99133d5de",
            "index": 215,
            "title": "Marc Andreessen: Why Perfect Products Become Obsolete",
            "pub_date": "2025-08-08T19:46:01.000Z",
            "duration": "00:37:16",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-why-perfect-products-become-obsolete-EwH7Y67p",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/79f00404-3978-4ec5-b80d-7c9d7c81f99c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=79f00404-3978-4ec5-b80d-7c9d7c81f99c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "27a12001-6430-4afd-acbf-1b284f1f81e6",
            "index": 216,
            "title": "GPT-5 and Agents Breakdown – w/ OpenAI Researchers Isa Fulford & Christina Kim",
            "pub_date": "2025-08-08T03:15:18.000Z",
            "duration": "00:43:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/gpt-5-breakdown-w-openai-researchers-isa-fulford-christina-kim-wdBsgzGu",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/bc5c94c8-56a6-40fb-a53d-75b7f7e3ac64/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=bc5c94c8-56a6-40fb-a53d-75b7f7e3ac64&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "798ee900-cb9c-456a-9ee3-f9de5240afd7",
            "index": 217,
            "title": "How to Build a Successful Company in an Era of Disruption",
            "pub_date": "2025-08-06T17:14:12.000Z",
            "duration": "00:42:52",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-to-build-a-successful-company-in-an-era-of-disruption-m7RDJVx4",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/b24bd8fe-8db6-4703-9076-c1eedaa1da26/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=b24bd8fe-8db6-4703-9076-c1eedaa1da26&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ebdd43be-071d-473d-9382-4c126ee1c34c",
            "index": 218,
            "title": "Dwarkesh and Noah Smith on AGI and the Economy",
            "pub_date": "2025-08-04T10:00:00.000Z",
            "duration": "01:01:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "reasoning"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/dwarkesh-patel-on-agi-what-it-means-for-humanity-gGsPgTfG",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/c6c5bfa2-903b-4cb1-8026-fbdf635a209c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=c6c5bfa2-903b-4cb1-8026-fbdf635a209c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3210ae0-0a3b-4898-b088-cffcd5fa349c",
            "index": 219,
            "title": "Balaji on How Tech Truly Wins Media",
            "pub_date": "2025-08-01T10:00:00.000Z",
            "duration": "01:37:40",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/balaji-on-how-tech-truly-wins-media-7_A7wgE3",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d5850670-dbe3-4f74-a648-f880794f86bf/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d5850670-dbe3-4f74-a648-f880794f86bf&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ab4a3fe-b618-4428-9edb-2448d1807b38",
            "index": 220,
            "title": "AI Content and the War for Your Attention",
            "pub_date": "2025-07-30T10:00:00.000Z",
            "duration": "00:41:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ai-content-and-the-war-for-your-attention-PlwHuH3P",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e1f192e1-39cc-4d1d-be5d-0c963265ce24/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e1f192e1-39cc-4d1d-be5d-0c963265ce24&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cb11e13b-e6b6-4eb0-9e25-ca9e49c3b8a1",
            "index": 221,
            "title": "Balaji Srinivasan: How AI Will Change Politics, War, and Money",
            "pub_date": "2025-07-28T17:16:19.000Z",
            "duration": "01:05:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "reasoning"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/balaji-srinivasan-how-ai-will-change-politics-war-and-money-G6eK3tzu",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/fdc257e9-01d2-46b4-b8a4-eb8dfe39621b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=fdc257e9-01d2-46b4-b8a4-eb8dfe39621b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd5c122e-85aa-4a6e-9edb-7fcd96dbcdaa",
            "index": 222,
            "title": "Ben and Marc on New Media:  Podcasts, Politics & the Collapse of Trust",
            "pub_date": "2025-07-25T10:00:00.000Z",
            "duration": "01:37:50",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/new-media-podcasts-politics-the-collapse-of-trust-W62W99Ro",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/43334807-b5ab-4c20-a7bf-0d3799d8a7a7/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=43334807-b5ab-4c20-a7bf-0d3799d8a7a7&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7aade00-0266-48f2-9073-01875ebfbbc5",
            "index": 223,
            "title": "Critical Minerals: Mining for the Industrial Future",
            "pub_date": "2025-07-23T10:00:00.000Z",
            "duration": "00:48:19",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/critical-minerals-mining-for-the-industrial-future-aVTpVVdT",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/504a245c-5fe6-4a6c-8b6b-dcb2f01b1566/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=504a245c-5fe6-4a6c-8b6b-dcb2f01b1566&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "44d511d0-9f4b-4378-a933-794405962c31",
            "index": 224,
            "title": "The Future of Software Development - Vibe Coding, Prompt Engineering & AI Assistants",
            "pub_date": "2025-07-21T10:00:00.000Z",
            "duration": "00:44:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-future-of-software-development-vibe-coding-prompt-engineering-ai-assistants-yjyHZT5E",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/16504cbc-f140-4caf-9ff4-3a58bf304166/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=16504cbc-f140-4caf-9ff4-3a58bf304166&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5afe116d-a569-4971-aa71-74747fb190b5",
            "index": 225,
            "title": "Marc Andreessen and Joe Lonsdale on Tariffs and Trade",
            "pub_date": "2025-07-18T10:00:00.000Z",
            "duration": "00:30:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-and-joe-lonsdale-on-tariffs-and-trade-m_5q6nlD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/648a5e96-6689-48af-80a2-ca8b0e66ec0b/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=648a5e96-6689-48af-80a2-ca8b0e66ec0b&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1760f6ef-e4b2-464d-a82c-ed25dfb68201",
            "index": 226,
            "title": "America's Energy Problem: The Grid That Built America Can’t Power Its Future",
            "pub_date": "2025-07-16T10:00:00.000Z",
            "duration": "00:44:45",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/americas-energy-problem-the-grid-that-built-america-cant-power-its-future-T4cIIiRI",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/8ceba7f9-e805-4e30-89ae-325be812322d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=8ceba7f9-e805-4e30-89ae-325be812322d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "63df9159-14ed-4f20-a590-ccc4708c3a1e",
            "index": 227,
            "title": "Aaron Levie on AI's Enterprise Adoption",
            "pub_date": "2025-07-14T10:00:00.000Z",
            "duration": "00:53:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/aaron-levie-on-ais-enterprise-adoption-0GbhMdXE",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0a5ffba9-a60d-4fcb-8c3a-f076b33fdf42/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0a5ffba9-a60d-4fcb-8c3a-f076b33fdf42&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36acc89e-e618-4515-aa43-0274d455fa73",
            "index": 228,
            "title": "Ben Horowitz: What Founders Must Know About AI and Crypto",
            "pub_date": "2025-07-11T10:00:00.000Z",
            "duration": "01:22:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/ben-horowitz-what-founders-must-know-about-ai-and-crypto-JTvZK__3",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/fe8b1439-fbe0-4057-ac4d-b2e5e3ca29b8/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=fe8b1439-fbe0-4057-ac4d-b2e5e3ca29b8&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4316bd41-810e-4f3f-906a-01cedc0a7a35",
            "index": 229,
            "title": "Stablecoins & the Future Financial System",
            "pub_date": "2025-07-09T10:00:00.000Z",
            "duration": "00:37:52",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/stablecoins-the-future-financial-system-uRafstfC",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/8a5cf2bc-ba44-43fe-bab1-f5aa36e4a09c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=8a5cf2bc-ba44-43fe-bab1-f5aa36e4a09c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89c30608-186c-42d1-a109-8bf07c93f2f6",
            "index": 230,
            "title": "How Andreessen Horowitz Disrupted VC & What’s Coming Next",
            "pub_date": "2025-07-07T10:00:00.000Z",
            "duration": "01:23:01",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-andreessen-horowitz-disrupted-vc-whats-coming-next-eh8ht9tq-KbEP78sV",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/fd4b2e60-558c-408e-a595-834414e87f06/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=fd4b2e60-558c-408e-a595-834414e87f06&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35cf43b3-5dbe-4813-a9a4-e8b8d77ff573",
            "index": 231,
            "title": "Enabling Agents and Battling Bots on an AI-Centric Web",
            "pub_date": "2025-07-04T10:00:00.000Z",
            "duration": "00:26:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "inference"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/enabling-agents-and-battling-bots-on-an-ai-centric-web-iBB0QjkB",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a58119e6-d221-4790-9d67-2eb38195fd1d/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a58119e6-d221-4790-9d67-2eb38195fd1d&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e083a1ce-f68e-436e-bf88-fe2d2d0fc6d2",
            "index": 232,
            "title": "Marc Andreessen on Startup Timing",
            "pub_date": "2025-07-02T10:00:00.000Z",
            "duration": "00:18:16",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-on-startup-timing-MFDl9KDi",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d24df261-0614-427c-a8e1-8832ec14db08/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d24df261-0614-427c-a8e1-8832ec14db08&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa877e31-008f-4309-a244-2b1f9cf819b1",
            "index": 233,
            "title": "Katherine Boyle: How Tech Can Rebuild America",
            "pub_date": "2025-06-30T10:00:00.000Z",
            "duration": "00:52:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/how-tech-can-rebuild-america-d9tGccEs",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/24a527d0-d153-4077-b023-6ed7757a3c1c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=24a527d0-d153-4077-b023-6ed7757a3c1c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2bc85805-4320-4046-a1c9-09bd1649c256",
            "index": 234,
            "title": "Where We Are in the AI Cycle",
            "pub_date": "2025-06-27T10:00:00.000Z",
            "duration": "00:30:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/where-we-are-in-the-ai-cycle-6ZfbkiTz",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/517186ff-cc89-401f-bcb2-6d880d7fce87/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=517186ff-cc89-401f-bcb2-6d880d7fce87&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad7bbc89-c542-44a7-8081-8191ad3439dd",
            "index": 235,
            "title": "Building Cluely: The Viral AI Startup that raised $15M in 10 Weeks",
            "pub_date": "2025-06-25T10:00:00.000Z",
            "duration": "00:38:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-cluely-the-viral-ai-startup-that-raised-15m-in-10-weeks-lZK9ek6j",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/f2072d4b-63e5-40b1-a703-7f30ea45ce2a/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=f2072d4b-63e5-40b1-a703-7f30ea45ce2a&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "05876a10-a210-428d-9f5c-6daf3a6a81c6",
            "index": 236,
            "title": "Chris Dixon & Tyler Cowen on Crypto, AI, and Philosophy",
            "pub_date": "2025-06-23T10:00:00.000Z",
            "duration": "01:06:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/chris-dixon-tyler-cowen-on-crypto-ai-and-philosophy-a396Z_G_",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a6e92bb2-c730-421a-87d4-243502536002/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a6e92bb2-c730-421a-87d4-243502536002&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8906393e-6033-4c5e-ae08-9fe56714a0a2",
            "index": 237,
            "title": "Why We Invested In Cluely",
            "pub_date": "2025-06-21T10:00:00.000Z",
            "duration": "00:12:28",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/why-we-invested-in-cluely-jYcSMgS4",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/6740c70c-e640-4663-a568-954663773c48/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=6740c70c-e640-4663-a568-954663773c48&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "96a8de4d-4048-4510-af59-9b9f13525d9a",
            "index": 238,
            "title": "The State of AI & Education",
            "pub_date": "2025-06-20T10:00:00.000Z",
            "duration": "00:29:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-state-of-ai-education-tjQQope1",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d7c6eba6-770e-44a1-b5b0-0756c641f559/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d7c6eba6-770e-44a1-b5b0-0756c641f559&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba310738-d5a4-4ea2-ad1d-748daf9264fd",
            "index": 239,
            "title": "How Apple Became So Reliant on China & What it Means For Their Future",
            "pub_date": "2025-06-18T10:00:00.000Z",
            "duration": "00:49:22",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/how-apple-became-so-reliant-on-china-what-it-means-for-their-future-hhNTn7DQ",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/14a5771d-aef2-4e87-938a-088ace9066ce/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=14a5771d-aef2-4e87-938a-088ace9066ce&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f3cd695-7dd8-47c9-85ec-a92873c75dff",
            "index": 240,
            "title": "Adam Neumann: This is How You Build Iconic Companies",
            "pub_date": "2025-06-16T10:00:00.000Z",
            "duration": "01:29:51",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "alignment"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/adam-neuman-this-is-how-you-build-iconic-companies-oS01oeoD",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/bfde9b8b-0be0-4a61-9c52-65a30e51a28c/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=bfde9b8b-0be0-4a61-9c52-65a30e51a28c&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "61e87d66-f357-496f-abc2-2052be163a85",
            "index": 241,
            "title": "What You Missed in AI This Week (Google, Apple, ChatGPT)",
            "pub_date": "2025-06-13T10:00:00.000Z",
            "duration": "00:28:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/what-you-missed-in-ai-this-week-google-apple-chatgpt-hjMTMFZN",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/0179e266-3f64-4065-bdfa-bf57f6795043/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=0179e266-3f64-4065-bdfa-bf57f6795043&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d9abec83-f7bc-4a15-b88c-512022018cef",
            "index": 242,
            "title": "Marc Andreessen & Jack Altman: Venture Capital, AI, & Media",
            "pub_date": "2025-06-11T12:30:00.000Z",
            "duration": "01:41:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-jack-altman-venture-capital-ai-media-FR0jdOGe",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/eeda1c79-b541-4c33-bdb2-9daf8957cb03/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=eeda1c79-b541-4c33-bdb2-9daf8957cb03&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e983347-7815-4b62-87a6-84d988a772b7",
            "index": 243,
            "title": "Chris Dixon: Stablecoins, Startups, and the Crypto Stack",
            "pub_date": "2025-06-09T10:00:00.000Z",
            "duration": "00:29:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/chris-dixon-on-tbpn-w4oGirDM",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a81529f7-ad64-4305-b4dc-050c445b1c3e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a81529f7-ad64-4305-b4dc-050c445b1c3e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f678f9f-5cae-4738-b89a-7612977302ed",
            "index": 244,
            "title": "The State of Consumer Tech in the Age of AI",
            "pub_date": "2025-06-06T10:00:00.000Z",
            "duration": "00:47:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-state-of-consumer-tech-in-the-age-of-ai-BcmpJN_v",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/90d8d659-7b41-4c86-803a-c9369b0e87b6/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=90d8d659-7b41-4c86-803a-c9369b0e87b6&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b427638c-af28-498a-875c-648c8ab79528",
            "index": 245,
            "title": "Fei-Fei Li: World Models and the Multiverse",
            "pub_date": "2025-06-04T12:53:31.000Z",
            "duration": "00:22:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "robotics"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/fei-fei-li-world-models-and-the-multiverse-8kZQbh9a",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/e596a090-a9e7-4ea5-9de0-1b4f46b9c4cc/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=e596a090-a9e7-4ea5-9de0-1b4f46b9c4cc&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66c00a7b-df4c-4c89-8ade-a1ca0e57847a",
            "index": 246,
            "title": "Marc Andreessen: What We Got Right—and Wrong—About the Future of Tech",
            "pub_date": "2025-06-02T10:00:00.000Z",
            "duration": "00:32:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://a16z.simplecast.com/episodes/marc-andreessen-what-we-got-rightand-wrongabout-the-future-of-tech-tpgwmcjc",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/95f34969-87be-40be-a178-9ff48ccdd0e0/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=95f34969-87be-40be-a178-9ff48ccdd0e0&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1e9e671-1f11-4d65-826d-cdb86446f515",
            "index": 247,
            "title": "Where Crypto Meets AI with Chris Dixon & David George",
            "pub_date": "2025-05-31T10:00:00.000Z",
            "duration": "00:33:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/building-the-next-internet-where-crypto-meets-ai-I5TEXg6P",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/fe5fa17f-7002-4aca-b0d3-f05dd493e950/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=fe5fa17f-7002-4aca-b0d3-f05dd493e950&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8e96714-509d-4b22-837b-c300d1dff815",
            "index": 248,
            "title": "Rick Rubin: Vibe Coding is the Punk Rock of Software",
            "pub_date": "2025-05-29T17:42:07.000Z",
            "duration": "01:16:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "coding"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/rick-rubin-vibe-coding-is-the-punk-rock-of-software-9QhxjZpI",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/d5dbade1-ab55-4d6f-9724-0ae2d3a3427e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=d5dbade1-ab55-4d6f-9724-0ae2d3a3427e&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d6dfd7e1-4754-4217-9a0c-39399653803d",
            "index": 249,
            "title": "Where Value Will Accrue in AI: Martin Casado & Sarah Wang",
            "pub_date": "2025-05-27T18:12:28.000Z",
            "duration": "00:21:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/the-state-of-ai-with-martin-casado-sarah-wang-UDPtwqTk",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/a5a0836e-768a-4874-b2f7-5e45ff9561c2/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=a5a0836e-768a-4874-b2f7-5e45ff9561c2&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c2fe9c7-ce0c-4ee2-a93e-993327035281",
            "index": 250,
            "title": "Sovereign AI: Why Nations Are Building Their Own Models",
            "pub_date": "2025-05-24T10:00:00.000Z",
            "duration": "00:32:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://a16z.simplecast.com/episodes/infra-lp-summit-2025-5SuxEQec",
            "audio_url": "https://mgln.ai/e/1344/afp-848985-injected.calisto.simplecastaudio.com/3f86df7b-51c6-4101-88a2-550dba782de8/episodes/ef189add-2dda-4815-ab2d-f17dd4d87a70/audio/128/default.mp3?aid=rss_feed&awCollectionId=3f86df7b-51c6-4101-88a2-550dba782de8&awEpisodeId=ef189add-2dda-4815-ab2d-f17dd4d87a70&feed=JGE3yC0V",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "practical-ai",
        "title": "Practical AI",
        "feed_title": "Practical AI",
        "priority": "P1",
        "selection_mode": "all_ai",
        "focus": [
          "AI engineering",
          "ML systems",
          "open source",
          "developers"
        ],
        "feed_url": "https://feeds.transistor.fm/practical-ai-machine-learning-data-science-llm",
        "source_url": "https://feeds.transistor.fm/practical-ai-machine-learning-data-science-llm",
        "detail_path": "/podcasts/practical-ai/",
        "episode_count": 200,
        "selected_episode_count": 200,
        "latest_episode_title": "Breaking down the 2026 Stanford AI Index Report",
        "latest_pub_date": "2026-06-04T09:00:00.000Z",
        "latest_page_url": "https://share.transistor.fm/s/302b36f8",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "fe415ec1-2ec5-4f37-9a63-5cb23414339c",
            "index": 1,
            "title": "Breaking down the 2026 Stanford AI Index Report",
            "pub_date": "2026-06-04T09:00:00.000Z",
            "duration": "2833",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "safety",
              "robotics"
            ],
            "page_url": "https://share.transistor.fm/s/302b36f8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/302b36f8/d474795e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "16863a1c-38c8-4d5c-ac85-efdbf1da5b40",
            "index": 2,
            "title": "Rebooting Enterprise AI with MCP and Kubernetes",
            "pub_date": "2026-05-28T09:00:00.000Z",
            "duration": "2889",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "enterprise ai"
            ],
            "page_url": "https://share.transistor.fm/s/d76e02d5",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d76e02d5/e934139b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2883cd96-a811-4539-967a-3705c330d3dc",
            "index": 3,
            "title": "Hermes Agent: Agents that grow with you",
            "pub_date": "2026-05-21T09:00:00.000Z",
            "duration": "3102",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/451da102",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/451da102/629a058c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "748c2de5-a16b-4bfd-b73c-57440513e542",
            "index": 4,
            "title": "U.S. Congressman Beyer on AI challenges facing America and the World",
            "pub_date": "2026-05-14T09:00:00.000Z",
            "duration": "2705",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/9ac73d0a",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/9ac73d0a/a5131751.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 108,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1b717d56-974a-4ffe-8189-8df486ba2198",
            "index": 5,
            "title": "The Myth of Model Wars: Open vs Closed AI in 2026",
            "pub_date": "2026-05-07T09:00:00.000Z",
            "duration": "2542",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "llama"
            ],
            "page_url": "https://share.transistor.fm/s/6095edc5",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/6095edc5/d370f038.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 81,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "53e551ea-abda-4837-8fd8-e2983ad02528",
            "index": 6,
            "title": "The mythos of Mythos and Allbirds takes flight to the neocloud",
            "pub_date": "2026-04-23T09:00:00.000Z",
            "duration": "2707",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "frontier model",
              "anthropic"
            ],
            "page_url": "https://share.transistor.fm/s/b11bd219",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b11bd219/8827ba44.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 100,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "be951332-169e-43b4-8963-277b2a1b86ee",
            "index": 7,
            "title": "Open Source Self-Driving with Comma AI",
            "pub_date": "2026-04-16T09:00:00.000Z",
            "duration": "2764",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "robotics"
            ],
            "page_url": "https://share.transistor.fm/s/9d157a1b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/9d157a1b/d3175cb9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 121,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "935cb988-528b-460c-a13b-ac081b371aef",
            "index": 8,
            "title": "Post-Mortem of Anthropic's Claude Code Leak",
            "pub_date": "2026-04-09T09:00:00.000Z",
            "duration": "2676",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "anthropic",
              "claude",
              "safety"
            ],
            "page_url": "https://share.transistor.fm/s/44e59b0b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/44e59b0b/1ecd61fa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 77,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c3d9a882-c06e-4e90-bcb8-95b9c5e5eda6",
            "index": 9,
            "title": "Agentic Coding and the Economics of Open Source",
            "pub_date": "2026-04-02T09:00:00.000Z",
            "duration": "2939",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/7d8e0293",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/7d8e0293/0bbed6a2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 94,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c0bc0a38-8ba5-40a7-994e-0e60e37985f3",
            "index": 10,
            "title": "AI at the Edge is a different operating environment",
            "pub_date": "2026-03-25T18:59:43.000Z",
            "duration": "2819",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/ea7694a9",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/ea7694a9/378817af.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 86,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c1054380-2ce1-4eb5-830b-34357f7d99e7",
            "index": 11,
            "title": "Humility in the Age of Agentic Coding",
            "pub_date": "2026-03-17T14:29:29.000Z",
            "duration": "3326",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "claude",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/7e1ca2c8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/7e1ca2c8/3ade85d6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 154,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "65c042ae-28bb-4ec7-b442-4bce381ddcb2",
            "index": 12,
            "title": "AI policy and the battle for computing power",
            "pub_date": "2026-03-09T13:27:19.000Z",
            "duration": "2934",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "safety"
            ],
            "page_url": "https://share.transistor.fm/s/1923dca1",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/1923dca1/0dd54a72.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 118,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "556e1c17-50d5-4099-8fba-2df8ae15661e",
            "index": 13,
            "title": "Cognitive Synthesis and Neural Athletes",
            "pub_date": "2026-02-18T13:57:44.000Z",
            "duration": "3147",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/4aaf31b4",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/4aaf31b4/4eefa767.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 104,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "fcbe89dc-70d4-4351-bc8a-ee570292ae36",
            "index": 14,
            "title": "AI incidents, audits, and the limits of benchmarks",
            "pub_date": "2026-02-13T15:57:56.000Z",
            "duration": "2572",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://share.transistor.fm/s/1b8e65f4",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/1b8e65f4/5f10a20b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a35462b5-9a44-435f-bd31-cf8d10d437e7",
            "index": 15,
            "title": "Inside an AI-Run Company",
            "pub_date": "2026-02-02T19:00:22.000Z",
            "duration": "2963",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/bc10d952",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/bc10d952/62cf79c5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 120,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e26c0ac8-688a-4957-bbab-3ce2f48ef9e4",
            "index": 16,
            "title": "How is AI shaping democracy?",
            "pub_date": "2026-01-27T13:58:25.000Z",
            "duration": "2903",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/0d2fa64e",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/0d2fa64e/d7cf6a15.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "57872af6-b6b7-4832-86a9-35608a8296b8",
            "index": 17,
            "title": "Controlling AI Models from the Inside",
            "pub_date": "2026-01-20T19:10:20.000Z",
            "duration": "2635",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety"
            ],
            "page_url": "https://share.transistor.fm/s/df33214d",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/df33214d/9c2dd1a8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 119,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3d69fe1e-b2e4-4a33-9efc-4466e56b1887",
            "index": 18,
            "title": "2025 was the year of agents, what's coming in 2026?",
            "pub_date": "2026-01-09T20:08:07.000Z",
            "duration": "3075",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning",
              "multimodal"
            ],
            "page_url": "https://share.transistor.fm/s/e7fda8ce",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e7fda8ce/c218cdfa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "07b2ca44-92af-4b4f-80ac-448a00e8e548",
            "index": 19,
            "title": "Beyond chatbots: Agents that tackle your SOPs",
            "pub_date": "2025-12-17T18:30:41.000Z",
            "duration": "2753",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "https://share.transistor.fm/s/49afc59f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/49afc59f/0704690c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 121,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "22b000ed-38fb-415a-8084-25b7475983cb",
            "index": 20,
            "title": "The AI engineer skills gap",
            "pub_date": "2025-12-10T15:01:19.000Z",
            "duration": "2733",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/e3639074",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e3639074/9b5391ce.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 103,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "fa371b17-2f78-43b7-9cba-9321b35219f3",
            "index": 21,
            "title": "Technical advances in document understanding",
            "pub_date": "2025-12-02T20:58:43.000Z",
            "duration": "2958",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/ba36c917",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/ba36c917/9f513f05.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0285ede8-e11a-414d-baa3-c667ce5c971b",
            "index": 22,
            "title": "Chris on AI, autonomous swarming, home automation and Rust!",
            "pub_date": "2025-11-26T21:28:00.000Z",
            "duration": "5829",
            "duration_label": "1h 37m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "chatgpt",
              "robotics",
              "automation"
            ],
            "page_url": "https://share.transistor.fm/s/50ac2613",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/50ac2613/493156dd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 416,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5bbaf36f-b4da-4f44-b217-932122310fb0",
            "index": 23,
            "title": "Beyond note-taking with Fireflies",
            "pub_date": "2025-11-19T17:59:41.000Z",
            "duration": "2939",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://share.transistor.fm/s/a3018119",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/a3018119/3a4ba1ea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 102,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5604b042-20c2-4aa8-b9c5-95664ad78ddd",
            "index": 24,
            "title": "Autonomous Vehicle Research at Waymo",
            "pub_date": "2025-11-13T15:33:36.000Z",
            "duration": "3128",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "safety"
            ],
            "page_url": "https://share.transistor.fm/s/7b9cfe10",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/7b9cfe10/fe5031af.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 114,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "21825b5b-994c-4aed-8d3f-25a84159eb80",
            "index": 25,
            "title": "Are we in an AI bubble?",
            "pub_date": "2025-11-10T14:18:57.000Z",
            "duration": "2981",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/533b0b3f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/533b0b3f/ebbf2629.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 92,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e8faf8b3-70e8-437d-b879-363fbd741efa",
            "index": 26,
            "title": "While loops with tool calls",
            "pub_date": "2025-10-30T20:39:08.000Z",
            "duration": "2685",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/ca41b93c",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/ca41b93c/a54b2afe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "26fd3387-635e-4844-be9b-05356c6b8449",
            "index": 27,
            "title": "Tiny Recursive Networks",
            "pub_date": "2025-10-24T15:17:53.000Z",
            "duration": "2903",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "reasoning"
            ],
            "page_url": "https://share.transistor.fm/s/e568790b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e568790b/ebe47dbc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8a585606-13c6-4064-821f-6b4be5b232ca",
            "index": 28,
            "title": "Dealing with increasingly complicated agents",
            "pub_date": "2025-10-16T16:30:17.000Z",
            "duration": "3296",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://share.transistor.fm/s/e60866e6",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e60866e6/972751fe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 118,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2a9fd6ef-4894-4931-a47e-6ea7df4d07dc",
            "index": 29,
            "title": "The impact of AI on the workforce: A state-level case study",
            "pub_date": "2025-10-09T13:02:04.000Z",
            "duration": "2644",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/0da5a2b1",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/0da5a2b1/3081228f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 107,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d9e8078b-5582-490f-976e-f5197f3db234",
            "index": 30,
            "title": "We've all done RAG, now what?",
            "pub_date": "2025-09-29T20:46:04.000Z",
            "duration": "2615",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "reasoning",
              "rag",
              "retrieval"
            ],
            "page_url": "https://share.transistor.fm/s/e13d399b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e13d399b/bf9fec0b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 99,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "552ed99d-351d-4fbb-b653-d2f5e1c5402a",
            "index": 31,
            "title": "Creating a private AI assistant in Thunderbird",
            "pub_date": "2025-09-23T19:50:58.000Z",
            "duration": "3188",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "inference"
            ],
            "page_url": "https://share.transistor.fm/s/c73dd974",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/c73dd974/7b2ed2ac.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 124,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2f2c3429-83eb-40cd-9bdd-23e02e8467cd",
            "index": 32,
            "title": "Cracking the code of failed AI pilots",
            "pub_date": "2025-09-11T15:16:03.000Z",
            "duration": "2804",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/2cde3de8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/2cde3de8/d2cafdc4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 81,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "93a2312f-6730-434a-b7c1-2919df8b2897",
            "index": 33,
            "title": "GenAI risks and global adoption",
            "pub_date": "2025-08-27T15:19:09.000Z",
            "duration": "2600",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety"
            ],
            "page_url": "https://share.transistor.fm/s/522b45c8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/522b45c8/587aa613.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9d741acd-2d69-449e-af5b-7c95a01be2dd",
            "index": 34,
            "title": "Inside America’s AI Action Plan",
            "pub_date": "2025-08-19T13:51:16.000Z",
            "duration": "2632",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/f9da825c",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/f9da825c/8f07ed62.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 77,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1457578d-17e0-4567-9443-eaeee007634b",
            "index": 35,
            "title": "Confident, strategic AI leadership",
            "pub_date": "2025-08-12T18:03:38.000Z",
            "duration": "2860",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/05d1bf50",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/05d1bf50/1451323b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 102,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a1a0a979-7151-48cb-8234-0d31cfbfb373",
            "index": 36,
            "title": "Educating a data-literate generation",
            "pub_date": "2025-08-08T16:40:01.000Z",
            "duration": "2681",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/a952cb30",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/a952cb30/c4daf7a6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 100,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1b23e30a-100f-4f8a-84df-7ac9e714057f",
            "index": 37,
            "title": "Workforce dynamics in an AI-assisted world",
            "pub_date": "2025-08-01T17:25:25.000Z",
            "duration": "2646",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/12268c7d",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/12268c7d/5821e976.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 88,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "fccfe798-4145-481d-af81-c8c4cc73fd7b",
            "index": 38,
            "title": "Reimagining actuarial science with AI",
            "pub_date": "2025-07-25T14:41:35.000Z",
            "duration": "2459",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/4771f92e",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/4771f92e/5b998ce7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "be96969b-dbf8-402d-bde2-890d642e023a",
            "index": 39,
            "title": "Agentic AI for Drone & Robotic Swarming",
            "pub_date": "2025-07-15T16:37:07.000Z",
            "duration": "2787",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "inference",
              "robotics"
            ],
            "page_url": "https://share.transistor.fm/s/6743e631",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/6743e631/0661990d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 111,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a189de61-20ec-443a-b297-bb094cd44c42",
            "index": 40,
            "title": "AI in the shadows: From hallucinations to blackmail",
            "pub_date": "2025-07-07T19:04:27.000Z",
            "duration": "2690",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "anthropic",
              "reasoning"
            ],
            "page_url": "https://share.transistor.fm/s/60675819",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/60675819/fc06806a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 99,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "25f2c986-c65c-4333-b088-6b00c3ac3f05",
            "index": 41,
            "title": "Finding Nemotron",
            "pub_date": "2025-07-02T18:54:16.000Z",
            "duration": "2783",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama",
              "nvidia",
              "reasoning"
            ],
            "page_url": "https://share.transistor.fm/s/6b9fa11e",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/6b9fa11e/e7dbbada.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f5bf4735-b82f-41a3-9c2e-5cc25f5168bc",
            "index": 42,
            "title": "AI hot takes and debates: Autonomy",
            "pub_date": "2025-06-27T16:26:05.000Z",
            "duration": "2736",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/2492fb57",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/2492fb57/9e049748.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 84,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1455019e-f400-4041-88e5-5f9b3b6fc8cc",
            "index": 43,
            "title": "Behind-the-Scenes: VC Funding for AI Startups",
            "pub_date": "2025-06-18T19:23:21.000Z",
            "duration": "2508",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "https://share.transistor.fm/s/2f7547c3",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/2f7547c3/4ad7b59c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 100,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "4e5c87dc-afca-4fb5-b295-4e4b955627a7",
            "index": 44,
            "title": "AI-Automated Film Making",
            "pub_date": "2025-06-12T15:22:11.000Z",
            "duration": "2582",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/d6f5844f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d6f5844f/25da64eb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 84,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d723ab20-4c1c-497a-8b1f-02d5defcefd7",
            "index": 45,
            "title": "Federated learning in production (part 2)",
            "pub_date": "2025-06-04T15:46:58.000Z",
            "duration": "2725",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/1e3c9247",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/1e3c9247/e9f0e8cd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "cc6e6d9b-5a7d-46fa-b784-6b5f3c12c9e7",
            "index": 46,
            "title": "Federated learning in production (part 1)",
            "pub_date": "2025-05-30T17:25:32.000Z",
            "duration": "2678",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/e283a9d0",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e283a9d0/77122826.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 78,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "4218866a-0122-472b-af2b-98355cf1d7d8",
            "index": 47,
            "title": "Emailing like a superhuman",
            "pub_date": "2025-05-20T17:55:24.000Z",
            "duration": "2847",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/f4e7b59f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/f4e7b59f/22aa6309.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 98,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0deadba3-7280-47cf-8346-dd75bb5f7983",
            "index": 48,
            "title": "Model Context Protocol Deep Dive",
            "pub_date": "2025-05-08T12:56:50.000Z",
            "duration": "2543",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "anthropic"
            ],
            "page_url": "https://share.transistor.fm/s/d7a0d796",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d7a0d796/0e8b4946.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 101,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d0825afe-5941-48ef-b4ee-42f963df6b38",
            "index": 49,
            "title": "Seeing beyond the scan in neuroimaging",
            "pub_date": "2025-04-30T12:57:06.000Z",
            "duration": "2578",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://share.transistor.fm/s/c2ab9c38",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/c2ab9c38/08b556c2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 92,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "46192cc2-91ab-46ca-8a26-a0976c1c9f33",
            "index": 50,
            "title": "Open source AI to tackle your backlog",
            "pub_date": "2025-04-17T23:12:06.000Z",
            "duration": "2524",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/c34dea01",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/c34dea01/a089ddae.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 100,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6f648f8c-8bfa-432e-8bc1-c49f4e8d58b4",
            "index": 51,
            "title": "Orchestrating agents, APIs, and MCP servers",
            "pub_date": "2025-04-14T12:53:31.000Z",
            "duration": "2572",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://share.transistor.fm/s/657d28be",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/657d28be/0b5d4eee.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 110,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5edd910e-8474-40c8-8b83-ee289c67ae3b",
            "index": 52,
            "title": "Software and hardware acceleration with Groq",
            "pub_date": "2025-04-02T20:51:52.000Z",
            "duration": "2604",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://share.transistor.fm/s/5e63c891",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/5e63c891/c3ddeda7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 96,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "97b9dc86-ad4c-4fb7-bfc0-bb98fd13a9fa",
            "index": 53,
            "title": "AI-assisted coding with GitHub's COO",
            "pub_date": "2025-03-21T21:34:33.000Z",
            "duration": "3004",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "github copilot",
              "coding",
              "copilot"
            ],
            "page_url": "https://share.transistor.fm/s/de9cc636",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/de9cc636/54d4d266.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 107,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f8b53471-70f1-4ade-a68d-c0a89fa9211b",
            "index": 54,
            "title": "Optimizing for efficiency with IBM’s Granite",
            "pub_date": "2025-03-14T13:28:22.000Z",
            "duration": "2618",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "https://share.transistor.fm/s/fb39a0d8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/fb39a0d8/fd368e57.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 107,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1c08e18d-2c47-4af0-934c-a672510f1510",
            "index": 55,
            "title": "Build a workspace of AI agents",
            "pub_date": "2025-03-08T17:52:57.000Z",
            "duration": "2859",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/b1865616",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b1865616/558ce8ee.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_transistor_transcript",
              "transcript_record_count": 132,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2670",
            "index": 56,
            "title": "GenAI hot takes and bad use cases",
            "pub_date": "2025-02-24T17:00:00.000Z",
            "duration": "1836",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/8dbe8848",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/8dbe8848/7cde8f58.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "changelog.com/7/2665",
            "index": 57,
            "title": "Tool calling and agents",
            "pub_date": "2025-02-14T15:00:00.000Z",
            "duration": "2700",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "agent",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/937fd39e",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/937fd39e/d551db68.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "changelog.com/7/2658",
            "index": 58,
            "title": "Deep-dive into DeepSeek",
            "pub_date": "2025-01-31T15:30:00.000Z",
            "duration": "3047",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://share.transistor.fm/s/ffcbf272",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/ffcbf272/270b8e8f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "changelog.com/7/2653",
            "index": 59,
            "title": "Video generation with realistic motion",
            "pub_date": "2025-01-23T16:00:00.000Z",
            "duration": "2709",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/7c4c29cc",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/7c4c29cc/c239855c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "changelog.com/7/2643",
            "index": 60,
            "title": "Mozart to Megadeth at CHRP",
            "pub_date": "2024-12-19T16:30:00.000Z",
            "duration": "3233",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/04a91808",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/04a91808/a957a48b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 41,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2640",
            "index": 61,
            "title": "Sidekick is an AI Shopify expert",
            "pub_date": "2024-12-11T22:15:00.000Z",
            "duration": "3097",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "rag"
            ],
            "page_url": "https://share.transistor.fm/s/f5a16bd0",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/f5a16bd0/4db0a9b4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 80,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2631",
            "index": 62,
            "title": "Full-duplex, real-time dialogue with Kyutai",
            "pub_date": "2024-12-04T16:00:00.000Z",
            "duration": "3003",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "rag"
            ],
            "page_url": "https://share.transistor.fm/s/3f7b3ef6",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/3f7b3ef6/d0797f1b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 34,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2629",
            "index": 63,
            "title": "Clones, commerce & campaigns",
            "pub_date": "2024-11-29T17:30:00.000Z",
            "duration": "3191",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://share.transistor.fm/s/fb1edb1f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/fb1edb1f/336a3cbc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 73,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2623",
            "index": 64,
            "title": "scikit-learn & data science you own",
            "pub_date": "2024-11-19T21:00:00.000Z",
            "duration": "3122",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "rag"
            ],
            "page_url": "https://share.transistor.fm/s/5e938e26",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/5e938e26/995d49d3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 37,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2615",
            "index": 65,
            "title": "Creating tested, reliable AI applications",
            "pub_date": "2024-11-13T19:30:00.000Z",
            "duration": "3007",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "rag"
            ],
            "page_url": "https://share.transistor.fm/s/604d821f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/604d821f/c7d880d2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 46,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2604",
            "index": 66,
            "title": "AI is changing the cybersecurity threat landscape",
            "pub_date": "2024-11-05T19:40:00.000Z",
            "duration": "3323",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/e656f736",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e656f736/b31150cf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 53,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2597",
            "index": 67,
            "title": "The path towards trustworthy AI",
            "pub_date": "2024-10-29T19:00:00.000Z",
            "duration": "3104",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://share.transistor.fm/s/38a4b5e2",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/38a4b5e2/1f9afbec.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 22,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2598",
            "index": 68,
            "title": "Big data is dead, analytics is alive",
            "pub_date": "2024-10-24T15:30:00.000Z",
            "duration": "3019",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/a1eb867f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/a1eb867f/eb5e5a5b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 39,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2586",
            "index": 69,
            "title": "Practical workflow orchestration",
            "pub_date": "2024-10-15T20:00:00.000Z",
            "duration": "3504",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic"
            ],
            "page_url": "https://share.transistor.fm/s/483a51a6",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/483a51a6/7ddedbe9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 49,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2579",
            "index": 70,
            "title": "Towards high-quality (maybe synthetic) datasets",
            "pub_date": "2024-10-09T13:30:00.000Z",
            "duration": "3422",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/af180c44",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/af180c44/952ea310.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 41,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2576",
            "index": 71,
            "title": "Understanding what's possible, doable & scalable",
            "pub_date": "2024-10-03T15:45:00.000Z",
            "duration": "3741",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/aee0a4a0",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/aee0a4a0/abeadb91.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 34,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2570",
            "index": 72,
            "title": "GraphRAG (beyond the hype)",
            "pub_date": "2024-09-25T18:30:00.000Z",
            "duration": "3302",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "rag"
            ],
            "page_url": "https://share.transistor.fm/s/d2299d84",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d2299d84/fcae2902.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 37,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2565",
            "index": 73,
            "title": "Pausing to think about scikit-learn & OpenAI o1",
            "pub_date": "2024-09-17T19:00:00.000Z",
            "duration": "3010",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://share.transistor.fm/s/35fff0ca",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/35fff0ca/6b8ef8e6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 47,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2554",
            "index": 74,
            "title": "Cybersecurity in the GenAI age",
            "pub_date": "2024-09-11T20:35:00.000Z",
            "duration": "3094",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/47e8830c",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/47e8830c/1d6b1048.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 39,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2551",
            "index": 75,
            "title": "AI is more than GenAI",
            "pub_date": "2024-09-05T14:00:00.000Z",
            "duration": "2403",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embeddings"
            ],
            "page_url": "https://share.transistor.fm/s/ba93c83c",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/ba93c83c/515129a7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "changelog.com/7/2546",
            "index": 76,
            "title": "Metrics Driven Development",
            "pub_date": "2024-08-29T20:45:00.000Z",
            "duration": "2532",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "rag"
            ],
            "page_url": "https://share.transistor.fm/s/4873f35c",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/4873f35c/d4cac168.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "changelog.com/7/2541",
            "index": 77,
            "title": "Threat modeling LLM apps",
            "pub_date": "2024-08-22T13:30:00.000Z",
            "duration": "3278",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "chatgpt",
              "gemini",
              "alignment"
            ],
            "page_url": "https://share.transistor.fm/s/6947239f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/6947239f/6e55ab91.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 37,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2534",
            "index": 78,
            "title": "Only as good as the data",
            "pub_date": "2024-08-14T21:15:00.000Z",
            "duration": "2741",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/1edb5dc5",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/1edb5dc5/16bf7b93.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 43,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2518",
            "index": 79,
            "title": "Gaudi processors & Intel's AI portfolio",
            "pub_date": "2024-08-07T13:45:00.000Z",
            "duration": "2788",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "gpu"
            ],
            "page_url": "https://share.transistor.fm/s/0ef709e4",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/0ef709e4/0702cc71.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 43,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2515",
            "index": 80,
            "title": "Broccoli AI at its best 🥦",
            "pub_date": "2024-07-31T21:40:00.000Z",
            "duration": "2551",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/732541e8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/732541e8/c90a105e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 56,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2499",
            "index": 81,
            "title": "Hyperventilating over the Gartner AI Hype Cycle",
            "pub_date": "2024-07-24T19:00:00.000Z",
            "duration": "3309",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://share.transistor.fm/s/254d82f8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/254d82f8/392cb90d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 318,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2497",
            "index": 82,
            "title": "The first real-time voice assistant",
            "pub_date": "2024-07-18T12:45:00.000Z",
            "duration": "2601",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/dce6df9c",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/dce6df9c/cb45fd3a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 46,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2491",
            "index": 83,
            "title": "Vectoring in on Pinecone",
            "pub_date": "2024-07-10T17:30:00.000Z",
            "duration": "2651",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "retrieval",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/8c9648cd",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/8c9648cd/8f08d251.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 38,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2477",
            "index": 84,
            "title": "Stanford's AI Index Report 2024",
            "pub_date": "2024-07-02T19:45:00.000Z",
            "duration": "2824",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/087fcf22",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/087fcf22/9a41ccbb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 41,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2473",
            "index": 85,
            "title": "Apple Intelligence & Advanced RAG",
            "pub_date": "2024-06-25T20:45:00.000Z",
            "duration": "2706",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "rag",
              "retrieval",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/b03b373b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b03b373b/c427872b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 56,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2462",
            "index": 86,
            "title": "The perplexities of information retrieval",
            "pub_date": "2024-06-19T16:30:00.000Z",
            "duration": "2766",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity",
              "retrieval"
            ],
            "page_url": "https://share.transistor.fm/s/be091144",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/be091144/6e675934.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 34,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2457",
            "index": 87,
            "title": "Using edge models to find sensitive data",
            "pub_date": "2024-06-13T16:45:00.000Z",
            "duration": "2308",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/2a3a610c",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/2a3a610c/211363d4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 74,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2449",
            "index": 88,
            "title": "Rise of the AI PC & local LLMs",
            "pub_date": "2024-06-04T18:45:00.000Z",
            "duration": "2135",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama",
              "nvidia"
            ],
            "page_url": "https://share.transistor.fm/s/66087536",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/66087536/5f42ce2d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 32,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2442",
            "index": 89,
            "title": "AI in the U.S. Congress",
            "pub_date": "2024-05-29T14:30:00.000Z",
            "duration": "2448",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "foundation model"
            ],
            "page_url": "https://share.transistor.fm/s/8559b2a8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/8559b2a8/fd242e2b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 51,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2436",
            "index": 90,
            "title": "First impressions of GPT-4o",
            "pub_date": "2024-05-22T00:30:00.000Z",
            "duration": "2608",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "openai",
              "multimodal"
            ],
            "page_url": "https://share.transistor.fm/s/bdabf9ac",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/bdabf9ac/c566e748.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 63,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2429",
            "index": 91,
            "title": "Full-stack approach for effective AI agents",
            "pub_date": "2024-05-15T14:00:00.000Z",
            "duration": "2822",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://share.transistor.fm/s/b5914d1d",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b5914d1d/859790b8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 40,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2425",
            "index": 92,
            "title": "Autonomous fighter jets?!",
            "pub_date": "2024-05-08T19:00:00.000Z",
            "duration": "2471",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "https://share.transistor.fm/s/9eebe810",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/9eebe810/ddc1fe41.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "changelog.com/7/2419",
            "index": 93,
            "title": "Private, open source chat UIs",
            "pub_date": "2024-04-30T20:45:00.000Z",
            "duration": "2305",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "rag",
              "multimodal"
            ],
            "page_url": "https://share.transistor.fm/s/a422b8c2",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/a422b8c2/ab8b5227.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 64,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2412",
            "index": 94,
            "title": "Mamba & Jamba",
            "pub_date": "2024-04-24T15:45:00.000Z",
            "duration": "2473",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/ab7644a6",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/ab7644a6/22b07c1a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 36,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2401",
            "index": 95,
            "title": "Udio & the age of multi-modal AI",
            "pub_date": "2024-04-16T18:20:00.000Z",
            "duration": "2332",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://share.transistor.fm/s/e0bd1784",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e0bd1784/3a615bf2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2391",
            "index": 96,
            "title": "RAG continues to rise",
            "pub_date": "2024-04-10T14:00:00.000Z",
            "duration": "2899",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "rag"
            ],
            "page_url": "https://share.transistor.fm/s/e70550d7",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e70550d7/643ce4a4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 106,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2385",
            "index": 97,
            "title": "Should kids still learn to code?",
            "pub_date": "2024-04-02T20:00:00.000Z",
            "duration": "2360",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "perplexity",
              "nvidia",
              "copilot"
            ],
            "page_url": "https://share.transistor.fm/s/10f202c1",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/10f202c1/907c237c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 34,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2381",
            "index": 98,
            "title": "AI vs software devs",
            "pub_date": "2024-03-26T19:30:00.000Z",
            "duration": "3420",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/bec4b1c2",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/bec4b1c2/b247d8e8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 122,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2376",
            "index": 99,
            "title": "Prompting the future",
            "pub_date": "2024-03-20T13:45:00.000Z",
            "duration": "2759",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/f7d9e521",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/f7d9e521/21267eeb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 43,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2367",
            "index": 100,
            "title": "Generating the future of art & entertainment",
            "pub_date": "2024-03-12T17:00:00.000Z",
            "duration": "2526",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/de752b57",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/de752b57/0a7c871c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 32,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2355",
            "index": 101,
            "title": "YOLOv9: Computer vision is alive and well",
            "pub_date": "2024-03-06T17:00:00.000Z",
            "duration": "2566",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/b15dacfe",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b15dacfe/21dfffea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 55,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2352",
            "index": 102,
            "title": "Representation Engineering (Activation Hacking)",
            "pub_date": "2024-02-28T15:00:00.000Z",
            "duration": "2614",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "mistral"
            ],
            "page_url": "https://share.transistor.fm/s/20514e97",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/20514e97/d2bf9d0b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2344",
            "index": 103,
            "title": "Leading the charge on AI in National Security",
            "pub_date": "2024-02-20T15:15:00.000Z",
            "duration": "3123",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://share.transistor.fm/s/d6c1a16d",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d6c1a16d/6597fbdd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 37,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2339",
            "index": 104,
            "title": "Gemini vs OpenAI",
            "pub_date": "2024-02-14T20:00:00.000Z",
            "duration": "2609",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "gemini"
            ],
            "page_url": "https://share.transistor.fm/s/9e65312d",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/9e65312d/d7165f5d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 66,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2328",
            "index": 105,
            "title": "Data synthesis for SOTA LLMs",
            "pub_date": "2024-02-06T22:00:00.000Z",
            "duration": "2799",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/01314cdb",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/01314cdb/e401aff1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 52,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2321",
            "index": 106,
            "title": "Large Action Models (LAMs) & Rabbits 🐇",
            "pub_date": "2024-01-30T21:00:00.000Z",
            "duration": "2893",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "multimodal"
            ],
            "page_url": "https://share.transistor.fm/s/1155daea",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/1155daea/d86f47d3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 50,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2317",
            "index": 107,
            "title": "Collaboration & evaluation for LLM apps",
            "pub_date": "2024-01-23T22:30:00.000Z",
            "duration": "2774",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/5727b584",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/5727b584/bf2f49b9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 30,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2306",
            "index": 108,
            "title": "Advent of GenAI Hackathon recap",
            "pub_date": "2024-01-17T20:00:00.000Z",
            "duration": "2870",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/23880001",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/23880001/3fa78827.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 35,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2303",
            "index": 109,
            "title": "AI predictions for 2024",
            "pub_date": "2024-01-10T19:30:00.000Z",
            "duration": "2698",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/796ef477",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/796ef477/be7f6232.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 50,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2291",
            "index": 110,
            "title": "Open source, on-disk vector search with LanceDB",
            "pub_date": "2023-12-19T19:40:00.000Z",
            "duration": "2511",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/59efe3b9",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/59efe3b9/7b786f9d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 35,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2287",
            "index": 111,
            "title": "The state of open source AI",
            "pub_date": "2023-12-12T19:45:00.000Z",
            "duration": "2555",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/38b5e899",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/38b5e899/a6c844f0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 48,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2282",
            "index": 112,
            "title": "Suspicion machines ⚙️",
            "pub_date": "2023-12-05T21:45:00.000Z",
            "duration": "2815",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/ce204655",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/ce204655/818fa630.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 49,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2279",
            "index": 113,
            "title": "The OpenAI debacle (a retrospective)",
            "pub_date": "2023-11-29T18:00:00.000Z",
            "duration": "2827",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://share.transistor.fm/s/b792cebf",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b792cebf/c86e0384.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 81,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2267",
            "index": 114,
            "title": "Generating product imagery at Shopify",
            "pub_date": "2023-11-21T18:45:00.000Z",
            "duration": "3014",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/82538875",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/82538875/02d2ec8f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 66,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2261",
            "index": 115,
            "title": "AI trailblazers putting people first",
            "pub_date": "2023-11-14T17:45:00.000Z",
            "duration": "2863",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/be2008fd",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/be2008fd/105c01b6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 42,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2257",
            "index": 116,
            "title": "Government regulation of AI has arrived",
            "pub_date": "2023-11-07T14:00:00.000Z",
            "duration": "2705",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "safety"
            ],
            "page_url": "https://share.transistor.fm/s/c5cc7077",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/c5cc7077/f9f88fab.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 55,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2254",
            "index": 117,
            "title": "Self-hosting & scaling models",
            "pub_date": "2023-10-31T18:00:00.000Z",
            "duration": "2467",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/da056f75",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/da056f75/b8f20316.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 90,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2250",
            "index": 118,
            "title": "Deep learning in Rust with Burn 🔥",
            "pub_date": "2023-10-24T20:40:00.000Z",
            "duration": "2434",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/11dc4d43",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/11dc4d43/fc5a862f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 74,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2247",
            "index": 119,
            "title": "AI's impact on developers",
            "pub_date": "2023-10-20T16:30:00.000Z",
            "duration": "2902",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/03e961bf",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/03e961bf/d5c37e94.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2237",
            "index": 120,
            "title": "Generative models: exploration to deployment",
            "pub_date": "2023-10-03T19:00:00.000Z",
            "duration": "2942",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "inference"
            ],
            "page_url": "https://share.transistor.fm/s/e3e8f060",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e3e8f060/f00c17a8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 61,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2215",
            "index": 121,
            "title": "Automate all the UIs!",
            "pub_date": "2023-09-20T16:00:00.000Z",
            "duration": "2581",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "automation"
            ],
            "page_url": "https://share.transistor.fm/s/8d59e904",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/8d59e904/b20409b2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 52,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2203",
            "index": 122,
            "title": "Fine-tuning vs RAG",
            "pub_date": "2023-09-06T12:30:00.000Z",
            "duration": "3487",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "openai",
              "rag",
              "retrieval"
            ],
            "page_url": "https://share.transistor.fm/s/3df4a8e5",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/3df4a8e5/9724a01b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 112,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2196",
            "index": 123,
            "title": "Automating code optimization with LLMs",
            "pub_date": "2023-08-29T21:30:00.000Z",
            "duration": "2699",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/edad1d61",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/edad1d61/c36cbcc8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 38,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2184",
            "index": 124,
            "title": "The new AI app stack",
            "pub_date": "2023-08-23T12:00:00.000Z",
            "duration": "2707",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/99147ee2",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/99147ee2/7f9fc73d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 46,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2177",
            "index": 125,
            "title": "Blueprint for an AI Bill of Rights",
            "pub_date": "2023-08-09T16:20:00.000Z",
            "duration": "2498",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/5c0ca3eb",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/5c0ca3eb/c62759e6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 74,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2173",
            "index": 126,
            "title": "Vector databases (beyond the hype)",
            "pub_date": "2023-08-01T18:30:00.000Z",
            "duration": "3089",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "embedding"
            ],
            "page_url": "https://share.transistor.fm/s/424fa922",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/424fa922/4c30b1af.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 42,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2168",
            "index": 127,
            "title": "There's a new Llama in town",
            "pub_date": "2023-07-25T19:00:00.000Z",
            "duration": "2891",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "llama"
            ],
            "page_url": "https://share.transistor.fm/s/50483491",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/50483491/f959ff29.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 79,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2165",
            "index": 128,
            "title": "Legal consequences of generated content",
            "pub_date": "2023-07-18T18:30:00.000Z",
            "duration": "2571",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "llama"
            ],
            "page_url": "https://share.transistor.fm/s/63e1f75a",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/63e1f75a/a9bf4b35.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 48,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2128",
            "index": 129,
            "title": "A developer's toolkit for SOTA AI",
            "pub_date": "2023-07-12T21:00:00.000Z",
            "duration": "2521",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "github copilot",
              "gpu",
              "copilot"
            ],
            "page_url": "https://share.transistor.fm/s/d3eff646",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d3eff646/a49c5bf7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 46,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2124",
            "index": 130,
            "title": "Cambrian explosion of generative models",
            "pub_date": "2023-07-06T17:30:00.000Z",
            "duration": "2531",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/f2ddd724",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/f2ddd724/6559f5aa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 52,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2119",
            "index": 131,
            "title": "Automated cartography using AI",
            "pub_date": "2023-06-28T14:30:00.000Z",
            "duration": "2677",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://share.transistor.fm/s/b1def249",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b1def249/925a471c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 32,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2116",
            "index": 132,
            "title": "From ML to AI to Generative AI",
            "pub_date": "2023-06-21T13:30:00.000Z",
            "duration": "2799",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/2e62c4ad",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/2e62c4ad/b6727bf8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 52,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2109",
            "index": 133,
            "title": "AI trends: a Latent Space crossover",
            "pub_date": "2023-06-14T19:00:00.000Z",
            "duration": "3579",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/8bb2b368",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/8bb2b368/e550cdc0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2102",
            "index": 134,
            "title": "Accidentally building SOTA AI",
            "pub_date": "2023-06-06T20:45:00.000Z",
            "duration": "2522",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/cca816a0",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/cca816a0/d2fad3bc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 77,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2095",
            "index": 135,
            "title": "Controlled and compliant AI applications",
            "pub_date": "2023-05-31T17:00:00.000Z",
            "duration": "2981",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/4817f35b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/4817f35b/3d558516.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 35,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2085",
            "index": 136,
            "title": "Data augmentation with LlamaIndex",
            "pub_date": "2023-05-23T16:15:00.000Z",
            "duration": "2690",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://share.transistor.fm/s/d3e7ab55",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d3e7ab55/9a34cf29.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 42,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2081",
            "index": 137,
            "title": "Creating instruction tuned models",
            "pub_date": "2023-05-16T18:20:00.000Z",
            "duration": "1591",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/e4bc043b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e4bc043b/52bf883f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 54,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2074",
            "index": 138,
            "title": "The last mile of AI app development",
            "pub_date": "2023-05-11T13:00:00.000Z",
            "duration": "2337",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "chatgpt"
            ],
            "page_url": "https://share.transistor.fm/s/7e30e465",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/7e30e465/cc291206.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 36,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2066",
            "index": 139,
            "title": "Large models on CPUs",
            "pub_date": "2023-05-02T16:00:00.000Z",
            "duration": "2308",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "inference"
            ],
            "page_url": "https://share.transistor.fm/s/8e44d5e0",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/8e44d5e0/47d9aa51.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 28,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2061",
            "index": 140,
            "title": "Causal inference",
            "pub_date": "2023-04-25T16:35:00.000Z",
            "duration": "2539",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "llm",
              "inference"
            ],
            "page_url": "https://share.transistor.fm/s/311a1f1d",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/311a1f1d/143fcd08.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 34,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2057",
            "index": 141,
            "title": "Capabilities of LLMs 🤯",
            "pub_date": "2023-04-19T21:00:00.000Z",
            "duration": "2283",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "agents",
              "chatgpt",
              "training",
              "reasoning"
            ],
            "page_url": "https://share.transistor.fm/s/73986a0f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/73986a0f/c4e20fd5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 50,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2054",
            "index": 142,
            "title": "Computer scientists as rogue art historians",
            "pub_date": "2023-04-12T13:30:00.000Z",
            "duration": "2595",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://share.transistor.fm/s/2196a4f4",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/2196a4f4/3d855c76.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 57,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2048",
            "index": 143,
            "title": "Accelerated data science with a Kaggle grandmaster",
            "pub_date": "2023-04-04T20:00:00.000Z",
            "duration": "2632",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://share.transistor.fm/s/c04ce2de",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/c04ce2de/25783b30.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 50,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2037",
            "index": 144,
            "title": "Explainable AI that is accessible for all humans",
            "pub_date": "2023-03-28T15:30:00.000Z",
            "duration": "2735",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://share.transistor.fm/s/c3fd1221",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/c3fd1221/0d096bc3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 41,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2029",
            "index": 145,
            "title": "AI search at You.com",
            "pub_date": "2023-03-15T19:15:00.000Z",
            "duration": "2520",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "chatgpt"
            ],
            "page_url": "https://share.transistor.fm/s/e15efb1f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e15efb1f/c9d94632.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 39,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2024",
            "index": 146,
            "title": "End-to-end cloud compute for AI/ML",
            "pub_date": "2023-03-07T20:00:00.000Z",
            "duration": "2659",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/76659e53",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/76659e53/931a252a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 48,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2018",
            "index": 147,
            "title": "Success (and failure) in prompting",
            "pub_date": "2023-02-28T21:15:00.000Z",
            "duration": "2630",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://share.transistor.fm/s/a56eaecd",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/a56eaecd/bd9cfc57.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 72,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2015",
            "index": 148,
            "title": "Applied NLP solutions & AI education",
            "pub_date": "2023-02-22T15:15:00.000Z",
            "duration": "2307",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/d98fc7ab",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d98fc7ab/bb80c8fd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 23,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2008",
            "index": 149,
            "title": "Serverless GPUs",
            "pub_date": "2023-02-14T21:30:00.000Z",
            "duration": "2311",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/4d6d9bbf",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/4d6d9bbf/608f69a7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 59,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/2001",
            "index": 150,
            "title": "MLOps is alive and well",
            "pub_date": "2023-02-07T21:00:00.000Z",
            "duration": "3412",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/652123fd",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/652123fd/814b9c25.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 135,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1994",
            "index": 151,
            "title": "3D assets & simulation at NVIDIA",
            "pub_date": "2023-01-31T20:00:00.000Z",
            "duration": "2552",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://share.transistor.fm/s/2cd2558b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/2cd2558b/44d306e6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 58,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1991",
            "index": 152,
            "title": "GPU dev environments that just work",
            "pub_date": "2023-01-24T21:30:00.000Z",
            "duration": "2390",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://share.transistor.fm/s/25e6c751",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/25e6c751/c981f50e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 47,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1975",
            "index": 153,
            "title": "Machine learning at small organizations",
            "pub_date": "2023-01-17T20:15:00.000Z",
            "duration": "2990",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/42403483",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/42403483/04297df2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 57,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1964",
            "index": 154,
            "title": "ChatGPT goes prime time!",
            "pub_date": "2023-01-10T21:20:00.000Z",
            "duration": "2684",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://share.transistor.fm/s/22432f59",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/22432f59/c179ae59.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 54,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1959",
            "index": 155,
            "title": "NLP research by & for local communities",
            "pub_date": "2023-01-03T20:15:00.000Z",
            "duration": "2204",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/182d8f69",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/182d8f69/af052ea6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 46,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1950",
            "index": 156,
            "title": "SOTA machine translation at Unbabel",
            "pub_date": "2022-12-13T19:45:00.000Z",
            "duration": "1826",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/3d390eaa",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/3d390eaa/dea900a7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 41,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1946",
            "index": 157,
            "title": "AI competitions & cloud resources",
            "pub_date": "2022-12-07T21:00:00.000Z",
            "duration": "2035",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/bb2174ee",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/bb2174ee/8e2a484b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 49,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1943",
            "index": 158,
            "title": "Copilot lawsuits & Galactica \"science\"",
            "pub_date": "2022-11-29T20:45:00.000Z",
            "duration": "2650",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "meta ai",
              "github copilot",
              "copilot"
            ],
            "page_url": "https://share.transistor.fm/s/305891d5",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/305891d5/44529a1b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 51,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1937",
            "index": 159,
            "title": "Protecting us with the Database of Evil",
            "pub_date": "2022-11-16T17:20:00.000Z",
            "duration": "2905",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://share.transistor.fm/s/8e2526bc",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/8e2526bc/0c3e149c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 56,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1930",
            "index": 160,
            "title": "Hybrid computing with quantum processors",
            "pub_date": "2022-11-08T21:00:00.000Z",
            "duration": "2617",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/bebc875e",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/bebc875e/606c872c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 36,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1925",
            "index": 161,
            "title": "The practicalities of releasing models",
            "pub_date": "2022-11-01T22:35:00.000Z",
            "duration": "2239",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/36181d91",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/36181d91/8ec3e7e9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 67,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1883",
            "index": 162,
            "title": "AI adoption in large, well-established companies",
            "pub_date": "2022-10-26T14:30:00.000Z",
            "duration": "1995",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/81e8d2c6",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/81e8d2c6/c6b9d091.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 24,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1878",
            "index": 163,
            "title": "Data for All",
            "pub_date": "2022-10-18T14:05:00.000Z",
            "duration": "2967",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/03f0ef99",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/03f0ef99/8921d7df.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 66,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1872",
            "index": 164,
            "title": "What's up, DocQuery?",
            "pub_date": "2022-10-12T15:00:00.000Z",
            "duration": "2537",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/d38492e4",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/d38492e4/4a5e69f1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 56,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1860",
            "index": 165,
            "title": "Production data labeling workflows",
            "pub_date": "2022-09-27T19:40:00.000Z",
            "duration": "1903",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/7af850a8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/7af850a8/3f7ceed7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 30,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1849",
            "index": 166,
            "title": "Evaluating models without test data",
            "pub_date": "2022-09-20T19:20:00.000Z",
            "duration": "2693",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/0c672de3",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/0c672de3/f45eec9e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 51,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1841",
            "index": 167,
            "title": "Stable Diffusion",
            "pub_date": "2022-09-13T22:20:00.000Z",
            "duration": "2653",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/e1f7a9a9",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e1f7a9a9/a4cd964e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 47,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1834",
            "index": 168,
            "title": "Licensing & automating creativity",
            "pub_date": "2022-09-06T21:45:00.000Z",
            "duration": "2662",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "automation"
            ],
            "page_url": "https://share.transistor.fm/s/26f3adb3",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/26f3adb3/20dc000b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 73,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1815",
            "index": 169,
            "title": "Privacy in the age of AI",
            "pub_date": "2022-08-30T19:20:00.000Z",
            "duration": "2581",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/893e6ec0",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/893e6ec0/96c5a159.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 38,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1814",
            "index": 170,
            "title": "Practical, positive uses for deep fakes",
            "pub_date": "2022-08-24T15:00:00.000Z",
            "duration": "2595",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/20701c82",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/20701c82/ef2671f8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 39,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1807",
            "index": 171,
            "title": "CMU's AI pilot lands in the news 🗞",
            "pub_date": "2022-08-16T21:45:00.000Z",
            "duration": "2486",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/661a4a9f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/661a4a9f/c151152e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 44,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1798",
            "index": 172,
            "title": "AlphaFold is revolutionizing biology",
            "pub_date": "2022-08-09T19:45:00.000Z",
            "duration": "2710",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind"
            ],
            "page_url": "https://share.transistor.fm/s/096a1573",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/096a1573/8b32eeba.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 52,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1792",
            "index": 173,
            "title": "AI IRL & Mozilla's Internet Health Report",
            "pub_date": "2022-08-02T20:30:00.000Z",
            "duration": "2564",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/9ecd8c10",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/9ecd8c10/c23200b3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 32,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1753",
            "index": 174,
            "title": "The geopolitics of artificial intelligence",
            "pub_date": "2022-07-26T20:00:00.000Z",
            "duration": "2771",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://share.transistor.fm/s/e61ba232",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e61ba232/145cbebe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 60,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1716",
            "index": 175,
            "title": "DALL-E is one giant leap for raccoons! 🔭",
            "pub_date": "2022-07-19T20:10:00.000Z",
            "duration": "2450",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://share.transistor.fm/s/e56ce463",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e56ce463/ddf58443.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 61,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1712",
            "index": 176,
            "title": "Cloning voices with Coqui",
            "pub_date": "2022-07-12T15:10:00.000Z",
            "duration": "3105",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/39ef8e3f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/39ef8e3f/ad3b0557.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 57,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1694",
            "index": 177,
            "title": "AI's role in reprogramming immunity",
            "pub_date": "2022-06-28T19:00:00.000Z",
            "duration": "2928",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/14a3c811",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/14a3c811/7d41f8a0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 42,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1684",
            "index": 178,
            "title": "Machine learning in your database",
            "pub_date": "2022-06-22T14:45:00.000Z",
            "duration": "2945",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/ca7e5e7e",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/ca7e5e7e/1d854e4d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 44,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1673",
            "index": 179,
            "title": "Digital humans & detecting emotions",
            "pub_date": "2022-06-14T18:45:00.000Z",
            "duration": "2530",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/c4c7ce53",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/c4c7ce53/718cb249.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 98,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1670",
            "index": 180,
            "title": "Generalist models & Iceman's voice",
            "pub_date": "2022-06-07T15:15:00.000Z",
            "duration": "2434",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "deepmind"
            ],
            "page_url": "https://share.transistor.fm/s/f311cad1",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/f311cad1/40afd2f9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 79,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1664",
            "index": 181,
            "title": "🤗 The AI community building the future",
            "pub_date": "2022-05-31T18:45:00.000Z",
            "duration": "2832",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://share.transistor.fm/s/306f6fbd",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/306f6fbd/6d29e7f6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 33,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1658",
            "index": 182,
            "title": "Active learning & endangered languages",
            "pub_date": "2022-05-17T16:45:00.000Z",
            "duration": "2950",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/1d61dc97",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/1d61dc97/8594df87.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 74,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1642",
            "index": 183,
            "title": "Learning the language of life",
            "pub_date": "2022-05-03T17:30:00.000Z",
            "duration": "2878",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://share.transistor.fm/s/b9ef03c1",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b9ef03c1/61debe83.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 56,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1640",
            "index": 184,
            "title": "MLOps is NOT Real",
            "pub_date": "2022-04-26T14:00:00.000Z",
            "duration": "2757",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/444b43ae",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/444b43ae/660aaafb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 51,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1638",
            "index": 185,
            "title": "🌍 AI in Africa - Agriculture",
            "pub_date": "2022-04-19T19:30:00.000Z",
            "duration": "3073",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/85f91f30",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/85f91f30/f73269df.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 34,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1623",
            "index": 186,
            "title": "Quick, beautiful web UIs for ML apps",
            "pub_date": "2022-04-05T15:30:00.000Z",
            "duration": "2529",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/b48cb33f",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/b48cb33f/5a198def.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 55,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1613",
            "index": 187,
            "title": "It's been a BIG week in AI news 🗞",
            "pub_date": "2022-03-29T21:00:00.000Z",
            "duration": "2477",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/50dfee77",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/50dfee77/9cb50ac3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 152,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1610",
            "index": 188,
            "title": "\"Foundation\" models",
            "pub_date": "2022-03-23T17:00:00.000Z",
            "duration": "2487",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/99ddb901",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/99ddb901/51b91c61.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 71,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1607",
            "index": 189,
            "title": "Clothing AI in a data fabric",
            "pub_date": "2022-03-16T13:40:00.000Z",
            "duration": "2768",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/54496c57",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/54496c57/f8f3ddd8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 77,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1604",
            "index": 190,
            "title": "Creating a culture of innovation",
            "pub_date": "2022-03-08T19:35:00.000Z",
            "duration": "3125",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/f6bcfbd5",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/f6bcfbd5/cd37dcdb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 37,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1598",
            "index": 191,
            "title": "Deploying models (to tractors 🚜)",
            "pub_date": "2022-03-01T19:50:00.000Z",
            "duration": "3056",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/dc874154",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/dc874154/ece864f3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 66,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1588",
            "index": 192,
            "title": "One algorithm to rule them all?",
            "pub_date": "2022-02-15T20:15:00.000Z",
            "duration": "2695",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "deepmind",
              "coding"
            ],
            "page_url": "https://share.transistor.fm/s/2bd0e363",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/2bd0e363/bcf07767.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 112,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1584",
            "index": 193,
            "title": "🌍 AI in Africa - Voice & language tools",
            "pub_date": "2022-02-09T16:15:00.000Z",
            "duration": "2617",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/e3b2b9e8",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/e3b2b9e8/5c1a8e65.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 27,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1568",
            "index": 194,
            "title": "Exploring deep reinforcement learning",
            "pub_date": "2022-02-01T20:00:00.000Z",
            "duration": "2482",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://share.transistor.fm/s/31fe69cf",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/31fe69cf/ce4a0657.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 45,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1564",
            "index": 195,
            "title": "The world needs an AI superhero",
            "pub_date": "2022-01-25T22:25:00.000Z",
            "duration": "2598",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "google ai"
            ],
            "page_url": "https://share.transistor.fm/s/0f11a2cd",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/0f11a2cd/2384258d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 59,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1560",
            "index": 196,
            "title": "Democratizing ML for speech",
            "pub_date": "2022-01-19T15:30:00.000Z",
            "duration": "2690",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://share.transistor.fm/s/0243f082",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/0243f082/ed9b4041.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 56,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1554",
            "index": 197,
            "title": "Eliminate AI failures",
            "pub_date": "2022-01-11T18:00:00.000Z",
            "duration": "2500",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://share.transistor.fm/s/259c38d4",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/259c38d4/bab54fdc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 41,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1552",
            "index": 198,
            "title": "🌍 AI in Africa - Radiant Earth",
            "pub_date": "2022-01-05T14:30:00.000Z",
            "duration": "2587",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://share.transistor.fm/s/cb62bd49",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/cb62bd49/d19ac8d7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 36,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1546",
            "index": 199,
            "title": "OpenAI and Hugging Face tooling",
            "pub_date": "2021-12-14T20:00:00.000Z",
            "duration": "3034",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai"
            ],
            "page_url": "https://share.transistor.fm/s/695b726b",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/695b726b/2dd048ae.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 88,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "changelog.com/7/1545",
            "index": 200,
            "title": "Friendly federated learning 🌼",
            "pub_date": "2021-12-07T16:15:00.000Z",
            "duration": "2795",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://share.transistor.fm/s/9cf347ca",
            "audio_url": "https://pscrb.fm/rss/p/dts.podtrac.com/redirect.mp3/media.transistor.fm/9cf347ca/baf3cc25.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_changelog_transcript",
              "transcript_record_count": 32,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          }
        ]
      },
      {
        "id": "lex-fridman",
        "title": "Lex Fridman Podcast",
        "feed_title": "Lex Fridman Podcast",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "AI researchers",
          "robotics",
          "AGI",
          "science"
        ],
        "feed_url": "https://lexfridman.com/feed/podcast/",
        "source_url": "https://lexfridman.com/feed/podcast/",
        "detail_path": "/podcasts/lex-fridman/",
        "episode_count": 400,
        "selected_episode_count": 187,
        "latest_episode_title": "#497 – Biggest Mysteries in Physics: Antimatter, Dark Energy & ToE – Don Lincoln",
        "latest_pub_date": "2026-05-29T16:22:02.000Z",
        "latest_page_url": "https://lexfridman.com/don-lincoln/?utm_source=rss&utm_medium=rss&utm_campaign=don-lincoln",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "https://lexfridman.com/?p=6457",
            "index": 1,
            "title": "#497 – Biggest Mysteries in Physics: Antimatter, Dark Energy & ToE – Don Lincoln",
            "pub_date": "2026-05-29T16:22:02.000Z",
            "duration": "3:01:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity"
            ],
            "page_url": "https://lexfridman.com/don-lincoln/?utm_source=rss&utm_medium=rss&utm_campaign=don-lincoln",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_don_lincoln.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6450",
            "index": 2,
            "title": "#496 – FFmpeg: The Incredible Technology Behind Video on the Internet",
            "pub_date": "2026-05-06T22:06:47.000Z",
            "duration": "4:23:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity"
            ],
            "page_url": "https://lexfridman.com/ffmpeg/?utm_source=rss&utm_medium=rss&utm_campaign=ffmpeg",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_ffmpeg.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 963,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6441",
            "index": 3,
            "title": "#495 – Vikings, Ragnar, Berserkers, Valhalla & the Warriors of the Viking Age",
            "pub_date": "2026-04-09T17:43:17.000Z",
            "duration": "2:09:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity"
            ],
            "page_url": "https://lexfridman.com/lars-brownworth/?utm_source=rss&utm_medium=rss&utm_campaign=lars-brownworth",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_lars_brownworth.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 449,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6434",
            "index": 4,
            "title": "#494 – Jensen Huang: NVIDIA – The $4 Trillion Company & the AI Revolution",
            "pub_date": "2026-03-23T16:28:42.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "perplexity",
              "nvidia"
            ],
            "page_url": "https://lexfridman.com/jensen-huang/?utm_source=rss&utm_medium=rss&utm_campaign=jensen-huang",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_jensen_huang.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 398,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6426",
            "index": 5,
            "title": "#493 – Jeff Kaplan: World of Warcraft, Overwatch, Blizzard, and Future of Gaming",
            "pub_date": "2026-03-11T20:37:33.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity"
            ],
            "page_url": "https://lexfridman.com/jeff-kaplan/?utm_source=rss&utm_medium=rss&utm_campaign=jeff-kaplan",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_jeff_kaplan.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6421",
            "index": 6,
            "title": "#492 – Rick Beato: Greatest Guitarists of All Time, History & Future of Music",
            "pub_date": "2026-03-01T04:33:22.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity",
              "training"
            ],
            "page_url": "https://lexfridman.com/rick-beato/?utm_source=rss&utm_medium=rss&utm_campaign=rick-beato",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_rick_beato.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 713,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6413",
            "index": 7,
            "title": "#491 – OpenClaw: The Viral AI Agent that Broke the Internet – Peter Steinberger",
            "pub_date": "2026-02-12T03:10:39.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "claude",
              "perplexity"
            ],
            "page_url": "https://lexfridman.com/peter-steinberger/?utm_source=rss&utm_medium=rss&utm_campaign=peter-steinberger",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_peter_steinberger.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 779,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 6,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6394",
            "index": 8,
            "title": "#490 – State of AI in 2026: LLMs, Coding, Scaling Laws, China, Agents, GPUs, AGI",
            "pub_date": "2026-02-01T02:46:43.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 30,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "large language model",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://lexfridman.com/ai-sota-2026/?utm_source=rss&utm_medium=rss&utm_campaign=ai-sota-2026",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_ai_sota_2026.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 624,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6384",
            "index": 9,
            "title": "#489 – Paul Rosolie: Uncontacted Tribes in the Amazon Jungle",
            "pub_date": "2026-01-13T20:15:15.000Z",
            "duration": "3:14:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity"
            ],
            "page_url": "https://lexfridman.com/paul-rosolie-3/?utm_source=rss&utm_medium=rss&utm_campaign=paul-rosolie-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_paul_rosolie_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 551,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 7,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6378",
            "index": 10,
            "title": "#488 – Infinity, Paradoxes that Broke Mathematics, Gödel Incompleteness & the Multiverse – Joel David Hamkins",
            "pub_date": "2025-12-31T21:24:33.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity"
            ],
            "page_url": "https://lexfridman.com/joel-david-hamkins/?utm_source=rss&utm_medium=rss&utm_campaign=joel-david-hamkins",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_joel_david_hamkins.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 602,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6369",
            "index": 11,
            "title": "#487 – Irving Finkel: Deciphering Secrets of Ancient Civilizations & Flood Myths",
            "pub_date": "2025-12-12T20:04:16.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/irving-finkel/?utm_source=rss&utm_medium=rss&utm_campaign=irving-finkel",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_irving_finkel.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6361",
            "index": 12,
            "title": "#486 – Michael Levin: Hidden Reality of Alien Intelligence & Biological Life",
            "pub_date": "2025-11-30T19:40:53.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://lexfridman.com/michael-levin-2/?utm_source=rss&utm_medium=rss&utm_campaign=michael-levin-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_michael_levin_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 481,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6354",
            "index": 13,
            "title": "#485 – David Kirtley: Nuclear Fusion, Plasma Physics, and the Future of Energy",
            "pub_date": "2025-11-17T18:55:13.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "gpu"
            ],
            "page_url": "https://lexfridman.com/david-kirtley/?utm_source=rss&utm_medium=rss&utm_campaign=david-kirtley",
            "audio_url": "https://media.blubrry.com/takeituneasy/ins.blubrry.com/takeituneasy/lex_ai_david_kirtley.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 357,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6348",
            "index": 14,
            "title": "#484 – Dan Houser: GTA, Red Dead Redemption, Rockstar, Absurd & Future of Gaming",
            "pub_date": "2025-10-31T20:53:37.000Z",
            "duration": "2:54:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://lexfridman.com/dan-houser/?utm_source=rss&utm_medium=rss&utm_campaign=dan-houser",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dan_houser.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 670,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 6,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6338",
            "index": 15,
            "title": "#483 – Julia Shaw: Criminal Psychology of Murder, Serial Killers, Memory & Sex",
            "pub_date": "2025-10-14T17:32:37.000Z",
            "duration": "2:48:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/julia-shaw/?utm_source=rss&utm_medium=rss&utm_campaign=julia-shaw",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_julia_shaw.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6328",
            "index": 16,
            "title": "#482 – Pavel Durov: Telegram, Freedom, Censorship, Money, Power & Human Nature",
            "pub_date": "2025-10-01T01:40:10.000Z",
            "duration": "4:42:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://lexfridman.com/pavel-durov/?utm_source=rss&utm_medium=rss&utm_campaign=pavel-durov",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_pavel_durov.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 420,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 7,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6320",
            "index": 17,
            "title": "#481 – Norman Ohler: Hitler, Nazis, Drugs, WW2, Blitzkrieg, LSD, MKUltra & CIA",
            "pub_date": "2025-09-19T18:34:47.000Z",
            "duration": "4:31:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://lexfridman.com/norman-ohler/?utm_source=rss&utm_medium=rss&utm_campaign=norman-ohler",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_norman_ohler.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 817,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6312",
            "index": 18,
            "title": "#480 – Dave Hone: T-Rex, Dinosaurs, Extinction, Evolution, and Jurassic Park",
            "pub_date": "2025-09-04T20:57:38.000Z",
            "duration": "3:41:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://lexfridman.com/dave-hone/?utm_source=rss&utm_medium=rss&utm_campaign=dave-hone",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dave_hone.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 825,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6305",
            "index": 19,
            "title": "#479 – Dave Plummer: Programming, Autism, and Old-School Microsoft Stories",
            "pub_date": "2025-08-29T23:59:06.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://lexfridman.com/dave-plummer/?utm_source=rss&utm_medium=rss&utm_campaign=dave-plummer",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dave_plummer.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6299",
            "index": 20,
            "title": "#478 – Scott Horton: The Case Against War and the Military Industrial Complex",
            "pub_date": "2025-08-24T01:25:12.000Z",
            "duration": "10:35:13",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/scott-horton/?utm_source=rss&utm_medium=rss&utm_campaign=scott-horton",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_scott_horton.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6278",
            "index": 21,
            "title": "#477 – Keyu Jin: China’s Economy, Tariffs, Trade, Trump, Communism & Capitalism",
            "pub_date": "2025-08-13T21:29:29.000Z",
            "duration": "1:57:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chips"
            ],
            "page_url": "https://lexfridman.com/keyu-jin/?utm_source=rss&utm_medium=rss&utm_campaign=keyu-jin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_keyu_jin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 219,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6271",
            "index": 22,
            "title": "#476 – Jack Weatherford: Genghis Khan and the Mongol Empire",
            "pub_date": "2025-08-01T01:36:22.000Z",
            "duration": "4:39:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://lexfridman.com/jack-weatherford/?utm_source=rss&utm_medium=rss&utm_campaign=jack-weatherford",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jack_weatherford.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 628,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6265",
            "index": 23,
            "title": "#475 – Demis Hassabis: Future of AI, Simulating Reality, Physics and Video Games",
            "pub_date": "2025-07-23T19:34:16.000Z",
            "duration": "2:34:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "deepmind",
              "gemini"
            ],
            "page_url": "https://lexfridman.com/demis-hassabis-2/?utm_source=rss&utm_medium=rss&utm_campaign=demis-hassabis-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_demis_hassabis_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 371,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 6,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6259",
            "index": 24,
            "title": "#474 – DHH: Future of Programming, AI, Ruby on Rails, Productivity & Parenting",
            "pub_date": "2025-07-12T17:16:31.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "coding"
            ],
            "page_url": "https://lexfridman.com/dhh-david-heinemeier-hansson/?utm_source=rss&utm_medium=rss&utm_campaign=dhh-david-heinemeier-hansson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dhh_david_heinemeier_hansson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 870,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6253",
            "index": 25,
            "title": "#473 – Iran War Debate: Nuclear Weapons, Trump, Peace, Power & the Middle East",
            "pub_date": "2025-06-26T23:28:10.000Z",
            "duration": "4:11:08",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/iran-war-debate/?utm_source=rss&utm_medium=rss&utm_campaign=iran-war-debate",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_iran_israel_debate.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6249",
            "index": 26,
            "title": "#472 – Terence Tao: Hardest Problems in Mathematics, Physics & the Future of AI",
            "pub_date": "2025-06-15T00:25:41.000Z",
            "duration": "3:23:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind"
            ],
            "page_url": "https://lexfridman.com/terence-tao/?utm_source=rss&utm_medium=rss&utm_campaign=terence-tao",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_terence_tao.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 508,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 10,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6244",
            "index": 27,
            "title": "#471 – Sundar Pichai: CEO of Google and Alphabet",
            "pub_date": "2025-06-05T17:53:32.000Z",
            "duration": "2:17:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "gemini"
            ],
            "page_url": "https://lexfridman.com/sundar-pichai/?utm_source=rss&utm_medium=rss&utm_campaign=sundar-pichai",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sundar_pichai.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 377,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6237",
            "index": 28,
            "title": "#470 – James Holland: World War II, Hitler, Churchill, Stalin & Biggest Battles",
            "pub_date": "2025-05-24T23:11:49.000Z",
            "duration": "3:30:56",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/james-holland/?utm_source=rss&utm_medium=rss&utm_campaign=james-holland",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_james_holland.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6234",
            "index": 29,
            "title": "#469 – Oliver Anthony: Country Music, Blue-Collar America, Fame, Money, and Pain",
            "pub_date": "2025-05-20T15:20:42.000Z",
            "duration": "2:27:02",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/oliver-anthony/?utm_source=rss&utm_medium=rss&utm_campaign=oliver-anthony",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_oliver_anthony.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6228",
            "index": 30,
            "title": "#468 – Janna Levin: Black Holes, Wormholes, Aliens, Paradoxes & Extra Dimensions",
            "pub_date": "2025-05-05T23:03:38.000Z",
            "duration": "3:07:16",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/janna-levin/?utm_source=rss&utm_medium=rss&utm_campaign=janna-levin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_janna_levin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6220",
            "index": 31,
            "title": "#467 – Tim Sweeney: Fortnite, Unreal Engine, and the Future of Gaming",
            "pub_date": "2025-04-30T21:53:41.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tim-sweeney/?utm_source=rss&utm_medium=rss&utm_campaign=tim-sweeney",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tim_sweeney.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6217",
            "index": 32,
            "title": "#466 – Jeffrey Wasserstrom: China, Xi Jinping, Trade War, Taiwan, Hong Kong, Mao",
            "pub_date": "2025-04-24T23:14:06.000Z",
            "duration": "3:14:21",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jeffrey-wasserstrom/?utm_source=rss&utm_medium=rss&utm_campaign=jeffrey-wasserstrom",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jeffrey_wasserstrom.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6211",
            "index": 33,
            "title": "#465 – Robert Rodriguez: Sin City, Desperado, El Mariachi, Alita, and Filmmaking",
            "pub_date": "2025-04-17T17:51:39.000Z",
            "duration": "3:35:08",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/robert-rodriguez/?utm_source=rss&utm_medium=rss&utm_campaign=robert-rodriguez",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_robert_rodriguez.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 730,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6204",
            "index": 34,
            "title": "#464 – Dave Smith: Israel, Ukraine, Epstein, Mossad, Conspiracies & Antisemitism",
            "pub_date": "2025-04-09T02:02:56.000Z",
            "duration": "3:26:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/dave-smith/?utm_source=rss&utm_medium=rss&utm_campaign=dave-smith",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dave_smith.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6195",
            "index": 35,
            "title": "#463 – Douglas Murray: Putin, Zelenskyy, Trump, Israel, Netanyahu, Hamas & Gaza",
            "pub_date": "2025-03-30T21:07:22.000Z",
            "duration": "3:16:06",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/douglas-murray-2/?utm_source=rss&utm_medium=rss&utm_campaign=douglas-murray-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_douglas_murray_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6192",
            "index": 36,
            "title": "#462 – Ezra Klein and Derek Thompson: Politics, Trump, AOC, Elon & DOGE",
            "pub_date": "2025-03-26T08:59:23.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ezra-klein-and-derek-thompson/?utm_source=rss&utm_medium=rss&utm_campaign=ezra-klein-and-derek-thompson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ezra_klein_and_derek_thompson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6184",
            "index": 37,
            "title": "#461 – ThePrimeagen: Programming, AI, ADHD, Productivity, Addiction, and God",
            "pub_date": "2025-03-22T19:58:22.000Z",
            "duration": "5:30:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/theprimeagen/?utm_source=rss&utm_medium=rss&utm_campaign=theprimeagen",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_theprimeagen.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6181",
            "index": 38,
            "title": "#460 – Narendra Modi: Prime Minister of India – Power, Democracy, War & Peace",
            "pub_date": "2025-03-16T13:21:05.000Z",
            "duration": "3:25:53",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/narendra-modi/?utm_source=rss&utm_medium=rss&utm_campaign=narendra-modi",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_narendra_modi.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 272,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 7,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6155",
            "index": 39,
            "title": "#459 – DeepSeek, China, OpenAI, NVIDIA, xAI, TSMC, Stargate, and AI Megaclusters",
            "pub_date": "2025-02-03T03:37:42.000Z",
            "duration": "5:16:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "openai",
              "xai",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://lexfridman.com/deepseek-dylan-patel-nathan-lambert/?utm_source=rss&utm_medium=rss&utm_campaign=deepseek-dylan-patel-nathan-lambert",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_deepseek_dylan_patel_nathan_lambert.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 1014,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 8,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6148",
            "index": 40,
            "title": "#458 – Marc Andreessen: Trump, Power, Tech, AI, Immigration & Future of America",
            "pub_date": "2025-01-26T20:50:35.000Z",
            "duration": "3:57:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "copilot"
            ],
            "page_url": "https://lexfridman.com/marc-andreessen-2/?utm_source=rss&utm_medium=rss&utm_campaign=marc-andreessen-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_marc_andreessen_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 595,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 10,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6138",
            "index": 41,
            "title": "#457 – Jennifer Burns: Milton Friedman, Ayn Rand, Economics, Capitalism, Freedom",
            "pub_date": "2025-01-19T19:56:15.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "copilot"
            ],
            "page_url": "https://lexfridman.com/jennifer-burns/?utm_source=rss&utm_medium=rss&utm_campaign=jennifer-burns",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jennifer_burns.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 459,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6105",
            "index": 42,
            "title": "#456 – Volodymyr Zelenskyy: Ukraine, War, Peace, Putin, Trump, NATO, and Freedom",
            "pub_date": "2025-01-06T00:12:14.000Z",
            "duration": "3:13:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "copilot"
            ],
            "page_url": "https://lexfridman.com/volodymyr-zelenskyy/?utm_source=rss&utm_medium=rss&utm_campaign=volodymyr-zelenskyy",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_volodymyr_zelenskyy.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 438,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 13,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6099",
            "index": 43,
            "title": "#455 – Adam Frank: Alien Civilizations and the Search for Extraterrestrial Life",
            "pub_date": "2024-12-22T22:36:20.000Z",
            "duration": "3:39:11",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/adam-frank/?utm_source=rss&utm_medium=rss&utm_campaign=adam-frank",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_adam_frank.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 655,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 10,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6093",
            "index": 44,
            "title": "#454 – Saagar Enjeti: Trump, MAGA, DOGE, Obama, FDR, JFK, History & Politics",
            "pub_date": "2024-12-08T16:39:43.000Z",
            "duration": "3:39:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/saagar-enjeti-2/?utm_source=rss&utm_medium=rss&utm_campaign=saagar-enjeti-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_saagar_enjeti_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6084",
            "index": 45,
            "title": "#453 – Javier Milei: President of Argentina – Freedom, Economics, and Corruption",
            "pub_date": "2024-11-20T16:07:42.000Z",
            "duration": "2:08:34",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/javier-milei/?utm_source=rss&utm_medium=rss&utm_campaign=javier-milei",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_javier_milei.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6077",
            "index": 46,
            "title": "#452 – Dario Amodei: Anthropic CEO on Claude, AGI & the Future of AI & Humanity",
            "pub_date": "2024-11-11T19:53:30.000Z",
            "duration": "5:22:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "openai",
              "anthropic",
              "claude",
              "xai"
            ],
            "page_url": "https://lexfridman.com/dario-amodei/?utm_source=rss&utm_medium=rss&utm_campaign=dario-amodei",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dario_amodei.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 781,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 8,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6070",
            "index": 47,
            "title": "#451 – Rick Spence: CIA, KGB, Illuminati, Secret Societies, Cults & Conspiracies",
            "pub_date": "2024-10-30T21:30:55.000Z",
            "duration": "3:36:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/rick-spence/?utm_source=rss&utm_medium=rss&utm_campaign=rick-spence",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_rick_spence.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6062",
            "index": 48,
            "title": "#450 – Bernie Sanders Interview",
            "pub_date": "2024-10-23T20:30:41.000Z",
            "duration": "1:09:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/bernie-sanders/?utm_source=rss&utm_medium=rss&utm_campaign=bernie-sanders",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bernie_sanders.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6054",
            "index": 49,
            "title": "#449 – Graham Hancock: Lost Civilization of the Ice Age & Ancient Human History",
            "pub_date": "2024-10-16T17:39:58.000Z",
            "duration": "2:41:34",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/graham-hancock/?utm_source=rss&utm_medium=rss&utm_campaign=graham-hancock",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_graham_hancock.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6046",
            "index": 50,
            "title": "#448 – Jordan Peterson: Nietzsche, Hitler, God, Psychopathy, Suffering & Meaning",
            "pub_date": "2024-10-11T18:25:36.000Z",
            "duration": "2:30:11",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jordan-peterson-2/?utm_source=rss&utm_medium=rss&utm_campaign=jordan-peterson-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jordan_peterson_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6042",
            "index": 51,
            "title": "#447 – Cursor Team: Future of Programming with AI",
            "pub_date": "2024-10-06T18:47:46.000Z",
            "duration": "2:37:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "claude",
              "cursor",
              "github copilot",
              "copilot"
            ],
            "page_url": "https://lexfridman.com/cursor-team/?utm_source=rss&utm_medium=rss&utm_campaign=cursor-team",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_cursor_team.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 460,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=6035",
            "index": 52,
            "title": "#446 – Ed Barnhart: Maya, Aztec, Inca, and Lost Civilizations of South America",
            "pub_date": "2024-09-30T17:59:36.000Z",
            "duration": "3:36:19",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ed-barnhart/?utm_source=rss&utm_medium=rss&utm_campaign=ed-barnhart",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ed_barnhart.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6027",
            "index": 53,
            "title": "#445 – Vivek Ramaswamy: Trump, Conservatism, Nationalism, Immigration, and War",
            "pub_date": "2024-09-25T21:17:23.000Z",
            "duration": "2:51:22",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/vivek-ramaswamy/?utm_source=rss&utm_medium=rss&utm_campaign=vivek-ramaswamy",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_vivek_ramaswamy.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6018",
            "index": 54,
            "title": "#444 – Vejas Liulevicius: Communism, Marxism, Nazism, Stalin, Mao, and Hitler",
            "pub_date": "2024-09-20T22:02:44.000Z",
            "duration": "3:37:43",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/vejas-liulevicius/?utm_source=rss&utm_medium=rss&utm_campaign=vejas-liulevicius",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_vejas_liulevicius.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6014",
            "index": 55,
            "title": "#443 – Gregory Aldrete: The Roman Empire – Rise and Fall of Ancient Rome",
            "pub_date": "2024-09-12T22:57:47.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/gregory-aldrete/?utm_source=rss&utm_medium=rss&utm_campaign=gregory-aldrete",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_gregory_aldrete.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=6007",
            "index": 56,
            "title": "#442 – Donald Trump Interview",
            "pub_date": "2024-09-03T16:24:11.000Z",
            "duration": "1:12:35",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/donald-trump/?utm_source=rss&utm_medium=rss&utm_campaign=donald-trump",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_donald_trump.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 158,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5998",
            "index": 57,
            "title": "#441 – Cenk Uygur: Trump vs Harris, Progressive Politics, Communism & Capitalism",
            "pub_date": "2024-08-30T23:49:16.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/cenk-uygur/?utm_source=rss&utm_medium=rss&utm_campaign=cenk-uygur",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_cenk_uygur.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5990",
            "index": 58,
            "title": "#440 – Pieter Levels: Programming, Viral AI Startups, and Digital Nomad Life",
            "pub_date": "2024-08-20T20:22:09.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "automation",
              "coding"
            ],
            "page_url": "https://lexfridman.com/pieter-levels/?utm_source=rss&utm_medium=rss&utm_campaign=pieter-levels",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_pieter_levels.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 1380,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 10,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5979",
            "index": 59,
            "title": "#439 – Craig Jones: Jiu Jitsu, $2 Million Prize, CJI, ADCC, Ukraine & Trolling",
            "pub_date": "2024-08-14T19:58:00.000Z",
            "duration": "2:21:29",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/craig-jones-2/?utm_source=rss&utm_medium=rss&utm_campaign=craig-jones-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_craig_jones_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 576,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5968",
            "index": 60,
            "title": "#438 – Elon Musk: Neuralink and the Future of Humanity",
            "pub_date": "2024-08-02T19:19:20.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "safety"
            ],
            "page_url": "https://lexfridman.com/elon-musk-and-neuralink-team/?utm_source=rss&utm_medium=rss&utm_campaign=elon-musk-and-neuralink-team",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_elon_musk_and_neuralink_team.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 1772,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 11,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5953",
            "index": 61,
            "title": "#437 – Jordan Jonas: Survival, Hunting, Siberia, God, and Winning Alone Season 6",
            "pub_date": "2024-07-21T23:43:00.000Z",
            "duration": "2:56:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jordan-jonas/?utm_source=rss&utm_medium=rss&utm_campaign=jordan-jonas",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jordan_jonas.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5947",
            "index": 62,
            "title": "#436 – Ivanka Trump: Politics, Family, Real Estate, Fashion, Music, and Life",
            "pub_date": "2024-07-02T23:04:59.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ivanka-trump/?utm_source=rss&utm_medium=rss&utm_campaign=ivanka-trump",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ivanka_trump.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5941",
            "index": 63,
            "title": "#435 – Andrew Huberman: Focus, Controversy, Politics, and Relationships",
            "pub_date": "2024-06-28T00:07:39.000Z",
            "duration": "1:57:00",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/andrew-huberman-5/?utm_source=rss&utm_medium=rss&utm_campaign=andrew-huberman-5",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrew_huberman_5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5934",
            "index": 64,
            "title": "#434 – Aravind Srinivas: Perplexity CEO on Future of AI, Search & the Internet",
            "pub_date": "2024-06-19T21:27:17.000Z",
            "duration": "3:11:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity",
              "rag"
            ],
            "page_url": "https://lexfridman.com/aravind-srinivas/?utm_source=rss&utm_medium=rss&utm_campaign=aravind-srinivas",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_aravind_srinivas.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 614,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5927",
            "index": 65,
            "title": "#433 – Sara Walker: Physics of Life, Time, Complexity, and Aliens",
            "pub_date": "2024-06-13T21:50:25.000Z",
            "duration": "3:01:39",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/sara-walker-3/?utm_source=rss&utm_medium=rss&utm_campaign=sara-walker-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sara_walker_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 715,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5918",
            "index": 66,
            "title": "#432 – Kevin Spacey: Power, Controversy, Betrayal, Truth & Love in Film and Life",
            "pub_date": "2024-06-05T23:50:39.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/kevin-spacey/?utm_source=rss&utm_medium=rss&utm_campaign=kevin-spacey",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_kevin_spacey.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5913",
            "index": 67,
            "title": "#431 – Roman Yampolskiy: Dangers of Superintelligent AI",
            "pub_date": "2024-06-02T21:18:34.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "safety"
            ],
            "page_url": "https://lexfridman.com/roman-yampolskiy/?utm_source=rss&utm_medium=rss&utm_campaign=roman-yampolskiy",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_roman_yampolskiy.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 421,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5901",
            "index": 68,
            "title": "#430 – Charan Ranganath: Human Memory, Imagination, Deja Vu, and False Memories",
            "pub_date": "2024-05-25T20:52:50.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://lexfridman.com/charan-ranganath/?utm_source=rss&utm_medium=rss&utm_campaign=charan-ranganath",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_charan_ranganath.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 429,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5891",
            "index": 69,
            "title": "#429 – Paul Rosolie: Jungle, Apex Predators, Aliens, Uncontacted Tribes, and God",
            "pub_date": "2024-05-15T23:30:39.000Z",
            "duration": "4:12:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/paul-rosolie-2/?utm_source=rss&utm_medium=rss&utm_campaign=paul-rosolie-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_paul_rosolie_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5880",
            "index": 70,
            "title": "#428 – Sean Carroll: General Relativity, Quantum Mechanics, Black Holes & Aliens",
            "pub_date": "2024-04-22T19:25:24.000Z",
            "duration": "2:44:40",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://lexfridman.com/sean-carroll-3/?utm_source=rss&utm_medium=rss&utm_campaign=sean-carroll-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sean_carroll_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 555,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 8,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5877",
            "index": 71,
            "title": "#427 – Neil Adams: Judo, Olympics, Winning, Losing, and the Champion Mindset",
            "pub_date": "2024-04-20T21:59:31.000Z",
            "duration": "2:35:25",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/neil-adams/?utm_source=rss&utm_medium=rss&utm_campaign=neil-adams",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_neil_adams.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 561,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5874",
            "index": 72,
            "title": "#426 – Edward Gibson: Human Language, Psycholinguistics, Syntax, Grammar & LLMs",
            "pub_date": "2024-04-17T20:05:39.000Z",
            "duration": "3:00:32",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "embedding"
            ],
            "page_url": "https://lexfridman.com/edward-gibson/?utm_source=rss&utm_medium=rss&utm_campaign=edward-gibson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_edward_gibson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 656,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5868",
            "index": 73,
            "title": "#425 – Andrew Callaghan: Channel 5, Gonzo, QAnon, O-Block, Politics & Alex Jones",
            "pub_date": "2024-04-13T17:48:56.000Z",
            "duration": "2:59:43",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/andrew-callaghan/?utm_source=rss&utm_medium=rss&utm_campaign=andrew-callaghan",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrew_callaghan.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5860",
            "index": 74,
            "title": "#424 – Bassem Youssef: Israel-Palestine, Gaza, Hamas, Middle East, Satire & Fame",
            "pub_date": "2024-04-05T20:39:42.000Z",
            "duration": "2:48:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/bassem-youssef/?utm_source=rss&utm_medium=rss&utm_campaign=bassem-youssef",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bassem_youssef.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5855",
            "index": 75,
            "title": "#423 – Tulsi Gabbard: War, Politics, and the Military Industrial Complex",
            "pub_date": "2024-04-02T18:23:31.000Z",
            "duration": "1:56:56",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tulsi-gabbard/?utm_source=rss&utm_medium=rss&utm_campaign=tulsi-gabbard",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tulsi_gabbard.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5850",
            "index": 76,
            "title": "#422 – Mark Cuban: Shark Tank, DEI & Wokeism Debate, Elon Musk, Politics & Drugs",
            "pub_date": "2024-03-29T20:59:49.000Z",
            "duration": "2:23:38",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/mark-cuban/?utm_source=rss&utm_medium=rss&utm_campaign=mark-cuban",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_mark_cuban.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 522,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 10,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5844",
            "index": 77,
            "title": "#421 – Dana White: UFC, Fighting, Khabib, Conor, Tyson, Ali, Rogan, Elon & Zuck",
            "pub_date": "2024-03-25T15:34:42.000Z",
            "duration": "1:36:03",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/dana-white/?utm_source=rss&utm_medium=rss&utm_campaign=dana-white",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dana_white.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5838",
            "index": 78,
            "title": "#420 – Annie Jacobsen: Nuclear War, CIA, KGB, Aliens, Area 51, Roswell & Secrecy",
            "pub_date": "2024-03-22T20:55:05.000Z",
            "duration": "3:12:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/annie-jacobsen/?utm_source=rss&utm_medium=rss&utm_campaign=annie-jacobsen",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_annie_jacobsen.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5834",
            "index": 79,
            "title": "#419 – Sam Altman: OpenAI, GPT-5, Sora, Board Saga, Elon Musk, Ilya, Power & AGI",
            "pub_date": "2024-03-18T15:04:35.000Z",
            "duration": "2:02:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://lexfridman.com/sam-altman-2/?utm_source=rss&utm_medium=rss&utm_campaign=sam-altman-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sam_altman_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 499,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 6,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5829",
            "index": 80,
            "title": "#418 – Israel-Palestine Debate: Finkelstein, Destiny, M. Rabbani & Benny Morris",
            "pub_date": "2024-03-14T14:59:21.000Z",
            "duration": "5:04:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/israel-palestine-debate/?utm_source=rss&utm_medium=rss&utm_campaign=israel-palestine-debate",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_israel_palestine_debate.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5823",
            "index": 81,
            "title": "#417 – Kimbal Musk: The Art of Cooking, Tesla, SpaceX, Zip2, and Family",
            "pub_date": "2024-03-10T21:14:39.000Z",
            "duration": "1:53:04",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/kimbal-musk/?utm_source=rss&utm_medium=rss&utm_campaign=kimbal-musk",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_kimbal_musk.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5817",
            "index": 82,
            "title": "#416 – Yann Lecun: Meta AI, Open Source, Limits of LLMs, AGI & the Future of AI",
            "pub_date": "2024-03-07T21:58:59.000Z",
            "duration": "2:54:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llama",
              "meta ai",
              "reasoning",
              "embedding"
            ],
            "page_url": "https://lexfridman.com/yann-lecun-3/?utm_source=rss&utm_medium=rss&utm_campaign=yann-lecun-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_yann_lecun_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 394,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 6,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5809",
            "index": 83,
            "title": "#415 – Serhii Plokhy: History of Ukraine, Russia, Soviet Union, KGB, Nazis & War",
            "pub_date": "2024-03-04T20:02:09.000Z",
            "duration": "3:27:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/serhii-plokhy/?utm_source=rss&utm_medium=rss&utm_campaign=serhii-plokhy",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_serhii_plokhy.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5802",
            "index": 84,
            "title": "#414 – Tucker Carlson: Putin, Navalny, Trump, CIA, NSA, War, Politics & Freedom",
            "pub_date": "2024-02-27T16:36:05.000Z",
            "duration": "3:12:35",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tucker-carlson/?utm_source=rss&utm_medium=rss&utm_campaign=tucker-carlson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tucker_carlson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5794",
            "index": 85,
            "title": "#413 – Bill Ackman: Investing, Financial Battles, Harvard, DEI, X & Free Speech",
            "pub_date": "2024-02-20T19:19:43.000Z",
            "duration": "3:41:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://lexfridman.com/bill-ackman/?utm_source=rss&utm_medium=rss&utm_campaign=bill-ackman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bill_ackman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 541,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 9,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5773",
            "index": 86,
            "title": "#412 – Marc Raibert: Boston Dynamics and the Future of Robotics",
            "pub_date": "2024-02-16T18:49:37.000Z",
            "duration": "1:52:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/marc-raibert/?utm_source=rss&utm_medium=rss&utm_campaign=marc-raibert",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_marc_raibert.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 385,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5766",
            "index": 87,
            "title": "#411 – Omar Suleiman: Palestine, Gaza, Oct 7, Israel, Resistance, Faith & Islam",
            "pub_date": "2024-02-02T00:04:50.000Z",
            "duration": "2:31:08",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/omar-suleiman-2/?utm_source=rss&utm_medium=rss&utm_campaign=omar-suleiman-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_omar_suleiman_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5756",
            "index": 88,
            "title": "#410 – Ben Shapiro vs Destiny Debate: Politics, Jan 6, Israel, Ukraine & Wokeism",
            "pub_date": "2024-01-23T17:06:47.000Z",
            "duration": "2:25:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ben-shapiro-destiny-debate/?utm_source=rss&utm_medium=rss&utm_campaign=ben-shapiro-destiny-debate",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ben_shapiro_destiny_debate.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5743",
            "index": 89,
            "title": "#409 – Matthew Cox: FBI Most Wanted Con Man – $55 Million in Bank Fraud",
            "pub_date": "2024-01-17T16:51:44.000Z",
            "duration": "6:07:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/matthew-cox/?utm_source=rss&utm_medium=rss&utm_campaign=matthew-cox",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_matthew_cox.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5736",
            "index": 90,
            "title": "#408 – Tal Wilkenfeld: Music, Guitar, Bass, Jeff Beck, Prince, and Leonard Cohen",
            "pub_date": "2024-01-09T22:35:21.000Z",
            "duration": "1:55:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tal-wilkenfeld/?utm_source=rss&utm_medium=rss&utm_campaign=tal-wilkenfeld",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tal_wilkenfeld.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5728",
            "index": 91,
            "title": "#407 – Guillaume Verdon: Beff Jezos, E/acc Movement, Physics, Computation & AGI",
            "pub_date": "2023-12-29T21:03:57.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://lexfridman.com/guillaume-verdon/?utm_source=rss&utm_medium=rss&utm_campaign=guillaume-verdon",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_guillaume_verdon.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 347,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5723",
            "index": 92,
            "title": "#406 – Teddy Atlas: Mike Tyson, Cus D’Amato, Boxing, Loyalty, Fear & Greatness",
            "pub_date": "2023-12-24T21:27:55.000Z",
            "duration": "2:15:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/teddy-atlas/?utm_source=rss&utm_medium=rss&utm_campaign=teddy-atlas",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_teddy_atlas.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5715",
            "index": 93,
            "title": "#405 – Jeff Bezos: Amazon and Blue Origin",
            "pub_date": "2023-12-14T18:57:48.000Z",
            "duration": "2:20:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jeff-bezos/?utm_source=rss&utm_medium=rss&utm_campaign=jeff-bezos",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jeff_bezos.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5707",
            "index": 94,
            "title": "#404 – Lee Cronin: Controversial Nature Paper on Evolution of Life and Universe",
            "pub_date": "2023-12-09T21:21:58.000Z",
            "duration": "3:27:50",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://lexfridman.com/lee-cronin-3/?utm_source=rss&utm_medium=rss&utm_campaign=lee-cronin-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_lee_cronin_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 776,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 9,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5700",
            "index": 95,
            "title": "#403 – Lisa Randall: Dark Matter, Theoretical Physics, and Extinction Events",
            "pub_date": "2023-12-03T17:37:26.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/lisa-randall/?utm_source=rss&utm_medium=rss&utm_campaign=lisa-randall",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_lisa_randall.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5691",
            "index": 96,
            "title": "#402 – Michael Malice: Thanksgiving Pirate Special",
            "pub_date": "2023-11-25T21:11:31.000Z",
            "duration": "1:47:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-malice-7/?utm_source=rss&utm_medium=rss&utm_campaign=michael-malice-7",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_malice_7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5683",
            "index": 97,
            "title": "#401 – John Mearsheimer: Israel-Palestine, Russia-Ukraine, China, NATO, and WW3",
            "pub_date": "2023-11-18T14:05:32.000Z",
            "duration": "3:35:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/john-mearsheimer/?utm_source=rss&utm_medium=rss&utm_campaign=john-mearsheimer",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_john_mearsheimer.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5674",
            "index": 98,
            "title": "#400 – Elon Musk: War, AI, Aliens, Politics, Physics, Video Games, and Humanity",
            "pub_date": "2023-11-09T19:03:46.000Z",
            "duration": "2:27:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "grok"
            ],
            "page_url": "https://lexfridman.com/elon-musk-4/?utm_source=rss&utm_medium=rss&utm_campaign=elon-musk-4",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_elon_musk_4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 549,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5666",
            "index": 99,
            "title": "#399 – Jared Kushner: Israel, Palestine, Hamas, Gaza, Iran, and the Middle East",
            "pub_date": "2023-10-11T20:21:10.000Z",
            "duration": "3:54:15",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jared-kushner/?utm_source=rss&utm_medium=rss&utm_campaign=jared-kushner",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jared_kushner.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5661",
            "index": 100,
            "title": "#398 – Mark Zuckerberg: First Interview in the Metaverse",
            "pub_date": "2023-09-28T21:15:22.000Z",
            "duration": "1:12:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai"
            ],
            "page_url": "https://lexfridman.com/mark-zuckerberg-3/?utm_source=rss&utm_medium=rss&utm_campaign=mark-zuckerberg-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_mark_zuckerberg_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 5,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5654",
            "index": 101,
            "title": "#397 – Greg Lukianoff: Cancel Culture, Deplatforming, Censorship & Free Speech",
            "pub_date": "2023-09-25T01:12:01.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/greg-lukianoff/?utm_source=rss&utm_medium=rss&utm_campaign=greg-lukianoff",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_greg_lukianoff.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5647",
            "index": 102,
            "title": "#396 – James Sexton: Divorce Lawyer on Marriage, Relationships, Sex, Lies & Love",
            "pub_date": "2023-09-18T01:07:29.000Z",
            "duration": "3:51:11",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/james-sexton/?utm_source=rss&utm_medium=rss&utm_campaign=james-sexton",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_james_sexton.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5641",
            "index": 103,
            "title": "#395 – Walter Isaacson: Elon Musk, Steve Jobs, Einstein, Da Vinci & Ben Franklin",
            "pub_date": "2023-09-10T20:21:44.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/walter-isaacson/?utm_source=rss&utm_medium=rss&utm_campaign=walter-isaacson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_walter_isaacson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5633",
            "index": 104,
            "title": "#394 – Neri Oxman: Biology, Art, and Science of Design & Engineering with Nature",
            "pub_date": "2023-09-01T19:10:20.000Z",
            "duration": "2:25:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/neri-oxman/?utm_source=rss&utm_medium=rss&utm_campaign=neri-oxman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_neri_oxman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5626",
            "index": 105,
            "title": "#393 – Andrew Huberman: Relationships, Drama, Betrayal, Sex, and Love",
            "pub_date": "2023-08-17T20:37:40.000Z",
            "duration": "2:20:40",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/andrew-huberman-4/?utm_source=rss&utm_medium=rss&utm_campaign=andrew-huberman-4",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrew_huberman_4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5618",
            "index": 106,
            "title": "#392 – Joscha Bach: Life, Intelligence, Consciousness, AI & the Future of Humans",
            "pub_date": "2023-08-01T18:49:08.000Z",
            "duration": "2:59:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/joscha-bach-3/?utm_source=rss&utm_medium=rss&utm_campaign=joscha-bach-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_joscha_bach_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 478,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5610",
            "index": 107,
            "title": "#391 – Mohammed El-Kurd: Palestine",
            "pub_date": "2023-07-24T15:32:40.000Z",
            "duration": "2:23:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/mohammed-el-kurd/?utm_source=rss&utm_medium=rss&utm_campaign=mohammed-el-kurd",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_mohammed_el_kurd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5607",
            "index": 108,
            "title": "#390 – Yuval Noah Harari: Human Nature, Intelligence, Power, and Conspiracies",
            "pub_date": "2023-07-17T15:44:20.000Z",
            "duration": "2:52:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://lexfridman.com/yuval-noah-harari/?utm_source=rss&utm_medium=rss&utm_campaign=yuval-noah-harari",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_yuval_noah_harari.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 347,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 7,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5596",
            "index": 109,
            "title": "#389 – Benjamin Netanyahu: Israel, Palestine, Power, Corruption, Hate, and Peace",
            "pub_date": "2023-07-12T18:07:31.000Z",
            "duration": "1:17:06",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/benjamin-netanyahu/?utm_source=rss&utm_medium=rss&utm_campaign=benjamin-netanyahu",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_benjamin_netanyahu.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 156,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 8,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5588",
            "index": 110,
            "title": "#388 – Robert F. Kennedy Jr: CIA, Power, Corruption, War, Freedom, and Meaning",
            "pub_date": "2023-07-06T22:07:19.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/robert-f-kennedy-jr/?utm_source=rss&utm_medium=rss&utm_campaign=robert-f-kennedy-jr",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_robert_f_kennedy_jr.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5583",
            "index": 111,
            "title": "#387 – George Hotz: Tiny Corp, Twitter, AI Safety, Self-Driving, GPT, AGI & God",
            "pub_date": "2023-06-30T01:16:21.000Z",
            "duration": "3:15:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "nvidia",
              "safety"
            ],
            "page_url": "https://lexfridman.com/george-hotz-3/?utm_source=rss&utm_medium=rss&utm_campaign=george-hotz-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_george_hotz_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 1365,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 8,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5578",
            "index": 112,
            "title": "#386 – Marc Andreessen: Future of the Internet, Technology, and AI",
            "pub_date": "2023-06-22T02:04:50.000Z",
            "duration": "3:15:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "training"
            ],
            "page_url": "https://lexfridman.com/marc-andreessen/?utm_source=rss&utm_medium=rss&utm_campaign=marc-andreessen",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_marc_andreessen.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5567",
            "index": 113,
            "title": "#385 – Jimmy Wales: Wikipedia",
            "pub_date": "2023-06-18T22:42:02.000Z",
            "duration": "3:19:37",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "chatgpt"
            ],
            "page_url": "https://lexfridman.com/jimmy-wales/?utm_source=rss&utm_medium=rss&utm_campaign=jimmy-wales",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jimmy_wales.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 465,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "https://lexfridman.com/?p=5536",
            "index": 114,
            "title": "#384 – Matthew McConaughey: Freedom, Truth, Family, Hardship, and Love",
            "pub_date": "2023-06-13T18:26:43.000Z",
            "duration": "2:24:00",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/matthew-mcconaughey/?utm_source=rss&utm_medium=rss&utm_campaign=matthew-mcconaughey",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_matthew_mcconaughey.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5520",
            "index": 115,
            "title": "#383 – Mark Zuckerberg: Future of AI at Meta, Facebook, Instagram, and WhatsApp",
            "pub_date": "2023-06-08T22:49:41.000Z",
            "duration": "2:47:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "meta ai"
            ],
            "page_url": "https://lexfridman.com/mark-zuckerberg-2/?utm_source=rss&utm_medium=rss&utm_campaign=mark-zuckerberg-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_mark_zuckerberg_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5513",
            "index": 116,
            "title": "#382 – Bert Kreischer: Comedy, Drinking, Rogan, Segura, Churchill & Kim Jong Un",
            "pub_date": "2023-06-05T17:10:35.000Z",
            "duration": "2:11:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/bert-kreischer/?utm_source=rss&utm_medium=rss&utm_campaign=bert-kreischer",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bert_kreischer.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5509",
            "index": 117,
            "title": "#381 – Chris Lattner: Future of Programming and AI",
            "pub_date": "2023-06-02T21:20:17.000Z",
            "duration": "3:38:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://lexfridman.com/chris-lattner-3/?utm_source=rss&utm_medium=rss&utm_campaign=chris-lattner-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_chris_lattner_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5497",
            "index": 118,
            "title": "#380 – Neil Gershenfeld: Self-Replicating Robots and the Future of Fabrication",
            "pub_date": "2023-05-28T15:29:58.000Z",
            "duration": "2:11:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/neil-gershenfeld/?utm_source=rss&utm_medium=rss&utm_campaign=neil-gershenfeld",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_neil_gershenfeld.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5492",
            "index": 119,
            "title": "#379 – Randall Kennedy: The N-Word – History of Race, Law, Politics, and Power",
            "pub_date": "2023-05-24T15:27:23.000Z",
            "duration": "3:14:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/randall-kennedy/?utm_source=rss&utm_medium=rss&utm_campaign=randall-kennedy",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_randall_kennedy.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5489",
            "index": 120,
            "title": "#378 – Anna Frebel: Origin and Evolution of the Universe, Galaxies, and Stars",
            "pub_date": "2023-05-18T21:18:08.000Z",
            "duration": "2:23:21",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/anna-frebel/?utm_source=rss&utm_medium=rss&utm_campaign=anna-frebel",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_anna_frebel.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5486",
            "index": 121,
            "title": "#377 – Harvey Silverglate: Freedom of Speech",
            "pub_date": "2023-05-16T01:18:32.000Z",
            "duration": "1:55:28",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/harvey-silverglate/?utm_source=rss&utm_medium=rss&utm_campaign=harvey-silverglate",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_harvey_silverglate.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5481",
            "index": 122,
            "title": "#376 – Stephen Wolfram: ChatGPT and the Nature of Truth, Reality & Computation",
            "pub_date": "2023-05-09T17:12:11.000Z",
            "duration": "4:19:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://lexfridman.com/stephen-wolfram-4/?utm_source=rss&utm_medium=rss&utm_campaign=stephen-wolfram-4",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_stephen_wolfram_4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5476",
            "index": 123,
            "title": "#375 – David Pakman: Politics of Trump, Biden, Bernie, AOC, Socialism & Wokeism",
            "pub_date": "2023-05-06T17:39:54.000Z",
            "duration": "3:36:04",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "chatgpt"
            ],
            "page_url": "https://lexfridman.com/david-pakman/?utm_source=rss&utm_medium=rss&utm_campaign=david-pakman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_david_pakman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5471",
            "index": 124,
            "title": "#374 – Robert Playter: Boston Dynamics CEO on Humanoid and Legged Robotics",
            "pub_date": "2023-04-28T19:13:09.000Z",
            "duration": "2:32:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/robert-playter/?utm_source=rss&utm_medium=rss&utm_campaign=robert-playter",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_robert_playter.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5468",
            "index": 125,
            "title": "#373 – Manolis Kellis: Evolution of Human Civilization and Superintelligent AI",
            "pub_date": "2023-04-21T22:21:23.000Z",
            "duration": "2:35:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://lexfridman.com/manolis-kellis-5/?utm_source=rss&utm_medium=rss&utm_campaign=manolis-kellis-5",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_manolis_kellis_5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5463",
            "index": 126,
            "title": "#372 – Simone Giertz: Queen of Sh*tty Robots, Innovative Engineering, and Design",
            "pub_date": "2023-04-16T19:51:34.000Z",
            "duration": "2:04:05",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/simone-giertz/?utm_source=rss&utm_medium=rss&utm_campaign=simone-giertz",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_simone_giertz.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5459",
            "index": 127,
            "title": "#371 – Max Tegmark: The Case for Halting AI Development",
            "pub_date": "2023-04-13T16:26:42.000Z",
            "duration": "2:53:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "automation"
            ],
            "page_url": "https://lexfridman.com/max-tegmark-3/?utm_source=rss&utm_medium=rss&utm_campaign=max-tegmark-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_max_tegmark_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5455",
            "index": 128,
            "title": "#370 – Edward Frenkel: Reality is a Paradox – Mathematics, Physics, Truth & Love",
            "pub_date": "2023-04-10T02:14:34.000Z",
            "duration": "3:51:31",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/edward-frenkel/?utm_source=rss&utm_medium=rss&utm_campaign=edward-frenkel",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_edward_frenkel.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5450",
            "index": 129,
            "title": "#369 – Paul Rosolie: Amazon Jungle, Uncontacted Tribes, Anacondas, and Ayahuasca",
            "pub_date": "2023-04-04T18:50:10.000Z",
            "duration": "3:38:41",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/paul-rosolie/?utm_source=rss&utm_medium=rss&utm_campaign=paul-rosolie",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_paul_rosolie.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5445",
            "index": 130,
            "title": "#368 – Eliezer Yudkowsky: Dangers of AI and the End of Human Civilization",
            "pub_date": "2023-03-30T15:14:29.000Z",
            "duration": "3:22:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "alignment"
            ],
            "page_url": "https://lexfridman.com/eliezer-yudkowsky/?utm_source=rss&utm_medium=rss&utm_campaign=eliezer-yudkowsky",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_eliezer_yudkowsky.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5440",
            "index": 131,
            "title": "#367 – Sam Altman: OpenAI CEO on GPT-4, ChatGPT, and the Future of AI",
            "pub_date": "2023-03-25T18:04:11.000Z",
            "duration": "2:28:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "openai",
              "safety"
            ],
            "page_url": "https://lexfridman.com/sam-altman/?utm_source=rss&utm_medium=rss&utm_campaign=sam-altman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sam_altman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5436",
            "index": 132,
            "title": "#366 – Shannon Curry: Johnny Depp & Amber Heard Trial, Marriage, Dating & Love",
            "pub_date": "2023-03-21T23:02:22.000Z",
            "duration": "1:50:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/shannon-curry/?utm_source=rss&utm_medium=rss&utm_campaign=shannon-curry",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_shannon_curry.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5432",
            "index": 133,
            "title": "#365 – Sam Harris: Trump, Pandemic, Twitter, Elon, Bret, IDW, Kanye, AI & UFOs",
            "pub_date": "2023-03-14T17:19:34.000Z",
            "duration": "4:33:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/sam-harris-2/?utm_source=rss&utm_medium=rss&utm_campaign=sam-harris-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sam_harris_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5426",
            "index": 134,
            "title": "#364 – Chris Voss: FBI Hostage Negotiator",
            "pub_date": "2023-03-10T17:16:27.000Z",
            "duration": "2:15:56",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/chris-voss/?utm_source=rss&utm_medium=rss&utm_campaign=chris-voss",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_chris_voss.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5421",
            "index": 135,
            "title": "#363 – B-Team Jiu Jitsu: Craig Jones, Nicky Rod, and Nicky Ryan",
            "pub_date": "2023-03-06T18:33:58.000Z",
            "duration": "2:54:11",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/b-team/?utm_source=rss&utm_medium=rss&utm_campaign=b-team",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_b_team.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5417",
            "index": 136,
            "title": "#362 – Ginni Rometty: IBM CEO on Leadership, Power, and Adversity",
            "pub_date": "2023-03-02T19:08:42.000Z",
            "duration": "1:56:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ginni-rometty/?utm_source=rss&utm_medium=rss&utm_campaign=ginni-rometty",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ginni_rometty.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5403",
            "index": 137,
            "title": "#361 – Aaron Smith-Levin: Scientology",
            "pub_date": "2023-02-25T20:26:53.000Z",
            "duration": "2:17:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/aaron-smith-levin/?utm_source=rss&utm_medium=rss&utm_campaign=aaron-smith-levin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_aaron_smith_levin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5396",
            "index": 138,
            "title": "#360 – Tim Urban: Tribalism, Marxism, Liberalism, Social Justice, and Politics",
            "pub_date": "2023-02-20T20:18:52.000Z",
            "duration": "3:10:58",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tim-urban-2/?utm_source=rss&utm_medium=rss&utm_campaign=tim-urban-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tim_urban_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5393",
            "index": 139,
            "title": "#359 – Andrew Strominger: Black Holes, Quantum Gravity, and Theoretical Physics",
            "pub_date": "2023-02-15T17:17:16.000Z",
            "duration": "2:25:03",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/andrew-strominger/?utm_source=rss&utm_medium=rss&utm_campaign=andrew-strominger",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrew_strominger.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5389",
            "index": 140,
            "title": "#358 – Aella: Sex Work, OnlyFans, Porn, Escorting, Dating, and Human Sexuality",
            "pub_date": "2023-02-10T18:57:08.000Z",
            "duration": "4:02:14",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/aella/?utm_source=rss&utm_medium=rss&utm_campaign=aella",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_aella.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5386",
            "index": 141,
            "title": "#357 – Paul Conti: Narcissism, Sociopathy, Envy, and the Nature of Good and Evil",
            "pub_date": "2023-02-07T17:05:12.000Z",
            "duration": "3:22:27",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/paul-conti/?utm_source=rss&utm_medium=rss&utm_campaign=paul-conti",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_paul_conti.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5381",
            "index": 142,
            "title": "#356 – Tim Dodd: SpaceX, Starship, Rocket Engines, and Future of Space Travel",
            "pub_date": "2023-02-02T17:36:01.000Z",
            "duration": "5:21:22",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tim-dodd/?utm_source=rss&utm_medium=rss&utm_campaign=tim-dodd",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tim_dodd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5374",
            "index": 143,
            "title": "#355 – David Kipping: Alien Civilizations and Habitable Worlds",
            "pub_date": "2023-01-28T20:03:06.000Z",
            "duration": "3:50:47",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/david-kipping/?utm_source=rss&utm_medium=rss&utm_campaign=david-kipping",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_david_kipping.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5368",
            "index": 144,
            "title": "#354 – Jeremi Suri: American Civil War",
            "pub_date": "2023-01-25T17:22:29.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jeremi-suri-2/?utm_source=rss&utm_medium=rss&utm_campaign=jeremi-suri-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jeremi_suri_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5364",
            "index": 145,
            "title": "#353 – Dennis Whyte: Nuclear Fusion and the Future of Energy",
            "pub_date": "2023-01-21T18:37:56.000Z",
            "duration": "3:13:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/dennis-whyte/?utm_source=rss&utm_medium=rss&utm_campaign=dennis-whyte",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dennis_whyte.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5359",
            "index": 146,
            "title": "#352 – Omar Suleiman: Islam",
            "pub_date": "2023-01-17T17:35:28.000Z",
            "duration": "3:07:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/omar-suleiman/?utm_source=rss&utm_medium=rss&utm_campaign=omar-suleiman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_omar_suleiman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5355",
            "index": 147,
            "title": "#351 – MrBeast: Future of YouTube, Twitter, TikTok, and Instagram",
            "pub_date": "2023-01-11T17:36:11.000Z",
            "duration": "2:24:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/mrbeast/?utm_source=rss&utm_medium=rss&utm_campaign=mrbeast",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_mrbeast.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5334",
            "index": 148,
            "title": "#350 – Betül Kaçar: Origin of Life, Ancient DNA, Panspermia, and Aliens",
            "pub_date": "2022-12-29T17:35:50.000Z",
            "duration": "2:47:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/betul-kacar/?utm_source=rss&utm_medium=rss&utm_campaign=betul-kacar",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_betul_kacar.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5330",
            "index": 149,
            "title": "#349 – Bhaskar Sunkara: The Case for Socialism",
            "pub_date": "2022-12-22T19:41:28.000Z",
            "duration": "3:52:04",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/bhaskar-sunkara/?utm_source=rss&utm_medium=rss&utm_campaign=bhaskar-sunkara",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bhaskar_sunkara.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5324",
            "index": 150,
            "title": "#348 – Nathalie Cabrol: Search for Alien Life",
            "pub_date": "2022-12-19T18:57:17.000Z",
            "duration": "2:12:12",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/nathalie-cabrol/?utm_source=rss&utm_medium=rss&utm_campaign=nathalie-cabrol",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_nathalie_cabrol.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5317",
            "index": 151,
            "title": "#347 – Michael Malice: Christmas Special",
            "pub_date": "2022-12-15T20:28:53.000Z",
            "duration": "3:47:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-malice-6/?utm_source=rss&utm_medium=rss&utm_campaign=michael-malice-6",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_malice_6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5312",
            "index": 152,
            "title": "#346 – Ed Calderon: Mexican Drug Cartels",
            "pub_date": "2022-12-12T17:10:47.000Z",
            "duration": "4:11:43",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ed-calderon/?utm_source=rss&utm_medium=rss&utm_campaign=ed-calderon",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ed_calderon.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5309",
            "index": 153,
            "title": "#345 – Coffeezilla: SBF, FTX, Fraud, Scams, Fake Gurus, Money, Fame, and Power",
            "pub_date": "2022-12-09T02:27:44.000Z",
            "duration": "3:51:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/coffeezilla/?utm_source=rss&utm_medium=rss&utm_campaign=coffeezilla",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_coffeezilla.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5304",
            "index": 154,
            "title": "#344 – Noam Brown: AI vs Humans in Poker and Games of Strategic Negotiation",
            "pub_date": "2022-12-06T17:23:36.000Z",
            "duration": "2:33:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "meta ai"
            ],
            "page_url": "https://lexfridman.com/noam-brown/?utm_source=rss&utm_medium=rss&utm_campaign=noam-brown",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_noam_brown.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5296",
            "index": 155,
            "title": "#343 – Roger Gracie: Greatest Jiu Jitsu Competitor of All Time",
            "pub_date": "2022-12-03T17:10:50.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/roger-gracie/?utm_source=rss&utm_medium=rss&utm_campaign=roger-gracie",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_roger_gracie.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5293",
            "index": 156,
            "title": "#342 – Todd Howard: Skyrim, Elder Scrolls 6, Fallout, and Starfield",
            "pub_date": "2022-11-29T17:04:46.000Z",
            "duration": "2:49:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/todd-howard/?utm_source=rss&utm_medium=rss&utm_campaign=todd-howard",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_todd_howard.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5287",
            "index": 157,
            "title": "#341 – Guido van Rossum: Python and the Future of Programming",
            "pub_date": "2022-11-26T16:25:26.000Z",
            "duration": "3:22:36",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "github copilot",
              "copilot"
            ],
            "page_url": "https://lexfridman.com/guido-van-rossum-2/?utm_source=rss&utm_medium=rss&utm_campaign=guido-van-rossum-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_guido_van_rossum_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5283",
            "index": 158,
            "title": "#340 – Chris Tarbell: FBI Agent Who Took Down Silk Road",
            "pub_date": "2022-11-22T17:24:13.000Z",
            "duration": "3:02:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "agent"
            ],
            "page_url": "https://lexfridman.com/chris-tarbell/?utm_source=rss&utm_medium=rss&utm_campaign=chris-tarbell",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_chris_tarbell.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5277",
            "index": 159,
            "title": "#339 – Climate Change Debate: Bjørn Lomborg and Andrew Revkin",
            "pub_date": "2022-11-18T16:57:39.000Z",
            "duration": "4:16:22",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/climate-change-debate/?utm_source=rss&utm_medium=rss&utm_campaign=climate-change-debate",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_climate_change_debate.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5274",
            "index": 160,
            "title": "#338 – Chamath Palihapitiya: Money, Success, Startups, Energy, Poker & Happiness",
            "pub_date": "2022-11-15T16:58:05.000Z",
            "duration": "3:04:21",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/chamath-palihapitiya/?utm_source=rss&utm_medium=rss&utm_campaign=chamath-palihapitiya",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_chamath_palihapitiya.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5269",
            "index": 161,
            "title": "#337 – Destiny: Politics, Free Speech, Controversy, Sex, War, and Relationships",
            "pub_date": "2022-11-11T17:48:28.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/destiny/?utm_source=rss&utm_medium=rss&utm_campaign=destiny",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_destiny.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5264",
            "index": 162,
            "title": "#336 – Ben Shapiro: Politics, Kanye, Trump, Biden, Hitler, Extremism, and War",
            "pub_date": "2022-11-07T15:43:59.000Z",
            "duration": "2:36:39",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ben-shapiro/?utm_source=rss&utm_medium=rss&utm_campaign=ben-shapiro",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ben_shapiro.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5261",
            "index": 163,
            "title": "#335 – Fiona Hill: Vladimir Putin and Donald Trump",
            "pub_date": "2022-11-04T16:07:36.000Z",
            "duration": "3:24:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/fiona-hill/?utm_source=rss&utm_medium=rss&utm_campaign=fiona-hill",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_fiona_hill.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5256",
            "index": 164,
            "title": "#334 – Abbas Amanat: Iran Protests, Mahsa Amini, History, CIA & Nuclear Weapons",
            "pub_date": "2022-11-02T17:29:54.000Z",
            "duration": "3:11:25",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/abbas-amanat/?utm_source=rss&utm_medium=rss&utm_campaign=abbas-amanat",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_abbas_amanat.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5252",
            "index": 165,
            "title": "#333 – Andrej Karpathy: Tesla AI, Self-Driving, Optimus, Aliens, and AGI",
            "pub_date": "2022-10-29T16:36:12.000Z",
            "duration": "3:33:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "https://lexfridman.com/andrej-karpathy/?utm_source=rss&utm_medium=rss&utm_campaign=andrej-karpathy",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrej_karpathy.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5241",
            "index": 166,
            "title": "#332 – Kanye ‘Ye’ West Interview",
            "pub_date": "2022-10-24T21:09:11.000Z",
            "duration": "2:33:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ye-aka-kanye-west/?utm_source=rss&utm_medium=rss&utm_campaign=ye-aka-kanye-west",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ye_aka_kanye_west.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5236",
            "index": 167,
            "title": "#331 – Balaji Srinivasan: How to Fix Government, Twitter, Science, and the FDA",
            "pub_date": "2022-10-20T16:24:03.000Z",
            "duration": "7:53:01",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/balaji-srinivasan/?utm_source=rss&utm_medium=rss&utm_campaign=balaji-srinivasan",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_balaji_srinivasan.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5231",
            "index": 168,
            "title": "#330 – Hikaru Nakamura: Chess, Magnus, Kasparov, and the Psychology of Greatness",
            "pub_date": "2022-10-17T16:42:50.000Z",
            "duration": "2:54:07",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/hikaru-nakamura/?utm_source=rss&utm_medium=rss&utm_campaign=hikaru-nakamura",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_hikaru_nakamura.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5227",
            "index": 169,
            "title": "#329 – Kate Darling: Social Robots, Ethics, Privacy and the Future of MIT",
            "pub_date": "2022-10-15T19:33:53.000Z",
            "duration": "3:09:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "grok",
              "robotics",
              "automation"
            ],
            "page_url": "https://lexfridman.com/kate-darling-2/?utm_source=rss&utm_medium=rss&utm_campaign=kate-darling-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_kate_darling.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5218",
            "index": 170,
            "title": "#328 – John Danaher: Submission Grappling, ADCC, Animal Combat, and Knives",
            "pub_date": "2022-10-10T17:53:32.000Z",
            "duration": "4:55:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/john-danaher-3/?utm_source=rss&utm_medium=rss&utm_campaign=john-danaher-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_john_danaher_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5211",
            "index": 171,
            "title": "#327 – GothamChess: Hans Niemann, Magnus Carlsen, Cheating Scandal & Chess Bots",
            "pub_date": "2022-10-07T16:34:07.000Z",
            "duration": "3:38:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/gothamchess/?utm_source=rss&utm_medium=rss&utm_campaign=gothamchess",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_gothamchess.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5207",
            "index": 172,
            "title": "#326 – Annaka Harris: Free Will, Consciousness, and the Nature of Reality",
            "pub_date": "2022-10-05T17:24:25.000Z",
            "duration": "2:46:15",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/annaka-harris/?utm_source=rss&utm_medium=rss&utm_campaign=annaka-harris",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_annaka_harris.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5199",
            "index": 173,
            "title": "#325 – Michael Levin: Biology, Life, Aliens, Evolution, Embryogenesis & Xenobots",
            "pub_date": "2022-10-01T16:56:45.000Z",
            "duration": "3:05:29",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-levin/?utm_source=rss&utm_medium=rss&utm_campaign=michael-levin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_levin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5189",
            "index": 174,
            "title": "#324 – Daniel Negreanu: Poker",
            "pub_date": "2022-09-27T18:37:49.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/daniel-negreanu/?utm_source=rss&utm_medium=rss&utm_campaign=daniel-negreanu",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_daniel_negreanu.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5183",
            "index": 175,
            "title": "#323 – Will Sasso: Comedy, MADtv, AI, Friendship, Madness, and Pro Wrestling",
            "pub_date": "2022-09-24T17:19:49.000Z",
            "duration": "2:28:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/will-sasso/?utm_source=rss&utm_medium=rss&utm_campaign=will-sasso",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_will_sasso.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5179",
            "index": 176,
            "title": "#322 – Rana el Kaliouby: Emotion AI, Social Robots, and Self-Driving Cars",
            "pub_date": "2022-09-21T16:35:09.000Z",
            "duration": "2:42:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/rana-el-kaliouby/?utm_source=rss&utm_medium=rss&utm_campaign=rana-el-kaliouby",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_rana_el_kaliouby.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5174",
            "index": 177,
            "title": "#321 – Ray Kurzweil: Singularity, Superintelligence, and Immortality",
            "pub_date": "2022-09-17T16:54:53.000Z",
            "duration": "1:42:20",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://lexfridman.com/ray-kurzweil/?utm_source=rss&utm_medium=rss&utm_campaign=ray-kurzweil",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ray_kurzweil.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5168",
            "index": 178,
            "title": "#320 – Christopher Capozzola: World War I, Ideology, Propaganda, and Politics",
            "pub_date": "2022-09-14T18:12:58.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/christopher-capozzola/?utm_source=rss&utm_medium=rss&utm_campaign=christopher-capozzola",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_christopher_capozzola.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5164",
            "index": 179,
            "title": "#319 – Botez Sisters: Chess, Streaming, and Fame",
            "pub_date": "2022-09-09T14:04:45.000Z",
            "duration": "2:42:41",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/botez-sisters/?utm_source=rss&utm_medium=rss&utm_campaign=botez-sisters",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_botez_sisters.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5155",
            "index": 180,
            "title": "#318 – Nick Lane: Origin of Life, Evolution, Aliens, Biology, and Consciousness",
            "pub_date": "2022-09-07T15:29:01.000Z",
            "duration": "3:47:44",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/nick-lane/?utm_source=rss&utm_medium=rss&utm_campaign=nick-lane",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_nick_lane.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5149",
            "index": 181,
            "title": "#317 – John Vervaeke: Meaning Crisis, Atheism, Religion & the Search for Wisdom",
            "pub_date": "2022-09-04T19:05:26.000Z",
            "duration": "3:17:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/john-vervaeke/?utm_source=rss&utm_medium=rss&utm_campaign=john-vervaeke",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_john_vervaeke.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5146",
            "index": 182,
            "title": "#316 – Noam Chomsky: Putin, Ukraine, China, and Nuclear War",
            "pub_date": "2022-08-31T20:41:11.000Z",
            "duration": "52:56",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/noam-chomsky-2/?utm_source=rss&utm_medium=rss&utm_campaign=noam-chomsky-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_noam_chomsky_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5141",
            "index": 183,
            "title": "#315 – Magnus Carlsen: Greatest Chess Player of All Time",
            "pub_date": "2022-08-27T17:50:28.000Z",
            "duration": "2:39:43",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/magnus-carlsen/?utm_source=rss&utm_medium=rss&utm_campaign=magnus-carlsen",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_magnus_carlsen.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5136",
            "index": 184,
            "title": "#314 – Liv Boeree: Poker, Game Theory, AI, Simulation, Aliens & Existential Risk",
            "pub_date": "2022-08-24T16:29:52.000Z",
            "duration": "3:41:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/liv-boeree/?utm_source=rss&utm_medium=rss&utm_campaign=liv-boeree",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_liv_boeree.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5131",
            "index": 185,
            "title": "#313 – Jordan Peterson: Life, Death, Power, Fame, and Meaning",
            "pub_date": "2022-08-19T15:59:42.000Z",
            "duration": "3:10:00",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jordan-peterson/?utm_source=rss&utm_medium=rss&utm_campaign=jordan-peterson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jordan_peterson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5124",
            "index": 186,
            "title": "#312 – Duncan Trussell: Comedy, Sentient Robots, Suffering, Love & Burning Man",
            "pub_date": "2022-08-16T15:26:19.000Z",
            "duration": "3:25:56",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/duncan-trussell/?utm_source=rss&utm_medium=rss&utm_campaign=duncan-trussell",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_duncan_trussell.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5118",
            "index": 187,
            "title": "#311 – Magatte Wade: Africa, Capitalism, Communism, and the Future of Humanity",
            "pub_date": "2022-08-13T15:26:22.000Z",
            "duration": "3:38:27",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/magatte-wade/?utm_source=rss&utm_medium=rss&utm_campaign=magatte-wade",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_magatte_wade.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5110",
            "index": 188,
            "title": "#310 – Andrew Bustamante: CIA Spy",
            "pub_date": "2022-08-08T17:16:04.000Z",
            "duration": "3:59:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/andrew-bustamante/?utm_source=rss&utm_medium=rss&utm_campaign=andrew-bustamante",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrew_bustamante.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5107",
            "index": 189,
            "title": "#309 – John Carmack: Doom, Quake, VR, AGI, Programming, Video Games, and Rockets",
            "pub_date": "2022-08-04T17:04:07.000Z",
            "duration": "5:22:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://lexfridman.com/john-carmack/?utm_source=rss&utm_medium=rss&utm_campaign=john-carmack",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_john_carmack.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5101",
            "index": 190,
            "title": "#308 – Ryan Graves: UFOs, Fighter Jets, and Aliens",
            "pub_date": "2022-08-01T16:07:41.000Z",
            "duration": "2:37:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://lexfridman.com/ryan-graves/?utm_source=rss&utm_medium=rss&utm_campaign=ryan-graves",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ryan_graves.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5097",
            "index": 191,
            "title": "#307 – Brian Armstrong: Coinbase, Cryptocurrency, and Government Regulation",
            "pub_date": "2022-07-29T16:26:01.000Z",
            "duration": "2:36:02",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/brian-armstrong/?utm_source=rss&utm_medium=rss&utm_campaign=brian-armstrong",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_brian_armstrong.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5092",
            "index": 192,
            "title": "#306 – Oriol Vinyals: Deep Learning and Artificial General Intelligence",
            "pub_date": "2022-07-26T16:17:10.000Z",
            "duration": "2:15:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "deepmind"
            ],
            "page_url": "https://lexfridman.com/oriol-vinyals-2/?utm_source=rss&utm_medium=rss&utm_campaign=oriol-vinyals-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_oriol_vinyals_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5086",
            "index": 193,
            "title": "#305 – Martin Rees: Black Holes, Alien Life, Dark Matter, and the Big Bang",
            "pub_date": "2022-07-23T15:53:10.000Z",
            "duration": "2:19:10",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/martin-rees/?utm_source=rss&utm_medium=rss&utm_campaign=martin-rees",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_martin_rees.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5083",
            "index": 194,
            "title": "#304 – Bishop Robert Barron: Christianity and the Catholic Church",
            "pub_date": "2022-07-20T15:54:01.000Z",
            "duration": "2:00:44",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/robert-barron/?utm_source=rss&utm_medium=rss&utm_campaign=robert-barron",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_robert_barron.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5078",
            "index": 195,
            "title": "#303 – Steve Keen: Marxism, Capitalism, and Economics",
            "pub_date": "2022-07-17T13:57:03.000Z",
            "duration": "3:36:45",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/steve-keen/?utm_source=rss&utm_medium=rss&utm_campaign=steve-keen",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_steve_keen.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5073",
            "index": 196,
            "title": "#302 – Richard Haier: IQ Tests, Human Intelligence, and Group Differences",
            "pub_date": "2022-07-14T16:04:12.000Z",
            "duration": "2:51:03",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/richard-haier/?utm_source=rss&utm_medium=rss&utm_campaign=richard-haier",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_richard_haier.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5069",
            "index": 197,
            "title": "#301 – Jack Barsky: KGB Spy",
            "pub_date": "2022-07-09T15:59:57.000Z",
            "duration": "3:43:16",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "agent",
              "training"
            ],
            "page_url": "https://lexfridman.com/jack-barsky/?utm_source=rss&utm_medium=rss&utm_campaign=jack-barsky",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jack_barsky.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5063",
            "index": 198,
            "title": "#300 – Joe Rogan: Comedy, Controversy, Aliens, UFOs, Putin, CIA, and Freedom",
            "pub_date": "2022-07-04T13:14:02.000Z",
            "duration": "1:49:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/joe-rogan-2/?utm_source=rss&utm_medium=rss&utm_campaign=joe-rogan-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_joe_rogan_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5058",
            "index": 199,
            "title": "#299 – Demis Hassabis: DeepMind",
            "pub_date": "2022-07-01T10:12:10.000Z",
            "duration": "2:17:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind"
            ],
            "page_url": "https://lexfridman.com/demis-hassabis/?utm_source=rss&utm_medium=rss&utm_campaign=demis-hassabis",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_demis_hassabis.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5054",
            "index": 200,
            "title": "#298 – Susan Cain: The Power of Introverts and Loneliness",
            "pub_date": "2022-06-28T17:13:39.000Z",
            "duration": "2:05:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/susan-cain/?utm_source=rss&utm_medium=rss&utm_campaign=susan-cain",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_susan_cain.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5051",
            "index": 201,
            "title": "#297 – Jonathan Reisman: The Human Body – From Sex & Sperm to Hands & Heart",
            "pub_date": "2022-06-25T18:11:25.000Z",
            "duration": "2:49:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jonathan-reisman/?utm_source=rss&utm_medium=rss&utm_campaign=jonathan-reisman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jonathan_reisman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5048",
            "index": 202,
            "title": "#296 – Douglas Murray: Racism, Marxism, and the War on the West",
            "pub_date": "2022-06-21T12:38:18.000Z",
            "duration": "2:44:40",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/douglas-murray/?utm_source=rss&utm_medium=rss&utm_campaign=douglas-murray",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_douglas_murray.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5043",
            "index": 203,
            "title": "#295 – Richard Wolff: Marxism and Communism",
            "pub_date": "2022-06-17T16:19:37.000Z",
            "duration": "2:59:19",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/richard-wolff/?utm_source=rss&utm_medium=rss&utm_campaign=richard-wolff",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_richard_wolff.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5040",
            "index": 204,
            "title": "#294 – Tony Fadell: iPhone, iPod, and Nest",
            "pub_date": "2022-06-15T18:53:03.000Z",
            "duration": "2:52:32",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tony-fadell/?utm_source=rss&utm_medium=rss&utm_campaign=tony-fadell",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tony_fadell.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5037",
            "index": 205,
            "title": "#293 – Donald Hoffman: Reality is an Illusion – How Evolution Hid the Truth",
            "pub_date": "2022-06-12T18:50:15.000Z",
            "duration": "3:23:17",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "agent"
            ],
            "page_url": "https://lexfridman.com/donald-hoffman/?utm_source=rss&utm_medium=rss&utm_campaign=donald-hoffman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_donald_hoffman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5032",
            "index": 206,
            "title": "#292 – Robin Hanson: Alien Civilizations, UFOs, and the Future of Humanity",
            "pub_date": "2022-06-09T12:38:30.000Z",
            "duration": "4:18:35",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/robin-hanson/?utm_source=rss&utm_medium=rss&utm_campaign=robin-hanson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_robin_hanson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5026",
            "index": 207,
            "title": "#291 – Jonathan Haidt: The Case Against Social Media",
            "pub_date": "2022-06-04T17:18:02.000Z",
            "duration": "1:48:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jonathan-haidt/?utm_source=rss&utm_medium=rss&utm_campaign=jonathan-haidt",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jonathan_haidt.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5020",
            "index": 208,
            "title": "#290 – Dan Reynolds: Imagine Dragons",
            "pub_date": "2022-05-30T17:13:22.000Z",
            "duration": "2:18:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/dan-reynolds/?utm_source=rss&utm_medium=rss&utm_campaign=dan-reynolds",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dan_reynolds.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5016",
            "index": 209,
            "title": "#289 – Stephen Kotkin: Putin, Zelenskyy, and War in Ukraine",
            "pub_date": "2022-05-25T14:27:52.000Z",
            "duration": "2:49:16",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/stephen-kotkin-2/?utm_source=rss&utm_medium=rss&utm_campaign=stephen-kotkin-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_stephen_kotkin_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5012",
            "index": 210,
            "title": "#288 – Sarma Melngailis: Bad Vegan",
            "pub_date": "2022-05-23T17:33:00.000Z",
            "duration": "4:21:21",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/sarma-melngailis/?utm_source=rss&utm_medium=rss&utm_campaign=sarma-melngailis",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sarma_melngailis.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5009",
            "index": 211,
            "title": "#287 – Bobby Lee: Comedy, Skyrim, Sex Robots, Love, Fame, and Power",
            "pub_date": "2022-05-20T17:10:40.000Z",
            "duration": "1:45:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/bobby-lee/?utm_source=rss&utm_medium=rss&utm_campaign=bobby-lee",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bobby_lee.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5005",
            "index": 212,
            "title": "#286 – Oliver Stone: Vladimir Putin and War in Ukraine",
            "pub_date": "2022-05-17T17:42:24.000Z",
            "duration": "1:59:28",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/oliver-stone/?utm_source=rss&utm_medium=rss&utm_campaign=oliver-stone",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_oliver_stone.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=5002",
            "index": 213,
            "title": "#285 – Glenn Loury: Race, Racism, Identity Politics, and Cancel Culture",
            "pub_date": "2022-05-14T18:44:34.000Z",
            "duration": "3:38:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/glenn-loury/?utm_source=rss&utm_medium=rss&utm_campaign=glenn-loury",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_glenn_loury.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4998",
            "index": 214,
            "title": "#284 – Saifedean Ammous: Bitcoin, Anarchy, and Austrian Economics",
            "pub_date": "2022-05-11T17:01:27.000Z",
            "duration": "4:21:08",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/saifedean-ammous/?utm_source=rss&utm_medium=rss&utm_campaign=saifedean-ammous",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_saifedean_ammous.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4995",
            "index": 215,
            "title": "#283 – Chris Mason: Space Travel, Colonization, and Long-Term Survival in Space",
            "pub_date": "2022-05-08T20:52:32.000Z",
            "duration": "3:01:52",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/chris-mason/?utm_source=rss&utm_medium=rss&utm_campaign=chris-mason",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_christopher_mason.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4990",
            "index": 216,
            "title": "#282 – David Buss: Sex, Dating, Relationships, and Sex Differences",
            "pub_date": "2022-05-04T15:17:27.000Z",
            "duration": "3:38:34",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/david-buss/?utm_source=rss&utm_medium=rss&utm_campaign=david-buss",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_david_buss.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4986",
            "index": 217,
            "title": "#281 – Grimes: Music, AI, and the Future of Humanity",
            "pub_date": "2022-04-29T18:19:22.000Z",
            "duration": "2:11:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/grimes/?utm_source=rss&utm_medium=rss&utm_campaign=grimes",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_grimes.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4983",
            "index": 218,
            "title": "#280 – Cristiano Amon: Qualcomm CEO",
            "pub_date": "2022-04-27T18:01:38.000Z",
            "duration": "1:14:35",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "chip"
            ],
            "page_url": "https://lexfridman.com/cristiano-amon/?utm_source=rss&utm_medium=rss&utm_campaign=cristiano-amon",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_cristiano_amon.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4980",
            "index": 219,
            "title": "#279 – Alien Debate: Sara Walker and Lee Cronin",
            "pub_date": "2022-04-24T17:45:22.000Z",
            "duration": "4:11:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/alien-debate/?utm_source=rss&utm_medium=rss&utm_campaign=alien-debate",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_lee_cronin_sara_walker.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4976",
            "index": 220,
            "title": "#278 – Skye Fitzgerald: Hunger, War, and Human Suffering",
            "pub_date": "2022-04-20T22:23:59.000Z",
            "duration": "2:34:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/skye-fitzgerald/?utm_source=rss&utm_medium=rss&utm_campaign=skye-fitzgerald",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_skye_fitzgerald.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4972",
            "index": 221,
            "title": "#277 – Andrew Huberman: Focus, Stress, Relationships, and Friendship",
            "pub_date": "2022-04-17T17:53:59.000Z",
            "duration": "3:31:39",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/andrew-huberman-3/?utm_source=rss&utm_medium=rss&utm_campaign=andrew-huberman-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrew_huberman_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4968",
            "index": 222,
            "title": "#276 – Michael Saylor: Bitcoin, Inflation, and the Future of Money",
            "pub_date": "2022-04-14T19:03:57.000Z",
            "duration": "4:02:29",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-saylor/?utm_source=rss&utm_medium=rss&utm_campaign=michael-saylor",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_saylor.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4965",
            "index": 223,
            "title": "#275 – Rick Rubin: Legendary Music Producer",
            "pub_date": "2022-04-10T16:43:38.000Z",
            "duration": "3:27:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/rick-rubin/?utm_source=rss&utm_medium=rss&utm_campaign=rick-rubin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_rick_rubin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4962",
            "index": 224,
            "title": "#274 – Karl Deisseroth: Depression, Schizophrenia, and Psychiatry",
            "pub_date": "2022-04-07T16:50:15.000Z",
            "duration": "3:27:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/karl-deisseroth/?utm_source=rss&utm_medium=rss&utm_campaign=karl-deisseroth",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_karl_deisseroth.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4958",
            "index": 225,
            "title": "#273 – Chris Blattman: War and Violence",
            "pub_date": "2022-04-03T16:54:27.000Z",
            "duration": "2:54:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/chris-blattman/?utm_source=rss&utm_medium=rss&utm_campaign=chris-blattman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_chris_blattman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4955",
            "index": 226,
            "title": "#272 – Brett Johnson: US Most Wanted Cybercriminal",
            "pub_date": "2022-03-27T16:31:26.000Z",
            "duration": "3:53:05",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/brett-johnson/?utm_source=rss&utm_medium=rss&utm_campaign=brett-johnson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_brett_johnson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4952",
            "index": 227,
            "title": "#271 – Ariel Ekblaw: Space Colonization and Self-Assembling Space Megastructures",
            "pub_date": "2022-03-23T19:14:12.000Z",
            "duration": "1:52:53",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://lexfridman.com/ariel-ekblaw/?utm_source=rss&utm_medium=rss&utm_campaign=ariel-ekblaw",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ariel_ekblaw.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4948",
            "index": 228,
            "title": "#270 – David Wolpe: Judaism",
            "pub_date": "2022-03-16T21:11:24.000Z",
            "duration": "2:17:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/david-wolpe/?utm_source=rss&utm_medium=rss&utm_campaign=david-wolpe",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_david_wolpe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4945",
            "index": 229,
            "title": "#269 – Lee Cronin: Origin of Life, Aliens, Complexity, and Consciousness",
            "pub_date": "2022-03-11T18:35:10.000Z",
            "duration": "4:12:27",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://lexfridman.com/lee-cronin/?utm_source=rss&utm_medium=rss&utm_campaign=lee-cronin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_lee_cronin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4940",
            "index": 230,
            "title": "#268 – Robert Proctor: Nazi Science and Ideology",
            "pub_date": "2022-03-05T16:05:48.000Z",
            "duration": "2:55:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/robert-proctor/?utm_source=rss&utm_medium=rss&utm_campaign=robert-proctor",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_robert_proctor.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4934",
            "index": 231,
            "title": "#267 – Mark Zuckerberg: Meta, Facebook, Instagram, and the Metaverse",
            "pub_date": "2022-02-26T17:26:05.000Z",
            "duration": "2:05:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai"
            ],
            "page_url": "https://lexfridman.com/mark-zuckerberg/?utm_source=rss&utm_medium=rss&utm_campaign=mark-zuckerberg",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_mark_zuckerberg_feb26.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4929",
            "index": 232,
            "title": "#266 – Nicole Perlroth: Cybersecurity and the Weapons of Cyberwar",
            "pub_date": "2022-02-20T22:31:53.000Z",
            "duration": "2:07:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/nicole-perlroth/?utm_source=rss&utm_medium=rss&utm_campaign=nicole-perlroth",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_nicole_perlroth.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4926",
            "index": 233,
            "title": "#265 – Devon Larratt: Arm Wrestling",
            "pub_date": "2022-02-16T21:49:00.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/devon-larratt/?utm_source=rss&utm_medium=rss&utm_campaign=devon-larratt",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_devon_larratt.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4923",
            "index": 234,
            "title": "#264 – Tim Urban: Elon Musk, Neuralink, AI, Aliens, and the Future of Humanity",
            "pub_date": "2022-02-13T20:35:31.000Z",
            "duration": "2:43:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/tim-urban/?utm_source=rss&utm_medium=rss&utm_campaign=tim-urban",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tim_urban.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4919",
            "index": 235,
            "title": "#263 – John Abramson: Big Pharma",
            "pub_date": "2022-02-11T17:17:55.000Z",
            "duration": "2:24:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/john-abramson/?utm_source=rss&utm_medium=rss&utm_campaign=john-abramson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_john_abramson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4916",
            "index": 236,
            "title": "#262 – Garry Nolan: UFOs and Aliens",
            "pub_date": "2022-02-06T22:20:41.000Z",
            "duration": "1:50:04",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/garry-nolan/?utm_source=rss&utm_medium=rss&utm_campaign=garry-nolan",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_garry_nolan.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4913",
            "index": 237,
            "title": "#261 – Philip Goff: Consciousness, Panpsychism, and the Philosophy of Mind",
            "pub_date": "2022-02-03T17:36:56.000Z",
            "duration": "2:53:05",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/philip-goff/?utm_source=rss&utm_medium=rss&utm_campaign=philip-goff",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_philip_goff.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4907",
            "index": 238,
            "title": "#260 – Georges St-Pierre, John Danaher & Gordon Ryan: The Greatest of All Time",
            "pub_date": "2022-01-30T20:47:31.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/georges-st-pierre-john-danaher-gordon-ryan/?utm_source=rss&utm_medium=rss&utm_campaign=georges-st-pierre-john-danaher-gordon-ryan",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_gsp_danaher_gordon.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4904",
            "index": 239,
            "title": "#259 – Thomas Tull: From Batman Dark Knight Trilogy to AI and the Rolling Stones",
            "pub_date": "2022-01-26T20:43:15.000Z",
            "duration": "2:23:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/thomas-tull/?utm_source=rss&utm_medium=rss&utm_campaign=thomas-tull",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_thomas_tull.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4900",
            "index": 240,
            "title": "#258 – Yann LeCun: Dark Matter of Intelligence and Self-Supervised Learning",
            "pub_date": "2022-01-22T20:08:32.000Z",
            "duration": "2:51:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "multimodal"
            ],
            "page_url": "https://lexfridman.com/yann-lecun-2/?utm_source=rss&utm_medium=rss&utm_campaign=yann-lecun-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_yann_lecun_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4897",
            "index": 241,
            "title": "#257 – Brian Keating: Cosmology, Astrophysics, Aliens & Losing the Nobel Prize",
            "pub_date": "2022-01-18T20:28:05.000Z",
            "duration": "4:06:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/brian-keating/?utm_source=rss&utm_medium=rss&utm_campaign=brian-keating",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_brian_keating.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4893",
            "index": 242,
            "title": "#256 – Nationalism Debate: Yaron Brook and Yoram Hazony",
            "pub_date": "2022-01-15T19:50:01.000Z",
            "duration": "3:04:47",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/nationalism-debate/?utm_source=rss&utm_medium=rss&utm_campaign=nationalism-debate",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_nationalism_debate.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4890",
            "index": 243,
            "title": "#255 – Mark Normand: Comedy!",
            "pub_date": "2022-01-08T21:53:16.000Z",
            "duration": "1:58:24",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/mark-normand/?utm_source=rss&utm_medium=rss&utm_campaign=mark-normand",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_mark_normand.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4887",
            "index": 244,
            "title": "#254 – Jay Bhattacharya: The Case Against Lockdowns",
            "pub_date": "2022-01-04T23:52:11.000Z",
            "duration": "2:28:33",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://lexfridman.com/jay-bhattacharya/?utm_source=rss&utm_medium=rss&utm_campaign=jay-bhattacharya",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jay_bhattacharya.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4883",
            "index": 245,
            "title": "#253 – Michael Malice: New Year’s Special",
            "pub_date": "2021-12-31T22:40:33.000Z",
            "duration": "3:32:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-malice-5/?utm_source=rss&utm_medium=rss&utm_campaign=michael-malice-5",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_malice_5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4880",
            "index": 246,
            "title": "#252 – Elon Musk: SpaceX, Mars, Tesla Autopilot, Self-Driving, Robotics, and AI",
            "pub_date": "2021-12-28T19:02:28.000Z",
            "duration": "2:39:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/elon-musk-3/?utm_source=rss&utm_medium=rss&utm_campaign=elon-musk-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_elon_musk_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4876",
            "index": 247,
            "title": "#251 – Ray Dalio: Money, Power, and the Collapse of Empires",
            "pub_date": "2021-12-25T20:04:14.000Z",
            "duration": "1:40:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ray-dalio-2/?utm_source=rss&utm_medium=rss&utm_campaign=ray-dalio-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ray_dalio_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4872",
            "index": 248,
            "title": "#250 – Peter Wang: Python and the Source Code of Humans, Computers, and Reality",
            "pub_date": "2021-12-23T23:09:53.000Z",
            "duration": "2:53:07",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/peter-wang/?utm_source=rss&utm_medium=rss&utm_campaign=peter-wang",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_peter_wang.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4868",
            "index": 249,
            "title": "#249 – Albert Bourla: Pfizer CEO",
            "pub_date": "2021-12-18T15:04:38.000Z",
            "duration": "1:14:32",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://lexfridman.com/albert-bourla/?utm_source=rss&utm_medium=rss&utm_campaign=albert-bourla",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/albert_bourla_audio.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4864",
            "index": 250,
            "title": "#248 – Norman Naimark: Genocide, Stalin, Hitler, Mao, and Absolute Power",
            "pub_date": "2021-12-13T05:13:10.000Z",
            "duration": "2:25:24",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/norman-naimark/?utm_source=rss&utm_medium=rss&utm_campaign=norman-naimark",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_norman_naimark.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4861",
            "index": 251,
            "title": "#247 – Jamie Metzl: Lab Leak Theory",
            "pub_date": "2021-12-08T18:28:39.000Z",
            "duration": "5:01:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jamie-metzl/?utm_source=rss&utm_medium=rss&utm_campaign=jamie-metzl",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jamie_metzl.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4857",
            "index": 252,
            "title": "#246 – Peter Woit: Theories of Everything and Why String Theory is Not Even Wrong",
            "pub_date": "2021-12-03T20:27:34.000Z",
            "duration": "2:23:05",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/peter-woit/?utm_source=rss&utm_medium=rss&utm_campaign=peter-woit",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_peter_woit.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4854",
            "index": 253,
            "title": "#245 – Tom Brands: Iowa Wrestling",
            "pub_date": "2021-11-30T18:23:26.000Z",
            "duration": "1:03:16",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tom-brands/?utm_source=rss&utm_medium=rss&utm_campaign=tom-brands",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tom_brands.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4851",
            "index": 254,
            "title": "#244 – Robert Crews: Afghanistan, Taliban, Bin Laden, and War in the Middle East",
            "pub_date": "2021-11-28T21:11:14.000Z",
            "duration": "2:49:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/robert-crews/?utm_source=rss&utm_medium=rss&utm_campaign=robert-crews",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_robert_crews.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4847",
            "index": 255,
            "title": "#243 – Kevin Systrom: Instagram",
            "pub_date": "2021-11-23T20:55:28.000Z",
            "duration": "2:52:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/kevin-systrom/?utm_source=rss&utm_medium=rss&utm_campaign=kevin-systrom",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_kevin_systrom.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4843",
            "index": 256,
            "title": "#242 – Ben Askren: Wrestling and MMA",
            "pub_date": "2021-11-20T18:15:18.000Z",
            "duration": "2:21:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ben-askren/?utm_source=rss&utm_medium=rss&utm_campaign=ben-askren",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ben_askren.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4840",
            "index": 257,
            "title": "#241 – Boris Sofman: Waymo, Cozmo, Self-Driving Cars, and the Future of Robotics",
            "pub_date": "2021-11-16T23:17:58.000Z",
            "duration": "3:20:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "robotics",
              "automation"
            ],
            "page_url": "https://lexfridman.com/boris-sofman/?utm_source=rss&utm_medium=rss&utm_campaign=boris-sofman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_boris_sofman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4836",
            "index": 258,
            "title": "#240 – Neal Stephenson: Sci-Fi, Space, Aliens, AI, VR & the Future of Humanity",
            "pub_date": "2021-11-11T21:24:43.000Z",
            "duration": "2:47:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/neal-stephenson/?utm_source=rss&utm_medium=rss&utm_campaign=neal-stephenson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_neal_stephenson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4833",
            "index": 259,
            "title": "#239 – Niall Ferguson: History of Money, Power, War, and Truth",
            "pub_date": "2021-11-08T18:39:08.000Z",
            "duration": "2:48:49",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/niall-ferguson/?utm_source=rss&utm_medium=rss&utm_campaign=niall-ferguson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_niall_ferguson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4829",
            "index": 260,
            "title": "#238 – Francis Collins: National Institutes of Health (NIH)",
            "pub_date": "2021-11-05T20:30:24.000Z",
            "duration": "1:33:22",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/francis-collins/?utm_source=rss&utm_medium=rss&utm_campaign=francis-collins",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_francis_collins.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4826",
            "index": 261,
            "title": "#237 – Steve Viscelli: Trucking and the Decline of the American Dream",
            "pub_date": "2021-11-03T23:36:02.000Z",
            "duration": "3:19:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/steve-viscelli/?utm_source=rss&utm_medium=rss&utm_campaign=steve-viscelli",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_steve_viscelli.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4822",
            "index": 262,
            "title": "#236 – Jimmy Pedro: Judo and the Forging of Champions",
            "pub_date": "2021-10-31T23:26:56.000Z",
            "duration": "2:30:32",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jimmy-pedro/?utm_source=rss&utm_medium=rss&utm_campaign=jimmy-pedro",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jimmy_pedro.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4819",
            "index": 263,
            "title": "#235 – Michael Mina: Rapid COVID Testing",
            "pub_date": "2021-10-29T21:48:18.000Z",
            "duration": "1:53:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-mina-2/?utm_source=rss&utm_medium=rss&utm_campaign=michael-mina-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_mina_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4815",
            "index": 264,
            "title": "#234 – Stephen Wolfram: Complexity and the Fabric of Reality",
            "pub_date": "2021-10-27T00:16:41.000Z",
            "duration": "3:45:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/stephen-wolfram-3/?utm_source=rss&utm_medium=rss&utm_campaign=stephen-wolfram-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_stephen_wolfram_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4812",
            "index": 265,
            "title": "#233 – Carl Hart: Heroin, Cocaine, MDMA, Alcohol & the Role of Drugs in Society",
            "pub_date": "2021-10-23T17:11:38.000Z",
            "duration": "1:16:47",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/carl-hart/?utm_source=rss&utm_medium=rss&utm_campaign=carl-hart",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_carl_hart.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4809",
            "index": 266,
            "title": "#232 – Brian Greene: Quantum Gravity, Big Bang, Aliens, Life, Death, and Meaning",
            "pub_date": "2021-10-20T18:05:14.000Z",
            "duration": "1:52:11",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/brian-greene/?utm_source=rss&utm_medium=rss&utm_campaign=brian-greene",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_brian_greene.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4805",
            "index": 267,
            "title": "#231 – Alex Gladstein: Bitcoin, Authoritarianism, and Human Rights",
            "pub_date": "2021-10-16T21:23:02.000Z",
            "duration": "2:40:35",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/alex-gladstein/?utm_source=rss&utm_medium=rss&utm_campaign=alex-gladstein",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_alex_gladstein.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4802",
            "index": 268,
            "title": "#230 – Kelsi Sheren: War, Artillery, PTSD, and Love",
            "pub_date": "2021-10-14T23:44:42.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/kelsi-sheren/?utm_source=rss&utm_medium=rss&utm_campaign=kelsi-sheren",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_kelsi_sheren.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4799",
            "index": 269,
            "title": "#229 – Richard Wrangham: Role of Violence, Sex, and Fire in Human Evolution",
            "pub_date": "2021-10-10T19:08:05.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/richard-wrangham/?utm_source=rss&utm_medium=rss&utm_campaign=richard-wrangham",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_richard_wrangham.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4784",
            "index": 270,
            "title": "#228 – RZA: Wu-Tang Clan, Kung Fu, Chess, God, Life, and Death",
            "pub_date": "2021-10-05T22:06:26.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/rza/?utm_source=rss&utm_medium=rss&utm_campaign=rza",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_rza.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4781",
            "index": 271,
            "title": "#227 – Sean Kelly: Existentialism, Nihilism, and the Search for Meaning",
            "pub_date": "2021-09-30T23:51:37.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/sean-kelly/?utm_source=rss&utm_medium=rss&utm_campaign=sean-kelly",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sean_kelly.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4777",
            "index": 272,
            "title": "#226 – Jo Boaler: How to Learn Math",
            "pub_date": "2021-09-27T21:36:02.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jo-boaler/?utm_source=rss&utm_medium=rss&utm_campaign=jo-boaler",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jo_boaler.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4771",
            "index": 273,
            "title": "#225 – Jeffrey Shainline: Neuromorphic Computing and Optoelectronic Intelligence",
            "pub_date": "2021-09-26T23:16:52.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jeffrey-shainline/?utm_source=rss&utm_medium=rss&utm_campaign=jeffrey-shainline",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jeffrey_shainline.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4768",
            "index": 274,
            "title": "#224 – Travis Oliphant: NumPy, SciPy, Anaconda, Python & Scientific Programming",
            "pub_date": "2021-09-23T01:41:13.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/travis-oliphant/?utm_source=rss&utm_medium=rss&utm_campaign=travis-oliphant",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_audio_travis_oliphant.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4765",
            "index": 275,
            "title": "#223 – Travis Stevens: Judo, Olympics, and Mental Toughness",
            "pub_date": "2021-09-21T01:59:35.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/travis-stevens/?utm_source=rss&utm_medium=rss&utm_campaign=travis-stevens",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_travis_stevens.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4762",
            "index": 276,
            "title": "#222 – Jay McClelland: Neural Networks and the Emergence of Cognition",
            "pub_date": "2021-09-20T05:26:44.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jay-mcclelland/?utm_source=rss&utm_medium=rss&utm_campaign=jay-mcclelland",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jay_mcclelland.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4758",
            "index": 277,
            "title": "#221 – Douglas Lenat: Cyc and the Quest to Solve Common Sense Reasoning in AI",
            "pub_date": "2021-09-15T16:35:47.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "reasoning"
            ],
            "page_url": "https://lexfridman.com/douglas-lenat/?utm_source=rss&utm_medium=rss&utm_campaign=douglas-lenat",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_douglas_lenat.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4755",
            "index": 278,
            "title": "#220 – Niels Jorgensen: New York Firefighters and the Heroes of 9/11",
            "pub_date": "2021-09-11T21:12:40.000Z",
            "duration": "2:49:44",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/niels-jorgensen/?utm_source=rss&utm_medium=rss&utm_campaign=niels-jorgensen",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_niels_jorgensen.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4751",
            "index": 279,
            "title": "#219 – Donald Knuth: Programming, Algorithms, Hard Problems & the Game of Life",
            "pub_date": "2021-09-09T17:04:19.000Z",
            "duration": "2:27:39",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://lexfridman.com/donald-knuth-2/?utm_source=rss&utm_medium=rss&utm_campaign=donald-knuth-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_donald_knuth_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4748",
            "index": 280,
            "title": "#218 – Jaron Lanier: Virtual Reality, Social Media & the Future of Humans and AI",
            "pub_date": "2021-09-06T20:30:43.000Z",
            "duration": "1:58:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/jaron-lanier/?utm_source=rss&utm_medium=rss&utm_campaign=jaron-lanier",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jaron_lanier.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4745",
            "index": 281,
            "title": "#217 – Rodney Brooks: Robotics",
            "pub_date": "2021-09-03T21:32:27.000Z",
            "duration": "2:30:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/rodney-brooks/?utm_source=rss&utm_medium=rss&utm_campaign=rodney-brooks",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_rodney_brooks.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4742",
            "index": 282,
            "title": "#216 – Vincent Racaniello: Viruses and Vaccines",
            "pub_date": "2021-09-01T17:40:53.000Z",
            "duration": "3:35:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/vincent-racaniello/?utm_source=rss&utm_medium=rss&utm_campaign=vincent-racaniello",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_vincent_racaniello.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4738",
            "index": 283,
            "title": "#215 – Wojciech Zaremba: OpenAI Codex, GPT-3, Robotics, and the Future of AI",
            "pub_date": "2021-08-29T17:41:06.000Z",
            "duration": "2:58:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "safety",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/wojciech-zaremba/?utm_source=rss&utm_medium=rss&utm_campaign=wojciech-zaremba",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_wojciech_zaremba.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4735",
            "index": 284,
            "title": "#214 – Jed Buchwald: Isaac Newton and the Philosophy of Science",
            "pub_date": "2021-08-27T21:11:29.000Z",
            "duration": "1:58:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jed-buchwald/?utm_source=rss&utm_medium=rss&utm_campaign=jed-buchwald",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jed_buchwald.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4731",
            "index": 285,
            "title": "#213 – Barry Barish: Gravitational Waves and the Most Precise Device Ever Built",
            "pub_date": "2021-08-23T19:18:41.000Z",
            "duration": "2:30:12",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/barry-barish/?utm_source=rss&utm_medium=rss&utm_campaign=barry-barish",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_barry_barish.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4728",
            "index": 286,
            "title": "#212 – Joscha Bach: Nature of Reality, Dreams, and Consciousness",
            "pub_date": "2021-08-21T23:50:34.000Z",
            "duration": "3:18:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://lexfridman.com/joscha-bach-2/?utm_source=rss&utm_medium=rss&utm_campaign=joscha-bach-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_joscha_bach_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4723",
            "index": 287,
            "title": "#211 – Brian Muraresku: The Secret History of Psychedelics",
            "pub_date": "2021-08-15T01:55:25.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/brian-muraresku/?utm_source=rss&utm_medium=rss&utm_campaign=brian-muraresku",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_brian_muraresku.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4719",
            "index": 288,
            "title": "#210 – Matt Walker: Sleep",
            "pub_date": "2021-08-11T13:55:29.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/matt-walker/?utm_source=rss&utm_medium=rss&utm_campaign=matt-walker",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_matt_walker.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4714",
            "index": 289,
            "title": "#209 – Luís and João Batalha: Fermat’s Library and the Art of Studying Papers",
            "pub_date": "2021-08-09T03:15:55.000Z",
            "duration": "3:02:43",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/luis-and-joao-batalha/?utm_source=rss&utm_medium=rss&utm_campaign=luis-and-joao-batalha",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_luis_and_joao_batalha.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4711",
            "index": 290,
            "title": "#208 – Jeff Hawkins: The Thousand Brains Theory of Intelligence",
            "pub_date": "2021-08-08T04:30:20.000Z",
            "duration": "2:25:58",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/jeff-hawkins-2/?utm_source=rss&utm_medium=rss&utm_campaign=jeff-hawkins-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jeff_hawkins_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4708",
            "index": 291,
            "title": "#207 – Chris Duffin: The Mad Scientist of Strength",
            "pub_date": "2021-08-03T18:14:17.000Z",
            "duration": "2:48:34",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/chris-duffin/?utm_source=rss&utm_medium=rss&utm_campaign=chris-duffin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_chris_duffin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4703",
            "index": 292,
            "title": "#206 – Ishan Misra: Self-Supervised Deep Learning in Computer Vision",
            "pub_date": "2021-07-31T16:03:43.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning"
            ],
            "page_url": "https://lexfridman.com/ishan-misra/?utm_source=rss&utm_medium=rss&utm_campaign=ishan-misra",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ishan_misra.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4700",
            "index": 293,
            "title": "#205 – Zach Bitter: Ultramarathon Running",
            "pub_date": "2021-07-29T01:51:41.000Z",
            "duration": "3:06:51",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/zach-bitter/?utm_source=rss&utm_medium=rss&utm_campaign=zach-bitter",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_zach_bitter.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4697",
            "index": 294,
            "title": "#204 – Cumrun Vafa: String Theory",
            "pub_date": "2021-07-26T01:07:44.000Z",
            "duration": "2:18:36",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/cumrun-vafa/?utm_source=rss&utm_medium=rss&utm_campaign=cumrun-vafa",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_cumrun_vafa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4693",
            "index": 295,
            "title": "#203 – Anya Fernald: Regenerative Farming and the Art of Cooking Meat",
            "pub_date": "2021-07-23T23:09:58.000Z",
            "duration": "1:50:44",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/anya-fernald/?utm_source=rss&utm_medium=rss&utm_campaign=anya-fernald",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_anya_fernald.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4690",
            "index": 296,
            "title": "#202 – Rick Doblin: Psychedelics",
            "pub_date": "2021-07-21T02:24:45.000Z",
            "duration": "2:42:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/rick-doblin/?utm_source=rss&utm_medium=rss&utm_campaign=rick-doblin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_rick_doblin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4687",
            "index": 297,
            "title": "#201 – Konstantin Batygin: Planet 9 and the Edge of Our Solar System",
            "pub_date": "2021-07-19T05:23:11.000Z",
            "duration": "2:45:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/konstantin-batygin/?utm_source=rss&utm_medium=rss&utm_campaign=konstantin-batygin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_konstanin_botygin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4682",
            "index": 298,
            "title": "#200 – Michael Malice: Totalitarianism and Anarchy",
            "pub_date": "2021-07-15T15:38:27.000Z",
            "duration": "2:44:44",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-malice-3/?utm_source=rss&utm_medium=rss&utm_campaign=michael-malice-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_malice_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4679",
            "index": 299,
            "title": "#199 – Roger Reaves: Smuggling Drugs for Pablo Escobar and the Medellin Cartel",
            "pub_date": "2021-07-11T19:51:49.000Z",
            "duration": "2:15:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/roger-reaves/?utm_source=rss&utm_medium=rss&utm_campaign=roger-reaves",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_roger_reaves.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4676",
            "index": 300,
            "title": "#198 – Sara Walker: The Origin of Life on Earth and Alien Worlds",
            "pub_date": "2021-07-09T22:14:56.000Z",
            "duration": "2:05:18",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/sara-walker/?utm_source=rss&utm_medium=rss&utm_campaign=sara-walker",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sara_walker.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4673",
            "index": 301,
            "title": "#197 – Jocko Willink: War, Leadership, and Discipline",
            "pub_date": "2021-07-05T02:01:39.000Z",
            "duration": "2:03:29",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jocko-willink/?utm_source=rss&utm_medium=rss&utm_campaign=jocko-willink",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jocko_willink.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4669",
            "index": 302,
            "title": "#196 – Yeonmi Park: North Korea",
            "pub_date": "2021-07-01T03:23:58.000Z",
            "duration": "2:06:18",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/yeonmi-park/?utm_source=rss&utm_medium=rss&utm_campaign=yeonmi-park",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_yeonmi_park.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4666",
            "index": 303,
            "title": "#195 – Clara Sousa-Silva: Searching for Signs of Life on Venus and Other Planets",
            "pub_date": "2021-06-28T01:24:27.000Z",
            "duration": "2:04:29",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/clara-sousa-silva/?utm_source=rss&utm_medium=rss&utm_campaign=clara-sousa-silva",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_clara_sousa_silva.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4663",
            "index": 304,
            "title": "#194 – Bret Weinstein: Truth, Science, and Censorship in the Time of a Pandemic",
            "pub_date": "2021-06-25T23:34:22.000Z",
            "duration": "3:22:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/bret-weinstein/?utm_source=rss&utm_medium=rss&utm_campaign=bret-weinstein",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bret_weinstein.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4659",
            "index": 305,
            "title": "#193 – Rob Reid: The Existential Threat of Engineered Viruses and Lab Leaks",
            "pub_date": "2021-06-21T00:31:22.000Z",
            "duration": "3:05:11",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/rob-reid/?utm_source=rss&utm_medium=rss&utm_campaign=rob-reid",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_rob_reid.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4656",
            "index": 306,
            "title": "#192 – Charles Hoskinson: Cardano",
            "pub_date": "2021-06-16T15:38:35.000Z",
            "duration": "5:04:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/charles-hoskinson/?utm_source=rss&utm_medium=rss&utm_campaign=charles-hoskinson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_charles_hoskinson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4652",
            "index": 307,
            "title": "#191 – Daniel Schmachtenberger: Steering Civilization Away from Self-Destruction",
            "pub_date": "2021-06-14T07:03:23.000Z",
            "duration": "4:21:41",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/daniel-schmachtenberger/?utm_source=rss&utm_medium=rss&utm_campaign=daniel-schmachtenberger",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_daniel_schmachtenberger.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4649",
            "index": 308,
            "title": "#190 – Jordan Ellenberg: Mathematics of High-Dimensional Shapes and Geometries",
            "pub_date": "2021-06-13T03:12:52.000Z",
            "duration": "2:47:26",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/jordan-ellenberg/?utm_source=rss&utm_medium=rss&utm_campaign=jordan-ellenberg",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jordan_ellenberg.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4646",
            "index": 309,
            "title": "#189 – David Sinclair: Extending the Human Lifespan Beyond 100 Years",
            "pub_date": "2021-06-07T01:18:48.000Z",
            "duration": "1:49:35",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/david-sinclair/?utm_source=rss&utm_medium=rss&utm_campaign=david-sinclair",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_david_sinclair.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4642",
            "index": 310,
            "title": "#188 – Vitalik Buterin: Ethereum 2.0",
            "pub_date": "2021-06-03T21:07:04.000Z",
            "duration": "3:08:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://lexfridman.com/vitalik-buterin-2/?utm_source=rss&utm_medium=rss&utm_campaign=vitalik-buterin-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_vitalik_buterin_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4639",
            "index": 311,
            "title": "#187 – Frank Wilczek: Physics of Quarks, Dark Matter, Complexity, Life & Aliens",
            "pub_date": "2021-05-29T22:26:23.000Z",
            "duration": "2:30:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/frank-wilczek/?utm_source=rss&utm_medium=rss&utm_campaign=frank-wilczek",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_frank_wilczek.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4633",
            "index": 312,
            "title": "#186 – Bryan Johnson: Kernel Brain-Computer Interfaces",
            "pub_date": "2021-05-24T09:55:51.000Z",
            "duration": "2:37:11",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/bryan-johnson/?utm_source=rss&utm_medium=rss&utm_campaign=bryan-johnson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bryan_johnson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4630",
            "index": 313,
            "title": "#185 – Sam Harris: Consciousness, Free Will, Psychedelics, AI, UFOs, and Meaning",
            "pub_date": "2021-05-20T18:55:24.000Z",
            "duration": "3:23:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/sam-harris/?utm_source=rss&utm_medium=rss&utm_campaign=sam-harris",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sam_harris.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4627",
            "index": 314,
            "title": "#184 – Katherine de Kleer: Planets, Moons, and Asteroids in Our Solar System",
            "pub_date": "2021-05-17T09:40:46.000Z",
            "duration": "2:02:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/katherine-de-kleer/?utm_source=rss&utm_medium=rss&utm_campaign=katherine-de-kleer",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_katherine_de_kleer.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4621",
            "index": 315,
            "title": "#183 – Po-Shen Loh: Mathematics, Math Olympiad, Combinatorics & Contact Tracing",
            "pub_date": "2021-05-14T22:33:44.000Z",
            "duration": "2:27:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/po-shen-loh/?utm_source=rss&utm_medium=rss&utm_campaign=po-shen-loh",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_po_shen_loh.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4618",
            "index": 316,
            "title": "#182 – John Danaher: The Path to Mastery in Jiu Jitsu, Grappling, Judo, and MMA",
            "pub_date": "2021-05-09T18:51:09.000Z",
            "duration": "3:43:23",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/john-danaher/?utm_source=rss&utm_medium=rss&utm_campaign=john-danaher",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_john_danaher.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4612",
            "index": 317,
            "title": "#181 – Sergey Nazarov: Chainlink, Smart Contracts, and Oracle Networks",
            "pub_date": "2021-05-01T07:35:02.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/sergey-nazarov/?utm_source=rss&utm_medium=rss&utm_campaign=sergey-nazarov",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sergey_nazarov.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4609",
            "index": 318,
            "title": "#180 – Jeremi Suri: History of American Power",
            "pub_date": "2021-04-30T01:38:44.000Z",
            "duration": "2:14:56",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/jeremi-suri/?utm_source=rss&utm_medium=rss&utm_campaign=jeremi-suri",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jeremi_suri.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4605",
            "index": 319,
            "title": "#179 – Georges St-Pierre: The Science of Fighting",
            "pub_date": "2021-04-26T03:33:39.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/georges-st-pierre/?utm_source=rss&utm_medium=rss&utm_campaign=georges-st-pierre",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_georges_st_pierre.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4602",
            "index": 320,
            "title": "#178 – Michael Malice and Yaron Brook: Ayn Rand, Human Nature, and Anarchy",
            "pub_date": "2021-04-24T17:34:01.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-malice-and-yaron-brook/?utm_source=rss&utm_medium=rss&utm_campaign=michael-malice-and-yaron-brook",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_malice_and_yaron_brook.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4599",
            "index": 321,
            "title": "#177 – Risto Miikkulainen: Neuroevolution and Evolutionary Computation",
            "pub_date": "2021-04-19T05:08:44.000Z",
            "duration": "2:02:00",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/risto-miikkulainen/?utm_source=rss&utm_medium=rss&utm_campaign=risto-miikkulainen",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_risto_miikkulainen.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4595",
            "index": 322,
            "title": "#176 – Robert Breedlove: Philosophy of Bitcoin from First Principles",
            "pub_date": "2021-04-17T22:42:36.000Z",
            "duration": "4:09:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/robert-breedlove/?utm_source=rss&utm_medium=rss&utm_campaign=robert-breedlove",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_robert_breedlove.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4592",
            "index": 323,
            "title": "#175 – Yannis Pappas: History and Comedy",
            "pub_date": "2021-04-12T20:38:54.000Z",
            "duration": "1:57:02",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/yannis-pappas/?utm_source=rss&utm_medium=rss&utm_campaign=yannis-pappas",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_yannis_pappas.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4589",
            "index": 324,
            "title": "#174 – Tyler Cowen: Economic Growth and the Fight Against Conformity and Mediocrity",
            "pub_date": "2021-04-10T20:10:48.000Z",
            "duration": "2:15:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/tyler-cowen/?utm_source=rss&utm_medium=rss&utm_campaign=tyler-cowen",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tyler_cowen.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4585",
            "index": 325,
            "title": "#173 – Nic Carter: Bitcoin Core Values, Layered Scaling, and Blocksize Debates",
            "pub_date": "2021-04-01T02:12:34.000Z",
            "duration": "2:32:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/nic-carter/?utm_source=rss&utm_medium=rss&utm_campaign=nic-carter",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_nic_carter.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4582",
            "index": 326,
            "title": "#172 – Ryan Schiller: Librex and the Free Exchange of Ideas on College Campuses",
            "pub_date": "2021-03-30T06:47:13.000Z",
            "duration": "2:32:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ryan-schiller/?utm_source=rss&utm_medium=rss&utm_campaign=ryan-schiller",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ryan_schiller.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4578",
            "index": 327,
            "title": "#171 – Anthony Pompliano: Bitcoin",
            "pub_date": "2021-03-25T17:26:57.000Z",
            "duration": "3:08:49",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/anthony-pompliano/?utm_source=rss&utm_medium=rss&utm_campaign=anthony-pompliano",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_anthony_pompliano.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4575",
            "index": 328,
            "title": "#170 – Ronald Sullivan: The Ideal of Justice in the Face of Controversy and Evil",
            "pub_date": "2021-03-22T04:24:16.000Z",
            "duration": "1:51:23",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/ronald-sullivan/?utm_source=rss&utm_medium=rss&utm_campaign=ronald-sullivan",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ronald_sullivan.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4572",
            "index": 329,
            "title": "#169 – Ryan Hall: Solving Martial Arts from First Principles",
            "pub_date": "2021-03-20T21:14:02.000Z",
            "duration": "3:00:50",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/ryan-hall-2/?utm_source=rss&utm_medium=rss&utm_campaign=ryan-hall-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ryan_hall_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4568",
            "index": 330,
            "title": "#168 – Silvio Micali: Cryptocurrency, Blockchain, Algorand, Bitcoin, and Ethereum",
            "pub_date": "2021-03-15T04:55:40.000Z",
            "duration": "2:00:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/silvio-micali/?utm_source=rss&utm_medium=rss&utm_campaign=silvio-micali",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_silvio_micali.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4565",
            "index": 331,
            "title": "#167 – Saagar Enjeti: Politics, History, and Power",
            "pub_date": "2021-03-14T00:48:05.000Z",
            "duration": "3:16:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/saagar-enjeti/?utm_source=rss&utm_medium=rss&utm_campaign=saagar-enjeti",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_saagar_enjeti.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4562",
            "index": 332,
            "title": "#166 – Cal Newport: Deep Work, Focus, Productivity, Email, and Social Media",
            "pub_date": "2021-03-05T00:27:52.000Z",
            "duration": "3:09:25",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/cal-newport/?utm_source=rss&utm_medium=rss&utm_campaign=cal-newport",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_cal_newport.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4558",
            "index": 333,
            "title": "#165 – Josh Barnett: Philosophy of Violence, Power, and the Martial Arts",
            "pub_date": "2021-03-01T13:36:20.000Z",
            "duration": "2:18:29",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/josh-barnett/?utm_source=rss&utm_medium=rss&utm_campaign=josh-barnett",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_josh_barnett.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4555",
            "index": 334,
            "title": "#164 – Andrew Huberman: Sleep, Dreams, Creativity & the Limits of the Human Mind",
            "pub_date": "2021-02-28T16:59:51.000Z",
            "duration": "2:58:53",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/andrew-huberman-2/?utm_source=rss&utm_medium=rss&utm_campaign=andrew-huberman-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrew_huberman_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4552",
            "index": 335,
            "title": "#163 – Eric Weinstein: Difficult Conversations, Freedom of Speech, and Physics",
            "pub_date": "2021-02-23T05:36:12.000Z",
            "duration": "2:44:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/eric-weinstein-4/?utm_source=rss&utm_medium=rss&utm_campaign=eric-weinstein-4",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_eric_weinstein_4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4544",
            "index": 336,
            "title": "#162 – Jim Keller: The Future of Computing, AI, Life, and Consciousness",
            "pub_date": "2021-02-18T17:39:43.000Z",
            "duration": "2:44:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://lexfridman.com/jim-keller-2/?utm_source=rss&utm_medium=rss&utm_campaign=jim-keller-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jim_keller_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4530",
            "index": 337,
            "title": "#161 – Jason Calacanis: Startups, Angel Investing, Capitalism, and Friendship",
            "pub_date": "2021-02-15T14:07:29.000Z",
            "duration": "2:16:30",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/jason-calacanis/?utm_source=rss&utm_medium=rss&utm_campaign=jason-calacanis",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jason_calacanis.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4526",
            "index": 338,
            "title": "#160 – Brendan Eich: JavaScript, Firefox, Mozilla, and Brave",
            "pub_date": "2021-02-12T14:06:59.000Z",
            "duration": "3:04:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/brendan-eich/?utm_source=rss&utm_medium=rss&utm_campaign=brendan-eich",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_brendan_eich.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4523",
            "index": 339,
            "title": "#159 – Richard Craib: WallStreetBets, Numerai, and the Future of Stock Trading",
            "pub_date": "2021-02-07T23:20:51.000Z",
            "duration": "1:55:40",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/richard-craib/?utm_source=rss&utm_medium=rss&utm_campaign=richard-craib",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_richard_craib.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4520",
            "index": 340,
            "title": "#158 – Zev Weinstein: The Next Generation of Big Ideas and Brave Minds",
            "pub_date": "2021-02-05T19:59:53.000Z",
            "duration": "1:49:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/zev-weinstein/?utm_source=rss&utm_medium=rss&utm_campaign=zev-weinstein",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_zev_weinstein.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4514",
            "index": 341,
            "title": "#157 – Natalya Bailey: Rocket Engines and Electric Spacecraft Propulsion",
            "pub_date": "2021-02-01T14:15:06.000Z",
            "duration": "1:39:56",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/natalya-bailey/?utm_source=rss&utm_medium=rss&utm_campaign=natalya-bailey",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_natalya_bailey.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4511",
            "index": 342,
            "title": "#156 – Tim Dillon: Comedy, Power, Conspiracy Theories, and Freedom",
            "pub_date": "2021-01-29T22:22:59.000Z",
            "duration": "2:29:00",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/tim-dillon/?utm_source=rss&utm_medium=rss&utm_campaign=tim-dillon",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_tim_dillon.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4508",
            "index": 343,
            "title": "Lex Fridman: Ask Me Anything – AMA January 2021",
            "pub_date": "2021-01-27T18:11:23.000Z",
            "duration": "1:19:23",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://lexfridman.com/ama1/?utm_source=rss&utm_medium=rss&utm_campaign=ama1",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ama1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4503",
            "index": 344,
            "title": "#155 – Max Tegmark: AI and Physics",
            "pub_date": "2021-01-18T06:16:39.000Z",
            "duration": "3:08:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment",
              "safety"
            ],
            "page_url": "https://lexfridman.com/max-tegmark-2/?utm_source=rss&utm_medium=rss&utm_campaign=max-tegmark-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_max_tegmark_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4500",
            "index": 345,
            "title": "#154 – Avi Loeb: Aliens, Black Holes, and the Mystery of the Oumuamua",
            "pub_date": "2021-01-14T04:04:03.000Z",
            "duration": "2:51:24",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/avi-loeb/?utm_source=rss&utm_medium=rss&utm_campaign=avi-loeb",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_avi_loeb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4496",
            "index": 346,
            "title": "#153 – Dmitry Korkin: Evolution of Proteins, Viruses, Life, and AI",
            "pub_date": "2021-01-11T10:49:20.000Z",
            "duration": "2:18:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/dmitry-korkin-2/?utm_source=rss&utm_medium=rss&utm_campaign=dmitry-korkin-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dmitry_korkin_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4493",
            "index": 347,
            "title": "#152 – Dan Gable: Olympic Wrestling, Mental Toughness & the Making of Champions",
            "pub_date": "2021-01-09T23:07:40.000Z",
            "duration": "1:16:40",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/dan-gable/?utm_source=rss&utm_medium=rss&utm_campaign=dan-gable",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dan_gable.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4490",
            "index": 348,
            "title": "#151 – Dan Kokotov: Speech Recognition with AI and Humans",
            "pub_date": "2021-01-04T09:25:10.000Z",
            "duration": "1:34:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/dan-kokotov/?utm_source=rss&utm_medium=rss&utm_campaign=dan-kokotov",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dan_kokotov.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4484",
            "index": 349,
            "title": "#150 – Michael Malice: The White Pill, Freedom, Hope, and Happiness Amidst Chaos",
            "pub_date": "2020-12-31T23:08:49.000Z",
            "duration": "3:09:25",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-malice-2/?utm_source=rss&utm_medium=rss&utm_campaign=michael-malice-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_malice_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4481",
            "index": 350,
            "title": "#149 – Diana Walsh Pasulka: Aliens, Technology, Religion, and the Nature of Belief",
            "pub_date": "2020-12-28T04:33:48.000Z",
            "duration": "3:01:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/diana-walsh-pasulka/?utm_source=rss&utm_medium=rss&utm_campaign=diana-walsh-pasulka",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_diana_walsh_pasulka.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4478",
            "index": 351,
            "title": "#148 – Charles Isbell and Michael Littman: Machine Learning and Education",
            "pub_date": "2020-12-26T17:05:48.000Z",
            "duration": "2:03:22",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/charles-isbell-and-michael-littman/?utm_source=rss&utm_medium=rss&utm_campaign=charles-isbell-and-michael-littman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_charles_isbell_and_michael_littman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4474",
            "index": 352,
            "title": "#147 – Dmitri Dolgov: Waymo and the Future of Self-Driving Cars",
            "pub_date": "2020-12-20T23:26:15.000Z",
            "duration": "2:28:50",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://lexfridman.com/dmitri-dolgov/?utm_source=rss&utm_medium=rss&utm_campaign=dmitri-dolgov",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dmitri_dolgov.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4471",
            "index": 353,
            "title": "#146 – Michael Mina: Rapid Testing, Viruses, and the Engineering Mindset",
            "pub_date": "2020-12-19T02:18:32.000Z",
            "duration": "2:19:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-mina/?utm_source=rss&utm_medium=rss&utm_campaign=michael-mina",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_mina.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4468",
            "index": 354,
            "title": "#145 – Matthew Johnson: Psychedelics",
            "pub_date": "2020-12-14T07:25:34.000Z",
            "duration": "3:39:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/matthew-johnson/?utm_source=rss&utm_medium=rss&utm_campaign=matthew-johnson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_matthew_johnson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4464",
            "index": 355,
            "title": "#144 – Michael Littman: Reinforcement Learning and the Future of AI",
            "pub_date": "2020-12-13T04:29:13.000Z",
            "duration": "2:01:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://lexfridman.com/michael-littman/?utm_source=rss&utm_medium=rss&utm_campaign=michael-littman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_littman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4461",
            "index": 356,
            "title": "#143 – John Clarke: The Art of Fighting and the Pursuit of Excellence",
            "pub_date": "2020-12-06T18:54:35.000Z",
            "duration": "3:00:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/john-clarke/?utm_source=rss&utm_medium=rss&utm_campaign=john-clarke",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_john_clarke.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4456",
            "index": 357,
            "title": "#142 – Manolis Kellis: Meaning of Life, the Universe, and Everything",
            "pub_date": "2020-11-30T19:17:57.000Z",
            "duration": "",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/manolis-kellis-4/?utm_source=rss&utm_medium=rss&utm_campaign=manolis-kellis-4",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_manolis_kellis_4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4453",
            "index": 358,
            "title": "#141 – Erik Brynjolfsson: Economics of AI, Social Networks, and Technology",
            "pub_date": "2020-11-25T17:57:38.000Z",
            "duration": "1:45:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/erik-brynjolfsson/?utm_source=rss&utm_medium=rss&utm_campaign=erik-brynjolfsson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_erik_brynjolfsson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4449",
            "index": 359,
            "title": "#140 – Lisa Feldman Barrett: Love, Evolution, and the Human Brain",
            "pub_date": "2020-11-20T17:51:17.000Z",
            "duration": "2:21:04",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/lisa-feldman-barrett-2/?utm_source=rss&utm_medium=rss&utm_campaign=lisa-feldman-barrett-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_lisa_feldman_barrett_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4446",
            "index": 360,
            "title": "#139 – Andrew Huberman: Neuroscience of Optimal Performance",
            "pub_date": "2020-11-16T16:02:15.000Z",
            "duration": "2:36:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/andrew-huberman/?utm_source=rss&utm_medium=rss&utm_campaign=andrew-huberman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_andrew_huberman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4442",
            "index": 361,
            "title": "#138 – Yaron Brook: Ayn Rand and the Philosophy of Objectivism",
            "pub_date": "2020-11-13T14:36:43.000Z",
            "duration": "2:53:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/yaron-brook/?utm_source=rss&utm_medium=rss&utm_campaign=yaron-brook",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_yaron_brook.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4439",
            "index": 362,
            "title": "#137 – Alex Filippenko: Supernovae, Dark Energy, Aliens & the Expanding Universe",
            "pub_date": "2020-11-08T00:02:56.000Z",
            "duration": "2:40:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/alex-filippenko/?utm_source=rss&utm_medium=rss&utm_campaign=alex-filippenko",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_alex_filippenko.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4435",
            "index": 363,
            "title": "#136 – Dan Carlin: Hardcore History",
            "pub_date": "2020-11-03T03:06:21.000Z",
            "duration": "3:26:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/dan-carlin/?utm_source=rss&utm_medium=rss&utm_campaign=dan-carlin",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dan_carlin.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4432",
            "index": 364,
            "title": "#135 – Charles Isbell: Computing, Interactive AI, and Race in America",
            "pub_date": "2020-11-02T00:51:41.000Z",
            "duration": "2:28:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/charles-isbell/?utm_source=rss&utm_medium=rss&utm_campaign=charles-isbell",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_charles_isbell.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4428",
            "index": 365,
            "title": "#134 – Eric Weinstein: On the Nature of Good and Evil, Genius and Madness",
            "pub_date": "2020-10-30T03:56:27.000Z",
            "duration": "2:57:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/eric-weinstein-3/?utm_source=rss&utm_medium=rss&utm_campaign=eric-weinstein-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_eric_weinstein_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4423",
            "index": 366,
            "title": "#133 – Manolis Kellis: Biology of Disease",
            "pub_date": "2020-10-25T23:12:31.000Z",
            "duration": "2:40:24",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/manolis-kellis-3/?utm_source=rss&utm_medium=rss&utm_campaign=manolis-kellis-3",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_manolis_kellis_3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4420",
            "index": 367,
            "title": "#132 – George Hotz: Hacking the Simulation & Learning to Drive with Neural Nets",
            "pub_date": "2020-10-22T01:08:41.000Z",
            "duration": "3:13:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://lexfridman.com/george-hotz-2/?utm_source=rss&utm_medium=rss&utm_campaign=george-hotz-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_george_hotz_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4415",
            "index": 368,
            "title": "#131 – Chris Lattner: The Future of Computing and Programming Languages",
            "pub_date": "2020-10-19T01:56:41.000Z",
            "duration": "2:47:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/chris-lattner-2/?utm_source=rss&utm_medium=rss&utm_campaign=chris-lattner-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_chris_lattner_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4412",
            "index": 369,
            "title": "#130 – Scott Aaronson: Computational Complexity and Consciousness",
            "pub_date": "2020-10-12T06:19:23.000Z",
            "duration": "1:56:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/scott-aaronson-2/?utm_source=rss&utm_medium=rss&utm_campaign=scott-aaronson-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_scott_aaronson_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4408",
            "index": 370,
            "title": "#129 – Lisa Feldman Barrett: Counterintuitive Ideas About How the Brain Works",
            "pub_date": "2020-10-04T17:03:58.000Z",
            "duration": "2:24:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/lisa-feldman-barrett/?utm_source=rss&utm_medium=rss&utm_campaign=lisa-feldman-barrett",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_lisa_feldman_barrett.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4403",
            "index": 371,
            "title": "#128 – Michael Malice: Anarchy, Democracy, Libertarianism, Love, and Trolling",
            "pub_date": "2020-10-02T15:15:51.000Z",
            "duration": "3:24:34",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/michael-malice/?utm_source=rss&utm_medium=rss&utm_campaign=michael-malice",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_michael_malice.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4398",
            "index": 372,
            "title": "#127 – Joe Rogan: Conversations, Ideas, Love, Freedom & The Joe Rogan Experience",
            "pub_date": "2020-09-26T17:00:48.000Z",
            "duration": "1:19:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/joe-rogan/?utm_source=rss&utm_medium=rss&utm_campaign=joe-rogan",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_joe_rogan.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4395",
            "index": 373,
            "title": "#126 – James Gosling: Java, JVM, Emacs, and the Early Days of Computing",
            "pub_date": "2020-09-24T14:31:26.000Z",
            "duration": "1:51:28",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "coding"
            ],
            "page_url": "https://lexfridman.com/james-gosling/?utm_source=rss&utm_medium=rss&utm_campaign=james-gosling",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_james_gosling.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4391",
            "index": 374,
            "title": "#125 – Ryan Hall: Martial Arts and the Philosophy of Violence, Power, and Grace",
            "pub_date": "2020-09-20T21:50:08.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://lexfridman.com/ryan-hall/?utm_source=rss&utm_medium=rss&utm_campaign=ryan-hall",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ryan_hall.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4388",
            "index": 375,
            "title": "#124 – Stephen Wolfram: Fundamental Theory of Physics, Life, and the Universe",
            "pub_date": "2020-09-15T23:36:19.000Z",
            "duration": "4:24:06",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/stephen-wolfram-2/?utm_source=rss&utm_medium=rss&utm_campaign=stephen-wolfram-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_stephen_wolfram_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4383",
            "index": 376,
            "title": "#123 – Manolis Kellis: Origin of Life, Humans, Ideas, Suffering, and Happiness",
            "pub_date": "2020-09-12T18:29:51.000Z",
            "duration": "2:11:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/manolis-kellis-2/?utm_source=rss&utm_medium=rss&utm_campaign=manolis-kellis-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_manolis_kellis_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4380",
            "index": 377,
            "title": "#122 – David Fravor: UFOs, Aliens, Fighter Jets, and Aerospace Engineering",
            "pub_date": "2020-09-08T16:14:41.000Z",
            "duration": "3:56:51",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/david-fravor/?utm_source=rss&utm_medium=rss&utm_campaign=david-fravor",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_david_fravor.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4377",
            "index": 378,
            "title": "Lex Solo #3 – In Memory of My Grandmother",
            "pub_date": "2020-09-07T20:59:01.000Z",
            "duration": "18:22",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/lex-solo-grandmother/?utm_source=rss&utm_medium=rss&utm_campaign=lex-solo-grandmother",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_solo_grandmother.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4374",
            "index": 379,
            "title": "#121 – Eugenia Kuyda: Friendship with an AI Companion",
            "pub_date": "2020-09-05T17:31:13.000Z",
            "duration": "3:01:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/eugenia-kuyda/?utm_source=rss&utm_medium=rss&utm_campaign=eugenia-kuyda",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_eugenia_kuyda.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4368",
            "index": 380,
            "title": "Lex Solo #2 – The Future of Neuralink",
            "pub_date": "2020-09-01T19:45:29.000Z",
            "duration": "33:53",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/lex-solo-neuralink/?utm_source=rss&utm_medium=rss&utm_campaign=lex-solo-neuralink",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_solo_neuralink.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4365",
            "index": 381,
            "title": "#120 – François Chollet: Measures of Intelligence",
            "pub_date": "2020-08-31T00:10:34.000Z",
            "duration": "2:34:47",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/francois-chollet-2/?utm_source=rss&utm_medium=rss&utm_campaign=francois-chollet-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_francois_chollet_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4359",
            "index": 382,
            "title": "#119 – David Eagleman: Neuroplasticity and the Livewired Brain",
            "pub_date": "2020-08-26T14:02:09.000Z",
            "duration": "1:41:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/david-eagleman/?utm_source=rss&utm_medium=rss&utm_campaign=david-eagleman",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_david_eagleman.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4355",
            "index": 383,
            "title": "New Name: Lex Fridman Podcast",
            "pub_date": "2020-08-24T23:40:32.000Z",
            "duration": "2:01",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/lex-fridman-podcast-new-name/?utm_source=rss&utm_medium=rss&utm_campaign=lex-fridman-podcast-new-name",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_fridman_podcast_new_name.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4351",
            "index": 384,
            "title": "#118 – Grant Sanderson: Math, Manim, Neural Networks & Teaching with 3Blue1Brown",
            "pub_date": "2020-08-23T22:43:27.000Z",
            "duration": "2:08:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://lexfridman.com/grant-sanderson-2/?utm_source=rss&utm_medium=rss&utm_campaign=grant-sanderson-2",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_grant_sanderson_2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4346",
            "index": 385,
            "title": "#117 – Sheldon Solomon: Death and Meaning",
            "pub_date": "2020-08-20T23:13:46.000Z",
            "duration": "2:56:51",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/sheldon-solomon/?utm_source=rss&utm_medium=rss&utm_campaign=sheldon-solomon",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sheldon_solomon.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4338",
            "index": 386,
            "title": "#116 – Sara Seager: Search for Planets and Life Outside Our Solar System",
            "pub_date": "2020-08-16T20:12:23.000Z",
            "duration": "1:42:02",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/sara-seager/?utm_source=rss&utm_medium=rss&utm_campaign=sara-seager",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sara_seager.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4335",
            "index": 387,
            "title": "#115 – Dileep George: Brain-Inspired AI",
            "pub_date": "2020-08-14T22:51:34.000Z",
            "duration": "2:10:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/dileep-george/?utm_source=rss&utm_medium=rss&utm_campaign=dileep-george",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_dileep_george.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4332",
            "index": 388,
            "title": "#114 – Russ Tedrake: Underactuated Robotics, Control, Dynamics and Touch",
            "pub_date": "2020-08-09T16:30:42.000Z",
            "duration": "2:49:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/russ-tedrake/?utm_source=rss&utm_medium=rss&utm_campaign=russ-tedrake",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_russ_tedrake.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4328",
            "index": 389,
            "title": "#113 – Manolis Kellis: Human Genome and Evolutionary Dynamics",
            "pub_date": "2020-07-31T13:20:37.000Z",
            "duration": "2:29:51",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/manolis-kellis/?utm_source=rss&utm_medium=rss&utm_campaign=manolis-kellis",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_manolis_kellis.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4324",
            "index": 390,
            "title": "#112 – Ian Hutchinson: Nuclear Fusion, Plasma Physics, and Religion",
            "pub_date": "2020-07-29T17:01:15.000Z",
            "duration": "2:01:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://lexfridman.com/ian-hutchinson/?utm_source=rss&utm_medium=rss&utm_campaign=ian-hutchinson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ian_hutchinson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4320",
            "index": 391,
            "title": "#111 – Richard Karp: Algorithms and Computational Complexity",
            "pub_date": "2020-07-26T15:49:07.000Z",
            "duration": "2:08:00",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/richard-karp/?utm_source=rss&utm_medium=rss&utm_campaign=richard-karp",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_richard_karp.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4316",
            "index": 392,
            "title": "#110 – Jitendra Malik: Computer Vision",
            "pub_date": "2020-07-21T23:16:54.000Z",
            "duration": "1:42:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://lexfridman.com/jitendra-malik/?utm_source=rss&utm_medium=rss&utm_campaign=jitendra-malik",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_jitendra_malik.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4313",
            "index": 393,
            "title": "#109 – Brian Kernighan: UNIX, C, AWK, AMPL, and Go Programming",
            "pub_date": "2020-07-18T21:28:25.000Z",
            "duration": "1:43:37",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/brian-kernighan/?utm_source=rss&utm_medium=rss&utm_campaign=brian-kernighan",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_brian_kernighan.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4309",
            "index": 394,
            "title": "#108 – Sergey Levine: Robotics and Machine Learning",
            "pub_date": "2020-07-14T15:59:56.000Z",
            "duration": "1:37:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/sergey-levine/?utm_source=rss&utm_medium=rss&utm_campaign=sergey-levine",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_sergey_levine.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4303",
            "index": 395,
            "title": "#107 – Peter Singer: Suffering in Humans, Animals, and AI",
            "pub_date": "2020-07-08T14:40:18.000Z",
            "duration": "1:09:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://lexfridman.com/peter-singer/?utm_source=rss&utm_medium=rss&utm_campaign=peter-singer",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_peter_singer.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4277",
            "index": 396,
            "title": "#106 – Matt Botvinick: Neuroscience, Psychology, and AI at DeepMind",
            "pub_date": "2020-07-03T15:08:10.000Z",
            "duration": "2:01:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "deepmind"
            ],
            "page_url": "https://lexfridman.com/matt-botvinick/?utm_source=rss&utm_medium=rss&utm_campaign=matt-botvinick",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_matt_botvinick.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4273",
            "index": 397,
            "title": "#105 – Robert Langer: Edison of Medicine",
            "pub_date": "2020-06-30T22:04:00.000Z",
            "duration": "1:02:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/robert-langer/?utm_source=rss&utm_medium=rss&utm_campaign=robert-langer",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_bob_langer.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4269",
            "index": 398,
            "title": "#104 – David Patterson: Computer Architecture and Data Storage",
            "pub_date": "2020-06-27T19:20:23.000Z",
            "duration": "1:50:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chips"
            ],
            "page_url": "https://lexfridman.com/david-patterson/?utm_source=rss&utm_medium=rss&utm_campaign=david-patterson",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_david_patterson.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4266",
            "index": 399,
            "title": "#103 – Ben Goertzel: Artificial General Intelligence",
            "pub_date": "2020-06-22T17:21:26.000Z",
            "duration": "4:09:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "robotics"
            ],
            "page_url": "https://lexfridman.com/ben-goertzel/?utm_source=rss&utm_medium=rss&utm_campaign=ben-goertzel",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_ben_goertzel.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "https://lexfridman.com/?p=4262",
            "index": 400,
            "title": "#102 – Steven Pressfield: The War of Art",
            "pub_date": "2020-06-20T17:48:10.000Z",
            "duration": "1:27:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://lexfridman.com/steven-pressfield/?utm_source=rss&utm_medium=rss&utm_campaign=steven-pressfield",
            "audio_url": "https://media.blubrry.com/takeituneasy/content.blubrry.com/takeituneasy/lex_ai_steven_pressfield.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "mlst",
        "title": "Machine Learning Street Talk",
        "feed_title": "Machine Learning Street Talk (MLST)",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "ML research",
          "AGI",
          "cognitive science",
          "AI safety"
        ],
        "feed_url": "https://anchor.fm/s/1e4a0eac/podcast/rss",
        "source_url": "https://anchor.fm/s/1e4a0eac/podcast/rss",
        "detail_path": "/podcasts/mlst/",
        "episode_count": 200,
        "selected_episode_count": 187,
        "latest_episode_title": "When AI Decides You're a Threat — Brad Carson",
        "latest_pub_date": "2026-05-31T07:18:02.000Z",
        "latest_page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/When-AI-Decides-Youre-a-Threat--Brad-Carson-e3k4a04",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "d684c5db-fa5a-48b3-a483-62ec4e15fc6d",
            "index": 1,
            "title": "When AI Decides You're a Threat — Brad Carson",
            "pub_date": "2026-05-31T07:18:02.000Z",
            "duration": "01:20:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "anthropic",
              "claude",
              "chip",
              "chips"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/When-AI-Decides-Youre-a-Threat--Brad-Carson-e3k4a04",
            "audio_url": "https://traffic.megaphone.fm/APO3666479479.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75350a3e-70ad-4af4-bbd0-5181b520e22b",
            "index": 2,
            "title": "Intelligence is collective, not artificial — Prof. Michael I. Jordan (UC Berkeley / Inria)",
            "pub_date": "2026-05-21T12:29:21.000Z",
            "duration": "01:17:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "inference",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Intelligence-is-collective--not-artificial--Prof--Michael-I--Jordan-UC-Berkeley--Inria-e3jkvil",
            "audio_url": "https://traffic.megaphone.fm/APO9545207589.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70520b9f-a961-4443-879f-b47b1baaea78",
            "index": 3,
            "title": "The AI Models Smart Enough to Know They're Cheating — Beth Barnes & David Rein [METR]",
            "pub_date": "2026-05-04T12:14:27.000Z",
            "duration": "01:53:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "frontier model",
              "agent",
              "agents",
              "openai",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-AI-Models-Smart-Enough-to-Know-Theyre-Cheating--Beth-Barnes--David-Rein-METR-e3iruda",
            "audio_url": "https://traffic.megaphone.fm/APO3788586647.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 98,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 15,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "a45b8877-0a03-4410-9846-886d2c2a41bb",
            "index": 4,
            "title": "When AI Discovers The Next Transformer - Robert Lange (Sakana)",
            "pub_date": "2026-03-13T21:04:39.000Z",
            "duration": "01:18:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model",
              "agent",
              "agents",
              "agentic",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/When-AI-Discovers-The-Next-Transformer---Robert-Lange-Sakana-e3gdghe",
            "audio_url": "https://traffic.megaphone.fm/APO5182281422.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 116,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "900fe43b-34a0-4263-9352-f9c9e3036710",
            "index": 5,
            "title": "\"Vibe Coding is a Slot Machine\" - Jeremy Howard",
            "pub_date": "2026-03-03T15:38:38.000Z",
            "duration": "01:26:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "anthropic",
              "claude",
              "deepmind",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Vibe-Coding-is-a-Slot-Machine---Jeremy-Howard-e3fsh5e",
            "audio_url": "https://traffic.megaphone.fm/APO4708406418.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 142,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "37176ce1-a57d-4333-af2b-bd7ed26fd02b",
            "index": 6,
            "title": "Evolution \"Doesn't Need\" Mutation - Blaise Agüera y Arcas",
            "pub_date": "2026-02-16T08:00:26.000Z",
            "duration": "00:55:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Evolution-Doesnt-Need-Mutation---Blaise-Agera-y-Arcas-e3f5d8f",
            "audio_url": "https://traffic.megaphone.fm/APO6748687122.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e51c0c84-f709-44b4-b7b0-9ed8d2b0cb42",
            "index": 7,
            "title": "VAEs Are Energy-Based Models? [Dr. Jeff Beck]",
            "pub_date": "2026-01-25T10:15:12.000Z",
            "duration": "00:46:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "inference",
              "training",
              "reasoning",
              "safety",
              "embedding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/VAEs-Are-Energy-Based-Models--Dr--Jeff-Beck-e3e55j3",
            "audio_url": "https://traffic.megaphone.fm/APO9907603727.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 62,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "59c0fecb-f78b-4197-97a7-1f6e15028ea9",
            "index": 8,
            "title": "Abstraction & Idealization: AI's Plato Problem [Mazviita Chirimuuta]",
            "pub_date": "2026-01-23T11:16:08.000Z",
            "duration": "00:53:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Abstraction--Idealization-AIs-Plato-Problem-Mazviita-Chirimuuta-e3e2nk2",
            "audio_url": "https://traffic.megaphone.fm/APO5086652450.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "536ae6c8-bbd3-425b-969f-65e25c673d90",
            "index": 9,
            "title": "Why Every Brain Metaphor in History Has Been Wrong [SPECIAL EDITION]",
            "pub_date": "2026-01-23T10:34:57.000Z",
            "duration": "00:42:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Why-Every-Brain-Metaphor-in-History-Has-Been-Wrong-SPECIAL-EDITION-e3e2n9d",
            "audio_url": "https://traffic.megaphone.fm/APO9562112635.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 45,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "e43e3788-5d55-4e10-94a9-e5df4c166a68",
            "index": 10,
            "title": "Bayesian Brain, Scientific Method, and Models [Dr. Jeff Beck]",
            "pub_date": "2025-12-31T19:48:47.000Z",
            "duration": "01:16:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "deepmind",
              "inference",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Bayesian-Brain--Scientific-Method--and-Models-Dr--Jeff-Beck-e3d1fle",
            "audio_url": "https://traffic.megaphone.fm/APO1104619714.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 77,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "86553cae-172d-46c8-ad6f-fe3eb01af737",
            "index": 11,
            "title": "Your Brain is Running a Simulation Right Now [Max Bennett]",
            "pub_date": "2025-12-30T07:26:36.000Z",
            "duration": "03:17:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "inference",
              "training",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Your-Brain-is-Running-a-Simulation-Right-Now-Max-Bennett-e3cvce2",
            "audio_url": "https://traffic.megaphone.fm/APO4908706053.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 111,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "bd9c4159-2dec-4a95-af06-e7a92faea686",
            "index": 12,
            "title": "The 3 Laws of Knowledge [César Hidalgo]",
            "pub_date": "2025-12-27T18:39:56.000Z",
            "duration": "01:37:05",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-3-Laws-of-Knowledge-Csar-Hidalgo-e3cs8s7",
            "audio_url": "https://traffic.megaphone.fm/APO3489453691.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0ff34341-7c39-4bee-b3a3-c8fc4ae25c8b",
            "index": 13,
            "title": "\"I Desperately Want To Live In The Matrix\" - Dr. Mike Israetel",
            "pub_date": "2025-12-24T12:57:22.000Z",
            "duration": "02:55:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agentic",
              "anthropic",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/I-Desperately-Want-To-Live-In-The-Matrix---Dr--Mike-Israetel-e3cpaii",
            "audio_url": "https://traffic.megaphone.fm/APO7040529835.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 198,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "4c94188d-7a08-473c-8eda-c95faaee0dca",
            "index": 14,
            "title": "Making deep learning perform real algorithms with Category Theory (Andrew Dudzik, Petar Velichkovich, Taco Cohen, Bruno Gavranović, Paul Lessard)",
            "pub_date": "2025-12-22T15:01:13.000Z",
            "duration": "00:43:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "chatgpt",
              "deepmind",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Making-deep-learning-perform-real-algorithms-with-Category-Theory-Andrew-Dudzik--Petar-Velichkovich--Taco-Cohen--Bruno-Gavranovi--Paul-Lessard-e3cmhua",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/112985482/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-22%2F414834607-44100-2-d15a91341d3b9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 41,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8fa1483b-896e-4f90-949b-81a7ae9762ed",
            "index": 15,
            "title": "Are AI Benchmarks Telling The Full Story? [SPONSORED] (Andrew Gordon and Nora Petrova - Prolific)",
            "pub_date": "2025-12-20T20:55:39.000Z",
            "duration": "00:16:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "grok",
              "training",
              "reasoning",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Are-AI-Benchmarks-Telling-The-Full-Story--SPONSORED-Andrew-Gordon-and-Nora-Petrova---Prolific-e3cki05",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/112920005/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-20%2F414752147-44100-2-35b0a4dd3d9ed.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 137,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6309cd81-ec51-41b6-bec6-1179c26d81ca",
            "index": 16,
            "title": "The Mathematical Foundations of Intelligence [Professor Yi Ma]",
            "pub_date": "2025-12-13T22:15:08.000Z",
            "duration": "01:39:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Mathematical-Foundations-of-Intelligence-Professor-Yi-Ma-e3cagbg",
            "audio_url": "https://traffic.megaphone.fm/APO7958079645.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 1023,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "debf8b10-0cf7-4ba7-a702-408bc4480bb4",
            "index": 17,
            "title": "Pedro Domingos: Tensor Logic Unifies AI Paradigms",
            "pub_date": "2025-12-08T00:36:44.000Z",
            "duration": "01:27:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "openai",
              "reasoning",
              "embedding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Pedro-Domingos-Tensor-Logic-Unifies-AI-Paradigms-e3c16cv",
            "audio_url": "https://traffic.megaphone.fm/APO5329966811.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 103,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "29d987a7-8718-4f28-be32-b04616951736",
            "index": 18,
            "title": "He Co-Invented the Transformer. Now: Continuous Thought Machines - Llion Jones and Luke Darlow [Sakana AI]",
            "pub_date": "2025-11-23T17:36:59.000Z",
            "duration": "01:12:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "chatgpt",
              "anthropic",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/He-Co-Invented-the-Transformer--Now-Continuous-Thought-Machines---Llion-Jones-and-Luke-Darlow-Sakana-AI-e3bbt96",
            "audio_url": "https://traffic.megaphone.fm/APO6903071163.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 80,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1062ebe0-6a34-43cc-bea2-cbfabe2c52f0",
            "index": 19,
            "title": "Why Humans Are Still Powering AI [Sponsored]",
            "pub_date": "2025-11-03T00:42:52.000Z",
            "duration": "00:24:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Why-Humans-Are-Still-Powering-AI-Sponsored-e3adil7",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/110594151/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-3%2F410469693-44100-2-84c3cf16ac6e7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "912b42eb-c444-4f87-9c8d-0859806c191f",
            "index": 20,
            "title": "The Universal Hierarchy of Life - Prof. Chris Kempes [SFI]",
            "pub_date": "2025-10-25T10:52:43.000Z",
            "duration": "00:40:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Universal-Hierarchy-of-Life---Prof--Chris-Kempes-SFI-e3a17m6",
            "audio_url": "https://traffic.megaphone.fm/APO3213100229.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 499,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e66db573-9f5c-4ef8-aae5-c0e9bfff1d95",
            "index": 21,
            "title": "Google Researcher Shows Life \"Emerges From Code\" - Blaise Agüera y Arcas",
            "pub_date": "2025-10-21T17:02:31.000Z",
            "duration": "00:59:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Google-Researcher-Shows-Life-Emerges-From-Code---Blaise-Agera-y-Arcas-e39rm3j",
            "audio_url": "https://traffic.megaphone.fm/APO2492909630.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 586,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e1ff02ca-df6a-4672-991f-d0443a7c834c",
            "index": 22,
            "title": "The Secret Engine of AI - Prolific [Sponsored] (Sara Saab, Enzo Blindow)",
            "pub_date": "2025-10-18T14:23:27.000Z",
            "duration": "01:19:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "anthropic",
              "grok",
              "reasoning",
              "evals"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Secret-Engine-of-AI---Prolific-Sponsored-Sara-Saab--Enzo-Blindow-e39msv5",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/109851045/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-18%2F409496718-44100-2-9497dd37cc303.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 128,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 19,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "7c125595-39ca-4fe2-9fb9-2081d4a7802e",
            "index": 23,
            "title": "AI Agents Can Code 10,000 Lines of Hacking Tools In Seconds - Dr. Ilia Shumailov (ex-GDM)",
            "pub_date": "2025-10-04T06:55:01.000Z",
            "duration": "01:01:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "deepmind"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/AI-Agents-Can-Code-10-000-Lines-of-Hacking-Tools-In-Seconds---Dr--Ilia-Shumailov-ex-GDM-e392tna",
            "audio_url": "https://traffic.megaphone.fm/APO3359132879.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0d9aa259-2017-4a88-a089-4aabf36f116e",
            "index": 24,
            "title": "New top score on ARC-AGI-2-pub (29.4%) - Jeremy Berman",
            "pub_date": "2025-09-27T16:21:01.000Z",
            "duration": "01:08:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "large language model",
              "anthropic",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/New-top-score-on-ARC-AGI-2-pub-29-4---Jeremy-Berman-e38pj96",
            "audio_url": "https://traffic.megaphone.fm/APO8526044538.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f26da6ec-68d8-47b5-9f4f-4fc85aeef964",
            "index": 25,
            "title": "Deep Learning is Not So Mysterious or Different - Prof. Andrew Gordon Wilson (NYU)",
            "pub_date": "2025-09-19T15:59:12.000Z",
            "duration": "02:03:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "anthropic",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Deep-Learning-is-Not-So-Mysterious-or-Different---Prof--Andrew-Gordon-Wilson-NYU-e38eq74",
            "audio_url": "https://traffic.megaphone.fm/APO3101626167.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "31530e8e-0338-4528-837e-c1795abb80d5",
            "index": 26,
            "title": "Karl Friston - Why Intelligence Can't Get Too Large (Goldilocks principle)",
            "pub_date": "2025-09-10T17:31:44.000Z",
            "duration": "01:21:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Karl-Friston---Why-Intelligence-Cant-Get-Too-Large-Goldilocks-principle-e381ot2",
            "audio_url": "https://traffic.megaphone.fm/APO8448582556.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 1263,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "78ae3b32-d001-4795-870d-b572603b56ed",
            "index": 27,
            "title": "The Day AI Solves My Puzzles Is The Day I Worry (Prof. Cristopher Moore)",
            "pub_date": "2025-09-04T16:01:10.000Z",
            "duration": "01:34:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Day-AI-Solves-My-Puzzles-Is-The-Day-I-Worry-Prof--Cristopher-Moore-e37ojdg",
            "audio_url": "https://traffic.megaphone.fm/APO9880672406.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 69,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8e9fff8c-956f-417c-a2aa-e1f928ef75f4",
            "index": 28,
            "title": "Michael Timothy Bennett: Defining Intelligence and AGI Approaches",
            "pub_date": "2025-08-28T14:06:57.000Z",
            "duration": "01:05:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "inference",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Michael-Timothy-Bennett-Defining-Intelligence-and-AGI-Approaches-e37eb0n",
            "audio_url": "https://traffic.megaphone.fm/APO5055207512.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0799c4ee-34ad-48b1-adde-ff8f8c3a8ed8",
            "index": 29,
            "title": "Superintelligence Strategy (Dan Hendrycks)",
            "pub_date": "2025-08-14T00:05:57.000Z",
            "duration": "01:45:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "gemini",
              "chips",
              "data center",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Superintelligence-Strategy-Dan-Hendrycks-e36r1j5",
            "audio_url": "https://traffic.megaphone.fm/APO8504277993.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc2055b9-b9ef-4546-a398-c89dc584373a",
            "index": 30,
            "title": "DeepMind Genie 3 [World Exclusive] (Jack Parker Holder, Shlomi Fruchter)",
            "pub_date": "2025-08-05T14:47:17.000Z",
            "duration": "00:58:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "deepmind",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/DeepMind-Genie-3-World-Exclusive-Jack-Parker-Holder--Shlomi-Fruchter-e36fq96",
            "audio_url": "https://traffic.megaphone.fm/APO1926454457.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 512,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f9d5054a-edd6-44b9-a09e-9dfe1ab18be1",
            "index": 31,
            "title": "Large Language Models and Emergence: A Complex Systems Perspective (Prof. David C. Krakauer)",
            "pub_date": "2025-07-31T18:43:41.000Z",
            "duration": "00:49:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Large-Language-Models-and-Emergence-A-Complex-Systems-Perspective-Prof--David-C--Krakauer-e369pb7",
            "audio_url": "https://traffic.megaphone.fm/APO2962678850.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "564a3939-9604-4eb8-9c1d-5684dc1dc95b",
            "index": 32,
            "title": "Pushing compute to the limits of physics",
            "pub_date": "2025-07-21T20:07:52.000Z",
            "duration": "01:23:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "chips",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Pushing-compute-to-the-limits-of-physics-e35r8ru",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/105799998/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-6-21%2F404299996-44100-2-abef86652c6ad.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c78d87d8-27c8-4f2b-b4fa-4a0f15871f3a",
            "index": 33,
            "title": "The Fractured Entangled Representation Hypothesis (Kenneth Stanley, Akarsh Kumar)",
            "pub_date": "2025-07-06T00:28:44.000Z",
            "duration": "02:16:22",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Fractured-Entangled-Representation-Hypothesis-Kenneth-Stanley--Akarsh-Kumar-e355a6r",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/105080475/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-6-6%2F403375610-44100-2-0e8f60325cf2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 1477,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "715ff48a-41df-477b-bc5d-902a8567cdfd",
            "index": 34,
            "title": "The Fractured Entangled Representation Hypothesis (Intro)",
            "pub_date": "2025-07-05T23:55:51.000Z",
            "duration": "00:15:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Fractured-Entangled-Representation-Hypothesis-Intro-e3559ud",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/105080205/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-6-5%2F403374922-44100-2-6d6d5ac6ccd5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 128,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 24,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "a935de76-26f6-48c2-852c-80086f0caf33",
            "index": 35,
            "title": "Three Red Lines We're About to Cross Toward AGI (Daniel Kokotajlo, Gary Marcus, Dan Hendrycks)",
            "pub_date": "2025-06-24T01:32:24.000Z",
            "duration": "02:07:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agentic",
              "openai",
              "gemini",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Three-Red-Lines-Were-About-to-Cross-Toward-AGI-Daniel-Kokotajlo--Gary-Marcus--Dan-Hendrycks-e34l58q",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/104551130/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-5-24%2F402697735-44100-2-9688589328b1e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_rescript_transcript",
              "transcript_record_count": 319,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "61ab7e83-c458-4ed1-929f-7eaba24fd650",
            "index": 36,
            "title": "How AI Learned to Talk and What It Means - Prof. Christopher Summerfield",
            "pub_date": "2025-06-17T03:24:53.000Z",
            "duration": "01:08:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "deepmind",
              "gemini",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/How-AI-Learned-to-Talk-and-What-It-Means---Prof--Christopher-Summerfield-e34bnl0",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/104242272/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-5-17%2F402302891-44100-2-aff27fec8096e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eb30c5f8-b47a-48e1-b8c0-1673c92849ef",
            "index": 37,
            "title": "\"Blurring Reality\" - Chai's Social AI Platform (SPONSORED)",
            "pub_date": "2025-05-26T21:18:57.000Z",
            "duration": "00:50:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "chatgpt",
              "openai",
              "reasoning",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Blurring-Reality---Chais-Social-AI-Platform-SPONSORED-e33d0jm",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/103235638/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-4-26%2F401041586-44100-2-c1c7c54714968.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f75eb49b-6bb6-4013-82fa-863e1a947ea3",
            "index": 38,
            "title": "Google AlphaEvolve - Discovering new science (exclusive interview)",
            "pub_date": "2025-05-14T18:45:06.000Z",
            "duration": "01:13:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "deepmind",
              "gemini",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Google-AlphaEvolve---Discovering-new-science-exclusive-interview-e32rjpn",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/102665463/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-4-14%2F400288116-44100-2-bf56074113cbc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2cd3f44d-a967-42fe-9389-401f42fbd759",
            "index": 39,
            "title": "Prof. Randall Balestriero - LLMs without pretraining and SSL",
            "pub_date": "2025-04-23T14:16:32.000Z",
            "duration": "00:34:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Randall-Balestriero---LLMs-without-pretraining-and-SSL-e31ta64",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/101672580/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-3-23%2Fc31e9f0d-1a79-4a2a-df8d-c8608ab858e1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e55c63f4-2976-4c7f-a4ca-eb1b309745b9",
            "index": 40,
            "title": "How Machines Learn to Ignore the Noise (Kevin Ellis + Zenna Tavares)",
            "pub_date": "2025-04-08T21:03:31.000Z",
            "duration": "01:16:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "inference",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/How-Machines-Learn-to-Ignore-the-Noise-Kevin-Ellis--Zenna-Tavares-e319n04",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/101030340/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-3-8%2Feca73139-5076-05da-1c71-0c4421ae52e9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd6f4efb-7967-4f83-853f-f70c04b0185d",
            "index": 41,
            "title": "Eiso Kant (CTO poolside) - Superhuman Coding Is Coming!",
            "pub_date": "2025-04-02T19:58:20.000Z",
            "duration": "01:36:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "openai",
              "training",
              "reasoning",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Eiso-Kant-CTO-poolside---Superhuman-Coding-Is-Coming-e3117gu",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/100752350/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-3-2%2F9a64e682-db0b-c9ec-bed7-1469af13f755.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e4571571-99cb-4274-9fe3-0c5ce7e92fe4",
            "index": 42,
            "title": "The Compendium - Connor Leahy and Gabriel Alfour",
            "pub_date": "2025-03-30T17:16:37.000Z",
            "duration": "01:37:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "large language model",
              "openai",
              "reasoning",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Compendium---Connor-Leahy-and-Gabriel-Alfour-e30s7s0",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/100588864/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-30%2F2f821d64-3ab9-3534-5bc2-ec24a7e20e6a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2c463a67-2add-4475-8bbd-b992de11b4f5",
            "index": 43,
            "title": "ARC Prize v2 Launch! (Francois Chollet and Mike Knoop)",
            "pub_date": "2025-03-24T20:26:47.000Z",
            "duration": "00:54:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/ARC-Prize-v2-Launch--Francois-Chollet-and-Mike-Knoop-e30k12p",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/100319769/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-24%2F103fc293-4801-926b-df34-d8027ffb69d0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a9426f0-cc35-48c2-aecc-6c3cc7c284e7",
            "index": 44,
            "title": "Test-Time Adaptation: the key to reasoning with DL (Mohamed Osman)",
            "pub_date": "2025-03-22T22:48:25.000Z",
            "duration": "01:03:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "openai",
              "llama",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Test-Time-Adaptation-the-key-to-reasoning-with-DL-Mohamed-Osman-e30hd8t",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/100233949/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-22%2Fed4795dc-93de-d0ab-94b3-c2face88c2fd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9bd7543c-4462-497e-9f60-7dc1dca826d1",
            "index": 45,
            "title": "GSMSymbolic paper - Iman Mirzadeh (Apple)",
            "pub_date": "2025-03-19T22:33:28.000Z",
            "duration": "01:11:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "openai",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/GSMSymbolic-paper---Iman-Mirzadeh-Apple-e30dhvp",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/100107705/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-19%2F22dc98c2-78df-ec59-226d-b38b3fd4bd0e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3634932-ec71-42b8-ad4f-ac837de15909",
            "index": 46,
            "title": "Reasoning, Robustness, and Human Feedback in AI - Max Bartolo (Cohere)",
            "pub_date": "2025-03-18T23:06:22.000Z",
            "duration": "01:23:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "large language model",
              "training",
              "reasoning",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Reasoning--Robustness--and-Human-Feedback-in-AI---Max-Bartolo-Cohere-e30c1uu",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/100058526/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-18%2F936d6a62-ffe6-effb-7f41-e798337ea80c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "45e533c7-66eb-4b92-ae84-2eb8369b2ee4",
            "index": 47,
            "title": "Tau Language: The Software Synthesis Future (sponsored)",
            "pub_date": "2025-03-12T21:53:03.000Z",
            "duration": "01:41:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "reasoning",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Tau-Language-The-Software-Synthesis-Future-sponsored-e3038m1",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/99770497/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-12%2F4ffc9948-b05c-e06b-ad86-719c2d41344d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90450b9b-9fa1-48ce-b2b1-09909ac041c8",
            "index": 48,
            "title": "John Palazza - Vice President of Global Sales @ CentML ( sponsored)",
            "pub_date": "2025-03-10T22:31:37.000Z",
            "duration": "00:54:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "llama"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/John-Palazza---Vice-President-of-Global-Sales--CentML--sponsored-e3001cd",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/99664717/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-10%2F883e8222-2dd8-6ae6-fc66-bcb3048f7610.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7f27f3f-0faf-4316-8403-ec985f36ed79",
            "index": 49,
            "title": "Transformers Need Glasses! - Federico Barbero",
            "pub_date": "2025-03-08T22:49:35.000Z",
            "duration": "01:00:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "anthropic",
              "claude",
              "deepmind",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Transformers-Need-Glasses----Federico-Barbero-e2vt2tn",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/99567991/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-8%2F93abdba7-8239-0f46-eb47-df058b0f2033.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "80ad50a4-1703-4c71-b103-5d02704418d0",
            "index": 50,
            "title": "Sakana AI - Chris Lu, Robert Tjarko Lange, Cong Lu",
            "pub_date": "2025-03-01T18:40:22.000Z",
            "duration": "01:37:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "agents",
              "deepmind",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Sakana-AI---Chris-Lu--Robert-Tjarko-Lange--Cong-Lu-e2vih1p",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/99222009/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-2-1%2F69665050-bc4f-a25b-5de2-11f53c0f4735.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f028bec6-c1d5-40e2-9bfa-7118a6ed0311",
            "index": 51,
            "title": "Clement Bonnet - Can Latent Program Networks Solve Abstract Reasoning?",
            "pub_date": "2025-02-19T22:05:30.000Z",
            "duration": "00:51:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "inference",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Clement-Bonnet---Can-Latent-Program-Networks-Solve-Abstract-Reasoning-e2v41og",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/98747600/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-1-19%2F65f76eb2-6635-fdd1-17ed-23a2f70eb94a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8eb1de55-6f92-43d6-8bd8-f945ac4cf16c",
            "index": 52,
            "title": "Prof. Jakob Foerster - ImageNet Moment for Reinforcement Learning?",
            "pub_date": "2025-02-18T20:21:54.000Z",
            "duration": "00:53:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Jakob-Foerster---ImageNet-Moment-for-Reinforcement-Learning-e2v2cl2",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/98693218/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-1-18%2F52dc0817-4adf-4877-0b7b-e190a4542c3a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed0ae5f5-90ee-4a8f-8043-05712f5b49e4",
            "index": 53,
            "title": "Daniel Franzen & Jan Disselhoff - ARC Prize 2024 winners",
            "pub_date": "2025-02-12T21:05:30.000Z",
            "duration": "01:09:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "openai",
              "nvidia",
              "gpu",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Daniel-Franzen--Jan-Disselhoff---ARC-Prize-2024-winners-e2upr5k",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/98413172/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-1-12%2Ff8b7b2e7-5a61-710b-2650-1958e0115cec.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6ce02743-772d-47f9-a86d-26a7a396d718",
            "index": 54,
            "title": "Sepp Hochreiter - LSTM: The Comeback Story?",
            "pub_date": "2025-02-12T00:31:18.000Z",
            "duration": "01:07:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "deepmind",
              "reasoning",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Sepp-Hochreiter---LSTM-The-Comeback-Story-e2uoffb",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/98368427/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-1-12%2F528f8181-5bf4-b25d-6c34-e71a7ea674b4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0bb5bc52-2ffd-40f7-ac52-b53787d7a4b8",
            "index": 55,
            "title": "Want to Understand Neural Networks? Think Elastic Origami! - Prof. Randall Balestriero",
            "pub_date": "2025-02-08T14:18:53.000Z",
            "duration": "01:18:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "grok",
              "training",
              "reasoning",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Want-to-Understand-Neural-Networks--Think-Elastic-Origami----Prof--Randall-Balestriero-e2ujg9u",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/98205438/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-1-8%2F0d2541ce-6d8a-f729-83eb-feb798bbbd9b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "56ca916a-6956-4124-a7bc-ddd727bbae94",
            "index": 56,
            "title": "Nicholas Carlini (Google DeepMind)",
            "pub_date": "2025-01-25T21:22:34.000Z",
            "duration": "01:21:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "chatgpt",
              "deepmind",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Nicholas-Carlini-Google-DeepMind-e2tvqch",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/97560401/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-0-25%2Fe2cfa06e-9d17-d934-48a1-c88f969a4f47.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ee01beb-0c7d-4e9a-965e-5db8c3a272f7",
            "index": 57,
            "title": "Subbarao Kambhampati - Do o1 models search?",
            "pub_date": "2025-01-23T01:46:43.000Z",
            "duration": "01:32:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "openai",
              "deepmind",
              "reasoning",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Subbarao-Kambhampati---Do-o1-models-search-e2ts49m",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/97439478/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-0-23%2F9a1ea19a-508f-9cf3-ab02-be2d528461f4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f1ecadd9-b99b-4a87-815a-476bf42264d6",
            "index": 58,
            "title": "How Do AI Models Actually Think? - Laura Ruis",
            "pub_date": "2025-01-20T00:28:12.000Z",
            "duration": "01:18:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "reasoning",
              "safety",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/How-Do-AI-Models-Actually-Think----Laura-Ruis-e2tn9l9",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/97281129/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-0-20%2F808da284-ab46-0ae7-eb82-bb0885ebbcb1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6986baf2-ab2d-4a10-8c43-4ae8bfd81e4d",
            "index": 59,
            "title": "Jurgen Schmidhuber on Humans co-existing with AIs",
            "pub_date": "2025-01-16T21:42:55.000Z",
            "duration": "01:12:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "generative ai",
              "nvidia",
              "gpu",
              "reasoning",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Jurgen-Schmidhuber-on-Humans-co-existing-with-AIs-e2tjkb6",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/97160998/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-0-16%2Fdf844efa-ab18-f562-ed39-af86e3f5078d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e17d0bc4-f4dd-474e-9193-8b92e10ac899",
            "index": 60,
            "title": "Yoshua Bengio - Designing out Agency for Safe AI",
            "pub_date": "2025-01-15T19:21:54.000Z",
            "duration": "01:41:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agentic",
              "inference",
              "reasoning",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Yoshua-Bengio---Designing-out-Agency-for-Safe-AI-e2thu9p",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/97105657/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-0-15%2Fec5f2ba3-9244-22fc-7c18-43ca121cc9e3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "74384305-489e-400e-b7aa-c6bbee7bc96e",
            "index": 61,
            "title": "Francois Chollet - ARC reflections - NeurIPS 2024",
            "pub_date": "2025-01-09T02:49:59.000Z",
            "duration": "01:26:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Francois-Chollet---ARC-reflections---NeurIPS-2024-e2t8g92",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/96796386/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-0-9%2F4ca3ad40-917d-3330-2912-75d11359b605.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c71174c-868d-42c1-a059-65ee49666a44",
            "index": 62,
            "title": "Jeff Clune - Agent AI Needs Darwin",
            "pub_date": "2025-01-04T02:43:42.000Z",
            "duration": "02:00:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "reasoning",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Jeff-Clune---Agent-AI-Needs-Darwin-e2t1pjm",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/96576566/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-0-4%2F38a26c33-f494-d09e-9ca1-77ea7ba2cba6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f86c9e2-9e94-4c36-9bb9-072e28332c51",
            "index": 63,
            "title": "Neel Nanda - Mechanistic Interpretability (Sparse Autoencoders)",
            "pub_date": "2024-12-07T21:14:42.000Z",
            "duration": "03:42:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "anthropic",
              "claude",
              "deepmind",
              "inference",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Neel-Nanda---Mechanistic-Interpretability-Sparse-Autoencoders-e2s186i",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/95510162/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-11-7%2Fc6f11920-f06a-6c65-f767-1b957d252a38.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68e9b1ef-5394-4333-9063-266fc097f13e",
            "index": 64,
            "title": "Jonas Hübotter (ETH) - Test Time Inference",
            "pub_date": "2024-12-01T12:25:00.000Z",
            "duration": "01:45:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "inference",
              "training",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Jonas-Hbotter-ETH---Test-Time-Inference-e2rnle4",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/95196036/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-11-1%2Fc5b25fea-927b-5deb-5e11-619380dee886.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "299a7909-e926-4bda-95dc-1f4c972c1c1e",
            "index": 65,
            "title": "How AI Could Be A Mathematician's Co-Pilot by 2026 (Prof. Swarat Chaudhuri)",
            "pub_date": "2024-11-25T08:01:14.000Z",
            "duration": "01:44:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "deepmind",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/How-AI-Could-Be-A-Mathematicians-Co-Pilot-by-2026-Prof--Swarat-Chaudhuri-e2rf6es",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/94918556/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-10-25%2F82dd404f-8fb5-b449-b806-05fafc5c01fb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d8c91d2-80cf-491f-9231-bdaf3e3d1ff6",
            "index": 66,
            "title": "Nora Belrose - AI Development, Safety, and Meaning",
            "pub_date": "2024-11-17T21:35:53.000Z",
            "duration": "02:29:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "training",
              "alignment",
              "safety",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Nora-Belrose---AI-Development--Safety--and-Meaning-e2r495k",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/94560884/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-10-17%2F32c2c614-a959-6bd8-19d8-8809895158fa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67701f9c-fb9c-4351-853a-cecd1ccbb266",
            "index": 67,
            "title": "Why Your GPUs are underutilised for AI - CentML CEO Explains",
            "pub_date": "2024-11-13T15:05:27.000Z",
            "duration": "02:08:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "nvidia",
              "gpu",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Why-Your-GPUs-are-underutilised-for-AI---CentML-CEO-Explains-e2qu3ta",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/94358890/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-10-13%2F91737282-52b3-b9fd-c84a-d926a6025edc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2d640f09-ff05-4f62-b282-9dd4e45019a8",
            "index": 68,
            "title": "Eliezer Yudkowsky and Stephen Wolfram on AI X-risk",
            "pub_date": "2024-11-11T19:07:14.000Z",
            "duration": "04:18:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Eliezer-Yudkowsky-and-Stephen-Wolfram-on-AI-X-risk-e2qrfue",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/94272910/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-10-11%2F6c16ee13-1ba9-84cc-557d-8894501c5f5e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c5dce2c-db4c-4e98-9a8a-c9cc287707e8",
            "index": 69,
            "title": "Pattern Recognition vs True Intelligence - Francois Chollet",
            "pub_date": "2024-11-06T23:19:06.000Z",
            "duration": "02:42:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "llm",
              "agent",
              "reasoning",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Pattern-Recognition-vs-True-Intelligence---Francois-Chollet-e2qld8a",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/94073546/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-10-6%2Fe7018962-36be-57fc-aca2-2b5f5a548a6d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1c8cfe93-17a5-4c6b-a5ca-b5eae39558f7",
            "index": 70,
            "title": "The Elegant Math Behind Machine Learning - Anil Ananthaswamy",
            "pub_date": "2024-11-04T21:02:17.000Z",
            "duration": "01:53:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "chatgpt",
              "chips",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Elegant-Math-Behind-Machine-Learning---Anil-Ananthaswamy-e2qia6m",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/93972118/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-10-4%2F864826a6-e0da-0d5d-8777-6420552127e6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5fbe9ee-6c13-4efe-aaae-ea0549cda83f",
            "index": 71,
            "title": "Michael Levin - Why Intelligence Isn't Limited To Brains.",
            "pub_date": "2024-10-24T15:27:33.000Z",
            "duration": "01:03:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Michael-Levin---Why-Intelligence-Isnt-Limited-To-Brains-e2q3c8p",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/93482713/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-24%2Fcd5c61f1-9788-f730-6d4b-135bda34ee73.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f6a7e55-14ce-4a5d-b6a9-204df45471e2",
            "index": 72,
            "title": "Speechmatics CTO - Next-Generation Speech Recognition",
            "pub_date": "2024-10-23T22:38:32.000Z",
            "duration": "01:46:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "reasoning",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Speechmatics-CTO---Next-Generation-Speech-Recognition-e2q2g1a",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/93453802/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-23%2F28773177-f173-7635-f237-352753d4afbe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0bb5d8d3-de5a-4d88-8edb-4350cf8ee350",
            "index": 73,
            "title": "Dr. Sanjeev Namjoshi - Active Inference",
            "pub_date": "2024-10-22T21:35:28.000Z",
            "duration": "02:45:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "inference",
              "reasoning",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Dr--Sanjeev-Namjoshi---Active-Inference-e2q0uk6",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/93403206/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-22%2F101db96c-3f18-2959-af87-3fe9099bc526.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7e0c338f-8d54-4f44-a18d-c34e26704c5a",
            "index": 74,
            "title": "Joscha Bach - Why Your Thoughts Aren't Yours.",
            "pub_date": "2024-10-20T15:09:32.000Z",
            "duration": "01:52:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "inference",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Joscha-Bach---Why-Your-Thoughts-Arent-Yours-e2pti01",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/93291969/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-20%2F78260547-211e-1163-ae4e-6f576a708b01.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2a782174-80e8-4e37-b80d-82fb54bf9c57",
            "index": 75,
            "title": "Decompiling Dreams: A New Approach to ARC? - Alessandro Palmarini",
            "pub_date": "2024-10-19T16:12:42.000Z",
            "duration": "00:51:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "inference",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Decompiling-Dreams-A-New-Approach-to-ARC----Alessandro-Palmarini-e2psmmi",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/93264018/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-19%2Ff7911b01-908c-b0ee-a56f-0a887128d747.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9618ef53-29de-4be6-b005-db97e761b4bc",
            "index": 76,
            "title": "It's Not About Scale, It's About Abstraction - Francois Chollet",
            "pub_date": "2024-10-12T21:21:42.000Z",
            "duration": "00:46:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "llm",
              "training",
              "reasoning",
              "embedding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Its-Not-About-Scale--Its-About-Abstraction---Francois-Chollet-e2pj27h",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/92948145/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-12%2Fab6fafeb-0931-545a-05f7-a60b471139a2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5de03151-2c1d-4ce3-abf2-cf5d8ade4451",
            "index": 77,
            "title": "Bold AI Predictions From Cohere Co-founder",
            "pub_date": "2024-10-10T13:07:28.000Z",
            "duration": "00:47:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "gpu",
              "inference",
              "training",
              "reasoning",
              "rag"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Bold-AI-Predictions-From-Cohere-Co-founder-e2pflom",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/92837078/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-10%2F088bb22b-caaa-75a8-cd18-6843ddfadf5a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9e708e15-c57a-4ed8-89e2-430e4d2d3182",
            "index": 78,
            "title": "Open-Ended AI: The Key to Superhuman Intelligence? - Prof. Tim Rocktäschel",
            "pub_date": "2024-10-04T22:46:32.000Z",
            "duration": "00:55:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "agent",
              "deepmind",
              "gemini",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Open-Ended-AI-The-Key-to-Superhuman-Intelligence----Prof--Tim-Rocktschel-e2p8drk",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/92599604/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-4%2F56819f16-9f8f-20db-3672-b2a59ad48b08.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "827f78b7-e597-44dd-b503-057ddb46e264",
            "index": 79,
            "title": "Ben Goertzel on \"Superintelligence\"",
            "pub_date": "2024-10-01T23:32:57.000Z",
            "duration": "01:37:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "reasoning",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Ben-Goertzel-on-Superintelligence-e2p490r",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/92463579/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-9-1%2Fdf396abc-ceb7-a419-f796-86b772be29b2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c66fe9a-7cb0-46ab-9151-9ae7f280e4c3",
            "index": 80,
            "title": "Taming Silicon Valley - Prof. Gary Marcus",
            "pub_date": "2024-09-24T20:45:27.000Z",
            "duration": "01:56:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "reasoning",
              "alignment",
              "safety",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Taming-Silicon-Valley---Prof--Gary-Marcus-e2oqqli",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/92153970/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-24%2F07fc532f-22b6-af88-999b-daff9175d82d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f2620e4-40c1-4ab0-8d63-58703f610633",
            "index": 81,
            "title": "Prof. Mark Solms - The Hidden Spring",
            "pub_date": "2024-09-18T20:14:31.000Z",
            "duration": "01:26:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude",
              "training",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Mark-Solms---The-Hidden-Spring-e2oinpp",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/91888889/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-18%2Fb0c23e11-aa25-87e7-f2a3-268b7e8dae67.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd41eb07-5c2b-44d8-b29d-0e4167052ae3",
            "index": 82,
            "title": "Patrick Lewis (Cohere) - Retrieval Augmented Generation",
            "pub_date": "2024-09-16T18:36:22.000Z",
            "duration": "01:13:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "training",
              "rag",
              "retrieval",
              "embeddings"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Patrick-Lewis-Cohere---Retrieval-Augmented-Generation-e2ofomu",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/91791518/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-16%2Fe5358a0e-d3e0-3c43-d400-f12ce212ea4c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e9fc284-add6-458f-a5ce-5d0188220efc",
            "index": 83,
            "title": "Ashley Edwards - Genie Paper (DeepMind/Runway)",
            "pub_date": "2024-09-13T18:59:35.000Z",
            "duration": "00:25:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "training",
              "safety",
              "retrieval",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Ashley-Edwards---Genie-Paper-DeepMindRunway-e2oc9m5",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/91677829/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-13%2F43b709ac-1c14-74ab-673a-ab9bb09beac6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9932f8d1-987b-4649-9358-bac6f6dd7bfd",
            "index": 84,
            "title": "Cohere's SVP Technology - Saurabh Baji",
            "pub_date": "2024-09-12T14:38:11.000Z",
            "duration": "01:30:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Coheres-SVP-Technology---Saurabh-Baji-e2oaip5",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/91621605/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-12%2Fe009712b-d928-a548-ac9c-0deefab73e3b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7afd0bd5-e003-49c9-ab99-64b4305a903a",
            "index": 85,
            "title": "David Hanson's Vision for Sentient Robots",
            "pub_date": "2024-09-10T12:23:51.000Z",
            "duration": "00:53:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "training",
              "retrieval",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/David-Hansons-Vision-for-Sentient-Robots-e2o7m8l",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/91526869/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-10%2F46ba67e2-af77-8c48-67a4-b887c16babe8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95bcd85a-4f4c-4063-8bb2-1203e3dbd47d",
            "index": 86,
            "title": "The Fabric of Knowledge - David Spivak",
            "pub_date": "2024-09-05T17:56:26.000Z",
            "duration": "00:46:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "deepmind",
              "inference",
              "training",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/The-Fabric-of-Knowledge---David-Spivak-e2o220h",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/91342289/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-8-5%2F36a47360-f8fa-68aa-a676-7adfd1c3d0c8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad883c65-b25b-4723-8840-829b0a98ca5f",
            "index": 87,
            "title": "Jürgen Schmidhuber - Neural and Non-Neural AI, Reasoning, Transformers, and LSTMs",
            "pub_date": "2024-08-28T17:44:55.000Z",
            "duration": "01:39:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "generative ai",
              "chatgpt",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Jrgen-Schmidhuber---Neural-and-Non-Neural-AI--Reasoning--Transformers--and-LSTMs-e2nnmjl",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/91002933/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-28%2Fcf47b479-3c88-d4c3-62f1-009ef82e37c6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "173f5e18-4bb9-44e9-9c40-2fe3de0aef94",
            "index": 88,
            "title": "\"AI should NOT be regulated at all!\" - Prof. Pedro Domingos",
            "pub_date": "2024-08-25T14:05:24.000Z",
            "duration": "02:12:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "openai",
              "training",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/AI-should-NOT-be-regulated-at-all----Prof--Pedro-Domingos-e2njada",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/90859370/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-25%2F75faedd3-d828-e304-6b74-ef99b82e9929.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "20355b07-60ae-4bb0-98ae-887fa03eed88",
            "index": 89,
            "title": "Adversarial Examples and Data Modelling - Andrew Ilyas (MIT)",
            "pub_date": "2024-08-22T07:02:03.000Z",
            "duration": "01:28:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning",
              "alignment",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Adversarial-Examples-and-Data-Modelling---Andrew-Ilyas-MIT-e2nfov9",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/90743209/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-22%2F55ac46ce-094a-59bf-3bca-0792f898e1e2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7028322c-f965-4768-9f8c-478be64f8f3a",
            "index": 90,
            "title": "Joscha Bach - AGI24 Keynote (Cyberanimism)",
            "pub_date": "2024-08-21T06:23:08.000Z",
            "duration": "00:57:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "training",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Joscha-Bach---AGI24-Keynote-Cyberanimism-e2neeui",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/90700178/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-21%2F90b41e5b-7b95-22bd-11d1-6ef4e7b11782.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9dfd74a-de24-463f-9fd9-146ce0626d5c",
            "index": 91,
            "title": "Gary Marcus' keynote at AGI-24",
            "pub_date": "2024-08-17T20:35:43.000Z",
            "duration": "01:12:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "generative ai",
              "training",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Gary-Marcus-keynote-at-AGI-24-e2na1t7",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/90555751/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-17%2F3488c017-c039-6cf1-7cb9-980321040c02.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ea872137-e817-4472-b744-b39d7a2c83c9",
            "index": 92,
            "title": "Is ChatGPT an N-gram model on steroids?",
            "pub_date": "2024-08-15T05:42:06.000Z",
            "duration": "00:32:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "deepmind",
              "training",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Is-ChatGPT-an-N-gram-model-on-steroids-e2n74rr",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/90460475/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-15%2F8357f15a-4c0a-9942-6abe-41ce610b8b07.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "20dd8077-a65c-40a9-aae3-99c365e8e40a",
            "index": 93,
            "title": "Jay Alammar on LLMs, RAG, and AI Engineering",
            "pub_date": "2024-08-11T20:16:32.000Z",
            "duration": "00:57:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "training",
              "rag",
              "retrieval",
              "embeddings"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Jay-Alammar-on-LLMs--RAG--and-AI-Engineering-e2n2koj",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/90312915/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-11%2F9be9c216-1f7a-6045-b79c-2dfedc30d327.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0e209fc-f6c2-4b07-a62e-b9a4208513f9",
            "index": 94,
            "title": "Can AI therapy be more effective than drugs?",
            "pub_date": "2024-08-08T18:30:56.000Z",
            "duration": "02:14:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Can-AI-therapy-be-more-effective-than-drugs-e2mvhd0",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/90211168/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-7-8%2F7ab263b2-ff32-f2de-204b-b7bf4edb486b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed66eb64-43f7-4a8e-9891-38b34723880b",
            "index": 95,
            "title": "Prof. Subbarao Kambhampati - LLMs don't reason, they memorize (ICML2024 2/13)",
            "pub_date": "2024-07-29T18:32:42.000Z",
            "duration": "01:42:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "training",
              "reasoning",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Subbarao-Kambhampati---LLMs-dont-reason--they-memorize-ICML2024-213-e2mjcse",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/89813326/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-6-29%2F24b87b76-4192-b8fd-013e-4d817810331f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "797c903b-9639-4222-93e8-35b331cf409d",
            "index": 96,
            "title": "Sayash Kapoor - How seriously should we take AI X-risk? (ICML 1/13)",
            "pub_date": "2024-07-28T16:14:17.000Z",
            "duration": "00:49:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "chatgpt",
              "training",
              "eval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Sayash-Kapoor---How-seriously-should-we-take-AI-X-risk--ICML-113-e2mhuoc",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/89766092/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-6-28%2Fc7d57c66-93af-1ac3-0a5c-b62ccdcdd61b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "111a9825-6ebf-4474-8501-7195a56100f8",
            "index": 97,
            "title": "Sara Hooker - Why US AI Act Compute Thresholds Are Misguided",
            "pub_date": "2024-07-18T22:51:28.000Z",
            "duration": "01:05:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "claude",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Sara-Hooker---Why-US-AI-Act-Compute-Thresholds-Are-Misguided-e2m6qm4",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/89401476/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-6-18%2F91087ab7-05de-3101-b203-620838e6e030.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "440edf42-54c6-4273-a226-457dd4baf2de",
            "index": 98,
            "title": "Prof. Murray Shanahan - Machines Don't Think Like Us",
            "pub_date": "2024-07-14T19:58:21.000Z",
            "duration": "02:15:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "anthropic",
              "claude",
              "deepmind",
              "inference",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Murray-Shanahan---Machines-Dont-Think-Like-Us-e2m1499",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/89214697/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-6-14%2F45f81b8b-673a-f931-4cb5-8955ca84aaf6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "72818461-e3ba-40ac-ba4f-6a86fe3e193e",
            "index": 99,
            "title": "David Chalmers - Reality+",
            "pub_date": "2024-07-08T18:54:14.000Z",
            "duration": "01:17:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/David-Chalmers---Reality-e2lq0f1",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/88981409/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-6-8%2Fcf89bea4-5bf7-5d7d-4292-d8cf67b3de65.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8ecccaa-9fdc-47c2-9ca9-e6ea5f09233d",
            "index": 100,
            "title": "Ryan Greenblatt - Solving ARC with GPT4o",
            "pub_date": "2024-07-06T19:14:27.000Z",
            "duration": "02:18:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agentic",
              "reasoning",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Ryan-Greenblatt---Solving-ARC-with-GPT4o-e2lnplq",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/88908922/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-6-6%2F17966cac-d485-a913-5ade-6644c3feacfc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "41d7fda2-7841-4b49-8f01-fa662a74d4d9",
            "index": 101,
            "title": "Aiden Gomez - CEO of Cohere (AI's 'Inner Monologue' – Crucial for Reasoning)",
            "pub_date": "2024-06-29T21:00:09.000Z",
            "duration": "01:00:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Aiden-Gomez---CEO-of-Cohere-AIs-Inner-Monologue--Crucial-for-Reasoning-e2lf8fg",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/88629168/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-5-29%2F8d59b65c-4d2c-5ef7-07aa-f848990d9725.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8eb32119-f72a-4e75-a300-1eed3a9719ec",
            "index": 102,
            "title": "New \"50%\" ARC result and current winners interviewed",
            "pub_date": "2024-06-18T21:57:44.000Z",
            "duration": "02:14:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "inference",
              "reasoning",
              "eval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/New-50-ARC-result-and-current-winners-interviewed-e2l1prl",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/88188213/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-5-18%2Fdb923632-5035-adf8-0949-08dd818b67e0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f0b80aa4-e77b-48de-b00f-bcee4505a9e3",
            "index": 103,
            "title": "Cohere co-founder Nick Frosst on building LLM apps for business",
            "pub_date": "2024-06-16T12:00:01.000Z",
            "duration": "00:41:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "rag"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Cohere-co-founder-Nick-Frosst-on-building-LLM-apps-for-business-e2kuiu2",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/88082818/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-5-16%2Faf493afb-1f13-ef9c-a566-c75b56696a06.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1e61ace0-8450-4186-8a0c-e1323ee437a0",
            "index": 104,
            "title": "What’s the Magic Word? A Control Theory of LLM Prompting.",
            "pub_date": "2024-06-05T20:22:54.000Z",
            "duration": "01:17:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Whats-the-Magic-Word--A-Control-Theory-of-LLM-Prompting-e2khs2t",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/87666205/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-5-5%2Fedcc7f6f-d812-d535-6844-d68532b9a96b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8409f249-7892-4055-9395-84231c463117",
            "index": 105,
            "title": "CAN MACHINES REPLACE US? (AI vs Humanity) - Maria Santacaterina",
            "pub_date": "2024-05-06T10:48:22.000Z",
            "duration": "02:31:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/CAN-MACHINES-REPLACE-US--AI-vs-Humanity---Maria-Santacaterina-e2jaa4p",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/86369881/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-4-6%2F8ede7e72-d5ef-7870-f16d-ab499569ea1c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5d40cea-2292-4218-9bda-bb911b145934",
            "index": 106,
            "title": "Dr. Thomas Parr - Active Inference Book",
            "pub_date": "2024-05-01T21:24:44.000Z",
            "duration": "01:37:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "agents",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Dr--Thomas-Parr---Active-Inference-Book-e2j4sdn",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/86191991/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-4-1%2F54df4213-e234-c151-3bfa-b5e2a923ab29.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ce28373f-f12c-4cb6-a7e9-41002f7a7e9a",
            "index": 107,
            "title": "Connor Leahy - e/acc, AGI and the future.",
            "pub_date": "2024-04-21T15:05:53.000Z",
            "duration": "01:19:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Connor-Leahy---eacc--AGI-and-the-future-e2im26o",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/85706392/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-3-21%2F43e6978e-0033-d0f1-05e9-ac3b88108ced.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b9aba838-5518-4be3-8d96-560b18cade35",
            "index": 108,
            "title": "Prof. Chris Bishop's NEW Deep Learning Textbook!",
            "pub_date": "2024-04-10T14:50:34.000Z",
            "duration": "01:22:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Chris-Bishops-NEW-Deep-Learning-Textbook-e2i63r0",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/85183776/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-3-9%2F90ce9a86-62a0-eb9d-1e3a-380c3dc56c43.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bcbcbe80-9ed2-42a2-9e15-86e086d15913",
            "index": 109,
            "title": "Philip Ball - How Life Works",
            "pub_date": "2024-04-07T16:24:00.000Z",
            "duration": "02:09:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Philip-Ball---How-Life-Works-e2i39dj",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/85091187/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-3-7%2F7f812191-d67c-4b88-41d6-2dbf817ed901.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd102195-267d-4644-afda-0e598517f9a4",
            "index": 110,
            "title": "Dr. Paul Lessard - Categorical/Structured Deep Learning",
            "pub_date": "2024-04-01T12:53:09.000Z",
            "duration": "01:49:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Dr--Paul-Lessard---CategoricalStructured-Deep-Learning-e2hqqlq",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/84813946/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-3-1%2Fcb2afcb9-86d2-c3ee-def3-dc54f73377c9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3bcac65f-8965-475a-82e6-f3bf40ced60d",
            "index": 111,
            "title": "Can we build a generalist agent? Dr. Minqi Jiang and Dr. Marc Rigter",
            "pub_date": "2024-03-20T18:36:23.000Z",
            "duration": "01:57:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agent",
              "agents",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Can-we-build-a-generalist-agent--Dr--Minqi-Jiang-and-Dr--Marc-Rigter-e2hbgmm",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/84312214/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-2-20%2F1bbd0c9c-d5cd-0177-632d-f6c191a25928.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dbef7495-afd6-4fdb-928c-87d759ce38ff",
            "index": 112,
            "title": "Prof. Nick Chater - The Language Game (Part 1)",
            "pub_date": "2024-03-01T19:37:44.000Z",
            "duration": "01:43:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Nick-Chater---The-Language-Game-Part-1-e2gh3dv",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/83446655/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-2-1%2Fd41cc5ea-41e4-cb35-8648-003762e2ea38.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c1ed114-7997-4736-a733-b58abb79a476",
            "index": 113,
            "title": "Kenneth Stanley created a new social network based on serendipity and divergence",
            "pub_date": "2024-02-28T10:26:27.000Z",
            "duration": "03:15:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Kenneth-Stanley-created-a-new-social-network-based-on-serendipity-and-divergence-e2gcpda",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/83305322/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-1-28%2Fd5ee117f-75e1-6b8b-a6bb-f3dadc46d5df.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70ee1cdc-ebd3-41cf-85ea-73434c5aee54",
            "index": 114,
            "title": "Dr. Brandon Rohrer - Robotics, Creativity and Intelligence",
            "pub_date": "2024-02-13T21:39:39.000Z",
            "duration": "01:31:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Dr--Brandon-Rohrer---Robotics--Creativity-and-Intelligence-e2foau9",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/82635145/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-1-13%2F918a5e58-b1e8-4844-ad4c-b04feb4939fc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a199ec26-abf2-4235-90b2-b57051f1e51a",
            "index": 115,
            "title": "Showdown Between e/acc Leader And Doomer - Connor Leahy + Beff Jezos",
            "pub_date": "2024-02-03T21:00:16.000Z",
            "duration": "03:00:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Showdown-Between-eacc-Leader-And-Doomer---Connor-Leahy--Beff-Jezos-e2far3q",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/82192954/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-1-3%2F71511474-0933-6a0d-b298-475e741e13ab.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cf1628b1-5421-4442-8d81-0e5efba02fa4",
            "index": 116,
            "title": "Mahault Albarracin - Cognitive Science",
            "pub_date": "2024-01-14T14:16:36.000Z",
            "duration": "01:07:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Mahault-Albarracin---Cognitive-Science-e2ee5m0",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/81253504/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-0-14%2F4725de70-1169-18b6-e9b9-d060c4d35f9d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "418866e7-1e82-41c3-8282-479dd632720c",
            "index": 117,
            "title": "$450M AI Startup In 3 Years | Chai AI",
            "pub_date": "2024-01-09T22:11:35.000Z",
            "duration": "00:29:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "ai startup"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/450M-AI-Startup-In-3-Years--Chai-AI-e2e7pma",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/81044618/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-0-9%2Fda5f159a-22f5-5db0-2c50-5348da2678e5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "45c4ddaa-cd42-455d-9fe4-cdeb02d3a855",
            "index": 118,
            "title": "DOES AI HAVE AGENCY? With Professor. Karl Friston and Riddhi J. Pitliya",
            "pub_date": "2024-01-07T19:37:46.000Z",
            "duration": "01:02:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/DOES-AI-HAVE-AGENCY--With-Professor--Karl-Friston-and-Riddhi-J--Pitliya-e2e4f2n",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/80935447/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2024-0-7%2F43178d4d-663b-e236-7650-35007b52702c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "84b9ea9e-310c-4c3b-b348-9cd280b2b6bd",
            "index": 119,
            "title": "Understanding Deep Learning - Prof. SIMON PRINCE [STAFF FAVOURITE]",
            "pub_date": "2023-12-26T20:33:13.000Z",
            "duration": "02:06:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "inference",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Understanding-Deep-Learning---Prof--SIMON-PRINCE-STAFF-FAVOURITE-e2dmd3i",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/80474674/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-11-26%2F74a865bd-0387-d8d3-2ffd-ed59ee431f03.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b14f6711-ae9e-4f0c-864e-a94f7dab2204",
            "index": 120,
            "title": "Prof. BERT DE VRIES - ON ACTIVE INFERENCE",
            "pub_date": "2023-11-20T22:08:27.000Z",
            "duration": "02:27:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--BERT-DE-VRIES---ON-ACTIVE-INFERENCE-e2c6l1u",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/78909950/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-10-20%2Feaceb699-dd36-1cf1-f316-ba2102d1a009.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b978bda-9030-469f-93bb-ed26c6899fce",
            "index": 121,
            "title": "MULTI AGENT LEARNING - LANCELOT DA COSTA",
            "pub_date": "2023-11-05T15:15:32.000Z",
            "duration": "00:49:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "inference",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/MULTI-AGENT-LEARNING---LANCELOT-DA-COSTA-e2bgsjs",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/78196796/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-10-5%2F1891ba52-58fa-c7c3-6e74-5a39fbf25723.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1eb58c44-2c13-4552-96d2-dff031d7bda2",
            "index": 122,
            "title": "THE HARD PROBLEM OF OBSERVERS - WOLFRAM & FRISTON [SPECIAL EDITION]",
            "pub_date": "2023-10-29T22:38:11.000Z",
            "duration": "01:59:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/THE-HARD-PROBLEM-OF-OBSERVERS---WOLFRAM--FRISTON-SPECIAL-EDITION-e2b7ib5",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/77891365/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-9-29%2F1e458bfd-b223-3678-e645-ce1d53be4687.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "850f7f92-e5d3-4bf8-83c6-ce4d46543af0",
            "index": 123,
            "title": "DR. JEFF BECK - THE BAYESIAN BRAIN",
            "pub_date": "2023-10-16T10:47:07.000Z",
            "duration": "01:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "inference",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/DR--JEFF-BECK---THE-BAYESIAN-BRAIN-e2akqa1",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/77276929/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-9-16%2F2548666f-3f72-9008-5898-d9f59132c94f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69502d64-cf64-4426-b69c-9153320504ea",
            "index": 124,
            "title": "Prof. Melanie Mitchell 2.0 - AI Benchmarks are Broken!",
            "pub_date": "2023-09-10T18:28:11.000Z",
            "duration": "01:01:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Melanie-Mitchell-2-0---AI-Benchmarks-are-Broken-e2959li",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/75719794/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-8-10%2F5127448f-aab3-b628-ec12-ca8103f1ded7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ebdb88ae-8b52-475d-b7d3-8dca24857ab1",
            "index": 125,
            "title": "Autopoitic Enactivism and the Free Energy Principle - Prof. Friston, Prof Buckley, Dr. Ramstead",
            "pub_date": "2023-09-05T21:39:06.000Z",
            "duration": "01:34:46",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Autopoitic-Enactivism-and-the-Free-Energy-Principle---Prof--Friston--Prof-Buckley--Dr--Ramstead-e28v7rp",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/75521337/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-8-5%2F7ab707f2-38b9-28d9-e473-a5a99cca111a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f4228db-f7e6-4e3d-b61b-d2937193d415",
            "index": 126,
            "title": "STEPHEN WOLFRAM 2.0 - Resolving the Mystery of the Second Law of Thermodynamics",
            "pub_date": "2023-08-15T02:13:47.000Z",
            "duration": "01:24:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/STEPHEN-WOLFRAM-2-0---Resolving-the-Mystery-of-the-Second-Law-of-Thermodynamics-e2847qh",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/74636561/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-7-15%2F10889ed6-9b45-bf9b-712a-f509dddb0716.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a77e5c11-db67-4871-9535-c8a6ebf4cd71",
            "index": 127,
            "title": "Prof. Jürgen Schmidhuber - FATHER OF AI ON ITS DANGERS",
            "pub_date": "2023-08-14T11:12:35.000Z",
            "duration": "01:21:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "openai",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Jrgen-Schmidhuber---FATHER-OF-AI-ON-ITS-DANGERS-e2839av",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/74605343/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-7-14%2F31c302ae-c16f-ca62-f807-dac6c80dc9d7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dd18d5a1-1559-416a-bc25-7ed0ce2a7f0e",
            "index": 128,
            "title": "Can We Develop Truly Beneficial AI? George Hotz and Connor Leahy",
            "pub_date": "2023-08-04T00:10:20.000Z",
            "duration": "01:29:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Can-We-Develop-Truly-Beneficial-AI--George-Hotz-and-Connor-Leahy-e27nhtg",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/74220912/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-7-4%2Fca4227d5-5ea7-4432-36fc-1e9fbda9549d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b5a0b1e-68fd-44b4-bb2f-deddc039604b",
            "index": 129,
            "title": "Dr. MAXWELL RAMSTEAD - The Physics of Survival",
            "pub_date": "2023-07-16T00:23:17.000Z",
            "duration": "02:05:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Dr--MAXWELL-RAMSTEAD---The-Physics-of-Survival-e2704fa",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/73453482/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-6-16%2F54cf5039-4acd-6a69-a628-c2c18ba8f1cb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1e15c652-13e2-4d65-b49f-47d796b78f9d",
            "index": 130,
            "title": "MUNK DEBATE ON AI (COMMENTARY) [DAVID FOSTER]",
            "pub_date": "2023-07-02T18:02:15.000Z",
            "duration": "02:08:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/MUNK-DEBATE-ON-AI-COMMENTARY-DAVID-FOSTER-e26f787",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/72899271/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-6-2%2F5b72d680-bae9-0b56-44f7-c49750ce828f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f18e52ad-7c64-49e0-b824-55d5b4a62785",
            "index": 131,
            "title": "[SPONSORED] The Digitized Self: AI, Identity and the Human Psyche (YouAi)",
            "pub_date": "2023-06-29T08:25:27.000Z",
            "duration": "01:46:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/SPONSORED-The-Digitized-Self-AI--Identity-and-the-Human-Psyche-YouAi-e26b90f",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/72769999/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-5-29%2F4ccdedce-34a4-29f5-0a6a-2b014c76ef99.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3a0a6b0-6d7a-4e3d-bc97-5ccb6d8d8fb2",
            "index": 132,
            "title": "Joscha Bach and Connor Leahy on AI risk",
            "pub_date": "2023-06-20T01:14:46.000Z",
            "duration": "01:31:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Joscha-Bach-and-Connor-Leahy-on-AI-risk-e25ukc5",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/72355653/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-5-20%2F81fd6c77-364d-2af5-b47e-98f121101d8a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7e27836-5dab-4440-9846-53a7a790d88a",
            "index": 133,
            "title": "Neel Nanda - Mechanistic Interpretability",
            "pub_date": "2023-06-18T13:52:48.000Z",
            "duration": "04:10:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Neel-Nanda---Mechanistic-Interpretability-e25sibc",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/72288044/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-5-18%2Fd25a054b-86a0-d2b6-dc25-292faf13246d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "14f68ceb-8c07-4b8e-bea5-fa33381af744",
            "index": 134,
            "title": "Prof. Daniel Dennett - Could AI Counterfeit People Destroy Civilization? (SPECIAL EDITION)",
            "pub_date": "2023-06-04T23:49:02.000Z",
            "duration": "01:14:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Prof--Daniel-Dennett---Could-AI-Counterfeit-People-Destroy-Civilization--SPECIAL-EDITION-e257pcm",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/71607126/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-5-4%2F171638b5-c3f5-ed57-dff0-3f500ae34bfc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a919cd7-5a5d-4ab5-97c9-892ed4702ac7",
            "index": 135,
            "title": "Decoding the Genome: Unraveling the Complexities with AI and Creativity [Prof. Jim Hughes, Oxford]",
            "pub_date": "2023-05-31T23:05:16.000Z",
            "duration": "00:42:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Decoding-the-Genome-Unraveling-the-Complexities-with-AI-and-Creativity-Prof--Jim-Hughes--Oxford-e250mck",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/71374676/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-4-31%2Fb0588e48-adf6-8c94-abb3-c6a2baaa001d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e567446a-e5e6-4af5-9779-87eb42bc64a4",
            "index": 136,
            "title": "ROBERT MILES - \"There is a good chance this kills everyone\"",
            "pub_date": "2023-05-21T16:42:51.000Z",
            "duration": "02:01:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/ROBERT-MILES---There-is-a-good-chance-this-kills-everyone-e24eio7",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/70781127/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-4-21%2Fb355263e-1788-fabd-ebe6-f7ed528dd89c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "92114a10-2c71-424a-ac55-3752f2397a42",
            "index": 137,
            "title": "AI Senate Hearing - Executive Summary (Sam Altman, Gary Marcus)",
            "pub_date": "2023-05-16T22:00:30.000Z",
            "duration": "00:49:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/AI-Senate-Hearing---Executive-Summary-Sam-Altman--Gary-Marcus-e246bab",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/70511371/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-4-16%2F50b698b1-2c54-c842-6da1-fad6b777c706.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4bfdf781-c14e-4e03-98c6-9023788c5170",
            "index": 138,
            "title": "Future of Generative AI [David Foster]",
            "pub_date": "2023-05-11T16:44:57.000Z",
            "duration": "02:31:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "generative ai",
              "inference",
              "training",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Future-of-Generative-AI-David-Foster-e23sut7",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/70203751/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-4-11%2Fd36a6cd7-8f50-67bb-80ba-474a04e402e7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c308b2a8-0344-4c07-a361-88d75ef02b34",
            "index": 139,
            "title": "PERPLEXITY AI - The future of search.",
            "pub_date": "2023-05-08T18:58:01.000Z",
            "duration": "00:59:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/PERPLEXITY-AI---The-future-of-search-e23i5fq",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/69850042/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-4-5%2F8e48f567-a6ef-5a83-09d0-37a535267a10.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1ad6f36-06e0-4a17-bdf0-004651c2f554",
            "index": 140,
            "title": "#114 - Secrets of Deep Reinforcement Learning (Minqi Jiang)",
            "pub_date": "2023-04-16T18:00:40.000Z",
            "duration": "02:47:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "meta ai",
              "training",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/114---Secrets-of-Deep-Reinforcement-Learning-Minqi-Jiang-e22fkp7",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/68718823/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-3-16%2F9d4f6981-9471-b94a-e360-4e90ddd666f4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c334c034-8c4c-45f4-ba6f-e07e9a7523a0",
            "index": 141,
            "title": "Unlocking the Brain's Mysteries: Chris Eliasmith on Spiking Neural Networks and the Future of Human-Machine Interaction",
            "pub_date": "2023-04-10T18:07:39.000Z",
            "duration": "01:49:36",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "chip"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Unlocking-the-Brains-Mysteries-Chris-Eliasmith-on-Spiking-Neural-Networks-and-the-Future-of-Human-Machine-Interaction-e224fh6",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/68352998/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-3-10%2Faa6b8b83-e7b8-6164-495a-a94b9aebc9d7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "199fd723-606a-43ea-b8a4-d0adc373a9cb",
            "index": 142,
            "title": "#112 AVOIDING AGI APOCALYPSE - CONNOR LEAHY",
            "pub_date": "2023-04-02T18:00:09.000Z",
            "duration": "02:40:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "chatgpt",
              "openai",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/112-AVOIDING-AGI-APOCALYPSE---CONNOR-LEAHY-e21ji45",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/67798597/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-3-2%2F2b84c075-edce-9bd9-9a26-800f67c3441d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ddcb4c8a-e882-454e-ab59-20d61068bd5e",
            "index": 143,
            "title": "#111 - AI moratorium, Eliezer Yudkowsky, AGI risk etc",
            "pub_date": "2023-04-01T18:45:33.000Z",
            "duration": "00:26:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "gpu",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/111---AI-moratorium--Eliezer-Yudkowsky--AGI-risk-etc-e21hnrq",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/67738938/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-3-1%2F321607929-44100-2-6282408081976.m4a",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e3662b59-6c66-4aa5-be32-c5ce9e42474e",
            "index": 144,
            "title": "#110 Dr. STEPHEN WOLFRAM - HUGE ChatGPT+Wolfram announcement!",
            "pub_date": "2023-03-23T20:59:11.000Z",
            "duration": "00:57:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "chatgpt",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/110-Dr--STEPHEN-WOLFRAM---HUGE-ChatGPTWolfram-announcement-e210qda",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/67184490/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-2-23%2Fd509e7a4-bb85-d958-be7c-721bb996eb57.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0488e11-6e2f-47f5-87ee-6d6c49374872",
            "index": 145,
            "title": "#109 - Dr. DAN MCQUILLAN - Resisting AI",
            "pub_date": "2023-03-20T08:56:43.000Z",
            "duration": "02:51:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/109---Dr--DAN-MCQUILLAN---Resisting-AI-e20oplg",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/66921584/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-2-20%2Feca0ead2-ee1a-d115-3a84-c60336c4008d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b1546d3-5786-4c63-8e53-37e2a4dd4a6d",
            "index": 146,
            "title": "#108 - Dr. JOEL LEHMAN - Machine Love [Staff Favourite]",
            "pub_date": "2023-03-16T16:24:33.000Z",
            "duration": "02:09:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/108---Dr--JOEL-LEHMAN---Machine-Love-Staff-Favourite-e20i0qt",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/66699549/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-2-16%2F712fbb29-0f50-e76d-1e7b-aee556e1f077.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b2279203-a90c-423d-92af-4db59d56c077",
            "index": 147,
            "title": "#107 - Dr. RAPHAËL MILLIÈRE - Linguistics, Theory of Mind, Grounding",
            "pub_date": "2023-03-13T22:45:03.000Z",
            "duration": "01:43:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/107---Dr--RAPHAL-MILLIRE---Linguistics--Theory-of-Mind--Grounding-e20c60h",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/66508241/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-2-13%2F2d22c6b6-f49f-3546-40ff-1e6fb1a6d1bd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c576dd50-4533-4268-9e24-4ba38059ee76",
            "index": 148,
            "title": "#106 - Prof. KARL FRISTON 3.0 - Collective Intelligence [Special Edition]",
            "pub_date": "2023-03-11T20:42:19.000Z",
            "duration": "02:59:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/106---Prof--KARL-FRISTON-3-0---Collective-Intelligence-Special-Edition-e208f50",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/66386528/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-2-11%2F50d0286c-1634-44a2-466f-3eb6a7b11f8a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "769e06d7-c240-4c95-83d8-a11017046844",
            "index": 149,
            "title": "#105 - Dr. MICHAEL OLIVER [CSO - Numerai]",
            "pub_date": "2023-03-04T21:54:48.000Z",
            "duration": "01:20:42",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/105---Dr--MICHAEL-OLIVER-CSO---Numerai-e1vs6u5",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/65984901/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-2-4%2F6e350f12-9f3b-d80e-bc4a-dc342b58fe63.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "873ac99b-6594-4f11-8419-5e831236a3ae",
            "index": 150,
            "title": "#104 - Prof. CHRIS SUMMERFIELD - Natural General Intelligence [SPECIAL EDITION]",
            "pub_date": "2023-02-22T00:13:40.000Z",
            "duration": "01:28:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/104---Prof--CHRIS-SUMMERFIELD---Natural-General-Intelligence-SPECIAL-EDITION-e1vb94c",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/65430092/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-1-22%2Ff4d615d7-9082-642b-d34d-45850c5d95a5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "27fdf89c-f2df-4eb2-b2e5-72cf133e6d46",
            "index": 151,
            "title": "#103 - Prof. Edward Grefenstette - Language, Semantics, Philosophy",
            "pub_date": "2023-02-11T21:31:22.000Z",
            "duration": "01:01:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "anthropic",
              "deepmind",
              "rag",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/103---Prof--Edward-Grefenstette---Language--Semantics--Philosophy-e1uqlsv",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/64886111/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-1-11%2F4c4a3c7e-b852-53d6-bd24-925cc62046b2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "49992a79-5cce-4334-9001-c80cd17e7cfa",
            "index": 152,
            "title": "#102 - Prof. MICHAEL LEVIN, Prof. IRINA RISH - Emergence, Intelligence, Transhumanism",
            "pub_date": "2023-02-11T01:45:44.000Z",
            "duration": "00:55:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/102---Prof--MICHAEL-LEVIN--Prof--IRINA-RISH---Emergence--Intelligence--Transhumanism-e1upji9",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/64850953/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-1-11%2F3f321bd4-9a00-592b-3d46-2fd4e058bfb9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "27c09745-67b4-4f55-8167-901fdb5fe3e2",
            "index": 153,
            "title": "#100 Dr. PATRICK LEWIS (co:here) - Retrieval Augmented Generation",
            "pub_date": "2023-02-10T11:18:53.000Z",
            "duration": "00:26:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/100-Dr--PATRICK-LEWIS-cohere---Retrieval-Augmented-Generation-e1uok1c",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/64818668/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-1-10%2F6ad66fd6-9a81-4ddb-db6f-7f12bcb34e8d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aac6c836-894b-4a7d-8e1b-6239844f100c",
            "index": 154,
            "title": "#99 - CARLA CREMER & IGOR KRAWCZUK - X-Risk, Governance, Effective Altruism",
            "pub_date": "2023-02-05T20:53:52.000Z",
            "duration": "01:39:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/99---CARLA-CREMER--IGOR-KRAWCZUK---X-Risk--Governance--Effective-Altruism-e1ugl0o",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/64557528/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-1-5%2F4481f8e5-0aac-cc52-c7a5-c150602cf74f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a023843f-299e-43fa-8951-3bd7e8f62a3b",
            "index": 155,
            "title": "[NO MUSIC] #98 - Prof. LUCIANO FLORIDI - ChatGPT, Singularitarians, Ethics, Philosophy of Information",
            "pub_date": "2023-02-03T11:08:10.000Z",
            "duration": "01:06:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/NO-MUSIC-98---Prof--LUCIANO-FLORIDI---ChatGPT--Singularitarians--Ethics--Philosophy-of-Information-e1udbq2",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/64449794/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-1-3%2Ff88b042f-4471-aeea-ac51-c0e3b8ab9cb3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dfc9a2aa-9f01-437a-93fe-144bd3a79e1c",
            "index": 156,
            "title": "#98 - Prof. LUCIANO FLORIDI - ChatGPT, Superintelligence, Ethics, Philosophy of Information",
            "pub_date": "2023-02-03T02:26:19.000Z",
            "duration": "01:06:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/98---Prof--LUCIANO-FLORIDI---ChatGPT--Superintelligence--Ethics--Philosophy-of-Information-e1ucs52",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/64433762/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-1-3%2F21b72512-f79e-b583-7335-cb0479b32a0f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8aa6fb24-4d96-459e-8545-dea43c8fac59",
            "index": 157,
            "title": "#97 SREEJAN KUMAR - Human Inductive Biases in Machines from Language",
            "pub_date": "2023-01-28T18:35:51.000Z",
            "duration": "00:24:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/97-SREEJAN-KUMAR---Human-Inductive-Biases-in-Machines-from-Language-e1u50ps",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/64176380/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2023-0-28%2F56774d90-b570-185c-0845-14d2cc8faeb7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "433f389f-391a-46f5-9633-95a28bd72c22",
            "index": 158,
            "title": "#96 Prof. PEDRO DOMINGOS - There are no infinities, utility functions, neurosymbolic",
            "pub_date": "2022-12-30T12:18:50.000Z",
            "duration": "02:49:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "deepmind",
              "inference",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/96-Prof--PEDRO-DOMINGOS---There-are-no-infinities--utility-functions--neurosymbolic-e1st1d3",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62866275/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-30%2Fc324daaf-01f8-b193-73ee-4063db376493.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a5a2a48-d3b5-4091-8f96-b501dea2fc8e",
            "index": 159,
            "title": "#95 - Prof. IRINA RISH - AGI, Complex Systems, Transhumanism",
            "pub_date": "2022-12-26T19:29:14.000Z",
            "duration": "00:39:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/95---Prof--IRINA-RISH---AGI--Complex-Systems--Transhumanism-e1so8lh",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62709873/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-26%2Fd096c2eb-f32f-c82a-dde1-ef7efcce9425.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d4c0ff4a-a6e7-419d-9e16-eb474a162d1a",
            "index": 160,
            "title": "#94 - ALAN CHAN - AI Alignment and Governance #NEURIPS",
            "pub_date": "2022-12-26T13:39:32.000Z",
            "duration": "00:13:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "alignment"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/94---ALAN-CHAN---AI-Alignment-and-Governance-NEURIPS-e1sntud",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62698893/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-26%2F4605a493-e90e-e35d-f934-f0809c40a24d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8fefd42a-e85f-440b-b23d-720cd0c4d8e9",
            "index": 161,
            "title": "#93 Prof. MURRAY SHANAHAN - Consciousness, Embodiment, Language Models",
            "pub_date": "2022-12-24T18:26:48.000Z",
            "duration": "01:20:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/93-Prof--MURRAY-SHANAHAN---Consciousness--Embodiment--Language-Models-e1sm6k6",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62642246/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-24%2F1c7f0dc8-f752-0f66-bcbb-9a055c8467c3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d53f325-5748-4518-ac54-d43b69c8c599",
            "index": 162,
            "title": "#92 - SARA HOOKER - Fairness, Interpretability, Language Models",
            "pub_date": "2022-12-23T01:32:15.000Z",
            "duration": "00:51:31",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/92---SARA-HOOKER---Fairness--Interpretability--Language-Models-e1skba2",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62581506/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-23%2Fe7589c5f-a1ef-d1e5-8af8-196ef6030af2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a41b3a0c-d5ca-4269-a23b-33f47cdc08fc",
            "index": 163,
            "title": "#91 - HATTIE ZHOU - Teaching Algorithmic Reasoning via In-context Learning #NeurIPS",
            "pub_date": "2022-12-20T17:04:50.000Z",
            "duration": "00:21:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/91---HATTIE-ZHOU---Teaching-Algorithmic-Reasoning-via-In-context-Learning-NeurIPS-e1sgvh9",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62471145/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-20%2F583c8109-d89f-19c1-8546-79e6540a4469.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19aad36d-57c1-4f0a-b303-8aacc91bf965",
            "index": 164,
            "title": "(Music Removed) #90 - Prof. DAVID CHALMERS - Consciousness in LLMs [Special Edition]",
            "pub_date": "2022-12-19T11:10:43.000Z",
            "duration": "00:53:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "llm",
              "large language model",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/Music-Removed-90---Prof--DAVID-CHALMERS---Consciousness-in-LLMs-Special-Edition-e1sf1l7",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62407783/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-19%2Faeed01f9-97eb-4232-5f12-4a81e6bf34c5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "886902b3-7e8c-4678-9f13-e0e23f383640",
            "index": 165,
            "title": "#90 - Prof. DAVID CHALMERS - Consciousness in LLMs [Special Edition]",
            "pub_date": "2022-12-19T01:23:06.000Z",
            "duration": "00:53:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "llm",
              "large language model",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/90---Prof--DAVID-CHALMERS---Consciousness-in-LLMs-Special-Edition-e1sej50",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62392928/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-19%2F292febaa-6bad-4785-baf5-8b4eef6b373f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c22257a-b16e-40f3-9d32-35103da10739",
            "index": 166,
            "title": "#88 Dr. WALID SABA - Why machines will never rule the world [UNPLUGGED]",
            "pub_date": "2022-12-16T02:23:04.000Z",
            "duration": "01:21:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/88-Dr--WALID-SABA---Why-machines-will-never-rule-the-world-UNPLUGGED-e1sb1di",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62276466/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-16%2F848d26cf-34f8-7d8d-fe1f-775d3bc965ea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6b251bdc-dd72-4587-bf92-e3aa74f46437",
            "index": 167,
            "title": "#86 - Prof. YANN LECUN and Dr. RANDALL BALESTRIERO - SSL, Data Augmentation, Reward isn't enough [NEURIPS2022]",
            "pub_date": "2022-12-11T00:41:40.000Z",
            "duration": "00:30:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/86---Prof--YANN-LECUN-and-Dr--RANDALL-BALESTRIERO---SSL--Data-Augmentation--Reward-isnt-enough-NEURIPS2022-e1s2kkk",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/62001236/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-11%2F31ada0f7-f4f4-38b1-bd5c-7d6c7a699e8f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "225b5310-9d5d-41ad-ae02-aac8f9111736",
            "index": 168,
            "title": "#85 Dr. Petar Veličković (Deepmind) - Categories, Graphs, Reasoning [NEURIPS22 UNPLUGGED]",
            "pub_date": "2022-12-08T23:45:34.000Z",
            "duration": "00:36:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/85-Dr--Petar-Velikovi-Deepmind---Categories--Graphs--Reasoning-NEURIPS22-UNPLUGGED-e1rvtha",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/61912042/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-9%2F301976398-44100-2-92ee0219bd9a2.m4a",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e6e0bec4-f28e-4553-a573-33502348f5b2",
            "index": 169,
            "title": "#84 LAURA RUIS - Large language models are not zero-shot communicators [NEURIPS UNPLUGGED]",
            "pub_date": "2022-12-06T17:36:04.000Z",
            "duration": "00:27:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/84-LAURA-RUIS---Large-language-models-are-not-zero-shot-communicators-NEURIPS-UNPLUGGED-e1rri6k",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/61769364/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-6%2F0b5fdbf7-c39d-a59e-34ae-68a8b363175a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9e222cf7-61a7-438a-a673-d8014fd767f2",
            "index": 170,
            "title": "#83 Dr. ANDREW LAMPINEN (Deepmind) - Natural Language, Symbols and Grounding [NEURIPS2022 UNPLUGGED]",
            "pub_date": "2022-12-04T07:51:26.000Z",
            "duration": "00:20:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "deepmind",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/83-Dr--ANDREW-LAMPINEN-Deepmind---Natural-Language--Symbols-and-Grounding-NEURIPS2022-UNPLUGGED-e1rne53",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/61634147/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-11-4%2Fc72faf62-61e3-adf3-f536-eb12931f875b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d68ffd66-9ee4-494a-95b7-6a9e1993d4e5",
            "index": 171,
            "title": "#82 - Dr. JOSCHA BACH - Digital Physics, DL and Consciousness [UNPLUGGED]",
            "pub_date": "2022-11-27T20:31:09.000Z",
            "duration": "01:15:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/82---Dr--JOSCHA-BACH---Digital-Physics--DL-and-Consciousness-UNPLUGGED-e1rctlc",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/61289580/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-10-27%2F6acae91c-c188-3292-6e06-252781f05e02.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "71bd8c87-6c62-4e64-a2dc-8e32651baf91",
            "index": 172,
            "title": "#81 JULIAN TOGELIUS, Prof. KEN STANLEY - AGI, Games, Diversity & Creativity [UNPLUGGED]",
            "pub_date": "2022-11-20T04:05:21.000Z",
            "duration": "01:09:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/81-JULIAN-TOGELIUS--Prof--KEN-STANLEY---AGI--Games--Diversity--Creativity-UNPLUGGED-e1r1jhu",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/60918782/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-10-20%2F02b7ed72-9d32-982d-f87c-b46408a6410d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "60a7f9f6-6e94-4e1d-9265-6e9b4e2126b7",
            "index": 173,
            "title": "#80 AIDAN GOMEZ [CEO Cohere] - Language as Software",
            "pub_date": "2022-11-15T01:03:48.000Z",
            "duration": "00:51:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "deepmind"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/80-AIDAN-GOMEZ-CEO-Cohere---Language-as-Software-e1qp5vd",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/60642733/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-10-15%2Ffb3d3060-e938-33bb-e82d-a488ca4f5e41.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "955eecc7-7834-4ee8-a488-dda079d68732",
            "index": 174,
            "title": "#79 Consciousness and the Chinese Room [Special Edition] (CHOLLET, BISHOP, CHALMERS, BACH)",
            "pub_date": "2022-11-08T19:44:42.000Z",
            "duration": "02:09:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/79-Consciousness-and-the-Chinese-Room-Special-Edition-CHOLLET--BISHOP--CHALMERS--BACH-e1qet8o",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/60306136/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-10-8%2F9a558340-8a0f-5977-5fc5-c04960c7bd26.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e505dbb5-f742-4352-bd38-e558e49d192a",
            "index": 175,
            "title": "MLST #78 - Prof. NOAM CHOMSKY (Special Edition)",
            "pub_date": "2022-07-08T22:16:00.000Z",
            "duration": "03:37:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/MLST-78---Prof--NOAM-CHOMSKY-Special-Edition-e1l0760",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/54581888/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-6-8%2Fbea2dff0-649d-224a-7398-5d3411bf031e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7767be9-ca00-404b-82d9-df98a7c746c5",
            "index": 176,
            "title": "#77 - Vitaliy Chiley (Cerebras)",
            "pub_date": "2022-06-16T14:27:25.000Z",
            "duration": "01:07:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/77---Vitaliy-Chiley-Cerebras-e1k1hvu",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/53577150/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-5-16%2F657fdf4b-2e57-c09b-67c2-826794d27185.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c909458-d218-4a71-ae8e-8b7aeb476932",
            "index": 177,
            "title": "#76 - LUKAS BIEWALD (Weights and Biases CEO)",
            "pub_date": "2022-06-09T00:02:00.000Z",
            "duration": "00:57:36",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/76---LUKAS-BIEWALD-Weights-and-Biases-CEO-e1jmvd5",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/53230437/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-5-8%2F6bfa5a0d-90fc-a4e0-f2e0-4c1cb4d7dc21.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5f9f96e-f13f-4d93-a668-8d4a64f1a24b",
            "index": 178,
            "title": "#75 - Emergence [Special Edition] with Dr. DANIELE GRATTAROLA",
            "pub_date": "2022-04-29T12:17:05.000Z",
            "duration": "01:55:28",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/75---Emergence-Special-Edition-with-Dr--DANIELE-GRATTAROLA-e1hrb23",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/51276291/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-3-29%2F36ec7f84-e3ba-1b8e-6e39-94e296d58819.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3199dcc-0788-4844-a71a-0c8f5c4d8fa6",
            "index": 179,
            "title": "#74 Dr. ANDREW LAMPINEN - Symbolic behaviour in AI [UNPLUGGED]",
            "pub_date": "2022-04-14T17:20:24.000Z",
            "duration": "01:05:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "deepmind",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/74-Dr--ANDREW-LAMPINEN---Symbolic-behaviour-in-AI-UNPLUGGED-e1h6far",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/50592539/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-3-14%2F9316a669-8858-5ef2-5fe8-a0b9dc7d09b7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e659b75d-b40b-4b46-aa7e-d842025688a6",
            "index": 180,
            "title": "#73 - YASAMAN RAZEGHI & Prof. SAMEER SINGH - NLP benchmarks",
            "pub_date": "2022-04-07T11:56:56.000Z",
            "duration": "00:55:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "deepmind",
              "training",
              "reasoning",
              "retrieval"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/73---YASAMAN-RAZEGHI--Prof--SAMEER-SINGH---NLP-benchmarks-e1grvjj",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/50248755/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-3-7%2Fb423170b-1bdc-6466-f8e6-42a2f27545e9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "85f6d54d-a675-40d2-8636-1362d84c5597",
            "index": 181,
            "title": "#72 Prof. KEN STANLEY 2.0 - On Art and Subjectivity [UNPLUGGED]",
            "pub_date": "2022-03-29T21:31:56.000Z",
            "duration": "01:24:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/72-Prof--KEN-STANLEY-2-0---On-Art-and-Subjectivity-UNPLUGGED-e1gelqt",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/49812765/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-2-29%2F7c22738e-43be-8bb3-9019-94f4a936a946.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "26bb5cb0-1e78-482f-948d-a54b985e8fbe",
            "index": 182,
            "title": "#71 - ZAK JOST (Graph Neural Networks + Geometric DL) [UNPLUGGED]",
            "pub_date": "2022-03-25T18:10:05.000Z",
            "duration": "01:02:35",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/71---ZAK-JOST-Graph-Neural-Networks--Geometric-DL-UNPLUGGED-e1g8dvr",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/49608123/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-2-25%2F469e352d-1565-1e37-7d4f-93d9240b57fb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46ea9658-aefa-436e-a75b-429a1ec39b2f",
            "index": 183,
            "title": "#70 - LETITIA PARCALABESCU - Symbolics, Linguistics [UNPLUGGED]",
            "pub_date": "2022-03-19T14:24:37.000Z",
            "duration": "01:18:30",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/70---LETITIA-PARCALABESCU---Symbolics--Linguistics-UNPLUGGED-e1fuqas",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/49293084/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-2-19%2F7cadb348-563c-bb7b-4a8b-9a74e8cc4422.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b48cc804-6bad-41b3-8d8c-e740f09a3736",
            "index": 184,
            "title": "#69 DR. THOMAS LUX - Interpolation of Sparse High-Dimensional Data",
            "pub_date": "2022-03-12T14:13:07.000Z",
            "duration": "00:50:38",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/69-DR--THOMAS-LUX---Interpolation-of-Sparse-High-Dimensional-Data-e1fk3am",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/48941846/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-2-12%2Fb0de86de-c053-2048-f079-396dec019876.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef843a67-85e6-40f4-b5c5-a8ef3e135b5b",
            "index": 185,
            "title": "#68 DR. WALID SABA 2.0 - Natural Language Understanding [UNPLUGGED]",
            "pub_date": "2022-03-07T13:25:57.000Z",
            "duration": "01:42:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/68-DR--WALID-SABA-2-0---Natural-Language-Understanding-UNPLUGGED-e1fbsdp",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/48672633/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-2-7%2F252293775-44100-2-c7ff5cdd5f40b.m4a",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0374dd4-5857-416c-bbba-c94538315d46",
            "index": 186,
            "title": "#67 Prof. KARL FRISTON 2.0",
            "pub_date": "2022-03-02T10:01:46.000Z",
            "duration": "01:42:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/67-Prof--KARL-FRISTON-2-0-e1f4ck3",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/48427075/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-2-2%2F04dcf002-3cef-4c37-ac83-b68c43a69e4f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1bc202a1-47c2-4150-8919-f66a7c8accbc",
            "index": 187,
            "title": "#66 ALEXANDER MATTICK - [Unplugged / Community Edition]",
            "pub_date": "2022-02-28T08:09:10.000Z",
            "duration": "00:50:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/66-ALEXANDER-MATTICK---Unplugged--Community-Edition-e1f12n9",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/48318633/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-1-28%2F59d17419-d570-9ae7-3e29-b1b367645f10.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e0d20e0a-15b8-4d74-a816-f17f69d9a85a",
            "index": 188,
            "title": "#65 Prof. PEDRO DOMINGOS [Unplugged]",
            "pub_date": "2022-02-26T00:27:22.000Z",
            "duration": "01:28:27",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "training",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/65-Prof--PEDRO-DOMINGOS-Unplugged-e1eu8pp",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/48226553/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-1-26%2F14f8fb2f-d937-5d27-3241-b3dff1801ad3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "56e13bd1-0861-4c66-93b5-35b6ea3c9520",
            "index": 189,
            "title": "#64 Prof. Gary Marcus 3.0",
            "pub_date": "2022-02-24T15:44:12.000Z",
            "duration": "00:51:47",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/64-Prof--Gary-Marcus-3-0-e1es2gc",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/48154572/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-1-24%2Ff7efaa32-dd48-9e03-aa3b-0687dde9e928.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0625feba-36d1-4cfc-adc9-3b5ed8b3e6c3",
            "index": 190,
            "title": "#063 - Prof. YOSHUA BENGIO - GFlowNets, Consciousness & Causality",
            "pub_date": "2022-02-22T00:07:28.000Z",
            "duration": "01:33:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "inference",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/063---Prof--YOSHUA-BENGIO---GFlowNets--Consciousness--Causality-e1enlor",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/48010459/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-1-21%2F8ff3e9bb-1aff-6fef-2c2e-140852498452.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9acd8525-4034-48ac-83a9-cf2bb20af75f",
            "index": 191,
            "title": "#062 - Dr. Guy Emerson - Linguistics, Distributional Semantics",
            "pub_date": "2022-02-03T12:41:59.000Z",
            "duration": "01:29:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/062---Dr--Guy-Emerson---Linguistics--Distributional-Semantics-e1ds64t",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/47109725/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-1-3%2F26941690-35c1-33ee-e47c-4979d30a79ea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "198d3ee2-efda-4f3a-9dfe-e80b78b08a23",
            "index": 192,
            "title": "061: Interpolation, Extrapolation and Linearisation (Prof. Yann LeCun, Dr. Randall Balestriero)",
            "pub_date": "2022-01-04T12:59:49.000Z",
            "duration": "03:19:43",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/061-Interpolation--Extrapolation-and-Linearisation-Prof--Yann-LeCun--Dr--Randall-Balestriero-e1cgdr0",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/45675808/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2022-0-4%2F2aa9693f-f8f0-ebad-2737-3a1e1c40a352.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f83c2af5-c105-4695-bfed-e079ed9e9640",
            "index": 193,
            "title": "#60 Geometric Deep Learning Blueprint (Special Edition)",
            "pub_date": "2021-09-19T01:29:09.000Z",
            "duration": "03:33:22",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "deepmind"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/60-Geometric-Deep-Learning-Blueprint-Special-Edition-e17i495",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/40488677/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-8-19%2F449d199e-c75f-722f-e76a-1ae28213dd6c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5604cbf9-a551-406e-b89f-f4a06e16a8ab",
            "index": 194,
            "title": "#59 - Jeff Hawkins (Thousand Brains Theory)",
            "pub_date": "2021-09-03T18:09:33.000Z",
            "duration": "02:34:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/59---Jeff-Hawkins-Thousand-Brains-Theory-e16sb64",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/39774852/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-8-3%2F4d48d916-4cd7-7398-69f6-83aded175656.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0fcb7894-4556-410c-8903-47b5eefd090c",
            "index": 195,
            "title": "#58 Dr. Ben Goertzel - Artificial General Intelligence",
            "pub_date": "2021-08-11T14:05:22.000Z",
            "duration": "02:28:14",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "artificial intelligence",
              "agi"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/58-Dr--Ben-Goertzel---Artificial-General-Intelligence-e15p20i",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/38618578/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-7-11%2F3eea790a-e615-bc66-a8d3-7faf1f0593bb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ce219ec4-4862-4f7f-a511-cf6a321eb785",
            "index": 196,
            "title": "#57 - Prof. Melanie Mitchell - Why AI is harder than we think",
            "pub_date": "2021-07-25T15:40:20.000Z",
            "duration": "02:31:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/57---Prof--Melanie-Mitchell---Why-AI-is-harder-than-we-think-e1502td",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/37800301/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-6-25%2F136f8d4a-706e-128d-80e2-10db09f28fc9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "15a18fe5-7f45-44c6-8bfc-fd372510a470",
            "index": 197,
            "title": "#56 - Dr. Walid Saba, Gadi Singer, Prof. J. Mark Bishop (Panel discussion)",
            "pub_date": "2021-07-08T21:31:16.000Z",
            "duration": "01:11:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/56---Dr--Walid-Saba--Gadi-Singer--Prof--J--Mark-Bishop-Panel-discussion-e145bt0",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/36924768/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-6-8%2F2fc7931c-492f-a5cb-1aaf-17cc4b9c7675.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4a6c5359-97c5-4269-b95f-420780b7747b",
            "index": 198,
            "title": "#55 Self-Supervised Vision Models (Dr. Ishan Misra - FAIR).",
            "pub_date": "2021-06-21T01:21:42.000Z",
            "duration": "01:36:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/55-Self-Supervised-Vision-Models-Dr--Ishan-Misra---FAIR-e1355js",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/35869756/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-5-21%2F6f9782df-d4f0-9fa1-1fe8-b04a7444e7d1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd1736df-6b5a-4687-b36c-4f280b031620",
            "index": 199,
            "title": "#54 Gary Marcus and Luis Lamb - Neurosymbolic models",
            "pub_date": "2021-06-04T08:41:29.000Z",
            "duration": "02:24:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/54-Gary-Marcus-and-Luis-Lamb---Neurosymbolic-models-e125495",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/34819813/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-5-4%2F7e2e44b8-15e5-33eb-e154-02b5e1033bea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "335950a9-47a2-4292-93c6-1689541aefd0",
            "index": 200,
            "title": "#53 Quantum Natural Language Processing - Prof. Bob Coecke (Oxford)",
            "pub_date": "2021-05-19T11:07:33.000Z",
            "duration": "02:17:39",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://podcasters.spotify.com/pod/show/machinelearningstreettalk/episodes/53-Quantum-Natural-Language-Processing---Prof--Bob-Coecke-Oxford-e1164i5",
            "audio_url": "https://anchor.fm/s/1e4a0eac/podcast/play/33804293/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2021-4-19%2F7ed9e6cc-97aa-9c19-9dfe-4b1a50547e08.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "invest-like-the-best",
        "title": "Invest Like the Best",
        "feed_title": "Invest Like the Best with Patrick O'Shaughnessy",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "business",
          "investing",
          "AI companies"
        ],
        "feed_url": "https://feeds.megaphone.fm/CLS2859450455",
        "source_url": "https://feeds.megaphone.fm/CLS2859450455",
        "detail_path": "/podcasts/invest-like-the-best/",
        "episode_count": 300,
        "selected_episode_count": 158,
        "latest_episode_title": "Dara Khosrowshahi - Uber's Bet on AVs, AI, and Building a Super-App - [Invest Like the Best, EP.476]",
        "latest_pub_date": "2026-06-03T08:00:00.000Z",
        "latest_page_url": "https://colossus.com/episode/order-out-of-chaos/",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "b0548680-5efc-11f1-b7e5-c74e739454e3",
            "index": 1,
            "title": "Dara Khosrowshahi - Uber's Bet on AVs, AI, and Building a Super-App - [Invest Like the Best, EP.476]",
            "pub_date": "2026-06-03T08:00:00.000Z",
            "duration": "4037",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "cursor",
              "chip"
            ],
            "page_url": "https://colossus.com/episode/order-out-of-chaos/",
            "audio_url": "https://traffic.megaphone.fm/CLS3105050568.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "287a409a-5a58-11f1-b0cd-5fd58e8d8d52",
            "index": 2,
            "title": "Dan Loeb - Lessons from 30 Years of Investing - [Invest Like the Best, EP.475]",
            "pub_date": "2026-05-28T08:00:00.000Z",
            "duration": "3783",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://colossus.com/episode/reminiscences-of-an-investor/",
            "audio_url": "https://traffic.megaphone.fm/CLS8547493168.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "880fe730-5891-11f1-af54-f7159e798863",
            "index": 3,
            "title": "Darren Farber on Iran, China, and the Rise of Neoprimes - [Invest Like the Best, EP.474]",
            "pub_date": "2026-05-26T08:00:00.000Z",
            "duration": "2779",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://colossus.com/episode/the-new-rules-of-war/",
            "audio_url": "https://traffic.megaphone.fm/CLS3936356790.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3bc7d580-53ec-11f1-99c0-3bd245449e4f",
            "index": 4,
            "title": "Gavin Baker - Watts and Wafers - [Invest Like the Best, EP.473]",
            "pub_date": "2026-05-20T08:00:00.000Z",
            "duration": "4611",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "cursor",
              "chip"
            ],
            "page_url": "https://colossus.com/episode/watts-and-wafers/",
            "audio_url": "https://traffic.megaphone.fm/CLS8755474209.mp3?updated=1779241717",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fdfca472-4e43-11f1-bf1a-cf5adcc9aeb5",
            "index": 5,
            "title": "Krishna Rao - Anthropic's CFO on Compute, Scaling to $30B ARR, and the Returns to Frontier Intelligence - [Invest Like the Best, EP.472]",
            "pub_date": "2026-05-13T08:00:00.000Z",
            "duration": "4567",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "claude",
              "cursor",
              "chip"
            ],
            "page_url": "https://colossus.com/episode/cone-of-uncertainty/",
            "audio_url": "https://traffic.megaphone.fm/CLS3629415437.mp3?updated=1778621552",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6162ba8a-4843-11f1-b7b7-53d3b402f9a6",
            "index": 6,
            "title": "Brian Chesky - AI Founder Mode - [Invest Like the Best, EP.471]",
            "pub_date": "2026-05-05T08:00:00.000Z",
            "duration": "4523",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "cursor",
              "training"
            ],
            "page_url": "https://colossus.com/episode/ai-founder-mode/",
            "audio_url": "https://traffic.megaphone.fm/CLS3515065653.mp3?updated=1777959750",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52d36872-42a6-11f1-b41c-87326559037a",
            "index": 7,
            "title": "Paul Tudor Jones - Lessons From 50 Years in Markets - [Invest Like the Best, EP.470]",
            "pub_date": "2026-04-28T08:00:00.000Z",
            "duration": "4013",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://colossus.com/episode/you-retire-you-die/",
            "audio_url": "https://traffic.megaphone.fm/CLS2354819617.mp3?updated=1777343956",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ceb34422-3ec7-11f1-97a5-8bd036d5980c",
            "index": 8,
            "title": "Dylan Patel - The Infinite Demand for Tokens, Claude Mythos, and Supply Constraints - [Invest Like the Best, EP.469]",
            "pub_date": "2026-04-23T08:00:00.000Z",
            "duration": "2719",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "frontier model",
              "agents",
              "openai",
              "anthropic",
              "claude",
              "cursor"
            ],
            "page_url": "https://colossus.com/episode/supply-demand-of-tokens/",
            "audio_url": "https://traffic.megaphone.fm/CLS5440706188.mp3?updated=1776949663",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cbc5538c-3d2c-11f1-abeb-8fa0b9345ba8",
            "index": 9,
            "title": "Alex Karnal - The Trillion-Dollar Health Revolution - [Invest Like the Best, EP.468]",
            "pub_date": "2026-04-21T08:00:00.000Z",
            "duration": "5540",
            "duration_label": "1h 32m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "training"
            ],
            "page_url": "https://colossus.com/episode/trillion-dollar-health-revolution/",
            "audio_url": "https://traffic.megaphone.fm/CLS4367259219.mp3?updated=1776741147",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5edee546-3776-11f1-b41d-a76759576e87",
            "index": 10,
            "title": "Scott Nolan - SpaceX, Founders Fund, and Rebuilding American Uranium Enrichment - [Invest Like the Best, EP.467]",
            "pub_date": "2026-04-14T08:00:00.000Z",
            "duration": "4558",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/betting-on-atoms/",
            "audio_url": "https://traffic.megaphone.fm/CLS4605449926.mp3?updated=1776112623",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d74e56f4-32b4-11f1-8f92-73b020faf92b",
            "index": 11,
            "title": "Alan Waxman - Private Credit and the Modern Financial System - [Invest Like the Best, EP.466]",
            "pub_date": "2026-04-08T08:00:00.000Z",
            "duration": "3739",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/clarity-of-purpose/",
            "audio_url": "https://traffic.megaphone.fm/CLS1757520791.mp3?updated=1775592030",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fdcd4328-2c77-11f1-a72b-977309fd08f1",
            "index": 12,
            "title": "Sergey Levine - Building LLMs for the Physical World - [Invest Like the Best, EP.465]",
            "pub_date": "2026-03-31T08:00:00.000Z",
            "duration": "3995",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "robotics"
            ],
            "page_url": "https://colossus.com/episode/building-general-physical-intelligence",
            "audio_url": "https://traffic.megaphone.fm/CLS7427739184.mp3?updated=1774904050",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75b94c5e-2716-11f1-9b2f-8fbf1bf324fd",
            "index": 13,
            "title": "Mitchell Green - Lessons from Cold Calling 10,000 Companies - [Invest Like the Best, EP.464]",
            "pub_date": "2026-03-24T08:00:00.000Z",
            "duration": "3262",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/building-a-machine/",
            "audio_url": "https://traffic.megaphone.fm/CLS1941425055.mp3?updated=1774315696",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fafd11c6-2198-11f1-9f4c-331b7fdffb5f",
            "index": 14,
            "title": "William Hockey - Building the Operating System for the Dollar and Silicon Valley Heresy - [Invest Like the Best, EP.463]",
            "pub_date": "2026-03-17T08:00:00.000Z",
            "duration": "4250",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/playing-a-different-game/",
            "audio_url": "https://traffic.megaphone.fm/CLS2527788345.mp3?updated=1773710398",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9dee904c-1bbf-11f1-a1a6-0b200fdaa525",
            "index": 15,
            "title": "Shyam Sankar - Celebrating Heretics - [Invest Like the Best, EP.462]",
            "pub_date": "2026-03-10T08:00:00.000Z",
            "duration": "4898",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/celebrating-heretics/",
            "audio_url": "https://traffic.megaphone.fm/CLS5250833209.mp3?updated=1773108898",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d466670-1755-11f1-baf2-dfb3d97a3978",
            "index": 16,
            "title": "John Arnold - China, Energy Markets and Fixing America's Systems - [Invest Like the Best, EP.461]",
            "pub_date": "2026-03-04T09:00:00.000Z",
            "duration": "4549",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "robotics"
            ],
            "page_url": "https://colossus.com/episode/the-best-seat-in-the-market",
            "audio_url": "https://traffic.megaphone.fm/CLS5258916659.mp3?updated=1772590723",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6935741a-1133-11f1-8658-83eef776ecd3",
            "index": 17,
            "title": "Dan Sundheim - The Art of Public and Private Market Investing - [Invest Like the Best, EP.460]",
            "pub_date": "2026-02-24T09:00:00.000Z",
            "duration": "4518",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "https://colossus.com/episode/the-art-of-public-private-market-investing",
            "audio_url": "https://traffic.megaphone.fm/CLS5459102822.mp3?updated=1771933632",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77704aec-0c73-11f1-9aef-47fb47e3545b",
            "index": 18,
            "title": "Josh Kushner - Concentration and Conviction - [Invest Like the Best, EP.459]",
            "pub_date": "2026-02-18T09:00:00.000Z",
            "duration": "3784",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai"
            ],
            "page_url": "https://colossus.com/episode/concentration-and-conviction/",
            "audio_url": "https://traffic.megaphone.fm/CLS3628063408.mp3?updated=1771386030",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e08d17d8-0630-11f1-900f-af0896d80a14",
            "index": 19,
            "title": "Alex Behring and Daniel Schwartz - Inside 3G Capital - [Invest Like the Best, EP.458]",
            "pub_date": "2026-02-10T09:00:00.000Z",
            "duration": "5749",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/inside-3g-capital/",
            "audio_url": "https://traffic.megaphone.fm/CLS7883898186.mp3?updated=1770695228",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9505619a-009e-11f1-869d-c7d5bc43b194",
            "index": 20,
            "title": "Ben Horowitz - Backing America’s Future - [Invest Like the Best, EP.457]",
            "pub_date": "2026-02-03T09:00:00.000Z",
            "duration": "3351",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/backing-americas-future/",
            "audio_url": "https://traffic.megaphone.fm/CLS6351108007.mp3?updated=1770089197",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a35cb364-fc94-11f0-a24d-836fa963ece3",
            "index": 21,
            "title": "Gokul Rajaram - Lessons from Investing in 700 Companies - [Invest Like the Best, EP.456]",
            "pub_date": "2026-01-29T16:32:00.000Z",
            "duration": "4562",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/lessons-from-investing-in-700-companies",
            "audio_url": "https://traffic.megaphone.fm/CLS3048664941.mp3?updated=1769654391",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "816fce6a-f5b6-11f0-9c9c-33831009577b",
            "index": 22,
            "title": "Patrick O’Shaughnessy - Creating on Principle - [Invest Like the Best, EP.455]",
            "pub_date": "2026-01-20T09:00:00.000Z",
            "duration": "7600",
            "duration_label": "2h 6m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/creating-on-principle/",
            "audio_url": "https://traffic.megaphone.fm/CLS5957049474.mp3?updated=1768886345",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8459013c-f00c-11f0-ac98-fbad2fe189ee",
            "index": 23,
            "title": "Tom Digan & Greg Stewart - Building the World’s Best Fitness App - [Invest Like the Best, EP.454]",
            "pub_date": "2026-01-13T09:00:00.000Z",
            "duration": "4448",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://colossus.com/episode/building-the-worlds-best-fitness-app",
            "audio_url": "https://traffic.megaphone.fm/CLS1415175202.mp3?updated=1768269876",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2f1ecac4-e4ba-11f0-a8e8-777eb8de0c5a",
            "index": 24,
            "title": "Reed Hastings - Building Netflix - [Invest Like the Best, EP.453]",
            "pub_date": "2026-01-06T09:00:00.000Z",
            "duration": "3753",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "anthropic"
            ],
            "page_url": "https://joincolossus.com/episode/building-netflix/",
            "audio_url": "https://traffic.megaphone.fm/CLS6619786132.mp3?updated=1767944938",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7f11b7e-e516-11f0-8700-239aa8e47bb9",
            "index": 25,
            "title": "Nick Kokonas - Know What You Are Selling - [Invest Like The Best, REPLAY]",
            "pub_date": "2025-12-30T09:00:00.000Z",
            "duration": "4667",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/kokonas-know-what-you-are-selling/",
            "audio_url": "https://traffic.megaphone.fm/CLS6172837310.mp3?updated=1767945418",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8d024f8-df4f-11f0-840d-5ff663ee0c32",
            "index": 26,
            "title": "Ric Elias - The Art of Living Well - [Invest Like The Best, CLASSICS]",
            "pub_date": "2025-12-23T09:00:00.000Z",
            "duration": "5115",
            "duration_label": "1h 25m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episode/ric-elias-the-art-of-living-well/",
            "audio_url": "https://traffic.megaphone.fm/CLS5070092687.mp3?updated=1767945497",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "498a0910-d6ea-11f0-aae4-8f837283e00f",
            "index": 27,
            "title": "Henry Ellenbogen - Man Versus Machine - [Invest Like the Best, EP.452]",
            "pub_date": "2025-12-16T09:00:00.000Z",
            "duration": "6478",
            "duration_label": "1h 47m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://joincolossus.com/episode/man-versus-machine",
            "audio_url": "https://traffic.megaphone.fm/CLS7071600099.mp3?updated=1767945547",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d97fee14-d4d7-11f0-8951-8324b640c1c1",
            "index": 28,
            "title": "Gavin Baker - Nvidia v. Google, Scaling Laws, and the Economics of AI - [Invest Like the Best, EP.451]",
            "pub_date": "2025-12-09T15:05:00.000Z",
            "duration": "5133",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gemini",
              "nvidia",
              "training"
            ],
            "page_url": "https://joincolossus.com/episode/nvidia-v-google-%E2%80%A6-economics-of-ai/",
            "audio_url": "https://traffic.megaphone.fm/CLS5994992754.mp3?updated=1767945603",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8da7dbd8-ceeb-11f0-941c-ef83bcdd4c9f",
            "index": 29,
            "title": "David George - Building a16z Growth, Investing Across the AI Stack, and Why Markets Misprice Growth - [Invest Like the Best, EP.450]",
            "pub_date": "2025-12-02T09:00:00.000Z",
            "duration": "4021",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "cursor",
              "robotics"
            ],
            "page_url": "https://joincolossus.com/episode/inside-a16z-growth/",
            "audio_url": "https://traffic.megaphone.fm/CLS8238779690.mp3?updated=1767945688",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f7c9aa8e-cb8d-11f0-828e-0b281809c10a",
            "index": 30,
            "title": "Palmer Luckey - Inventing the Future of Defense - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-11-28T09:00:00.000Z",
            "duration": "4509",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/luckey-inventing-the-future-of-defense/",
            "audio_url": "https://traffic.megaphone.fm/CLS9097832031.mp3?updated=1764249583",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90e6e3e6-c984-11f0-ae5f-27bb851bdc56",
            "index": 31,
            "title": "Martín Escobari - Inside General Atlantic - [Invest Like the Best, EP.449]",
            "pub_date": "2025-11-25T09:00:00.000Z",
            "duration": "4219",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/inside-general-atlantic/",
            "audio_url": "https://traffic.megaphone.fm/CLS8198317626.mp3?updated=1767945725",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5910280-c4dd-11f0-94be-ab6a7a5865b0",
            "index": 32,
            "title": "Ari Emanuel - The Anti-AI Bet - [Invest Like the Best, EP.448]",
            "pub_date": "2025-11-19T12:40:00.000Z",
            "duration": "3744",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://joincolossus.com/episode/ari-emanuel-the-anti-ai-bet/",
            "audio_url": "https://traffic.megaphone.fm/CLS9602368643.mp3?updated=1767945780",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "adaa55e4-bead-11f0-a5d6-a799713dc0a0",
            "index": 33,
            "title": "Wolfgang Hammer - The Power of Story - [Invest Like the Best, EP.447]",
            "pub_date": "2025-11-11T11:31:00.000Z",
            "duration": "2552",
            "duration_label": "42m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/the-power-of-story/",
            "audio_url": "https://traffic.megaphone.fm/CLS4036126152.mp3?updated=1767945800",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b29cbd80-b93a-11f0-a1b7-2b977c9469a2",
            "index": 34,
            "title": "Luca Ferrari - Building Bending Spoons - [Invest Like the Best, EP.446]",
            "pub_date": "2025-11-04T09:00:00.000Z",
            "duration": "4895",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-bending-spoons/",
            "audio_url": "https://traffic.megaphone.fm/CLS9376149052.mp3?updated=1767945867",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9e957b1c-b60e-11f0-8fae-c3720ebd149d",
            "index": 35,
            "title": "Kevin Kelly - Be Generous and Unique - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-10-31T08:00:00.000Z",
            "duration": "4099",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/52190137/kelly-be-generous-unique",
            "audio_url": "https://traffic.megaphone.fm/CLS2116983513.mp3?updated=1761885712",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1fe2ef5a-b37c-11f0-8838-43577722245c",
            "index": 36,
            "title": "Ken Langone - The American Dream - [Invest Like the Best, REPLAY]",
            "pub_date": "2025-10-30T18:29:00.000Z",
            "duration": "3008",
            "duration_label": "50m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/32603766/langone-the-american-dream",
            "audio_url": "https://traffic.megaphone.fm/CLS6941283955.mp3?updated=1767945893",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cae7f966-ae33-11f0-8236-4fd7e9c6dce4",
            "index": 37,
            "title": "Karim Atiyeh - Building Ramp - [Invest Like the Best, EP.445]",
            "pub_date": "2025-10-21T08:00:00.000Z",
            "duration": "6362",
            "duration_label": "1h 46m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "https://joincolossus.com/episode/building-ramp/",
            "audio_url": "https://traffic.megaphone.fm/CLS5019508518.mp3?updated=1767945998",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e1599a88-a9f6-11f0-b532-e3695bb27d60",
            "index": 38,
            "title": "Dan Wang - The US vs China In The 21st Century - [Invest Like the Best, EP.444]",
            "pub_date": "2025-10-16T08:00:00.000Z",
            "duration": "5767",
            "duration_label": "1h 36m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/the-us-vs-china-…the-21st-century/",
            "audio_url": "https://traffic.megaphone.fm/CLS7039449544.mp3?updated=1767946576",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2cc4da2a-a266-11f0-ac41-9f5060c6f4ef",
            "index": 39,
            "title": "Jesse Zhang - Building Decagon - [Invest Like the Best, EP.443]",
            "pub_date": "2025-10-06T08:00:00.000Z",
            "duration": "4932",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "coding"
            ],
            "page_url": "https://joincolossus.com/episode/building-decagon/",
            "audio_url": "https://traffic.megaphone.fm/CLS5548199143.mp3?updated=1767946599",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "799253cc-9de9-11f0-8661-ab7b8e3cb4c1",
            "index": 40,
            "title": "Dylan Patel - Inside the Trillion-Dollar AI Buildout - [Invest Like the Best, EP.442]",
            "pub_date": "2025-09-30T10:45:00.000Z",
            "duration": "7155",
            "duration_label": "1h 59m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "data center",
              "training"
            ],
            "page_url": "https://joincolossus.com/episode/inside-the-trill…llar-ai-buildout/",
            "audio_url": "https://traffic.megaphone.fm/CLS4002728814.mp3?updated=1767946650",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "74c692e0-9ad3-11f0-a7bd-af761a644c08",
            "index": 41,
            "title": "Rolex: Timeless Excellence - (Invest Like the Best, CLASSICS)",
            "pub_date": "2025-09-26T12:30:00.000Z",
            "duration": "3751",
            "duration_label": "1h 2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/12878745/clymer-rolex-timeless-excellence",
            "audio_url": "https://traffic.megaphone.fm/CLS4571350710.mp3?updated=1758889804",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da754fbe-982b-11f0-906f-df064e72aff3",
            "index": 42,
            "title": "Barry Diller - Building An Entertainment Empire - [Invest Like the Best, EP.441]",
            "pub_date": "2025-09-23T08:30:00.000Z",
            "duration": "3275",
            "duration_label": "54m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-an-entertainment-empire/",
            "audio_url": "https://traffic.megaphone.fm/CLS5960158397.mp3?updated=1767947872",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b4266fde-9298-11f0-aa46-0ffc388021d9",
            "index": 43,
            "title": "Jeff Horing - Building Insight Partners - [Invest Like the Best, EP.440]",
            "pub_date": "2025-09-16T08:00:00.000Z",
            "duration": "5531",
            "duration_label": "1h 32m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-insight-partners/",
            "audio_url": "https://traffic.megaphone.fm/CLS2610477243.mp3?updated=1767947933",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3e5e0f6e-8d2a-11f0-811d-c7a277274b56",
            "index": 44,
            "title": "Sam Hinkie - Find Your People - [Invest Like the Best, REPLAY]",
            "pub_date": "2025-09-09T08:00:00.000Z",
            "duration": "4738",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/hinkie-find-your-people/",
            "audio_url": "https://traffic.megaphone.fm/CLS5867676116.mp3?updated=1767947983",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed36752c-8a18-11f0-8a0e-2349cece244e",
            "index": 45,
            "title": "Sean Feeney - Reinventing the Restaurant Business - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-09-05T08:00:00.000Z",
            "duration": "6467",
            "duration_label": "1h 47m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/98380145/feeney-reinventing-the-restaurant-business",
            "audio_url": "https://traffic.megaphone.fm/CLS5430101548.mp3?updated=1757069423",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2aea930c-87ae-11f0-8697-cb5dad1db6b4",
            "index": 46,
            "title": "Justin Ishbia - Lessons from Acquiring 586 Companies [Invest Like the Best, REPLAY]",
            "pub_date": "2025-09-02T08:00:00.000Z",
            "duration": "4491",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/ishbia-a-system-for-success/",
            "audio_url": "https://traffic.megaphone.fm/CLS3471159072.mp3?updated=1767947980",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "280e6dec-8223-11f0-97fc-afb1d278310c",
            "index": 47,
            "title": "Joe Liemandt  - Building Alpha School, and The Future of Education - [Invest Like the Best, EP.439]",
            "pub_date": "2025-08-26T08:00:00.000Z",
            "duration": "8852",
            "duration_label": "2h 27m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-alpha-s…ure-of-education/",
            "audio_url": "https://traffic.megaphone.fm/CLS3773083193.mp3?updated=1767948040",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c88d404c-7c81-11f0-a8de-6b966ecd7668",
            "index": 48,
            "title": "Mark Bertolini - Performance During Pain - [Invest Like the Best, EP.438]",
            "pub_date": "2025-08-19T08:00:00.000Z",
            "duration": "5934",
            "duration_label": "1h 38m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/performance-during-pain/",
            "audio_url": "https://traffic.megaphone.fm/CLS3042335672.mp3?updated=1767948055",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "07a5dc58-76e2-11f0-82c4-d3c1d7e0262e",
            "index": 49,
            "title": "Peter Lacaillade - Backing The Best Managers In Private Markets - [Invest Like the Best, EP.437]",
            "pub_date": "2025-08-12T08:00:00.000Z",
            "duration": "5517",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/backing-the-best…-private-markets/",
            "audio_url": "https://traffic.megaphone.fm/CLS3382985624.mp3?updated=1767948315",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "76d10438-7177-11f0-ba5f-cb7a7e884de4",
            "index": 50,
            "title": "Andrew Milgram - Full-Contact Capitalism - [Invest Like the Best, EP.436]",
            "pub_date": "2025-08-05T08:00:00.000Z",
            "duration": "5649",
            "duration_label": "1h 34m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/full-contact-capitalism/",
            "audio_url": "https://traffic.megaphone.fm/CLS1669092691.mp3?updated=1767948349",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8322f8e4-6c19-11f0-9a7d-03d179280ede",
            "index": 51,
            "title": "Ramtin Naimi - Building Abstract - [Invest Like the Best, EP.435]",
            "pub_date": "2025-07-29T08:00:00.000Z",
            "duration": "6830",
            "duration_label": "1h 53m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-abstract/",
            "audio_url": "https://traffic.megaphone.fm/CLS8386413842.mp3?updated=1767948390",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "86655662-653b-11f0-98f4-2bf762dcde4d",
            "index": 52,
            "title": "Brad Jacobs - Think Big and Move Fast - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-07-25T08:00:00.000Z",
            "duration": "5126",
            "duration_label": "1h 25m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/19966134/jacobs-think-big-and-move-fast",
            "audio_url": "https://traffic.megaphone.fm/CLS4300859859.mp3?updated=1753011551",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "396c4896-5e67-11f0-8f37-5f21dc2aa439",
            "index": 53,
            "title": "Zach Dell - Powering the Future - [Invest Like the Best, EP.434]",
            "pub_date": "2025-07-22T08:00:00.000Z",
            "duration": "4985",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/powering-the-future/",
            "audio_url": "https://traffic.megaphone.fm/CLS3055880779.mp3?updated=1767948403",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca61248a-5e66-11f0-9653-57575f43fea0",
            "index": 54,
            "title": "Alan Waxman - Building Sixth Street - [Invest Like the Best, EP.433]",
            "pub_date": "2025-07-15T08:00:00.000Z",
            "duration": "4493",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-sixth-street/",
            "audio_url": "https://traffic.megaphone.fm/CLS2136515576.mp3?updated=1767948503",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "14c8768e-5b99-11f0-8e58-57c473fbf77a",
            "index": 55,
            "title": "Caryn Seidman-Becker: Rebuilding CLEAR - [Invest Like the Best, EP.432]",
            "pub_date": "2025-07-08T08:00:00.000Z",
            "duration": "5275",
            "duration_label": "1h 27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episode/rebuilding-clear/",
            "audio_url": "https://traffic.megaphone.fm/CLS4747113592.mp3?updated=1767948539",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b47d081e-55dd-11f0-84c0-4f0edbc32eb4",
            "index": 56,
            "title": "Jens Grede - Building SKIMS - [Invest Like the Best, EP.431]",
            "pub_date": "2025-07-01T08:00:00.000Z",
            "duration": "5480",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-skims/",
            "audio_url": "https://traffic.megaphone.fm/CLS5204568999.mp3?updated=1767948551",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98643910-52ac-11f0-80d8-0b9f0f0096bb",
            "index": 57,
            "title": "Charlie Songhurst – Lessons from Investing in 483 Companies - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-06-27T08:00:00.000Z",
            "duration": "4086",
            "duration_label": "1h 8m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episode/songhurst-lessons-from-investing-in-483-companies/",
            "audio_url": "https://traffic.megaphone.fm/CLS8006620064.mp3?updated=1750957046",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "368f34fc-50a3-11f0-b2b9-5b9f31405f9f",
            "index": 58,
            "title": "The Chainsmokers - Music & Markets - [Invest Like the Best, EP.430]",
            "pub_date": "2025-06-24T08:00:00.000Z",
            "duration": "4712",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/music-markets/",
            "audio_url": "https://traffic.megaphone.fm/CLS4770544876.mp3?updated=1767948618",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "973ac596-4ae5-11f0-80f4-c3be07cbc9a5",
            "index": 59,
            "title": "Jay Hoag - Keys to Successful Growth Investing - [Invest Like the Best, EP.429]",
            "pub_date": "2025-06-17T08:00:00.000Z",
            "duration": "2759",
            "duration_label": "45m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/keys-to-successf…growth-investing/",
            "audio_url": "https://traffic.megaphone.fm/CLS1497635309.mp3?updated=1767948634",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "82bc25a2-494f-11f0-828b-4fc9fdd5d765",
            "index": 60,
            "title": "Dinakar Singh - A Father’s Call To Action - [Invest Like the Best, EP.428]",
            "pub_date": "2025-06-15T08:00:00.000Z",
            "duration": "2869",
            "duration_label": "47m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/a-fathers-call-to-action/",
            "audio_url": "https://traffic.megaphone.fm/CLS4847690269.mp3?updated=1767948656",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd8491f4-459f-11f0-b056-235f82284870",
            "index": 61,
            "title": "Bill Gurley - The Gift and The Curse of Staying Private - [Invest Like the Best, EP.427]",
            "pub_date": "2025-06-10T08:00:00.000Z",
            "duration": "4822",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/the-gift-and-the…-staying-private/",
            "audio_url": "https://traffic.megaphone.fm/CLS7062756763.mp3?updated=1767948686",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e8d06122-429d-11f0-89fa-4babbd442cfa",
            "index": 62,
            "title": "Asurion: 50X Season Two - (50X, S2)",
            "pub_date": "2025-06-06T08:00:00.000Z",
            "duration": "11689",
            "duration_label": "3h 14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/series/50x/",
            "audio_url": "https://traffic.megaphone.fm/CLS9371692186.mp3?updated=1749191372",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "86e464e2-402a-11f0-8702-9ff10da43017",
            "index": 63,
            "title": "John Zito - Inside Apollo - [Invest Like the Best, EP.426]",
            "pub_date": "2025-06-03T08:00:00.000Z",
            "duration": "4657",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/inside-apollo/",
            "audio_url": "https://traffic.megaphone.fm/CLS3745475453.mp3?updated=1767948717",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "470d3cc2-3d19-11f0-bebb-1b6c8f9b92eb",
            "index": 64,
            "title": "Fidji Simo - Creating Delightful Consumer Experiences - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-05-30T08:00:00.000Z",
            "duration": "4333",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai"
            ],
            "page_url": "https://joincolossus.com/episodes/80275266/simo-creating-delightful-consumer-experiences",
            "audio_url": "https://traffic.megaphone.fm/CLS4256241181.mp3?updated=1748585154",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "acbc8918-3aaa-11f0-9041-eb58ace393c9",
            "index": 65,
            "title": "Graham Weaver - Building Alpine - [Invest Like the Best, EP.425]",
            "pub_date": "2025-05-27T08:00:00.000Z",
            "duration": "5457",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://joincolossus.com/episode/building-alpine/",
            "audio_url": "https://traffic.megaphone.fm/CLS3639166396.mp3?updated=1767948780",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "14a05590-352a-11f0-9847-4f738ed0671c",
            "index": 66,
            "title": "Gustav Söderström - How Spotify Thinks - [Invest Like the Best, EP.424]",
            "pub_date": "2025-05-20T08:00:00.000Z",
            "duration": "5073",
            "duration_label": "1h 24m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "inference",
              "coding"
            ],
            "page_url": "https://joincolossus.com/episode/how-spotify-thinks/",
            "audio_url": "https://traffic.megaphone.fm/CLS3589160334.mp3?updated=1767948798",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "18c645cc-2f8e-11f0-92f6-e31830f1caeb",
            "index": 67,
            "title": "Royce Yudkoff & Rick Ruback - Entrepreneurship Through Acquisition - [Invest Like the Best, EP.423]",
            "pub_date": "2025-05-13T08:00:00.000Z",
            "duration": "5332",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/entrepreneurship…ough-acquisition/",
            "audio_url": "https://traffic.megaphone.fm/CLS1864561016.mp3?updated=1767948818",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "81657e22-2a0c-11f0-a69b-b7acea904edb",
            "index": 68,
            "title": "David Senra - The Focused Few - [Invest Like the Best, EP.422]",
            "pub_date": "2025-05-06T08:00:00.000Z",
            "duration": "4897",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/the-focused-few/",
            "audio_url": "https://traffic.megaphone.fm/CLS6527290478.mp3?updated=1767948839",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "91d85d60-24a8-11f0-a677-c7c240abf32f",
            "index": 69,
            "title": "Cliff Sosin - Investing in Carvana - [Invest Like the Best, EP.421]",
            "pub_date": "2025-04-29T08:00:00.000Z",
            "duration": "7275",
            "duration_label": "2h 1m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/investing-in-carvana/",
            "audio_url": "https://traffic.megaphone.fm/CLS3811344622.mp3?updated=1767948878",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "08b93ac8-217d-11f0-8e2a-13edac7ab4b5",
            "index": 70,
            "title": "Cyan Banister - Investing for a Higher Purpose - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-04-25T08:00:00.000Z",
            "duration": "5155",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind"
            ],
            "page_url": "https://joincolossus.com/episodes/62018848/banister-investing-for-a-higher-purpose",
            "audio_url": "https://traffic.megaphone.fm/CLS1207615146.mp3?updated=1748584106",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4b26ece-1f0a-11f0-9344-dff07a9dac2e",
            "index": 71,
            "title": "Matt Huang - Investing At The Frontier - [Invest Like the Best, EP.420]",
            "pub_date": "2025-04-22T08:00:00.000Z",
            "duration": "5600",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/investing-at-the-frontier/",
            "audio_url": "https://traffic.megaphone.fm/CLS3162472559.mp3?updated=1767948900",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d16b41c0-19ab-11f0-bed3-e7051157b776",
            "index": 72,
            "title": "Neil Mehta - Finding Future S&P 500 Companies - [Invest Like the Best, EP.419]",
            "pub_date": "2025-04-15T08:00:00.000Z",
            "duration": "5704",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/finding-future-sp-500-companies/",
            "audio_url": "https://traffic.megaphone.fm/CLS5138977228.mp3?updated=1767948913",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66a4bfd0-1404-11f0-868b-974fcef4e30d",
            "index": 73,
            "title": "Michael Ovitz - Turning Potential into Prominence - [Invest Like the Best, EP.418]",
            "pub_date": "2025-04-08T08:00:00.000Z",
            "duration": "6193",
            "duration_label": "1h 43m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://joincolossus.com/episode/turning-potential-into-prominence/",
            "audio_url": "https://traffic.megaphone.fm/CLS3094253966.mp3?updated=1767948958",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "adad179e-0e9e-11f0-97c0-131609c3b316",
            "index": 74,
            "title": "Darren Farber - The Business of Defense - [Invest Like the Best, EP.417]",
            "pub_date": "2025-04-01T08:00:00.000Z",
            "duration": "4510",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/the-business-of-defense/",
            "audio_url": "https://traffic.megaphone.fm/CLS4050342713.mp3?updated=1767948983",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "07554222-0b56-11f0-a080-935e11313d28",
            "index": 75,
            "title": "Josh Kushner - Building Thrive Capital - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-03-28T08:00:00.000Z",
            "duration": "6453",
            "duration_label": "1h 47m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/60539836/kushner-building-thrive-capital",
            "audio_url": "https://traffic.megaphone.fm/CLS7861033231.mp3?updated=1743428555",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "165e23c4-08ef-11f0-9b4a-2bc3b33e6b65",
            "index": 76,
            "title": "Gili Raanan - Cybersecurity Investment Playbook - [Invest Like the Best, EP416]",
            "pub_date": "2025-03-25T08:00:00.000Z",
            "duration": "3361",
            "duration_label": "56m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/cybersecurity-investment-playbook/",
            "audio_url": "https://traffic.megaphone.fm/CLS2508018384.mp3?updated=1767950889",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bfda1988-037e-11f0-88da-33380406b8f6",
            "index": 77,
            "title": "Alex Wiltschko - Giving Computers A Sense Of Smell - [Invest Like the Best, EP.415]",
            "pub_date": "2025-03-18T08:00:00.000Z",
            "duration": "3887",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/giving-computers-a-sense-of-smell/",
            "audio_url": "https://traffic.megaphone.fm/CLS3874358176.mp3?updated=1767950935",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e83c012-fdf5-11ef-81d0-a32d0e17e011",
            "index": 78,
            "title": "Kelly Granat - Investing At Lone Pine - [Invest Like the Best, EP.414]",
            "pub_date": "2025-03-11T08:00:00.000Z",
            "duration": "5336",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/investing-at-lone-pine/",
            "audio_url": "https://traffic.megaphone.fm/CLS3041850024.mp3?updated=1767950946",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f837fe2-f8a5-11ef-a903-93d3522fdc43",
            "index": 79,
            "title": "Devon Zuegel: How To Create A New Town - [Invest Like the Best, EP.413]",
            "pub_date": "2025-03-04T09:00:00.000Z",
            "duration": "4652",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/how-to-create-a-new-town/",
            "audio_url": "https://traffic.megaphone.fm/CLS6017865276.mp3?updated=1767950956",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc69044c-f582-11ef-a6b9-97f92c19edcd",
            "index": 80,
            "title": "Doug Leone - Lessons from a Titan - [Invest Like the Best, CLASSICS]",
            "pub_date": "2025-02-28T09:00:00.000Z",
            "duration": "4173",
            "duration_label": "1h 9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/54685008/leone-clear-and-simple",
            "audio_url": "https://traffic.megaphone.fm/CLS1990162105.mp3?updated=1743113029",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "720aa922-f323-11ef-8516-9f51f393ebdd",
            "index": 81,
            "title": "Chris Pedregal - Building Granola - [Invest Like the Best, EP.412]",
            "pub_date": "2025-02-25T09:00:00.000Z",
            "duration": "3696",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-granola/",
            "audio_url": "https://traffic.megaphone.fm/CLS1570248300.mp3?updated=1767950971",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f70dc6c-ed89-11ef-99d7-1f4bf7b18593",
            "index": 82,
            "title": "Ravi Gupta - AI or Die - [Invest Like the Best, EP.411]",
            "pub_date": "2025-02-18T09:00:00.000Z",
            "duration": "3579",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/ai-or-die/",
            "audio_url": "https://traffic.megaphone.fm/CLS4609151233.mp3?updated=1767950986",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "868f4aca-e7ec-11ef-abca-f730f7c666f2",
            "index": 83,
            "title": "Marc Andreessen - The Battle For Tech Supremacy - [Invest Like the Best, EP.410]",
            "pub_date": "2025-02-11T09:00:00.000Z",
            "duration": "5059",
            "duration_label": "1h 24m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://joincolossus.com/episode/the-battle-for-tech-supremacy/",
            "audio_url": "https://traffic.megaphone.fm/CLS1564743482.mp3?updated=1767951020",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a10aff4-e276-11ef-8154-9319d2235f39",
            "index": 84,
            "title": "Graham Duncan - Talent Whisperer - [Invest Like the Best, EP.409]",
            "pub_date": "2025-02-04T09:00:00.000Z",
            "duration": "8290",
            "duration_label": "2h 18m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://joincolossus.com/article/graham-duncan/",
            "audio_url": "https://traffic.megaphone.fm/CLS6437819345.mp3?updated=1767951177",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e92237ea-dcdb-11ef-bec6-e356aab631c1",
            "index": 85,
            "title": "Blake Hall - Combat, Service, and Innovation  - [Invest Like the Best, EP.408]",
            "pub_date": "2025-01-28T09:00:00.000Z",
            "duration": "5673",
            "duration_label": "1h 34m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/combat-service-and-innovation/",
            "audio_url": "https://traffic.megaphone.fm/CLS5656075566.mp3?updated=1767951202",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "005c5bf8-d7c7-11ef-9ac4-b73761751c32",
            "index": 86,
            "title": "Dylan Field - Designing The Future - [Invest Like the Best, EP.407]",
            "pub_date": "2025-01-21T09:00:00.000Z",
            "duration": "2767",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "https://joincolossus.com/episode/designing-the-future/",
            "audio_url": "https://traffic.megaphone.fm/CLS5439975919.mp3?updated=1767951226",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cffc0926-d1f5-11ef-b9c0-37cdba87283f",
            "index": 87,
            "title": "Tal Zaks - Bridging Science, Medicine, and Returns - [Invest Like the Best, EP.406]",
            "pub_date": "2025-01-14T09:00:00.000Z",
            "duration": "4960",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://joincolossus.com/episode/bridging-science…cine-and-returns/",
            "audio_url": "https://traffic.megaphone.fm/CLS1366883601.mp3?updated=1767951253",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "58915f06-cc5c-11ef-8844-e79152f85f8d",
            "index": 88,
            "title": "Gaurav Misra & Dwight Churchill - Building Captions - [Invest Like the Best, EP.405]",
            "pub_date": "2025-01-07T09:00:00.000Z",
            "duration": "3976",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://joincolossus.com/episode/building-captions/",
            "audio_url": "https://traffic.megaphone.fm/CLS2520799101.mp3?updated=1767951266",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "deaccbea-c584-11ef-a080-e75119215e25",
            "index": 89,
            "title": "Jack Kokko - Building AlphaSense - [Invest Like the Best, EP.404]",
            "pub_date": "2024-12-31T09:00:00.000Z",
            "duration": "3042",
            "duration_label": "50m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-alphasense/",
            "audio_url": "https://traffic.megaphone.fm/CLS9657032798.mp3?updated=1767951296",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7c790068-be83-11ef-a8ac-e39af39942da",
            "index": 90,
            "title": "Jared Kushner - The Mechanic - [Invest Like the Best, EP.403]",
            "pub_date": "2024-12-20T09:00:00.000Z",
            "duration": "10526",
            "duration_label": "2h 55m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/jared-kushner-bu…sting-government/",
            "audio_url": "https://traffic.megaphone.fm/CLS8145631955.mp3?updated=1767951362",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b296237a-bc20-11ef-b2ab-f38e0030a7f6",
            "index": 91,
            "title": "Scott Wu - Building Cognition - [Invest Like the Best, EP.402]",
            "pub_date": "2024-12-17T09:00:00.000Z",
            "duration": "4474",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents"
            ],
            "page_url": "https://joincolossus.com/episode/building-cognition/",
            "audio_url": "https://traffic.megaphone.fm/CLS3046706449.mp3?updated=1767951407",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1c2f9a94-b674-11ef-9391-d3f73e080366",
            "index": 92,
            "title": "Micky Malka - Building Ribbit - [Invest Like the Best, EP.401]",
            "pub_date": "2024-12-10T09:00:00.000Z",
            "duration": "5612",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-ribbit/",
            "audio_url": "https://traffic.megaphone.fm/CLS7444449100.mp3?updated=1767951873",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f16caf98-b34b-11ef-bb7b-fb8e3070f178",
            "index": 93,
            "title": "Chetan Puttagunta and Modest Proposal - Capital, Compute & AI Scaling - [Invest Like the Best, EP.400]",
            "pub_date": "2024-12-06T09:00:00.000Z",
            "duration": "5797",
            "duration_label": "1h 36m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "training",
              "reasoning"
            ],
            "page_url": "https://joincolossus.com/episode/capital-compute-ai-scaling/",
            "audio_url": "https://traffic.megaphone.fm/CLS9214404210.mp3?updated=1767951806",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95c2fa70-b130-11ef-b06f-83ae28f1bf92",
            "index": 94,
            "title": "Ronnie Fieg - Building Kith - [Invest Like the Best, EP.399]",
            "pub_date": "2024-12-03T09:00:00.000Z",
            "duration": "5228",
            "duration_label": "1h 27m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-kith/",
            "audio_url": "https://traffic.megaphone.fm/CLS6701662634.mp3?updated=1767954968",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8735242-ab97-11ef-a0a7-9f85e112c135",
            "index": 95,
            "title": "Gabe Whaley - Building MSCHF - [Invest Like the Best, EP.398]",
            "pub_date": "2024-11-26T09:00:00.000Z",
            "duration": "4703",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/monopolizing-a-feeling/",
            "audio_url": "https://traffic.megaphone.fm/CLS1984582172.mp3?updated=1767955874",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68cb6302-a854-11ef-8476-5b4af08a7f63",
            "index": 96,
            "title": "Brad Jacobs - Think Big and Move Fast - [Invest Like the Best, REPLAY]",
            "pub_date": "2024-11-22T09:00:00.000Z",
            "duration": "5220",
            "duration_label": "1h 27m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/jacobs-think-big-and-move-fast/",
            "audio_url": "https://traffic.megaphone.fm/CLS4700285680.mp3?updated=1767955949",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95ac87a6-a085-11ef-867d-ff6919244d2e",
            "index": 97,
            "title": "Ernie Garcia - Leading Through Crisis - [Invest Like the Best, EP.397]",
            "pub_date": "2024-11-12T09:00:00.000Z",
            "duration": "4436",
            "duration_label": "1h 13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episode/steering-carvana%E2%80%A6gh-a-99-drawdown/",
            "audio_url": "https://traffic.megaphone.fm/CLS9859912870.mp3?updated=1767955966",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "165909e8-9b26-11ef-857b-ef32bebd305d",
            "index": 98,
            "title": "Andrew Homan & Chris Miller - Redefining Semiconductor Progress - [Invest Like the Best, EP.396]",
            "pub_date": "2024-11-05T09:00:00.000Z",
            "duration": "5272",
            "duration_label": "1h 27m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip"
            ],
            "page_url": "https://joincolossus.com/episode/redefining-semiconductor-progress/",
            "audio_url": "https://traffic.megaphone.fm/CLS4238248081.mp3?updated=1767955994",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "471ef8f4-957b-11ef-9237-1b0cb90b2be7",
            "index": 99,
            "title": "Boyd Varty - Becoming A Meaning Maker - [Invest Like the Best, EP.395]",
            "pub_date": "2024-10-29T08:00:00.000Z",
            "duration": "3818",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/becoming-a-meaning-maker/",
            "audio_url": "https://traffic.megaphone.fm/CLS2362006141.mp3?updated=1767956010",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "37eec9cc-8fe5-11ef-8387-939a04e85ca4",
            "index": 100,
            "title": "Tobi Lütke - Building Islands of Innovation - [Invest Like the Best, EP.394]",
            "pub_date": "2024-10-22T08:00:00.000Z",
            "duration": "4099",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/building-islands-of-innovation/",
            "audio_url": "https://traffic.megaphone.fm/CLS8265562166.mp3?updated=1767956082",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bf087af4-8a7a-11ef-a52b-c35711c1a2de",
            "index": 101,
            "title": "Matt Perelman & Alex Sloane - The Art of Franchise Investing - [Invest Like the Best, EP.393]",
            "pub_date": "2024-10-15T08:00:00.000Z",
            "duration": "6171",
            "duration_label": "1h 42m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/the-art-of-franchise-investing/",
            "audio_url": "https://traffic.megaphone.fm/CLS7441910184.mp3?updated=1767956130",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f51e6e00-84da-11ef-945e-e3cb8d33ecf9",
            "index": 102,
            "title": "Kareem Zaki - Small Ideas Attract Competition - [Invest Like the Best, EP.392]",
            "pub_date": "2024-10-08T08:00:00.000Z",
            "duration": "5284",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/small-ideas-attract-competition/",
            "audio_url": "https://traffic.megaphone.fm/CLS5624724267.mp3?updated=1767956171",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a7f4e30c-7f67-11ef-8f08-973682cfa508",
            "index": 103,
            "title": "Ray Ozzie - The Future of Intelligent Machines - [Invest Like the Best, EP.391]",
            "pub_date": "2024-10-01T08:00:00.000Z",
            "duration": "5758",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/the-future-of-intelligent-machines/",
            "audio_url": "https://traffic.megaphone.fm/CLS7440114462.mp3?updated=1767956207",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b2fbf152-7b82-11ef-ac1e-07972a2a9d3a",
            "index": 104,
            "title": "Ted Seides - Investment Industry Paradigms - [Invest Like the Best, EP.390]",
            "pub_date": "2024-09-26T08:00:00.000Z",
            "duration": "3712",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/investment-industry-paradigms/",
            "audio_url": "https://traffic.megaphone.fm/CLS5814539548.mp3?updated=1767956331",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48b854d6-7a22-11ef-8bbc-d76d3609d557",
            "index": 105,
            "title": "Lulu Meservey - Transforming Company Narrative - [Invest Like the Best, EP.389]",
            "pub_date": "2024-09-24T08:00:00.000Z",
            "duration": "4080",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/transforming-company-narrative/",
            "audio_url": "https://traffic.megaphone.fm/CLS8374908872.mp3?updated=1767956359",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "14d7ed12-749f-11ef-90b3-5f49795122a1",
            "index": 106,
            "title": "Ric Elias - The Art of Living Well - [Invest Like the Best, EP.388]",
            "pub_date": "2024-09-17T08:00:00.000Z",
            "duration": "5196",
            "duration_label": "1h 26m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episode/ric-elias-the-art-of-living-well/",
            "audio_url": "https://traffic.megaphone.fm/CLS3676864931.mp3?updated=1767956393",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1032eac-6f00-11ef-9f13-1fdfe88e54f4",
            "index": 107,
            "title": "Alex Smith, Shane Battier, & Ravi Gupta - What Makes A Glue Guy? - [Invest Like the Best, EP.387]",
            "pub_date": "2024-09-10T08:00:00.000Z",
            "duration": "5097",
            "duration_label": "1h 24m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episode/what-makes-a-glue-guy/",
            "audio_url": "https://traffic.megaphone.fm/CLS4306451223.mp3?updated=1767956757",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b29c22ec-6979-11ef-a775-9742d6bbb803",
            "index": 108,
            "title": "Bret Taylor - The Agent Era - [Invest Like the Best, EP.386]",
            "pub_date": "2024-09-03T08:00:00.000Z",
            "duration": "5361",
            "duration_label": "1h 29m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "multimodal"
            ],
            "page_url": "https://joincolossus.com/episodes/48526910/taylor-the-agent-era-and-another-version-the-agentic-era",
            "audio_url": "https://traffic.megaphone.fm/CLS4591437414.mp3?updated=1767956796",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd8f5ed2-642c-11ef-8c5d-d742ac671eb4",
            "index": 109,
            "title": "Gavin Baker - AI, Semiconductors, and the Robotic Frontier - [Invest Like the Best, EP.385]",
            "pub_date": "2024-08-27T08:00:00.000Z",
            "duration": "5576",
            "duration_label": "1h 32m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia",
              "inference",
              "training",
              "robotics"
            ],
            "page_url": "https://joincolossus.com/episodes/67636422/baker-ai-semiconductors-and-the-robotic-frontier",
            "audio_url": "https://traffic.megaphone.fm/CLS3009851426.mp3?updated=1767957377",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "08e1a5c2-5e95-11ef-9419-af05a8aa9b84",
            "index": 110,
            "title": "A Conversation with Charlie Munger & John Collison - [Invest Like the Best, REPLAY]",
            "pub_date": "2024-08-20T08:00:00.000Z",
            "duration": "6096",
            "duration_label": "1h 41m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/76168278/munger-a-conversation-with-charlie-munger-john-collison?tab=transcript",
            "audio_url": "https://traffic.megaphone.fm/CLS7691728000.mp3?updated=1767957406",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "05f24096-58e7-11ef-9813-7b81b4956207",
            "index": 111,
            "title": "Vlad Tenev - Navigating Robinhood's Evolution - [Invest Like the Best, EP.384]",
            "pub_date": "2024-08-13T08:00:00.000Z",
            "duration": "4783",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "https://www.joincolossus.com/episodes/1268740/tenev-navigating-robinhoods-evolution",
            "audio_url": "https://traffic.megaphone.fm/CLS6564491672.mp3?updated=1767957370",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8aef1c0-533c-11ef-9755-6b2ce0fc76e3",
            "index": 112,
            "title": "Sarah Guo - The Power of Conviction - [Invest Like the Best, EP.383]",
            "pub_date": "2024-08-06T08:00:00.000Z",
            "duration": "4478",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chips"
            ],
            "page_url": "https://joincolossus.com/episodes/63314045/guo-the-power-of-conviction",
            "audio_url": "https://traffic.megaphone.fm/CLS1145400574.mp3?updated=1767957479",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3b0418a-4dc7-11ef-aa3c-2f65dcb5c038",
            "index": 113,
            "title": "Hemant Taneja - Engineering Global Resilience - [Invest Like the Best, EP.382]",
            "pub_date": "2024-07-31T08:00:00.000Z",
            "duration": "3896",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/18391328/taneja-engineering-global-resilience",
            "audio_url": "https://traffic.megaphone.fm/CLS9956201030.mp3?updated=1767957495",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b3c7f710-4875-11ef-9362-035d39cf0809",
            "index": 114,
            "title": "Jeremy Giffon - Special Situations in Private Markets - [Invest Like the Best, Replay]",
            "pub_date": "2024-07-23T08:00:00.000Z",
            "duration": "6243",
            "duration_label": "1h 44m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/79714195/giffon-special-situations-in-private-markets",
            "audio_url": "https://traffic.megaphone.fm/CLS3548590800.mp3?updated=1767957686",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33af7204-42be-11ef-8046-5363134dfec3",
            "index": 115,
            "title": "David Senra - Passion & Pain - [Invest Like the Best, Replay]",
            "pub_date": "2024-07-16T08:00:00.000Z",
            "duration": "5047",
            "duration_label": "1h 24m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/85503387/senra-passion-pain?tab=transcript",
            "audio_url": "https://traffic.megaphone.fm/CLS6644755188.mp3?updated=1767957698",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c9c4e62-3d41-11ef-ad76-83a4e85f8c9a",
            "index": 116,
            "title": "Martin Casado - Entering Uncharted AI Territory - [Invest Like the Best, EP.381]",
            "pub_date": "2024-07-09T08:00:00.000Z",
            "duration": "4083",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "training",
              "robotics"
            ],
            "page_url": "https://www.joincolossus.com/episodes/57965417/casado-entering-uncharted-ai-territory",
            "audio_url": "https://traffic.megaphone.fm/CLS6894817101.mp3?updated=1767957746",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed7e3670-382d-11ef-8993-bba1164629cd",
            "index": 117,
            "title": "Modest Proposal - AI Commoditization and Capital Dynamics - [Invest Like the Best, EP.380]",
            "pub_date": "2024-07-02T08:00:00.000Z",
            "duration": "3467",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://joincolossus.com/episodes/84488038/proposal-ai-commoditization-and-capital-dynamics",
            "audio_url": "https://traffic.megaphone.fm/CLS4401291241.mp3?updated=1767957928",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1df24bec-326c-11ef-846c-c3a77ad93c96",
            "index": 118,
            "title": "Robert Greene - Optimizing Your Reality - [Invest Like the Best, EP.379]",
            "pub_date": "2024-06-25T08:00:00.000Z",
            "duration": "3783",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/22993321/greene-optimizing-your-reality",
            "audio_url": "https://traffic.megaphone.fm/CLS4215399232.mp3?updated=1767957953",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "765a273e-2d15-11ef-9053-67a7369e4779",
            "index": 119,
            "title": "Pat Grady - Relentless Application of Force - [Invest Like the Best, EP.378]",
            "pub_date": "2024-06-18T08:00:00.000Z",
            "duration": "5544",
            "duration_label": "1h 32m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://joincolossus.com/episodes/16640225/grady-relentless-application-of-force",
            "audio_url": "https://traffic.megaphone.fm/CLS7193347411.mp3?updated=1767957987",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a67ad3c-276b-11ef-9369-a38f32fd9e30",
            "index": 120,
            "title": "Frank Blake - Leading By Example - [Invest Like the Best, EP.377]",
            "pub_date": "2024-06-11T08:00:00.000Z",
            "duration": "3854",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/66171278/blake-investing-in-your-people",
            "audio_url": "https://traffic.megaphone.fm/CLS2657144754.mp3?updated=1767958002",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d73102c-21ea-11ef-9ef5-874298246022",
            "index": 121,
            "title": "Adam Sandow - The Power of Print Media - [Invest Like the Best, EP.376]",
            "pub_date": "2024-06-04T08:00:00.000Z",
            "duration": "3986",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/21079315/sandow-building-brand-new-businesses",
            "audio_url": "https://traffic.megaphone.fm/CLS9832253054.mp3?updated=1767958077",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fde041be-1c91-11ef-bd2f-ab3eb3acb05f",
            "index": 122,
            "title": "Howie Liu - Building Airtable - [Invest Like the Best, EP.375]",
            "pub_date": "2024-05-28T08:00:00.000Z",
            "duration": "4232",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/84072882/liu-building-airtable",
            "audio_url": "https://traffic.megaphone.fm/CLS2292392286.mp3?updated=1767958116",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69bb5024-16eb-11ef-a430-7f4e990dc8f0",
            "index": 123,
            "title": "Mark Groden - The Future of Flying - [Invest Like the Best, EP.374]",
            "pub_date": "2024-05-21T08:00:00.000Z",
            "duration": "4056",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety",
              "automation"
            ],
            "page_url": "https://www.joincolossus.com/episodes/24686226/groden-the-future-of-flying",
            "audio_url": "https://traffic.megaphone.fm/CLS5228991932.mp3?updated=1767958140",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "79c578ac-1162-11ef-bf88-e32a0a80fb10",
            "index": 124,
            "title": "Dev Ittycheria - The Database Evolution - [Invest Like the Best, EP.373]",
            "pub_date": "2024-05-14T08:00:00.000Z",
            "duration": "4240",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/36961434/ittycheria-the-database-evolution",
            "audio_url": "https://traffic.megaphone.fm/CLS1583219915.mp3?updated=1767958179",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d6095aa6-0baf-11ef-a861-1f3f47600f99",
            "index": 125,
            "title": "Nico Wittenborn - Finding the Adjacent Possible - [Invest Like the Best, EP.372]",
            "pub_date": "2024-05-07T08:00:00.000Z",
            "duration": "5014",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/17932440/wittenborn-finding-the-adjacent-possible",
            "audio_url": "https://traffic.megaphone.fm/CLS7704857493.mp3?updated=1767958264",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dabc2c08-07ff-11ef-a81e-7f7a82ffbf51",
            "index": 126,
            "title": "Mitch Rales: The Art of Compounding - [Art of Investing, Forever Episode]",
            "pub_date": "2024-05-02T08:00:00.000Z",
            "duration": "7709",
            "duration_label": "2h 8m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/37099495/rales-the-art-of-compounding?tab=transcript",
            "audio_url": "https://traffic.megaphone.fm/CLS2030587914.mp3?updated=1767958322",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "20d67df2-0679-11ef-81cd-2f496ff3eeff",
            "index": 127,
            "title": "Marc Lasry - Making Bucks in Credit and Sports - [Invest Like the Best, EP.371]",
            "pub_date": "2024-04-30T08:00:00.000Z",
            "duration": "4144",
            "duration_label": "1h 9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/57280714/lasry-making-bucks-in-credit-and-sports",
            "audio_url": "https://traffic.megaphone.fm/CLS9918818768.mp3?updated=1767958298",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b874c98a-00f6-11ef-997b-47b3d079ed57",
            "index": 128,
            "title": "Bill Gurley & Michael Mauboussin - Putting Theory into Practice - [Invest Like the Best, EP.370]",
            "pub_date": "2024-04-23T08:00:00.000Z",
            "duration": "5637",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/82708652/mauboussin-a-meeting-of-the-minds",
            "audio_url": "https://traffic.megaphone.fm/CLS3680551999.mp3?updated=1767958332",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "18da3c68-fb8b-11ee-a435-ff4ff3c909f3",
            "index": 129,
            "title": "Tim Ferriss - Curating Curiosities - [Invest Like the Best, EP.369]",
            "pub_date": "2024-04-16T08:00:00.000Z",
            "duration": "5253",
            "duration_label": "1h 27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/11271167/ferriss-curating-curiosities",
            "audio_url": "https://traffic.megaphone.fm/CLS2540276214.mp3?updated=1767958421",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b17205bc-f5ed-11ee-bc37-57ced2ef6924",
            "index": 130,
            "title": "Ken Langone - The American Dream - [Invest Like the Best, EP.368]",
            "pub_date": "2024-04-09T08:00:00.000Z",
            "duration": "3012",
            "duration_label": "50m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/32603766/langone-the-american-dream",
            "audio_url": "https://traffic.megaphone.fm/CLS7334304700.mp3?updated=1767958446",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "419ad9ba-f02c-11ee-9354-0b2f9a1368a3",
            "index": 131,
            "title": "Robin Dunbar - Optimizing Human Connection (Dunbar's Number) - [Invest Like the Best, EP.367]",
            "pub_date": "2024-04-02T08:00:00.000Z",
            "duration": "3830",
            "duration_label": "1h 3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/86440098/dunbar-optimizing-human-connection",
            "audio_url": "https://traffic.megaphone.fm/CLS6999105201.mp3?updated=1767958581",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9811539c-eaef-11ee-aeee-574ffe8d20af",
            "index": 132,
            "title": "Sean Feeney - Reinventing the Restaurant Business - [Invest Like the Best, EP.366]",
            "pub_date": "2024-03-26T08:00:00.000Z",
            "duration": "6600",
            "duration_label": "1h 50m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/98380145/feeney-reinventing-the-restaurant-business",
            "audio_url": "https://traffic.megaphone.fm/CLS6395132082.mp3?updated=1767958730",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "61d28f22-e57b-11ee-acac-bb2b11f48870",
            "index": 133,
            "title": "Dave Fontenot - The Monastery of Code - [Invest Like the Best, EP.365]",
            "pub_date": "2024-03-19T08:00:00.000Z",
            "duration": "3916",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "coding"
            ],
            "page_url": "https://www.joincolossus.com/episodes/20057232/fontenot-the-monastery-of-code",
            "audio_url": "https://traffic.megaphone.fm/CLS1581818946.mp3?updated=1767958723",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0adb3dde-dfd8-11ee-ab3f-f3a8446ff2a4",
            "index": 134,
            "title": "Anne-Marie Peterson - The Capital System - [Invest Like the Best, EP.364]",
            "pub_date": "2024-03-12T08:00:00.000Z",
            "duration": "3565",
            "duration_label": "59m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/58908438/peterson-a-people-first-approach",
            "audio_url": "https://traffic.megaphone.fm/CLS5885175571.mp3?updated=1767959904",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e8ac93da-da90-11ee-a311-53ec0697e5bb",
            "index": 135,
            "title": "Aravind Srinivas - Building An Answer Engine - [Invest Like the Best, EP.363]",
            "pub_date": "2024-03-05T09:00:00.000Z",
            "duration": "4252",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "perplexity"
            ],
            "page_url": "https://joincolossus.com/episodes/17619043/srinivas-building-an-answer-engine",
            "audio_url": "https://traffic.megaphone.fm/CLS2937786983.mp3?updated=1767959931",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77ef65a6-d4ef-11ee-a10e-37936aef5b60",
            "index": 136,
            "title": "Ali Hamed - Building an Investment Firm - [Invest Like the Best, EP.362]",
            "pub_date": "2024-02-27T09:00:00.000Z",
            "duration": "5439",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/61221899/hamed-multi-disciplinary-investing",
            "audio_url": "https://traffic.megaphone.fm/CLS5011594407.mp3?updated=1767959958",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e0d4c670-cf94-11ee-8294-e713b5d9fd0b",
            "index": 137,
            "title": "Cyan Banister - Investing for a Higher Purpose - [Invest Like the Best, EP.361]",
            "pub_date": "2024-02-20T09:00:00.000Z",
            "duration": "5227",
            "duration_label": "1h 27m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "deepmind"
            ],
            "page_url": "https://joincolossus.com/episodes/62018848/banister-investing-for-a-higher-purpose",
            "audio_url": "https://traffic.megaphone.fm/CLS3797639603.mp3?updated=1767959980",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d509a958-c9e7-11ee-b95b-2fb3e364477f",
            "index": 138,
            "title": "Danny Meyer - The Power of Hospitality - [Invest Like the Best, REPLAY]",
            "pub_date": "2024-02-13T09:00:00.000Z",
            "duration": "3077",
            "duration_label": "51m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/21049021/meyer-the-power-of-hospitality?tab=transcript",
            "audio_url": "https://traffic.megaphone.fm/CLS2819189715.mp3?updated=1767959986",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9d3ffab8-c483-11ee-a640-cb7be50f54b6",
            "index": 139,
            "title": "Chuck Akre - The Three Legged Stool - [Invest Like the Best, REPLAY]",
            "pub_date": "2024-02-06T09:00:00.000Z",
            "duration": "3011",
            "duration_label": "50m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/42568501/akre-the-three-legged-stool?tab=shownotes",
            "audio_url": "https://traffic.megaphone.fm/CLS6306139885.mp3?updated=1767960008",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "39c167d6-bef4-11ee-942d-a7f60aae9873",
            "index": 140,
            "title": "Alex Telford - Unlocking Innovation in Pharma - [Invest Like the Best, EP.360]",
            "pub_date": "2024-01-30T09:00:00.000Z",
            "duration": "3630",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/71127942/telford-unlocking-innovation-in-pharma",
            "audio_url": "https://traffic.megaphone.fm/CLS8467416126.mp3?updated=1767960033",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c50a8cee-b974-11ee-b357-5b977e29ab90",
            "index": 141,
            "title": "Madhavan Ramanujam - How to Price Products - [Invest Like the Best, REPLAY]",
            "pub_date": "2024-01-23T09:00:00.000Z",
            "duration": "3455",
            "duration_label": "57m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/67388971/ramanujam-how-to-price-products?tab=transcript",
            "audio_url": "https://traffic.megaphone.fm/CLS7618938575.mp3?updated=1767960068",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "94708c7a-b44a-11ee-b583-53b69043ac06",
            "index": 142,
            "title": "Daryl Morey - Systems Thinking in Sports - [Invest Like the Best, REPLAY]",
            "pub_date": "2024-01-16T09:00:00.000Z",
            "duration": "3910",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://www.joincolossus.com/episodes/50823211/morey-systems-thinking-in-sports",
            "audio_url": "https://traffic.megaphone.fm/CLS1732175922.mp3?updated=1767960086",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c14ba6ea-ae77-11ee-a0b0-934994ae032d",
            "index": 143,
            "title": "Michael Ovitz - Knowledge Is Power - [Invest Like the Best, EP.359]",
            "pub_date": "2024-01-09T09:00:00.000Z",
            "duration": "6625",
            "duration_label": "1h 50m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "agent",
              "agents"
            ],
            "page_url": "https://joincolossus.com/episodes/52549979/ovitz-knowledge-is-power",
            "audio_url": "https://traffic.megaphone.fm/CLS1564690982.mp3?updated=1767960130",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d8d1a00-a8fd-11ee-b58f-0f263a675b53",
            "index": 144,
            "title": "Erik Serrano - Investing in Investment Firms - [Invest Like the Best, EP.358]",
            "pub_date": "2024-01-02T09:00:00.000Z",
            "duration": "5222",
            "duration_label": "1h 27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/14312393/serrano-the-investors-investor",
            "audio_url": "https://traffic.megaphone.fm/CLS1075508075.mp3?updated=1767960435",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8ce0cd1e-a10b-11ee-b8dc-9f544fc7cf74",
            "index": 145,
            "title": "Doug Leone - Lessons from a Titan - [Invest Like the Best, REPLAY]",
            "pub_date": "2023-12-26T09:00:00.000Z",
            "duration": "4245",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/54685008/leone-clear-and-simple",
            "audio_url": "https://traffic.megaphone.fm/CLS1210977310.mp3?updated=1767960451",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0bc54322-9de6-11ee-8cd0-bb01130b8dd5",
            "index": 146,
            "title": "Justin Ishbia - Lessons from Acquiring 586 Companies - [Invest Like the Best, EP.357]",
            "pub_date": "2023-12-19T09:00:00.000Z",
            "duration": "4491",
            "duration_label": "1h 14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/92911943/ishbia-a-system-for-success",
            "audio_url": "https://traffic.megaphone.fm/CLS5000632969.mp3?updated=1767960497",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a4dbda0a-987b-11ee-8e1a-978c1d609bae",
            "index": 147,
            "title": "Gavin Uberti - Real-Time AI & The Future of AI Hardware - [Invest Like the Best, EP.356]",
            "pub_date": "2023-12-12T09:00:00.000Z",
            "duration": "5117",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "nvidia",
              "chip",
              "chips",
              "inference"
            ],
            "page_url": "https://joincolossus.com/episodes/73767562/uberti-the-future-of-ai-hardware",
            "audio_url": "https://traffic.megaphone.fm/CLS1714605546.mp3?updated=1767960514",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "53c669e4-92ba-11ee-8464-33de239d180d",
            "index": 148,
            "title": "A Conversation with Charlie Munger & John Collison - [Invest Like the Best, EP.355]",
            "pub_date": "2023-12-05T09:00:00.000Z",
            "duration": "6096",
            "duration_label": "1h 41m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/76168278/munger-a-conversation-with-charlie-munger-john-collison",
            "audio_url": "https://traffic.megaphone.fm/CLS7328362599.mp3?updated=1767960555",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7a55abca-8daa-11ee-9a62-d73facb2f275",
            "index": 149,
            "title": "Peter Fenton & Victor Lazarte - Purpose and Partnership - [Invest Like the Best, EP.354]",
            "pub_date": "2023-11-28T09:00:00.000Z",
            "duration": "5451",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/22608829/lazarte-cultivating-generative-purpose",
            "audio_url": "https://traffic.megaphone.fm/CLS8598031122.mp3?updated=1767960561",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "93a81ac8-8822-11ee-a74f-efd45a142be5",
            "index": 150,
            "title": "Lior Susan - Leave the World Better than You Found It - [Invest Like the Best, EP.353]",
            "pub_date": "2023-11-21T09:00:00.000Z",
            "duration": "3891",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/73363357/susan-leave-the-world-better-than-you-found-it",
            "audio_url": "https://traffic.megaphone.fm/CLS6835381757.mp3?updated=1767960578",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65a7a5b8-826d-11ee-8e61-d3d9ecec6a48",
            "index": 151,
            "title": "Brad Jacobs - Think Big and Move Fast - [Invest Like the Best, EP.352]",
            "pub_date": "2023-11-14T09:00:00.000Z",
            "duration": "5204",
            "duration_label": "1h 26m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/19966134/jacobs-think-big-and-move-fast",
            "audio_url": "https://traffic.megaphone.fm/CLS4626149545.mp3?updated=1767960602",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ee698442-7ce2-11ee-8ee1-df2433c6aa5d",
            "index": 152,
            "title": "Elizabeth Zalman & Jerry Neumann - Founder vs Investor - [Invest Like the Best, EP.351]",
            "pub_date": "2023-11-07T09:00:00.000Z",
            "duration": "4368",
            "duration_label": "1h 12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/90886887/zalman-founder-vs-investor",
            "audio_url": "https://traffic.megaphone.fm/CLS3227927062.mp3?updated=1767960616",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a57687b2-7797-11ee-8b1a-13e7c7b1c828",
            "index": 153,
            "title": "Palmer Luckey - Inventing the Future of Defense - [Invest Like the Best, EP.350]",
            "pub_date": "2023-10-31T08:00:00.000Z",
            "duration": "4586",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/47841592/luckey-inventing-the-future-of-defense",
            "audio_url": "https://traffic.megaphone.fm/CLS4882765450.mp3?updated=1767960639",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7dcd2584-7230-11ee-ad84-d39e6b4f0bf4",
            "index": 154,
            "title": "Aswath Damodaran - Making Sense of the Market Pt. 2 - [Invest Like the Best, EP.349]",
            "pub_date": "2023-10-24T08:00:00.000Z",
            "duration": "4976",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "automation"
            ],
            "page_url": "https://joincolossus.com/episodes/72302556/damodaran-making-sense-of-the-market-pt",
            "audio_url": "https://traffic.megaphone.fm/CLS8996916989.mp3?updated=1767961217",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "71e4eb76-6c8b-11ee-881a-d711bf290c45",
            "index": 155,
            "title": "Patrick Collison & John Collison - A Business State of Mind - [Invest Like the Best, EP.348]",
            "pub_date": "2023-10-17T08:00:00.000Z",
            "duration": "4802",
            "duration_label": "1h 20m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/85748309/collison-a-business-state-of-mind",
            "audio_url": "https://traffic.megaphone.fm/CLS4424904312.mp3?updated=1767961243",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "580d0678-671a-11ee-b4ea-0be3cf0234aa",
            "index": 156,
            "title": "Strauss Zelnick - Playing to Your Strengths - [Invest Like the Best, EP.347]",
            "pub_date": "2023-10-10T08:00:00.000Z",
            "duration": "4560",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/73840840/zelnick-playing-to-your-strengths",
            "audio_url": "https://traffic.megaphone.fm/CLS2636918880.mp3?updated=1767961274",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c31aaca-616b-11ee-a798-6f50f4d6c706",
            "index": 157,
            "title": "Rick Buhrman & Paul Buser - Find Your X, Nurture Your N - [Invest Like the Best, EP.346]",
            "pub_date": "2023-10-03T08:00:00.000Z",
            "duration": "7227",
            "duration_label": "2h 0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/31867155/buhrman-find-your-x-nurture-your-n",
            "audio_url": "https://traffic.megaphone.fm/CLS6096028735.mp3?updated=1767961318",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e9a862c-5bcd-11ee-a4c5-d32d7a5ce9e9",
            "index": 158,
            "title": "Jack Altman & Miles Grimshaw - Building and Investing in Lattice - [Invest Like the Best, EP.345]",
            "pub_date": "2023-09-26T08:00:00.000Z",
            "duration": "4874",
            "duration_label": "1h 21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/76952965/altman-building-and-investing-in-lattice",
            "audio_url": "https://traffic.megaphone.fm/CLS9032896186.mp3?updated=1767961325",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5c2ecb6c-566f-11ee-b26e-bb369d2bff7a",
            "index": 159,
            "title": "Michael Simanovsky - A Platform Approach to Real Estate - [Invest Like the Best, EP.344]",
            "pub_date": "2023-09-19T08:00:00.000Z",
            "duration": "4055",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/98175771/simanovsky-a-platform-approach-to-real-estate",
            "audio_url": "https://traffic.megaphone.fm/CLS2308142983.mp3?updated=1767961340",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97fb8ada-50f3-11ee-8065-43ce4737bcdf",
            "index": 160,
            "title": "David Senra - In Service of Founders - [Invest Like the Best, EP.343]",
            "pub_date": "2023-09-12T08:00:00.000Z",
            "duration": "5174",
            "duration_label": "1h 26m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/13444907/senra-in-service-of-founders",
            "audio_url": "https://traffic.megaphone.fm/CLS8709415929.mp3?updated=1767961374",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d3bebb96-4b49-11ee-8f5e-4f811677331d",
            "index": 161,
            "title": "Will England - A Primer on Multi-Strategy Hedge Funds - [Invest Like the Best, EP.342]",
            "pub_date": "2023-09-05T08:00:00.000Z",
            "duration": "4866",
            "duration_label": "1h 21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/87302493/england-a-primer-on-multi-strategy-hedge-funds",
            "audio_url": "https://traffic.megaphone.fm/CLS8699257234.mp3?updated=1767961395",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ee34498-4604-11ee-838f-7b89e27948d2",
            "index": 162,
            "title": "James Cameron - The Futurist - [Founders, Forever Episode]",
            "pub_date": "2023-08-29T08:00:00.000Z",
            "duration": "4533",
            "duration_label": "1h 15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/51878786/senra-james-cameron-the-futurist?tab=shownotes",
            "audio_url": "https://traffic.megaphone.fm/CLS2311409787.mp3?updated=1767961425",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2d0b8678-4039-11ee-ac11-ff533597ed89",
            "index": 163,
            "title": "Lee Ainslie - Hedge Fund Maverick - [Invest Like the Best, EP. 341]",
            "pub_date": "2023-08-22T08:00:00.000Z",
            "duration": "5884",
            "duration_label": "1h 38m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/70732909/ainslie-lee-ainslie",
            "audio_url": "https://traffic.megaphone.fm/CLS5727654917.mp3?updated=1767961450",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0fa154a0-3abc-11ee-b4a2-dffebed1c6d0",
            "index": 164,
            "title": "Nick Kokonas - Know What You Are Selling – [Founder’s Field Guide, Forever Episode]",
            "pub_date": "2023-08-15T08:18:00.000Z",
            "duration": "4690",
            "duration_label": "1h 18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/20135760/kokonas-know-what-you-are-selling",
            "audio_url": "https://traffic.megaphone.fm/CLS7557982646.mp3?updated=1767961788",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fca7bcfa-3588-11ee-a34c-8f8722fe2886",
            "index": 165,
            "title": "Des Traynor - Real Talk about AI and Software - [Invest Like the Best, EP.340]",
            "pub_date": "2023-08-08T08:00:00.000Z",
            "duration": "4028",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "training"
            ],
            "page_url": "https://joincolossus.com/episodes/54663623/traynor-the-reality-of-ai",
            "audio_url": "https://traffic.megaphone.fm/CLS3658579667.mp3?updated=1767961810",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a5e4d546-2fd5-11ee-a47a-138bae3f07dd",
            "index": 166,
            "title": "Samo Burja - The Great Founder Theory of History - [Invest Like the Best, EP.339]",
            "pub_date": "2023-08-01T08:00:00.000Z",
            "duration": "4213",
            "duration_label": "1h 10m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/89710393/burja-the-great-founder-theory-of-history",
            "audio_url": "https://traffic.megaphone.fm/CLS9830827985.mp3?updated=1767961831",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e466e940-2a2a-11ee-8325-c3a209275aa2",
            "index": 167,
            "title": "Chris Paik - Venture Investing Frameworks - [Invest Like the Best, EP.338]",
            "pub_date": "2023-07-25T08:00:00.000Z",
            "duration": "5499",
            "duration_label": "1h 31m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "alignment"
            ],
            "page_url": "https://joincolossus.com/episodes/44807654/paik-venture-frameworks",
            "audio_url": "https://traffic.megaphone.fm/CLS3331016571.mp3?updated=1767961861",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "06db7b7a-24e1-11ee-8ed9-2b2c3adf3c88",
            "index": 168,
            "title": "Josh Kushner - Building Thrive Capital - [Invest Like the Best, EP.337]",
            "pub_date": "2023-07-18T08:00:00.000Z",
            "duration": "6524",
            "duration_label": "1h 48m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/60539836/kushner-building-thrive-capital",
            "audio_url": "https://traffic.megaphone.fm/CLS3236827417.mp3?updated=1767961903",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e72751a8-1f38-11ee-a5b7-5b68841349cf",
            "index": 169,
            "title": "Jeremy Giffon - Special Situations in Private Markets - [Invest Like the Best, EP.336]",
            "pub_date": "2023-07-11T08:00:00.000Z",
            "duration": "6243",
            "duration_label": "1h 44m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/79714195/giffon-special-situations-in-private-markets",
            "audio_url": "https://traffic.megaphone.fm/CLS4838478890.mp3?updated=1767961928",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f0515c2-19c3-11ee-a2a8-c782a534dd60",
            "index": 170,
            "title": "Dave Yuan - A Primer on Vertical Market Software - [Invest Like the Best, EP.335]",
            "pub_date": "2023-07-04T08:00:00.000Z",
            "duration": "3299",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/83067189/yuan-a-primer-on-vertical-market-software",
            "audio_url": "https://traffic.megaphone.fm/CLS9818141403.mp3?updated=1767961919",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9625f300-145b-11ee-980d-df4c1fcd8e94",
            "index": 171,
            "title": "Kevin Kelly - Be Generous and Unique - [Invest Like the Best, EP.334]",
            "pub_date": "2023-06-27T08:00:00.000Z",
            "duration": "4084",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/52190137/kelly-be-generous-unique",
            "audio_url": "https://traffic.megaphone.fm/CLS9585001708.mp3?updated=1767961944",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a895a6ea-0ec3-11ee-ac2d-57a9fb94a640",
            "index": 172,
            "title": "Justin Mares - The US Health Crisis - [Invest Like the Best, EP.333]",
            "pub_date": "2023-06-20T08:00:00.000Z",
            "duration": "4991",
            "duration_label": "1h 23m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/67478361/mares-the-us-health-crisis",
            "audio_url": "https://traffic.megaphone.fm/CLS7908529528.mp3?updated=1767961972",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dfa28bea-094f-11ee-8af7-f7a9ec134faf",
            "index": 173,
            "title": "Scott Goodwin - Know The Names - [Invest Like the Best, EP.332]",
            "pub_date": "2023-06-13T08:00:00.000Z",
            "duration": "4417",
            "duration_label": "1h 13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/33400952/goodwin-know-the-names",
            "audio_url": "https://traffic.megaphone.fm/CLS5449662580.mp3?updated=1767962000",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f04f77fc-0439-11ee-8612-6bf4eab0201a",
            "index": 174,
            "title": "Rolex: Timeless Excellence - [Business Breakdowns, Forever Episode]",
            "pub_date": "2023-06-06T08:00:00.000Z",
            "duration": "3821",
            "duration_label": "1h 3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/12878745/clymer-rolex-timeless-excellence",
            "audio_url": "https://traffic.megaphone.fm/CLS8182606342.mp3?updated=1767963150",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f09ebaf8-fe33-11ed-bf36-3b06b7bdbfb3",
            "index": 175,
            "title": "Kieran Goodwin - Imagination, Volatility, and the Pursuit of Alpha - [Invest Like the Best, EP.331]",
            "pub_date": "2023-05-30T08:00:00.000Z",
            "duration": "3724",
            "duration_label": "1h 2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/48452518/goodwin-imagination-volatility-and-the-pursuit-of-alpha",
            "audio_url": "https://traffic.megaphone.fm/CLS2296513515.mp3?updated=1767963175",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "198c9b50-f877-11ed-afac-3b1394f5481c",
            "index": 176,
            "title": "Henry Schuck - Building ZoomInfo - [Invest Like the Best, EP.330]",
            "pub_date": "2023-05-23T08:00:00.000Z",
            "duration": "5656",
            "duration_label": "1h 34m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://www.joincolossus.com/episodes/49638569/schuck-finding-your-next-best-customer",
            "audio_url": "https://traffic.megaphone.fm/CLS7474913272.mp3?updated=1767963214",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e50d790-f374-11ed-9771-3f707f3cad8e",
            "index": 177,
            "title": "Karen Karniol-Tambour - Macro Headwinds vs. Tech Tailwinds - [Invest Like the Best, EP.329]",
            "pub_date": "2023-05-16T08:00:00.000Z",
            "duration": "2325",
            "duration_label": "38m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/88931712/karniol-tambour-macro-headwinds-vs-tech-tailwinds",
            "audio_url": "https://traffic.megaphone.fm/CLS3729541336.mp3?updated=1767963214",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fdbff35e-edcc-11ed-924c-d3c2210259c1",
            "index": 178,
            "title": "Fidji Simo - Creating Delightful Consumer Experiences - [Invest Like the Best, EP.328]",
            "pub_date": "2023-05-09T08:00:00.000Z",
            "duration": "4450",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://joincolossus.com/episodes/80275266/simo-creating-delightful-consumer-experiences",
            "audio_url": "https://traffic.megaphone.fm/CLS4116346404.mp3?updated=1767963257",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ab316d8-e80c-11ed-9d90-6f3f0e38859b",
            "index": 179,
            "title": "Bessemer Venture Partners - Building a VC Firm that Lasts Centuries - [Invest Like the Best, EP.327]",
            "pub_date": "2023-05-02T08:00:00.000Z",
            "duration": "4715",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://joincolossus.com/episodes/53409650/levine-scaling-a-venture-firm",
            "audio_url": "https://traffic.megaphone.fm/CLS4960842091.mp3?updated=1767963347",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "136c1f2a-e2e7-11ed-a374-035cfd711352",
            "index": 180,
            "title": "Alexis Rivas - A New Blueprint for Homebuilding - [Invest Like the Best, EP.326]",
            "pub_date": "2023-04-25T08:00:00.000Z",
            "duration": "3141",
            "duration_label": "52m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/41239943/rivas-a-new-blueprint-for-building-homes",
            "audio_url": "https://traffic.megaphone.fm/CLS2837430574.mp3?updated=1767963380",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "559ed8c8-dd34-11ed-9ace-4b01472494ca",
            "index": 181,
            "title": "Dr. Peter Attia - The Portfolio to Live Longer - [Invest Like the Best, EP.325]",
            "pub_date": "2023-04-18T08:00:00.000Z",
            "duration": "5182",
            "duration_label": "1h 26m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/46859896/attia-the-portfolio-to-live-longer",
            "audio_url": "https://traffic.megaphone.fm/CLS7976056142.mp3?updated=1767963456",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2452829c-d7a8-11ed-9182-fff566026141",
            "index": 182,
            "title": "Scott Davis & Rob Wertheimer - Lessons from the Industrial Titans - [Invest Like the Best, EP.324]",
            "pub_date": "2023-04-11T08:00:00.000Z",
            "duration": "4298",
            "duration_label": "1h 11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/36463135/wertheimer-lessons-from-the-industrial-titans",
            "audio_url": "https://traffic.megaphone.fm/CLS4724716555.mp3?updated=1767963472",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a23d670c-d2bd-11ed-aa16-ab9e49d7f0a1",
            "index": 183,
            "title": "Sam Hinkie, Boyd Varty, Charlie Songhurst - Trail Magic - [Invest Like the Best, EP.323]",
            "pub_date": "2023-04-04T08:00:00.000Z",
            "duration": "6095",
            "duration_label": "1h 41m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://joincolossus.com/episodes/84175166/varty-trail-magic",
            "audio_url": "https://traffic.megaphone.fm/CLS6282239007.mp3?updated=1767963523",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9bfa5c6-cfa2-11ed-85d6-ff6a0a979be3",
            "index": 184,
            "title": "David Senra - Passion & Pain - [Invest Like the Best, Forever Episode]",
            "pub_date": "2023-03-31T08:00:00.000Z",
            "duration": "5145",
            "duration_label": "1h 25m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://traffic.megaphone.fm/CLS3013239790.mp3?updated=1767963933",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5ccd62d8-cf9a-11ed-bf98-b3ae06fc48bc",
            "index": 185,
            "title": "David Einhorn - The Long and Short of Investing - [Invest Like the Best, EP.322]",
            "pub_date": "2023-03-28T08:00:00.000Z",
            "duration": "4404",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://joincolossus.com/episodes/72443180/einhorn-the-long-and-short-of-investing",
            "audio_url": "https://traffic.megaphone.fm/CLS4605461012.mp3?updated=1767963954",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1717054e-dcae-4eb0-8e5e-078123f30be5",
            "index": 186,
            "title": "Avi Goldfarb - The Economic Impact of AI - [Invest Like the Best, EP.321]",
            "pub_date": "2023-03-21T08:00:00.000Z",
            "duration": "3619",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://joincolossus.com/episodes/45120795/goldfarb-the-disruptive-economics-of-ai",
            "audio_url": "https://traffic.megaphone.fm/CLS7903463108.mp3?updated=1767963969",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83849f26-ee81-4e50-87eb-6f4baf6832a4",
            "index": 187,
            "title": "Auren Hoffman - A Deep Dive on Data - [Invest Like the Best, EP.320]",
            "pub_date": "2023-03-14T08:00:00.000Z",
            "duration": "4301",
            "duration_label": "1h 11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/13721230/hoffman-a-deep-dive-on-data",
            "audio_url": "https://traffic.megaphone.fm/CLS1673760299.mp3?updated=1767963991",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "836e877f-c04f-4c8b-950b-9d1cdf499b82",
            "index": 188,
            "title": "Trae Stephens - Find Good Quests - [Invest Like the Best, EP.319]",
            "pub_date": "2023-03-07T09:00:00.000Z",
            "duration": "4119",
            "duration_label": "1h 8m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/39798384/stephens-find-good-quests",
            "audio_url": "https://traffic.megaphone.fm/CLS6675840003.mp3?updated=1767964013",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a8b0aa3-8fa5-4f2f-af2d-00aec32fb05c",
            "index": 189,
            "title": "Doug Leone - Lessons from a Titan - [Invest Like the Best, EP.318]",
            "pub_date": "2023-02-28T09:00:00.000Z",
            "duration": "4345",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/54685008/leone-clear-and-simple",
            "audio_url": "https://traffic.megaphone.fm/CLS8480857180.mp3?updated=1767964045",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22fd3b9f-b7f4-4512-901d-54400a58b7e9",
            "index": 190,
            "title": "Tim Urban - Idea Labs and High-Rung Thinking - [Invest Like the Best, EP.317]",
            "pub_date": "2023-02-21T09:00:00.000Z",
            "duration": "5435",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/16521394/urban-restore-high-rung-thinking",
            "audio_url": "https://traffic.megaphone.fm/CLS3016311512.mp3?updated=1767964069",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2b2689ef-7a18-4bb8-ae6c-40d066f0ecba",
            "index": 191,
            "title": "Dan Rose - How Stunning Founders Operate - [Invest Like the Best, EP.316]",
            "pub_date": "2023-02-14T09:00:00.000Z",
            "duration": "4473",
            "duration_label": "1h 14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/82256020/rose-how-stunning-founders-operate",
            "audio_url": "https://traffic.megaphone.fm/CLS8056828244.mp3?updated=1767964084",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c1a6f03-52b3-4b4a-ad18-b11fc1ba90f7",
            "index": 192,
            "title": "Jeff Green - Modernizing Advertising - [Invest Like the Best, EP.315]",
            "pub_date": "2023-02-07T09:00:00.000Z",
            "duration": "4043",
            "duration_label": "1h 7m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/83995153/green-building-nyse-for-advertisers",
            "audio_url": "https://traffic.megaphone.fm/CLS8081820962.mp3?updated=1767964103",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6749ab6e-208f-4543-a2f7-533cf59e4705",
            "index": 193,
            "title": "Carl Kawaja - Dealing with Regime Change - [Invest Like the Best, EP.314]",
            "pub_date": "2023-01-31T09:00:00.000Z",
            "duration": "4469",
            "duration_label": "1h 14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/34879627/kawaja-dealing-with-regime-change",
            "audio_url": "https://traffic.megaphone.fm/CLS4237316799.mp3?updated=1767964170",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b52155b9-f65e-4405-870c-179b81c54b38",
            "index": 194,
            "title": "Daryl Morey - Systems Thinking in Sports - [Invest Like the Best, EP.313]",
            "pub_date": "2023-01-24T09:00:00.000Z",
            "duration": "3959",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://www.joincolossus.com/episodes/50823211/morey-systems-thinking-in-sports",
            "audio_url": "https://traffic.megaphone.fm/CLS2906306962.mp3?updated=1767964625",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "647db043-5d17-404c-a9f9-d7c2c4419d2a",
            "index": 195,
            "title": "Miles Grimshaw - The DNA of Software Companies - [Invest Like the Best, EP.312]",
            "pub_date": "2023-01-17T09:00:00.000Z",
            "duration": "4388",
            "duration_label": "1h 13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/29895246/grimshaw-assessing-the-dna-of-software-companies",
            "audio_url": "https://traffic.megaphone.fm/CLS7452176505.mp3?updated=1767964650",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ee72819-e02c-4417-96c2-515d33b93746",
            "index": 196,
            "title": "John Fio - Creating Magic for Consumers - [Invest Like the Best, EP.311]",
            "pub_date": "2023-01-10T09:00:00.000Z",
            "duration": "5055",
            "duration_label": "1h 24m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/86445795/fiorentino-creating-magic-for-consumers",
            "audio_url": "https://traffic.megaphone.fm/CLS9143611214.mp3?updated=1767964675",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5dbabda8-b735-4895-afb8-3c8db74318ae",
            "index": 197,
            "title": "Amjad Masad - The Future of Software Creation - [Invest Like the Best, EP.310]",
            "pub_date": "2023-01-03T09:00:00.000Z",
            "duration": "3784",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "replit",
              "training",
              "coding"
            ],
            "page_url": "https://www.joincolossus.com/episodes/47968266/masad-the-future-of-software-creation",
            "audio_url": "https://traffic.megaphone.fm/CLS1453881503.mp3?updated=1767964685",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db33d5ba-c4ed-4050-bdda-a84e590915ac",
            "index": 198,
            "title": "Rebecca Lynn - Finding Your Customers - [Invest Like the Best, EP.309]",
            "pub_date": "2022-12-27T09:00:00.000Z",
            "duration": "3244",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/71195566/lynn-finding-your-customers",
            "audio_url": "https://traffic.megaphone.fm/CLS4148288720.mp3?updated=1767964706",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7b53c8a1-dd77-490e-8a19-58137cc3b375",
            "index": 199,
            "title": "Michael Mauboussin - Sharpening Investor & Executive Toolkits - [Invest Like the Best, EP.308]",
            "pub_date": "2022-12-20T09:00:00.000Z",
            "duration": "4135",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://www.joincolossus.com/episodes/70973958/mauboussin-sharpening-investor-executive-toolkits",
            "audio_url": "https://traffic.megaphone.fm/CLS1695921771.mp3?updated=1767964726",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cb38dd52-ba0e-4faa-b53e-6ab4952a359d",
            "index": 200,
            "title": "Jeremiah Lowin: Explaining the New AI Paradigm - [Invest Like the Best, EP.307]",
            "pub_date": "2022-12-13T09:00:00.000Z",
            "duration": "3781",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "openai",
              "github copilot",
              "training",
              "coding"
            ],
            "page_url": "https://www.joincolossus.com/episodes/77957344/lowin-explaining-the-new-ai-paradigm",
            "audio_url": "https://traffic.megaphone.fm/CLS9975483830.mp3?updated=1767964745",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b150989-356e-4105-aded-7d937c63d496",
            "index": 201,
            "title": "Bill Lenehan: Investing in Commercial Real Estate - [Invest Like the Best, EP.306]",
            "pub_date": "2022-12-06T09:00:00.000Z",
            "duration": "4735",
            "duration_label": "1h 18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/2027453/lenehan-commercial-real-estate",
            "audio_url": "https://traffic.megaphone.fm/CLS1376301480.mp3?updated=1767964773",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8bc62a7-436b-4454-9618-aca1293989a7",
            "index": 202,
            "title": "Ron Howard and Brian Grazer - Box Office Business - [Invest Like the Best, EP.305]",
            "pub_date": "2022-11-29T09:00:00.000Z",
            "duration": "3325",
            "duration_label": "55m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/19204230/howard-box-office-business",
            "audio_url": "https://traffic.megaphone.fm/CLS3062489448.mp3?updated=1767964795",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a250c26d-986e-4352-9a3b-92b87097fe75",
            "index": 203,
            "title": "Shane Battier - The No-Stats All-Star - [Invest Like the Best, EP.304]",
            "pub_date": "2022-11-22T09:00:00.000Z",
            "duration": "3446",
            "duration_label": "57m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/68722518/battier-how-to-win",
            "audio_url": "https://traffic.megaphone.fm/CLS6254022263.mp3?updated=1767964810",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "71f9a0ac-5699-4b2c-b991-6b0c522dc02b",
            "index": 204,
            "title": "Parker Conrad - Building a Compound Company - [Invest Like the Best, EP.303]",
            "pub_date": "2022-11-15T09:00:00.000Z",
            "duration": "3769",
            "duration_label": "1h 2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/43859721/conrad-building-a-compound-company",
            "audio_url": "https://traffic.megaphone.fm/CLS4975777021.mp3?updated=1767964844",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "174bb256-950d-4ad7-90af-c5885c721887",
            "index": 205,
            "title": "Bob Elliott - A Macro Tour - [Invest Like the Best, EP.302]",
            "pub_date": "2022-11-08T09:00:00.000Z",
            "duration": "4957",
            "duration_label": "1h 22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/69469677/elliott-a-macro-tour",
            "audio_url": "https://traffic.megaphone.fm/CLS2757291969.mp3?updated=1767964974",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1035674d-c51d-4c6c-b1a8-59c54695ec3d",
            "index": 206,
            "title": "Kirsten Green - Investing in Consumer Change - [Invest Like the Best, EP.301]",
            "pub_date": "2022-11-01T08:00:00.000Z",
            "duration": "4301",
            "duration_label": "1h 11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/37119956/green-investing-in-consumer-change",
            "audio_url": "https://traffic.megaphone.fm/CLS4185018438.mp3?updated=1767964982",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9350b465-573b-47b9-950f-df766d8b50f3",
            "index": 207,
            "title": "Jason Droege - Building Uber Eats - [Invest Like the Best, EP.300]",
            "pub_date": "2022-10-25T08:00:00.000Z",
            "duration": "3996",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/57349226/droege-building-a-second-act",
            "audio_url": "https://traffic.megaphone.fm/CLS1274237963.mp3?updated=1767965002",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a0d7479-7547-4d82-ab7a-9d6cb75b3411",
            "index": 208,
            "title": "Paul Orfalea - It’s About the Money - [Invest Like the Best, EP.299]",
            "pub_date": "2022-10-18T08:00:00.000Z",
            "duration": "2928",
            "duration_label": "48m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "alignment"
            ],
            "page_url": "https://www.joincolossus.com/episodes/56546035/orfalea-its-about-the-money",
            "audio_url": "https://traffic.megaphone.fm/CLS8740974330.mp3?updated=1767965020",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "51f80a03-ef1f-4b2a-a803-531cdedfe624",
            "index": 209,
            "title": "Madhavan Ramanujam - How to Price Products - [Invest Like the Best, EP.298]",
            "pub_date": "2022-10-11T08:00:00.000Z",
            "duration": "3540",
            "duration_label": "59m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/67388971/ramanujam-how-to-price-products",
            "audio_url": "https://traffic.megaphone.fm/CLS3761819978.mp3?updated=1767965039",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "878f9a5c-19bf-4b1e-ba28-2217d6791787",
            "index": 210,
            "title": "Scott Wilson - Non-Traditional Endowment Investing - [Invest Like the Best, EP.297]",
            "pub_date": "2022-10-04T08:00:00.000Z",
            "duration": "3542",
            "duration_label": "59m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/43243284/wilson-global-endowment-investing",
            "audio_url": "https://traffic.megaphone.fm/CLS2181689246.mp3?updated=1767965062",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1530e56-9c86-4350-83ab-07f2d14ccb56",
            "index": 211,
            "title": "Julio Vasconcellos & Mate Pencz - Investing in Latin America - [Invest Like the Best, EP.296]",
            "pub_date": "2022-09-27T08:00:00.000Z",
            "duration": "3844",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/77749600/pencz-investing-in-latin-america",
            "audio_url": "https://traffic.megaphone.fm/CLS2218455684.mp3?updated=1767965144",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b6be5a13-c8ad-4a35-b8e2-d3c47ee7446d",
            "index": 212,
            "title": "Trina Spear - Billion Dollar Scrubs - [Invest Like the Best, EP.295]",
            "pub_date": "2022-09-20T08:00:00.000Z",
            "duration": "3107",
            "duration_label": "51m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "chip"
            ],
            "page_url": "https://www.joincolossus.com/episodes/52929807/spear-billion-dollar-scrubs",
            "audio_url": "https://traffic.megaphone.fm/CLS5919340288.mp3?updated=1767965152",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0d834f0-7b16-4c9e-bc3c-85c3efd64e8d",
            "index": 213,
            "title": "Gabriel Leydon - How Web3 Onboards a Billion Users - [Web3 Breakdowns, EP.37]",
            "pub_date": "2022-09-15T08:00:00.000Z",
            "duration": "3719",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/28317960/leydon-the-third-wave-of-nfts",
            "audio_url": "https://traffic.megaphone.fm/CLS5672513620.mp3?updated=1767965188",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04446d4e-400b-4bc6-8609-76293dcde966",
            "index": 214,
            "title": "Harley Finkelstein - Building the Entrepreneurship Company - [Invest Like the Best, EP.294]",
            "pub_date": "2022-09-13T08:00:00.000Z",
            "duration": "4100",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://www.joincolossus.com/episodes/69994634/finkelstein-building-the-entrepreneurship-company",
            "audio_url": "https://traffic.megaphone.fm/CLS5338952973.mp3?updated=1767967834",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "15e75d4c-4778-4d9e-8096-f20a61957819",
            "index": 215,
            "title": "Mitch Lasky - The Business of Gaming - [Invest Like the Best, EP.293]",
            "pub_date": "2022-09-06T08:00:00.000Z",
            "duration": "4559",
            "duration_label": "1h 15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/99764091/lasky-the-business-of-gaming",
            "audio_url": "https://traffic.megaphone.fm/CLS4829497450.mp3?updated=1767967844",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "422f2801-d693-41e2-a122-5acca752176f",
            "index": 216,
            "title": "David Senra - Passion & Pain - [Invest Like the Best, EP.292]",
            "pub_date": "2022-08-30T08:00:00.000Z",
            "duration": "5134",
            "duration_label": "1h 25m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/85503387/senra-passion-pain",
            "audio_url": "https://traffic.megaphone.fm/CLS2216455730.mp3?updated=1767967799",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f337118f-8920-4070-9a06-3ba15ccb3835",
            "index": 217,
            "title": "Robert Smith - Investing in Enterprise Software - [Invest Like the Best, EP.291]",
            "pub_date": "2022-08-23T08:00:00.000Z",
            "duration": "3548",
            "duration_label": "59m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://www.joincolossus.com/episodes/87713997/f-investing-in-enterprise-software",
            "audio_url": "https://traffic.megaphone.fm/CLS6425561552.mp3?updated=1767967785",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "797ec556-12e2-4937-9508-c588aec6bc59",
            "index": 218,
            "title": "Katherine Boyle - Investing for America - [Invest Like the Best, EP.290]",
            "pub_date": "2022-08-16T08:00:00.000Z",
            "duration": "3440",
            "duration_label": "57m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/80105860/boyle-investing-for-america",
            "audio_url": "https://traffic.megaphone.fm/CLS2665619008.mp3?updated=1767967856",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9486c0e8-4a32-4d09-9145-7068696be5f7",
            "index": 219,
            "title": "Ravi Gupta - Focus - [Invest Like the Best, EP.289]",
            "pub_date": "2022-08-09T08:00:00.000Z",
            "duration": "4784",
            "duration_label": "1h 19m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/49602794/gupta-demanding-and-supportive",
            "audio_url": "https://traffic.megaphone.fm/CLS1545124260.mp3?updated=1767967810",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "44a0d245-677e-4936-9f7a-099a479ceeda",
            "index": 220,
            "title": "Will Thorndike - The Power of Long Holding Periods - [Invest Like the Best, EP.288]",
            "pub_date": "2022-08-02T08:00:00.000Z",
            "duration": "3694",
            "duration_label": "1h 1m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/88167992/thorndike-the-power-of-long-holding-periods",
            "audio_url": "https://traffic.megaphone.fm/CLS5848959644.mp3?updated=1767967894",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e2b8de5-767d-4a2d-a7ae-5ffde24bda8f",
            "index": 221,
            "title": "Alok Vasudev - Searching for White Space - [Invest Like the Best, EP.287]",
            "pub_date": "2022-07-26T08:00:00.000Z",
            "duration": "4458",
            "duration_label": "1h 14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/66341032/vasudev-searching-for-white-space",
            "audio_url": "https://traffic.megaphone.fm/CLS3700688357.mp3?updated=1767967985",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "169f7d58-0f83-43bd-a6ef-02ffc2f4b186",
            "index": 222,
            "title": "Matthew Ball - A Manual to The Metaverse - [Invest Like the Best, EP.286]",
            "pub_date": "2022-07-19T08:00:00.000Z",
            "duration": "4971",
            "duration_label": "1h 22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/87307833/ball-a-primer-on-the-metaverse",
            "audio_url": "https://traffic.megaphone.fm/CLS1497271538.mp3?updated=1767968026",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ea90a685-5162-4d57-96b1-5e84e1de6fb1",
            "index": 223,
            "title": "TransDigm: Foundations with Nick Howley [50X, EP.1]",
            "pub_date": "2022-07-14T08:00:00.000Z",
            "duration": "5215",
            "duration_label": "1h 26m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "training",
              "embedding"
            ],
            "page_url": "https://www.50xpodcast.com",
            "audio_url": "https://traffic.megaphone.fm/CLS2434182019.mp3?updated=1767968009",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a52caf08-a641-4886-8cc0-df559077367f",
            "index": 224,
            "title": "Alice Bentinck - Building a Start-Up Machine - [Invest Like the Best, EP.285]",
            "pub_date": "2022-07-12T08:00:00.000Z",
            "duration": "3976",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/35108124/bentinck-building-a-start-up-machine",
            "audio_url": "https://traffic.megaphone.fm/CLS2631295640.mp3?updated=1767968035",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "61c6bf99-53e6-4dff-bac2-126bf530e327",
            "index": 225,
            "title": "Jess Lee - Designing Investment Products - [Invest Like the Best, EP.284]",
            "pub_date": "2022-07-05T08:00:00.000Z",
            "duration": "3639",
            "duration_label": "1h 0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/87558266/lee-designing-investment-products",
            "audio_url": "https://traffic.megaphone.fm/CLS7994051394.mp3?updated=1767968052",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7d431268-535c-4a53-88bc-360b4c6ff657",
            "index": 226,
            "title": "Kenneth Stanley - Greatness Without Goals - [Invest Like the Best, EP.283]",
            "pub_date": "2022-06-28T08:00:00.000Z",
            "duration": "4586",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/88083127/stanley-greatness-without-goals",
            "audio_url": "https://traffic.megaphone.fm/CLS3147124051.mp3?updated=1767968107",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f413c5b4-3540-4b6c-b3cb-890f37c45a06",
            "index": 227,
            "title": "Lydia Jett - Investing in E-commerce - [Invest Like the Best, EP.282]",
            "pub_date": "2022-06-21T08:00:00.000Z",
            "duration": "4220",
            "duration_label": "1h 10m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/90356557/jett-investing-in-e-commerce",
            "audio_url": "https://traffic.megaphone.fm/CLS6228879261.mp3?updated=1767968130",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a8706906-098e-4192-bb0e-c278fd26e12b",
            "index": 228,
            "title": "Josh Wolfe & Chris Power - Factories of the Future - [Invest Like the Best, EP.281]",
            "pub_date": "2022-06-14T08:00:00.000Z",
            "duration": "4317",
            "duration_label": "1h 11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/68087320/wolfe-factories-of-the-future",
            "audio_url": "https://traffic.megaphone.fm/CLS9915513037.mp3?updated=1767968204",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "16aafc86-d341-4db6-b5f9-45a7d6ead63f",
            "index": 229,
            "title": "Martin Casado - The Past, Present, and Future of Digital Infrastructure - [Invest Like the Best, EP.280]",
            "pub_date": "2022-06-07T08:00:00.000Z",
            "duration": "3404",
            "duration_label": "56m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/1290016/casado-the-past-present-and-future-of-digital-infrastructure",
            "audio_url": "https://traffic.megaphone.fm/CLS7826028060.mp3?updated=1767968159",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "363a9acd-4675-4c81-af41-0a13329538fa",
            "index": 230,
            "title": "Aswath Damodaran - Making Sense of the Market - [Invest Like the Best, EP. 279]",
            "pub_date": "2022-05-31T08:00:00.000Z",
            "duration": "7071",
            "duration_label": "1h 57m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/75305584/damodaran-teaching-the-world-finance",
            "audio_url": "https://traffic.megaphone.fm/CLS1026286569.mp3?updated=1767968366",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af63c765-29fc-444f-b6c4-855588047148",
            "index": 231,
            "title": "Anduril: Building the Future of Defense - [Business Breakdowns, EP. 59]",
            "pub_date": "2022-05-26T08:00:00.000Z",
            "duration": "4370",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/95062882/schimpf-building-the-future-of-defense",
            "audio_url": "https://traffic.megaphone.fm/CLS9088256644.mp3?updated=1767968337",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd69036c-4316-4cbf-a3d2-eb9f8f58035c",
            "index": 232,
            "title": "Tobi Lütke - Embrace the Unexpected - [Invest Like the Best, EP. 278]",
            "pub_date": "2022-05-24T08:00:00.000Z",
            "duration": "5250",
            "duration_label": "1h 27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/64394067/lutke-embrace-the-unexpected",
            "audio_url": "https://traffic.megaphone.fm/CLS5662597072.mp3?updated=1767968493",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed699236-fc38-481b-960d-ab1fd772befb",
            "index": 233,
            "title": "Tyler Cowen & Daniel Gross - Identifying Talent - [Invest Like the Best, EP. 277]",
            "pub_date": "2022-05-17T08:00:00.000Z",
            "duration": "4904",
            "duration_label": "1h 21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/14095368/gross-identifying-talent",
            "audio_url": "https://traffic.megaphone.fm/CLS4682437364.mp3?updated=1767968396",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "245608d6-e127-4d6e-b0dc-2d1db40af2dc",
            "index": 234,
            "title": "Jeff Jordan - Building & Investing in Marketplaces - [Invest Like the Best, EP. 276]",
            "pub_date": "2022-05-10T08:00:00.000Z",
            "duration": "4964",
            "duration_label": "1h 22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/90027351/jordan-building-investing-in-marketplaces",
            "audio_url": "https://traffic.megaphone.fm/CLS1805258584.mp3?updated=1767968705",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9883ad48-4326-4ed3-bf29-cb38bec9a90f",
            "index": 235,
            "title": "Eric Glyman - Reimagining Corporate Finance - [Invest Like the Best, EP. 275]",
            "pub_date": "2022-05-03T08:00:00.000Z",
            "duration": "3838",
            "duration_label": "1h 3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/8753343/glyman-reimagining-corporate-finance",
            "audio_url": "https://traffic.megaphone.fm/CLS8197005313.mp3?updated=1767968759",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22d3c215-87ad-42e3-ad96-8073bc65fb0d",
            "index": 236,
            "title": "Dmitry Balyasny - Building a Better Model - [Invest Like the Best, EP. 274]",
            "pub_date": "2022-04-26T08:00:00.000Z",
            "duration": "4509",
            "duration_label": "1h 15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/36513013/balyasny-building-a-better-model",
            "audio_url": "https://traffic.megaphone.fm/CLS5333943598.mp3?updated=1767968746",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9da8af1-34a0-42dd-baad-0ee06a8f767e",
            "index": 237,
            "title": "Henry Ward - Transforming Private Markets - [Invest Like the Best, EP. 273]",
            "pub_date": "2022-04-21T08:00:00.000Z",
            "duration": "5052",
            "duration_label": "1h 24m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/39950198/ward-transforming-private-markets",
            "audio_url": "https://traffic.megaphone.fm/CLS9519977720.mp3?updated=1767968855",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e21ac2ba-c0b0-4c9c-8317-adb2ceb0fc5f",
            "index": 238,
            "title": "Alexandr Wang - A Primer on AI - [Invest Like the Best, EP. 272]",
            "pub_date": "2022-04-12T08:00:00.000Z",
            "duration": "4501",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai"
            ],
            "page_url": "https://www.joincolossus.com/episodes/75224660/wang-a-primer-on-ai",
            "audio_url": "https://traffic.megaphone.fm/CLS7986268859.mp3?updated=1767969008",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7280f243-b417-490c-8f16-f58dd35b93b0",
            "index": 239,
            "title": "Antonio Gracias - Pro-Entropic Investing - [Invest Like the Best, EP. 271]",
            "pub_date": "2022-04-05T08:00:00.000Z",
            "duration": "4460",
            "duration_label": "1h 14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/71060298/gracias-pro-entropic-investing",
            "audio_url": "https://traffic.megaphone.fm/CLS1714286445.mp3?updated=1767968981",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ffb7cc26-5e8b-4b3e-86fc-3da806b2189b",
            "index": 240,
            "title": "David Rubenstein - Life, Leadership, and LBOs - [Invest Like the Best, EP. 270]",
            "pub_date": "2022-03-29T08:00:00.000Z",
            "duration": "4665",
            "duration_label": "1h 17m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/77502018/rubenstein-life-leadership-and-lbos",
            "audio_url": "https://traffic.megaphone.fm/CLS1330417517.mp3?updated=1767969014",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "692fdbbc-9e2b-4c13-8d0a-d61cc4266ce9",
            "index": 241,
            "title": "Gaurav Kapadia - Everything Compounds - [Invest Like the Best, EP. 269]",
            "pub_date": "2022-03-22T08:00:00.000Z",
            "duration": "4787",
            "duration_label": "1h 19m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/37926218/kapadia-everything-compounds",
            "audio_url": "https://traffic.megaphone.fm/CLS7655846832.mp3?updated=1767969127",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97ca5903-3889-4b32-87ae-58dda9be9d68",
            "index": 242,
            "title": "Marko Papic - A Multi-Polar World - [Invest Like the Best, EP. 268]",
            "pub_date": "2022-03-15T08:00:00.000Z",
            "duration": "4336",
            "duration_label": "1h 12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/70558964/papic-a-multi-polar-world",
            "audio_url": "https://traffic.megaphone.fm/CLS8095927977.mp3?updated=1767969137",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f360432-481f-4c8a-b84c-1ed3267b9a11",
            "index": 243,
            "title": "Garry Tan - Unwrapping the Gift - [Invest Like the Best, EP. 267]",
            "pub_date": "2022-03-08T09:00:00.000Z",
            "duration": "3767",
            "duration_label": "1h 2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/46775005/tan-unwrapping-the-gift",
            "audio_url": "https://traffic.megaphone.fm/CLS9582306403.mp3?updated=1767969151",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5dcd1ad-0cf9-42c2-b253-32304c8418db",
            "index": 244,
            "title": "Eric Mandelblatt - Investing in the Industrial Economy - [Invest Like the Best, EP. 266]",
            "pub_date": "2022-03-01T09:00:00.000Z",
            "duration": "4841",
            "duration_label": "1h 20m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/43906331/mandelblatt-investing-in-the-industrial-economy",
            "audio_url": "https://traffic.megaphone.fm/CLS1466794976.mp3?updated=1767969472",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "47f04627-d351-4209-bb20-61bca9044f7d",
            "index": 245,
            "title": "Sebastian Kanovich - Powering Emerging Markets Payments - [Founder’s Field Guide, EP. 56]",
            "pub_date": "2022-02-24T09:00:00.000Z",
            "duration": "2622",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/25751178/kanovich-powering-emerging-markets-payments",
            "audio_url": "https://traffic.megaphone.fm/CLS3395078046.mp3?updated=1767969475",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8e5d0051-f581-43aa-9daa-ee9a5b44ed19",
            "index": 246,
            "title": "Frank Slootman - Narrow the Focus, Increase the Quality - [Invest Like the Best, EP. 265]",
            "pub_date": "2022-02-22T09:00:00.000Z",
            "duration": "3231",
            "duration_label": "53m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/75184353/slootman-narrow-the-focus-increase-the-quality",
            "audio_url": "https://traffic.megaphone.fm/CLS6397361742.mp3?updated=1767969518",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ede6d7f0-505a-49d5-bafb-ede1fb5bec28",
            "index": 247,
            "title": "Tim Flannery - Simplifying Fund Closing - [Founder’s Field Guide, EP. 55]",
            "pub_date": "2022-02-17T09:00:00.000Z",
            "duration": "3209",
            "duration_label": "53m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/22807467/flannery-simplifying-fund-closing",
            "audio_url": "https://traffic.megaphone.fm/CLS8372229430.mp3?updated=1767969546",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7067e335-4b19-4a22-9260-d49f27d3afb2",
            "index": 248,
            "title": "Joey Levin - Building an Anti-Conglomerate - [Invest Like the Best, EP. 264]",
            "pub_date": "2022-02-15T09:00:00.000Z",
            "duration": "4303",
            "duration_label": "1h 11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/21653644/levin-building-an-anti-conglomerate",
            "audio_url": "https://traffic.megaphone.fm/CLS8032121390.mp3?updated=1767969648",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "47a72ab1-1ef1-441e-85e7-ddad020054fd",
            "index": 249,
            "title": "Peter Chernin - Betting on Passion - [Invest Like the Best, EP. 263]",
            "pub_date": "2022-02-08T09:00:00.000Z",
            "duration": "3609",
            "duration_label": "1h 0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/46126901/chernin-betting-on-passion",
            "audio_url": "https://traffic.megaphone.fm/CLS4888545830.mp3?updated=1767969560",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e06d3de6-d66d-408c-8aaf-8b71484e7737",
            "index": 250,
            "title": "John Pfeffer - Adapt and Evolve - [Invest Like the Best, EP. 262]",
            "pub_date": "2022-02-01T09:00:00.000Z",
            "duration": "6946",
            "duration_label": "1h 55m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/26583628/pfeffer-adapt-and-evolve",
            "audio_url": "https://traffic.megaphone.fm/CLS3215662450.mp3?updated=1767969857",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad6d7ca3-4739-447a-87f3-5477807e55e3",
            "index": 251,
            "title": "Geoffrey Moore - Building Gorilla Businesses - [Invest Like the Best, EP. 261]",
            "pub_date": "2022-01-27T09:00:00.000Z",
            "duration": "4660",
            "duration_label": "1h 17m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/88229579/moore-building-gorilla-businesses",
            "audio_url": "https://traffic.megaphone.fm/CLS4791322102.mp3?updated=1767969725",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1cf828e-d323-42bf-84da-f1a40c819238",
            "index": 252,
            "title": "Gavin Baker - The Cyclone Under the Surface - [Invest Like the Best, EP. 260]",
            "pub_date": "2022-01-25T09:00:00.000Z",
            "duration": "4927",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://www.joincolossus.com/episodes/42741941/baker-the-cyclone-under-the-surface",
            "audio_url": "https://traffic.megaphone.fm/CLS3655748149.mp3?updated=1767969764",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c6b2230f-c2c0-449a-8f17-827e4bdcb0b7",
            "index": 253,
            "title": "Sam Englebardt and Richard Kim - Investing in Immersive Worlds - [Invest Like the Best, EP. 259]",
            "pub_date": "2022-01-20T09:00:00.000Z",
            "duration": "4966",
            "duration_label": "1h 22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/1535353/englebardt-investing-in-immersive-worlds",
            "audio_url": "https://traffic.megaphone.fm/CLS4480819660.mp3?updated=1767969725",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "38ac4b1d-8f2a-4d7a-9fe4-492539c7d873",
            "index": 254,
            "title": "Ricky Sandler - Building an Investment Compass - [Invest Like the Best, EP. 258]",
            "pub_date": "2022-01-18T09:00:00.000Z",
            "duration": "4229",
            "duration_label": "1h 10m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/28925950/sandler-building-an-investment-compass",
            "audio_url": "https://traffic.megaphone.fm/CLS5206383895.mp3?updated=1767970358",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4969df85-e459-411d-bb9b-8ddfce1d36fe",
            "index": 255,
            "title": "Orlando Bravo - The Art of Software Buyouts - [Invest Like the Best, EP. 257]",
            "pub_date": "2021-12-28T09:00:00.000Z",
            "duration": "4067",
            "duration_label": "1h 7m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/88585306/bravo-the-art-of-software-buyouts",
            "audio_url": "https://traffic.megaphone.fm/CLS1997932436.mp3?updated=1767970511",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6233d9a9-0b5c-41cf-ab34-029e198cfea0",
            "index": 256,
            "title": "Nick Saltarelli - One Foot in Front of the Other - [Founder’s Field Guide, EP. 54]",
            "pub_date": "2021-12-23T09:00:00.000Z",
            "duration": "4296",
            "duration_label": "1h 11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/71926484/saltarelli-one-foot-in-front-of-the-other",
            "audio_url": "https://traffic.megaphone.fm/CLS7709896597.mp3?updated=1767970494",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6906276b-53c6-4016-bad8-edad00022788",
            "index": 257,
            "title": "Jenny Johnson - Seven Decades of Investing Expertise - [Invest Like the Best, EP. 256]",
            "pub_date": "2021-12-21T09:00:00.000Z",
            "duration": "3938",
            "duration_label": "1h 5m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/36382659/johnson-seven-decades-of-investing-expertise",
            "audio_url": "https://traffic.megaphone.fm/CLS8082692298.mp3?updated=1767970460",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa718e40-cd82-43d4-84a7-38e1d744b822",
            "index": 258,
            "title": "Doug Colkitt - The Evolution of Markets - [Invest Like the Best, EP. 255]",
            "pub_date": "2021-12-14T09:00:00.000Z",
            "duration": "4776",
            "duration_label": "1h 19m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/76741581/colkitt-the-evolution-of-markets",
            "audio_url": "https://traffic.megaphone.fm/CLS1583239213.mp3?updated=1767970490",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "06b88b98-7fc3-4411-a232-6f5ab299d0bd",
            "index": 259,
            "title": "Bill Gurley and Philip Rosedale - Back to the Future - [Invest Like the Best, EP. 254]",
            "pub_date": "2021-12-07T09:00:00.000Z",
            "duration": "4739",
            "duration_label": "1h 18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/43447310/gurley-back-to-the-future",
            "audio_url": "https://traffic.megaphone.fm/CLS5890460112.mp3?updated=1767970548",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a45bc877-4b79-42c0-9874-9d48eb2b5979",
            "index": 260,
            "title": "Francis Davidson - Design-led Hospitality - [Invest Like the Best, EP.253]",
            "pub_date": "2021-11-30T09:00:00.000Z",
            "duration": "3351",
            "duration_label": "55m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/68562438/davidson-design-led-hospitality",
            "audio_url": "https://traffic.megaphone.fm/CLS8519330848.mp3?updated=1767970580",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "62387df7-42a8-414b-b5c9-8180ac09fa14",
            "index": 261,
            "title": "Niraj Shah - Developing Every Skill - [Invest Like the Best, EP. 252]",
            "pub_date": "2021-11-23T09:00:00.000Z",
            "duration": "3998",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/73227114/shah-developing-every-skill",
            "audio_url": "https://traffic.megaphone.fm/CLS6507727337.mp3?updated=1767970619",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a083c32-e228-42dc-b7ff-3cdc773b7ae2",
            "index": 262,
            "title": "Bored Ape Yacht Club -  [Web3 Breakdowns, EP. 1]",
            "pub_date": "2021-11-18T09:00:00.000Z",
            "duration": "3265",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/99935896/golden-bored-ape-yacht-club",
            "audio_url": "https://traffic.megaphone.fm/CLS2263268787.mp3?updated=1767970635",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17492f95-89b7-44b4-850c-fe079e9209c4",
            "index": 263,
            "title": "Will Marshall - Indexing the Earth - [Invest Like the Best, EP. 251]",
            "pub_date": "2021-11-16T09:00:00.000Z",
            "duration": "3141",
            "duration_label": "52m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/14029498/marshall-indexing-the-earth",
            "audio_url": "https://traffic.megaphone.fm/CLS6013323480.mp3?updated=1767970658",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f84dd934-5068-4f8d-be44-66165fa11248",
            "index": 264,
            "title": "Roelof Botha - Sequoia’s Crucible Moment - [Invest Like the Best, EP. 250]",
            "pub_date": "2021-11-05T08:00:00.000Z",
            "duration": "4201",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "alignment"
            ],
            "page_url": "https://www.joincolossus.com/episodes/66371765/botha-sequoias-crucible-moment",
            "audio_url": "https://traffic.megaphone.fm/CLS2691904653.mp3?updated=1767970711",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "741b53b8-0c04-48a0-96ac-044b0cd1b8f6",
            "index": 265,
            "title": "Sarah Friar - Building the Local Graph - [Invest Like the Best, EP. 249]",
            "pub_date": "2021-11-02T08:00:00.000Z",
            "duration": "4555",
            "duration_label": "1h 15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/99036602/friar-building-the-local-graph",
            "audio_url": "https://traffic.megaphone.fm/CLS6877963330.mp3?updated=1767970739",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3d9e74f-8f89-4342-9489-576896efed5d",
            "index": 266,
            "title": "Universal Music Group: The Gatekeepers of Music - [Business Breakdowns, EP. 32]",
            "pub_date": "2021-10-28T08:00:00.000Z",
            "duration": "4735",
            "duration_label": "1h 18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/25864787/gokgol-kline-universal-music-group-the-gatekeepers-of-music",
            "audio_url": "https://traffic.megaphone.fm/CLS7989160737.mp3?updated=1767970839",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dfc87155-b132-4a32-91c7-4f5eb083250f",
            "index": 267,
            "title": "Alex Rampell - Investing in Operating Systems - [Invest Like the Best, EP. 248]",
            "pub_date": "2021-10-26T08:00:00.000Z",
            "duration": "4807",
            "duration_label": "1h 20m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/90737874/rampell-investing-in-operating-systems",
            "audio_url": "https://traffic.megaphone.fm/CLS8932689103.mp3?updated=1767970881",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b69910ba-566b-4416-aef3-b034f354f3f7",
            "index": 268,
            "title": "Sam Bankman-Fried - Creating a Perfect Market - [Invest Like the Best, EP. 247]",
            "pub_date": "2021-10-19T08:00:00.000Z",
            "duration": "4651",
            "duration_label": "1h 17m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/48641353/bankman-fried-creating-a-perfect-market",
            "audio_url": "https://traffic.megaphone.fm/CLS5916714949.mp3?updated=1767970972",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "71ac75e0-b6fc-4c72-9015-bb167d6e25ce",
            "index": 269,
            "title": "Nick Neuman - Becoming Your Own Bank - [Invest Like the Best, EP. 246]",
            "pub_date": "2021-10-12T08:00:00.000Z",
            "duration": "3992",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "https://www.joincolossus.com/episodes/73084963/neuman-becoming-your-own-bank",
            "audio_url": "https://traffic.megaphone.fm/CLS5048678473.mp3?updated=1767970926",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "86ed3e60-5106-404d-a1f3-138c845600f3",
            "index": 270,
            "title": "Devin Finzer - An Everything Store for Digital Assets - [Founder’s Field Guide, EP. 53]",
            "pub_date": "2021-10-07T08:00:00.000Z",
            "duration": "3212",
            "duration_label": "53m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.joincolossus.com/episodes/76162803/finzer-an-everything-store-for-digital-assets",
            "audio_url": "https://traffic.megaphone.fm/CLS5152504119.mp3?updated=1767970944",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "efdfc718-7aa3-4b76-9cdd-a60696ad2ab7",
            "index": 271,
            "title": "Jenny Lefcourt - The Go-to-Market Motion - [Invest Like the Best, EP. 245]",
            "pub_date": "2021-10-05T08:00:00.000Z",
            "duration": "3847",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/38318717/lefcourt-the-go-to-market-motion",
            "audio_url": "https://traffic.megaphone.fm/CLS1303326639.mp3?updated=1767971001",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "721ad7ab-ed54-48db-adf4-782b6293ab0f",
            "index": 272,
            "title": "Dave Girouard - Making Better Loans - [Founder’s Field Guide, EP. 52]",
            "pub_date": "2021-09-30T08:00:00.000Z",
            "duration": "4180",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://www.joincolossus.com/episodes/91470262/girouard-making-better-loans",
            "audio_url": "https://traffic.megaphone.fm/CLS1352368605.mp3?updated=1767971034",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "37f8cf40-3cfd-4002-b85a-a9d18b782522",
            "index": 273,
            "title": "Jay Hoag - Calibrating Market Adoption - [Invest Like the Best, EP. 244]",
            "pub_date": "2021-09-28T08:00:00.000Z",
            "duration": "4706",
            "duration_label": "1h 18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/80028950/hoag-calibrating-market-adoption",
            "audio_url": "https://traffic.megaphone.fm/CLS1334797466.mp3?updated=1767971083",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7c782f79-7187-41b9-9919-db3239c3456a",
            "index": 274,
            "title": "Gina Bianchini - Helping Creators Build Communities - [Founder’s Field Guide, EP. 51]",
            "pub_date": "2021-09-23T08:00:00.000Z",
            "duration": "3489",
            "duration_label": "58m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://www.joincolossus.com/episodes/24767191/bianchini-helping-creators-build-communities",
            "audio_url": "https://traffic.megaphone.fm/CLS5342098079.mp3?updated=1767971111",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed72327e-e4c5-458c-888b-3a55ced4b332",
            "index": 275,
            "title": "David Fialkow - Paint Outside the Lines - [Invest Like the Best, EP. 243]",
            "pub_date": "2021-09-21T08:00:00.000Z",
            "duration": "3970",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/48136535/fialkow-paint-outside-the-lines",
            "audio_url": "https://traffic.megaphone.fm/CLS6097107946.mp3?updated=1767971191",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b2d5839-37d8-42ec-9543-379ba58d2b30",
            "index": 276,
            "title": "Justin Waldron - The Future of Social Gaming - [Founder’s Field Guide, EP. 50]",
            "pub_date": "2021-09-16T08:00:00.000Z",
            "duration": "3940",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://www.joincolossus.com/episodes/1361386/waldron-the-future-of-social-gaming",
            "audio_url": "https://traffic.megaphone.fm/CLS3999901853.mp3?updated=1767971236",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a5f3320d-9dc8-4a1d-a5f9-3a15cc8ec6dd",
            "index": 277,
            "title": "Daniel Ek - Enabling Creators Everywhere - [Invest Like the Best, EP. 242]",
            "pub_date": "2021-09-14T08:00:00.000Z",
            "duration": "5343",
            "duration_label": "1h 29m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/14058936/ek-enabling-creators-everywhere",
            "audio_url": "https://traffic.megaphone.fm/CLS7857283623.mp3?updated=1767971312",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e0eb6844-5827-4281-8f5d-08fb93d8efa4",
            "index": 278,
            "title": "Gabby Dizon - Mapping the Metaverse Economy - [Founder’s Field Guide, EP. 49]",
            "pub_date": "2021-09-02T08:00:00.000Z",
            "duration": "3560",
            "duration_label": "59m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/45988185/dizon-mapping-the-metaverse-economy",
            "audio_url": "https://traffic.megaphone.fm/CLS1457855691.mp3?updated=1767971356",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02cb455a-1d0c-4c63-b543-905aa4c303e5",
            "index": 279,
            "title": "Scott Malpass - Building a Great Endowment - [Invest Like the Best, EP. 241]",
            "pub_date": "2021-08-31T08:00:00.000Z",
            "duration": "3880",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "alignment"
            ],
            "page_url": "https://www.joincolossus.com/episodes/77217304/malpass-building-a-great-endowment",
            "audio_url": "https://traffic.megaphone.fm/CLS2631964750.mp3?updated=1767971350",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8ef4bb73-da66-4493-a565-5216a959905e",
            "index": 280,
            "title": "Mike Maples, Jr. - A Playbook for Startups - [Founder’s Field Guide, EP. 48]",
            "pub_date": "2021-08-26T08:00:00.000Z",
            "duration": "4081",
            "duration_label": "1h 8m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/61719/maples-a-playbook-for-startups",
            "audio_url": "https://traffic.megaphone.fm/CLS1069845499.mp3?updated=1767971390",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca682a23-97db-4d52-95c1-f560f100015b",
            "index": 281,
            "title": "Renata Quintini and Roseanne Wincek - Investing at the Supercritical Stage - [Invest Like the Best, EP. 240]",
            "pub_date": "2021-08-24T08:00:00.000Z",
            "duration": "3861",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/73766219/quintini-investing-at-the-supercritical-stage",
            "audio_url": "https://traffic.megaphone.fm/CLS6550121162.mp3?updated=1767971455",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b110757-1996-4208-ae48-4edb1fbad626",
            "index": 282,
            "title": "Max Simkoff - Redesigning the Home Buying Experience - [Founder’s Field Guide, EP. 47]",
            "pub_date": "2021-08-19T08:00:00.000Z",
            "duration": "4320",
            "duration_label": "1h 12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/14284383/simkoff-redesigning-the-home-buying-experience",
            "audio_url": "https://traffic.megaphone.fm/CLS3131319357.mp3?updated=1767971432",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2920ff1-6868-4805-8f56-1cebd005bcb6",
            "index": 283,
            "title": "Suzanne Ciani - Exploring the Creative Process - [Invest Like the Best, EP. 239]",
            "pub_date": "2021-08-17T08:00:00.000Z",
            "duration": "3548",
            "duration_label": "59m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/67301309/ciani-exploring-the-creative-process",
            "audio_url": "https://traffic.megaphone.fm/CLS4780113623.mp3?updated=1767971485",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c36f96d6-76c1-4707-af2e-344d52e45cf3",
            "index": 284,
            "title": "Sameer Shariff - Breaking Language Barriers - [Founder’s Field Guide, EP. 46 ]",
            "pub_date": "2021-08-12T08:00:00.000Z",
            "duration": "3411",
            "duration_label": "56m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/51567490/shariff-breaking-language-barriers",
            "audio_url": "https://traffic.megaphone.fm/CLS4507277783.mp3?updated=1767971780",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b47ac248-5a29-43a5-b2bc-d32ed1524659",
            "index": 285,
            "title": "Sridhar Ramaswamy - The Past, Present, and Future of Search - [Invest Like the Best, EP. 238]",
            "pub_date": "2021-08-10T08:00:00.000Z",
            "duration": "4776",
            "duration_label": "1h 19m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/84033716/ramaswamy-the-past-present-and-future-of-search",
            "audio_url": "https://traffic.megaphone.fm/CLS3923777973.mp3?updated=1767971843",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d0d59db8-3036-4abc-bb18-ce7625361b31",
            "index": 286,
            "title": "Ernie Garcia - Disrupting the Auto Buying Experience - [Founder’s Field Guide, EP. 45]",
            "pub_date": "2021-08-05T08:00:00.000Z",
            "duration": "4588",
            "duration_label": "1h 16m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/86846154/garcia-disrupting-the-auto-buying-experience",
            "audio_url": "https://traffic.megaphone.fm/CLS3438495680.mp3?updated=1767971867",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "afaa8e28-2c21-4a55-8053-9e6c1085609f",
            "index": 287,
            "title": "Karen Karniol-Tambour - All Things Macro - [Invest Like the Best, EP. 237]",
            "pub_date": "2021-08-03T08:00:00.000Z",
            "duration": "4898",
            "duration_label": "1h 21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/969568/karniol-tambour-all-things-macro",
            "audio_url": "https://traffic.megaphone.fm/CLS9360265934.mp3?updated=1767971897",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3ad09f7c-b72d-4f4d-9d9a-37d18e2d25f7",
            "index": 288,
            "title": "Sebastian Mejia - Mastering On-Demand Convenience - [Founder’s Field Guide, EP. 44]",
            "pub_date": "2021-07-29T08:00:00.000Z",
            "duration": "3527",
            "duration_label": "58m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/48872654/mejia-mastering-on-demand-convenience",
            "audio_url": "https://traffic.megaphone.fm/CLS9060459740.mp3?updated=1767971887",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e829176d-6a8f-40f6-96f4-63f9a1a80056",
            "index": 289,
            "title": "Carl Kawaja - Wisdom from Decades of Investing - [Invest Like the Best, EP. 236]",
            "pub_date": "2021-07-27T08:00:00.000Z",
            "duration": "5448",
            "duration_label": "1h 30m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/25055995/kawaja-wisdom-from-decades-of-investing",
            "audio_url": "https://traffic.megaphone.fm/CLS1071572475.mp3?updated=1767972035",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7115097c-66de-4f97-b2ec-349e0d8002e2",
            "index": 290,
            "title": "Stewart Butterfield - We Don’t Sell Saddles Here - [Founder’s Field Guide, EP. 43]",
            "pub_date": "2021-07-22T08:00:00.000Z",
            "duration": "4163",
            "duration_label": "1h 9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/57400066/butterfield-we-dont-sell-saddles-here",
            "audio_url": "https://traffic.megaphone.fm/CLS8026824426.mp3?updated=1767971971",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4506a5ba-7b61-4467-ba9d-fd4dee8512fa",
            "index": 291,
            "title": "Steve Mandel - Investing Behind Change - [Invest Like the Best, EP. 235]",
            "pub_date": "2021-07-20T08:00:00.000Z",
            "duration": "4379",
            "duration_label": "1h 12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/17309631/mandel-investing-behind-change",
            "audio_url": "https://traffic.megaphone.fm/CLS4745171338.mp3?updated=1767972011",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0aee04d-4934-40c7-972e-9099d131c822",
            "index": 292,
            "title": "Spenser Skates - Challenging Big Ideas - [Founder’s Field Guide, EP. 42]",
            "pub_date": "2021-07-15T08:00:00.000Z",
            "duration": "3650",
            "duration_label": "1h 0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/73422676/skates-challenging-big-ideas",
            "audio_url": "https://traffic.megaphone.fm/CLS8940723280.mp3?updated=1767972016",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f3087dfb-8754-41f9-8754-3830294651ac",
            "index": 293,
            "title": "David Sacks - How to Operate a SaaS Startup - [Invest Like the Best, EP. 234]",
            "pub_date": "2021-07-13T08:00:00.000Z",
            "duration": "3848",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/58778794/sacks-how-to-operate-a-saas-startup",
            "audio_url": "https://traffic.megaphone.fm/CLS2132129588.mp3?updated=1767972042",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5dd4cbb5-cdbe-46ed-831b-bc7c5e844bdf",
            "index": 294,
            "title": "David Vélez - Building the Branchless Bank - [Founder’s Field Guide, EP. 41]",
            "pub_date": "2021-07-08T08:00:00.000Z",
            "duration": "3558",
            "duration_label": "59m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/16951337/velez-building-the-branchless-bank",
            "audio_url": "https://traffic.megaphone.fm/CLS7863899220.mp3?updated=1767972102",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33f3b1c6-590c-434c-94c0-4748392b5adc",
            "index": 295,
            "title": "Balaji Srinivasan - Optimizing Your Inputs - [Invest Like the Best, EP. 233]",
            "pub_date": "2021-07-06T08:00:00.000Z",
            "duration": "6491",
            "duration_label": "1h 48m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/85214124/srinivasan-optimizing-your-inputs",
            "audio_url": "https://traffic.megaphone.fm/CLS5098669214.mp3?updated=1767972182",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2f95c6fd-3e24-4c4a-9122-95886919740b",
            "index": 296,
            "title": "Michael Mayer - Business Boss Battles - [Founder’s Field Guide, EP. 40]",
            "pub_date": "2021-07-01T08:00:00.000Z",
            "duration": "3864",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/91593009/mayer-business-boss-battles",
            "audio_url": "https://traffic.megaphone.fm/CLS6989992336.mp3?updated=1767972148",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a4d247c-b42d-474b-9ab5-f3103e23a48c",
            "index": 297,
            "title": "Marc Andreessen - Making the Future - [Invest Like the Best, EP. 232]",
            "pub_date": "2021-06-29T08:00:00.000Z",
            "duration": "4939",
            "duration_label": "1h 22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/58516750/andreessen-making-the-future",
            "audio_url": "https://traffic.megaphone.fm/CLS6149309821.mp3?updated=1767972198",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "56effd85-b312-458b-a9a3-7e172d39ad38",
            "index": 298,
            "title": "Will Ahmed - Optimizing Human Performance – [Founder’s Field Guide, EP. 39]",
            "pub_date": "2021-06-24T08:00:00.000Z",
            "duration": "4442",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://www.joincolossus.com/episodes/50922947/ahmed-optimizing-human-performance",
            "audio_url": "https://traffic.megaphone.fm/CLS4426364068.mp3?updated=1767972216",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b3da5d53-970d-4576-b512-0f77821df5c0",
            "index": 299,
            "title": "Howard Marks - Embracing the Psychology of Investing - [Invest Like the Best, EP. 231]",
            "pub_date": "2021-06-22T08:00:00.000Z",
            "duration": "3644",
            "duration_label": "1h 0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/70790270/marks-embracing-the-psychology-of-investing",
            "audio_url": "https://traffic.megaphone.fm/CLS3020420420.mp3?updated=1767972265",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b4670de5-be8c-4bce-b65a-f7e4500aa866",
            "index": 300,
            "title": "Christina Cacioppo - Building the New Standard in Security – [Founder’s Field Guide, EP. 38]",
            "pub_date": "2021-06-17T08:00:00.000Z",
            "duration": "3981",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.joincolossus.com/episodes/92432452/cacioppo-building-the-new-standard-in-security",
            "audio_url": "https://traffic.megaphone.fm/CLS4814659701.mp3?updated=1767972268",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "gradient",
        "title": "The Gradient: Perspectives on AI",
        "feed_title": "The Gradient: Perspectives on AI",
        "priority": "P1",
        "selection_mode": "all_ai",
        "focus": [
          "AI research",
          "academia",
          "NLP",
          "AI safety"
        ],
        "feed_url": "https://api.substack.com/feed/podcast/265424/s/1354.rss",
        "source_url": "https://api.substack.com/feed/podcast/265424/s/1354.rss",
        "detail_path": "/podcasts/gradient/",
        "episode_count": 149,
        "selected_episode_count": 149,
        "latest_episode_title": "2025 in AI, with Nathan Benaich",
        "latest_pub_date": "2026-01-22T16:30:00.000Z",
        "latest_page_url": "https://thegradientpub.substack.com/p/nathan-benaich-2025",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "substack:post:184890183",
            "index": 1,
            "title": "2025 in AI, with Nathan Benaich",
            "pub_date": "2026-01-22T16:30:00.000Z",
            "duration": "3675",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "xai",
              "grok",
              "nvidia",
              "gpu",
              "chip"
            ],
            "page_url": "https://thegradientpub.substack.com/p/nathan-benaich-2025",
            "audio_url": "https://api.substack.com/feed/podcast/184890183/556849448c1f4ee0eefdeb6131b3f6b7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:179318402",
            "index": 2,
            "title": "Iason Gabriel: Value Alignment and the Ethics of Advanced AI Systems",
            "pub_date": "2025-11-26T19:36:07.000Z",
            "duration": "3519",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "deepmind",
              "alignment"
            ],
            "page_url": "https://thegradientpub.substack.com/p/iason-gabriel-value-alignment-ethics",
            "audio_url": "https://api.substack.com/feed/podcast/179318402/f0ec93d8cdf4d697ff1ae78f3ef73268.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:153615689",
            "index": 3,
            "title": "2024 in AI, with Nathan Benaich",
            "pub_date": "2024-12-26T16:30:00.000Z",
            "duration": "6523",
            "duration_label": "1h 48m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "generative ai",
              "nvidia",
              "gpu",
              "chips",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/state-of-ai-2024",
            "audio_url": "https://api.substack.com/feed/podcast/153615689/2217602b80c3816a2368f5543e9a31c4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:152943720",
            "index": 4,
            "title": "Philip Goff: Panpsychism as a Theory of Consciousness",
            "pub_date": "2024-12-12T16:30:00.000Z",
            "duration": "3604",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/philip-goff-panpsychism",
            "audio_url": "https://api.substack.com/feed/podcast/152943720/3fcae7efb8f6e93b5cc8f82f0cedc2d9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:151954362",
            "index": 5,
            "title": "Some Changes at The Gradient",
            "pub_date": "2024-11-21T16:30:00.000Z",
            "duration": "2065",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "alignment"
            ],
            "page_url": "https://thegradientpub.substack.com/p/some-changes-at-the-gradient",
            "audio_url": "https://api.substack.com/feed/podcast/151954362/fe76a0216db65c2d47bb9d120e4e887b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:149890149",
            "index": 6,
            "title": "Jacob Andreas: Language, Grounding, and World Models",
            "pub_date": "2024-10-10T15:30:00.000Z",
            "duration": "6763",
            "duration_label": "1h 52m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "artificial intelligence",
              "agent",
              "embeddings"
            ],
            "page_url": "https://thegradientpub.substack.com/p/jacob-andreas-language-grounding-world-models",
            "audio_url": "https://api.substack.com/feed/podcast/149890149/d0c12b7bbdd5033d57221eb92d64d376.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:149190041",
            "index": 7,
            "title": "Evan Ratliff: Our Future with Voice Agents",
            "pub_date": "2024-09-26T15:30:00.000Z",
            "duration": "4799",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://thegradientpub.substack.com/p/evan-ratliff-our-future-with-voice",
            "audio_url": "https://api.substack.com/feed/podcast/149190041/8719326a44b4fa43182655159619b62b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:148557970",
            "index": 8,
            "title": "Meredith Ringel Morris: Generative AI's HCI Moment",
            "pub_date": "2024-09-12T15:30:00.000Z",
            "duration": "5865",
            "duration_label": "1h 37m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "generative ai",
              "agents",
              "agentic",
              "deepmind",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/meredith-morris-generative-ai-hci",
            "audio_url": "https://api.substack.com/feed/podcast/148557970/a3c8ba58c76bed05858f92edd127b34c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:148422625",
            "index": 9,
            "title": "Davidad Dalrymple: Towards Provably Safe AI",
            "pub_date": "2024-09-05T16:04:35.000Z",
            "duration": "4850",
            "duration_label": "1h 20m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "anthropic",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/davidad-dalrymple-towards-provably",
            "audio_url": "https://api.substack.com/feed/podcast/148422625/500798c2e1e603771a2c9a0d54ba5fac.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:148114063",
            "index": 10,
            "title": "Clive Thompson: Tales of Technology",
            "pub_date": "2024-08-29T15:30:00.000Z",
            "duration": "8855",
            "duration_label": "2h 27m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://thegradientpub.substack.com/p/clive-thompson-tales-of-technology",
            "audio_url": "https://api.substack.com/feed/podcast/148114063/95ed86b63919d71a90b08d7e0f1c1fc7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:147854304",
            "index": 11,
            "title": "Judy Fan: Reverse Engineering the Human Cognitive Toolkit",
            "pub_date": "2024-08-22T15:30:00.000Z",
            "duration": "5559",
            "duration_label": "1h 32m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "artificial intelligence",
              "agent",
              "inference",
              "training",
              "alignment"
            ],
            "page_url": "https://thegradientpub.substack.com/p/judy-fan-reverse-engineering-the-human-cognitive-toolkit",
            "audio_url": "https://api.substack.com/feed/podcast/147854304/3f6f6001e7a564cfbfaceb8e9b0271da.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:147597983",
            "index": 12,
            "title": "L.M. Sacasas: The Questions Concerning Technology",
            "pub_date": "2024-08-15T15:30:00.000Z",
            "duration": "6440",
            "duration_label": "1h 47m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/lm-sacasas-convivial-society-the-questions-concerning-technology",
            "audio_url": "https://api.substack.com/feed/podcast/147597983/80996810a9b0d7eb874a135644fc7730.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:147342332",
            "index": 13,
            "title": "Pete Wolfendale: The Revenge of Reason",
            "pub_date": "2024-08-08T15:30:00.000Z",
            "duration": "10377",
            "duration_label": "2h 52m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://thegradientpub.substack.com/p/pete-wolfendale-the-revenge-of-reason",
            "audio_url": "https://api.substack.com/feed/podcast/147342332/88e6992ab34a2cadccd7e14f01a1d7d3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:146900944",
            "index": 14,
            "title": "Peter Lee: Computing Theory and Practice, and GPT-4's Impact",
            "pub_date": "2024-08-01T15:30:00.000Z",
            "duration": "3708",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi"
            ],
            "page_url": "https://thegradientpub.substack.com/p/peter-lee-computing-theory-compilers-gpt-4",
            "audio_url": "https://api.substack.com/feed/podcast/146900944/c7384fe311a65791d43a368d2a163c47.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:146804040",
            "index": 15,
            "title": "Manuel & Lenore Blum: The Conscious Turing Machine",
            "pub_date": "2024-07-25T15:30:00.000Z",
            "duration": "8584",
            "duration_label": "2h 23m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "multimodal"
            ],
            "page_url": "https://thegradientpub.substack.com/p/manuel-lenore-blum-conscious-turing-machine-tcs",
            "audio_url": "https://api.substack.com/feed/podcast/146804040/0b57a62b702bf03d8e4ef8a1352dbaf4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:146186676",
            "index": 16,
            "title": "Kevin Dorst: Against Irrationalist Narratives",
            "pub_date": "2024-07-18T15:30:00.000Z",
            "duration": "8121",
            "duration_label": "2h 15m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "chatgpt"
            ],
            "page_url": "https://thegradientpub.substack.com/p/kevin-dorst-bayesian-epistemolology-irrational",
            "audio_url": "https://api.substack.com/feed/podcast/146186676/bfc1acbc5332b106ad60a71dab82a8d2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:145684839",
            "index": 17,
            "title": "David Pfau: Manifold Factorization and AI for Science",
            "pub_date": "2024-07-11T15:30:00.000Z",
            "duration": "7252",
            "duration_label": "2h 0m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "deepmind",
              "inference",
              "embeddings"
            ],
            "page_url": "https://thegradientpub.substack.com/p/david-pfau-manifold-factorization",
            "audio_url": "https://api.substack.com/feed/podcast/145684839/d167695b2eab996ec1b4f111df531a3b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:145674056",
            "index": 18,
            "title": "Dan Hart and Michelle Michael: Bringing AI to Students in New South Wales",
            "pub_date": "2024-07-04T15:30:00.000Z",
            "duration": "4434",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://thegradientpub.substack.com/p/dan-hart-michelle-michael-ai-education-nsw",
            "audio_url": "https://api.substack.com/feed/podcast/145674056/d2aa68ab4ce3f884920349764ae14aa7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:145781938",
            "index": 19,
            "title": "Kristin Lauter: Private AI, Homomorphic Encryption, and AI for Cryptography",
            "pub_date": "2024-06-27T15:30:00.000Z",
            "duration": "4633",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama",
              "inference",
              "training",
              "embeddings"
            ],
            "page_url": "https://thegradientpub.substack.com/p/kristin-lauter-private-ai-homomorphic-encryption",
            "audio_url": "https://api.substack.com/feed/podcast/145781938/1d3b6622916604adc884e474878f7d1a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:145427494",
            "index": 20,
            "title": "Sergiy Nesterenko: Automating Circuit Board Design",
            "pub_date": "2024-06-20T15:30:00.000Z",
            "duration": "3815",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://thegradientpub.substack.com/p/sergiy-nesterenko-quilter-pcb-design-ai-compiler",
            "audio_url": "https://api.substack.com/feed/podcast/145427494/d390ebec3841b10664d39dd2ec56ccdf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:145396751",
            "index": 21,
            "title": "C. Thi Nguyen: Values, Legibility, and Gamification",
            "pub_date": "2024-06-13T15:30:00.000Z",
            "duration": "5413",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://thegradientpub.substack.com/p/c-thi-nguyen-values-legibility-games",
            "audio_url": "https://api.substack.com/feed/podcast/145396751/2f2f2ca58b0a07cee89c5b2f6b9925a5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:145181732",
            "index": 22,
            "title": "Vivek Natarajan: Towards Biomedical AI",
            "pub_date": "2024-06-06T15:30:00.000Z",
            "duration": "6903",
            "duration_label": "1h 55m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "training",
              "reasoning",
              "multimodal"
            ],
            "page_url": "https://thegradientpub.substack.com/p/vivek-natarajan-biomedical-ai-healthcare-palm",
            "audio_url": "https://api.substack.com/feed/podcast/145181732/1cb341ff3383b1cb9b254901bf774626.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:144961905",
            "index": 23,
            "title": "Thomas Mullaney: A Global History of the Information Age",
            "pub_date": "2024-05-30T15:30:00.000Z",
            "duration": "6225",
            "duration_label": "1h 43m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/tom-mullaney-chinese-typewriter-computer-history",
            "audio_url": "https://api.substack.com/feed/podcast/144961905/9f3955c0317f5e820c692b30e80fd390.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:144562369",
            "index": 24,
            "title": "Seth Lazar: Normative Philosophy of Computing",
            "pub_date": "2024-05-23T15:30:00.000Z",
            "duration": "6617",
            "duration_label": "1h 50m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/seth-lazar-normative-philosophy-of-computing",
            "audio_url": "https://api.substack.com/feed/podcast/144562369/3151312eb4ac0ff36828dca6fbea2dc6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:144541434",
            "index": 25,
            "title": "Suhail Doshi: The Future of Computer Vision",
            "pub_date": "2024-05-16T15:30:00.000Z",
            "duration": "4087",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "foundation model"
            ],
            "page_url": "https://thegradientpub.substack.com/p/suhail-doshi-playground-ai-computer-vision",
            "audio_url": "https://api.substack.com/feed/podcast/144541434/3b4b6046f00a392353603949d914cd5a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:144151316",
            "index": 26,
            "title": "Azeem Azhar: The Exponential View",
            "pub_date": "2024-05-09T15:30:00.000Z",
            "duration": "6385",
            "duration_label": "1h 46m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents"
            ],
            "page_url": "https://thegradientpub.substack.com/p/azeem-azhar-the-exponential-view",
            "audio_url": "https://api.substack.com/feed/podcast/144151316/d1a6f5da94457124ff3b014f435dcee7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:143790651",
            "index": 27,
            "title": "David Thorstad: Bounded Rationality and the Case Against Longtermism",
            "pub_date": "2024-05-02T15:30:00.000Z",
            "duration": "8342",
            "duration_label": "2h 19m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "agi",
              "agents"
            ],
            "page_url": "https://thegradientpub.substack.com/p/david-thorstad-bounded-rationality-longtermism",
            "audio_url": "https://api.substack.com/feed/podcast/143790651/4d66ab1da604ad52621261d6fbec6214.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:143790442",
            "index": 28,
            "title": "Ryan Tibshirani: Statistics, Nonparametric Regression, Conformal Prediction",
            "pub_date": "2024-04-25T15:30:00.000Z",
            "duration": "6389",
            "duration_label": "1h 46m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "inference"
            ],
            "page_url": "https://thegradientpub.substack.com/p/ryan-tibshirani-regression-conformal-prediction",
            "audio_url": "https://api.substack.com/feed/podcast/143790442/7f77dfaa802c82eadad0522cf5eceb02.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:143588652",
            "index": 29,
            "title": "Sasha Luccioni: Connecting the Dots Between AI's Environmental and Social Impacts",
            "pub_date": "2024-04-18T15:30:00.000Z",
            "duration": "3787",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "data center",
              "inference",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/sasha-luccioni-ai-climate-change-bias-ethics",
            "audio_url": "https://api.substack.com/feed/podcast/143588652/587380c959db74b31eccca07d2c9d5ba.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:143113827",
            "index": 30,
            "title": "Michael Sipser: Problems in the Theory of Computation",
            "pub_date": "2024-04-11T15:30:00.000Z",
            "duration": "5301",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://thegradientpub.substack.com/p/michael-sipser-theory-of-computation",
            "audio_url": "https://api.substack.com/feed/podcast/143113827/e34532894252aaced8da82ae4bc8adb8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:142678686",
            "index": 31,
            "title": "Andrew Lee: How AI will Shape the Future of Email",
            "pub_date": "2024-04-04T15:30:00.000Z",
            "duration": "3820",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/andrew-lee-how-shortwave-ai-email",
            "audio_url": "https://api.substack.com/feed/podcast/142678686/c563a8e8df0c2671d8223fbeda724e86.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:142410517",
            "index": 32,
            "title": "Joss Fong: Videomaking, AI, and Science Communication",
            "pub_date": "2024-03-28T15:30:00.000Z",
            "duration": "5039",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/joss-fong-videomaking-ai-science-communication",
            "audio_url": "https://api.substack.com/feed/podcast/142410517/6135161f295950002fa510e6752bc7e5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:142376948",
            "index": 33,
            "title": "Kate Park: Data Engines for Vision and Language",
            "pub_date": "2024-03-21T15:30:00.000Z",
            "duration": "2494",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/kate-park-data-engines-vision-language-scale",
            "audio_url": "https://api.substack.com/feed/podcast/142376948/02491bb7d19d4aab55d3a7c86e4ff227.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:142376947",
            "index": 34,
            "title": "Ben Wellington: ML for Finance and Storytelling through Data",
            "pub_date": "2024-03-14T15:30:00.000Z",
            "duration": "4060",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/ben-wellington-ml-for-finance-and",
            "audio_url": "https://api.substack.com/feed/podcast/142376947/c076ace68ef175c5731b15b2dd21eeed.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:142159369",
            "index": 35,
            "title": "Venkatesh Rao: Protocols, Intelligence, and Scaling",
            "pub_date": "2024-03-07T16:30:00.000Z",
            "duration": "8315",
            "duration_label": "2h 18m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "training",
              "robotics"
            ],
            "page_url": "https://thegradientpub.substack.com/p/venkatesh-rao-protocols-intelligence-scaling",
            "audio_url": "https://api.substack.com/feed/podcast/142159369/54029a2379cc6a0f5dbeab400ed0a27d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:139032026",
            "index": 36,
            "title": "Sasha Rush: Building Better NLP Systems",
            "pub_date": "2024-02-29T16:30:00.000Z",
            "duration": "3243",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "inference",
              "training",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/sasha-rush-nlp-systems-architectures-efficiency",
            "audio_url": "https://api.substack.com/feed/podcast/139032026/522f6653a2b1d08f4df1e2c93c58befc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:140569294",
            "index": 37,
            "title": "Cameron Jones & Sean Trott: Understanding, Grounding, and Reference in LLMs",
            "pub_date": "2024-02-22T16:30:00.000Z",
            "duration": "7166",
            "duration_label": "1h 59m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "llm",
              "inference",
              "multimodal"
            ],
            "page_url": "https://thegradientpub.substack.com/p/cameron-jones-sean-trott-llms-meaning-grounding",
            "audio_url": "https://api.substack.com/feed/podcast/140569294/56836cbbb8f756675f28028206bca115.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:141480057",
            "index": 38,
            "title": "Nicholas Thompson: AI and Journalism",
            "pub_date": "2024-02-15T16:30:00.000Z",
            "duration": "3583",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/nicholas-thompson-ai-journalism-atlantic-running",
            "audio_url": "https://api.substack.com/feed/podcast/141480057/bf86688d34739a5fec9f7880dc6601f8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:139032038",
            "index": 39,
            "title": "Subbarao Kambhampati: Planning, Reasoning, and Interpretability in the Age of LLMs",
            "pub_date": "2024-02-08T16:30:00.000Z",
            "duration": "7143",
            "duration_label": "1h 59m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "reasoning",
              "retrieval"
            ],
            "page_url": "https://thegradientpub.substack.com/p/subbarao-kambhampati-planning-reasoning-llms",
            "audio_url": "https://api.substack.com/feed/podcast/139032038/d26803cc4a5b5f3f54c740f39272f148.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:141181855",
            "index": 40,
            "title": "Russ Maschmeyer: Spatial Commerce and AI in Retail",
            "pub_date": "2024-02-01T16:30:00.000Z",
            "duration": "3341",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/russ-maschmeyer-spatial-commerce-ai-retail",
            "audio_url": "https://api.substack.com/feed/podcast/141181855/4f5dba9d982c444f29dc04ecfcbb618a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:138793337",
            "index": 41,
            "title": "Benjamin Breen: The Intersecting Histories of Psychedelics and AI Research",
            "pub_date": "2024-01-25T16:30:00.000Z",
            "duration": "4065",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "automation"
            ],
            "page_url": "https://thegradientpub.substack.com/p/benjamin-breen-ai-psychedelics-history-narrative",
            "audio_url": "https://api.substack.com/feed/podcast/138793337/f7673ce202971ed9065c18c708eedb5f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:138793336",
            "index": 42,
            "title": "Ted Gibson: The Structure and Purpose of Language",
            "pub_date": "2024-01-18T16:30:00.000Z",
            "duration": "8004",
            "duration_label": "2h 13m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "llm"
            ],
            "page_url": "https://thegradientpub.substack.com/p/ted-gibson-language-structure-communication-llms",
            "audio_url": "https://api.substack.com/feed/podcast/138793336/9340763395e188725b650b77831e7a79.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:140406919",
            "index": 43,
            "title": "Harvey Lederman: Propositional Attitudes and Reference in Language Models",
            "pub_date": "2024-01-11T16:30:00.000Z",
            "duration": "7834",
            "duration_label": "2h 10m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/harvey-lederman-reference-semantics-llms",
            "audio_url": "https://api.substack.com/feed/podcast/140406919/b3f2c63918f89f028d232691f8b45484.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:139032028",
            "index": 44,
            "title": "Eric Jang: AI is Good For You",
            "pub_date": "2024-01-04T16:30:00.000Z",
            "duration": "5397",
            "duration_label": "1h 29m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "training",
              "robotics"
            ],
            "page_url": "https://thegradientpub.substack.com/p/eric-jang-ai-is-good-for-you",
            "audio_url": "https://api.substack.com/feed/podcast/139032028/43377423ede89ca3266cea12b8f5d71f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:140079864",
            "index": 45,
            "title": "2023 in AI, with Nathan Benaich",
            "pub_date": "2023-12-28T16:30:00.000Z",
            "duration": "5737",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "chatgpt",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/nathan-benaich-state-of-ai-report-2023",
            "audio_url": "https://api.substack.com/feed/podcast/140079864/270adda70d173ae2ddc625075e61b399.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:139843904",
            "index": 46,
            "title": "Kathleen Fisher: DARPA and AI for National Security",
            "pub_date": "2023-12-21T16:30:00.000Z",
            "duration": "2776",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/kathleen-fisher-darpa-ai-national-security",
            "audio_url": "https://api.substack.com/feed/podcast/139843904/df471a70755dd2a0ee4baa540abbf717.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:138793335",
            "index": 47,
            "title": "Peter Tse: The Neuroscience of Consciousness and Free Will",
            "pub_date": "2023-12-14T16:30:00.000Z",
            "duration": "8644",
            "duration_label": "2h 24m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://thegradientpub.substack.com/p/peter-tse-the-neuroscience-of-consciousness",
            "audio_url": "https://api.substack.com/feed/podcast/138793335/0bb78815357c0a409d1b6a04a114b1de.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:138793333",
            "index": 48,
            "title": "Vera Liao: AI Explainability and Transparency",
            "pub_date": "2023-12-07T16:30:00.000Z",
            "duration": "5823",
            "duration_label": "1h 37m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "xai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/vera-liao-ai-explainability-and-transparency",
            "audio_url": "https://api.substack.com/feed/podcast/138793333/91fea41e454cc25428857e79713fc454.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137815777",
            "index": 49,
            "title": "Thomas Dietterich: From the Foundations",
            "pub_date": "2023-11-30T16:30:00.000Z",
            "duration": "7317",
            "duration_label": "2h 1m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "inference",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/thomas-dietterich-from-the-foundations-ai",
            "audio_url": "https://api.substack.com/feed/podcast/137815777/1e49bb59778f942b748eb8bef0cf967e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137815813",
            "index": 50,
            "title": "Martin Wattenberg: ML Visualization and Interpretability",
            "pub_date": "2023-11-16T16:30:00.000Z",
            "duration": "6125",
            "duration_label": "1h 42m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://thegradientpub.substack.com/p/martin-wattenberg-ml-visualization",
            "audio_url": "https://api.substack.com/feed/podcast/137815813/973ac99e397d9cdd17e87ed1d46078e8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137815773",
            "index": 51,
            "title": "Laurence Liew: AI Singapore",
            "pub_date": "2023-11-09T16:30:00.000Z",
            "duration": "3028",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/laurence-liew-ai-singapore",
            "audio_url": "https://api.substack.com/feed/podcast/137815773/e6d4eca2edddc29bced8742f15bc460f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137815776",
            "index": 52,
            "title": "Michael Levin & Adam Goldstein: Intelligence and its Many Scales",
            "pub_date": "2023-11-02T15:30:00.000Z",
            "duration": "3441",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/michael-levin-adam-goldstein-intelligence-scales",
            "audio_url": "https://api.substack.com/feed/podcast/137815776/4b3d7e826f1a3daf50f8f60428a4fafe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137151903",
            "index": 53,
            "title": "Jonathan Frankle: From Lottery Tickets to LLMs",
            "pub_date": "2023-10-26T15:30:00.000Z",
            "duration": "4102",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/jonathan-frankle-lottery-tickets-llms-policy",
            "audio_url": "https://api.substack.com/feed/podcast/137151903/0fb2f9e289b0d75458f0d1b3e945cbc9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:137151901",
            "index": 54,
            "title": "Nao Tokui: \"Surfing\" Musical Creativity with AI",
            "pub_date": "2023-10-19T15:30:00.000Z",
            "duration": "3739",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/nao-tokui-ai-music-hci",
            "audio_url": "https://api.substack.com/feed/podcast/137151901/e92809c7b82d04a8ad2d25e0d58af602.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:136198397",
            "index": 55,
            "title": "Divyansh Kaushik: The Realities of AI Policy",
            "pub_date": "2023-10-12T15:30:00.000Z",
            "duration": "4664",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/divyansh-kaushik-ai-policy",
            "audio_url": "https://api.substack.com/feed/podcast/136198397/0e3fd8e2b5c1eb40268ed89efe14357c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:136198391",
            "index": 56,
            "title": "Tal Linzen: Psycholinguistics and Language Modeling",
            "pub_date": "2023-10-05T15:30:00.000Z",
            "duration": "4490",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/tal-linzen-psycholinguistics-language-modeling",
            "audio_url": "https://api.substack.com/feed/podcast/136198391/9da7d294e2628abc4fdbc58e76d2b511.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:136198386",
            "index": 57,
            "title": "Kevin K. Yang: Engineering Proteins with ML",
            "pub_date": "2023-09-28T15:30:00.000Z",
            "duration": "3600",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "nvidia",
              "training",
              "embeddings",
              "multimodal"
            ],
            "page_url": "https://thegradientpub.substack.com/p/kevin-yang-protein-engineering-machine-learning",
            "audio_url": "https://api.substack.com/feed/podcast/136198386/53deb74230c867848958ca7530ddae8e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:136702570",
            "index": 58,
            "title": "Arjun Ramani & Zhengdong Wang: Why Transformative AI is Really, Really Hard to Achieve",
            "pub_date": "2023-09-21T15:30:00.000Z",
            "duration": "6573",
            "duration_label": "1h 49m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "chatgpt",
              "openai",
              "deepmind",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/arjun-ramani-zhengdong-wang-transformative-ai",
            "audio_url": "https://api.substack.com/feed/podcast/136702570/4ee504eaff6f436ea8747f0da29e2a77.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:135386791",
            "index": 59,
            "title": "Miles Grimshaw: Benchmark, LangChain, and Investing in AI",
            "pub_date": "2023-09-14T15:30:00.000Z",
            "duration": "3647",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/miles-grimshaw-benchmark-langchain-ai-investing",
            "audio_url": "https://api.substack.com/feed/podcast/135386791/62d26e7fedbb9e6133a38833d43bfd20.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:135386790",
            "index": 60,
            "title": "Shreya Shankar: Machine Learning in the Real World",
            "pub_date": "2023-09-07T15:30:00.000Z",
            "duration": "4596",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://thegradientpub.substack.com/p/shreya-shankar-mlops-ml-engineering",
            "audio_url": "https://api.substack.com/feed/podcast/135386790/647dde332543ecad8b9614da0975593a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:133721549",
            "index": 61,
            "title": "Stevan Harnad: AI's Symbol Grounding Problem",
            "pub_date": "2023-08-31T15:30:00.000Z",
            "duration": "7101",
            "duration_label": "1h 58m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "https://thegradientpub.substack.com/p/stevan-harnad-symbol-grounding-ai-cognition",
            "audio_url": "https://api.substack.com/feed/podcast/133721549/e51c7b333048a955651183cd9d0032dc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:133721540",
            "index": 62,
            "title": "Terry Winograd: AI, HCI, Language, and Cognition",
            "pub_date": "2023-08-24T15:30:00.000Z",
            "duration": "5601",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/terry-winograd-ai-hci-language-cognition",
            "audio_url": "https://api.substack.com/feed/podcast/133721540/f23a72a32562b0f078c3a2226324f86e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:133721495",
            "index": 63,
            "title": "Gil Strang: Linear Algebra and Deep Learning",
            "pub_date": "2023-08-17T15:30:00.000Z",
            "duration": "3636",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/gil-strang-linear-algebra-deep-learning",
            "audio_url": "https://api.substack.com/feed/podcast/133721495/0bb284f286a48db471ddadda1505123f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:135899719",
            "index": 64,
            "title": "Anant Agarwal: AI for Education",
            "pub_date": "2023-08-10T16:55:31.000Z",
            "duration": "2860",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt"
            ],
            "page_url": "https://thegradientpub.substack.com/p/anant-agarwal-ai-for-education",
            "audio_url": "https://api.substack.com/feed/podcast/135899719/b1db07b685d4a8e831f91115e0927975.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:127641859",
            "index": 65,
            "title": "Raphaël Millière: The Vector Grounding Problem and Self-Consciousness",
            "pub_date": "2023-08-04T19:30:24.000Z",
            "duration": "7492",
            "duration_label": "2h 4m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://thegradientpub.substack.com/p/raphael-milliere-vector-grounding-consciousness",
            "audio_url": "https://api.substack.com/feed/podcast/127641859/d1d4a52974ad948f47ac7e23fca41034.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:127641955",
            "index": 66,
            "title": "Peli Grietzer: A Mathematized Philosophy of Literature",
            "pub_date": "2023-07-27T15:30:00.000Z",
            "duration": "9213",
            "duration_label": "2h 33m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/peli-grietzer-a-mathematized-philosophy",
            "audio_url": "https://api.substack.com/feed/podcast/127641955/23f5fc762d3c87ddea03f3a039b08603.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:128851773",
            "index": 67,
            "title": "Ryan Drapeau: Battling Fraud with ML at Stripe",
            "pub_date": "2023-07-20T15:30:00.000Z",
            "duration": "3991",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/ryan-drapeau-battling-fraud-with",
            "audio_url": "https://api.substack.com/feed/podcast/128851773/03e219d0a9e7fae421e6a5bbbd1e4825.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:121633732",
            "index": 68,
            "title": "Shiv Rao: Enabling Better Patient Care with AI",
            "pub_date": "2023-07-13T15:30:00.000Z",
            "duration": "3651",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/shiv-rao-enabling-better-patient",
            "audio_url": "https://api.substack.com/feed/podcast/121633732/516ed23a06f1b8d94a527f2b854fb5b6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:121633718",
            "index": 69,
            "title": "Hugo Larochelle: Deep Learning as Science",
            "pub_date": "2023-07-06T15:30:00.000Z",
            "duration": "6508",
            "duration_label": "1h 48m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/hugo-larochelle-deep-learning",
            "audio_url": "https://api.substack.com/feed/podcast/121633718/32c6b7a336b70f360a4cb2a0292fc40a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:121464022",
            "index": 70,
            "title": "Jeremie Harris: Realistic Alignment and AI Policy",
            "pub_date": "2023-06-29T15:30:00.000Z",
            "duration": "5435",
            "duration_label": "1h 30m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "alignment"
            ],
            "page_url": "https://thegradientpub.substack.com/p/jeremie-harris-realistic-alignment",
            "audio_url": "https://api.substack.com/feed/podcast/121464022/9298b455a4a623de5d97575dd4894ed4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:121464031",
            "index": 71,
            "title": "Antoine Blondeau: Alpha Intelligence Capital and Investing in AI",
            "pub_date": "2023-06-22T15:30:00.000Z",
            "duration": "3574",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/antoine-blondeau-alpha-intelligence",
            "audio_url": "https://api.substack.com/feed/podcast/121464031/042928ee9e86926321792caa73343b4f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:119526170",
            "index": 72,
            "title": "Joon Park: Generative Agents and Human-Computer Interaction",
            "pub_date": "2023-06-15T15:30:00.000Z",
            "duration": "8485",
            "duration_label": "2h 21m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "alignment",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/joon-park-generative-agents-and-human",
            "audio_url": "https://api.substack.com/feed/podcast/119526170/e7c66ca1f5513bff2035722908548628.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:126923811",
            "index": 73,
            "title": "Christoffer Holmgård: AI for Video Games",
            "pub_date": "2023-06-08T17:24:24.000Z",
            "duration": "4146",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/christoffer-holmgard-ai-for-video",
            "audio_url": "https://api.substack.com/feed/podcast/126923811/97e50bbbe4b21f39faaa294fceda4a2a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:116392067",
            "index": 74,
            "title": "Riley Goodside: The Art and Craft of Prompt Engineering",
            "pub_date": "2023-06-01T15:30:00.000Z",
            "duration": "3582",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/riley-goodside-the-art-and-craft",
            "audio_url": "https://api.substack.com/feed/podcast/116392067/6e1d7c5a7662362e1e92c11f2150c9f4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:117229865",
            "index": 75,
            "title": "Talia Ringer: Formal Verification and Deep Learning",
            "pub_date": "2023-05-25T15:30:00.000Z",
            "duration": "6335",
            "duration_label": "1h 45m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "reasoning",
              "safety",
              "automation"
            ],
            "page_url": "https://thegradientpub.substack.com/p/talia-ringer-formal-verification",
            "audio_url": "https://api.substack.com/feed/podcast/117229865/4422297949a88ca7d6d3d91faf9ae251.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:113190707",
            "index": 76,
            "title": "Brigham Hyde: AI for Clinical Decision-Making",
            "pub_date": "2023-05-18T15:30:00.000Z",
            "duration": "2503",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/brigham-hyde-ai-for-clinical-decision",
            "audio_url": "https://api.substack.com/feed/podcast/113190707/88989d862fa118208e945c7a804ca5fb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:113749116",
            "index": 77,
            "title": "Scott Aaronson: Against AI Doomerism",
            "pub_date": "2023-05-11T15:30:00.000Z",
            "duration": "4172",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "alignment",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/scott-aaronson-against-ai-doomerism",
            "audio_url": "https://api.substack.com/feed/podcast/113749116/2117c5bb3624f817d1cd55c0e284dadd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:111302477",
            "index": 78,
            "title": "Ted Underwood: Machine Learning and the Literary Imagination",
            "pub_date": "2023-05-04T15:15:00.000Z",
            "duration": "6239",
            "duration_label": "1h 43m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/ted-underwood-machine-learning-and",
            "audio_url": "https://api.substack.com/feed/podcast/111302477/fff3f237c3418a60d1083c7c2d9b1d78.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:111151755",
            "index": 79,
            "title": "Irene Solaiman: AI Policy and Social Impact",
            "pub_date": "2023-04-27T15:30:00.000Z",
            "duration": "4331",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "generative ai",
              "openai",
              "anthropic",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/irene-solaiman-ai-policy-and-social",
            "audio_url": "https://api.substack.com/feed/podcast/111151755/9c53ef0177be94c0f646cf93cc978369.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:110104175",
            "index": 80,
            "title": "Drago Anguelov: Waymo and Autonomous Vehicles",
            "pub_date": "2023-04-20T15:30:00.000Z",
            "duration": "3923",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://thegradientpub.substack.com/p/drago-anguelov-waymo-and-autonomous",
            "audio_url": "https://api.substack.com/feed/podcast/110104175/468aec7d51a2e728763753f9818016c8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:108441187",
            "index": 81,
            "title": "Joanna Bryson: The Problems of Cognition",
            "pub_date": "2023-04-13T15:30:00.000Z",
            "duration": "4385",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "agent",
              "agents",
              "inference"
            ],
            "page_url": "https://thegradientpub.substack.com/p/joanna-bryson-the-problems-of-cognition",
            "audio_url": "https://api.substack.com/feed/podcast/108441187/1ca334da4116c694c54a9a1e08da8b31.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:107095720",
            "index": 82,
            "title": "Daniel Situnayake: AI on the Edge",
            "pub_date": "2023-04-06T15:30:00.000Z",
            "duration": "7087",
            "duration_label": "1h 58m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "google ai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/daniel-situnayake-ai-on-the-edge",
            "audio_url": "https://api.substack.com/feed/podcast/107095720/51570382b44cef399829d608e3d34733.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:107095723",
            "index": 83,
            "title": "Soumith Chintala: PyTorch",
            "pub_date": "2023-03-30T15:51:04.000Z",
            "duration": "4100",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai",
              "robotics"
            ],
            "page_url": "https://thegradientpub.substack.com/p/soumith-chintala-pytorch",
            "audio_url": "https://api.substack.com/feed/podcast/107095723/0d613dbae2ee8869d0c45ef1cfb6ac97.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:107045593",
            "index": 84,
            "title": "Sewon Min: The Science of Natural Language",
            "pub_date": "2023-03-23T16:30:00.000Z",
            "duration": "6164",
            "duration_label": "1h 42m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai",
              "inference",
              "training",
              "reasoning",
              "retrieval"
            ],
            "page_url": "https://thegradientpub.substack.com/p/sewon-min-the-science-of-natural",
            "audio_url": "https://api.substack.com/feed/podcast/107045593/db8e891acfc45b373643913aad80c32c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:104955812",
            "index": 85,
            "title": "Richard Socher: Re-Imagining Search",
            "pub_date": "2023-03-16T16:30:00.000Z",
            "duration": "5869",
            "duration_label": "1h 37m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://thegradientpub.substack.com/p/richard-socher-re-imagining-search",
            "audio_url": "https://api.substack.com/feed/podcast/104955812/71d271e50be04d2b73d47fc1c89fe471.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:104900805",
            "index": 86,
            "title": "Joe Edelman: Meaning-Aligned AI",
            "pub_date": "2023-03-09T16:30:00.000Z",
            "duration": "3983",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/joe-edelman-meaning-aligned-ai",
            "audio_url": "https://api.substack.com/feed/podcast/104900805/b1cf23a5efc4f7e4d04f79d8619eaede.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:104574543",
            "index": 87,
            "title": "Ed Grefenstette: Language, Semantics, Cohere",
            "pub_date": "2023-03-02T16:30:00.000Z",
            "duration": "4456",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "deepmind",
              "training",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/ed-grefenstette-language-semantics",
            "audio_url": "https://api.substack.com/feed/podcast/104574543/d279338b71e9b9115a6a47581dd141d2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:99907397",
            "index": 88,
            "title": "Ken Liu: What Science Fiction Can Teach Us",
            "pub_date": "2023-02-23T16:30:00.000Z",
            "duration": "7360",
            "duration_label": "2h 2m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/ken-liu",
            "audio_url": "https://api.substack.com/feed/podcast/99907397/e48908172081612dcb9d10efa60749ae.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:99907787",
            "index": 89,
            "title": "Hattie Zhou: Lottery Tickets and Algorithmic Reasoning in LLMs",
            "pub_date": "2023-02-16T16:30:00.000Z",
            "duration": "6179",
            "duration_label": "1h 42m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/hattie-zhou-lottery-tickets-and-algorithmic",
            "audio_url": "https://api.substack.com/feed/podcast/99907787/67cb2508c5a97e714ef55212f476bd43.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:92178018",
            "index": 90,
            "title": "Kyunghyun Cho: Neural Machine Translation, Language, and Doing Good Science",
            "pub_date": "2023-02-09T16:30:00.000Z",
            "duration": "7682",
            "duration_label": "2h 8m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/kyunghyun-cho-neural-machine-translation",
            "audio_url": "https://api.substack.com/feed/podcast/92178018/0ed0818e73cf0ce3d9e8af0508b0dfe3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:92178016",
            "index": 91,
            "title": "Steve Miller: Will AI Take Your Job? It's Not So Simple.",
            "pub_date": "2023-02-02T16:30:00.000Z",
            "duration": "4225",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://thegradientpub.substack.com/p/steve-miller-will-ai-take-your-job",
            "audio_url": "https://api.substack.com/feed/podcast/92178016/24b91e07cc1a38e5b8c500ec2d5080f0.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:99125547",
            "index": 92,
            "title": "Blair Attard-Frost: Canada’s AI strategy and the ethics of AI business practices",
            "pub_date": "2023-01-26T16:14:11.000Z",
            "duration": "3502",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://thegradientpub.substack.com/p/blair-attard-frost-canadas-ai-strategy",
            "audio_url": "https://api.substack.com/feed/podcast/99125547/5cf45b00e2c58b2e69b6412e0a8eaa1b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:87607153",
            "index": 93,
            "title": "Linus Lee: At the Boundary of Machine and Mind",
            "pub_date": "2023-01-19T16:30:00.000Z",
            "duration": "8926",
            "duration_label": "2h 28m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "replit"
            ],
            "page_url": "https://thegradientpub.substack.com/p/linus-lee-at-the-boundary-of-machine",
            "audio_url": "https://api.substack.com/feed/podcast/87607153/6f0ff7e105f02f83a0cf44e7d4532499.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:86622995",
            "index": 94,
            "title": "Suresh Venkatasubramanian: An AI Bill of Rights",
            "pub_date": "2023-01-12T16:30:00.000Z",
            "duration": "6058",
            "duration_label": "1h 40m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/suresh-venkatasubramanian-an-ai-bill",
            "audio_url": "https://api.substack.com/feed/podcast/86622995/56fecb2d2ca9d7b6a412e3ade8f27448.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:92285127",
            "index": 95,
            "title": "Pete Florence: Dense Visual Representations, NeRFs, and LLMs for Robotics",
            "pub_date": "2023-01-05T17:00:00.000Z",
            "duration": "4524",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning",
              "multimodal",
              "robotics"
            ],
            "page_url": "https://thegradientpub.substack.com/p/pete-florence-dense-visual-representations",
            "audio_url": "https://api.substack.com/feed/podcast/92285127/b45d1c2b0763d98e297b0797536529b5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:85444012",
            "index": 96,
            "title": "Melanie Mitchell: Abstraction and Analogy in AI",
            "pub_date": "2022-12-15T17:42:43.000Z",
            "duration": "3287",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/melanie-mitchell-abstraction-and",
            "audio_url": "https://api.substack.com/feed/podcast/85444012/3bb8f0e5e8b721d18c65dbe203793afb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:83788038",
            "index": 97,
            "title": "Marc Bellemare: Distributional Reinforcement Learning",
            "pub_date": "2022-12-08T16:30:00.000Z",
            "duration": "4342",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "deepmind"
            ],
            "page_url": "https://thegradientpub.substack.com/p/marc-bellemare-distributional-reinforcement",
            "audio_url": "https://api.substack.com/feed/podcast/83788038/946790f96d23179b6376b2499796f79e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:83327277",
            "index": 98,
            "title": "François Chollet: Keras and Measures of Intelligence",
            "pub_date": "2022-12-01T15:30:00.000Z",
            "duration": "5330",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/francois-chollet-keras-and-measures",
            "audio_url": "https://api.substack.com/feed/podcast/83327277/551ac0444456bd5dba8cea9464377b93.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:74034736",
            "index": 99,
            "title": "Yoshua Bengio: The Past, Present, and Future of Deep Learning",
            "pub_date": "2022-11-21T16:30:00.000Z",
            "duration": "4449",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embeddings"
            ],
            "page_url": "https://thegradientpub.substack.com/p/yoshua-bengio",
            "audio_url": "https://api.substack.com/feed/podcast/74034736/6e8b2c18a060dc8c2095328ec227b487.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:83327279",
            "index": 100,
            "title": "Kanjun Qiu and Josh Albrecht: Generally Intelligent",
            "pub_date": "2022-11-17T16:30:00.000Z",
            "duration": "2841",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "safety",
              "ai startup"
            ],
            "page_url": "https://thegradientpub.substack.com/p/kanjun-qiu-and-josh-albrecht-generally",
            "audio_url": "https://api.substack.com/feed/podcast/83327279/e0fa55f3bbb5937b936ceb8562bcbaa8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:81965425",
            "index": 101,
            "title": "Nathan Benaich: The State of AI Report",
            "pub_date": "2022-11-10T16:13:02.000Z",
            "duration": "4731",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "anthropic",
              "alignment",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/nathan-benaich-the-state-of-ai-report",
            "audio_url": "https://api.substack.com/feed/podcast/81965425/660b6b3b957e54297c0dc25fc8394825.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:80810814",
            "index": 102,
            "title": "Matt Sheehan: China's AI Strategy and Governance",
            "pub_date": "2022-11-03T15:30:00.000Z",
            "duration": "3990",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "chips"
            ],
            "page_url": "https://thegradientpub.substack.com/p/matt-sheehan-chinas-ai-strategy-and",
            "audio_url": "https://api.substack.com/feed/podcast/80810814/c871bd6cedea6ce123ef12ba58f425a2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:77433145",
            "index": 103,
            "title": "Luis Voloch: AI and Biology",
            "pub_date": "2022-10-27T15:30:00.000Z",
            "duration": "2636",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/luis-voloch-ai-and-biology",
            "audio_url": "https://api.substack.com/feed/podcast/77433145/ce00d544d68f20add1a3cd8fcdbebeb4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:75980594",
            "index": 104,
            "title": "Zachary Lipton: Where Machine Learning Falls Short",
            "pub_date": "2022-10-13T15:30:00.000Z",
            "duration": "6058",
            "duration_label": "1h 40m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/zachary-lipton-where-machine-learning",
            "audio_url": "https://api.substack.com/feed/podcast/75980594/62419e6d4033145bfffc20ed72befb33.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:71586689",
            "index": 105,
            "title": "Stuart Russell: The Foundations of Artificial Intelligence",
            "pub_date": "2022-10-06T15:30:00.000Z",
            "duration": "4247",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "robotics"
            ],
            "page_url": "https://thegradientpub.substack.com/p/stuart-russell-the-foundations-of",
            "audio_url": "https://api.substack.com/feed/podcast/71586689/ed699c8023a2e0ae233dedfe236be7bc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:75312530",
            "index": 106,
            "title": "Varun Ganapathi: AKASA, AI and Healthcare",
            "pub_date": "2022-09-29T15:30:00.000Z",
            "duration": "3071",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://thegradientpub.substack.com/p/varun-ganapathi-akasa-ai-and-healthcare",
            "audio_url": "https://api.substack.com/feed/podcast/75312530/d7280c20fb8350b1afeeb485bb681012.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:70538872",
            "index": 107,
            "title": "Joel Lehman: Open-Endedness and Evolution through Large Models",
            "pub_date": "2022-09-22T15:30:00.000Z",
            "duration": "5933",
            "duration_label": "1h 38m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "training",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/joel-lehman-open-endedness-and-evolution",
            "audio_url": "https://api.substack.com/feed/podcast/70538872/1069edee0177a2bffd86b5c9e3d8d2ba.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:72132838",
            "index": 108,
            "title": "Andrew Feldman: Cerebras and AI Hardware",
            "pub_date": "2022-09-15T15:30:00.000Z",
            "duration": "3407",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chips",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/andrew-feldman-cerebras-and-ai-hardware",
            "audio_url": "https://api.substack.com/feed/podcast/72132838/94622a16d2c6365bad02d2a851ec22a4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:69315110",
            "index": 109,
            "title": "Christopher Manning: Linguistics and the Development of NLP",
            "pub_date": "2022-09-08T15:30:00.000Z",
            "duration": "4295",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "inference",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/christopher-manning-linguistics-and",
            "audio_url": "https://api.substack.com/feed/podcast/69315110/014f4c9b6362120e92b014231aa63429.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:71270938",
            "index": 110,
            "title": "Jeff Clune: Genetic Algorithms, Quality-Diversity, Curiosity",
            "pub_date": "2022-09-01T19:10:10.000Z",
            "duration": "4121",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/jeff-clune-genetic-algorithms-quality",
            "audio_url": "https://api.substack.com/feed/podcast/71270938/eed9455cad10ecc58effb8a178b071b8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:70420916",
            "index": 111,
            "title": "Catherine Olsson and Nelson Elhage: Anthropic, Understanding Transformers",
            "pub_date": "2022-08-26T16:00:00.000Z",
            "duration": "2824",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/catherine-olsson-and-nelson-elhage",
            "audio_url": "https://api.substack.com/feed/podcast/70420916/9b7e257711d3986dab03dd296add7771.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:68553829",
            "index": 112,
            "title": "Been Kim: Interpretable Machine Learning",
            "pub_date": "2022-08-18T16:00:00.000Z",
            "duration": "4292",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://thegradientpub.substack.com/p/been-kim-interpretable-machine-learning",
            "audio_url": "https://api.substack.com/feed/podcast/68553829/b93add20154638c6ad408ca65fd30a1c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:67344843",
            "index": 113,
            "title": "Laura Weidinger: Ethical Risks, Harms, and Alignment of Large Language Models",
            "pub_date": "2022-08-05T19:31:00.000Z",
            "duration": "3341",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "deepmind",
              "alignment"
            ],
            "page_url": "https://thegradientpub.substack.com/p/laura-weidinger-on-ethical-risks",
            "audio_url": "https://api.substack.com/feed/podcast/67344843/285bb036575981c604f8460d26c91674.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:64970914",
            "index": 114,
            "title": "Sebastian Raschka: AI Education and Research",
            "pub_date": "2022-07-29T16:00:00.000Z",
            "duration": "3812",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/sebastian-raschka-ai-education-and",
            "audio_url": "https://api.substack.com/feed/podcast/64970914/f8d80e25d4f103bdc629d62824931f71.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:65225803",
            "index": 115,
            "title": "Lt. General Jack Shanahan: AI in the DoD, Project Maven, and Bridging the Tech-DoD Gap",
            "pub_date": "2022-07-22T17:00:00.000Z",
            "duration": "1860",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://thegradientpub.substack.com/p/lt-general-jack-shanahan-ai-in-the",
            "audio_url": "https://api.substack.com/feed/podcast/65225803/a8f2c86e6143256c8fcdd3ead94c9c12.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:62381093",
            "index": 116,
            "title": "Sara Hooker: Cohere For AI, the Hardware Lottery, and DL Tradeoffs",
            "pub_date": "2022-07-14T16:00:00.000Z",
            "duration": "3175",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/sara-hooker-cohere-for-ai-the-hardware",
            "audio_url": "https://api.substack.com/feed/podcast/62381093/3a3c564f2158991d9615d6939118edcf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:63009934",
            "index": 117,
            "title": "Lukas Biewald: Crowdsourcing at CrowdFlower and ML Tooling at Weights & Biases",
            "pub_date": "2022-07-07T18:13:15.000Z",
            "duration": "2804",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/lukas-biewald-crowdsourcing-at-crowdflower",
            "audio_url": "https://api.substack.com/feed/podcast/63009934/2c7da602a3d436ea43717cc48eed7fc8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:61921012",
            "index": 118,
            "title": "Chip Huyen: Machine Learning Tools and Systems",
            "pub_date": "2022-06-30T18:17:42.000Z",
            "duration": "2907",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip"
            ],
            "page_url": "https://thegradientpub.substack.com/p/chip-huyen-machine-learning-tools",
            "audio_url": "https://api.substack.com/feed/podcast/61921012/5e4ffb7eb64659a711f33b1ba1b9d981.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:60198855",
            "index": 119,
            "title": "Preetum Nakkiran: An Empirical Theory of Deep Learning",
            "pub_date": "2022-06-24T16:00:00.000Z",
            "duration": "5849",
            "duration_label": "1h 37m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/preetum-nakkiran-an-empirical-theory",
            "audio_url": "https://api.substack.com/feed/podcast/60198855/e73d7176976ee4e8102e0444fade4b68.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:56851092",
            "index": 120,
            "title": "Max Woolf: Data Science at BuzzFeed and AI Content Generation",
            "pub_date": "2022-06-16T16:00:00.000Z",
            "duration": "2903",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://thegradientpub.substack.com/p/max-woolf-data-science-at-buzzfeed",
            "audio_url": "https://api.substack.com/feed/podcast/56851092/8243861e1bfc2f2d31a473a4597de3ef.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:58835687",
            "index": 121,
            "title": "Rosanne Liu: Paths in AI Research and ML Collective",
            "pub_date": "2022-06-10T17:00:00.000Z",
            "duration": "4508",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://thegradientpub.substack.com/p/rosanne-liu-paths-in-ai-research",
            "audio_url": "https://api.substack.com/feed/podcast/58835687/b35a4b46648dc68a51abb71d236d162a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:56850246",
            "index": 122,
            "title": "Ben Green: \"Tech for Social Good\" Needs to Do More",
            "pub_date": "2022-06-02T16:00:00.000Z",
            "duration": "3190",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://thegradientpub.substack.com/p/ben-green-thinking-beyond-algorithms",
            "audio_url": "https://api.substack.com/feed/podcast/56850246/80e28cceb984900e53e3b891959a05d9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:56672334",
            "index": 123,
            "title": "Max Braun: Teaching Robots to Help People in their Everyday Lives",
            "pub_date": "2022-05-26T17:16:41.000Z",
            "duration": "4971",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://thegradientpub.substack.com/p/max-braun-teaching-robots-to-help",
            "audio_url": "https://api.substack.com/feed/podcast/56672334/c7cb833e55c5aa605fb7f9692d959c34.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:55253702",
            "index": 124,
            "title": "Yejin Choi: Teaching Machines Common Sense and Morality",
            "pub_date": "2022-05-19T16:00:00.000Z",
            "duration": "4584",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/yejin-choi-teaching-machines-common",
            "audio_url": "https://api.substack.com/feed/podcast/55253702/59984f5b5094899d545039a0585b7d1a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:53168058",
            "index": 125,
            "title": "David Chalmers on AI and Consciousness",
            "pub_date": "2022-05-12T16:00:00.000Z",
            "duration": "3129",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/david-chalmers-on-ai-and-consciousness",
            "audio_url": "https://api.substack.com/feed/podcast/53168058/ee2ece0408b24da63a99e7b856fcfb2d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:53007553",
            "index": 126,
            "title": "Greg Yang on Communicating Research, Tensor Programs, and µTransfer",
            "pub_date": "2022-04-28T16:00:00.000Z",
            "duration": "3950",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/greg-yang-on-communicating-research",
            "audio_url": "https://api.substack.com/feed/podcast/53007553/e5f7785f0b0a865edb72cf304831ab31.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:50979145",
            "index": 127,
            "title": "Nick Walton on AI Dungeon and the Future of AI in Games",
            "pub_date": "2022-03-24T20:27:28.000Z",
            "duration": "3757",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/nick-walton-on-ai-dungeon-and-the",
            "audio_url": "https://api.substack.com/feed/podcast/50979145/8be97b172f69272167411601c387690d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:48171839",
            "index": 128,
            "title": "Connor Leahy on EleutherAI, Replicating GPT-2/GPT-3, AI Risk and Alignment",
            "pub_date": "2022-02-03T18:41:48.000Z",
            "duration": "",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "openai",
              "alignment",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/connor-leahy-on-eleutherai-replicating",
            "audio_url": "https://api.substack.com/feed/podcast/48171839/2c495bcc51d5ae4bb8904730ab5b8cc2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:47820803",
            "index": 129,
            "title": "Percy Liang on Machine Learning Robustness, Foundation Models, and Reproducibility",
            "pub_date": "2022-01-27T22:45:17.000Z",
            "duration": "3054",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "training",
              "reasoning"
            ],
            "page_url": "https://thegradientpub.substack.com/p/percy-liang-on-machine-learning-robustness",
            "audio_url": "https://api.substack.com/feed/podcast/47820803/40a513e98ef5542d9774215e86c84c0b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:46808550",
            "index": 130,
            "title": "Eric Jang on Robots Learning at Google and Generalization via Language",
            "pub_date": "2022-01-08T17:18:40.000Z",
            "duration": "5599",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://thegradientpub.substack.com/p/eric-jang-on-robots-learning-at-google",
            "audio_url": "https://api.substack.com/feed/podcast/46808550/e11125f95401c39dcfb041de24ea23c9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:45237959",
            "index": 131,
            "title": "Rishi Bommasani on Foundation Models",
            "pub_date": "2021-12-09T16:52:27.000Z",
            "duration": "5631",
            "duration_label": "1h 33m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embeddings"
            ],
            "page_url": "https://thegradientpub.substack.com/p/rishi-bommasani-on-foundation-models",
            "audio_url": "https://api.substack.com/feed/podcast/45237959/47e5cab171832f7504f4eedc0b3c82b1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:44953841",
            "index": 132,
            "title": "Upol Ehsan on Human-Centered Explainable AI and Social Transparency",
            "pub_date": "2021-12-03T17:00:17.000Z",
            "duration": "5716",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/upol-ehsan-on-human-centered-explainable",
            "audio_url": "https://api.substack.com/feed/podcast/44953841/37be55068be291d325bdad6066c35c58.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:44445878",
            "index": 133,
            "title": "Miles Brundage on AI Misuse and Trustworthy AI",
            "pub_date": "2021-11-23T16:00:42.000Z",
            "duration": "3243",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai"
            ],
            "page_url": "https://thegradientpub.substack.com/p/miles-brundage-on-ai-misuse-and-trustworthy",
            "audio_url": "https://api.substack.com/feed/podcast/44445878/735a4ce3a190c4d1f7a68fbbb1493d46.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:44254341",
            "index": 134,
            "title": "Jeffrey Ding on China's AI Dream, the AI 'Arms Race', and AI as a General Purpose Technology",
            "pub_date": "2021-11-18T20:04:35.000Z",
            "duration": "4264",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://thegradientpub.substack.com/p/jeffrey-ding-on-chinas-ai-dream-the",
            "audio_url": "https://api.substack.com/feed/podcast/44254341/2b706c2f4eeba8c7bd9e0412c305d00e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:43916476",
            "index": 135,
            "title": "Alex Tamkin on Self-Supervised Learning and Large Language Models",
            "pub_date": "2021-11-11T22:31:27.000Z",
            "duration": "4241",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "multimodal"
            ],
            "page_url": "https://thegradientpub.substack.com/p/alex-tamkin-on-self-supervised-learning",
            "audio_url": "https://api.substack.com/feed/podcast/43916476/629486bd91006ea94afe979eb07a4885.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:43238945",
            "index": 136,
            "title": "Peter Henderson on RL Benchmarking, Climate Impacts of AI, and AI for Law",
            "pub_date": "2021-10-28T19:14:41.000Z",
            "duration": "5322",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://thegradientpub.substack.com/p/peter-henderson-on-rl-benchmarking",
            "audio_url": "https://api.substack.com/feed/podcast/43238945/6b35d2ae1d6fd9b9d1efb40c6612a41f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:42605619",
            "index": 137,
            "title": "Chelsea Finn on Meta Learning & Model Based Reinforcement Learning",
            "pub_date": "2021-10-14T18:53:41.000Z",
            "duration": "2980",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://thegradientpub.substack.com/p/chelsea-finn-on-meta-learning-and",
            "audio_url": "https://api.substack.com/feed/podcast/42605619/edfcd86cdea9a97555b7991ec34b7ec1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:42072200",
            "index": 138,
            "title": "Devi Parikh on Generative Art & AI for Creativity",
            "pub_date": "2021-10-01T20:12:22.000Z",
            "duration": "3314",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/devi-parikh-on-generative-art-and",
            "audio_url": "https://api.substack.com/feed/podcast/42072200/46fd94eff1471dc5ca982188adfcdd2a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:41415653",
            "index": 139,
            "title": "Sergey Levine on Robot Learning & Offline RL",
            "pub_date": "2021-09-16T16:47:50.000Z",
            "duration": "3231",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "training",
              "robotics"
            ],
            "page_url": "https://thegradientpub.substack.com/p/sergey-levine-on-robot-learning-and",
            "audio_url": "https://api.substack.com/feed/podcast/41415653/4eeedc151c3404881cead28be07f2a0c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:41120217",
            "index": 140,
            "title": "Jeremy Howard on Kaggle, Enlitic, and fast.ai",
            "pub_date": "2021-09-09T17:34:37.000Z",
            "duration": "3483",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/jeremy-howard-on-kaggle-enlitic-and",
            "audio_url": "https://api.substack.com/feed/podcast/41120217/78e0973343618dcb149a7bb649e43609.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:40861929",
            "index": 141,
            "title": "Evan Hubinger on Effective Altruism and AI Safety",
            "pub_date": "2021-09-03T11:38:41.000Z",
            "duration": "4520",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "alignment",
              "safety"
            ],
            "page_url": "https://thegradientpub.substack.com/p/evan-hubinger-on-effective-altruism",
            "audio_url": "https://api.substack.com/feed/podcast/40861929/119a4436e47ed6080ce4072a4dcbd0d9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:40572160",
            "index": 142,
            "title": "Yannic Kilcher on Being an AI Researcher and Educator",
            "pub_date": "2021-08-27T19:33:27.000Z",
            "duration": "2432",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/yannic-kilcher-on-being-an-ai-researcher",
            "audio_url": "https://api.substack.com/feed/podcast/40572160/957b20d9c263d5a87c569a2899990183.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:40210754",
            "index": 143,
            "title": "Alexander Veysov on Self-Teaching AI and Creating Open Speech-To-Text",
            "pub_date": "2021-08-19T13:00:06.000Z",
            "duration": "2811",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/alexander-veysov-on-self-teaching",
            "audio_url": "https://api.substack.com/feed/podcast/40210754/c2dc8b441d541e87d0eb245c020e62b7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:39650710",
            "index": 144,
            "title": "Yann LeCun on his Start in Research and Self-Supervised Learning",
            "pub_date": "2021-08-05T16:46:14.000Z",
            "duration": "3348",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/yann-lecun-on-his-start-in-research",
            "audio_url": "https://api.substack.com/feed/podcast/39650710/a24eef6c17481e6fbb1eec0e8bf3bcde.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:39392869",
            "index": 145,
            "title": "Anna Rogers on the Flaws of Peer Review in AI",
            "pub_date": "2021-07-30T15:00:00.000Z",
            "duration": "3790",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/anna-rogers-on-the-flaws-of-peer",
            "audio_url": "https://api.substack.com/feed/podcast/39392869/acb1585736afd4741e3b89b0a9afb8dc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:38969069",
            "index": 146,
            "title": "Joel Simon on AI art and Artbreeder",
            "pub_date": "2021-07-20T15:00:13.000Z",
            "duration": "3498",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/joel-simon-on-ai-art-and-artbreeder",
            "audio_url": "https://api.substack.com/feed/podcast/38969069/0fdc34257e82f93881ba7b8821f9e611.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:38440907",
            "index": 147,
            "title": "Abubakar Abid on AI for Genomics, Gradio, and the Fatima Fellowship",
            "pub_date": "2021-07-06T16:16:45.000Z",
            "duration": "2680",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/abubakar-abid-interview",
            "audio_url": "https://api.substack.com/feed/podcast/38440907/0e1c8c7f93659c176c53bce4ca371fb5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:37780644",
            "index": 148,
            "title": "Helena Sarin on being an AI Artist",
            "pub_date": "2021-06-19T15:00:46.000Z",
            "duration": "2449",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/helena-sarin-on-being-an-ai-artist",
            "audio_url": "https://api.substack.com/feed/podcast/37780644/5efb0cccf328a8715d2dbac6e9cdd666.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "substack:post:37061390",
            "index": 149,
            "title": "Hello World from The Gradient Podcast!",
            "pub_date": "2021-06-01T17:22:22.000Z",
            "duration": "1334",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://thegradientpub.substack.com/p/hello-world-from-the-gradient-podcast",
            "audio_url": "https://api.substack.com/feed/podcast/37061390/96ffa411386e7a1530172ed8016aeed6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "training-data",
        "title": "Training Data",
        "feed_title": "Training Data",
        "priority": "P1",
        "selection_mode": "all_ai",
        "focus": [
          "AI startups",
          "venture",
          "company building"
        ],
        "feed_url": "https://feeds.megaphone.fm/trainingdata",
        "source_url": "https://feeds.megaphone.fm/trainingdata",
        "detail_path": "/podcasts/training-data/",
        "episode_count": 95,
        "selected_episode_count": 95,
        "latest_episode_title": "Knowing What Your Customers Want, All the Time: Listen Labs' Alfred Wahlforss",
        "latest_pub_date": "2026-06-02T09:00:00.000Z",
        "latest_page_url": "",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "245db97c-5de8-11f1-beb7-d7c1b176fe75",
            "index": 1,
            "title": "Knowing What Your Customers Want, All the Time: Listen Labs' Alfred Wahlforss",
            "pub_date": "2026-06-02T09:00:00.000Z",
            "duration": "2521",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "anthropic",
              "cursor"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4652106703.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c85a76ee-3dd8-11f1-8934-37efe54dd294",
            "index": 2,
            "title": "How Cursor Trained Composer on Fireworks: Distributed Infrastructure for High-Performance RL",
            "pub_date": "2026-05-26T09:00:00.000Z",
            "duration": "2733",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "foundation model",
              "cursor",
              "inference",
              "training",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1086513324.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11894f9c-52f7-11f1-a868-f30cc344c1ee",
            "index": 3,
            "title": "Rebuilding IT From the Ground Up for the AI Age: Serval's Jake Stauch",
            "pub_date": "2026-05-19T09:00:00.000Z",
            "duration": "2303",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4526751506.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "beaede5a-4d82-11f1-9272-4f6372b94ca8",
            "index": 4,
            "title": "Suno's Mikey Shulman: Everyone Can Make Music Now",
            "pub_date": "2026-05-13T18:55:00.000Z",
            "duration": "2088",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5617471569.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "41e0e0de-4a72-11f1-8f25-0bf25b7d3e24",
            "index": 5,
            "title": "ElevenLabs' Mati Staniszewski: How Voice Becomes the Interface for Everything",
            "pub_date": "2026-05-08T17:05:00.000Z",
            "duration": "1608",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5362828253.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d73930f8-47f4-11f1-a018-3b5d50482f68",
            "index": 6,
            "title": "Anthropic's Boris Cherny: Coding's Printing Press Moment",
            "pub_date": "2026-05-05T09:00:00.000Z",
            "duration": "1475",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2772021536.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a6ff5c8c-47f4-11f1-a8a5-03b48837c50f",
            "index": 7,
            "title": "Waymo's Dmitri Dolgov: 20 Million Rides and the Road to Full Autonomy",
            "pub_date": "2026-05-04T20:05:00.000Z",
            "duration": "1635",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "safety",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9639393938.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2b60e614-458c-11f1-8407-d363b4cb5860",
            "index": 8,
            "title": "OpenAI's Greg Brockman: Why Human Attention Is the New Bottleneck",
            "pub_date": "2026-05-01T18:32:00.000Z",
            "duration": "1706",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "agentic",
              "openai",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2111409921.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d029858c-44b7-11f1-b968-43e05671113c",
            "index": 9,
            "title": "Demis Hassabis on Building DeepMind, AlphaFold, and the Final Stretch to AGI",
            "pub_date": "2026-04-30T17:12:00.000Z",
            "duration": "1611",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1446613297.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90151d98-433c-11f1-93d1-9316de7fe3e7",
            "index": 10,
            "title": "Andrej Karpathy: From Vibe Coding to Agentic Engineering",
            "pub_date": "2026-04-30T09:00:00.000Z",
            "duration": "1788",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "openai",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9375467036.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65d389a8-3765-11f1-a29e-cf3fbe697ce7",
            "index": 11,
            "title": "From SEO to Agent-Led Growth: Profound’s James Cadwallader",
            "pub_date": "2026-04-14T09:00:00.000Z",
            "duration": "1886",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "claude",
              "gemini",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4586939097.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "99f20e54-26e3-11f1-b50e-fff5703b4285",
            "index": 12,
            "title": "How Autonomous Labs Will Transform Scientific Research: Ginkgo Bioworks’ Jason Kelly",
            "pub_date": "2026-03-24T14:12:00.000Z",
            "duration": "3507",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7929969804.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75c18b74-1f25-11f1-949a-2bfed1442ac3",
            "index": 13,
            "title": "Greetings, Earthlings: Philip Johnston of Starcloud on Data Centers in Space",
            "pub_date": "2026-03-17T09:00:00.000Z",
            "duration": "2659",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3959632960.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f0b727a-1c04-11f1-ac41-ff188f29fe44",
            "index": 14,
            "title": "Physics Gets a Vote: Nominal Cofounders on Hardware Development in an AI World",
            "pub_date": "2026-03-10T09:00:00.000Z",
            "duration": "2455",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI6588043940.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d4638cb0-05e7-11f1-b247-b3b1016a4a74",
            "index": 15,
            "title": "Building the GitHub for RL Environments: Prime Intellect's Will Brown & Johannes Hagemann",
            "pub_date": "2026-02-10T07:00:00.000Z",
            "duration": "2685",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI8352076279.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed0e9954-005f-11f1-b4af-ffe0a0718e1a",
            "index": 16,
            "title": "What’s the Future of Vertical SaaS in an AGI World? Jamie Cuffe, CEO of Pace",
            "pub_date": "2026-02-03T10:00:00.000Z",
            "duration": "3115",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI8570430815.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5f041e0-fae8-11f0-a812-9b47b3178e15",
            "index": 17,
            "title": "Making the Case for the Terminal as AI's Workbench: Warp’s Zach Lloyd",
            "pub_date": "2026-01-27T16:57:00.000Z",
            "duration": "2883",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4053137942.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "20f372c4-f635-11f0-a84f-3709416bfe71",
            "index": 18,
            "title": "Context Engineering Our Way to Long-Horizon Agents: LangChain’s Harrison Chase",
            "pub_date": "2026-01-21T10:00:00.000Z",
            "duration": "2387",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9761150620.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5941256-f0c8-11f0-9b50-539a245e1b60",
            "index": 19,
            "title": "How Ricursive Intelligence’s Founders are Using AI to Shape The Future of Chip Design",
            "pub_date": "2026-01-14T20:36:00.000Z",
            "duration": "2219",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI8200472129.mp3?updated=1768421374",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f559db38-eaba-11f0-abb4-734c8eec0697",
            "index": 20,
            "title": "Training General Robots for Any Task: Physical Intelligence’s Karol Hausman and Tobi Springenberg",
            "pub_date": "2026-01-06T07:00:00.000Z",
            "duration": "3697",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "training",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2576277674.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "38ba3326-da00-11f0-9d53-8b0924ed4775",
            "index": 21,
            "title": "Why the Next AI Revolution Will Happen Off-Screen: Samsara CEO Sanjit Biswas",
            "pub_date": "2025-12-16T10:00:00.000Z",
            "duration": "2301",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4396694185.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "23afc5da-d484-11f0-be65-b7d8916b5eab",
            "index": 22,
            "title": "The Rise of Generative Media: fal's Bet on Video, Infrastructure, and Speed",
            "pub_date": "2025-12-10T10:00:00.000Z",
            "duration": "3738",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gpu"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI6713513341.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ecca5f38-ceef-11f0-9aaa-eb11459bc42e",
            "index": 23,
            "title": "Why IDEs Won't Die in the Age of AI Coding: Zed Founder Nathan Sobo",
            "pub_date": "2025-12-02T10:00:00.000Z",
            "duration": "2413",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "gpu",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7976674176.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bbe8e7e6-c3fe-11f0-abed-6f18b823562c",
            "index": 24,
            "title": "How End-to-End Learning Created Autonomous Driving 2.0: Wayve CEO Alex Kendall",
            "pub_date": "2025-11-18T10:00:00.000Z",
            "duration": "2496",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9488284627.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "573109d4-be89-11f0-92b1-a7f50322b31d",
            "index": 25,
            "title": "How Google’s Nano Banana Achieved Breakthrough Character Consistency",
            "pub_date": "2025-11-11T17:25:00.000Z",
            "duration": "2618",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7583811947.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f586934e-b8e2-11f0-a7ef-9f352ab19a62",
            "index": 26,
            "title": "OpenAI Sora 2 Team: How Generative Video Will Unlock Creativity and World Models",
            "pub_date": "2025-11-06T12:00:00.000Z",
            "duration": "3625",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1671501466.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "56363538-b39c-11f0-8ea1-3bc8ac01af0c",
            "index": 27,
            "title": "Nvidia CTO Michael Kagan: Scaling Beyond Moore's Law to Million-GPU Clusters",
            "pub_date": "2025-10-28T09:00:00.000Z",
            "duration": "2491",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "chip",
              "inference",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5059499822.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f9f0c36-ade0-11f0-a1ac-3f87a20a5114",
            "index": 28,
            "title": "Securing the AI Frontier: Irregular Co-founder Dan Lahav",
            "pub_date": "2025-10-21T09:00:00.000Z",
            "duration": "2649",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "deepmind",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2344270803.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "59ff2cc0-a856-11f0-91b6-a31ab56b5c2a",
            "index": 29,
            "title": "Why AI Will Transform Customer Experience: Cresta CEO Ping Wu and Sequoia’s Doug Leone",
            "pub_date": "2025-10-14T17:55:00.000Z",
            "duration": "2686",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1092043399.mp3?updated=1760465413",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "501be594-9d6c-11f0-b436-c32ec611976e",
            "index": 30,
            "title": "Block CTO Dhanji Prasanna: Building the AI-First Enterprise with Goose, their Open Source Agent",
            "pub_date": "2025-09-30T09:00:00.000Z",
            "duration": "3583",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "anthropic",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9803179915.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de942aa4-97de-11f0-b8ca-63bc5a95e438",
            "index": 31,
            "title": "Why Businesses Are Rejecting the AI They’ve Asked For: Agency CEO Elias Torres",
            "pub_date": "2025-09-23T09:00:00.000Z",
            "duration": "2689",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4560153176.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d1d59a2-8d00-11f0-810c-4fc7e6321c8c",
            "index": 32,
            "title": "Building the \"App Store\" for Robots: Hugging Face's Thomas Wolf on Physical AI",
            "pub_date": "2025-09-09T09:00:00.000Z",
            "duration": "2588",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5891850195.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "55c8bb6c-878b-11f0-8ef9-db7a46549d94",
            "index": 33,
            "title": "Deal Velocity, Not Billable Hours: How Crosby Uses AI to Redefine Legal Contracting",
            "pub_date": "2025-09-02T09:00:00.000Z",
            "duration": "2999",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5276137366.mp3?updated=1756783315",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "314fd0f8-81ec-11f0-a8b1-930b48eb68fc",
            "index": 34,
            "title": "n8n CEO Jan Oberhauser on Building the Universal AI Automation Layer",
            "pub_date": "2025-08-26T09:00:00.000Z",
            "duration": "2144",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "retrieval",
              "embeddings",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4430428192.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d98ee368-7c6e-11f0-9648-8fbbb6ccd4e1",
            "index": 35,
            "title": "Scaling the ‘Cursor for Slides’ to $50M ARR: Gamma founder Jon Noronha",
            "pub_date": "2025-08-19T09:00:00.000Z",
            "duration": "1805",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "claude",
              "gemini",
              "cursor",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI6180959104.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ea9afc9e-76e4-11f0-8392-df12cf983147",
            "index": 36,
            "title": "Delphi’s Dara Ladjevardian: How AI Digital Minds Can Scale Human Connection",
            "pub_date": "2025-08-12T09:00:00.000Z",
            "duration": "2345",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3407041036.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c5ae996-6ca7-11f0-b077-331c149643a1",
            "index": 37,
            "title": "Vercel CEO Guillermo Rauch: Building the Generative Web with AI",
            "pub_date": "2025-08-05T15:16:00.000Z",
            "duration": "3659",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI6550481372.mp3?updated=1753812926",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d852e0c-6be4-11f0-bfc8-17c4dd88558b",
            "index": 38,
            "title": "OpenAI’s IMO Team on Why Models Are Finally Solving Elite-Level Math",
            "pub_date": "2025-07-30T09:00:00.000Z",
            "duration": "1810",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5438545942.mp3?updated=1753741141",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fcf7d8e6-667a-11f0-b529-03460f90d957",
            "index": 39,
            "title": "OpenAI Just Released ChatGPT Agent, Its Most Powerful Agent Yet",
            "pub_date": "2025-07-22T09:00:00.000Z",
            "duration": "2256",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "openai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3656372926.mp3?updated=1753134664",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "374f25ea-5dc9-11f0-8673-e3429a658718",
            "index": 40,
            "title": "DeepMind's Pushmeet Kohli on AI's Scientific Revolution",
            "pub_date": "2025-07-11T09:00:00.000Z",
            "duration": "2473",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "chip",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI8285386832.mp3?updated=1752178226",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cf8b451e-5b67-11f0-8e44-2339eea2f29f",
            "index": 41,
            "title": "Mapping the Mind of a Neural Net: Goodfire’s Eric Ho on the Future of Interpretability",
            "pub_date": "2025-07-08T17:30:00.000Z",
            "duration": "2827",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "large language model",
              "foundation model",
              "openai",
              "anthropic",
              "llama"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9154425844.mp3?updated=1751996708",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1873606c-55f1-11f0-a023-dff571f953f4",
            "index": 42,
            "title": "ElevenLabs’ Mati Staniszewski: Why Voice Will Be the Fundamental Interface for Tech",
            "pub_date": "2025-07-01T15:56:00.000Z",
            "duration": "3593",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9463195605.mp3?updated=1751386277",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c19c7236-506b-11f0-b377-33261e3cdf36",
            "index": 43,
            "title": "From DevOps ‘Heart Attacks’ to AI-Powered Diagnostics With Traversal’s AI Agents",
            "pub_date": "2025-06-24T09:00:00.000Z",
            "duration": "2432",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "inference"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3597815854.mp3?updated=1750708889",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0ae02282-47dc-11f0-8118-9f5839eff378",
            "index": 44,
            "title": "The Breakthroughs Needed for AGI Have Already Been Made: OpenAI Former Research Head Bob McGrew",
            "pub_date": "2025-06-17T09:00:00.000Z",
            "duration": "2931",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "chatgpt",
              "openai",
              "anthropic",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1197287200.mp3?updated=1750138681",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c94bf4a-4560-11f0-9b8d-a375401dd345",
            "index": 45,
            "title": "OpenAI Codex Team: From Coding Autocomplete to Asynchronous Autonomous Agents",
            "pub_date": "2025-06-10T09:00:00.000Z",
            "duration": "2264",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "inference",
              "training",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3386040744.mp3?updated=1749494336",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "218a23b8-3ff6-11f0-af25-738e98987a00",
            "index": 46,
            "title": "Google I/O Afterparty: The Future of Human-AI Collaboration, From Veo to Mariner",
            "pub_date": "2025-06-03T09:00:00.000Z",
            "duration": "3231",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5011322493.mp3?updated=1748923896",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa97b31a-373a-11f0-b165-cb01a0914fe3",
            "index": 47,
            "title": "From Data Centers to Dyson Spheres: P-1 AI's Path to Hardware Engineering AGI",
            "pub_date": "2025-05-27T09:00:00.000Z",
            "duration": "2305",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "data center",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1894390805.mp3?updated=1747938856",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65773554-3586-11f0-8c3b-ff4c582059ac",
            "index": 48,
            "title": "Gong’s Amit Bendov: From Meeting Recordings to Revenue AI",
            "pub_date": "2025-05-20T23:31:00.000Z",
            "duration": "2525",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI6858689358.mp3?updated=1747784170",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "445b7ab0-3063-11f0-8c60-c7b5c1c04834",
            "index": 49,
            "title": "LIVE: Google's Jeff Dean on the Coming Transformations in AI",
            "pub_date": "2025-05-16T09:00:00.000Z",
            "duration": "1859",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9861411995.mp3?updated=1747759710",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7aef0ace-3063-11f0-b4e0-d77a665b645e",
            "index": 50,
            "title": "LIVE: Ambient Agents and the New Agent Inbox ft. Harrison Chase of LangChain",
            "pub_date": "2025-05-15T15:57:00.000Z",
            "duration": "508",
            "duration_label": "8m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4695410539.mp3?updated=1747688161",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b77c3dee-3064-11f0-9909-43fa231b2eba",
            "index": 51,
            "title": "LIVE: How AI is Reinventing Software Business Models ft. Bret Taylor of Sierra",
            "pub_date": "2025-05-14T12:00:00.000Z",
            "duration": "2070",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9567164362.mp3?updated=1747760861",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3edaf0a4-2f71-11f0-a10e-e7c869b7bacd",
            "index": 52,
            "title": "LIVE: Sam Altman of OpenAI on Building the ‘Core AI Subscription’ for Your Life",
            "pub_date": "2025-05-14T01:36:00.000Z",
            "duration": "1947",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9115438162.mp3?updated=1747761906",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "00bd288c-29e5-11f0-bf17-5bbccf75de3b",
            "index": 53,
            "title": "Workday CEO Carl Eschenbach: Building the System of Record for the AI Era",
            "pub_date": "2025-05-06T09:00:00.000Z",
            "duration": "2869",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9236633719.mp3?updated=1746472699",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "25a8734c-246b-11f0-bc46-2be325d93284",
            "index": 54,
            "title": "The Quest to ‘Solve All Diseases’ with AI: Isomorphic Labs’ Max Jaderberg",
            "pub_date": "2025-04-29T09:00:00.000Z",
            "duration": "3340",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9345244137.mp3?updated=1745875147",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bdaa8bd8-1edc-11f0-8e1a-7f6ccbba1f21",
            "index": 55,
            "title": "Pricing in the AI Era: From Inputs to Outcomes, with Paid CEO Manny Medina",
            "pub_date": "2025-04-22T09:00:00.000Z",
            "duration": "2729",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3016010881.mp3?updated=1745259699",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "15c9e3ce-1972-11f0-a5c8-c76e38cc3e1d",
            "index": 56,
            "title": "Arc Institute's Patrick Hsu on Building an App Store for Biology with AI",
            "pub_date": "2025-04-15T13:55:00.000Z",
            "duration": "3491",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "openai",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI6181193044.mp3?updated=1744664492",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2da47ea2-140c-11f0-afca-d7551c42a717",
            "index": 57,
            "title": "Replit CEO Amjad Masad on 1 Billion Developers: A Better End State than AGI?",
            "pub_date": "2025-04-08T09:00:00.000Z",
            "duration": "5178",
            "duration_label": "1h 26m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "replit"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3845961326.mp3?updated=1744070642",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f007c2f0-0e81-11f0-a4d6-ebea52fd4128",
            "index": 58,
            "title": "Why CRM Needs an AI Revolution, with Day.ai Founder Christopher O’Donnell",
            "pub_date": "2025-04-01T09:00:00.000Z",
            "duration": "4265",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7652918508.mp3?updated=1743461490",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7b59f70-08d2-11f0-bc40-f37d4bb00282",
            "index": 59,
            "title": "From Software Engineers to AI Word Artisans: Filip Kozera of Wordware",
            "pub_date": "2025-03-25T09:00:00.000Z",
            "duration": "2584",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "deepmind",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2166058098.mp3?updated=1742836484",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f4964c8-0371-11f0-a7de-d359cbe867ee",
            "index": 60,
            "title": "Josh Woodward: Google Labs is Rapidly Building AI Products from 0-to-1",
            "pub_date": "2025-03-18T09:00:00.000Z",
            "duration": "3076",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "deepmind",
              "gemini",
              "replit",
              "training",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2961001947.mp3?updated=1742271117",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f14ec56-fe0e-11ef-b603-a35ac89367c0",
            "index": 61,
            "title": "How AI Breakout Harvey is Transforming Legal Services, with CEO Winston Weinberg",
            "pub_date": "2025-03-11T15:29:29.000Z",
            "duration": "3249",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4850855251.mp3?updated=1741707222",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d2fd45e-f891-11ef-acd6-c3cb1a3969be",
            "index": 62,
            "title": "The AI Product Going Viral With Doctors: OpenEvidence, with CEO Daniel Nadler",
            "pub_date": "2025-03-04T10:00:00.000Z",
            "duration": "3892",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7686673568.mp3?updated=1741101717",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5145824-f2d7-11ef-8b0a-efc5a34cf4cf",
            "index": 63,
            "title": "OpenAI’s Deep Research Team on Why Reinforcement Learning is the Future for AI Agents",
            "pub_date": "2025-02-25T10:00:00.000Z",
            "duration": "1965",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "meta ai",
              "training",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7097750063.mp3?updated=1740442579",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "335ce02e-ed7d-11ef-8371-df24fdb17d20",
            "index": 64,
            "title": "Palo Alto Networks’ Nikesh Arora: AI, Security and the New World Order",
            "pub_date": "2025-02-18T10:00:00.000Z",
            "duration": "3608",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7104965903.mp3?updated=1741376579",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eca071d6-e7f1-11ef-9d5b-3b420a3cbea7",
            "index": 65,
            "title": "MongoDB’s Sahir Azam: Vector Databases and the Data Structure of AI",
            "pub_date": "2025-02-13T10:00:00.000Z",
            "duration": "2666",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "gemini",
              "perplexity",
              "retrieval",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2602273912.mp3?updated=1739399014",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4ea1d540-e280-11ef-99dc-13b91512a718",
            "index": 66,
            "title": "Roblox Studio Head Stef Corazza: Using AI to Empower Creators",
            "pub_date": "2025-02-04T10:00:00.000Z",
            "duration": "3286",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "generative ai",
              "agents",
              "nvidia",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3267265498.mp3?updated=1738629084",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca77b012-dd18-11ef-84b1-7302ab161486",
            "index": 67,
            "title": "ReflectionAI Founder Ioannis Antonoglou: From AlphaGo to AGI",
            "pub_date": "2025-01-28T10:00:00.000Z",
            "duration": "3149",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "chatgpt",
              "openai",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9834139396.mp3?updated=1738028703",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "93587a04-d510-11ef-acae-2bdd53651d78",
            "index": 68,
            "title": "Kumo’s Hema Raghavan: Turning Graph AI into ROI",
            "pub_date": "2025-01-21T10:00:00.000Z",
            "duration": "3126",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "rag",
              "retrieval"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7965589198.mp3?updated=1737156040",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "267c6a94-cd54-11ef-8cb9-27942977ce88",
            "index": 69,
            "title": "Databricks Founder Ion Stoica: Turning Academic Open Source into Startup Success",
            "pub_date": "2025-01-14T10:00:00.000Z",
            "duration": "3605",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI6710068648.mp3?updated=1736797296",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b42b92f0-b67c-11ef-84e3-3bb54b15f0b5",
            "index": 70,
            "title": "XBOW CEO and GitHub Copilot Creator Oege de Moor: Cracking the Code on Offensive Security With AI",
            "pub_date": "2024-12-10T10:00:00.000Z",
            "duration": "3097",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "github copilot",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5694805221.mp3?updated=1733783520",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5cdbbbb8-ac24-11ef-9d0d-ff37896ee911",
            "index": 71,
            "title": "Ramp CEO Eric Glyman: Using AI to Build “Self-Driving Money”",
            "pub_date": "2024-12-03T10:00:00.000Z",
            "duration": "2328",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2257299052.mp3?updated=1733170160",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c662fd26-ab75-11ef-aa14-ff49d9592c89",
            "index": 72,
            "title": "Dust’s Gabriel Hubert and Stanislas Polu: Getting the Most From AI With Multiple Custom Agents",
            "pub_date": "2024-11-26T10:00:00.000Z",
            "duration": "3787",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7799192741.mp3?updated=1732581003",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95090f38-a5f6-11ef-9656-af9fef6a2c0d",
            "index": 73,
            "title": "Clay’s Kareem Amin on Building the Sales ‘System of Action’ with AI",
            "pub_date": "2024-11-19T10:00:00.000Z",
            "duration": "3098",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2291906498.mp3?updated=1731968810",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f796ab06-a12d-11ef-92e7-d70d5dfd91eb",
            "index": 74,
            "title": "Decart’s Dean Leitersdorf on AI-Generated Video Games and Worlds",
            "pub_date": "2024-11-13T10:00:00.000Z",
            "duration": "2794",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7938039267.mp3?updated=1731446633",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f0a91b8-9568-11ef-9129-c706b2d9d655",
            "index": 75,
            "title": "How Glean CEO Arvind Jain Solved the Enterprise Search Problem – and What It Means for AI at Work",
            "pub_date": "2024-10-29T09:00:00.000Z",
            "duration": "2688",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agentic",
              "reasoning",
              "rag",
              "retrieval"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7182880302.mp3?updated=1730155599",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d17bfcec-8ff2-11ef-ba06-c3db1fbb2417",
            "index": 76,
            "title": "OpenAI Researcher Dan Roberts on What Physics Can Teach Us About AI",
            "pub_date": "2024-10-22T09:00:00.000Z",
            "duration": "2502",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3810831988.mp3?updated=1729546154",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bf576c50-8a6f-11ef-86af-13c224eed9f4",
            "index": 77,
            "title": "Google NotebookLM’s Raiza Martin and Jason Spielman on Creating Delightful AI Podcast Hosts and the Potential for Source-Grounded AI",
            "pub_date": "2024-10-15T09:00:00.000Z",
            "duration": "1927",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4197953594.mp3?updated=1728965922",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5e866de0-84de-11ef-92c9-2fb1d47a401b",
            "index": 78,
            "title": "Snowflake CEO Sridhar Ramaswamy on Using Data to Create Simple, Reliable AI for Businesses",
            "pub_date": "2024-10-08T09:00:00.000Z",
            "duration": "3569",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3006145813.mp3?updated=1728335232",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "439017ca-7f66-11ef-a656-7fff69ded708",
            "index": 79,
            "title": "OpenAI's Noam Brown, Ilge Akkaya and Hunter Lightman on o1 and Teaching LLMs to Reason Better",
            "pub_date": "2024-10-02T09:00:00.000Z",
            "duration": "2722",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "openai",
              "deepmind",
              "inference",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI9323260941.mp3?updated=1727894425",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "41f16434-79d3-11ef-b145-1b674a134d5d",
            "index": 80,
            "title": "Why Vlad Tenev and Tudor Achim of Harmonic Think AI Is About to Change Math—and Why It Matters",
            "pub_date": "2024-09-24T09:00:00.000Z",
            "duration": "2385",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "training",
              "reasoning",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7750646273.mp3?updated=1727202335",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f0614f5c-746f-11ef-b014-17e5a317e802",
            "index": 81,
            "title": "Jim Fan on Nvidia’s Embodied AI Lab and Jensen Huang’s Prediction that All Robots will be Autonomous",
            "pub_date": "2024-09-17T09:00:00.000Z",
            "duration": "2953",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agent",
              "agents",
              "openai",
              "nvidia",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1518157518.mp3?updated=1727806879",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "12ea47cc-6eda-11ef-a4e1-b7d333840a0f",
            "index": 82,
            "title": "Founder Eric Steinberger on Magic’s Counterintuitive Approach to Pursuing AGI",
            "pub_date": "2024-09-10T09:00:00.000Z",
            "duration": "3075",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "agents",
              "openai",
              "deepmind",
              "eval"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4739438465.mp3?updated=1725907138",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f80bdd2-6a27-11ef-8c33-9b52e99bfa9c",
            "index": 83,
            "title": "Crucible Moments Returns for S2: The ServiceNow Story ft. CEO Frank Slootman & Founder Fred Luddy",
            "pub_date": "2024-09-03T19:53:32.000Z",
            "duration": "2573",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7797180218.mp3?updated=1725393683",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8b161690-63ea-11ef-bd0b-f32d9265f776",
            "index": 84,
            "title": "Sierra Co-Founder Clay Bavor on Making Customer-Facing AI Agents Delightful",
            "pub_date": "2024-08-27T09:00:00.000Z",
            "duration": "4351",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5105179357.mp3?updated=1724712070",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52aa3e86-5e7b-11ef-934e-974555431f99",
            "index": 85,
            "title": "Phaidra’s Jim Gao on Building the Fourth Industrial Revolution with Reinforcement Learning",
            "pub_date": "2024-08-20T09:00:00.000Z",
            "duration": "3033",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI8665139084.mp3?updated=1724107224",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "84e3014a-5907-11ef-9a8c-cfe6fb0c150f",
            "index": 86,
            "title": "Fireworks Founder Lin Qiao on How Fast Inference and Small Models Will Benefit Businesses",
            "pub_date": "2024-08-13T09:00:00.000Z",
            "duration": "2358",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "openai",
              "nvidia",
              "inference",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2778481768.mp3?updated=1723555274",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f7ac4e6-5371-11ef-ae98-df1c65a83821",
            "index": 87,
            "title": "GitHub CEO Thomas Dohmke on Building Copilot, and the the Future of Software Development",
            "pub_date": "2024-08-06T09:00:00.000Z",
            "duration": "4054",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "github copilot",
              "coding",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4987704053.mp3?updated=1722906967",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "32e969ca-4df3-11ef-b9c8-97293cd3833d",
            "index": 88,
            "title": "Meta’s Joe Spisak on Llama 3.1 405B and the Democratization of Frontier Models",
            "pub_date": "2024-07-30T12:00:00.000Z",
            "duration": "2527",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agentic",
              "mistral",
              "llama",
              "reasoning",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3029012972.mp3?updated=1722345193",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "295b4624-4864-11ef-879c-9fff35fc0dc9",
            "index": 89,
            "title": "Klarna CEO Sebastian Siemiatkowski on Getting AI to Do the Work of 700 Customer Service Reps",
            "pub_date": "2024-07-23T09:00:00.000Z",
            "duration": "3095",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI4197462355.mp3?updated=1721692854",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "07e17634-37df-11ef-a5e9-bb3393be302a",
            "index": 90,
            "title": "Reflection AI’s Misha Laskin on the AlphaGo Moment for LLMs",
            "pub_date": "2024-07-16T09:00:00.000Z",
            "duration": "4024",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI2618323153.mp3?updated=1721088578",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef855cbe-37dd-11ef-bc7f-8f47192a0688",
            "index": 91,
            "title": "Microsoft CTO Kevin Scott on How Far Scaling Laws Will Extend",
            "pub_date": "2024-07-09T09:00:00.000Z",
            "duration": "3627",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm",
              "large language model",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1597985326.mp3?updated=1720475440",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a14664b2-37dd-11ef-999f-0f0d12bf1d0a",
            "index": 92,
            "title": "Zapier’s Mike Knoop launches ARC Prize to Jumpstart New Ideas for AGI",
            "pub_date": "2024-07-02T09:00:00.000Z",
            "duration": "3312",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "generative ai",
              "chip",
              "reasoning",
              "eval"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI5994281884.mp3?updated=1719870627",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af04fbc0-324e-11ef-a799-73b3d7be953b",
            "index": 93,
            "title": "Factory’s Matan Grinberg and Eno Reyes Unleash the Droids on Software Development",
            "pub_date": "2024-06-25T11:00:00.000Z",
            "duration": "3550",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "foundation model",
              "agent",
              "agents",
              "openai",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI1261809222.mp3?updated=1719351451",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "508cbf82-2d18-11ef-b32d-4711f6368100",
            "index": 94,
            "title": "LangChain’s Harrison Chase on Building the Orchestration Layer for AI Agents",
            "pub_date": "2024-06-18T11:00:00.000Z",
            "duration": "2990",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "agentic",
              "openai",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI7343169125.mp3?updated=1719341743",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a62839a4-236c-11ef-b0da-53dfccbfba11",
            "index": 95,
            "title": "Introducing \"Training Data\"",
            "pub_date": "2024-06-05T23:28:26.000Z",
            "duration": "86",
            "duration_label": "1m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pscrb.fm/rss/p/traffic.megaphone.fm/CPUAI3056114565.mp3?updated=1717613803",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "42zhangjing",
        "title": "42章经",
        "feed_title": "42章经",
        "priority": "P1",
        "selection_mode": "all",
        "focus": [
          "AI",
          "Agent",
          "创业",
          "商业",
          "访谈",
          "中文播客"
        ],
        "feed_url": "https://feed.xyzfm.space/evgg6xle9rdc",
        "source_url": "https://www.xiaoyuzhoufm.com/podcast/648b0b641c48983391a63f98",
        "detail_path": "/podcasts/42zhangjing/",
        "episode_count": 65,
        "selected_episode_count": 65,
        "latest_episode_title": "一个 AI 创始人的虚荣心、装，和愚昧之巅｜对谈 invoko.ai 创始人梦琪",
        "latest_pub_date": "2026-05-23T13:30:00.000Z",
        "latest_page_url": "https://www.xiaoyuzhoufm.com/episode/6a100e7da7621e15d0c88337",
        "has_play_count_data": true,
        "episodes": [
          {
            "id": "6a100e7da7621e15d0c88337",
            "index": 1,
            "title": "一个 AI 创始人的虚荣心、装，和愚昧之巅｜对谈 invoko.ai 创始人梦琪",
            "pub_date": "2026-05-23T13:30:00.000Z",
            "duration": "4122",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a100e7da7621e15d0c88337",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6a100e7da7621e15d0c88337/media.xyzcdn.net/648b0b641c48983391a63f98/lsI79O-Z19zPlvmqdBpZnEOGPk3F.m4a",
            "play_count": 37418,
            "show_notes_text": "梦琪是过去几年里最受欢迎的一类创始人的典型代表：字节背景、组了一个华丽的团队、借 Agent 势能讲一个不错的故事、连续拿钱融资，然后跟着技术和热点 pivot。\n\n当然，在 AI Coding 指数级进步之后，她也和很多创始人一样，因为模型太强而一度陷入低谷。\n\n但难得的是，在经历了大量反思、复盘和学习之后，梦琪又从「绝望之谷」里爬了出来，重新变得乐观，并再次相信：软件依然大有可为。\n\n节目里，梦琪非常坦诚地分享了这一年里的思考与心态变化。她复盘了自己的几次 pivot：为什么那些一开始听起来非常自洽的决策，最后大多都错了？为什么她后来意识到，to B 对自己来说并不是一个值得创业的方向？以及在转向 C 端之后，她又是如何重新找回对软件的信心的？\n\n她还进行了很多尖锐的自我批评：刚开始创业时，人很容易被虚荣心和性感叙事牵着走，而忽略业务和用户真正需要的东西；而刚拿到融资的时候，往往也是创始人最接近「愚昧之巅」的时刻。\n\n在这样毫不遮掩的表达里，梦琪也贡献了不少金句和暴论。比如，行业里有很多「诈骗公司」；很多垂直 Agent，本质上只是给投资人看的景观；某类很流行的表达是 AI 圈的番茄小说。\n\n听的时候，一边觉得很真实很爽，一边也真的替她捏把汗。她坦诚到让我甚至怀疑：这个行业里是不是已经没有她在乎的人了（笑）。\n\n但在一个普遍焦虑、普遍迷茫的时刻，这种既有活人感、又有希望感的声音，可能恰恰是我们最需要的吧。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n48 号珍藏：梦琪，invoko.ai 创始人\n\n【时光机】\n\n02:54 去年融到大钱的软件创始人，都该给 Manus 磕一个？\n\n03:45 2、3 月的时候，我觉得自己做软件真是脑子进水了\n\n05:17 AI Coding 已经这么强了，为什么真正跑出来的产品还是很少？\n\n08:26 Pivot 路上的错误决策：\n\n08:45 ① 做垂直 Agent\n\n11:40 ② 过度服务专业用户\n\n12:28 ③ 选择错了场景\n\n17:08 垂直 Agent 的两个结构性困局\n\n17:30 很多 AI 产品，其实就是给投资人看的一个景？\n\n18:45 AI 软件的两种生意：大 R 运营 & 健身房模式\n\n21:18 效率工具也能提供情绪价值？Steam 给了我很大启发\n\n22:48 对我来说，to B 是一个不值得创业的方向\n\n24:44 锐评创始人的虚荣心、装，和愚昧之巅\n\n28:36 见过美国 to B 的骚操作后，我对美国创业生态祛魅了\n\n30:21 AI Coding 越强，反而越让我对软件有敬畏之心\n\n35:58 C 端产品只要能做到这一件事，就有价值\n\n39:07 分享一个粗暴但好用的用研方式\n\n44:00 AI 可能会彻底颠覆「拿着锤子找钉子」的思维模式\n\n51:02 扩散乐观：软件依然大有可为！\n\n55:38 抗拒「全球首款 xxx」，抵制 AI 圈番茄小说式表达\n\n57:41 上一个产品是在迎合市场做证明题，现在我想做一道真的想答的简答题\n\n01:01:37 灵魂拷问：后悔过离开字节来创业吗？\n\n01:05:00 创业不能用太多左脑\n\n【The gang that made this happen】\n\n制作人：陈皮\n\n剪辑：陈皮\n\n片头：Mondo Bongo - Joe Strummer & The Mescaleros\n\n片尾：Sunday Morning - The Velvet Underground,Nico",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "invoko.ai",
                "url": "http://invoko.ai/"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1692,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a059d321b7bd50295257a5e",
            "index": 2,
            "title": "当软件容易被创作，新时代的产品长什么样？ | 对谈 Albert",
            "pub_date": "2026-05-16T13:30:00.000Z",
            "duration": "2831",
            "duration_label": "47m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a059d321b7bd50295257a5e",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6a059d321b7bd50295257a5e/media.xyzcdn.net/648b0b641c48983391a63f98/ltgaLbpl0P41D33VvSBACZqrCBdI.m4a",
            "play_count": 14952,
            "show_notes_text": "我们又又又请来了 Albert（笑）。\n\n前不久他刚刚来过，总结了一下他 AI 创业的阶段性思考（回顾：优化胜率而非赔率，把一件事做到理论上该有的样子｜对谈连续创业者 Albert）。之所以这么快又请他来，是因为过去两个月里，他们团队鼓捣了几十个新产品，但都没达到 Albert 心中的发布标准——直到这次的 merging.live。这个产品核心想做的事，是为新的 maker 群体提供「回响」。\n\n做这个产品的过程中，Albert 思考了很多问题。在这期节目里，我们就一一讨论了一下，包括：\n\nOpus 4.6 之后，公司内部做几十个项目的积累；\n\n人人都能做自己产品的未来真的会到来吗？对软件行业会有什么影响？\n\n未来的软件格局可能是什么样？现在还有什么值得做的机会？\n\n一级市场可能有什么变化？\n\n新产品的底层思路是什么，为谁做、为什么做、打算怎么做？\n\n其实这期节目一上来聊得稍微有点颓。就像 Albert 说的：「最近行业里可以说是哀鸿遍野」。这背后的一大原因，就是模型厂商在加速挤压创业空间、可能最终会掌握绝大多数价值。但在 Albert 心里，智能并不是最 high level 的价值，所以他找到了新的方向。希望他的思考，能给大家带来一些启发吧。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n六号珍藏：Albert\n\n【时光机】\n\n01:07 最近行业里哀鸿遍野…大家都在 pivot 和 pivot 的路上\n\n04:23 「人人自己做产品」的未来已来？\n\n07:19 两个月做了几十个新产品，主线是什么、有什么积累？\n\n10:43 探讨下未来软件的格局\n\n13:52 软件可能会出现新的溢价和品牌效应？\n\n15:12 会有新的平台型机会吗？\n\n17:46 长尾产品的可消费性到底有多强？\n\n21:57 vibe coding 的核心价值其实是…\n\n26:23 build in public / 奉献自己的 skills，该怎么解决变现问题？\n\n27:33 决定做现在这个新产品，是因为观察到了几层变化\n\n29:22 做「下一个抖音」的思考方式就不对\n\n30:55 介绍一下新产品：给 makers 创造「回响」\n\n31:34 在我心里，智能就不是最 high level 的价值\n\n34:51 现在不能围绕普遍性去做产品，否则就完蛋了\n\n37:32 一级市场可能会…GG？\n\n38:14 软件行业会越来越像泡泡玛特\n\n39:17 我最近在思考：从 token 到经济价值的更短路径\n\n【The gang that made this happen】\n\n制作人：陈皮\n\n剪辑：陈皮\n\n片头：Mondo Bongo - Joe Strummer & The Mescaleros\n\n片尾：Run Run Run - 回响",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "优化胜率而非赔率，把一件事做到理论上该有的样子｜对谈连续创业者 Albert",
                "url": "https://www.xiaoyuzhoufm.com/episode/69abf2cec8cdeb38c24b2038"
              },
              {
                "text": "merging.live",
                "url": "http://merging.live/"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1436,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69e999241e94ae6921f2901d",
            "index": 3,
            "title": "用 Agent 动力学，和 40 个 Agents 一起为「人 + AI」做产品｜对谈 Slock.ai 创始人 RC",
            "pub_date": "2026-04-23T13:30:00.000Z",
            "duration": "3970",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69e999241e94ae6921f2901d",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/69e999241e94ae6921f2901d/media.xyzcdn.net/648b0b641c48983391a63f98/liiv-fKcDolfb06hKOyz0IX3feJY.m4a",
            "play_count": 19062,
            "show_notes_text": "活动预告🥳：5 月 10 日，我们会请到 Slock.ai 创始人 RC、merging.live 创始人 Albert、Raphael AI 创始人刘小排、velobase.io 创始人聪聪做一场线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\n最近有个产品在小圈子里很火，叫 Slock.ai。\n\n这期节目，我们就请来了这个产品的 Founder，也是 Kimi CLI 的作者——RC。\n\n今年 1 月，他就有了 Slock 这个 idea，目标是为多 Agents 和人提供一个协作环境。而为了更好地实现这个 idea，他果断离开 Kimi，花了大量时间思考「Agent 动力学」、Agent 与人协作的各种可能性，以及其中的产品化难点。\n\n在这个过程中，他直接把公司运行在 Slock 上，从 OPC 慢慢拓展成一个「40 个 Agents + 7 个人」的团队，边做边观察边迭代，积累了不少一手认知。（其中有些观察非常有意思，比如 Agents 会相互监督，甚至也会出现办公室政治哈哈。\n\n节目中，RC 重点分享了做 Slock 的完整实践与思考，包括一个很有想象力的 roadmap。此外，他也深入浅出地聊了 CLI 这个热点，并分享了他对模型能力、模型与应用的关系、OPC 以及新型组织形式的看法。\n\n最后，我们还聊到了一个有点虚无的问题：如果模型继续变强，那做产品还有意义吗？\n\nRC 的回答很有道理：每个需求本质上都是一个 idea。只要人类还存在，这件事就依然有意义。\n\n当然，最理想的情况是，大家都能把这些 ideas 直接丢进 Slock，让 Agents 帮你一起实现。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n47 号珍藏：RC，Slock.ai 创始人，Kimi CLI 作者\n\n【时光机】\n\nPart 1 Kimi 时期\n\n 0:28 为什么大家突然都开始做 CLI？\n 3:04 做 Kimi CLI 的思考过程 6:29 有借鉴 Claude Code 吗（？\n\n 8:30 如果模型继续变强，世界可能会崩溃…？ 11:56 但我是乐观共存派\n\n 15:32 在 Kimi 的感受如何，为什么决定离开？\nPart 2 创业阶段\n\n 17:32 Slock 核心在解决什么问题？\n 19:38 Coding 和 Building 已经变成正交的两件事了\n 21:50 学 Coding 的路径，正在从 bottom-up 变成 top-down\n 24:28 产品费 Token 并不一定是坏事\n 26:04 Slock 团队有多少人和 Agents？为什么是这个配比？\n 28:08 论人 + Agent 协作的两种流派：「单一全能 Agent」vs「多 Agents 分工」\n 32:06 分享一个很有想象力的 roadmap：Agent Marketplace\n 39:27 Slock 在做的事有点像飞书，但 Agent-first\n 41:50 到底要怎样做好给 Agent 用的产品？ 42:02 难点一：UI/UX & AI/AX\n 44:40 难点二：分工与协作机制\n\nPart 3 观察与思考\n\n 48:27 我花了很长时间思考「Agent 动力学」\n 50:18 Agent 也会形成不同的组织文化（甚至会搞办公室政治\n 51:56 模型继续变强，那应用公司还能拼什么？\n 54:40 对 OPC 和 AI-Native 组织形式的思考\n 59:42 我最近每天都在想：人 + Agents 的团队到底该有多大？\n 1:01:30 如果真的 AGI 了，做产品还有意义吗？\n 1:03:18 我脑子里还有无数想做的东西\n【活动预告🥳】\n\n5 月 10 日，我们会请到 Slock.ai 创始人 RC、merging.live 创始人 Albert、Raphael AI 创始人刘小排、velobase.io 创始人聪聪做一场线上活动，感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：Deceiver - M83",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "Albert",
                "url": "https://www.xiaoyuzhoufm.com/episode/6505cb5496875579717a1369"
              },
              {
                "text": "链接",
                "url": "https://my.feishu.cn/share/base/form/shrcnnZGPwi4TMJjk7opp74Syze"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9teS5mZWlzaHUuY24vc3BhY2UvYXBpL2JveC9zdHJ",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9teS5mZWlzaHUuY24vc3BhY2UvYXBpL2JveC9zdHJlYW0vZG93bmxvYWQvYXN5bmNjb2RlLz9jb2RlPU16RXlNV1V5WTJFME1XUXdZVEEwT0RGbVlqTTNaalE0WWpNek16QTBOVE5mVGt4QlEyNVJTM2x6U0hSc1JHUkJTa2xOYjA1VWREVmhjazAyZVdKeldWaGZWRzlyWlc0NlZrSjRZV0kxWkcwM2IwNTVVRWg0WW0xSGRtTmFZVTlYYmxKblh6RTNOelk1TVRZMk5URTZNVGMzTmpreU1ESTFNVjlXTkE="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1976,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69bbc8ea3c625cc5ae21b461",
            "index": 4,
            "title": "我们是如何定义 OpenClaw for Teams 新产品形态的｜对谈 Kuse&Junior 联创兼 CTO 宇豪",
            "pub_date": "2026-03-19T14:00:00.000Z",
            "duration": "4483",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69bbc8ea3c625cc5ae21b461",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/69bbc8ea3c625cc5ae21b461/media.xyzcdn.net/648b0b641c48983391a63f98/lkp1A0TodFlxOyYCYo3zhRaP3eBv.m4a",
            "play_count": 22146,
            "show_notes_text": "活动预告🥳：3 月 28 日，我们会请到 Sheet0 创始人文锋、Kuse.ai / Junior.so 联合创始人兼 CTO Austin Xu、Clockless.ai 创始人任川、PingCAP 联创兼 CTO 黄东旭做一场线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\nKuse.ai 未曾融资就从 0 做到千万刀 ARR，Junior.so 则是最早上线的相当成熟的 OpenClaw for Teams 类产品。\n\n这期我们请到的嘉宾，就是这两个产品背后的联创和 CTO 宇豪。他分享了很多踩过的坑，以及对 OpenClaw 类产品的思考，其中有些地方，甚至已经带点科幻感。\n\n宇豪的一个核心判断是：26 年将进入 7×24 的 AI 劳动力时代。\n\n这并非凭空想象，而是他们正在经历的现实：\n\n他们现在的团队，由 15 个全职人类员工加上三四个「AI 同事」组成。这些 Agents 有名字、有 Gmail、有手机号，每天都在真实地产生业务价值：有的专门监控数据，有的能帮他们识别出多条价值上万美金的销售线索，有的还会在参会后给人类提建议。而且这些 Agents 工作过于高效，以至于他们不得不专门建了一个 human only 的群，留给人类去摸鱼吹水（笑）。\n\n在聊这些 usecases 时，宇豪始终有种难掩的兴奋。而这套「Agent as Workforce」的体验，都已经被他们封装进了 Junior.so 这个新产品里。\n\n节目中，宇豪还分享了很多零融资做增长的思考，以及快速发现并落地新的产品机会的经验。说起来没有什么 secret sauce，但确实有效，在当下也很有借鉴意义。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n46 号珍藏：徐宇豪，Kuse.ai & Junior.so 联创兼 CTO\n\n【时光机】\n\nPart 1 老产品 Kuse：踩坑、迭代，与催生出的创新\n\n 1:56 在没有融资的情况下，怎么快速把产品做到千万刀 ARR？\n 3:52 固定定价在 Agent 时代是个陷阱\n 8:15 我们曾经希望用同一个产品服务所有人，但发现这条路不太 work\n 10:42 所有 Agent 创业者都应该尽早建立自己的 Evaluation & Benchmark\n 14:09 去年 12 月开始，我们内部就有了 7×24 工作的「AI 同事」\n 16:51 Token 成本这么高，为什么还是选 Agents 而不是人？又为什么不把人都换成 Agents？\n 18:29 之前我不觉得 SaaS 会完蛋，直到……\n 21:10 零融资倒逼出来的增长思考\nPart 2 新产品 Junior：让 AI 成为真正的数字员工\n\n 24:26 我们是怎么定义 OpenClaw for Teams 这个新产品的形态的？ 29:03 很多产品需求其实是「自己长出来的」\n\n 32:09 我们的 AI 说：人类是最大的瓶颈\n 34:52 越好的模型其实越安全\n 36:15 应该把钱花在 Token 上，而不是花在工资上\n 38:07 这么多团队都在做 OpenClaw 类产品，那大家最后拼的是什么？\n 44:46 我们在收费模式上有一些小巧思\n 45:47 该怎么给 Agent 员工界定职责边界？\n 48:32 分享一些 Agents 间协作的有趣实践，比如让它们自己去赚钱\n 54:31 互联网世界准备好迎接 AI 员工了吗？还差什么？\n 58:10 AI 大规模替代劳动力之后，真不知道社会会怎样\n 1:02:22 模型依然有幻觉，但我们的 Agent 已经可以主动自我纠正了\n 1:05:55 如果你是客户，你选 OpenClaw 类产品时会重点关注什么？\n 1:07:40 给正在做类似事情的人一些建议\n【活动预告🥳】\n\n3 月 28 日，我们会请 Sheet0 创始人文锋、Kuse.ai/ Junior.so 联合创始人兼 CTO Austin Xu、Clockless.ai 创始人任川、PingCAP 联创兼 CTO 黄东旭做一场线上活动，感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：U - SUPER JUNIOR",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://my.feishu.cn/share/base/form/shrcntAIYfNyvErSmuYOLSmgzid"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9teS5mZWlzaHUuY24vc3BhY2UvYXBpL2JveC9zdHJ",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9teS5mZWlzaHUuY24vc3BhY2UvYXBpL2JveC9zdHJlYW0vZG93bmxvYWQvYXN5bmNjb2RlLz9jb2RlPU1tVXdPVFZrWlRVMFpUUTBNV0ZtWWpZMk5USXhNR0V6WVdRd09HWmlZV0pmTkc1bGNGWlBUakZJUkVaR2Qya3dUa05yT1dObllYaHBielYxVG5SRWEyOWZWRzlyWlc0NlZGRlJiR0o2VVZKVWIzaE5OMHQ0VFRWb2VHTkZWRTVYYmpOa1h6RTNOek01TVRReU1UZzZNVGMzTXpreE56Z3hPRjlXTkE="
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9teS5mZWlzaHUuY24vc3BhY2UvYXBpL2JveC9zdHJ",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9teS5mZWlzaHUuY24vc3BhY2UvYXBpL2JveC9zdHJlYW0vZG93bmxvYWQvYXN5bmNjb2RlLz9jb2RlPU1qWmxOVEV5WWprNVlqUTVOMkl6TURaa1ltUmtObVZqTXpabU1qTTRNRFpmT1hVeFQyZHZUMlZrZDB0SU0yazJUbTA1T1hvMWN6aHJhbkp2Y2pCTlpIWmZWRzlyWlc0NlNHdHVkV0l3TjJObGIydDNhbXg0ZUhKUVQyTmFha05tYmt4a1h6RTNOek01TVRReU1UZzZNVGMzTXpreE56Z3hPRjlXTkE="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2141,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69b4d2f9f8b8079bfa3ae7f2",
            "index": 5,
            "title": "OpenClaw 之后，我只想未来 3-6 个月的事情｜对谈 Sheet0 创始人王文锋",
            "pub_date": "2026-03-14T14:00:00.000Z",
            "duration": "3430",
            "duration_label": "57m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69b4d2f9f8b8079bfa3ae7f2",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/69b4d2f9f8b8079bfa3ae7f2/media.xyzcdn.net/648b0b641c48983391a63f98/lu_D4y7QIfAG6-rc79TP-rOxJp4Z.m4a",
            "play_count": 26447,
            "show_notes_text": "活动预告🥳：3 月 28 日，我们会请到 Sheet0 创始人文锋、Kuse AI / Junior.so 联合创始人兼 CTO Austin Xu、Clockless.ai 创始人任川、PingCAP 联创兼 CTO 黄东旭做一场线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\n如果回到去年 3 月份，你会不会借鉴 Manus 做个 Genspark？\n\n这是文锋问自己，也是问团队的一个问题。\n\n这个问题，其实折射着文锋对创业这件事的理解的重大变化：\n\n从预判未来 5–10 年、力争差异化，变成只想未来 3–6 个月、做确定性更高的事情。\n\n而这个问题的当下版本，就是：\n\n现在创业，到底要不要做 OpenClaw 方向？如果真要做，又该怎么做？\n\n在这期节目里，文锋就从 OpenClaw 到底为什么这么火、这波和去年 Manus 带起来的那波 Agent 热有什么异同、Agent 赛道接下来会发生什么变化，以及他对创业的最新理解等方面，给出了他在战略思考与落地执行层面上的答案。\n\n（其中我们还聊出了一个很有意思的判断：现在的 C 端用户，可能未来会变成像 B 一样的角色。）\n\n在我看来，文锋的这种转变，正是一个创业者走向成熟的标志。创业并不只有一种英雄之旅。很多时候，放下一部分 Ego，去做那些正确、务实、能带来结果的事情，反而更需要拼劲和勇气。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n33 号珍藏：王文锋，Sheet0 创始人（往期考古：《Agent 开发的上半场: 环境、Tools 和 Context 如何决定 Agent》）\n\n【时光机】\n\nPart 1 关于 Agent 的新思考\n\n 00:34 这波 Agent 热和去年 Manus 带起来的那波，有什么区别？\n 1:29 OpenClaw 为啥火成这样？\n 2:34 去年 AI Coding 是大模型的灵巧手，那今年呢？\n 5:29 垂直 Agent 不成立，SaaS 也要被淘汰？\n 14:03 OpenClaw 给我带来的最大震撼还不是产品本身\n 15:29 Agent 现在遇到的最大瓶颈并不是技术\n 17:36 当下可能有上千个团队在围绕 OpenClaw 创业\n 19:38 详解 OpenClaw 的三板斧 19:52 ① 更好的长程任务能力（其实 hidecloud 的那句话一直都是对的\n 23:24 ② Proactive\n 27:36 ③ 自进化\n\n 31:28 使用 OpenClaw 的一个 Aha Moment\n 33:10 现在开发一个新产品，两个月都太慢了，两周就够了\n 34:43 「Harness」是 Agent 的下一个胜负手？\nPart 2 创业的新选择\n\n 41:18 一道灵魂拷问题：回到去年 3 月，你做不做 Genspark？\n 42:25 我们的新产品是在做 AI Coding 的平权\n 45:37 今天服务大 C，就和过去服务世界 500 强是一样的\n 48:24 我现在只看未来 3-6 个月的事\n 51:48 放下 Ego 后，我创业中最大的改变\n【活动预告🥳】\n\n3 月 28 日，我们会请 Sheet0 创始人文锋、Kuse AI / Junior.so 联合创始人兼 CTO Austin Xu、Clockless.ai 创始人任川、PingCAP 联创兼 CTO 黄东旭做一场线上活动，感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：Krafty (2015 Remaster) - New Order",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "《Agent 开发的上半场: 环境、Tools 和 Context 如何决定 Agent》",
                "url": "https://www.xiaoyuzhoufm.com/episode/68032a401f1db84a563d5d83"
              },
              {
                "text": "链接",
                "url": "https://my.feishu.cn/share/base/form/shrcntAIYfNyvErSmuYOLSmgzid"
              },
              {
                "text": "https://image.xyzcdn.net/FlPFV9-uIbbeYPX3YFgFxv9k760P.png",
                "url": "https://image.xyzcdn.net/FlPFV9-uIbbeYPX3YFgFxv9k760P.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 872,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69abf2cec8cdeb38c24b2038",
            "index": 6,
            "title": "优化胜率而非赔率，把一件事做到理论上该有的样子｜对谈连续创业者 Albert",
            "pub_date": "2026-03-07T14:00:00.000Z",
            "duration": "3951",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69abf2cec8cdeb38c24b2038",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/69abf2cec8cdeb38c24b2038/media.xyzcdn.net/648b0b641c48983391a63f98/lu0VAMAaWCTwVa3qbLNsf99esAR2.m4a",
            "play_count": 18547,
            "show_notes_text": "我们又请来了 Albert。\n\n他是我认识的最 sharp 的人之一。\n\n过去三年，他一直在从「想象力」和「智能」这两个方向思考 AI 创业的机会，做过各种尝试，而我们的播客正好一路见证了他的探索：\n\n23 年，他正在「追求赔率」，探索连接平台和互动内容方向的大机会（考古：《拒绝三亿美金 offer 的人》）；\n\n24 年，他转向「优化胜率」，很快就找到了一个又一个 PMF，甚至做出了一款几千万美金 ARR 的产品（考古：《找 PMF 就是要做没壁垒的事》）。\n\n前两年，他主要在做「想象力」方向的事情；而随着 25 年 AI Coding 的大爆发，他又准备把重心放在「智能」上，推倒重来。\n\n不过，Albert 的这种反复横跳有时显得过于激进，以至于很多人都难以理解。在这期节目里，我们就聊了聊他过去三年创业思路的变化、过程中的反思，以及最近的一些新思考。\n\n其实他身上这种极端的行动力、极致的思考、极度的自我 Challenge，有时会显得有些矛盾，因为按理说，这种配置很容易让人左脚绊右脚。所以和他交流越多，我越好奇：为什么他明明不太稳定，却总能让人相信他会做出成绩？\n\n在这期节目里，Albert 反复提到的一句话，似乎给了我答案：\n\n「把一件事做到理论上应该有的样子。」\n\n这句话越想越有道理。\n\n虽然他的行事风格经常「矫枉过正」，但这不重要，重要的是，他始终试图思考事物的本质，用科学的方法去 scale，同时保有对「万事无常」的平常心，然后把事情尽可能推向它理论上的最好状态。\n\n这或许正是他既有破坏力、又极具韧性的原因吧。\n\n进入 26 年，带着对胜率的无尽追逐、对过往路径的反思，以及 AI Coding 的东风，Albert 又在带领团队做着日新月异的事情。他们目前正在招人，欢迎有兴趣的朋友联系。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n六号珍藏：Albert，AI 创业者\n\n【时光机】\n\nPart 1 创业思维的大转向\n\n 1:38 「追求赔率」阶段的产品思路\n 2:57 探索互动内容方向 (失败) 后的反思 for 消费的 AIGC 还不太成立？\n for 表达的 AIGC 很难有平台型机会？\n\n 6:10 为什么从「赔率驱动」转向「胜率驱动」？\n 7:57 AI Coding 的爆发，打开了哪些新的创业思路？\nPart 2 AI 创业的两条主线：想象力 & 智能\n\n 13:08 怎么理解「想象力」与「智能」这两个方向？\n 15:35 对多模态产品路径的一些判断 16:23 还没到出现 AI 泛娱乐爆款产品的时机？\n 19:52 只做好创作工具可能还不够\n\n 20:25 做好内容平台的三大要素\n 23:29 会出现 AI 时代的抖音吗？\n 26:10 影像领域的模型能力和竞争格局是怎样的？ 28:28 为什么 Higgsfield 能跑得这么好？\n\n 31:47 怎样才能「做好套壳」？一些给创业者的建议\n 36:19 在「智能」方向上的一些思考\nPart 3 优化胜率才是正解\n\n 40:36 张一鸣、黄峥、王兴、小红……一流企业家都在优化胜率 43:23 赔率其实是等来的\n\n 45:23 探讨一下字节的优化策略 46:11 做公司是攻城更难，还是守城更难？\n\n 48:09 从赔率驱动到胜率驱动，实际的行为转变是什么？\n 48:39 最近研究段永平的一些感悟 50:03 从他和张一鸣身上学到的，有什么不同？\n\n 51:56 「优化胜率」会不会意味着更保守、反而错过机会？\n 53:29 什么叫「把一件事做到理论上该有的样子」？\n 54:33 26 年我们会重点关注的两个方向\n 55:29 选择做事机会时，应该怎样思考赔率和胜率？\n 58:01 招人！\n1:00:41 2 个彩蛋\n\n Sharp 就是极端\n 畅想一个算力无尽的科幻终局\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：Esperanza - Hermanos Gutierrez",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "《拒绝三亿美金 offer 的人》",
                "url": "https://www.xiaoyuzhoufm.com/episode/6505cb5496875579717a1369"
              },
              {
                "text": "《找 PMF 就是要做没壁垒的事》",
                "url": "https://www.xiaoyuzhoufm.com/episode/66ee95306920a36bfc9f1de1"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69a0b34b66e2c303778cd3ce",
            "index": 7,
            "title": "AI + 游戏 + 社交的新演绎 | 对谈 Wanaka 创始人张阳",
            "pub_date": "2026-02-28T13:00:00.000Z",
            "duration": "4553",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "创业",
              "商业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69a0b34b66e2c303778cd3ce",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/69a0b34b66e2c303778cd3ce/media.xyzcdn.net/648b0b641c48983391a63f98/lvpBxKvVz9yclRYSNWjJ-_XG1Qkp.m4a",
            "play_count": 13030,
            "show_notes_text": "张阳已经是第三次创业，并在 3 年内连续做出了 2 个 AI 项目。\n\n过去，张阳一直深耕社交与内容领域，在产品、增长和商业化等各个环节都有丰富经验，且很擅长出海：\n\n在字节，他曾从 0 打造过海外数千万日活的社交产品；他的第一个创业项目，曾冲上北美应用榜前三，甚至一度压过 TikTok；上一款产品 Answer.ai，也在一年内做到了北美的赛道 Top 1。\n\n带着如此亮眼的成绩，这一次创业，他又做出了新的突破——\n\n在市场还没有反应过来的时候，他就选择了「AI + 游戏 + 社交」这一方向，推出了一款名为 Wanaka 的产品。\n\n为什么他会选择这个方向？该如何理解游戏与社交之间的关系？Wanaka 想提供怎样的产品体验，又走了怎样不同的路径？实践一年后，产品经历了哪些关键迭代、他又获得了哪些关于游戏与社交的新理解？\n\n在这期节目中，我们逐一探讨了这些问题。张阳给出了非常 solid 的思考，也结合过往经历，分享了许多关于社交与游戏的实践经验与个人洞察。\n\n坦白讲，他的表达很平实，但和他共事过的人都非常认可他的产品能力。而且在我看来，难能可贵的是，他既足够稳重，又始终保留着对「好玩」这件事的热情和想象力。\n\n一期播客或许无法完整呈现他的思考与魅力哈哈，所以最后，不如就贴一段 Wanaka 的自我介绍吧，或许能让大家更直观地感受到他们的愿景：\n\n在 AI 已经从多个维度超越人类的今天，我们还要建造工具、发明产品的意义是什么？我们不期望为世界带来更多焦虑，也不期待让人们的生活变得更高效。我们只希望你能在这里，找回玩游戏到忘我的暑假，找回和朋友通宵玩乐、舍不得结束的那种快乐。Wanaka 已开启内测。欢迎大家呼朋唤友，一起建造属于你们的游戏世界，并在其中愉快地玩耍。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n12 号珍藏：张阳，Wanaka 创始人\n\n【时光机】\n\nPart 1 迭代复盘\n\n 0:20 连续创业的体悟\n 2:36 第三次创业，为什么选择「AI + 游戏 + 社交」？\n 3:14 AI + 游戏的两条主流路径 5:44 Wanaka 做出了怎样不太一样的选择？\n\n 11:38 为什么选择丢掉「上下滑交互」的产品形态？ 15:12 AIGC 内容可能会演化出三种分发形式\n\n 20:37 2D vs 3D 方案的抉择\nPart 2 实践理解\n\n 22:55 Roblox 到底为什么这么受欢迎？\n 26:09 为什么中国的游戏化社交做不大？\n 27:15 在北美，为什么新的社交产品总有机会火一把？ 28:33 但为什么绝大多数新产品还是会死掉？\n\n 31:55 怎样平衡游戏 & 社交之间的关系？\n 32:51 Wanaka 是怎样切社交市场的？\n 35:48 AI 给游戏赛道带来了时代性的机会？\n 41:46 Wanaka 最终迭代出了怎样的产品解决方案？\n 43:50 淬炼一年后，对「AI + 游戏 + 社交」的几点思考 47:01 怎么在游戏体验中实现社交？\n\nPart 3 个人思考\n\n 49:20 分享一些做社交和增长的核心认知\n 52:52 AI + 社交的两种可能性\n 58:54 「下一个抖音」这个命题其实不太成立？ 1:00:58 但即梦或有一个机会\n\n 1:03:20 产品早期会重点关注什么指标？\n 1:04:44 一个「感受型产品人」的产品思路 1:06:46 真正的大机会，往往无法通过逻辑推演出来？\n\n 1:09:55 最近因为 OpenClaw 而思考的一个问题\n 1:10:58 探讨：26 年 AI 会有什么大变化？\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：哪吒乐队 - 小分队",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "一年内做到了北美的赛道 Top 1",
                "url": "https://www.xiaoyuzhoufm.com/episode/65be63d8cace72dff87dddc0"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1764,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "698563a188663289fe80769a",
            "index": 8,
            "title": "从 Clawdbot 到 26 年 AI Coding 主题大爆发｜对谈 PingCAP CTO 东旭",
            "pub_date": "2026-02-07T14:00:00.000Z",
            "duration": "4285",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/698563a188663289fe80769a",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/698563a188663289fe80769a/media.xyzcdn.net/648b0b641c48983391a63f98/lrW05Gh-VfH-ovLmLZzQXejMrbOX.m4a",
            "play_count": 34367,
            "show_notes_text": "最近 Clawdbot（现在叫 OpenClaw）各种刷屏 🦞。\n\n事实上，不只是 Clawdbot，从 25 年年底开始，Claude Code、Cowork、Skills 等产品和概念就一直在霸占我们的信息流。相信很多朋友和我们一样，在应接不暇的同时，也产生了各种疑问：\n\n到底这些产品都是做什么的？为什么这些产品会在最近密集爆发？技术上出现了什么新范式？AI 的未来又会发生怎样的变化？\n\n为了得到答案，我们请回了一位老朋友——PingCAP CTO 东旭。在上一期节目中，东旭更多是以联创的身份，分享了他关于全球化的思考与方法论。但其实，他还有很多面相，比如野生音乐人、哲学爱好者，以及始终在技术最前沿冲浪、甚至每天能烧掉 billion 级别 token 的 builder。\n\n所以，他可能是这期节目最合适的嘉宾人选之一。\n\n在这期节目里，东旭就从大量一手经验出发，分享了他对各种热门产品的实操体悟，用简单好懂的方式讲清楚了许多技术变化，并给出了他对 AI 未来走向的判断与推演。\n\n在讨论过程中，我们也梳理出了一条 AI 的演进线索：AI 产品，正在从「套壳大模型」，向「套壳 Coding Agent」方向演进。未来，一切可能都建立在 Coding 和 Agent 之上。\n\n最后，不得不再一次感慨，AI 的变化实在太快了。新产品层出不穷，我们似乎也在不断逼近 AI 拥有自我演化能力，甚至是某种「终极形态」的临界点。\n\n在这样的节点上，或许我们不只需要高密度地输入信息，也需要面对随之而来的迷茫与焦虑。所以在节目结尾，我们还请东旭回答了几个彩蛋问题，希望也能给一些朋友带来一点平静和启发吧～\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n35 号珍藏：黄东旭，PingCAP 联合创始人、CTO，野生音乐人\n\n【时光机】\n\nPart 1 实操体悟\n\n 2:04 AI Coding 已经跃过了「奇点时刻」\n 3:18 25 年，AI Coding 的能力从多少分提高到了多少分?\n 4:44 未来应该禁止人类写代码？\n 6:49 Claude Code 开创了什么新范式？\n 8:35 过去一年，模型与 Agent 大幅进步的两个关键指标\n 13:54 Cowork 被高估了？\n 15:15 为什么说 Skills 比 MCP 更适合 Agent？\n 19:06 简单讲讲 Clawdbot 到底是个啥\n 21:22 关于 Clawdbot 未来可能性的一个猜想\n 21:48 Clawdbot 在本地跑 vs 在云端跑，有什么不同？\n 23:21 Clawdbot 和 Manus 有什么本质区别？\n 25:40 到底能用 Clawdbot 来干啥？一些真实的 Usecases 27:59 神奇（可怕）：AI 已经能自我演化了？\n\n 33:43 Clawdbot 最重要的意义\nPart 2 个人思考\n\n 35:14 今年 AI 可能会怎样发展？\n 37:10 未来 AI Coding 和人，应该如何分工？\n 40:52 创业可能只剩下两个方向\n 45:50 给工程师们的建议\n 48:21 AI 时代的组织形式会发生什么变化？\n 50:07 如果 1 个 Agent 已经足够强，为什么还需要 100 个 Agents 来协同？\n 51:03 一个构想：Skill 的下一步，可能是「Box」\n 54:42 无论是 AI 还是人类，高效协作都需要两个前提\n 59:20 东旭人生的底层驱动力是什么？\n 1:01:50 一个野生音乐人是怎么看待 AI 音乐的？\n 1:03:24 关于手搓编程的未来畅想\n1:05:11 彩蛋：一些 AI 浓度很低、存在主义浓度偏高的问题\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：Welcome to the Machine - Pink Floyd",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "上一期节目",
                "url": "https://www.xiaoyuzhoufm.com/episode/68274977457b22ce0d0dc9e9"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 902,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6961bd3af8b05f9f75c3edb8",
            "index": 9,
            "title": "All in AI 的第一个三年｜对谈绿洲资本合伙人张津剑",
            "pub_date": "2026-01-10T14:00:00.000Z",
            "duration": "4864",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "大模型",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6961bd3af8b05f9f75c3edb8",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6961bd3af8b05f9f75c3edb8/media.xyzcdn.net/648b0b641c48983391a63f98/ll07TIl2xuyGLCMBxon0WUy1zx4Z.m4a",
            "play_count": 26681,
            "show_notes_text": "新年的第一期节目，我们在智谱和 MiniMax 上市的钟声中开始。\n\n从 2023 年第一批信仰者入场，到如今第一批大模型公司完成上市闭环，AI 这波浪潮，已经完整走过了一个三年的小周期。相信大家和我们一样，有很多的感慨。\n\n站在这个特别的时间节点，我再一次邀请了老朋友津剑。\n\n津剑是我们第一期播客（投 AI 最猛的人）的嘉宾，他所在的绿洲资本，也是三年前最早押中 MiniMax 的投资方之一。无论是作为这一波浪潮中最早坚定重仓 AI 的信仰者，还是「最猛」的充值者，在这个小周期的末尾，津剑无疑是最合适的对谈对象。\n\n在这期节目里，我们用快问快答的形式，从 23 年最初 All in AI 的决策谈起，回看过去，展望未来，同时聊了聊在这场高速变化中，个体的收获与思考，以及对于「生命力」和「真」的理解。\n\n三年过去，轻舟刚过万重山。AI 的新纪元仍在持续展开，我们愿意相信，属于新一代中国创始人的前路，依旧光明灿烂。\n\n绿洲也在制作自己的播客节目《信号与噪声》(链接：https://www.xiaoyuzhoufm.com/podcast/6819d5a7e37664602a344e0e)，诉说更多关于生命力的故事，欢迎大家订阅关注！\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n1 号珍藏：张津剑，绿洲资本合伙人\n\n【时光机】\n\nPart 1 回顾与展望\n\n 2:07 过去三年，最正确的决定与最大的遗憾 3:30 投 AI 没有最猛，只有更猛\n\n 7:37 如果时光能倒流，如何降维打击做投资？\n 9:44 你对 AI 的认知，最大的迭代是什么？\n 11:18 你还相信 AGI 吗？\n 11:56 对未来三年有什么预期？\n 16:13 幽默一下：未来可能会出现「PPT 非遗传承人」\n 17:31 我不太喜欢「泡沫」这个词，太学究（甚至有点登？\n 19:54 引领改革的都是边缘人，创新一定发生在边缘处？\nPart 2 投资与市场\n\n 21:13 信息越过载、市场越嘈杂，越该如何做判断？\n 23:37 识人逻辑有什么变化？\n 24:42 AI 时代的资产策略：「long action, short thinking」\n 25:55 未来十年可能都会围绕一个词展开：主体性\n 32:13 当下真正值得关注的信号是什么？\n 34:54 智谱、MiniMax 上市，对市场意味着什么？\n 36:49 从投 MiniMax 到现在，对大模型的理解有什么变化吗？\n 39:48 大模型与具身，是通向 AGI 的南坡和北坡\n 41:32 具身的发展有三个阶段，市场认知仍处在第二阶段\n 45:54 绿洲最近关注和想投的方向\n 48:32 我对 26 年的中国市场非常乐观\nPart 3 参赞生命力\n\n 50:37 怎么理解「生命力」？\n 52:23 怎么活出自己？——由「不吃晚饭」悟出的道\n 57:25 分享一个研究 AI 带来的启发\n 1:00:52 如果人生是一场强化学习，你的奖励函数是什么？\n 1:03:02 投资的成败，到底在多大程度上可以归因为运气？\n 1:06:00 播客给津剑带来了什么？ 1:07:55 反问曲凯：播客又给你带来了什么？\n\n 1:11:03 给每个人未来三年的最大建议 1:13:11 未来，人可能只有两种生存策略\n 1:15:24 一个具体的例子：俊杰是怎样做决策的？\n\n 1:17:13 要相信这一代中国创始人的全球视野与创新能力\n【张津剑 @42章经 系列回顾】\n\n播客\n\n世界加速分化下，我们的机会在哪里？2025.6.2\n\n世界好像变难了，我们该如何应对？ 2024.5.26\n\n投 AI 最猛的人 2023.7.30\n\n文章\n\n投资中的节奏与结构 2023.6.18\n\n投资中的周期与载波 2021.3.14\n\n投资决策中的信噪比 2020.2.23\n\n投资中的信号与噪声 2018.12.2\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：明日へ向かって (向明天出发) - 長渕剛",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "投 AI 最猛的人",
                "url": "https://www.xiaoyuzhoufm.com/episode/64c542a399e1e7669e56d4da"
              },
              {
                "text": "世界加速分化下，我们的机会在哪里？",
                "url": "https://www.xiaoyuzhoufm.com/episode/683cdd6c38dcc57c641216cb"
              },
              {
                "text": "世界好像变难了，我们该如何应对？",
                "url": "https://www.xiaoyuzhoufm.com/episode/6651b7a4c59d1e575797a520"
              },
              {
                "text": "投资中的节奏与结构",
                "url": "https://mp.weixin.qq.com/s/1bwTtJBi4vF5DEsLWFkAKw"
              },
              {
                "text": "投资中的周期与载波",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651049973&idx=1&sn=842cc37798360f367d1e63be336f47a0&chksm=8c38c05dbb4f494b072c90bb3fe80e48397373600081d20ba87f72b895d6d9f027321ad044e6&scene=21#wechat_redirect"
              },
              {
                "text": "投资决策中的信噪比",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651049307&idx=1&sn=2eee9b484a94b476a215ae23f0e7a83c&chksm=8c38c2f3bb4f4be5d45d12bcccd4c1086e000e376128d2deb4b63145a35546cc7200455d8196&scene=21#wechat_redirect"
              },
              {
                "text": "投资中的信号与噪声",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651048827&idx=1&sn=51dd4a5e6b428a842591723453b68825&chksm=8c38c4d3bb4f4dc50d961db0869529b1aebb6b093c1b31d29f49437b21d648507e62b3c53b91&scene=21#wechat_redirect"
              },
              {
                "text": "https://www.xiaoyuzhoufm.com/podcast/6819d5a7e37664602a344e0e",
                "url": "https://www.xiaoyuzhoufm.com/podcast/6819d5a7e37664602a344e0e"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1112,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "694e181744647f77684bb4f1",
            "index": 10,
            "title": "中美 AI 创投的真实差异｜对谈 Leonis Capital 合伙人 Jenny",
            "pub_date": "2025-12-27T14:00:00.000Z",
            "duration": "4100",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "创业",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/694e181744647f77684bb4f1",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/694e181744647f77684bb4f1/media.xyzcdn.net/648b0b641c48983391a63f98/lh3BbNd3MtLK-zVruSZLMFqSEXNy.m4a",
            "play_count": 15842,
            "show_notes_text": "我们今年的主线之一，是促进中美之间更真实的连接。今年的最后一期节目，也是这条主线的延续。\n\n这一次，我们邀请到了 Leonis Capital 合伙人、前 OpenAI 研究员 Jenny Xiao。她的背景很有意思：在美国长大，也在中国生活过 8 年；曾于 2021 年加入 OpenAI，却在 ChatGPT 爆火一周后毅然转身，创立了自己的基金。\n\n这种横跨中美文化，且兼具科研、创业与投资视角的复合背景，让 Jenny 对市场形成了多元且综合的理解。\n\n本期节目中，我们从市场、资本、融资及一线观察等多个维度，探讨了中美创投环境中的真实差异：为什么美国投资人偏爱 To B，甚至「看不懂」To C？中美投资人在决策逻辑与审美偏好上有哪些本质不同？中国创业者如果想做海外市场、拿美国的资金，全流程是怎样的？以及，眼下硅谷争论最激烈的几个问题是什么？\n\n整体聊下来，会发现中美之间的差异并没有很多人想象中那么大。很多时候，我们给硅谷加上的那层滤镜，更多来自信息的不对称。这也是为什么我们今年持续尝试打破两地之间的信息差，把硅谷正在发生的变化、判断和节奏，尽可能传递给国内的创业者。\n\n最后，2025 年即将过去。前不久小宇宙的年度盘点显示，我们的节目在过去一年里被播放了 176996 小时。如果直观感受一下这个数字，可以这样理解：\n\n176996 小时意味着在这一年的每一秒钟，平均都有 20 个人正在塞着耳机听我们的声音。也就是可以想象，在这个星球的某个角落，永远有一间坐着 20 个人的小沙龙，窗外四季流转，但里面的人永远静静地听你聊天。这个房间，从未熄灯。\n\n感谢大家过去一年的同行❤️。在 2026 年即将到来之际，也提前祝大家新年快乐！\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n45 号珍藏：Jenny Xiao，Leonis Capital 合伙人、前 OpenAI 研究员\n\n【时光机】\n\nPart 1 市场篇\n\n 00:53 为啥在 ChatGPT 爆火一周后却离开 OpenAI，并做了支基金？\n 3:34 老牌基金 vs 年轻基金，美国的创业者会怎么选？\n 4:55 回看 23–25 年：美国 AI 的几个关键 Milestones\n 6:44 展望 26 年：如果 Scaling Law 真的走到了尽头，还有什么新机会？\n 9:58 为什么美国投资人更偏爱 To B，甚至「看不懂」To C？\n 13:11 To Prosumer 产品在美国的最佳发展路径是怎样的？\n 16:06 「只有两三个大客户」是美国投资人最警惕的信号之一\n 17:05 在美国，To B 公司最现实的出路是什么？\nPart 2 投资篇\n\n 18:23 美国投资人会怎样考察一个创业者？ 21:18 大家更「看人」还是更「看事」？\n\n 22:01 为什么美国投资人敢于下注非常年轻（甚至是辍学）的创业者？\n 24:58 一组数据：美国顶级 AI 公司创始人的年龄分布\n 28:36 中美最受欢迎的创始人画像有什么异同？\n 30:10 硅谷当前 AI 公司的估值逻辑和区间是怎样的？\n32:27 AI 公司就不该沿用 SaaS 的定价方式\nPart 3 融资篇\n\n 36:21 全流程拆解：中国创业者想在美国融资，一共需要几步？ 38:21 在美国，用 FA 融资是一个减分项？\n 43:10 在找机构之前，更建议先融一波天使投资人\n\n 44:36 最好的 pitch 往往从主动提问开始\nPart 4 观察篇\n\n 46:58 中美创投审美的最大差异\n 48:09 分享几款最喜欢和看好的 AI 产品\n 50:11 明年美国 AI 的泡沫会破？\n 54:55 应用公司自己训模型，会是一个未来方向吗？\n 58:15 硅谷企业最近讨论最多的一个问题\n 1:00:04 Leonis 当前最明确想投的公司画像 1:00:25 一个很有意思的案例：AI 维修\n 1:03:00 我们更愿意投「替代人」的产品，而不是「赋能人」\n\n 1:03:52 给国内创业者的出海建议\n 1:07:08 Manus 能拿到海外融资，真正起作用的因素可能是什么？\n【今年关于中美连接的节目回顾】\n\n信念感与硅谷顶尖孵化器的奇遇：赴美三月，实现千万刀 ARR｜对谈 ACE Studio 创始人 Joe\n\n世界怎么就「东升西落」了？聊聊二级市场与 DeepSeek+Manus 的热潮｜对谈莫傑麟\n\n硅谷 AI 大转弯与二级市场的牛市｜对谈莫傑麟\n\nMercor 高速增长的秘诀与其中的聪明人｜对谈 Mercor 首位中国员工虞快\n\n组织能力才是 AI 公司真正的壁垒 | 对谈 Palona AI 联创任川\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：The Pied Piper - Crispian St. Peters",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "信念感与硅谷顶尖孵化器的奇遇：赴美三月，实现千万刀 ARR｜对谈 ACE Studio 创始人 Joe",
                "url": "https://www.xiaoyuzhoufm.com/episode/67c1faf7bf52a16cd1b80a7c"
              },
              {
                "text": "世界怎么就「东升西落」了？聊聊二级市场与 DeepSeek+Manus 的热潮｜对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/67de36c4dd11f9c8c150b8f0"
              },
              {
                "text": "硅谷 AI 大转弯与二级市场的牛市｜对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/68a821c942cc2798e7dd1f4a"
              },
              {
                "text": "Mercor 高速增长的秘诀与其中的聪明人｜对谈 Mercor 首位中国员工虞快",
                "url": "https://www.xiaoyuzhoufm.com/episode/68bbf7cc5faf3686594e9534"
              },
              {
                "text": "组织能力才是 AI 公司真正的壁垒 | 对谈 Palona AI 联创任川",
                "url": "https://www.xiaoyuzhoufm.com/episode/68ccfa75a56ca3e0c438706c"
              },
              {
                "text": "https://image.xyzcdn.net/FhDzelRyWwrgxSYzgYvKZ7HqTHW1.jpg",
                "url": "https://image.xyzcdn.net/FhDzelRyWwrgxSYzgYvKZ7HqTHW1.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 569,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "693285733fec3166cf688645",
            "index": 11,
            "title": "Dify 从被低估到成为明星项目，到底做对了什么｜对谈 Dify 创始人路宇",
            "pub_date": "2025-12-06T14:00:00.000Z",
            "duration": "4765",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/693285733fec3166cf688645",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/693285733fec3166cf688645/media.xyzcdn.net/648b0b641c48983391a63f98/loBSm2rmmxY7GiScNiiDo37PsTjJ.m4a",
            "play_count": 40252,
            "show_notes_text": "上一次和路宇录《这个男人帮 5 万个 AI 应用接上了大模型》那期播客，是在 2023 年。那时的 Dify 刚开源不久，大家对 AI 的理解也远不如今天，我们聊的还是 Prompt 工程怎么做、RAG 是什么之类的话题（现在回头看，恍如隔世…\n\n两年过去，AI 的世界翻天覆地。技术在加速迭代，新概念和新产品一波接一波。但在这样的浪潮里，Dify 却始终稳扎稳打，在竞争与质疑中一步步向前，成长为今天最知名、最具影响力的开源项目之一。\n\n很多人都没想到，一个名不见经传的小团队，会在短短两年里走到现在的高度。甚至直到今天，我仍常听到有人问：“为什么 Dify 能起来？它到底做对了什么？”\n\n于是，这期节目我想和路宇把过去两年里最关键的底层判断、战略取舍与组织思考，完整复盘一遍。\n\n节目的前半段，我们从竞争聊起：从 LangChain、Coze、GPTs、n8n 到 AgentKit，Dify 是怎么在一轮又一轮的外部冲击里站稳脚跟的？它在关键时间点做对了哪些选择，又坚持了哪些长期不变的原则？\n\n节目后半段，我们探讨了更多有关战略、全球化与组织的议题。比如：为什么路宇始终坚定 Workflow 的价值？为什么在几乎零销售的情况下，Dify 能服务多家财富 500 强企业，甚至在日本市场现象级流行？\n\n聊着聊着，我突然意识到，Dify 本质上是一张「寻找模型答案的藏宝图」。只要人类仍以组织的方式协作工作，无论外部技术如何变化，这张「地图」，始终会有它的价值。\n\n两年多过去，路宇没什么变化，依然纯粹、依然坚定，对底层问题的判断仍然异常清晰。\n\n但让我意外的是，在节目的最后，他主动讲起了一个许多创业者都会忽略的词：快乐。\n\n在他看来，创始人的任务是「把未来带到现在」。而要做到这件事，一个人必须保持在最自由、最敏捷、最有生命力的状态。\n\n所以，最后，也希望正在听节目的你，能在自己的节奏里保持快乐吧！\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n三号珍藏：张路宇，Dify.AI 创始人\n\n【时光机】\n\nPart 1「竞对」轮番登场，为什么 Dify 却岿然不动🌲？\n\n 1:20 2023→2025：市场认知与技术范式的三次迁移\n 4:11 Dify vs. LangChain 的本质差异\n 7:13 很多类似产品一定做不好，因为它们就没想清楚谁才有能力「用 AI 做好产品」 8:39 用 AI 做好产品所需的四种条件\n\n 10:58 Coze 发布时我确实焦虑过，但焦虑没有超过 48h\n 11:46 模型就像鱼，在不同的上下文鱼缸里会长成不同的样子\n 12:07 GPTs 不仅没有杀死任何产品，反而帮 Dify 做好了市场教育\n 13:32 n8n 是 Dify 最大的威胁吗？\n 15:57 AgentKit 在短期内不会对任何产品构成威胁？\n 17:51 与模型方 & 云厂商竞争的关键策略\n 19:25 很多人认为「工程不值钱」，但在我们看来，最值钱的恰恰是工程\nPart 2 长期主义的思考\n\n 22:26 一些关于产品迭代的思考\n 25:09 Workflow 会被替代吗？——我非常坚定地认为不会\n 28:52 Dify 坚信的技术路线 29:47 我从未相信 Transformer 架构是智能的终极答案\n\n 32:44 SaaS 真的会变成快时尚吗？\n 35:05 如果重来一遍，Dify 会怎样做得更好？\n 39:25 已经有企业把 Agent 和人类视为同等重要的劳动力资源了\n 45:42 为什么在几乎零销售的情况下，Dify 仍能拿下众多 500 强客户，并在日本市场风靡？\n 48:34 搭建全球化组织的经验\n 55:05 Dify 的本质，其实是一张「寻找大模型答案的藏宝图」\n 58:51 最近在思考的两个问题： 59:26 未来的人类还剩什么非对称的竞争力？\n 1:02:52 怎样才能让组织真正高效地运转？\n\n 1:04:08 Dify 从被低估到越做越好，最核心的原因是什么？\n 1:07:01 未来几年最大的结构性机遇\n 1:10:47 最后想说：创始人一定要快乐\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：声音玩具 - 时间",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "《这个男人帮 5 万个 AI 应用接上了大模型》",
                "url": "https://www.xiaoyuzhoufm.com/episode/64e040eb80c9ec4c5faf2868"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1431,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "692035926018cc2c98f08264",
            "index": 12,
            "title": "「你觉得 AI 有泡沫吗？」——有！｜对谈莫傑麟",
            "pub_date": "2025-11-22T14:00:00.000Z",
            "duration": "2882",
            "duration_label": "48m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "创业",
              "商业",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/692035926018cc2c98f08264",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/692035926018cc2c98f08264/media.xyzcdn.net/648b0b641c48983391a63f98/lpP8GvMaKgJvyhS0tJWqa-kMk1WT.m4a",
            "play_count": 17528,
            "show_notes_text": "活动预告🥳：11 月 29 日，我们会请到莫傑麟办一场线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\n现在的 AI 到底有没有泡沫？\n\n这是近期最受关注的话题，也是本期节目开门见山的第一问。\n\n在节目开头，我们先给出了自己的判断：\n\nAI 的价格确实有泡沫，但价值没有。尤其在中国一级市场，估值远比美国理性；而我们身边的一线 AI 从业者，也几乎不认为现在存在泡沫。而且即便有泡沫，也不一定是件坏事。\n\n那为什么反观社交媒体和二级市场，情绪却异常脆弱？\n\n面对这个巨大的认知温差，我又拉上莫傑麟，试图在情绪的噪音之外，梳理出这波泡沫背后更理性、也更结构性的逻辑。\n\n我们在节目中达成了一个共识：\n\n泡沫只是情绪化的表象，真正值得关注的，是行业正在发生的结构性变化。\n\n在几个月前的那期聊硅谷 AI 大转弯与二级市场牛市的节目中，我们曾聊到过，市场预期正在从 AGI 切换到产业落地。当下的泡沫，似乎正是这一转变的投射。\n\n而当叙事从 AGI 的「复利周期」切换到 ROI 的「算账周期」，我们更该关注的不是表层的泡沫，而是底层的信号： 这一轮周期是否到了交界点？下一代的 Winner 会是谁？OpenAI、英伟达等巨头的商业动作，又预示了怎样的未来格局？\n\n限于篇幅，还有很多内容没能展开。更多结构性的讨论，我们会放在 11 月 29 日的线上活动和活动群里。欢迎大家报名，一起讨论未来一年最值得关注的结构性变化（尤其欢迎 AI 从业者！）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n九号珍藏：莫傑麟，家族办公室资深从业者\n\n【时光机】\n\n 0:20 开门见山：现在 AI 到底有没有泡沫？ 0:48 一线从业者完全不认为有泡沫，反而很振奋？\n\n 4:29 这一次泡沫的论据虽然杂乱，但都指向同一个核心焦虑：ROI\n 6:01 这一轮泡沫讨论，与过去相比有哪些区别？ 7:24 这轮看空情绪的导火索是什么？\n\n 8:11 美股下跌，到底有多大程度可以归因于 AI 泡沫？ 10:48 市场似乎在合力寻找泡沫？\n\n 11:20 表层波动之下，真正驱动这波泡沫讨论的底层逻辑是什么？\n 19:41 中美一二级市场的泡沫浓度完全不同，国内一级反而最健康？\n 20:54 这波泡沫中最令人费解的一点：英伟达没怎么跌\n 21:55 在 AI 的脉冲式发展与诡谲的泡沫情绪里，两个最值得关注的信号 25:43 谁能给市场提供下一次信仰充值？\n 27:12 新周期里，谁最有可能成为最终 Winner？\n\n 29:03 泡沫是情绪词，很可能与中长期结论相反\n 30:50 如果一家公司（如 Manus、Kimi）一直被骂，反而是件好事？\n 31:22 二级市场的判断失真，从业者的判断反而更接近真实水位？ 32:04 二级投资范式，已经从「价值投资」迁移为了「Financial Engineering」\n\n 35:00 一个很有意思的观察：硅谷低估了字节的 AI 竞争力？\n 35:40 与其说泡沫，不如说我们正处于两个周期的交界处\n 39:03 给创业者的建议：在泡沫周期里，最该抓住的救生圈是什么？\n 42:11 25 年 Q3 最值得讨论的问题就不是泡沫\n【References】\n\n 为什么说 AI 还没到泡沫？等四篇 | 42章经 AI Newsletter 2025.11.9\n莫傑麟 @42章经 播客回顾\n\n 硅谷 AI 大转弯与二级市场的牛市｜对谈莫傑麟 2025.8.23\n 世界怎么就「东升西落」了？聊聊二级市场与 DeepSeek+Manus 的热潮｜对谈莫傑麟 2025.3.22\n 上半年 AI 市场有多差？别刚起跑就想冲刺 | 我答莫傑麟 2024.7.14\n 英伟达、Sora 与 AI 的三种核心叙事逻辑 | 对谈莫傑麟 2024.3.2\n 为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟 2023.12.3\n【活动预告🥳】\n\n11 月 29 日，我们会办一场线上活动。感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：泡沫 - 花儿乐队",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "硅谷 AI 大转弯与二级市场牛市的节目中，",
                "url": "https://www.xiaoyuzhoufm.com/episode/68a821c942cc2798e7dd1f4a"
              },
              {
                "text": "为什么说 AI 还没到泡沫？等四篇 | 42章经 AI Newsletter",
                "url": "https://mp.weixin.qq.com/s/l35m7SyAqgR9wChAthTVBg"
              },
              {
                "text": "世界怎么就「东升西落」了？聊聊二级市场与 DeepSeek+Manus 的热潮｜对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/67de36c4dd11f9c8c150b8f0"
              },
              {
                "text": "上半年 AI 市场有多差？别刚起跑就想冲刺 | 我答莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/669144fc8fcadceb90e98435"
              },
              {
                "text": "英伟达、Sora 与 AI 的三种核心叙事逻辑 | 对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/65e34a65da891a9cd9bf90f2"
              },
              {
                "text": "为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/656aeffd0500be931c4eb099"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcndcx5o3PcUohkxFJkTNaNEc"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TldNek1UbGlOekJsTWpKa1pUSmlOV1kyWTJNNVlXTmhaamswWVdVeVpEbGZSMkpLYTIwM1NWTkNla2R2TjNKMWMwRlpkbXA1TldZeGRtRm1ibUZ4U1RWZlZHOXJaVzQ2U1RKaVEySnVRbVJPYnpOVk0xaDRVVFpuZW1OUmJGSldibWxvWHpFM05qTTNNVGcxTURBNk1UYzJNemN5TWpFd01GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 760,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "690d657baf4fc00da78badba",
            "index": 13,
            "title": "2018 - 2020，抖音超越快手的关键三年｜对谈 Lessie AI 创始人于北川",
            "pub_date": "2025-11-08T14:00:00.000Z",
            "duration": "5089",
            "duration_label": "1h 24m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/690d657baf4fc00da78badba",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/690d657baf4fc00da78badba/media.xyzcdn.net/648b0b641c48983391a63f98/lu5USjEN2J0bGtjzmn9RqT57ipuW.m4a",
            "play_count": 29929,
            "show_notes_text": "前阵子，很多人可能都被一款叫 Lessie AI 的产品刷了屏。\n\n这期节目，我们就请到了它的创始人——于北川。\n\n北川在 18 年以校招生身份加入抖音，亲历了抖音从 4000 万日活一路狂奔、反超快手，成长为日活仅次于微信的庞然大物的全过程。\n\n节目前半段，我们请北川从内部视角，带我们复盘了抖音 18 - 20 年那段堪称神话的增长史：当时的抖音，在字节内部其实并不被看好？抖音最早是如何起量的，又为什么能在众多短视频产品中脱颖而出？以及，它是如何打赢 20 年那场决定命运的「抖快之战」？\n\n聊到后半段，我们把视角从产品转向了组织。到底是什么，让字节既高效又极致？在卷卷，甚至张一鸣手下工作，又是一种怎样的体验？\n\n我还问了北川一个本以为播不了的问题：既然字节优点那么多，为什么这几年还有这么多人选择离开？\n\n没想到，他坦然地给出了答案，也分享了自己离开后的核心思考，包括为什么要创业、做 Lessie AI 的逻辑链条，以及从大厂到创业这一路，他最深的感受与转变。\n\n作为 96 年出生的人，北川的谈吐有着超出同龄人的成熟。他无疑也是幸运的那一个：22 岁加入抖音，赶上了移动互联网的最后一波红利，也在那几年打过最真枪实弹的仗。\n\n但当红利散去，他和无数同龄人一样，陷入了焦虑，甚至一度感到绝望。\n\n还好在这时——用北川自己的话说：「某种意义上，AI 拯救了所有人的灵魂。」\n\n这句话听起来或许有些夸张，但北川说得极为真诚。\n\n我相信很多人都会有共鸣吧。AI 不只是新技术，更让一批人，重新看见了希望的曙光。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n44 号珍藏：于北川，Lessie AI 创始人，抖音团队早期产品经理\n\n【时光机】\n\nPart 1 抖音是怎样起量的？\n\n 2:29 18 年时，抖音在字节内外都不被看好？\n 5:30 抖音快速增长的关键节点\n 8:42 抖音立项的源点：一鸣画的一条线\n 9:58 为什么抖音涨得越快，团队反而越焦虑？\n 10:51 抖音一度把「社交」放在第一优先级，背后的考量是什么？ 15:17 为什么字节做不好社交？\n\n 16:52 同样是字节系，为啥头条「土到 low」、抖音却「有调性」？\n 18:05 抖音在起量时，短视频市场什么样？\n 20:32 决定抖音调性的三个关键 20:41 ① 坚决不从头条导流\n 20:51 ② UI\n 21:30 ③ 内容运营\n\n 23:04 优秀的年轻人是需要「打仗」的\n 25:21 为什么抖音在保有品味的同时，还能成功泛化？\n 28:16 单列 vs 双列，当年在抖音内部也有非常激烈的讨论 30:36 那为什么不 AB Test 一下？\n\nPart 2 字节的做事方式与组织文化\n\n 32:42 抖音能长到今天这么大，最核心的原因是什么？\n 34:41 为什么微视会失败，而视频号能成功？\n 37:19 抖音这个超级分发器，也有分发不好的东西？\n 39:49 字节做事，就是分发所有「无脑」内容？\n 41:10 当下抖音、小红书、快手之间的竞争格局\n 49:22 关键一战！抖音是怎样在 20 年春节反超快手的？\n 52:57 字节最重要的增长方法论\n 56:07 如果时光能倒流，我会怎样重做抖音？\n 58:24 字节最不一样的组织文化是什么？\n 1:00:42 一个本以为播不了的问题：为什么这几年那么多人离开字节？\n 1:02:46 「企业文化就是你招的前几十个人什么样」\n 1:04:08 在字节最核心的一点收获：极致思维 1:05:14 一鸣是怎样 push 大家追求极致的？\n\nPart 3 创业的思考\n\n 1:06:05 为什么要从字节出来创业？\n 1:07:07 我们一直在思考：什么样的产品不会被模型吃掉？\n 1:09:36 简单介绍下 Lessie AI 1:11:41 分享一下产品的推敲过程\n\n 1:18:08 从大厂到创业，需要的能力模型有什么不同？\n 1:20:47 灵魂拷问：如果字节也来做你们这个方向，你要怎么办？\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：Twilight Rush - 结冰水",
            "show_notes_source": "rss_description",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1673,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68fb18780156720321d444eb",
            "index": 14,
            "title": "OpusClip 增长秘诀：如果每个阶段只让我选一件事做 | 对谈 Opus 前增长产品负责人君陶",
            "pub_date": "2025-10-25T14:00:00.000Z",
            "duration": "3155",
            "duration_label": "52m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68fb18780156720321d444eb",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/68fb18780156720321d444eb/media.xyzcdn.net/648b0b641c48983391a63f98/lmTUTnHEJfT1d38OEZcXQtces9b3.m4a",
            "play_count": 19307,
            "show_notes_text": "当我们提到海外 AI 产品的时候，都会想到两款最成功的华人产品，就是 Heygen 和 OpusClip。\n\n在前不久的一场活动中，我们就邀请到了曾在 OpusClip 负责增长产品、亲历了公司从 0 到 1 再到 100 整个增长周期的谢君陶，分享他在实践中总结出的增长经验。\n\n他把每个阶段最重要的事、最常见的误区、踩过的坑和经验，都毫无保留地讲了出来。内容非常干货，也非常实在。\n\n于是我们决定，把那场活动中君陶的个人分享，以及我之后的一些提问，剪成一期节目带给大家。\n\n在前半部分，君陶从获客、转化、留存、洞察四个维度，提出了一套逻辑清晰、实战性极强的增长框架，也对许多创业者常遇到的核心问题给出了有理有据的回答。你将听到 Opus 内部最一线的实操，比如他们如何做增长、怎样和创作者合作、如何科学定价等等。\n\n在后半段的问答中，我们还讨论了更多创业者关心的话题，包括增长团队该怎么搭建、小团队如何用低预算跑好 AB Test、在付费与定价上，还有哪些实用经验与策略等等。\n\n聊下来，其实增长这件事并不是 rocket science，也没什么神秘的 secret sauce，很多时候就是需要在该做的地方，把事情做得更科学、更好，然后真的落地。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n43 号珍藏：谢君陶，OpusClip 前增长产品负责人，目前正在视频创作产品创业中\n\n【时光机】\n\nPart 1 获客\n\n 1:21 冷启动最先要想清楚的一个问题\n 2:25 你的第一批用户，应该是 Partners，而不是 Affiliates\n 3:43 产品该怎么做冷启动？ 3:52 当一个视频产品找到了 PMF，它就会自带破圈力\n\n 4:36 为什么必须与创作者形成利益共同体？\n 6:08 案例：OpusClip 成功冷启动的一大关键策略\n 6:57 常见误区：冷启动阶段，宣传不是铺得越多越好\n 7:26 去哪精准找到第一批种子用户和 KOL？\nPart 2 转化\n\n 8:15 早期有效且确定性高的转化抓手：定价策略\n 9:30 产品调整定价的核心策略是什么？ 10:15 优秀示例 1：RunwayML\n 10:58 优秀示例 2：Higgsfield\n 11:42 总结：视频和创作者生态中的一大付费点\n\n 12:03 定价调整的关键经验\nPart 3 留存\n\n 15:42 留存为什么是最重要的增长指标？一道简单的算术题 16:25 高留存，是实现复利式增长的基石\n\n 17:18 那要怎么提高留存率？ 17:35 Stripe 创始人的一句话，点明了两条路径\n\n 19:02 怎么构建高效的用户反馈闭环？\n 20:02 案例：为什么 OpusClip 要花大成本去做好客服？\nPart 4 洞察\n\n 21:45 怎样才能做到真·数据驱动？\n 22:09 应该优先做哪些 AB Test？ 22:56 付费弹窗是早期最简单、暴利的测试\n 23:09 做 AB Test 的过程，也是理解用户 Aha Moment 的过程\n\n 23:39 哪怕在产品早期，也有很多获取用户数据的方式 23:48 例 1：邮箱后缀\n 24:15 例 2：已有用户的社媒账号\n\n 24:36 创业公司该如何规划在数据上的投入？\nPart 5 Q&A 精选\n\n 27:20 怎样搭建增长团队？透露一下 OpusClip 的架构\n 30:52 做增长产品的过程，就是找到 PMF 的过程？\n 31:59 初创团队完全可以 0 成本快速跑 AB Test\n 32:50 案例分享：一个付费点抓得极准的产品\n 34:29 最好的 AB Test 不在于验证已有想法，而在于让你学到意料之外的事 34:39 举例：我们通过 AB Test 测出过一个意想不到的机会点\n\n 35:44 绝大多数 AI 产品都有蛮大的涨价空间？\n 36:56 周费、月费、年费…付费模式到底该怎么选？\n 38:21 什么情况下该做付费测试？\n 40:11 增长团队怎么提效？分享一些好用的工具 40:56 Pass Due Payment 是一个隐藏的留存金矿\n\n 42:32 OpusClip 过去几年最正确的决策\n 45:02 分享一些对 AI 视频市场的观察 48:56 AI 视频产品最大的卡点是什么？\n\n【节目中提到的公司/产品】\n\nRunwayML、Higgisfield：AI 视频生成产品，是定价策略的优秀案例\n\nIntercom：客服支持工具\n\nCanny：用于结构化收集用户的功能需求\n\nstatsig：可帮助创业公司快速搭建 AB Test 基建的 SaaS 工具\n\nArcade Software：用于制作产品 Demo 的软件，是付费转化的优秀案例\n\nMintlify：可以用于搭建 Help Center，提升客服团队效率\n\nListen Labs：用户调研产品，曾进行大幅定价调整\n\nPixverse：君陶比较看好的 AI 视频产品\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：走过咖啡屋 - 千百惠",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "https://image.xyzcdn.net/FtdfymXAhkx16J8lyYATkLgvhUhv.PNG",
                "url": "https://image.xyzcdn.net/FtdfymXAhkx16J8lyYATkLgvhUhv.PNG"
              },
              {
                "text": "https://image.xyzcdn.net/Fh277Pyw3Df-u7DQku4cNoMlSLPw.PNG",
                "url": "https://image.xyzcdn.net/Fh277Pyw3Df-u7DQku4cNoMlSLPw.PNG"
              },
              {
                "text": "https://image.xyzcdn.net/Fj6pYYjDXoKkKWthkP1Gor7fTwh5.PNG",
                "url": "https://image.xyzcdn.net/Fj6pYYjDXoKkKWthkP1Gor7fTwh5.PNG"
              },
              {
                "text": "https://image.xyzcdn.net/FsTllk7b400pj-tYT-DfJac3gqfF.PNG",
                "url": "https://image.xyzcdn.net/FsTllk7b400pj-tYT-DfJac3gqfF.PNG"
              },
              {
                "text": "https://image.xyzcdn.net/Fv7U9d73jbRdNvJM6OEEo4nnIiPD.PNG",
                "url": "https://image.xyzcdn.net/Fv7U9d73jbRdNvJM6OEEo4nnIiPD.PNG"
              },
              {
                "text": "https://image.xyzcdn.net/FnSPzREZayHLxxitC3SVII_Dohb4.png",
                "url": "https://image.xyzcdn.net/FnSPzREZayHLxxitC3SVII_Dohb4.png"
              },
              {
                "text": "https://image.xyzcdn.net/Fu9L2o8sc6xdGvytqPfgAwHfeSyf.png",
                "url": "https://image.xyzcdn.net/Fu9L2o8sc6xdGvytqPfgAwHfeSyf.png"
              },
              {
                "text": "https://image.xyzcdn.net/FujFhQzZ5ZF_HzxBEuc5lTWTcV6I.png",
                "url": "https://image.xyzcdn.net/FujFhQzZ5ZF_HzxBEuc5lTWTcV6I.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 996,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68e8a8fd525f51df3895a239",
            "index": 15,
            "title": "一个原教旨主义产品经理眼中的世界 | 对谈理想 SVP 范皓宇",
            "pub_date": "2025-10-11T14:00:00.000Z",
            "duration": "4941",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68e8a8fd525f51df3895a239",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/68e8a8fd525f51df3895a239/media.xyzcdn.net/648b0b641c48983391a63f98/ltsh-rZKJ6uFbC_UdMa-0EJ5B4Q-.m4a",
            "play_count": 34241,
            "show_notes_text": "这期播客，我们邀请到了理想汽车高级副总裁、SVP——范皓宇。\n\n皓宇的经历非常丰富：从工业设计起家，到手机、游戏、自媒体，再到今天的智能汽车。二十多年来，他跨越多个行业，亲历了中国过去二十年发展的黄金年代，也始终保持着一份理想主义和浪漫气质。\n\n这期播客我们定下了一个很纯粹的目标——不聊理想的具体业务，而是纯聊产品、人生。我们从皓宇因为热爱文艺而选择来到北京聊起，在对话中，我们穿梭了二十多年的时空。\n\n我们聊到他做了 25 年产品后的一些核心洞察：比如，在看似纷杂的经历中，他不变的底层能力和主线是什么？如何理解复杂的用户需求？以及，怎样做出一个「既要、又要、也要」的产品？\n\n除此之外，我们还探讨了一些更有哲学意味的话题，包括如何面对数据与个人品味的冲突、 「有趣」与「实用」之间的矛盾该如何取舍，以及，理想主义和实用主义之间的辩证关系等等。\n\n节目中，皓宇提到，许知远曾说他是一个纯粹的理想主义者。但我反而觉得不然——他身上既有脚踏实地的实用主义，也有热爱文艺、想改变世界的理想主义。正因如此，他才需要超出常人的意志力，在两者之间保持平衡，去实现那个「让世界变得更美好」的目标。\n\n和皓宇两个多小时的对话里，我最受感染的，是他身上那种乐观与笃定。希望这期节目，也能让你感受到他那种黄金时代留下的精气神，并从中获得一点乐观与信念的力量。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n42 号珍藏：范皓宇，理想汽车高级副总裁、SVP\n\n【时光机】\n\nPart 1 浅忆黄金年代\n\n 2:10 一个文艺青年的自白：为什么总有人向往和留恋北京？\n 5:32 为什么最早一批互联网创业者如此理想主义、充满精气神？\n 9:10 创业的黄金年代是怎样被造就的？ 9:19 原因一：中国在过去二十年经历了三重变迁\n 10:32 原因二：人的流动\n\nPart 2 二十五年的产品和用户观察\n\n 13:56 分享：自己最满意的一次产品设计\n 14:38 做游戏、做自媒体、做产品…看似纷杂的经历背后，共通的底层能力是什么？\n 18:20 为什么做产品不能一味依赖数据反馈？\n 21:07 如何平衡产品的「有趣」与「有用」？\n 21:46 Maker、User、Designer 的三角关系 22:24 工业化如何分离了 Maker 和 User？\n 22:39 以苹果为代表的产品又怎样分离了 Designer 和 Maker？\n 22:48 AI 出现后，这三者的关系还会怎样变化？\n\n 26:15 如何理解用户、做好大众产品？ 27:20 一二线城市与下沉市场的用户需求有什么不同？\n 32:26 过去几十年间，中国用户不变与变化的需求分别是什么？\n 36:06 大众的审美和品味，其实一直在提升\n\n 37:14 注入鸡血！在中国做产品，是一件幸福且充满希望的事\nPart 3 产品哲学\n\n 39:42 品味的本质 42:03 当数据反馈与品味发生冲突时，该怎么办？\n\n 45:46 在不确定与逆境中，如何坚定地持续创造？\n 47:47 实用主义是理想主义的前提？\n 48:31 做产品怎么实现「既要又要」？\n 52:35 做软硬件产品的异同\n 53:43 如何找到真实的用户需求？\n 56:22 产品人与用户之间的三种关系：神、仆、友\n 59:54 最想分享的产品哲学：衡量好产品的「四个声音」\n 01:03:18 在 AI 时代，Maker、User、Designer 之外还会诞生一个新角色？\n 1:06:22 「有趣」可以被设计吗？为什么？\n 1:09:16 做产品一定不能只讲逻辑？\n 01:16:16 如果「有趣」与「有用」必须二选一，该如何取舍？\n 1:17:47 为什么 AI 会逼迫组织发生端到端的自我革命？\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n 片头：Mondo Bongo - Joe Strummer & The Mescaleros\n 片尾：New Boy - 朴树",
            "show_notes_source": "rss_description",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1606,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68ccfa75a56ca3e0c438706c",
            "index": 16,
            "title": "组织能力才是 AI 公司真正的壁垒 | 对谈 Palona AI 联创任川",
            "pub_date": "2025-09-20T14:00:00.000Z",
            "duration": "2668",
            "duration_label": "44m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 2,
            "matched_keywords": [
              "AI",
              "创业"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68ccfa75a56ca3e0c438706c",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/68ccfa75a56ca3e0c438706c/media.xyzcdn.net/648b0b641c48983391a63f98/linculSOkGSpp5xWbol6ChbFcSPp.m4a",
            "play_count": null,
            "show_notes_text": "我一直认为，在 AI 时代，组织形式的重要性被大大低估了，但长远来看，它很可能成为创业公司最核心的竞争壁垒。因此，我最近一直在和各种人探讨 AI 时代的组织形式。\n\n在上期和 Mercor 首位中国员工虞快的对谈中，我们也曾聊到过这个话题，但没来得及深入展开。于是，我又请来了一位在湾区创业的朋友——Palona AI 的联创任川，和虞快一起做了一场活动，继续探究硅谷最先进的组织形式。\n\nPalona AI 是少数在思考、真的在实践 AI Native 组织形式的公司，而且成立后不久，他们就把 AI 全面嵌入了研发流程中（比如他们 90% 的代码都是 AI 写的），运转效率很高。在这次的活动中，任川毫无保留地分享了他们打造 AI Native 工程团队的核心经验，对国内创业者极具参考价值，所以我们决定把他的分享剪出来，尽快分享给大家。\n\n在本期节目的上半段，任川从工作流、人才、组织三个维度，总结了一套可复制的实操经验。下半段则是现场交流，其中不乏很多好问题，比如怎么筛选真正会用 AI 的人、如何招到并留住顶尖人才等等，也很精彩。\n\n刚听完任川的分享时，我有点感慨也有点兴奋：这场分享的听众，或许正在见证新时代组织形式的诞生与变革。虽然这句话听起来有点大哈哈，但这确实是我当时最真实的感受。所以，也希望这期节目能给大家带来一些启发。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n41 号珍藏：任川，Palona AI 联合创始人，前 Google、LinkedIn 工程师\n\n【时光机】\n\nPart 1 用 AI 重构研发工作流的经验\n\n 3:51 一个例子：AI 如何远不止十倍地提效？\n 5:55 ① 默认由 AI 承担所有研发工作 7:00 分享几个亲测好用的工具\n\n 8:18 ② 只要有 SOP，就没有 Claude Code 无法完成的任务\n 9:36 ③ 反直觉经验之减少人与人之间的交互\n\nPart 2 AI 时代最需要什么样的人才？\n\n 10:51 ① 人是 Context Provider 11:00 一个重要的观念转变：应该是人为 AI 提效，而不是反过来\n\n 12:33 ② 做 Fast Learner，快速掌握「最少必要知识」\n 13:27 ③ 每个人都是为最终结果负责的 Builder\n\nPart 3 AI Native 的组织与分工\n\n 14:37 怎么分工更高效？ 15:34 为什么工程师也应该去跑客户？\n\n 16:16 工程团队和其他团队怎么配合？\n 17:56 未来的组织结构可能什么样？怎么留住核心人才？\n\nPart 4 Q&A 精选\n\n 19:49 我们 20 人的团队，没有一个全职的 PM 20:47 未来可能没有 Engineer，大家都是 Builder\n\n 24:22 硅谷对 AI Native 的组织形式形成共识了吗？\n 26:09 大厂很难转型成 AI Native 的组织形式？\n 28:59 AI 有能力处理复杂的历史代码吗？\n 30:51 AI 还可以重塑什么工作流？\n 31:55 该如何打造 AI Native 的组织形式？\n 33:07 如何筛选出真正会用 AI 的人？分享两个方法\n 36:27 怎么衡量 AI Code Review 的效果？\n 39:54 不同阶段的公司分别需要设立什么样的岗位？\n 43:57 怎样招到并激励 AI 人才？\n【任川在节目中提到的工具&文章】\n\nCodeRabbit：AI Code Review 工具，可以把一次代码审查的时间从 1-2 天缩短到 10 分钟\n\nLinear：AI 项目管理工具，在其中创建任务后，可自动分配给 AI 生成代码\n\nDevin：华人团队开发的 AI 编程工具\n\nincident.io：日志分析与告警工具，可覆盖近一半的运维工作\n\n刘小排公众号 @刘小排r：大家可以去其中学习下他使用 Claude Code 的方法\n\n文章《「全职员工」的消逝与「合伙人」及「小时工」的崛起》：zhuanlan.zhihu.com\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "Mercor 首位中国员工虞快的对谈",
                "url": "https://www.xiaoyuzhoufm.com/episode/68bbf7cc5faf3686594e9534"
              },
              {
                "text": "CodeRabbit",
                "url": "https://www.coderabbit.ai/"
              },
              {
                "text": "Linear",
                "url": "https://linear.app/ai"
              },
              {
                "text": "Devin",
                "url": "https://devin.ai/"
              },
              {
                "text": "incident.io",
                "url": "https://incident.io/"
              },
              {
                "text": "zhuanlan.zhihu.com",
                "url": "https://zhuanlan.zhihu.com/p/1946082346362213602?share_code=hDJ0eCUlAGDx&utm_psn=1952701404734034630"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9T1RVME5UZGlOakV5TlRjNFpEZ3hOV0V5TURrMlpXVXdZakl6TmpRek1EZGZNa3RLVWtwbFJ6WldUVTFZUW1wR1lVcFJhRVV6ZDJ0aGVtTkhTMFp1WkdkZlZHOXJaVzQ2UlZJNFNHSjNWazEzYjFKalZUVjRaRWN6VjJOMk1scEZiamhtWHpFM05UZ3lOak0yTlRnNk1UYzFPREkyTnpJMU9GOVdOQQ=="
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TlRnNU0yWTFPVGMyWWpsa04yWmtOMk5sTXpOallUVTFNREprT1RoalkyTmZZMlJ5YVhCMlFqSm1TRWR0U1hadWQyMXNhMGhQVUV0a1RXdENOak0yYVZCZlZHOXJaVzQ2VjBKeFRtSnVSV3gzYjFCYVRteDRWbWhZVkdOeWFETnVibTVpWHpFM05UZ3lOak0yTlRnNk1UYzFPREkyTnpJMU9GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68bbf7cc5faf3686594e9534",
            "index": 17,
            "title": "Mercor 高速增长的秘诀与其中的聪明人｜对谈 Mercor 首位中国员工虞快",
            "pub_date": "2025-09-06T14:00:00.000Z",
            "duration": "3013",
            "duration_label": "50m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "创业",
              "商业",
              "科技",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68bbf7cc5faf3686594e9534",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/68bbf7cc5faf3686594e9534/media.xyzcdn.net/648b0b641c48983391a63f98/lj_PGvt_GjX_3g5Vzr9Borxh1yAj.m4a",
            "play_count": null,
            "show_notes_text": "活动预告🥳：9 月 13 日，我们会请到虞快和 Palona AI 联创任川办一场线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\n这次硅谷之行，我的一大收获就是认识了 Mercor 的首位中国工程师（节目录制时也是全司唯一的中国员工）虞快。\n\nMercor 是上半年硅谷最热的创业公司之一。\n\n它最初在大众印象中是一家 AI 招聘平台，但很快转型为直接与 Scale AI 等竞争的数据标注公司。\n\n这次转型，使得 Mercor 在短短 11 个月内就实现了年收入 1 亿美金，估值也迅速攀升至 20 亿美金。\n\n也正是这次转型，再次激起了我对 Mercor 的好奇：它究竟是一家怎样的公司？它相比于 Scale AI、Surge 等玩家的核心竞争力又是什么？\n\n在这期节目里，前半段我请虞快从内部人的视角，带我深入了解了 Mercor 的定位、业务流程、商业模式以及高速增长的原因等。后半段，我们则聊到了如何做出聪明的职业选择、硅谷创业公司的真实氛围、以及对识人用人的思考等等。\n\n节目的最后，虞快还现场出了两道 IQ 思考题，也欢迎大家和我一起挑战 ；）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n40 号珍藏：虞快，Mercor 首位中国工程师（节目录制时也是全司唯一一位中国员工），前金融科技独角兽工程总监，Google、Two Sigma、Citadel 工程师\n\n【时光机】\n\nPart 1 Mercor 的业务\n\n 1:57 AI 招聘？数据标注？Mercor 到底是做什么的？\n 03:05 为什么 AI Labs 不用 Scale AI、Surge，而选择 Mercor？\n 05:37 Mercor ToB 的商业模式是怎么跑通的？\n 09:01 拆解 Mercor 的产品和业务流程 09:06 ① 获客\n 10:00 ② AI Interview\n 10:52 ③ 匹配和验证\n\n 13:05 在 Mercor，你甚至能看到时薪 400 刀、推荐费 5000 刀的岗位（疯狂心动…\n 15:48 为什么 Mercor 的客户都很愿意花钱？\n 16:49 Meta 收购 Scale AI 的意图是什么？一些个人猜测\n 19:50 从 AI 招聘到数据标注，接下来 Mercor 的故事还能往哪走？\n 21:33 国内有可能复制出一个 Mercor 吗？\n 22:40 数据标注市场还有多大的增长空间？\nPart2 职场智慧与识人之道\n\n 24:22 什么样的创业公司才值得加入？\n 27:07 Mercor 招 PM 最看重什么？\n 27:48 国外更容易出现年轻有为的创业者？为什么？\n 30:21 美国人的 sales 和 marketing 能力是怎么训练出来的？\n 30:47 Mercor 高速增长的秘诀：快 31:38 决策要快，但决策的对错不重要？\n 32:25 执行要快，增长是驱动团队的第一要素\n\n 33:03 美国创业公司其实比国内的更卷？\n 35:20 分享一些招人的标准\n 36:42 怎么判断一个人是否聪明？ 37:21 示例：如何一秒钟学会一个新概念？\n 39:58 欢迎大家一起来挑战两道 IQ 题！\n\n 46:23 我从 Google 学到了什么？\n 47:23 到底该去什么样的公司？一个选工作的 tip\n 47:58 未来 AI 公司的组织形态会是什么样子？\n【活动预告🥳】\n\n9 月 13 日，我们会办一场线上活动。感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcn92DCzjp5QMCZ6914gsk5lc"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TlRSallUVXhOMlUxWkdFd05XSTJNMlExTnpVM09UWXhNRFF4WWpFM09EVmZOV2huY1U1d1RWcFlkRkprUjNBMFZYaHhNbWR0WkhaQ1JtSkdNVVJqYURaZlZHOXJaVzQ2VnpoclFXSnFTa2xpYjI5eGFGZDRUWFI0VUdONGRucFFibTVsWHpFM05UY3hORGc0T0RNNk1UYzFOekUxTWpRNE0xOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68a821c942cc2798e7dd1f4a",
            "index": 18,
            "title": "硅谷 AI 大转弯与二级市场的牛市｜对谈莫傑麟",
            "pub_date": "2025-08-23T14:00:00.000Z",
            "duration": "4867",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 6,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "商业",
              "大模型",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68a821c942cc2798e7dd1f4a",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/68a821c942cc2798e7dd1f4a/media.xyzcdn.net/648b0b641c48983391a63f98/lpD9n6rE-fSSfBJO5zmFl0jbqrOM.m4a",
            "play_count": null,
            "show_notes_text": "这又是一期录制于硅谷的节目。\n\n差不多半年前，我来美国和莫傑麟聊了一期「东升西落」的市场叙事。彼时，DeepSeek 和 Manus 刚刚点燃了国内市场的信心和热度，也一度让美股跌入深坑。\n\n半年过去，市场再次风云变幻：美股落了又升、GPT-5 发布、Agent 热潮冷却、以 Meta 为代表的大厂开启抢人大战……于是我又拉上莫傑麟，复盘过去半年硅谷和市场的新变化。\n\n节目中我们聊出了一个核心结论：\n\nAI 正在进入一个全新的提速周期，但叙事的核心指标已从「Scaling Law」转向了「Token 消耗」。这意味着行业竞争正在从比「谁的模型更聪明」，转向拼「谁能把已有智能用得更好、更快、更省」。在这个趋势下，Infra 将成为下一个主战场，整合将成为关键词。\n\n除此之外，我们还聊到许多值得反复咀嚼的话题，比如：英伟达还能涨吗？散户在这轮波动中扮演了怎样的角色？当前这波 A 股到底算不算牛市？国内外一二级市场的热点有什么不同等等。\n\n最后，莫傑麟团队最近在做一个叫 WhatIf 的项目，希望把更多投研经验与 AI 实践结合起来。他们定期组织商业和投资的 Panel 讨论，如果你对中国和美国 AI 基础设施和应用公司研究有持续稳定的视角，且对宏观/二级市场策略感兴趣，可以在公众号「WhatIf Ideas」中提交注册信息，通过后加入讨论日历名单。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n九号珍藏：莫傑麟，家族办公室资深从业者\n\n【时光机】\n\nPart 1 AI 发展的新共识\n\n 00:59 硅谷 AI 大转弯，Token 消耗成第一指标？\n 4:17 模型并没有更聪明，但为啥 GPT 的日活和使用时长还在涨？\n 6:21 不讲 Scaling Law，是不是意味着大家不再预期 AGI 了？\n 07:31 GPT-5 就没想和其他模型拼智商\n 9:28 模型和应用的分工发生了什么变化？\n 12:33 为什么我们不希望大模型也来做应用？\n 18:56 今年有哪些亮点的应用方向？\n 22:14 我们已经没有太多工具可以去评估模型的好与坏了\n 23:42 GPT-5 标志着 AI 竞争将进入国内创业者的舒适区？\n 26:26 Infra 优化可以拆分为 4 层 27:05 简评两家推理加速公司：Together AI & Fireworks\n 28:53 应用层 Infra 的核心竞争力是什么？\n\nPart 2 硅谷市场趋势复盘\n\n 33:13 英伟达还能涨多久？\n 38:09 该出现的 Infra 软件已经出现得差不多了？\n 39:08 Google 和 Meta 最值得研究的点分别是什么？\n 40:31 2025 的 FOMO 情绪不减反增，且已经从「抢卡」延伸到了「抢人」\n 44:00 为什么说 AI 是美国市场上唯一的「泡沫」？\n 46:57 支撑英伟达估值的逻辑发生了变化\n 48:52 接下来值得关注的两件事： 48:59 ① Meta 砸钱招人有用吗？\n 49:20 ② AI 应用的真需求在哪？\n\n 54:48 这波 A 股到底是不是真牛市？怎么判断？\n 56:38 散户是这轮波动中非常值得研究的变量\n 59:59 A 股很难建立正反馈的闭环\n 1:03:31 美股三家值得持续关注的公司：Reddit、ServiceNow、Figma\n 1:08:41 哪类 AI 公司能在一级市场拿到最夸张的估值？\n 1:12:20 国内一级市场的两大趋势\n 1:13:38 42章经接触的创业者普遍会遇到什么问题？\n 1:15:51 Vibe Coding 会带来「一人公司」的繁荣吗？\n 1:18:13 我们年初关于 AI 发展的预测，正在逐步被验证：为什么我们对 25 年 AI 极度乐观｜AI 年终复盘\n【Reference】\n\n Agent 开发的上半场: 环境、Tools 和 Context 如何决定 Agent｜对谈 Sheet0 创始人王文锋\n 从 E2B 到 Browserbase，Agent Infra 新热点中有哪些大机会？ | 对谈 Grasp 创始人雷磊\n 关于 AI Infra 的一切 | 对谈阶跃星辰联创朱亦博\n莫傑麟 @42章经 播客回顾：\n\n 世界怎么就「东升西落」了？聊聊二级市场与 DeepSeek+Manus 的热潮｜对谈莫傑麟 2025.3.22\n 上半年 AI 市场有多差？别刚起跑就想冲刺 | 我答莫傑麟 2024.7.14\n 英伟达、Sora 与 AI 的三种核心叙事逻辑 | 对谈莫傑麟 2024.3.2\n 为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟 2023.12.3\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "「东升西落」的市场叙事",
                "url": "https://www.xiaoyuzhoufm.com/episode/67de36c4dd11f9c8c150b8f0"
              },
              {
                "text": "为什么我们对 25 年 AI 极度乐观｜AI 年终复盘",
                "url": "https://www.xiaoyuzhoufm.com/episode/6777d48a15a5fd520ecd1ea6"
              },
              {
                "text": "Agent 开发的上半场: 环境、Tools 和 Context 如何决定 Agent｜对谈 Sheet0 创始人王文锋",
                "url": "https://www.xiaoyuzhoufm.com/episode/68032a401f1db84a563d5d83"
              },
              {
                "text": "从 E2B 到 Browserbase，Agent Infra 新热点中有哪些大机会？ | 对谈 Grasp 创始人雷磊",
                "url": "https://www.xiaoyuzhoufm.com/episode/684cf1dd4abe6e29cb105710"
              },
              {
                "text": "关于 AI Infra 的一切 | 对谈阶跃星辰联创朱亦博",
                "url": "https://www.xiaoyuzhoufm.com/episode/688cc1cc8e06fe8de7d920cd"
              },
              {
                "text": "上半年 AI 市场有多差？别刚起跑就想冲刺 | 我答莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/669144fc8fcadceb90e98435"
              },
              {
                "text": "英伟达、Sora 与 AI 的三种核心叙事逻辑 | 对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/65e34a65da891a9cd9bf90f2"
              },
              {
                "text": "为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/656aeffd0500be931c4eb099"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "688cc1cc8e06fe8de7d920cd",
            "index": 19,
            "title": "关于 AI Infra 的一切 | 对谈阶跃星辰联创朱亦博",
            "pub_date": "2025-08-02T14:00:00.000Z",
            "duration": "3488",
            "duration_label": "58m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "创业",
              "大模型",
              "科技",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/688cc1cc8e06fe8de7d920cd",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/688cc1cc8e06fe8de7d920cd/media.xyzcdn.net/648b0b641c48983391a63f98/lkhmOdOOesDEETSXGFQV4cuVFSGe.m4a",
            "play_count": null,
            "show_notes_text": "活动预告🥳：8 月 16 日，我们会办一场线上活动，嘉宾是 Luma AI 模型产品 Lead 戴高乐、爱诗科技联创谢旭璋、前 OpusClip 增长产品负责人谢君陶，大家记得翻到 shownotes 末尾查看报名信息！\n\n本期嘉宾朱亦博可以说是国内最懂 AI Infra 的人之一。\n\n从微软、字节 AI Infra 负责人到谷歌、再到阶跃联创，他的职业经历几乎和 AI Infra 的发展并行，如他所说，贾扬清、李沐等人可能是 AI Infra 的开路者，而他则是紧随其后的第二批从业者。\n\n在这期播客中，亦博不仅分享了 AI Infra 的底层认知，也讲了很多行业的内幕故事与实战细节。我们从最基础的 AI Infra 定义聊起，解答了其在模型表现中的作用、重要性，也揭示了“优化指标”的意义与评判标准，并讨论了行业现状和未来发展等等内容。\n\n听完这期，你可能会意识到：在大模型时代，AI Infra 不只是「降本」的后台支持，也是决定一家 AI 公司能走多远的核心战斗力。\n\nBTW：阶跃最近刚刚开源了推理效率更高的基模 Step 3（github.com），亦博自己的团队也在招人中，感兴趣的可以联系邮箱：recruiting@step.ai\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n39 号珍藏：朱亦博，阶跃星辰联合创始人，前字节 AI Infra 负责人，也曾在微软、Google 任职\n\n 1:07 AI Infra 的定义\n 2:49 贾扬清、李沐是 AI Infra 的第一批人，我属于第二批\n 4:13 为什么说 Infra 迎来了一个新的 Google 级别的机会？\n 6:21 移动互联网 vs 大模型时代：两代 Infra 有什么异同？\n 7:38 算法人可能「只有 2 年的保质期」，Infra 更吃经验\n 8:40 怎么衡量 AI Infra 的好坏？几个关键指标\n 10:09 该不该、该怎么投入 Infra？一笔很好量化的 ROI 账\n 11:20 面对云厂商和模型公司的挤压，第三方公司的突破口是什么？\n 14:17 对 Infra 人的一句忠告：要么深入模型、要么深入硬件\n 16:15 AI Infra 对模型效果到底有多大的影响？\n 17:45 DeepSeek 能冲出来，一大原因是选对了优化目标 20:04 阶跃现在最重视的优化目标是什么？\n\n 22:06 Infra、算法、数据团队之间该怎么配合？有关组织架构的心得体会\n 28:41 做 AI Infra 最大的阻碍是什么？\n 30:16 模型范式不会那么快革新，但多模态可能是一个突破口\n 32:29 简评几家硅谷当红 AI Infra 公司\n 34:15 第三方 AI Infra 的创业机会在哪里？\n 36:35 我们想提升国产卡的竞争力，哪怕只有一点点\n 39:28 介绍一下阶跃新发布的视觉推理模型\n 46:30 DeepSeek 做得好，就是因为梁文锋懂 Infra？\n 47:54 一些业内真实的踩坑案例\n 55:13 给 Infra 从业者的一些建议\n 55:43 《The Bitter Lesson》的含金量还在上升\n【活动预告🥳】\n\n8 月 16 日，我们会办一场线上活动。感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "github.com",
                "url": "https://github.com/stepfun-ai/Step3"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcnTg1WWZ3KvQvyT5Bm57KXwh"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TkdKbE1qa3laVEl4TlRobVptUmhNVEkwWkdNNE4yWmxNVFV6TURRNE1qTmZOME4zWldWaWVVWlRUSFl3YkRVeFpXcHdlVGcxTWxSRWVVUTNSWGx2VmtOZlZHOXJaVzQ2V2sxTVZXSklRV1Z6YnpKMWRYUjRkRkkzZEdOUE4xUmFiazFtWHpFM05UUXdOVFE1TWpNNk1UYzFOREExT0RVeU0xOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6879ead0a9dec92500eab32e",
            "index": 20,
            "title": "并购的本质 | 对谈云磬投资创始人立阳",
            "pub_date": "2025-07-19T14:00:00.000Z",
            "duration": "3174",
            "duration_label": "52m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6879ead0a9dec92500eab32e",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6879ead0a9dec92500eab32e/media.xyzcdn.net/648b0b641c48983391a63f98/luD47Z239LhVMCv62W9AS-q_87Cz.m4a",
            "play_count": null,
            "show_notes_text": "最近，AI 创投圈接连出现了两起引人关注的收并购事件：智元机器人买入上市公司控股权、Windsurf 宣布被收购。\n\n收并购，似乎正越来越频繁地出现在创业者的视野中。\n\n相信大家对收并购这个词并不陌生，但未必了解其背后的资本逻辑，我们也一直对并购的运作方式有很多好奇之处。因此，本期节目我们请到了一位有十多年经验的资深并购投资人来一起聊聊收并购这件事。\n\n本期节目中我们聊到了智元近期的资本动作、并购基金与 VC/PE 的核心差异、一名优秀的并购投资人需要具备哪些关键能力，以及一桩复杂交易如何真正落地等。节目的最后，我们也请立阳从他的视角，给 AI 创业者分享了一些关于收并购的实用建议。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n38 号珍藏：张立阳，云磬投资创始人，有十五年的并购经验。此前，他曾先后任麦肯锡公司的战略分析师、中信资本的执行董事，及 TPG 亚洲基金的董事总经理。\n\n【时光机】\n\n 1:27 当我们说并购的时候，到底在说什么？\n 6:54 为什么很多一级市场的人开始做二级市场？\n 7:59 智元到底是不是在「借壳」？\n 10:11 做并购和做 VC/PE 的核心区别是什么？\n 12:14 并购是一件概率高、赔率低的事情？\n 15:04 并购投资人就像工程师，要通过财务模型拧紧每一颗螺丝\n 17:55 为什么很多并购基金喜欢把上市公司私有化？\n 19:27 并购的最大价值：通过改变生产关系解放生产力\n 20:59 并购通常都会管理层大换血吗？\n 28:25 找项目的两个流派：行业覆盖 V.S. 抓结构性机会\n 29:56 做 VC 是投梦想，做并购是盘生意\n 32:12 怎么协调各方复杂的利益关系？\n 36:13 一个案例：一场极限施压的伦敦闪电战\n 37:58 在顶尖 MBA 项目中学到的谈判技巧\n 44:51 做并购最关键的两件事\n 45:53 追 Alpha 就像气宗，追 Beta 则像剑宗\n 48:00 未来，并购在中国可能会怎么发展？\n 49:19 给 AI 创业者的几点收并购建议\n【Reference】\n\n 《门口的野蛮人》\n 单伟建《金钱博弈》（Money Games：The Inside Story of How American Dealmakers Saved Korea's Most Iconic Bank）\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "685f566108d8fd858662acd3",
            "index": 21,
            "title": "人生就是一场大 Sales，如何做一个更好的 BD？ | 对谈某科技家办戴安琪",
            "pub_date": "2025-06-28T14:00:00.000Z",
            "duration": "1998",
            "duration_label": "33m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 1,
            "matched_keywords": [
              "科技"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/685f566108d8fd858662acd3",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/685f566108d8fd858662acd3/media.xyzcdn.net/648b0b641c48983391a63f98/lrDu5aRrevFwzvku7w8BIOCSvSJB.m4a",
            "play_count": null,
            "show_notes_text": "本期节目录制于一次内部分享活动。因为我们每天都在找人、聊人，于是请来了在 BD 方面颇有经验的 Angie，分享她的一些方法和心得。\n\n坦白讲，起初我们有点犹豫到底要不要发布这期播客，因为担心内容听起来比较“功利”，但最后还是决定放出来——因为只要你需要与人打交道，无论是找合作方、组建团队，还是建立一个更高效的社交网络，这些方法都非常实用。\n\n在这次分享中，Angie 提供了一整套 BD 框架：从如何确认线索、获取转介绍、建联，到如何增信、促成转化和实现长期经营，她一一拆解了每个关键环节背后的策略与思路，我也在一些问题上有所补充。\n\n其实，所有行业最后的本质都是 BD，世界本身也是一场大的 Sales。当我们掌握了 BD 的核心方法，也就拥有了与人建立连接、达成合作、共同前行的能力。\n\n当然，技巧只是起点。希望我们都可以在日常实践中不断积累势能，慢慢从一个自下而上的链接者，变成一个拥有影响力的构建者。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n37 号珍藏：戴安琪，某科技家办副总裁，前36氪出海创始团队，科技&跨境出海 super node\n\nPart 1 线索确认和转介绍\n\n 00:49 明确客户画像和渠道画像，是一切的起点 1:04 目标客户可以从哪找？\n\n 5:21 思考题：你能脱口说出自己最牛的 1-3 点吗？\n 5:55 BD 分两种：① 专业型 ② 人格魅力型\n 6:47 要善用平台的杠杆、精准提炼你的机构价值\n 8:15 怎么筛选出一个靠谱的转介绍人？\nPart 2 怎么成功建联？\n\n 9:30 「你是不是一个 likeable person」这件事很重要\n 11:19 找人不仅靠努力和运气，也需要运营 sense\n 11:54 把废话说好是一项非常牛的技能\n 12:41 沟通中最消极的反应是不说话，任何其他反应都能给你带来机会\n 13:58 想在线下约到重要客户？装熟 + 积极主动 + 坚持不要脸\n 15:24 怎么才能把废话说好？ 17:46 对于有好奇心、爱学的人来说，任何事情都是素材和课堂\n 18:55 一个让对方舒服的聊天框架：5 分钟闲天 + 45 分钟对方关心的事 + 10 分钟自己的需求\n 19:31 关于聊天的节奏感\n\nPart 3 增信\n\n 20:26 任何细节都可以为你增信，包括你的微信头像\n 21:04 真诚是必杀技，不要在拿过更大结果的人面前耍小聪明\n 23:24 比较厉害的人都是理性判断、感性决策\n 24:34 做 BD 也需要动线设计，要在关键节点释放情绪价值\nPart 4 转化\n\n 25:29 成功转化的核心：需求匹配 + 关系到位\n 27:46 把长期主义纳入每一次 BD 的微决策\n 29:39 只有当你知道自己想要什么时，别人才知道该怎么帮你\n 30:22 世界本身就是一场巨大的 Sales\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "684cf1dd4abe6e29cb105710",
            "index": 22,
            "title": "从 E2B 到 Browserbase，Agent Infra 新热点中有哪些大机会？ | 对谈 Grasp 创始人雷磊",
            "pub_date": "2025-06-14T14:00:00.000Z",
            "duration": "3275",
            "duration_label": "54m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/684cf1dd4abe6e29cb105710",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/684cf1dd4abe6e29cb105710/media.xyzcdn.net/648b0b641c48983391a63f98/luiCb1QuKUYyvmPHl__BpvrG9pck.m4a",
            "play_count": null,
            "show_notes_text": "活动预告🥳：6 月 21 日，我们会请到雷磊和 Gus (Memobase & nano-graphrag 作者，solo 项目 GitHub 获 5000+ Star) 办一场线下活动，大家记得翻到 shownotes 末尾查看报名信息！\n\nAgent 赛道自今年年初被 Manus 引爆以来，热度持续了好几个月。有非常多各种方向和概念的 Agent 项目已经拿到融资，而很多人也已经开始思考：\n\n下一波机会，会出现在哪里？\n\n我们看到的可能性之一，就是 Agent Infra。\n\n原因在于，如果未来真的会有万亿个 Agent，它们将不再只是「工具本身」，而会反过来成为无数软件的「终端用户」。而由于 Agent 和人类的行动模式存在本质区别，我们很可能需要重新设计整个 AI-Native 的软件体系，从代码环境、浏览器，到各种工具，全部为 Agent 重写一遍。\n\n于是本期节目，我们请来了 Grasp（一款给 Agent 用的浏览器） 创始人雷磊，一起聊聊他对 Agent Infra 的观察与思考。我们讨论了「给 Agent 做产品」与「给人做产品」在底层逻辑上的差异、Agent Infra 的两大明星项目 E2B 和 Browserbase，以及这个领域未来可能出现的创业机会等等。\n\nGrasp 现已开放 waiting list 申请：https://getgrasp.ai，即将内测。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n36 号珍藏：雷磊，Grasp、AirCode 创始人，连续创业者，前字节开发者平台轻服务产品负责人，超过十年开发者领域经验\n\n【时光机】\n\n 1:03 Agent 热潮之后，下一波机会可能是 Agent Infra\n 3:55 未来应该是「人为 Agent 服务」，而不是「Agent 为人服务」？\n 6:17 人与 Agent 的核心区别 6:22 ① 工作范式：人是单线程，而 AI 是多线程\n 7:23 ② 责任与安全边界：人可以对自己的行为负责，但 AI…\n\n 10:49 Agent Infra 产品最关键的是什么？\n 13:03 被 Manus 带火的 E2B 到底是个啥？\n 15:02 虚拟机、云、沙盒、E2B 的关系是什么？ 15:54 Agent 产品一定是在云端运行\n 18:35 云厂商就像「地产商」，而 E2B 类产品是「装修商」\n\n 21:02 什么团队适合做 E2B 这样的产品？\n 26:49 Agent Infra 产品 = 给 Agent 用的 SaaS\n 28:32 海外当红的 Browserbase 又是做啥的？\n 31:48 给 AI 用的浏览器 V.S. 给人用的浏览器有哪些区别？\n 35:55 Agent Browser 的三层架构：Runtime + Agentic + Knowledge\n 42:40 为什么说今天的 Browser Use 很像 23 年的 AI Coding？ 44:35 二者都还有上千亿美金的市场增长空间\n\n 47:46 Agent Infra 还有哪些值得重做一遍的机会？\n 49:04 一个迷思：有没有可能 AI 根本就不需要人类的反馈？\n【活动预告🥳】\n\n6 月 21 日，我们会办一场线下活动。感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcnbNIIfnc0Qa8QOwBxviybpf"
              },
              {
                "text": "https://getgrasp.ai，即将内测。",
                "url": "https://getgrasp.xn--ai,-rz1e71gk8tio3a./"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9WlRBM01qUTJNek14WW1RME9HSTVOMlJpWTJRMll6aGpZekZqWTJJM00yUmZVV0ZHVDB4aVoySlZjWFJMY25KSllWRmtPVkZ3ZVhkdlpqRTBZalEyV2s1ZlZHOXJaVzQ2VjNkV1UySlNORkZtYjFGMlZEQjRZM1pKUzJOT2FsTnpibmxrWHpFM05EazROekk1TlRJNk1UYzBPVGczTmpVMU1sOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "683cdd6c38dcc57c641216cb",
            "index": 23,
            "title": "世界加速分化下，我们的机会在哪里？ | 对谈绿洲资本合伙人张津剑",
            "pub_date": "2025-06-02T14:00:00.000Z",
            "duration": "3322",
            "duration_label": "55m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "Agent",
              "大模型",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/683cdd6c38dcc57c641216cb",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/683cdd6c38dcc57c641216cb/media.xyzcdn.net/648b0b641c48983391a63f98/ll7LArfWymQJk7OV_THk0ZI4aDn4.m4a",
            "play_count": null,
            "show_notes_text": "在去年那期播放量超 10w 的节目《这个世界变难了，我们该如何应对？》中，津剑从信号学的角度拆解了这两年世界变化的本质，给很多人带来了一个全新的思考万事万物的视角。而针对世界的新变化，津剑也在一年后为我们带来了他升级后的思考。\n\n这期节目的前半小时，你会听到津剑在我们线下活动中的个人分享。他从「频率与频谱」的角度出发，解释了这个世界为什么在加速分化？注意力机制为什么人类最重要的特质之一？ 为什么说 Agent 其实是一场感知革命？人类在 AI 时代的核心价值又是什么？节目的后半段，则是我和津剑的双人对谈。我们讨论了一些更具体的问题，比如怎么判断一个方向值不值得坚持？未来 5 年 AI 可能会发展成什么样等等。\n\n希望这期听完之后，我们都能更好地重建自己的注意力系统。\n\nAfter all. Attention Is All We Need.\n\n绿洲也在制作自己的播客节目《信号与噪声》(链接：www.xiaoyuzhoufm.com)，诉说更多关于生命力的故事，欢迎大家订阅关注！\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n1 号珍藏：张津剑，绿洲资本合伙人\n\n【时光机】\n\nPart 1 单人演讲《投资中的频率与频谱》\n\n 1:15 2025 年，世界在加速分化\n 1:20 分化的背后是注意力的失控\n 2:43 注意力是大脑进化出的主动滤波器\n\n 6:20 顶级企业家有一个共同特点——专注\n 9:12 拉尔森效应与世界的啸叫\n 11:33 这个时代的机会在变多，而不是变少\n 11:59 如何重建注意力机制？\n 15:26 作为一个多模态大模型，人类能感知到的世界是真实世界的 1/10^9\n\n 21:48 Agent 是一场感知革命，AI 能处理的模态和频谱理论上是无限的\n 25:27 从以「人」为中心组织工作，到以「AI」为中心组织工作\n 28:49 Wishful thinking 是一种懒惰\n 30:03 人类因为自身的有限性而进化出了审美 ，这也是 AI 时代人最核心的价值\nPart 2 双人对谈《人的有限与无限》\n\n 33:58 怎么找到真正值得注意的事，并坚持下去？\n 40:17 绝症面前，人会改变自己，还是接纳自己？\n 42:39 分享两个提高决策力的方法\n 43:48 区块链与 AR&VR 被低估了\n 47:06 未来 5 年，人 和 AI 之间的关系可能会发展成什么样？\n 49:01 工业革命：体力→智力，AI 时代：智力→心力\n 50:53 未来的智能会像今天的电一样\n 51:54 什么是新时代的「家电三件套」？\n 53:10 分化世界下，普通人还有机会吗？\n【Reference】\n\n张津剑 @42章经 系列回顾\n\n播客\n\n世界好像变难了，我们该如何应对？ 2024.5.26\n\n投 AI 最猛的人 2023.7.30\n\n文章\n\n投资中的节奏与结构 2023.6.18\n\n投资中的周期与载波 2021.3.14\n\n投资决策中的信噪比 2020.2.23\n\n投资中的信号与噪声 2018.12.2\n\n（谢谢到场的每一位朋友！）\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "《这个世界变难了，我们该如何应对？》",
                "url": "https://www.xiaoyuzhoufm.com/episode/6651b7a4c59d1e575797a520"
              },
              {
                "text": "www.xiaoyuzhoufm.com",
                "url": "https://www.xiaoyuzhoufm.com/podcast/6819d5a7e37664602a344e0e"
              },
              {
                "text": "投 AI 最猛的人",
                "url": "https://www.xiaoyuzhoufm.com/episode/64c542a399e1e7669e56d4da"
              },
              {
                "text": "投资中的节奏与结构",
                "url": "https://mp.weixin.qq.com/s/1bwTtJBi4vF5DEsLWFkAKw"
              },
              {
                "text": "投资中的周期与载波",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651049973&idx=1&sn=842cc37798360f367d1e63be336f47a0&chksm=8c38c05dbb4f494b072c90bb3fe80e48397373600081d20ba87f72b895d6d9f027321ad044e6&scene=21#wechat_redirect"
              },
              {
                "text": "投资决策中的信噪比",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651049307&idx=1&sn=2eee9b484a94b476a215ae23f0e7a83c&chksm=8c38c2f3bb4f4be5d45d12bcccd4c1086e000e376128d2deb4b63145a35546cc7200455d8196&scene=21#wechat_redirect"
              },
              {
                "text": "投资中的信号与噪声",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651048827&idx=1&sn=51dd4a5e6b428a842591723453b68825&chksm=8c38c4d3bb4f4dc50d961db0869529b1aebb6b093c1b31d29f49437b21d648507e62b3c53b91&scene=21#wechat_redirect"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TXpBeU4yVmtPREl5TWpoallUY3hOVEprTkRnMVptWTJabVEwTkRFM09HVmZibU50TWxsVlkzTkZhV05WZDJKMWNuVmlia0Y2UTBZMFQyNXRZMHg2TTBaZlZHOXJaVzQ2V1VGT2VtSllUVXRzYjJSbllsTjRWRVJ1WVdORlpFZHlibGx0WHpFM05EZzRNVGt4TmpnNk1UYzBPRGd5TWpjMk9GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68274977457b22ce0d0dc9e9",
            "index": 24,
            "title": "关于 AI、开源、商业化与全球化的经验、教训和方法论 | 对谈 PingCAP CTO 东旭",
            "pub_date": "2025-05-17T14:00:00.000Z",
            "duration": "3236",
            "duration_label": "53m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "商业",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68274977457b22ce0d0dc9e9",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/68274977457b22ce0d0dc9e9/media.xyzcdn.net/648b0b641c48983391a63f98/ljw8Va0EvOBhz4OJzRULqZJvXW5-.m4a",
            "play_count": null,
            "show_notes_text": "活动预告🥳：5 月 31 日，我们会请到东旭办一场线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\nPingCAP 在前些年最被大家熟知的可能就是其非常高的估值，经常被 challenge 的则是其商业化的收入。而这两年很多人不知道的是 PingCAP 的国际化业务发展得异常好，且已经有了非常高的海外年收入。\n\n23 年我曾经请云启资本的陈昱分享过他投资 PingCAP 等知名公司背后的逻辑。在那期播客中，陈昱说他投资 PingCAP 的重要原因之一是发现他们团队有野心（选择了分布式数据库这个难度极高的方向）、且有实现野心的潜力（三个联创都是技术背景，代码写得很扎实）。\n\n两年过去，很开心今天终于能和 PingCAP 的联合创始人兼 CTO 黄东旭面对面聊天，听他亲口讲述这家估值 30 亿美金的数据库创业公司从 0 到 1 的实践和思考。\n\n在这期播客中，东旭坦诚分享了他们踩过的非常多的坑。我们聊到了 PingCAP 在发展过程中的关键决策、开源项目的运作逻辑与商业化策略，以及中国团队在海外市场的落地经验和商业化探索过程。此外，他也从他的视角聊到了很多关于 AI 的观察和思考。\n\n和他聊的时候，还意外得知原来他是一个弹吉他和贝斯、玩合成器的音乐爱好者，这个爱好，也是他创业十年来保持身心轻盈的重要原因之一 ；）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n35 号珍藏：PingCAP 联合创始人、CTO，PingCAP 最新公开估值已达 30 亿美元\n\n【时光机】\n\nPart1 PingCAP 从 0 到 1 的发展历程\n\n 1:21 PingCAP 到底是做什么的？—— 一个装数据的魔法杯子\n 6:55 PingCAP 十年来最关键的四个决策 7:10 ① 开源\n 7:30 ② 选择了关系型数据库这个难度最大、但期望最高的方向\n 8:37 ③ 做全球化\n 9:09 ④ 转型云服务\n\n 9:52 为什么 15 年还能长出一个数据库巨头？\n 12:58 为什么在商业化没做起来时，公司就能有 30 亿美金的估值？\n 18:47 商业化的摸索过程\nPart2 关于国际化的经验和思考\n\n 24:32 一个真·国际化的公司应该具备什么样的心态？\n 27:51 怎么判断自己的公司是不是真的做到了国际化？\n 32:33 在国际化的过程中，我们可踩过太多坑了…\n 34:03 先做美国市场是一个事半功倍的选择\n 34:49 这波 AI 创业者中我最看好 Day 1 就搬去美国的那一批\n 36:51 想融入当地环境？先招个本地销售，然后跟着 ta 一起跑客户\n 40:34 出海没有捷径，我过去十年尝试的所有花活基本上都失败了\n 43:57 出海华人创业者，第一容易高估语言障碍，第二容易高估商业化难度\n 45:23 一些关于 AI 的观察和思考 45:53 营销被大大低估了！不存在什么「酒香不怕巷子深」\n 46:42 AI 还缺一个通用的 sharing memory layer\n 49:26 我个人很看好企业服务端的机会\n\n【Reference】\n\n Agent 开发的上半场: 环境、Tools 和 Context 如何决定 Agent｜对谈 Sheet0 创始人王文锋\n 揭秘 Minimax、Zilliz、PingCAP 背后的投资逻辑 | 对谈云启合伙人陈昱\n【活动预告🥳】\n\n5 月 31 日，我们会办一场线上活动。感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "播客",
                "url": "https://www.xiaoyuzhoufm.com/episode/64d7b71de490c5dee544aca2"
              },
              {
                "text": "Agent 开发的上半场: 环境、Tools 和 Context 如何决定 Agent｜对谈 Sheet0 创始人王文锋",
                "url": "https://www.xiaoyuzhoufm.com/episode/68032a401f1db84a563d5d83"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcnX7hZowfyYxmvTQsxzQwBkh"
              },
              {
                "text": "https://image.xyzcdn.net/FoVvOyN2sax6o2gdMRD3pwtB_joI.png",
                "url": "https://image.xyzcdn.net/FoVvOyN2sax6o2gdMRD3pwtB_joI.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6818517a6970cc7b4db62789",
            "index": 25,
            "title": "AI 下半场：聊透 Benchmark 与 Evaluation | 对谈前 Kimi 产品经理丁丁",
            "pub_date": "2025-05-05T14:00:00.000Z",
            "duration": "2472",
            "duration_label": "41m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6818517a6970cc7b4db62789",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6818517a6970cc7b4db62789/media.xyzcdn.net/648b0b641c48983391a63f98/lp_jcN996FHUOEfSyqVpF1buoeQn.m4a",
            "play_count": null,
            "show_notes_text": "活动预告🥳：5 月 24 日，我们会请到丁丁和 Fellou 创始人谢扬办一场线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\n像 RL 这个概念一样，Benchmark 和 Evaluation 也是做 AI 的人经常挂在嘴边的词，但到底该怎么理解这个概念，该如何正确的设定这些问题和数值呢？\n\n正巧前不久 OpenAI 研究员姚顺雨的那篇《AI 即将进入下半场》特别火，他核心讲的就是「我们当下已经进入了 AI 的第二阶段——从解决问题转向定义问题，评估的意义会超过训练本身。而这其中，评估最关键的不是设置更难的基准测试，而是要在实际落地的场景中重新设计一套实用的评估标准」。\n\n所以这期我们请到了前 Kimi 产品经理丁丁，从她在大模型公司一年多的实践经验出发，请她分享些对于 Benchmark 和 Evaluation 的思考，相信大多数人听完这期都会对这些概念有更深的理解，也可以开始自己设定一些评估问题和标准了。\n\nP.S. 丁丁之前曾在微信做过 5 年的搜索产品，也在美团做过策略产品，所以在节目最后她也分享了一些从古典产品转型 AI 产品经理的心得。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n34 号珍藏：丁丁，前微信、美团、Moonshot 产品（负责 Kimi App）\n\n【时光机】\n\n 1:27 进入 AI 下半场，「重新定义 Benchmark」比「刷榜提分」更关键\n 3:23 回顾 AI 上半场，国内大模型公司的发展重心历经了哪些变化？\n 5:51 一味追求 DAU 是一种偷懒的经验主义\n 7:07 数据固然重要，但更多的用户数据 ≠ 更好的模型智能\n 9:28 如果你是梁文锋，你要不要承接这波泼天的用户？\n 9:59 Evaluation 和 Benchmark 是拉开模型差距的一大关键\n 14:40 对于没有标准答案的问题，该怎么制定 Benchmark？\n 17:55 怎么衡量 Benchmark 的好坏？\n 22:14 创业公司的 Benchmark 有多少道题比较合理？\n 22:38 能通过高频的用户 Prompt 反推出一套 Benchmark 吗？\n 24:23 让模型「突出长板」好，还是「全面均衡」好？\n 25:42 以 C.AI 类产品为例，示范一下该怎么设计 Benchmark\n 29:28 Benchmark 是团队的核心机密，算法同学都不应该告诉\n 30:07 AI 产品经理和古典产品经理有什么异同？\n 31:49 怎么更好地理解模型边界？\n 33:38 未来每个人都要具备全栈能力\n 35:38 做微信产品积累下来的 knowhow\n 39:52 分享一些招 AI 产品经理的标准\n【Reference】\n\n OpenAI Agent Researcher 姚顺雨的最新博客内容，探讨了 AI 发展的「下半场」：ysymyth.github.io\n 一个顶级 AI 产品经理的自我修养 | 对谈光年之外产品负责人 Hidecloud\n【活动预告🥳】\n\n5 月 24 日，我们会办一场线上活动。感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "ysymyth.github.io",
                "url": "https://ysymyth.github.io/The-Second-Half/"
              },
              {
                "text": "一个顶级 AI 产品经理的自我修养 | 对谈光年之外产品负责人 Hidecloud",
                "url": "https://www.xiaoyuzhoufm.com/episode/6607a6961519139e4f7fd8a5"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcnc1Vn5kEBNgwwedfdSGSHUf"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9WTJNek56TTVNemc1WldNME5XWmlNREZsTURJMU5URXdOV0UxTmpnNFl6QmZXWFJUWkhKbE0zWnhZbk5UTUd4WlZWY3dNa3B4V2sxdk9HMXdWVGxUUW5WZlZHOXJaVzQ2VFU5NGNtSmpjM0pWYjFKak4yMTRWR1IzV1dOaWNUZ3hia0ZrWHpFM05EWTBNak0zTnprNk1UYzBOalF5TnpNM09WOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68032a401f1db84a563d5d83",
            "index": 26,
            "title": "Agent 开发的上半场: 环境、Tools 和 Context 如何决定 Agent｜对谈 Sheet0 创始人王文锋",
            "pub_date": "2025-04-19T14:00:00.000Z",
            "duration": "3158",
            "duration_label": "52m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68032a401f1db84a563d5d83",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/68032a401f1db84a563d5d83/media.xyzcdn.net/648b0b641c48983391a63f98/ljifNys_cvR45rLXBOoRhjDRqYac.m4a",
            "play_count": null,
            "show_notes_text": "活动预告🥳：4 月 26 日，我们会请到 sheet0.com 创始人文锋做一场线下活动，大家记得翻到 shownotes 末尾查看报名信息！\n\n关于 Agent 这个话题，我自己有一些核心在思考的问题，相信这些也是很多人同样会有疑问的地方，这期播客中我们就这些问题展开了讨论，并基本得到了一些答案：\n\n1）怎么定义 Agent，Agent 最重要的是什么\n\n2）今天的 Agent 和两年前的 Agent 的区别是什么\n\n3）如何简单快速理解 Function Call，Coding Agent，MCP，A2A，Computer Use，Browser Use 等概念\n\n4）不同方式的区别是什么，有什么优劣之分吗\n\n5）怎么看通用 Agent 和垂直 Agent 的区别，终局是什么\n\n6）AI Coding 和 Agent 最终会是一件事吗，或者二者会有什么关联\n\n7）Workflow 和 Agent 的区别和终局\n\n8）RL 这件事在 Agent 里的重要程度是什么，一家公司（尤其是做 Agent 的创业公司）到底该如何使用 RL\n\n9）大模型自身的 Agent 比如 OpenAI Operator 和其他应用产品的区别是什么，最终市场形态会怎样\n\n10）如何快速判断一家 Agent 公司做得好不好\n\n另外，在整段讨论中，本期嘉宾文锋基于长时间对 Agent 的研究和实操，还提出了很多理解和分析 Agent 的框架和关键要素，以及在接近结尾部分留下了让我非常有启发的一句话：AI Coding 是大模型的灵巧手。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n33 号珍藏：王文锋，Agent builder，sheet0.com Founder & CEO，连续创业者，有近十年 AI、Data Infra 产品设计和 Coding 经验。sheet0.com 已开放 waiting list 申请，即将内测。\n\n【时光机】\n\n 00:47 Agent 三要素：LLM、Context、Tool Use\n 1:17 这波 Agent 和过去两年的区别是什么？\n 2:30 怎么理解 Agent 中的 Context？\n 4:21 快速理解 Tool Use 的不同方案 4:40 代码调用支线：Function Call、MCP、A2A 之间的区别是什么？\n 6:35 模拟人类支线：浏览器是大模型能调用的最重要的工具\n 7:07 两条支线各有优缺点，也可以混合起来\n 10:27 Manus、Devin、Genspark 各用的什么方案？\n 12:25 Browser Use 的核心价值是给用户提供「安全感」\n\n 14:19 AI Coding 和 Agent 最终会殊途同归吗？\n 16:15 Agent 的终局会走向通用还是垂直？\n 17:17 脱离了 RL，Agent 就不成立了 19:15 所以 Agent 创业公司该如何使用 RL？\n\n 22:54 一个非共识理解：聊天框 + 场景推荐 UI 界面就是最好的交互形态\n 31:54 Sheet0 是一个怎样的 Agent 产品？ 34:15 怎么把任务执行的准确率做到了 100%？\n\n 35:39 Workflow 会被 Agent 颠覆掉吗？\n 36:49 不同 Agent 的核心区别是什么？\n 39:05 AI Coding 是大模型的「灵巧手」\n 41:41 Agent 有两大「信任」命题\n 44:22 分享一个预测 Agent 未来发展的思考框架\n 47:33 如何快速判断一家 Agent 公司做得好不好？\n【Reference】\n\n文锋推荐大家都读一读强化学习之父 Richard Sutton 的《Reinforcement Learning：An Introduction》\n\n【活动预告🥳】\n\n4 月 26 日，我们会请到文锋做一场线下活动，感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "sheet0.com",
                "url": "http://sheet0.com/"
              },
              {
                "text": "《Reinforcement Learning：An Introduction》",
                "url": "https://book.douban.com/subject/34809689/"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcnOOUIJITjHclEGe4REqN4Tc"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9WXpRNE5HTmtNMkptTVRZNU9EazRZbVZoTkRjeU16QXlOV0ZpTWpReU1EWmZkblIyV0ZWR1dGSnNhM1l4ZDBwRlVrcGFkV1owT0dwRmIwMVFjbXhpYUV4ZlZHOXJaVzQ2VW1rd2JtSm9ia1pLYjB0aE0yeDRRVlpETVdOa2QyMTVibWhsWHpFM05EVXdORGcyTkRFNk1UYzBOVEExTWpJME1WOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67efcaf5f9578163d601286a",
            "index": 27,
            "title": "一堂「强化学习」大师课｜对谈清华叉院助理教授吴翼",
            "pub_date": "2025-04-05T14:00:00.000Z",
            "duration": "4369",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "Agent",
              "大模型"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/67efcaf5f9578163d601286a",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/67efcaf5f9578163d601286a/media.xyzcdn.net/648b0b641c48983391a63f98/llO1xDKbG6ocJSOyBc1WBVYTSbwP.m4a",
            "play_count": null,
            "show_notes_text": "当 AI 预训练的 scaling law 开始放缓，强化学习 (RL) 接过接力棒，拉出了一条漂亮的第二曲线。\n\n在当下的 Agent 热里，有 RL 能力的团队，也是最被看好和押注的。\n\n但很多人对 RL 都没有一个足够清晰的理解，包括我自己。\n\n所以这期我们请到了国内 RL 领域的专家、清华大学交叉信息研究院助理教授吴翼，来讲讲 RL 的原理到底是啥、RL+LLM 的路径是怎么发展起来的、目前存在哪些非共识、未来还会怎么演变等等（聊完感觉像上了一堂免费大师课）。\n\n而且聊着聊着，我们发现，人生就是一个 RL 的过程，区别是 RL 有明确的奖励函数，但是人生没有。可能如吴翼教授所说，我们首先都要以一种「最大熵」的方式去主动和不确定的世界交互，才能找到自己的奖励函数，优化自己的人生曲线。\n\n最后，吴翼教授的团队最近开源了一个 RL 框架 AReaL-boba，在 SOTA 7B 上跑出了 AIME24 61.9 的分数，也欢迎大家去 GitHub 关注。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n32 号珍藏：吴翼，清华大学交叉信息研究院助理教授，前 OpenAI 研究员。\n\n【时光机】\n\n 1:51 到底什么是 RL？\n 4:25 人生就是一个强化学习的过程\n 6:22 RL 和 LLM 是怎么结合起来的？ 7:01 强强联手第一步：InstructGPT，实现指令遵从\n 10:07 过程中衍生出了 RLHF\n 11:41「慢思考」的需求催生了 RL 的应用\n\n 16:10 为什么说 Anthropic RL 做得特别好？\n 21:17 行业对 RL+LLM 的最优路径形成共识了吗？\n 25:11 RL 起来之后，对 Agent 的影响是什么？\n 32:11 Intelligence = LLM (理解) × RL (决策)，二者缺一不可\n 34:14 Scaling law 的未来 34:33 Pretraining 的两个发展方向\n 36:43 RL 还处于早期，进入深水区后可能会走向分化\n\n 40:02 大模型团队的组织架构要如何设计？\n 43:21 一个反常识：对 AI 来说，理解比生成更难，token 消耗更大\n 47:38 现在做 Agent 一定需要一个懂 RL 的人吗？\n 49:32 为什么 RL 人才这么稀缺？\n 56:10 RL 目前三大分支：泛化 (DeepSeek)、代码 (Anthropic)、Agent (OpenAI)\n 58:55 框架对 RL 意味着什么？\n 1:02:51 RL 在海内外进展还有明显差距\n 1:04:42 想做好 RL，基建≫数据＞算法\n 1:06:05 研究 RL 收获的一些人生启发\n【Reference】\n\n 吴翼的 PhD 毕业论文：On Building Generalizable Learning Agents\n 吴翼获机器学习顶级会议 NIPS2016 最佳论文奖的论文： Value Iteration Network\n 吴翼提到的他非常喜欢的有关 Diversity-Driven RL 的两篇论文：Iteratively Learn Diverse Strategies with State Distance Information、Discovering Diverse Multi-Agent Strategic Behavior via Reward Randomization\n 吴翼团队和蚂蚁研究院开源的强化学习训练框架：AReaL-boba\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "AReaL-boba",
                "url": "https://github.com/inclusionAI/AReaL/releases/tag/v0.2.0"
              },
              {
                "text": "On Building Generalizable Learning Agents",
                "url": "https://www2.eecs.berkeley.edu/Pubs/TechRpts/2020/EECS-2020-9.html"
              },
              {
                "text": "Value Iteration Network",
                "url": "https://proceedings.neurips.cc/paper_files/paper/2016/file/c21002f464c5fc5bee3b98ced83963b8-Paper.pdf"
              },
              {
                "text": "Iteratively Learn Diverse Strategies with State Distance Information",
                "url": "https://arxiv.org/abs/2310.14509"
              },
              {
                "text": "Discovering Diverse Multi-Agent Strategic Behavior via Reward Randomization",
                "url": "https://arxiv.org/abs/2103.04564"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67de36c4dd11f9c8c150b8f0",
            "index": 28,
            "title": "世界怎么就「东升西落」了？聊聊二级市场与 DeepSeek+Manus 的热潮｜对谈莫傑麟",
            "pub_date": "2025-03-22T14:00:00.000Z",
            "duration": "3378",
            "duration_label": "56m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 2,
            "matched_keywords": [
              "AI",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/67de36c4dd11f9c8c150b8f0",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/67de36c4dd11f9c8c150b8f0/media.xyzcdn.net/648b0b641c48983391a63f98/ltAz-WW1y9875Dq3KAbhyq39DsZU.m4a",
            "play_count": null,
            "show_notes_text": "我又来美国了。\n\n这次来，我发现市场真的变化太快，这边很多人都开始相信一个所谓「东升西落」的叙事。于是我再次请来了莫傑麟，和他聊聊二级市场自 DeepSeek 发布以来有哪些新变化、新趋势。\n\n在这期播客里，我们推演了「东升西落」的演绎过程和底层逻辑，谈了我们各自对 DeepSeek 和 Manus 这两个热门产品的感受，也聊了宏观的市场环境和股市的未来。\n\n最近两年很多人都在说，这波 AI 中的最赚钱的方式是炒股。\n\n但真的是这样吗？\n\n二级市场真的才是大家最终的归宿吗？\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n九号珍藏：莫傑麟，家族办公室资深从业者\n\n【时光机】\n\nPart1 「东升西落」的叙事\n\n 00:30 为什么二级市场突然流行「东升西落」的叙事？ 1:00 推演一下演绎过程和底层逻辑\n 5:19 之前大家过于低估国内 AI 了\n\n 6:47 中美对 AI 的叙事重点完全不同\n 7:27 简评 DeepSeek\n 9:48 简评 Manus 10:15 Manus 是最典型的中国式 AI 产品\n 11:58 Manus 爆火背后的两个核心原因\n 14:35 为什么后来风评急转直下？\n 16:01 未来的 AI 产品可能要先在海外宣发，再杀回国内\n\nPart2 二级市场的宏观环境\n\n 22:04 二级市场 = 预期 + 趋势\n 23:12 关于预期——大家对中国的预期是什么？\n 24:39 为什么阿里加大对 AI 的 Capex 投入后，股价大涨？\n 26:17 腾讯是 DeepSeek 这波的最大受益者\n 31:11 25 年的中国在重演 23-24 年的美国\n 33:48 芯片「卡脖子」还会是问题吗？\n 35:42 关于趋势 35:52 暗线 (宏观环境)：稳中向好\n 37:30 明线 (产业趋势)：AI+专精特新+消费多点开花\n\nPart3 股市的未来\n\n 38:44 今年 A 股会不会继续涨，美股会不会继续跌？\n 41:13 二级市场在变得越来越卷，共识的达成和演绎速度越来越快\n 43:57 这波 AI 最赚钱的方式真的是炒股吗？\n 46:44「大起大落的高频波动」可能是未来股市的常态\n 48:14「做时间的朋友」还行得通吗？\n 49:54 分享一些 25 年的个人观察 50:18 AI 领域我会重点关注三个问题\n 52:53 很多非 AI 公司也很值得研究\n\n 54:56 二级市场是所有人的最终归宿吗？\n【Reference】\n\n为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/656aeffd0500be931c4eb099"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67c1faf7bf52a16cd1b80a7c",
            "index": 29,
            "title": "信念感与硅谷顶尖孵化器的奇遇：赴美三月，实现千万刀 ARR｜对谈 ACE Studio 创始人 Joe",
            "pub_date": "2025-03-01T14:00:00.000Z",
            "duration": "2912",
            "duration_label": "48m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "创业",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/67c1faf7bf52a16cd1b80a7c",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/67c1faf7bf52a16cd1b80a7c/media.xyzcdn.net/648b0b641c48983391a63f98/loELD1FA2dT11ITFpZRyxAqyfFPW.m4a",
            "play_count": null,
            "show_notes_text": "如果有人问你，给你三个月的时间，你能把目前手上负责的业务数据翻十倍吗？\n\n相信大多数人都会觉得这是痴人说梦，但这件事 ACE Studio 做到了。\n\n而他们做到的原因不是他们本来就能，而是有人让他们相信了这件事。\n\n这就是我们今天要讲的故事，这就是信念感这三个字的力量。\n\n去年 5 月份我们做过一期 PMF 主题的节目，ACE Studio 的创始人 Joe 聊了很多他们的产品是如何在美国市场找到 PMF 的。当时他们刚刚开启付费半年，就已经做到了很不错的月收入。这次我们又把他请来，是因为才刚过去了大半年，他们的收入竟然就增长了 10 倍，已经成功跻身千万美金 ARR 第一梯队。\n\n能做到这点，是因为他们去了硅谷一家很有名的孵化器 HF0，并在那边搞了 3 个月的封闭式开发。这期播客中，Joe 就毫无保留地分享了 HF0 到底是怎么奏效的、他们在 HF0 的实际体验与收获，和实现 10 倍增长的具体经验（比如他们是怎么一招就让公司一夜之间收入翻倍的？）。\n\n如果你对 Joe 的参加孵化器的经验，或者对去美国参加类似的组织感兴趣，可以添加我的微信 qukai42，42章经今年也会组织更多中美连接的活动和事情，欢迎你用各种方式加入进来。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n20 号珍藏：Joe，ACE Studio 创始人。ACE Studio 是一款面向专业音乐制作人和创作者的 AI 音乐工作站，致力于用 AI 重新定义音乐创作，自 2023 年 10 月上线以来发展迅猛，月收入已达 80 万美金。\n\n【时光机】\n\nPart1 HF0 为什么有效\n\n 01:23 先回顾下入选这家美国知名孵化器的过程 03:48 英语不好会是阻力吗？\n 05:34 3000 进 10 的概率下，HF0 为什么选中了你们？\n\n 07:19 HF0 和其它孵化器不太一样\n 08:46 HF0 没教我们怎么做业务，这事也不该别人来教\n 10:35 最关键的第一步：HF0 给我们注入了「一定能猛涨」的信念感 12:23 这种信念感很难自我激发\n\n 14:23 开营后，HF0 营造了一个专注于增长的氛围 16:25 最大的压力和最深的恐惧就是「别丢脸」…\n 17:44 这种氛围本质上改变了我想问题的方式\n 19:17 也让我们涌起了「别让大家觉得华人不行」的责任感\n 21:38 一直 build「憋大招」可能并不成立\n\n 22:40 从 HF0 出来后，还能保持在其中的状态吗？ 23:55 我们马上要复刻 HF0 的体验\n\nPart2 3 个月涨 10 倍的具体实践\n\n 26:50 五周过去都没怎么增长的时候，信念感崩塌了吗？\n 27:43 绝境逢生的戏剧化转折：我们试了一招，第二天日收入直接 double 28:51 Quora 创始人教会了我们一种思考方法\n 30:00 之前没想到这么干，是因为我们没悟到一件事\n 31:18 要问这招是啥？——答案乍一听可能有点搞笑哈\n 31:29 但搞笑背后是一种硅谷的方法论\n 32:57 在硅谷的几个经历也启发了我们\n\n 33:53 后面我们还试了很多招数，最终达成了 10 倍的增长 34:01 我们在价格模型上做了很多文章\n 34:24 Blake Anderson（千万美金 ARR 产品 Cal AI 的创始人）让我意识到，我们之前联系 influencer 的方式都不对\n 36:33 我们把付费广告的 ROI 提高到了 2 倍\n 36:59 产品功能升级和老用户也没落下\n\n 37:30 但前六周的苦工是省不掉的\nPart3 一些观察\n\n 39:02 美国投资人的工作方式和提的问题有什么不同？\n 40:31 美国机构真的很不喜欢中国团队吗？\n 42:51 肉身到硅谷去很重要\n 43:12 我越来越坚信，AI 产品化大有可为 44:44 Perplexity 的 pitch deck 上有两句话，合起来看很妙\n 45:13 我的壁垒就是我的「人日」\n\n 46:47 硅谷的做事风格越来越回归本质了\n【Reference】\n\n ACE Studio 产品界面\n\n 关于 HF0：HF0 是由 Dave Fontenot（世界上最大的黑客松 MHacks 创始人）、Evan Stites- Clayton 和 Emily Liu 共同创立的常驻创业孵化器，有着严苛的筛选标准，由包括 Marc Andreessen、Chris Dixon 在内的多位知名投资者支持，创办第一年就孵化出了 3 家独角兽公司，也孵化过包括 ComfyUI、Story.com 等在内的多家优秀的 AI 公司。\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "一期 PMF 主题的节目",
                "url": "https://www.xiaoyuzhoufm.com/episode/663f954caf1e22bb15b943d5"
              },
              {
                "text": "HF0",
                "url": "https://www.hf0.com/"
              },
              {
                "text": "Dave Fontenot",
                "url": "https://x.com/davefontenot?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
              },
              {
                "text": "Evan Stites- Clayton",
                "url": "https://x.com/escliu?lang=en"
              },
              {
                "text": "Emily Liu",
                "url": "https://x.com/emilyathf0?lang=en"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TVRJNVlXWXlNV05rTkRjeE5qQXpPRGszT1RNMFlUQTJOak00WXpJMlpESmZNV2hsVW1KeWIxTnljMFJ1WjBORVJrUk5aVzFVUW1kR1RYcEdhVGRTZVdKZlZHOXJaVzQ2VlhJelRXSmxiSGw0YjBKTWEyTjRUakZHVDJNMmMybGxibHBqWHpFM05EQTNOalUzTVRnNk1UYzBNRGMyT1RNeE9GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67affb07606e5c59408daf5c",
            "index": 30,
            "title": "第一个出 ICU 的 AI 创业者｜对谈心影随形 CEO Binson",
            "pub_date": "2025-02-15T14:00:00.000Z",
            "duration": "3790",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/67affb07606e5c59408daf5c",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/67affb07606e5c59408daf5c/media.xyzcdn.net/648b0b641c48983391a63f98/lgIKPVefBedFFN1pYrVIFWjo7lX3.m4a",
            "play_count": null,
            "show_notes_text": "Binson literally 进了 ICU，一场严重的车祸让他对这个世界和创业这件事有了不同的认识。\n\n这期播客中我们先聊了他的这场车祸，和他是如何度过在 ICU 的六个日夜的，相信这种经历是绝大多数人没有机会尝试甚至是听说的，而 Binson 恢复了四个月后已经可以比较正常地坐在我的对面回顾这段经历，他讲了在这个过程中他心态的一些变化，以及在事故之后他是如何改变他对待人生和经营公司的方式的。\n\nBinson 在此之前是知名的大厂高管，他从百度副总监、360 助理总裁，一路做到了 bilibili 副总裁，所以我们也聊了他打工和换工作的很多经验，以及就是他为什么创业，现在又是如何看待 AI 和自己的心影随形（逗逗游戏伙伴）这个公司和产品的。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n31 号珍藏：Binson，心影随形 CEO。心影随形成立至今已获得多轮融资。逗逗游戏伙伴是其推出的一款陪用户玩游戏的 AI 桌宠软件，已有 600 万的用户规模。此前，Binson 曾先后担任百度副总监、360 助理总裁、bilibili 副总裁等职位。\n\n【时光机】\n\nPart1 车祸后的感悟\n\n 1:52 我是怎么差点挂了的？ 2:19 死里逃生的过程\n 7:56 更痛苦的是躺进 ICU 后的精神煎熬\n\n 12:01 我们活着的意义到底是啥？\n 13:58 这件事教会了我「停下来」和「放手」的重要性\n 17:35 我创业的心态和行动有些具体的变化\nPart2 大厂打工 V.S. 创业的体悟\n\n 22:38 如果真的只为了赚钱，不要创业\n 23:04 复盘三段大厂经历 23:20 我应该更早离开百度\n 25:09 为什么不应该为了两三倍工资而跳槽？\n 27:15 为什么 20 年我选择去 B 站，而不是字节、快手、拼多多或者小红书？\n 29:43 原本没想去 360，但周鸿祎给了我一个新的视角\n\n 35:12 作为一个如此有创业精神的人，为什么没有更早出来？\n 37:33 创业首先要摒弃大厂思维\n 42:46 创业总是焦虑？多半是因为事先思考得不够充分\n 44:42 不要回避大厂竞争的问题\n 45:25 创业最难的是招人和统一大家的思路 46:22 成长最快的是工作两三年的\n 47:31「有爱」可以后天培养吗？\n 47:57 一个残酷的现实是，大厂已经不育人了\n\n 49:13 分享一个有效训练决策能力的方法\nPart3 聊聊 AI\n\n 51:12 桌宠形态产品的留存高是一个值得炫耀的事么？\n 52:06 为什么逗逗游戏伙伴很难被 copy？\n 53:46 一些 AI 观察 54:10 今年会陆续有一批 AI 公司被淘汰\n 55:08 LLM 的进展超出预期，多模态则不及预期\n 55:53 Chatbot 这种模式可能就不对\n 56:17 我们不看对话轮数、不看留存、不看时长\n\n 58:49 一个值得思考的未来方向\n【Reference】\n\n Binson 交通事故的完整经历和更多感悟，可以看他之前写的公众号mp.weixin.qq.com\n 逗逗游戏伙伴桌宠形态的示意图：\n\n 逗逗游戏伙伴陪玩《黑神话：悟空》的示意视频\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescalero",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "mp.weixin.qq.com",
                "url": "https://mp.weixin.qq.com/s/KmelYU_dKG1jXXuyPFrlZw"
              },
              {
                "text": "逗逗游戏伙伴陪玩《黑神话：悟空》的示意视频",
                "url": "https://www.bilibili.com/video/BV1h5W3eiEBZ?spm_id_from=333.788.videopod.sections&vd_source=16ef455a9b451fa36503bdbcf26935a1"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly9kMmNzNTB5OXd5LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9WkRWbE1HSXlaVFUxTnpsa01EZGxNalExWWpBME1XWTVNVFkxTVdSaU5UVmZRMlpLV0ZSS2IyZHJTM2xpT0c1RFVtTTVVVm8zWjNkWU1sQmFUbGh3UTBkZlZHOXJaVzQ2VUhwUlRXSnlWbU5WYjNOQmJrNTRZVk4xYVdOMVZXVktibkJtWHpFM016azFPRFUzTXpnNk1UY3pPVFU0T1RNek9GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "678b10ecfd38652366dc9038",
            "index": 31,
            "title": "我是这样用 RL + LLM 做 Agent 的｜对谈 Pokee AI 创始人朱哲清 Bill",
            "pub_date": "2025-01-18T14:00:00.000Z",
            "duration": "2757",
            "duration_label": "45m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 2,
            "matched_keywords": [
              "AI",
              "Agent"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/678b10ecfd38652366dc9038",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/678b10ecfd38652366dc9038/media.xyzcdn.net/648b0b641c48983391a63f98/lhTyzyqE4LTCfjejXjl3jLTBCmts.m4a",
            "play_count": null,
            "show_notes_text": "新年正式第一期，来点新东西。\n\n大家都说 Agent 热，那 Agent 到底是啥、到底为啥热、到底咋做、到底长啥样？\n\n大家都说 RL 是新方向，那 RL 到底是啥，和 LLM 的关系是什么，又能怎么和 Agent 结合？\n\n这期我们就请到了在 Meta 工作了七年的应用强化学习组负责人朱哲清 Bill，讲一讲他是怎么用一种很新的技术路线来做一种很新的 Agent，并且在电商等领域是如何落地的。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n30 号珍藏：朱哲清 Bill，Pokee AI 创始人兼 CEO，此前 7 年在 Meta AI 做应用强化学习组负责人，并攻读了斯坦福大学强化学习专业博士学位\n\n【时光机】\n\nPart1 强化学习\n\n 3:06 我们思考方式已经全面 RL 化 —— from OpenAI 研究员\n 4:36 Transformer 和 RL 到底是什么关系？又要如何结合？\n 10:15 RL 解答的是平行宇宙问题\n 12:35 RL+LLM，就是公认最好的技术路线吗？\n 14:02 RL 的算法原理类似于「多巴胺刺激」\n 14:42 在无法清晰定义 Reward 的场景下，RL 还好用吗？\n 15:12 RL 最强的三个能力\nPart2 给 Agent 用上强化学习\n\n 18:42 为什么直接用 LLM 做不出规划型 Agent？\n 20:17 一个有效的 Agent 架构：RL 做核心，LLM 做翻译\n 23:35 我们做出了一个电商领域的通用型 Agent 24:39 体验相当于一个资深的网站负责人\n 26:05 原理是让 Agent 通过 self-play 学会使用上千个底层 API\n\n 29:43 Agent 当前市场格局: 29:52 Coding Agent 是皇冠上的明珠\n 30:26 Vertical Agent 遍地开花，但准确性仍是大难题\n 30:46 通用型 Agent 尚不存在，但 RL 或可迎战\n\n 31:17 万物皆可 call API\n 34:07 一个具体的应用示例：Agent 是怎么帮商家省钱提效的？\n 39:08 训练成本和推理成本都低得令人发指...\n 40:33 先定一个小目标：做各行各业的 API 杀手\n 42:57 对 25 年硅谷 AI 市场的观察和预判 43:11 垂类 Agent 是绝对的热点赛道，融资并不困难\n 45:29 25 年是 Agent 真正落地的一年\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescalero",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6777d48a15a5fd520ecd1ea6",
            "index": 32,
            "title": "为什么我们对 25 年 AI 极度乐观｜AI 年终复盘",
            "pub_date": "2025-01-04T14:00:00.000Z",
            "duration": "1894",
            "duration_label": "31m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6777d48a15a5fd520ecd1ea6",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6777d48a15a5fd520ecd1ea6/media.xyzcdn.net/lkkff9BfHxVOMz1kx4MBIsIqqKf7.m4a",
            "play_count": null,
            "show_notes_text": "去年我们做了一期年终总结，叫《24、25 年会是下一代浪潮最关键的两年》，今天我仍然坚定的站在这个结论背后，24 年看似悲观实则蕴藏了很多机会，而 25 年就是爆发的一年。而还没有进场的人，可能 25 年就是最好的机会。\n\n在这期播客中，我帮大家快速理解：\n\n1）23 年 24 年市场发生了什么，核心重点是什么，原因是什么。\n\n2）为什么市场普遍悲观，而我们却极其乐观。\n\n3）当下市场中最流行的 Prosumer 概念是什么，为什么会有这个概念。\n\n4）市场都说 Agent 是重点，我从传统软件到 SaaS 再从 SaaS 到 Agent 解释了这里的机会和做法到底是什么。\n\n5）为什么多模态 2C 产品，反而是我们最看好的机会？这个可能就是 AI Native 的答案。\n\n这期播客一共 30 分钟，23 到 25 年 AI 市场的精华都在其中。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【时光机】\n\nPart1 复盘过去两年的 AI 发展\n\n 00:50 市场从盲目乐观走向过度悲观（不过最近有新风向\n 02:26 24 年 1-9 月，一级市场是过去十年 (大概率也是未来十年) 之最差\n 04:19 模型侧符合我们 23 年初的 4 个判断\n 05:17 应用侧不及预期，但也有人赚到钱\n 06:35 为什么我们开始乐观？ 06:48 ① 9 月后，融资市场明显复苏\n 07:05 ② 多模态的能力在持续加强\n 09:04 ③ 大多数人忽略的一点是，AI 创始人的画像发生了明显变化\n 10:07 无论外部因素如何，最终起决定性作用的是资产价值本身\n\nPart2 展望 2025\n\n 10:41 市场大环境会进一步变好，但会越来越两极分化\n 11:59 当下最好的选择不是创业，而是先加入一家 AI 公司积累经验\n 12:30 市场关键词演变：23 年「大模型」，24 年「具身智能」，25 年「应用落地 13:06 目前最具共识的是 Prosumer 赛道，可能会率先跑出千万美金 ARR\n 15:03 此外我们最看好 Agent 和多模态\n\nPart3 详谈 Agent 和多模态\n\n 15:30 Agent 会是 SaaS 的十倍？\n 16:02 Agent 更可能是新公司的机会，而不是现有 SaaS 公司的机会\n 22:57 Perplexity 未来其实是一家 Agent 公司\n 26:25 AI Native 的答案是什么？\n 30:28 早入场的人、乐观的人，往往都获得了回报\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "《24、25 年会是下一代浪潮最关键的两年》",
                "url": "https://www.xiaoyuzhoufm.com/episode/65a2a75fb5e4856c70801eba"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "675a56087d8426f692780f68",
            "index": 33,
            "title": "用绝对理性应对世界的波动 | 对谈德扑世界冠军 Ricky Mao",
            "pub_date": "2024-12-14T14:00:00.000Z",
            "duration": "2978",
            "duration_label": "49m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 1,
            "matched_keywords": [
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/675a56087d8426f692780f68",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/675a56087d8426f692780f68/media.xyzcdn.net/llKBp7m20kvkCiGiwmIabk__Eb5Q.m4a",
            "play_count": null,
            "show_notes_text": "这期是我自己一直感兴趣的话题。\n\n我一直觉得像德扑、狼人杀这样的游戏设置非常有意思，里面的各种理性策略、感性判断和说服人的能力，都能体现在现实世界的角角落落。相信绝大多数人都大抵接触过这些游戏，哪怕不是相关领域的专家，所以我们这次就请来了一位德扑世界冠军来一起讨论他视角下的德扑，以及其中很多“技巧”对这个世界的映射。\n\n在整个聊天过程中，嘉宾说了无数次的“绝对理性”，也谈论了在游戏中是如何对“人”进行判断（比如行为基准线的概念），另外在结尾部分，他还说了一句点破社会经济运转规律的话，即“通胀是人生的大小盲”。\n\n这期很多内容比较偏向于德扑本身，希望大家听完能够从中收获些对现实世界中博弈、决策和投资等的参照，也祝所有人都能跑赢通胀。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n29 号珍藏：Ricky Mao，毕业于复旦、 MIT，前投资人、企业 CFO，现是全球 Global Poker Index 排名 200 左右、中国前 10 的扑克选手。曾获 WSOP（世界扑克系列赛，代表着竞技扑克的最高水平）金手链、两次 APT（亚洲扑克巡回赛）冠军。\n\n【时光机】\n\nPart 1 一个顶级牌手的核心素养\n\n 4:15 要素一：绝对理性 5:53 but how?\n 8:34 那还能 all in 吗？\n\n 10:26 要素二：识人 11:34 核心是知道基准线在哪里，然后分析每个人动作上的偏移\n 12:07 线下接触一个人，可以先通过外在形象给 ta 建模（日常生活不鼓励这么做哈\n- 示例：金表大哥 v.s. 沙滩白男的行事风格模型\n- 所以要怎么又快又准地给人建模？\n 14:55 见不到面时，能通过什么信息来判断对方是什么样的人？\n 15:28 国人更喜欢刺激、赌性更强\n 19:47 大家最常犯的错误是什么？\n 21:16 行业 top，最后真正拼的是什么？\n\n 22:29 要素三：掌握概率\nPart 2 心态篇\n\n 23:41 为什么说「一场比赛毁一个冠军」？\n 26:51 是人都会经历大的下风期\n 27:53 拿到金手链的精彩故事\n 28:20 我曾经想过：如果拿到金手链，我愿意第二天去死\n 29:04 肾上腺素飙升…反败为胜前的尖峰十小时\nPart 3 策略篇\n\n 31:03 大部分人对 Bluff 的认知都不对\n 35:26 更激进的打法，能引向更好的结果吗？\n 36:00 怎么打满价值？\n 40:02 位置这件事，到底有多重要？\nPart 4 人生思考\n\n 41:01 绝对理性和保持感性并不矛盾\n 42:28 「再坚持一下」可能是一种有毒的心态\n 43:36 通胀是人生的大小盲，环境不好的时候你完全可以空仓\n 48:03 顶尖高手的风格都是万法归宗\n【Notes】\n\n Tom Dwan：一位著名的德州扑克选手，以其非常激进和高风险的打法著称。节目中还提到了几位顶尖高手，包括 Eric Seidel、Phil Ivey、Daniel Negreanu、Dan Cates (Jungleman)、Adrian Mateos、Steven Chidwick。\n GTO（博弈论最优）：GTO 策略是一种防守性策略，目的是让你不容易被对手剥削。在 GTO 策略下，玩家通过混合不同的行动（例如：下注、加注、弃牌等）来保持平衡，使得对手即使知道你的策略，也无法从中找到漏洞。\n 大小盲：德扑中使用的强制性下注结构中的两种盲注。小盲注（Small Blind）是由庄家左手边的玩家支付的强制性下注金额，通常为最小的注额。大盲注（Big Blind）：是由小盲注左边的玩家支付的强制性下注金额，通常是小盲注的两倍。这些盲注的设置目的在于推动游戏进行，确保每一局牌都有一定的筹码池。游戏中的其他玩家可以选择跟注、加注或者弃牌，而支付盲注的玩家则已经支付了入池的初始金额。\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67359e9843dc3a43878eaa90",
            "index": 34,
            "title": "我在 Character.ai 做 Post Training｜对谈前 C.AI 模型应用算法专家 Ted",
            "pub_date": "2024-11-16T14:00:00.000Z",
            "duration": "3611",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "Agent",
              "商业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/67359e9843dc3a43878eaa90",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/67359e9843dc3a43878eaa90/media.xyzcdn.net/lsC5Bvk_Yy0MFXswWPLA0L01nqQS.m4a",
            "play_count": null,
            "show_notes_text": "活动预告🥳：12 月 7 日，我们会请到 Ted 做一场线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\n在我 9 月份的硅谷行程里，我见过的印象最深、让我最有收获的人之一就是 Ted。\n\n那个时候他正要离开 Character.ai，作为第四十多号加入的员工，他对于 C.AI 的产品、模型、训练等等的熟悉程度都非常高，这次很开心能把他请来，跟大家一起分享下美国最著名的 AI 公司内部是如何运作的，Post Training 的最佳实践是怎么做的，以及硅谷一众 AI 从业者的现状和认知等。\n\n这期播客的内容基本代表了美国最一线的 AI 从业者的实践和认知，非常有代表性，希望对大家有帮助！\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n28 号珍藏：Ted，前 C.AI 模型应用算法专家\n\nPart 1 从内部视角看 C.AI\n\n 01:06 为什么商业化一直没做起来？\n 04:40 如果 C.AI 当时往 AGI 赌把大的，或者把产品交给字节系，能改写自己的结局吗？\n 06:51 我们很认可 Talkie，但不想学 Talkie\n 09:36 被收购后，你还相信 C.AI 类产品的未来吗？\n 11:35 有人说「C.AI 不是真正的 AI 陪伴」，那它到底是啥？\n 12:19 C.AI 为什么做得比别人好？\nPart 2 我在 C.AI 做 Post Training 的这一年\n\n 14:56 工作状态是 996（主动的哈，passion！\n 17:15 Post Training 的核心是设计高效的迭代路径 18:42 四种迭代路径，都有很多低垂的果实可以摘\n 21:40 怎么评估和改善「模型变蠢」的问题？\n 22:54 迭代中一个有趣的 EQ 涌现\n\n 24:19 Post Training 到底是怎么个流程？ 25:37 介绍 Post Training 三大件：SFT（监督微调) 、RLHF（人类反馈强化学习）、DPO （直接偏好对齐）\n 32:07 以上天花板极高，RAG 和 Prompt Engineering 我们几乎没做\n\n 32:53 帮你拉开和同行差距的 2 道数据思考题： 33:18 你微调用的数据，质量真的不能更高了吗？\n 36:00 收集来的用户偏好数据，只能是点赞点踩吗？\n\n 39:32 大家现在关注的几个技术难题，C.AI 是怎么做的？ 39:49 怎么做好评估？\n 41:10 怎么做好意图识别？\n 43:22 C.AI 的语音延迟基本是业界做得最好的，是怎么做到的？\n\nPart 3 硅谷观察\n\n 46:17 一个不被公开的秘密：ChatGPT 内部也是多模型混用？\n 47:28 硅谷整体还是很乐观，推理侧仍然大有可为\n 50:45 硅谷现状： 51:01 做产品的想靠多模态赚钱\n 51:06 搞算法的想复制 o1\n 51:16 两边都在期待自动交互 Agent 解锁的想象空间\n\n 53:48 复盘最近的硅谷求职记 53:54 Post-train 人才极其抢手\n 54:27 印象最深的是，面 Cursor 的时候，我甚至被允许用 Cursor 现场解题\n 56:03 最喜欢被问到「你觉得我们的 idea 有多不靠谱？」\n 56:45 如果我是面试官，我会考察面试者的这项直觉能力\n\n 57:28 我很喜欢现在硅谷的氛围！当下可能是华人扬眉吐气的最好时机\n【活动预告🥳】\n\n12 月 7 日，我们会请到 Ted 做一场线上活动，感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcnjqfpJE5rtW8TYCSbgnZSib"
              },
              {
                "text": "https://image.xyzcdn.net/FoDtHFfW3mjnORZFktG36DdARKkd.png",
                "url": "https://image.xyzcdn.net/FoDtHFfW3mjnORZFktG36DdARKkd.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "672e0dcf43dc3a438716da42",
            "index": 35,
            "title": "这可能才是 AI 陪伴真正该有的样子｜对谈刷屏产品 EVE 创始人 Tristan",
            "pub_date": "2024-11-09T14:00:00.000Z",
            "duration": "2716",
            "duration_label": "45m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "商业",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/672e0dcf43dc3a438716da42",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/672e0dcf43dc3a438716da42/media.xyzcdn.net/lgVCb1TuUR_1rf2qK8Jv9cHMWew_.m4a",
            "play_count": null,
            "show_notes_text": "几周前，EVE 的产品宣传片一上线就在 B 站获得了超百万播放，且刷屏了朋友圈。\n\n几天前正好和一个投资人聊天，大家在讨论未来的 AI 巨头和入口型的公司/产品到底有什么可能性，我当时就说 AI 陪伴类产品肯定是有大机会的，过去两年里，真正验证了 PMF 的赛道就是 Character.ai 类的产品形态，不管从用户量级还是时长等数据来看，这类产品都一骑绝尘。\n\n当然，如 EVE 的创始人所说，在他眼中，C.AI 根本就还不算真的陪伴，这可能也是类似产品没有获得更大突破和成功的原因。作为最早的恋爱游戏类公司创始人，他有自己一套清晰的关于陪伴的定义，这不仅让他做出了最成功的乙男向游戏《奇点时代》，也让他能做出现在的这款万众期待的 EVE。\n\n在这期播客中，我们具体聊了他是如何定义陪伴的、他是如何用各种复杂工程手段解决长期记忆等模型问题的、以及他是如何把游戏和 AI 产品结合起来的等等话题，作为最早期的内测用户之一，我非常相信 EVE 能在明年成为一款现象级的产品。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n27 号珍藏：Tristan，EVE 创始人，《奇点时代》创始人\n\n【时光机】\n\nPart 1 背景介绍\n\n 00:54 为什么我说 C.AI 类产品根本不是陪伴\n 2:38 陪伴的第一性原理\nPart 2 工程设计\n\n 4:22 所有人都解决不了的长期记忆问题，你们是怎么实现的？\n 4:55 被动记忆与主动记忆的区别\n 6:24 情侣实验与 128 个记忆槽位\n 8:03 给 AI 女友设计脑回路：我们用十几个模型搭建了一套工程管线\n 10:08 举个例子，一个最复杂的话题处理流程是什么样子的？\n 12:44 交代一下成本与商业模式\nPart 3 游戏设计\n\n 14:07 一个迷思：为什么只有你们把 AI 产品做到了这个程度？\n 15:42 从游戏转做 AI 陪伴的明显优势\n 17:07 那些产品中的游戏化设计 (及用意)\n 23:51《奇点时代》一年 2 亿流水，其实远低于我们对男性恋爱游戏的市场预期\n 25:00 我相信世界 50% 人都会需要一个 AI 伴侣\n 27:14 聊聊角色设计\nPart 4 AI 设计\n\n 29:27 怎么做到 10 个月的时间就快速搞懂、搭建起这样一套 AI 架构？\n 31:13 如何训练出市面上最好的情感聊天效果？\n 32:39 我们找了一个天资卓绝的真人陪聊，试图复刻她的大脑\n 37:51 AI 陪伴的四个核心要素\n38:10 超级对齐\n38:26 真实时空感知\n39:17 独立人格\n43:20 荷尔蒙钩子\n 43:45 模型的情商和智商到底是怎样一个关系？\n【Reference】\n\n EVE 预告 PV (内含产品内测申请链接)\n EVE 模型系统工作机制：\n\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "EVE 预告 PV (内含产品内测申请链接)",
                "url": "https://www.bilibili.com/video/BV1Ti2DY5EJt/?spm_id_from=333.337.search-card.all.click&vd_source=0050e5d7ff0b01dbea4d2d8963bc34a2"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9WmpBMU1UWXlaREZrTW1ZNU1tWmxNemRrTkRGbE0yVTNaVEprTnpFNFltWmZaWEJFT1VwMFpHSTFXblpzYkVaaE0yZzFlWEpFYlhvM1lVeGxiSFEyUlUxZlZHOXJaVzQ2VDJOdk5XSTFaWGhyYjFaRVkxRjRWMGx1WkdOMlJGUlBibE5rWHpFM016RXdOekV6TlRJNk1UY3pNVEEzTkRrMU1sOVdOQQ=="
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9WVRZeU5UUmlOakExWkdSbVpERmlZalE1TWpaaVpUQm1OemxrT0RsbE5ETmZRelJ4UzFaTE1IRndWVlI0VW5wd1dEZFZlWEpLTkRoMWNsWldOVU0wU0ZSZlZHOXJaVzQ2UlRSNlRXSnZUazExYjBGNE9WbDROREZIY0dOWmVIUmlialprWHpFM016RXdOekV6TlRJNk1UY3pNVEEzTkRrMU1sOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "671c9a42eb46cd6655da1e6f",
            "index": 36,
            "title": "Cursor 刷屏背后，复盘 AI Coding 的现状与发展｜对谈 Gru.ai 创始人张海龙",
            "pub_date": "2024-10-26T14:00:00.000Z",
            "duration": "2228",
            "duration_label": "37m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/671c9a42eb46cd6655da1e6f",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/671c9a42eb46cd6655da1e6f/media.xyzcdn.net/llyKP5iVutvfJsVEm5AECynqsiO6.m4a",
            "play_count": null,
            "show_notes_text": "活动预告🥳：11 月 7 日晚，我们会请到张海龙做一场免费的线上活动，大家记得翻到 shownotes 末尾查看报名信息！\n\n前一阵 Cursor 刷屏，也带火了有关 AI Coding 的讨论。\n\nAI Coding 到底发展如何了，Cursor 为什么火了，他们和 Github Copilot 的区别是什么，Coding Copilot 又和 Agent 的区别是什么？其他那些 AI Coding 公司都在做什么，为什么国内的 AI Coding 似乎不温不火？带着类似的种种问题，作为一个非技术背景的人，我找来了张海龙一起来聊聊 AI Coding 这件事。\n\n海龙无疑是国内在 Coding 领域最有发言权的人之一，他写了 20 多年程序，一直致力于做给程序员的工具，他曾经是开源中国的联合创办人和 Coding.net 的创始人，最近的一年多时间里他也又重新创业在做 AI Coding 方向。在摸索了一段时间以后，他也经历过产品转型、也踩过坑，这些都让他对 AI Coding 有了更深的理解，也对当下这个市场各个公司和类别有了更好的判断。\n\n所以，你可以把这期播客当做一个对 AI Coding 领域的入门和了解的素材，哪怕不懂编程，听完这期你也会有更深的了解和认知。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n26 号珍藏：张海龙，Gru.ai 创始人，前 Coding.net 创始人兼 CEO、开源中国联合创办人\n\n【时光机】\n\nPart 1 为什么国内的 (AI) coding 没做起来\n\n 1:56 Developers 是最不愿意花钱的一群人？\n 3:37 我最新的感知是，海外比国内更卷\n 4:33 国内 AI coding 发展现状\n 5:31 国内是在有 PMF 之后卷，海外是在有 PMF 之前卷\nPart 2 Coding Copilot vs Agent\n\n 6:20 Copilot 与 Agent 的区别：Copilot 是给你一把电钻，Agent 是给你一个小弟\n 7:43 Copilot 已经明确跑通了 PMF 7:52 简评赛道老大哥 Github Copilot\n 9:03 详评新晋顶流 Cursor：成功靠的是大胆创新，大胆到一开始很多人觉得不靠谱\n\n 16:53 Agent 还没有找到 PMF 17:27 Devin 等等都是有声量，无留存\n 18:53 但为什么这个赛道还如此拥挤？\n\nPart 3 关于 Coding Agent 的实践思考\n\n 21:30 我们找到的一个好落地的场景：Unit Test\n 24:37 Agent 会最终淘汰 Copilot 吗？\n 25:30 我不相信「编程大众化」的未来\n 27:44 模型会最终吃掉 Coding Agent 吗？\n 30:50 我坚定地认为，AI 替代不了人类程序员\n 32:44 一些硅谷观察 32:52 有千奇百怪的 AI+ 项目，且能拿钱\n 33:52 我在国内啥 SaaS 都不买，来了这啥 SaaS 都买\n\n 35:27 最后的建议：多读论文多动手，获得那些微妙的体感至关重要\n【活动预告🥳】\n\n11 月 7 日晚，我们会请到张海龙做一场线上活动，感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！\n\n【Reference】\n\n Cursor 成功的背后：两个 PMF\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcngpWVXAYL18J78va7zjcPhf"
              },
              {
                "text": "Cursor 成功的背后：两个 PMF",
                "url": "https://mp.weixin.qq.com/s/2Zhg29gWb0-ZMst3-snajA"
              },
              {
                "text": "https://image.xyzcdn.net/FlYxyhoaXCzdZQ5R5bvkHkIripyW.png",
                "url": "https://image.xyzcdn.net/FlYxyhoaXCzdZQ5R5bvkHkIripyW.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "670a90fcdb2cf82757b990dd",
            "index": 37,
            "title": "重生之我在大厂做 AI+教育的 18 个月 | 对谈高途 AI 产品负责人封诚",
            "pub_date": "2024-10-12T15:08:43.000Z",
            "duration": "2131",
            "duration_label": "35m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "创业",
              "访谈",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/670a90fcdb2cf82757b990dd",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/670a90fcdb2cf82757b990dd/media.xyzcdn.net/lsurkfHf4YX2k7oGO_lHdLaNCfFP.m4a",
            "play_count": null,
            "show_notes_text": "我们做过非常多创业者的访谈，这次不一样。\n\n封诚作为一个连续创业者，在 AI 最鼎盛的时期，反而选择加入了大厂高途，并在内部负责 AI 产品的探索。之前也有人提过说想听到更落地的实际的 AI 在传统行业的应用，这期播客中我们就聊了他们是如何在业务中具体应用 AI 的，比如在获客、转化和交付等全链条场景中的探索和试错。\n\n作为结果，目前他们已经能用 AI 把转化效率提升至少一倍，并且模式也已经完全跑通，相信这件事不只是在教育行业可以得到应用，在其他很多行业也是类似的。此外，我们自然也聊到了很多教育领域的情况，以及他在大厂做 AI 的感受。\n\n最后提一个问题，你觉得 AI 到底能不能取代老师呢？而当 AI 可以帮老师解决几乎所有的问题时，老师实际存在的意义又是什么呢？我很喜欢这期播客中我们一起给出的答案。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n25 号珍藏：封诚，高途 AI 提效 & 创新产品负责人\n\n【时光机】\n\nPart 1 AI 赋能传统业务的核心是提效\n\n 01:56 体现在三个环节： 02:47 交付端：提效不明显，但存在彻底掀桌子的可能\n 03:45 获客端：有很多短期的机会，但不可持续...\n 06:38 转化端：价值最大，可稳定提效至少一倍\n\n 09:43 AI 把我们的成单率提高了 3-4 倍\n 12:42 招人之「让懂 AI 的人学业务」会好过「让懂业务的人学 AI」\n 14:23 转化场景里 AI 具体能做什么？\n 16:25 提效的本质是给金牌销售配了一堆助理\nPart 2 AI native 的探索和思考\n\n 17:11 用好 AI 的最大难题：大家 ego 太大，耻于摘那些低垂的果实\n 18:37 怎么培养创业者视角？稻盛和夫培养管理者的方式对我很有启发\n 22:10 AI 和教育的本质非常 match\n 22:46 AI 提效这个事儿能不能外包来搞？\n 26:31 AI+教育都有哪些全新的产品机会？\n 29:35 当 AI 可以帮老师解决所有问题时，老师存在的意义是什么?\n 32:45 创业者都可以问自己这三个问题\n【活动预告】\n\n10 月 24 日，我们会在北京办一场线下活动。除了主讲嘉宾封诚，我们还请到了其他嘉宾，在陆续确认中。感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识 & 交流！（尤其欢迎正在探索把 AI 和传统业务结合起来的朋友们～)\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：陈皮\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcn6u2aCKEv3QXUh5BQo4JKlg"
              },
              {
                "text": "https://image.xyzcdn.net/FoNNURnsyuRAxSGC7H08rt-YXTiD.png",
                "url": "https://image.xyzcdn.net/FoNNURnsyuRAxSGC7H08rt-YXTiD.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66ee95306920a36bfc9f1de1",
            "index": 38,
            "title": "找 PMF 就是要做没壁垒的事 | 对谈连续创业者 Albert",
            "pub_date": "2024-09-21T16:00:00.000Z",
            "duration": "3784",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/66ee95306920a36bfc9f1de1",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/66ee95306920a36bfc9f1de1/media.xyzcdn.net/lj8IJvGIsRfQxk0SdECUvNQfeamK.m4a",
            "play_count": null,
            "show_notes_text": "Albert 是我个人最喜欢的嘉宾，每次的输出都有很强的时效性、有很多的深度认知、也有很多实操经验，他很擅长总结、思考和输出金句，且言之有物。\n\n这期播客大概正好是上期之后的一年，也是 Albert 真正做 AI 产品的一年，所以在这期播客中我们反思了很多 AI 创业和产品的认知，比如 AI 的本质到底是什么？该怎么选择 AI 的落地方向？该如何寻找 AI 产品的 PMF 等。另外，这一年对很多人来说都是面对很多 AI 的发展局限和负反馈的一年，Albert 也给我们讲了他是如何克服这个问题、如何改变思维方式的（包括他向张一鸣提的两个问题和对答案的思考）。\n\n相信所有听过上期 拒绝三亿美金 offer 的人 节目的人，应该都认同一件事，就是小宇宙真的欠他一个首页。这不，新一期又来了。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n六号珍藏：Albert，AI 创业者 (往期考古：拒绝三亿美金 offer 的人 | 对谈音遇创始人 Albert）\n\n【时光机】\n\nPart 1 AI 创业的本质\n\n 2:15 最重要的问题有两个： AI 的长期关键要素是什么？\n 因为 AI 的出现，各行各业的哪些长期关键要素会发生变化？\n\n 3:05 AI 创业的本质：通过数据，提升模型的交付能力，进而提升用户体验\n 3:58 AI 创业的核心：评估 (评估决定迭代效率)\n 4:15 Albert 的进场原则用户对交付是否有明确预期？\n仅依靠模型是否能完成交付？\n 12:21 创业的核心是定义资产\nPart 2 我在微信上问了张一鸣两个问题\n\n 16:53 如果张一鸣没做成字节，他大概率会做出拼多多\n 28:26 张一鸣回我说：对于有才华的人，要做更有把握的事\n 29:50 运气是优势被时间放大的结果\n 31:25 总说做正确的事，到底什么叫正确的事？\n 32:29 我请教了张一鸣怎么训练平常心\n 34:10 我们往往会高估理想带来的激情，低估正反馈带来的刺激\nPart 3 找 PMF 就是要做没壁垒的事\n\n 36:33 现在 AI 有太多可做的了\n 38:20 工具产品的要义只有一个：用速度换规模\n 40:23 我是一向反对过脑瘾的，但在今天，我反而觉得你是有条件去想一些终局的\n 41:52 如果让我现在从 0 到 1 再创业，我会这样做\n 43:34 AI 还会有爆发吗？\n 47:15 快速评估一个 AI 创业者的认知，可以问这些问题\n 49:29 最近在琢磨：当摄像头带了脑子，世界能发生什么？\nPart 4 人才与预期管理\n\n 50:32 最焦虑的还是人才 (欢迎联系!)\n 52:01 给大家传授一下为什么总能飞速跟进新技术\n 53:51 再传授一下做 C 端产品，最该具备的一个认知\n 55:23 去年最大的认知变化：别上播客 (但今年还是来了\n 57:26 对 AI 的预期？特别乐观啊，甚至都想做硬件\n 58:13 面试最常问的一个问题\n 1:00:14 我一直在思考怎么能给人才提供安全感\n【活动预告】\n\n10 月 8 号，在北京，我们还会邀请 Albert 来一场线下活动！感兴趣的朋友欢迎点击链接或扫描下面的二维码，一起来认识&交流！(限 50 人，如果有想加入 Albert 团队的 AI 工程师同学，尤其欢迎前来面基！)\n\n【The gang that made this happen】\n\n 制作人：陈皮、Celia\n 剪辑：思娜\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "拒绝三亿美金 offer 的人",
                "url": "https://www.xiaoyuzhoufm.com/episode/6505cb5496875579717a1369?s=eyJ1IjogIjVmODY4YzQxZTBmNWU3MjNiYjRmYzM1ZSJ9"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "链接",
                "url": "https://d2cs50y9wy.feishu.cn/share/base/form/shrcnq0ey4YLquGzNwI6MLVtp7e"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TVRkbFptWmpOalUyT0dNek9ERm1NRGN3WVdRMU16Qm1ZV1UxTlRjeU1XUmZXalphYVRoSWJYQjRObGcwVVZvNU5rUjJkV3BRUTNoSFkyYzVUR2x2ZWtSZlZHOXJaVzQ2U0RsUVRXSjJXVUoyYjAxV1ZVdDRNakJxTldOR1JYbENibUZuWHpFM01qWTVNVEUyT1RBNk1UY3lOamt4TlRJNU1GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66d338824a0f950f848f10e1",
            "index": 39,
            "title": "未来是千亿 bot 和个人模型的时代 | 对谈心识宇宙创始人陶芳波",
            "pub_date": "2024-08-31T15:36:33.000Z",
            "duration": "3144",
            "duration_label": "52m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "Agent",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/66d338824a0f950f848f10e1",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/66d338824a0f950f848f10e1/media.xyzcdn.net/loK_2qsgzpe0UFULQ3GcwwO-y0Fr.m4a",
            "play_count": null,
            "show_notes_text": "心识宇宙是国内最早做 AI 的公司之一，我记得 22 年中的时候就和他们交流过，当时他们说我们在做人类大脑之类的，我听得云里雾里，后来才知道，原来就是大模型，再后来他们推出了 MindOS，应该算是全球最早的 Agent 类产品。\n\n在这期播客中，陶芳波分享了他这么多年做 AI 的经验和教训，包括他觉得 MindOS 类 Agent 产品的问题是什么，为什么他们要推出新的 Me.bot 这款产品，背后的思路是怎样的等等。我们也又花了很长时间来探讨 bot 的意义和未来，及为什么 bot 是 AI 的最小基础单元（以及入口？）。\n\n另外，我印象很深的是，他说个人模型才是未来，还提出了很大胆的猜想，未来的大模型就是去中心化的，就像个人电脑一样，最开始大家觉得全世界就只有几台大型电脑就可以，但最后的结果是我们的身边充斥了各种小型计算机。\n\n期待千亿 bot 和个人模型的时代！\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n24 号珍藏：陶芳波，心识宇宙 (Mindverse) 创始人\n\n【时光机】\n\n 00:54 不能免俗的背景介绍：Facebook→阿里达摩院→Mind OS→Me.bot\n 02:46「个人模型」也许是下一个十年的「个人计算机」\n 4:27 AI 世界的最小基础单元\n 5:56 AI 来了，国内 2B 行业似乎可以直接跳过 SaaS 阶段\n 6:40 大家都在做「提供供给」的 bot，但我认为最重要的是「理解需求」的 bot\n 14:19 一个艰巨的问题：如何让 AI 具备自我进化能力？\n 20:34 自我的两种形式：「Experiencing self」vs「Remembering self」\n 24:46 AI 如何知道，什么该被记住，什么可以被忘掉？\n 26:45 事情有了一些眉目：我们找到了一种新的记忆训练方法\n 31:05 我本以为做 Agent 是一个工程问题，后来发现这是一个科学问题\n 36:16 最终极的 AI 助理，到底会是 her，him，them 还是 me?\n 38:09 回到眼前，Me.bot 现阶段的使用方法\n 43:00 什么应用最终能成为超级入口？\n 44:57 个人模型上生长出的应用生态\n 51:01 未来，个人模型和智能设备会是什么关系？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜、梦昕\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66c0c83a33591c27becd1d89",
            "index": 40,
            "title": "宿命论与万恶的 Scaling Law | 暴论 CAI 被收购",
            "pub_date": "2024-08-17T15:56:42.000Z",
            "duration": "2198",
            "duration_label": "36m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "创业",
              "访谈",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/66c0c83a33591c27becd1d89",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/66c0c83a33591c27becd1d89/media.xyzcdn.net/lryVHmXC5KBQKs7ktAfujWjNc1l1.m4a",
            "play_count": null,
            "show_notes_text": "这又是一期单口。\n\n有很多人从各种视角聊过 Character.AI 被收购这件事，我的视角和大家都不太一样。\n\n这几天我把 C.AI 创始人的各种访谈和他们官网的文章都看了一遍，再把之前了解到的各种信息串在一起以后，我突然有种融会贯通，“原来如此”的感觉：\n\n原来海外大厂的 AI 逻辑是这样的，原来 C.AI 被收购是必然的，原来现在这个节点做 AI 应用确实是最有利的。\n\n很多人把 C.AI 被收购解读成 AI 市场的悲观信号，但我却觉得这何尝不是一个利好创业公司的积极信号呢？（虽然背后确实有一种更深的宿命论）。\n\n且听我娓娓道来...\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【时光机】\n\n 1:10 C.AI 被收购，和陪聊产品是否成立，其实没太大关系\n 6:11 如果你是 C.AI 创始人，你会把 C.AI 定位为一家模型公司，还是一家应用公司？\n 8:02 C.AI 官网第一篇文章的第一句话，就注定了 C.AI 被收购的结局\n 19:32 如果要改变 C.AI 的结局，它唯一能做的，大概是在 23 年以最激进的态度融资\n 20:14 Scaling Law 的本质是规模效应，拼的是资源整合与融资能力\n 20:55 大模型是一场拼爹游戏\n 22:51 C.AI 的收购宣告了三点： 底层大模型的战争几乎结束\n 模型注定会商品化，护城河并不存在\n 做产品的人，可以安心拥抱开源了\n\n 24:13 一层更深的宿命论：Google 为什么要收 C.AI？\n 24:49 模块化 vs 全链路自营，哪个是 AI 市场的终局最优解？\n\n 28:07 微软和 OpenAI 的关系是最微妙最有趣的\n 29:49 关于开源，Meta 和阿里的决策逻辑是截然相反的 (这我真没想明白)\n 34:20 C.AI 可能做错了一些事情，但他们绝对选对了退场时间\n 34:46 如果 C.AI 生在中国，它能等来的大概不是收购邀约，而是回购条款\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n Ben Thompson 的文章：AI Integration and Modularization\n 红杉文章：Generative AI’s Act Two\n A16Z 文章：Who Owns the Generative AI Platform?\n 汪华播客：AI 的三个发展阶段、和移动互联网的异同、未来的演进路线｜对谈创新工场汪华\n C.AI 架构图：\n\n最后，插播一条全职招聘信息！42章经在招募新的内容同事，协助我们做播客、采访、私董会等等，欢迎大家点击链接了解投递",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "AI Integration and Modularization",
                "url": "https://stratechery.com/2024/ai-integration-and-modularization/"
              },
              {
                "text": "Generative AI’s Act Two",
                "url": "https://www.sequoiacap.com/article/generative-ai-act-two/"
              },
              {
                "text": "Who Owns the Generative AI Platform?",
                "url": "https://a16z.com/who-owns-the-generative-ai-platform/"
              },
              {
                "text": "AI 的三个发展阶段、和移动互联网的异同、未来的演进路线｜对谈创新工场汪华",
                "url": "https://www.xiaoyuzhoufm.com/episode/66b7909133591c27be2480c3"
              },
              {
                "text": "链接",
                "url": "https://yveh7jntg7.feishu.cn/docx/V546dZyZ2oKBzWxRyvAcfBcznOg?from=from_copylink"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9T0dFM016a3daalZpTnpVME1HWmpOV1JqWXpjNU16bGpaakJpWVRJNVpXWmZNVkp1TjFobk4wZGpabkpuVmpSVFZscHBSRE5LTUVaaldqRnlNbFZGU2taZlZHOXJaVzQ2VmtsbmMySjVaR296YjBSTldrZDRaSFZwVG1OemNUSlliakprWHpFM01qTTVNVEF4TlRnNk1UY3lNemt4TXpjMU9GOVdOQQ=="
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9WXpRM1pHSTROMkkzWldRM01EaGhaR0ZoWVdNMk9ERm1PRFEzWWpreU5qWmZUbHBDTVRCRlNsWlplSEpETWxrd1RVRm5aRXhhU3psV00zVnhSVlkxUTBOZlZHOXJaVzQ2Um05NmRtSlFjWEJDYnpneWIyRjRhSGxzWm1NeldtWTNibkprWHpFM01qTTVNVEF4TlRnNk1UY3lNemt4TXpjMU9GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66b7909133591c27be2480c3",
            "index": 41,
            "title": "AI 的三个发展阶段、和移动互联网的异同、未来的演进路线｜对谈创新工场汪华",
            "pub_date": "2024-08-10T16:08:49.000Z",
            "duration": "2716",
            "duration_label": "45m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "创业",
              "商业",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/66b7909133591c27be2480c3",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/66b7909133591c27be2480c3/media.xyzcdn.net/li5lEm-mwVwsc5TBo7P7OcRh1eWa.m4a",
            "play_count": null,
            "show_notes_text": "汪华是我过去十多年里见过的最有远见的投资人之一，他从 2009 年开始参与创新工场的创立并坚定地笃信移动互联网的投资机会，这比移动互联网元年还早一年，比大众市场对移动互联网形成共识还早四年。\n\n他在 2011、2012 年出来布道的很多文章到现在回看都非常准确，而令人欣喜的是，最近几个月他又开始频繁出现在大众的视野中为 AI 站台。对此，我问他，为什么去年没出来，最近反而出来了？他的回答是“去年大家对 AI 信到科幻，今年却又莫名悲观。”（笑）\n\n在这期播客中，我们回顾了移动互联网当年发生了什么，为什么绝大多数聪明人在 2008 到 2012 年之间都不认可移动互联网的机会，我们也再次把 AI 和移动互联网做了比较，汪华给出的答案我认为是对这个问题答案最好的阐述。\n\n可以说，这期内容更清晰的梳理了 AI 发展的机会、逻辑、框架，也讲清了未来几年的演进路线，对之前大家讨论的很多问题给出了答案。当然，我们也聊了很多当下 AI 和一级市场的问题，但不论如何，正如汪华结尾所说，对 AI，我们的内心都是火热的。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n23 号珍藏：汪华，创新工场合伙人\n\n【时光机】\n\n 1:04 去年大家对 AI 都信到科幻程度了，今年却又悲观起来了\n 2:52 为什么 08-13 年，相当多聪明人都迟迟没有意识到移动互联网的机会？\n 6:50 极少数人「因为相信所以看见」，大多数人「因为看见所以相信」\n 9:05 如果一定要拿 AI 做一个类比，它最适合对标什么？ 阶段 1: 交互革命 (移动互联网级别，100% 能实现)\n 阶段 2: 复杂任务自动化 (蒸汽机级别，50% 概率能实现)\n 阶段 3: AGI (智人走出非洲级别，不造能否实现)\n\n 13:02 AI 带来的变化和增量似乎远小于移动互联网，这会是一个问题吗？\n 18:14 AI 能否达到第 2 阶段，大概只要观察 3-4 年\n 18:50 AI 应用的发展顺序： 2B&生产力工具\n 大用户量工具\n 图文级别的社交娱乐类产品\n 海量的多媒体娱乐产品，以及真正意义上的商业重构\n\n 23:37 AI 比移动互联网更依赖创始人本身的能力\n 26:02 AI 创业，先发优势重要吗？\n 28:33 做 2C 应用，当下是最好的入场时间点\n 29:34 明年上半年，GPT-4 级别的模型一个 DAU 大概只要几分钱\n 30:28 开源模型和闭源模型会是怎样一个格局？\n 32:46 未来的 App 会变成什么样子？\n 36:49 一个新浪潮中，大厂早期优势大，但新公司晚期机会多\n 41:38 对于真正的聪明人来说，一级市场会是对 TA 天赋的浪费吗？\n 43:18 美元 VC 的消亡，可能是 AI 在中国发展遇到的最大阻碍\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜、梦昕\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n 文字稿：https://mp.weixin.qq.com/s/jwnDTmODj7PWWsmLw-1FJg\n最后，插播一条全职招聘信息！42章经在招募新的内容同事，协助我们做播客、采访、私董会等等，欢迎大家点击链接了解投递",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "链接",
                "url": "https://yveh7jntg7.feishu.cn/docx/V546dZyZ2oKBzWxRyvAcfBcznOg?from=from_copylink"
              },
              {
                "text": "https://mp.weixin.qq.com/s/jwnDTmODj7PWWsmLw-1FJg",
                "url": "https://mp.weixin.qq.com/s/jwnDTmODj7PWWsmLw-1FJg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "669144fc8fcadceb90e98435",
            "index": 42,
            "title": "上半年 AI 市场有多差？别刚起跑就想冲刺 | 我答莫傑麟",
            "pub_date": "2024-07-13T16:00:00.000Z",
            "duration": "3027",
            "duration_label": "50m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 6,
            "matched_keywords": [
              "AI",
              "创业",
              "大模型",
              "科技",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/669144fc8fcadceb90e98435",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/669144fc8fcadceb90e98435/media.xyzcdn.net/lk9IM7jiJSrxAX8bgmrt6EA1HcOx.m4a",
            "play_count": null,
            "show_notes_text": "这期播客有点不一样，往期主要都是我来提问，但这期是我来回答，我们之前的嘉宾莫傑麟来客串了一次主持。\n\n上一次我讲整个 AI 市场的复盘是在 24、25 年会是下一代浪潮最关键的两年 | AI 年终复盘，这次又过了半年时间，通过这次问答，我把我对于 AI 和当下市场的最新的观察、思考又做了一次输出，里面又有了很多新的迭代。\n\n相信经常关注 42章经 的人都对我们的产出质量有了解，这里我也就不多写什么具体的介绍了，祝收听愉快。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n9 号珍藏：莫傑麟，家族办公室资深从业者，拥有超过 10 年资产管理经验，专注于科技行业的另类投资组合 ( 往期考古：Ep.9 为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟 、 Ep.14 英伟达、Sora 与 AI 的三种核心叙事逻辑 | 对谈莫傑麟 )\n\n【时光机】\n\n 0:53 首先画一张 AI 市场的走势图\n 4:37 一线大模型的领先优势在不断拉大\n 5:59 AI 更像是电，做模型的人，不一定是最后赚到钱的人\n 9:14 今年上半年一级市场之差是十年所未见\n 12:20 做大模型没有先发优势，但做应用可能有两个：数据&认知\n 13:23 一些能跑出 PMF 的新线索： Prosumer 赛道\n 非结构化数据结构化\n\n 14:25 目前亮眼的 AI 应用做出的大多是增长型产品点，而不是刚需型产品点\n 15:00 全球华人创业者做的 AI 公司，有 PMF 的不超过 30 家\n 20:28 一个 AI 创业者，这两年最应该积累的是什么？\n 22:09 我仍然坚信这两年就是进场的好时机\n 26:33 如果选择一个上市公司作为 AI 的投资标的，你会选择哪个公司？\n 33:34 大家想产品方向要把脑洞开大一点啊，比如，我举个栗子\n 37:32 怎么定义最好的人？\n 39:40 大厂做模型的两类出发点：进攻 VS 防守\n 42:05 市场远远低估了 AI coding 的想象空间\n 44:13 这半年最重要的一个认知变化是什么？\n 44:28 为什么未来的 AI 产品一定是端到端分离的？\n 47:57 如何看待国内投资人转行做自媒体？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n 24、25 年会是下一代浪潮最关键的两年 | AI 年终复盘\n 一个顶级 AI 产品经理的自我修养 | 对谈光年之外产品负责人 Hidecloud\n 赚到 RMB 的 AiPPT、赚到美金的 ACE Studio 和赚到用户留存的捏Ta | AI PMF 系列创始人对话\n最后，插播一条全职招聘信息！42章经在招募新的内容同事，协助我们做播客、采访、私董会等等，欢迎大家点击链接了解投递",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "24、25 年会是下一代浪潮最关键的两年 | AI 年终复盘",
                "url": "https://www.xiaoyuzhoufm.com/episode/65a2a75fb5e4856c70801eba"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "Ep.9 为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/656aeffd0500be931c4eb099"
              },
              {
                "text": "Ep.14 英伟达、Sora 与 AI 的三种核心叙事逻辑 | 对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/65e34a65da891a9cd9bf90f2"
              },
              {
                "text": "一个顶级 AI 产品经理的自我修养 | 对谈光年之外产品负责人 Hidecloud",
                "url": "https://www.xiaoyuzhoufm.com/episode/6607a6961519139e4f7fd8a5"
              },
              {
                "text": "赚到 RMB 的 AiPPT、赚到美金的 ACE Studio 和赚到用户留存的捏Ta | AI PMF 系列创始人对话",
                "url": "https://www.xiaoyuzhoufm.com/episode/663f954caf1e22bb15b943d5"
              },
              {
                "text": "链接",
                "url": "https://yveh7jntg7.feishu.cn/docx/V546dZyZ2oKBzWxRyvAcfBcznOg?from=from_copylink"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6666dd6a94977a26ef5e07b7",
            "index": 43,
            "title": "英伟达的阳谋、破绽与野心 | 对话行云创始人 Mackler 季宇",
            "pub_date": "2024-06-10T16:00:00.000Z",
            "duration": "3399",
            "duration_label": "56m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 1,
            "matched_keywords": [
              "AI"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6666dd6a94977a26ef5e07b7",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6666dd6a94977a26ef5e07b7/media.xyzcdn.net/ljnpMxYJaVegL9lVD613ydxmJqWu.m4a",
            "play_count": null,
            "show_notes_text": "季宇是清华物理本科、计算机体系结构方向博士，他也是我认识的几个华为天才少年之一。认识他是因为在不同的时间点，分别有几个人跟我说，你要聊英伟达一定要找他，他是最懂英伟达的人，后来我看了他知乎（Mackler）上的很多篇文章以后确实觉得很厉害，于是就有了这次的对话。\n\n其实关于英伟达已经有各种文章和播客讲过，但大多花费了大量的笔墨和时间在讲 CPU、GPU、CUDA 等名词解释，我们这次先用了几分钟时间快速科普了这些基础内容，然后用一个不太一样的视角讲英伟达背后的战略体系，讲英伟达是怎么从 Intel 的垄断地位中杀出来，并有了今天绝对领先的生态地位的。\n\n我敢保证，这期的内容和视角是你从来没有看过听过的。在收听过这期内容之后，你会更理解英伟达在过去几十年里都做了什么，现在正在做什么，也更能理解老黄的 NB 和精妙之处，而且还会对芯片产业历史沿袭及各个公司的战略选择有更多的体会和启发。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n22 号珍藏：季宇，行云集成电路创始人\n\n【时光机】\n\nPart 1 如何理解过去 30 年，英伟达战略选择的精妙之处？\n\n 1:29 试图用两分钟解释 CPU、GPU 和 CUDA (CPU≈几个老教授，GPU≈几万个小学生，CUDA≈小学生指挥部）\n 4:21 说英伟达靠运气，是低估了老黄的实力\n 5:34 英伟达是如何解构英特尔的？\n 6:08 过去 10 年，英伟达为什么能把性能提升 1000 倍？\n 15:47 最顶级的竞争策略是一场阳谋\n 23:41 英伟达最重要的护城河并不是芯片，而是芯片之上的软件生态\n 24:58 黄仁勋最 nb 的能力：定义进化的方向\n 31:54 黄仁勋在一开始就把一切都想清楚了 (真可怕.jpg)\n 32:52 以弱胜强的一个解法：单点打爆\nPart 2 如何看待未来 30 年，英伟达的壁垒与软肋？\n\n 38:07 你对英伟达看好到什么程度？\n 40:40 英伟达的破绽在哪里？\n 44:01 英伟达的野心：把整个计算机系统变成我的全家桶\n 45:23 当一个芯片越全能，它反而越有可能被解构\n 51:54 英伟达的微妙处境——既想把市场做大，又想收更高溢价\n 54:16 如果你是黄仁勋，接下来最重要的事情是什么？\n 55:13 如果你是英特尔或 AMD，后面的仗要怎么打？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n 季宇知乎主页：www.zhihu.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "www.zhihu.com",
                "url": "https://www.zhihu.com/people/mackler"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6651b7a4c59d1e575797a520",
            "index": 44,
            "title": "世界好像变难了，我们该如何应对？| 对谈绿洲资本张津剑之 AI、人 与 生命力",
            "pub_date": "2024-05-25T16:00:00.000Z",
            "duration": "4746",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "科技",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6651b7a4c59d1e575797a520",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6651b7a4c59d1e575797a520/media.xyzcdn.net/ljJB_cRlXYB8imHiZMkllnczeXAG.m4a",
            "play_count": null,
            "show_notes_text": "这期内容的 AI 含量很低，但其实又处处在说 AI。\n\n新的科技不断带来信息频次的跃迁，让我们的生活有了天翻地覆的变化。这个世界是不是越来越难了？时间流速是不是越来越快了？至少我感觉确实如此。那这个背后的原因究竟是什么，我们又该如何应对这个情况呢？在这期内容里，张津剑给出了他系统性的答案。\n\n在将近一个半小时的时间里，你首先会听到张津剑在我们线下活动中的单人分享，主要就是围绕信息、频次、世界的变化等主题，这部分听完希望你能对我们所处的这个世界有更清晰客观的认知，之后在后半段的内容里你会听到我和他围绕 AI、人、生命力展开的问答讨论，包括如何理解一个人的生命力、如何变成一个更“好”的人取得更“好”的结果等等。\n\n相信这会是一期能超出 AI，并为每个人的人生带来更广泛的启发和释然的内容。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n1 号珍藏：张津剑，绿洲资本合伙人 (往期考古：投 AI 最猛的人 | 对谈绿洲资本合伙人张津剑)\n\n【时光机】\n\nPart 1 单人演讲 《投资中的低频与高频》\n\n 2:21 2024：世界变难了&时间变快了\n 11:16 每一次科技革命都是一次频率的跃迁\n\n 14:44 过去一年投 AI，我们越投越害怕\n 17:56 世界频率跃迁所带来的 5 个现象\n 25:02 一个奶茶铺子的傅里叶变换\n 32:51 找到自己的低频信号\n 33:44 我永远有三个东西：善良、欢喜、生命力\nPart 2 双人对谈 《AI、人、生命力》\n\n 37:55 生命力强的两大表现：实事求是&爱自己\n 43:25 爱自己，最重要的是放过自己\n 44:15 一个人经历的苦难和 TA 的生命力有多大的相关性？\n 49:00 一个好的创始人，大概会有一个怎样的脚本？\n 54:21 一个人的「定」，往往来自于一个人的「信」\n 1:00:07 一个有生命力的状态，恰恰是对自己预期比较低的状态\n 1:06:30 和创始人聊天的时候，哪一个问题是你经常会问的？\n 1:10:46 AI 还在以超出预期的方式加速\n 1:14:59 怎么看未来的经济和市场？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【张津剑|信号与噪声系列回顾】\n\n 投资中的信号与噪声\n 投资决策中的信噪比\n 投资中的周期与载波\n 投资中的节奏与结构\n\n（是一个尽兴的下午，谢谢到场的每一个人）\n\n【AI 私董会活动预告】",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "投 AI 最猛的人 | 对谈绿洲资本合伙人张津剑",
                "url": "https://www.xiaoyuzhoufm.com/episode/64c542a399e1e7669e56d4da"
              },
              {
                "text": "投资中的信号与噪声",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651048827&idx=1&sn=51dd4a5e6b428a842591723453b68825&chksm=8c38c4d3bb4f4dc50d961db0869529b1aebb6b093c1b31d29f49437b21d648507e62b3c53b91&scene=21#wechat_redirect"
              },
              {
                "text": "投资决策中的信噪比",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651049307&idx=1&sn=2eee9b484a94b476a215ae23f0e7a83c&chksm=8c38c2f3bb4f4be5d45d12bcccd4c1086e000e376128d2deb4b63145a35546cc7200455d8196&scene=21#wechat_redirect"
              },
              {
                "text": "投资中的周期与载波",
                "url": "http://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651049973&idx=1&sn=842cc37798360f367d1e63be336f47a0&chksm=8c38c05dbb4f494b072c90bb3fe80e48397373600081d20ba87f72b895d6d9f027321ad044e6&scene=21#wechat_redirect"
              },
              {
                "text": "投资中的节奏与结构",
                "url": "https://mp.weixin.qq.com/s/1bwTtJBi4vF5DEsLWFkAKw"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9WldVeVpEYzFaRGRsT1dKaE1EQTVNekExTlRrMU1qbGlPVGs1WVRGa09UbGZlSGxVVEd0WE0zSm1RV2RHWm5SR09IVkJOMmxFWVcxV1owaHRWRUZaZFRoZlZHOXJaVzQ2UW14Q1RXSTJWWGxOYjB0VGFEbDRWa1pQWm1NM1F6ZzNia3BrWHpFM01UWTJNekV4TnpZNk1UY3hOall6TkRjM05sOVdOQQ=="
              },
              {
                "text": "https://image.xyzcdn.net/FnmKtMnkbUEGJGZtTpvKFAke_RhJ.png",
                "url": "https://image.xyzcdn.net/FnmKtMnkbUEGJGZtTpvKFAke_RhJ.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "663f954caf1e22bb15b943d5",
            "index": 45,
            "title": "赚到 RMB 的 AiPPT、赚到美金的 ACE Studio 和赚到用户留存的捏Ta | AI PMF 系列创始人对话",
            "pub_date": "2024-05-11T15:56:59.000Z",
            "duration": "4761",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "创业",
              "商业",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/663f954caf1e22bb15b943d5",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/663f954caf1e22bb15b943d5/media.xyzcdn.net/lu7ABrO9O3ZzW7f6JRm_EOshdsyL.m4a",
            "play_count": null,
            "show_notes_text": "如果要给 23 年的 AI 市场一个关键词，那肯定是“大模型”，不管是大家的注意力、钱还是明星聚光灯下的公司都是那几家大模型公司，那如果要给 24 年的 AI 市场一个关键词，则一定是 PMF。\n\n不管是资本市场、还是从业人员、甚至包括大模型公司本身，今年最大的压力、最想看到的公司和产品，一定是有 PMF 的公司，如果没有 PMF，那 AI 这件事就会沦为一个 bubble。我知道大家日常可能很少有看到或使用到真的好的产品，也有很多人在质疑 AI 到底行不行，而我们则渐渐地开始看到一些 AI PMF 的影子，所以今年我们的播客新推出一个主题就是采访当下在 AI 领域已经有 PMF 的公司，我们每一期都会通过对话的方式给大家介绍三四家阶段性验证了 PMF 的 AI 公司。\n\n本期的三家公司分别是 AiPPT、ACE Studio 和 捏Ta。AiPPT 上线半年达到单月几百万人民币的收入，算是在国内验证了付费 PMF 的公司，ACE Studio 开启付费半年，目前单月几十万刀的海外收入，算是在海外验证了付费 PMF 的公司，而 捏Ta 则是已经有了超出互联网时代平均水平的用户留存数据，验证了国内的用户使用行为 PMF。\n\n这几家公司各有各的特色，有 2B 也有 2C，创始人的风格、关注点、对 AI 和产品等的理解也都不尽相同。PMF 并没有一个官方的绝对的定义，但我们希望用这样的方式多介绍一些能实际使用、有实际场景、收入或用户留存的产品，给这个行业一些信心，也给关注 AI 领域的人一些启发。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，本期的嘉宾中有两位也是我们 AI 私董会的成员，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n19 号珍藏：赵充，AiPPT 创始人\n\n20 号珍藏：Joe，ACE Studio 创始人\n\n21 号珍藏：胡修涵，捏Ta 创始人\n\n【时光机】\n\nPart 1 一键生成 PPT 的 AiPPT\n\n 4:08 AiPPT 为什么半年多就做到了几百万月收入？\n 11:39 到底谁在用 AiPPT？\n 16:48 从上帝视角创业\n 22:01 AiPPT 核心是在三个关键维度上竞争\n 26:23 我问了身边无数朋友，你打这场仗会怎么打？\n 27:09 如果需要向下补位，说明在招聘上没有花够的时间\nPart 2 AI 音乐制作工具 ACE Studio\n\n 34:36 ACE Studio 和 Suno 的核心区别是什么？\n 37:51 模型、创作工具、消费平台，到底谁是产业链的链主，谁会被整合吃掉？\n 41:04 ACE Studio 的商业化进阶史\n 44:47 格莱美音乐人的套娃反应 “I don't believe it & I told you”\n 50:33 一个小功能让用户翻了一倍\n 52:41 英语四级没过，也并不妨碍出海赚钱\n\nPart 3 二次元角色创建平台 捏Ta\n\n 58:31 捏Ta 是如何通过观察用户来持续迭代的？\n 1:01:00 只要能把内容创作的要素拆分得足够好，用户的消费行为和创作行为其实就可以合二为一\n 1:08:27 目前跑通 PMF 的 AI 产品基本都是在解决内容跨模态组合的问题\n 1:09:06 让 AI 从 creator 退化为 composer\n 1:15:07 捏Ta 核心做对了哪几件事情？\n\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜、梦昕\n Bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://image.xyzcdn.net/Fg-uy9OEd6wNDozWA1mAuaIEaK0K.png",
                "url": "https://image.xyzcdn.net/Fg-uy9OEd6wNDozWA1mAuaIEaK0K.png"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TVRBellXTmpOR1ZtTkRFeE1HVXlaalUyTnpCak0yUTVaREF6Wmpka1pXUmZPVGhtY1d0TVYwSjJWR2w0TVhaemFYSlBaMk4yVHpCelIzVXpWek5GVTI1ZlZHOXJaVzQ2U2tWYWFHSlhaa2xqYjFOd1ZXbDROMDlxYUdONmFGZDJibEZpWHpFM01UVTBNelV3T0RjNk1UY3hOVFF6T0RZNE4xOVdOQQ=="
              },
              {
                "text": "https://image.xyzcdn.net/FjuGYe0ownwz-8x5aIy764jULmXU.png",
                "url": "https://image.xyzcdn.net/FjuGYe0ownwz-8x5aIy764jULmXU.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6623ad66c3e09d8f374ff730",
            "index": 46,
            "title": "AI 硬件的道、法、术 | 对谈三耳猫创始人谢羽佳",
            "pub_date": "2024-04-20T16:00:00.000Z",
            "duration": "3018",
            "duration_label": "50m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6623ad66c3e09d8f374ff730",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6623ad66c3e09d8f374ff730/media.xyzcdn.net/lkCgIB-UWaFNw-qXlfOSGQlhwYcI.m4a",
            "play_count": null,
            "show_notes_text": "最近 AI 硬件特别的如火如荼，但因为经历过上波消费出海的热潮，我对 AI 硬件的定位是本质上这还是一种消费电子。那既然是消费电子，仍然是众筹、Amazon、线下渠道等一系列打法，所以这期播客我们请来了有十多年出海消费电子经验的羽佳，她既是这个领域的专家，又是一位新入行的 AI 硬件的创业者，我们借由 AI 的话题，一起聊了下她多年来在这方面积累的经验和认知，以及她对于 AI 带来的新变化的一些看法。\n\n羽佳作为 Anker 的 CEO 助理，经历了 Anker 从几亿到几十亿的全过程，后来她又在出门问问负责整个海外业务的增长，之后她参与创立的公司 Global Oneclick 更是出海服务领域的绝对头部代表，他们服务了超过 40 家百万美金级别的众筹项目，包括近年来特别成功的 Ecoflow、云鲸、拓竹、追觅、华米，以及新时代的 AI 硬件公司 plaud 等等都是他们的客户，所以她在这方面的话语权毋庸置疑。\n\n这期内容中，我们其实反复围绕着道、法、术三个层面对 AI 硬件/消费电子展开了讨论，相信听完这期播客，你也能快速的掌握 AI 硬件其中的核心 know how。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n18 号珍藏：谢羽佳，三耳猫创始人，前 Global Oneclick 联创\n\n【时光机】\n\n 2:35 AI 硬件怎么就突然火起来了?\n 3:26 硬件出海的三波浪潮 3:34 09-18 年，以安克为代表的第一波跨境电商品牌\n 5:04 16-22 年，以 EcoFlow、拓竹为代表的产品创新型品牌\n 6:20 23 年开始的 AI 硬件浪潮\n\n 6:32 AI 形成了一个又高又宽又长周期的共创空间，有超级物种的机会，也有小鱼小虾的空间\n 7:44 这一波 AI 本质上给硬件产品带来的两个核心作用是？\n 12:33 AI 能不能把所有的硬件都重做一遍？\n 18:58 众筹更多的作用其实是 to VC？\n 25:49 Amazon 对新兴品牌变得不友好了吗？\n 27:21 一个硬件消费品公司一共有几条命？\n 27:51 创新变量是需要高容错来对冲的\n 29:16 我真的希望硬件创业者都能想明白的一个问题\n 36:41 消费电子品牌能长出够深的护城河吗？\n 43:13 消费电子的 0-1，1-10，10-100 核心分别是什么？\n 46:36 AI 硬件的道、法、术到底是什么？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66116fd14f66d1c1da5f1541",
            "index": 47,
            "title": "Suno 与 AI 重塑音乐的想象 | 对谈快音创始人李岩",
            "pub_date": "2024-04-06T15:52:49.000Z",
            "duration": "1804",
            "duration_label": "30m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "商业"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/66116fd14f66d1c1da5f1541",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/66116fd14f66d1c1da5f1541/media.xyzcdn.net/lrrLhQhMRB5kJU_x54fmJeCS1E34.m4a",
            "play_count": null,
            "show_notes_text": "我当下有个感慨，以后的小朋友们应该都不会背唐诗三百首了，就应该有人做一个 AI 音乐专辑叫《唐诗新唱三百首》之类的。AI 音乐现在大家都玩得很开心，但我确实觉得大多数人都低估了这件事的想象空间，未来会有很多表达形态和日常习惯会被其改变。\n\n在这期播客中，我们就请到了快音的创始人李岩，他从 15 年到 18 年在字节负责整体增长策略，经历了抖音等各个平台的快速起量和增长阶段，后来他看到了音乐平台被推荐算法改变的机会，创业做了快音这个平台，最高峰达到了 300w+ 的日活，这两年他们也一直在思考和探索 AI 生成音乐这条路径。\n\nAI 音乐改变的不只是音乐产业的运作方式，大幅降低的音乐生产门槛其实还解锁了非常多的想象空间，比如现在已经有很多博主在用快音创作 AI 音乐解说电影等，这期内容中我和李岩一起探讨了音乐发展的几个历程（从版权之争、到短视频对音乐产业的改变、再到当下的 AI 浪潮），我们也开放性地探讨了 AI 音乐未来的想象空间。\n\n就像我们在播客中所说的，我相信 AI 生成音乐是所有 AI 生成类型的内容中最被大家低估的一个场景，而其成熟度其实已经非常之高，在这期音频中我们也插入了三段 AI 生成的音乐供大家感受。\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n17 号珍藏：李岩，快音创始人\n\n【时光机】\n\n 1:49 AI 之前，音乐行业的核心就是拼版权\n 3:35 音乐是最妙的一个商业模式: 一首歌，越老越值钱\n 4:43 短视频给音乐这种内容形式带来了哪些改变？\n 6:59 AI 会如何改变音乐的生产流程？\n 8:38 当前 AI 生成音乐的两种解决方案，与各自的优劣\n 10:23 AI 对音乐从业者的影响：头部永远很稳，中部会受到冲击，底部会有更多机会\n 11:20 供给增大后，音乐的供需匹配会发生怎样的变化？\n 16:42 AI 音乐的出现，会解锁哪些新的场景？\n 20:30 为什么说音乐是所有 AI 生成类别里最被低估的？\n 26:12 音乐会是 AI 时代的表情包，所有个人表达的场景都可以被它吃掉一部分\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Suno 生成 （歌词及完整版音乐参见：yveh7jntg7.feishu.cn）\n 正片民谣版《江雪》：Suno 生成\n 片尾 bgm：快音 AI 写歌生成\n【Reference】\n\n世界上竟然有一张在发行后还不断更新的唱片？\n\n【AI 私董会活动预告】",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "yveh7jntg7.feishu.cn",
                "url": "https://yveh7jntg7.feishu.cn/docx/N7IMdmls0oTL4Rx8QeBcMdx6nNc?from=from_copylink"
              },
              {
                "text": "世界上竟然有一张在发行后还不断更新的唱片？",
                "url": "https://mp.weixin.qq.com/s/Lj7cbk0SBXqejUu06Xe70A"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TWpFM09UYzRaakEwTURKbU56Y3dORGhqTnpjME16RTVOREZqWkRObE4yWmZRV0kwTW5BNVNFcFBWbFJLUlU4MVJrVndiRlp5T0RWek5VeFhlSGRZVW01ZlZHOXJaVzQ2U2xsWVVtSkNjblJ2YjBoWFRraDRhMUZDZG1OYWJXdFlibFptWHpFM01USTBNVGczTURrNk1UY3hNalF5TWpNd09WOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6607a6961519139e4f7fd8a5",
            "index": 48,
            "title": "一个顶级 AI 产品经理的自我修养 | 对谈光年之外产品负责人 Hidecloud",
            "pub_date": "2024-03-30T16:00:00.000Z",
            "duration": "3352",
            "duration_label": "55m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6607a6961519139e4f7fd8a5",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6607a6961519139e4f7fd8a5/media.xyzcdn.net/lh7GqpS4vRCFtPM-vI9_a7lJCY05.m4a",
            "play_count": null,
            "show_notes_text": "最近一年经常和创业者聊到的话题就是 AI 产品经理到底该长什么样子，该怎么招、怎么培养，以及公司的组织结构该怎么调整成最适应 AI Native 的形态。\n\n我认为 Hidecloud 是目前国内最典型的做得最好的 AI 产品经理之一，他通过一年的探索，亲身试验了很多 AI 产品，在这期播客中我们一起探讨和解答了很多上述提到的问题，而且相信每个人在听过他的分享以后，都能有个大概的感觉：原来这就是好的 AI 产品经理的画像。\n\n此外，因为他的动手能力很强，真正实践过很多产品的落地，所以本期内容中也包括了大量一线的对技术判断的视角，以及对市场和产品现状的感受等。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n16 号珍藏：张涛 (Hidecloud)，光年之外产品负责人\n\n【时光机】\n\n 1:20 光年之外最近在做什么？\n 3:14 开源社区每天都和过年一样\n 8:08 为什么市面上迟迟没出来好的 AI 产品？\n 17:14 高度看好陪伴类 AI，因为人类的情感太容易被 hack 了\n 23:34 文字和图像模型都完全够用了，多模态模型还要 3-6 个月成熟\n 24:25 我认为今年 toB，toC 都会有现象级的产品出来了\n 25:04 AIGC 的过程有很多未被挖掘的产品嗨点\n 32:25 AI 产品经理该怎么招？\n 34:33 AI 时代，产品经理与技术的分工合作会发生哪些变化？\n 38:54 从 Stable Diffusion 的底层原理思考未来的推荐系统\n 43:40 产品经理该如何学 AI ?\n 47:53 动手体验一次，比看 10 篇文章启发都大\n 50:55 AI 太早期了，你做点微小的工作，就能产生极其大的回报\n 55:21 我更坚定地认为，AI 是移动互联网之后的第二次大机会\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n 嘉宾公众号：潜云思绪\n 产品人该怎么学 AI：古典 PM 现身说法 (播客中提到的分享视频版)\n 关于Diffusion你应该了解的一切 (分享文字稿)\n 一个有趣的职业可能性，与你分享 (Hidecloud 早年前给神策写的 JD)\n Andrej Karpathy Twitter (Follow 最新论文)\n StreamDiffusion: A Pipeline-Level Solution for Real-Time Interactive Generation (Hidecloud 提到的用工程学方法加速图片生成的研究)\n PIXART-Σ: Weak-to-Strong Training of Diffusion Transformer for 4K Text-to-Image Generation (华为诺亚方舟实验室发布的文生图模型)\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "产品人该怎么学 AI：古典 PM 现身说法",
                "url": "https://mp.weixin.qq.com/s/DMLtaesPTZMOuxjr0BTFbQ"
              },
              {
                "text": "关于Diffusion你应该了解的一切",
                "url": "https://mp.weixin.qq.com/s/wTLfg4D2jx3aYPAvhfv32A"
              },
              {
                "text": "一个有趣的职业可能性，与你分享",
                "url": "https://mp.weixin.qq.com/s/FlP-owZ814ArO8Fkxrtt3A"
              },
              {
                "text": "Andrej Karpathy Twitter",
                "url": "https://twitter.com/karpathy?lang=en"
              },
              {
                "text": "StreamDiffusion: A Pipeline-Level Solution for Real-Time Interactive Generation",
                "url": "https://github.com/cumulo-autumn/StreamDiffusion"
              },
              {
                "text": "PIXART-Σ: Weak-to-Strong Training of Diffusion Transformer for 4K Text-to-Image ",
                "url": "https://pixart-alpha.github.io/PixArt-sigma-project/"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65febe0b1519139e4f1d717f",
            "index": 49,
            "title": "完整经历 AI 四小龙与 RPA 浪潮后，他觉得 24 年会迎来 2B AI 应用的爆发 | 对谈澜码创始人周健",
            "pub_date": "2024-03-23T16:00:00.000Z",
            "duration": "2611",
            "duration_label": "43m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 6,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "大模型",
              "科技",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/65febe0b1519139e4f1d717f",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/65febe0b1519139e4f1d717f/media.xyzcdn.net/lq9c_bhr5QBvPBzqHaKSrhw_DivI.m4a",
            "play_count": null,
            "show_notes_text": "澜码是目前国内 AI 2B 领域的典型代表公司之一。从阿里云创始团队成员、到依图的十号员工、再到弘玑 RPA 的 CTO，周健几乎横跨了国内整个 AI 和 2B 产业的发展历程。去年初，他又是最早的一批出来做 AI Agent 2B 创业的人。\n\n在这期播客中，我和他快速回顾了当年 AI 四小龙的一些发展历程，并和这波大模型的发展做了一些对比，他也给出了为什么不看好 RPA + AI 的一些看法观点。我们还聊了国内 AI 落地的一些场景、局限等，其中周健给出了一个很乐观的观察，即在他眼中目前国内的市场、客户、钱、技术等其实都到了一个很 ready 的状态，需要的就是更多人进来做产品把市场需求打通。\n\n作为一个有着最丰富 AI 相关经验的人，周健在这期播客中的回答都非常实在，我们围绕很多国内 2B 市场核心问题进行了很直接的讨论（比如为什么觉得国内 2B 还有机会、大小 B 的选择、国内 AI 2B 领域的落地场景、一些之前踩过的坑等等），相信这期内容对感兴趣 AI + 2B 市场的人来说会是一个很好的参考。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n15 号珍藏：周健，澜码科技创始人\n\n【时光机】\n\n 2:25 现在的大模型与上一波 AI 四小龙有可比性吗？\n 12:08 RPA + AI 真的是一个很好的结合吗？\n 14:20 ToB 场景里，AI 的能力已经完全够用了\n 15:00 上两波周期中一些可复用的踩坑教训\n 23:56 国内 toB 还是存在结构性的机会的\n 27:31 澜码已经落地的 AI 应用场景有哪些？\n 28:21 企业算力管理会是一个极大的刚需\n 35:53 AI Agent 为什么还都无法落地？\n 38:55 我认为 24 年会迎来 AI 应用的爆发\n 40:28 我的竞争者不是太多了，而是太少了\n 41:24 AGI、世界模型与人机共生的一些想象\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Notes】\n\n周健播客中提到的 Inbound 是指通过 SEO/内容营销等手段，吸引有需求的客户主动上门咨询 (区别于 outbound marketing，即企业方更加主动，通过各种渠道接触潜在的客户，推销产品)\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人（本期嘉宾周健也是其中一员），欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65f16b236764957079157e9c",
            "index": 50,
            "title": "02 年伯克利辍学生，千万美金融资额，FlowGPT 背后的从 0 到 1 | 对谈 FlowGPT 创始人 Jay",
            "pub_date": "2024-03-13T16:00:00.000Z",
            "duration": "2997",
            "duration_label": "49m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/65f16b236764957079157e9c",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/65f16b236764957079157e9c/media.xyzcdn.net/lqDBV0jS1Va9YuQTP3DuN-GZ9RbM.m4a",
            "play_count": null,
            "show_notes_text": "这是一期补发的播客。我们是在去年 11 月录制的，因为实在聊 high 了讲了太多细节，尤其是新一轮融资的一些情况所以 hold 到了今天。最近 FlowGPT 终于官宣了新一轮 Goodwater 领投的千万美元的融资，这期也可以重见天日啦。\n\nJ 大概会是42章经播客历史上（和可见的未来）最小的被访者。\n\n他是 02 年的，去年年初刚大二就从伯克利辍学创业，做了一家公司叫 FlowGPT。截止去年 11 月，FlowGPT 已经拥有了 300 万的月活用户，成为了全球最大的 Prompt 社区——或者用他现在给自己的定位 “AI 原生应用平台”。\n\n我其实在之前的播客里有提到过，我对于年轻、经验不足的创业者是倾向于悲观的，但 J 聊起来给我一种非常早熟、踏实的感觉，这和他的年龄非常不符合。从和他的对话中，我大概明白了为什么他能做得这么成功，以及为什么他是今年最常被投资人提及、讨论和喜爱的创业者之一。\n\n在这期播客中，你将听到他辍学创业的起因经过，也能从他的视角看到 300 万的月活用户都是怎么理解和使用 AI 的，以及他对于 AI、Prompt 等事情的理解，我相信他是全球对这件事最有发言权的人之一了。此外，我还和他聊了一些他融资中的趣事，和他中美两地融资的一些故事和感受。\n\n正是 J 这样的创业者，让我们仍然对 AI、对创业、对未来充满热诚和期望。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n14 号珍藏：Jay 党嘉成，FlowGPT 创始人\n\n【时光机】\n\nPart 1 一个 00 后如何做出了全球最大的开源 AI 应用平台？\n\n 2:04 为什么果断地选择大二就辍学创业？\n 3:27 做 2C 平台需要的是你没有经验\n 4:11 我违背了我当时读到的所有创业指南\n 6:03 Do things don't scale 之我私聊了几千个用户\nPart 2 全球用户的 Prompt 使用观察\n\n 12:27 GPT Store 是 AI 时代的 ios，FlowGPT 是安卓\n 20:21 FlowGPT 上最典型的应用\n 21:36 为什么创作者普遍不喜欢 Character.AI?\n 22:59 300w 月活用户的主要使用场景\n 23:55 那些颠覆认知的用户观察\n 29:33 Prompt 会是一个阶段性的东西吗？\nPart 3 中美融资的区别\n\n 38:54 中美融资的不同特点\n 41:29 Jay 的美国融资故事\n 47:13 中美基金合伙人，问出的令你印象最深的问题分别是什么？\n 49:00 作为一个 02 年的创业者，我最担心的事是我太老了\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n Paul Graham 经典文章：Do Things That Don't Scale\n FlowGPT 上最火的 Prompt 生成器: flowgpt.com\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "Do Things That Don't Scale",
                "url": "http://www.paulgraham.com/ds.html"
              },
              {
                "text": "flowgpt.com",
                "url": "https://flowgpt.com/p/prompt-generator-11"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65ec84e02d96b6aa80bdf296",
            "index": 51,
            "title": "比特币怎么又创新高了？Web3 世界这几年在发生什么？| 对谈 Generative Ventures 合伙人 Will",
            "pub_date": "2024-03-09T15:48:47.000Z",
            "duration": "4191",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "科技",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/65ec84e02d96b6aa80bdf296",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/65ec84e02d96b6aa80bdf296/media.xyzcdn.net/lssbPDjOzxK9Kn4zKmLtZMx3uWja.m4a",
            "play_count": null,
            "show_notes_text": "我不属于 Web3 世界，本期播客也不是为了鼓励大家买币或投身 Web3，更不构成任何的投资建议。但不得不承认，我身边不断有很多靠谱又聪明的朋友投身其中，所以我隔三差五还是会好奇 Web3 世界到底在发生什么，以及，怎么 BTC 就真的又新高了呢。。\n\nWill 就是我说的这些朋友之一，他在古典互联网从事了十多年的投资，也有非常好的成绩和口碑，在这期播客里他详细解释了投身 Web3 的原因，也讲了他眼中的 Web3 世界目前的发展和底层叙事逻辑。在录这期播客的时候，BTC 大概是 63000 的价格，我们还在讨论什么时候会新高，没想到几天过去就已经达到了 70000 的价格。\n\n所以，如果你也对这个世界的进展感兴趣，如果你也是一个 open-minded 的充满好奇心的人，那希望这期播客能帮你获取到关于 Web3 和 BTC 新高背后最新的信息和叙事。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n13 号珍藏：Will，Generative Ventures 合伙人\n\n【时光机】\n\n 2:56 为什么选择在 23 年成立一支看 Web3 的基金？\n 5:12 是什么底层的规律使得区块链比移动互联网存在的时间还要长？\n 10:36 这一轮 Web3 牛市的原因是什么？\n 15:30 比特币将创历史新高，但它的价值到底是什么？\n 22:00 我们基金的假设是，比特币未来 5 年会有 5 倍的涨幅\n 22:49 躺赢在这个行业是可以做到的\n 26:21 为什么做 Web3 现在成为了一个减分项？\n 31:08 Web3 的核心价值是什么？\n 37:55 Web3 的基建还没有做完，应用注定落不了地\n 42:35 Web3 本质是公海上搭建起的一套金融网络\n 43:52 NFT 和 GameFi 做不起来的根本原因\n 48:33 未来 10 年内可能会有新的中本聪时刻，来解决 AI 带来的 Agency risk\n 52:07 AI + Web3 的机会有哪些？\n 57:15 稀释是对投资最大，但最容易被忽视的伤害\n 1:05:50 现在的 TMT 投资人都是站在 “第三次世界大战” 前线的人\n 1:08:24 从一个行商，变为一个坐商吧\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Notes】\n\nMagnificent 7：指美股市场的七大科技巨头，包括：苹果、微软、Alphabet、Meta、特斯拉、英伟达、亚马逊\n\nAgency risk：指委托人将资产的支配权转让给代理人后可能有利益损失的风险 (通常因为代理人更倾向于以自己的最佳利益，而非以委托人的最佳利益行事)\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65e34a65da891a9cd9bf90f2",
            "index": 52,
            "title": "英伟达、Sora 与 AI 的三种核心叙事逻辑 | 对谈莫傑麟",
            "pub_date": "2024-03-02T15:48:52.000Z",
            "duration": "2345",
            "duration_label": "39m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "创业",
              "大模型",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/65e34a65da891a9cd9bf90f2",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/65e34a65da891a9cd9bf90f2/media.xyzcdn.net/lpDDho7HlYk_O62Mv3C4OlQochV9.m4a",
            "play_count": null,
            "show_notes_text": "Sora 我想了很久该怎么讲，也问了一些人，但其实技术层面的解读已经很多了，产品上也没有开放，再去赘述也没什么意思，本质上 Sora 还是模型能力的一种延续，所以在这期里，我们把 Sora、英伟达 等统一到了一个大的叙事逻辑之下来讨论。\n\n我们讲了 Sora 的意义和影响是什么，英伟达持续飙涨的背后原因是什么 (以及是否可持续?)，还讨论了 AI 世界 (尤其是海外) 到底在发生什么，以及在这个叙事下不同阶段的逻辑、可能产生的变化是什么。相信听完这期播客，大家都能从宏观上对整体的 AI 发展有一个把握，再去看各种新模型、新热点也都能有更好的对号入座的理解。\n\n如播客中所讲，我们目前其实是处于 1.0 时代到 1.5 时代的交替过程中，我们也十分期盼 2.0 时代 AI 真正爆发的到来。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n九号珍藏：莫傑麟，家族办公室资深从业者\n\n【时光机】\n\n 1:33 如何理解 AI 市场的核心逻辑？\n 1:42 AI 1.0 阶段的叙事逻辑：Scaling law\n 4:41 AI 1.5 阶段的叙事逻辑：Scale in & Scale out\n 5:56 AI 2.0 阶段的叙事逻辑：应用的大爆发\n 9:28 AI 应用目前处于一个试探玩法的阶段\n 11:10 国内这波创始人的质量是相当高的\n 12:51 AI 投资的三种表现\n 19:16 评估英伟达的股价，要同时具备微观、中观、宏观三种视角\n 21:20 贪吃蛇与俄罗斯方块的游戏\n 22:23 大公司与创业公司的博弈像一场「球球大作战」的游戏\n 29:57 国内大模型和 OpenAI 之间的差距到底是在缩进还是在拉远？\n 31:31 关于 Sora 的几点启发\n 33:12 Sam Altman 是面壁人，Elon Musk 是破壁人，Jensen Huang 是真正的受益人\n 35:24 行业开始洗牌，谁领先，谁出局，会是今年的核心看点\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟",
                "url": "https://www.xiaoyuzhoufm.com/episode/656aeffd0500be931c4eb099?s=eyJ1IjogIjVmODY4YzQxZTBmNWU3MjNiYjRmYzM1ZSJ9"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://image.xyzcdn.net/FiDy9_V3LdWmmOPOWc-okhYJt42_.png",
                "url": "https://image.xyzcdn.net/FiDy9_V3LdWmmOPOWc-okhYJt42_.png"
              },
              {
                "text": "https://image.xyzcdn.net/Fo_pTYDNEq0iRN4VdoVUdleKoKKC.jpg",
                "url": "https://image.xyzcdn.net/Fo_pTYDNEq0iRN4VdoVUdleKoKKC.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FmcZ9suuUTBS2mMsv07x2egnr5ob.jpg",
                "url": "https://image.xyzcdn.net/FmcZ9suuUTBS2mMsv07x2egnr5ob.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65be63d8cace72dff87dddc0",
            "index": 53,
            "title": "一年内做成北美 Top 1 的 AI 教育产品，出海到底该咋干？ | 对谈 Answer.AI 张阳",
            "pub_date": "2024-02-03T16:03:35.000Z",
            "duration": "3094",
            "duration_label": "51m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "商业",
              "大模型",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/65be63d8cace72dff87dddc0",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/65be63d8cace72dff87dddc0/media.xyzcdn.net/lvMV9c5xta7EwBeWMdT-1282VACM.m4a",
            "play_count": null,
            "show_notes_text": "这期又为大家带来一个优秀的水下项目。Answer.AI 的用户量级和收入都很出彩，可以算是目前北美 AI 教育赛道的第一名。这期我们请来了在公司负责产品和增长的联合创始人张阳来分享下他多年的经验，以及 Answer.AI 是如何从零到一的。\n\n张阳对于出海可以说有非常多一手的经验认知，他之前分别在小米、字节等公司做过多款出海产品，有的很快就做到了日活几千万量级。在这期播客里，他为我们分享了很多关于出海用研、增长和商业化的思考，比如是否本地化本质是用户研究做的怎么样，产品出海增长的三要素到底是什么，以及他是如何从零开始做出海渠道增长这件事的等等。\n\n其实聊的过程中，我发现有很多点都是普世的真理，很多人容易把出海这件事神话，或者自己天然在心理上创造了门槛，但其实我们花了很多时间在聊的还是怎么找用户需求、怎么做好产品和增长，是不是出海似乎也没有那么大的区别，相信大家听完以后也可以打破一些过往的迷思，所谓的出海，不算是什么艰难的远征，就只是一步步把该做的事情做好。\n\n对了，我们还在结尾探讨了一下 AI 原生产品的设计思路，这部分内容格外精彩，也不要错过 :P\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n12 号珍藏：张阳，Answer.AI 联创\n\n【时光机】\n\nPart 1 出海产品设计\n\n 2:13 好的国际化产品≈通用化产品+本土化运营\n 6:49 出海到底需不需要人也出去？\n 12:03 出海的难度，被市场低估了还是高估了？\n 13:36 怎么做用户调研？\n 15:55 关于商业化变现，你要做得比你想象得还大胆一些\n 21:13 Answer.ai 收获的两个重要反馈\nPart 2 出海产品增长\n\n 25:09 增长核心三要素：产品底子、供血的商业化能力、自然裂变能力\n 29:09 海外做增长的三个重要手段 29:22 媒体投放 (取决于渠道+内容)\n 30:02 自然增长 (取决于品牌力+裂变设计)\n 30:44 社群 (一定要做，越早越好)\n\n 33:49 Answer.ai 在增长方面都做对了什么？\n 37:22 对相当多 AI 产品来说，大模型的能力都还有可被深挖的地方\n 41:59 基于 AI 的产品设计，到底有什么核心不同？\n 47:08 增长会给你一种幻觉\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n钱颖一对谈张一鸣：做 CEO 学会的最重要的事是面对不确定性\n\nHeygen 创始人徐卓的自我复盘：我们如何在 7 个月内达成 100 万美金年收入？\n\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "钱颖一对谈张一鸣：做 CEO 学会的最重要的事是面对不确定性",
                "url": "https://mp.weixin.qq.com/s/OnwT4llsJkPuQi1gn8XmKQ"
              },
              {
                "text": "Heygen 创始人徐卓的自我复盘：我们如何在 7 个月内达成 100 万美金年收入？",
                "url": "https://www.heygen.com/article/0-1m-arr-in-7-months"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65a2a75fb5e4856c70801eba",
            "index": 54,
            "title": "24、25 年会是下一代浪潮最关键的两年 | AI 年终复盘",
            "pub_date": "2024-01-13T15:08:15.000Z",
            "duration": "2444",
            "duration_label": "40m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "创业",
              "大模型",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/65a2a75fb5e4856c70801eba",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/65a2a75fb5e4856c70801eba/media.xyzcdn.net/luOboCPVpk62kKRZfHYn8crxe0UU.m4a",
            "play_count": null,
            "show_notes_text": "这是一期单口。\n\n2023 年，我聊过市场上大部分的 AI 创始人，和几乎所有的 AI 投资人，我们自己也服务了十多家 AI 公司的融资，并且参与了其中四家的投资。可以说我的视角相对而言是最一线和全面的，在这个过程中我也有很多自己关于 AI 市场、产品、资本环境等等的思考。\n\n这一期播客，我就和大家无保留地分享下我对于 23 年 AI 市场的总结观察，以及对 24 年及之后市场变化趋势的判断。这期虽然叫复盘，但其中大量的内容和思考都是未在市场上出现过的，希望不会听起来太“干” :P\n\n诚如这期的标题，我觉得 24、25 年就是我们这代人最关键的两年的机会，而我敢说任何人都可以通过听这期播客快速拉齐信息和认知差，成为最懂当下 AI 市场的人之一。希望这两年能和大家一起加油努力，也期待能和大家以各种方式产生合作和联系。\n\n另外，因为发现42章经有好多宝藏听友，评论区总卧虎藏龙，所以我们决定，往后每一期节目的评论区都留出一场小型的讨论会，欢迎大家补充你们的观点，我们一起切磋讨论。或者，你也可以把它当成一场为期一天的 AMA (Ask Me Anything)，向我们随意发问，凡是第一天的评论我们都会及时回复 (往后就一切随缘啦)。\n\n【时光机】\n\n 0:20 24、25 年会是下一代浪潮最关键的两年\n 7:51 当下市场的核心问题：AI 并不能被称为一个 “赛道”\n 9:16 创业者要解决的核心问题从 “如何讲故事拿融资” 变成了 “如何靠自己赚钱做收入利润”\n 11:18 解决大模型可控性差的三条路径\n 14:29 技术不成熟的阶段，反而更需要好的产品经理\n 16:22 2024 会不会是 AI 时代的 2010 (移动互联网元年) ？\n 18:36 一个判断：24 年会出现大规模落地的产品，25 年 AI 会迎来爆发\n 19:11 当下一定要接受的两个设定： 19:18 ① 暂时放弃对 AI Native 的追求\n 21:12 ② 当前所有的产品都将成为先烈和炮灰 (但团队不会)\n\n 24:00 一些未来的方向和机会： 24:23 ① 所有的外包场景都有机会用 AI 重做一遍，并扩大 n 倍\n 26:17 ② 大多的双边平台都有机会被 AI 改造\n 33:33 ③ 大多的复杂产品都有机会被简化成聊天类产品交付\n 35:56 ④ 内容生成即渠道\n\n 37:45 2024 年我们判断公司和选择项目的标准\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n 推送文字稿：https://mp.weixin.qq.com/s/0XOBiRjjTR8KZIB5eRxS5g\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://image.xyzcdn.net/FkB1ihpMIA9dx9UG5-Jo-WKki1pp.jpg",
                "url": "https://image.xyzcdn.net/FkB1ihpMIA9dx9UG5-Jo-WKki1pp.jpg"
              },
              {
                "text": "https://mp.weixin.qq.com/s/0XOBiRjjTR8KZIB5eRxS5g",
                "url": "https://mp.weixin.qq.com/s/0XOBiRjjTR8KZIB5eRxS5g"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6586ca30157cd445eebb399c",
            "index": 55,
            "title": "插件、套壳、收购产品? Monica 从 0 到百万用户的 AI 助手之路 | 对谈 Monica 创始人肖弘",
            "pub_date": "2023-12-23T16:00:00.000Z",
            "duration": "3258",
            "duration_label": "54m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "创业",
              "商业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6586ca30157cd445eebb399c",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6586ca30157cd445eebb399c/media.xyzcdn.net/lp7n3o3nx1WJrpQxdXhtGKC6sV7B.m4a",
            "play_count": null,
            "show_notes_text": "很开心这期我们又请来了一家标杆式的 AI 企业的创始人。\n\nMonica 是今年很多人都听说过的一家公司，从年初开始起量，到目前有几百万的用户，而且主要市场就是海外，这在今年的 AI 产品来说，肯定算是少有的成功案例了。而在这个过程中市场上也流传了很多相关的故事，比如 Monica 作为一家初创公司竟然是靠收购了一个产品做起来的？比如 Monica 是否就是一个套壳产品？比如浏览器插件的价值到底在哪里？等等。\n\n在这期播客里，我们复盘了 Monica 的创业故事，讲了这个 idea 的由来、分享了收购其它产品和公司的故事及逻辑，创始人也回应了对于套壳等说法的看法。Monica 创始人肖弘在我眼中是个非典型的成熟创始人，可能是因为他曾经成功出售过一家公司的原因，他对于商业的理解很深，很擅长做商业化，也善于用资本的工具来构建自己的产品和业务，并且从第一天开始就格外关注组织建设，会不断理性地用 top down 的方式思考各种机会。\n\n所以，希望大家听完这期能从中汲取到一些不同的创业视角和逻辑，开拓一下思路。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n11 号珍藏：Red 肖弘，Monica.im 创始人\n\n【时光机】\n\nPart 1 Monica 背后的商业洞察\n\n 1:51 早于 ChatGPT 的 Monica，立项是基于哪些洞察？\n 3:43 浏览器插件的核心优势：实现对功能的分发\n 9:15 我超过一半的精力在思考组织建设\n 13:00 套壳到极致就是牛逼\n 13:46 Jasper 最致命的战略失误：它给自己提了一个错误的问题\nPart 2 小红的创业故事\n\n 19:14 定个小目标：每月额外挣出 50 万补贴公司主业\n 20:43 从筹备亚马逊店/咖啡店，到发现商机做出拥有百万用户的 AI 应用\n 22:10 通过收购独立开发者的小产品做业务增长\n 24:28 收购 ChatGPT for Google 的估值逻辑&谈判经验\nPart 3 比思考更重要的是如何形成这些思考\n\n 34:10 Downside 由自己掌控，Upside 凭时局安排\n 36:10 那些不一样的做事思路是如何形成的？\n 36:46 从《详谈》,《金钱博弈》及安踏并购中分别收获的创业启发\n 42:24 商业化能力决定增长能力\n 45:41 问自己：有什么变化一旦发生会很了不起，然后去持续观察这件事\n 47:25 一个思考 AI 产品设计的巧妙角度\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n 台积电创始人张忠谋演讲，关于 60 年创业和管理心得mp.weixin.qq.com\n 《详谈：赵鹏》李翔 book.douban.com\n 《金钱博弈》单伟建 book.douban.com\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "mp.weixin.qq.com",
                "url": "https://mp.weixin.qq.com/s/5BEY3pzs9vXNQYRnssSUkA"
              },
              {
                "text": "book.douban.com",
                "url": "https://book.douban.com/subject/35523118/"
              },
              {
                "text": "book.douban.com",
                "url": "https://book.douban.com/subject/35902211/"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TkdVek1EQmlPRFpoTldVeFlqZGpPRFF6Wm1KaU9HSTROamxoWVdVMU9UWmZVVEl4VDJ3eWVHdHhVSGgwWjJaVk5HZENabUZuUWxka1lYcFhjelJ1UkV4ZlZHOXJaVzQ2UlRWR04ySnBkbGRDYjJVMlNUTjRSR0Y2YTJORldVeEpibGRoWHpFM01ETXpNekl6TlRRNk1UY3dNek16TlRrMU5GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "657d446d3d5d24e9cb3a6b86",
            "index": 56,
            "title": "从图形学到 AI 生成 3D：我们离 3D 版 Midjourney 还有多远？ | 对谈 Meshy.AI 创始人渊鸣",
            "pub_date": "2023-12-16T16:00:00.000Z",
            "duration": "2624",
            "duration_label": "43m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/657d446d3d5d24e9cb3a6b86",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/657d446d3d5d24e9cb3a6b86/media.xyzcdn.net/lltdi0L8LE9vAokSd_oGk_iH3qjK.m4a",
            "play_count": null,
            "show_notes_text": "大概 2020 年初的时候，胡渊鸣在知乎上发表过一个爆文，叫《99 行代码的冰雪奇缘》，那个时候他还在 MIT 读图形学的博士，在这篇文章下，第一名的评论是这么说的：“太巨了，图形+系统+编译，真的是创世的快乐”。\n\n在这个之后他在图形学领域创业了几年，最近刚发布了新产品 Meshy.ai，一个 AI 生成 3D 的项目，这也是今年 AI 生成下最热门的方向之一。AI 生成文字、图片、视频、3D，基本是生成类方向的四块基石，前三者很多人大概都有些概念或者看过一些实际的产出，但相信还有不少人对 AI3D 领域很陌生，所以这期播客我就请来了图形学的专家渊鸣来一起聊聊这个领域的发展和 knowhow。\n\n在这期播客中，我们理清了很多基础的概念，比如到底什么是图形学、如何理解渲染这件事、实现 3D 的一些基础技术路径等等，我们希望每个人都能通过这期播客了解到 AI3D 领域的基础知识，也能更好的理解图形学和未来世界的可能性。此外，我们也聊到了一些他作为科研 PhD 创业的心得体会等。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n十号珍藏：胡渊鸣，Meshy.AI 创始人，清华大学姚班本科，MIT 计算机科学博士\n\n【时光机】\n\n 1:42 当我们聊到图形学，我们到底在聊什么？\n 12:36 3D 数据的不同表达方式 12:44 点云\n 12:53 体素\n 14:23 NeRF\n 15:02 高斯散射\n 16:00 Mesh\n\n 21:07 2D+时间维度=视频，2D+空间维度=3D\n 22:25 AI 生成 3D 要解决的三类任务 22:32 文字生成贴图\n 22:56 文字生成 3D\n 23:51 图像生成 3D\n\n 29:49 当 VR 设备成为了下一代 iPhone，3D 资产会成为日常生活的重要组成\n 32:08 AI 生成 3D 的市场需求\n 33:29 我们距离一个 3D 版的 Midjourney 还有多远？\n 34:50 AI 生成视频与生成 3D，哪个会更快一些？\n 38:48 创业最深的感悟：Why 是比 How 更重要的事情\n 39:51 忘记自己从一个科学家角度对这个世界的理解\n 43:11 上帝说：要有光\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n 渊鸣一不小心爆火的文章：99 行代码的《冰雪奇缘》\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n渊鸣 (左)，我，又在我家沙发",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "99 行代码的《冰雪奇缘》",
                "url": "https://zhuanlan.zhihu.com/p/97700605"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TVRVM09USXlPREF4TlRObE5XRmpNR0ZpT1RCaVpEUTJNakJpTkdGbE5EVmZlRXczV0VNd1REbGpOa1pUV2tvd1ZVTlpWbWR6ZG1sVU5UaHBlRVZwY0VsZlZHOXJaVzQ2VVdkdlEySm9iWE5qYjI5SE9WQjROVEZCUkdOalltbG1ibmRuWHpFM01ESTNNRGN3TlRBNk1UY3dNamN4TURZMU1GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "656aeffd0500be931c4eb099",
            "index": 57,
            "title": "为什么我们开始乐观？关于经济发展的明线暗线、AI 与最佳实践 | 对谈莫傑麟",
            "pub_date": "2023-12-02T16:00:00.000Z",
            "duration": "2819",
            "duration_label": "46m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 1,
            "matched_keywords": [
              "AI"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/656aeffd0500be931c4eb099",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/656aeffd0500be931c4eb099/media.xyzcdn.net/lsPgAz_i4_Kbcw4g7WCUwX4Z6Db0.m4a",
            "play_count": null,
            "show_notes_text": "其实我一直都挺乐观的。但今年有太多人倾向于悲观，有太多人对未来持消极的态度，但我一直都觉得悲观是最没有用的，悲观能怎样呢，能化为什么行动吗，能改变什么现实吗，如果都不能，那为什么不乐观一些呢？尤其是我们都知道最伟大的公司都是从周期底部成长起来的，我们也知道市场最悲观的时候就是抄底的时候，我们还知道如果一个人或一件事处于谷底，那不管你像哪个方向走，只要动起来就都是在上升。\n\n所以，我一直觉得自己有一种使命感，就是要让身边的人也都乐观起来，但这件事只凭口头呼吁肯定是不够的，还得有理有据才行，所以这期我们就请到了我身边这个同样乐观的好朋友，而且他的乐观是基于他多年对全球一二级市场和各种资产的实际观察分析和交易经验得来的，何况他还提到了他们当下确实在为乐观而付出体力或金钱上的行动。\n\n在这期播客中，我们聊到了现在市场到底在发生什么，什么变了、什么没变，为什么大家其实不是悲观而是消极，为什么我们认为目前市场处于底部，我们是如何用库存、明线、暗线等方式去判断市场机会的，以及我们也谈到了 AI 这件事为什么会是未来一个重要的方向和希望。\n\n正如这期播客结尾所说，我真心觉得年轻人没有悲观的本钱，我也真心希望你听完这期播客能够乐观起来，下次再和朋友聊起来，也可以和他说，你看我们应该更乐观一些的，不信？你可以去听一下42章经的那期播客……\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n九号珍藏：莫傑麟，家族办公室资深从业者\n\n【时光机】\n\nPart 1 悲观与乐观\n\n 00:46 你对未来是乐观还是悲观？\n 02:16 大家情绪上悲观，但行动上反而更拼了\n 3:17 未来不是没有回报了，而是回报的反馈周期变长了\nPart 2 时代的乐观指数：ROE (净资产回报率)\n\n 4:37 公式： ROE = 毛利 × 杠杆倍数 × 周转率\n 5:26 行业拆解①：房地产的 ROE\n 6:31 行业拆解②：作为个体的 ROE\n 9:35 行业拆解③：互联网的 ROE\n 11:33 新时代的范式迁移：低毛利→高毛利\nPart 3 经济发展的明线与暗线\n\n 16:03 明线：新的产业趋势与发展机会\n 16:22 暗线：宏观政策、经济周期等个体只能认知，无法改变的因子\n 22:48 做事情最好的节点不是拐点到来的那一刻，而是预期拐点将要来的那一刻\n 23:49 暗线展望：去库存接近尾声，积蓄的问题在稳步消解\n 25:59 明线展望：AI 未来可期\nPart 4 美国的 AI 市场观察\n\n 28:40 美国对 AI 的信念感极其强烈\n 32:20 从模型数据来看，中国的可利用数据其实比美国要好\n 35:15 美国的一二级市场近些年有哪些变化？\nPart 5 寻找最佳实践\n\n 35:56 乐观背后的行动是什么？如何为拐点做准备？\n 39:13 最佳实践的概念\n 45:38 年轻人不具备悲观的本钱\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n傑麟 (左)、我与万年不变的我家沙发",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://image.xyzcdn.net/Fp4kGfm3-2Ykygi9TRU_cIaGO41M.png",
                "url": "https://image.xyzcdn.net/Fp4kGfm3-2Ykygi9TRU_cIaGO41M.png"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TmpoaVptSTJOVGcyWmprMk1UVmtaakUwWldNME5HTXlNVGM0TW1ZME5tUmZkVUpXY0VSRmRYbFlTbkJQZW5kV1FWQkVhRGxzYlRscmNtZExaVzlXWlRSZlZHOXJaVzQ2U1VSUGVtSTVTVkYzYjJ4a05IRjRTbVpCTTJNMVVISlZibVpLWHpFM01ERTFNRFkyTlRBNk1UY3dNVFV4TURJMU1GOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "653cf8b64acaf6ffd2151988",
            "index": 58,
            "title": "AI 的对错早晚与 VC 的农耕渔牧 | 对谈心资本合伙人吴炳见",
            "pub_date": "2023-10-28T16:30:00.000Z",
            "duration": "4018",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "创业",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/653cf8b64acaf6ffd2151988",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/653cf8b64acaf6ffd2151988/media.xyzcdn.net/lqfy4pFvmf5ivgdYox5qQL1jyd_L.m4a",
            "play_count": null,
            "show_notes_text": "大家也许知道一个事实：今年投过两家以上 AI 公司的投资机构已经是凤毛麟角了。\n\n我们第一期播客投 AI 最猛的人的嘉宾张津剑是其中之一，而这次我请来了另一位，心资本的合伙人吴炳见，他们机构除了参与了百川的天使轮融资外，也还投了其它数家 AI 公司。而他本人也对 AI 非常乐观，在 AI 开始变冷的当下，他还是坚定地觉得 AI 是比移动互联网还要大几倍的机会。\n\n我们最喜欢乐观的嘉宾，所以这次我们就畅聊了下彼此对当下 AI 市场的看法，比如，我们详细辩论了 AI 对错早晚的问题，这其中的机会分哪几种类型。\n\n此外，作为同在一级市场有十余年经验积累的老人，我们两个也不可避免地忆苦思甜了一下，我们总结了天使投资的本质到底是什么，以及如何用翻螃蟹理论来更好地积累优质人脉等等。\n\n这期内容算是我们对今年 AI 热潮的一个阶段性复盘，我们各自毫无保留地贡献了这一年对市场的观察，以及对未来的预判，希望能对你有所启发。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n八号珍藏：吴炳见，心资本 Soul Capital 合伙人\n\n【时光机】\n\nPart 1 AI 的对错早晚\n\n 00:53 AI 可能是移动互联网加个零的机会\n 08:48 现在很像移动互联网的 2009 年\n 11:32 我们距离 iPhone 4 时刻还有多远？\n 21:22 AI 创业，什么时候最适合入场?\nPart 2 大浪潮中的四类机会\n\n 26:03 第一类机会：手电筒\n 26:22 第二类机会：汤姆猫\n 26:46 第三类机会：91手机助手\n 27:28 第四类机会：抖音快手\n 37:34 工具类产品很难站稳，终局拼的一定是资产\n 40:24 「生产端/消费端」是比「2B/2C」更好用的分类框架\nPart 3 投资中的农耕与渔牧\n\n 42:45 VC 回到农耕时代\n 45:25 如果移动互联网是在争首屏的十个位置，AI 时代最后争的是什么？\n 48:28 现在的创业者要做好准备：融到 A 轮后就不融了\n 51:34 天使投资的本质是优质人脉变现\n 52:21 寻找优质人脉的本质是翻螃蟹理论\n 55:26 每个人的磁场会吸引来属于自己的几块石头\n 1:02:02 好的创始人跟顶尖创始人的区别在哪儿？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n炳见 (左)，我，又在我家沙发",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "投 AI 最猛的人",
                "url": "https://www.xiaoyuzhoufm.com/episode/64c542a399e1e7669e56d4da"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TmpVek1HTTBaVEJtT0dFNVltWTNZV0poTURVek56WTFZMkk1T0RReU1XSmZURFpxWkhOQ1VWcGhTa1l3Ulhad1JFRkVVbEpUWkhaT1kwUkxXVEJSU1ZOZlZHOXJaVzQ2UWpOQloySkVOVTFDYjA4eFZrWjRUVVl3U21OU01HTkhia1ZtWHpFMk9UZzBPVFF6TkRFNk1UWTVPRFE1TnprME1WOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "652120bb50cf691d2433332d",
            "index": 59,
            "title": "TikTok 商业化增长从 0 到 1 的幕后经验：关于投放、出海与组织管理等 | 对谈前 TT Ads 首席增长立东",
            "pub_date": "2023-10-07T16:00:00.000Z",
            "duration": "2925",
            "duration_label": "48m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "商业"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/652120bb50cf691d2433332d",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/652120bb50cf691d2433332d/media.xyzcdn.net/lkGEzNK2DWDubd9bWdnIXl1f_SzE.m4a",
            "play_count": null,
            "show_notes_text": "在上期播客《拒绝三亿美金 offer 的人 | 对谈音遇创始人Albert》里，Albert 提到“增长的核心就是商业化”，于是这期我们就请来一位做商业化增长的好朋友 :P\n\n立东是 2020 年进入的 TikTok，负责 TT 广告业务的增长。他这个位置和视角非常之妙，首先 TT 本身就是最大的媒体平台，他在 TT 能看到一手的 C 端数据和反馈，其次他又要帮 TT 在 FB、Google 等平台真金白银地投放广告 (而且还要采买各种第三方广告公司的服务)，最后他还要对 TT 上的商户负责，让他们尽可能多地投放广告并拿到效果，所以可以说他的角色是横跨了甲乙丙三方。\n\n在过去的几年里，他每年负责几亿美金的投放预算，其所负责的业务也从接近于零的状态开始，成长了 2000 倍，并且收获了几百万的付费客户，这个成绩在过去几年的互联网世界里可以说是凤毛麟角了。\n\n在这期内容中，我和他聊了几个他很有经验和发言权的问题，比如 TT 广告业务增长的经验，出海业务和国际化团队的管理，以及对 SaaS + AI 的一些思考。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n七号珍藏：杨立东，WorkMagic 创始人，前 TikTok Ads Head of Growth\n\n【时光机】\n\n 2:21 TikTok 自助广告业务的发展史\n 4:59 怎么通过自己摸索，实现 3 年收入翻 2000 倍的跨越？\n 7:34 几亿美金买到的投放经验与踩坑教训\n 9:05 广告投放的 ROI 是真的能算清楚的吗？\n 10:35 甲乙丙三方视角全占是怎样一种开挂体验？\n 14:09 广告投放的成功，几成靠创意？几成靠科学？\n 16:51 我可以明确地说，4A公司是不会死的\n 18:23 中美中小商家的区别 & 为什么国内 SaaS 做不起来？\n 20:30 增长的核心真的是商业化吗？商业化增长的核心又是什么？\n 23:09 中小商家业务与 KA 业务的关键分别是什么？\n 27:58 TikTok 出海成功究竟是踩中了哪几点？\n 31:41 如何管理 5 国 10 城的全球化团队？\n 41:21 美国 AI 市场现况：当下确定性最强的创业机会是什么？\n 45:08 怎么看市面上各类AI+营销公司？\n 47:39 WorkMagic 的愿景 —— One Man Shop\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：梦昕\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）\n\n立东(左)、我与我家沙发",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "《拒绝三亿美金 offer 的人 | 对谈音遇创始人Albert》",
                "url": "https://www.xiaoyuzhoufm.com/episode/6505cb5496875579717a1369"
              },
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGk",
                "url": "https://bts-image.xyzcdn.net/aHR0cHM6Ly95dmVoN2pudGc3LmZlaXNodS5jbi9zcGFjZS9hcGkvYm94L3N0cmVhbS9kb3dubG9hZC9hc3luY2NvZGUvP2NvZGU9TkdVMlpXWXdOREprTXpJM09XVXpORFZpTXpJM01ERmlaVGxqTTJSaE5HTmZNakJDVUVaS2RWa3hSalpMT1hGUmR6bGhNMjVPVTJ0VE5FVnpNa1V4TTJWZlZHOXJaVzQ2UjFkb1RtSm5hekphYjI1bFZYQjRjbXRGYVdONVMzSXlibkp3WHpFMk9UWTJOamsxTmpJNk1UWTVOalkzTXpFMk1sOVdOQQ=="
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6505cb5496875579717a1369",
            "index": 60,
            "title": "拒绝三亿美金 offer 的人｜对谈音遇创始人 Albert",
            "pub_date": "2023-09-16T15:35:47.000Z",
            "duration": "6726",
            "duration_label": "1h 52m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "AI",
              "创业",
              "商业",
              "人工智能",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6505cb5496875579717a1369",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/6505cb5496875579717a1369/media.xyzcdn.net/ltfmQQ1CoMUCdX2cgqIxJFQz5Wcq.m4a",
            "play_count": null,
            "show_notes_text": "Albert 是移动互联网十年的一个缩影。\n\n他从社交创业者，到被字节收购，\n\n从内涵段子的负责人，到二次下场创业，\n\n66 键盘、音遇，不到一年时间，创造了两种全新的产品形态，启发了众多社交、实时互动、音乐领域的创业者，也获得了数千万用户与超百万 DAU。\n\n再到后来拒绝三亿美金的收购，到 App 被下架的无奈出售，到重新起航做游戏，到今年开始结合 AI。\n\n这十年左右的时间里，Albert 十年如一日地在学习、创新和实践。\n\n也是 Albert 让我悟到了一个真理，即:\n\n「最好的创始人是不会输的，除非他们自己认输。」\n\n在这期播客里，我们聊到了那些最精彩的社交、社区公司的故事，一起梳理了移动互联网 2C 模式的各种本质和核心，聊到了我们眼中的张一鸣和张小龙，还有增长和 AI 等等背后的思考。\n\n这期播客对我而言就像一个时代的承上启下。\n\n我们告别了移动互联网最有创造力的几年，总结了很多道理，有些有用，还有些是遗憾。\n\n最终，我们也期待在未来的 AI 时代里一起再接再厉。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n六号珍藏：Albert，音遇创始人\n\n【时光机】\n\nPart 1 社区、社交与内容平台\n\n 1:30 如果当初留下，你本来能成为字节 Top 10\n 2:29「所有的生产要素都是可以构建的，只有认知是壁垒」\n 5:52 内容平台的三个成长阶段\n 16:45 社交的本质和机会\n 31:56 为什么中国没有出现 Facebook 和 Snapchat?\n 33:50 做社区和信息分发基本是在做一道送命题\n 42:00 为什么说 AI 的出现大大利好字节？\nPart 2 游戏\n\n 43:16 游戏的三种价值分类\n 46:28 米哈游本质不是游戏公司，是 IP 公司\n 50:50 游戏行业最关键的两点是什么？\n 53:42 一个游戏的世界观是怎么构建出来的？\n 56:37 做事的三重境界 ——「守破离」\n 58:20 产品经理是互联网最没用的岗位\nPart 3 增长\n\n 59:20 0-1 关键靠什么？\n 1:00:17 「同理心是地基，想象力是天空，中间是逻辑和工具」\n 1:02:12 找需求其实就是在一个梦里找破绽\n 1:06:22 我教张小龙做产品\n 1:07:41 张一鸣跟张小龙各有哪些特点？\n 1:08:17 活到一定阶段后，你会发现这个世界只有自己，其余全是 NPC\n 1:09:06 我和张一鸣见过一次，结论是我绝对不敢投张一鸣\n 1:12:37 我的每一个产品，我都明确知道它会火\n 1:13:38 1-100 阶段本质靠什么？\n 1:18:24 拒绝三亿美金\nPart 4 人工智能\n\n 1:32:08 摄像头是物质世界的编译器，AI 是想象力的编译器\n 1:37:56 泛娱乐领域的第一性原理\n 1:39:28 对于 AI，商业上我极度乐观，但对文明整体我是悲观的\n 1:43:11 AI 带来的生产力革命会使杀时间的需求大大增加\n 1:44:38 AI 目前是给企业空降了 1000 个高中生，而不是一个专家\n 1:47:00 人生是哪种类型的游戏？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n 文字稿：https://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651050321&idx=1&sn=03a43720c8e23a266dc6ac3282ebff27&chksm=8c38def9bb4f57efe6a982b7acdfd2b27de0386c93414f60f5573a22bed446b33cfba6eed66b&token=1672525596&lang=zh_CN#rd\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651050321&idx=1&sn=03a437",
                "url": "https://mp.weixin.qq.com/s?__biz=MzIyMDE5OTYyMw==&mid=2651050321&idx=1&sn=03a43720c8e23a266dc6ac3282ebff27&chksm=8c38def9bb4f57efe6a982b7acdfd2b27de0386c93414f60f5573a22bed446b33cfba6eed66b&token=1672525596&lang=zh_CN#rd"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "64f2fe70e490c5dee52428a3",
            "index": 61,
            "title": "人生的决策、算法与自由意志 | 对谈孤独大脑老喻",
            "pub_date": "2023-09-02T16:00:00.000Z",
            "duration": "3926",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 1,
            "matched_keywords": [
              "AI"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/64f2fe70e490c5dee52428a3",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/64f2fe70e490c5dee52428a3/media.xyzcdn.net/lk1Tv2KE82NEplQvZ3ATI0lUsTPc.m4a",
            "play_count": null,
            "show_notes_text": "我的日常工作中很重要的一部分是研究人。这几年，从感性的判断人，我逐渐进展到理性地给一个人建模。而这件事的抓手就是研究一个人是如何做决策的。\n\n选择的重要性大于努力，不同的决策带来不同的人生结果，越早意识到这件事越好。\n\n所以，这期能跟大家聊聊这个话题我特别开心，而本次请到的嘉宾我也觉得是最适合探讨这个话题的人 —— 公众号孤独大脑的主理人，《人生算法》一书的作者老喻。\n\n在这期播客中，我们不止探讨了人生的目标和决策，还讨论了很多关于自由意志、概率、财富、成功与自由等相关的话题。\n\n老喻也还是一个狂热的阅读爱好者，他在这期播客中旁征博引了很多书籍和观点，都非常精彩。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n五号珍藏：老喻，未来春藤创始人，公众号《孤独大脑》主理人，《人生算法》作者\n\n【时光机】\n\n 2:12 假如某一瞬间重复一万遍，它重复的到底是什么？\n 4:01 每个人都在逃避自己命运的过程当中，与自己的命运不期而遇\n 4:58 永恒轮回、主观概率与自由意志\n 9:30 人生的「几何平均」与「算术平均」\n 12:38 老喻的人生经历\n 17:45 曲凯最关键的两次人生决策\n 22:47 假如机会是一个矩形，大势是长，人力是宽\n 23:28 Success = Luck + Skill，但 Luck 和 Skill 的比例是可选择的\n 26:50 灰度认知，黑白决策\n 29:03 将贝叶斯算法纳入决策闭环\n 30:30 现实世界的伟大决策者底层跟 AI 是完全一样的\n 40:23 当财富达到多少时，人的自由度会享有一个质的提升？\n 44:36 人与人，拉开差距的原因在于 TA 有没有找到自己的核心算法\n 48:53 聪明人的决策失败，更多是因为自我评价过低，还是过高？\n 53:54 不要学习如何在演讲时不发抖，而是要学会在发抖时依然能继续演讲\n 55:11 —— 画外音环节 ——\n 56:55 曲凯的人生目标\n 59:58 成功的人普遍会越来越多地调用理性，还是越来越少地调用理性？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n【Reference】\n\n老喻的两篇文章：\n\n 看不见的“遍历性” (人生的几何平均与算术平均) mp.weixin.qq.com\n 你需要的不是重来一次的人生 mp.weixin.qq.com\n本期提到的书目包括：\n\n 《避风港》马克·斯皮茨纳格尔 book.douban.com\n 《资本的秩序》马克·斯皮茨纳格尔 book.douban.com\n 《生命无法承受之轻》 米兰·昆德拉 book.douban.com\n 《统计与真理》C·R·劳 book.douban.com\n 《为什么伟大无法被计划》肯尼斯·斯坦利 & 乔尔·雷曼 book.douban.com\n 《人生算法》喻颖正 book.douban.com\n 《创投42章经》曲凯 book.douban.com\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "mp.weixin.qq.com",
                "url": "https://mp.weixin.qq.com/s/XfNg1SoAkmIFruirifmc0g"
              },
              {
                "text": "mp.weixin.qq.com",
                "url": "https://mp.weixin.qq.com/s/aiiDF_iCijbRbsR9F7TEAA"
              },
              {
                "text": "book.douban.com",
                "url": "https://book.douban.com/subject/36315231/"
              },
              {
                "text": "book.douban.com",
                "url": "https://book.douban.com/subject/35284844/"
              },
              {
                "text": "book.douban.com",
                "url": "https://book.douban.com/subject/1017143/"
              },
              {
                "text": "book.douban.com",
                "url": "https://book.douban.com/subject/1238685/"
              },
              {
                "text": "book.douban.com",
                "url": "https://book.douban.com/subject/36357804/"
              },
              {
                "text": "book.douban.com",
                "url": "https://book.douban.com/subject/35125800/"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "64ea203980c9ec4c5f59590e",
            "index": 62,
            "title": "「VC」与「炒股」，哪个更容易通向财务自由？| 对谈饭统戴老板",
            "pub_date": "2023-08-26T15:54:33.000Z",
            "duration": "4129",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/64ea203980c9ec4c5f59590e",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/64ea203980c9ec4c5f59590e/media.xyzcdn.net/lkEPA_soSaGBt6veAzX2AZAbgO49.m4a",
            "play_count": null,
            "show_notes_text": "我一直觉得饭统戴老板就很像是泛财经领域的42章经。我们两个人的背景、经历和在做的事情都很像。可以说写东西是我们的术，心系市场和交易是我们的本色。\n\n正所谓隔行如隔山，作为一个二级市场资深韭菜，我一直对二级市场相关的运作，过去几年的变化等非常感兴趣。\n\n最近很多一级市场的朋友们工作有所动荡，我也总会提一个问题，说你要不考虑下二级市场？\n\n所以，这次我就请来饭统戴老板一起聊了聊一级市场和二级市场的一些异同，当然，也包括到底这里面有哪些赚钱的门道。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n四号珍藏：戴老板，远川研究所 & 饭统戴老板创始人\n\n【时光机】\n\n 1:07 戴老板的职业经历\n 2:38 如果重来一次，你会选一级还是二级？\n 5:00 一级市场本质上是一个 BD 生意，二级市场的高人则都是扫地僧\n 7:39 二级市场有两条路，顶尖高手都会在其中一条上走到极致\n 8:32 研究人是一件看天赋的事情\n 10:24 董事长本人对股票涨跌有多大影响？\n 20:52 一级二级，我们分别羡慕对方什么？\n 31:08 一级市场是被动的长期主义，二级市场是每天的人性考验\n 34:25 股市里百分之几的人在赚钱，百分之几的人在赔钱？\n 35:12 大家到底在赚贝塔的钱还是阿尔法的钱？\n 38:56 对于普通散户而言，是买基金好，还是自己选好，还是不买好？\n 39:37 有多少钱的时候应该炒股？\n 47:06 AI 能替人投资吗？\n 53:05 下一波大机会是什么？\n 58:09 —— 画外音环节 ——\n 1:00:01 如果重来一次，曲凯会选择一级还是二级？\n 1:02:57 一级市场未来的走向是？\n 1:03:58 一级市场看人也吃天赋吗？\n 1:06:44 一级、二级、创业、FA，究竟哪个更容易通向财务自由？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：梦昕\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "64e040eb80c9ec4c5faf2868",
            "index": 63,
            "title": "这个男人帮 5 万个 AI 应用接上了大模型 | 对谈 Dify 创始人路宇",
            "pub_date": "2023-08-19T16:00:00.000Z",
            "duration": "4449",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 6,
            "matched_keywords": [
              "AI",
              "Agent",
              "创业",
              "大模型",
              "产品",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/64e040eb80c9ec4c5faf2868",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/64e040eb80c9ec4c5faf2868/media.xyzcdn.net/lnjuOhhG3AbdR3dL0q6HnKotmfy0.m4a",
            "play_count": null,
            "show_notes_text": "Dify.AI 是我今年最喜欢的 AI 项目之一，创始人路宇也是一个十分有特色的好朋友。\n\n随手分享几个关于 Dify 和 Luyu 的趣事：\n\n1）年初在大家还在学习观察大模型的时候，Luyu 就开干了，年中在大家还在纠结中间层是否有存在价值的时候，Dify 就上线了，这个超强的执行力直接惊到我了。\n\n2）Luyu 有一套丰富的后台研究存档，说到什么公司和竞品他都能拉出来一套资料，说“我们研究过了”，这个学习能力也惊到我了。\n\n3）多年的开发者工具经验，让 Luyu 对如何做好中间层有非常深的洞察和理解，比如他说了一句话我一直印象深刻，他说：“我更需要研究怎么用好电，而不是弄清楚电是怎么发出来的”，在这句话的背后，当下确实有太多公司花过多时间去研究大模型的原理，而忽略了自己本身更该做好的事情。\n\n4）Luyu 经常说，要做好一款开源产品“节奏感”非常重要，我说，要做好一家公司也同样如此。\n\n5）Luyu 喜欢吃火锅，好像尤其是毛肚，约不到他的投资人们可以考虑以此诱惑他。\n\n最终，Dify 一上线 GitHub stars 就暴涨 trending，很合理。\n\n而最新的数据是，Dify 平台上已经有 5 万多个原生 AI 应用。\n\n基于这些数据，和 Dify 的战略定位，我相信他是全国最理解大模型落地和生态的人之一，所以这期我和他聊了很多大模型技术的落地、局限、和对未来发展的想法等等。\n\nEnjoy\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n三号珍藏：张路宇，Dify.AI 创始人\n\n【时光机】\n\n 00:34 什么是 LLMops ？\n 07:07 大模型工程化的三种方式\n Prompt\n Embedding\n Fine Tune\n 15:48 Agent 的三种形式与面临的三大问题\n 23:20 Prompt 的潜力被低估了，它的难度也被低估了\n 31:17 未来大模型的市场格局\n 33:07 Llama2 离真正投产还有相当长的距离\n 38:55 天天提 LangChain，到底什么是 LangChain?\n 48:23 Dify 五万多个应用中，最典型的落地场景是？\n 51:57 未来个人助手的入口会在哪儿？\n 53:48 日后的微信通讯录里躺着的可能是一群 bot\n 55:07 AI 的三大发展方向\n 请大模型看 4D 电影\n 模型小型化\n 一切数据向量化\n 59:07 对于 AI，我俩最焦虑的事情是同一个\n 1:02:44 —— 画外音环节 ——\n 1:04:35 曲凯会格外喜欢什么样的创业者？\n 1:08:49 曲凯怎么看中间层的创业机会？\n 1:11:47 现在创业者普遍暴露出来的问题都有什么？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "64d7b71de490c5dee544aca2",
            "index": 64,
            "title": "揭秘 Minimax、Zilliz、PingCAP 背后的投资逻辑 | 对谈云启合伙人陈昱",
            "pub_date": "2023-08-12T16:45:16.000Z",
            "duration": "3222",
            "duration_label": "53m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "AI",
              "大模型",
              "科技",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/64d7b71de490c5dee544aca2",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/64d7b71de490c5dee544aca2/media.xyzcdn.net/lovRv4IVo_8NXwutHROLxLRHJStj.m4a",
            "play_count": null,
            "show_notes_text": "陈昱是我当年在云启资本时的同事，\n\n当时他的背景听起来就已经很厉害，\n\n美国 google 多年，芝大 MBA，国内知名公司 CTO 等等，\n\n一晃近十年过去，他现在应该是软科技类赛道投得最好的投资人之一，\n\nMinimax、Zilliz、PingCAP 等等知名公司的早期融资背后都有他的身影。\n\n在这期对话中，我和他聊了这些明星项目背后的一些故事，\n\n包括他是如何找到这些项目、又是如何判断的，以及他是怎么衡量一个创始人的好坏等，\n\n通过这些故事，我也在试图探寻他投资成绩这么好的背后原理和规律，\n\n且，以史鉴今，我们还聊了他眼中最新的一些趋势和未来的机会，例如日本这个新兴市场等等。\n\n陈昱在很多人眼中应该是一个从不发朋友圈、很少和投资圈中的人 social、也不常在公开场合做很多发声的人，\n\n希望这期播客可以记录和呈现一些他的思考。\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n二号珍藏：陈昱，云启资本合伙人\n\n【时光机】\n\n 0:55 AI 在过去十年里的三波浪潮\n 4:35 「软科技不只是云启的赛道，它简直是陈昱的被窝」\n 5:48 揭秘 PingCAP 投资历程\n 10:41 陈昱最看重创始人的哪些方面？\n 12:37 揭秘 Zilliz 投资历程\n 20:29 揭秘 Minimax 投资历程\n 26:07 陈昱最看好的 AI 项目方向是？\n 27:55 为什么陈昱能成为 ABC 领域最好的投资人？\n 30:54 怎么能在 21 年就注意到大模型的机会？\n 31:51 作为一个一直领先市场的投资人，陈昱当下在看的新方向是？\n 35:10 日本市场的巨大机会\n 41:26 投出 6 个独角兽的成功公式\n 42:17 —— 画外音环节 ——\n 42:56 曲凯怎么看陈昱的自我认知和成功公式？\n 47:34 在曲凯眼里，「聪明」到底是一种什么样的感觉？\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜、小孙\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "64c542a399e1e7669e56d4da",
            "index": 65,
            "title": "投 AI 最猛的人 | 对谈绿洲资本合伙人张津剑",
            "pub_date": "2023-07-29T16:47:31.000Z",
            "duration": "4240",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "AI",
              "科技",
              "投资"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/64c542a399e1e7669e56d4da",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/648b0b641c48983391a63f98/64c542a399e1e7669e56d4da/media.xyzcdn.net/lsG0BKn6BYQLr4_uWEGWC2ng75gc.m4a",
            "play_count": null,
            "show_notes_text": "这是 42章经 的第一期播客，也是已经把我司好几个人听哭的一期播客。\n\n本期嘉宾张津剑是目前年轻一代 VC 里最有代表性的合伙人，他的绿洲资本是过去几年里少数募资到数亿美元的新基金，也是这波 AI 投资中出手最积极的机构，超过十家的 AI 企业投资数量在市场中绝对是数一数二。此外，津剑也是我多年的好友，他在 42章经 发表的《投资中的信号与噪声》系列文章也是脍炙人口、广为流传。\n\n在这期播客中，我和津剑聊了过去几年的投资市场、聊了最近的 AI 热潮以及对未来 AI 市场的看法、也讲了很多关于「生命力」的故事。\n\n其中，有人说听到生命力的部分感同身受被感动哭，这个我很理解。\n\n但竟然还有人说，被巨大的信息量和对未来 AI 世界的憧憬听哭了...\n\n我想，这大概就是我们播客的定位和价值吧，\n\n巨大的信息量、缜密的逻辑、给人启发的观点、以及带有人文关怀的对这个世界的解构和对未来的推演，\n\n好听到哭...\n\n【人类博物馆】\n\n导游：曲凯，42章经创始人\n\n一号珍藏：张津剑，绿洲资本合伙人\n\n【时光机】\n\n 2:02 津剑一路以来的投资历程\n 15:56 投了 10 家 AI 公司后，为什么我们还在加速投 AI ？\n 20:19 为什么寒冬的时候往往会出大公司？\n 21:33 Gartner 曲线，外面看是科技变化的曲线，里面看是人心人性的曲线\n 23:17 看完几十年的电脑报，我感受到了人类想象力的局限性\n 29:02 移动互联网的原住民是 DAU，那 AI 时代的原住民是什么？\n 32:38 畅想 AI Native：Bot 世界里的六层逻辑\n 39:28 垂直模型可能只是一个过渡态\n 45:29 津剑怎么看美元基金的未来？\n 47:52 中国是全球细分需求的练兵场\n 49:52 众人悲观的时代，正是乐观者的机会\n 52:53 为什么津剑对「生命力」怀有一种信仰？\n 1:04:13 画外音环节 —— 曲凯眼中的张津剑\n【The gang that made this happen】\n\n 制作人：Celia\n 剪辑：思娜\n 协助：Sophie、天然乔、姜越\n 片头 bgm：Mondo Bongo - Joe Strummer & The Mescaleros\n 文字稿：https://mp.weixin.qq.com/s/wOkZBO3_ZTDbDNrK21P6Bw\n最后，我们的 AI 私董会也在持续报名中，目前已经聚集了一批市场上最好的 AI 创始人，欢迎点击链接报名（里面也有目前已加入的成员名单，可点击查看）",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "链接",
                "url": "https://zhangjing42.feishu.cn/share/base/form/shrcnY2ab9rvvQPNn4rU0Xvi7WT"
              },
              {
                "text": "https://mp.weixin.qq.com/s/wOkZBO3_ZTDbDNrK21P6Bw",
                "url": "https://mp.weixin.qq.com/s/wOkZBO3_ZTDbDNrK21P6Bw"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "attention-mechanism",
        "title": "The Attention Mechanism",
        "feed_title": "The Attention Mechanism with Andrew Mayne",
        "priority": "P1",
        "selection_mode": "all_ai",
        "focus": [
          "AI products",
          "model capabilities",
          "creative tools"
        ],
        "feed_url": "https://attentionmechanismpodcast.com/rss",
        "source_url": "https://attentionmechanismpodcast.com/rss",
        "detail_path": "/podcasts/attention-mechanism/",
        "episode_count": 53,
        "selected_episode_count": 53,
        "latest_episode_title": "The Good, the Bad, and the I/O",
        "latest_pub_date": "2026-05-26T16:11:29.000Z",
        "latest_page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-good-the-bad-and-the-io",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "6a15c63283dd9b6e11bdd2f0",
            "index": 1,
            "title": "The Good, the Bad, and the I/O",
            "pub_date": "2026-05-26T16:11:29.000Z",
            "duration": "44:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-good-the-bad-and-the-io",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6a15c63283dd9b6e11bdd2f0/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a0c9469bf33122289f1f8af",
            "index": 2,
            "title": "Suing Your Way to the Moon",
            "pub_date": "2026-05-19T16:48:41.000Z",
            "duration": "36:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/suing-your-way-to-the-moon",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6a0c9469bf33122289f1f8af/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a037dabb4433645567e9bd0",
            "index": 3,
            "title": "Good Vibes",
            "pub_date": "2026-05-12T19:21:15.000Z",
            "duration": "1:01:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "xai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/good-vibes",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6a037dabb4433645567e9bd0/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69de55fbf02f2470e92bf4db",
            "index": 4,
            "title": "The Compute Crisis",
            "pub_date": "2026-04-14T14:58:03.000Z",
            "duration": "38:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "openai",
              "anthropic"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-compute-crisis",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/69de55fbf02f2470e92bf4db/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69cbcf2b16bd65d0699336b0",
            "index": 5,
            "title": "Heated Rivalry",
            "pub_date": "2026-03-31T13:42:03.000Z",
            "duration": "47:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/heated-rivalry",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/69cbcf2b16bd65d0699336b0/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69c1dde862f6c66afedc61cf",
            "index": 6,
            "title": "The Cursor Issue",
            "pub_date": "2026-03-24T00:42:16.000Z",
            "duration": "38:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "cursor",
              "coding"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-cursor-issue",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/69c1dde862f6c66afedc61cf/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69b970e905ad897c0298d8b0",
            "index": 7,
            "title": "Your Always-Available Second Opinion",
            "pub_date": "2026-03-17T15:19:05.000Z",
            "duration": "39:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/your-always-available-second-opinion",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/69b970e905ad897c0298d8b0/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "699db6c6e58ea911388aa66b",
            "index": 8,
            "title": "A 10-Speed Bicycle Behind a Tractor Trailer",
            "pub_date": "2026-02-24T14:33:42.000Z",
            "duration": "52:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/a-10-speed-bicycle-behind-a-tractor-trailer",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/699db6c6e58ea911388aa66b/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "699486702a42aa7d9b1cfc83",
            "index": 9,
            "title": "Claw-ture Clash",
            "pub_date": "2026-02-17T15:17:04.000Z",
            "duration": "49:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/claw-ture-clash",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/699486702a42aa7d9b1cfc83/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "698b862b0581faffc76f455a",
            "index": 10,
            "title": "The Super Bowl of Super Bowl AI Ads",
            "pub_date": "2026-02-10T19:25:31.000Z",
            "duration": "37:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-super-bowl-of-super-bowl-ai-ads",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/698b862b0581faffc76f455a/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6978cb51207e028ee4ef7574",
            "index": 11,
            "title": "Claude or Clawd",
            "pub_date": "2026-01-27T14:27:28.000Z",
            "duration": "47:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/claude-or-clawd",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6978cb51207e028ee4ef7574/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "696eece95e25e3a6c08dea5f",
            "index": 12,
            "title": "OpenAI Adds Ads",
            "pub_date": "2026-01-20T02:48:09.000Z",
            "duration": "39:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "chatgpt",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/openai-adds-ads",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/696eece95e25e3a6c08dea5f/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69659b861f21449d6de8c146",
            "index": 13,
            "title": "WWSD (What Would Steve Do?)",
            "pub_date": "2026-01-13T01:10:30.000Z",
            "duration": "48:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/wwsd-what-would-steve-do",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/69659b861f21449d6de8c146/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "695dfcdf39d31c858876c5a2",
            "index": 14,
            "title": "Nvidia Gets Groq (Not That One)",
            "pub_date": "2026-01-07T06:27:43.000Z",
            "duration": "27:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "chip",
              "inference"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/nvidia-gets-groq-not-that-one",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/695dfcdf39d31c858876c5a2/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "692efaa66acaf97c04b44424",
            "index": 15,
            "title": "The AI Bubble Question",
            "pub_date": "2025-12-02T14:41:42.000Z",
            "duration": "51:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-ai-bubble-question",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/692efaa66acaf97c04b44424/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69013175eb60f4c80cd1c711",
            "index": 16,
            "title": "Begun, the AI Browser Wars Have",
            "pub_date": "2025-10-28T21:11:18.000Z",
            "duration": "56:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/begun-the-ai-browser-wars-have",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/69013175eb60f4c80cd1c711/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68dc376146a2532cdd732ae8",
            "index": 17,
            "title": "Prompting for Prompts",
            "pub_date": "2025-09-30T20:02:41.000Z",
            "duration": "50:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/prompting-for-prompts",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/68dc376146a2532cdd732ae8/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68d2ff246f2bb8719f506fad",
            "index": 18,
            "title": "Robot-mancers",
            "pub_date": "2025-09-23T20:12:20.000Z",
            "duration": "55:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/robot-mancers",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/68d2ff246f2bb8719f506fad/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68acf7aaf842e159c5775b3a",
            "index": 19,
            "title": "Super P-AI-C",
            "pub_date": "2025-08-25T23:54:18.000Z",
            "duration": "45:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/super-p-ai-c",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/68acf7aaf842e159c5775b3a/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68a3babf457a24bb9518116a",
            "index": 20,
            "title": "A Busy AI Summer",
            "pub_date": "2025-08-18T23:43:59.000Z",
            "duration": "32:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "grok"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/a-busy-ai-summer",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/68a3babf457a24bb9518116a/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "686c7d1f7254eb13352619f1",
            "index": 21,
            "title": "$100 Million in Your Inbox",
            "pub_date": "2025-07-08T02:06:23.000Z",
            "duration": "44:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/100-million-in-your-inbox",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/686c7d1f7254eb13352619f1/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "685ab0274a2d8b8b5191bcd3",
            "index": 22,
            "title": "Meta Podcasting",
            "pub_date": "2025-06-24T14:03:19.000Z",
            "duration": "35:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/meta-podcasting",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/685ab0274a2d8b8b5191bcd3/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6850c09a259ce49e3ecda259",
            "index": 23,
            "title": "The Darker Side Of ChatGPT?",
            "pub_date": "2025-06-17T01:10:50.000Z",
            "duration": "38:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-darker-side-of-chatgpt",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6850c09a259ce49e3ecda259/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "684842c2680b3bd5046b9e6b",
            "index": 24,
            "title": "An AI-Lite WWDC",
            "pub_date": "2025-06-10T14:35:46.000Z",
            "duration": "41:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/an-ai-lite-wwdc",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/684842c2680b3bd5046b9e6b/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68351569944c948b9a1e3e64",
            "index": 25,
            "title": "From I/O to io",
            "pub_date": "2025-05-27T01:29:14.000Z",
            "duration": "39:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "google ai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/from-io-to-io",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/68351569944c948b9a1e3e64/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "682bd2bfbc0e7581523e8b8a",
            "index": 26,
            "title": "Apple's AI Dilemma",
            "pub_date": "2025-05-20T00:54:23.000Z",
            "duration": "38:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "nvidia"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/apples-ai-dilemma",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/682bd2bfbc0e7581523e8b8a/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6806e6e81aabee4d38dffe0d",
            "index": 27,
            "title": "AGI is a Vibe Now",
            "pub_date": "2025-04-22T00:46:33.000Z",
            "duration": "30:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "agi",
              "openai",
              "gemini",
              "evals"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/agi-is-a-vibe-now",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6806e6e81aabee4d38dffe0d/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67f4780947643545ed8b5269",
            "index": 28,
            "title": "The Tip Jar AI Model",
            "pub_date": "2025-04-08T01:29:59.000Z",
            "duration": "32:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama",
              "eval"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-tip-jar-ai-model",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67f4780947643545ed8b5269/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67d4dce134deae95a5947945",
            "index": 29,
            "title": "Manus a Manus",
            "pub_date": "2025-03-15T01:50:24.000Z",
            "duration": "31:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/manus-a-manus-2",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67d4dce134deae95a5947945/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67bd427d8ee8c32c7ff81e3f",
            "index": 30,
            "title": "Perplexity's Comet",
            "pub_date": "2025-02-25T04:09:33.000Z",
            "duration": "36:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "claude",
              "grok",
              "perplexity"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/perplexitys-comet",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67bd427d8ee8c32c7ff81e3f/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67b7b366b6cab9efc4cc417b",
            "index": 31,
            "title": "Is Grok Tops?",
            "pub_date": "2025-02-20T22:57:41.000Z",
            "duration": "27:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "grok"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/is-grok-tops",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67b7b366b6cab9efc4cc417b/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67ad246d9c6f7f7f287d3bda",
            "index": 32,
            "title": "Wait? Which Browser Agent?",
            "pub_date": "2025-02-12T22:45:01.000Z",
            "duration": "30:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/wait-which-browser-agent",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67ad246d9c6f7f7f287d3bda/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67a19649f0aed667c537f571",
            "index": 33,
            "title": "Deep Into Deep Research",
            "pub_date": "2025-02-04T04:23:37.000Z",
            "duration": "34:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/deep-into-deep-research",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67a19649f0aed667c537f571/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6798547bb6e07e5a2ff2e1b0",
            "index": 34,
            "title": "Is DeepSeek A Game Changer?",
            "pub_date": "2025-01-28T03:52:26.000Z",
            "duration": "39:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/is-deepseek-a-game-changer",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6798547bb6e07e5a2ff2e1b0/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67864f7bc1c1ddd57c16da6e",
            "index": 35,
            "title": "To The Cosmos",
            "pub_date": "2025-01-14T11:50:19.000Z",
            "duration": "30:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/to-the-cosmos",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67864f7bc1c1ddd57c16da6e/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6760fecaa89833ab77e51a1f",
            "index": 36,
            "title": "Putting AI Research To The Test",
            "pub_date": "2024-12-17T04:32:08.000Z",
            "duration": "38:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/putting-ai-research-to-the-test",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6760fecaa89833ab77e51a1f/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6757b6fb7205a5bc681b495c",
            "index": 37,
            "title": "Sora Debuts",
            "pub_date": "2024-12-10T03:35:22.000Z",
            "duration": "34:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "training"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/sora-debuts",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6757b6fb7205a5bc681b495c/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6745435b2954c876a42d69b3",
            "index": 38,
            "title": "No Code No Problem",
            "pub_date": "2024-11-26T03:41:15.000Z",
            "duration": "45:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/no-code-no-problem",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6745435b2954c876a42d69b3/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "673bf115ed94033880f0154f",
            "index": 39,
            "title": "Apple Intelligence First Impressions",
            "pub_date": "2024-11-19T01:59:49.000Z",
            "duration": "32:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/apple-intelligence-first-impressions",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/673bf115ed94033880f0154f/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6732d10bdde1904025ed18e4",
            "index": 40,
            "title": "Did AI Hit A Wall?",
            "pub_date": "2024-11-12T03:52:42.000Z",
            "duration": "31:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/did-ai-hit-a-wall",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6732d10bdde1904025ed18e4/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6729922e5b575bc851ed566f",
            "index": 41,
            "title": "Time To Slow Down?",
            "pub_date": "2024-11-05T04:00:52.000Z",
            "duration": "34:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/time-to-slow-down",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6729922e5b575bc851ed566f/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67206ceeb4c51fd569266a30",
            "index": 42,
            "title": "Automation",
            "pub_date": "2024-10-29T05:04:46.000Z",
            "duration": "32:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama",
              "automation"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/automation",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67206ceeb4c51fd569266a30/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67170af9e16fb75ed531b2c6",
            "index": 43,
            "title": "Reasoning with Apple's Reasoning Paper",
            "pub_date": "2024-10-22T02:16:24.000Z",
            "duration": "45:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "reasoning"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/reasoning-with-apples-reasoning-paper",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/67170af9e16fb75ed531b2c6/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "670de3d7aaedc4eac00aea1b",
            "index": 44,
            "title": "Voice Cloning Isn't Going Away",
            "pub_date": "2024-10-15T03:39:03.000Z",
            "duration": "43:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/voice-cloning-isnt-going-away",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/670de3d7aaedc4eac00aea1b/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6704a0ef1a3de581c6948e59",
            "index": 45,
            "title": "A Podcast About NotebookLM's Podcasts",
            "pub_date": "2024-10-08T03:03:11.000Z",
            "duration": "42:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/a-podcast-about-notebooklms-podcasts",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/6704a0ef1a3de581c6948e59/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66fb68090c1433458973f0be",
            "index": 46,
            "title": "California AI Bill Vetoed",
            "pub_date": "2024-10-01T03:10:01.000Z",
            "duration": "46:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "retrieval"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/california-ai-bill-vetoed",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/66fb68090c1433458973f0be/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66f2284fd61650978f4ae952",
            "index": 47,
            "title": "OpenAI Closes Biggest Funding Round In History",
            "pub_date": "2024-09-24T02:47:43.000Z",
            "duration": "43:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/openai-closes-biggest-funding-round-in-history",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/66f2284fd61650978f4ae952/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66e8e4e78ec46637d2c810e0",
            "index": 48,
            "title": "o1",
            "pub_date": "2024-09-17T02:09:42.000Z",
            "duration": "45:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "coding"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/o1",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/66e8e4e78ec46637d2c810e0/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66e615ac11d69f1045d46a6a",
            "index": 49,
            "title": "Is OpenAI Going Broke?",
            "pub_date": "2024-09-14T23:01:00.000Z",
            "duration": "38:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/is-openai-going-broke",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/66e615ac11d69f1045d46a6a/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66e6100058d4122cd979c216",
            "index": 50,
            "title": "Why AI Will Revolutionize Robotics",
            "pub_date": "2024-09-14T22:36:48.000Z",
            "duration": "45:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning",
              "robotics"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/why-ai-will-revolutionize-robotics",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/66e6100058d4122cd979c216/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66e60ec158d4122cd9798210",
            "index": 51,
            "title": "Understanding AGI",
            "pub_date": "2024-09-14T22:31:29.000Z",
            "duration": "47:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/understanding-agi",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/66e60ec158d4122cd9798210/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66e60cb1f106e38c4d7b02a8",
            "index": 52,
            "title": "The Role of Government in AI Regulation",
            "pub_date": "2024-09-14T22:22:41.000Z",
            "duration": "39:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-role-of-government-in-ai-regulation",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/66e60cb1f106e38c4d7b02a8/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66e60bc958d4122cd97909dc",
            "index": 53,
            "title": "The Possibility of an AI Bubble",
            "pub_date": "2024-09-14T22:18:49.000Z",
            "duration": "40:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://shows.acast.com/prompt-a-podcast-about-ai-with-andrew-mayne/episodes/the-possibility-of-an-ai-bubble",
            "audio_url": "https://sphinx.acast.com/p/open/s/66df653c6a4ad6e33d692556/e/66e60bc958d4122cd97909dc/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "luo-yonghao-crossroads",
        "title": "罗永浩的十字路口",
        "feed_title": "罗永浩的十字路口",
        "priority": "P1",
        "selection_mode": "all",
        "focus": [
          "中文播客",
          "科技",
          "商业",
          "访谈",
          "AI"
        ],
        "feed_url": "https://feed.xyzfm.space/wmnkvmrpwuww",
        "source_url": "https://www.xiaoyuzhoufm.com/podcast/68981df29e7bcd326eb91d88",
        "detail_path": "/podcasts/luo-yonghao-crossroads/",
        "episode_count": 30,
        "selected_episode_count": 30,
        "latest_episode_title": "王晶×罗永浩！谁还记得大导演张彻楚原？我死了什么都不需要留下",
        "latest_pub_date": "2026-06-11T04:38:27.000Z",
        "latest_page_url": "https://www.xiaoyuzhoufm.com/episode/6a2a32c83eedf1f4b268db58",
        "has_play_count_data": true,
        "episodes": [
          {
            "id": "6a2a32c83eedf1f4b268db58",
            "index": 1,
            "title": "王晶×罗永浩！谁还记得大导演张彻楚原？我死了什么都不需要留下",
            "pub_date": "2026-06-11T04:38:27.000Z",
            "duration": "12339",
            "duration_label": "3h 25m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "科技",
              "商业",
              "AI",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a2a32c83eedf1f4b268db58",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/6a2a32c83eedf1f4b268db58/media.xyzcdn.net/68981df29e7bcd326eb91d88/lrDssf4xU98BZVfCxK6Q1oKVm7nP.m4a",
            "play_count": 115789,
            "show_notes_text": "《十字路口》播客节目简介\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：王晶\n\n电影世界虽然肯定是一个高度工业化的商业世界，但在这里，人们热衷于讨论什么样的作品才是真正的经典，什么样的表演才是真正的“高级”，什么样的导演才是真正的艺术家。很少讨论谁能持续几十年让观众心甘情愿地买票进电影院，谁能亲自导演一百多部电影、参与制作数百部电影结果大部分都赚钱，谁能在香港电影最惨淡的时期让一大票电影人还能继续开工吃饭。\n\n邪门儿的是，虽然王晶几十年如一日宣称他拍片完全是为了赚钱，是纯商业活动，但人们总是从电影艺术的角度说他是“烂片王”。更邪门儿的是，这个被称为“烂片王”的导演，竟然在豆瓣上有19部七到八分的电影，8部超过八分的电影。显然，尽管电影工业的专业评审体系没有认可他的作品，但人民从钞票和投票两个角度，都选择了他的电影。\n\n这期节目，因为种种原因我们和王晶导演录制了两次，前后隔了几个月。如果你看视频的时候，发现在某些段落两个人的状态或着装突然发生了变化，放心，你的眼睛没出问题。另外在第二次录制前，王晶导演因为在外景地受风沙影响，干眼症复发，但他还是如约前来录制。录制过程中他一直在频繁地眨眼，这个请大家放心，他并没有被绑架^_^\n\n两次录制，王晶导演都毫无保留地回答了我们的几乎所有问题，可以说，只有我们不敢播的，没有他不敢回答的。接下来的这一期《罗永浩的十字路口》，我们就和王晶导演聊聊他传奇的人生，和他那个更传奇的电影江湖。\n\n【你将听到】\n\n00:03:00 王晶的童年\n\n00:20:45 香港地下世界\n\n00:34:27 《欢乐今宵》\n\n00:55:52 帅不过周润发\n\n01:13:47 将赌片发扬光大\n\n01:29:52 午夜场盛况\n\n01:45:41 工作狂\n\n02:02:27 舒淇往事\n\n02:24:04 进军大陆\n\n02:39:15 人民喜爱的导演\n\n02:43:27 混乱的黄金时代\n\n03:02:32 挨一巴掌\n\n03:20:31 AI能替代真人表演吗\n\n03:25:01 嘉宾推荐\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Ftx7s3kXV_8HyDk3v9S0hTmLs2wU.jpg",
                "url": "https://image.xyzcdn.net/Ftx7s3kXV_8HyDk3v9S0hTmLs2wU.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2793,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a190f4f7460cabdeb57a7ad",
            "index": 2,
            "title": "罗永浩的X字路口！当一群情绪不稳定的杠精讨论起情绪稳定",
            "pub_date": "2026-05-29T04:20:31.000Z",
            "duration": "9215",
            "duration_label": "2h 33m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a190f4f7460cabdeb57a7ad",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/6a190f4f7460cabdeb57a7ad/media.xyzcdn.net/68981df29e7bcd326eb91d88/lt9hwq-lvZE6WHFNoffgEs_MNb3a.m4a",
            "play_count": 191530,
            "show_notes_text": "《十字路口》播客节目简介\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：高寒、小块、孙书恒、王继业\n\n本期节目是《十字路口》分支系列《X字路口》的一次非典型试录，姑且算是这个系列的一个测试版吧。在内容负责人和策划团队什么都没想清楚的情况下，我们贸然请来我国著名脱口秀演员高寒、小块（即“块神”）、孙书恒和王继业四位老师（排名按现场座位从左到右的顺序），在现场观众面前进行了一场堪称小型史诗级灾难的混乱对话。最后，在这一期的录制注定报废的危难时刻，块神以一己之力，通过一段长达二十多分钟的无敌表现，使得这个两小时二十多分钟的节目至少有了值得观看或收听的......二十多分钟。同时他也再次证明，任何时候，只要他想无敌，他就是无敌的，无论是在台上还是台下，无论在车内还是车外。\n\n如果你对播客是陪伴型的需求，当然可以从头到尾听，可以体会到从无聊、烦躁、绝望到渐入佳境的乐趣。如果你对播客的干货密度要求比较高，没什么耐心，也可以直接跳到1小时24分处。在那里，有两个冷静、幸福、情绪稳定的神，和一个懦弱、失控的壮汉在等着你。\n\n【你将听到】\n\n00:00:29 嘉宾介绍\n\n00:17:09 成年人应该情绪稳定吗\n\n00:29:07 继业的不稳定时刻\n\n00:43:39 成年人的发泄渠道\n\n00:57:23 罗老师的反省时刻\n\n01:07:14 蠢和坏\n\n01:24:25 本片最精彩段落\n\n01:57:02 面对网络抬杠\n\n02:22:43 特朗普窄了\n\n02:27:59 节目总结\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Ft2aNjNjWsHZ02xpw2A5b-aBQUwd.jpg",
                "url": "https://image.xyzcdn.net/Ft2aNjNjWsHZ02xpw2A5b-aBQUwd.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 4813,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a0e83fa1b7bd502958f347d",
            "index": 3,
            "title": "郑执×罗永浩！总是赶末班车的人，可以改进时间管理......也可以拥有一辆属于自己的车",
            "pub_date": "2026-05-21T04:51:54.000Z",
            "duration": "9585",
            "duration_label": "2h 39m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "AI",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a0e83fa1b7bd502958f347d",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/6a0e83fa1b7bd502958f347d/media.xyzcdn.net/68981df29e7bcd326eb91d88/ljC91vSG9FcvnlissVoNvy7J0ug0.m4a",
            "play_count": 134195,
            "show_notes_text": "《十字路口》播客节目简介\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：郑执\n\n作为“东北文艺复兴三杰”之一的郑执，毫不掩饰自己的“邪路子”出身。十九岁带着“处男作”原稿愣闯作家出版社并获得出版，在香港借高利贷读书还不上时被江湖大哥贴过威胁门条，为莫言小说的香港版做责任编辑造就了错别字最多的一本莫言正版书，生活窘迫期间除了“骗吃螃蟹”，甚至想过靠“擦边”文学杀出一条人生的血路...... 他自嘲是一个永远在“追赶末班车”的人：没赶上青春文学的盛世，没赶上鸡汤文学的红利，终于获得严肃文学界的认可时，人们已经不看严肃文学了。当他拿起导筒拍出众星云集的电影作品《森中有林》时，电影的黄金时代似乎也已接近尾声。但这些始终压在头顶的紧迫感，没有击垮他，最终让他在文字和影像中建立了一个属于自己的叙事宇宙。证明了总是赶末班车的人，可以改进时间管理......也可以拥有一辆属于自己的车。\n\n郑执首次自编自导的电影作品《森中有林》，近日将在院线上映。在这部野心勃勃的“微型史诗”中，郑执以冷峻的风格呈现了横跨四十年的，关于三代人的罪与爱。该片集结了于和伟、高圆圆、韩庚、乔杉、宋小宝、张天爱这样的全明星阵容。并在第16届北京国际电影节主竞赛单元“天坛奖”中，斩获了两项重要奖项。\n\n《罗永浩的十字路口》第二十八期，我们从这部电影聊起，聊聊青春的幻觉和迷茫，聊聊人生的际遇和凶险，聊聊东北文学的复兴和沉重，当然还有那个著名的、安抚了无数游荡灵魂的沈阳“穷鬼乐园”。\n\n【你将听到】\n\n00:01:44 《森中有林》\n00:09:57 从小说家到导演\n00:27:23 选角趣事\n00:45:32 导演在AI时代很幸福\n00:53:26 关于导演剪辑版\n01:07:22 小说的黄金时代\n01:24:20 蔡澜和避风塘炒蟹\n01:43:30 童年成长经历\n01:56:42 走上文学道路\n02:10:56 一席、文学奖和啤酒屋\n02:28:46 东北文艺复兴三杰\n02:36:43 后续计划\n02:38:26 推荐嘉宾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FnKRw0pb3UUGSMxxss7hwro-dO3h.jpg",
                "url": "https://image.xyzcdn.net/FnKRw0pb3UUGSMxxss7hwro-dO3h.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3500,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a037114e1eb34a939471baf",
            "index": 4,
            "title": "李想×罗永浩！李想的理想：通过 AI 技术，让普通人也过上富豪的生活",
            "pub_date": "2026-05-13T04:00:00.000Z",
            "duration": "8459",
            "duration_label": "2h 20m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "科技",
              "AI",
              "产品",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a037114e1eb34a939471baf",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/6a037114e1eb34a939471baf/media.xyzcdn.net/68981df29e7bcd326eb91d88/lifY6z4XND4-vT9qQvxv_Pccs7FP.m4a",
            "play_count": 258868,
            "show_notes_text": "《十字路口》播客节目简介\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：李想\n\n今天请到的嘉宾是理想汽车的创始人——李想，我们“十字路口”开播的第一期嘉宾就是他。时隔两百多天，他完成了汽车公司转型走向 AI 和具身智能公司的阶段性工作，并带来了全新的智能产品：理想新一代的旗舰 SUV —— L9 Livis。\n\nL9 Livis 配备了理想自研的马赫 M100 芯片，还有“全球首个完全体全线控底盘”，以及 800V 主动式悬架系统。前者提供了目前量产的智能电动车当中最强的算力，算力达到了惊人的 2560 TOPS，后两者在五十万元左右的档位上，提供了百万甚至数百万元的豪车上才能享受的驾乘体验。\n\n《罗永浩的十字路口》第二十七期，我们和李想聊聊他的新旗舰 SUV，聊聊他逐渐成型的 AI + 具身智能公司，也聊聊他事业上的终极理想。\n\n【你将听到】\n\n00:01:48学AI是当下最重要的\n00:17:31聊聊具身智能\n00:31:46无人驾驶会影响车的销量吗？\n00:35:46汽车行业终极问题\n00:47:05关于AI的愿景和决心\n00:52:30关于L9 Livis\n01:12:41理想自研芯片\n01:26:27新的品牌认知\n01:36:46AI时代顶级人才\n01:46:46激进的组织调整\n02:03:50新能源车企出海\n02:15:30理想未来可能出现的危机\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FiKoEGxwhbcMkm_YitcPEmgaaNyi.jpg",
                "url": "https://image.xyzcdn.net/FiKoEGxwhbcMkm_YitcPEmgaaNyi.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 436,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69f12bc9d97e02e4ca5d1bc6",
            "index": 5,
            "title": "蔡康永×罗永浩！在残酷的世界寻找自在与和解、保持慈悲与真实",
            "pub_date": "2026-04-29T04:00:00.000Z",
            "duration": "12988",
            "duration_label": "3h 36m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "AI",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69f12bc9d97e02e4ca5d1bc6",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69f12bc9d97e02e4ca5d1bc6/media.xyzcdn.net/68981df29e7bcd326eb91d88/lqBW_yofWhs8RpT3W0XSe_g9ajJ1.m4a",
            "play_count": 858407,
            "show_notes_text": "《十字路口》播客节目简介\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：蔡康永\n\n《罗永浩的十字路口》第二十六期。\n\n这次请到的嘉宾，是我的偶像，整个华语主持界公认最会说话的人——蔡康永。\n\n蔡康永和小S联合主持的近3000期《康熙来了》，是全球华人娱乐世界的精神避风港，是中文综艺界前无古人后无来者的绝对标杆，也是全球非中文世界人民永远的人生缺憾。在文艺界，大家总讨论什么样的作品能够真正打败时间，但我相信从来没有人想过，一个通常被认为不入流的电视综艺节目，竟然能一口气把上世纪的六零后到新世纪的零零后，五代人全部搞定，而且借助短视频平台，《康熙来了》正在奇迹般地，不可阻挡地，海量转化一零后的年轻观众。\n\n蔡康永老师的情商课系列三部曲也是整个中文世界的超级畅销书，我的桌上放的，就是他情商三部曲的最后一本《你愿意，人生就会值得》。很多人误以为他的书是心灵鸡汤，其实这是一个非常大的误解。蔡康永老师的文字跟心灵鸡汤最大的区别是，“它会在承认衰亡和虚无的前提下探讨积极选择，这使得他的作品不是那种麻痹神经的廉价迷幻药，而是现代人在精神荒野中行路时的罗盘。”\n\n这次的对谈，我有幸和蔡康永老师聊了足足四个多小时，我们聊到了很多他从未公开触碰过的话题和内容，关于他的创作和生活的近况，关于敏感的心灵如何在时代剧变的背景下自处，关于直面中老年以及死亡的地狱话题，以及我们该如何提前练习跟这个世界优雅地告别等等。\n\n虽然谈到了很多全新的话题，但他还是你熟悉的那个独一无二的、艺人外壳、知识分子底色的蔡康永，还是那个在残酷的世界平静地寻找自在与和解、保持慈悲和真实的敏感灵魂。\n\n【你将听到】\n\n00:02:33聊聊近况\n00:13:11仍在写作\n00:23:45两老头论片\n00:33:28回应《康熙》不好看\n00:46:22烂书推荐语\n00:53:16绝非心灵鸡汤\n01:10:42电影票房扑街\n01:23:42《康熙来了》\n01:48:43艺术展\n02:06:05深入讨论AI\n02:20:12中年心理危机\n02:41:13遗嘱、死亡和葬礼\n03:13:07理想的告别\n03:34:32推荐嘉宾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FqXk67UB2h2m9Rb7885HshudTWJ3.jpg",
                "url": "https://image.xyzcdn.net/FqXk67UB2h2m9Rb7885HshudTWJ3.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2478,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69e19a1ee2c8be31556f0c7a",
            "index": 6,
            "title": "携程梁建章×罗永浩！在企业家与学者之间，他选择了最艰难的“往返票”",
            "pub_date": "2026-04-17T04:00:00.000Z",
            "duration": "13205",
            "duration_label": "3h 40m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "科技",
              "商业",
              "AI",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69e19a1ee2c8be31556f0c7a",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69e19a1ee2c8be31556f0c7a/media.xyzcdn.net/68981df29e7bcd326eb91d88/ljPurcSyivJkwJyAK_3kt3zly_fP.m4a",
            "play_count": 220795,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：梁建章\n\n梁建章是少年成名的计算机天才，是打造了在线旅游帝国的企业家，也是斯坦福的经济学博士。近年来最鲜明的标签，是热心关注人口问题的严肃学者，却被网民戏称为“催生办主任”。梁建章的人生轨迹，无法被世俗的单一标准所定义，这些看似跨界的选择，实际上是他对创新和未来一以贯之的关注。而基于长期趋势的忧患意识，则是他的行为贯穿始终的底层逻辑。\n\n《罗永浩的十字路口》第二十五期，这场长达三个多小时的深度对谈，不是又一个追逐风口的商业故事，而是一次关于科技伦理、高阶之爱和人类命运的心灵探索。\n\n【你将听到】\n\n00:00:35天才的童年\n\n00:10:21复旦少年班\n\n00:24:25工作在硅谷\n\n00:34:52携程四君子\n\n00:47:46远程办公\n\n01:01:23两度离开\n\n01:16:10海外业务\n\n01:33:02进修经济学\n\n01:47:52关注人口问题\n\n02:08:23各国生育状况\n\n02:20:45携程鼓励生育\n\n02:41:10生育哲学问题\n\n03:07:44如何看待AI\n\n03:26:42创生基金\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FqDJyB8XAgDoBGda-9C1WYJWjcN_.jpeg",
                "url": "https://image.xyzcdn.net/FqDJyB8XAgDoBGda-9C1WYJWjcN_.jpeg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3420,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69db5089e2c8be3155fd7978",
            "index": 7,
            "title": "“无聊斋” × 罗永浩的十字路口！喜剧工作者在AI时代可以多“活”几年",
            "pub_date": "2026-04-13T04:00:00.000Z",
            "duration": "9033",
            "duration_label": "2h 30m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "AI",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69db5089e2c8be3155fd7978",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69db5089e2c8be3155fd7978/media.xyzcdn.net/68981df29e7bcd326eb91d88/luag5VkVmErd4sl805M1Gdehyngs.m4a",
            "play_count": 139368,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期节目是《无聊斋》和《罗永浩的十字路口》联名款的特别现场。\n\n这一次的聚会，阎鹤祥、石老板、刘旸教主、六兽和罗永浩坐在一起，特别严肃地聊起了人生的各种“恐惧”。从看完恐怖片后的惊魂夜尿，到在朋友电影首映式上的烂片尬吹 ；从局麻手术脱裤子后被一屋子医生集体认出的人间惨剧 ，到电梯里有人放屁时究竟该如何绞尽脑汁照顾好每一个人（包括疑犯）。聊完这些人生的血泪和苦难之后，大家一致得出结论：幸好 AI 很快就会消灭我们。\n\n【你将听到】\n\n00:02:56聊聊恐惧\n\n00:05:41怕被罗老师回复\n\n00:17:35小众的恐惧\n\n00:28:54怕被架高姿态\n\n00:37:32恐怖片后遗症\n\n00:52:12放屁趣闻\n\n00:55:59害怕休息\n\n01:23:08害怕接触陌生人\n\n01:43:33脸盲的尴尬经历\n\n02:02:46害怕AI\n\n02:10:42最后淘汰喜剧人\n\n02:22:42毁灭世界\n\n02:26:33和AI交友\n\n02:29:27既恐惧又兴奋\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FmWp-4X1In7BLcJO4-i2Cyh40PMh.png",
                "url": "https://image.xyzcdn.net/FmWp-4X1In7BLcJO4-i2Cyh40PMh.png"
              },
              {
                "text": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg",
                "url": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 4787,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69cdbe5eb977fb2c47e1e409",
            "index": 8,
            "title": "崔健×罗永浩！去天堂和去地狱，都要带上艺术家",
            "pub_date": "2026-04-02T05:00:00.000Z",
            "duration": "9170",
            "duration_label": "2h 32m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "商业",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69cdbe5eb977fb2c47e1e409",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69cdbe5eb977fb2c47e1e409/media.xyzcdn.net/68981df29e7bcd326eb91d88/ljzsLBjyHPpWf11pKWO009U2hxii.m4a",
            "play_count": 182885,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：崔健\n\n在出道四十周年的巡演时刻，崔健并没有跟“怀旧”相关的任何念头，对回顾近半个世纪的成就和荣光也毫无兴趣，“我觉得那个日子并不重要，但是这个音乐会真是一个好音乐会，不看是你们的遗憾，大家的遗憾”。\n\n从1986年的石破天惊开始，四十年的风雨过后，他还是那个说话铿锵有力、掷地有声的崔健。到了中年之后，他反而更加积极和乐观，他认为中年危机不过是“你的脱壳时期，你进步的土壤，你最成熟的时候到来的前兆，是你最牛x的时候”。\n\n他也依然充满能量和热情，甚至比年轻时更忙于吸收学习各种新鲜的东西，不限于音乐。他拒绝复制自己，他想更多地、最大限度地呈现创作的丰富性。在科技和商业导致音乐行业巨变的时代浪潮中，他仍很享受成为现场表演中，音乐与听众之间还无法被技术替代的那种情感纽带。\n\n在长谈的结尾，他抛出了一个关于“诺亚方舟”和“外星”的测试：如果去地狱拯救世界或去天堂旅行，只能带五个行业的人去，你会选哪五个？5月9日，他将站在北京首都体育馆的舞台上，让你相信，天堂和地狱，都离不开艺术家。\n\n《罗永浩的十字路口》第二十三期，我们有幸邀请到了“中国摇滚教父”崔健。这一次，听他说话，和听他的音乐一样过瘾。他说，音乐不仅仅是旋律、和声和节奏，也是一种最纯粹的能量。他坚信，“拿乐器的人越多，拿武器的人就越少”。\n\n听完这近三个小时的对谈，你会发现，所有说“崔健老了”的人，甚至包括年轻人，都比崔健老多了。\n\n【你将听到】\n\n00:00:3430年前的合影\n\n00:02:12四十周年巡演\n\n00:14:07平日的创作\n\n00:23:54近年巡演情况\n\n00:28:59专辑是我的孩子\n\n00:53:14现场音乐\n\n01:06:24中年危机\n\n01:13:18排练问题\n\n01:22:51音乐制作和聆听体验\n\n01:38:47专辑在消亡\n\n01:48:53新的专辑计划\n\n01:57:44还能唱高音吗\n\n02:05:44评价说唱\n\n02:24:43天堂地狱测试\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FoHNlMEsCBQdJJuncVdM6Uw1KERo.png",
                "url": "https://image.xyzcdn.net/FoHNlMEsCBQdJJuncVdM6Uw1KERo.png"
              },
              {
                "text": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg",
                "url": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2328,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69c45e30e73b70b045dc11c5",
            "index": 9,
            "title": "杨笠×罗永浩！不想成为“靶心”，也无意成为“灯塔”",
            "pub_date": "2026-03-26T02:30:00.000Z",
            "duration": "13364",
            "duration_label": "3h 42m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69c45e30e73b70b045dc11c5",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69c45e30e73b70b045dc11c5/media.xyzcdn.net/68981df29e7bcd326eb91d88/lpRytONoy3jq2z8dNxgYgcqk_ZuO.m4a",
            "play_count": 788345,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：杨笠\n\n当整个互联网都为她的那个段子争吵、撕裂时，杨笠感受到的是一种极致的荒诞。她人生最黑暗的时刻和最高光的时刻同时来临，让她不知道该如何面对和言说，只能错愕地吞下生活给她的苦果......和糖果。\n\n在这场长达近四个小时，由“中国互联网最招黑体质”的两个人完成的对谈中，杨笠回顾了成长的种种往事，也包括那场席卷全网的舆论风暴。当这场风暴变得越诡谲，越来越复杂的时候，作为一名职业喜剧演员，她决定化繁为简，“只服务喜剧标准”，微笑着继续“冒犯”这个她无法回避的生活。\n\n从河北农村的猪圈旁，到火遍全国的综艺舞台，再到四千人体育馆里为她一个人点亮的聚光灯下，这一路，她没有刻意地选择坚强，当然也从没有考虑过选择退缩，她选择了平静地走到那个可以随心所欲，不强求被喜欢，也不畏惧被讨厌的真实自我。\n\n这一期的播客，是送给所有被误解、被污蔑、被命运作弄，但仍想守住内心平静的那些人的，一个精神上的拥抱。\n\n【你将听到】\n\n00:01:30巡演后续\n\n00:15:45回顾童年\n\n00:36:22大学时期\n\n01:00:41毕业之后\n\n01:14:42首次登台\n\n01:38:16一夜爆红\n\n01:52:10关于那次拍灯\n\n02:29:24和粉丝的关系\n\n02:52:44演出的初衷\n\n03:00:34专场、创作与行业\n\n03:10:00《爱江山更爱美人》\n\n03:22:07线下专场分享\n\n03:33:27圈内人\n\n03:38:04终身创作\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Fv5z5klJGK_jZuQWavoxopbafW3o.jpg",
                "url": "https://image.xyzcdn.net/Fv5z5klJGK_jZuQWavoxopbafW3o.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3429,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69a8fe02c8cdeb38c2e6df73",
            "index": 10,
            "title": "戏剧导演孟京辉×罗永浩！从“爱惹事的反叛者”，到戏剧乌托邦的建构者",
            "pub_date": "2026-03-05T06:00:01.000Z",
            "duration": "15640",
            "duration_label": "4h 20m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69a8fe02c8cdeb38c2e6df73",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69a8fe02c8cdeb38c2e6df73/media.xyzcdn.net/68981df29e7bcd326eb91d88/liB-NdRL_9td9h0KQl7pAZ834qEP.m4a",
            "play_count": 154400,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：孟京辉\n\n当孟京辉把《等待戈多》搬到学校操场的煤堆上演出时，你就知道，他的人生剧本注定不会遵循经典叙事。\n\n从中央戏剧学院那个“爱惹事的学生”，到中国先锋戏剧一面无法绕开的旗帜，孟京辉的前半生与他的戏剧一样，充斥着“不老实”的荷尔蒙与孩童般的探索欲。在这次长谈中，他聊起在排练场大喊“我错了”的快感，谈起押上全部身家赌一部戏时的豪迈，也毫不避讳因“闯祸太多”而被母校“婉拒”的往事...他的个人进化史，几乎等同于一部中国当代戏剧的突围史——那是一位创作者为了对抗沉闷的旧世界，而发动的漫长“远征”。\n\n《罗永浩的十字路口》第二十一期，我们和戏剧导演孟京辉展开了一场坦诚且充满细节的回望。他畅所欲言地分享着往事，让我们得以窥见一位大师的成长路径，听着他是如何从一名可爱的“反叛者”，一步步成长为伟大的“建构者”——他不仅亲手缔造了乌镇和阿那亚的戏剧乌托邦，更在每位观众心里留下一头拒绝被驯服的“犀牛”。\n\n【你将听到】\n\n00:03:36中国舞台剧现状\n\n00:16:51大学时期\n\n00:38:29学学表演\n\n00:50:55等待戈多\n\n01:11:59第五大混子\n\n01:27:06《思凡》爆火\n\n01:46:16文化交流\n\n02:01:57久经不衰的好戏\n\n02:18:08影像记录\n\n02:29:03关于排练\n\n02:44:16聊聊短视频\n\n02:53:13戏剧节\n\n03:21:19国外创新戏剧\n\n04:08:53观众流失问题\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Fs2Grh7BX7xCnwYlB5ZZS4bvWT8Q.jpeg",
                "url": "https://image.xyzcdn.net/Fs2Grh7BX7xCnwYlB5ZZS4bvWT8Q.jpeg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5034,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69a24e6d66e2c30377b1ede3",
            "index": 11,
            "title": "“不开玩笑” × 罗永浩的十字路口！折腾未必会赢，但不折腾一定会后悔",
            "pub_date": "2026-02-28T04:00:08.000Z",
            "duration": "8637",
            "duration_label": "2h 23m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "创业",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69a24e6d66e2c30377b1ede3",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69a24e6d66e2c30377b1ede3/media.xyzcdn.net/68981df29e7bcd326eb91d88/lga0l5q48bHT8MS9aOtmBz-Wh7oT.m4a",
            "play_count": 165793,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期介绍\n\n本期节目是《罗永浩的十字路口》和《不开玩笑》联名款现场。\n\n在这个《罗永浩的十字路口》第二十期（乱斗篇）中，罗永浩和史炎、宋方金、孙书恒、刘仁铖这几位朋友，打着讨论“折腾”这个严肃话题的幌子，进行了数小时的互相伤害；同时在互黑互损互殴的刀光剑影中，顺便聊到了创业与折腾，失败与再战，天赋与缺陷，音乐与舞蹈，手机与卤味，神经病与精神病等等。并在最后人模狗样地得出深刻的结论：折腾未必会赢，但不折腾一定会后悔。\n\n【你将听到】\n\n00:00:32 聊聊折腾\n\n00:17:01 “王哥卤味”\n\n00:26:43 最大单一遗憾\n\n00:40:56 心路历程\n\n01:00:57 关于卸妆\n\n01:20:52 网暴经历\n\n01:30:51 重启生活\n\n01:54:50 折腾电影\n\n2:04:46 继续折腾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Fjmogn0V3FoUXWR8l216d9gYw3dR.jpg",
                "url": "https://image.xyzcdn.net/Fjmogn0V3FoUXWR8l216d9gYw3dR.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FhWP0YEJR0jEuA-Fy369BNx9AuKq.png",
                "url": "https://image.xyzcdn.net/FhWP0YEJR0jEuA-Fy369BNx9AuKq.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3852,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "698ba733a22480add6956a2a",
            "index": 12,
            "title": "音乐人张玮玮×罗永浩！我们都是那个“混乱又伟大”的 90 年代的幸存者",
            "pub_date": "2026-02-11T04:00:00.000Z",
            "duration": "20344",
            "duration_label": "5h 39m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "AI",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/698ba733a22480add6956a2a",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/698ba733a22480add6956a2a/media.xyzcdn.net/68981df29e7bcd326eb91d88/llHEY1QKMnMxe-sjlXGleDJNTAOV.m4a",
            "play_count": 196074,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：张玮玮\n\n如果你曾以为《米店》就是张玮玮的全部，那你可能误读了他，也误读了那个被他称为“伟大的混乱”的 90 年代。从甘肃白银的矿坑烟尘，到广州大石镇的廉价饼干，从北京地下通道的嘶吼，到云南大理的舒适陷阱，张玮玮的人生轨迹，是一部中国独立音乐人的流浪史，也是一部为了对抗平庸与麻木而不断自我放逐的奥德赛。\n\n《罗永浩的十字路口》第十九期，罗永浩与张玮玮——这两个同样从 90 年代“野蛮生长”出来的老友，进行了一场长达近六小时的，密度极高，情感浓度也非常深厚的对谈。他们聊到了那些早已消失的地标：河酒吧的烟雾、无名高地的喧嚣、“金钱豹”奢华餐厅里跟音乐毫无关系的歌唱。\n\n张玮玮坦诚地剖析了自己从“站在角落的乐手”被迫走向台前成为“主唱”的恐惧，也毫不避讳地谈及中年危机时那只被风吹起的塑料袋。他轻轻抖掉了人们贴给他的“民谣”标签，用合成器和电子乐构建了新的《索拉里斯星》，只因他不愿在一个固化的梦境里沉睡。这是一次关于活着、关于尊严、关于如何在废墟之上重建自我的深度对话。\n\n【你将听到】\n\n00:01:58来自白银\n\n00:18:51初识郭龙\n\n00:31:10厂矿子弟\n\n00:56:04正向反馈\n\n01:29:11组建乐队\n\n02:11:48玩玩朋克\n\n02:54:42河酒吧往事\n\n03:25:53人生困境\n\n03:48:33电子音乐\n\n04:18:33圈内人\n\n04:49:49关于《米店》\n\n05:10:48AI创作\n\n05:26:09中年危机\n\n05:36:53嘉宾推荐\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Fr5HwnXbzyUVsbeGajow9SixssW2.jpeg",
                "url": "https://image.xyzcdn.net/Fr5HwnXbzyUVsbeGajow9SixssW2.jpeg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5891,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6982c33dc78b82389298d08d",
            "index": 13,
            "title": "蒋奇明&双雪涛×罗永浩！如何成为飞行家",
            "pub_date": "2026-02-04T04:27:42.000Z",
            "duration": "9291",
            "duration_label": "2h 34m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6982c33dc78b82389298d08d",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/6982c33dc78b82389298d08d/media.xyzcdn.net/68981df29e7bcd326eb91d88/lr4ZgdUjGLUXwAS7rbCitMC5kizZ.m4a",
            "play_count": 169642,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：蒋奇明 & 双雪涛\n\n最初，大家都是呱呱落地，但有些人落地，就是为了离开地面，飞向天空。\n\n演员蒋奇明，从话剧舞台转向影视镜头不过短短数年，就已经塑造出多个令人难忘的角色——完美诠释了“沉默震耳欲聋”的傅卫军，总在边缘挣扎的王安全，胸怀壮志但一生身不由己的李明奇......他和他所扮演的角色一样，都被生活的重力紧紧束缚，但从没放弃过“仰望星空”。\n\n作家&编剧双雪涛，多年来笔耕不辍，用文字完成了一次次冷静而又惊艳的探索。在他笔下，在那片老东北废弃工业区锈色的天空下，总有些人不甘心任由命运摆弄，执意寻找属于自己的升力。\n\n或许正因为曾经对抗过地面，如今他们比任何人都懂得“离地三米五”的珍贵，当蒋奇明和双雪涛相遇在电影《飞行家》，角色和文本互为翅膀，让“飞行”不再仅仅是隐喻，而是同时去往两个一样蔚蓝的天空。\n\n《罗永浩的十字路口》第十八期，我们节目首次迎来双嘉宾的对谈——演员蒋奇明与作家双雪涛。\n\n【你将听到】\n\n00:04:47关于改编\n\n00:13:25东北口音\n\n00:27:46前期准备\n\n00:40:47拍摄趣闻\n\n00:59:46父母反对\n\n01:09:28手语学习\n\n01:24:12投身表演\n\n01:43:47转职作家\n\n02:01:10重复演出\n\n02:04:49成名作品\n\n02:17:19越来越帅\n\n02:21:53双向奔赴\n\n02:26:34未来计划\n\n02:30:35推荐电影\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FtQQZdCjfMzCUhcd1XE1sUbNUA7i.jpeg",
                "url": "https://image.xyzcdn.net/FtQQZdCjfMzCUhcd1XE1sUbNUA7i.jpeg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3421,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69685b3def1cf272a7737d5d",
            "index": 14,
            "title": "刘震云×罗永浩！有些玩笑含着泪也要开完",
            "pub_date": "2026-01-15T04:00:33.000Z",
            "duration": "16067",
            "duration_label": "4h 27m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69685b3def1cf272a7737d5d",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69685b3def1cf272a7737d5d/media.xyzcdn.net/68981df29e7bcd326eb91d88/lu_1rRRenFntCaOiJjpBQJLBcAO_.m4a",
            "play_count": 493938,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：作家 刘震云\n\n时隔四年，刘震云老师带着他的新书《咸的玩笑》和我们进行了一次长谈。这一次故事又发生在家乡河南延津，又是一群失意的不知道找谁诉说的人们，又是一些生活中无可奈何的小事，最后不动声色地卷起狂风暴雨。几十年的文学创作让他成为了一个人类观察家，别人看到的是如常的生活，他说这里边全是哲学问题；别人听到的是玩笑，他却察觉了玩笑的味道，有些玩笑是咸的，因为开玩笑的人含着眼泪。那些平凡的日子，遗落了一些珍贵的东西，刘震云将它们捡起，用文字串了起来。他带着我们读懂了那些埋藏在冰冷世界里的异彩和辛酸。\n\n《罗永浩的十字路口》第十七期，我们邀请了作家刘震云，谈谈他的新作，谈谈他的往事，谈谈那些即便流着泪也要开完的玩笑。\n\n【你将听到】\n\n00:00:29咸的玩笑\n\n00:16:32新书缘起\n\n00:32:12生活异彩\n\n01:03:16乡土情结\n\n01:32:28创作状态\n\n01:57:55聊回童年\n\n02:18:49战友情谊\n\n02:41:26参加高考\n\n03:08:38初次投稿\n\n03:26:59创作动力\n\n03:31:07北大往事\n\n03:59:34全职写作\n\n04:08:53老友王朔\n\n04:24:29他的推荐\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FrjLp2PBA16ntvbwvSqZ28jqWXkX.jpg",
                "url": "https://image.xyzcdn.net/FrjLp2PBA16ntvbwvSqZ28jqWXkX.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5867,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69608f978f388c61e1fa0ad0",
            "index": 15,
            "title": "Lovart 创始人陈冕×罗永浩！且让我大闹一场，然后悄然离去",
            "pub_date": "2026-01-09T06:19:43.000Z",
            "duration": "13435",
            "duration_label": "3h 43m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 6,
            "matched_keywords": [
              "科技",
              "AI",
              "创业",
              "产品",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69608f978f388c61e1fa0ad0",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69608f978f388c61e1fa0ad0/media.xyzcdn.net/68981df29e7bcd326eb91d88/lh8a4SWN9y9z0Tw8AvCMLGljbeGX.m4a",
            "play_count": 199399,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：Lovart创始人 陈冕\n\n陈冕是一个天生的创业者，永远有新想法，永远跃跃欲试，永远准备战斗。他可能也的确是当下商战经验最丰富的创业者，因为他曾用 10 年时间集齐了几乎所有互联网大厂的工作履历，并亲身参与了一系列著名的商战。对他来说，打工是创业的预备期，他不断地吸收、总结、思考，等待着机会，一个让他义无反顾冲出去证明自己的机会，他等了好久，一度他以为自己生错了时代，直到那年冬天 AI 来了，他说自己得到了救赎。去年，他和他的创业团队推出了设计类的 AI Agent 产品 Lovart，在海外取得了现象级的成功，业内评价和收入规模都极为亮眼，叫好又叫座。在去年年底的十字路口科技创新分享大会上，我们将 Lovart 选为年度最佳图形图像类 AI 应用。但可惜因为时间的关系，最终没能现场讲解，日后我们会专门拍摄演示视频弥补这个遗憾。在这之前，让我们先用一场长谈，来认识一下这个积蓄了巨大能量、决心要大闹一场的年轻人。\n\n《罗永浩的十字路口》第十六期，让我们和 Lovart 创始人陈冕，聊聊他的创业之路。\n\n【你将听到】\n\n00:03:24生于重庆\n\n00:19:34大学经历\n\n00:38:06游遍大厂\n\n01:00:33转战字节\n\n01:18:45残酷竞争\n\n01:33:45准备创业\n\n01:50:14接触融资\n\n02:06:11Lovart\n\n02:36:49成绩斐然\n\n02:46:29同行观察\n\n03:04:43展望未来\n\n03:27:15AI绘画\n\n03:33:58终极风险\n\n03:41:21推荐嘉宾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Fuyg0QJbQ4sdrlKF123pyVgMmXo6.jpeg",
                "url": "https://image.xyzcdn.net/Fuyg0QJbQ4sdrlKF123pyVgMmXo6.jpeg"
              },
              {
                "text": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg",
                "url": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 4292,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "694cb5e1946dca09253c1b2e",
            "index": 16,
            "title": "影石Insta360 创始人刘靖康×罗永浩！比生存更重要的是那些微小的念头",
            "pub_date": "2025-12-25T04:34:42.000Z",
            "duration": "15877",
            "duration_label": "4h 24m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "科技",
              "创业",
              "产品",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/694cb5e1946dca09253c1b2e",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/694cb5e1946dca09253c1b2e/media.xyzcdn.net/nk78YhGKzrzA-pj5ex42Hwz7n352.mp3",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：影石Insta360创始人 刘靖康\n\n一段传奇，一个全世界瞩目的创业项目，一场被时代铭记的伟大冒险，很可能就来自于内心里一次微小的起心动念。在刘靖康的成长过程里，他无数次地被这种念头撞击着，总忍不住要创造些什么。从上学时，他的锋芒就藏不住了，他频频利用高超的计算机技术和天马行空的想法，制造出轰动校园乃至整个社会的热点事件。终于，他开始了自己的创业之路，他的创造欲彻底爆发，他在不同的细分场景里重新发明着相机，改变着人们记录生活的方式。他和他的公司都还很年轻，但他们的发明已经打开了诸多的新市场，解决了没人解决过的问题，以一个挑战者的姿态成长为新的巨头。他有足够的时间把奇思妙想带到更多的地方，也积累了足够的能力去找到更多内心里晃动着火苗的人们，让那些小小的冲动创造出巨大的快乐。\n\n《罗永浩的十字路口》第十五期，我们和 Insta360 的创始人刘靖康聊聊他的创业和他的创造。\n\n【你将听到】\n\n00:05:39童年环境\n\n00:28:49产生兴趣\n\n00:48:08大学创业\n\n01:08:28实习经历\n\n01:27:42全景相机\n\n01:50:21VR和AR\n\n02:12:39爆款产品\n\n02:34:04大赛风波\n\n02:49:48专利流氓\n\n03:01:32人才需求\n\n03:10:13重大决策\n\n03:24:51成功上市\n\n03:46:26发展趋势\n\n04:20:31始于敢想\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FmiF6NWuQKMk83Pxjg1zk1t-yM1p.jpeg",
                "url": "https://image.xyzcdn.net/FmiF6NWuQKMk83Pxjg1zk1t-yM1p.jpeg"
              },
              {
                "text": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg",
                "url": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5682,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6942389c4c65abaff36b20a8",
            "index": 17,
            "title": "导演大鹏×罗永浩！我这两辈子",
            "pub_date": "2025-12-17T07:35:38.000Z",
            "duration": "18141",
            "duration_label": "5h 2m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "访谈",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6942389c4c65abaff36b20a8",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/6942389c4c65abaff36b20a8/media.xyzcdn.net/68981df29e7bcd326eb91d88/liytV2s219yN3OX5dHR4Z4mroVYT.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：大鹏\n\n大鹏说，自己有时候感觉像活了两辈子。第一个大鹏从小镇怀着梦想闯荡北京，走得磕磕绊绊，遍体鳞伤。那时候的他永远站在角落，站在聚光灯旁边的阴影处。他努力地采访、主持、拍戏，接各种杂活儿，拼命尝试向舞台中央靠近…… 说不清究竟是哪一天，第二个大鹏发现自己站到了聚光灯下，结果很多人都要跟他重新认识一遍，因为他们大都不记得眼前这个人，不记得其实他们早就见过面。现在的他，无论是导演还是表演，无论是产量还是质量，拿出的都是扎扎实实的成绩。无论是作为导演还是演员，他离这个行业的最高荣誉也不止一次地只有半步之遥。可他还是不能放松，他总是想起第一个大鹏。他觉得一切本该做得更好，他心里好像总是有无限的遗憾、不安，和伴随着焦虑的更高目标。我们非常非常感谢他的信任，感谢他在这个超长的访谈中几乎毫无保留地呈现给了我们两个大鹏，两个命运截然不同但同样温暖柔软真诚的大鹏。\n\n《罗永浩的十字路口》第十四期，我们和大鹏聊聊他的两辈子。\n\n【你将听到】\n\n00:00:34来自集安\n\n00:15:35红棉吉他\n\n00:34:49少年时期\n\n00:50:22导演事业\n\n01:02:06创作思路\n\n01:52:44入职搜狐\n\n02:03:09拜师赵本山\n\n02:25:32离开搜狐\n\n02:36:11两段人生\n\n02:58:28关于评价\n\n03:25:34屌丝男士\n\n03:40:27投身电影\n\n04:39:21落选感言\n\n04:55:41有趣的人\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FnlOK7TNJi5bub4DViXVb-PKRQNR.jpeg",
                "url": "https://image.xyzcdn.net/FnlOK7TNJi5bub4DViXVb-PKRQNR.jpeg"
              },
              {
                "text": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg",
                "url": "https://image.xyzcdn.net/FuVItpAKbpWVfoWa11NZ_iRT0qsI.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5758,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69392768281939cce65925d3",
            "index": 18,
            "title": "MiniMax 创始人闫俊杰×罗永浩！大山并非无法翻越",
            "pub_date": "2025-12-10T08:34:31.000Z",
            "duration": "13859",
            "duration_label": "3h 50m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 6,
            "matched_keywords": [
              "科技",
              "AI",
              "大模型",
              "创业",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69392768281939cce65925d3",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69392768281939cce65925d3/media.xyzcdn.net/68981df29e7bcd326eb91d88/lhQbAp06A7_S4DXOSNV6gDX1ZESx.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：MiniMax创始人 闫俊杰\n\n闫俊杰似乎很擅长通关。他出生在小县城，一路读到了清华博士后，又从商汤的实习生一路做到了副总裁。但这些还不够，他的敏锐、他的决心、他的抱负一直在提醒他应该走出来，参与到世界的变革中来，于是在 AI 革命到来的前一年，他成立了 AI 大模型公司 MiniMax，这个公司的名字好像也在描述着起点和终点。他希望中国的厂商可以成为引领世界的巨头，他希望 AI 能够改变每一个普通人的生活。他看起来安静沉着，可内心对竞争充满期待，期待着跟王者一决高下，期待着他亲手将少数精英的工具变为普惠大众的生产力。\n\n《罗永浩的十字路口》第十三期，我们和 MiniMax 创始人闫俊杰聊一聊他的 AI 创业之路。\n\n【你将听到】\n\n00:01:26第一梯队\n\n00:04:10中国人才\n\n00:31:14飞速发展\n\n00:58:02梦幻开局\n\n01:12:25变革前夜\n\n01:23:53面对困境\n\n01:37:27人才策略\n\n01:54:31同行交流\n\n02:14:41成本降低\n\n02:32:27关于硬件\n\n02:52:17持续学习\n\n03:06:30内部分歧\n\n03:32:45展望未来\n\n03:48:36推荐嘉宾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Flsp22LFXsFUSJVa-XNDumUKcYs2.jpeg",
                "url": "https://image.xyzcdn.net/Flsp22LFXsFUSJVa-XNDumUKcYs2.jpeg"
              },
              {
                "text": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg",
                "url": "https://image.xyzcdn.net/FowPUSMac2OogPODg3OjeuVh5jZC.jpeg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 4859,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69286665f2b167179817c7e4",
            "index": 19,
            "title": "导演毕赣×罗永浩！清醒、深刻、独一无二的造梦者",
            "pub_date": "2025-11-28T04:00:11.000Z",
            "duration": "12056",
            "duration_label": "3h 20m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69286665f2b167179817c7e4",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69286665f2b167179817c7e4/media.xyzcdn.net/68981df29e7bcd326eb91d88/lhsUt9wu8N73DBdyHPS50yMyf9wa.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：导演 毕赣\n\n才华这件事终究是无法解释的。毕赣的成长很像是得到了一个艺术创作的火种，让他完全凭借直觉和自学形成了属于他的美学体系，而这些恰好能以诗一样的电影作为出口。但令人更加意外的是，他同时还兼具另一种才华——能将混沌的艺术理念和模糊的生命体验讲述清楚的能力。我谈到了很多在艺术上长久以来的困惑，他三言两语就让人豁然开朗。这一次，他在大银幕上带来了绵延一个世纪的梦境，又在这场超长的谈话中带来了“梦的解析”。\n\n《罗永浩的十字路口》第十二期，我们和导演毕赣聊聊他的梦，他的艺术观和他的狂野时代。\n\n【你将听到】\n\n01:52 凯里往事\n\n11:14 导演童年\n\n23:03 创作经历\n\n40:01 阅片经历\n\n53:53 首次拍片\n\n01:07:55 发掘演员\n\n01:22:48 路边野餐\n\n01:39:32 观影体验\n\n02:01:42 海外得奖\n\n02:13:28 前辈认可\n\n02:32:38 地球夜晚\n\n02:36:07 狂野时代\n\n03:03:41 戛纳摘奖\n\n03:20:09 推荐嘉宾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Fhw-7DhN1_yk7qfYmTz_XpSAYbIV.jpg",
                "url": "https://image.xyzcdn.net/Fhw-7DhN1_yk7qfYmTz_XpSAYbIV.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png",
                "url": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2812,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "691d4c86cbba038b4241a301",
            "index": 20,
            "title": "何同学×罗永浩！青年何同学的骄傲与烦恼",
            "pub_date": "2025-11-20T04:00:00.000Z",
            "duration": "12629",
            "duration_label": "3h 30m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/691d4c86cbba038b4241a301",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/691d4c86cbba038b4241a301/media.xyzcdn.net/68981df29e7bcd326eb91d88/lipRfske7D5elPqDHIOrn-zTvXZH.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：何同学\n\n何同学有着精干而稍显瘦小的身躯，可他面对的一切似乎都是巨大的。巨大的流量、赞赏和争议，他像一个被选中的年轻人，时代的浪潮向他疯狂涌来。在滔天的风浪中，他总是能够沉住气精心策划出好内容，用对内容的执着构筑起一道防线，那是他的堡垒、他的骄傲，也是他漂洋过海的小船。他总是说自己很幸运，尽管他并不知道迎接他的会是什么。船在继续往前走着，他有时候也茫然，但他知道他要去到哪里。\n\n《罗永浩的十字路口》第十一期，我们和何同学聊聊他的视频和一些刻骨铭心的成长。\n\n【你将听到】\n\n00:38 锤子赠礼\n\n04:33 疯狂课外班\n\n13:10 大学生活\n\n18:33 数码兴趣\n\n26:08 TNT往事\n\n42:17 公开演讲\n\n50:11 5G 时代\n\n57:25 量产难题\n\n01:08:57 成名之后\n\n01:48:13 打车风波\n\n02:03:32 公司困境\n\n02:07:00 海外状况\n\n02:39:07 苹果开箱\n\n02:58:44 选题思路\n\n03:12:27 性格懂事\n\n03:16:35 欣赏的同行\n\n03:22:22 当下的焦虑\n\n03:29:02 推荐嘉宾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FuBQFGN_PEBarLhzffbOZmpT6eVE.jpg",
                "url": "https://image.xyzcdn.net/FuBQFGN_PEBarLhzffbOZmpT6eVE.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png",
                "url": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 4020,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6911792bd99642be964e9813",
            "index": 21,
            "title": "魔术大师刘谦×罗永浩！你所不知道的刘谦",
            "pub_date": "2025-11-11T04:00:00.000Z",
            "duration": "16081",
            "duration_label": "4h 28m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "访谈",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6911792bd99642be964e9813",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/6911792bd99642be964e9813/media.xyzcdn.net/68981df29e7bcd326eb91d88/lkmBNVq3I5S8rvzS22fyi2xhNbtE.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：刘谦\n\n魔术大师刘谦把魔术分为两种，一种是观众看了会说“哇，好厉害，你怎么做到的？”还有一种是观众会觉得，“天呐！这不可能！刚刚发生了什么？！” 他说，后一种，会给在场的人留下回味终生的绝妙体验。\n\n刘谦是彻底的唯物主义魔术师，可他一直致力于给观众的心里留下魔法的踪迹。在这个超长的访谈中，他通过一连串让人拍案叫绝的故事和令人头皮发麻的演绎，完成了对魔术的正本清源和深度揭秘，阐述了他对这个行业的深刻理解和终极追求。也给我们心中所谓魔术的价值和意义，赋予了一层前所未有的认知。\n\n【你将听到】\n\n00:00:52 刘谦近况\n\n00:08:05 人生态度\n\n00:12:39 回忆童年\n\n00:19:12 开启魔术生涯\n\n00:31:18 魔术心得\n\n00:38:32 同行交流\n\n00:46:22 崭露头角\n\n00:55:42 街头表演魔术\n\n01:03:41 手速的秘密\n\n01:26:57 魔术综艺\n\n01:31:48 春晚往事\n\n01:44:41 遭遇不顺\n\n01:59:57 行业现状\n\n02:12:39 现场表演魔术\n\n02:33:11 巴格拉斯效应\n\n02:52:25 收入来源\n\n03:18:30 魔壶表演\n\n03:24:15 面对失误\n\n03:29:47 夜总会魔术\n\n03:45:42 保密和揭秘\n\n04:02:56 关于家人\n\n04:15:32 冰块魔术\n\n04:25:42 大师的理念\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png",
                "url": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5395,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69013002740634ca477ad956",
            "index": 22,
            "title": "贾樟柯×罗永浩！成为贾樟柯（上）",
            "pub_date": "2025-10-29T04:00:00.000Z",
            "duration": "13515",
            "duration_label": "3h 45m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69013002740634ca477ad956",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/69013002740634ca477ad956/media.xyzcdn.net/68981df29e7bcd326eb91d88/lhruzjXLjCFha9bK5K2hU_wDQCiR.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n本期嘉宾：贾樟柯\n\n在多数镜头都在追逐都市霓虹和英雄传奇时，贾樟柯的摄像机却始终对准他脚下的土地。他的电影画面中鲜少出现激烈的冲突，有的只是山西小城里随处可见的煤矿、摩托车、县城歌舞团、终日无所事事的少年，以及巨变的大时代背景下，一些踉踉跄跄，不知所措的身影。这些被宏大叙事忽略的人与事，在他的取景框里发出了低沉有力的轰鸣，让山西县城的天空和威尼斯的夜晚一起震颤。\n\n《罗永浩的十字路口》第九期，我们的嘉宾是导演贾樟柯。\n\n和贾樟柯对谈，就好像在看贾樟柯的电影。他的讲述如同他的镜头语言，真实，质朴，平静，偶尔有些跳跃，一如既往蕴藏着触碰心弦的力量。跟随他的叙述，我们将一起见证，那个曾经徘徊在汾阳街头的“问题少年”，是如何抵达威尼斯，并走到金狮奖的聚光灯下的。\n\n【你将听到】\n\n00:31 戴墨镜的原因\n\n01:27 成长的地方\n\n04:32 儿时的梦想\n\n09:45 家庭的影响\n\n16:46 对文学产生兴趣\n\n22:45 开始写作\n\n29:56 街头战争\n\n52:50 乌兰巴托的夜\n\n01:24:10 向往电影\n\n01:49:29 中年人打架\n\n02:00:08 北京求学\n\n02:19:51 电影开幕\n\n02:45:50 《三峡好人》往事\n\n02:57:22 个人风格\n\n03:03:27 OK 先生\n\n03:09:25 性格转变\n\n03:22:52 观影喜好\n\n03:34:20 好脾气导演\n\n03:41:17 表白贾樟柯\n\n03:43:21 推荐嘉宾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png",
                "url": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5094,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68f8351e2265473020a2058a",
            "index": 23,
            "title": "名创优品叶国富×罗永浩！重塑线下购物，让人们重新爱上逛街！",
            "pub_date": "2025-10-22T04:00:51.000Z",
            "duration": "10444",
            "duration_label": "2h 54m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "科技",
              "商业",
              "访谈",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68f8351e2265473020a2058a",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/68f8351e2265473020a2058a/media.xyzcdn.net/68981df29e7bcd326eb91d88/ltdPlF6Zr1aGmhHbOPqptuTVr-ng.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n【本期嘉宾介绍】\n\n一年 1000 家店，从 0 到 100 亿，为了 IP 业务转型要求做事的人一年至少浪费 1 个亿……这些数字既是一个狂飙突进商业奇迹的见证，也是一连串坐标，带我们了解这个奇迹是如何具体而微地被构建出来的。\n\n对于任何一个想要探求商业运作背后机制和原理的人，这场访谈都是一次令人兴奋的旅程。过去这些年，中国企业家创造了太多激动人心，光彩夺目的商业故事，叶国富和他的名创优品无疑是其中异常璀璨的一个。将近三个小时的篇幅里，听他讲述如何从“卖杂货”起始，到加盟店开遍全球，随即成为中国最会玩 IP 的企业之一，继而又义无反顾投身被视为夕阳产业的超市领域，每一步都兼具敏锐的判断和扎实的执行。他是怎么做到的？\n\n《罗永浩的十字路口》第八期，我们和叶国富一起聊聊他的线下零售世界。\n\n【你将听到】\n\n00:35 爱好逛街\n\n01:19 名创优品的由来\n\n17:13 供应商结款模式\n\n23:02 加盟情况\n\n28:19 打造爆款\n\n41:09 打造 IP\n\n53:08 探讨预制菜\n\n59:28 经营状况\n\n01:06:00 关于胖改店\n\n01:11:32 文化出海\n\n01:23:48 TOP TOY 面世\n\n01:32:08 原创 IP 的难点\n\n01:39:51 爆火具有偶然性\n\n01:52:25 潮玩市场格局已定\n\n02:14:56 收购永辉\n\n02:24:55 调改永辉\n\n02:44:52 最佩服的中国企业家\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png",
                "url": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2770,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68f1044e456ffec65e21a811",
            "index": 24,
            "title": "宋方金×罗永浩！故事必须有人讲下去",
            "pub_date": "2025-10-17T04:00:00.000Z",
            "duration": "19376",
            "duration_label": "5h 22m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 4,
            "matched_keywords": [
              "科技",
              "AI",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68f1044e456ffec65e21a811",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/68f1044e456ffec65e21a811/media.xyzcdn.net/68981df29e7bcd326eb91d88/lt24pCOBVqnYXJeven2dWhuHvMFu.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n【本期嘉宾介绍】\n\n编剧宋方金讲故事的能力似乎是与生俱来的，他能把严肃的话题讲得引人入胜，同时把好玩的话题讲得意味深长。我们聊了近七个小时，他始终保持了相同的信息密度、节奏以及语言包袱，甚至都没怎么喝水。\n\n他聊创作，聊电影，聊影视行业，聊他看不惯的种种，百无禁忌。别人缄口不提的，他侃侃而谈；别人舍不得讲出来的，他知无不言。\n\n他是讲述者、斗争者，也是捍卫者、坚持者，捍卫编剧的权利，坚持编剧的职责。在他看来，有些话必须要说，有些架必须要吵，有些故事必须要讲。正因如此，面对这个时代，他才能问心无愧地说出，“我没有守口如瓶”。\n\n《罗永浩的十字路口》第 7 期，我们和知名编剧宋方金聊聊他的故事。\n\n【你将听到】\n\n01:22 写作机缘\n\n05:12 拜访莫言\n\n11:13 谈刘震云\n\n23:57 接触影视\n\n25:46 探讨微短剧\n\n52:59 脱口秀元老\n\n01:18:30 命中贵人\n\n01:45:56 罗永浩打脸表情包\n\n01:57:54 畅谈张艺谋\n\n02:07:22 张艺谋见外星人\n\n02:17:27 科幻片是翻译错误\n\n03:10:44 编剧署名乱象\n\n03:23:39 喜剧创作难点\n\n03:28:22 作家网红化\n\n03:51:01 毒舌人设\n\n04:34:11 影视行业现状\n\n04:39:09 目标两百亿票房\n\n04:45:20 影视行业各阶段\n\n04:53:08 评《周处除三害》\n\n05:02:54 编剧创作方法论\n\n05:06:57 畅谈电影行业未来\n\n05:18:30 AI 冲击电影行业\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png",
                "url": "https://image.xyzcdn.net/FtPh6ArxJrtZt3iIBlgnKy3oQchW.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 8020,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68e74f521bef327f3d7ddcd7",
            "index": 25,
            "title": "影视飓风TIM×罗永浩！用影像打开世界的梦想家",
            "pub_date": "2025-10-10T04:00:00.000Z",
            "duration": "10296",
            "duration_label": "2h 51m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "科技",
              "AI",
              "创业",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68e74f521bef327f3d7ddcd7",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/68e74f521bef327f3d7ddcd7/media.xyzcdn.net/68981df29e7bcd326eb91d88/lkn6q5faprZ9P8w1Ue3-xTXEuP2h.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n【本期嘉宾介绍】\n\n因为一次偶然，他拿起了摄像机，扭动变焦镜头的时候，命运的齿轮也随之转动起来。影视创作成了他的生活，用想法和镜头打开世界成了他的使命。他痴迷器材，痴迷影像，也痴迷创业。这些年，他的公司像公司的名字一样，越走越快，越走越远，越走越势不可挡。\n\n在毛里求斯的海中和抹香鲸共舞，在冰岛近距离拍摄喷发中的火山，在国内用肉身体验最凶悍的匪徒都害怕的电击枪......他举重若轻地完成了这些在过去通常被认为是“欧美人才会喜欢的冒险”。接下来，去蛇岛过夜，去雪原探险，去大海追逐最凶猛的鲨鱼..… 更多新奇的冒险计划在他的任务清单里排好了队。脚踏着地球一步步落实计划的同时，他也想好了有一天要把镜头对准我们的星球之外，对准没人抵达过的地方，以回应那颗永远跳动着的好奇心。他有了和年龄完全不匹配的成就，更有着值得无限期待的未来。\n\n他是影视飓风的 Tim，潘天鸿。《罗永浩的十字路口》第 6 期，我们会一起谈谈，他是如何像呼吸般自然地实现了一个又一个年轻的、狂野的梦想。\n\n【你将听到】\n\n00:42 Tim 这个名字是怎么来的\n\n03:13 儿时曾被冤枉是小偷\n\n07:11 从小到大一直以为家里很穷\n\n13:21 Tim 回忆视频事业的开端\n\n22:36 内心想拿奥斯卡短片奖\n\n34:39 做媒体能站着赚钱吗\n\n42:32 影视飓风的收入来源\n\n55:58 Tim 想探索自媒体的上限\n\n01:19:36 什么时候意识到自己是网红\n\n01:26:52 荒岛直播的前因后果\n\n01:45:17 Tim 给视频工作者的建议\n\n02:17:13 AI 会替代视频工作者吗\n\n02:38:55 五年内想要 10 亿人看过影视飓风\n\n02:44:00 Tim 想要死在火星\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg",
                "url": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2634,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68d29202522b40626cead830",
            "index": 26,
            "title": "周鸿祎×罗永浩！周鸿祎深度谈 AI！近四小时高密度输出",
            "pub_date": "2025-09-24T04:00:00.000Z",
            "duration": "12766",
            "duration_label": "3h 32m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 5,
            "matched_keywords": [
              "科技",
              "AI",
              "大模型",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68d29202522b40626cead830",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/68d29202522b40626cead830/media.xyzcdn.net/68981df29e7bcd326eb91d88/lhG2BOYB8BeGpX0hYQ_n6Qur47Ks.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n【本期嘉宾介绍】\n\n走过二十多年的腥风血雨，周鸿祎说他迎来了最伟大的科技革命，并且他已经为这场变革准备好了，无论是精神上还是体能上。只要聊起 AI，他就会马上全情投入，把他的观察、思考和发现，源源不断地，密不透风地讲下去。这是我说话最少的一期博客节目，好像只要给他输入一点简短合适的提示词，他就能持续地生成高质量的谈话内容。这个版本的周鸿祎，依旧敏锐、兴奋和坚决，但他已经不再将“对手”视作“敌人”。《罗永浩的十字路口》第五期，我们和周鸿祎集中谈谈 AI。\n\n【你将听到】\n\n00:30 为什么选择当网红企业家\n\n07:59 当网红对360而言是好事吗\n\n20:54 罗永浩解释为什么做深度播客\n\n23:21 在公众前高频出现会有压力吗\n\n28:08 拍卖迈巴赫的幕后真相\n\n35:09 周鸿祎坦言并不想当车圈大V\n\n40:51 周鸿祎为何拳打机器人\n\n54:08 语言是人类的金钥匙\n\n01:01:40 周鸿祎：AI 的进化相当快速\n\n01:11:23 大模型的能力远远不止于此\n\n01:14:03 AI 已经全知，就差全能了\n\n01:30:25 周鸿祎不同意脑机接口这个观点\n\n01:49:23 周鸿祎后悔没学好线性代数\n\n02:02:46 周鸿祎为何甘愿当“配角”\n\n02:22:35 国内有哪些优秀的AI团队\n\n02:30:13 周鸿祎对 AI 的未来保持乐观\n\n02:39:25 AI 软件未来的盈利模式\n\n02:58:51 AI 对杀毒软件行业有帮助吗\n\n03:17:19 如何看待新版GPT\n\n03:22:08 AI 领域存在泡沫，但这是好事\n\n03:30:28 经常觉得昨天的自己是傻x\n\n03:30:46 推荐下一期嘉宾\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg",
                "url": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3930,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68c086ac2c82c9dcca930f35",
            "index": 27,
            "title": "五条人之仁科×罗永浩！近五个小时的变态超长对谈！",
            "pub_date": "2025-09-10T04:00:00.000Z",
            "duration": "16658",
            "duration_label": "4h 37m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68c086ac2c82c9dcca930f35",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/68c086ac2c82c9dcca930f35/media.xyzcdn.net/68981df29e7bcd326eb91d88/lml-eUxpi9EKjvk_IhNkFZwP4Ysq.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n【本期介绍】\n\n和仁科面对面长谈是一件异常奇妙的事。在“土”与酷、流行与小众、无厘头与严肃、装疯卖傻与坦率真诚之间，他随心所欲，肆意往复摆荡。这些貌似严格对立的两极，完美和谐地统一在他一个人身上。那个周末，我们聊了一个整天，或者说是几十年。从海丰的穷街发廊到广州的陋巷碟店，从地摊的三无拖鞋到奢侈品牌的裤衩，从烟雾和汗臭缭绕的摇滚酒吧到音乐和呐喊刺破长空的万人体育场，从城中村逼仄的合租屋到阿那亚辽阔的海边。在这场漫长但其实并没有“终点”的对谈中，仁科用他特有的天马行空和略带神经质的方式，让整个过程充满了难以割舍的灵光与奇趣的碎片。\n\n所以这一次，我们做了一个放肆的决定：我们仅做最微小的剪辑工作，尽可能还原这场对谈的全貌。因此这期播客节目，有惊人的近五个小时时长。在观看或收听之前，请一定调整好心态，甚至作息时间，虽然你也可以用碎片时间断断续续地看完听完，但损失的很可能是罕见的、宝贵的，连续近五个小时的心流。你将要打开的，是一位风格上完全无法归类的当代艺术家，三十多年的音乐探索和心灵成长的完整编年史。我们把它献给坚称不死但不可避免地走向黄昏的摇滚乐，献给这个全人类撕裂和下行的艰难周期，献给那些不再热衷表达但并没有放弃思考的文艺青年。这听起来好像有些伤感，但其实整体上是非常欢乐的，毕竟他是我们热爱的那个独一无二的“神经病”仁科^_^\n\n《罗永浩的十字路口》第四期，我们的嘉宾是五条人之仁科。让他陪我们一起，度过这时代的晚上......或一个明晃晃的白天。\n\n【欢迎看完了全片的朋友们在评论区打卡留言和交流，相信对绝大多数人，这样的播客体验都是生平第一次，即便不是最后一次】\n\n【你将听到】\n\n00:00 原来仁科和罗老师是“农具组合”\n\n01:48 小时候竟然还是富二代\n\n06:24 被女同学捧着脸说“你好帅”\n\n13:28 也曾“黑白两道通杀”\n\n26:25 初中就开始听各路摇滚乐了\n\n32:06 小镇青春岁月的终结\n\n51:49 “完蛋，来了个正常人，某种意义上不帅了”\n\n1:02:32 仁科的“时光列车”思想实验\n\n1:04:50 仁科：不得不佩服我自己啊，也算是经商奇才。\n\n1:23:06 竟然还有一个人和仁科“发病的方式很像”\n\n1:25:44 罗老师深情回忆小河的“变态演出”\n\n1:29:17 既然穷途末路了，那就组乐队吧！\n\n1:33:54 罗老师“一辈子也没听过”的不插电演出\n\n1:49:19 土味美学的诞生\n\n2:00:15 那个著名的塑料袋 LOGO 是怎么来的\n\n2:05:04 为什么要用海丰话写歌\n\n2:23:19 早起演出的爆笑经历\n\n2:49:39 两次跟父亲流露感性\n\n2:55:14 参加乐夏的时候正在生阿茂的气\n\n3:01:30 意识到“哥红了”的瞬间\n\n3:51:44 参加综艺节目是一种逃离\n\n4:01:40 仁科是草蜢的粉丝\n\n4:35:22 结束前来一曲安可\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg",
                "url": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 7208,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68b4d92f97178f08ee9b2d79",
            "index": 28,
            "title": "何广智×罗永浩！何广智：我到长安了",
            "pub_date": "2025-09-01T04:00:00.000Z",
            "duration": "11877",
            "duration_label": "3h 17m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 3,
            "matched_keywords": [
              "科技",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68b4d92f97178f08ee9b2d79",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/68b4d92f97178f08ee9b2d79/media.xyzcdn.net/68981df29e7bcd326eb91d88/lkz6aMsE3fTpkTl8vkoZPFxj2KwT.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n【本期介绍】\n\n他是脱口秀舞台的大明星，他是穷门的初代掌门人，他屡次打入脱口秀节目的决赛，他是很多人心中的无冕之王。又是一年决赛，这一次，脱口秀大王的奖杯只为他的捧起而等待了整整一个夏天，而他也等来了自己的人生段子。历时七年，带刺的玫瑰从苏北以北三百多公里走到了上海，又从上海走到了他的长安。他是 2025 年《脱口秀和 Ta 的朋友们》的冠军 @何广智，欢迎收看《罗永浩的十字路口》第三期，让我们和他一起回顾这一路笑声不断的汗水和忧伤，光荣与梦想。\n\n微信搜 “罗永浩的十字路口” 公众号，点菜单栏加听友群，有机会得节目限量周边和签名好物。\n\n【你将听到】\n\n01:28 这一季一开始就来势汹汹，是装出来的？\n\n05:30 广智替周奇墨捏一把汗：遇上我算你“倒霉”吧。\n\n11:07 庆功宴上最让广智动容的一个事。\n\n32:25 广智的私人歌单到底有多“羞耻”？\n\n43:16 一部分脱评人慢慢在被时代抛弃\n\n46:58 广智“猖狂”到拿自己和梅西相比了？\n\n53:55 这一季，广智最喜欢孙书恒的作品？\n\n1:17:33 小时候“出身穷门”，有多穷？\n\n1:19:45 幼小的广智惊呆了，城里人都这么“放荡”吗？\n\n1:26:10 广智发现自己洞悉了这个世界的规律。\n\n1:28:52 穿布鞋打篮球还挺酷的。\n\n01:42:06 如果让广智拿脱口秀大王换一段刻骨铭心的恋爱…他愿意。\n\n01:52:37 怀揣1万块钱，坐着绿皮火车来上海闯荡。\n\n01:58:39 青旅、地道、流浪汉…元素齐全了，上海配得上广智的梦想。\n\n02:12:22 在笑果当“练习生”，终于管吃住了。\n\n02:14:04 上节目之前，已经是跑过上千场演出的“炸场王”。\n\n02:34:23 有资格去李诞家喝酒了。\n\n02:56:30 “穷门”赛道不是被规划出来的\n\n03:08:50 挣钱了，广智说要不我买个路虎？\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg",
                "url": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 4623,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68acd788293471fed470ef39",
            "index": 29,
            "title": "何小鹏×罗永浩！何小鹏讲述从财富自由奔赴无尽地狱模式的创业故事",
            "pub_date": "2025-08-26T04:00:00.000Z",
            "duration": "10035",
            "duration_label": "2h 47m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 6,
            "matched_keywords": [
              "科技",
              "AI",
              "创业",
              "产品",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68acd788293471fed470ef39",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/68acd788293471fed470ef39/media.xyzcdn.net/68981df29e7bcd326eb91d88/lnmPQIptZutrEvnWR4OT5zRWxuAk.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n【本期介绍】\n\n他早年创立 UC 浏览器，早早就实现了年少时的宏愿，而这很快又变成了他开启下一局游戏的筹码。他马上投入到更大更具风险性的事业，从陆地到天空，他渴望挑战更高的难度。他说，已经习惯了在深渊里行走，他的人生只能被梦想支配。他是本期嘉宾小鹏汽车的何小鹏。\n\n微信搜 “罗永浩的十字路口” 公众号，点菜单栏加听友群，有机会得节目限量周边和签名好物。\n\n【你将听到】\n\n01:27 财富自由的三条路径\n\n07:45 早期创业选对合伙人非常重要\n\n14:20 UC 浏览器成功的背后故事\n\n20:07 财富自由之后经受了人性的考验\n\n26:43 决定亲自下场做车的契机和动机\n\n36:34 为什么用自己的名字给公司起名\n\n44:23 小鹏汽车关于品牌产品定位的思考\n\n50:04 AI 如此烧钱，小鹏必须靠收入支撑\n\n54:19 发现方向不对，应该尽早“干掉”\n\n01:03:55 新能源造车的淘汰赛还有五年\n\n01:18:15 计算机系出身的何小鹏如何看待自动驾驶\n\n01:28:39 何小鹏是如何成为产品经理的\n\n01:37:02 为什么小鹏要自研芯片，要做飞行汽车\n\n01:50:36 何小鹏鼓励罗永浩创业到八十岁\n\n02:00:44 小鹏汽车人事剧变的惊涛骇浪\n\n02:04:48 因为太老实而经常上当受骗\n\n02:10:14 何小鹏：我是一个性格暴躁的人\n\n02:17:40 互联网人和传统车企人如何合作造车\n\n02:23:34 最难的时候，小鹏甚至想过把自己换掉\n\n02:28:44 何小鹏：很多人都是在“假重视”AI\n\n02:32:30 AI 的未来是悲观的，脑科学可能更悲观\n\n02:40:51 产品经理比其他工种更难被 AI 取代\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg",
                "url": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2115,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "68a3d1fe293471fed44ce974",
            "index": 30,
            "title": "李想×罗永浩！四小时马拉松访谈！李想首度公开讲述 25 年创业之路",
            "pub_date": "2025-08-19T04:00:00.000Z",
            "duration": "14201",
            "duration_label": "3h 56m",
            "selected": true,
            "confidence": "rss-feed",
            "score": 7,
            "matched_keywords": [
              "科技",
              "访谈",
              "人工智能",
              "创业",
              "产品",
              "罗永浩",
              "十字路口"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/68a3d1fe293471fed44ce974",
            "audio_url": "https://dts-api.xiaoyuzhoufm.com/track/68981df29e7bcd326eb91d88/68a3d1fe293471fed44ce974/media.xyzcdn.net/68981df29e7bcd326eb91d88/lqzFpSTn-STz-J4YSIqhokQ6S228.m4a",
            "play_count": null,
            "show_notes_text": "《十字路口》播客节目简介\n\n本节⽬是⼀档由罗永浩主持的深度播客类节⽬，每集长达三到五个小时。我们与时代浪潮中的⼈物展开对话，聚焦于科技与⼈⽂领域，讲述个体命运故事，探讨时代发展趋势。\n\n【本期介绍】\n\n他经历了少年得志，高中创业，24 岁身价过亿，公司九成员工一夜离职，差点被创始团队驱逐，企业上市前夜股东叛变；他押上全部身家再次创业，打造了“500 万以内最好的 SUV”，成为唯一一家持续盈利的造车新势力企业；但过程中也遭遇了资金链断裂、产能地狱、铺天盖地的污蔑、诽谤和泼脏水。如今回望四分之一世纪的创业之路，他依然充满了理性作为基础的热情与梦想，这一期的嘉宾是理想汽车的李想。我们与他谈起他的故事。\n\n微信搜 “罗永浩的十字路口” 公众号，点菜单栏加听友群，有机会得节目限量周边和签名好物。\n\n【你将听到】\n\n03:59 从写作中受益，父亲送电脑，母亲教理财\n\n14:49 从小就想当总经理，高三开始收入就已经是父母的十倍\n\n27:15 上大学还是直接创业的抉择，面对霸凌一定要还手\n\n39:36 遭遇互联网泡沫，孤身前往北京\n\n48:52 24 岁身价过亿，开始寻找下一个创业风口\n\n56:06 罗永浩和李想分享对任天堂的宫本茂和苹果的乔布斯的喜爱\n\n61:17 二次创业想要做更大的赛道，选择了汽车这个“标品”\n\n66:02 李想：成功的公司无非两种组织方式，不同的方式决定了不同的产品\n\n72:37 从汽车之家到理想汽车，选对创始团队一直都是最重要的\n\n86:54 为什么理想ONE 选择了反共识的增程式方案，李想是怎么判断的\n\n97:09 谈到融资最困难时的贵人相助，李想忍不住哭了\n\n105:34 产能地狱，被供应链欺负的时候，理想是怎么挺过来的\n\n112:56 中国造车新势力为什么能在全球范围内快速崛起\n\n119:40 罗永浩：理想ONE 是当时“500 万以内最好的家用 SUV”\n\n131:33 李想回应MEGA被黑和真人秀节目被断章取义\n\n138:48 李想：面对泼脏水，自己也不想成为那样的人\n\n148:42 理想的设计理念和全球战略\n\n154:57 李想谈做产品时的用户定位和用户认知\n\n161:21 时间管理和学习能力只是基础，大佬的三个关键共性是反常识的\n\n169:28 每次新品上市，是创业者情感上最脆弱的时刻\n\n179:40 创始人和企业品牌是否做强绑定的迷思\n\n183:23 找对了合伙人，开会吵架才能吵出好的结果\n\n187:41 李想分享创业二十多年来的至暗时刻，“情节堪比TVB商战剧”\n\n206:10 罗永浩分享为数不多在公众面前真情流露的感性时刻\n\n210:31 理想新推出的 VLA 智能驾驶方案为什么能更像一个“人”\n\n223:59 人工智能发展的五个阶段和未来的发展\n\n227:43 “家”的概念是如何影响到李想的创业历程和产品思维的\n\n232:58 Ending：雷军计划造车时，李想让他All In\n\n欢迎关注：\n\n微博 @罗永浩的十字路口\n\nB站 @罗永浩的十字路口\n\n抖音 @罗永浩的十字路口\n\n小红书 @罗永浩的十字路口\n\n商务合作：\n\n欢迎发送邮件至 jayci_chen@163.com",
            "show_notes_source": "rss_description",
            "show_notes_links": [
              {
                "text": "@罗永浩的十字路口",
                "url": "https://weibo.com/u/7762107285"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://space.bilibili.com/538596213?spm_id_from=333.337.0.0"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.douyin.com/user/MS4wLjABAAAAdYnizw-yHaCBKEeZugZp-kWwLCjvB8GW-iR0I3BdxmkdyKxQkCODEKwzMTvYQgB0?from_tab_name=main"
              },
              {
                "text": "@罗永浩的十字路口",
                "url": "https://www.xiaohongshu.com/user/profile/630fb094000000001200c9f8?xsec_token=ABK3ZzbS_1knRDAWEbDt8_OF_nrL9jX9Ss823dFGgisUY%3D&xsec_source=pc_search&m_source=baidusem"
              },
              {
                "text": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg",
                "url": "https://image.xyzcdn.net/Ft09AwQQv25CahFtWns6XO6zrsue.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5567,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          }
        ]
      },
      {
        "id": "silicon-valley-101",
        "title": "硅谷101",
        "feed_title": "硅谷101",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "AI",
          "科技",
          "商业",
          "创新",
          "硅谷",
          "中文播客"
        ],
        "feed_url": "",
        "source_url": "https://www.xiaoyuzhoufm.com/podcast/5e5c52c9418a84a04625e6cc",
        "detail_path": "/podcasts/silicon-valley-101/",
        "episode_count": 15,
        "selected_episode_count": 15,
        "latest_episode_title": "E238｜聊聊Harness时代AI-First的组织架构：从信任人到信任AI",
        "latest_pub_date": "2026-05-25T00:00:00.000Z",
        "latest_page_url": "https://www.xiaoyuzhoufm.com/episode/6a13923cfe904f3873c51d2b",
        "has_play_count_data": true,
        "episodes": [
          {
            "id": "6a13923cfe904f3873c51d2b",
            "index": 1,
            "title": "E238｜聊聊Harness时代AI-First的组织架构：从信任人到信任AI",
            "pub_date": "2026-05-25T00:00:00.000Z",
            "duration": "3920",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 6,
            "matched_keywords": [
              "AI",
              "Agent",
              "OpenAI",
              "大模型",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a13923cfe904f3873c51d2b",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lqoOCxv382JdiBvm1xMrvaCoMAnn.mp3",
            "play_count": 37502,
            "show_notes_text": "“Harness Engineering”（挽具工程）正在成为硅谷的新共识，Anthropic、OpenAI等公司都在探索这一工程范式。但真正理解Harness的人还不多。前不久，一篇题为《Why Your “AI-First” Strategy Is Probably Wrong》的文章在X上获得百万级阅读和热议，作者是来自硅谷CreaoAI的Peter Pang。在这篇文章里，Peter展示了Harness Agent系统激发出的极致效率：99%的代码由AI完成，每天平均3到8次生产部署，过去六周的产品流程，现在一天就能跑完。\n本期播客，主播泓君邀请到Creao的三位创始人，聊聊这家公司对Harness的实践，以及在组织AI-First转型上的深度思考。嘉宾们指出，AI-First不等于“使用AI”，想要把效率提升100倍、1000倍，就不能只把AI当成工具，而要让AI成为所有生产力的主导。组织转型最难跨出的一步在于——是否能让所有员工都能做到信任AI。\n这场对话中有一些有趣的观察，比如在Creao，市场不用再追着开发提需求，因为开发速度已经远超市场消化能力；当大量对齐工作被AI接管之后，拿掉产品经理，反而让团队效率大幅提升；初级工程师比资深工程师更适应AI时代的转型；尽管过去十年积累的专长正在快速贬值，但资深工程师仍然有竞争力，因为未来的核心竞争力不再是写代码，而是“找到AI Planning的缺陷”和“判断什么是有价值的”。\n\n【主播】\n泓君，硅谷101创始人，播客主理人\n【嘉宾】\nKai，Creao联合创始人/CEO\nPeter，Creao联合创始人/CTO\nClark，Creao联合创始人/CPO，clark@creao.ai\n\n【你将听到】\nAI 主导的效率革命\n02:32 什么是Harness（挽具）？\n03:09 Harness范围远大于prompt/context engineering，榨干大模型能力\n04:52 Harness成败在于，设计好系统自身的feedback loop\n07:11 传统软件静态人主导，Harness动态AI主导迭代\n08:10 一篇X爆文，揭秘CreaoAI的Harness实战\n09:53 AI-first第一步：重构流程，降低对齐成本\n13:19 思维转变：AI不是工具，是所有生产力的AI主导者\n14:01 放弃传统开会讨论，让AI主导对齐，沟通成本大幅降低\n19:12 Agent主导排查bug，50%以上问题由AutoFixing自动修复\n23:48 搭建整个Agent系统，只需要1个Architect用一周定框架\n25:47 Harness观念：AI是动态系统，出错要弥补系统而非简单纠错\n27:13 你的内容和产品，受众可能是Agent\n\nHarness时代的组织转型\n31:09 组织转型挑战：只要有人觉得“不如人做”，改造就会被拉长\n32:02 AI能力已达，CreaoAI 2026年1月用两周完成全部架构重构\n36:00 “2026年我没有写过一行代码”，架构师的价值是找出AI planning的缺陷\n38:22 产品开发超前于市场，市场尚不了解Harness Agent的工作方式\n43:05 大企业难转型的原因：合规问题，人员过多\n\nHarness时代人的价值\n47:47 信任从人转向AI需要guardrails，产品经理角色被拿掉，对齐成本反而更低\n52:00 交流成本＞落地成本，AI环境下复合型人才更重要\n53:21 “资深悖论”：初级工程师更适应AI，资深专家转变难度大\n01:00:30 人类未来最核心的能力和价值：定义需求，review结果\n\n【延伸阅读和相关术语】\n《Why Your “AI-First” Strategy Is Probably Wrong》\n《The Self-Healing Agent Harness》\nCI/CD（持续集成/持续部署），软件开发中的自动化流程。CI（Continuous Integration，持续集成） 指开发者频繁地将代码合并到主干，并自动运行测试，以便尽早发现集成错误。CD（Continuous Delivery/Deployment，持续部署/持续交付） 指通过自动化流水线将通过测试的代码自动发布到生产环境。\nAgent Behavior（智能体行为），指AI Agent在执行任务时的行为模式，包括它如何理解指令、调用工具、做出决策、处理错误等。\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nRadar Focus - Blue Saga\nRumors About Us - T. Morri\nEasily Served - Gerhard Feng\nPoisson d'Avril - Ludvig Moulin\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: Clark Gao, Peter Pang, and 程凯.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "CreaoAI",
                "url": "http://creao.ai/"
              },
              {
                "text": "《Why Your “AI-First” Strategy Is Probably Wrong》",
                "url": "https://x.com/intuitiveml/status/2043545596699750791"
              },
              {
                "text": "《The Self-Healing Agent Harness》",
                "url": "https://x.com/intuitiveml/status/2048912026018484317"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpN",
                "url": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpNQR_oxXw.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 481,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a0e4c4021e40bb435e4a53b",
            "index": 2,
            "title": "E237｜央视和FIFA谈判纷争背后，体育赛事转播权的博弈与生意",
            "pub_date": "2026-05-21T00:00:00.000Z",
            "duration": "3957",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "商业",
              "硅谷"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a0e4c4021e40bb435e4a53b",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lh7KMOUMATlWp0krL9atp8PRl0Ds.mp3",
            "play_count": 33274,
            "show_notes_text": "离美加墨世界杯开赛还有一个月，央视和国际足联FIFA之间的版权谈判终于是谈妥了，本期我们来聊聊世界杯的定价逻辑与体育赛事版权生意的变化脉络。\n\n【主播】\n麻花，硅谷101特约研究员\n\n【嘉宾】\n朱晓东，力赞体育CEO ，本届世界杯日本转播权销售顾问\n张宾，《体育产业独立评论》主理人\n\n【你将听到】\n谈判的虚惊一场，赞助商的从中斡旋\n02:40 价格细节：打包的版权交易里，很少透露单届的价格\n04:25 FIFA的让步，单独售卖的女子世界杯，也被打包进来了\n05:28 联想出面协调，背后动力是什么\n08:31 谈判纷争的惯常套路，最终双方都会让步到促成交易\n09:47 从18年到26年，世界杯的中国赞助商为什么在变少\n12:30 赞助世界杯，到底能给中国企业带来多少好处\n\n世界杯的定价逻辑\n14:41 中国被FIFA设定到版权价格第一梯队，定价逻辑是什么？\n19:00 体育赛事版权谈判的流程、阶段和套路\n21:51 提前一个月转播权还没谈拢，这种情况经常发生\n22:36 从02年到26年，FIFA对央视的版权要价涨了20倍\n25:49 全球体育比赛的版权价格，都被转播方里的新玩家带起来了\n27:30 2022年世界杯，央视入账了50亿\n29:54 转播方能赚多少，在FIFA面前并非秘密\n\n从中国到全球，体育赛事版权生意的变化脉络\n33:14 全球范围内，大转播方的变现能力并没有变强\n35:35 体育版权上亏钱的，可不止乐视体育\n39:29 世界杯的转播权，为什么总是两届打包卖\n41:31 赛事版权在中国，坐过速升速落的过山车\n45:35 十年前中国的版权泡沫，源于不计成本的恶性竞争\n49:30 对比国外版权市场，中国的同行打得太凶了\n51:42 健康的版权生意，关键是要“量KPI为出”\n53:09 中国版权生意难做，稳赚不赔的可能只有世界杯和奥运会\n55:05 NFL、NBA和F1，为什么顶级赛事的版权都在疯涨\n59:00 抖音和快手，正在尝试边解说比赛边直播带货\n01:02:22 赛事版权的长期受益者，可能是优质IP持有方和去中心化的流量平台\n\n【延伸阅读和相关术语】\n央视签约世界杯背后：FIFA让了步，联想是关键协调者\n世界杯版权，即将迎来转机？\n咪咕：中国移动旗下的数字内容平台，旗下拥有中超、英超、法甲、WTT、UFC的独家版权，并拥有NBA、亚洲杯、汤尤杯等赛事的转播权。\n电通：深度介入体育产业的日本广告营销公司，在体育版权中扮演“超级代理商”的角色，拥有世界杯、奥运会等诸多体育赛事在日本和部分亚洲国家的代理资源。\nDAZN：总部位于英国的体育流媒体巨头，由Access Industries和Perform Group于2016年推出，资本雄厚，业务覆盖超过200个国家和地区，是全球体育版权市场最大的买家之一，被称为“体育界的Netflix”。\nWTT：世界乒乓球职业大联盟，由国际乒联于2019年创立，旨在推动乒乓球职业化与商业化，由运营大满贯、冠军赛等全新赛事体系。\n中国体育赛事版权泡沫：2015年前后，资本疯狂涌入体育产业，其中乐视体育花两年27亿购入中超新媒体版权，PP体育花3年7.2亿美元获得英超版权。随着乐视资金链断裂，以及中国付费习惯未养成、盗播泛滥等问题，体育赛事版权价格在中国回归理性。\nPP体育：前身是视频网站PPTV，2013年被苏宁收购，曾是中国最早的互联网体育直播平台之一，巅峰时期手握英超、欧冠、意甲等50多项赛事的版权，但在20-21年间已因无力支付版权费而被逐一放弃。\n新英体育：中国最早的体育版权巨头之一，2010-19赛季长期拥有英超在中国内地独家转播权，并于2013年在中国首推付费观赛模式，2018年与爱奇艺成立合资公司新爱体育。\nLeague Pass：NBA官方推出的全球性赛事流媒体订阅服务，支持多场比赛同屏观看、比赛中实时叠加球员数据等，除了赛事直播，还提供7x24小时的NBA TV的节目，比如赛事分析和采访等。\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nKick Off - Earle Belo\nIn a Minute - John Runefelt\nRumors About Us - T. Morri\nAll Parts Equal - Airae\nBurn Away - Nyck Caution\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: 张宾 and 朱晓东.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "央视签约世界杯背后：FIFA让了步，联想是关键协调者",
                "url": "https://mp.weixin.qq.com/s/PXe4Mmxrq9UJzA9L8XrMtQ"
              },
              {
                "text": "世界杯版权，即将迎来转机？",
                "url": "https://mp.weixin.qq.com/s/S-Rkwmq2o5-pxZsunIcPLA"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1229,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a0663649ea0a02f5ed5182e",
            "index": 3,
            "title": "E236｜99%的作业都是AI写的：当代名校生眼里，大学还剩下什么？",
            "pub_date": "2026-05-15T00:00:00.000Z",
            "duration": "4895",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "大模型",
              "硅谷"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a0663649ea0a02f5ed5182e",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/liD30i-jo6S1D6PDX_CmZbVhP15P.mp3",
            "play_count": 67452,
            "show_notes_text": "人类历史上第一批和生成式AI同时长大的学生，正在踏入毕业季。\n去年我们和大学生聊AI时，讨论还集中在“要不要使用AI”、“教授怎么看”。然而仅一年后，AI真正成为了生产力工具。这届毕业生可能会发现：不管你学的是知识性课程，还是实用性技能，都难逃AI冲击，想要脱颖而出必须成为那个“更善于使用AI的人”。\n当知识可以被AI调取，技能可以被工具取代，大学还能给你什么独一无二的东西？面对AI冲击，有哪些能力是不会被时代洗牌的“元能力”？\n本期播客，我们邀请三位刚刚走出校园的名校毕业生——Alfred、Kolento、Jack，一起聊聊他们在教育标准化的大学里，如何用AI实现高度个性化的学习；从哪里汲取思想的养分，最看重的能力又是什么；站在毕业的关口，他们如何评估大学的价值，面对未来又做出了怎样的选择。\n这也是一份送给所有大学生“自救指南”，那些AI取代不了的能力，才是教育留给我们的真正底气。\n\n【主播】\n泓君，硅谷101创始人，播客主理人\n\n【嘉宾】\n林桐宇 (Alfred)，清华大学法学（国际）2026届\n侯泰羽 (Kolento)，纽约大学应用心理学2026届\n饶杰武 (Jack)，哥伦比亚大学管理科学与工程研究生2026届，Emergences Labs 创始人兼CTO\n\n【你将听到】\nAlfred\n03:28 刚上大学就有了ChatGPT，预感打不过开始辅修AI\n09:40 AI速通法律专业课：模拟教授出题，拿下4.0满绩\n12:15 大学老师对AI态度发生转变，评估体系亟待升级\n13:43 大学两大价值——认识自己 + 获得技能；后者被AI侵蚀\n15:49 记忆类知识会过时，批判性思维和素养课程更值得投入\n20:11 清华最重要的财富：同侪的深度交流、老师的解惑\n\nKolento\n23:05 马斯克说对了，我上大学最重要的目的就是社交\n26:30 学历不再是知识的证明，但仍是社会信任的重要凭证\n28:35 追寻美德、向往真理，才能更好地驾驭AI技术\n29:55 用AI在大学期间大量试错，而不是对中长期目标做死板的预设\n32:32 AI可以做出决策（deciding），但只有人能做出选择（choosing）\n36:38 “自顶向下”学习法：先见证最高水平的卓越，再提问、理解、验证\n\nJack\n39:23 99%作业由AI参与，已经想不到任何没有AI参与的作业了\n43:14 翻书不会把我变成一个更好学生，只是在浪费我的时间\n44:44 当大家都用AI做作业，真正PK的还是每个人的理解和判断\n\n进化的AI工具\n46:19 最近常用AI工具盘点\n52:05 哪些AI工具正在被抛弃？首当其冲：ChatGPT\n58:12 适当关闭memory，避免模型被记忆污染形成信息茧房\n\n元认知积累与AI上瘾\n01:01:00 设计师的审美，程序员对代码的感觉，仍然不可替代\n01:04:10 AI比短视频更上瘾，失去AI就失去了执行力和灵感来源\n01:05:51 完全抽离AI我们还能做什么？还能回到手写代码吗？\n01:12:20 用AI的资深工程师反而慢了19%，初学者在AI时代可能反成优势\n01:16:33 2026最迷茫就业季，这一代毕业生就业向何处去\n01:19:40 硅谷高中生反驳主播：为什么要假设，我们不会离开AI了\n\n【本期节目中提到的AI工具】\nVariant：输入一句话需求，几秒内生成数十套高保真网页与APP设计方案的AI设计工具。\nTypeless：像真人一样自然说话，自动转化为润色后可直接发送的清晰文本的AI语音听写工具。\nDify：一个开源平台，让你能通过拖拽等可视化方式，快速构建和部署基于大模型的AI应用。\nRaycast：用键盘统一控制整个电脑、快速启动应用与各类服务的Mac效率中枢。\nSuno：支持上传个人声音克隆，一键生成包含人声与配器的完整原创歌曲的AI音乐创作平台。\nGemini Dynamic View：谷歌Gemini根据你的自然语言提示，实时生成可交互3D模型和定制UI界面的动态可视化功能。\nMercury 2：基于扩散架构每秒可生成超过1000个Token，比主流模型快5到10倍的极速推理大语言模型。\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nBetween Moments - Amber Glow\nCall Waiting - Future Joust\nPulse Runner - Helmut Schenker\nFirst Flakes - Philip Ayers\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: Kolento, 林桐宇, and 饶杰武.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "去年我们和大学生聊AI时",
                "url": "https://www.xiaoyuzhoufm.com/episode/677c6f32d6168725739c9dc8"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpN",
                "url": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpNQR_oxXw.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1330,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69fe7a01140504ded81abb90",
            "index": 4,
            "title": "E235｜20年内CAR-T治愈癌症？与刘诚博士聊聊癌症治疗的底层哲学",
            "pub_date": "2026-05-09T00:00:00.000Z",
            "duration": "4205",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "商业",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69fe7a01140504ded81abb90",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/loK2tSrexyv7p-G_-NG4rge9hbiL.mp3",
            "play_count": 36536,
            "show_notes_text": "近年来，癌症治疗正迎来多个技术平台并行演进、加速迭代的新阶段：从ADC、双特异性抗体、放射性配体疗法，到细胞治疗，整个行业都在经历一轮底层技术工具的升级。其中，CAR-T是最具范式转换意义的一类疗法——它首次在部分血液肿瘤中，把“利用工程化改造的免疫细胞精准清除癌细胞”带入了临床现实。更值得关注的是，2025年以来，跨国药企的押注明显转向体内CAR-T：阿斯利康、艾伯维、百时美施贵宝和礼来等公司，先后收购了仍处于临床前或早期临床阶段的相关企业；其中金额最大的一笔，是礼来于2026年4月20日宣布收购Kelonia，交易总额最高达70亿美元。\n为什么大药企会在这个时点密集下注？CAR-T到底是一种什么样的治疗方式？它会成为改写癌症治疗格局的关键武器吗？本期节目，我们有幸邀请到深耕CAR-T与细胞治疗领域二十多年、也是体外CAR-T领域专利布局最丰富的亚裔科学家之一的刘诚博士，和我们一起回顾CAR-T与癌症治疗的发展脉络，拆解这项技术的突破、局限与未来。节目最后，刘诚博士还从更大的视角谈到了癌症本身以及癌症治疗的底层逻辑，或许也会帮助我们重新理解这种疾病。\n\n【主播】\nYushan，硅谷101特约研究员，生物医药行业从业者\n泓君，硅谷101创始人，播客主理人\n\n【嘉宾】\n刘诚，美国Eureka Therapeutics创始人兼CEO，Estrella Immunopharma（Nasdaq上市公司）创始人兼CEO，JW Therapeutics（药明巨诺，香港上市公司）董事会主席\n\n【你将听到】\n02:48 CAR-T（嵌合抗原受体T细胞疗法）：用患者自己的免疫细胞治疗自身癌症，这个观念本身就是一场革命\n05:56 CAR-T像一艘军舰：嵌合抗原受体像导航系统，用来寻找癌细胞表面的靶点蛋白（抗原）\n06:45 体外CAR-T的制作过程高度个性化，因此治疗成本很高\n10:38 CAR-T的疗效相比传统癌症疗法强在哪里\n13:33 体外自体CAR-T的常规制备接近一个月，快速制备技术FasTCAR可将时间加快一周左右\n14:30 异体CAR-T：利用供体免疫细胞缩短治疗时间，但过去几年整体疗效表现有限\n17:19 体内CAR-T：仍然利用自体免疫细胞治病，但细胞改造过程在患者体内完成\n18:19 体内CAR-T在概念上很理想，但技术实现非常复杂\n21:35 CAR-T的现实挑战：目前仍主要对于血液肿瘤有效\n22:55 体外CAR-T制备成本约15万美元；体内CAR-T有望将成本降低约10倍；中国制造成本大约是美国的40%\n25:48 为什么CAR-T治疗实体瘤更难\n30:17 肿瘤微环境和免疫抑制的存在，进一步限制了免疫细胞治疗实体瘤\n32:01 诺奖得主Jennifer Doudna参与创立的Azalea：希望通过CRISPR技术提升体内CAR-T的一致性与可靠性\n34:07 人体免疫系统为什么会有免疫抑制功能\n38:42 CAR-T诞生之初主要用于末线肿瘤；随着疗效逐步验证，开始进入更前线、惠及更多患者\n41:26 CAR-T的关键价值在于一部分患者能够获得长期缓解；如何解决其余复发患者的问题，是当前研究重点\n43:04 脱靶效应和髓外肿瘤，被认为是CAR-T治疗后复发的可能根源\n44:07 细胞因子风暴等不良反应，限制了CAR-T的应用和推广\n48:12 为什么中国在CAR-T领域走在全球前列：研发基础、监管环境、患者资源与医疗体系效率\n53:29 体内CAR-T更偏工程应用范畴；在这类技术的追赶和产业化上，中国具备明显优势\n54:58 CAR-T在国内存在两条监管路径：药品审批和医疗技术管理并存\n58:36 如何理解人体细胞之间的分工与协作\n59:26 如何理解癌细胞在人体内是一种怎样的存在\n1:02:03 癌症治疗的基本思路，是尽可能有效地区分并杀死癌细胞\n1:02:24 如何理解癌症的不同疗法与治疗思路\n1:04:39 为什么CAR-T可能是治疗癌症最强的武器之一\n1:06:07 CAR-T的未来发展方向：从血液瘤扩展到实体瘤\n1:06:32 体外CAR-T的优势是可控性和质量；体内CAR-T试图解决的是成本和商业化问题，未来更可能是并存而不是替代\n1:07:47 癌症可以被治愈吗？刘诚博士的判断：“最多20年”\n1:08:39 如何定义“治愈”：不要死于癌症\n\n【相关名词解释】\nT细胞：免疫系统中负责识别并清除异常细胞的一类白细胞\nCAR-T：把T细胞工程化改造后，用来更精准识别和杀伤癌细胞的细胞疗法\n体外CAR-T：把患者的T细胞取出，在体外完成改造后再回输体内\n免疫原性：一种物质引发人体免疫反应的能力\n基因编辑：对细胞DNA进行定点修改的技术\n抗体：能特异性识别某个目标分子的免疫蛋白\n抗原：能被免疫系统识别的分子标记\n靶点：药物或免疫细胞作用的具体分子目标\n嵌合受体：人工设计的受体，把不同功能模块拼接在一起，用来让细胞识别特定目标\nLeukapheresis：通过机器从血液中分离并采集白细胞的过程\nCD19：B细胞表面常见的一种蛋白，也是多种CAR-T疗法的重要靶点\nALL：急性淋巴细胞白血病，一类进展较快的血液系统恶性肿瘤\nQA/QC：质量保证与质量控制，用来确保产品生产过程和最终质量符合标准\nFasTCAR：一种加快CAR-T制备流程的技术平台，目标是缩短生产时间\n异体CAR-T（allogeneic CAR-T）：使用供体而非患者本人来源的T细胞制备的CAR-T\n自体CAR-T（autologous CAR-T）：使用患者本人T细胞制备的CAR-T\nGVHD：移植物抗宿主病，指移植来的免疫细胞反过来攻击患者自身组织\n慢病毒：一类常用于基因递送的病毒载体，可把目的基因导入细胞\n载体：把基因编辑工具或治疗性基因送入细胞的递送工具\nComplete response：完全缓解，指经过治疗后已检测不到明确的肿瘤证据\n血液瘤/实体瘤：血液瘤发生在血液、骨髓或淋巴系统；实体瘤是在器官或组织中形成肿块的肿瘤\n浸润：肿瘤细胞或免疫细胞进入并扩散到周围组织的过程\n肿瘤微环境：肿瘤周围由免疫细胞、血管、基质和信号分子共同构成的局部生态系统\n免疫抑制：免疫系统的攻击能力被压低，导致其更难清除癌细胞或病原体\nCRISPR：一种可对DNA进行定点剪切和修改的基因编辑工具\n去分化：细胞失去原有成熟特征，变得更像早期或更原始状态的过程\nTreg：调节性T细胞，主要作用是抑制过强的免疫反应、维持免疫平衡\n一线/末线治疗：一线是首选初始治疗；末线是前面多种方案失败后使用的后续治疗\nPFS / EFS：PFS是无进展生存期，指疾病未恶化的时间；EFS是无事件生存期，除进展外还会把复发、治疗失败或死亡等算作事件\n髓外肿瘤：发生在骨髓外部组织或器官的血液系统肿瘤病灶\nCRS：细胞因子释放综合征，是免疫治疗后因炎症因子大量释放引起的全身炎症反应\nICANS：免疫效应细胞相关神经毒性综合征，是CAR-T等治疗后出现的神经系统不良反应\nCDE：国家药品监督管理局药品审评中心，负责药品注册申请的技术审评\nIIT：研究者发起的临床试验，由医院或研究者主导开展\n818号令：中国国务院发布的《生物医学新技术临床研究和临床转化应用管理条例》，自2026年5月1日起施行，是针对细胞治疗、基因编辑等前沿生物医学技术的重要监管规则\nCarl June：美国宾夕法尼亚大学的肿瘤学家和科学家，被广泛视为CAR-T疗法的先驱人物之一\n小分子：一类分子量较小、通常可进入细胞内部发挥作用的药物\nADC：抗体偶联药物，用抗体把细胞毒药物更精准地送到肿瘤细胞\nToxin：毒素，在ADC等药物中通常指用于杀伤细胞的细胞毒载荷\n伽马刀：利用高剂量聚焦射线精准破坏病灶的放射治疗设备，并不是真正的“刀”\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nThe Vindicator Waltz - FormantX\nPulse Runner - Helmut Schenker\nMy Moon and Your Sun - Hampus Naeselius\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guest: 刘诚.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpN",
                "url": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpNQR_oxXw.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 916,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69e8652f7992995028a2855d",
            "index": 5,
            "title": "E234｜未来实拍电影还存在吗？与导演陆川聊聊AI给影视人的恐惧与自由",
            "pub_date": "2026-04-22T06:00:00.000Z",
            "duration": "2416",
            "duration_label": "40m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "硅谷"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69e8652f7992995028a2855d",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/ljA6Fc3v27ybIgcTglTFd90gcUB0.mp3",
            "play_count": 40623,
            "show_notes_text": "最近，《灵魂摆渡·浮生梦》成为中国首部全AI生成的电影，暑期档即将上映。“AI能否替代真人演员”、“真人短剧是不是在被AI团灭”，这些话题最近都在冲上微博热搜，成为大家讨论的焦点。\n人工智能正以惊人的速度渗透进影视工业的核心流程。从剧本开发到视觉预览，从角色建模到声音演绎，AI 带来的效率提升令人震惊。这场变革不仅是技术迭代，更是创作哲学的重构。AI把传统影视制作中长达六个月的特效前期流程，压缩到了72小时；让个体创作者拥有了前所未有的表达自由，却也在审美趋同、情感缺失与版权争议中暴露出局限。\n本期《硅谷101》播客邀请导演陆川、配音演员黄莺与AI内容创作者KiSA深入探讨：AI正在如何重塑影视创作生态，而人类艺术家的价值又将在何处闪光。我们从AI工具的效率神话聊到创作的不可复制性，看看这场技术浪潮，到底是解放了创作者，还是在矮化真正的艺术表达。\n\n【主播】\n泓君，硅谷101创始人，播客主理人\n【嘉宾】\n陆川，中国著名导演，中国AIAIA联盟主席，红树林AI电影周创始主席\n黄莺，国家一级演员，上海电影译制厂有限公司译制导演，配音代表作：《哈利波特》赫敏、《盗梦空间》梅尔等\nKiSA，编剧、策展人，故事接龙StoryStorm AI影视社区发起人\n\n【你将听到】\nAI目前能做出什么样的电影？\n00:56 AI视频工具因涉嫌系统性侵权遭到好莱坞的集体声讨，引发关于AI是否威胁影视从业者生计的广泛讨论\n04:28 传统影视困境：IP开发周期长、成本高、返工常态化\n06:03 AI创作初体验：48小时完成短片，创作门槛被彻底打破\n07:36 陆川：传统视效流程长达6个月，AI将效率提升近100倍\n11:48 陆川讲AI创作痛点：人物形象同质化，模型审美被大众数据绑架\n14:24 陆川认为专业影视创作需要专属工具与统一工作流\n16:35 陆川认为AI只是工具，电影的价值仍要回归作品本身\n20:21 配音演员黄莺讲AI无法复刻人类下意识、情感与表演逻辑\n\nAI 时代的版权和维权困境\n25:59 声音的边界：AI克隆、版权侵权与行业维权困境\n27:31 声音权利：声音与肖像权同等重要，未经授权属于侵权\n\nAI 不可替代的是什么？\n29:36 陆川动情讲述《南京！南京！》拍摄现场，AI无法替代的创作瞬间\n32:18 陆川认为未来AI会成为一把尺，实拍将成为顶级奢侈创作\n37:02 创作者的底气：AI让每一个想法都有机会被拍成电影\n38:31 陆川对给年轻创作者的建议：电影学院的现场体验无法被AI替代\n\n【延伸阅读和相关术语】\nE164｜当电影遇上AI：与好莱坞特效美术聊聊他们和新工具的博弈\nE110 | 好莱坞编剧罢工：AI冲击波与编剧们的生存危机\nMidjourney：全球主流 AI 图像生成工具，可根据文字提示快速生成高精度图片，广泛用于影视概念设计、分镜与场景可视化。\nStory board artist（分镜师）：影视制作核心岗位，负责将剧本、导演创意绘制成连续静态画面，确定镜头、构图与叙事节奏，是拍摄与后期的执行蓝图。\nMotion board（动态分镜）：在静态分镜基础上加入简单运动、转场与节奏，形成初步动态预览，用于快速验证镜头逻辑与叙事流畅度。\n\n【监制】\n泓君\n【采访 & 制作】\n静远\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nWaiting in Vain - Kikoru\nThe Connection - Lennon Hutton\nPoisson d'Avril - Ludvig Moulin\nOh Please - Gerhard Feng\nOpen Road - Lennon Hutton\nThe Big Truth - August Wilhelmsson\nCassette Party - Automatic Bananas\nCharcoal Stream - Curved Mirror\nElan - Jakob Ahlbom\nDeep meaning - Timur Haisyn\nDeep motivation - Abstract solar\nHidden Place - Finval\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: KiSA, 陆川, and 黄莺.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "E164｜当电影遇上AI：与好莱坞特效美术聊聊他们和新工具的博弈",
                "url": "https://www.xiaoyuzhoufm.com/episode/66c681061b12cc3a6e3893a8"
              },
              {
                "text": "E110 | 好莱坞编剧罢工：AI冲击波与编剧们的生存危机",
                "url": "https://www.xiaoyuzhoufm.com/episode/646d561ef8a54aa2943fe4a1"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpN",
                "url": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpNQR_oxXw.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 460,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69e1793c1c446d3a0f943495",
            "index": 6,
            "title": "E233｜硅谷右翼的权力网如何形成？聊聊彼得·蒂尔的思想启蒙拼图",
            "pub_date": "2026-04-17T00:00:00.000Z",
            "duration": "2972",
            "duration_label": "49m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 5,
            "matched_keywords": [
              "AI",
              "商业",
              "科技",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69e1793c1c446d3a0f943495",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lkO3DxS-93Qk-thrONBhF2_lvul0.mp3",
            "play_count": 46213,
            "show_notes_text": "Peter Thiel，是硅谷最具争议和影响力的思想家之一。如果要用一句话概括他的思想，那就是：世界是由少数天选之人在幕后驱动的，而他就是其中之一。这套理论，不仅在以他为核心的“硅谷右翼”圈子中产生了影响，还通过Peter Thiel的政治参与，影响了更多的人。\n那么，Peter Thiel的思想，又来源于什么呢？要理解他，答案藏在三位哲学家身上：法国文学批评理论家吉拉尔、纳粹党员法学家施密特、和政治哲学家施特劳斯。这三层哲学，解释了Peter Thiel的种种选择：创立Palantir、投资早期Facebook、扶持JD Vance，以及为什么他自己永远不参加竞选。\n这期播客，我们从1987年的斯坦福校园里的一本学生杂志聊起，谈谈Peter Thiel这套几乎从未改变的世界观如何影响了他自己，又如何影响了他身边的科技网络。\n\n【主播】\nYiwen，硅谷101特约研究员\n\n【嘉宾】\n房天语，哈佛大学科技史专业博士生、自由撰稿人\n李狄皓，硅谷101特约研究员\n\n【你将听到】\n从《斯坦福评论》到硅谷右翼\n02:14 保守派学生报纸《斯坦福评论》的创立\n04:22 Allan Bloom与《美国精神的封闭》：校园文化战的思想来源\n06:29 欧林基金会：军火大亨出钱，赞助全美100多个右派学生媒体\n08:16 《斯坦福评论》的风格：挑衅、点名、制造争议\n\n影响Peter Thiel的三名哲学家\n10:36 吉拉尔的模仿理论\n12:08 PayPal的诞生和与马斯克公司的合并\n13:12 投资Facebook：社交网络是最完美的模仿性增长机器\n16:12 卡尔·施密特：自由主义掩盖了敌我关系\n17:40 Palantir的哲学起点：危机时刻可以绕过民主程序\n20:40 施特劳斯：真正的哲学只写给少数天选之人\n\n权力网络：从校园到白宫\n23:44 斯坦福评论的校友们今天在哪里\n27:35 David Horowitz：从极左到极右，Thiel的策略导师\n35:56 Thiel的媒体布局：海盗通讯、美国伟大、Pladium\n37:12 海盗通讯的两篇出圈报道：弹劾旧金山检察官、揭露维基百科左倾\n40:21 美国伟大：落魄商人如何成为特朗普最重要的媒体声音\n41:32 岩桥网络与1789资本：Thiel和Vance联手构建右派政治动员体系\n\n造王者与他的门生\n43:38 网红经济时代，影响力就是上桌的筹码\n45:52 Thiel与Vance的相遇：一场耶鲁法学院的演讲改变了两人的轨迹\n46:23 从\"逃离政治\"到\"造王者\"：Thiel的思想转变\n\n【延伸阅读和相关术语】\n《作为思想家的彼得·蒂尔如何被Web3影响，又如何背叛Web3》\n《DEI的风暴眼：常春藤、硅谷与被改写的“美国梦”》\n\nPeter Thiel（彼得·蒂尔） PayPal联合创始人、Palantir创始人、Founders Fund创始合伙人。斯坦福哲学系本科出身，耶鲁法学院法学博士。硅谷右翼的精神教父，长期在幕后资助保守派媒体、政治人物和思想网络。\nNorman Book Thiel在斯坦福的同学，《斯坦福评论》联合创始人。\nKeith Rabois（基思·拉博瓦） 斯坦福评论早期参与者，现为硅谷著名风险投资人。因在宿舍发表挑衅性言论引发校园争议，是蒂尔早期圈子中以挑衅著称的代表人物。\nAllan Bloom（艾伦·布鲁姆） 美国学者，著有《美国精神的封闭》（The Closing of the American Mind，1987），批评大学教育放弃了严肃的西方思想传统。斯坦福评论的重要思想来源之一。\nJohn Olin（约翰·欧林） 欧林基金会创始人，军火大亨（M1卡宾枪制造商），二战老兵，为包括斯坦福评论在内的百余家保守派学生媒体提供资金支持。\nJD Vance（JD·万斯） 现任美国副总统。耶鲁法学院毕业，曾任风险投资人，著有回忆录《乡下人的悲歌》（Hillbilly Elegy）。被视为Peter Thiel最重要的政治投资之一，Thiel在其俄亥俄州参议员竞选中投入约1500万美元。\nRené Girard（勒内·吉拉尔） 法国文学批评理论家，长期在斯坦福执教。提出\"模仿理论\"（Mimetic Theory），对Thiel的商业哲学影响深远。\nCarl Schmitt（卡尔·施密特） 德国法学家，纳粹党员。其“敌我理论”与“例外状态”（State of Exception）理论是Thiel创立Palantir的重要思想来源。\nAlex Karp Palantir CEO，法学院出身的文科生，由Thiel引入担任CEO。\nLeo Strauss（利奥·施特劳斯） 德裔犹太哲学家，移民美国后长期执教芝加哥大学。主张哲学家应将真正的思想隐藏在文字的\"深层含义\"中，只对少数人开放。Thiel自认施特劳斯主义者，并以此为由构建其幕后政治网络。\nDavid Horowitz（大卫·霍洛维茨） 从极左到极右的转变人物。早年曾是左翼知识分子、《城墙》杂志联合主编；后转向右派，为小布什竞选提供策略支持。与Thiel在欧林基金会研讨会相识，据称教导Thiel要主动挑衅、用左派方法打败左派。\nDavid Sacks（大卫·萨克斯） 《多样性神话》合著者，斯坦福评论重要参与者。现为川普内阁的AI与加密货币政策顾问。\nJoe Lonsdale（乔·隆斯代尔） Palantir联合创始人，8VC创始合伙人，曾创立智库西塞罗学院（Cicero Institute）。\nStephen Cohen（史蒂芬·科恩） Palantir联合创始人，8周内开发出Palantir第一个产品原型，现任 Palantir 总裁。\nJosh Hawley（乔什·霍利） 美国共和党参议员（密苏里州），曾在斯坦福评论担任编辑。\nMichael Anton（迈克尔·安顿） 施特劳斯主义者，川普内阁政策规划主任。2016年以笔名发表著名文章《Flight 93 Election》（93号航班的选举），以劫机隐喻呼吁保守派支持川普，被认为是Thiel圈子内的重要思想动员文件。\nMike Solana（迈克·索拉纳） 《海盗通讯》（Pirate Wires）创始人，Founders Fund员工。曾协助Thiel出版《从0到1》，长期担任Founders Fund的品牌与公关工作。\nChris Buskirk 《美国伟大》（American Greatness）创始人，早期获Thiel资助，与万斯共同创立Rockbridge Network。\nElizabeth Genovese（伊丽莎白·吉诺维斯） 女性研究学者先驱，埃默里大学教授，早年马克思主义者，后皈依天主教转向保守派，为Thiel的《多样性神话》作序。著有《女权主义不是我的人生故事》。\nPatri Friedman（帕特里·弗里德曼） 经济学家弥尔顿·弗里德曼之孙，海上家园研究所（Seasteading Institute）联合创始人，获Thiel资助。\nCarlos Ghosn（卡洛斯·戈恩） 日产雷诺前CEO，因财务丑闻在日本被捕，保释期间藏身大提琴箱逃亡。其子Anthony Ghosn曾任斯坦福评论总编辑。\n\n哲学理论和概念：\n模仿理论（Mimetic Theory） René Girard提出。核心观点：人类没有自发的欲望，所有欲望都是对他人欲望的模仿。模仿导致竞争，竞争导致冲突与暴力。Thiel据此发展出\"逃离竞争、追求垄断\"的商业哲学，也用此理论解释Facebook的社交增长逻辑。\n敌我理论（Friend-Enemy Distinction） Carl Schmitt提出。认为自由主义掩盖了真实的政治关系，政治的本质在于划定朋友与敌人的界限。Thiel以此批评后冷战自由主义对伊斯兰世界威胁的误判，认为911正是自由主义失败的明证。\n例外状态（State of Exception） Carl Schmitt理论核心之一。\"主权者是决定例外状态的人。\"在紧急状态下，正常的民主与法律程序可以被绕过。Thiel以此为Palantir建立监控与数据分析能力提供哲学依据。\n隐微写作（Esotericism） Leo Strauss的方法论。主张哲学文本有字面含义与隐藏含义两层，真正的思想只对少数\"天选之人\"开放。Thiel以此为由构建\"深层国家\"（Deep State）式的幕后政治操作网络。\n施特劳斯时刻（The Straussian Moment） Thiel于911后撰写的重要论文标题，以施特劳斯和施密特的视角分析恐怖袭击对西方自由主义的冲击，是理解Thiel政治哲学转型的关键文本。\n自由意志主义（Libertarianism） 主张最小政府、反对税收与政府管控的政治哲学。Thiel早期自称坚定的自由意志主义者，海上家园计划是其极端实践。进入政治后，他的立场逐渐从“逃离政治”转向“参与政治夺权”。\n文化战（Culture War） 美国保守派与进步派围绕文化、教育、性别、种族等议题的长期对抗。1980年代为“第一次文化战”，当时的核心争论是是否应在大学保留西方经典课程；近年为“第二次文化战”，核心争论为DEI、性别认同等议题。\nFlight 93 Election（93号航班的选举） Michael Anton以笔名发表的著名文章（2016），以911劫机事件为隐喻，主张2016年大选对保守派而言是\"要么冲进驾驶舱（支持川普），要么等死\"的生死抉择，在Thiel圈子内广泛流传，被视为保守派知识界支持川普的重要思想节点。\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nWarped by Light - Jay Varton\nAshbound Oath - Ruiqi Zhao\nEstimations - Christoffer Moe Ditlevsen\n【图片来源】\nGage Skidmore / Peter Thiel，基于CC BY-SA 2.0协议使用，原图已用于播客封面二次裁剪，协议链接：creativecommons.org\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: 房天语 and 李狄皓.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "《作为思想家的彼得·蒂尔如何被Web3影响，又如何背叛Web3》",
                "url": "https://www.xiaoyuzhoufm.com/episode/696d76278ecc42efe7c274b5"
              },
              {
                "text": "《DEI的风暴眼：常春藤、硅谷与被改写的“美国梦”》",
                "url": "https://www.xiaoyuzhoufm.com/episode/680ac9ff777ec593815e17ec"
              },
              {
                "text": "creativecommons.org",
                "url": "https://creativecommons.org/licenses/by-sa/2.0/"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpN",
                "url": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpNQR_oxXw.jpg"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/cfce-audiofreehighqps/42/7D/GKwRIUENt1QWAAtCE",
                "url": "https://imagev2.xmcdn.com/storages/cfce-audiofreehighqps/42/7D/GKwRIUENt1QWAAtCEwSLe0gm.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 641,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69d83d8ff6e591a7ac54d0d2",
            "index": 7,
            "title": "E232｜餐饮出海有新招儿吗？从鼎泰丰与贡茶拿下美国初代销冠聊起",
            "pub_date": "2026-04-10T00:00:00.000Z",
            "duration": "3996",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 5,
            "matched_keywords": [
              "AI",
              "商业",
              "创新",
              "硅谷",
              "出海"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69d83d8ff6e591a7ac54d0d2",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lk7iiYQUMeaBz9NV_bX1tcw3DwG1.mp3",
            "play_count": 37125,
            "show_notes_text": "2025年，中国餐饮品牌开启了声势浩大的出海美国。喜茶在纽约开出了更具辨识度的LAB店，霸王茶姬、瑞幸和蜜雪冰城也在这一年正式登陆美国。\n但要问目前在美国做得最好的中餐和茶饮品牌，答案可能会出乎你意料——中餐第一是一度退出中国华北市场的鼎泰丰，茶饮标杆则是早在内地销声匿迹的贡茶。\n究其原因，餐饮企业想顺利出海美国，不仅需要足够的“做时间的朋友”的耐心，需要对当地商业规则足够了解，更要吃透当地主流人群的生活习惯和饮食需求。想要更运筹帷幄，还得和本国的文化输出打好配合。\n这期播客，我们邀请到了北美吃货传媒的三位嘉宾，我们一起聊了聊，那些在媒体高频关注的企业之外的、餐食茶饮闯美国的好生意和坏生意。\n\n【主播】\n麻花，硅谷101特约研究员\n【嘉宾】\nAmy Duan，北美吃货传媒公司创始人，专注中餐出海、北美餐饮孵化落地投资\nCosmo Hu，北美餐饮食品行业协会发起人、TOA中美餐饮大会执行主席、易升资本联合创始人\nYuxuan Xiao (Henry)，AC Marketing营销传播公司CEO\n\n【你将听到】\n美国中餐茶饮的初代销冠是怎么练成的\n02:57 鼎泰丰的出海史：标准化、单店打磨、品类优势和本地化\n11:08 贡茶的秘密：利用资本优势抢占点位红利\n15:20 寻找“二代店”，应对美国点位区域保护的好方式\n19:19 餐饮立足北美，要卖的是体验而不是口味\n23:11 国粹麻辣烫，可能不算出海美国的好品类\n25:33 费大厨在美国改了招牌菜，这算好招还是坏招\n\n文化输出，怎么和餐饮出海打配合\n29:18 必品阁和辛拉面，绑定Kpop做出海\n31:40 日本所有主要动漫里，都有它们想出海的食物\n32:53 霸榜美国速冻饺子，必品阁的渠道收购和本地化洞察\n35:08 泰餐在美的突飞猛进，政府连厨师的英语都培训了\n37:07 中餐出海，暂时还难以匹配更合适的文化输出\n38:07 太执着于自我表达和地域自豪，反而容易“帮倒忙”\n43:32 海底捞和喜茶：结合中国文化做出海的好案例\n\n内卷致胜的中国品牌，能把“卷”复制到美国吗\n45:53 目标别太激进，出海美国注定是门慢生意\n47:26 在美国，雇主是乙方，员工才是甲方\n51:26 海底捞：卷不了服务，就卷体验的稀缺性\n52:47 卷创新和噱头很难，因为美国人没那么爱追新\n55:20 茉莉奶白：用“轻中式”拿下泛亚裔人群\n58:26 霸王茶姬：视觉上做减法，时尚上做加法\n01:00:00 中小品牌的机会：没有总部强束缚，反而更好发挥\n01:01:39 华莱士 vs Jollibee：亚洲炸鸡去美国可不能主打性价比\n\n【延伸阅读和相关术语】\nBrothers Plan Din Tai Fung ExpansionAmerica’s Most Successful Restaurant Chain Feeds a Dumpling Frenzy\n“新茶饮祖师爷”要被卖了，估值140亿元\n中国新茶饮品牌在美国的出海趋势与区域分布洞察\n熊猫快餐（Panda Express）：1983年创立于美国，主打美式中餐，总门店数2500+，门店覆盖全球12个国家及美国49个州，为全球规模最大的中式快餐连锁品牌。\n快可立（Quickly），珍珠奶茶品牌，1996年创立于中国台湾，门店遍布日本、韩国、泰国、菲律宾、新加坡、美国、加拿大等地。\nChipotle：1993年创立，主打墨西哥卷饼、碗餐等，年营收约113亿美元，门店超3700家，现为全球市值第三的连锁餐饮品牌。\n快乐蜂（Jollibee）：1975年创立于菲律宾，主打炸鸡等西式快餐，全球门店超一万家，为菲律宾最大餐饮集团，旗下还拥有添好運、永和大王等19个品牌。\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nOh Please - Gerhard Feng\nRumors About Us - T. Morri\nMelting Glass - Eden Avery\nQuietly Tense - Marten Moses\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: Amy Duan, Cosmo Hu, and Yuxuan Xiao.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "Brothers Plan Din Tai Fung ExpansionAmerica’s Most Successful Restaurant Chain F",
                "url": "https://www.wsj.com/real-estate/commercial/americas-most-successful-restaurant-chain-feeds-a-dumpling-frenzy-a9a94bde?mod=Searchresults&amp;pos=1&amp;page=1"
              },
              {
                "text": "“新茶饮祖师爷”要被卖了，估值140亿元",
                "url": "https://www.jiemian.com/article/14220277.html"
              },
              {
                "text": "中国新茶饮品牌在美国的出海趋势与区域分布洞察",
                "url": "https://uscanyin.com/success-tips/data-insights/chinese-tea-brands-us-2026-report"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpN",
                "url": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpNQR_oxXw.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1072,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69cc6100d5fbbf50d3c2d34c",
            "index": 8,
            "title": "E231｜从B2B到A2A：Agent新基建，如何让“一人企业”做全球生意？",
            "pub_date": "2026-04-01T00:00:00.000Z",
            "duration": "3561",
            "duration_label": "59m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 6,
            "matched_keywords": [
              "AI",
              "Agent",
              "商业",
              "创新",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69cc6100d5fbbf50d3c2d34c",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lp6_l5SWSIA7ew_AYc2kIrOVa9H7.mp3",
            "play_count": 62047,
            "show_notes_text": "“龙虾热”正在退潮，但它带来的创新冲击还在持续——当它与行业know-how相结合，正在迸发出新的能量。\n阿里国际站有着26年的B2B数据和经验积累，今年初，OpenClaw、Cowork这些工作范式被验证，让他们看到了打通B2B闭环的智能体，终于到了可以落地的临界点。\n于是春节之后，“外贸版龙虾”Accio Work来了，海外用户只需要和这个Agent对话，它就能自主跑完从市场分析、选品设计、供应商筛选、商品发布和日常运营的全过程，把原本需要数周甚至数月的流程，压缩成几句对话。\n以往复杂的专业知识壁垒正在被Agent攻破，生产力被重新定义。从数据上来看，Accio Work40%的用户都是Solopreneur（一人企业）。降低门槛的同时，生意越做越精明了，在AI的帮助下今年阿里国际站EBITA（息税摊销前利润）增长了18%。\n在AI带来巨大变革的时代，工作流程如何被Agent重构？人才的标准发生了怎样的变化？SaaS行业的转型机会在哪里？本期播客，我们与阿里国际站总裁张阔一起聊聊，他作为互联网巨头的掌舵人，在这一轮AI浪潮下，对新业务、新人才的思考与判断。\n\n【主播】\n泓君，硅谷101创始人，播客主理人\n【嘉宾】\n张阔，阿里国际站总裁\n\n【你将听到】\n硅谷AI生态初印象\n03:49 AI吞噬SaaS，或者让它变得更好？\n05:46 两种工作新范式：OpenClaw与Claude Cowork\n\n当B2B遇到Agent\n11:57 未来所有的B2B都会走向A2A\n15:16 Accio：AI如何使采购流程缩短5倍\n18:52 B2B的强化学习：以成功撮合交易为正反馈\n21:52 Accio Work智能体进化：从采购到日常经营，覆盖整个商品销售周期\n24:07  AI原生产品的检验标准：能否随着模型的升级而变得更聪明\n\nSaaS的转型机会\n25:30 让“一个企业”也能拥有“数字团队”\n29:36 中小企业的真实画像与“开箱即用”的产品设计\n31:48 商业模式双轨：Token计费 + 平台服务\n34:42 当推荐从1000个变成5个，广告还好卖吗？\n36:26 AI不是颠覆商业模式，而是把市场做大\n39:15 数据闭环很重要，用户挑剔倒逼极致效率\n41:41 A2A时代的竞争：谁能成为那个“主智能体”（Master Agent）？\n43:01 成功标准：不看token消耗量，看用户留存和单位token价值\n\nAI时代工作方式\n45:07 人才新标准：产品经理要预判6个月后的模型能力\n47:49 工程新范式：主Agent调度子Agent，群聊驱动的开发助手\n50:11 衡量AI是否有效：看“有效想法”上线数量，看指标是否“非线性增长”\n51:59 检验AI原生的试金石：新模型来了，团队兴奋还是焦虑？\n55:01 OpenClaw冲击波：当AI能力被验证，新一轮的创新开始涌现\n\n【Accio · 免费试用】\n想让AI帮你管理从设计采购到售后的全部流程？前往www.accio.com 下载Accio Work，新用户享7天免费试用，亲自体验“一人企业”如何做全球生意。\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nWaiting in Vain - Kikoru\nHidden Agenda-Experia\nSpring Dance - Forever Sunset\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guest: 张阔.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "www.accio.com",
                "url": "https://www.accio.com/"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpN",
                "url": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpNQR_oxXw.jpg"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/139a-audiofreehighqps/BF/FB/GKwRIW4NqiVHAAKfC",
                "url": "https://imagev2.xmcdn.com/storages/139a-audiofreehighqps/BF/FB/GKwRIW4NqiVHAAKfCwSGO-Sb.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 853,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69c477e9abc3dc8807b8ca2d",
            "index": 9,
            "title": "E230｜1万亿收入预期背后：英伟达的巅峰与软肋",
            "pub_date": "2026-03-26T00:00:00.000Z",
            "duration": "3981",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "Coding",
              "创业",
              "硅谷"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69c477e9abc3dc8807b8ca2d",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lsUEI5612GkwuQrDorKsT2S9HBaQ.mp3",
            "play_count": 76151,
            "show_notes_text": "本期播客是硅谷101在GTC 2026大会期间的线下特别录制，我们从老黄在Keynote上抛出的那几个大数字开始聊起：\n1万亿——这是黄仁勋预期到2027年底，Blackwell和Vera Rubin两个平台带来的订单收入。\n7块——这是大会一次性发布的Vera Rubin新芯片数量。\n10倍、35倍——这是Vera Rubin NVL72 AI机架系统，相比Blackwell，它的推理效率提升了10倍，每瓦Token产出性能是之前的35倍。\n但我们聊的远不止数字本身，也不只是芯片的故事。当推理拐点全面到来，算力狂奔的路上，芯片设计、代工产能、推理架构、软件生态、电力基建、云服务运营……这些环节都在被重新丈量。\n在这场串联起AI全产业链关键节点的线下对谈中，我们试图穿透英伟达庞大的AI生态帝国表象，看清它真正的护城河，以及那些潜伏在高速增长背后的软肋与隐忧。\n\n【主播】\n泓君，硅谷101创始人，播客主理人\n【嘉宾】\n张璐，Fusion Fund创始管理合伙人\nDr.Mark Ren, Agentrys创始人&CEO，前英伟达研究总监\nDr.Zhibin Xiao, ZFLOW AI创始人&CEO，前CASPA主席与董事会顾问\nAlex Yeh，GMI Cloud创始人&CEO\n\n【你将听到】\n万亿野心背后的产业现实\n03:21 万亿目标背后，推理业务正成为英伟达关键收入来源\n05:50 供应链瓶颈：CoWoS产能成最大挑战，硬件周期非资金可突破\n09:03 七芯齐发的关键：英伟达全公司都在用 Coding Agent 做芯片\n10:10 Groq的优势：纯SRAM架构专攻低延迟\n15:43 推理芯片创业还有机会吗？关键：找英伟达短板\n19:07 未来数据中心是异构的，系统级优化比单芯片更重要\n21:25 OpenClaw引爆TOKEN消耗，英伟达NemoCloud能让人惊艳吗？\n24:27 SaaS面临挑战：未来软件公司卖的不是软件，是AI劳动力\n28:36 未来企业架构：CEO同时管员工和智能体，HR、财务都可外包\n30:07 英伟达芯片设计模型ChipNemo，硬件代码也能写，难点在于优化\n31:47 谷歌TPU系统能力强，但英伟达的护城河已从CUDA扩展到全栈基础设施\n35:28 英伟达的护城河：执行力与供应链\n36:14 未来挑战：垂直领域、边缘端与私有化部署的崛起、推理市场红利被分流、资本压力\n40:16 观众提问1： 英特尔是否有望成为代工第二源？\n42:56 观众提问2：CUDA护城河是否会被Coding Agent削弱？\n\n一线云服务商谈数据中心瓶颈\n46:30 数据中心竞速：靠自发电与预制集装箱加速\n50:22 谁在引爆GPU云需求？模型训练、视频生成、AI Coding以及OpenClaw\n53:39 模块化、标准化、全套打包的AI工厂方案\n56:57 不止GPU缺货，数据中心核心配件供应趋紧\n58:42 运营GPU云的核心能力：先有卡，再稳得住，SLA是生死线\n01:01:04 GPU折旧比资本市场预估更耐久\n01:02:08 观众提问3：AI云服务商的差异化策略\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nPulse Runner - Helmut Schenker\nInterstate 895 - Bonnie Grace\nUnfinished Stories - Lennon Hutton\nSeven Daughters - Fabien Tell\nAI sing-along recaps GTC keynote\n\n本期节目不构成任何投资建议\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: Alex Yeh, Dr.Mark Ren, Dr.Zhibin Xiao, and 张璐.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpN",
                "url": "https://imagev2.xmcdn.com/storages/c4ce-audiofreehighqps/29/FA/GAqhI8INmcS2AAHpNQR_oxXw.jpg"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/50ad-audiofreehighqps/EE/F3/GKwRIW4NmdQWADbk8",
                "url": "https://imagev2.xmcdn.com/storages/50ad-audiofreehighqps/EE/F3/GKwRIW4NmdQWADbk8QR_pxN9.png"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/121b-audiofreehighqps/DF/36/GKwRIRwNmcTMACQAO",
                "url": "https://imagev2.xmcdn.com/storages/121b-audiofreehighqps/DF/36/GKwRIRwNmcTMACQAOwR_ox4C.jpg"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/139a-audiofreehighqps/BF/FB/GKwRIW4NqiVHAAKfC",
                "url": "https://imagev2.xmcdn.com/storages/139a-audiofreehighqps/BF/FB/GKwRIW4NqiVHAAKfCwSGO-Sb.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 988,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69bc8f3e21b3b2db21bd65d7",
            "index": 10,
            "title": "E229｜从手工作坊到全球第一：中国动力电池逆袭史",
            "pub_date": "2026-03-20T00:00:00.000Z",
            "duration": "3897",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "硅谷"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69bc8f3e21b3b2db21bd65d7",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lpG5ZkzcmTKxdDnMQ3V6Th9vE1sq.mp3",
            "play_count": 49732,
            "show_notes_text": "这几年，如果说全球制造业里，有哪个故事最值得被重新讲一遍，那一定是动力电池。\n中国在动力电池产业链中，建立了极强的优势。当欧洲电池巨头Northvolt破产，日韩也不再具备领先地位，很多人会问：为什么很多原始技术并非源自中国，但最后却是中国把它做成了最完整、强势的产业？这背后到底是政策红利、市场规模，还是极致的工程能力在起作用 ？\n这一期节目，我们邀请了材料学博士、TDK Ventures 投资人何倩然，和《三联生活周刊》资深记者、也是新书《电车之心：中国动力电池传》作者杨璐和张从志，一起聊聊中国动力电池产业的逆袭故事。《电车之心》通过大量核心人物采访和工厂一线走访，拿到了许多难得的一手资料，这本书也在试图回答一个问题：为什么中国能在动力电池产业弯道超车？\n这一期节目会沿着几条线展开：先看中国动力电池优势是怎么形成的，再拆解这个行业真正难的地方；接着看固态电池、钠离子电池等关键路线走到了哪一步；最后再讨论，下一阶段全球动力电池竞争的重点会怎么变。\n\n【主播】\n刘一鸣，硅谷101特约研究员\n\n【嘉宾】\nKatherine He，硅谷TDK Ventures高级投资经理\n杨璐，三联生活周刊资深编辑\n张从志，三联生活周刊主笔\n\n【你将听到】\n产业突围：中国动力电池如何跑出来\n02:48 决定性优势：中国在产业链的很多环节，市占率达到80%以上\n03:11 关键拐点：“十城千辆”如何在早期用政策先创造需求\n05:03 白名单与补贴：“白名单”政策，怎样进一步扶起本土电池厂商\n06:43 全球格局对比：中国领跑，日韩稳定跟进，美国更像是一个“聪明但掉队”的学生\n\n制造逻辑：为什么工程能力才是核心护城河？\n12:47 “手搓电池”的往事：早期中国电池企业有多“狼狈”\n14:59 砸锅卖铁解决问题：曾毓群当年如何从贝尔实验室授权技术，并攻克核心的“鼓气”难题\n17:37 极致制造的差距：电池是“微米级制造”，难在一致性\n21:56 从磁带到电池：揭秘涂布技术秘籍\n26:41 电池厂最深的护城河：不只是配方，更是极致的工程能力\n28:27 工程师红利：中国工厂的“内卷”，与美国工厂“下午五点准时下班”的差异\n\n城市竞争：从“五粮液”到“动力电池之都”\n35:48 常州的“四小时产业圈”：四小时车程内，可以配齐绝大部分零部件\n39:40 地方政府的“产投”逻辑：从“铜头铁嘴”到“兔子腿”\n40:25 宜宾的转型奇迹：白酒与动力电池\n\n下一代电池：谁能实现真正的颠覆？\n50:06 固态电池的瓶颈：全固态电池仍需等到2030年之后\n55:32 钠电池的战略意义：无需依赖关键金属，它是美国电网储能的更优解吗？\n01:00:38 弯道超车的尝试：美国公司正在寻找新赛道\n01:03:12 Northvolt破产启示录：曾毓群说“从头到脚都做错了”\n\n【听众福利】\n想了解关于中国电力电池崛起的故事，欢迎关注《电车之心：中国动力电池传》\n作者：杨璐 张从志\n\n我们将在评论区抽出3名幸运听众赠送这本书，快来留言参与吧（截止时间3月24日）\n\n【监制】\n泓君\n【后期】\nAmei\n【运营】\n朱婕\n【BGM】\nInvasion 2 - Fredrik Ekstrom\nPulse Runner - Helmut Schenker\nAll Parts Equal - Airae\n\n本期节目录制于2026年1月16日\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: 何倩然, 张从志, and 杨璐.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpN",
                "url": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpNQRBU__s.jpg"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/69eb-audiofreehighqps/BD/37/GKwRIJENkbLwAAVYB",
                "url": "https://imagev2.xmcdn.com/storages/69eb-audiofreehighqps/BD/37/GKwRIJENkbLwAAVYBAR8UDtM.jpg"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/139a-audiofreehighqps/BF/FB/GKwRIW4NqiVHAAKfC",
                "url": "https://imagev2.xmcdn.com/storages/139a-audiofreehighqps/BF/FB/GKwRIW4NqiVHAAKfCwSGO-Sb.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 981,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69b35445dc0cc48a76772b57",
            "index": 11,
            "title": "E228｜谷歌TPU能撼动英伟达吗？前TPU工程师首次揭秘",
            "pub_date": "2026-03-13T00:00:00.000Z",
            "duration": "4006",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 4,
            "matched_keywords": [
              "AI",
              "大模型",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69b35445dc0cc48a76772b57",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lnmEUuV2U71JRMB5dAmBGK_jSCFI.mp3",
            "play_count": 52457,
            "show_notes_text": "在AI算力争霸时代，英伟达凭借GPU市值一路狂飙。但如今，它的蛋糕正在被一点点分食——2024年，苹果论文披露Apple Intelligence全部由TPU训练；2025年，Anthropic签下数十亿美元订单，购买TPU训练Claude；近期，Meta与谷歌签署数十亿美元协议，租用TPU跑Llama。\nTPU一直是谷歌低调的“自家武器”，在过去十年里驱动着几乎全部核心产品。直到TPU训练的Gemini 3打了一场漂亮的翻身仗，人们才开始重新审视：这套从搜索推荐系统中长出来的定制芯片，究竟藏着多少秘密？\n本期播客，我们邀请到前谷歌TPU工程师Henry。他在2018年至2024年间深度参与了三代TPU的研发，也见证了大模型时代TPU的关键转型。他将从硬件架构、软件生态、生产供应链三个维度，一层层揭开TPU的神秘面纱。\n我们将深入探讨：TPU与GPU的架构有何根本不同？TPU的产能瓶颈卡在哪里？当谷歌开始向Anthropic、Meta开放TPU，它在软件生态上要迈过哪些坎？如果未来模型的底层范式发生改变，TPU还能押准方向吗？而最关键的问题是：TPU真的有机会撼动英伟达的霸主地位吗？\n\n【主播】\n泓君，硅谷101创始人，播客主理人\n【嘉宾】\nHenry Zhu，前Google TPU工程师，参与V6/V7/V8 TPU研发\n\n【你将听到】\nTPU挑战GPU\n03:06 架构对决：GPU像多个大厨，TPU像流水线接力\n06:41 TPU vs GPU：谁在模型训练上更强？\n10:20 TPU产能之困：HBM、封装与良率\n\nXLA软件黑盒\n14:06 Anthropic为何率先下单百万部署？\n16:01 黑盒优化如何“榨干”硬件性能\n17:47 XLA与CUDA，两种生态之争\n19:53 苹果为什么能成为TPU大客户？\n\n“大模型客户”\n20:45 Gemini成功背后，TPU做了什么？\n22:34 TPU是如何做MoE优化的？\n23:45 设计难点：如何押中两三年后的算法？\n26:05 TPU的转身：V6开始押注大模型预训练\n28:53 Transformer先发优势带来的旗鼓相当能持续多久？\n32:04 Meta的TPU托管服务：生态逐渐走向兼容\n\n供应链命门\n36:08 拓扑通信架构如何为TPU打赢数据中心成本战\n38:27 博通（Broadcom）是谁？为什么它如此关键\n42:04 挑战GPU的机会：用户规模越大推理越快\n45:36 V7（Ironwood）之后：Gemini实现100%TPU训练\n48:15 一句话总结TPU优劣势\n\nTPU十年进化史\n49:49 V1推理芯片试水，V2训练芯片旗舰，V4优化推荐算法\n52:16 V5/V6：进入大模型时代，推出推理专用版本\n56:05 团队演变：软件组话语权越来越重\n\n新星Groq\n57:14 踩准每一次红利的编译器公司\n59:27 差异化定位：做小规模部署的低延迟优化\n01:01:59 AI算力芯片新战局\n\n【更正】\n54:20 口误，Groq创始人Jonathan Ross，现为英伟达首席软件架构师\n\n【延伸阅读】\n《谷歌收获大单：与Anthropic达成数百亿美元合作，部署100万个TPU芯片》\n《不再单押英伟达，Meta斥资数十亿美元租用谷歌TPU》\n\n【监制】\n泓君\n【剪辑】\n小师 Jacob\n【运营】\n朱婕\n【BGM】\nVirtuoso Violin - Rafael Krux\nAngular Pulse - Guy Copeland\nTop Flow - This Violin\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\n本期节目中嘉宾所表达观点均为其个人看法。\n本期节目不构成任何投资建议，投资有风险，入市需谨慎。\n\nSpecial Guest: Henry Zhu.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "《谷歌收获大单：与Anthropic达成数百亿美元合作，部署100万个TPU芯片》",
                "url": "https://www.thepaper.cn/newsDetail_forward_31831042"
              },
              {
                "text": "《不再单押英伟达，Meta斥资数十亿美元租用谷歌TPU》",
                "url": "https://news.qq.com/rain/a/20260227A0243600"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpN",
                "url": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpNQRBU__s.jpg"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/53ac-audiofreehighqps/25/65/GAqhVp8NiJDXAALbY",
                "url": "https://imagev2.xmcdn.com/storages/53ac-audiofreehighqps/25/65/GAqhVp8NiJDXAALbYgR4uiFR.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 597,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69a77745f44b398f59390e48",
            "index": 12,
            "title": "E227｜美国医疗市场AI争夺战：巨头押注，创业公司能赢吗？",
            "pub_date": "2026-03-04T00:00:00.000Z",
            "duration": "3579",
            "duration_label": "59m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 7,
            "matched_keywords": [
              "AI",
              "OpenAI",
              "Coding",
              "创业",
              "商业",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69a77745f44b398f59390e48",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lsuwO3xOIfJXNpDssdP18zdDz_mz.mp3",
            "play_count": 81339,
            "show_notes_text": "每周，有超过2.3亿人在ChatGPT上询问健康和保健问题。在人类创造的所有数据中，有30%来自医疗领域，但其中真正被利用起来的，不足5%。\n一边是巨大的数据金矿，一边是与未被满足的庞大需求，这正是AI的机会。\n在年初的摩根大通医疗健康大会上，我们看到医疗与AI正在加速“双向奔赴”。礼来制药与英伟达达成10亿美元合作，试图用算力重塑药物发现的底层范式；在OpenAI发布ChatGPT for Health之后几天，Anthropic也迅速跟进，推出了Claude for Healthcare。而一家成立仅三年的初创公司OpenEvidence，以120亿美元的估值跻身AI医疗新贵——40%的美国医生每天都使用它。\n面对这场火热的AI医疗争夺战，我们想问一个根本的问题：AI到底在解决医疗的什么问题？它只是巨头的游戏吗，创业公司还有没有机会？\n我们从一位急诊室医生的真实经历聊起，他常常在凌晨三四点完成生死抢救后，站在传真机前处理medical coding。这不是个例——美国全科医生的周平均工作时长高达61.8小时，相当大的一部分精力耗费在了病历录入、保险对接、医疗编码这些琐碎却容错率极低的行政事务上，而这恰恰是AI最容易切入的场景。\n\n【主播】\n泓君，《硅谷101》创始人，播客主理人\n【嘉宾】\n张璐，Fusion Fund创始管理合伙人\n周叶斌，遗传学博士，现在药企从事免疫学研究（《说医解药》主播，微博@生物狗Y博，公众号：一个生物狗的科普小园）\n\n【你将听到】\nAI医疗大年拉开序幕\n01:13 JPM大会见闻：药企集体“转身”，AI从“可选项”变为“必答题”\n04:05 2026年AI医疗战局初探：谁在入局，谁在领跑？\n04:58 医生“过劳”成常态，每周工作61.8小时，大部分时间竟不在看病\n\nAnthropic：从行政合规切入\n08:21 医疗支付系统有多复杂？碎片化行政工作拉扯医生精力\n10:30 AI在医疗的最大机会：30%的人类数据在这里，但利用率不足5%\n13:56 被忽视的“医疗编码”，为什么适合交给AI？\n17:26 HIPAA合规模型：医疗AI的“入场券”\n20:50 为什么医疗AI多用小语言模型？\n\nOpenAI：ToB野心与生态博弈\n21:34 OpenAI为何重注医疗ToB？不止是商业化，更是模型进化\n23:57 医生的知识更新难题：AI 能做什么？\n25:26 生态之争：OpenAI能否撼动微软的医疗地盘？\n27:55 便宜又好用，开源模型带来的冲击\n\nOpenEvidence：新贵独角兽能走多远\n28:51 40%美国医生每天都在用，OpenEvidence是什么？\n32:30 核心竞争力：顶级期刊独家高质量医学内容数据\n33:25 商业模式隐忧：靠医疗广告赚钱，能保持客观吗？\n35:12 垂直模型的优势：优质语料训练+本地化部署能力\n\n展望AI医疗未来\n40:19 AI如何促进医疗均衡？分层诊疗+提升效率是关键\n44:16 HealthBench：从考“知识点”到考“真实场景下的对话能力”\n48:31 巨头v.s初创：谁更适合做医疗AI？\n52:27 医疗3.0时代：预防>治疗，生命质量成为核心\n\n【延伸阅读和相关术语】\n《健康保险可携带性和责任法案》（HIPAA）是一部联邦法律，要求制定国家标准以保护敏感的患者健康信息，以免在未经患者同意或不知情的情况下披露。\nChatGPT for Healthcare：OpenAI ToB产品，一套面向医疗机构的企业级产品套件，支持HIPAA合规性要求，还包括OpenAI API、评估系统HealthBench⁠等。\nChatGPT Health：OpenAI ToC产品，核心定位是用户的“个人健康助手”，旨在通过整合用户健康数据提供个性化建议，但明确声明不用于诊断或治疗，仅为辅助工具。\nClaude for Healthcare：由Anthropic推出的医疗专用AI工具，为医疗服务提供者、保险公司和消费者提供符合HIPAA标准的人工智能服务。\n\n【监制】\n泓君\n【后期】\nAMEI\n【运营】\n朱婕\n【BGM】\nPrimary Code - Max Anson\nGetting to It - Max Anson\nUnfinished Stories - Lennon Hutton\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: 周叶斌 and 张璐.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "《说医解药》",
                "url": "https://www.xiaoyuzhoufm.com/podcast/675fed6284447b1bd047dc1b"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpN",
                "url": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpNQRBU__s.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 711,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "699f8dc4ff5fd5761ab49c2a",
            "index": 13,
            "title": "E226｜聊聊DeepMind创始人哈萨比斯：一个科学家与失控的AI竞赛",
            "pub_date": "2026-02-26T00:00:00.000Z",
            "duration": "4394",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 4,
            "matched_keywords": [
              "AI",
              "大模型",
              "商业",
              "硅谷"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/699f8dc4ff5fd5761ab49c2a",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/ljGWTVvQbkRrGmfGydHbxpwRuzn0.mp3",
            "play_count": 59254,
            "show_notes_text": "他是霍金口中“地球上最聪明的人之一”，4岁下国际象棋，13岁获大师称号，却在一场对弈中突然顿悟，转身奔向人工智能。\n他是DeepMind创始人，AlphaGo、AlphaFold背后的大脑，2024年诺贝尔化学奖得主。他也是那个因执念于强化学习险些错失大语言模型时代，又率领谷歌Gemini逆袭，成功回到牌桌的“孤傲天才”。\n我们想聊聊哈萨比斯，不仅因为他的天才传奇，更想了解：发明终极技术的那一小撮人，他们的思想从何而来，动机又是什么？\n作者塞巴斯蒂安·马拉比在传记中抛出一个问题：哈萨比斯一直想做正确的事，但他能做到吗？\n本期播客，我们邀请到了《哈萨比斯：谷歌AI之脑》译者周健工，他也是中国最早当面采访哈萨比斯的媒体人。我们从哈萨比斯的少年往事聊起，复盘DeepMind被谷歌收购的博弈，以及错失大模型的战略失误，也追问了那个绕不开的问题：当一个科学家手握可能改变人类命运的技术，他的理想、执念与野心，会把我们带向何方？\n\n【主播】\n泓君，《硅谷101》创始人，播客主理人\n【嘉宾】\n周健工，未尽研究创始人，资深媒体人，《哈萨比斯：谷歌AI之脑》译者\n\n【你将听到】\n03:12 外表普通，智力超群——译者对哈萨比斯的第一印象\n06:53 作者马拉比为什么选择哈萨比斯\n\n哈萨比斯早年经历\n10:38 象棋神童的顿悟时刻：下棋并非人生的全部，转向人工智能\n13:41 他在游戏中植入“智能体”的雏形，却因算力不足失败\n15:50 “如果你不能把一个东西造出来，你就不能真正理解它”\n17:22 对强化学习的执念，为未来悄悄埋下伏笔\n20:15 学派之争：萨顿的“强化学习”和辛顿的“深度学习”\n\nDeepMind崛起和失误\n22:23 DeepMind另外两位创始人登场：肖恩·莱格和苏莱曼\n26:17 融资历程：彼得·蒂尔觉得他商业上不成立，却还是投了\n31:33 扎克伯格“端水”回答，让DeepMind果断选择谷歌\n37:59 从围棋到生物学难题：“没有我玩不赢的游戏”\n41:18 AI发展里程碑：2024年诺贝尔化学奖背后的故事\n46:07 密谋脱离谷歌的“马里奥计划”、NHS数据风波和苏莱曼的离开\n52:42 昔日伙伴各自成为谷歌、微软AI掌门人\n55:16 孤傲下的战略失误：DeepMind为什么错失大语言模型\n\n故事的背后，我们再聊聊……\n59:31 Gemini逆袭背后，谷歌内部经历了什么\n1:03:02 AI末日警告？顶级科学家态度各不同\n01:07:24 客观看待作者倾向性：与硅谷保持距离的“英国立场”\n01:09:13 哈萨比斯的矛盾：他不愿意控制别人，却一定要赢过别人\n\n【听众福利】\n想了解更多故事，欢迎关注哈萨比斯官方授权传记：《哈萨比斯：谷歌AI之脑》（The Infinity Machine：Demis Hassabis, DeepMind, and the Quest for Superintelligence）\n作者：[美]塞巴斯蒂安·马拉比（Sebastian Mallaby）\n译者：周健工\n\n我们将在评论区抽出2名幸运听众赠送这本书，快来留言参与吧（截止时间3月2日）\n\n【监制】\n泓君\n【后期】\nAMEI\n【运营】\n朱婕\n【BGM】\nAshbound Oath - Ruiqi Zhao\nEstimations - Christoffer Moe Ditlevsen\nFloating in Space - Eva Hummingbird\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guest: 周健工.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpN",
                "url": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpNQRBU__s.jpg"
              },
              {
                "text": "https://imagev2.xmcdn.com/storages/24c6-audiofreehighqps/F6/D5/GKwRIMANdLGkAAKwm",
                "url": "https://imagev2.xmcdn.com/storages/24c6-audiofreehighqps/F6/D5/GKwRIMANdLGkAAKwmQRwANPe.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1360,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "698fbbc62cbb0d7f6e4ae7e7",
            "index": 14,
            "title": "E225｜SaaS业数千亿市值蒸发：AI如何变革组织架构？",
            "pub_date": "2026-02-14T00:00:00.000Z",
            "duration": "3348",
            "duration_label": "55m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 4,
            "matched_keywords": [
              "AI",
              "Agent",
              "Coding",
              "硅谷"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/698fbbc62cbb0d7f6e4ae7e7",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/lqMHn2FFjBv0wNSBlwknH6nNJ56w.mp3",
            "play_count": 57254,
            "show_notes_text": "本节目由百融云创赞助播出\n\n2026年2月的第一周，全球软件行业经历了一场如“葬礼”般的信仰地震。随着Anthropic基于Claude Cowork平台，发布了11款覆盖法律、金融、销售等核心业务的职能插件，全球软件板块市值，在短短一周内蒸发了数千亿美元。华尔街的交易员们直言：SaaS的末日到了。\n这不仅是股价的波动，更是生存模式的更迭。当“按人头卖坐席”的万亿帝国，在AI Agent面前显得摇摇欲坠时，每一位职场人和企业管理者，都不得不面对那个迫在眉睫的问题：在“硅碳共治”的时代，我的位置在哪里？\n本期节目，我们邀请到了百融云创创始人、AI时代的“急先锋”张韶峰。他的公司拥有1000多位人类员工，却指挥着20多万个拥有工号、KPI，甚至退役机制的“硅基员工”。这套体系可以把很多公司流程缩短、效率提升，我们将深度拆解Agent如何终结软件工具时代。\n\n【主播】\n刘一鸣，硅谷101特约研究员\n\n【嘉宾】\n张韶峰，百融云创创始人，专注于企业级Agent与AINative架构，倡导RaaS（结果即服务）模式\n\n【你将听到】\nSaaS的黄昏与RaaS的崛起\n03:46 “信仰地震”：为何Anthropic的插件更新，成了压死传统SaaS的最后一根稻草？\n05:14 三年“救赎期”：概率模型时代，复杂流程如何成为传统软件最后的护城河？\n09:46 RaaS崛起：告别“坐席费”，从“螺丝刀”进化为按结果付费\n\n“硅碳共治”：管理20万硅基员工的实战录\n15:05 组织重塑：碳基员工汇报给硅基员工？从黄仁勋的1亿AI助手说起\n18:17 “硅基员工之家”：有名字、有工号、有绩效，甚至有退出机制的管理系统\n20:50 数字替身：CEO如何在除夕夜，为自己定制一个永不下线的助理？\n22:32 消失的“合成感”：2020年银行系统里，那场让客户完全感知不到AI的技术潜行\n27:07 角色转变：45名客服转岗AI训练师，从成本中心走向利润中心\n\n行业深拆：Agent如何在实战中“杀疯了”\n34:06 最终目标：建立 AgentStore，打造一个像Apple Store一样的硅基生态系统\n38:20 招聘革命：流程从28天砍到2天，AI如何识别被隐藏的“真人才”？\n41:07 Vibe Coding时代：拒绝纯人工写代码，为何不再招聘不会用AI的员工？\n42:29 法律提效：一份法务合同审核，从56分钟缩短至4分钟的实操经验\n\n未来展望：传统企业的求生指南\n47:53 麦肯锡已拥2.5万“硅基员工”：未来三年，你的工作只剩审核签字？\n49:47 拒绝FOMO：传统企业转型第一步，是厘清“大脑”（模型）与“手脚”（智能体）的区别\n52:37 愿景实现：具备领域Know-how的“将军”，如何统领Agent军团开启“一人公司”模式？\n\n【延伸阅读和相关术语】\nSaaS（软件即服务）、PaaS（平台即服务）和IaaS（基础设施即服务）是三种主要的云计算服务模型，它们的区别如下：\n• SaaS：提供完整的软件应用，用户开箱即用，构建在PaaS之上，用户无需管理底层基础设施（相当于精装修、沙发电器床都是齐全的，直接拎包入住）\n• PaaS：提供应用开发和部署平台，用户专注于代码与数据，构建在IaaS之上，增加了开发环境和工具（相当于给你毛坯房和工具箱，你可以自己根据自己的喜好来建）\n• IaaS：提供基础计算资源，用户自主管理操作系统及以上层面，它为PaaS和SaaS提供底层的硬件资源支持（相当于给你一块地，也就是最底层的资源，自己盖房，适合技术大牛）\nTaaS：Transaction as a Service（交易即服务），企业不再是单纯购买一个软件工具，而是要求服务商直接帮客户促成交易，并从最终的交易结果中分享价值\n53:28 Prosumer，意指“Producer + Consumer”，既是生产者也是消费者\n\n【监制】\n泓君\n【后期】\nAMEI\n【运营】\n朱婕\n【BGM】\nAshbound Oath - Ruiqi Zhao\nEstimations - Christoffer Moe Ditlevsen\nFloating in Space - Eva Hummingbird\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guest: 张韶峰.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpN",
                "url": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpNQRBU__s.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1056,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69828c85a712301410e31643",
            "index": 15,
            "title": "E224｜深度拆解Clawdbot，为何它能成为2026年第一个现象级产品？",
            "pub_date": "2026-02-04T00:00:00.000Z",
            "duration": "4780",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 7,
            "matched_keywords": [
              "AI",
              "Agent",
              "大模型",
              "创业",
              "商业",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69828c85a712301410e31643",
            "audio_url": "https://media.xyzcdn.net/5e5c52c9418a84a04625e6cc/ljnOELVX5c-IHGeSWp8Sl7WLw-S8.mp3",
            "play_count": 143718,
            "show_notes_text": "AI正在冲出浏览器，走向了接管电脑权限、主动为人打工的新阶段，为了它，你得买台Mac mini？\nGitHub星标数几天内突破14万，社交媒体上全网刷屏，甚至直接带火了Mac mini的销量，Clawdbot成了2026“AI Agent爆发元年”第一个现象级产品。它不再是冷冰冰的聊天框，而是一个住在你电脑里、甚至能在AI“朋友圈”（Moltbook）里社交的“数字生命”。\nClawdbot的“活人感“来自哪里？那些让人“上头”的Agent功能，在真实工作流中到底能实现什么？把电脑权限交给AI，到底是在请“管家”还是请“黑客”？未来的Agent硬件形态会是什么样？我们真的需要给Agent配一台独立计算机吗？\n本期播客，我们邀请了三位嘉宾，分别代表了用户侧、软件算法侧和硬件侧三个方向，希望全方位拆解Clawdbot的底层逻辑，以及它对2026年AI行业产生的深远影响。\n\n【主播】\n刘一鸣，硅谷101特约研究员\n\n【嘉宾】\n知县，北京大学计算机系本硕，AI爱好者和社区项目OwliaBot builder，X handle@zhixianio\n华祯豪Troy，EverMind VP，负责技术生态，本科毕业于清华姚班，卡耐基梅隆硕士（研究NLP和对话系统方向），曾在硅谷任职大型互联网公司算法团队，后创业，加入EverMind\n叶天奇，PamirAI CEO\n\n【你将听到】\n对Clawdbot的深度拆解（软件侧）\n05:04 长期记忆与主动性，赋予了Clawdbot“活人感”\n12:24 创始人在旅行中的Aha Moment，Clawdbot自我实现了语音功能\n13:28 预判意识：Agent能根据对话碎碎念，自动推送生活与工作建议\n14:06 降本增效：Agent通过监控，自主削减服务器预算\n14:24 自动化闭环：AI十秒内自主摸清仓库规则并完成配图发布\n16:28 模拟操作：Agent通过浏览器点击，绕过API限制完成文件跨路径保存\n21:40 结构化存储：MD文本记忆系统比Context压缩更确保持久稳定\n26:04 混合检索：70%语义匹配加30%关键词搜索，实现秒级记忆定位\n29:48 心跳机制：让Agent在静默状态下，也能定期自我触发任务\n\nAgent专用硬件与部署方案（硬件侧）\n31:40 物理隔离部署是应对Agent高系统权限隐私风险的必选项\n50:42 性价比首选：Mac mini成为本地运行Agent的理想基座\n52:11 专用硬件逻辑：Agent电脑取消屏幕依赖，转而强化I/O与状态灯\n53:50 Agent电脑的核心参数：在于大内存与高频存储空间\n56:22 物理隔离：独立硬件能有效保护敏感信息\n\n组织重塑与商业展望\n43:22 鲁棒性挑战：生产级Agent需要透明的审核机制与系统级回滚能力\n1:00:55 厂商博弈：大模型公司布局第一方Agent应用，旨在避免沦为底层纯算力管道\n1:07:58 商业重构：互联网的商业模式有可能会往“按爬取付费”转型\n1:10:33 .md域名与文件，正成为自然语言编译时代的新形态\n1:12:56 一人公司可行性：具备know-how的“将军”，能统领Agent军团实现生产力爆发\n1:17:26 开发范式转移：在AI极速迭代的时代，Idea的重要性已超越纯粹的执行力\n\n【监制】\n泓君\n【后期】\nAMEI\n【运营】\n朱婕\n【BGM】\nGetting to It - Max Anson\nPoisson d'Avril - Ludvig Moulin\nRumors About Us - T. Morri\nPrimary Code - Max Anson\nStar Voyage - Out To The World\n\n【在这里找到我们】\n公众号：硅谷101\n收听渠道：Apple Podcast｜Spotify｜小宇宙｜喜马拉雅｜蜻蜓FM｜荔枝FM｜网易云音乐｜QQ音乐\n其他平台：YouTube｜Bilibili 搜索「硅谷101播客」\n联系我们：podcast@sv101.net\n\nSpecial Guests: 华祯豪Troy, 叶天奇, and 知县.",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpN",
                "url": "https://imagev2.xmcdn.com/storages/a723-audiofreehighqps/B7/79/GAqhfD0NByqOAAHpNQRBU__s.jpg"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1039,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          }
        ]
      },
      {
        "id": "zhang-xiaojun-business-interview",
        "title": "张小珺Jùn｜商业访谈录",
        "feed_title": "张小珺Jùn｜商业访谈录",
        "priority": "P1",
        "selection_mode": "keyword",
        "focus": [
          "AI",
          "商业",
          "科技",
          "访谈",
          "中文播客"
        ],
        "feed_url": "",
        "source_url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962",
        "detail_path": "/podcasts/zhang-xiaojun-business-interview/",
        "episode_count": 15,
        "selected_episode_count": 15,
        "latest_episode_title": "143. 对何小鹏的第二次访谈：更大赌注、人形机器人Iron诞生、那场意外、技术剧变下CEO、GX和缝合怪",
        "latest_pub_date": "2026-05-28T00:00:00.000Z",
        "latest_page_url": "https://www.xiaoyuzhoufm.com/episode/6a170f747460cabdeb56dabb",
        "has_play_count_data": true,
        "episodes": [
          {
            "id": "6a170f747460cabdeb56dabb",
            "index": 1,
            "title": "143. 对何小鹏的第二次访谈：更大赌注、人形机器人Iron诞生、那场意外、技术剧变下CEO、GX和缝合怪",
            "pub_date": "2026-05-28T00:00:00.000Z",
            "duration": "5301",
            "duration_label": "1h 28m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "机器人",
              "人形机器人"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a170f747460cabdeb56dabb",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/ljeKstsAfrj-oVTm2bpL92S4nwoc.m4a",
            "play_count": 34061,
            "show_notes_text": "本集是小鹏汽车董事长兼CEO何小鹏的返场。\n\n在我们之前那次访谈（70集）中，何小鹏形容，造车就像在“在血海里游泳”。\n\n在过去1年中，除了汽车这场血海战役，小鹏汽车也要面临AI和机器人这场未来之战——后者的战线更漫长，造人形机器人的胜率也要比造车低得多。\n\n对此，何小鹏在2025年下了更大的赌注。\n\n我们这次从“赌”开始聊起。他也聊了聊人形机器人Iron的诞生与意外、技术变革下CEO的心路、新车GX等话题。不过，对于正在发生的事，他有一些顾忌，也有一些尚且不能说的秘密。\n\n接下来，就是我对何小鹏的访谈。\n\nOUTLINE:\n\n00:02:00  CEO使用AI小调研\n\n00:11:24  不能做缝合怪\n\n00:18:23  2025年下的赌注\n\n00:41:15  IRON机器人的诞生故事\n\n00:49:51  去年那场意外\n\n00:57:43  我们有两成胜率\n\n01:09:20  新车GX\n\n01:17:17  没有一家游出血海\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\nDETAILS: 本集节目由语言即世界工作室与微博、新浪财经联合呈现。\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "我们之前那次访谈（70集）",
                "url": "https://www.xiaoyuzhoufm.com/episode/6695032837236c546e4c2e0f"
              },
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "https://image.xyzcdn.net/ntWQBVte_mNkPlHIMnOCvsHL3Xl5.png",
                "url": "https://image.xyzcdn.net/ntWQBVte_mNkPlHIMnOCvsHL3Xl5.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1625,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a15a2cbff7b9a8c0a5b953f",
            "index": 2,
            "title": "142. 雨森的创投观察第2集：Harness、下一个字节、2026大机会和Stanley Druckenmiller",
            "pub_date": "2026-05-27T00:00:00.000Z",
            "duration": "8312",
            "duration_label": "2h 18m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 7,
            "matched_keywords": [
              "AI",
              "Agent",
              "OpenAI",
              "Coding",
              "创业",
              "创新",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a15a2cbff7b9a8c0a5b953f",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lg4SPHlAUnrJuULqRaXS_1Gc5ufZ.m4a",
            "play_count": 49886,
            "show_notes_text": "今天是我们的系列节目《雨森的创投观察》第2集。\n\n在《雨森的创投观察》第1集（我们节目124集）中，真格基金管理合伙人戴雨森预言称，2026年的关键词是“The Year of R”，他彼时较为谨慎，觉得2026年将是一个现实与回调之年。并在过年前清空了所有二级市场股票。\n\n现在过去了小半年，很多人说他的一部分观点有点打脸。雨森经过了短暂的内心挣扎，决定还是继续录制我们的系列节目。他将持续分享自己的投资思考。\n\nOUTLINE:\n\nStrong Opinions, Weakly Held\n\n00:02:00 雨森回应第一集“被打脸”往事：“Strong Opinions, Weakly Held”\n\n00:06:50 我的二级市场投资偶像是Stanley Freeman Druckenmiller\n\n00:09:07 在《雨森的创投观察》第1集，我说对了什么？说错了什么？\n\n00:13:06 理解Anthropic的选择、组织和价值观（Dario的memo和对齐）\n\n00:18:57 Harness由模型公司第一方地来做，更有优势吗？\n\n00:20:07 Anthropic vs OpenAI，Claude Code vs Codex\n\n00:23:17 “Year of Return”，到今天return的问题并没有真正被解答\n\n好的Harness是很有生命力的，Harness本身更像OS，模型更像处理器\n\n00:34:05 重新总结2026年的大叙事、大变化\n\n00:37:14 在模型外面包了越来越多的层次，“壳”早已不是简单的壳：model - harness - context - runtime\n\n00:41:30 通过Harness带来的数据也能够反哺模型的训练，形成数据飞轮。Chatbot没有数据飞轮，是因为普通人的聊天很难给模型带来新的知识。但Agentic模型要的就是帮用户解决真实问题，用户真实使用产品的轨迹是很好的训练资料\n\n00:44:45 之前节目中罗福莉和姚顺宇的观点差异（关于Harness重要性），其实不矛盾\n\n00:46:26 一个好的Harness是很有生命力的。按照出现顺序，像Manus、Claude Code、OpenClaw、Codex、Hermes是用户喜欢的Coding Agent Harness，甚至说ChatGPT可以认为是GPT API的第一个 Harness\n\n00:52:25 我认为Harness本身更像是OS：之前广密有一个比方说，模型公司是新生代的OS，但我感觉，模型更像是驱动OS的处理器，我们看到有越来越多的应用是跟用户的Harness对接，而并非直接跟用户使用的底层模型去进行耦合\n\n00:55:24 一个反直觉的现象是，勇敢地去做创新，勇敢地去做通用的，是有大机会的\n\n00:57:33 我的第一个暴论：“AGI是在缩水的”\n\n00:59:20 模型能力提升会不会向下吞并Harness的空间？有可能出现Agent的网络效应\n\n字节系创始人，要把在字节学的东西，自己颠覆自己\n\n01:04:03 2026年各个基金投的创业公司变多了，估值也变高了\n\n01:04:07 创业者要做大厂看不上的事情，比如曾经的“套壳”、“开源”\n\n01:10:50 好的创始人和好的方向有时候是共振的\n\n01:21:26 “你原来的护城河可能会变成你的软肋”\n\n01:26:24 对于AI产品，大DAU应该成为目标吗？ 大DAU vs 高质量任务，优化哪个指标？\n\n01:28:51 “AI有点像外星人，来到了人类的世界”，这里面的机会\n\n01:34:35 AI时代的组织与组织变革\n\n01:38:51 “下一个字节跳动级的公司可能长得不像字节”\n\n01:41:42 我的第二个暴论：“字节系创始人，要把在字节学的东西，自己颠覆自己”\n\n01:42:37 我眼中的AI创业框架和大机会\n\n01:48:01 美国vs中国创业端对比\n\n02:01:30 思考需要刻意练习，创新需要刻意练习\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "《雨森的创投观察》第1集（我们节目124集）",
                "url": "https://www.xiaoyuzhoufm.com/episode/693d7c172a383da167ecfcde"
              },
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "https://image.xyzcdn.net/nsLTK_gpweH8qfLfmNbmc8TjpYEh.png",
                "url": "https://image.xyzcdn.net/nsLTK_gpweH8qfLfmNbmc8TjpYEh.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2325,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a09d58b1b7bd502955258ab",
            "index": 3,
            "title": "141. Freda的投资札记第2集：Tokenmaxxing、把电机塞进蒸汽机、接力赛变篮球赛、孤独、人的连接",
            "pub_date": "2026-05-18T00:00:00.000Z",
            "duration": "5033",
            "duration_label": "1h 23m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 8,
            "matched_keywords": [
              "AI",
              "Agent",
              "OpenAI",
              "Coding",
              "创业",
              "科技",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a09d58b1b7bd502955258ab",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lmeczS2JtKzE79rKpVM-RC5yw22M.m4a",
            "play_count": 31443,
            "show_notes_text": "今天是我们的系列节目《Freda的投资札记》第2集。\n\n可能有听众是第一次听我们的节目，那还是先介绍一下——Freda Duan在湾区做投资，是Altimeter Capital的合伙人。Altimeter是一个硅谷科技基金，横跨一二级。在一级市场投资案例有OpenAI、Anthropic、字节跳动等，在二级市场投资案例有英伟达、存储芯片、Snowflake、Robinhood等。\n\n在《Freda的投资札记》第1集，也就是我们的125集节目中，Freda深入分析了当下美国的明星公司，给他们的巨额投入算了算账；也探讨了美国资本新秩序，以及当时大家很关心的泡沫。\n\n可以预告一下的是，在本集，我们除了一如既往聊AI和投资这些很干的内容——如，Tokenmaxxing、AI时代的组织架构；还会聊一些感性的东西，尤其在这个充满不确定、每个人都很焦虑和孤独的时代，人和人的关系剩下什么？\n\nOUTLINE:\n\n02:13 Token的世界\n\nToken是一个非常容易误导人的单位\n\n同样一个task，不同模型消耗的token可能差几十倍，甚至上百倍\n\nToken消耗是越多越好吗？肯定不是越多越好，而且是反过来的\n\nTokenmaxxing 现在有大量浪费 - 是的；Token用量未来还会继续上升 - 也对\n\n行业会逐渐从按token收费，转向按效果收费\n\n11:44 模型公司的赛点与竞争\n\nCoding Agent成熟之后，出现了一个很重要的loop：better AI makes better AI\n\n现在到了无法追赶的地步了吗？用一个不太恰当的类比 - 马车换汽车\n\n最早的汽车经常抛锚，跑在前面的几匹快马还能跟一跟、追一追，那时候两者差距没有那么清楚；但一旦汽车可以稳定跑起来，没有汽车引擎的马，再快也追不上\n\nOpenAI按GPT和Coding两条主线重组，把Coding放到非常高的位置；Google是Sergey直接管Coding；Meta内部也开始推自己的Coding model，目标是年底前做出SOTA；xAI公开收购Cursor\n\n27:41 投资人是在抛弃软件公司吗？\n\nAnthropic Cowork这么成功的产品，是两个人做出来的，AI来了以后，值得重新思考“一个公司到底应该需要多少人”\n\n投资人是在抛弃软件公司吗？对，是。最简单的投资逻辑是discount rate\n\n哪些软件更脆弱？AI时代新的软件机会在哪里？软件是不是要为Agent重新设计？\n\n36:32 组织架构变革\n\nDario提过两个概念：technology diffusion和economic diffusion\n\nAI现在在曲线的哪个位置？在“把电机塞进蒸汽机位置”这一阶段——每个人都在把AI加进自己的工作流，但很少有人退一步问：这个流程本身、这家公司本身，为什么长成现在这样？为什么需要这么多层级？\n\n接力赛变篮球赛——过去是接力赛，一棒接一棒，每一棒都是一次翻译、一次等待；未来更像篮球赛，3到5个人的小分队，必要技能都在队里，同步推进，自己拍板，只有重大方向才往上升级\n\n44:21 AI对投资行业的影响\n\n投资行业是一个非常低效的行业，大量时间花在找信息、清洗数据、比较预期、判断positioning\n\n我这几个月想的问题是：如果给Agent足够干净的数据和足够清晰的交易目标，它有没有可能做的比我好？\n\nAI时代会让更多人参与股市，散户行为会更复杂，也更值得tracking\n\n投资本质上会越来越像一个解构市场玩家的游戏\n\n50:08 应用创业公司还剩什么？\n\nAI这波创业公司，哪些方向已经跑出收入？一波快问快答\n\n这几年经历了一个过程 - 23年大家特别担心模型公司吃一切，wrapper大家都不敢碰；过去两年大家不担心了，因为应用或者叫wrappers收入增长很快；但到了今年我现在又重新开始担心了\n\nAnthropic先吃编程这一块，现在第二大业务吃金融领域；OpenAI马上自己推出音频模型，对ElevenLabs会是什么影响？OpenAI和Anthropic都和大的私募基金合作，把自己模型推到私募基金的被投企业里面，这个决心是很大的，真的adoption还没有开始\n\n2026年了，你还投应用创业公司吗？\n\n硅谷最火的是Neo Labs，另一个很重要方向是给Agent用的基础设施\n\n01:00:42 大票和资本市场\n\n01:08:33 AI会带来裁员和通缩吗？\n\n01:14:17 焦虑、孤独与人的连接\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "《Freda的投资札记》第1集，也就是我们的125集节目",
                "url": "https://www.xiaoyuzhoufm.com/episode/694180874c65abaff3576bc4"
              },
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "https://image.xyzcdn.net/nuzHJVCagytHsVtjj4x0zsuw2C9l.png",
                "url": "https://image.xyzcdn.net/nuzHJVCagytHsVtjj4x0zsuw2C9l.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 990,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6a00aa051b7bd50295dfe41d",
            "index": 4,
            "title": "140. 对姚顺宇的4小时访谈：请允许我小疯一下！在Anthropic和Gemini训模型、技术预测、英雄主义已过去",
            "pub_date": "2026-05-11T00:00:00.000Z",
            "duration": "13835",
            "duration_label": "3h 50m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 5,
            "matched_keywords": [
              "AI",
              "OpenAI",
              "Coding",
              "机器人",
              "硅谷"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6a00aa051b7bd50295dfe41d",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/ll7qIcIWWGFSsORHr4yY-UuqAe8h.m4a",
            "play_count": 268023,
            "show_notes_text": "姚顺宇戴了一副茶色眼镜走过来，这副眼镜会随光线变化而改变颜色。\n\n硅谷AI业界有两位Yao Shunyu，他们曾是清华同一届毕业生，这让姚顺雨与姚顺宇时常成为话题人物。\n\n前一位姚顺雨2025年从OpenAI跳槽到腾讯，他去年来过我们节目（第115集）；后一位姚顺宇也于同年跳槽，从Anthropic来到Google DeepMind。\n\n今天的嘉宾姚顺宇，毕业于清华和斯坦福大学，曾经的研究方向是理论物理——非厄米系统、量子物理与高能物理。他的人生奋斗姿态是——“总想挑战一些自己不太会的事”。\n\n他人生最大的一次跨步是博士毕业，毅然决然离开深造9年的物理，来到崭新的AI行业。过去两年，他先后在Anthropic和Google DeepMind出任研究科学家，参与了Claude 3.7、4.5、Gemini 3等关键模型的开发过程。\n\n姚顺宇一点也不nerd。有时，他会令你猝不及防，突然发表一点“小疯”言论。\n\n第一次见面，他就对我说：“我在这个行业又没有什么导师，又没有什么旧友，我当然想喷谁喷谁。”\n\n转行AI的两年，他变得越来越直接，越来越不害怕得罪人。访谈中，他也说了一些直白言论：\n\n“AI个人英雄主义时代已经过去了，所以也没有什么英雄，有时候甚至觉得旧时代英雄有点蠢。”\n\n“没有哪个老登是你的亲属，所以你觉得他傻，他就是傻，就可以直接说他傻。无所谓的啊。（笑）”\n\n“现在大家都是冲浪的人，本质上是那个浪，而不是你那个冲浪的人。”\n\n“AI这个事，本来也不太需要脑子——真的不太需要脑子。这个行业最重要的特质，就是靠谱，就是做事细，对自己做的事情负责任。”\n\n“你不用太担心因为自己的观点而惹到什么人。只要你的观点是自洽的，不是说随便喷人，你是有一套自己的理解。最终你在这个领域做的怎样，是有客观评价标准的——大家是会尊重你的。”\n\n不过，在描述自己的研究时，姚顺宇又显得异常审慎。\n\n他对于这些工作的描述是：“我自己对那个事没那么重要，更多的是，我很幸运，有机会在那个时候加入了一个重要的项目，做了一些事。”\n\n他反复强调，AI个人英雄主义的时代已经过去了，现在都是集体主义的故事，要对神话个体的一切叙事充满警惕。\n\n我们的节目录制于2026年3月，距离我们这次节目录制完，世界又发生了许多意想不到的变化：Meta对Manus的收购被撤销、Cursor可能被SpaceX收购、xAI将终止独立运营并入SpaceX，并更名为SpaceXAI等等。如果我们的谈话内容有一定滞后性，请大家多包涵——AI的世界实在变化太快、太出乎意料了。\n\n可能还要特别说明的一点是，技术细节会涉及企业机密，有一些嘉宾是不方便分享的，也请大家能够包容。\n\n在访谈中，我们尽最大可能和大家一起学习AI。你会收获姚顺宇在Anthroic和Google Gemini的技术探索历程与思考洞察。\n\n而对于那些离经叛道的微小片刻，还请允许我们小疯一下。\n\n接下来，就是我对顺宇的访谈。\n\nOUTLINE:\n\n00:02:41 两个Shunyu Yao\n\n00:06:50 竞争与逃逸\n\n00:26:37 “Pre-train没有到头”\n\n00:36:23 Coding的爆发\n\n00:51:25 字节和豆包\n\n00:54:45 \"硬蒸\"和\"聪明的蒸\"\n\n01:05:22 机器人\n\n01:10:00 在Underdog之地赌一把\n\n01:20:59 非厄米系统与量子物理\n\n01:37:42 高能物理\n\n01:44:24 物理与AI\n\n01:53:47 在Anthropic训练Claude 3.7、4.5\n\n02:36:18 \"AI本质是简单的\"\n\n02:42:25 在Google DeepMind训练Gemini 3\n\n03:02:43 \"Pre-train也是一种RL\"\n\n03:08:04 技术预测\n\n03:14:06 组织搭建\n\n03:24:48 集体主义胜利\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\n本集的文字版：《独家对话姚顺宇：请允许我小疯一下》\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "第115集",
                "url": "https://www.xiaoyuzhoufm.com/episode/68c29ca12c82c9dccadba127"
              },
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "《独家对话姚顺宇：请允许我小疯一下》",
                "url": "https://mp.weixin.qq.com/s/Vy4IINteDQFrdr9cffKMhA"
              },
              {
                "text": "https://image.xyzcdn.net/nuzHJVCagytHsVtjj4x0zsuw2C9l.png",
                "url": "https://image.xyzcdn.net/nuzHJVCagytHsVtjj4x0zsuw2C9l.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3800,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69f3857a5c60a99573fea0c2",
            "index": 5,
            "title": "139. 【Agent的综述】和苏煜聊Agent技术史、OpenClaw Moment、边界的消弭和社会的辐射",
            "pub_date": "2026-05-01T00:00:00.000Z",
            "duration": "8268",
            "duration_label": "2h 17m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 5,
            "matched_keywords": [
              "AI",
              "Agent",
              "Coding",
              "创业",
              "科技"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69f3857a5c60a99573fea0c2",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/luffrgudEiiGHQxam49tfQci63NO.m4a",
            "play_count": 66755,
            "show_notes_text": "前面在福莉和广密的节目中，我们深入揭示了AI的进化从第一幕Chat走向第二幕Agent。可以说，Agent是2026年的高频词。\n\n关于Agent，我一直非常希望深入技术原理层，给大家做一次技术讲解，能够让我们一起非常清晰地了解技术的脉络。\n\n今天我邀请的是俄亥俄州立大学计算机系教授、也是创业公司NeoCognition创始人，苏煜。苏煜是少数见证过Agent演化史的学者，研究方向是Language Agent。我们从更长周期复盘了Agent的技术演进史，尤其是最近三年Language Agent的快速进化。此外，苏煜也是2025年“斯隆研究奖”得主。\n\n接下来，是我们对Agent的技术综述。\n\n祝大家五一假期学习快乐啦^。^\n\nOUTLINE:\n\n00:02:00 苏煜是谁\n\n00:03:30 Agent的技术演进史：从Logical Agent（1960-90s） → Neural Agent（2000年以后，神经代理）  → Semantic Parsing（另一边的故事，语义解析） → Language Agent（语言代理）\n\n00:27:21 人类的进化史来说，语言非常晚发生，但对人类文明有了指数型发展\n\n00:29:28 过去三年发展速度比过去几十年都要快，复盘Language Agent上的关键工作\n\n00:40:56 At the end of the day，大家想要的就是universal digital agent；边界的消弭和coding有关\n\n00:45:18 我是最早从Semantic Parsing转型做Language Agent的学者之一\n\n00:48:56 OpenClaw Moment和ChatGPT Moment有非常多相似的地方\n\n00:55:10 中美科技辐射的pattern不同，中国更全民化，在应用层的动作更快\n\n01:02:05 创业新公司NeoCognition，最近融完了一轮$40M的seed round\n\n01:20:30 聊聊Continual Learning、世界模型、交互（GUI vs. CLI）\n\n01:44:34 Agent现在最大的瓶颈是什么？对2026年Agent进展的预期？\n\n01:47:09 各个大厂都在Agent上bet什么，有什么有意思的bets？\n\n01:52:47 我们这一代人经历了Agent的完整周期，我喜欢搭建conceptional framework\n\n02:10:13 最后的快问快答\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "https://image.xyzcdn.net/nl-uMq2sthj3H5NjjTRunzPceVUJ.png",
                "url": "https://image.xyzcdn.net/nl-uMq2sthj3H5NjjTRunzPceVUJ.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1864,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69eae15a1e94ae692107cc50",
            "index": 6,
            "title": "138. 对罗福莉3.5小时访谈：AI范式已然巨变！OpenClaw、Agent范式很吃后训练、卡的分配、组织平权",
            "pub_date": "2026-04-24T03:44:26.609Z",
            "duration": "12996",
            "duration_label": "3h 36m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "Agent",
              "大模型"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69eae15a1e94ae692107cc50",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lvjthrP5i6nloL64YOJ_JDDRa4WF.m4a",
            "play_count": 122914,
            "show_notes_text": "2026年，大模型战争全面升级，掀开了第二幕——从Pre-train（预训练）主导的Chat时代，转向Post-train（后训练）主导的Agent时代。\n\n在AI范式巨变之际，我访谈了人工智能研究员罗福莉。罗福莉曾供职阿里达摩院、DeepSeek，目前是小米大模型团队负责人，主导研发了MiMo-V2系列模型。她在网络空间有很多标签，例如“AI天才少女”，但她不喜欢这个称呼。\n\n这次是她的第一次访谈，也是她第一次进行长时间的技术访谈。\n\n我们系统性地谈论了，2026年由Claude Opus 4.6、OpenClaw等技术变量所触发的AI巨震，以及后续结构性影响。\n\n在这个生产力大爆炸的时代，人人都有危机感。哪怕是对于亲手训练模型的研究者来说。\n\n“我之前认为我们自己做的工作已经足够有创造力、足够不会被Skill化、不会被Workflow化。但我现在发现，它竟然也能！那它可不可以训出更强的模型？自己左脚踩右脚就提升了？——这是这一两年会发生的事情。”\n\n当人类的知识与智慧内化为模型能力，未来的人类去做什么？我们的社会如何消化这次剧烈的技术变革？——这些宏大的时代命题我们不得而知。\n\n但无论如何，这仍然是一次信息密度极大的访谈——你能从中看见，当面临一次巨大技术范式转折时，一家AI Lab内部，在技术押注、资源调配、组织与人员等诸多方面的系列举措。而它应对巨变的根基是，文化与价值观的成型。\n\n罗福莉对当下有一些关键的技术判断：  Anthropic的路径是正确的，这是当下共识。\n  在路径更清晰的情况下，国内大模型团队进入加速追赶的状态。现在大家在Pre-train上的代差是基本没有的，或者说非常接近。\n  现在至少跟23年要去追平Pre-train的差距一样，大家很all in，要去做好Agent的Post-train。更具体说，是在Agent上怎么做好RL的scaling。\n  系统从“以Rollout推理引擎为核心”，转变为“以Agent为核心”的一个更复杂系统。这对团队提出了更高的要求：必须具备足够敏捷性，能够快速开发出适配当前时代的RL Infra系统。\n  接下来两三个月，大家怎么发生变化，是考验团队整体研究水平、技术敏捷程度，以及怎么拥抱新的范式来做研究的关键。\n  一个for更长期的事情：我们不会在1T水平上走太久。如果要拿到下一个阶段的领先，就要寻求更大规模scaling。到底是去scaling模型的参数量，还是去scaling什么东西？以及要在什么样的芯片上去scaling？——这是当下立即需要去决策和判断的，这才决定了大半年过后谁更领先。\n在卡的调配上：  至少在Chat时代，for研究、for Pre-train和for Post-train的用卡比例非常夸张，比如3比5比1，现在一个非常合理的用卡比例可能是3比1比1。\n  预训练跟后训练一个比例，这是今年可能发生的很大变化。顶尖团队应该都是1比1了。\n在组织的重组上：  做后训练现在一个重要的范式变化是，需要具备diversity（多样性），让预训练的人做后训练是个很好的补充。\n“接下来两三个月会非常精彩。”罗福莉称。\n\n接下来，就是我对罗福莉的访谈。\n\nOUTLINE:\n\n00:02:16 OpenClaw引发巨变\n\n00:24:17 群体智能提升Agent框架\n\n00:41:31 2026是生产力变革之年\n\n01:01:45 Agent的自进化与自迭代\n\n01:19:39 MiMo-V2：觉醒和伏击\n\n01:45:24 1T模型是入场券\n\n01:52:33 组织平权\n\n02:02:56 训练细节和成本\n\n02:09:03 另类架构\n\n02:22:32 AI没有生存危机\n\n02:39:12 每天在否认昨天的自己\n\n02:48:34 过去3年的AI进化史\n\n03:05:54 当下共识与竞争\n\n03:19:45 环境比经验更重要\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\n本集文字版：《独家对话罗福莉：AI范式已然巨变！》\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "《独家对话罗福莉：AI范式已然巨变！》",
                "url": "https://mp.weixin.qq.com/s/zqnJuv5OVsNGEefM7RguqQ"
              },
              {
                "text": "https://image.xyzcdn.net/liHw2J2Qjpr_C1kn_8Dlpx5DE9YA.png",
                "url": "https://image.xyzcdn.net/liHw2J2Qjpr_C1kn_8Dlpx5DE9YA.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3832,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69e4e6951d989496e7fecc7b",
            "index": 7,
            "title": "137. 对洪乐潼的4小时访谈：AI for Math、把数学变成Lean、数学天书中的证明、直觉、被创造与被发现的",
            "pub_date": "2026-04-20T03:00:00.000Z",
            "duration": "15857",
            "duration_label": "4h 24m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "创业",
              "商业"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69e4e6951d989496e7fecc7b",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lha_FAiWxTGet0QMbcOSts3cb5Vb.m4a",
            "play_count": 41102,
            "show_notes_text": "2026年，美国诞生了一系列的Neo Labs（新型研究室）。Neo Labs是近年兴起的一个新概念，专指由顶级AI研究者创立、以基础模型或新一代智能体系为目标、融资规模巨大、研究导向很强的一类新型AI实验室。我们133集的嘉宾，来自AMI Labs的谢赛宁是，今天我们邀请的是另外一位。\n\n她是《商业访谈录》至今最年轻的一位嘉宾，是一位00后华人女孩，网络空间有人会叫她“数学少女”——她的名字是洪乐潼Carina，这是她第一次接受中文访谈。\n\n她探索的方向是AI for Math，所创办的公司Axiom（公理）刚完成2亿美元的A轮融资，估值16亿美金。\n\n而她引起很多人的关注，来自于这样一条新闻：57岁美国终身教授小野肯（Ken Ono）突然辞职，去给24岁的华人女孩打工。\n\n我们谈论了许多数学与美、被创造的与被发现的数学、数学天书中的证明与公理、最不可能的创业者的创业旅途，当然还有AI for Math。\n\n接下来，是我对洪乐潼的访谈。\n\nOUTLINE:\n\n00:02:14 被创造的与被发现的\n\n00:14:38 bounded vs free attention\n\n00:32:14 对苦难上瘾\n\n00:50:21 数论多美啊!\n\n01:02:26 Verve Coffee\n\n01:16:23 最不可能创业的创业者\n\n01:38:33 没有人喜欢融资\n\n02:07:17 小野肯的邮件\n\n02:19:51 数学天书中的证明\n\n02:24:38 Al for Math\n\n03:03:50 把数学变成Lean\n\n03:09:59 数学家的直觉\n\n03:26:18 登月要么成功，要么失败\n\n03:54:17 与数学家共进晚餐\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "https://image.xyzcdn.net/Ft9tIYtQyxYe9oeth-OgGbIYt1A9.png",
                "url": "https://image.xyzcdn.net/Ft9tIYtQyxYe9oeth-OgGbIYt1A9.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 5853,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69de68cfb977fb2c47f1ee14",
            "index": 8,
            "title": "136. 全球大模型季报第9集：和广密聊，Coding是AGI第二幕、硅谷御三家真相、模型正成为新一代OS",
            "pub_date": "2026-04-14T23:30:00.000Z",
            "duration": "4960",
            "duration_label": "1h 22m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 8,
            "matched_keywords": [
              "AI",
              "Agent",
              "OpenAI",
              "Coding",
              "机器人",
              "大模型",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69de68cfb977fb2c47f1ee14",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lh_CQyoSs_DztmYB5kmBjaPA6W9V.m4a",
            "play_count": 78709,
            "show_notes_text": "今天给大家带来的是全球大模型季报第9集，这一集的情绪十分复杂。\n\n一方面，你会看到正在急速进化的AI革命。Coding把AI从聊天机器人Chatbot第一幕，推向了能够干活的Agent第二幕。研究员们已经不再亲自写代码。广密带来的核心判断是，Coding是新的”AI加速器\"，正在加速AGI实现，领先的Coding模型就像领先的GPU。\n\n另一方面，社会层面随之进入白领通缩与失业的窗口。整个社会准备好了应对这么剧烈变化的AI革命吗？\n\nOUTLINE:\n\n00:02:00 第9集季报的概览\n\n00:03:28 硅谷体感与洞察\n\n过去一个Q，智能水平进步幅度赶上2025全年，推背感非常强，AI奇点时刻应该很快就到\n\n最关键转折点就是Opus 4.5 → Opus 4.6模型，算是GPT-3 → GPT-4跨代际提升的模型\n\n今年6月之前可能还会再有一个从GPT-3→4水平幅度的跨越，OpenAI/Anthropic新模型都很强，Mythos/Spud下一代也开始训练了，继续加速\n\nCoding会是头部的放大器，最顶尖1的人才能放大10-50倍的生产力\n\n你是否相信Code可以表达数字世界的绝大多数任务？“语言即世界，代码即方案”\n\n如果领先的模型公司不重视Coding，大概率会掉出第一梯队\n\nCoding就像Amazon最早卖书一样，借助卖完书把所有仓储物流用户全都拉通了\n\nCoding在整个AGI的历史进程中处在什么位置？\n\n做好Coding的难点到底在哪里？不只是技术knowhow，更是战略组织和文化问题\n\n00:22:10 硅谷御三家内部真实情况\n\n00:22:10 Anthropic\n\nAll in Coding不是day1这个团队就想清楚的\n\n创始人特别hands-on亲自看训练数据，重视数据和重视技术细节刻在基因里\n\n偏好“underdog”而非大人物，文化面试非常严格，尤其是看重一个人的文化特质\n\n00:33:35 OpenAI\n\n在这个时代的过去胜利秘诀，可能是下个时代的毒药\n\n过去OpenAI在ChatGPT的成功，让他们专注ToC忽视了Coding\n\n重点说下OpenAI做的不好的地方，可以在构建组织的时候借鉴一下\n\nOpenAI即将要发布的新模型，是真正意义上的GPT-5吧\n\n00:47:13 Gemini\n\nGemini 3被高估\n\nCoding严重落后，Google最大的战略失误\n\nGoogle是最领先的追随者，资源和布局上没啥绝对短板，但战略跟随OpenAI/Anthropic，掉队可能性很低\n\n00:54:16 Meta TBD\n\n最有机会的挑战者，已经取代xAI，成为硅谷4号种子\n\n00:58:07 xAI\n\nxAI短期基本上掉队了，最大问题感觉也是战略摇摆\n\n崩溃始于founding team逐渐离开\n\n01:02:00 Harness Engineering\n\n01:03:57 中国御三家\n\n01:05:42 模型是新一代操作系统\n\n01:07:01 潜在的社会影响，失业、通缩\n\n01:14:36 硅谷新趋势和投资新思考\n\n《全球大模型季报》系列追踪：2023: 54. 口述全球大模型这一年：人类千亿科学豪赌与参差的中美景观\n\n2024Q1: 64. 和广密聊AGI大基建时代：电+芯片=产出智能\n\n2024Q2: 69. 口述全球大模型这半年：Perplexity突然火爆和尚未爆发的AI应用生态\n\n2024Q3: 73. AGI范式大转移：和广密预言草莓、OpenAI o1和self-play RL｜全球大模型季报4\n\n2024Q4: 86. 大模型季报年终特辑：和广密预言LLM产品超越Google之路\n\n2025Q1: 97. 25年Q1大模型季报：和广密聊当下最大非共识、AGI的主线与主峰\n\n2025Q2-Q3: 112. 和广密聊大模型季报：分化与收敛、全家桶与垂直整合、L4体验与挖矿窗口\n\n2025Q4: 127. 大模型季报跨年对谈：和广密预言一场AI War、两大联盟和第三个范式Online Learning\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "54. 口述全球大模型这一年：人类千亿科学豪赌与参差的中美景观",
                "url": "https://www.xiaoyuzhoufm.com/episodes/65910adb991e2ee60880f151"
              },
              {
                "text": "64. 和广密聊AGI大基建时代：电+芯片=产出智能",
                "url": "https://www.xiaoyuzhoufm.com/episodes/661f21075dae7932c6f821d8"
              },
              {
                "text": "69. 口述全球大模型这半年：Perplexity突然火爆和尚未爆发的AI应用生态",
                "url": "https://www.xiaoyuzhoufm.com/episodes/667774b3b6a84127299efd5a"
              },
              {
                "text": "73. AGI范式大转移：和广密预言草莓、OpenAI o1和self-play RL｜全球大模型季报4",
                "url": "https://www.xiaoyuzhoufm.com/episodes/66d866f0f39a2201c069dccb"
              },
              {
                "text": "86. 大模型季报年终特辑：和广密预言LLM产品超越Google之路",
                "url": "https://www.xiaoyuzhoufm.com/episodes/6766a52a15a5fd520e6c86a9"
              },
              {
                "text": "97. 25年Q1大模型季报：和广密聊当下最大非共识、AGI的主线与主峰",
                "url": "https://www.xiaoyuzhoufm.com/episodes/67e9614b8eecdbeb601ac5fe"
              },
              {
                "text": "112. 和广密聊大模型季报：分化与收敛、全家桶与垂直整合、L4体验与挖矿窗口",
                "url": "https://www.xiaoyuzhoufm.com/episodes/68a370be293471fed447c691"
              },
              {
                "text": "127. 大模型季报跨年对谈：和广密预言一场AI War、两大联盟和第三个范式Online Learning",
                "url": "https://www.xiaoyuzhoufm.com/episodes/694bbc49d996dd7bfddeecbf"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 883,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69d8bbdfe2c8be3155dcc2fe",
            "index": 9,
            "title": "135. 和自然选择创始人Tristan聊，Elys、赛博分身、灵魂、Context的获取与流动和AI社交网络",
            "pub_date": "2026-04-10T09:08:49.137Z",
            "duration": "6774",
            "duration_label": "1h 52m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "Agent",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69d8bbdfe2c8be3155dcc2fe",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/ltwEGwVo7grn_V-Rft0TXlMqmcty.m4a",
            "play_count": 24534,
            "show_notes_text": "春节节后，一款AI native产品Elys引起了小圈层人的关注，这是一款还在测试，尚且没有全面上线的AI社交产品。某种程度上，它展现了AI时代社交产品的一些雏形：打造赛博分身、分身替你去主动社交、为你转化成真实世界的连接。\n\n今天我邀请了自然选择创始人Tristan（张筱帆）来聊聊。他们公司目前有两款产品，分别是AI游戏Eve和AI社交Elys，它们背后的精神内核都是：“人类太孤独了。”\n\n接下来，就是我对Tristan的访谈。\n\nOUTLINE：\n\n02:00 做过陌生人社交、恋爱游戏\n\n10:53 毫不犹豫地成立了新公司自然选择，毫不犹豫地做Eve\n\n13:23 陪你一起面对世界的Agent\n\n16:23 Elys想法雏形，我终于想清楚了AI社交网络应该怎么做：Context的流动\n\n20:32 最大的范式转移：传统互联网是低维标签化信息，新的互联网第一次有了Context\n\n23:05 Elys产品设计的关键、难点、双重冷却\n\n36:56 接下来AI时代唯一重要的事情是，构建主体性\n\n45:17 交出Context与用户隐私的博弈\n\n48:20 Elys是不是AI版的Tinder？\n\n54:35 中国拥有最多Context的公司是谁？（微信？小红书？即刻？）\n\n56:20 定义什么是好的Context？\n\n01:00:02 AI时代社交 vs 互联网时代社交\n\n01:15:15 未来的社交网络\n\n01:21:48 ChatGPT可能拓展的社交网络\n\n01:28:10 和模型公司的竞争（“我觉得完全不用自己训模型”）\n\n01:33:42 北极星指标：真人的连接率\n\n01:34:05 你担心Elys是昙花一现的产品吗？\n\n01:41:15 我们现在处于终极忙碌“前进4”状态\n\n01:46:02 做AI产品和做互联网产品的本质区别（Proactive！）\n\n01:49:16 人类太孤独了\n\n*对了，我们提到的小实验会在Elys上线时来做:)\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "https://image.xyzcdn.net/FgCyNByOtmFms8CiR5kNFPckUoJR.png",
                "url": "https://image.xyzcdn.net/FgCyNByOtmFms8CiR5kNFPckUoJR.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1695,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69c953b4b977fb2c478df5c3",
            "index": 10,
            "title": "134. 【数据的综述】和谢晨聊，新时代的石油、历史、版图、数据金字塔、定价与Recipe",
            "pub_date": "2026-03-30T00:00:00.000Z",
            "duration": "9502",
            "duration_label": "2h 38m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "机器人"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69c953b4b977fb2c478df5c3",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lkInPy65_ZR4cQmK23rmHJ_hhLVQ.m4a",
            "play_count": 39083,
            "show_notes_text": "2026年，除了嘉宾访谈，我们也很希望推出一些内部人士的产业单集。今天就是这样的一次尝试。\n\n我们知道数据、算力、算法，是驱动人工智能的三驾马车。今天这集节目我们邀请我们的返场嘉宾、光轮智能创始人兼CEO谢晨，试图通过一集节目完整聊聊这其中一架马车——数据。我们尝试来做一个“数据的产业综述”。\n\n大语言模型的数据遇到撞墙的难题，机器人的数据则处于一片荒漠中。数据产业是如何运转的？一些人正在探索的仿真数据、数据金字塔等将如何改变产业格局？\n\nOUTLINE：\n\n00:01:07 寻觅\n\n00:20:09 综述\n\n00:41:39 共生\n\n00:48:30 势力\n\n01:06:56 历程\n\n01:14:45 迹象\n\n01:32:00 对照\n\n01:42:40 金字塔\n\n01:55:31 定价\n\n02:02:50 Recipe\n\n02:17:06 版图\n\n02:28:52 终点\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "https://image.xyzcdn.net/FgCyNByOtmFms8CiR5kNFPckUoJR.png",
                "url": "https://image.xyzcdn.net/FgCyNByOtmFms8CiR5kNFPckUoJR.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 1869,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "69b77577f8b8079bfa8eb837",
            "index": 11,
            "title": "133. 对谢赛宁的7小时马拉松访谈：世界模型、逃出硅谷、AMI Labs、两次拒绝Ilya、杨立昆、李飞飞和42",
            "pub_date": "2026-03-16T04:01:08.137Z",
            "duration": "24329",
            "duration_label": "6h 45m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 5,
            "matched_keywords": [
              "AI",
              "机器人",
              "创业",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/69b77577f8b8079bfa8eb837",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lqXBPXddXfukbdlAP-NDrFNp-2wn.m4a",
            "play_count": 158299,
            "show_notes_text": "2026年春节，在中国机器人登上春晚的喜乐时分，纽约刚下过一场暴雪——这是近几年以来纽约最凛冽的一个冬天。\n\n2月雪后的一天，在布鲁克林一栋略显凌乱的楼房，我与谢赛宁开启了这场始料未及的马拉松式访谈。我们从下午2点开始，直到凌晨时分散去。\n\n就在前不久，他与图灵奖得主杨立昆（Yann LeCun）等，踏上了一条关于“世界模型”的创业旅程。他们创立的AMI Labs（Advanced Machine Intelligence Labs），目前仅25人、在没有任何产品的情况下，完成10.3亿美元Seed轮融资，投前估值35亿美元。\n\n“Silicon Valley is very LLM-pilled。”AMI联合创始人兼首席科学官谢赛宁说道，“硅谷已经深陷于LLM（大语言模型），完全被它催眠了。”\n\n这位出生于1990年的华人科学家，毕业于上海交通大学与加利福尼亚大学圣地亚哥分校，现于纽约大学任教。创业之前，他曾在Google DeepMind担任研究科学家。更早之前，他在Meta的FAIR实验室担任研究科学家4年。他的论文总计引用数近10万次，曾共同提出Diffusion Transformers（DiT）。\n\n这是谢赛宁第一次接受访谈。在黑暗浸透的霓虹纽约街头，空气中弥漫着没化完冰雪与难闻烟雾的混合味道。就像谢赛宁的表达，总是带着多重的混合感。\n\nOUTLINE:\n\n00:01:19 The normal one\n\n00:35:40 世界总不让我做Vision\n\n00:52:06 学术流浪\n\n00:57:43 与何恺明的友谊\n\n01:21:05 两次拒绝了Ilya\n\n01:37:50 杨立昆和李飞飞往事\n\n01:58:30 草蛇灰线：“表征的世界”\n\n02:43:55 Research taste与《金刚经》\n\n04:11:07 世界模型是什么？\n\n04:29:47 从下载互联网，到下载人类\n\n04:58:17 和杨立昆创立AMI始末\n\n05:45:53 “硅谷被催眠了”\n\n06:07:17 自大的人类！\n\n06:18:45 “42”\n\nLINKS：\n\n我们的播客在小宇宙、Apple Podcast、Spotify等全音频平台播出；\n\n我们的视频播客在Bilibili、小红书、视频号、抖音等全视频平台播出；\n\n如果你想服用文字版，请搜索我们工作室的公众号：语言即世界language is world。\n\n本集的文字版：《对话谢赛宁：逃出硅谷！》\n\nDISCLAIMER: 本内容不作为投资建议。\n\nCONTACT: xiaojunzhang@lisw.ai\n\nJump into the new world-and explore with us!😉",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "小宇宙",
                "url": "https://www.xiaoyuzhoufm.com/podcast/626b46ea9cbbf0451cf5a962"
              },
              {
                "text": "Apple Podcast",
                "url": "https://podcasts.apple.com/cn/podcast/%E5%BC%A0%E5%B0%8F%E7%8F%BAj%C3%B9n-%E5%95%86%E4%B8%9A%E8%AE%BF%E8%B0%88%E5%BD%95/id1634356920"
              },
              {
                "text": "Bilibili",
                "url": "https://b23.tv/FZ0s2Q1"
              },
              {
                "text": "小红书",
                "url": "https://xhslink.com/m/4clvm6edHk1"
              },
              {
                "text": "《对话谢赛宁：逃出硅谷！》",
                "url": "https://mp.weixin.qq.com/s/PIOh_aXVuNUT27G5UoKCkw"
              },
              {
                "text": "https://image.xyzcdn.net/FjP3uQ6Hjle0Jf8Z50TCz0ZuAFS3.png",
                "url": "https://image.xyzcdn.net/FjP3uQ6Hjle0Jf8Z50TCz0ZuAFS3.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 9780,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "698ebb0b66e2c30377510cf6",
            "index": 12,
            "title": "132. 对星海图创始人高继扬的3小时访谈：鲶鱼、曾国藩、Waymo与Momenta的两面、一只狼与许华哲的离开",
            "pub_date": "2026-02-13T10:00:00.000Z",
            "duration": "11092",
            "duration_label": "3h 4m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "机器人"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/698ebb0b66e2c30377510cf6",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lplNqS9I0z2b64zp9zF2h6EkhXjr.m4a",
            "play_count": 48856,
            "show_notes_text": "我一直有一个疑惑，为什么在中国具身智能行业里，至今我尚且没有遇到像梁文锋、杨植麟这样带有浓重的技术浪漫主义色彩的人。这让我有时有点失落。\n\n直到我认识了高继扬，他似乎是技术浪漫的反面，追求极致的效率、生存与工程拆解。\n\n这次的访谈时候，星海图的联合创始人许华哲正要离职。这也许是某种信号。\n\n高继扬告诉我，机器人是一个链条极长的的行业——很大程度上，你要把头伸进泥土里。\n\n接下来，就是我对星海图创始人兼CEO高继扬的访谈。\n\n期待2026年，我们和AI共同进步！\n\n00:01:49 冲刺型小孩\n\n00:12:07 学习曾国藩\n\n00:25:30 提高顶会命中概率\n\n00:33:46 Waymo是没有创始人的\n\n00:55:38 Momenta是极致的反面\n\n01:02:25 鲶鱼\n\n01:19:26 从一份糟糕的BP开始\n\n01:35:26 挣扎着做整机和供应链\n\n01:49:32 Data Recipe\n\n02:16:33 机器人大脑\n\n02:29:37 许华哲的离开\n\n02:39:04 我们天然要到土里去\n\n02:51:58 狼\n\n《对DeepMind谭捷的访谈：机器人、跨本体、世界模型、Gemini Robotics 1.5和Google》\n\n《和王鹤聊，具身智能的学术边缘史和资本轰炸后的人为乱象》\n\n《逐篇讲解机器人基座模型和VLA经典论文——“人就是最智能的VLA”》\n\n【更多信息】\n\n免责声明：本内容不作为投资建议。",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "《对DeepMind谭捷的访谈：机器人、跨本体、世界模型、Gemini Robotics 1.5和Google》",
                "url": "https://www.xiaoyuzhoufm.com/episodes/692965c0ba2292550f3551f7"
              },
              {
                "text": "《和王鹤聊，具身智能的学术边缘史和资本轰炸后的人为乱象》",
                "url": "https://www.xiaoyuzhoufm.com/episodes/6857f2174abe6e29cb65d76e"
              },
              {
                "text": "《逐篇讲解机器人基座模型和VLA经典论文——“人就是最智能的VLA”》",
                "url": "https://www.xiaoyuzhoufm.com/episodes/67f28c6e0decaeb0943fb14a"
              },
              {
                "text": "https://image.xyzcdn.net/Flo18nNUSP7OUNlTf8UgCdHxio6O.jpg",
                "url": "https://image.xyzcdn.net/Flo18nNUSP7OUNlTf8UgCdHxio6O.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/Fm2F9n8vMm_n-xafqMi98xs3T3K8.png",
                "url": "https://image.xyzcdn.net/Fm2F9n8vMm_n-xafqMi98xs3T3K8.png"
              },
              {
                "text": "https://image.xyzcdn.net/FjpqSnIzje6iPWbSgkkZCU7IFWFM.png",
                "url": "https://image.xyzcdn.net/FjpqSnIzje6iPWbSgkkZCU7IFWFM.png"
              },
              {
                "text": "https://image.xyzcdn.net/FvV-R5FBydYHGZAMyXAV1K1A9iJT.png",
                "url": "https://image.xyzcdn.net/FvV-R5FBydYHGZAMyXAV1K1A9iJT.png"
              },
              {
                "text": "https://image.xyzcdn.net/FvVbUNblF7FHIjfdp3MmmbAdLZ8G.png",
                "url": "https://image.xyzcdn.net/FvVbUNblF7FHIjfdp3MmmbAdLZ8G.png"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2765,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6976bdf0ef1cf272a76fa9f3",
            "index": 13,
            "title": "131. 印奇出任阶跃星辰董事长的访谈：聪明人的诱惑、取舍、超长链路残酷淘汰赛、阶跃函数和超多元方程",
            "pub_date": "2026-01-26T01:30:13.125Z",
            "duration": "7287",
            "duration_label": "2h 1m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 4,
            "matched_keywords": [
              "AI",
              "大模型",
              "创业",
              "科技"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6976bdf0ef1cf272a76fa9f3",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/lo-xQNj9qSh16zHeUQI6pQ3jOkjq.m4a",
            "play_count": 52847,
            "show_notes_text": "今天的嘉宾是印奇。\n\n他在担任智能汽车技术公司千里科技的董事长之外，最近也迎来一个新的身份：出任大模型公司阶跃星辰的董事长。\n\n这次，我和他聊了聊新身份、新阶段与从AI 1.0到2.0转轨与反思。\n\n接下来是我对印奇的访谈。\n\n期待2026年，我们和AI共同进步！\n\n01:31 一个新的身份\n\n15:14 残酷的淘汰赛和赌注\n\n21:09 重新定义阶跃星辰\n\n45:00 打后发战役\n\n53:03 AI 1.0到2.0的转轨与反思\n\n01:14:32 聪明人的诱惑、技术信仰与技术投机\n\n01:37:35 预判\n\n01:42:27 姚班、创业和超多元方程\n\n《和张祥雨聊，多模态研究的挣扎史和未来两年的2个“GPT-4时刻”》\n\n【更多信息】\n\n免责声明：本内容不作为投资建议。",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "《和张祥雨聊，多模态研究的挣扎史和未来两年的2个“GPT-4时刻”》",
                "url": "https://www.xiaoyuzhoufm.com/episodes/683d2ceb38dcc57c641a7d0f"
              },
              {
                "text": "https://image.xyzcdn.net/Flo18nNUSP7OUNlTf8UgCdHxio6O.jpg",
                "url": "https://image.xyzcdn.net/Flo18nNUSP7OUNlTf8UgCdHxio6O.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/Fm2F9n8vMm_n-xafqMi98xs3T3K8.png",
                "url": "https://image.xyzcdn.net/Fm2F9n8vMm_n-xafqMi98xs3T3K8.png"
              },
              {
                "text": "https://image.xyzcdn.net/FppfGV1QEmLbwz80t6C0YjgpMpF8.png",
                "url": "https://image.xyzcdn.net/FppfGV1QEmLbwz80t6C0YjgpMpF8.png"
              },
              {
                "text": "https://image.xyzcdn.net/FvV-R5FBydYHGZAMyXAV1K1A9iJT.png",
                "url": "https://image.xyzcdn.net/FvV-R5FBydYHGZAMyXAV1K1A9iJT.png"
              },
              {
                "text": "https://image.xyzcdn.net/FvVbUNblF7FHIjfdp3MmmbAdLZ8G.png",
                "url": "https://image.xyzcdn.net/FvVbUNblF7FHIjfdp3MmmbAdLZ8G.png"
              },
              {
                "text": "https://image.xyzcdn.net/Fn7o36NtUYpCM_rQiFj1LW-TIwk8.JPG",
                "url": "https://image.xyzcdn.net/Fn7o36NtUYpCM_rQiFj1LW-TIwk8.JPG"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2052,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6970c1e0109824f9e1c60e7a",
            "index": 14,
            "title": "130. 张月光创业两年首次访谈：妙鸭不是AI Native产品、流程到上下文设计、One Way Door和乙女游戏",
            "pub_date": "2026-01-22T00:00:00.000Z",
            "duration": "11655",
            "duration_label": "3h 14m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 7,
            "matched_keywords": [
              "AI",
              "Agent",
              "Coding",
              "创业",
              "商业",
              "硅谷",
              "产品"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/6970c1e0109824f9e1c60e7a",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/loO-1ybVpymqgCDLe0P0iLTL9ueO.m4a",
            "play_count": 49546,
            "show_notes_text": "过去两年，张月光仿佛消失了。\n\n这位产品经理在2023年创造过妙鸭这样现象级AI产品，但在妙鸭走红后，仅3个月他便从阿里辞职。他说，这源于他独自在日本京都的鸭川边，坐了一夜，想清楚了许多重要的人生决定。\n\n2024年初，张月光筹措资金，创业沐言智语。这家公司成为那年AI应用型公司里融资额最高的初创公司之一。\n\n有人说，投资人在没有产品的情况下，对他“盲注”4轮，累计金额近三亿元人民币。也有人开玩笑，张月光是在拿着融资额的利息养公司。\n\n过去两年，我和张月光见了很多次，他在尝试的产品形态每一次都有一些变化，他也并不掩饰自己的困惑，坦言的确有一段时间“看不懂”。转折来自半年前。\n\n一位师承于互联网时代的产品经理，当他转向AI，会经历怎样的试错与求索？又要跨越怎样的认知鸿沟？——让我无比意外的是，张月光说，他后来才意识到，妙鸭根本不是AI Native的产品。\n\n沐言智语现阶段正在做的有两款主力产品：AI乙女游戏《星眠》，和即将要推出的Agent产品Dokie。他说，他的探索期结束了，他终于找到那个他愿意集公司之重力下注的东西。\n\n接下来是我对张月光的访谈。\n\n期待2026年，我们和AI共同进步！\n\n（张月光坐在鸭川边思考人生的长夜）\n\n02:00 嘉宾小传2012年清华计算机毕业，大三发现自己卷不了Coding\n\n2018年第一次失败的创业与产品（元音）\n\n上次创业到最后非常困惑：不知道自己为什么要开始创业\n\n我在字节的两段经历（时光相册、今日头条专项）\n\n这次创业前的人生链路：SaaS公司>支付宝>字节>创业>阿里优酷\n\n2023年国庆节的凌晨，在京都鸭川边坐着，决定了第二次创业\n\n我的原则：“我想35岁-45岁，和同一群人做同一件事情”\n\n16:56 在大厂打怪升级的游戏27岁是字节3-2，30岁是阿里P9\n\n大厂普遍有两种战役：外部战役和内部战役\n\n坦白说，大厂游戏会让绝大部分人变成内部作战的人\n\nAI提供了外部游戏的增量，否则只能打内部游戏\n\n创业最好的理由是两个：1、你就想当老板；2、你特别想让一件事发生；但凡想发财、想成名，创业的期望收益都很差\n\n长视频平台不是平台，就像电影院不是平台一样，说到底它是内容产品\n\n2023年我开会说：“从今天开始关于优酷的各种会我都不参与了”\n\n28:28 妙鸭不是一个AI Native产品，那什么是？我喜欢One Way Door产品（单向门产品）\n\n互联网时代的产品设计是面向流程的设计，好的产品比如微信是游乐园，但也是有限自由度\n\n但AI Native产品非常开放，不仅是输入开放，输出也是开放的\n\n从互联网产品设计到AI Native产品设计，有一个巨大的范式变化：从流程设计到上下文设计\n\n传统互联网产品团队的协作方式在今天很有可能出现问题\n\n42:04 设计AI产品究竟需要什么样的AI组织？决策边界在变模糊，Taste变得非常重要，从线形工作变成两段式\n\n妙鸭和美图秀秀不在一桌，它本质是写真生意\n\n我们发现很难让一个模型做到真、像、美，于是我们让三个模型同时做\n\n最多时用了接近2万张推理卡\n\n妙鸭添加了我人生的幸福时刻：和同事在亮马桥喝酒那天，日收入破了100万\n\n2023年7月到10月忙得屁滚尿流，10月休假决定辞职，一切戛然而止\n\n01:01:16 出发第二次创业啦这代AI技术应该是“创造AI人口”，而不是“创造AI服务”\n\nAI会被连接到整个人类网络里来\n\n今天的专业技能正在贬值，多元化的品味、博学程度决定团队上限\n\n“人应该负责Will，人应该负责Skill”\n\n2023年作为融资额最高的AI应用公司之一，投资人为什么在没有产品的情况下，“盲注”？\n\n行业里的人开玩笑说，“我们天天在花利息”\n\n01:14:29 上路后，产品的多次选择和变化一条确定的线路：以交互为核心的AI乙女游戏（星眠）\n\n一条不确定的线路：花了1年摸索，做了三四个小产品，比如播客、信息工具、图像工具\n\n说说我们为什么之前做了一个播客产品，然后放弃了？\n\n新的内容平台的唯一机会：新媒介、新交互，产生新平台\n\nSora绝不可能成为新平台，但是ChatGPT可以\n\n我觉得Chatbot的商业空间是难以想象的大，可能是人类有史以来从没见过的商业模式——它背后藏着长程的决策控制的能力\n\n抖音式的短视频交互剥夺了你的信息自主权，Chatbot有机会剥夺你的自主决策权\n\n它可以控制你，那么它可以拿很高的Take Rate（抽佣率）\n\n02:01:21 从模型范式过渡到Agent范式让Agent做到更多你完全做不到的事情\n\nManus是一个“比硅谷更硅谷的童话故事”，Meta买到了一个范式的代表\n\n我不想做Manus这样的Agent，即将发布新产品：Dokie\n\n我很在意Latency（延迟），希望持续协作\n\n为什么Dokie选择PPT这么窄的赛道？——“别说the first了，我们都开始the last了”\n\n我的产品哲学：不是the first，90分等于0分，没有人觉得这是AI做的，做出One Way Door/单向门体验\n\n回答天问：怎么看待和模型公司的竞争？（应用公司都在用Claude的tool call）\n\n星眠做的不是我的AI朋友，Dokie做的是一个突破我能力边界的AI朋友\n\n【更多信息】\n\n免责声明：本内容不作为投资建议。",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "https://image.xyzcdn.net/Flo18nNUSP7OUNlTf8UgCdHxio6O.jpg",
                "url": "https://image.xyzcdn.net/Flo18nNUSP7OUNlTf8UgCdHxio6O.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/lhtlXvHeDgzBFvINKr129ZgdX2w4.jpg",
                "url": "https://image.xyzcdn.net/lhtlXvHeDgzBFvINKr129ZgdX2w4.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/Fm2F9n8vMm_n-xafqMi98xs3T3K8.png",
                "url": "https://image.xyzcdn.net/Fm2F9n8vMm_n-xafqMi98xs3T3K8.png"
              },
              {
                "text": "https://image.xyzcdn.net/FltklubTQlf1RyLKP9F1AWfrs9DT.png",
                "url": "https://image.xyzcdn.net/FltklubTQlf1RyLKP9F1AWfrs9DT.png"
              },
              {
                "text": "https://image.xyzcdn.net/FvV-R5FBydYHGZAMyXAV1K1A9iJT.png",
                "url": "https://image.xyzcdn.net/FvV-R5FBydYHGZAMyXAV1K1A9iJT.png"
              },
              {
                "text": "https://image.xyzcdn.net/Fn7o36NtUYpCM_rQiFj1LW-TIwk8.JPG",
                "url": "https://image.xyzcdn.net/Fn7o36NtUYpCM_rQiFj1LW-TIwk8.JPG"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 3909,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "695f008dc1e012a7abf0be09",
            "index": 15,
            "title": "129. 全球大模型第一股的上市访谈，和智谱CEO张鹏聊：敢问路在何方？",
            "pub_date": "2026-01-08T01:09:14.477Z",
            "duration": "8799",
            "duration_label": "2h 26m",
            "selected": true,
            "confidence": "xiaoyuzhou-next-data",
            "score": 3,
            "matched_keywords": [
              "AI",
              "大模型",
              "商业"
            ],
            "page_url": "https://www.xiaoyuzhoufm.com/episode/695f008dc1e012a7abf0be09",
            "audio_url": "https://media.xyzcdn.net/626b46ea9cbbf0451cf5a962/liEES-JtJxuXJqZStaCtRdJmWHWb.m4a",
            "play_count": 135341,
            "show_notes_text": "上市前夕，智谱CEO张鹏在一次出差途中摔断伤了右腿。到达访谈地点时，他拄着一副拐杖。\n\n当时，智谱的上市日期尚未明朗。它与MiniMax之间围绕“中国大模型第一股”的竞争仍在继续，结果并未尘埃落定。张鹏提到一句西方俚语：Break a leg（摔断一条腿），它通常意味着祝你好运。\n\n几天之后，结果揭晓。\n\n智谱确认于2026年1月8日登陆港交所，成为中国首家上市的大模型公司，这也意味着它将是“全球大模型第一股”。\n\n在这个意味深长的时刻，我与张鹏进行了一场3小时长谈。\n\n如果一百年后，智谱出现在人工智能的历史书中，你希望它以怎样的方式被写下？\n\n“AGI的先行者。”张鹏想了想，说，“一个开路的人。”\n\n这是《张小珺商业访谈录》与大家在2026年见面的第一集节目——祝大家新年快乐！期待在2026年，我们与AI共同进步！\n\n02:22 吃螃蟹的人\n\n20:29 从感知智能到认知智能的摸索\n\n29:25 GPT-3来了！\n\n40:46 ChatGPT又来了：既焦虑又兴奋的2023年\n\n01:09:06 2024年：新的主角\n\n01:17:58 Scaling Law的范式演变\n\n01:29:56 2025年：向DeepSeek学习\n\n01:38:40 开源 vs 闭源\n\n01:48:33 IPO：全球大模型第一股\n\n02:01:40 开路的人\n\n【更多信息】\n\n本集由语言即世界工作室与微博财经联合呈现。\n\n免责声明：本内容不作为投资建议。",
            "show_notes_source": "xiaoyuzhou_episode_payload",
            "show_notes_links": [
              {
                "text": "https://image.xyzcdn.net/Flo18nNUSP7OUNlTf8UgCdHxio6O.jpg",
                "url": "https://image.xyzcdn.net/Flo18nNUSP7OUNlTf8UgCdHxio6O.jpg"
              },
              {
                "text": "https://image.xyzcdn.net/Fm2F9n8vMm_n-xafqMi98xs3T3K8.png",
                "url": "https://image.xyzcdn.net/Fm2F9n8vMm_n-xafqMi98xs3T3K8.png"
              },
              {
                "text": "https://image.xyzcdn.net/FsDgR_9P3S2gds74aRINaowopRVi.png",
                "url": "https://image.xyzcdn.net/FsDgR_9P3S2gds74aRINaowopRVi.png"
              },
              {
                "text": "https://image.xyzcdn.net/FvV-R5FBydYHGZAMyXAV1K1A9iJT.png",
                "url": "https://image.xyzcdn.net/FvV-R5FBydYHGZAMyXAV1K1A9iJT.png"
              },
              {
                "text": "https://image.xyzcdn.net/FvVbUNblF7FHIjfdp3MmmbAdLZ8G.png",
                "url": "https://image.xyzcdn.net/FvVbUNblF7FHIjfdp3MmmbAdLZ8G.png"
              },
              {
                "text": "https://image.xyzcdn.net/FirtILBnNOPkNKOx28EeqzXPjEcv.png",
                "url": "https://image.xyzcdn.net/FirtILBnNOPkNKOx28EeqzXPjEcv.png"
              },
              {
                "text": "https://image.xyzcdn.net/Fn7o36NtUYpCM_rQiFj1LW-TIwk8.JPG",
                "url": "https://image.xyzcdn.net/Fn7o36NtUYpCM_rQiFj1LW-TIwk8.JPG"
              }
            ],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "local_whispercpp_asr",
              "transcript_record_count": 2307,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          }
        ]
      },
      {
        "id": "ai-daily-brief",
        "title": "The AI Daily Brief",
        "feed_title": "The AI Daily Brief: Artificial Intelligence News and Analysis",
        "priority": "P2",
        "selection_mode": "all_ai",
        "focus": [
          "AI news",
          "market updates",
          "daily analysis"
        ],
        "feed_url": "https://anchor.fm/s/f7cac464/podcast/rss",
        "source_url": "https://anchor.fm/s/f7cac464/podcast/rss",
        "detail_path": "/podcasts/ai-daily-brief/",
        "episode_count": 250,
        "selected_episode_count": 250,
        "latest_episode_title": "10+ Things You Should Build With AI Instead of Sending Files",
        "latest_pub_date": "2026-06-07T16:00:00.000Z",
        "latest_page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/10-Things-You-Should-Build-With-AI-Instead-of-Sending-Files-e3keqlt",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "5e2a0bca-58ca-477d-aadf-ec5ca7212ffb",
            "index": 1,
            "title": "10+ Things You Should Build With AI Instead of Sending Files",
            "pub_date": "2026-06-07T16:00:00.000Z",
            "duration": "00:22:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "training",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/10-Things-You-Should-Build-With-AI-Instead-of-Sending-Files-e3keqlt",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/121120893/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-5-7%2F425662565-44100-2-0f49b2fa98952.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "12fc940d-b503-48b7-8235-b77b9efa8d56",
            "index": 2,
            "title": "This Week in AI for Ridiculously Busy People",
            "pub_date": "2026-06-06T18:21:10.000Z",
            "duration": "00:05:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/This-Week-in-AI-for-Ridiculously-Busy-People-e3ke2rp",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/121096505/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-5-6%2F425630910-44100-2-69a857093c6e6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90be2caa-45fc-44f5-b0eb-b6e02a58c3e2",
            "index": 3,
            "title": "What OpenAI and Anthropic Think Happens Next With AI",
            "pub_date": "2026-06-05T19:06:49.000Z",
            "duration": "00:31:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-OpenAI-and-Anthropic-Think-Happens-Next-With-AI-e3kd32n",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/121063959/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-5-5%2F425587851-44100-2-014cc22bdebc9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1703393d-2542-4445-92e0-10ce36167e27",
            "index": 4,
            "title": "How Companies Are Becoming AI Token Efficient",
            "pub_date": "2026-06-04T19:37:51.000Z",
            "duration": "00:25:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "inference",
              "reasoning",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-Companies-Are-Becoming-AI-Token-Efficient-e3kbm85",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/121018053/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-5-4%2F425526383-44100-2-33562354187ed.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d60b7363-b409-46cd-aa0d-98b1f35cc99b",
            "index": 5,
            "title": "The Next Wave of Enterprise AI",
            "pub_date": "2026-06-03T20:05:18.000Z",
            "duration": "00:26:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "chip",
              "reasoning",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Next-Wave-of-Enterprise-AI-e3ka603",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120968643/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-5-3%2F425460343-44100-2-2d98e8ffc691d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1100819-8b0a-494d-99bf-0f8ed8f287f7",
            "index": 6,
            "title": "Should Americans Get Shares in AI Companies?",
            "pub_date": "2026-06-02T22:36:26.000Z",
            "duration": "00:22:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "nvidia",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Should-Americans-Get-Shares-in-AI-Companies-e3k8jtv",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120917375/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-5-2%2F425395678-44100-2-ac8c10b7b1e0b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0cc6fc99-7763-4522-be2b-c2091cf2ef49",
            "index": 7,
            "title": "The AI Token Shortage Begins [AI Monthly Recap]",
            "pub_date": "2026-06-01T16:00:01.000Z",
            "duration": "00:28:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Token-Shortage-Begins-AI-Monthly-Recap-e3k6e0o",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120845784/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-5-1%2F425294191-44100-2-2347f703e4875.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2a5641cc-9d7d-4c4d-90fb-81b96607ff75",
            "index": 8,
            "title": "How to Use /Goal to Do More With AI",
            "pub_date": "2026-05-31T15:22:26.000Z",
            "duration": "00:22:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "claude",
              "reasoning",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Use-Goal-to-Do-More-With-AI-e3k4u0l",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120796629/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-31%2F425229655-44100-2-12955b17f2372.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b0d92d5a-5a1e-41b1-9020-f76f7aa99300",
            "index": 9,
            "title": "Claude Opus 4.8 First Impressions",
            "pub_date": "2026-05-29T21:52:49.000Z",
            "duration": "00:27:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "claude",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Claude-Opus-4-8-First-Impressions-e3k36l2",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120739938/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-29%2F425154676-44100-2-b2fab8fda5c06.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f114f84-e4a8-47a7-a827-a6bdaf6c01d6",
            "index": 10,
            "title": "The Case for an AI Token Tax",
            "pub_date": "2026-05-28T18:05:35.000Z",
            "duration": "00:22:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Case-for-an-AI-Token-Tax-e3k146b",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120671883/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-28%2F425062878-44100-2-f77a9fee4d4fb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35e973ad-054b-4559-bc5a-48d2a4d4eab9",
            "index": 11,
            "title": "The Annual AI Slowdown Panic is Here",
            "pub_date": "2026-05-27T21:43:23.000Z",
            "duration": "00:29:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "inference",
              "reasoning",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Annual-AI-Slowdown-Panic-is-Here-e3k03e9",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120638345/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-27%2F425021038-44100-2-48bf8e3f3ced1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "671e8cea-c28b-489b-9f3d-6abc0cee54c6",
            "index": 12,
            "title": "What the Pope Actually Said About AI",
            "pub_date": "2026-05-26T20:01:05.000Z",
            "duration": "00:26:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "agentic",
              "anthropic",
              "grok",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-the-Pope-Actually-Said-About-AI-e3jucn5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120582309/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-26%2F424942895-44100-2-3f4ee3d18276.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02b33a1e-d632-42f7-9d29-2802e6c4e6b8",
            "index": 13,
            "title": "The 4 AI Team Members Execs Should Hire Right Now",
            "pub_date": "2026-05-25T19:06:54.000Z",
            "duration": "00:32:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-4-AI-Team-Members-Execs-Should-Hire-Right-Now-e3jslkq",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120525914/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-25%2F424867724-44100-2-de50193bc2249.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69920bc0-6e95-43ad-9fc8-fb03154477cf",
            "index": 14,
            "title": "Why Agents Still Need Humans",
            "pub_date": "2026-05-24T11:13:00.000Z",
            "duration": "00:26:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "claude",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Agents-Still-Need-Humans-e3jqnvj",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120462771/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-24%2F424784366-44100-2-9a2aff5f14639.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2938d95c-faf6-4f86-b78c-ffeef181c741",
            "index": 15,
            "title": "AI’s New Acceleration Phase",
            "pub_date": "2026-05-22T19:07:24.000Z",
            "duration": "00:24:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "cursor",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AIs-New-Acceleration-Phase-e3jor7l",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120400565/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-22%2F424703957-44100-2-a72fd093a128a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c238d713-029f-4cad-84ba-2ff293747c58",
            "index": 16,
            "title": "Anthropic Just Reset AI Expectations",
            "pub_date": "2026-05-21T21:47:39.000Z",
            "duration": "00:25:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "cursor",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Anthropic-Just-Reset-AI-Expectations-e3jngg2",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120356802/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-21%2F424645081-44100-2-d0251bcbe7ab1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f8750a4-234d-4ce9-bd52-9fa0f8b0a668",
            "index": 17,
            "title": "Why Google Isn't Chasing Claude Code",
            "pub_date": "2026-05-20T19:36:21.000Z",
            "duration": "00:35:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "claude",
              "gemini",
              "embedding",
              "multimodal"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Google-Isnt-Chasing-Claude-Code-e3jlltb",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120296811/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-20%2F424564530-44100-2-f370a9e6769bb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e97ccfd8-efeb-45a5-8ef0-1adbe970bb71",
            "index": 18,
            "title": "9 Codex Tips From the Codex Team",
            "pub_date": "2026-05-19T18:44:20.000Z",
            "duration": "00:29:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/9-Codex-Tips-From-the-Codex-Team-e3jjvfu",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120241086/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-19%2F424488443-44100-2-8b0a9e7e811c7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2077a9d-8659-4059-8805-274b0b122c31",
            "index": 19,
            "title": "Beating the AI Doom Cycle",
            "pub_date": "2026-05-18T20:30:55.000Z",
            "duration": "00:33:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Beating-the-AI-Doom-Cycle-e3jibjn",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120187959/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-18%2F424419569-44100-2-fe00d211f569.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f97889d9-74ce-4ca5-9cd0-595ea20edc68",
            "index": 20,
            "title": "AI Inequality",
            "pub_date": "2026-05-17T11:28:24.000Z",
            "duration": "00:26:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "frontier model",
              "agents",
              "agentic",
              "data center"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Inequality-e3jg00q",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120110554/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-17%2F424314084-44100-2-11f5dba446105.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69176e65-02e8-47ba-a0b1-d06359f9aa05",
            "index": 21,
            "title": "Google’s Big AI Test Comes Next Week",
            "pub_date": "2026-05-15T19:06:17.000Z",
            "duration": "00:30:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "chatgpt",
              "openai",
              "anthropic",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Googles-Big-AI-Test-Comes-Next-Week-e3je6gd",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120051661/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-15%2F424236283-44100-2-9f58a995a3287.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "25ff55b2-66bf-481e-93b5-62019ed8e124",
            "index": 22,
            "title": "RIP Golden Age of Agent Experimentation 2026-2026",
            "pub_date": "2026-05-14T20:34:42.000Z",
            "duration": "00:31:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/RIP-Golden-Age-of-Agent-Experimentation-2026-2026-e3jcpfl",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/120005557/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-14%2F424173738-44100-2-12e26fb529d91.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8df780e6-980c-489e-8778-a3330d763e28",
            "index": 23,
            "title": "In Defense of Tokenmaxxing",
            "pub_date": "2026-05-13T20:43:26.000Z",
            "duration": "00:28:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "anthropic",
              "claude",
              "gemini",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/In-Defense-of-Tokenmaxxing-e3jb2us",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119949724/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-13%2F424099224-44100-2-b3dd1d3d8bedc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad46c90e-93ce-490d-afa5-87305a8cce24",
            "index": 24,
            "title": "Towards AI That Can Actually Interact",
            "pub_date": "2026-05-12T21:19:07.000Z",
            "duration": "00:29:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "openai",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Towards-AI-That-Can-Actually-Interact-e3j9esv",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119896415/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-12%2F424027074-44100-2-17f6b2339fd0d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17693d12-1811-48ad-af0b-2c5158b7fd3c",
            "index": 25,
            "title": "The Best Way to Talk to Your AI Agents",
            "pub_date": "2026-05-11T21:02:30.000Z",
            "duration": "00:29:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Best-Way-to-Talk-to-Your-AI-Agents-e3j7qch",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119842641/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-11%2F423954907-44100-2-506c5702295bb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "851eeec6-6289-413a-870e-2c5c1a1697ed",
            "index": 26,
            "title": "The New Jobs AI Will Create",
            "pub_date": "2026-05-10T19:00:00.000Z",
            "duration": "00:30:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-New-Jobs-AI-Will-Create-e3j4fts",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119733628/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-9%2F423810380-44100-2-597f34d57f08.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d91da8d-7141-450d-8922-deacda67d21e",
            "index": 27,
            "title": "How to Build an AI Native Team with Mike Cannon-Brookes",
            "pub_date": "2026-05-09T21:00:01.000Z",
            "duration": "00:29:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Build-an-AI-Native-Team-with-Mike-Cannon-Brookes-e3j4cjo",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119730232/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-9%2F423806070-44100-2-9c909109bf962.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "229c6033-3ace-41d0-8942-500627e2e43c",
            "index": 28,
            "title": "The Week the AI Story Shifted",
            "pub_date": "2026-05-08T19:42:00.000Z",
            "duration": "00:30:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "training",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Week-the-AI-Story-Shifted-e3j3nh7",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119708647/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-8%2F423776761-44100-2-5c5fae1ca0b7f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cc40a34d-c7c5-479d-a754-342c2939706c",
            "index": 29,
            "title": "Surprise Elon Anthropic Team Up Reshapes the AI Race",
            "pub_date": "2026-05-07T21:21:48.000Z",
            "duration": "00:31:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "claude",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Surprise-Elon-Anthropic-Team-Up-Reshapes-the-AI-Race-e3j27qr",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119659803/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-7%2F423711559-44100-2-2520249dd1d5b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4736d7f8-e307-47f5-a390-2c0654f6090e",
            "index": 30,
            "title": "Who Cares About Consumer AI",
            "pub_date": "2026-05-06T20:13:50.000Z",
            "duration": "00:31:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "anthropic",
              "training",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Who-Cares-About-Consumer-AI-e3j0cq9",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119599369/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-6%2F423629057-44100-2-fc9626bcfeb9f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "774cc557-07b5-4c1e-af0b-ace296132e52",
            "index": 31,
            "title": "Why OpenAI and Anthropic Are Becoming Consultants",
            "pub_date": "2026-05-05T21:11:54.000Z",
            "duration": "00:26:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "training",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-OpenAI-and-Anthropic-Are-Becoming-Consultants-e3iukhm",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119541750/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-5%2F423549447-44100-2-8f38fa4b802.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "99594c9c-7818-47f5-acda-5fe9dab9b2ab",
            "index": 32,
            "title": "Is AI Doom Going Out of Style?",
            "pub_date": "2026-05-04T19:47:03.000Z",
            "duration": "00:26:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Is-AI-Doom-Going-Out-of-Style-e3islgt",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119477213/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-4%2F423457255-44100-2-fe6b9de1ef78c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17e55de0-1a13-446c-96a8-13d868cf3ab7",
            "index": 33,
            "title": "Why Agents Make Every Job a Startup",
            "pub_date": "2026-05-03T11:30:36.000Z",
            "duration": "00:25:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Agents-Make-Every-Job-a-Startup-e3iqfa9",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119405321/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-3%2F423360033-44100-2-c575d9afb184.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f88ce7f5-6a14-4bf8-a1c6-77b975d3a8ee",
            "index": 34,
            "title": "The Week AI Grew Up",
            "pub_date": "2026-05-01T20:45:04.000Z",
            "duration": "00:25:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Week-AI-Grew-Up-e3iosi7",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119353351/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-4-1%2F423292374-44100-2-592667a340f63.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b7e74caa-fff0-48e7-99a5-a30848f314b0",
            "index": 35,
            "title": "How Harness-as-a-Service Will Change Agents",
            "pub_date": "2026-04-30T20:00:00.000Z",
            "duration": "00:28:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-Harness-as-a-Service-Will-Change-Agents-e3inabf",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119301935/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-30%2F423220216-44100-2-a4431219fe598.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1bd7dc9b-2454-4c32-ad81-af02d6050a9e",
            "index": 36,
            "title": "AI Lab Power Rankings",
            "pub_date": "2026-04-29T20:30:01.000Z",
            "duration": "00:25:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Lab-Power-Rankings-e3ilimg",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119244944/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-29%2F423141638-44100-2-097e1549e5fb8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "490dc902-b1c3-432b-ae51-d801fcc047c7",
            "index": 37,
            "title": "The AI Subsidy Era is Over",
            "pub_date": "2026-04-28T21:36:58.000Z",
            "duration": "00:26:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Subsidy-Era-is-Over-e3ik12g",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119194128/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-28%2F423074314-44100-2-dc11121b3ca1a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8764070d-98cc-485f-9afa-0ed935b5bca3",
            "index": 38,
            "title": "How DeepSeek V4 Connects to the US Power Grid",
            "pub_date": "2026-04-27T23:00:39.000Z",
            "duration": "00:24:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-DeepSeek-V4-Connects-to-the-US-Power-Grid-e3ii7md",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119135373/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-27%2F422991934-44100-2-bf0039b658dd9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "87cfc467-d00c-4159-a181-ed668aa9a14b",
            "index": 39,
            "title": "Where the Economy Thrives After AI",
            "pub_date": "2026-04-26T21:05:52.000Z",
            "duration": "00:29:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Where-the-Economy-Thrives-After-AI-e3igj4g",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119081552/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-26%2F422917551-44100-2-d710229f0de6f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "168d4abf-a169-495d-9e81-a67c59f203e5",
            "index": 40,
            "title": "How To Build a Personal Agentic Operating System",
            "pub_date": "2026-04-25T18:59:18.000Z",
            "duration": "00:28:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-To-Build-a-Personal-Agentic-Operating-System-e3ifc1h",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119041521/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-25%2F422864523-44100-2-38ea79f10d717.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "62268ce5-4012-492b-b6d0-bb45b94f44f9",
            "index": 41,
            "title": "What I Learned Testing GPT-5.5",
            "pub_date": "2026-04-24T17:10:03.000Z",
            "duration": "00:36:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-I-Learned-Testing-GPT-5-5-e3ie4f9",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/119001001/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-24%2F422810956-44100-2-21f01078273f9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6aa624bb-9f4a-44e1-a803-0283a49f31ce",
            "index": 42,
            "title": "How Headless Agents Will Change Work",
            "pub_date": "2026-04-24T00:14:12.000Z",
            "duration": "00:30:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "mistral",
              "xai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-Headless-Agents-Will-Change-Work-e3icmjg",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118954032/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-24%2F422740558-44100-2-03f6bf92152a1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "79a04926-5fc9-4e1d-af5c-225ee626ed03",
            "index": 43,
            "title": "What GPT Images 2 Unlocks",
            "pub_date": "2026-04-22T20:40:37.000Z",
            "duration": "00:24:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "claude",
              "cursor"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-GPT-Images-2-Unlocks-e3iack9",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118878281/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-22%2F422634675-44100-2-6e4f28e9684fe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1cd2203-9aeb-40e4-ba6a-9c1059a75a91",
            "index": 44,
            "title": "How Apple's AI Strategy Changes with a New CEO",
            "pub_date": "2026-04-21T19:42:19.000Z",
            "duration": "00:23:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-Apples-AI-Strategy-Changes-with-a-New-CEO-e3i8iaq",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118818586/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-21%2F422553423-44100-2-fb6599687750b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1aac6c04-c653-431c-b867-e23d74228538",
            "index": 45,
            "title": "What To Build First With Claude Design",
            "pub_date": "2026-04-20T22:01:22.000Z",
            "duration": "00:29:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-To-Build-First-With-Claude-Design-e3i6roe",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118762702/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-20%2F422476976-44100-2-ef66399077096.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8ffcb89d-9ac9-4a39-afbc-559bb24ffb18",
            "index": 46,
            "title": "How the Best Companies Use AI",
            "pub_date": "2026-04-19T22:59:54.000Z",
            "duration": "00:26:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-the-Best-Companies-Use-AI-e3i576d",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118708877/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-19%2F422405331-44100-2-6b935379afb19.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "785a17f8-6135-43b9-b899-424199de82da",
            "index": 47,
            "title": "Agent Building Trends [Operator Bonus Episode]",
            "pub_date": "2026-04-18T20:00:00.000Z",
            "duration": "00:10:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Agent-Building-Trends-Operator-Bonus-Episode-e3i3o5l",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118660725/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-18%2F422342250-44100-2-182bb7140f3c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c8bf2c4f-b4e8-4961-8068-be099e270ef1",
            "index": 48,
            "title": "How to Use Opus 4.7 and the New Codex",
            "pub_date": "2026-04-17T20:21:10.000Z",
            "duration": "00:24:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Use-Opus-4-7-and-the-New-Codex-e3i2r1s",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118630908/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-17%2F422302900-44100-2-a1a0d9b3038be.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "54ce5d5b-a66b-4e46-9275-26b7d5732b38",
            "index": 49,
            "title": "AI's Great Divergence",
            "pub_date": "2026-04-16T20:28:34.000Z",
            "duration": "00:20:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AIs-Great-Divergence-e3i11a9",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118571785/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-16%2F422223490-44100-2-54cddc394c35f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a6868698-faaf-4dce-a969-8c79d13e8e83",
            "index": 50,
            "title": "Vibe Coding Gets an Upgrade",
            "pub_date": "2026-04-15T20:19:57.000Z",
            "duration": "00:24:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Vibe-Coding-Gets-an-Upgrade-e3hvdgd",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118518733/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-15%2F422151792-44100-2-01d2afe495cfd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4755b5d-045f-4ea1-a588-c136a7e63f15",
            "index": 51,
            "title": "AI Populism Turns Violent",
            "pub_date": "2026-04-15T00:56:02.000Z",
            "duration": "00:31:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Populism-Turns-Violent-e3hu1b3",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118473507/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-15%2F422094145-44100-2-5f2984c00c24f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "368b1cf6-b757-40f2-b120-a9c81d9d360a",
            "index": 52,
            "title": "Harness Engineering 101",
            "pub_date": "2026-04-13T17:00:01.000Z",
            "duration": "00:25:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Harness-Engineering-101-e3hqs2e",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118369806/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-13%2F421955000-44100-2-1bd967633a8ec.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "55f246ce-7fd8-40a1-8049-14868915ef82",
            "index": 53,
            "title": "The New AI Org Chart",
            "pub_date": "2026-04-12T13:21:57.000Z",
            "duration": "00:27:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-New-AI-Org-Chart-e3hphs6",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118326598/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-12%2F421897951-44100-2-689b676c039cb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2fed4f2-dbbf-4e6d-b696-c024e5338daf",
            "index": 54,
            "title": "Why Enterprise AI Has a Leadership Problem",
            "pub_date": "2026-04-10T20:08:34.000Z",
            "duration": "00:26:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Enterprise-AI-Has-a-Leadership-Problem-e3hnmar",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118265627/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-10%2F421816997-44100-2-064aef9ae0d62.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b2c59d00-2422-4279-a6af-378ade6bc1ca",
            "index": 55,
            "title": "All of AI's New Models and Tools",
            "pub_date": "2026-04-09T21:05:00.000Z",
            "duration": "00:28:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "gemini",
              "perplexity"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/All-of-AIs-New-Models-and-Tools-e3hm0bl",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118210357/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-9%2F421744614-44100-2-823df3c985a52.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7acf7268-d2d6-40df-8519-f5fba893d70d",
            "index": 56,
            "title": "Should We Be Scared of Anthropic's Mythos?",
            "pub_date": "2026-04-08T20:57:02.000Z",
            "duration": "00:31:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "anthropic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Should-We-Be-Scared-of-Anthropics-Mythos-e3hkhgm",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118162390/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-8%2F421681738-44100-2-5a6eacc4e2469.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c80b24d4-e909-484c-87df-9014e809afa0",
            "index": 57,
            "title": "OpenAI's New Deal",
            "pub_date": "2026-04-08T00:30:38.000Z",
            "duration": "00:36:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/OpenAIs-New-Deal-e3hj6vo",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118118840/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-8%2F421668833-44100-2-cc7910e5d5263.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff1210c9-2d88-4c78-8f9a-e0ad57cec73c",
            "index": 58,
            "title": "The Calm Before the AGI Storm",
            "pub_date": "2026-04-06T19:59:21.000Z",
            "duration": "00:29:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Calm-Before-the-AGI-Storm-e3hh4jq",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/118050874/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-6%2F421531568-44100-2-f00da6840b2c6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "131ed1a1-40b2-48c0-a667-8a38e1178fdb",
            "index": 59,
            "title": "6 Questions Shaping AI",
            "pub_date": "2026-04-05T12:50:36.000Z",
            "duration": "00:24:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/6-Questions-Shaping-AI-e3hf5o5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117986501/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-5%2F421446388-44100-2-a27fabad44196.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "57ee30ec-eb96-4082-afe6-110eb55590ed",
            "index": 60,
            "title": "The Masked Medici: How to Build a Faceless Youtube Channel and Companion 1990s Strategy Game in a Single Afternoon with Google AI",
            "pub_date": "2026-04-04T11:48:31.000Z",
            "duration": "00:18:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "google ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Masked-Medici-How-to-Build-a-Faceless-Youtube-Channel-and-Companion-1990s-Strategy-Game-in-a-Single-Afternoon-with-Google-AI-e3he3ld",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117951597/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-4%2F421400819-44100-2-63dbdb04087c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "555f8b96-2cc2-4af6-8430-e63b8b0b2291",
            "index": 61,
            "title": "How to Build a Personal Context Portfolio and MCP Server",
            "pub_date": "2026-04-03T11:24:36.000Z",
            "duration": "00:24:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Build-a-Personal-Context-Portfolio-and-MCP-Server-e3hcfrl",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117898549/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-3%2F421332826-44100-2-45e725e18c8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5c8b738b-64d4-40d0-9475-09c0c2c05863",
            "index": 62,
            "title": "Agent Skills Masterclass",
            "pub_date": "2026-04-02T11:25:08.000Z",
            "duration": "00:33:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Agent-Skills-Masterclass-e3hasv7",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117846439/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-3-2%2F421263700-44100-2-9b311e0101063.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3775e0c2-89e2-45cf-b129-8f05413e1d6b",
            "index": 63,
            "title": "Introducing Maturity Maps — A New Way to Measure AI Adoption",
            "pub_date": "2026-04-01T11:30:00.000Z",
            "duration": "00:25:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Introducing-Maturity-Maps--A-New-Way-to-Measure-AI-Adoption-e3h89ni",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117761202/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-31%2F421146863-44100-2-9be5396d0d522.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9361fbe3-25e1-419a-81d1-3089a7ced807",
            "index": 64,
            "title": "The Ultimate AI Catch-Up Guide",
            "pub_date": "2026-03-31T11:25:27.000Z",
            "duration": "00:33:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Ultimate-AI-Catch-Up-Guide-e3h7jao",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117738264/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-31%2F421116811-44100-2-b28b74dea071a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff143f2c-de85-4cd4-a5c9-01f7923fa460",
            "index": 65,
            "title": "The State of AI Q2: AI's Second Moment",
            "pub_date": "2026-03-30T11:55:00.000Z",
            "duration": "00:23:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-State-of-AI-Q2-AIs-Second-Moment-e3h5sha",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117682154/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-30%2F421041506-44100-2-81ba6fc331ea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba46d55d-2dfd-46c4-a3fa-1b2c67895cc8",
            "index": 66,
            "title": "How AI Can Help Democracy Work Better",
            "pub_date": "2026-03-28T11:51:27.000Z",
            "duration": "00:30:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-AI-Can-Help-Democracy-Work-Better-e3h3bkl",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117599317/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-28%2F420931339-44100-2-a9dfa79aece6a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b162fa2a-4134-4657-8813-ca2b43e2b2a4",
            "index": 67,
            "title": "Anthropic Accidentally Revealed Their Most Powerful Model Ever",
            "pub_date": "2026-03-27T19:41:22.000Z",
            "duration": "00:27:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Anthropic-Accidentally-Revealed-Their-Most-Powerful-Model-Ever-e3h2l87",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117576391/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-27%2F420901152-44100-2-cf36e3e287b55.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "67ffcfd7-302b-467e-b0ce-a5e4810d22a9",
            "index": 68,
            "title": "Why AI Needs Better Benchmarks",
            "pub_date": "2026-03-26T23:39:51.000Z",
            "duration": "00:30:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "agentic",
              "gemini",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-AI-Needs-Better-Benchmarks-e3h1coa",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117534922/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-26%2F420845559-44100-2-51f7c49bb4d8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f73a145-c477-4cf3-9b16-94e188286879",
            "index": 69,
            "title": "Work AGI is the Only AGI that Matters",
            "pub_date": "2026-03-25T21:52:28.000Z",
            "duration": "00:26:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Work-AGI-is-the-Only-AGI-that-Matters-e3gvn96",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117480166/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-25%2F420770749-44100-2-10135bbcb046.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9d75dbc9-215e-45d6-b54b-fbea0b8a3a92",
            "index": 70,
            "title": "How to Use Claude's Massive New Upgrades",
            "pub_date": "2026-03-25T00:52:43.000Z",
            "duration": "00:25:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Use-Claudes-Massive-New-Upgrades-e3guag5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117434309/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-25%2F420708687-44100-2-478a7af3fa717.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f6588a6-30c8-4c33-bece-850c68225156",
            "index": 71,
            "title": "The Coming AI Rules Battle",
            "pub_date": "2026-03-23T19:35:35.000Z",
            "duration": "00:26:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Coming-AI-Rules-Battle-e3gs9nj",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117367987/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-23%2F420618704-44100-2-94cd8d04dce72.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a46b7b0b-9f62-40d5-a2a2-1754a38ea882",
            "index": 72,
            "title": "Why AI Actually Won't Take Your Job",
            "pub_date": "2026-03-22T12:18:29.000Z",
            "duration": "00:32:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-AI-Actually-Wont-Take-Your-Job-e3gq5op",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117298393/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-22%2F420526905-44100-2-98ded4e82f85c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a25b33aa-535b-40bf-98a5-912aa539f04b",
            "index": 73,
            "title": "Every AI Product Is Becoming Every Other AI Product",
            "pub_date": "2026-03-20T20:39:44.000Z",
            "duration": "00:27:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "replit",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Every-AI-Product-Is-Becoming-Every-Other-AI-Product-e3goh0v",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117244383/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-20%2F420455596-44100-2-c3368a95f1e17.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5f9795d-04e5-4c2e-b6f7-bba7cf650732",
            "index": 74,
            "title": "What People Really Want From AI",
            "pub_date": "2026-03-19T23:36:43.000Z",
            "duration": "00:30:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "claude",
              "copilot"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-People-Really-Want-From-AI-e3gn965",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117203589/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-19%2F420398776-44100-2-25e7b8c729498.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a6600807-9cb6-42e2-9fc1-f4ec12ba05a0",
            "index": 75,
            "title": "How to Use Agent Skills",
            "pub_date": "2026-03-18T21:29:07.000Z",
            "duration": "00:27:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Use-Agent-Skills-e3glb09",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117139913/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-18%2F420309604-44100-2-cca9c27f729db.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "755e8b65-4538-4d1d-85dd-b6f8d7cfcc3c",
            "index": 76,
            "title": "The Race to Put AI Agents Everywhere",
            "pub_date": "2026-03-17T20:57:34.000Z",
            "duration": "00:27:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "nvidia",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Race-to-Put-AI-Agents-Everywhere-e3gjia2",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117081858/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-17%2F420229522-44100-2-a3d932e24cfb9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "989bff43-796e-447d-ac8c-072bf1e40faa",
            "index": 77,
            "title": "A Guy Used AI to Cure His Dog's Cancer*",
            "pub_date": "2026-03-16T20:25:35.000Z",
            "duration": "00:28:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/A-Guy-Used-AI-to-Cure-His-Dogs-Cancer-e3ghqmv",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/117024927/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-16%2F420152614-44100-2-1f25f41f0d806.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7d9eea5c-613b-485d-85d8-782d824f4220",
            "index": 78,
            "title": "The Power to Shape AI",
            "pub_date": "2026-03-15T20:00:00.000Z",
            "duration": "00:25:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Power-to-Shape-AI-e3gfi08",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116950472/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-15%2F420052278-44100-2-4c7d075c873db.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ce6b5bd5-f181-431f-9983-5498eb0cce95",
            "index": 79,
            "title": "The Coolest Agents I've Built So Far",
            "pub_date": "2026-03-14T21:37:51.000Z",
            "duration": "00:20:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Coolest-Agents-Ive-Built-So-Far-e3geoup",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116924825/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-14%2F420016326-44100-2-852a832b18408.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "45681386-42b5-4763-bb29-9fa5a9d2d0ed",
            "index": 80,
            "title": "Pro-Worker AI",
            "pub_date": "2026-03-13T20:32:22.000Z",
            "duration": "00:28:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "cursor"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Pro-Worker-AI-e3gdhbe",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116884270/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-13%2F419962579-44100-2-45627a25052d6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f684021c-f134-4f54-b5a2-f58228247804",
            "index": 81,
            "title": "What Vibe Coding is Turning Into",
            "pub_date": "2026-03-12T21:19:10.000Z",
            "duration": "00:23:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-Vibe-Coding-is-Turning-Into-e3gc0sm",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116834646/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-12%2F419895889-44100-2-fa51198fdc2ee.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7e781064-0843-4565-80b2-5a594d9c4c6c",
            "index": 82,
            "title": "Why Google Workspace CLI is a Big Deal",
            "pub_date": "2026-03-11T21:15:08.000Z",
            "duration": "00:24:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "gemini",
              "perplexity",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Google-Workspace-CLI-is-a-Big-Deal-e3ga8i5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116776965/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-11%2F419818033-44100-2-ece265cec9db4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e1faa62a-2511-4eb6-83d9-cc14c030501f",
            "index": 83,
            "title": "The Debate Over Anthropic’s New Product: Price or Existential Dread?",
            "pub_date": "2026-03-10T20:46:24.000Z",
            "duration": "00:26:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Debate-Over-Anthropics-New-Product-Price-or-Existential-Dread-e3g8e49",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116717129/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-10%2F419737009-44100-2-b0e359fa705d4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f90ef77c-e558-475c-ba33-041fb0812cfd",
            "index": 84,
            "title": "Autoresearch, Agent Loops and the Future of Work",
            "pub_date": "2026-03-09T20:16:26.000Z",
            "duration": "00:25:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Autoresearch--Agent-Loops-and-the-Future-of-Work-e3g6e7r",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116651707/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-9%2F419645105-44100-2-2b2de81d67699.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b178bef0-b324-4c2c-9f4e-5e529c9d21c7",
            "index": 85,
            "title": "10 OpenClaw Lessons for Building Agent Teams",
            "pub_date": "2026-03-08T11:51:23.000Z",
            "duration": "00:29:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/10-OpenClaw-Lessons-for-Building-Agent-Teams-e3g40vm",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116572598/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-8%2F419535977-44100-2-0ed2b983d24b9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3d0e0328-8f6d-4be0-b04b-5c74960434ff",
            "index": 86,
            "title": "GPT 5.4 First Test Results",
            "pub_date": "2026-03-06T21:56:05.000Z",
            "duration": "00:28:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/GPT-5-4-First-Test-Results-e3g28p5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116515045/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-6%2F419457472-44100-2-d30040b95d65c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "336e1b27-63c3-4b1d-abc6-dce90489c83b",
            "index": 87,
            "title": "AI Is Officially Political",
            "pub_date": "2026-03-06T00:05:38.000Z",
            "duration": "00:27:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Is-Officially-Political-e3g0oc2",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116465474/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-6%2F419389212-44100-2-8e3f5a14837ba.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97ff1c22-c80a-403b-b7cf-ff8aaa13ee3a",
            "index": 88,
            "title": "The Big Questions That Will Decide the Consumer AI War",
            "pub_date": "2026-03-04T22:17:02.000Z",
            "duration": "00:31:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Big-Questions-That-Will-Decide-the-Consumer-AI-War-e3fut3o",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116404792/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-4%2F419307125-44100-2-2da2dd47ff32b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "566e3c0c-abc4-4ad9-b844-52b3e1ace36e",
            "index": 89,
            "title": "The Rise of the Zero Human Company",
            "pub_date": "2026-03-04T00:11:52.000Z",
            "duration": "00:29:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "claude",
              "cursor"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Rise-of-the-Zero-Human-Company-e3ftc9a",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116354794/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-4%2F419237766-44100-2-6d16790b1235a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6566ddb0-94cb-45d2-be64-06e163238415",
            "index": 90,
            "title": "The Month AI Woke Up",
            "pub_date": "2026-03-02T22:34:21.000Z",
            "duration": "00:26:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Month-AI-Woke-Up-e3frjhb",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116296683/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-2%2F419158504-44100-2-e1e1349834b1a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "99232a9e-877c-41c4-a9b0-57ff4fadd6ea",
            "index": 91,
            "title": "Schrödinger’s Apocalypse",
            "pub_date": "2026-03-01T21:16:12.000Z",
            "duration": "00:29:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Schrdingers-Apocalypse-e3fpqhe",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116238318/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-1%2F419080003-44100-2-da0c3d174734b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "10625204-5102-4b76-86dc-8e434faa7c5c",
            "index": 92,
            "title": "Who Controls AI?",
            "pub_date": "2026-02-28T22:21:53.000Z",
            "duration": "00:30:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Who-Controls-AI-e3foi8t",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116197085/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-28%2F419024961-44100-2-39facebc1e97.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "031c0aaf-b677-4c3a-ad9e-0a1e3f43d68d",
            "index": 93,
            "title": "Are 40% Staff Cuts the New AI Normal?",
            "pub_date": "2026-02-28T01:11:42.000Z",
            "duration": "00:24:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "claude",
              "chips",
              "copilot"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Are-40-Staff-Cuts-the-New-AI-Normal-e3fnjad",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116165389/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-28%2F418983673-44100-2-41183ec178c64.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "30e87ece-65f4-4f6b-b792-50e60f6516df",
            "index": 94,
            "title": "The OpenClaw-ification of AI",
            "pub_date": "2026-02-26T23:27:54.000Z",
            "duration": "00:28:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-OpenClaw-ification-of-AI-e3fluoh",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/116111569/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-26%2F418912386-44100-2-575c6bb03bb99.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "145512ef-6270-4569-863d-e7cdc2380380",
            "index": 95,
            "title": "The Rise of the Anti-AI Movement",
            "pub_date": "2026-02-24T21:47:12.000Z",
            "duration": "00:30:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "data center",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Rise-of-the-Anti-AI-Movement-e3fiem1",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115996801/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-24%2F418760348-44100-2-a73aa2033a0fe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a53389ba-7294-404f-948c-f09c0b3e726d",
            "index": 96,
            "title": "The Perils of the AI Exponential",
            "pub_date": "2026-02-23T20:30:00.000Z",
            "duration": "00:27:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Perils-of-the-AI-Exponential-e3fgek4",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115931204/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-23%2F418671766-44100-2-c774c63c81f04.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a47b4d01-d552-4c16-abd6-c205c641e0e0",
            "index": 97,
            "title": "Why AI Could Be Better for Plumbers than Programmers",
            "pub_date": "2026-02-22T13:15:29.000Z",
            "duration": "00:22:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-AI-Could-Be-Better-for-Plumbers-than-Programmers-e3fef0d",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115866061/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-22%2F418584959-44100-2-94a6534fcf88d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5c33dc6-50e9-4eae-bf7a-f19c69ddaf87",
            "index": 98,
            "title": "Does Gemini 3.1 Pro Matter?",
            "pub_date": "2026-02-20T20:52:38.000Z",
            "duration": "00:26:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "gemini",
              "reasoning",
              "multimodal"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Does-Gemini-3-1-Pro-Matter-e3fcld4",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115807076/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-20%2F418507671-44100-2-bffc0f836fc43.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ecab5bad-bbbc-465e-b60b-52bcfb67be45",
            "index": 99,
            "title": "How People Actually Use AI Agents",
            "pub_date": "2026-02-19T20:12:12.000Z",
            "duration": "00:26:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "anthropic",
              "gemini",
              "grok",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-People-Actually-Use-AI-Agents-e3fb1oc",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115754188/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-19%2F418436114-44100-2-ebbd5d62d5247.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "247efdb2-a176-4ba8-8472-17dd71c32ae2",
            "index": 100,
            "title": "Sonnet 4.6 Changes the Agent Math",
            "pub_date": "2026-02-18T21:00:01.000Z",
            "duration": "00:26:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "grok",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Sonnet-4-6-Changes-the-Agent-Math-e3f9d3g",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115700272/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-18%2F418363673-44100-2-cc07397dc6bf8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "09223e68-592b-495f-9801-e2df6b50b14a",
            "index": 101,
            "title": "The AI Productivity Boom Finally Shows Up",
            "pub_date": "2026-02-17T21:27:01.000Z",
            "duration": "00:26:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Productivity-Boom-Finally-Shows-Up-e3f7uge",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115652558/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-17%2F418299327-44100-2-c16a4882ea573.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e20bc3c1-455e-4f19-8f3d-8099fca22a99",
            "index": 102,
            "title": "OpenClaw Goes to OpenAI",
            "pub_date": "2026-02-16T21:51:30.000Z",
            "duration": "00:30:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/OpenClaw-Goes-to-OpenAI-e3f6ehl",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115603445/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-16%2F418232992-44100-2-c7d9116d6b714.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3cf6e65e-b6bf-4633-b3e5-71ab32af4742",
            "index": 103,
            "title": "Something Big Is Happening",
            "pub_date": "2026-02-15T12:03:00.000Z",
            "duration": "00:28:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Something-Big-Is-Happening-e3f3g0j",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115506643/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-14%2F418105915-44100-2-b3dd172e22a7f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ce1b40bd-3f5d-4fd9-b216-f68452b54ef0",
            "index": 104,
            "title": "The Time Savings Era of AI Is Over",
            "pub_date": "2026-02-13T19:30:00.000Z",
            "duration": "00:20:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "claude",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Time-Savings-Era-of-AI-Is-Over-e3f2d7u",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115471038/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-13%2F418058741-44100-2-a7ef3cd4eed94.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6dd2e3b5-cb68-42e7-953d-6e545b3dd4c1",
            "index": 105,
            "title": "How I Built My 10-Agent OpenClaw Team",
            "pub_date": "2026-02-12T20:00:00.000Z",
            "duration": "00:22:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-I-Built-My-10-Agent-OpenClaw-Team-e3ev5p8",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115365096/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-11%2F417916900-44100-2-a1eab8b0be297.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "78f56d87-d7a6-42e9-8190-94d7e9df39ba",
            "index": 106,
            "title": "How the Global AI Race Has Shifted",
            "pub_date": "2026-02-11T21:00:01.000Z",
            "duration": "00:24:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "xai",
              "chips",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-the-Global-AI-Race-Has-Shifted-e3ev60q",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115365338/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-11%2F417917272-44100-2-f1e37203c8a27.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c633b54f-aac6-4a5b-9747-eb86891a43cb",
            "index": 107,
            "title": "Why AI Leads to More Work, Not Less",
            "pub_date": "2026-02-10T22:00:00.000Z",
            "duration": "00:23:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "data center",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-AI-Leads-to-More-Work--Not-Less-e3etq4k",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115320404/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-10%2F417856510-44100-2-f8ff376240ff5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa660948-b085-4deb-970b-ba4c9a9e8d40",
            "index": 108,
            "title": "Did the Super Bowl Make Americans Like AI Any More?",
            "pub_date": "2026-02-09T21:45:59.000Z",
            "duration": "00:26:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Did-the-Super-Bowl-Make-Americans-Like-AI-Any-More-e3es87e",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115269294/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-9%2F417787347-44100-2-2f56ce67edc3b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cf82bd33-b369-4af9-ba55-604367f85a10",
            "index": 109,
            "title": "Claude Code Killed the AI Bubble",
            "pub_date": "2026-02-08T14:47:34.000Z",
            "duration": "00:24:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "claude",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Claude-Code-Killed-the-AI-Bubble-e3eq5fr",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115200955/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-8%2F417696610-44100-2-65ec9c27ece02.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e876230f-3483-4973-97d0-abebd45f29e5",
            "index": 110,
            "title": "How to Learn AI With AI",
            "pub_date": "2026-02-08T01:49:26.000Z",
            "duration": "00:17:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Learn-AI-With-AI-e3epktu",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115183998/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-8%2F417674513-44100-2-3c8ee89560189.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "798e037d-2113-4dcb-a398-ab310e29aad2",
            "index": 111,
            "title": "Opus 4.6 and ChatGPT 5.3-Codex Are Here and the Labs Are at War",
            "pub_date": "2026-02-06T21:51:23.000Z",
            "duration": "00:27:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Opus-4-6-and-ChatGPT-5-3-Codex-Are-Here-and-the-Labs-Are-at-War-e3eoc60",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115142272/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-6%2F417618971-44100-2-69d4a94f12e5d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "574ffd8f-aa92-4f2e-b86d-7d1ac2b648b8",
            "index": 112,
            "title": "Is Software Dead?",
            "pub_date": "2026-02-05T22:38:05.000Z",
            "duration": "00:28:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Is-Software-Dead-e3emthk",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115094516/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-6%2F417591660-44100-2-05e1c30af2331.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e3a7f3eb-5288-44cd-8bae-246859c043e9",
            "index": 113,
            "title": "The Dawn of the Agent Age",
            "pub_date": "2026-02-05T00:15:22.000Z",
            "duration": "00:24:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "claude",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Dawn-of-the-Agent-Age-e3eldab",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/115045131/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-4%2F417488790-44100-2-ff81c6839ba2b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a72084e9-1e05-44d8-bc2d-1af19271561e",
            "index": 114,
            "title": "The AI Race Just Got a SpaceX-Sized Twist",
            "pub_date": "2026-02-03T21:53:52.000Z",
            "duration": "00:26:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "xai",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Race-Just-Got-a-SpaceX-Sized-Twist-e3ejn0u",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114989534/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-3%2F417414539-44100-2-38e43c084826f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ab94db4d-e708-4ed4-a5ee-93989f0dc81f",
            "index": 115,
            "title": "Why Moltbook Matters",
            "pub_date": "2026-02-02T22:01:03.000Z",
            "duration": "00:25:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Moltbook-Matters-e3ei1kq",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114934874/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-2%2F417341610-44100-2-76d9c56fb88eb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b30b82b2-41f0-44cd-9efa-d2055d329403",
            "index": 116,
            "title": "OpenAI IPO? Grok-SpaceX Merger? The AI IPO Race Heats Up",
            "pub_date": "2026-02-01T12:22:15.000Z",
            "duration": "00:29:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "xai",
              "grok",
              "perplexity"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/OpenAI-IPO--Grok-SpaceX-Merger--The-AI-IPO-Race-Heats-Up-e3efme6",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114857862/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-1-1%2F417238881-44100-2-ab9e0a9e51149.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4a2e2fd0-1977-4245-8c1f-586420bd8ebd",
            "index": 117,
            "title": "100,000 AI Agents Joined Their Own Social Network Today. It's Called Moltbook.",
            "pub_date": "2026-01-31T00:49:02.000Z",
            "duration": "00:26:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/100-000-AI-Agents-Joined-Their-Own-Social-Network-Today--Its-Called-Moltbook-e3ee5ue",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114808206/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-31%2F417174134-44100-2-845c08a34cead.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d3c6fe8a-4362-49b6-b513-a5cfa378b2cc",
            "index": 118,
            "title": "Are Markets Still Worried About an AI Bubble?",
            "pub_date": "2026-01-30T01:24:50.000Z",
            "duration": "00:28:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "openai",
              "anthropic",
              "claude",
              "xai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Are-Markets-Still-Worried-About-an-AI-Bubble-e3eco6e",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114761358/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-30%2F417111454-44100-2-91ce3a5512e83.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7cb3be7-e24f-4079-bb3e-dbd798445e25",
            "index": 119,
            "title": "Are Agent Swarms the Next AI Paradigm?",
            "pub_date": "2026-01-28T22:30:01.000Z",
            "duration": "00:22:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "anthropic",
              "nvidia",
              "chip",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Are-Agent-Swarms-the-Next-AI-Paradigm-e3eb0mb",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114704523/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-28%2F417033962-44100-2-2a3f794d4a1cd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c221ad1f-bd0a-4878-ac38-07fe04b91b2c",
            "index": 120,
            "title": "The AI Acceleration Gap",
            "pub_date": "2026-01-28T02:23:10.000Z",
            "duration": "00:28:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "chips",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Acceleration-Gap-e3e9nf7",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114662311/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-28%2F416977728-44100-2-029aafbc063b8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "afa332d8-0852-40c7-9384-0faac5ffda22",
            "index": 121,
            "title": "Ralph Wiggum, Clawdbot, and Mac Minis: How Pros Are Vibe Coding in 2026",
            "pub_date": "2026-01-26T18:00:00.000Z",
            "duration": "00:24:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Ralph-Wiggum--Clawdbot--and-Mac-Minis-How-Pros-Are-Vibe-Coding-in-2026-e3e5ior",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114526427/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-25%2F416797359-44100-2-c9000cf69946e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6ade6559-05a2-4475-98f6-0c40ecdda572",
            "index": 122,
            "title": "Skills for the Code AGI Era",
            "pub_date": "2026-01-25T13:50:00.000Z",
            "duration": "00:18:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Skills-for-the-Code-AGI-Era-e3e4skk",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114503764/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-25%2F416769286-44100-2-359d44dd39906.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1b0f6b9a-8619-41e9-ab49-75e5c37db013",
            "index": 123,
            "title": "Who Will Adapt Best to AI Disruption?",
            "pub_date": "2026-01-24T12:16:41.000Z",
            "duration": "00:21:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "data center",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Who-Will-Adapt-Best-to-AI-Disruption-e3e3p6q",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114467482/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-24%2F416740744-44100-2-1ed9c79a08fb2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fc46ddf1-cc58-4068-a320-ac63b5151b03",
            "index": 124,
            "title": "The 3x Payoff of Deep AI Integration",
            "pub_date": "2026-01-22T23:36:19.000Z",
            "duration": "00:23:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chip",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-3x-Payoff-of-Deep-AI-Integration-e3e24qb",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114413835/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-22%2F416653232-44100-2-d5389c170071d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cde32e4a-5dfd-4559-8665-ce2ad1d2294d",
            "index": 125,
            "title": "AGI Timelines Shift Forward",
            "pub_date": "2026-01-22T01:29:40.000Z",
            "duration": "00:21:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "openai",
              "gemini",
              "chip",
              "chips"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AGI-Timelines-Shift-Forward-e3e0o7c",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114368172/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-22%2F416593762-44100-2-56aff435bc48c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "153c1c69-c61a-4193-90e5-69ee3be422d4",
            "index": 126,
            "title": "The AI Capabilities Overhang",
            "pub_date": "2026-01-21T03:32:14.000Z",
            "duration": "00:29:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude",
              "xai",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Capabilities-Overhang-e3dv7r0",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114318624/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-21%2F416529459-44100-2-fcf27a704c6fe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5bee5fbb-e72b-40e1-82a1-bcd255f41fff",
            "index": 127,
            "title": "How to Make ChatGPT Ads Not Suck",
            "pub_date": "2026-01-19T22:10:22.000Z",
            "duration": "00:23:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Make-ChatGPT-Ads-Not-Suck-e3dt4fv",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114249663/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-19%2F416439676-44100-2-7a1b14132f534.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d33c8f2-05ce-4988-9230-0caa2097ac7e",
            "index": 128,
            "title": "Code AGI is Functional AGI (And It's Here)",
            "pub_date": "2026-01-18T13:07:02.000Z",
            "duration": "00:24:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Code-AGI-is-Functional-AGI-And-Its-Here-e3dqp2s",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114172444/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-18%2F416342116-44100-2-a3f1b96fea.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8470af2f-e172-4858-97a8-9df91e1a82e9",
            "index": 129,
            "title": "Why CEOs Need to Lead AI Strategy",
            "pub_date": "2026-01-17T01:51:22.000Z",
            "duration": "00:23:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "deepmind",
              "replit",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-CEOs-Need-to-Lead-AI-Strategy-e3dp5gj",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114119635/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-17%2F416275720-44100-2-be4e486222645.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "814165a1-7891-46dc-8d3a-7d2de890d70d",
            "index": 130,
            "title": "AI's Battle for Your Context",
            "pub_date": "2026-01-15T23:48:49.000Z",
            "duration": "00:22:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude",
              "gemini",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AIs-Battle-for-Your-Context-e3dnhmr",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114066587/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-15%2F416207582-44100-2-1db1820f7a15c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "74553d7f-e4a1-4f3a-9059-86bace513138",
            "index": 131,
            "title": "ChatGPT 5.5 Coming Soon?",
            "pub_date": "2026-01-15T01:04:32.000Z",
            "duration": "00:20:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "openai",
              "anthropic",
              "nvidia",
              "chip"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/ChatGPT-5-5-Coming-Soon-e3dlva0",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/114014976/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-15%2F416141703-44100-2-0edcb301ce8f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "51233a09-d2ce-4c68-992d-5102554ad0b7",
            "index": 132,
            "title": "Claude Cowork Is Claude Code for Everyone Else",
            "pub_date": "2026-01-13T22:58:30.000Z",
            "duration": "00:28:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Claude-Cowork-Is-Claude-Code-for-Everyone-Else-e3dk53n",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113955383/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-13%2F416066354-44100-2-afe0224530251.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c202e8fe-3846-491d-b3db-2908d5416632",
            "index": 133,
            "title": "Google to Officially Power Apple AI Siri",
            "pub_date": "2026-01-13T01:07:27.000Z",
            "duration": "00:25:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agent",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Google-to-Officially-Power-Apple-AI-Siri-e3dieoe",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113899726/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-12%2F415994440-44100-2-97dcae5d2eb47.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0edd6892-c38c-4486-bb18-a8f50219806f",
            "index": 134,
            "title": "Does Work Still Matter in the Age of AI?",
            "pub_date": "2026-01-11T19:42:49.000Z",
            "duration": "00:22:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Does-Work-Still-Matter-in-the-Age-of-AI-e3dgbkg",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113830992/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-11%2F415907463-44100-2-a4d14670f0857.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "08c55af6-e0d4-4d40-963b-3c1ba80c933c",
            "index": 135,
            "title": "Building a Personal AI Model Map [AI Operators Bonus Episode]",
            "pub_date": "2026-01-10T18:18:33.000Z",
            "duration": "00:12:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Building-a-Personal-AI-Model-Map-AI-Operators-Bonus-Episode-e3df457",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113790567/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-10%2F415856922-44100-2-61ccb2ab8eeb9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33bfde93-8531-4cca-bc26-10203688e5d6",
            "index": 136,
            "title": "What Happens When AI Obliterates Your Business Model?",
            "pub_date": "2026-01-10T00:05:49.000Z",
            "duration": "00:22:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "gemini",
              "nvidia",
              "chip",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-Happens-When-AI-Obliterates-Your-Business-Model-e3debhm",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113765366/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-10%2F415825131-44100-2-5c09798761f77.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "028c8f84-0f11-4a69-b2e7-7c50f1d17fa9",
            "index": 137,
            "title": "How People Are Using AI for Health",
            "pub_date": "2026-01-09T03:15:00.000Z",
            "duration": "00:24:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "openai",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-People-Are-Using-AI-for-Health-e3dcvau",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113720094/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-9%2F415767559-44100-2-4e79b9beb4152.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3daf70f7-91d7-4ea4-b779-76a3ecf49019",
            "index": 138,
            "title": "Why Everyone Is Obsessed With Claude Code",
            "pub_date": "2026-01-09T01:10:24.000Z",
            "duration": "00:28:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "claude",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Everyone-Is-Obsessed-With-Claude-Code-e3dbb2r",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113666587/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-8%2F415698507-44100-2-ad36c12225211.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "90bd6d0e-d3dc-41e2-b9aa-e96f2f535de1",
            "index": 139,
            "title": "AI at CES is Not Just Cheesy Gadgets Anymore",
            "pub_date": "2026-01-07T01:28:06.000Z",
            "duration": "00:30:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "nvidia",
              "data center",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-at-CES-is-Not-Just-Cheesy-Gadgets-Anymore-e3d9k98",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113610472/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-7%2F415626664-44100-2-04a5c6da68222.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1c5bae31-5fcf-4a39-bcb3-7166881a23e6",
            "index": 140,
            "title": "Context Graphs: AI's Next Big Idea",
            "pub_date": "2026-01-05T21:30:00.000Z",
            "duration": "00:25:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "grok",
              "coding",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Context-Graphs-AIs-Next-Big-Idea-e3d7hej",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113542035/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-5%2F415541300-44100-2-e0c2726b31802.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6ae1237b-3905-40d3-b3a5-299632ee192e",
            "index": 141,
            "title": "Work in the Age of Infinite Agents",
            "pub_date": "2026-01-04T13:33:55.000Z",
            "duration": "00:23:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "automation",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Work-in-the-Age-of-Infinite-Agents-e3d5ggm",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113475542/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-4%2F415457562-44100-2-2ac756999971f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f4a2be8-c32a-4445-b3fc-fbba8397578c",
            "index": 142,
            "title": "What Manus and Groq Acquisitions Tell Us About AI",
            "pub_date": "2026-01-03T00:51:43.000Z",
            "duration": "00:25:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "claude",
              "xai",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-Manus-and-Groq-Acquisitions-Tell-Us-About-AI-e3d3td4",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113423204/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-0-3%2F415391666-44100-2-6617f083c0a16.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "25d8f43f-1bf3-41f8-b824-73f5b407ca97",
            "index": 143,
            "title": "AI New Year’s: The 10-Week AI Resolution",
            "pub_date": "2025-12-31T15:00:00.000Z",
            "duration": "00:27:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-New-Years-The-10-Week-AI-Resolution-e3d10rk",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113328436/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-31%2F415271103-44100-2-e3b06acd076ee.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9804249e-3054-4506-b9e8-96447793c19a",
            "index": 144,
            "title": "50 AI Predictions for 2026 - Part 2",
            "pub_date": "2025-12-30T15:43:28.000Z",
            "duration": "00:26:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "grok",
              "data center",
              "coding",
              "model labs"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/50-AI-Predictions-for-2026---Part-2-e3cvs7s",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113290940/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-30%2F415222969-44100-2-a1410d6349adb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eac962ae-6dc4-46e7-96c4-5b71e87e1a39",
            "index": 145,
            "title": "50 AI Predictions for 2026 - Part 1",
            "pub_date": "2025-12-29T18:48:58.000Z",
            "duration": "00:24:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "multimodal",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/50-AI-Predictions-for-2026---Part-1-e3cujje",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113249326/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-29%2F415170720-44100-2-533c2ce3ffef2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2bf73860-a781-45f5-94da-e94ae9767912",
            "index": 146,
            "title": "Why 2026 Is the Year of the AI Builder with Lovable CEO Anton Osika",
            "pub_date": "2025-12-28T13:13:06.000Z",
            "duration": "00:34:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-2026-Is-the-Year-of-the-AI-Builder-with-Lovable-CEO-Anton-Osika-e3cstoo",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113194200/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-28%2F415101659-44100-2-272c22e1a9a51.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46130502-6d0e-4c18-9be5-28d8690e2ba6",
            "index": 147,
            "title": "The 5 Most Impactful AI Model Releases of 2025",
            "pub_date": "2025-12-26T14:40:28.000Z",
            "duration": "00:29:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-5-Most-Impactful-AI-Model-Releases-of-2025-e3cr2nh",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113133745/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-26%2F415024861-44100-2-b016c0a2f4a29.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "586c2917-dc08-4e90-9057-1d57e2fda35f",
            "index": 148,
            "title": "51 Charts That Will Shape AI in 2026",
            "pub_date": "2025-12-24T23:00:00.000Z",
            "duration": "00:27:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/51-Charts-That-Will-Shape-AI-in-2026-e3cploj",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113087699/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-24%2F414966463-44100-2-8d1928896b1f3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da68f83e-04bc-43f1-ac69-b02fa58ca8af",
            "index": 149,
            "title": "How AI Starts Doing the Work in 2026 With Anthropic CPO Mike Krieger",
            "pub_date": "2025-12-24T00:25:27.000Z",
            "duration": "00:30:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-AI-Starts-Doing-the-Work-in-2026-With-Anthropic-CPO-Mike-Krieger-e3cojsp",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113053017/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-23%2F414922729-44100-2-5d2b7a57e0243.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89aefcca-e2ad-43f1-849c-90d8cace91e0",
            "index": 150,
            "title": "The 10 Biggest AI Stories of 2025",
            "pub_date": "2025-12-22T22:12:28.000Z",
            "duration": "00:28:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "gemini",
              "reasoning",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-10-Biggest-AI-Stories-of-2025-e3cn5q0",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/113005824/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-22%2F414861302-44100-2-dd0143d55654b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "38d9ed24-d1c9-465e-a209-dfe04a06f9f7",
            "index": 151,
            "title": "Power Ranking the Big AI Ideas for 2026",
            "pub_date": "2025-12-21T12:38:35.000Z",
            "duration": "00:31:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "multimodal",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Power-Ranking-the-Big-AI-Ideas-for-2026-e3cl409",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112938441/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-21%2F414775313-44100-2-feed802ad7bdf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3107a450-d9c6-404a-8376-85cf8e9913d6",
            "index": 152,
            "title": "The Most Important AI Stories This Week",
            "pub_date": "2025-12-19T21:30:01.000Z",
            "duration": "00:31:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "gemini",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Most-Important-AI-Stories-This-Week-e3cium4",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112867460/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-19%2F414684775-44100-2-3f4c4d925b46d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cb33cbf0-7ea3-4442-b42e-956ff4b3ea3c",
            "index": 153,
            "title": "82% of Companies Are Seeing Positive AI ROI",
            "pub_date": "2025-12-19T00:36:55.000Z",
            "duration": "00:23:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/82-of-Companies-Are-Seeing-Positive-AI-ROI-e3cidhk",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112849908/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-19%2F414662304-44100-2-6e6d1afbadddd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e6986926-30b5-419a-bc2f-508738a75712",
            "index": 154,
            "title": "4 Reasons to Use GPT Image 1.5 Over Nano Banana Pro",
            "pub_date": "2025-12-18T01:26:29.000Z",
            "duration": "00:25:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/4-Reasons-to-Use-GPT-Image-1-5-Over-Nano-Banana-Pro-e3cgskf",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112799823/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-18%2F414597973-44100-2-3096187fb9e3f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d3af2871-bc82-4577-8ed9-58ac6951a268",
            "index": 155,
            "title": "The Most Important AI Lesson Businesses Learned in 2025",
            "pub_date": "2025-12-17T01:22:37.000Z",
            "duration": "00:21:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Most-Important-AI-Lesson-Businesses-Learned-in-2025-e3cfbb5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112749349/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-17%2F414532423-44100-2-01f2eb9151772.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5012ebf6-34c6-46e9-a7a6-6485f3773e76",
            "index": 156,
            "title": "Will This OpenAI Update Make AI Agents Work Better?",
            "pub_date": "2025-12-15T22:24:04.000Z",
            "duration": "00:22:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Will-This-OpenAI-Update-Make-AI-Agents-Work-Better-e3cddbr",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112685883/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-15%2F414450083-44100-2-6920ca83c7094.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "543b940c-6adc-4fb4-9340-8151c12f6b88",
            "index": 157,
            "title": "The Architects of AI That TIME Missed",
            "pub_date": "2025-12-14T11:34:02.000Z",
            "duration": "00:19:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "model labs"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Architects-of-AI-That-TIME-Missed-e3cb2cs",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112609116/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-14%2F414352906-44100-2-5eadd28a4b4a8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "60d0e36c-d779-4e92-a998-dca20d508197",
            "index": 158,
            "title": "Why AI Advantage Compounds",
            "pub_date": "2025-12-12T22:00:00.000Z",
            "duration": "00:22:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "gemini",
              "google ai",
              "chip"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-AI-Advantage-Compounds-e3c9h58",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112558696/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-12%2F414289257-44100-2-68cdc2bf9c765.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0fef1ee7-70f2-444c-8505-a503009ff2e2",
            "index": 159,
            "title": "GPT-5.2 is Here",
            "pub_date": "2025-12-11T23:44:22.000Z",
            "duration": "00:24:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "gemini",
              "google ai",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/GPT-5-2-is-Here-e3c83vm",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112512438/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-11%2F414230710-44100-2-3881cfb08e50f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5cbfeeb-5d0b-489f-980a-c164e7170119",
            "index": 160,
            "title": "The State of Enterprise AI",
            "pub_date": "2025-12-10T22:52:58.000Z",
            "duration": "00:28:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 18,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-State-of-Enterprise-AI-e3c6da9",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112456457/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-10%2F414159090-44100-2-c22de8ea8afe.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bde74624-e235-471d-b0b4-a65ea07cf856",
            "index": 161,
            "title": "The AI Race Gets a Massive Power Shift",
            "pub_date": "2025-12-10T01:00:19.000Z",
            "duration": "00:24:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "claude",
              "gemini",
              "google ai",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Race-Gets-a-Massive-Power-Shift-e3c4lr6",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112399654/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-10%2F414086885-44100-2-c0100092a9124.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f34fc452-1863-4b47-b76a-62e3a25a6acd",
            "index": 162,
            "title": "What People Are Actually Using AI For Right Now",
            "pub_date": "2025-12-08T22:20:26.000Z",
            "duration": "00:25:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "gemini",
              "google ai",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-People-Are-Actually-Using-AI-For-Right-Now-e3c2ood",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112337101/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-8%2F414005895-44100-2-99abed376d305.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04e1db76-b931-43be-b73a-b7fa25b9616b",
            "index": 163,
            "title": "AI Has a PR Problem",
            "pub_date": "2025-12-07T12:30:54.000Z",
            "duration": "00:23:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Has-a-PR-Problem-e3c0db1",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112259873/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-7%2F413905366-44100-2-86a5c85a87d95.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dca6fd05-09c5-49f7-8208-423c5b0e3105",
            "index": 164,
            "title": "What 1,250 Professionals Say About Working With AI",
            "pub_date": "2025-12-05T23:28:35.000Z",
            "duration": "00:28:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "anthropic",
              "gemini",
              "replit"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-1-250-Professionals-Say-About-Working-With-AI-e3buu4o",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112211544/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-5%2F413842740-44100-2-ceb2a49681407.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c0c4f0c-aaf3-43e3-a7c3-9529049e4469",
            "index": 165,
            "title": "Can Today’s AI Really Replace 12% of Work?",
            "pub_date": "2025-12-04T23:05:31.000Z",
            "duration": "00:21:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Can-Todays-AI-Really-Replace-12-of-Work-e3btac0",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112158528/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-4%2F413774778-44100-2-c2b8fde2615dd.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "054a73d0-013b-41d5-89dc-92e6452033b7",
            "index": 166,
            "title": "What We Learned About Amazon’s AI Strategy",
            "pub_date": "2025-12-03T22:29:32.000Z",
            "duration": "00:26:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "mistral",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-We-Learned-About-Amazons-AI-Strategy-e3brgpr",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112099579/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-3%2F413697922-44100-2-3e5fe6e8c30aa.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4d7fd74-cbdd-4d8f-aaf4-6d40e8876457",
            "index": 167,
            "title": "OpenAI Declares Code Red",
            "pub_date": "2025-12-02T22:21:40.000Z",
            "duration": "00:22:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "anthropic",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/OpenAI-Declares-Code-Red-e3bpsd3",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/112045923/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-2%2F413627733-44100-2-aebbb8628ba6b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ee6d4895-6e10-402a-94fb-4a732d6978d0",
            "index": 168,
            "title": "The 5 Biggest AI Stories to Watch in December",
            "pub_date": "2025-12-01T22:45:59.000Z",
            "duration": "00:26:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-5-Biggest-AI-Stories-to-Watch-in-December-e3bo7tu",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111992190/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-11-1%2F413556959-44100-2-15f2e92fe7dab.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9b1dcc4-c462-43ea-8d41-9acddfb929e7",
            "index": 169,
            "title": "A Practical Guide to Scaling AI",
            "pub_date": "2025-11-30T12:18:28.000Z",
            "duration": "00:26:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/A-Practical-Guide-to-Scaling-AI-e3bloih",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111910929/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-30%2F413452114-44100-2-160e8d86b79eb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bcaaba7a-07e9-40b9-85e0-28c336ba5c18",
            "index": 170,
            "title": "10 AI Projects to Learn Gemini 3 Nano Banana and Opus 4.5",
            "pub_date": "2025-11-28T18:00:01.000Z",
            "duration": "00:24:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "gemini",
              "reasoning",
              "multimodal"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/10-AI-Projects-to-Learn-Gemini-3-Nano-Banana-and-Opus-4-5-e3bjjb5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111840037/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-28%2F413359249-44100-2-e079aa8e32a4b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "57e6e9bc-d291-4f85-bb2a-ea99d549b469",
            "index": 171,
            "title": "10 Holiday-Themed Kids AI Activities",
            "pub_date": "2025-11-27T16:00:01.000Z",
            "duration": "00:14:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/10-Holiday-Themed-Kids-AI-Activities-e3bi0ut",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111788445/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-27%2F413275302-44100-2-f59d6ba36a5fb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "270c587c-68d7-44fb-951f-832ccb0b7850",
            "index": 172,
            "title": "Can AI Really Automate 57 Percent of Work?",
            "pub_date": "2025-11-26T22:30:01.000Z",
            "duration": "00:23:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Can-AI-Really-Automate-57-Percent-of-Work-e3bh2bs",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111757116/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-26%2F413233593-44100-2-ddc4edf2b7b55.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd14741d-c04e-4603-8f31-31c8a2c1baaf",
            "index": 173,
            "title": "Why Opus 4.5 Changes Vibe Coding",
            "pub_date": "2025-11-26T03:29:47.000Z",
            "duration": "00:28:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Opus-4-5-Changes-Vibe-Coding-e3bftl2",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111719522/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-26%2F413184149-44100-2-f1d48de95e9fc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d88c1d2-4c06-4c4a-9c66-94bfc1e71895",
            "index": 174,
            "title": "Why the AI Bubble Debate is Useless",
            "pub_date": "2025-11-24T20:45:17.000Z",
            "duration": "00:26:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-the-AI-Bubble-Debate-is-Useless-e3bdrvf",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111652271/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-24%2F413093339-44100-2-9b5df4d2fb367.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3ad38a11-686a-4b8a-a542-bb925350a415",
            "index": 175,
            "title": "The 7 Most Important Things We Learned About AI This Week",
            "pub_date": "2025-11-23T11:59:53.000Z",
            "duration": "00:19:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "nvidia",
              "training",
              "reasoning",
              "multimodal"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-7-Most-Important-Things-We-Learned-About-AI-This-Week-e3bbmk7",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111581255/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-23%2F413000766-44100-2-b6e63ef69e0bc.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "acbbc0e0-ce2a-4952-a64b-ca60b9b824f3",
            "index": 176,
            "title": "25 Things Nano Banana Pro Does That AI Couldn't Before",
            "pub_date": "2025-11-22T00:13:24.000Z",
            "duration": "00:20:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/25-Things-Nano-Banana-Pro-Does-That-AI-Couldnt-Before-e3ba9f3",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111535011/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-22%2F412941255-44100-2-bf1a790123f83.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cc3d5a3f-bf1d-4bc3-8d6c-c3cbfefccf75",
            "index": 177,
            "title": "A Huge Week for AI Models Gets Even Bigger",
            "pub_date": "2025-11-21T02:23:19.000Z",
            "duration": "00:24:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "gemini",
              "nvidia",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/A-Huge-Week-for-AI-Models-Gets-Even-Bigger-e3b8rhk",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111487988/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-21%2F412880781-44100-2-d078c34e413a7.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "821837cb-3374-43a7-9fe1-58a64803f40f",
            "index": 178,
            "title": "AI Winners and Losers After Gemini 3",
            "pub_date": "2025-11-20T02:01:26.000Z",
            "duration": "00:26:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "gemini",
              "grok"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Winners-and-Losers-After-Gemini-3-e3b7bik",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111438868/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-20%2F412815159-44100-2-f0001b652f06f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be9d99dc-25a7-49a6-aded-42277051896e",
            "index": 179,
            "title": "How Gemini 3 Changes the AI Race",
            "pub_date": "2025-11-18T20:55:36.000Z",
            "duration": "00:23:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "anthropic",
              "gemini",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-Gemini-3-Changes-the-AI-Race-e3b5dke",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111375438/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-18%2F412730407-44100-2-3476d577e588b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6da466a3-269f-42d0-a80e-aad19944d9ed",
            "index": 180,
            "title": "The AI Scientist That Does 6 Months of Work in a Day",
            "pub_date": "2025-11-17T21:06:17.000Z",
            "duration": "00:24:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Scientist-That-Does-6-Months-of-Work-in-a-Day-e3b3noq",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111320282/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-17%2F412658778-44100-2-94bc189eef52e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13ee0ab7-4ba1-4474-8399-92aed9017040",
            "index": 181,
            "title": "Can AI Be Normal and Transformative at the Same Time?",
            "pub_date": "2025-11-16T12:05:30.000Z",
            "duration": "00:22:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "alignment",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Can-AI-Be-Normal-and-Transformative-at-the-Same-Time-e3b1fhg",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111246320/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-16%2F412563662-44100-2-913daeb7555da.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "99fc98e0-73b7-4788-84e3-1ae7c8269dd5",
            "index": 182,
            "title": "Apps vs Models: Who Wins AI?",
            "pub_date": "2025-11-14T22:30:00.000Z",
            "duration": "00:28:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "cursor"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Apps-vs-Models-Who-Wins-AI-e3avt1m",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111194614/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-14%2F412495820-44100-2-32efb5868403d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6ab0a321-d05b-4ec5-9e3f-ef6d4c1f04e0",
            "index": 183,
            "title": "6 Things GPT-5.1 Does Better",
            "pub_date": "2025-11-14T00:39:06.000Z",
            "duration": "00:25:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/6-Things-GPT-5-1-Does-Better-e3aum2e",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111154702/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-21%2F412922274-44100-2-d80f43fb644b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f4aa016-6636-4076-becc-5d2dbb045ab1",
            "index": 184,
            "title": "Are World Models AI’s Next Big Frontier?",
            "pub_date": "2025-11-12T23:12:16.000Z",
            "duration": "00:23:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "meta ai",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Are-World-Models-AIs-Next-Big-Frontier-e3asu6p",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111097497/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-12%2F412367837-44100-2-2892f236c0f2d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b95cbdbf-f39f-452e-ba47-9e0a1d25736e",
            "index": 185,
            "title": "The Open Source AI Model Beating GPT-5 on Agents",
            "pub_date": "2025-11-11T21:29:45.000Z",
            "duration": "00:23:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Open-Source-AI-Model-Beating-GPT-5-on-Agents-e3ar66h",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/111040145/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-11%2F412291423-44100-2-d29275e244cd9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be248a5b-61a6-4091-b7ab-add6de85a54c",
            "index": 186,
            "title": "What Should the Government’s Role in AI Be?",
            "pub_date": "2025-11-10T20:50:13.000Z",
            "duration": "00:27:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-Should-the-Governments-Role-in-AI-Be-e3apgvm",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110985654/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-10%2F412219158-44100-2-cc641d409ae22.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5e73814d-6897-4f37-9dbb-0a4944a3e893",
            "index": 187,
            "title": "A Framework for Choosing Winning AI Use Cases [Agent Readiness Part 3]",
            "pub_date": "2025-11-09T12:01:03.000Z",
            "duration": "00:29:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/A-Framework-for-Choosing-Winning-AI-Use-Cases-Agent-Readiness-Part-3-e3an7c7",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110910279/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-9%2F412121285-44100-2-ae02ada7c7d6e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c13d259e-c1c2-448d-a0ac-718e7d35f2f6",
            "index": 188,
            "title": "The AI ROI Surprise: Wharton Finds 75% of Enterprises Seeing Positive ROI from AI",
            "pub_date": "2025-11-08T11:42:44.000Z",
            "duration": "00:21:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "anthropic",
              "perplexity"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-ROI-Surprise-Wharton-Finds-75-of-Enterprises-Seeing-Positive-ROI-from-AI-e3am6g8",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110876616/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-8%2F412042956-44100-2-2749b786d3fd8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db8a633f-6d6f-4f1a-9a1a-67ca290f29a4",
            "index": 189,
            "title": "Why OpenAI’s CFO Just Sparked an AI Bailout Debate",
            "pub_date": "2025-11-06T22:17:25.000Z",
            "duration": "00:25:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "nvidia",
              "data center"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-OpenAIs-CFO-Just-Sparked-an-AI-Bailout-Debate-e3ak5q5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110810373/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-6%2F410757363-44100-2-27d493ec76843.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "57596d42-87d9-4d85-94ee-970078b57435",
            "index": 190,
            "title": "How Consulting Reveals the Real Pattern of AI Disruption",
            "pub_date": "2025-11-06T00:03:36.000Z",
            "duration": "00:23:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-Consulting-Reveals-the-Real-Pattern-of-AI-Disruption-e3aiqqc",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110766348/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-5%2F410697828-44100-2-f0c15c033016d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19d48928-e462-4517-8f8c-60e0da696f74",
            "index": 191,
            "title": "Is OpenAI Becoming Too Big to Fail?",
            "pub_date": "2025-11-04T21:06:29.000Z",
            "duration": "00:23:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "chip"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Is-OpenAI-Becoming-Too-Big-to-Fail-e3agml6",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110696550/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-4%2F410603447-44100-2-493b197495a0c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "423bca7c-0421-44fb-b0b4-80c74c9d0005",
            "index": 192,
            "title": "RIP Vibe Coding. Feb 2025-Oct 2025.",
            "pub_date": "2025-11-03T20:00:01.000Z",
            "duration": "00:40:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/RIP-Vibe-Coding--Feb-2025-Oct-2025-e3ae9u2",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110617986/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-3%2F410500724-44100-2-6fc419dc133ef.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19958d2f-1f8f-4135-918d-6e8e51a8f6ef",
            "index": 193,
            "title": "The 5 Biggest AI Stories to Watch in November",
            "pub_date": "2025-11-02T11:18:29.000Z",
            "duration": "00:20:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "gemini",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-5-Biggest-AI-Stories-to-Watch-in-November-e3aco3a",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110566954/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-2%2F410434907-44100-2-09270cc6f0d81.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f99f8d9f-ca72-475a-9228-5bd9f628bba7",
            "index": 194,
            "title": "So Far, AI Can Only Automate 2.5% of Jobs",
            "pub_date": "2025-11-01T01:38:19.000Z",
            "duration": "00:21:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "nvidia",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/So-Far--AI-Can-Only-Automate-2-5-of-Jobs-e3ab96n",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110518935/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-10-1%2F410372627-44100-2-578da7f29834b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2923d7b8-3aa8-4736-97b0-592fef789870",
            "index": 195,
            "title": "Why OpenAI’s $1 Trillion IPO Can’t Come Soon Enough",
            "pub_date": "2025-10-31T01:06:11.000Z",
            "duration": "00:25:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-OpenAIs-1-Trillion-IPO-Cant-Come-Soon-Enough-e3a9q0l",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110470613/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-31%2F410308380-44100-2-156600d3c3bf9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cc5fc17c-80a8-4c35-aa8a-5bae2a33fc72",
            "index": 196,
            "title": "OpenAI is Now Officially a For-Profit Company",
            "pub_date": "2025-10-30T00:49:53.000Z",
            "duration": "00:22:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/OpenAI-is-Now-Officially-a-For-Profit-Company-e3a84ln",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110415991/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-30%2F410236254-44100-2-730b6e53b935d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8bc1eed0-c5cd-4f71-96aa-4b6687667465",
            "index": 197,
            "title": "Where AI Spend is Already ROI Positive",
            "pub_date": "2025-10-29T18:17:39.000Z",
            "duration": "00:21:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "claude",
              "chips",
              "inference"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Where-AI-Spend-is-Already-ROI-Positive-e3a6fjk",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110361652/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-29%2F410165105-44100-2-f1b51fb1e4e11.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4d28616-bccd-4da7-8091-55cd0bb0118b",
            "index": 198,
            "title": "The Surprising Way AI Expands Markets Instead of Capturing Them",
            "pub_date": "2025-10-27T21:36:42.000Z",
            "duration": "00:30:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "openai",
              "mistral"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Surprising-Way-AI-Expands-Markets-Instead-of-Capturing-Them-e3a4hv6",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110298534/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-27%2F410082391-44100-2-6d64f20b2e2cb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0cfcac5e-e1d1-403f-9c6a-970048ec7eae",
            "index": 199,
            "title": "Workers Are Excited About AI Agents — So Why Are Companies Screwing It Up?",
            "pub_date": "2025-10-26T20:00:00.000Z",
            "duration": "00:22:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Workers-Are-Excited-About-AI-Agents--So-Why-Are-Companies-Screwing-It-Up-e3a2fps",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110230780/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-26%2F409994153-44100-2-026c91168f22c.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa2d8472-2187-41ee-b565-7fbfc2944f13",
            "index": 200,
            "title": "Why Data is the Biggest Barrier to AI Readiness (And What to Do About It)",
            "pub_date": "2025-10-25T20:00:01.000Z",
            "duration": "00:26:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Data-is-the-Biggest-Barrier-to-AI-Readiness-And-What-to-Do-About-It-e3a1j2s",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110201372/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-25%2F409955675-44100-2-2ce2e03b4db7e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e59b6eaf-ceea-41d5-86e9-be759af91242",
            "index": 201,
            "title": "AI Context Gets a Major Upgrade",
            "pub_date": "2025-10-24T20:12:19.000Z",
            "duration": "00:23:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Context-Gets-a-Major-Upgrade-e3a0m4e",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110171726/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-24%2F409917307-44100-2-954c415f1e153.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8e694015-970f-4bf3-bcd8-4727e4896d96",
            "index": 202,
            "title": "Why Electricity is AI's Biggest Problem",
            "pub_date": "2025-10-24T00:14:51.000Z",
            "duration": "00:24:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-Electricity-is-AIs-Biggest-Problem-e39ve7k",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110130868/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-24%2F409863340-44100-2-bed4a97194b13.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "195b9340-f805-4901-bc2b-60838fd0e377",
            "index": 203,
            "title": "ChatGPT Just Launched Atlas — Here’s How Get Value From Your AI Browser",
            "pub_date": "2025-10-22T21:44:02.000Z",
            "duration": "00:29:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "perplexity",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/ChatGPT-Just-Launched-Atlas--Heres-How-Get-Value-From-Your-AI-Browser-e39toc9",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110075721/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-22%2F409789367-44100-2-76b2b8c290791.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cace7379-59d4-4652-a801-dc3470913521",
            "index": 204,
            "title": "GPT-5 is 58% AGI",
            "pub_date": "2025-10-21T23:30:01.000Z",
            "duration": "00:23:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "claude",
              "replit",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/GPT-5-is-58-AGI-e39s29i",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/110020338/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-21%2F409715619-44100-2-b3d63e048585d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7e3ff81d-22b3-472a-8d2e-fa6d68d24a73",
            "index": 205,
            "title": "Why an AGI Delay Doesn't Mean an AI Bubble",
            "pub_date": "2025-10-21T02:11:42.000Z",
            "duration": "00:23:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-an-AGI-Delay-Doesnt-Mean-an-AI-Bubble-e39qmgf",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109975503/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-21%2F409656715-44100-2-8dea71c6ab755.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7096b8c0-d0c8-4490-be7b-c31f5ba9688a",
            "index": 206,
            "title": "5 Prompting Tricks to Make Your AI Less Average",
            "pub_date": "2025-10-19T22:00:01.000Z",
            "duration": "00:20:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/5-Prompting-Tricks-to-Make-Your-AI-Less-Average-e39nq5b",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109880939/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-19%2F409534500-44100-2-636068210d179.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f9c03f5-81c3-4825-bc0a-4608df69b9c3",
            "index": 207,
            "title": "How to Build an AI-Ready Culture: A Practical Guide",
            "pub_date": "2025-10-18T18:00:00.000Z",
            "duration": "00:31:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Build-an-AI-Ready-Culture-A-Practical-Guide-e39mrtf",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109849967/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-18%2F409494440-44100-2-a7de16db5e2d2.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a4ec7949-0ad1-4ce1-b012-4d1ce48c32c9",
            "index": 208,
            "title": "15 Business Model Questions for OpenAI and Anthropic",
            "pub_date": "2025-10-17T20:00:01.000Z",
            "duration": "00:29:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/15-Business-Model-Questions-for-OpenAI-and-Anthropic-e39m3ft",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109824957/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-17%2F409461681-44100-2-84da39e40a4d4.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "47599dcf-ad22-4bf4-99f1-3e79a9ddecf9",
            "index": 209,
            "title": "Maybe AI Will Cure Cancer After All",
            "pub_date": "2025-10-17T01:24:09.000Z",
            "duration": "00:24:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Maybe-AI-Will-Cure-Cancer-After-All-e39l4d2",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109793122/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-17%2F409419981-44100-2-61bce5ffd95f9.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1082d8f6-a5ef-4411-a6ee-655e1e271bc0",
            "index": 210,
            "title": "The Problem with ChatGPT Erotica",
            "pub_date": "2025-10-15T21:35:50.000Z",
            "duration": "00:26:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Problem-with-ChatGPT-Erotica-e39j9ub",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109733259/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-15%2F409341873-44100-2-3926dcd65cea5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ae4a67e7-9816-41d2-b5f8-7cd5aac2913b",
            "index": 211,
            "title": "The Next AI Platform Isn't a Model -- It's Your Context",
            "pub_date": "2025-10-14T21:14:28.000Z",
            "duration": "00:24:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "gemini",
              "chips"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Next-AI-Platform-Isnt-a-Model----Its-Your-Context-e39hnte",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109682030/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-14%2F409275893-44100-2-0b892af9e6588.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "38685a59-e885-42b3-9d82-59d19f00d61a",
            "index": 212,
            "title": "These Are the Jobs People Actually WANT AI to Automate",
            "pub_date": "2025-10-13T21:04:35.000Z",
            "duration": "00:31:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "gemini",
              "xai",
              "chip"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/These-Are-the-Jobs-People-Actually-WANT-AI-to-Automate-e39g1i1",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109626369/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-13%2F409202727-44100-2-a318d69edc715.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f0f08845-c167-49f8-9bd8-f99f94556afa",
            "index": 213,
            "title": "What 1,000+ Executives Told Us About AI Agents",
            "pub_date": "2025-10-12T10:00:00.000Z",
            "duration": "00:29:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/What-1-000-Executives-Told-Us-About-AI-Agents-e39ddv4",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109540772/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-12%2F409090737-44100-2-4f0f195c2f0cb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4cf415ec-6d1e-4f38-9e1f-3955b08b14d1",
            "index": 214,
            "title": "Why the Future of AI Has a Body",
            "pub_date": "2025-10-10T20:12:40.000Z",
            "duration": "00:24:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-the-Future-of-AI-Has-a-Body-e39c7ms",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109501596/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-10%2F409039076-44100-2-541cd3114f7b5.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "deca6458-8dee-466e-a222-47b8a36dc7c9",
            "index": 215,
            "title": "How to Use Sora 2 For Business + Prompting Guide",
            "pub_date": "2025-10-09T23:42:00.000Z",
            "duration": "00:27:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "gemini"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Use-Sora-2-For-Business--Prompting-Guide-e39ava1",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109460225/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-9%2F408984699-44100-2-b20464b7213d3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "99a04cf2-f26b-4fb9-81c5-67661527b93a",
            "index": 216,
            "title": "5 Reasons AI is a Bubble (And 5 It’s Not)",
            "pub_date": "2025-10-08T23:03:21.000Z",
            "duration": "00:35:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai",
              "xai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/5-Reasons-AI-is-a-Bubble-And-5-Its-Not-e399a6l",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109405845/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-8%2F408914156-44100-2-141cc923adfc8.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b239b587-d4ad-472c-9769-cda58c9b592f",
            "index": 217,
            "title": "Why OpenAI's AMD Deal Could Be Bigger News than DevDay",
            "pub_date": "2025-10-07T23:22:48.000Z",
            "duration": "00:25:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "nvidia",
              "chip"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-OpenAIs-AMD-Deal-Could-Be-Bigger-News-than-DevDay-e397scs",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109358940/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-7%2F408852793-44100-2-7cd5bae06036e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7518a4d-099f-4ac0-a4a5-e6e1d6942c0d",
            "index": 218,
            "title": "Did OpenAI Just Kill a Bunch of Agent Startups? OpenAI DevDay 2025 First Reactions",
            "pub_date": "2025-10-06T23:48:26.000Z",
            "duration": "00:18:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Did-OpenAI-Just-Kill-a-Bunch-of-Agent-Startups--OpenAI-DevDay-2025-First-Reactions-e396bpt",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109309181/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-6%2F408787947-44100-2-a448e0f4d414b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be861f46-d285-46f3-966f-7e6db5fd9fcb",
            "index": 219,
            "title": "The Top 50 AI For Work Apps You Haven't Tried Yet",
            "pub_date": "2025-10-06T18:53:44.000Z",
            "duration": "00:27:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Top-50-AI-For-Work-Apps-You-Havent-Tried-Yet-e395v3k",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109296180/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-6%2F408771034-44100-2-e646926115d81.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d407414c-1689-4e35-8abb-6006c43278b0",
            "index": 220,
            "title": "I Tested ChatGPT As My Cofounder for a Week - Here's Everything I Learned",
            "pub_date": "2025-10-05T11:00:00.000Z",
            "duration": "00:26:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "anthropic",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/I-Tested-ChatGPT-As-My-Cofounder-for-a-Week---Heres-Everything-I-Learned-e393ld6",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109220710/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-5%2F408673153-44100-2-5e1e72e60c3ce.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a5ecca45-094e-478c-8132-911cf10abe6a",
            "index": 221,
            "title": "The Era of Agentic Shopping",
            "pub_date": "2025-10-03T22:22:50.000Z",
            "duration": "00:23:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Era-of-Agentic-Shopping-e392kat",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109186845/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-3%2F408629215-44100-2-f96d3669d2b74.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a8705f42-ca59-4429-9ef2-6b75761f56b1",
            "index": 222,
            "title": "When Will AI Make Scientific Discoveries?",
            "pub_date": "2025-10-02T21:28:26.000Z",
            "duration": "00:24:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agent",
              "agents",
              "agentic",
              "chips",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/When-Will-AI-Make-Scientific-Discoveries-e39161h",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109139441/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-2%2F408567474-44100-2-b0481171772c1.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97130855-2f4f-4fe1-861e-cde85dcfc770",
            "index": 223,
            "title": "Sora 2 and the Brainrot Rebellion",
            "pub_date": "2025-10-02T00:44:40.000Z",
            "duration": "00:31:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Sora-2-and-the-Brainrot-Rebellion-e38vknq",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109088954/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-9-1%2F408501049-44100-2-31fbfaeee61cf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "651bd1a8-d5b9-439e-93c9-a1074e7374c3",
            "index": 224,
            "title": "Claude Sonnet 4.5 Can Code Autonomously for 30 Hours 🤯",
            "pub_date": "2025-09-30T20:57:50.000Z",
            "duration": "00:28:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Claude-Sonnet-4-5-Can-Code-Autonomously-for-30-Hours-e38u1gj",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/109036499/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-30%2F408433329-44100-2-631512ac39f32.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c23b131-b799-46d7-8e96-5a83eff07028",
            "index": 225,
            "title": "Learn AI or Be Replaced - Accenture’s 11,000 Layoffs Are a Warning",
            "pub_date": "2025-09-29T20:55:56.000Z",
            "duration": "00:25:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Learn-AI-or-Be-Replaced---Accentures-11-000-Layoffs-Are-a-Warning-e38sevd",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108984749/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-29%2F408365550-44100-2-60e9bfcd84d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e7e618fd-15d1-4be6-b52d-44bacc6738f6",
            "index": 226,
            "title": "Don't Blame AI for Workslop",
            "pub_date": "2025-09-28T11:59:30.000Z",
            "duration": "00:22:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Dont-Blame-AI-for-Workslop-e38qbf7",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108915623/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-28%2F408277145-44100-2-8967b7d9b9415.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75db0eb7-0f64-49fb-b637-64e1051ee93a",
            "index": 227,
            "title": "How ChatGPT Pulse Could Change AI",
            "pub_date": "2025-09-27T11:09:49.000Z",
            "duration": "00:27:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-ChatGPT-Pulse-Could-Change-AI-e38pd5c",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108884588/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-27%2F408237250-44100-2-409be3bc985ee.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d0878b10-77e3-415f-b006-b15460932be7",
            "index": 228,
            "title": "Could Gemini 3.0 and Claude 4.5 Be Coming Soon?",
            "pub_date": "2025-09-26T00:00:00.000Z",
            "duration": "00:25:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "foundation model",
              "agent",
              "agents",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Could-Gemini-3-0-and-Claude-4-5-Be-Coming-Soon-e38nfrc",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108821804/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-25%2F408155653-44100-2-47c343338bc39.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5442da2f-5367-4f5c-8555-1499d7c181ed",
            "index": 229,
            "title": "AI Adoption Lessons from 5000 Devs",
            "pub_date": "2025-09-25T00:07:01.000Z",
            "duration": "00:24:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Adoption-Lessons-from-5000-Devs-e38m269",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108775049/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-24%2F408094082-44100-2-c4c779494d968.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1b6fd86-a28d-4147-96fe-2f711583f5cf",
            "index": 230,
            "title": "Nvidia and OpenAI Up the AI Stakes with $100B Deal",
            "pub_date": "2025-09-24T02:47:57.000Z",
            "duration": "00:21:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Nvidia-and-OpenAI-Up-the-AI-Stakes-with-100B-Deal-e38kp45",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108732997/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-24%2F408039303-44100-2-10a513cb583ab.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c6c9b90-2fd8-4d6e-9be4-2bde3aa720d7",
            "index": 231,
            "title": "How Apple Could Get Their AI Revenge",
            "pub_date": "2025-09-23T00:01:34.000Z",
            "duration": "00:26:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-Apple-Could-Get-Their-AI-Revenge-e38j32p",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108677657/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-22%2F407967239-44100-2-779c159fc5aef.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "54cca6c5-3740-4702-bb2b-757607cfc056",
            "index": 232,
            "title": "The Truth About the AI Bubble",
            "pub_date": "2025-09-21T12:24:08.000Z",
            "duration": "00:33:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Truth-About-the-AI-Bubble-e38gnno",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108600504/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-21%2F407868800-44100-2-e78ef98f95924.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e8cff263-4fe5-4e40-ad07-8e8c9c587005",
            "index": 233,
            "title": "AI Agent Deployments Quadruple in 2025",
            "pub_date": "2025-09-19T23:39:03.000Z",
            "duration": "00:23:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Agent-Deployments-Quadruple-in-2025-e38fcsr",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108556635/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-19%2F407812649-44100-2-daafac733a5a3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff6c515a-3076-4f9f-8e6c-de6e28227084",
            "index": 234,
            "title": "AI Just Beat the World's Best Coders",
            "pub_date": "2025-09-19T00:31:00.000Z",
            "duration": "00:25:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "deepmind"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Just-Beat-the-Worlds-Best-Coders-e38dou5",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108503429/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-18%2F407743092-44100-2-19ca45a7550ff.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "caa55677-9bc2-4816-b425-0b5fc946e6b7",
            "index": 235,
            "title": "How People Actually Use ChatGPT",
            "pub_date": "2025-09-18T00:35:19.000Z",
            "duration": "00:27:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-People-Actually-Use-ChatGPT-e38ce74",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108459684/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-18%2F407686619-44100-2-2cc55978f643b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cf3ee5a9-7b97-4603-bc58-9a8460259967",
            "index": 236,
            "title": "GPT-5-Codex and the Year of Agentic Coding",
            "pub_date": "2025-09-17T00:49:44.000Z",
            "duration": "00:28:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "gemini",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/GPT-5-Codex-and-the-Year-of-Agentic-Coding-e38ark1",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108407873/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-17%2F407620259-44100-2-2ae8d16151ecf.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46d24de2-92ba-4762-9e14-2d82884577ca",
            "index": 237,
            "title": "How to Get to AGI",
            "pub_date": "2025-09-15T23:52:34.000Z",
            "duration": "00:23:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "openai",
              "xai",
              "reasoning"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Get-to-AGI-e38990s",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108356060/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-15%2F407552994-44100-2-b51d2f0d38377.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed6161ab-3427-4e0f-a60f-18b264962c73",
            "index": 238,
            "title": "The AI Slopocalypse",
            "pub_date": "2025-09-14T11:13:49.000Z",
            "duration": "00:25:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Slopocalypse-e386r4r",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108276315/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-14%2F407452189-44100-2-67f6564bf6922.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d3fdf264-1b5d-4527-b666-17be2d072665",
            "index": 239,
            "title": "The AI Office Tools That Actually Work",
            "pub_date": "2025-09-13T00:06:53.000Z",
            "duration": "00:26:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-AI-Office-Tools-That-Actually-Work-e385i4h",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108234321/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-13%2F407398937-44100-2-232c69d5915e.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e4be9889-f0b3-4953-b612-b2847707efac",
            "index": 240,
            "title": "AI Skepticism is CANCELLED",
            "pub_date": "2025-09-11T23:54:49.000Z",
            "duration": "00:21:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "openai",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Skepticism-is-CANCELLED-e3844r4",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108187940/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-11%2F407339676-44100-2-a34e412b3d065.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "86b61f81-346f-4319-b6f0-746fb0f35b7d",
            "index": 241,
            "title": "Why You Need Different AIs for Different Jobs",
            "pub_date": "2025-09-11T00:47:33.000Z",
            "duration": "00:24:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Why-You-Need-Different-AIs-for-Different-Jobs-e382mlj",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108140659/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-11%2F407279054-44100-2-28d7c3fbfbc3f.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "26483477-048c-468d-a471-0ee96131a5b4",
            "index": 242,
            "title": "AI Generated Code Reaching 50% in Some Companies",
            "pub_date": "2025-09-10T01:38:35.000Z",
            "duration": "00:24:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/AI-Generated-Code-Reaching-50-in-Some-Companies-e3817eb",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108092299/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-10%2F407217511-44100-2-1aadcae5b5b5b.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd8633dd-968d-4b54-b053-4c76a4560f03",
            "index": 243,
            "title": "5 Debates Shaping AI",
            "pub_date": "2025-09-09T00:45:11.000Z",
            "duration": "00:29:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "coding"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/5-Debates-Shaping-AI-e37vkf3",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/108040099/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-9%2F407151385-44100-2-99948caccc84.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70b978eb-5dbc-468a-81d9-d969511490ae",
            "index": 244,
            "title": "For the Agent Era, Work Charts Beat Org Charts",
            "pub_date": "2025-09-07T11:33:14.000Z",
            "duration": "00:16:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/For-the-Agent-Era--Work-Charts-Beat-Org-Charts-e37t86o",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/107962008/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-7%2F407053266-44100-2-185f4fd799199.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e027a5cd-776b-4c0c-aeda-0d28a3f6d287",
            "index": 245,
            "title": "OpenAI Launches Jobs and Certifications",
            "pub_date": "2025-09-05T22:08:59.000Z",
            "duration": "00:22:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/OpenAI-Launches-Jobs-and-Certifications-e37rq82",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/107914946/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-5%2F406994184-44100-2-efc0ac910cdb.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7d861f9f-f7cc-49ff-acc6-3c9fffc49796",
            "index": 246,
            "title": "How to Be An AI Leader (According to OpenAI)",
            "pub_date": "2025-09-05T00:58:59.000Z",
            "duration": "00:28:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/How-to-Be-An-AI-Leader-According-to-OpenAI-e37q6uj",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/107862419/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-5%2F406928803-44100-2-603ab03d79cb3.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0df11067-8275-4300-85f0-3e702de2ebf0",
            "index": 247,
            "title": "Is Google Now the AI Leader?",
            "pub_date": "2025-09-04T00:28:36.000Z",
            "duration": "00:29:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "gemini",
              "multimodal"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Is-Google-Now-the-AI-Leader-e37nkdo",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/107777912/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-4%2F406828839-44100-2-5fef65bf3c315.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b9438c89-64e1-42fd-97ed-b2d9755f4f10",
            "index": 248,
            "title": "My Autumn AI Predictions",
            "pub_date": "2025-09-03T02:20:28.000Z",
            "duration": "00:29:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "multimodal"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/My-Autumn-AI-Predictions-e37m4rd",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/107729197/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-8-3%2F406767387-44100-2-c69ab5c74b40d.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dce2fb5a-31a3-40f2-b418-0bf113cc1122",
            "index": 249,
            "title": "The Era of AI Mass Intelligence Arrives",
            "pub_date": "2025-08-31T11:59:39.000Z",
            "duration": "00:24:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/The-Era-of-AI-Mass-Intelligence-Arrives-e37i5e1",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/107598721/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-7-31%2F406602054-44100-2-cdc42425d47b6.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "28324c57-44e0-430a-a88a-7ce847d84877",
            "index": 250,
            "title": "Workers Don't Trust Their Companies on AI",
            "pub_date": "2025-08-30T11:14:41.000Z",
            "duration": "00:25:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "training",
              "automation"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/nlw/episodes/Workers-Dont-Trust-Their-Companies-on-AI-e37h0au",
            "audio_url": "https://anchor.fm/s/f7cac464/podcast/play/107560734/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2025-7-30%2F406556507-44100-2-b871742d53a7a.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "nvidia-ai",
        "title": "NVIDIA AI Podcast",
        "feed_title": "NVIDIA AI Podcast",
        "priority": "P2",
        "selection_mode": "keyword",
        "focus": [
          "GPU",
          "robotics",
          "industry applications",
          "accelerated computing"
        ],
        "feed_url": "https://feeds.megaphone.fm/nvidiaaipodcast",
        "source_url": "https://feeds.megaphone.fm/nvidiaaipodcast",
        "detail_path": "/podcasts/nvidia-ai/",
        "episode_count": 250,
        "selected_episode_count": 240,
        "latest_episode_title": "Everyone Can Build a Robot: Open Source Embodied AI With Seeed Studio | NVIDIA AI Podcast Ep. 300",
        "latest_pub_date": "2026-05-27T15:45:00.000Z",
        "latest_page_url": "",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "d5e0ea3c-5930-11f1-8aef-6fa48be07041",
            "index": 1,
            "title": "Everyone Can Build a Robot: Open Source Embodied AI With Seeed Studio | NVIDIA AI Podcast Ep. 300",
            "pub_date": "2026-05-27T15:45:00.000Z",
            "duration": "1744",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "nvidia",
              "training",
              "robotics",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9592437490.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1158b364-53ec-11f1-82f7-975ad2e37d6f",
            "index": 2,
            "title": "Inside AI Tokenomics: How to Profitably Turn Tokens Into Business Value | NVIDIA AI Podcast Ep. 299",
            "pub_date": "2026-05-21T16:00:00.000Z",
            "duration": "2005",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "nvidia",
              "gpu",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1708428495.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02d8a5d0-4e59-11f1-9037-e3af07f8ddc0",
            "index": 3,
            "title": "Snap’s Secret to Processing 10 Petabytes a Day: GPU-Accelerated Spark | NVIDIA AI Podcast Ep. 298",
            "pub_date": "2026-05-13T13:00:00.000Z",
            "duration": "1415",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "inference",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2926487857.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "454a0a66-4955-11f1-adf9-2fa0e93c779d",
            "index": 4,
            "title": "Harrison Chase of LangChain on Deep Agents, LangSmith, and Earning Trust | NVIDIA AI Podcast Ep. 297",
            "pub_date": "2026-05-06T12:45:00.000Z",
            "duration": "1494",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "claude",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4347035801.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "217d7074-4373-11f1-997a-4f4c10618430",
            "index": 5,
            "title": "How Dassault Systèmes Is Building AI That Understands Physics - Ep. 296",
            "pub_date": "2026-04-29T15:45:00.000Z",
            "duration": "1384",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4106910030.mp3?updated=1777908733",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0bc9a3c-3de1-11f1-8297-23f4c478808a",
            "index": 6,
            "title": "One Brain, Any Robot: Skild AI's Skild Brain Explained - Ep. 295",
            "pub_date": "2026-04-22T15:45:00.000Z",
            "duration": "1787",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1970448695.mp3?updated=1777583284",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1864c80-3766-11f1-a17b-8323ac12a047",
            "index": 7,
            "title": "How AI Will Change Quantum Computing - Ep. 294",
            "pub_date": "2026-04-14T14:00:00.000Z",
            "duration": "1888",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7634787225.mp3?updated=1777589805",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9d680dae-1e1e-11f1-a58e-cbc963e1c1a2",
            "index": 8,
            "title": "Building AI Factories: How Red Hat and NVIDIA Turn Enterprise Data Into Intelligence - Ep. 293",
            "pub_date": "2026-03-12T15:45:00.000Z",
            "duration": "2323",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3762220235.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bfa86990-175c-11f1-805b-b37d2c0211e7",
            "index": 9,
            "title": "Powering the AI Inference Wave with EPRI's Ben Sooter - Ep. 292",
            "pub_date": "2026-03-04T16:45:00.000Z",
            "duration": "1940",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8231364994.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5353db82-139a-11f1-a616-2f7836c8351a",
            "index": 10,
            "title": "AI Agents and the Future of Global Trade with Alibaba’s Kuo Zhang - Ep. 291",
            "pub_date": "2026-02-27T16:45:00.000Z",
            "duration": "1993",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4056061208.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "296a0f92-0c58-11f1-a77a-8796c280c835",
            "index": 11,
            "title": "Safer, Faster Public Transportation: AC Transit’s AI-Powered Upgrade with Hayden AI - Ep. 290",
            "pub_date": "2026-02-18T16:45:00.000Z",
            "duration": "1765",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1218461159.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4dfa456-06f5-11f1-b4e0-fbeee9bbb50a",
            "index": 12,
            "title": "Driving Safer AVs Faster with Smart Simulation, Neural Reconstruction, and Data-Centric Tools - Ep. 289",
            "pub_date": "2026-02-11T16:45:00.000Z",
            "duration": "2720",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7506650645.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f6bed06-0161-11f1-bfa2-c76740872b44",
            "index": 13,
            "title": "How AI-Powered Holograms Are Reimagining Fan Experiences at the Big Game - Ep. 288",
            "pub_date": "2026-02-04T16:45:00.000Z",
            "duration": "2337",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3533804875.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d263abca-fbe7-11f0-b3d0-e70ec5e5735f",
            "index": 14,
            "title": "Accelerating Disaster Response with GiveDirectly's Nick Allardice - Ep. 287",
            "pub_date": "2026-01-28T16:45:00.000Z",
            "duration": "2915",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6380643445.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "232137ee-f689-11f0-9dac-2ff078d65b6b",
            "index": 15,
            "title": "From Warehouses to Robot Shoppers: Jason Goldberg Talks Retail’s AI Makeover - Ep. 286",
            "pub_date": "2026-01-21T16:45:00.000Z",
            "duration": "2992",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7912093061.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f2cadc2-f165-11f0-b40f-6b2ed18bd2ce",
            "index": 16,
            "title": "Safer, Smarter Construction Sites with Edge AI and Caterpillar Autonomous Machines - Ep. 285",
            "pub_date": "2026-01-14T16:45:00.000Z",
            "duration": "2379",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6815070765.mp3?updated=1768518351",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "adaedf1e-e0eb-11f0-ac21-7fd42f4abca1",
            "index": 17,
            "title": "Lowering the Cost of Intelligence With NVIDIA's Ian Buck - Ep. 284",
            "pub_date": "2025-12-29T16:57:00.000Z",
            "duration": "2295",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3854335892.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c5c22f0-daf7-11f0-b6c3-77cdab16f60e",
            "index": 18,
            "title": "How Anyone Can Build Meaningful AI Without Code - Ep. 283",
            "pub_date": "2025-12-17T16:45:00.000Z",
            "duration": "2429",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8239537757.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2a835f8a-d569-11f0-85a0-dbad4e9c0a77",
            "index": 19,
            "title": "AI in 2025: From Agents to Factories - Ep. 282",
            "pub_date": "2025-12-10T16:45:00.000Z",
            "duration": "1779",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8849693155.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac9eacd6-c1a0-11f0-a842-bba1459bb408",
            "index": 20,
            "title": "How AI Data Platforms Are Shaping the Future of Enterprise Storage - Ep. 281",
            "pub_date": "2025-11-18T15:45:00.000Z",
            "duration": "2118",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4610272696.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7e7e610c-be99-11f0-91db-c7b7f0ab1e7e",
            "index": 21,
            "title": "Mayor Matt Mahan on How AI Is Changing City Life in San Jose - Ep. 280",
            "pub_date": "2025-11-12T16:45:00.000Z",
            "duration": "2798",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7529658576.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2b49c6da-be98-11f0-9cdd-27e4c60ec3e7",
            "index": 22,
            "title": "AI for Robotics and Manufacturing | GTC Live Washington, D.C. Chapter 5",
            "pub_date": "2025-11-11T00:48:00.000Z",
            "duration": "1576",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7208846099.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fdea902a-be97-11f0-b045-1fd48bdb910d",
            "index": 23,
            "title": "AI for Science | GTC Live Washington, D.C. Chapter 4",
            "pub_date": "2025-11-11T00:47:00.000Z",
            "duration": "2048",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3007734717.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cfcf6d14-be97-11f0-8e10-df34cd22b053",
            "index": 24,
            "title": "AI Infrastructure Ecosystem | GTC Live Washington, D.C. Chapter 3",
            "pub_date": "2025-11-11T00:46:00.000Z",
            "duration": "2042",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2785598858.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6bf9ba6a-be97-11f0-a626-c71c4ad44943",
            "index": 25,
            "title": "Agentic AI for Every Industry | GTC Live Washington, D.C. Chapter 2",
            "pub_date": "2025-11-11T00:43:00.000Z",
            "duration": "1999",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5027196192.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2fcd1564-be97-11f0-aab8-93813510cf82",
            "index": 26,
            "title": "State of AI Innovation | GTC Live Washington, D.C. Chapter 1",
            "pub_date": "2025-11-11T00:41:00.000Z",
            "duration": "1957",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2800708191.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6d760ec8-b9df-11f0-bd7a-07a13b376e10",
            "index": 27,
            "title": "Learning Together: How Students and Educators are Harnessing AI for Success - Ep. 279",
            "pub_date": "2025-11-05T16:45:00.000Z",
            "duration": "2264",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8352810938.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5b506c52-adf5-11f0-852e-63863d573d77",
            "index": 28,
            "title": "What Open Source Teaches Us About Making AI Better - Ep. 278",
            "pub_date": "2025-10-21T15:45:00.000Z",
            "duration": "2053",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9762145115.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3472e840-a93f-11f0-bef8-a381a58487a0",
            "index": 29,
            "title": "How Agentic AI Shortens Drug Development and Boosts Patient Outcomes - Ep. 277",
            "pub_date": "2025-10-15T15:45:00.000Z",
            "duration": "2018",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "nvidia",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9878201151.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11590044-a3ac-11f0-adf1-075366f93251",
            "index": 30,
            "title": "How CytoReason is Bridging the Data Insight Gap to Accelerate Healthcare Breakthroughs - Ep. 276",
            "pub_date": "2025-10-08T15:50:00.000Z",
            "duration": "2112",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2109034146.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fb6fb666-995f-11f0-ad03-7bf574aa212a",
            "index": 31,
            "title": "AI Everywhere: How San José State University Empowers Students and Educators - Ep. 275",
            "pub_date": "2025-09-24T16:03:00.000Z",
            "duration": "2541",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4563043987.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0dac7d4-932b-11f0-b609-b3a5538e89a1",
            "index": 32,
            "title": "Bringing Robots to Life with AI: The Three Computer Revolution - Ep. 274",
            "pub_date": "2025-09-17T15:54:00.000Z",
            "duration": "3137",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "inference",
              "training",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7639306314.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83621eac-8cda-11f0-91e4-77232ccf96e5",
            "index": 33,
            "title": "From AlphaFold to MMseqs2-GPU: How AI is Accelerating Protein Science - Ep. 273",
            "pub_date": "2025-09-10T07:00:00.000Z",
            "duration": "2077",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "retrieval"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5514715943.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3905afc-88e0-11f0-b324-cfd85df6f81b",
            "index": 34,
            "title": "Superhuman Surgery with Moon Surgical and Maestro - Ep. 272",
            "pub_date": "2025-09-03T16:11:00.000Z",
            "duration": "1984",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1815956960.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "abc04cee-82a2-11f0-a3ba-ebb09f65af74",
            "index": 35,
            "title": "Amperity Reimagines Data and Developer Workflows with AI - Ep. 271",
            "pub_date": "2025-08-27T15:45:00.000Z",
            "duration": "2200",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "nvidia",
              "automation",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3669584880.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bbe7803e-76da-11f0-8270-43e491928af2",
            "index": 36,
            "title": "Carbon Robotics on a New Era of Farming with Robots and Sustainable Innovation - Ep. 270",
            "pub_date": "2025-08-20T15:45:00.000Z",
            "duration": "2097",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6272390681.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7c3f6ee-747c-11f0-8b13-238bd4f86533",
            "index": 37,
            "title": "AI, Spatial Intelligence, and 3D Content Creation With Sanja Fidler of NVIDIA - Ep. 269",
            "pub_date": "2025-08-12T15:45:00.000Z",
            "duration": "2395",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4054061615.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d18b87a8-7137-11f0-901b-776882945f90",
            "index": 38,
            "title": "How OpenUSD and AI Are Building Smarter Virtual Worlds - Ep. 268",
            "pub_date": "2025-08-06T15:45:00.000Z",
            "duration": "1461",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1602402405.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba5df220-6c99-11f0-a347-4b19e9121d2f",
            "index": 39,
            "title": "Autonomous Driving, Visual AI, and the Road Ahead with Porsche and Voxel51 - Ep. 267",
            "pub_date": "2025-07-30T15:45:00.000Z",
            "duration": "2466",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "safety"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3273935187.mp3?updated=1753891862",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89b587c8-63f7-11f0-97e0-479035014e39",
            "index": 40,
            "title": "NVIDIA’s Mike Pritchard Shares How Applying AI to Climate Simulation is Helping Forecast the Future - Ep. 266",
            "pub_date": "2025-07-23T15:45:00.000Z",
            "duration": "1939",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6419810743.mp3?updated=1752857950",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a023a336-5e6c-11f0-be41-e32c60e59032",
            "index": 41,
            "title": "Canva’s Danny Wu on Giving 230 Million Users Superpowers With AI - Ep. 265",
            "pub_date": "2025-07-16T15:45:00.000Z",
            "duration": "1469",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8313693543.mp3?updated=1752701765",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4eb5238-51d8-11f0-bd7d-ff58dc54fc96",
            "index": 42,
            "title": "How Bristol Myers Squibb Is Accelerating Drug Development With AI - Ep. 264",
            "pub_date": "2025-07-09T15:45:00.000Z",
            "duration": "1900",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8879536138.mp3?updated=1750865572",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5857d6a8-51d8-11f0-9c07-fff9370cfeb2",
            "index": 43,
            "title": "Alembic and the Future of AI in Marketing - Ep. 263",
            "pub_date": "2025-07-02T15:45:00.000Z",
            "duration": "2384",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "inference"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5821802377.mp3?updated=1750865309",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "21407a2c-4624-11f0-b311-3b1cb34949a6",
            "index": 44,
            "title": "Hippocratic AI's Munjal Shah on How AI Agents Are Expanding Healthcare Capacity - Ep. 262",
            "pub_date": "2025-06-25T15:45:00.000Z",
            "duration": "1309",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agent",
              "agents",
              "nvidia",
              "inference",
              "safety"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5723729057.mp3?updated=1750886466",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "feefe422-42fd-11f0-ac75-af90761dfddf",
            "index": 45,
            "title": "CVS Health and Aible are Delivering Enterprise AI with Rapid Prototyping, Agents, and Reasoning Models - Ep. 261",
            "pub_date": "2025-06-18T15:45:00.000Z",
            "duration": "2374",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia",
              "training",
              "reasoning",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4792321922.mp3?updated=1750194480",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4842126-3fea-11f0-bb30-e3883493f933",
            "index": 46,
            "title": "NVIDIA’s Marco Pavone on AI Simulation, Safety, and the Road to Autonomous Vehicles - Ep. 260",
            "pub_date": "2025-06-11T07:00:00.000Z",
            "duration": "2144",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia",
              "safety"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2797470744.mp3?updated=1749658963",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0205bfc8-34e5-11f0-a0e7-d7ea75d154a8",
            "index": 47,
            "title": "The Future of Humanoid Robots With 1X's Bernt Bornich - Ep. 259",
            "pub_date": "2025-06-04T15:45:00.000Z",
            "duration": "1885",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2289926480.mp3?updated=1749572759",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7fac56f8-34e5-11f0-b6ad-73975b0ff918",
            "index": 48,
            "title": "NVIDIA’s Bartley Richardson on Why ‘Agentic AI Is Next-Level Automation’ - Ep. 258",
            "pub_date": "2025-05-28T15:45:00.000Z",
            "duration": "1712",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agentic",
              "nvidia",
              "automation"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5557359354.mp3?updated=1747682375",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4dc9a52-31b9-11f0-99d3-7bcd4cdc2ed1",
            "index": 49,
            "title": "How Siemens Is Bringing AI to Factory Floors - Ep. 257",
            "pub_date": "2025-05-20T15:45:00.000Z",
            "duration": "2238",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2321858142.mp3?updated=1747333820",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1fcc7290-2b80-11f0-b76f-6388555b4b30",
            "index": 50,
            "title": "How Visa Is Making Payments Safer and Smarter with AI - Ep. 256",
            "pub_date": "2025-05-14T15:45:00.000Z",
            "duration": "1333",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1767769652.mp3?updated=1746649274",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a62e261c-2603-11f0-b8f0-37da2ab35d1e",
            "index": 51,
            "title": "NVIDIA’s Rama Akkiraju on Building the Right AI Infrastructure for Enterprise Success - Ep. 255",
            "pub_date": "2025-05-07T15:45:00.000Z",
            "duration": "2092",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "nvidia"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7570149000.mp3?updated=1746046057",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8169d3d2-1eea-11f0-9729-03fd4a54bb97",
            "index": 52,
            "title": "Yum! Brands, the World’s Largest Restaurant Company, Advances AI Adoption - Ep. 254",
            "pub_date": "2025-04-30T15:45:00.000Z",
            "duration": "1446",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2416455099.mp3?updated=1745265769",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5baab3a-194d-11f0-9277-a3410fb0923e",
            "index": 53,
            "title": "Capital One’s Prem Natarajan Shares How AI Can Enhance Financial Services and Customer Experiences - Ep. 253",
            "pub_date": "2025-04-23T16:00:00.000Z",
            "duration": "1904",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7586743955.mp3?updated=1744648527",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dab3e144-194a-11f0-a4a8-97551b790455",
            "index": 54,
            "title": "Isomorphic Labs Discusses AI-Driven Drug Discovery and the Future of Medicine - Ep. 252",
            "pub_date": "2025-04-16T16:00:00.000Z",
            "duration": "2365",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2151852467.mp3?updated=1744647274",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2b5b5238-148e-11f0-ab0c-b7e7a7987c5b",
            "index": 55,
            "title": "‘Black Women in Artificial Intelligence’ Founder Talks AI Education and Empowerment - Ep. 251",
            "pub_date": "2025-04-09T16:00:00.000Z",
            "duration": "1279",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5831197517.mp3?updated=1744126430",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dca8389c-0f27-11f0-8da7-87d9daeaf3b1",
            "index": 56,
            "title": "NVIDIA’s Jacob Liberman on the Power of Agentic AI in the Enterprise - Ep. 250",
            "pub_date": "2025-04-02T16:00:00.000Z",
            "duration": "1782",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "nvidia"
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1684874550.mp3?updated=1743532733",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9cce3e40-0998-11f0-b033-f337ffa422a0",
            "index": 57,
            "title": "Enhancing Grid Reliability: How Buzz Solutions Uses Vision AI to Prevent Outages and Wildfires - Ep. 249",
            "pub_date": "2025-03-26T13:00:00.000Z",
            "duration": "2180",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://ai-podcast.nvidia.com/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4254475272.mp3?updated=1743619807",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "446d9d80-f922-11ef-826d-93763a168a12",
            "index": 58,
            "title": "Roboflow Simplifies Computer Vision for Developers and the Enterprise - Ep. 248",
            "pub_date": "2025-03-05T16:00:00.000Z",
            "duration": "2320",
            "duration_label": "38m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://blogs.nvidia.com/blog/roboflow-computer-vision/",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6283742998.mp3?updated=1741127809",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f6227b84-f460-11ef-abfa-bfb1e0ee066d",
            "index": 59,
            "title": "Telenor's Kaaren Hilsen on Launching Norway’s First AI Factory - Ep. 247",
            "pub_date": "2025-02-27T16:00:00.000Z",
            "duration": "1385",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8727670438.mp3?updated=1741121462",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/2037536680",
            "index": 60,
            "title": "Temenos’ Barb Morgan Shares How AI Is Reshaping Banking - Ep. 246",
            "pub_date": "2025-02-17T00:00:00.000Z",
            "duration": "1843",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/barb-morgan-temenos",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5407555760.mp3?updated=1741121445",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/2030812652",
            "index": 61,
            "title": "Tara Chklovksi, Anshita Saini on Technovation Pioneering AI Education for Innovation - Ep. 245",
            "pub_date": "2025-02-08T00:00:00.000Z",
            "duration": "2045",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/tara-chklovski-anshita-saini",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3155865046.mp3?updated=1741121417",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/2025039724",
            "index": 62,
            "title": "AI for Everyone: How Gooey.AI Empowers Global Frontline Workers with Low Code Workflows - Ep. 244",
            "pub_date": "2025-02-03T00:00:00.000Z",
            "duration": "2436",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/gooey-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2573962144.mp3?updated=1741121399",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/2021182833",
            "index": 63,
            "title": "AI Agents Take Digital Experiences to the Next Level in Gaming and Beyond, Featuring Chris Covert from Inworld AI - Ep. 243",
            "pub_date": "2025-01-29T00:00:00.000Z",
            "duration": "1592",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/chris-covert-inworld",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6624782194.mp3?updated=1741121387",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/2014776835",
            "index": 64,
            "title": "Firsthand's Jon Heller Shares How AI Agents Enhance Consumer Journeys in Retail - Ep. 242",
            "pub_date": "2025-01-21T00:00:00.000Z",
            "duration": "2117",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/jon-heller-firsthand",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5937093417.mp3?updated=1741121375",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/2009018743",
            "index": 65,
            "title": "How SDSC Uses AI to Transform Surgical Training and Practice - Ep. 241",
            "pub_date": "2025-01-13T00:00:00.000Z",
            "duration": "1568",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/margaux-masson-forsythe-sdsc",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8311576906.mp3?updated=1741121363",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/2000119463",
            "index": 66,
            "title": "How World Foundation Models Will Advance Physical AI With NVIDIA’s Ming-Yu Liu - Ep. 240",
            "pub_date": "2025-01-07T16:00:00.000Z",
            "duration": "1231",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/world-foundation-models",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7271089150.mp3?updated=1741121351",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1983647039",
            "index": 67,
            "title": "Imbue CEO Kanjun Qiu on Transforming AI Agents Into Personal Collaborators - Ep. 239",
            "pub_date": "2024-12-16T00:00:00.000Z",
            "duration": "2016",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-agents-kanjun-qiu",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5047734177.mp3?updated=1740586325",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1972135971",
            "index": 68,
            "title": "How AI Can Help Boost Disability Inclusion - Ep. 238",
            "pub_date": "2024-11-30T00:00:00.000Z",
            "duration": "2147",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/sara-minkara-tim-shriver",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2442740634.mp3?updated=1740586326",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1957516771",
            "index": 69,
            "title": "NVIDIA's Louis Stewart on How AI Is Shaping Workforce Development - Ep. 237",
            "pub_date": "2024-11-25T00:00:00.000Z",
            "duration": "1874",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-workforce-development",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1559648366.mp3?updated=1740586327",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1957585027",
            "index": 70,
            "title": "How the Department of Energy Is Tapping AI to Transform Science, Industry and Government - Ep. 236",
            "pub_date": "2024-11-20T00:00:00.000Z",
            "duration": "1491",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/helena-fu-department-of-energy",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9427831936.mp3?updated=1740586327",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1940222278",
            "index": 71,
            "title": "Zoom CTO Xuedong \"XD\" Huang on How AI Revolutionizes Productivity - Ep. 235",
            "pub_date": "2024-10-24T00:00:00.000Z",
            "duration": "2195",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/zoom-xuedong-huang",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2686827061.mp3?updated=1740586328",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1924472510",
            "index": 72,
            "title": "NVIDIA's Josh Parker on How AI and Accelerated Computing Drive Sustainability - Ep. 234",
            "pub_date": "2024-10-03T00:00:00.000Z",
            "duration": "2101",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-accelerated-computing-sustainability",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7696903686.mp3?updated=1740586328",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1914925946",
            "index": 73,
            "title": "SonicJobs CEO Mikhil Raja on Using AI Agents to Connect the Internet, starting with Jobs - Ep. 233",
            "pub_date": "2024-09-25T00:00:00.000Z",
            "duration": "1653",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-sonicjobs",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6937118061.mp3?updated=1740586329",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1906641035",
            "index": 74,
            "title": "Machina Labs’ Edward Mehr on Autonomous Blacksmith Bots and More - Ep. 232",
            "pub_date": "2024-09-03T00:00:00.000Z",
            "duration": "2245",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/machina-labs-edward-mehr-on-autonomous-blacksmith-bots-and-more",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7088039115.mp3?updated=1740586330",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1900414140",
            "index": 75,
            "title": "Snowflake's Baris Gultekin on Unlocking the Value of Data With Large Language Models - Ep. 231",
            "pub_date": "2024-08-21T00:00:00.000Z",
            "duration": "1930",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/snowflake-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1168756815.mp3?updated=1740586330",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1879973706",
            "index": 76,
            "title": "Recursion CEO Chris Gibson on Accelerating the Biopharmaceutical Industry With AI - Ep. 230",
            "pub_date": "2024-08-07T00:00:00.000Z",
            "duration": "2275",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/recursion-ceo-chris-gibson",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9356389112.mp3?updated=1740586331",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1868252172",
            "index": 77,
            "title": "How Georgia Tech’s AI Makerspace Is Preparing the Future Workforce for AI - Ep. 229",
            "pub_date": "2024-07-24T00:00:00.000Z",
            "duration": "1920",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/georgia-tech",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3425820980.mp3?updated=1740586331",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1864135386",
            "index": 78,
            "title": "Paige Cofounder Thomas Fuchs’ Diagnosis on Improving Cancer Patient Outcomes With AI - Ep. 228",
            "pub_date": "2024-07-10T18:19:59.000Z",
            "duration": "1991",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/paige-thomas-fuchs",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2028628801.mp3?updated=1740586332",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1851430170",
            "index": 79,
            "title": "How Roblox Uses Generative AI to Enhance User Experiences - Ep. 227",
            "pub_date": "2024-06-26T00:00:00.000Z",
            "duration": "1742",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia",
              "safety",
              "coding"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/anumpam-singh-roblox",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6337007007.mp3?updated=1740586333",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1844347677",
            "index": 80,
            "title": "Michael Rubloff Explains How Neural Radiance Fields Turn 2D Images Into 3D Models - Ep. 226",
            "pub_date": "2024-06-12T00:00:00.000Z",
            "duration": "1490",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nerf",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6388661675.mp3?updated=1740586333",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1837778895",
            "index": 81,
            "title": "Yotta CEO Sunil Gupta on Supercharging India’s Fast-Growing AI Market - Ep. 225",
            "pub_date": "2024-06-03T00:00:00.000Z",
            "duration": "2000",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "data center"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/yotta-ceo-sunil-gupta",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6972219091.mp3?updated=1740586334",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1832461098",
            "index": 82,
            "title": "How Two Stanford Students Are Building Robots for Handling Household Chores - Ep. 224",
            "pub_date": "2024-05-27T00:00:00.000Z",
            "duration": "1840",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/household-robots",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2941900425.mp3?updated=1740586334",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1821274848",
            "index": 83,
            "title": "Basecamp's Phil Lorenz on Combining AI With Biodiversity Data  - Ep. 223",
            "pub_date": "2024-05-15T13:00:02.000Z",
            "duration": "1763",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/basecamp-phil-lorenz",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8121030595.mp3?updated=1740586335",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1816942410",
            "index": 84,
            "title": "Media.Monks’ Lewis Smithingham on Enhancing Media and Marketing With AI - Ep. 222",
            "pub_date": "2024-05-09T00:00:00.000Z",
            "duration": "2554",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/mediamonks-lewis-smithingham",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7739159415.mp3?updated=1740586335",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1811598663",
            "index": 85,
            "title": "Performance AI: Insights from Arthur's Adam Wenchel – Ep. 221",
            "pub_date": "2024-04-30T00:00:00.000Z",
            "duration": "1608",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/arthur-adam-wenchel",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9904238366.mp3?updated=1740586336",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1806553098",
            "index": 86,
            "title": "AI2’s Christopher Bretherton Discusses Using Machine Learning for Climate Modeling - Ep. 220",
            "pub_date": "2024-04-24T00:00:00.000Z",
            "duration": "1949",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/christopher-bretherton",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2607576157.mp3?updated=1740586337",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1802251500",
            "index": 87,
            "title": "Living Optics CEO Robin Wang on Democratizing Hyperspectral Imaging - Ep. 219",
            "pub_date": "2024-04-23T00:00:00.000Z",
            "duration": "1594",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/robin-wang",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7278146921.mp3?updated=1740586337",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1797413893",
            "index": 88,
            "title": "Cleanlab's Curtis Northcutt and Berkeley Research Group's Steven Gawthorpe on AI for Fighting Crime",
            "pub_date": "2024-04-10T00:00:00.000Z",
            "duration": "1968",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/cleanlabs-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2521763222.mp3?updated=1740586338",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1791227923",
            "index": 89,
            "title": "Dotlumen CEO Cornel Amariei on Assistive Technology for the Visually Impaired - Ep. 217",
            "pub_date": "2024-04-09T00:00:00.000Z",
            "duration": "2133",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/gtc24-cornel-amariei-inception",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7122446127.mp3?updated=1740586339",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1785368577",
            "index": 90,
            "title": "Personalized Health: Viome's Guru Banavar Discusses Startup’s AI-Driven Approach - Ep. 216",
            "pub_date": "2024-03-27T00:00:00.000Z",
            "duration": "3146",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/viome-guru-banavar",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3995782121.mp3?updated=1740586339",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1772793834",
            "index": 91,
            "title": "ITIF's Daniel Castro on Energy-Efficient AI and Climate Change - Ep. 215",
            "pub_date": "2024-03-11T00:00:00.000Z",
            "duration": "1993",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-daniel-castro-itif",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2574294771.mp3?updated=1740586340",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1759544883",
            "index": 92,
            "title": "Exploring Filmmaking with Cuebric's AI: Insights from Pinar Seyhan Demirdag - Ep. 214",
            "pub_date": "2024-02-27T00:00:00.000Z",
            "duration": "2007",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/pinar-demirdag-cuebric",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2736711034.mp3?updated=1740586340",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1746649332",
            "index": 93,
            "title": "How the Ohio Supercomputer Center Drives the Future of Computing - Ep. 213",
            "pub_date": "2024-02-21T00:00:00.000Z",
            "duration": "2095",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training",
              "safety"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-alan-chalker",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4583154680.mp3?updated=1740586341",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1731441726",
            "index": 94,
            "title": "Cardiac Clarity: Dr. Keith Channon Talks Revolutionizing Heart Health With AI - Ep. 212",
            "pub_date": "2024-01-31T00:00:00.000Z",
            "duration": "2024",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/cardiac-caristo-dr-keith-channon",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8696540596.mp3?updated=1740586342",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1713097308",
            "index": 95,
            "title": "DigitalPath's Ethan Higgins On Using AI to Fight Wildfires - Ep. 211",
            "pub_date": "2024-01-17T00:00:00.000Z",
            "duration": "1341",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-wildfire",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5540889943.mp3?updated=1740586342",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1694640141",
            "index": 96,
            "title": "The Case for Generative AI in the Legal Field - Ep. 210",
            "pub_date": "2023-12-20T00:00:00.000Z",
            "duration": "1783",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia",
              "retrieval"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/legal",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6140298575.mp3?updated=1740586343",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1683154701",
            "index": 97,
            "title": "Wayve CEO Alex Kendall on Making a Splash in Autonomous Vehicles - Ep. 209",
            "pub_date": "2023-12-06T00:00:00.000Z",
            "duration": "1905",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia",
              "safety"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-wayve",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1595215679.mp3?updated=1740586343",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1651053912",
            "index": 98,
            "title": "NVIDIA’s Annamalai Chockalingam on the Rise of LLMs - Ep. 206",
            "pub_date": "2023-11-23T00:00:00.000Z",
            "duration": "2312",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "chatgpt",
              "nvidia",
              "rag",
              "retrieval"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-llm",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7219344189.mp3?updated=1740586344",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1671268662",
            "index": 99,
            "title": "Afresh Co-Founder Nathan Fenner On How AI Can Help Grocers Manage Supply Chains - Ep. 208",
            "pub_date": "2023-11-21T00:00:00.000Z",
            "duration": "1980",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "ai startup"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nathan-fenner-afresh",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1265458091.mp3?updated=1740586345",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1658401437",
            "index": 100,
            "title": "Co-Founder of Annalise.ai Aengus Tran on Using AI as a Spell Check for Health Checks - Ep. 207",
            "pub_date": "2023-11-06T00:00:00.000Z",
            "duration": "1876",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/harrisonai-ceo-aengus-tran",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8575652623.mp3?updated=1740586346",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1643145072",
            "index": 101,
            "title": "Making Machines Mindful: NYU Professor Talks Responsible AI - Ep. 205",
            "pub_date": "2023-10-18T00:00:00.000Z",
            "duration": "2150",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/making-machines-mindful",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6206788715.mp3?updated=1740586346",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1627125918",
            "index": 102,
            "title": "NVIDIA’s Jim Fan Delves Into Large Language Models and Their Industry Impact - Ep. 204",
            "pub_date": "2023-10-03T00:00:00.000Z",
            "duration": "2258",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "nvidia",
              "safety",
              "robotics",
              "coding"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-jim-fan",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3996919971.mp3?updated=1740586347",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1613940966",
            "index": 103,
            "title": "Anima Anandkumar on Using Generative AI to Tackle Global Challenges - Ep. 203",
            "pub_date": "2023-09-11T00:00:00.000Z",
            "duration": "2408",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/anima-anandkumar",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1131830366.mp3?updated=1740586347",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1601292126",
            "index": 104,
            "title": "Deepdub’s Ofir Krakowski on Redefining Dubbing from Hollywood to Bollywood - Ep. 202",
            "pub_date": "2023-08-30T00:00:00.000Z",
            "duration": "1957",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-deepdub",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5744793810.mp3?updated=1740586348",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1590910059",
            "index": 105,
            "title": "Replit CEO Amjad Masad on Empowering the Next Billion Software Creators - Ep. 201",
            "pub_date": "2023-08-14T00:00:00.000Z",
            "duration": "2549",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "replit",
              "nvidia",
              "coding"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/replit-ceo-amjad-masad",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2842799795.mp3?updated=1740586349",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1574497063",
            "index": 106,
            "title": "Codeium’s Varun Mohan and Jeff Wang on Unleashing the Power of AI in Software Development - Ep. 200",
            "pub_date": "2023-07-26T00:00:00.000Z",
            "duration": "2342",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "coding",
              "ai startup"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/codeiums",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4310650478.mp3?updated=1740586349",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1558919602",
            "index": 107,
            "title": "MosaicML's Naveen Rao on Making Custom LLMs More Accessible - Ep. 199",
            "pub_date": "2023-07-12T00:00:00.000Z",
            "duration": "1886",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/mosaicml-naveen-rao",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3831162358.mp3?updated=1740586350",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1550643253",
            "index": 108,
            "title": "Matice Founder Jessica Whited on Harnessing Regenerative Species for Medical Breakthroughs - Ep. 198",
            "pub_date": "2023-06-28T00:00:00.000Z",
            "duration": "2348",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/matice",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7590452540.mp3?updated=1740586350",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1532657599",
            "index": 109,
            "title": "MIT's Anant Agarwal on AI in Education - Ep. 197",
            "pub_date": "2023-06-07T00:00:00.000Z",
            "duration": "2325",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/edtech",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3638376296.mp3?updated=1740586351",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1518052162",
            "index": 110,
            "title": "How Alex Fielding and Privateer Space Are Taking on Space Debris - Ep. 196",
            "pub_date": "2023-05-18T00:00:00.000Z",
            "duration": "2400",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chips",
              "robotics"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-alex-fielding",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6651023419.mp3?updated=1740586352",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1502486944",
            "index": 111,
            "title": "Bojan Tunguz, Johnny Israeli on How AI and Crowdsourcing Can Advance Vaccine Distribution - Ep. 195",
            "pub_date": "2023-05-01T00:00:00.000Z",
            "duration": "1985",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/crowdsource",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7551446723.mp3?updated=1740586352",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1497818689",
            "index": 112,
            "title": "The Future of Intelligent Vehicle Interiors: Building Trust With HMI & AI - Ep. 194",
            "pub_date": "2023-04-25T00:00:00.000Z",
            "duration": "1254",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-rightware",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3721111282.mp3?updated=1740586353",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1490530207",
            "index": 113,
            "title": "How GlüxKind Created Ella, the AI-Powered Smart Stroller - Ep. 193",
            "pub_date": "2023-04-10T00:00:00.000Z",
            "duration": "1584",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-stroller",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2248006908.mp3?updated=1740586353",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1475533357",
            "index": 114,
            "title": "Ubisoft’s Yves Jacquier on How Generative AI Will Revolutionize Gaming - Ep. 192",
            "pub_date": "2023-03-27T00:00:00.000Z",
            "duration": "2126",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-ubisoft",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3249357315.mp3?updated=1740586354",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1469975854",
            "index": 115,
            "title": "Peter Ma on Using AI to Find Promising Signals for Alien Life - Ep. 191",
            "pub_date": "2023-03-15T00:00:00.000Z",
            "duration": "2050",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/peter-ma-ai-technosignatures",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1810219958.mp3?updated=1740586355",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1455306718",
            "index": 116,
            "title": "Glean Founders Talk AI-Powered Enterprise Search on NVIDIA Podcast - Ep. 190",
            "pub_date": "2023-03-01T00:00:00.000Z",
            "duration": "1979",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/glean-enterprise-search-llm",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7975910330.mp3?updated=1740586355",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1435966984",
            "index": 117,
            "title": "Making a Splash: AI Can Help Protect Ocean Goers from Deadly Rips - Ep. 189",
            "pub_date": "2023-02-15T00:00:00.000Z",
            "duration": "2207",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "safety"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-christo-rautenbach",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7005396227.mp3?updated=1740586356",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1435453027",
            "index": 118,
            "title": "Deloitte’s Nitin Mittal on the Secrets of 'All-In' AI Success - Ep. 188",
            "pub_date": "2023-02-01T00:00:00.000Z",
            "duration": "2318",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-deloitte",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8963207151.mp3?updated=1740586357",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1416677611",
            "index": 119,
            "title": "Sequoia Capital’s Pat Grady and Sonya Huang on Generative AI - Ep. 187",
            "pub_date": "2023-01-18T00:00:00.000Z",
            "duration": "2564",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/sequoia-capitals-pat-grady-and-sonya-huang-on-generative-ai-ep-187",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3320310554.mp3?updated=1740586357",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1412938858",
            "index": 120,
            "title": "UF Provost Joe Glover on Building a Leading AI University - Ep. 186",
            "pub_date": "2023-01-04T00:00:00.000Z",
            "duration": "1674",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/university-of-florida-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1190617787.mp3?updated=1740586358",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1397620591",
            "index": 121,
            "title": "Doing the Best They Can: EverestLabs Ensures Fewer Recyclables Go to Landfills - Ep. 184",
            "pub_date": "2022-12-19T00:00:00.000Z",
            "duration": "2252",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/everestlabs",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7557883582.mp3?updated=1740586359",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1392173029",
            "index": 122,
            "title": "Hittin’ the Sim: NVIDIA’s Matt Cragun on Conditioning Autonomous Vehicles in Simulation - Ep. 185",
            "pub_date": "2022-12-06T00:00:00.000Z",
            "duration": "1753",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/autonomous-vehicles-simulation",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4167200124.mp3?updated=1740586359",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1383245527",
            "index": 123,
            "title": "WSC Sports’ Amos Bercovich on How AI Keeps the Sports Highlights Coming - Ep. 183",
            "pub_date": "2022-11-15T00:00:00.000Z",
            "duration": "1575",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/wsc-sports",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9594156376.mp3?updated=1740586360",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1373296717",
            "index": 124,
            "title": "AI-Equipped Drones Could Offer Real-Time Updates on Endangered African Black Rhinos - Ep. 182",
            "pub_date": "2022-11-05T00:00:00.000Z",
            "duration": "1634",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-zoe-jewell-alice-hua",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1762810954.mp3?updated=1740586360",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1365975223",
            "index": 125,
            "title": "How Tarteel Uses AI to Help Arabic Learners Perfect Their Pronunciation - Ep. 181",
            "pub_date": "2022-10-20T00:00:00.000Z",
            "duration": "1778",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/tarteel-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2918733966.mp3?updated=1740586361",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1356146131",
            "index": 126,
            "title": "Researchers Use AI to Help Earbud Users Mute Background Noise - Ep. 180",
            "pub_date": "2022-10-02T00:00:00.000Z",
            "duration": "1901",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-clearbuds",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9816455771.mp3?updated=1740586362",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1336626109",
            "index": 127,
            "title": "Overjet's Ai Wardah Inam on Bringing AI to Dentistry - Ep. 179",
            "pub_date": "2022-09-20T00:00:00.000Z",
            "duration": "1693",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-overjet",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7559783465.mp3?updated=1740586362",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1342943932",
            "index": 128,
            "title": "Reinventing the Wheel: Gatik’s Apeksha Kumavat Accelerates Autonomous Delivery - Ep. 178",
            "pub_date": "2022-09-14T00:00:00.000Z",
            "duration": "1950",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-gatik",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4076789545.mp3?updated=1740586363",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1326089404",
            "index": 129,
            "title": "Rendered.ai CEO Nathan Kundtz on Using AI to Build Better AI - Ep. 177",
            "pub_date": "2022-08-31T13:00:09.000Z",
            "duration": "1878",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia",
              "training"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/renderedai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6102804457.mp3?updated=1740586363",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1316650894",
            "index": 130,
            "title": "NVIDIA’s Clément Farabet on Orchestrating AI Training for Autonomous Vehicles - Ep. 175",
            "pub_date": "2022-08-02T00:00:00.000Z",
            "duration": "1776",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidia-clement-farabet-ai-training-av",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9404582027.mp3?updated=1740586364",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1310110849",
            "index": 131,
            "title": "Immunai CTO and Co-Founder Luis Voloch on Using Deep Learning to Develop New Drugs - Ep. 176",
            "pub_date": "2022-07-31T00:00:00.000Z",
            "duration": "1672",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-luis-voloch",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2880380085.mp3?updated=1740586365",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1300294819",
            "index": 132,
            "title": "Lucid Motors’ Mike Bell on Software-Defined Innovation - Ep. 174",
            "pub_date": "2022-07-20T00:00:00.000Z",
            "duration": "1093",
            "duration_label": "18m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/lucid-motors-mike-bell-on-software-defined-innovation-ep-173",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3155946696.mp3?updated=1740586365",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1300758916",
            "index": 133,
            "title": "Santiago Valderrama on Getting Smarter on Machine Learning, One Problem at a Time - Ep. 173",
            "pub_date": "2022-07-06T00:00:00.000Z",
            "duration": "1635",
            "duration_label": "27m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-santiago-valdarrama",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6869490475.mp3?updated=1740586366",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1291324111",
            "index": 134,
            "title": "Artem Cherkasov and Olexandr Isayev on Democratizing Drug Discovery with Deep Learning - Ep. 172",
            "pub_date": "2022-06-22T00:00:00.000Z",
            "duration": "1685",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-drug-discovery",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5816241500.mp3?updated=1740586366",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1280705689",
            "index": 135,
            "title": "Astrophysicist Brant Robertson Using AI to Glean Insights from James Webb Space Telescope - Ep. 171",
            "pub_date": "2022-06-08T00:00:00.000Z",
            "duration": "2151",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/scientists-turn-to-ai-to-glean-insights-from-nasas-james-webb-space-telescope",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2140945088.mp3?updated=1740586367",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1275209080",
            "index": 136,
            "title": "Hume AI’s Alan Cowen on Building AIs With a Devotion to Emotion - Ep. 170",
            "pub_date": "2022-05-26T13:00:20.000Z",
            "duration": "2849",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/alan-cowen",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7231365087.mp3?updated=1740586368",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1262573350",
            "index": 137,
            "title": "Waabi CEO Raquel Urtasun on Using AI, Simulation to Teach Autonomous Vehicles to Drive - Ep. 169",
            "pub_date": "2022-05-05T00:00:00.000Z",
            "duration": "1339",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-raquel-urtasun",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2259175973.mp3?updated=1740586368",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1256968012",
            "index": 138,
            "title": "What Is Conversational AI? ZeroShot Bot CEO Jason Mars Explains - Ep. 168",
            "pub_date": "2022-04-27T13:00:11.000Z",
            "duration": "2305",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/what-is-conversational-ai-zeroshot-bot-ceo-jason-mars-explains",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4864275038.mp3?updated=1740586369",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1247044111",
            "index": 139,
            "title": "MLCommons’ David Kanter, NVIDIA’s Daniel Galvez on Publicly Accessible Datasets - Ep. 167",
            "pub_date": "2022-04-12T00:00:00.000Z",
            "duration": "2111",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "training"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/mlcommons",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8273333074.mp3?updated=1740586369",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1240933747",
            "index": 140,
            "title": "Polestar’s Dennis Nobelius on the Sustainable Performance Brand’s Plans - Ep. 166",
            "pub_date": "2022-03-30T00:00:00.000Z",
            "duration": "1045",
            "duration_label": "17m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-polestar",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6828649317.mp3?updated=1740586370",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1232997337",
            "index": 141,
            "title": "Robust Intelligence CEO Yaron Singer on How to Prevent AI Failures - Ep. 165",
            "pub_date": "2022-03-17T00:00:00.000Z",
            "duration": "1405",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/robust-intelligence-ceo-yaron-singer-on-how-to-prevent-ai-failures-ep-170",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7329381887.mp3?updated=1740586371",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1224771802",
            "index": 142,
            "title": "Recommender Systems 101: NVIDIA’s Even Oldridge Breaks It Down - Ep. 164",
            "pub_date": "2022-03-02T00:00:00.000Z",
            "duration": "2295",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/recommender-system",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3082775359.mp3?updated=1740586371",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1215858001",
            "index": 143,
            "title": "Exaggeration Detector Could Lead to More Accurate Health Science Journalism - Ep. 163",
            "pub_date": "2022-02-16T00:00:00.000Z",
            "duration": "1787",
            "duration_label": "29m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/exaggeration-detector",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8725424622.mp3?updated=1740586372",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1212343507",
            "index": 144,
            "title": "NVIDIA’s Sarah Tariq Turning Cars into Software-Defined Vehicles - Ep. 162",
            "pub_date": "2022-02-09T00:00:00.000Z",
            "duration": "1092",
            "duration_label": "18m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidias-sarah-tariq-turning-cars-into-software-defined-vehicles-ep-162",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5217264172.mp3?updated=1740586372",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1205786227",
            "index": 145,
            "title": "Listen Up: How Audio Analytic Is Teaching Machines to Listen - Ep. 161",
            "pub_date": "2022-02-02T00:00:00.000Z",
            "duration": "1891",
            "duration_label": "31m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/ai-chris-mitchell",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9273534095.mp3?updated=1740586373",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1195372741",
            "index": 146,
            "title": "Fusing Art and Tech: MORF Gallery CEO Scott Birnbaum on Digital Paintings, NFTs and More - Ep. 160",
            "pub_date": "2022-01-19T00:00:00.000Z",
            "duration": "1854",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-scott-birnbaum-morf",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5361239659.mp3?updated=1740586374",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1190646844",
            "index": 147,
            "title": "‘AI Dungeon’ Creator Nick Walton Uses AI to Generate Infinite Gaming Storylines - Ep. 159",
            "pub_date": "2022-01-05T00:00:00.000Z",
            "duration": "1557",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-dungeon",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4574387667.mp3?updated=1740586374",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1178242306",
            "index": 148,
            "title": "AI Pioneer Kai-Fu Lee Discusses His New Work of Fiction - Ep. 158",
            "pub_date": "2021-12-15T00:00:00.000Z",
            "duration": "1819",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-kaifu-lee",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9361611653.mp3?updated=1740586375",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1169788282",
            "index": 149,
            "title": "Real or Not Real? Attorney Steven Frank Uses Deep Learning to Authenticate Art - Ep. 157",
            "pub_date": "2021-11-30T00:00:00.000Z",
            "duration": "2486",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/real-or-not-real-attorney-steven-frank-uses-deep-learning-to-authenticate-art",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7062782662.mp3?updated=1740586376",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1162090666",
            "index": 150,
            "title": "AI of the Tiger: Conservation Biologist Jeremy Dertien - Ep. 156",
            "pub_date": "2021-11-17T00:00:00.000Z",
            "duration": "1885",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-jeremy-dertien",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5986161941.mp3?updated=1740586377",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1150589371",
            "index": 151,
            "title": "Metaspectral’s‌ ‌Migel‌ ‌Tissera‌ ‌on‌ ‌AI-Based‌ ‌Data‌ ‌Management‌ ‌ - Ep. 155",
            "pub_date": "2021-11-03T00:00:00.000Z",
            "duration": "1909",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-migel-tissera",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4644884241.mp3?updated=1740586377",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1142735335",
            "index": 152,
            "title": "Researchers Chris Downum and Leszek Pawlowicz Use Deep Learning to Accelerate Archaeology - Ep. 154",
            "pub_date": "2021-10-20T00:00:00.000Z",
            "duration": "1588",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-sherd",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9111753962.mp3?updated=1740586378",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1134648463",
            "index": 153,
            "title": "Maya Ackerman on LyricStudio, an AI-Based Writing Songwriting Assistant - Ep. 153",
            "pub_date": "2021-10-01T00:00:00.000Z",
            "duration": "1394",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/maya-ackerman",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7512369271.mp3?updated=1740586379",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1126687156",
            "index": 154,
            "title": "Wild Things: NVIDIA’s Sifei Liu Talks 3D Reconstructions of Endangered Species - Ep. 152",
            "pub_date": "2021-09-20T00:00:00.000Z",
            "duration": "1268",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidia-sifei-liu-3d-reconstructions-endangered-species",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5408764746.mp3?updated=1740586380",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1118476090",
            "index": 155,
            "title": "GANTheftAuto: Harrison Kinsley on AI-Generated Gaming Environments - Ep. 151",
            "pub_date": "2021-09-08T00:00:00.000Z",
            "duration": "1786",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/gantheftauto-harrison-kinsley-on-ai-generated-gaming-environments",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2010160389.mp3?updated=1740586380",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1108428379",
            "index": 156,
            "title": "GE's Danielle Merfeld and Arvind Rangarajan on AI and Renewable Energy - Ep. 150",
            "pub_date": "2021-08-20T00:00:00.000Z",
            "duration": "1872",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-ge-renewable-energy",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6083519599.mp3?updated=1740586381",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1103963611",
            "index": 157,
            "title": "Jules Anh Tuan Nguyen Explains How AI Lets Amputee Control Prosthetic Hand, Video Games - Ep. 149",
            "pub_date": "2021-08-11T00:00:00.000Z",
            "duration": "2203",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/jules-anh-tuan-nguyen-explains-how-ai-lets-amputee-control-prosthetic-hand-video-games-ep-149",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8313735235.mp3?updated=1740586381",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1095310237",
            "index": 158,
            "title": "Matt Ginsberg Built a GPU-Powered Crossword Solver to Take on Top Word Nerds - Ep. 148",
            "pub_date": "2021-07-28T00:00:00.000Z",
            "duration": "1675",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-matt-ginsberg",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7969103431.mp3?updated=1740586382",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1083569986",
            "index": 159,
            "title": "NVIDIA’s Liila Torabi Talks the New Era of Robotics Through Isaac Sim - Ep. 147",
            "pub_date": "2021-07-13T00:00:00.000Z",
            "duration": "1663",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidia-liila-torabi",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4381359861.mp3?updated=1740586383",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1078364350",
            "index": 160,
            "title": "NVIDIA's Simon Yuen Talks About the Future Horizon of Digital Humans - Ep. 146",
            "pub_date": "2021-06-29T00:00:00.000Z",
            "duration": "2061",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/audio2face-simon-yuen",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2158711731.mp3?updated=1740586383",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1069450864",
            "index": 161,
            "title": "Waste Not, Want Not: AI Startup Opseyes Revolutionizes Wastewater Analysis - Ep. 145",
            "pub_date": "2021-06-16T00:00:00.000Z",
            "duration": "1955",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "ai startup"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-opseyes",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7151807959.mp3?updated=1740586384",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1060251388",
            "index": 162,
            "title": "Getting Clever with Kaolin: Researchers Accelerate 3D Deep Learning with New Tools - Ep. 144",
            "pub_date": "2021-06-01T00:00:00.000Z",
            "duration": "1413",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "robotics"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/kaolin",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3654541804.mp3?updated=1740586384",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1051541071",
            "index": 163,
            "title": "AI Researcher James Kahn Explains Deep Learning’s Collision Course with Particle Physics - Ep. 143",
            "pub_date": "2021-05-19T00:00:00.000Z",
            "duration": "1375",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-researcher-james-kahn-deep-learnings-particle-physics",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1560138828.mp3?updated=1740586385",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1042831483",
            "index": 164,
            "title": "Walmart’s Grant Gelvin on Prediction Analytics at Supercenter Scale - Ep. 142",
            "pub_date": "2021-05-05T00:00:00.000Z",
            "duration": "1374",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/walmarts-prediction-analytics",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9841835320.mp3?updated=1740586386",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1033656982",
            "index": 165,
            "title": "NVIDIA’s Julie Bernauer Talks Setting Up One of World’s Fastest Supercomputers - Ep. 141",
            "pub_date": "2021-04-21T00:00:00.000Z",
            "duration": "1783",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidias-julie-bernauer-ep-141",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2792257173.mp3?updated=1740586386",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1024629535",
            "index": 166,
            "title": "NVIDIA’s Shalini De Mello Talks Self-Supervised AI, NeurIPS Successes - Ep. 140",
            "pub_date": "2021-04-07T00:00:00.000Z",
            "duration": "2132",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "safety"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidias-shalini-de-mello-talks-self-supervised-ai-neurips-successes-ep-xxx",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4925855361.mp3?updated=1740586387",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1019600446",
            "index": 167,
            "title": "Drum Roll, Please: AI Startup Sunhouse Founder Tlacael Esparza Finds His Rhythm - Ep. 139",
            "pub_date": "2021-03-31T00:00:00.000Z",
            "duration": "1923",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "ai startup"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-tlacael-esparza",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9695537518.mp3?updated=1740586388",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/1004404831",
            "index": 168,
            "title": "Author Cade Metz Talks About His New Book \"Genius Makers\" - Ep. 138",
            "pub_date": "2021-03-16T00:00:00.000Z",
            "duration": "2036",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-cade-metz-ep-138",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5421447117.mp3?updated=1740586388",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/990956506",
            "index": 169,
            "title": "NVIDIA’s Marc Hamilton on Building the Cambridge-1 Supercomputer During a Pandemic - Ep. 137",
            "pub_date": "2021-03-02T00:00:00.000Z",
            "duration": "1623",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "data center"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidias-marc-hamilton-on-building-the-cambridge-1-supercomputer-during-a-pandemic",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2217956075.mp3?updated=1740586389",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/987707857",
            "index": 170,
            "title": "Miracle Qure: Founder Pooja Rao Talks Medical Technology at Qure.ai - Ep. 136",
            "pub_date": "2021-02-18T14:00:25.000Z",
            "duration": "1722",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/qure-pooja-rao",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1562002325.mp3?updated=1740586389",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/977995255",
            "index": 171,
            "title": "Making Machines More Human: Best-Selling Author Brian Christian on the Alignment Problem - Ep. 135",
            "pub_date": "2021-02-01T00:00:00.000Z",
            "duration": "2107",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/making-machines-more-human-author-brian-christian-talks-the-alignment-problem",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6697057652.mp3?updated=1740586390",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/969753745",
            "index": 172,
            "title": "Otter.ai CEO Sam Liang on Bringing Live Captions to a Meeting Near You - Ep. 134",
            "pub_date": "2021-01-21T14:00:29.000Z",
            "duration": "1451",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-sam-liang-otter-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1958434634.mp3?updated=1740586391",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/960284578",
            "index": 173,
            "title": "On the Clock: High School Junior Ana DuCristea Creates Timely AI-based Reminder App - Ep. 133",
            "pub_date": "2021-01-06T14:00:24.000Z",
            "duration": "1333",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/on-the-clock-high-school-junior-ana-ducristea-creates-timely-ai-based-reminder-app-ep-133",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8291532447.mp3?updated=1740586391",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/949832608",
            "index": 174,
            "title": "Hey, Mr. DJ: Super Hi-Fi’s AI Applies Smarts to Sound - Ep. 132",
            "pub_date": "2020-12-23T14:00:18.000Z",
            "duration": "2163",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "ai startup"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-brendon-cassidy-super-hifi",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2049389098.mp3?updated=1740586392",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/943475032",
            "index": 175,
            "title": "Behind the Scenes at NeurIPS with NVIDIA and CalTech’s Anima Anandkumar - Ep. 131",
            "pub_date": "2020-12-07T00:00:00.000Z",
            "duration": "1820",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-anima-anandkumar",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3042726412.mp3?updated=1740586392",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/907983682",
            "index": 176,
            "title": "Lilt CEO AI Spence Green Is Making More Information Accessible to More People - Ep. 130",
            "pub_date": "2020-10-06T00:00:00.000Z",
            "duration": "1640",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-lilt-translation-spence-green",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9403352755.mp3?updated=1740586393",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/905915449",
            "index": 177,
            "title": "Art(ificial) Intelligence: Pindar Van Arman Builds Robots that Paint - Ep. 129",
            "pub_date": "2020-10-01T00:00:00.000Z",
            "duration": "2059",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/pindar-van-arman-ai-robots",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9635493773.mp3?updated=1740586394",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/898549855",
            "index": 178,
            "title": "Exploring the AI Startup Ecosystem with NVIDIA Inception’s Jeff Herbst - Ep. 128",
            "pub_date": "2020-09-23T00:00:00.000Z",
            "duration": "2034",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "ai startup"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-nvidia-jeff-herbst",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8081913555.mp3?updated=1740586394",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/891262237",
            "index": 179,
            "title": "NVIDIA Research's David Luebke on Intersection of Graphics, AI - Ep. 127",
            "pub_date": "2020-09-09T00:00:00.000Z",
            "duration": "2605",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidia-research-david-luebke",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2878923624.mp3?updated=1740586395",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/886706377",
            "index": 180,
            "title": "Picture Perfection: Topaz Labs CTO Albert Yang Will Take Your Snapshots to the Next Level - Ep. 126",
            "pub_date": "2020-08-31T00:00:00.000Z",
            "duration": "1719",
            "duration_label": "28m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-albert-yang",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5398920967.mp3?updated=1740586396",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/880567855",
            "index": 181,
            "title": "NVIDIA Research's Aaron Lefohn on What's Next at Intersection of AI and Computer Graphics – Ep. 125",
            "pub_date": "2020-08-24T00:00:00.000Z",
            "duration": "2045",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidia-researchs-aaron-lefohn-on-whats-next-at-intersection-of-ai-computer-graphics-ep-125",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7841321196.mp3?updated=1740586396",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/879536599",
            "index": 182,
            "title": "Hugging Face’s Sam Shleifer Talks Natural Language Processing - Ep. 124",
            "pub_date": "2020-08-20T00:00:00.000Z",
            "duration": "1964",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/huggingface",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5483950787.mp3?updated=1740586397",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/874386253",
            "index": 183,
            "title": "Here Comes the Sun: NASA Scientists Talk Solar Physics - Ep. 123",
            "pub_date": "2020-08-11T00:00:00.000Z",
            "duration": "2609",
            "duration_label": "43m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/deep-learning-key-to-understanding-data-from-latest-scientific-instruments",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9299163360.mp3?updated=1740586398",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/867395356",
            "index": 184,
            "title": "HP’s Jared Dame on How AI, Data Science Driving Demand for Powerful New Workstations - Ep. 122",
            "pub_date": "2020-07-27T00:00:00.000Z",
            "duration": "1715",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/hpe-jared-dame-ai-data-science",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6167523331.mp3?updated=1740586398",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/854731171",
            "index": 185,
            "title": "Not So Taxing: How Intuit Uses AI to Make Tax Day Easier - Ep. 121",
            "pub_date": "2020-07-08T00:00:00.000Z",
            "duration": "1801",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/not-so-taxing-how-intuit-uses-ai-to-make-tax-day-easier-ep-121",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5136526263.mp3?updated=1740586399",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/829476304",
            "index": 186,
            "title": "NVIDIA’s Jonah Alben Talks AI - Ep. 120",
            "pub_date": "2020-05-27T00:00:00.000Z",
            "duration": "1328",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "chips"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-jonah-alben",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3780132679.mp3?updated=1740586400",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/815607637",
            "index": 187,
            "title": "NVIDIA’s Keith Strier Talks AI Nations - Ep. 119",
            "pub_date": "2020-04-30T00:00:00.000Z",
            "duration": "1749",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-keith-strier",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3530776342.mp3?updated=1740586400",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/805409266",
            "index": 188,
            "title": "Lenovo's Mike Leach on the Role of the Workstation in Modern AI - Ep. 118",
            "pub_date": "2020-04-22T00:00:00.000Z",
            "duration": "1736",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/lenovo",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8840281462.mp3?updated=1740586401",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/803738632",
            "index": 189,
            "title": "Ford’s Nikita Jaipuria and Rohan Bhasin on Generating Synthetic Data - Ep. 117",
            "pub_date": "2020-04-21T00:00:00.000Z",
            "duration": "1400",
            "duration_label": "23m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/ford-generating-synthetic-data",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7285580902.mp3?updated=1740586402",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/801031951",
            "index": 190,
            "title": "Finding Trash in Sensitive Waterways with AI - Ep. 116",
            "pub_date": "2020-04-16T00:00:00.000Z",
            "duration": "1530",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-waterways",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7298454199.mp3?updated=1740586402",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/797956489",
            "index": 191,
            "title": "MIT’s Jonathan Frankle on “The Lottery Hypothesis” - Ep. 115",
            "pub_date": "2020-04-14T00:00:00.000Z",
            "duration": "1457",
            "duration_label": "24m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/mit-the-lottery-hypothesis",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9071990085.mp3?updated=1740586403",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/793374328",
            "index": 192,
            "title": "Credit Check: Capital One’s Kyle Nicholson on Modern Machine Learning in Finance - Ep. 114",
            "pub_date": "2020-04-09T00:00:00.000Z",
            "duration": "1147",
            "duration_label": "19m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/capital-one",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1136278267.mp3?updated=1740586403",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/789512254",
            "index": 193,
            "title": "Demystifying AI with NVIDIA’s Will Ramey - Ep. 113",
            "pub_date": "2020-04-03T00:00:00.000Z",
            "duration": "2838",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/deep-learning-demystified",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4992366460.mp3?updated=1740586404",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/788200978",
            "index": 194,
            "title": "Speed of Light: SLAC’s Ryan Coffee Talks Ultrafast Science - Ep. 112",
            "pub_date": "2020-04-03T00:00:00.000Z",
            "duration": "2212",
            "duration_label": "36m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/slac-ryan-coffee",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4449147487.mp3?updated=1740586405",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/783605716",
            "index": 195,
            "title": "Stanford's Margot Gerritsen on Data Science and Women in Tech - Ep. 111",
            "pub_date": "2020-03-28T00:00:00.000Z",
            "duration": "2050",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/stanfords-margot-gerritsen",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1237387148.mp3?updated=1740586405",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/782872945",
            "index": 196,
            "title": "Keeping an Eye on AI: Building Ethical Technology at Salesforce - Ep. 110",
            "pub_date": "2020-03-24T00:00:00.000Z",
            "duration": "2014",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ethical-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3860948829.mp3?updated=1740586406",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/762906757",
            "index": 197,
            "title": "Nanotronics Brings Deep Learning to Precision Manufacturing - Ep. 109",
            "pub_date": "2020-02-17T00:00:00.000Z",
            "duration": "1404",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-nanotronics-matthew-putman-3",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1505451092.mp3?updated=1740586406",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/755381191",
            "index": 198,
            "title": "NVIDIA’s Neda Cvijetic Explains the Science Behind Self-Driving Cars - Ep. 108",
            "pub_date": "2020-02-04T00:00:00.000Z",
            "duration": "1488",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/nvidias-neda-cvijetic-explains-the-science-behind-self-driving-cars-ep-108",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2911676460.mp3?updated=1740586407",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/740460151",
            "index": 199,
            "title": "AI’s Mild Ride: RoadBotics Puts AI on Pothole Patrol - Ep. 107",
            "pub_date": "2020-01-09T00:00:00.000Z",
            "duration": "1510",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-ben-schmidt-roadbotics-podcast",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8271112415.mp3?updated=1740586408",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/731092522",
            "index": 200,
            "title": "Serkan Piantino’s Company Makes AI for Everyone - Ep. 106",
            "pub_date": "2019-12-18T00:00:00.000Z",
            "duration": "1397",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/serkan-piantino-spell",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7849067564.mp3?updated=1740586408",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/723283363",
            "index": 201,
            "title": "Pod Squad: Descript Uses AI to Make Managing Podcasts Quicker, Easier - Ep. 105",
            "pub_date": "2019-12-04T00:00:00.000Z",
            "duration": "1539",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/descript-ai-podcast-andrew-mason",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8729540932.mp3?updated=1740586409",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/716059609",
            "index": 202,
            "title": "Speaking the Same Language: How Oracle’s Conversational AI Serves Customers - Ep. 104",
            "pub_date": "2019-11-21T00:00:00.000Z",
            "duration": "1955",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/speaking-the-same-language-how-oracles-conversational-ai-serves-customers-ep-103",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9220630566.mp3?updated=1740586410",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/706098688",
            "index": 203,
            "title": "AI4Good: Canadian Lab Empowers Women in Computer Science - Ep. 103",
            "pub_date": "2019-11-13T00:00:00.000Z",
            "duration": "1708",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "training",
              "ai startup"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai4good-canadian-lab-empowers-women-in-computer-science-ep-102",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7816522955.mp3?updated=1740586410",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/705238864",
            "index": 204,
            "title": "AI Startup Brings Computer Vision to Customer Service - Ep. 102",
            "pub_date": "2019-10-30T00:00:00.000Z",
            "duration": "1161",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/satish-mandalika-drishyam-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2722886199.mp3?updated=1740586411",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/701332282",
            "index": 205,
            "title": "Clean Sweep: Tokyo Robotics Company Builds Tidying Robots - Ep. 101",
            "pub_date": "2019-10-21T00:00:00.000Z",
            "duration": "1089",
            "duration_label": "18m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/jun-hatori-preferred-networks-ep-101",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC7532740076.mp3?updated=1740586412",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/697367537",
            "index": 206,
            "title": "The Buck Starts Here: NVIDIA’s Ian Buck on What’s Next for AI - Ep. 100",
            "pub_date": "2019-10-16T00:00:00.000Z",
            "duration": "1694",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ian-buck",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9234469927.mp3?updated=1740586412",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/690065029",
            "index": 207,
            "title": "GauGAN Rocket Man: Conceptual Artist Uses AI Tools for Sci-Fi Modeling - Ep. 99",
            "pub_date": "2019-10-01T00:00:00.000Z",
            "duration": "1976",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/gaugan-rocket-man-conceptual-artist-uses-ai-tools-for-sci-fi-modeling-ep-99",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8328451853.mp3?updated=1740586413",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/686738683",
            "index": 208,
            "title": "Say Yes to the AI Dress: Entrepreneur Brings GPUs to Fashion - Ep. 98",
            "pub_date": "2019-09-21T00:00:00.000Z",
            "duration": "1325",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/entrepreneur-brings-gpus-to-fashion",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6796988146.mp3?updated=1740586413",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/682966523",
            "index": 209,
            "title": "Focal Systems Brings AI to Grocery Stores - Ep. 97",
            "pub_date": "2019-09-15T00:00:00.000Z",
            "duration": "1512",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/focal-systems-grocery",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8052692872.mp3?updated=1740586414",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/679291599",
            "index": 210,
            "title": "Kiwibots Bring Sustenance to Students - Ep. 96",
            "pub_date": "2019-09-10T00:00:00.000Z",
            "duration": "1316",
            "duration_label": "21m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/kiwibot-felipe-chavez",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2214417849.mp3?updated=1740586415",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/676638071",
            "index": 211,
            "title": "Dial A for AI: Charter Boosts Customer Service with AI - Ep. 95",
            "pub_date": "2019-09-03T00:00:00.000Z",
            "duration": "1163",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/charter-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9679863416.mp3?updated=1740586415",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/655486025",
            "index": 212,
            "title": "Doc.ai CEO Walter De Brouwer on How Federated Learning Can Help Keep Data Private- Ep. 94",
            "pub_date": "2019-08-18T00:00:00.000Z",
            "duration": "1799",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/docai-ceo-walter-de-brouwer-ep-92",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4986753122.mp3?updated=1740586416",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/662196161",
            "index": 213,
            "title": "Forget Storming Area 51, AI’s Helping Astronomers Scour the Skies for Habitable Planets - Ep. 93",
            "pub_date": "2019-08-07T13:00:25.000Z",
            "duration": "1472",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/guyon-gratadour",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1700691861.mp3?updated=1740586417",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/658647725",
            "index": 214,
            "title": "Making \"Iron Man\" Interface Real: AI-Based Virtualitics Demystifies Data Science with VR - Ep. 92",
            "pub_date": "2019-07-28T00:00:00.000Z",
            "duration": "1646",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/aakash-virtualitics",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2356061868.mp3?updated=1740586417",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/645582363",
            "index": 215,
            "title": "Get Your Fashion Fix: Stitch Fix Adds AI Flair to Your Closet - Ep. 91",
            "pub_date": "2019-07-09T00:00:00.000Z",
            "duration": "1461",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/stitch-fix-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8252029858.mp3?updated=1740586418",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/645901110",
            "index": 216,
            "title": "Talking Trucks with TuSimple's Chuck Price - Ep. 90",
            "pub_date": "2019-07-02T00:00:00.000Z",
            "duration": "1448",
            "duration_label": "24m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/chuck-price-tusimple",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9457357354.mp3?updated=1740586418",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/642179742",
            "index": 217,
            "title": "Anthem Could Have Healthcare Industry Singing a New Tune - Ep. 89",
            "pub_date": "2019-06-26T00:00:00.000Z",
            "duration": "1273",
            "duration_label": "21m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/anthem-could-have-healthcare-industry-singing-a-new-tune-ep-89",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2087865091.mp3?updated=1740586419",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/631121661",
            "index": 218,
            "title": "SAS Chief Operating Officer Oliver Schabenberger - Ep. 88",
            "pub_date": "2019-06-04T00:00:00.000Z",
            "duration": "1001",
            "duration_label": "16m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/sas-chief-operating-officer-oliver-schabenberger-ep-88",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4231198610.mp3?updated=1740586420",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/624446466",
            "index": 219,
            "title": "AutoX's Professor X on the State of Automotive Autonomy - Ep. 87",
            "pub_date": "2019-05-29T00:00:00.000Z",
            "duration": "1280",
            "duration_label": "21m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "automation"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/autox-jianxiong-xiao",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9292831699.mp3?updated=1740586420",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/624422646",
            "index": 220,
            "title": "A-High: How Grownetics Automates Cannabis Cultivation with Deep Learning - Ep. 86",
            "pub_date": "2019-05-21T00:00:00.000Z",
            "duration": "1663",
            "duration_label": "27m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-cannabis-grownetics",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3584520080.mp3?updated=1740586421",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/621751281",
            "index": 221,
            "title": "Teaching Families to Embrace AI - Ep. 85",
            "pub_date": "2019-05-16T00:00:00.000Z",
            "duration": "1802",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/teaching-families-to-embrace-ai-ep-84",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3836838437.mp3?updated=1740586421",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/614526855",
            "index": 222,
            "title": "Astronomers Turn to AI as New Telescopes Come Online - Ep. 84",
            "pub_date": "2019-05-01T00:00:00.000Z",
            "duration": "1340",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/brant-robertson-astronomy",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2461053044.mp3?updated=1740586422",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/610888797",
            "index": 223,
            "title": "Primer's Sean Gourley on Bots, Propaganda and Fake News - Ep. 83",
            "pub_date": "2019-04-21T00:00:00.000Z",
            "duration": "1831",
            "duration_label": "30m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/primer-sean-gourley",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC4008692438.mp3?updated=1740586423",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/604056732",
            "index": 224,
            "title": "UC Berkeley’s Pieter Abbeel on How Deep Learning Will Help Robots Learn - Ep. 82",
            "pub_date": "2019-04-11T00:00:00.000Z",
            "duration": "1418",
            "duration_label": "23m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/pieter-abbeel-ep-82",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3505226585.mp3?updated=1740586423",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/598105551",
            "index": 225,
            "title": "How the Breakthrough Listen Harnessed AI in the Search for Aliens - Ep. 81",
            "pub_date": "2019-03-27T00:00:00.000Z",
            "duration": "1121",
            "duration_label": "18m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/gerry-zhang-ai-seti-institute",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6569504264.mp3?updated=1740586424",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/589251633",
            "index": 226,
            "title": "Ready for the Playoffs? Swish Analytics Can Help You Clean Up - Ep. 80",
            "pub_date": "2019-03-14T20:51:14.000Z",
            "duration": "1551",
            "duration_label": "25m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/march-madness-swish-analytics",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9315597192.mp3?updated=1740586424",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/581410521",
            "index": 227,
            "title": "How AI Helps GOAT Keep Sneakerheads a Step Ahead - Ep. 79",
            "pub_date": "2019-02-26T00:00:00.000Z",
            "duration": "1940",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-podcast-goat-gtc",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6764186881.mp3?updated=1740586425",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/575356416",
            "index": 228,
            "title": "How Nuance Brings AI to Healthcare - Ep. 78",
            "pub_date": "2019-02-11T00:00:00.000Z",
            "duration": "1396",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-podcast-karen-holzberger-nuance-f2",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5998113412.mp3?updated=1740586426",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/561225171",
            "index": 229,
            "title": "Sort Circuit: How GPUs Helped One Man Conquer His Lego Pile - Ep. 77",
            "pub_date": "2019-01-23T00:00:00.000Z",
            "duration": "1810",
            "duration_label": "30m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/sort-circuit-how-gpus-helped-one-man-conquer-his-lego-pile-ep-77",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3684649324.mp3?updated=1740586426",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/556350426",
            "index": 230,
            "title": "A Man, a GAN, and a 1080 Ti: How Jason Antic Created 'De-Oldify'  - Ep. 76",
            "pub_date": "2019-01-09T00:00:00.000Z",
            "duration": "1726",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/how-jason-antic-used-deep-learning-to-make-old-photos-look-new-ep-73",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2648904227.mp3?updated=1740586427",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/548027694",
            "index": 231,
            "title": "How SoundHound Uses AI to Bring Voice and Music Recognition to Any Platform - Ep. 75",
            "pub_date": "2018-12-19T00:00:00.000Z",
            "duration": "1713",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-podcast-soundhound",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5445071380.mp3?updated=1740586428",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/539956314",
            "index": 232,
            "title": "Good News About Fake News: AI Can Now Help Detect False Information - Ep. 74",
            "pub_date": "2018-12-06T00:00:00.000Z",
            "duration": "1605",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "embedding"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-podcast-vagelis-papalexakis-fake-news",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6425976454.mp3?updated=1740586428",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/533486289",
            "index": 233,
            "title": "A Conversation with the Entrepreneur Behind the World's Most Realistic Artificial Voices - Ep. 73",
            "pub_date": "2018-11-21T00:00:00.000Z",
            "duration": "2168",
            "duration_label": "36m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/a-conversation-with-the-entrepreneur-behind-the-worlds-most-realistic-artificial-voices-ep-73",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3478222809.mp3?updated=1740586429",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/525762432",
            "index": 234,
            "title": "Investor, AI Pioneer Kai-Fu Lee on the Future of AI in the US, China - Ep. 72",
            "pub_date": "2018-11-07T00:00:00.000Z",
            "duration": "2033",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/kai-fu-lee-ai",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2221055844.mp3?updated=1740586429",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/519141165",
            "index": 235,
            "title": "How Intuit Uses Deep Learning to Help You with Your Taxes - Ep. 71",
            "pub_date": "2018-10-24T14:47:41.000Z",
            "duration": "1922",
            "duration_label": "32m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ep-71",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC9660697367.mp3?updated=1740586430",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/512168646",
            "index": 236,
            "title": "What's in Your Wallet? For Capital One, the Answer Is AI - Ep. 70",
            "pub_date": "2018-10-10T00:00:00.000Z",
            "duration": "1476",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/whats-in-your-wallet-for-capital-one-the-answer-is-ai-ep-70",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8364631719.mp3?updated=1740586431",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/502348308",
            "index": 237,
            "title": "Cycle of DOOM Now Complete: Researchers Use AI to Generate New Levels for Seminal Videogame - Ep. 69",
            "pub_date": "2018-09-17T00:00:00.000Z",
            "duration": "1374",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/the-cycle-of-doom-now-complete-researchers-use-ai-to-generate-new-levels-for-seminal-videogame-ep-69",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2284249463.mp3?updated=1740586432",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/495430923",
            "index": 238,
            "title": "This Astrophysics Grad Student Doesn't Always Make Memes... But When He Does, He Uses Deep Learning",
            "pub_date": "2018-08-29T00:00:00.000Z",
            "duration": "1630",
            "duration_label": "27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/ai-podcast-dank-memes-lawrence-pierson",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6909660121.mp3?updated=1740586432",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/489011793",
            "index": 239,
            "title": "Teaching Bots Learn by Watching Human Behavior - Ep. 67",
            "pub_date": "2018-08-22T00:00:00.000Z",
            "duration": "2231",
            "duration_label": "37m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-stanford-svl-ep-67",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6113615083.mp3?updated=1740586433",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/479848629",
            "index": 240,
            "title": "Startup Uses Deep Learning to Understand Voice - Ep. 66",
            "pub_date": "2018-08-08T00:00:00.000Z",
            "duration": "1595",
            "duration_label": "26m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ep-70",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3875361470.mp3?updated=1740586433",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/471208941",
            "index": 241,
            "title": "Startup Uses AI to Help Airports Work More Smoothly  - Ep. 65",
            "pub_date": "2018-07-18T00:00:00.000Z",
            "duration": "1454",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-searidge",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5970996672.mp3?updated=1740586434",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/466429455",
            "index": 242,
            "title": "Startup Uses AI to Give Consumers the Credit They Deserve - Ep. 64",
            "pub_date": "2018-07-03T00:00:00.000Z",
            "duration": "1246",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/startup-uses-ai-to-give-millennials-the-credit-they-deserve",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6264898665.mp3?updated=1740586435",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/458477529",
            "index": 243,
            "title": "NVIDIA Chief Scientist Bill Dally on Where AI Goes Next - Ep. 62",
            "pub_date": "2018-06-13T00:00:00.000Z",
            "duration": "1596",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/ai-bill-dally-nvidia-research",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC2851161724.mp3?updated=1740586435",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/454828680",
            "index": 244,
            "title": "How AI's Storming the Fashion Industry - Ep. 61",
            "pub_date": "2018-06-07T00:00:00.000Z",
            "duration": "1542",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/gtc-fashion",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1914254897.mp3?updated=1740586436",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/447646695",
            "index": 245,
            "title": "Netflix's Justin Basilico on How Entertainment and AI Intersect - Ep. 60",
            "pub_date": "2018-05-29T00:00:00.000Z",
            "duration": "1155",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/netflixs-justin-basilico-on-how-entertainment-and-ai-intersect-ep-60",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC1252394337.mp3?updated=1740586436",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/444474210",
            "index": 246,
            "title": "A USB Port for Your Body? Startup Uses AI to Connect Medical Devices to Nervous System - Ep. 59",
            "pub_date": "2018-05-22T00:00:00.000Z",
            "duration": "1212",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://soundcloud.com/theaipodcast/cambridge-bio-augmentation-systems",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC3661130168.mp3?updated=1740586437",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/445529436",
            "index": 247,
            "title": "The Long View on Big Data: Wayne Thompson, Chief Data Scientist, SAS Data Science Institute - Ep. 58",
            "pub_date": "2018-05-17T00:00:00.000Z",
            "duration": "1128",
            "duration_label": "18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "gpu"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/wayne-thompson-chief-data-scientist-sas-data-science-institute-ep-58",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC6612664183.mp3?updated=1740586438",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/442297113",
            "index": 248,
            "title": "NVIDIA's Bryan Catanzaro on the Latest from NVIDIA Research - Ep. 57",
            "pub_date": "2018-05-10T00:00:00.000Z",
            "duration": "1180",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "nvidia"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/research",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5948825411.mp3?updated=1740586438",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/438683346",
            "index": 249,
            "title": "Grab and Go: Startup AiFi Using Deep Learning to Make Every Store Smarter - Ep. 56",
            "pub_date": "2018-05-02T00:00:00.000Z",
            "duration": "1131",
            "duration_label": "18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://soundcloud.com/theaipodcast/grab-and-go-store-retail-aifi",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC5476528038.mp3?updated=1740586439",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "tag:soundcloud,2010:tracks/435221490",
            "index": 250,
            "title": "How Deep Learning Can Accelerate the Quest for Cheap, Clean Fusion Energy - Ep. 55",
            "pub_date": "2018-04-25T00:00:00.000Z",
            "duration": "1644",
            "duration_label": "27m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://soundcloud.com/theaipodcast/fusion",
            "audio_url": "https://cohst.app/pdcst/9V4R8T/traffic.megaphone.fm/NVC8090404719.mp3?updated=1740586439",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "big-technology",
        "title": "Big Technology Podcast",
        "feed_title": "Big Technology Podcast",
        "priority": "P2",
        "selection_mode": "keyword",
        "focus": [
          "tech industry",
          "AI companies",
          "platforms"
        ],
        "feed_url": "https://feeds.megaphone.fm/LI3617121267",
        "source_url": "https://feeds.megaphone.fm/LI3617121267",
        "detail_path": "/podcasts/big-technology/",
        "episode_count": 250,
        "selected_episode_count": 230,
        "latest_episode_title": "Will Apple (Finally) Get AI Right At WWDC?, Anthropic’s Worry, Microsoft vs. OpenAI",
        "latest_pub_date": "2026-06-05T23:42:00.000Z",
        "latest_page_url": "",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "4bd4a6c6-6137-11f1-8112-57fe62b1b0cd",
            "index": 1,
            "title": "Will Apple (Finally) Get AI Right At WWDC?, Anthropic’s Worry, Microsoft vs. OpenAI",
            "pub_date": "2026-06-05T23:42:00.000Z",
            "duration": "3474",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5213997862.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "88b103c8-5f75-11f1-846b-eb42fc65425f",
            "index": 2,
            "title": "AI Pioneer Geoffrey Hinton: AI Is Conscious, Superintelligence is Coming, And We Should Be Worried",
            "pub_date": "2026-06-03T19:37:00.000Z",
            "duration": "3443",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2236404252.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04f21202-5de5-11f1-a703-0fb4bc94ca9f",
            "index": 3,
            "title": "Did Google Just Fall Behind Again?, iPhone Fold Cometh, Anthropic Files To Go Public",
            "pub_date": "2026-06-01T18:25:00.000Z",
            "duration": "4307",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9007482331.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d006a72a-5ba4-11f1-ad12-dba3c1a30fd3",
            "index": 4,
            "title": "Warning Signs For The AI Boom, Anthropic Passes OpenAI, Robinhood’s AI Trading",
            "pub_date": "2026-05-29T21:27:00.000Z",
            "duration": "3599",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "chip",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3267882986.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a01c7f2-59dd-11f1-8f35-a7f2ecd232aa",
            "index": 5,
            "title": "Predicting the SpaceX, OpenAI, and Anthropic IPOs — With Dick Costolo",
            "pub_date": "2026-05-27T15:37:00.000Z",
            "duration": "3406",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8546634208.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "080342ea-5665-11f1-9c3b-7bae17f17b11",
            "index": 6,
            "title": "Is OpenAI Ready To IPO?, The Datacenters in Space Myth, The Kids Boo AI",
            "pub_date": "2026-05-23T05:08:00.000Z",
            "duration": "3589",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9425036022.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db5f0738-5385-11f1-8cf4-3fde62afe2e7",
            "index": 7,
            "title": "Claude Code Head Boris Cherny: Insane Growth, Tokenmaxxing, AI Agents' Next Frontier",
            "pub_date": "2026-05-20T10:00:00.000Z",
            "duration": "3554",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6707672094.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0941368e-50b7-11f1-b478-af00ac0d59b3",
            "index": 8,
            "title": "Satya Nadella’s OpenAI Concerns, Google’s Next AI Model, The AI Monet Prank",
            "pub_date": "2026-05-15T23:39:00.000Z",
            "duration": "3295",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3621710754.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e7046f4c-4430-11f1-ac0c-878d191fd7f3",
            "index": 9,
            "title": "Does Anyone Want AI Wearables? + The Allure of AI Love — With Joanna Stern",
            "pub_date": "2026-05-13T15:43:00.000Z",
            "duration": "2569",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7327410699.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2769a060-4b26-11f1-86ff-fbcb1ca103a7",
            "index": 10,
            "title": "The Unlikely Anthropic & SpaceX Marriage, OpenAI Trial Revelations, AI Layoffs Or Cope?",
            "pub_date": "2026-05-08T21:47:00.000Z",
            "duration": "3430",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2375655383.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f1afd0a-4a1d-11f1-9b0f-d3fe42d294cd",
            "index": 11,
            "title": "AI Agents: Mirage Or Real Revolution? — With Dmitry Shevelenko",
            "pub_date": "2026-05-07T14:52:00.000Z",
            "duration": "3690",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2139162279.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a740bc7c-4844-11f1-adb5-57df7c340e5c",
            "index": 12,
            "title": "Did Apple Get AI Spending Right?, Microsoft & OpenAI’s New Reality, Where’s Stargate?",
            "pub_date": "2026-05-05T05:41:00.000Z",
            "duration": "3657",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9424129098.mp3?updated=1778072129",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c53f988a-459f-11f1-9571-e351015c311f",
            "index": 13,
            "title": "OpenAI’s User Growth Miss, Musk vs. Altman, Prediction Market Ban",
            "pub_date": "2026-05-01T20:51:00.000Z",
            "duration": "3473",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5282531330.mp3?updated=1777669268",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7113e862-43c2-11f1-8381-9b086aea2ab4",
            "index": 14,
            "title": "Mark Cuban: AI Hype vs. Reality, OpenAI's Wasting $1 Trillion, Lebron vs. Jordan",
            "pub_date": "2026-04-29T12:07:00.000Z",
            "duration": "3265",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6999535097.mp3?updated=1777465101",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "85fa8c2a-403b-11f1-a047-470ea79ab19a",
            "index": 15,
            "title": "Apple After Tim Cook, OpenAI’s New Mojo, Meta’s Internal Tracking Escapade",
            "pub_date": "2026-04-25T00:44:00.000Z",
            "duration": "3424",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5647341027.mp3?updated=1777078499",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1844c76-3f67-11f1-b7f5-5b2fc6f04601",
            "index": 16,
            "title": "OpenAI President Greg Brockman on GPT-5.5 “Spud,” AI Model Moats, and Cybersecurity Risks",
            "pub_date": "2026-04-23T22:55:00.000Z",
            "duration": "1686",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "openai",
              "training",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1320146805.mp3?updated=1776989787",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3cdea248-3e50-11f1-a133-1f09079f6775",
            "index": 17,
            "title": "Are We Too Obsessed With AI Predictions? — With Carissa Véliz",
            "pub_date": "2026-04-22T14:16:00.000Z",
            "duration": "3293",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4803772463.mp3?updated=1776866937",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c88b3518-3d1a-11f1-afb1-47f16fcc3732",
            "index": 18,
            "title": "Tim Cook Steps Down — With Joanna Stern",
            "pub_date": "2026-04-21T00:41:00.000Z",
            "duration": "958",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6600077617.mp3?updated=1776859286",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89f06d32-3a8b-11f1-afb6-f7f0bd84de28",
            "index": 19,
            "title": "Jensen On The Ropes, Sam Altman’s Conflicts, Allbirds’ GPU Pivot",
            "pub_date": "2026-04-17T18:51:00.000Z",
            "duration": "3480",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "openai",
              "anthropic",
              "nvidia",
              "gpu"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6752616479.mp3?updated=1776451319",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "673926ee-38fb-11f1-82b8-5f274e69da50",
            "index": 20,
            "title": "The Pentagon's AI Plan + Behind the Anthropic Fight — With Under Secretary of War Emil Michael",
            "pub_date": "2026-04-15T19:06:00.000Z",
            "duration": "3598",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7230758441.mp3?updated=1776279931",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eaf64cee-351f-11f1-8219-57d4758bd4fc",
            "index": 21,
            "title": "Anthropic’s Mythos Dilemma, Violence Against AI, Tokenmaxxing at Meta",
            "pub_date": "2026-04-10T21:25:00.000Z",
            "duration": "3713",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8933066130.mp3?updated=1775855961",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0bbabb28-334e-11f1-bc26-779fd668cd94",
            "index": 22,
            "title": "OpenAI vs. Anthropic's Direct Faceoff + Future of Agents — With Aaron Levie",
            "pub_date": "2026-04-08T15:02:00.000Z",
            "duration": "3514",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6131393798.mp3?updated=1775659805",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cf1954d0-31d2-11f1-9be9-0bd4dd6d64cf",
            "index": 23,
            "title": "More OpenAI Executive Drama, Is Siri Seriously Broken?, Meta’s Elusive Next Hit",
            "pub_date": "2026-04-06T16:57:00.000Z",
            "duration": "3919",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6982087835.mp3?updated=1775496261",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13bfcbc2-2fc2-11f1-83e1-577c8d923a70",
            "index": 24,
            "title": "OpenAI buys TBPN, SpaceX’s $2 Trillion IPO?, Iran Disables Amazon Infrastructure",
            "pub_date": "2026-04-04T01:17:00.000Z",
            "duration": "3295",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7510351765.mp3?updated=1775265828",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5ea5839c-2dc0-11f1-bdee-ef1eb8c439cf",
            "index": 25,
            "title": "OpenAI President Greg Brockman: AI Self-Improvement, The Superapp Bet, Path To AGI, Scaling Compute",
            "pub_date": "2026-04-01T14:39:00.000Z",
            "duration": "4493",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "training",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1785401983.mp3?updated=1775054062",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eed394f8-2a42-11f1-8315-674c805db069",
            "index": 26,
            "title": "Why OpenAI Killed Sora, Did Apple Just Save Siri?, Meta’s Big Loss",
            "pub_date": "2026-03-28T01:18:00.000Z",
            "duration": "3791",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4147573754.mp3?updated=1774661186",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "59776744-286d-11f1-8d60-d358851f777b",
            "index": 27,
            "title": "Senator Mark Warner: Nobody’s Ready for What AI Could Do To Us",
            "pub_date": "2026-03-25T18:40:00.000Z",
            "duration": "2896",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9456677024.mp3?updated=1774464300",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f5e590d8-2462-11f1-85a5-2b93333c490e",
            "index": 28,
            "title": "OpenAI’s Superapp Ambitions, Jensen on Jobs, Bezos’s $100 Billion Automation Fund",
            "pub_date": "2026-03-20T16:30:00.000Z",
            "duration": "3683",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia",
              "automation",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3468685020.mp3?updated=1774097484",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "93c7f462-22d3-11f1-acaf-6b0ae646ce9a",
            "index": 29,
            "title": "Are We Screwed If AI Works? — With Andrew Ross Sorkin",
            "pub_date": "2026-03-18T14:36:00.000Z",
            "duration": "3923",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1656307785.mp3?updated=1773844375",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2de3260c-1f14-11f1-91f9-a7f2194788a6",
            "index": 30,
            "title": "AI Backlash Intensifies, Nvidia GTC Preview, Meta’s Embarrassing Delay",
            "pub_date": "2026-03-13T19:54:00.000Z",
            "duration": "3677",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6622229861.mp3?updated=1773496431",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3eb54bda-1d4e-11f1-a0b5-376a7ea41f61",
            "index": 31,
            "title": "AI’s Unpopularity + Competing With ChatGPT — With Olivia Moore",
            "pub_date": "2026-03-11T16:13:00.000Z",
            "duration": "3416",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "chatgpt",
              "claude",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4007454476.mp3?updated=1773246136",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "53fabff6-1971-11f1-bfd2-cb68647752bd",
            "index": 32,
            "title": "AI Revenue Explodes, Dario’s Memo, McDonald's CEO’s Baby Burger Bite",
            "pub_date": "2026-03-06T17:30:00.000Z",
            "duration": "3647",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3350406270.mp3?updated=1772811892",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3e7f1802-17e6-11f1-ab72-bbbfd4c56667",
            "index": 33,
            "title": "Pentagon Insider: What's Next For Anthropic and The Department of War — With Michael Horowitz",
            "pub_date": "2026-03-04T16:31:00.000Z",
            "duration": "2902",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9796479878.mp3?updated=1772642427",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8376a40e-1681-11f1-bb7b-bbfa3ee59c7e",
            "index": 34,
            "title": "Dario’s Choice and Anthropic’s Future, Apple’s AI Devices, Netflix Loses WBD",
            "pub_date": "2026-03-02T21:51:00.000Z",
            "duration": "3677",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3236570834.mp3?updated=1772488656",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e58dfa40-1413-11f1-a1fc-bfcd3d99b099",
            "index": 35,
            "title": "Anthropic vs. The Pentagon, Bloodbath at Block, The Citrini Selloff",
            "pub_date": "2026-02-27T21:40:00.000Z",
            "duration": "3888",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6448065352.mp3?updated=1772228604",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba8f985c-124d-11f1-85b5-3bee3a6b999c",
            "index": 36,
            "title": "Can AI Become Conscious? — With Michael Pollan",
            "pub_date": "2026-02-25T13:41:00.000Z",
            "duration": "3312",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2068592565.mp3?updated=1772027350",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f35dc2aa-0e9a-11f1-93ad-2b641dc25ec3",
            "index": 37,
            "title": "OpenAI Closes in on $100 Billion, OpenClaw Acquired, AI’s Productivity Question — With Aaron Levie",
            "pub_date": "2026-02-20T21:49:00.000Z",
            "duration": "3329",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5109442804.mp3?updated=1771625111",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5772eec-0cd8-11f1-870a-6be0d9a9bc3f",
            "index": 38,
            "title": "How Google DeepMind Operates & Experiments — With Lila Ibrahim and James Manyika",
            "pub_date": "2026-02-18T15:48:00.000Z",
            "duration": "3001",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9094383241.mp3?updated=1771430179",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa79ef72-091e-11f1-addf-e7d9667676b0",
            "index": 39,
            "title": "Is Something Big Happening?, AI Safety Apocalypse, Anthropic Raises $30 Billion",
            "pub_date": "2026-02-13T21:03:00.000Z",
            "duration": "4115",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "alignment",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1075367237.mp3?updated=1771016870",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e687c8d2-074c-11f1-a7f5-6b2c5fb2b4e8",
            "index": 40,
            "title": "Who’s Winning The AI Race? + Software’s Future — With Sridhar Ramaswamy",
            "pub_date": "2026-02-11T13:44:00.000Z",
            "duration": "3501",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8800154852.mp3?updated=1770817979",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "60371100-03a2-11f1-80d2-0f7516d4ddf1",
            "index": 41,
            "title": "Software In Shambles, OpenAI vs. Anthropic Super Brawl, Amazon’s Struggles",
            "pub_date": "2026-02-06T21:31:00.000Z",
            "duration": "3825",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3566756038.mp3?updated=1770414101",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4726d42-0203-11f1-936c-2f88a62fd278",
            "index": 42,
            "title": "AI's Research Frontier: Memory, World Models, & Planning — With Joelle Pineau",
            "pub_date": "2026-02-04T20:30:00.000Z",
            "duration": "3291",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8814939880.mp3?updated=1770237596",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "022c2f2c-0060-11f1-86a8-6b045a8d583c",
            "index": 43,
            "title": "The Moltbook Uprising, NVIDIA’s OpenAI Pullback, Apple’s Conundrum",
            "pub_date": "2026-02-02T18:02:00.000Z",
            "duration": "3304",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2622010939.mp3?updated=1770055939",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "019e67fa-feb7-11f0-906f-2bd04d3a1164",
            "index": 44,
            "title": "The Anthropic Rocketship, AI’s Spending Limits, SpaceX IPO",
            "pub_date": "2026-01-31T15:17:00.000Z",
            "duration": "3446",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1975825680.mp3?updated=1769899338",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "326a6456-fc4b-11f0-a415-43a2f8d83694",
            "index": 45,
            "title": "Is AI Killing Software? — With Bret Taylor",
            "pub_date": "2026-01-28T13:46:00.000Z",
            "duration": "3803",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7933875812.mp3?updated=1769608388",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a3b81cc-f86c-11f0-acb5-cf6d1d381493",
            "index": 46,
            "title": "OpenAI’s $50 Billion Fundraise, AI Advertising Game Theory, Apple’s AI Wearable Pin",
            "pub_date": "2026-01-23T18:00:00.000Z",
            "duration": "3345",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7640154723.mp3?updated=1769181783",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2dbbae8a-f703-11f0-948d-7703b0f3fba0",
            "index": 47,
            "title": "Google DeepMind CEO Demis Hassabis: AI's Next Breakthroughs, AGI Timeline, Google's AI Glasses Bet",
            "pub_date": "2026-01-21T20:28:00.000Z",
            "duration": "2047",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2189130568.mp3?updated=1769026877",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2f388216-f612-11f0-a0a3-c7079d31b73f",
            "index": 48,
            "title": "Qualcomm CEO Cristiano Amon: Future Of AI Devices, AI Fashion, Blending Reality and Computing",
            "pub_date": "2026-01-20T15:30:00.000Z",
            "duration": "3317",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chips",
              "data center",
              "inference",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4775318988.mp3?updated=1768923648",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d2d903a8-f31c-11f0-8d5f-d316b8c7fd98",
            "index": 49,
            "title": "Is Google's Gemini Winning?, Thinking Machines Drama, Claude Cowork’s Potential",
            "pub_date": "2026-01-16T21:25:00.000Z",
            "duration": "3256",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "claude",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6497387669.mp3?updated=1768599328",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ce086396-f164-11f0-bfaa-ff8a71fe1c69",
            "index": 50,
            "title": "Who Wins if AI Models Commoditize? — With Mistral CEO Arthur Mensch",
            "pub_date": "2026-01-14T16:53:00.000Z",
            "duration": "3418",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "mistral"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9769627628.mp3?updated=1768555627",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36ccdf82-97e3-11f0-a839-c3f392c8e271",
            "index": 51,
            "title": "AI’s Steve Jobs?, Big Tech AI Chaos Ladder, 2026 Crystal Ball",
            "pub_date": "2026-01-12T22:29:00.000Z",
            "duration": "3299",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7696899195.mp3?updated=1768257512",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "580c49ba-ed8f-11f0-a3cf-770d82b267db",
            "index": 52,
            "title": "Claude Code’s Shining Moment, ChatGPT for Healthcare, End Of Busywork?",
            "pub_date": "2026-01-09T19:21:00.000Z",
            "duration": "3382",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5231778675.mp3?updated=1767987164",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b973d540-ebd9-11f0-9861-7b9808487d93",
            "index": 53,
            "title": "Coreweave: AI Bubble Poster Child Or The Next Tech Giant? — With Michael Intrator and Brian Venturo",
            "pub_date": "2026-01-07T15:12:00.000Z",
            "duration": "3714",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7432032632.mp3?updated=1767844801",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d195d254-e814-11f0-b5f2-7fae1c19381c",
            "index": 54,
            "title": "Meta's AI Agent Plan, Grok's Perversion, Prison Of Financial Mediocrity",
            "pub_date": "2026-01-02T19:57:00.000Z",
            "duration": "2947",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "grok",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3279143297.mp3?updated=1767384184",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36afed3c-97e3-11f0-a839-6be79ac1d589",
            "index": 55,
            "title": "Best of Big Technology: Demis Hassabis On AGI, Deceptive AIs, Building a Virtual Cell",
            "pub_date": "2025-12-31T11:00:00.000Z",
            "duration": "3453",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1856611047.mp3?updated=1766261105",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3692bece-97e3-11f0-a839-f3daf3bdf463",
            "index": 56,
            "title": "Alex And Ranjan's 2026 Outlook: ChatGPT 1 Billion, AI Shopping, Apple's Big Year, AI Love Boom",
            "pub_date": "2025-12-26T17:30:00.000Z",
            "duration": "1455",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2271735616.mp3?updated=1766259661",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36758d04-97e3-11f0-a839-0b3efd445d70",
            "index": 57,
            "title": "2025 In Review, 2026 Predictions — With Reed Albergotti",
            "pub_date": "2025-12-24T11:00:00.000Z",
            "duration": "2603",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "gemini",
              "nvidia",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5049880250.mp3?updated=1766263052",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3657a636-97e3-11f0-a839-b37c2da36d90",
            "index": 58,
            "title": "OpenAI’s Potential, Google’s Speedy Model, Copilot Hits Turbulence",
            "pub_date": "2025-12-20T17:57:00.000Z",
            "duration": "2522",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "gemini",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8134570529.mp3?updated=1766253750",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de7e1854-dc4e-11f0-ac63-53a2fdcbeaf3",
            "index": 59,
            "title": "Sam Altman: How OpenAI Wins, AI Buildout Logic, IPO in 2026?",
            "pub_date": "2025-12-18T20:37:00.000Z",
            "duration": "3592",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7122635892.mp3?updated=1766096384",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36390cb2-97e3-11f0-a839-47bd8b6b0534",
            "index": 60,
            "title": "CNBC's Jim Cramer: Big Tech Hot Takes, NVIDIA $10 Trillion?,  Building Wealth In Any Market",
            "pub_date": "2025-12-17T19:54:00.000Z",
            "duration": "2649",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4584498088.mp3?updated=1766002089",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "361aa542-97e3-11f0-a839-dbdc376076ef",
            "index": 61,
            "title": "OpenAI’s 2026 Priority, Disney’s AI Play, Datacenter Buildout Trouble",
            "pub_date": "2025-12-12T21:16:00.000Z",
            "duration": "3115",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "openai",
              "datacenter"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3364747408.mp3?updated=1765574415",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35fcb87a-97e3-11f0-a839-2b19dfe25a7e",
            "index": 62,
            "title": "AI Is Upending Law. Is That A Sign For The Rest Of Us? — With Melia Russell",
            "pub_date": "2025-12-10T17:17:00.000Z",
            "duration": "3434",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5000833965.mp3?updated=1765387702",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35e05c3e-97e3-11f0-a839-1b5f0677e09b",
            "index": 63,
            "title": "AI Device Wars Heat Up, RIP Metaverse?, Netflix Acquires Warner Brothers",
            "pub_date": "2025-12-08T21:45:00.000Z",
            "duration": "3846",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5376441080.mp3?updated=1765230916",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35c04192-97e3-11f0-a839-e7248987b85e",
            "index": 64,
            "title": "How An AI Model Learned To Be Bad — With Evan Hubinger And Monte MacDiarmid",
            "pub_date": "2025-12-03T18:43:00.000Z",
            "duration": "3896",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "alignment",
              "safety",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8280116174.mp3?updated=1764788372",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c85493c-ceec-11f0-8bb5-7f9d814532e4",
            "index": 65,
            "title": "Tim Cook’s Final Year?, Big Tech Horse Race, Anthropic’s Profitability Push",
            "pub_date": "2025-12-01T21:03:00.000Z",
            "duration": "3773",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4417425590.mp3?updated=1764623695",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35a0fcce-97e3-11f0-a839-4fa981ce480b",
            "index": 66,
            "title": "NVIDIA Panic Mode?, OpenAI’s Funding Hole, Ilya’s Mystery Revenue Plan",
            "pub_date": "2025-11-28T18:17:00.000Z",
            "duration": "3665",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "chatgpt",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8298565680.mp3?updated=1764354203",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3583d7ac-97e3-11f0-a839-775207d3b9aa",
            "index": 67,
            "title": "Communal Living, Sex, And Silicon Valley's Groupthink Problem — With Ellen Huet",
            "pub_date": "2025-11-26T15:22:00.000Z",
            "duration": "3612",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2455616768.mp3?updated=1764171307",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35633420-97e3-11f0-a839-63c5d8b933e4",
            "index": 68,
            "title": "Google Pushes OpenAI, Bezos Returns, AI’s No. 1 Hit",
            "pub_date": "2025-11-21T21:14:00.000Z",
            "duration": "4005",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gemini",
              "grok",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4159128285.mp3?updated=1764021167",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3545630a-97e3-11f0-a839-b300d5568804",
            "index": 69,
            "title": "Can We Trust Silicon Valley With Superintelligence? — With Nick Clegg",
            "pub_date": "2025-11-19T11:00:00.000Z",
            "duration": "3630",
            "duration_label": "1h 0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2017504237.mp3?updated=1763568789",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35277a66-97e3-11f0-a839-0fe3b5f7f07e",
            "index": 70,
            "title": "Inside The AI Bubble: Debt, Depreciation, and Losses — With Gil Luria",
            "pub_date": "2025-11-14T22:27:00.000Z",
            "duration": "3688",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1600898997.mp3?updated=1763159452",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3504ccf0-97e3-11f0-a839-2f3e70c68fa6",
            "index": 71,
            "title": "Could LLMs Be The Route To Superintelligence? — With Mustafa Suleyman",
            "pub_date": "2025-11-12T15:17:00.000Z",
            "duration": "2488",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1625796682.mp3?updated=1762952294",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34e76552-97e3-11f0-a839-9baa19ea204f",
            "index": 72,
            "title": "OpenAI Bailout?, Elon’s $1 Trillion Pay Deal, Amazon Sues Perplexity",
            "pub_date": "2025-11-07T18:40:00.000Z",
            "duration": "3547",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "openai",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5412815353.mp3?updated=1762541078",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34c93370-97e3-11f0-a839-3b08522ecd26",
            "index": 73,
            "title": "OpenAI’s IPO Plan, Deconstructing The AI Bet, Apple’s iPhone17 Revival",
            "pub_date": "2025-11-05T14:31:00.000Z",
            "duration": "3378",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1114702171.mp3?updated=1762353309",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34abc9f2-97e3-11f0-a839-bf588b31d9fd",
            "index": 74,
            "title": "OpenAI and Microsoft’s Grand Bargain, Sam Altman’s Next Three Years, A New Humanoid Robot",
            "pub_date": "2025-10-31T16:57:00.000Z",
            "duration": "3757",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3838780555.mp3?updated=1761930149",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "348e307c-97e3-11f0-a839-233b75e64d38",
            "index": 75,
            "title": "How AI Is Changing Writing — With Tony Stubblebine",
            "pub_date": "2025-10-29T12:06:00.000Z",
            "duration": "3833",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5275352958.mp3?updated=1761739804",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "71f0cb9a-b279-11f0-b659-eba1e681a256",
            "index": 76,
            "title": "Google Research Head Yossi Mathias: AI For Cancer Research, Quantum's Progress, Researchers' Future",
            "pub_date": "2025-10-27T16:30:00.000Z",
            "duration": "1769",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8089555380.mp3?updated=1761567285",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "346d6cb6-97e3-11f0-a839-cfee2624c456",
            "index": 77,
            "title": "OpenAI’s Risky Browser Bet, Amazon’s Mass Automation Plan, Clippy’s Back",
            "pub_date": "2025-10-24T22:29:00.000Z",
            "duration": "4069",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1379498408.mp3?updated=1761344214",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "344d717c-97e3-11f0-a839-cf7064d7b540",
            "index": 78,
            "title": "Amazon's Panos Panay: The Reality of Building Alexa Plus and AI Assistants",
            "pub_date": "2025-10-22T18:25:00.000Z",
            "duration": "2926",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4317510048.mp3?updated=1761158061",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3430117c-97e3-11f0-a839-1fb49bee49cd",
            "index": 79,
            "title": "Erotic ChatGPT, Zuck’s Apple Assault, AI’s Sameness Problem",
            "pub_date": "2025-10-17T15:57:00.000Z",
            "duration": "3445",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP7442298949.mp3?updated=1760718575",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34119a3a-97e3-11f0-a839-fba847f7e5c0",
            "index": 80,
            "title": "Where Are The AI Startups? — With Rick Heitzmann",
            "pub_date": "2025-10-15T10:00:00.000Z",
            "duration": "3568",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1160879134.mp3?updated=1760650319",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33f333b0-97e3-11f0-a839-1b8c0b7c7fd2",
            "index": 81,
            "title": "AGI or Bust, OpenAI’s $1 Trillion Gamble, Apple’s Next CEO?",
            "pub_date": "2025-10-10T15:19:00.000Z",
            "duration": "3612",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5886629266.mp3?updated=1760556480",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33cf24fc-97e3-11f0-a839-3b6d3349599f",
            "index": 82,
            "title": "Anthropic Chief Product Officer: Why AI Model Development Is Accelerating — With Mike Krieger",
            "pub_date": "2025-10-08T17:59:00.000Z",
            "duration": "3074",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4654466897.mp3?updated=1760650071",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33b0ecb2-97e3-11f0-a839-5f01870bdcfd",
            "index": 83,
            "title": "OpenAI and AMD's Megadeal, Sam Altman and Jony Ive’s Bumpy Start. Meta vs. Apple",
            "pub_date": "2025-10-06T18:24:00.000Z",
            "duration": "3455",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2944449833.mp3?updated=1759775541",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d90f23e-a0bb-11f0-aae9-3b675e303c28",
            "index": 84,
            "title": "The Sora 2  Breakthrough, Death Of The Creator Economy?, Apple’s SmartGlasses Roadmap",
            "pub_date": "2025-10-04T00:43:00.000Z",
            "duration": "3468",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2967356670.mp3?updated=1759539130",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3391cbb6-97e3-11f0-a839-63ecfba14261",
            "index": 85,
            "title": "Microsoft's Head of Cloud & AI on the AI Buildout's Risks and ROI — With Scott Guthrie",
            "pub_date": "2025-10-01T21:33:00.000Z",
            "duration": "3241",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "gpu",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6745013678.mp3?updated=1759354781",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3373e77c-97e3-11f0-a839-27721ac24c7d",
            "index": 86,
            "title": "OpenAI’s & NVIDIA's $100 Billion Marriage, Meta’s Sloppy Vibes, TikTok Deal Arrives?",
            "pub_date": "2025-09-26T21:43:00.000Z",
            "duration": "3572",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8840867509.mp3?updated=1758923382",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3333478a-97e3-11f0-a839-d3ab026668a3",
            "index": 87,
            "title": "Is Generative AI a Cybersecurity Disaster Waiting to Happen? — With Yinon Costica",
            "pub_date": "2025-09-24T12:05:00.000Z",
            "duration": "3809",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5386515474.mp3?updated=1758578197",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9e68da46-9569-11f0-8db0-1b0f61d6db17",
            "index": 88,
            "title": "How We Use ChatGPT, Meta’s New AI Glasses, Can Jimmy Kimmel Be Canceled?",
            "pub_date": "2025-09-19T16:30:00.000Z",
            "duration": "3352",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agent",
              "chatgpt",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1296685229.mp3?updated=1758294665",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89773fd4-93b5-11f0-9ae7-e34f6aa0659a",
            "index": 89,
            "title": "Are 95% of Businesses Really Getting No Return on AI Investment? — With Aaron Levie",
            "pub_date": "2025-09-17T11:38:00.000Z",
            "duration": "2813",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6580911203.mp3?updated=1758109571",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7d43663e-9018-11f0-beac-db3f64da5e5f",
            "index": 90,
            "title": "Do We Care About The iPhone Air?, Nepal's Discord Revolution, San Francisco’s 996 Culture",
            "pub_date": "2025-09-12T20:43:00.000Z",
            "duration": "3323",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1511086646.mp3?updated=1757710174",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f306229a-8e37-11f0-bc65-2b96b36388a0",
            "index": 91,
            "title": "Booz Allen CTO: Can AI Fix The Government — With Bill Vass",
            "pub_date": "2025-09-10T11:18:00.000Z",
            "duration": "4092",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8888368962.mp3?updated=1757515373",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bfd04d9c-8a90-11f0-a89b-af354346d0ab",
            "index": 92,
            "title": "Google’s Best Week Ever, AI’s Rising Costs, Putin and Xi’s Immortality Quest",
            "pub_date": "2025-09-05T19:44:00.000Z",
            "duration": "3415",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "anthropic",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8772337248.mp3?updated=1757102004",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9d1cbfe-88e4-11f0-87bd-e7c0b3fc45ec",
            "index": 93,
            "title": "Brain Computer Interface Frontier: Movement, Coma, Depression, AI Merge",
            "pub_date": "2025-09-03T16:40:00.000Z",
            "duration": "4452",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5807944895.mp3?updated=1756994681",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "189707e8-6e50-11f0-ab96-2fbfa669ed1d",
            "index": 94,
            "title": "Did OpenAI Break ChatGPT?, Apple’s New iPhones, Saving Intel",
            "pub_date": "2025-08-29T14:33:00.000Z",
            "duration": "3597",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5072052476.mp3?updated=1756478541",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "187a19bc-6e50-11f0-ab96-1f8b70656d16",
            "index": 95,
            "title": "The Hidden Science Behind Brain-Computer Interfaces — With Sally Adee",
            "pub_date": "2025-08-27T13:20:00.000Z",
            "duration": "3223",
            "duration_label": "53m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3517507556.mp3?updated=1756304391",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "185bed20-6e50-11f0-ab96-ab21ce0874f3",
            "index": 96,
            "title": "The Big GPT-5 Debate, Sam Altman’s AI Bubble, OnlyFans Chatbots",
            "pub_date": "2025-08-22T20:33:00.000Z",
            "duration": "3261",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8699872899.mp3?updated=1755895615",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9acdefae-7df2-11f0-9107-3b0b3ae9fa0a",
            "index": 97,
            "title": "Inside Google's Generative AI Reinvention — With Nick Fox and Liz Reid",
            "pub_date": "2025-08-20T18:21:00.000Z",
            "duration": "3960",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4466501865.mp3?updated=1755715151",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98cb201e-785c-11f0-a863-27c4dcb18955",
            "index": 98,
            "title": "Can The Web Survive Generative AI? — With Matthew Prince",
            "pub_date": "2025-08-15T16:30:00.000Z",
            "duration": "3314",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4664635918.mp3?updated=1755361926",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a34c62ba-6a78-11f0-8f0d-03c23bea6c32",
            "index": 99,
            "title": "Is The AI Going To Escape? — With Anthony Aguirre",
            "pub_date": "2025-08-13T13:07:00.000Z",
            "duration": "3550",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1108970668.mp3?updated=1755362152",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17fce4e2-6e50-11f0-ab96-6f052107f1d1",
            "index": 100,
            "title": "Does GPT-5 Live Up To the Hype?, AGI Wait Continues, Self-Loathing Gemini",
            "pub_date": "2025-08-08T19:00:00.000Z",
            "duration": "3265",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "gemini",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9626329007.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "081c8906-73f0-11f0-a683-7b36a3f62319",
            "index": 101,
            "title": "OpenAI COO Brad Lightcap: GPT-5's Capabilities, Why It Matters, and Where AI Goes Next",
            "pub_date": "2025-08-08T00:36:00.000Z",
            "duration": "1868",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP5496440504.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "94d271b2-72c4-11f0-b953-c3a891b060b9",
            "index": 102,
            "title": "Vibe Coding: Everything You Need To Know — With Amjad Masad",
            "pub_date": "2025-08-06T12:55:00.000Z",
            "duration": "4021",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "replit",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6519810477.mp3?updated=1754496089",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa50865c-6d95-11f0-bd54-b74024988a2e",
            "index": 103,
            "title": "Mark Zuckerberg’s Personal Superintelligence, Layoffs and Payoffs, Writing With AI — With M.G. Siegler",
            "pub_date": "2025-08-04T16:30:00.000Z",
            "duration": "3548",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP2788458925.mp3?updated=1753922773",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "84d6100a-6e1b-11f0-8be4-df5adf4a8a9f",
            "index": 104,
            "title": "Anthropic’s Potential, AI Video Gets Crazy, Market Bubble Approaching?",
            "pub_date": "2025-08-01T18:00:00.000Z",
            "duration": "3110",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3840391367.mp3?updated=1753972793",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad2da7a2-6d35-11f0-86ed-4bf2bf673a98",
            "index": 105,
            "title": "Anthropic CEO Dario Amodei: AI's Potential, OpenAI Rivalry, GenAI Business, Doomerism",
            "pub_date": "2025-07-30T11:09:00.000Z",
            "duration": "4219",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8551013654.mp3?updated=1753883119",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b7dd6e88-6995-11f0-a6e9-f743c8bed062",
            "index": 106,
            "title": "Countdown to GPT-5, OpenAI’s Stargate Sputters, AI Math Wars",
            "pub_date": "2025-07-25T20:34:00.000Z",
            "duration": "3891",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "anthropic",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1304111021.mp3?updated=1753476663",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b90168bc-6771-11f0-813b-d77fcb979c91",
            "index": 107,
            "title": "Are AI's Economics Unsustainable? — With Ed Zitron",
            "pub_date": "2025-07-23T10:00:00.000Z",
            "duration": "5731",
            "duration_label": "1h 35m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "nvidia",
              "gpu"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4965393099.mp3?updated=1753284976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "82c56394-63dd-11f0-a37e-5f316d7cd208",
            "index": 108,
            "title": "Grok's AI Lovebot, Aqui-Hire-Sition Backlash, OpenAI's ChatGPT Agent Debuts",
            "pub_date": "2025-07-18T16:30:00.000Z",
            "duration": "3360",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 20,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "openai",
              "grok",
              "perplexity",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP9717385272.mp3?updated=1753116814",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dd1f0ef4-61fc-11f0-aadb-872d12843b37",
            "index": 109,
            "title": "Condoleezza Rice: U.S. Tech at Risk Amid University Cuts, China Threat",
            "pub_date": "2025-07-16T10:00:00.000Z",
            "duration": "2771",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6806178672.mp3?updated=1757079593",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8e773930-60f2-11f0-ae60-fbda831f0596",
            "index": 110,
            "title": "Big Technology @ Five Years",
            "pub_date": "2025-07-14T20:38:00.000Z",
            "duration": "586",
            "duration_label": "9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP3402018707.mp3?updated=1752526169",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1fd7e9b8-5eb6-11f0-a601-d72d99a248a8",
            "index": 111,
            "title": "OpenAI’s Windsurf Crash, Grok’s Wild Week, Replace Tim Cook? — With Aaron Levie",
            "pub_date": "2025-07-12T00:20:00.000Z",
            "duration": "2912",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "grok",
              "nvidia",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP1755261156.mp3?updated=1752280218",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d9557d74-5cbd-11f0-88c9-d377314e1745",
            "index": 112,
            "title": "Trade War Scorecard: What's Changing, Who's Winning, What's Next — With Ryan Petersen",
            "pub_date": "2025-07-09T12:21:00.000Z",
            "duration": "4111",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP6777391418.mp3?updated=1757079819",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9e8c07f8-5b50-11f0-bdc4-b3f2ac0021a5",
            "index": 113,
            "title": "Apple’s Anthropic Flirtation, Can Meta Build Superintelligence?, AI Browser Wars — With M.G. Siegler",
            "pub_date": "2025-07-07T16:36:00.000Z",
            "duration": "3535",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP4265854187.mp3?updated=1751906527",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "80d626c0-5877-11f0-89bc-cbff2bf845cc",
            "index": 114,
            "title": "$100 Million AI Engineers, Vending Machine Claude, Legend Of Soham",
            "pub_date": "2025-07-04T16:30:00.000Z",
            "duration": "3567",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/AMPP8026056134.mp3?updated=1757080099",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "01709eb4-55ee-11f0-9273-2b928f29a6df",
            "index": 115,
            "title": "Is AI Really Taking Our Jobs? — With Noah Smith",
            "pub_date": "2025-07-02T10:00:00.000Z",
            "duration": "3373",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1218279248.mp3?updated=1751314970",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac1e440e-5307-11f0-a0c9-6b85acf87e2f",
            "index": 116,
            "title": "The Web’s ‘Existential’ AI Threat, OpenAI’s Microsoft Office Competitor, Tesla Robotaxi Launch",
            "pub_date": "2025-06-27T16:30:00.000Z",
            "duration": "4005",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6329974918.mp3?updated=1750996125",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "28ce82ea-5144-11f0-94ad-37884257fa82",
            "index": 117,
            "title": "Is AI Actually Saving The Stock Market? — With Tom Lee",
            "pub_date": "2025-06-25T10:00:00.000Z",
            "duration": "3752",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2980613052.mp3?updated=1750873807",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "592548b8-4e0e-11f0-a8ba-e7863dc7fcf3",
            "index": 118,
            "title": "OpenAI and Microsoft Tension Boils, Amazon’s Job Automation, Zuck’s Spending Spree",
            "pub_date": "2025-06-20T19:39:00.000Z",
            "duration": "2867",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5068884550.mp3?updated=1750449916",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d8c5fe0-4c4b-11f0-bcf5-670f174447b2",
            "index": 119,
            "title": "Dwarkesh Patel: AI Continuous Improvement, Intelligence Explosion, Memory, Frontier Lab Competition",
            "pub_date": "2025-06-18T13:39:00.000Z",
            "duration": "4320",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3750838817.mp3?updated=1750256079",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca398eb6-48a4-11f0-ab46-3b5fe137faa4",
            "index": 120,
            "title": "Sam Altman’s Gentle Singularity, Zuck’s AI Power Play, Burning Of The Waymos",
            "pub_date": "2025-06-13T22:21:00.000Z",
            "duration": "3621",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8790063925.mp3?updated=1749857002",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02278474-4687-11f0-b566-43edf8717dab",
            "index": 121,
            "title": "What Apple's Failures Say About AI's Limitations —  With M.G. Siegler",
            "pub_date": "2025-06-11T13:29:00.000Z",
            "duration": "3374",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8941921567.mp3?updated=1749679916",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d939d630-4581-11f0-9a2c-ab00dd7f6114",
            "index": 122,
            "title": "WWDC Dispatch: Apple Refines in a Reinvention Era",
            "pub_date": "2025-06-09T22:34:00.000Z",
            "duration": "824",
            "duration_label": "13m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5902173521.mp3?updated=1749620198",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "452520a6-4317-11f0-b822-53773c448eca",
            "index": 123,
            "title": "Apple’s AI 'Gap Year' at WWDC?, Elon Vs. Trump Goes Nuclear, NYTimes’ OpenAI Attack",
            "pub_date": "2025-06-06T20:46:00.000Z",
            "duration": "3663",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8887632855.mp3?updated=1749268890",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "69c411b6-40eb-11f0-bd06-07fd3729c1a7",
            "index": 124,
            "title": "Anthony Scaramucci: Elon Musk’s Trump Exit, Tim Cook’s Tariff Problem",
            "pub_date": "2025-06-04T10:00:00.000Z",
            "duration": "3876",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2283120529.mp3?updated=1757079758",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0cf3e8b6-3d9a-11f0-8440-8b353fbf8bd2",
            "index": 125,
            "title": "Mass AI-Driven Unemployment, NVIDIA Surges, CEOs' AI Avatars Unleashed",
            "pub_date": "2025-05-30T21:06:00.000Z",
            "duration": "3083",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2366326820.mp3?updated=1748639877",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66dbd662-3b5c-11f0-96fa-e3b0a1fa05d2",
            "index": 126,
            "title": "She Wants AI To Help You Thrive, Not Just Keep You Company — Y-Lan Boureau",
            "pub_date": "2025-05-28T10:00:00.000Z",
            "duration": "3875",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "meta ai",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4553293013.mp3?updated=1748400891",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1003697a-3834-11f0-bec5-df1c94cdf7a6",
            "index": 127,
            "title": "OpenAI's Jony Ive Moment, Anthropic's Big New Model, Google Enters 'AI Mode'",
            "pub_date": "2025-05-24T00:14:00.000Z",
            "duration": "3088",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4941235020.mp3?updated=1748046271",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad01178a-3600-11f0-ac1a-bbe8ab45c899",
            "index": 128,
            "title": "Google DeepMind CEO Demis Hassabis + Google Co-Founder Sergey Brin: Scaling AI, AGI Timeline, Simulation Theory",
            "pub_date": "2025-05-21T10:00:00.000Z",
            "duration": "1877",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2581995852.mp3?updated=1747803999",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fcd20854-3593-11f0-84c2-efb859a18b70",
            "index": 129,
            "title": "Google DeepMind CTO: Advancing AI Frontier, New Reasoning Methods, Video Generation’s Potential",
            "pub_date": "2025-05-20T17:46:00.000Z",
            "duration": "1821",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "inference",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7254370877.mp3?updated=1747763939",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1c4b7be0-329f-11f0-b5ff-7b2721442199",
            "index": 130,
            "title": "Is ChatGPT The Last Website?, Grok’s System Prompt, Meta’s llama Fiasco",
            "pub_date": "2025-05-16T21:45:00.000Z",
            "duration": "3257",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "llama",
              "grok",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7083952334.mp3?updated=1747432464",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9163e62c-30b2-11f0-ae69-3b60d92152f8",
            "index": 131,
            "title": "AI’s Drawbacks: Environmental Damage, Bad Benchmarks, Outsourcing Thinking — With Emily M. Bender and Alex Hanna",
            "pub_date": "2025-05-14T10:59:00.000Z",
            "duration": "3745",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4989787546.mp3?updated=1747220695",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "15fcac76-2d29-11f0-ae50-2f33db30f1b5",
            "index": 132,
            "title": "OpenAI’s New Structure, Apple Replacing Google With AI?, Cheating With ChatGPT",
            "pub_date": "2025-05-09T22:58:00.000Z",
            "duration": "3270",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6684082082.mp3?updated=1746832883",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "720f1516-2b27-11f0-9f02-d793455f1209",
            "index": 133,
            "title": "Is AI Scaling Dead? — With Gary Marcus",
            "pub_date": "2025-05-07T10:30:00.000Z",
            "duration": "3292",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4132751503.mp3?updated=1746611209",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52e96dca-26e1-11f0-a371-f76a77bd9f00",
            "index": 134,
            "title": "The ‘AI-First Company,’ Big Tech Mega Earnings, NVIDIA vs. Anthropic",
            "pub_date": "2025-05-02T16:30:00.000Z",
            "duration": "3900",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5639185189.mp3?updated=1746208494",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2fe1884a-25d2-11f0-af99-77196365cfbe",
            "index": 135,
            "title": "Amazon's Head Of Prime on Tariffs, Alexa Plus Rollout, and AI Differentiation — With Jamil Ghani",
            "pub_date": "2025-04-30T14:40:00.000Z",
            "duration": "3320",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5268643238.mp3?updated=1746026645",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a7fb5df6-21fe-11f0-9f87-ef2ccb29ad91",
            "index": 136,
            "title": "Is Anthropic’s Claude AI Conscious?, Shopping in ChatGPT, Systrom vs. Zuck",
            "pub_date": "2025-04-25T17:56:00.000Z",
            "duration": "3996",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6273929247.mp3?updated=1745604551",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "55612de8-2053-11f0-abe6-1330fa049533",
            "index": 137,
            "title": "Generative AI 101: Tokens, Pre-training, Fine-tuning, Reasoning — With Dylan Patel",
            "pub_date": "2025-04-23T14:57:00.000Z",
            "duration": "2499",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9563190229.mp3?updated=1745421190",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f38f7ac-1ca4-11f0-8c7a-03bbaa6d0018",
            "index": 138,
            "title": "Is OpenAI’s o3 Model AGI?, Is AI The New Social Media?,  Zuck’s Revealing Testimony",
            "pub_date": "2025-04-18T22:28:00.000Z",
            "duration": "3259",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8015489526.mp3?updated=1756994683",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e42c6558-1a66-11f0-8c17-a71dec565285",
            "index": 139,
            "title": "Why China's AI Strategy Just Might Work — With Grace Shao",
            "pub_date": "2025-04-16T10:00:00.000Z",
            "duration": "3885",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "chip",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3423231861.mp3?updated=1744771525",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd92b9a0-171f-11f0-90eb-c76a26e59197",
            "index": 140,
            "title": "A Week of Trade War Chaos & What's Next For Tech",
            "pub_date": "2025-04-11T21:55:00.000Z",
            "duration": "3470",
            "duration_label": "57m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2191105051.mp3?updated=1756994606",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "58175df4-14f1-11f0-b6a6-dbab5c7032fd",
            "index": 141,
            "title": "Google Cloud CEO Thomas Kurian on AI Competition, Agents, And Tariffs",
            "pub_date": "2025-04-09T12:00:00.000Z",
            "duration": "3442",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1233846635.mp3?updated=1744204975",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dedc8202-13e2-11f0-8bdf-f76b43c8327f",
            "index": 142,
            "title": "Special Report: Tariffs and Turmoil — With Ryan Petersen and Adam Parker",
            "pub_date": "2025-04-07T19:02:00.000Z",
            "duration": "4231",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9950898159.mp3?updated=1744054102",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1ab4760-1162-11f0-9322-c7e7beaf8e76",
            "index": 143,
            "title": "Microsoft AI CEO Mustafa Suleyman: Building AI Personality, OpenAI Relationship, Data Center Demand, AGI Timeline",
            "pub_date": "2025-04-04T16:30:00.000Z",
            "duration": "3329",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "deepmind",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2926619686.mp3?updated=1743782969",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4eca3e08-0fc7-11f0-b656-7f944a6acf0d",
            "index": 144,
            "title": "OpenAI Raises $40 billion, Is AI a Letdown?, Musk Sells X to xAI",
            "pub_date": "2025-04-02T13:35:00.000Z",
            "duration": "3752",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4396094562.mp3?updated=1743601892",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed41a976-0c17-11f0-a290-db477786e935",
            "index": 145,
            "title": "OpenAI’s Ghibli Moment, CoreWeave's IPO Letdown, End of Silicon Valley’s Monopoly?",
            "pub_date": "2025-03-28T21:02:00.000Z",
            "duration": "3568",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9921674102.mp3?updated=1743196600",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "848b91fc-09f7-11f0-879d-eb86d48bb1a0",
            "index": 146,
            "title": "AI's Rising Risks: Hacking, Virology, Loss of Control — With Dan Hendrycks",
            "pub_date": "2025-03-26T14:37:00.000Z",
            "duration": "4465",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3085827432.mp3?updated=1743032996",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "417468ce-06a7-11f0-818e-9fbcb9c15fea",
            "index": 147,
            "title": "NVIDIA’s New Roadmap, State of OpenAI, Apple Shuffles Siri Team",
            "pub_date": "2025-03-21T22:53:00.000Z",
            "duration": "3571",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "gpu",
              "chip",
              "chips",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8362319324.mp3?updated=1742598108",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "16f30d92-0479-11f0-965d-eb5fbd0e4e7b",
            "index": 148,
            "title": "Why Can't AI Make Its Own Discoveries? — With Yann LeCun",
            "pub_date": "2025-03-19T10:00:00.000Z",
            "duration": "3712",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4210578187.mp3?updated=1742439145",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "767c221c-00f0-11f0-a462-83fb849aba6c",
            "index": 149,
            "title": "Gruber Slams Apple, Tech Stocks In Freefall, Vibecoding & OpenAI's Agents",
            "pub_date": "2025-03-14T16:21:54.000Z",
            "duration": "3680",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "openai",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6604300430.mp3?updated=1741970176",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4843e472-fee1-11ef-9f8c-cb4a12cd4a0c",
            "index": 150,
            "title": "Roblox CEO: We Want AI To Generate Full Games — With David Baszucki",
            "pub_date": "2025-03-12T10:00:00.000Z",
            "duration": "3077",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5431977228.mp3?updated=1741790118",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4cec8d78-fbab-11ef-ae3c-13f91ed2e5c2",
            "index": 151,
            "title": "Apple’s Siri Embarrassment, Microsoft’s OpenAI Dilemma, Will AI Take Our Jobs?",
            "pub_date": "2025-03-07T23:23:58.000Z",
            "duration": "3591",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6064554173.mp3?updated=1741391207",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4920d358-f97a-11ef-af89-7bdfb967c86c",
            "index": 152,
            "title": "How Amazon Rebuilt Alexa From The Ground Up — With Panos Panay and Daniel Rausch",
            "pub_date": "2025-03-05T11:00:00.000Z",
            "duration": "3372",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1554458004.mp3?updated=1741195065",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c03a40b8-f624-11ef-b675-1f1c8737e4e6",
            "index": 153,
            "title": "OpenAI’s New Model, Jensen’s Bold Claim, Alexa+ Is Here",
            "pub_date": "2025-02-28T22:38:30.000Z",
            "duration": "3559",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "nvidia",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6319472252.mp3?updated=1740782846",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ec316a68-f541-11ef-8efc-97536d5cf9e1",
            "index": 154,
            "title": "OpenAI Chief Research Officer Mark Chen: GPT 4.5 is Live and Scaling Isn’t Dead",
            "pub_date": "2025-02-27T20:00:00.000Z",
            "duration": "1525",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "openai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7955467223.mp3?updated=1740685988",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7954b30e-f3fe-11ef-9d60-5fb1d8276bfd",
            "index": 155,
            "title": "The Formula for Capturing Your Attention, Price of Fame, & Algorithms as Editors — With Chris Hayes",
            "pub_date": "2025-02-26T11:00:00.000Z",
            "duration": "3621",
            "duration_label": "1h 0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9060303185.mp3?updated=1740546889",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "898dc6de-effd-11ef-8eae-9b65685634b0",
            "index": 156,
            "title": "Too Many AI Companies, Amazon's Alexa Upgrade Awaits, RIP Humane Pin",
            "pub_date": "2025-02-21T18:00:00.000Z",
            "duration": "3576",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8054170306.mp3?updated=1740106369",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4510b58c-ee65-11ef-8c8c-2ba62df4614a",
            "index": 157,
            "title": "Will Big Tech CEOs Win Their All-In Bet on Trump? — With Saagar Enjeti",
            "pub_date": "2025-02-19T11:00:00.000Z",
            "duration": "3458",
            "duration_label": "57m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8404140443.mp3?updated=1739931510",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fdb3679c-eb13-11ef-b5f6-438f3541bc79",
            "index": 158,
            "title": "Musk’s OpenAI Bid, Sam Altman’s Roadmap, Apple + Alibaba",
            "pub_date": "2025-02-14T20:40:13.000Z",
            "duration": "3077",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "llm",
              "openai",
              "anthropic",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1232543520.mp3?updated=1739566259",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef0afdec-e8ff-11ef-849c-1f1adfff0b57",
            "index": 159,
            "title": "AI Clones & The Future of Voice AI — With Evan Ratliff",
            "pub_date": "2025-02-12T11:00:00.000Z",
            "duration": "2800",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2358944172.mp3?updated=1739364523",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "05d90bbe-e562-11ef-bd6a-e341fc7adc99",
            "index": 160,
            "title": "Boom Times For ChatGPT, OpenAI’s Deep Research, AI Super Bowl",
            "pub_date": "2025-02-07T15:01:53.000Z",
            "duration": "3835",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "gemini",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2514875249.mp3?updated=1738941164",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5167012-e376-11ef-b761-db449e5b8390",
            "index": 161,
            "title": "NVIDIA's Plan To Build AI That Understands The Real World — With Rev Lebaredian",
            "pub_date": "2025-02-05T11:00:00.000Z",
            "duration": "3765",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7200551629.mp3?updated=1738731632",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a1a4b40-dff6-11ef-aa9b-6320bda19b5b",
            "index": 162,
            "title": "DeepSeek's Fallout For AI Companies, OpenAI’s Path Forward, Siri Somehow Got Worse",
            "pub_date": "2025-01-31T17:50:48.000Z",
            "duration": "3489",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5710097993.mp3?updated=1738346531",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b5ecefac-ddf6-11ef-801d-e38c82e59986",
            "index": 163,
            "title": "Reid Hoffman: Why The AI Investment Will Pay Off",
            "pub_date": "2025-01-29T11:00:00.000Z",
            "duration": "3334",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6406420111.mp3?updated=1738124620",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b474af6-dcc6-11ef-a201-bf8b1e2a72d5",
            "index": 164,
            "title": "Bonus: The DeepSeek Reckoning in Silicon Valley",
            "pub_date": "2025-01-27T15:46:18.000Z",
            "duration": "2772",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6409107367.mp3?updated=1737993339",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e329bce2-da8c-11ef-b482-6b41fa365d88",
            "index": 165,
            "title": "DeepSeek Rises, Stargate Drama, OpenAI’s Operator Debuts",
            "pub_date": "2025-01-24T20:00:04.000Z",
            "duration": "3423",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9210670509.mp3?updated=1737749419",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b10a5300-d854-11ef-a5e9-2b6b35ef5b40",
            "index": 166,
            "title": "Google DeepMind CEO Demis Hassabis: The Path To AGI, Deceptive AIs, Building a Virtual Cell",
            "pub_date": "2025-01-22T11:00:00.000Z",
            "duration": "3393",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5226883006.mp3?updated=1737516653",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db67209e-d500-11ef-84df-efd542009b63",
            "index": 167,
            "title": "TikTok On The Brink, ChatGPT Does Your Tasks, Unemployed MBAs",
            "pub_date": "2025-01-17T18:17:41.000Z",
            "duration": "3283",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8955992788.mp3?updated=1737139015",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "62b7f034-d28e-11ef-9aa4-6bbde611952b",
            "index": 168,
            "title": "To Love An AI Bot — With Eugenia Kuyda",
            "pub_date": "2025-01-15T11:00:00.000Z",
            "duration": "3235",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3139881779.mp3?updated=1736895059",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1b1b9f92-cfb3-11ef-a9b5-5f3968bee44c",
            "index": 169,
            "title": "Sam Altman’s Reflections, NVIDIA’s Robotics Play, Zuckerberg’s Moderation",
            "pub_date": "2025-01-11T00:33:17.000Z",
            "duration": "3633",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "anthropic",
              "nvidia",
              "training",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2638210145.mp3?updated=1736556029",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad13ea44-be56-11ef-84da-63466a77c006",
            "index": 170,
            "title": "Why The Costco Guys And Hawk Tuah Took Over The Internet — With Ryan Broderick",
            "pub_date": "2025-01-08T11:00:00.000Z",
            "duration": "3485",
            "duration_label": "58m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9264971397.mp3?updated=1736449546",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "339c039a-ca5e-11ef-9c5b-231ae862b7f4",
            "index": 171,
            "title": "AI’s Crucible Year, TikTok’s Lifeline, Manifesting Your Best Self",
            "pub_date": "2025-01-04T05:38:16.000Z",
            "duration": "2807",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2734285586.mp3?updated=1735969592",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2711b9e-be5f-11ef-a311-3f56df203d7b",
            "index": 172,
            "title": "2024 In Review, 2025 Predictions — With Casey Newton",
            "pub_date": "2025-01-01T11:00:00.000Z",
            "duration": "3052",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5648707122.mp3?updated=1734650901",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c560246-bb5e-11ef-a423-438f61f177ce",
            "index": 173,
            "title": "Best of Big Technology: Airbnb CEO Brian Chesky",
            "pub_date": "2024-12-27T11:00:00.000Z",
            "duration": "3737",
            "duration_label": "1h 2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2963206403.mp3?updated=1734321283",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "43a4ee12-be53-11ef-a83c-4b0595721e7e",
            "index": 174,
            "title": "What's the Right Amount of Tech to Give to Kids? — With Dr. Rona Novick and JinJa Birkenbeuel",
            "pub_date": "2024-12-25T11:00:00.000Z",
            "duration": "3516",
            "duration_label": "58m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2572261316.mp3?updated=1735163776",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "554b352a-bf27-11ef-9553-4bb4e1b9083d",
            "index": 175,
            "title": "1-800-Chat-GPT, Neuralink’s Potential, Meta's Live AI",
            "pub_date": "2024-12-20T23:07:57.000Z",
            "duration": "3225",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "openai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2359549625.mp3?updated=1734736637",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d73bf9bc-bb5c-11ef-b42f-e765284efd46",
            "index": 176,
            "title": "Neuralink's First Patient Controls Computers With His Mind — With Noland Arbaugh",
            "pub_date": "2024-12-18T11:00:00.000Z",
            "duration": "4170",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7532282335.mp3?updated=1756995032",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a62d78ec-b994-11ef-8883-c79dfa5366c8",
            "index": 177,
            "title": "What is OpenAI's Sora For?, Big Tech’s Trump Strategy, GM Kills Cruise",
            "pub_date": "2024-12-13T20:51:18.000Z",
            "duration": "3094",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gemini",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5745485584.mp3?updated=1734128870",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bb6d2b9a-b77c-11ef-a7fd-a30f173c5cbc",
            "index": 178,
            "title": "AI Predictions for 2025: Geopolitics, Agents, and Data Scaling — With Alexandr Wang",
            "pub_date": "2024-12-11T11:00:00.000Z",
            "duration": "3477",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "gpu"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3683206544.mp3?updated=1733893710",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da2ec9e0-b41a-11ef-beb3-7f3f65087794",
            "index": 179,
            "title": "Amazon’s New AI Model, Bitcoin $100,000, TikTok 'Ban' Upheld",
            "pub_date": "2024-12-06T23:46:38.000Z",
            "duration": "3458",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7813242016.mp3?updated=1733530307",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "afb61a66-b202-11ef-a11c-cbf69c6e53eb",
            "index": 180,
            "title": "AWS CEO Matt Garman on Amazon's Big AI Chips Bet, Working With OpenAI, and Nuclear Energy",
            "pub_date": "2024-12-04T11:00:00.000Z",
            "duration": "2560",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6316236370.mp3?updated=1733292338",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad9bd55a-aff9-11ef-8396-f308db2d31b8",
            "index": 181,
            "title": "Musk vs. OpenAI, Artists Leak Sora, Temu Black Friday",
            "pub_date": "2024-12-01T15:35:30.000Z",
            "duration": "3706",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agent",
              "openai",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3990314092.mp3?updated=1733069676",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b6d6c50e-ac47-11ef-9209-83de7ef1e83b",
            "index": 182,
            "title": "Salesforce CEO Marc Benioff Has Thoughts on AI Agents, Automation, and The Future of Your Job",
            "pub_date": "2024-11-27T11:00:00.000Z",
            "duration": "2957",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9182282320.mp3?updated=1732661505",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f712c52c-a90f-11ef-8b08-93f2e0409927",
            "index": 183,
            "title": "OpenAI Builds A Browser, Microsoft Copilot’s Struggles, Jaguar Rebrand",
            "pub_date": "2024-11-22T19:50:32.000Z",
            "duration": "3710",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "chatgpt",
              "openai",
              "anthropic",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8269378007.mp3?updated=1732307725",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "45eeef9e-a6e6-11ef-939f-b7f3979a5e6c",
            "index": 184,
            "title": "Rivian's CEO on Elon's Influence, Affordable EVs, and The Grid's Risky Future — With RJ Scaringe",
            "pub_date": "2024-11-20T11:00:00.000Z",
            "duration": "3262",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4564167425.mp3?updated=1732070000",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "60d90fe2-a39e-11ef-bde8-47c99b95c0ce",
            "index": 185,
            "title": "Is Generative AI Plateauing?, Booming Bluesky, Apple’s Smart Glasses Play",
            "pub_date": "2024-11-15T22:04:00.000Z",
            "duration": "3448",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "training",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9020693251.mp3?updated=1731709482",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac2ca05c-a16f-11ef-801f-d735237d2136",
            "index": 186,
            "title": "Spotify's Plan For AI Generated Music, Podcasts, and Recommendations — With Gustav Söderström",
            "pub_date": "2024-11-13T11:00:00.000Z",
            "duration": "3454",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8148715879.mp3?updated=1731548345",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba5c9112-9e24-11ef-8469-178c1d6ac545",
            "index": 187,
            "title": "Polymarket vs. Pollsters, Podcasts & Politics, Open Source AI In Trouble",
            "pub_date": "2024-11-08T22:31:59.000Z",
            "duration": "2961",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7804419622.mp3?updated=1731107222",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "760b885a-9c6d-11ef-adac-ab34606065e4",
            "index": 188,
            "title": "Trump Wins. What's Next for Tech and The Economy? — With Dan Primack and Ana Swanson",
            "pub_date": "2024-11-06T18:29:51.000Z",
            "duration": "3006",
            "duration_label": "50m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8480970361.mp3?updated=1730919092",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46bcc00a-9afb-11ef-b445-2f8a25fb3e9e",
            "index": 189,
            "title": "Trump, Tariffs, Trade War, And Technology — With Alan Deardorff",
            "pub_date": "2024-11-04T22:22:40.000Z",
            "duration": "2731",
            "duration_label": "45m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1351367503.mp3?updated=1730760459",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2bdcff4-988b-11ef-ac29-cb6f810f076b",
            "index": 190,
            "title": "OpenAI's GPT-5 In 2025?, Big Tech’s Big AI Spend, The Polymarket Election",
            "pub_date": "2024-11-01T19:58:30.000Z",
            "duration": "3489",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "llama",
              "nvidia",
              "gpu",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7556624308.mp3?updated=1730491628",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f8928a0-9560-11ef-9c63-7bce20b74df4",
            "index": 191,
            "title": "The Next Gen AI Models: Reliable, Consistent, Trustworthy — With Aidan Gomez",
            "pub_date": "2024-10-30T10:00:00.000Z",
            "duration": "2687",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "training",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3804347149.mp3?updated=1730143466",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34aa4040-9312-11ef-8cf8-5be70dbaeba8",
            "index": 192,
            "title": "AI Agents’ Shaky Debut, Musk and Putin, Perplexity vs. The Media",
            "pub_date": "2024-10-25T20:42:00.000Z",
            "duration": "3645",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4214071275.mp3?updated=1729979381",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "12b7593a-90cb-11ef-b94d-27afec186f93",
            "index": 193,
            "title": "The Apple Paradox, Trump’s Impact on Markets, NVIDIA Demand — With Dan Ives and Stephanie Link",
            "pub_date": "2024-10-23T10:00:00.000Z",
            "duration": "2769",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2407924576.mp3?updated=1729639518",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d3b540e-8d83-11ef-9933-4ba6963932d5",
            "index": 194,
            "title": "OpenAI and Microsoft's Tension, Apple Screens Everywhere, Meta’s Toothpaste Massacre",
            "pub_date": "2024-10-18T19:00:00.000Z",
            "duration": "3605",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5712966846.mp3?updated=1729281841",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6dd01fc6-8b3c-11ef-9c88-df4c3fca734f",
            "index": 195,
            "title": "Fear Buying AI & Automation Stocks, Whoops Too Many Winners, Booming Tech Trade — With Josh Brown",
            "pub_date": "2024-10-16T10:00:00.000Z",
            "duration": "4324",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2495256001.mp3?updated=1729028919",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "802b5eaa-8809-11ef-83c8-cf9473ad8157",
            "index": 196,
            "title": "OpenAI's Financials Revealed, Tesla Robotaxi Debut, Shein's Weird CEO",
            "pub_date": "2024-10-11T19:39:08.000Z",
            "duration": "3507",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "chatgpt",
              "openai",
              "inference",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3848435919.mp3?updated=1728676541",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1fda370a-8576-11ef-8808-a7f44cf878e4",
            "index": 197,
            "title": "Google's Head Of Search On Its Big AI Bet — With Liz Reid",
            "pub_date": "2024-10-09T10:00:00.000Z",
            "duration": "2141",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9710505016.mp3?updated=1728394940",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e7832ad8-8273-11ef-a46a-2f966600a432",
            "index": 198,
            "title": "OpenAI’s $6.6 Billion Fundraise, Meta’s Quiet Election, Imaginary AI Friends",
            "pub_date": "2024-10-04T17:05:45.000Z",
            "duration": "2919",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7686621338.mp3?updated=1728069694",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d525a6b4-800b-11ef-a86e-7332f5be9008",
            "index": 199,
            "title": "Meta's CTO On Its Augmented Reality Dreams — With Andrew Bosworth",
            "pub_date": "2024-10-02T10:00:00.000Z",
            "duration": "2674",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7804726229.mp3?updated=1727816141",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6ecb77e8-7d06-11ef-89cb-e358f7252a42",
            "index": 200,
            "title": "OpenAI’s Crazy Week, Meta’s New Orion AR Glasses, MKBHD’s Wallpaper App",
            "pub_date": "2024-09-27T19:25:23.000Z",
            "duration": "3250",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4329383745.mp3?updated=1727465930",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0e757e8-7ad8-11ef-8656-7fca551e0db5",
            "index": 201,
            "title": "Debate: Has Elon’s Twitter Takeover Worked? — With Ryan Mac, Kate Conger, Zach Coelius",
            "pub_date": "2024-09-25T10:00:00.000Z",
            "duration": "3487",
            "duration_label": "58m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1142245457.mp3?updated=1727243780",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ff187aa-7776-11ef-9ad7-9bfe2206b09b",
            "index": 202,
            "title": "Subprime AI Crisis, Mr. Beast’s Guide For Excellence, Amazon’s Culture Problems",
            "pub_date": "2024-09-20T17:26:19.000Z",
            "duration": "3386",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3115935173.mp3?updated=1726918770",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c25d43d0-7538-11ef-a9c1-db111342cea3",
            "index": 203,
            "title": "LinkedIn's CEO On How AI Changes Your Job — With Ryan Roslansky",
            "pub_date": "2024-09-18T10:00:00.000Z",
            "duration": "2452",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2800514343.mp3?updated=1726659977",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be2b6efe-7209-11ef-88be-57db027e1c5d",
            "index": 204,
            "title": "OpenAI’s o1 Reasoning Model Debuts, $2,000 ChatGPT, AI News Anchors",
            "pub_date": "2024-09-13T19:16:24.000Z",
            "duration": "3365",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "openai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5629799878.mp3?updated=1726258659",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3ceea50a-7046-11ef-9485-53214f569ccf",
            "index": 205,
            "title": "Apple's iPhone16 Debut + Apple Intelligence Delays",
            "pub_date": "2024-09-11T13:55:13.000Z",
            "duration": "2585",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5831779536.mp3?updated=1726064141",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19df3e30-6c68-11ef-a62d-fb8714c764b7",
            "index": 206,
            "title": "YouTubers on Russia’s Payroll, Ilya Raises $1 Billion, Founder Mode",
            "pub_date": "2024-09-06T15:48:41.000Z",
            "duration": "3358",
            "duration_label": "55m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5638582968.mp3?updated=1725638522",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2bdcec00-51fa-11ef-88bf-c32c8138a58d",
            "index": 207,
            "title": "How Ozempic Changes Our Bodies, Minds, and Economy — With Johann Hari",
            "pub_date": "2024-09-04T10:00:00.000Z",
            "duration": "3124",
            "duration_label": "52m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2925889022.mp3?updated=1722733332",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "927af7a8-66dc-11ef-aeb4-bb8f93ec5967",
            "index": 208,
            "title": "OpenAI’s Raising At $100B Valuation, Telegram’s Pavel Durov Arrested, NVIDIA's Just Okay Earnings",
            "pub_date": "2024-08-30T14:26:50.000Z",
            "duration": "3440",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "chatgpt",
              "openai",
              "nvidia",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5741273659.mp3?updated=1725029009",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "05509d78-51f7-11ef-a0dd-f32361110152",
            "index": 209,
            "title": "A Longterm Investor Looks Sudden Death In The Face — With Eric Markowitz",
            "pub_date": "2024-08-28T10:00:00.000Z",
            "duration": "2134",
            "duration_label": "35m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2982300455.mp3?updated=1722732840",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ffbd3b26-6175-11ef-ab83-c3e347924e22",
            "index": 210,
            "title": "Meta & Snap's New AR Glasses, Perplexity's Ads, Google's Work Ethic",
            "pub_date": "2024-08-23T17:31:00.000Z",
            "duration": "3027",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4238567762.mp3?updated=1724436168",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a4a2af26-51f5-11ef-b50b-cf01210c0fa8",
            "index": 211,
            "title": "Fyre Festival's Billy McFarland Dishes On Social Media Marketing, VC, and Prison",
            "pub_date": "2024-08-21T10:00:00.000Z",
            "duration": "3418",
            "duration_label": "56m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5310327494.mp3?updated=1722733163",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5117ffe-51fc-11ef-9fba-df0f33cd5cbb",
            "index": 212,
            "title": "Why Extreme Risk Takers Are Winning — With Nate Silver",
            "pub_date": "2024-08-14T10:00:00.000Z",
            "duration": "4615",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8288659042.mp3?updated=1722794504",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7b356478-567b-11ef-bd48-93b51c52eaa5",
            "index": 213,
            "title": "Wall Street Chaos, OpenAI Leadership Shakeup, Google The Monopolist",
            "pub_date": "2024-08-09T17:56:01.000Z",
            "duration": "3657",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2141828916.mp3?updated=1723247836",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a6b6a900-51f7-11ef-b077-7360304fac6f",
            "index": 214,
            "title": "AI's Doomsday Philosopher Says Maybe It'll All Be Totally Fine — With Nick Bostrum",
            "pub_date": "2024-08-07T10:00:00.000Z",
            "duration": "2373",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9505708768.mp3?updated=1722731874",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd19737a-50fd-11ef-b256-0b871fcf168d",
            "index": 215,
            "title": "Did The AI Bubble Just Pop?, Apple Intelligence Beta Arrives, Friend Dot Com",
            "pub_date": "2024-08-02T18:31:09.000Z",
            "duration": "3475",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4048490467.mp3?updated=1722624798",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f475b3ea-4eee-11ef-b6ad-23dd34917fa1",
            "index": 216,
            "title": "NVIDIA's Auto Play and the Future of Autonomous Driving — With Danny Shapiro",
            "pub_date": "2024-07-31T10:00:00.000Z",
            "duration": "2234",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8666978201.mp3?updated=1722433103",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11292004-4b6f-11ef-9d6e-d35158089c50",
            "index": 217,
            "title": "Kamala's Tech Agenda, Drunken AI Spending, Meta’s Open Source Necessity",
            "pub_date": "2024-07-26T16:49:19.000Z",
            "duration": "3957",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9556302995.mp3?updated=1722014367",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "afa6a750-4896-11ef-b246-4f1f6600bf9b",
            "index": 218,
            "title": "The One-Person, Billion-Dollar Startup? — With Thomas Dohmke",
            "pub_date": "2024-07-24T10:00:00.000Z",
            "duration": "3070",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1559400109.mp3?updated=1723150993",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e437903e-45de-11ef-abc0-fb897d6b142a",
            "index": 219,
            "title": "The Silicon Valley Election, Goldman’s AI Worries, Using AI To Talk To Animals",
            "pub_date": "2024-07-19T14:55:28.000Z",
            "duration": "3013",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2036223091.mp3?updated=1721402377",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9ec5005a-4394-11ef-a819-970c87134417",
            "index": 220,
            "title": "Did Klarna Really Automate 700 Jobs With AI? — With Sebastian Siemiatkowski",
            "pub_date": "2024-07-17T10:00:00.000Z",
            "duration": "3459",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4190557083.mp3?updated=1721183439",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1eac428-4096-11ef-8097-fbecd8a8ddf8",
            "index": 221,
            "title": "New ROI Questions For AI, Microsoft’s Empire Plans, Jassy’s Amazon Comeback",
            "pub_date": "2024-07-12T21:34:33.000Z",
            "duration": "4006",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4865615263.mp3?updated=1720820830",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "075f26a4-3e13-11ef-8f34-5f998c8c236a",
            "index": 222,
            "title": "Amazon's Longterm AI Vision — With Matt Wood",
            "pub_date": "2024-07-10T10:00:00.000Z",
            "duration": "3194",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2537107395.mp3?updated=1720620012",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "375d93d6-3adf-11ef-9f48-f7dc13573c29",
            "index": 223,
            "title": "Hawk Tuah and the Zynternet, OpenAI Hacked, One Year Of Threads",
            "pub_date": "2024-07-05T14:52:00.000Z",
            "duration": "3026",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6911122033.mp3?updated=1720196127",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "902ecb6a-37dd-11ef-baad-a7e5b678ca1c",
            "index": 224,
            "title": "What the Ex-OpenAI Safety Employees Are Worried About — With William Saunders and Lawrence Lessig",
            "pub_date": "2024-07-03T10:00:00.000Z",
            "duration": "2833",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9313429460.mp3?updated=1719863361",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "169c5f6a-34d6-11ef-9fcb-1fc46c70fc72",
            "index": 225,
            "title": "AI Adoption Challenges, Waymo’s Big Expansion, Amazon hits $2 Trillion",
            "pub_date": "2024-06-28T15:00:00.000Z",
            "duration": "3161",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4497295426.mp3?updated=1719528592",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "999d6b38-3356-11ef-a960-8f44d28ddabf",
            "index": 226,
            "title": "Decoding The NVIDIA Trade — With Michael Batnick",
            "pub_date": "2024-06-26T10:00:00.000Z",
            "duration": "2450",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2533295636.mp3?updated=1719363777",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "578fefc8-2f36-11ef-8c39-ffb1f9ec783a",
            "index": 227,
            "title": "NVIDIA Takes The Crown, Return of Ilya, Vision Pro Stalls",
            "pub_date": "2024-06-21T10:00:00.000Z",
            "duration": "3291",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "openai",
              "deepmind",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2248531110.mp3?updated=1718910051",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "58d76e70-2b25-11ef-80e5-1f823324a998",
            "index": 228,
            "title": "AI, Elon, Abundance, and Longevity — With Peter Diamandis",
            "pub_date": "2024-06-19T10:00:00.000Z",
            "duration": "3160",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1391693325.mp3?updated=1718581012",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5c183382-2a88-11ef-96da-233c94ac1987",
            "index": 229,
            "title": "Gurman on Apple, OpenAI’s Deal Terms, Forbes vs. Perplexity",
            "pub_date": "2024-06-14T19:54:17.000Z",
            "duration": "3837",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "openai",
              "perplexity",
              "nvidia",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5855530385.mp3?updated=1718396026",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de85645c-2817-11ef-b7bf-c3254990c83d",
            "index": 230,
            "title": "Apple Fails to Overreact to the AI Revolution — With M.G. Siegler",
            "pub_date": "2024-06-12T10:00:00.000Z",
            "duration": "3082",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7698562226.mp3?updated=1718127938",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "68537640-2784-11ef-ad4f-83402606f96c",
            "index": 231,
            "title": "Dispatch from WWDC: Apple AI News + Reaction",
            "pub_date": "2024-06-10T23:52:31.000Z",
            "duration": "1217",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI6842636707.mp3?updated=1718063853",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89f28096-251f-11ef-91b3-7be70d6a32e6",
            "index": 232,
            "title": "Apple’s AI WWDC Approaches, Nvidia $3 Trillion, OpenAI Safety Concerns",
            "pub_date": "2024-06-07T22:42:26.000Z",
            "duration": "3415",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9694946304.mp3?updated=1717801157",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98eb14ae-22e6-11ef-bf04-a7ccc5bb150f",
            "index": 233,
            "title": "Can The News Industry Survive The AI Era? — With Ben Smith, Nayeema Raza, and Joe Marchese",
            "pub_date": "2024-06-05T10:00:00.000Z",
            "duration": "3161",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3224347760.mp3?updated=1717560001",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "91371e76-21c2-11ef-9996-bf36155f0d12",
            "index": 234,
            "title": "How Walt Mossberg Built A Deep Relationship With Steve Jobs",
            "pub_date": "2024-06-03T15:59:00.000Z",
            "duration": "2200",
            "duration_label": "36m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4885610409.mp3?updated=1717431223",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35112528-1f89-11ef-a60c-c764e92679a6",
            "index": 235,
            "title": "OpenAI Teases GPT-5, Musk's Plan For xAI, Loneliness in Remote Work Era",
            "pub_date": "2024-05-31T20:05:43.000Z",
            "duration": "3544",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "xai",
              "alignment"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8436027781.mp3?updated=1717186824",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ccc1d898-1d6f-11ef-82b4-0b2352d2ddc7",
            "index": 236,
            "title": "How Shein and Temu Snuck Up On Amazon — With Louise Matsakis",
            "pub_date": "2024-05-29T10:00:00.000Z",
            "duration": "2600",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2440342156.mp3?updated=1716990384",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "54440d60-1a12-11ef-88a9-d3b53c94c128",
            "index": 237,
            "title": "Google’s Crazy AI Overviews, OpenAI’s Superalignment Drama, NVIDIA’s Unstoppable Run",
            "pub_date": "2024-05-24T21:05:00.000Z",
            "duration": "3552",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "alignment",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI7839822853.mp3?updated=1716587834",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97d50b9c-16fc-11ef-b801-6b6e64c997c5",
            "index": 238,
            "title": "What Cheaper, Faster, and Smarter AI Gets Us — With Aaron Levie",
            "pub_date": "2024-05-22T10:00:00.000Z",
            "duration": "3316",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI4949081898.mp3?updated=1716247373",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "325be63e-13bc-11ef-90e2-3b74a3009908",
            "index": 239,
            "title": "OpenAI’s Big Week, Did Google Kill The Web, AWS CEO Resigns",
            "pub_date": "2024-05-17T14:00:00.000Z",
            "duration": "2748",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3951337256.mp3?updated=1715889012",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "944b352c-1176-11ef-975f-e3ef1a67ce44",
            "index": 240,
            "title": "AI Scaling, Alignment, and the Path to Superintelligence — With Dwarkesh Patel",
            "pub_date": "2024-05-15T10:00:00.000Z",
            "duration": "3933",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "alignment",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI8849352471.mp3?updated=1715746928",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e021b80a-0f13-11ef-bde5-a7144b4840f2",
            "index": 241,
            "title": "Apple's Bad iPad Ad, AI Assistant Hype, Netflix's Big Live Ambitions",
            "pub_date": "2024-05-10T21:16:00.000Z",
            "duration": "3228",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1353513102.mp3?updated=1715377469",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98e9df6c-0cca-11ef-87f5-5b020782e158",
            "index": 242,
            "title": "Economics of OpenAI, Tesla’s Robotics Pivot, Hedonic Treadmill — With Slate Money",
            "pub_date": "2024-05-08T10:00:00.000Z",
            "duration": "3055",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2375471132.mp3?updated=1715125669",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "81d375ae-097d-11ef-82c7-eb02669dba68",
            "index": 243,
            "title": "Emails From Elon, AI Revenue Questions, Chatbot Boyfriends",
            "pub_date": "2024-05-03T18:45:23.000Z",
            "duration": "3656",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "claude",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI2999437210.mp3?updated=1714770847",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1fa2957e-07af-11ef-8b59-9ff682d879fc",
            "index": 244,
            "title": "Teaching AI To Read Our Emotions — With Alan Cowen",
            "pub_date": "2024-05-01T11:36:00.000Z",
            "duration": "3408",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1842286182.mp3?updated=1714650566",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b702f570-03f5-11ef-9032-2bf0c27d43b2",
            "index": 245,
            "title": "Are LLMs Hitting A Wall, Microsoft & Alphabet Save The Market, TikTok 'Ban'",
            "pub_date": "2024-04-26T17:46:54.000Z",
            "duration": "2629",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9957445377.mp3?updated=1714154578",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9d60fc18-018c-11ef-ae65-e7684680338a",
            "index": 246,
            "title": "Apple's AI Play — With M.G. Siegler",
            "pub_date": "2024-04-24T10:00:00.000Z",
            "duration": "3335",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI1191403874.mp3?updated=1713905889",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "44e089ce-fe84-11ee-993f-4f36d79b4c1f",
            "index": 247,
            "title": "Meta's Big Llama 3 Release, Google's New Culture, MKBHD vs. Humane",
            "pub_date": "2024-04-19T19:29:57.000Z",
            "duration": "3324",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "llama"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI9410366535.mp3?updated=1713556086",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1bda952-fc03-11ee-b219-0fefae9a8603",
            "index": 248,
            "title": "Kara Swisher Rates Tech Leaders — With Kara Swisher",
            "pub_date": "2024-04-17T13:46:57.000Z",
            "duration": "3303",
            "duration_label": "55m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI3794075751.mp3?updated=1713286722",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "91cd19fe-f903-11ee-899f-97cd0cd004c6",
            "index": 249,
            "title": "Google's AI Narrative Is Flipping, Microsoft Hedges Its OpenAI Bet, AI Clones Are Here",
            "pub_date": "2024-04-12T19:24:33.000Z",
            "duration": "3606",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5847281315.mp3?updated=1712951358",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "20f19d7a-f6ee-11ee-a881-97b1d9ff3f2f",
            "index": 250,
            "title": "Anthropic's Co-Founder on AI Agents, General Intelligence, and Sentience — With Jack Clark",
            "pub_date": "2024-04-10T10:00:00.000Z",
            "duration": "5087",
            "duration_label": "1h 24m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "openai",
              "anthropic",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/tracking.swap.fm/track/t7yC0rGPUqahTF4et8YD/pscrb.fm/rss/p/traffic.megaphone.fm/LI5741008274.mp3?updated=1712722363",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "last-week-in-ai",
        "title": "Last Week in AI",
        "feed_title": "Last Week in AI",
        "priority": "P2",
        "selection_mode": "all_ai",
        "focus": [
          "AI news",
          "weekly timeline",
          "research updates"
        ],
        "feed_url": "https://rss.art19.com/last-week-in-ai-podcast",
        "source_url": "https://rss.art19.com/last-week-in-ai-podcast",
        "detail_path": "/podcasts/last-week-in-ai/",
        "episode_count": 200,
        "selected_episode_count": 200,
        "latest_episode_title": "S&P 500 Blocks Future AI IPOs",
        "latest_pub_date": "2026-06-05T21:17:44.000Z",
        "latest_page_url": "",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "gid://art19-episode-locator/V0/WIm9aL2sND5hyJ1qP8B5AkmIGn7M7XkUOjIG100mqPI",
            "index": 1,
            "title": "S&P 500 Blocks Future AI IPOs",
            "pub_date": "2026-06-05T21:17:44.000Z",
            "duration": "00:12:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1a651fec-68d0-4b22-9ea6-6fe5c908e565.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/0QBSpwVtP-DPsK5b5896bGMyIvBNhbiPHOA2_ejM_Y4",
            "index": 2,
            "title": "Alphabet's Need for $80 Billion in AI Tech",
            "pub_date": "2026-06-02T21:44:27.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "github copilot",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/acd314e1-dee4-48a1-af54-dcb4f82141af.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Ly3OUaOIJMV5Z8737GjFWZnU1p-0_ACvVULr2GvAt0U",
            "index": 3,
            "title": "Weekly Update: Anthropic IPO and Nvidia",
            "pub_date": "2026-06-01T20:41:26.000Z",
            "duration": "00:13:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "nvidia",
              "chip",
              "reasoning",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6f5338bb-97b0-4ac9-ac72-25fd72278210.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/0c71Uq4iTLpqhRBK-t2_6IE-BnrBmPyfGxs8WOa4wl4",
            "index": 4,
            "title": "Anthropic Reports $965 Billion Valuation Milestone",
            "pub_date": "2026-05-29T20:52:26.000Z",
            "duration": "00:15:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "grok",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0fb29bb5-c5af-49e4-8e02-72ce4693bee7.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/l_l_0xKTGVGwfHZ2CEtxi5g2BTUpQzecZXZoCmY6F8E",
            "index": 5,
            "title": "Recent Trends in AI Returns",
            "pub_date": "2026-05-28T01:46:38.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/91fb1e45-2829-4a44-b893-de6159df0473.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/GZVD9s6zJxqRSfK-4X3VZ2kU21MiKTFnJPdwE0Tslyo",
            "index": 6,
            "title": "Uber's AI Spending, the Pope on AI, TikTok and Universal's AI Music Deal",
            "pub_date": "2026-05-26T21:22:01.000Z",
            "duration": "00:18:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/added4da-9350-454b-8388-5bfd904bb726.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_UbGjN0-_vt9rQc3SsdOCrqEYqPYeYNwMv-pSX2hop4",
            "index": 7,
            "title": "Recap: AI Interaction Models This Week",
            "pub_date": "2026-05-26T02:28:28.000Z",
            "duration": "00:13:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d8c9c651-e207-4728-a381-9a59a93d3bb5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jmLsj-5QKBU6ydWGK2OzOALCxWtzHhGeD-sZLeRRDjE",
            "index": 8,
            "title": "SpaceX Estimates $26.5T for AI Sector",
            "pub_date": "2026-05-22T22:26:50.000Z",
            "duration": "00:12:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/730c6934-4b8a-4032-91d2-6a8ca6d07d0a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/o7X7d374BpwqMkeCDmelEe9AVO1ck5VqOrCDEW3yilM",
            "index": 9,
            "title": "Recapping SpaceX Investments and AI Delays",
            "pub_date": "2026-05-22T00:12:17.000Z",
            "duration": "00:17:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0ea11d88-c739-4c65-a659-9da0b795eb34.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/iYSdWRHFfzGjtwE-FNio6xB2w8Ak13KgCiffa0cyt9c",
            "index": 10,
            "title": "OpenAI and SpaceX are Racing to IPO First",
            "pub_date": "2026-05-20T22:08:37.000Z",
            "duration": "00:18:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7c79ba3f-dfa8-4316-80ac-bc2e7255b2d5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/paiAZ0JKQI4Ao_fHjufdaLHaz33bsWjvvHfQyOQcK38",
            "index": 11,
            "title": "Dominion Acquired: What's Next for the Market?",
            "pub_date": "2026-05-18T19:59:39.000Z",
            "duration": "00:15:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/eb77157a-7491-4511-96e4-beb0318597c5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/fDd-tWCb9VUJV0fI8Xz7SpAK500PzZ14qH8ir1yKFLA",
            "index": 12,
            "title": "ChatGPT's in Your Bank, Google Spams the GEO Industry, Brockman Takes OpenAI Product",
            "pub_date": "2026-05-16T00:00:28.000Z",
            "duration": "00:19:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/98a62f4b-3230-400e-af81-3d8e60cc599e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/PJJ-fQpAOtIkedt01en9dbNqvaBZWvTaNmc24SQZngM",
            "index": 13,
            "title": "Anthropic + Gates Give $200M to Healthcare | Cerebras IPO Doubles",
            "pub_date": "2026-05-14T20:49:21.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7d868f03-bcfe-499c-ad2b-33490a429cff.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9wczuwdGllkgjP3TBwo0mVIjk2II30NfufWJdVDFcQQ",
            "index": 14,
            "title": "Claude for Small Business ships | Altman Testifies He's 'truthful'",
            "pub_date": "2026-05-13T22:02:46.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "gemini",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/744bb2f3-e2a2-4084-8649-96164c728040.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/RS4uKhhPT0MZ8KWLkavh7jBhI01QcuBk2G1c5qqDXJs",
            "index": 15,
            "title": "Amazon Devs \"tokenmaxxing\", SpaceX & Google Collab, Anthropic Legal Fight",
            "pub_date": "2026-05-12T21:48:42.000Z",
            "duration": "00:17:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2f6f52fd-2705-48b6-95d0-8ddaa16a44e0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Dbh6qBwTk1z3aH5PMuPZTAFHiaRJQZ7sHF03Rv2rYNY",
            "index": 16,
            "title": "Google Stops AI Exploit, Nadella Testifies, OpenAI's New $4B Unit",
            "pub_date": "2026-05-11T22:28:31.000Z",
            "duration": "00:16:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9db1849e-8215-4324-b8f8-9273104f0788.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4WhtqjjoNn1bvYERglve0TNNFcz75oBkCaLyYlTPqHo",
            "index": 17,
            "title": "Anthropic Aiming for $1 Trillion Valuation",
            "pub_date": "2026-05-08T19:48:08.000Z",
            "duration": "00:14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b5f4ff3c-f9b2-4ca9-ae4f-de110035f8ac.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/yn5tLmK43zMhFpit6OqmLBmv7GFbEeS1xYdJcjJphpA",
            "index": 18,
            "title": "Updates on Anthropic's Claude 'Dreaming'",
            "pub_date": "2026-05-07T21:03:22.000Z",
            "duration": "00:15:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3c97f63b-f4a0-4751-8b92-4c9d0844cd67.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/e_vb7PU2zYHgfuG9YEj0uewCXm45dQOuhUeMZSOkvA4",
            "index": 19,
            "title": "Highlights from OpenAI's GPT 5.5",
            "pub_date": "2026-05-06T20:52:42.000Z",
            "duration": "00:11:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "claude",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9c734bf0-ddee-4134-b513-26d1a5918158.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Nc4r_jtr3rN1RiqgmvOaMQNOdcNdEgILTCR7Mp43Plc",
            "index": 20,
            "title": "The Current State of AI Unionization",
            "pub_date": "2026-05-05T21:00:41.000Z",
            "duration": "00:21:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "openai",
              "anthropic",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1b967f3a-8fe9-4fea-9103-c28a609e37ec.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Xr4dXbhJHRNHnO8NMyybkH0vI0a-j--tMF8gxUozYoA",
            "index": 21,
            "title": "Last Week's Notable AI Funding News",
            "pub_date": "2026-05-04T21:40:04.000Z",
            "duration": "00:19:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/899d72be-eb64-4ccb-9c56-4ba4c969439d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/R961VD-Qqq0HO9xoDtrpKbYF5UxjYOQEvISfZUwwf8Y",
            "index": 22,
            "title": "Grok's Origins: Musk's Surprising Statement",
            "pub_date": "2026-05-01T20:47:59.000Z",
            "duration": "00:12:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "anthropic",
              "grok"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/eea67946-0927-4e71-850a-f396692280da.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4LvInrMp6dJ_vIP64JvgwVQfU1-iN7OA82iSoCF-8oA",
            "index": 23,
            "title": "Anthropic Seeks $50B: Key Developments",
            "pub_date": "2026-04-30T18:57:13.000Z",
            "duration": "00:23:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ba1e3584-1358-42a3-9945-009e6abfc32f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/hbXnOp4RQIi9EzYJ0VLodx0_w0cAKUevg4eVWWvX8ns",
            "index": 24,
            "title": "Musk vs. Altman Trial: Day 3 Recap",
            "pub_date": "2026-04-29T23:31:41.000Z",
            "duration": "00:14:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b1378d9c-41ab-4ca1-bb65-27b299f816e5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/rtdKa1SRHuoAUVNvN-P-V18FaFimyuYPEszN8etsAvw",
            "index": 25,
            "title": "Unpacking Altman's Challenge with CFO",
            "pub_date": "2026-04-28T19:35:23.000Z",
            "duration": "00:21:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c3123068-5a96-43df-a4c1-74dba3245706.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/FpOdWG3XkF3Fra5e_0033WgOVl2Hj9ZSzXUvr5ygLbs",
            "index": 26,
            "title": "OpenAI Ends Microsoft Association: A Brave Move",
            "pub_date": "2026-04-27T20:51:43.000Z",
            "duration": "00:16:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ed124d27-c77a-4ebc-9ee1-9c96b8dc5274.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/JZ89FwCnaQh5VTh1hMETi1JqQrspDE1RYBXQq3O92Bk",
            "index": 27,
            "title": "ChatGPT 5.5: Highlights from the Launch",
            "pub_date": "2026-04-24T20:25:11.000Z",
            "duration": "00:16:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "chatgpt",
              "gpu"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/bd2b98fe-822d-4a9b-ad5d-e694d0fefd71.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/8YQagyxZNeCe51PeCXYICzoCi6rMpzR_ndn3o5DpbGI",
            "index": 28,
            "title": "Highlights from Google Cloud Next AI Strategy",
            "pub_date": "2026-04-22T21:50:06.000Z",
            "duration": "00:16:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6802decc-0fce-4a3f-8e7a-ee087a8fe6aa.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/FfbQBPGlrgv3oTWGtGs5RbjbZR2s1gbjSWZ5AQNkLPE",
            "index": 29,
            "title": "New Apple CEO, OpenAI's New Image Model, Vercel AI Hack",
            "pub_date": "2026-04-21T21:40:39.000Z",
            "duration": "00:16:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/47d8d1ed-5f73-4e6f-b789-c7d0161a7adc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9kJdlK5tou6clfJB0HLKULU0kJ5ECOtpndXtg_X5Yos",
            "index": 30,
            "title": "Anthropic Financially Bypasses OpenAI",
            "pub_date": "2026-04-20T20:59:17.000Z",
            "duration": "00:14:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a6eff63e-1d77-438b-8c7b-83714f8cc38b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ThZdytBEprNogU48MDIKiawUdrp6PnzAs2sEK65svgg",
            "index": 31,
            "title": "AI News: Claude's Design Features",
            "pub_date": "2026-04-17T20:24:28.000Z",
            "duration": "00:14:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a8dfce78-62f7-4b42-b6d8-660a0fd46c5c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1jmlrJoVZTgDt3jpaBpceyKjjpkQT-plot6KVNOH2vo",
            "index": 32,
            "title": "Anthropic's Opus 4.7 Launch Review",
            "pub_date": "2026-04-16T22:11:39.000Z",
            "duration": "00:14:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/946f19ab-da3e-4c70-9bd7-510f26a24d22.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/RroKvuw43Itt_-z8zHl7DpKxVl6JgrDVQ7z3G3W7tNM",
            "index": 33,
            "title": "Highlights from Anthropic's IPO Announcement",
            "pub_date": "2026-04-15T11:22:23.000Z",
            "duration": "00:15:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e9719f9b-214d-4b2b-9914-a822837751a3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/WlRt_wBGGwhvc2q209QbPMg2doeE3KeWwVUdA0MG20M",
            "index": 34,
            "title": "Highlights from Last Week: Clones and Controversies",
            "pub_date": "2026-04-13T21:46:17.000Z",
            "duration": "00:15:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a5a6fe2e-fff2-4dbb-933a-8ba58352c970.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4BAId4k-V9U7JuhQhPvoHLbT3F-9eGh8DbLuC-Ohs7Q",
            "index": 35,
            "title": "Meta's Gemini 4: Latest Developments",
            "pub_date": "2026-04-09T19:15:14.000Z",
            "duration": "00:15:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5702efe7-331e-4774-8fad-2ef4621b812a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/aBuV4GLdZbgdrzJ4LpR8hbGG17NzkvsX3G8r9rHMAeg",
            "index": 36,
            "title": "Anthropic's Mythos Found Millions of Security Vulnerabilities",
            "pub_date": "2026-04-07T19:36:06.000Z",
            "duration": "00:11:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f028509c-d6de-42f3-89a4-60d08f1776bc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/eJynshhVfAgm5Sg_71K0MqHPfTN3VbzLeHn9NQjvFmk",
            "index": 37,
            "title": "Q1 2026 Venture Funding Hits $300B Record",
            "pub_date": "2026-04-06T19:10:26.000Z",
            "duration": "00:16:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/36c0ab46-03df-4709-8296-5f2e611a242e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1kNRP0uWVtsSoBgZ_KI3PMapfNDQoE7j9FuerOQzdA8",
            "index": 38,
            "title": "OpenAI Acquires TBPN: (yes the tech news podcast)",
            "pub_date": "2026-04-03T21:04:03.000Z",
            "duration": "00:09:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8420f1ad-4463-47f5-bd3f-f020bd6d2199.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/UvjGCrRXZr0Z_yvEfd8Z2j_OquSPRgeOWJ1oRUkQh2w",
            "index": 39,
            "title": "OpenAI's $121B Funding Round Explained",
            "pub_date": "2026-04-03T19:10:48.000Z",
            "duration": "00:13:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cdaeb882-e761-4714-af41-c6c778cff596.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/6g6D0Hjprng9ViPe7zxitCxEGQFP9kF3Yg_ts6TXTcU",
            "index": 40,
            "title": "OpenAI's $40 Billion Investment and AI Advances",
            "pub_date": "2026-04-03T16:35:27.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/36fce6a7-b775-4156-b1b9-6ca362c8f2ce.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/gL93vHqKccfMU-0NXWnpu1DqqRoTW0Gqti5-ji-4P4c",
            "index": 41,
            "title": "SoftBank's $40B OpenAI Investment & Anthropic's Claude Mythos Leak",
            "pub_date": "2026-03-27T21:56:27.000Z",
            "duration": "00:13:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9063a498-689e-4c04-9102-8041184d19fd.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9kZdrPxrId0Lj7LBUn-DliRmc5wTtn8-iN4Csv6rO4M",
            "index": 42,
            "title": "Claude Co-Work can now Control Your Computer",
            "pub_date": "2026-03-25T11:19:04.000Z",
            "duration": "00:12:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/40163143-4b16-41e4-9e9f-c78d1d08223e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/hI5f1eYy-L0W42_wrDywb2ovUcx62g2h-Fcugbwf6nQ",
            "index": 43,
            "title": "OpenAI Kills Sora Video Model",
            "pub_date": "2026-03-24T21:39:17.000Z",
            "duration": "00:10:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0e3a35eb-fdfb-4179-ac7e-cc329d43c420.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/DExRoSKQRTmMG92_rrDJz-juHO1wV74iOIP3Nsa08eM",
            "index": 44,
            "title": "Bezos to Raise $100B for AI and Nvidia's Challenges",
            "pub_date": "2026-03-23T21:09:09.000Z",
            "duration": "00:10:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5b2d5422-5bd3-4179-84b7-c7408be15f74.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/N8-1HFDJ3WPLk4evX4kbYfi6u6iqCLrvjQjafqDAd0k",
            "index": 45,
            "title": "AI Web Traffic to Exceed Humans by 2027, and Rogue AI Agents",
            "pub_date": "2026-03-19T21:29:13.000Z",
            "duration": "00:14:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3dfa4504-1e73-4677-bfd9-0177a7edc336.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/-UppPqs3fHX-PDHFXOISu6hSXMIW4YEmWtn8IWgjuA8",
            "index": 46,
            "title": "Meta Manus Desktop App, Anthropic Enterprise Lead, OpenAI AWS Deal",
            "pub_date": "2026-03-18T11:17:44.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "data center",
              "robotics",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d212e69c-0e80-4a0b-935c-ee2788642658.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/giOnBgc2IcNkbjBEIeYypy3Enr6hyCYKQAxsYmXLq8Y",
            "index": 47,
            "title": "Senators Say \"Shut AI Down\", Mistral Forage, Pentagon AI, Google AI",
            "pub_date": "2026-03-17T21:53:16.000Z",
            "duration": "00:14:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "google ai",
              "mistral",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0c66f902-c3e8-478b-85a3-648976a4f3e1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/IgTb29thdrEk9LZ7HW0pr4jgsGDRSDTbxrOvL23-mrs",
            "index": 48,
            "title": "Meta to Layoff 20%, AI Cured Dogs Cancer, Nvidia's New Chip",
            "pub_date": "2026-03-16T15:07:53.000Z",
            "duration": "00:13:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "chip",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ddad0d6a-ea53-4d12-952f-c3f67447a30f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/cnqb06sFKgPPQZTJRJOHybpHBiADwGKQ5q1W9eboxTI",
            "index": 49,
            "title": "NanoClaw Creator Lands Docker Deal After Six Weeks",
            "pub_date": "2026-03-13T21:41:32.000Z",
            "duration": "00:10:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b181fcb9-36e6-4073-8e43-ed22578048c6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Iz0EhLMtfN2MaY5xEy48JORG0w0K6KWxH5zMNostfxc",
            "index": 50,
            "title": "Gumloop Raises $50M from Benchmark to Scale AI Agents",
            "pub_date": "2026-03-12T21:38:30.000Z",
            "duration": "00:11:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4fba1add-d54b-4998-bfbb-513f41f5c75c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/IGmVoLLnaf3V8cRluWnEvwqiePW675gr7VB15tLubXU",
            "index": 51,
            "title": "AI App Crisis, OpenAI Does Math, Big Nvidia Deal",
            "pub_date": "2026-03-11T18:53:01.000Z",
            "duration": "00:18:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ccfcfe3e-e614-4d1c-8356-53aff9781c44.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_ENZFPwcnAIilZRQswEI12bQoxX6QTF7_fI0kxHLFN0",
            "index": 52,
            "title": "Meta Acquires Moltbook: Facebook for AI Bots",
            "pub_date": "2026-03-10T16:20:04.000Z",
            "duration": "00:10:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ac1f75d0-77c9-4380-8a4a-b5d244e518be.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Svj0gQ8MFmVF8wKgTf7wLrTg-h1CN3uPe08Hmt5scoY",
            "index": 53,
            "title": "Anthropic Launches \"Code Review\" to Fix AI Code Security Issues",
            "pub_date": "2026-03-09T21:56:32.000Z",
            "duration": "00:13:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/47b6196e-0d3d-4bce-a2dd-9845c4632e50.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4M6GL6Cbt6tSY86UNGKLatnhoV5PGL7876hoQceQIro",
            "index": 54,
            "title": "Meta Faces Lawsuit Over Ray-Ban Smart Glasses Privacy",
            "pub_date": "2026-03-06T17:56:54.000Z",
            "duration": "00:11:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2acef351-0919-477a-b38f-4bc4192ae6e6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Mdc9cW3l6IdNdyYKX89jPTZrEHkevfVhmH0ad4bQGaE",
            "index": 55,
            "title": "OpenAI Launches ChatGPT 5.4",
            "pub_date": "2026-03-06T01:36:00.000Z",
            "duration": "00:12:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/825fde7c-77cf-45d1-b594-a8815fb4dd7c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/s-MWBxFLovR6ujUm10B-Y0dzqODDY8hEcVSetTu_UCM",
            "index": 56,
            "title": "What VC's Are Looking For in AI Startups Today",
            "pub_date": "2026-03-03T16:46:58.000Z",
            "duration": "00:11:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2ff70b6c-7000-4129-9739-07de5b56c13a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/VorcVpFrkQGVO4PLS1Lw99FvNq0dx-deHcWBH7XC2pU",
            "index": 57,
            "title": "OpenAI Steals $200M Contract in Anthropic vs. Pentagon Battle",
            "pub_date": "2026-03-02T16:40:18.000Z",
            "duration": "00:12:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/85734cab-af5c-4bbe-ad79-f01c54c2a976.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/qK9R-7wgGD5gfHMPmoQhAHwN6BSKD48eywMLdvKdqis",
            "index": 58,
            "title": "Perplexity Max Debuts Multi-AI Agent Tool",
            "pub_date": "2026-03-01T20:44:34.000Z",
            "duration": "00:10:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "perplexity",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/27fe4dae-eec5-43ba-b8c3-cb4ed6d7caef.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/QUl4EiD7Hy1YCyw7sWAeNgcamJCQ6xfUDnKBhbg4_mk",
            "index": 59,
            "title": "Suno Hits $300M ARR: AI's Impact on the Music Industry",
            "pub_date": "2026-02-28T14:00:00.000Z",
            "duration": "00:13:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/69a4e811-610b-4561-861d-c5d0c3803566.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/RuSM3WzcacdrU2DyBnf0x_gxQhMchZw7bCoQT45idFs",
            "index": 60,
            "title": "OpenAI Raises Record $110B, Hits 900M Weekly Users",
            "pub_date": "2026-02-27T20:51:29.000Z",
            "duration": "00:10:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/92b28db6-9461-4f2c-897e-9c078da34076.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/b_0DLbh7FlA2S7v2lkPIhoY2p4Rf7eL6VW-lekO9llc",
            "index": 61,
            "title": "Anthropic Acquires Vercept Amidst Pentagon Standoff",
            "pub_date": "2026-02-26T17:01:44.000Z",
            "duration": "00:14:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7b88e01a-8a01-4514-8cdb-fe65b6626b3d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jgtGa4o1VQL0OOvfjxpthUP7utBiFtLffwdepB2GZGo",
            "index": 62,
            "title": "Anthropic and OpenAI Battle for Enterprise AI",
            "pub_date": "2026-02-24T19:22:53.000Z",
            "duration": "00:14:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/22e5e8b8-d7b3-40f7-9a8c-e0c8bf2c2c28.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/gJK6YE7HAb1gK4zIy5tGtwQHXqrG1dGwXCqEQ2bpjgk",
            "index": 63,
            "title": "AI Audio Updates: Spotify, Particle, ElevenLabs",
            "pub_date": "2026-02-23T18:20:36.000Z",
            "duration": "00:12:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/97f424d8-3aff-47f2-a22b-622f32ea492d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mfHhBZkSsdRkKKSjkaJ8yNkyXGNyExgF2RSUU7Ow3pM",
            "index": 64,
            "title": "Japanese Toilet Maker Toto's HUGE AI Windfall",
            "pub_date": "2026-02-22T14:00:00.000Z",
            "duration": "00:09:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a7c90e82-753b-4a06-9852-b21a85625e33.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/kL22neChHN_OgPi474RksaietnIiJiQylpDPdhmlPh8",
            "index": 65,
            "title": "Reddit Steps into AI-Powered Commerce",
            "pub_date": "2026-02-21T14:00:00.000Z",
            "duration": "00:10:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/e709182b-a223-4cfe-9217-74c1cd0b92ee.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KOR0pIaCDo2RTJyM5Hafa3E_QYeQTqhGk6x4Dmpi6Wc",
            "index": 66,
            "title": "OpenAI's $100 Billion Funding + Sam Altman Refuses to Hold Darios Hand...",
            "pub_date": "2026-02-20T22:16:42.000Z",
            "duration": "00:12:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/99edd0ea-9741-4e44-b857-67ef25511179.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/HlEsmMc9aH-Jl895U_n1UPq3gxraCpLAy_hc9KleMiA",
            "index": 67,
            "title": "Google Launches Gemini 3.1 and YouTube AI",
            "pub_date": "2026-02-20T02:35:07.000Z",
            "duration": "00:12:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "google ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/043373f0-4db8-4f1f-a266-98d8e9c9c489.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Pv-u0WlLActU0ZlfzAqvOr0mWyKyPhpc2DFPupl9B8c",
            "index": 68,
            "title": "Google Gemini Integrates AI Music Generation",
            "pub_date": "2026-02-18T22:30:41.000Z",
            "duration": "00:15:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/596accba-378b-41f3-86e4-7778ac71ed5f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/AFibS_rgskTIMo3_BVJ9d1dAByv7fCgpM0mjQK7Ug04",
            "index": 69,
            "title": "Apple Wins The AI Hardware Race",
            "pub_date": "2026-02-17T21:51:11.000Z",
            "duration": "00:14:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/17bde1d8-47ac-4470-81f0-8112f2d2c38b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/oi3bTs9EtzPUMDCllqmQWpe_KchCx3mcp9RNOpE6OHE",
            "index": 70,
            "title": "OpenClaw Could Be 1st 1-Person $1B Company, OpenAI Buys",
            "pub_date": "2026-02-17T02:09:43.000Z",
            "duration": "00:16:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ba295259-4c04-4fdd-a0cd-2b2514f000fb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5WwUHcFsQ3LQapJTQBOme6hCsewhW58VzyNWgVcuKhg",
            "index": 71,
            "title": "XAI's Radical Plan: Data Centers In Space",
            "pub_date": "2026-02-12T14:45:23.000Z",
            "duration": "00:18:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/896e6633-aab6-488e-b8f3-072969e23475.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/wPtqC92quhN3AqqXNS9p4S2CYhWIP5ccNRq88CYfEBk",
            "index": 72,
            "title": "Runway Raises $315M for AI World Models",
            "pub_date": "2026-02-11T18:07:12.000Z",
            "duration": "00:13:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/bf0e9779-4388-47ae-bec1-e46a7c670d43.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/h9lQ9l6ocLWnAtzi-TsjmUCRklmB7hf_OtTt3ty-0os",
            "index": 73,
            "title": "Anthropic to Raise $20B at $350B Valuation",
            "pub_date": "2026-02-10T13:51:33.000Z",
            "duration": "00:10:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7e94c5a9-2519-47e0-bfc1-5be7d638c521.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/UAMJNfuXVp3-x7F6l1X-2JRZGgXJ-HJwQKO78RdC-m8",
            "index": 74,
            "title": "Amazon's $200B CapEx Spend Dominates AI Race",
            "pub_date": "2026-02-08T14:00:00.000Z",
            "duration": "00:12:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/43ec3964-5c9c-4c7a-9669-b2ec753e2117.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/8ite5vgfvOUCcOoZSaTxzvRKLUqUgwsLEhUraztePgA",
            "index": 75,
            "title": "Reddit's AI Answers & Meta's Vibes App",
            "pub_date": "2026-02-07T14:00:00.000Z",
            "duration": "00:11:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b0950217-348b-4cf0-98fe-69907c310521.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/94b2Wm4bAxhM5fyizXUOcVUMhwlE6vVQNKaxIAgw6eQ",
            "index": 76,
            "title": "SpaceX Asks FCC for 1M AI Data Centers in Space",
            "pub_date": "2026-02-06T20:22:28.000Z",
            "duration": "00:11:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0de4cdfb-73d3-4e83-9baa-2834e8ff64b6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/CzAhsyRACC4PdJ9EcXp8eDGMJuAu4AIvzBLf5WIeZIg",
            "index": 77,
            "title": "Anthropic's Opus 4.6 and OpenAI's Codex: New AI Models Compete",
            "pub_date": "2026-02-05T21:42:22.000Z",
            "duration": "00:10:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9d753436-2f7e-4c2c-bb5d-1d3194c86e86.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/qPxGGsgWkQ76qeDq5U0OAi1rhqEvQJu70ZNjTt_IfDc",
            "index": 78,
            "title": "Lotus Health AI Doctor Raising $35M",
            "pub_date": "2026-02-04T12:11:20.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4b10d2c7-4bed-426d-bedf-31194a276cc3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/fhJsTZYyq3430-fNzTv3dVnE8b62091lYsm-dOFCPM0",
            "index": 79,
            "title": "Lotus Health AI Doctor Raising $35M",
            "pub_date": "2026-02-04T12:11:20.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8822780f-54a0-493d-ba30-db05be8c1080.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/6qEt64Conjcv0zm2tYhPDNc1NzO5fdOu4eHQo-EeG5Y",
            "index": 80,
            "title": "Lotus Health AI Doctor Raising $35M",
            "pub_date": "2026-02-04T12:11:18.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/074cd494-e523-42e0-9383-5ee3890bfe07.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/MZR93GTkqC3tqeEbEptB0d9xQK22RlxkFN7YnAfDmLo",
            "index": 81,
            "title": "Lotus Health AI Doctor Raising $35M",
            "pub_date": "2026-02-04T12:11:18.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3e63fb61-43f8-4653-8941-42407f2981f5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/neo21sHtH7av8t1DDzgLf0SZQHqRm5jdCDGHsQ3LyZA",
            "index": 82,
            "title": "SpaceX Acquires XAI for $1.25 Trillion",
            "pub_date": "2026-02-03T17:48:24.000Z",
            "duration": "00:12:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ba1661ac-5c79-45ed-a481-45569196bfbe.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/CK35A1uUMZLN486GtrzH8S_yB1RYe2sUjQqcOxyGKrc",
            "index": 83,
            "title": "The History of AI",
            "pub_date": "2026-02-02T18:28:36.000Z",
            "duration": "00:12:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5b0fd839-86d5-4931-8cc8-b623a212c165.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/cGAxbXs5nAiONqGXszwWKSraCF0Xa0cDN6hXCjqfu1U",
            "index": 84,
            "title": "Anthropic's New Plugins and $3 Billion Lawsuit",
            "pub_date": "2026-01-30T22:16:55.000Z",
            "duration": "00:10:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/37f4711b-3b51-44b5-827e-17e4cf2e6dec.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Ov1-irRFg9nMseJg9OaqnRJcyFwlj8by1_8e4tYcnT0",
            "index": 85,
            "title": "Anthropic's New Plugins and $3 Billion Lawsuit",
            "pub_date": "2026-01-30T22:16:54.000Z",
            "duration": "00:10:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a0254c07-fc9e-4a50-a31e-29a8e557b24f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/d1LELSY6FgkGRGDhsZ4dAFCzurPCmiIlM5gPYNetIjE",
            "index": 86,
            "title": "Meta's AI Surge: Smart Glasses & Billions",
            "pub_date": "2026-01-29T21:50:45.000Z",
            "duration": "00:12:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6174caa0-5140-4537-a04c-b26177099a3a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/44u_zpenOMUnVpqTXCv6_067mGru27Bi_HptsQV3g7Q",
            "index": 87,
            "title": "Waabi Raises $1B from Uber and VCs",
            "pub_date": "2026-01-28T18:55:26.000Z",
            "duration": "00:12:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/590e54c2-ab55-44f2-bd71-a9c9d8961e3f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/S9hU_HQWuOKvRzBmFWoMtUMxYjUL5DdGtIVjYsLtT0g",
            "index": 88,
            "title": "Anthropic's Cloud App Integrations and Hiring Challenges",
            "pub_date": "2026-01-28T12:03:21.000Z",
            "duration": "00:11:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/fca4eab8-b692-495c-9aa8-3cd343cbb00a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/3LoAhxvDfg9aZWey_p_tVVrzAO9YvXUw4-g3se2K7Lg",
            "index": 89,
            "title": "HumansAnd Raises $480M Seed Round to Build AI for Human Collaboration",
            "pub_date": "2026-01-26T23:23:00.000Z",
            "duration": "00:15:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1d21159a-ffae-4c36-bfd4-0d457853308d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/MfZJw9FytJ1q4S34TYFH_dnYIVjCbaVgwSPv-ckRmgc",
            "index": 90,
            "title": "NVIDIA Invests $2B in CoreWeave",
            "pub_date": "2026-01-26T22:10:35.000Z",
            "duration": "00:10:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/806f2981-24e2-4db9-88aa-96aaad14e30f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/rK2ezhG8LdPu8mvTRnqStlA2hQlpmI0eYrqrZcELzss",
            "index": 91,
            "title": "Microsoft Reveals Maya 200 AI Inference Chip",
            "pub_date": "2026-01-26T20:48:24.000Z",
            "duration": "00:11:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip",
              "inference",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c89df66d-9ffb-45de-9241-0b6856e26ce3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/HUJSHVRGY4jLdPK4E95y6xzBTFSaLMdQHKMwRsy4A0w",
            "index": 92,
            "title": "OpenAI Leadership Reshuffle, AI Unicorns, and White-Collar Work",
            "pub_date": "2026-01-23T22:15:59.000Z",
            "duration": "00:10:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4ede14aa-cb32-4796-8cee-1b20f4404b31.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/hpcsvJDAHcdf7wWNFVd3bMf3q9kms_k3F_aNgdlrjOk",
            "index": 93,
            "title": "Last Week: Google Enters Ed-Tech",
            "pub_date": "2026-01-22T22:32:19.000Z",
            "duration": "00:10:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8dd60232-72dc-4600-a8a6-643e47b77fb7.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/JgK_sRINq_9e3E8R95DaNeAWzXbu2gLRSS4AKoht0_c",
            "index": 94,
            "title": "Anthropic CEO Criticizes NVIDIA Over AI Chip Sales to China",
            "pub_date": "2026-01-21T20:28:16.000Z",
            "duration": "00:09:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 16,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "nvidia",
              "chip",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1cd63627-f0dd-4862-80b8-e6147405f2db.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KYkZ8PtWhKLiNkKW5GceQoowzRbdgFC12wfripNTfZk",
            "index": 95,
            "title": "RunPod: Top AI Cloud News",
            "pub_date": "2026-01-21T02:00:00.000Z",
            "duration": "00:08:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b57b3017-21ed-4980-884e-7a324c186b27.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/LmaZDYIRITlU3wCyFqieIYx8jny0RHawRO2bSPz_1GA",
            "index": 96,
            "title": "Last Week: AI Energy Deal",
            "pub_date": "2026-01-21T00:00:00.000Z",
            "duration": "00:11:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d1f70f8d-81dd-4b36-bc8e-b0e2c3d56334.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/3YJDG5CxZqxLNcwUlBRZ703XOlQC9qpWEKRxUriR24Q",
            "index": 97,
            "title": "Meta's AI Overhaul News",
            "pub_date": "2026-01-20T22:25:41.000Z",
            "duration": "00:13:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2b1663d3-dee4-4c3e-9d1a-3e98cceda5d6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ejaeGyTthmPBnFVCiii3FdI6A6oKhW3BJW65q-BihWI",
            "index": 98,
            "title": "Elon Musk Seeks $134B from OpenAI and Microsoft",
            "pub_date": "2026-01-19T15:10:15.000Z",
            "duration": "00:12:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/082c1756-0090-4091-8e5b-f8343544369f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/nIyYXV1Q4ug94jdAABVVFysa4i9r8OLw25PcpUobd_8",
            "index": 99,
            "title": "Last Week: Higgsfield's Unicorn",
            "pub_date": "2026-01-15T20:56:41.000Z",
            "duration": "00:10:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/604934b1-f98a-4981-9c16-fd1c109c627d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/aOQJPk8B9DkflVQMzI4_IvYBTctEPJgNyBKn6pyc2Nw",
            "index": 100,
            "title": "BCI Emerges Last Week",
            "pub_date": "2026-01-15T18:35:12.000Z",
            "duration": "00:11:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6f01344c-7119-4d76-882d-4d23bef53cda.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/jVBTerHNAWuyLjmEQSfeDSVc1XB4cF58_CAYe92YZ7M",
            "index": 101,
            "title": "Last Week: AI Solves Math",
            "pub_date": "2026-01-15T16:34:56.000Z",
            "duration": "00:13:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/592ee025-8c41-44f4-bdf1-12efb64cb5be.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/zwnFU49GX1gPmWBoSmgl9XoW7Yi5iic2H4DlO0e7mFk",
            "index": 102,
            "title": "230 Million ChatGPT Clinics Weekly",
            "pub_date": "2026-01-09T01:00:00.000Z",
            "duration": "00:10:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "reasoning",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8073f96f-e651-4a12-aa66-d140d9e31a1c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/dxro_OtqYDHXnMGiIaoipzzO7IakGnm3eBYo6OBNmRo",
            "index": 103,
            "title": "Fade Algorithm Clipper: CES AI Barber",
            "pub_date": "2026-01-08T00:00:00.000Z",
            "duration": "00:10:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/3e19e7ac-57da-4e3a-a9d9-5b29290f78b3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Fv9mM59CxUw_Bg4mpjbCD8ckGvd1L8q3SOgVRyQOk-s",
            "index": 104,
            "title": "LeCun Slams LLMs: Meta AI Architectural Failure",
            "pub_date": "2026-01-07T01:00:00.000Z",
            "duration": "00:08:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "meta ai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/485537fd-2b24-46ef-8fb4-fe216d154f89.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/vvDf926d_oby6qJzI5xAbvjzlTRS3F1iuxW6zCLFB9E",
            "index": 105,
            "title": "Billion-Dollar AI Startup Citadel: Nvidia Portfolio",
            "pub_date": "2026-01-07T00:00:00.000Z",
            "duration": "00:13:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "robotics",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/fcbf86af-6549-49cb-911f-4f2d02454975.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/kz2lnU8OePEUyxApqQjOOi5OUOqTmtjntMgNCnwnOyI",
            "index": 106,
            "title": "OpenAI Bets Audio Empire: Screens Fade Away",
            "pub_date": "2026-01-06T23:00:00.000Z",
            "duration": "00:10:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/125615ea-1c7b-4429-8b87-4a38a3f8311a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/yiYa5KqaEeCnskvOuG79iwhTkdL92qm-NyDFEQ3ykMw",
            "index": 107,
            "title": "Nvidia Poaches Groq Leadership + $20B Tech",
            "pub_date": "2026-01-06T02:30:00.000Z",
            "duration": "00:08:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia",
              "gpu",
              "chips",
              "inference"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/1b95c269-e27a-4705-9383-7520efdbe0eb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_pYVIRGxyinWhHNlt9XtUxAc05r3XK7UYQESGYZXg4w",
            "index": 108,
            "title": "Peripheral Labs Raises $3.6M: Volumetric Sports Leap",
            "pub_date": "2026-01-05T02:30:00.000Z",
            "duration": "00:07:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8d394b57-8d0a-4cc6-9c76-01cda47943ba.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/fdN_an5fi3-1QjiB1wNb-_Jw_aEYlnEKq0dyTNyi0JQ",
            "index": 109,
            "title": "Claude AI Agent Chrome: Cautionary Launch",
            "pub_date": "2026-01-04T02:30:00.000Z",
            "duration": "00:12:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5f20003b-1017-4a64-a279-06e7d61343d0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/534ZhAJl7LiaJjD5E4F6GoJ9e_d1ie0wDEDH5nxB_W0",
            "index": 110,
            "title": "Forever Fragile Agents: OpenAI's Injection Warning",
            "pub_date": "2026-01-03T00:00:00.000Z",
            "duration": "00:14:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/40ee18f1-7879-47f1-914c-76dd4bdd8dfb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/JuEDHHjA17ewIr7qRJKwHShUyqQ2whMQ3CKZDEV0L0k",
            "index": 111,
            "title": "Safety Czar Bounty: OpenAI's $555K+ Call",
            "pub_date": "2026-01-02T03:00:00.000Z",
            "duration": "00:10:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "alignment",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d9319ea4-128d-4121-a7ab-7be7149f0f03.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/2U17wUAYeUamFMlymHHGgN-bzF-ZC3cNO1_BSlNMU3k",
            "index": 112,
            "title": "Meta's $2B Chinese AI Power Grab: Manus",
            "pub_date": "2026-01-01T03:00:00.000Z",
            "duration": "00:10:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8dfdd5e8-3301-417c-a1d6-3d795af3aea7.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/rk0iw7ptgQlNBO16OtVEj_bZk9g79xOp4zcKgskMOSM",
            "index": 113,
            "title": "VC Forecast: AI's 2026 Turning Points",
            "pub_date": "2025-12-31T02:00:00.000Z",
            "duration": "00:08:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c1dd0d37-2f9b-459f-b565-adae3e921d48.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/i4CVV5FPsKOMmLpR6t3FK5bBNbQQC9Appu86MVgjBuQ",
            "index": 114,
            "title": "Fal Bags $140M Launching 10X Image Velocity",
            "pub_date": "2025-12-30T02:00:00.000Z",
            "duration": "00:09:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/9b36d95b-c63a-4b78-9fdc-ddf905503e38.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Dr2edIWTg12sJM3cqWnBm0hwy_GpPuY0DJ-UVxZPGWM",
            "index": 115,
            "title": "OpenAI's $100B Push Rides $3B ChatGPT Surge",
            "pub_date": "2025-12-26T01:00:00.000Z",
            "duration": "00:10:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5d3d38f0-c39b-4895-9192-c915bb547bae.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/u5tdc54T3-MyqPNWYhYaB4QoqvrZ13Mhl_o8AZZbtwc",
            "index": 116,
            "title": "Luma AI Lands $900M Amid Video Tech Launch",
            "pub_date": "2025-12-26T00:30:00.000Z",
            "duration": "00:10:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ffd0fd49-181a-408c-99e1-3a93ab017bf6.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ymb7cbVklwzShCUA8kJBJH3OPt3tT2JJdHwratDHjhE",
            "index": 117,
            "title": "Meta Glasses Add Spotify Hearing AI",
            "pub_date": "2025-12-24T02:30:00.000Z",
            "duration": "00:08:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/0e2d091a-95e2-4965-9e4c-d0eb65af20c0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/YoX70QIJ-8C6fXivtHkNuWCjjV-IkIUK6uOOW6WFW50",
            "index": 118,
            "title": "OpenAI Image Gen Cosmos",
            "pub_date": "2025-12-24T00:00:00.000Z",
            "duration": "00:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/989bc268-4074-4319-bffe-bc3975b587d5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/YsfW00dLZTRaoxyPg4k9wquT1dh7V28amcLV69BtOUU",
            "index": 119,
            "title": "Databricks Sovereign $134B Empire",
            "pub_date": "2025-12-23T23:00:00.000Z",
            "duration": "00:07:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f5e9544c-a212-421c-a28f-0a174d77313e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/LHzwhbkAW6CVhT1PXvjepy8yOPRd3ma4TSUZAUNQvWo",
            "index": 120,
            "title": "Firefly Prompt Video: Edit Instantly",
            "pub_date": "2025-12-22T04:00:00.000Z",
            "duration": "00:07:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/00c62c67-2378-4ee4-b13a-567a498df8f3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5nJur6J4vgI1riuXArkatVsSTUEzHDw3y5c2dj4wb34",
            "index": 121,
            "title": "Google's CC Tests Elevate Gmail",
            "pub_date": "2025-12-22T03:00:00.000Z",
            "duration": "00:09:50",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/abf796bb-6798-42c3-ac31-1fee1f58134f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/sJpUZAHeTtMO44gx87F3OPgDpijih2Dq_GF3NGDqICY",
            "index": 122,
            "title": "Triumphant Lovable: $6.6B/$330M Round",
            "pub_date": "2025-12-22T02:00:00.000Z",
            "duration": "00:08:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7ff16d0b-2516-4f02-bd08-7d526ef9f206.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/uz0WDZpGpOEUOizB4BccsnW7b_0PKL5pN7Dh79Guv9k",
            "index": 123,
            "title": "$10 Billion Amazon OpenAI Scoop",
            "pub_date": "2025-12-22T01:00:00.000Z",
            "duration": "00:09:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f7d771e7-fc46-4e7d-bd5d-2980a3cd89b1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/7VDIFGRLfkXzxbFuft_CtG6xNqFVy4dxA51j_kz6DXI",
            "index": 124,
            "title": "Yann LeCun Wants AI to Think Before It Acts",
            "pub_date": "2025-12-22T00:00:00.000Z",
            "duration": "00:07:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/41199917-2c00-46d8-bd7f-9d956f8e37ba.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/-4RRCHAcLwVR9VAUKJAslFsKygye4XsVyOnQdv7bOm8",
            "index": 125,
            "title": "Resolve AI Blazes to $1B on $4M ARR Trail",
            "pub_date": "2025-12-21T23:00:00.000Z",
            "duration": "00:06:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f978b0e4-dca2-4686-bac6-fcc0dc1c4484.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/6AJnDzKX1itmCmchhoAJxlmWexxsAPZ9oPlonmlS69A",
            "index": 126,
            "title": "Why This Image Model Is a Milestone for OpenAI",
            "pub_date": "2025-12-17T01:00:00.000Z",
            "duration": "00:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/7c88e4a6-9166-451c-b5b0-92f7013374f1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/R4_zxLZkuIAJ31YTwkpLTsqZZsihttHYCkQfsicODuo",
            "index": 127,
            "title": "Smart Glasses That Adapt to How You Hear",
            "pub_date": "2025-12-17T00:00:00.000Z",
            "duration": "00:08:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6bdae35d-8f32-4b1f-98f3-8c120ab5b261.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4amcPG5PRKR742XhL35_2xamWmyZiNEYqijdjNxc_ZA",
            "index": 128,
            "title": "Why DoorDash’s Zesty App Signals a Bigger Platform Play",
            "pub_date": "2025-12-16T23:00:00.000Z",
            "duration": "00:08:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/aaf4ea46-260d-4c3a-b1e6-99b2128cece7.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/y74Y26fbYSN9FAfZyuhi5-LmXD8opoF1xvODmTNxQdw",
            "index": 129,
            "title": "Why AI Audio Is the Final Frontier for Video",
            "pub_date": "2025-12-16T01:00:00.000Z",
            "duration": "00:08:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/c63e1957-c865-4630-9c05-d6efff3e6887.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/1lSnSwq24GLVaHLQMVteXJ6rOXDW1BYeevh6EfzzIz8",
            "index": 130,
            "title": "AI Hiring Could Reduce Bureaucratic Bottlenecks",
            "pub_date": "2025-12-16T00:00:00.000Z",
            "duration": "00:07:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/076d7c98-b944-4378-b015-a71c3d06d9ac.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/_WGVBtvu_A_iOV6VvRfozlU_DMkvs4oPkEGn6bROmrA",
            "index": 131,
            "title": "Trump’s AI EO Forces States to Rethink Strategy",
            "pub_date": "2025-12-15T23:00:00.000Z",
            "duration": "00:11:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/aac1b1a1-875c-4eea-819c-6823840312fc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mOoVr463Vz1_nN6DZrEOU1HinKZ1Hejohc3RntOX3P4",
            "index": 132,
            "title": "OpenAI’s GPT-5.2 Turns AI Competition Into a Sprint",
            "pub_date": "2025-12-13T01:00:00.000Z",
            "duration": "00:10:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cf27a8ab-e51a-4332-a563-55268b553b8c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/u4KjBDOCXlz1GlB8qvJdT-5RABfBhDCm1MolMelpesY",
            "index": 133,
            "title": "Disco Could Reshape the Way We Build Tools",
            "pub_date": "2025-12-13T00:00:00.000Z",
            "duration": "00:09:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6e3a6be7-613f-4aa0-aedb-6c720597826b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/JsBXmzwVYfnu2K8zdkforQs4i1BQkhre1YtZh59DBp8",
            "index": 134,
            "title": "Autonomous Vehicles Face the Human Factor",
            "pub_date": "2025-12-12T23:30:00.000Z",
            "duration": "00:07:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6a3f5134-c418-472b-ba01-31e1fe7fbc80.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/hnNvX9erSSWzXXSRWApP192meGozgpCfCrHcHZK2_Zk",
            "index": 135,
            "title": "Episode 1,001: My Biggest AI Misjudgments",
            "pub_date": "2025-12-12T00:00:00.000Z",
            "duration": "00:08:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/6934e1ff-6a61-4d2d-a197-e2de3af0e3da.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/5E1Do0UXv3JGja3lleYUIqh-BU5pLa7wn2UYFlIpLO8",
            "index": 136,
            "title": "Google Experiments With Step-By-Step AI Article Companions",
            "pub_date": "2025-12-12T00:00:00.000Z",
            "duration": "00:09:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/233cf4ca-7ace-4aa5-940f-8acaf5f6f3fa.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/amwAK2fgk8DoHSrJ-BYZuhS4w0KiQuINA1gOQycjKRY",
            "index": 137,
            "title": "Ring Rolls Out On-Device Facial Recognition to Limit Data Sharing",
            "pub_date": "2025-12-10T00:00:00.000Z",
            "duration": "00:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/74cc97e7-7a64-4d67-8ca4-77a41f20daf5.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/LSz2xW-3u00fpWP7ajPNJKOTW2xfegZNyUv5jaM5WZI",
            "index": 138,
            "title": "Google Adds More Autonomous AI Screening to Chrome",
            "pub_date": "2025-12-09T00:00:00.000Z",
            "duration": "00:14:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/497a3403-cd4e-45a2-83e7-54249d540626.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/2MgtomYBlIlrdTfKiKckv9Ohd8Nz3mqtbYAH0eTX4fI",
            "index": 139,
            "title": "OpenAI Funding Sparks Debate Over AI Market Stability",
            "pub_date": "2025-12-07T00:00:00.000Z",
            "duration": "00:10:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f93cef00-5867-4488-bd09-90774e667610.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/SdyRVtOBGN3wRjUjBsMw9qVGB3KVmPLEl2N1CCAE-4s",
            "index": 140,
            "title": "AWS Chips Enter Billion-Dollar Market With Explosive Growth",
            "pub_date": "2025-12-06T00:00:00.000Z",
            "duration": "00:09:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chips",
              "inference",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/30e0df77-67c5-4af6-b86a-151574ea110f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9dnglG5d3uTQ0gSPNutEg8iLj9X5uNqfKaUrbWOvq34",
            "index": 141,
            "title": "Black Forest Labs Raises $300M To Push Generative AI Forward",
            "pub_date": "2025-12-05T07:00:00.000Z",
            "duration": "00:08:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/dfed45f9-1642-4edd-9c2b-2e1edabb3456.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/VWR7CjrOD9eG-PQJGhYX0GRGHdEhDV0rwKBclw7hIik",
            "index": 142,
            "title": "Anthropic and IBM Formalize $190M AI Collaboration",
            "pub_date": "2025-12-05T06:00:00.000Z",
            "duration": "00:10:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f4aba5b9-a3b2-4bfc-b710-7c988fae41f2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/yu2dydNL13B0ETmm1inBpl2ZTGgh6-wHvUx6htPJZGI",
            "index": 143,
            "title": "xAI’s New Solar Expansion to Improve Workflow for Grok",
            "pub_date": "2025-12-05T05:00:00.000Z",
            "duration": "00:12:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "grok"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/f4e540ea-0bde-4719-9786-5fa2b5eb3006.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/U0Xse2258k7A4WshHr8JJB8FJG0SCra5q_3ZwYNyZUs",
            "index": 144,
            "title": "Google Experiments With AI-Centered Search Flow",
            "pub_date": "2025-12-05T02:00:00.000Z",
            "duration": "00:08:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/48f5f3fc-920c-4710-be41-17c24d21d619.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/9PG4ZMWxvDEAf8t9VOS1coLQLWY-oXWOpA5JtFNb3jE",
            "index": 145,
            "title": "Meta Shifts Its Roadmap: Less VR, More AI Automation",
            "pub_date": "2025-12-05T01:00:00.000Z",
            "duration": "00:10:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/29f2f024-b657-4657-b06c-adfd96853291.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/ptPyD23Nd_Us28W5iU3Uzgz6EacRcioGyMlNw7VdGhM",
            "index": 146,
            "title": "Ten New Mistral Models Offer Strong Performance Gains",
            "pub_date": "2025-12-05T00:00:00.000Z",
            "duration": "00:12:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "mistral"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/278a5086-0712-4854-b27e-6f517b308e2e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/4zx_-NQYFoUo2JtKRUYxzP7GyEKr1x5FzaS-EMDa4J8",
            "index": 147,
            "title": "Nvidia Insists Google Trails by One Generation in AI Hardware",
            "pub_date": "2025-11-27T00:00:00.000Z",
            "duration": "00:07:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/696bdde4-c014-46cb-8339-d977277abcad.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/alhUqtEWkTaoESNdNP__s1IvpjNmHueaoMIpgk_tJkc",
            "index": 148,
            "title": "Momentic Secures $15M for Test Automation Infrastructure",
            "pub_date": "2025-11-26T07:00:00.000Z",
            "duration": "00:08:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/65c28c49-ab8b-4c8b-8d04-1854f8defa8f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/s0YhWkAIrN2x6sFukTK2DIANRJRTrKVO0E1I9SxPbFs",
            "index": 149,
            "title": "AWS Gears Up for $50B Federal AI Data Center Expansion",
            "pub_date": "2025-11-26T06:00:00.000Z",
            "duration": "00:07:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/11ba4a26-407d-450c-aecf-6a947f247a2b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KPkkPZIkA0BRCLmJa6U591sn3ke20Wo54zYui7iGktk",
            "index": 150,
            "title": "Why Anthropic Chose Memory as the Focus for Opus 4.5",
            "pub_date": "2025-11-26T05:00:00.000Z",
            "duration": "00:07:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2d2acfb0-da15-4e05-b80e-005a5c587a58.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/S1bw-ZuBjdoO1NAqMnSWW8NLy1k1Wh9UBQVn0IBCHl4",
            "index": 151,
            "title": "Google’s AI Infrastructure Investment: 1,000X Growth",
            "pub_date": "2025-11-24T00:00:00.000Z",
            "duration": "00:12:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/87e29f43-94e3-4da3-b519-0c9f8a109745.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/oQEMKNx9CAm8bTFkyU6O6aoPhkAXPhpBZoliSVgQfSQ",
            "index": 152,
            "title": "Could a Federal AI Rulebook Change Everything?",
            "pub_date": "2025-11-23T00:00:00.000Z",
            "duration": "00:10:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/86a520f2-6f65-47e6-8d32-61baae222f15.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/0snh2w2P-RtQmhdtXcMXAi4Dwn_u1USPyU_8KNvxv-o",
            "index": 153,
            "title": "How Gmail Became Google’s Most Valuable AI Dataset",
            "pub_date": "2025-11-22T00:30:00.000Z",
            "duration": "00:09:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/d47b3cdd-edbd-474e-9912-491f9b3754ca.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/D3NXBeKK9A_ukPvtjL5ZKJ1vk0P3BcBUJetuSVutZuM",
            "index": 154,
            "title": "TikTok Adds Hard Filter for AI-Generated Comedy",
            "pub_date": "2025-11-21T07:00:00.000Z",
            "duration": "00:09:02",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/8908f8ed-415f-414e-ae4a-bfdc14441196.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/EuwqzH99IphBUL_MyU6JZaVcCsZsSuEio_ASs0-vk1k",
            "index": 155,
            "title": "NestAI Receives €100M, Builds Classified AI Defense Systems With Nokia",
            "pub_date": "2025-11-21T06:00:00.000Z",
            "duration": "00:08:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a5249832-a805-4cf1-b9d1-429f24f2f994.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/KqfLPqpIa46n1eRY32kEFU5X1rnPAB6xW6KZOJlFBvs",
            "index": 156,
            "title": "Function Health Raises Funds to Expand Predictive Testing",
            "pub_date": "2025-11-21T05:00:00.000Z",
            "duration": "00:08:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/5660d3d4-b83c-4ec8-b1e9-5d882ce82241.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/y7Cvt2au9RJF5hp-MG0KwgGYtv4ez5SqalPFb_28vdU",
            "index": 157,
            "title": "Nvidia’s Monster Quarter Raises Eyebrows",
            "pub_date": "2025-11-20T08:00:00.000Z",
            "duration": "00:09:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/a047a2b1-0eeb-4de0-81a7-8dd94d4291f3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/R8K2UxXbk-2qyBqfQPBLITOQVifr8ToCyOPRjYl8oIE",
            "index": 158,
            "title": "Suno Gains $200M as Warner Conflict Ends",
            "pub_date": "2025-11-20T07:00:00.000Z",
            "duration": "00:10:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/67f55ad2-6e09-412e-92b8-28b4004c7fe0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/G77TAxQlMMXizJrOG5_Ourq-ND-PmK2JBKo5He64Jo0",
            "index": 159,
            "title": "Google Unveils Gemini 3: Smarter AI for the Future",
            "pub_date": "2025-11-19T03:00:00.000Z",
            "duration": "00:09:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/4872e4f8-f70a-488b-9835-783953945d55.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Zl5djEo-5abYUwFd6gPlpES1d0YThk07EBxX0NYO8-M",
            "index": 160,
            "title": "Stack Overflow Enters AI Market With Verified Knowledge Sets",
            "pub_date": "2025-11-19T02:30:00.000Z",
            "duration": "00:09:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/2c48e363-b2ca-4dde-bb74-3fa41e1cbf72.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Azw77lYokDNxGrzIeglroZm1v8or2e1_dQDlaimP9ms",
            "index": 161,
            "title": "Bezos’ AI Firm Wins $6.2B to Build AI-Powered Infrastructure",
            "pub_date": "2025-11-19T02:00:00.000Z",
            "duration": "00:10:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/df158d08-506e-4c77-88e9-cab811c4c760.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/Dopqsug0XUa9OiEdvhW_W_tW0XJiOVNRZbdrI7IrDKI",
            "index": 162,
            "title": "OpenAI’s Microsoft Partnership Becomes Major Financial Liability",
            "pub_date": "2025-11-18T02:30:00.000Z",
            "duration": "00:09:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/084dfcdb-1fba-4325-98e9-1b592764ffcf.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/FX6OxaWPV5gWNSMsGyTrsbt1eTpfg5O6_Q5kXgXsd0g",
            "index": 163,
            "title": "Wonderful Receives $100M to Scale AI Helpdesk Systems",
            "pub_date": "2025-11-16T00:00:00.000Z",
            "duration": "00:09:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/841f6ae0-7091-4f17-ac95-8a2b9bb207d8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/fBkCsLrUA-ebCYUjjwcFfan6_HcJ4OU0UUcdWyW4FOU",
            "index": 164,
            "title": "Google Launches AI Caller to Eliminate Manual Product Checks",
            "pub_date": "2025-11-15T15:30:00.000Z",
            "duration": "00:12:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/b807b782-2f6a-43c4-bbc5-ed0cfaa56bc8.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/R0MPm_s6uCI9ttLg-ykuG6tTXBpLd9QI3q82YV0Gl1I",
            "index": 165,
            "title": "Cursor Raises $2.3B to Go All-In on AI-Driven Coding",
            "pub_date": "2025-11-15T15:30:00.000Z",
            "duration": "00:06:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "cursor",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/ff3237a3-f2c9-42b0-96e6-3fdffd175062.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "gid://art19-episode-locator/V0/mJ9eWUz8bnz-N1FmSkcBXZwEbYWeVC-SZEJGdYf50Us",
            "index": 166,
            "title": "OpenAI Unveils ChatGPT 5.1 With Collective Chat Intelligence",
            "pub_date": "2025-11-15T15:30:00.000Z",
            "duration": "00:07:33",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://rss.art19.com/episodes/cc848b62-bcca-40f4-a2e7-8e5358714b7c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e49ed1af-aa40-4ed5-b49d-a2db31db2f3c",
            "index": 167,
            "title": "OpenAI’s $38B Deal Sparks AI Power Shift",
            "pub_date": "2025-11-06T00:00:00.000Z",
            "duration": "00:14:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/OpenAIs-38B-Deal-Sparks-AI-Power-Shift-e3afm9j",
            "audio_url": "https://rss.art19.com/episodes/a3f1b8f2-cdd5-4339-93f5-b3af7f2b3b04.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8e66edf1-6e3f-45da-8730-56fc7aa9d8e1",
            "index": 168,
            "title": "The $5 Trillion Company Behind Every AI Breakthrough",
            "pub_date": "2025-11-05T01:00:00.000Z",
            "duration": "00:12:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chips"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/The-5-Trillion-Company-Behind-Every-AI-Breakthrough-e3afm68",
            "audio_url": "https://rss.art19.com/episodes/0a5628e8-f916-4d3f-b456-98f8726bb88c.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f1fd970-7a2d-4506-81ed-e522f1b62ab7",
            "index": 169,
            "title": "OpenAI Gives ChatGPT Access to Enterprise Databases",
            "pub_date": "2025-11-02T00:00:00.000Z",
            "duration": "00:13:41",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "enterprise ai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/OpenAI-Gives-ChatGPT-Access-to-Enterprise-Databases-e3a73o1",
            "audio_url": "https://rss.art19.com/episodes/b372d0bc-0a31-4bdf-a44b-bcf96e0467e7.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "44e5730a-f27a-40df-9007-788d4b8b58aa",
            "index": 170,
            "title": "OpenAI Integrates Sky: Hands-Free Computing Begins",
            "pub_date": "2025-11-01T00:00:00.000Z",
            "duration": "00:11:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/OpenAI-Integrates-Sky-Hands-Free-Computing-Begins-e3a734f",
            "audio_url": "https://rss.art19.com/episodes/f982faf9-804c-4c32-b8d6-0d2e76a4a56e.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4d816c84-115c-4bab-84f0-c7e250e757a8",
            "index": 171,
            "title": "Mastering Atlas: A Guide to OpenAI’s New AI Browser",
            "pub_date": "2025-10-31T00:00:00.000Z",
            "duration": "00:18:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Mastering-Atlas-A-Guide-to-OpenAIs-New-AI-Browser-e3a72op",
            "audio_url": "https://rss.art19.com/episodes/38b52014-13ab-4cb7-8675-6e9e3e822db0.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b3288da9-2ab9-4f42-aa25-7291263a728c",
            "index": 172,
            "title": "AI Learns Spatial Reasoning: General Intuition Raises $134M",
            "pub_date": "2025-10-29T23:00:00.000Z",
            "duration": "00:18:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "reasoning",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/AI-Learns-Spatial-Reasoning-General-Intuition-Raises-134M-e3a71ri",
            "audio_url": "https://rss.art19.com/episodes/835641b7-cb7d-4652-a41f-2c85c55a1532.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9279ac8a-a752-43ce-b52f-adcefdcad5cb",
            "index": 173,
            "title": "Reflection AI’s $2B Move to Rival DeepSeek",
            "pub_date": "2025-10-18T00:00:00.000Z",
            "duration": "00:13:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Reflection-AIs-2B-Move-to-Rival-DeepSeek-e39juth",
            "audio_url": "https://rss.art19.com/episodes/5e846307-4760-41c9-9516-2ae6a5d3676b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da01f03d-b0b3-4130-8a24-c14dc91b4a1f",
            "index": 174,
            "title": "How to Join Sora: OpenAI’s App Just Reached 1M Downloads",
            "pub_date": "2025-10-17T00:00:00.000Z",
            "duration": "00:12:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/How-to-Join-Sora-OpenAIs-App-Just-Reached-1M-Downloads-e39jucs",
            "audio_url": "https://rss.art19.com/episodes/8242309f-2208-4bb8-9325-4ad64ef83ec2.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bc583389-66b7-41f8-ae08-122f08dfaf5c",
            "index": 175,
            "title": "Supermemory’s Smart Memory Revolution",
            "pub_date": "2025-10-09T00:00:00.000Z",
            "duration": "00:10:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Supermemorys-Smart-Memory-Revolution-e39710s",
            "audio_url": "https://rss.art19.com/episodes/0d443dc5-aebe-4c9f-a51f-0fd3913f8576.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bb54f349-61ce-4711-8abc-7d7861fdc32f",
            "index": 176,
            "title": "AI Hardware Shake-Up: OpenAI Invests in AMD",
            "pub_date": "2025-10-07T23:00:00.000Z",
            "duration": "00:09:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "chip"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/AI-Hardware-Shake-Up-OpenAI-Invests-in-AMD-e3970mb",
            "audio_url": "https://rss.art19.com/episodes/d18795e2-5326-4510-9b49-ba20e23c2462.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e67cd95-030b-4015-889d-ae3ea1bff24c",
            "index": 177,
            "title": "AI News Roundup: Grok Staff Cuts, OpenAI Restrictions",
            "pub_date": "2025-10-05T00:00:00.000Z",
            "duration": "00:05:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "grok"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/AI-News-Roundup-Grok-Staff-Cuts--OpenAI-Restrictions-e391u97",
            "audio_url": "https://rss.art19.com/episodes/52240958-6102-4e5d-b405-c6bfd024e7f1.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c134939b-348f-4f48-a581-e80f76b20148",
            "index": 178,
            "title": "Apple’s Quiet AI Shift and Nvidia’s Bold Moves",
            "pub_date": "2025-10-04T00:00:00.000Z",
            "duration": "00:11:08",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Apples-Quiet-AI-Shift-and-Nvidias-Bold-Moves-e391tsp",
            "audio_url": "https://rss.art19.com/episodes/9e027428-cc32-4f9a-b697-6427b4fbba19.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8aec10a1-7f0b-4b82-ab06-b8c5063e55b0",
            "index": 179,
            "title": "Sora 2: The Next Chapter in AI Video",
            "pub_date": "2025-10-03T00:00:00.000Z",
            "duration": "00:12:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Sora-2-The-Next-Chapter-in-AI-Video-e38utf3",
            "audio_url": "https://rss.art19.com/episodes/2fecd884-38fd-4296-9cc8-6bad3a2b2a82.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e4b4d3c3-b580-4cce-ac4d-846604082d68",
            "index": 180,
            "title": "Scaling AI: OpenAI Meets Oracle",
            "pub_date": "2025-10-02T00:00:00.000Z",
            "duration": "00:10:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Scaling-AI-OpenAI-Meets-Oracle-e38ut30",
            "audio_url": "https://rss.art19.com/episodes/dde67563-a405-40f4-9ce1-0d30ca0e7622.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "84b7105c-b747-4fa4-a616-5a987914e670",
            "index": 181,
            "title": "Cohere’s $7B Milestone with AMD",
            "pub_date": "2025-09-27T00:00:00.000Z",
            "duration": "00:09:46",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Coheres-7B-Milestone-with-AMD-e38o65o",
            "audio_url": "https://rss.art19.com/episodes/f108c8cc-c17a-4462-93ac-7ece54339acb.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "50c5deb2-29f9-4f41-9ab0-c14b72457082",
            "index": 182,
            "title": "Overlooked AI Innovations",
            "pub_date": "2025-09-26T00:00:00.000Z",
            "duration": "00:10:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Overlooked-AI-Innovations-e38mnl7",
            "audio_url": "https://rss.art19.com/episodes/dd82471f-b922-45bf-95e9-4a811129c88b.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "32b9a8d7-5446-455f-9ecb-5cd885e0f239",
            "index": 183,
            "title": "Why AI Box Changes the Game",
            "pub_date": "2025-09-18T00:00:00.000Z",
            "duration": "00:14:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Why-AI-Box-Changes-the-Game-e389sm8",
            "audio_url": "https://rss.art19.com/episodes/a481fc4e-5625-4bb4-bfb1-bbdcb41d1323.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b3d00d70-d7e3-40ab-98e0-82a3a673e037",
            "index": 184,
            "title": "Anthropic’s $13B and the AI Arms Race",
            "pub_date": "2025-09-17T00:00:00.000Z",
            "duration": "00:10:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Anthropics-13B-and-the-AI-Arms-Race-e385rn6",
            "audio_url": "https://rss.art19.com/episodes/131335bf-54fa-47de-82c0-1b6898af387a.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95b0e768-c74d-445c-8863-965d6107a6c5",
            "index": 185,
            "title": "Making ChatGPT Safer for Everyone",
            "pub_date": "2025-09-16T00:00:00.000Z",
            "duration": "00:12:35",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "safety"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Making-ChatGPT-Safer-for-Everyone-e385rjm",
            "audio_url": "https://rss.art19.com/episodes/88f0a94b-1202-4054-bc64-46b6b118bb8d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "42c25e34-7d38-47a6-a8e0-e64c5d8eaa55",
            "index": 186,
            "title": "The Billion-Dollar Question: Copyright in AI",
            "pub_date": "2025-09-15T00:00:00.000Z",
            "duration": "00:10:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/The-Billion-Dollar-Question-Copyright-in-AI-e385rh2",
            "audio_url": "https://rss.art19.com/episodes/44a60d19-6ebf-46ed-9fc9-4cd01cf3b1af.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8ef72ed-2c02-4c91-81d5-6b11c062be14",
            "index": 187,
            "title": "The Quiet Alliance: OpenAI and StatSig",
            "pub_date": "2025-09-14T00:00:00.000Z",
            "duration": "00:08:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/The-Quiet-Alliance-OpenAI-and-StatSig-e385req",
            "audio_url": "https://rss.art19.com/episodes/909efc2b-e457-4c66-8462-cc14a9958bcc.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2d410084-956a-4199-bf2b-d2011beabab4",
            "index": 188,
            "title": "Meta Hypernova Chronicles",
            "pub_date": "2025-09-08T00:00:00.000Z",
            "duration": "00:11:30",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Meta-Hypernova-Chronicles-e37sf0c",
            "audio_url": "https://rss.art19.com/episodes/e354e1cc-8e24-42f8-8dc2-4f3c04c55784.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52fca5c2-056e-48da-8380-9721197b2b2b",
            "index": 189,
            "title": "When Musk Meets Zuckerberg",
            "pub_date": "2025-09-07T00:00:00.000Z",
            "duration": "00:06:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/When-Musk-Meets-Zuckerberg-e37set4",
            "audio_url": "https://rss.art19.com/episodes/bdec4182-d496-461c-b3e3-4f43b7abe46d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7830f2a-cd1a-495c-8e6a-753d4859e524",
            "index": 190,
            "title": "Why the Grok Leak Should Concern Everyone",
            "pub_date": "2025-09-06T00:00:00.000Z",
            "duration": "00:06:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "grok"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Why-the-Grok-Leak-Should-Concern-Everyone-e37jgfl",
            "audio_url": "https://rss.art19.com/episodes/2f47cd2e-ef38-488c-a315-58b83d1fdf68.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d79924b8-3484-4cf8-bc32-e583f7577169",
            "index": 191,
            "title": "The Story Behind Meta’s AI Restructuring Spotlight",
            "pub_date": "2025-09-05T00:00:00.000Z",
            "duration": "00:07:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/The-Story-Behind-Metas-AI-Restructuring-Spotlight-e37jgd4",
            "audio_url": "https://rss.art19.com/episodes/1af2420d-9b7e-497e-8e81-9c1767d5000f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cfa1fceb-dd08-4d32-af18-edf39e1e6fc4",
            "index": 192,
            "title": "The Next Frontier of AI Robotics with Field AI Uncovered",
            "pub_date": "2025-09-04T00:00:00.000Z",
            "duration": "00:04:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/The-Next-Frontier-of-AI-Robotics-with-Field-AI-Uncovered-e37jg9k",
            "audio_url": "https://rss.art19.com/episodes/7a261a10-5758-42f3-9dfa-2d578f433ca3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e0bac3d-7380-4627-a0b9-240140c54285",
            "index": 193,
            "title": "Google's Nano Banana Changes AI Creativity Uncovered",
            "pub_date": "2025-09-03T00:00:00.000Z",
            "duration": "00:18:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Googles-Nano-Banana-Changes-AI-Creativity-Uncovered-e37jg5h",
            "audio_url": "https://rss.art19.com/episodes/00f5f588-40fe-4270-bb6c-d6eaac813110.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "161d3595-2b37-409f-aede-b7ffd48e687b",
            "index": 194,
            "title": "How Eight Sleep Uses AI to Redefine Recovery Future Outlook",
            "pub_date": "2025-09-02T00:00:00.000Z",
            "duration": "00:13:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/How-Eight-Sleep-Uses-AI-to-Redefine-Recovery-Future-Outlook-e37jg1s",
            "audio_url": "https://rss.art19.com/episodes/c7b92ecd-da1b-4b56-b47e-0501668c8be3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97dac165-1500-4088-8538-ecdad6a0b980",
            "index": 195,
            "title": "The AI Soundscape: Exploring 11 Labs API",
            "pub_date": "2025-08-27T00:00:00.000Z",
            "duration": "00:13:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/The-AI-Soundscape-Exploring-11-Labs-API-e37bi24",
            "audio_url": "https://rss.art19.com/episodes/734338b2-2770-419e-a4da-991d723f2c9d.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd6c2875-6822-43c6-b8a2-07ffc3c67180",
            "index": 196,
            "title": "Why Perplexity Bids To Buy Google!: How this bid rattled the entire tech world",
            "pub_date": "2025-08-18T23:00:00.000Z",
            "duration": "00:09:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Why-Perplexity-Bids-To-Buy-Google--How-this-bid-rattled-the-entire-tech-world-e36u6pc",
            "audio_url": "https://rss.art19.com/episodes/5e2f69e2-44c3-41e5-82d1-3fb886179550.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "56d2827a-949b-4bbd-9453-41335f9032b8",
            "index": 197,
            "title": "New Updates to GPT-5: Deep Dive into Smarter AI",
            "pub_date": "2025-08-18T00:00:00.000Z",
            "duration": "00:09:29",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/New-Updates-to-GPT-5-Deep-Dive-into-Smarter-AI-e36u6fn",
            "audio_url": "https://rss.art19.com/episodes/1a1d62ae-7838-487d-8735-cf8586820a0f.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d9dc55c-ee42-4b36-bcc5-ed368729d851",
            "index": 198,
            "title": "Why Datumo Could Redefine the Future of AI Training",
            "pub_date": "2025-08-17T23:00:00.000Z",
            "duration": "00:09:39",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/Why-Datumo-Could-Redefine-the-Future-of-AI-Training-e36u642",
            "audio_url": "https://rss.art19.com/episodes/d4338e59-6d4b-4927-95a1-06ada6870ae7.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13973831-3df8-4372-8054-3544e388d930",
            "index": 199,
            "title": "The OpenArt Debate: Creativity vs. Content Saturation",
            "pub_date": "2025-08-17T00:00:00.000Z",
            "duration": "00:09:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/The-OpenArt-Debate-Creativity-vs--Content-Saturation-e36u5ou",
            "audio_url": "https://rss.art19.com/episodes/26e51be8-ead8-412e-928b-4d91d7906914.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0079d043-fdcb-4cd6-95fe-a34ba96a0690",
            "index": 200,
            "title": "The Big Leap: Nvidia’s Cosmos World Model",
            "pub_date": "2025-08-16T23:00:00.000Z",
            "duration": "00:08:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://podcasters.spotify.com/pod/show/last-week-in-ai/episodes/The-Big-Leap-Nvidias-Cosmos-World-Model-e36u56t",
            "audio_url": "https://rss.art19.com/episodes/15a37ff8-da67-4f14-9eae-9473b529c7a3.mp3?rss_browser=BAhJIgtDaHJvbWUGOgZFVA%3D%3D--d05363d83ce333c74f32188013892b2863ad051c",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "decoder",
        "title": "Decoder with Nilay Patel",
        "feed_title": "Decoder with Nilay Patel",
        "priority": "P2",
        "selection_mode": "keyword",
        "focus": [
          "big tech",
          "platforms",
          "AI products",
          "regulation"
        ],
        "feed_url": "https://feeds.megaphone.fm/recodedecode",
        "source_url": "https://feeds.megaphone.fm/recodedecode",
        "detail_path": "/podcasts/decoder/",
        "episode_count": 250,
        "selected_episode_count": 184,
        "latest_episode_title": "Elon Musk is steamrolling Wall Street to become a trillionaire",
        "latest_pub_date": "2026-06-04T09:00:00.000Z",
        "latest_page_url": "",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "85a66c0e-be7b-11f0-a56a-efc9cf920887",
            "index": 1,
            "title": "Elon Musk is steamrolling Wall Street to become a trillionaire",
            "pub_date": "2026-06-04T09:00:00.000Z",
            "duration": "2931",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1516221184.mp3?updated=1780517005",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8584b5fa-be7b-11f0-a56a-cbf980623a29",
            "index": 2,
            "title": "AI is blowing up music. How should the Grammys handle it?",
            "pub_date": "2026-06-01T09:00:00.000Z",
            "duration": "3953",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7221977177.mp3?updated=1780087223",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "855d31f6-be7b-11f0-a56a-ab4ed1ad5e50",
            "index": 3,
            "title": "Rivian's software chief thinks you don't need CarPlay or buttons",
            "pub_date": "2026-05-28T09:00:00.000Z",
            "duration": "4199",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7596151508.mp3?updated=1779904436",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cfa65252-496c-11f1-9277-af6760503824",
            "index": 4,
            "title": "How Sundar Pichai is rethinking Google for the AI era",
            "pub_date": "2026-05-26T09:00:00.000Z",
            "duration": "3076",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7196104544.mp3?updated=1779740309",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "85365310-be7b-11f0-a56a-07f62e290561",
            "index": 5,
            "title": "Musk v Altman: Much ado about nothing",
            "pub_date": "2026-05-21T09:00:00.000Z",
            "duration": "2041",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4133773225.mp3?updated=1779302047",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "850e3966-be7b-11f0-a56a-4372748debf5",
            "index": 6,
            "title": "Exclusive: Jonah Peretti explains why he sold BuzzFeed",
            "pub_date": "2026-05-18T09:00:00.000Z",
            "duration": "4222",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5884518601.mp3?updated=1779032438",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "84e74054-be7b-11f0-a56a-1b2c7ac4862d",
            "index": 7,
            "title": "How companies weaponize the terms of service against you",
            "pub_date": "2026-05-14T09:00:00.000Z",
            "duration": "3276",
            "duration_label": "54m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3451575893.mp3?updated=1778704752",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 180,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "84c17130-be7b-11f0-a56a-03025de97f84",
            "index": 8,
            "title": "Joanna Stern is not a robot, but she lived with them",
            "pub_date": "2026-05-11T09:00:00.000Z",
            "duration": "3624",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3930950490.mp3?updated=1778252889",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 50,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8498c9b0-be7b-11f0-a56a-8382cb46d8eb",
            "index": 9,
            "title": "Rewind: How AI is fueling an existential crisis in education",
            "pub_date": "2026-05-07T09:00:00.000Z",
            "duration": "2525",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9742367090.mp3?updated=1778099687",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "84765b14-be7b-11f0-a56a-53febd1fc9d0",
            "index": 10,
            "title": "Dara Khosrowshahi on replacing Uber drivers — and himself — with AI",
            "pub_date": "2026-05-04T09:00:00.000Z",
            "duration": "4459",
            "duration_label": "1h 14m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1002402973.mp3?updated=1777854186",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 104,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "84553e5c-be7b-11f0-a56a-b36a1afa84b0",
            "index": 11,
            "title": "How to win — or lose — Decoder",
            "pub_date": "2026-04-30T09:00:00.000Z",
            "duration": "2700",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9677416691.mp3?updated=1777484417",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 20,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "84330832-be7b-11f0-a56a-934579470eb3",
            "index": 12,
            "title": "That UL safety logo is a lot more complicated than it looks",
            "pub_date": "2026-04-27T09:00:00.000Z",
            "duration": "3752",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7620752085.mp3?updated=1777209294",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 28,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "84129106-be7b-11f0-a56a-d7f06db0706f",
            "index": 13,
            "title": "THE PEOPLE DO NOT YEARN FOR AUTOMATION",
            "pub_date": "2026-04-23T13:30:00.000Z",
            "duration": "1146",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "anthropic",
              "claude",
              "gemini",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6832768709.mp3?updated=1776949730",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83ec9640-be7b-11f0-a56a-bfa3ae0b63fb",
            "index": 14,
            "title": "Canva's CEO on its big pivot to AI enterprise software",
            "pub_date": "2026-04-20T09:00:00.000Z",
            "duration": "4004",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8000339561.mp3?updated=1776472756",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 191,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "83cad0dc-be7b-11f0-a56a-6ba9a189ce1c",
            "index": 15,
            "title": "Ronan Farrow on Sam Altman's \"unconstrained\" relationship with the truth",
            "pub_date": "2026-04-16T09:00:00.000Z",
            "duration": "3726",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7344474300.mp3?updated=1776282631",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "83a71624-be7b-11f0-a56a-53b901858ded",
            "index": 16,
            "title": "Can Puck’s CEO reinvent the news business for the influencer age?",
            "pub_date": "2026-04-13T12:38:00.000Z",
            "duration": "4497",
            "duration_label": "1h 14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6369079890.mp3?updated=1775843222",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8382c5e4-be7b-11f0-a56a-3b7ec91bbd98",
            "index": 17,
            "title": "The AI industry's existential race for profits",
            "pub_date": "2026-04-09T09:00:00.000Z",
            "duration": "2299",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1417581812.mp3?updated=1775703088",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83619554-be7b-11f0-a56a-a311da853d5a",
            "index": 18,
            "title": "Cisco CEO Chuck Robbins wants data centers in space",
            "pub_date": "2026-04-06T09:00:00.000Z",
            "duration": "3465",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "nvidia",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5182568214.mp3?updated=1775164591",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 148,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "83374d94-be7b-11f0-a56a-cf5e69c0b210",
            "index": 19,
            "title": "A jury says Meta and Google hurt a kid. What now?",
            "pub_date": "2026-04-02T09:00:00.000Z",
            "duration": "3070",
            "duration_label": "51m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6864828885.mp3?updated=1775072555",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c295f09c-a938-11f0-a3e7-97e8e0fa8897",
            "index": 20,
            "title": "Okta's CEO is betting big on AI agent identity",
            "pub_date": "2026-03-30T09:00:00.000Z",
            "duration": "3996",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5534175057.mp3?updated=1774640732",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c329d546-a938-11f0-a3e7-7bd96a659dd8",
            "index": 21,
            "title": "Everyone hates Ticketmaster. Why'd Trump go easy on them?",
            "pub_date": "2026-03-26T09:00:00.000Z",
            "duration": "2250",
            "duration_label": "37m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9136689791.mp3?updated=1774471292",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c26ec260-a938-11f0-a3e7-43e3e87b1c4a",
            "index": 22,
            "title": "Confronting the CEO of the AI company that impersonated me",
            "pub_date": "2026-03-23T09:00:00.000Z",
            "duration": "4553",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2162470496.mp3?updated=1774232671",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 258,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c309e66e-a938-11f0-a3e7-7ffff6909a49",
            "index": 23,
            "title": "Paramount's $110 billion Warner Bros. gamble",
            "pub_date": "2026-03-19T09:00:00.000Z",
            "duration": "2888",
            "duration_label": "48m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "reasoning"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3842448869.mp3?updated=1773856127",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c247dc4a-a938-11f0-a3e7-d39cf98f6832",
            "index": 24,
            "title": "Yahoo CEO Jim Lanzone on reviving the web's homepage",
            "pub_date": "2026-03-16T13:14:00.000Z",
            "duration": "4663",
            "duration_label": "1h 17m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8687950115.mp3?updated=1773667114",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2e632f0-a938-11f0-a3e7-bba4a5ba2ba7",
            "index": 25,
            "title": "Anthropic doesn't trust the Pentagon, and neither should you",
            "pub_date": "2026-03-12T09:00:00.000Z",
            "duration": "2937",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8736665038.mp3?updated=1773265819",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c22511c4-a938-11f0-a3e7-afe3094ed3a1",
            "index": 26,
            "title": "Hasbro's CEO lets AI Peppa Pig help design toys",
            "pub_date": "2026-03-09T09:00:00.000Z",
            "duration": "4323",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8118754179.mp3?updated=1773148641",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 141,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c2bc8de2-a938-11f0-a3e7-370d83a6c178",
            "index": 27,
            "title": "Prediction markets want to be the news",
            "pub_date": "2026-03-05T10:00:00.000Z",
            "duration": "2724",
            "duration_label": "45m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4088730788.mp3?updated=1772635992",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1ff5b5a-a938-11f0-a3e7-374907ae7e8d",
            "index": 28,
            "title": "Zillow's CEO on growth during a housing crisis",
            "pub_date": "2026-03-02T10:00:00.000Z",
            "duration": "3938",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5586290357.mp3?updated=1772306255",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 151,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c1df71aa-a938-11f0-a3e7-7bc7866aaa5d",
            "index": 29,
            "title": "Inside Xbox's executive shakeup",
            "pub_date": "2026-02-26T10:00:00.000Z",
            "duration": "2588",
            "duration_label": "43m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1923817266.mp3?updated=1772056636",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 116,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c13c179e-a938-11f0-a3e7-933e43244997",
            "index": 30,
            "title": "Hank Green lets loose on YouTube, billionaires, and algorithms",
            "pub_date": "2026-02-23T10:00:00.000Z",
            "duration": "4262",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2121157585.mp3?updated=1771622669",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 197,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c1b72a92-a938-11f0-a3e7-d33b52177ddf",
            "index": 31,
            "title": "Money no longer matters to AI's top talent",
            "pub_date": "2026-02-19T10:00:00.000Z",
            "duration": "2482",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "xai",
              "grok",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5634310442.mp3?updated=1771447498",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c426ba0-0908-11f1-b6fc-4b799d354440",
            "index": 32,
            "title": "Let's talk about Ring, lost dogs, and the surveillance state",
            "pub_date": "2026-02-16T10:00:00.000Z",
            "duration": "1622",
            "duration_label": "27m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2434405154.mp3?updated=1771024045",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 176,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c1885046-a938-11f0-a3e7-03664a261404",
            "index": 33,
            "title": "The surprising case for AI judges",
            "pub_date": "2026-02-12T15:30:00.000Z",
            "duration": "4385",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3736725118.mp3?updated=1770910399",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 147,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c0ef865e-a938-11f0-a3e7-cb47f2fe047a",
            "index": 34,
            "title": "Siemens CEO's mission to automate everything",
            "pub_date": "2026-02-09T10:00:00.000Z",
            "duration": "3766",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5136814270.mp3?updated=1770396056",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c168c78a-a938-11f0-a3e7-9b7075c66393",
            "index": 35,
            "title": "Reality is losing the deepfake war",
            "pub_date": "2026-02-05T10:00:00.000Z",
            "duration": "2935",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3917335756.mp3?updated=1770241724",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 103,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c0c4a934-a938-11f0-a3e7-272b23671aeb",
            "index": 36,
            "title": "Docusign's CEO on the dangers of trusting AI to read, and write, your contracts",
            "pub_date": "2026-02-02T10:00:00.000Z",
            "duration": "3948",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7355744773.mp3?updated=1769815754",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 171,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c07c1700-a938-11f0-a3e7-4bb42848f5d8",
            "index": 37,
            "title": "Netflix is eating Hollywood — because it has to",
            "pub_date": "2026-01-29T10:00:00.000Z",
            "duration": "3348",
            "duration_label": "55m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6534600210.mp3?updated=1769638552",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bfdf03ac-a938-11f0-a3e7-d31425f4a31b",
            "index": 38,
            "title": "Experian's tech chief defends credit scores: 'We're not Palantir'",
            "pub_date": "2026-01-26T10:00:00.000Z",
            "duration": "4192",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9507220192.mp3?updated=1769203070",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 159,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c0a0eae4-a938-11f0-a3e7-efdb2a30b46b",
            "index": 39,
            "title": "Why nobody's stopping Grok",
            "pub_date": "2026-01-22T16:15:00.000Z",
            "duration": "3951",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "xai",
              "grok"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3806235291.mp3?updated=1769098963",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac98ea9a-eb11-11f0-a1d0-5f9b5b7914b8",
            "index": 40,
            "title": "Razer CEO on AI in game dev, Grok, and anime waifus",
            "pub_date": "2026-01-19T10:00:00.000Z",
            "duration": "3876",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "grok"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7054704580.mp3?updated=1768594952",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c057753a-a938-11f0-a3e7-8b7254ba89a7",
            "index": 41,
            "title": "Rewind: How private equity kills companies and communities",
            "pub_date": "2026-01-15T10:00:00.000Z",
            "duration": "3104",
            "duration_label": "51m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2295375366.mp3?updated=1768425468",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bf8b4e10-a938-11f0-a3e7-bfd37fa24ff6",
            "index": 42,
            "title": "Dropout CEO Sam Reich on the business of subscription comedy",
            "pub_date": "2026-01-12T10:00:00.000Z",
            "duration": "3865",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8436287924.mp3?updated=1767986576",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 274,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c642b2cc-d358-11ef-a25c-4bdaf5084deb",
            "index": 43,
            "title": "What’s next for Netflix and Paramount in the Warner Bros. battle",
            "pub_date": "2025-12-22T10:00:00.000Z",
            "duration": "2625",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7810156539.mp3?updated=1766177244",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c61defa0-d358-11ef-a25c-9b1aec4ce2fd",
            "index": 44,
            "title": "\"All chaos and panic\": Nilay answers your burning Decoder questions",
            "pub_date": "2025-12-18T10:00:00.000Z",
            "duration": "3413",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "gemini",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8405423059.mp3?updated=1766010696",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 104,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c5fb4f7c-d358-11ef-a25c-27a8c7ead120",
            "index": 45,
            "title": "Stack Overflow users don't trust AI. They're using it anyway",
            "pub_date": "2025-12-15T10:00:00.000Z",
            "duration": "3889",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2195361773.mp3?updated=1765577524",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5d2b54e-d358-11ef-a25c-a74e57751992",
            "index": 46,
            "title": "Sen. Ed Markey wants media companies to fight for the First Amendment",
            "pub_date": "2025-12-11T10:00:00.000Z",
            "duration": "3462",
            "duration_label": "57m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8774208588.mp3?updated=1765404115",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5af5dd8-d358-11ef-a25c-cb40721597e7",
            "index": 47,
            "title": "Square's product chief on the death of the penny and the future of money",
            "pub_date": "2025-12-08T10:00:00.000Z",
            "duration": "4427",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2876875587.mp3?updated=1764974584",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c58cee7e-d358-11ef-a25c-a783cd813065",
            "index": 48,
            "title": "The tiny team trying to keep AI from destroying everything",
            "pub_date": "2025-12-04T10:00:00.000Z",
            "duration": "2300",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "claude",
              "grok"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6761870432.mp3?updated=1764775847",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5699d20-d358-11ef-a25c-ebce244e6161",
            "index": 49,
            "title": "IBM CEO Arvind Krishna says there is no AI bubble after all",
            "pub_date": "2025-12-01T10:00:00.000Z",
            "duration": "4174",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4542090967.mp3?updated=1764183909",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 179,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 30,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "c545d674-d358-11ef-a25c-4f7f38f1169c",
            "index": 50,
            "title": "What the climate story gets wrong",
            "pub_date": "2025-11-24T10:00:00.000Z",
            "duration": "3032",
            "duration_label": "50m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8539191942.mp3?updated=1763761345",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5226270-d358-11ef-a25c-83f4148e8885",
            "index": 51,
            "title": "The DoorDash Problem: How AI browsers are a huge threat to Amazon",
            "pub_date": "2025-11-20T15:30:00.000Z",
            "duration": "1855",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1258047460.mp3?updated=1763652832",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4ff85d4-d358-11ef-a25c-932a71c99a88",
            "index": 52,
            "title": "Ring's Jamie Siminoff thinks AI can reduce crime",
            "pub_date": "2025-11-17T10:00:00.000Z",
            "duration": "4217",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3415906394.mp3?updated=1763155369",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 176,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c4dc1cd4-d358-11ef-a25c-8f6756920620",
            "index": 53,
            "title": "The company at the heart of the AI bubble",
            "pub_date": "2025-11-13T14:30:00.000Z",
            "duration": "2276",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "gpu",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5349194279.mp3?updated=1763044411",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4b8feb6-d358-11ef-a25c-334a95be7aea",
            "index": 54,
            "title": "Sir Tim Berners-Lee doesn’t think AI will destroy the web",
            "pub_date": "2025-11-10T10:00:00.000Z",
            "duration": "3325",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt",
              "gemini",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7324573858.mp3?updated=1762547524",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 138,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c49715d0-d358-11ef-a25c-574a37bf09d4",
            "index": 55,
            "title": "How AI is fueling an existential crisis in education",
            "pub_date": "2025-11-06T10:00:00.000Z",
            "duration": "2377",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6750570212.mp3?updated=1762375643",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c474fdba-d358-11ef-a25c-d3797cbf4c39",
            "index": 56,
            "title": "Lyft CEO David Risher on paying drivers more and the shift to robotaxis",
            "pub_date": "2025-11-03T10:00:00.000Z",
            "duration": "4682",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.theverge.com/podcast/811532/lyft-uber-david-risher-interview-ai-rideshare",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9084728529.mp3?updated=1761947912",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 129,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c4526caa-d358-11ef-a25c-6b7dca10154d",
            "index": 57,
            "title": "How Silicon Valley enshittified the internet",
            "pub_date": "2025-10-30T09:00:00.000Z",
            "duration": "4181",
            "duration_label": "1h 9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1382045424.mp3?updated=1761781939",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c42fa224-d358-11ef-a25c-2f82fb1f00f2",
            "index": 58,
            "title": "LexisNexis CEO says the AI law era is already here",
            "pub_date": "2025-10-27T09:00:00.000Z",
            "duration": "3907",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5540704411.mp3?updated=1761338807",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 147,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c40d05e8-d358-11ef-a25c-23a0558d3fcb",
            "index": 59,
            "title": "Why GM will give you Gemini — but not CarPlay",
            "pub_date": "2025-10-22T15:00:00.000Z",
            "duration": "4683",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2043302074.mp3?updated=1761145155",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 157,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c3eb05ba-d358-11ef-a25c-739b95a15ef9",
            "index": 60,
            "title": "Zocdoc CEO: \"Dr. Google is going to be replaced by Dr. AI\"",
            "pub_date": "2025-10-20T09:00:00.000Z",
            "duration": "3966",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9307032190.mp3?updated=1760729543",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 156,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c3c88fe4-d358-11ef-a25c-d75dcf8ae83d",
            "index": 61,
            "title": "The EV tax credit is dead. What now?",
            "pub_date": "2025-10-16T09:00:00.000Z",
            "duration": "2383",
            "duration_label": "39m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2464670023.mp3?updated=1760557594",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e0f8ff84-a947-11f0-9992-63fc7aeb394c",
            "index": 62,
            "title": "Announcing an ad-free Decoder feed for Verge subscribers",
            "pub_date": "2025-10-15T13:00:00.000Z",
            "duration": "22",
            "duration_label": "0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2533083366.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3a68dfe-d358-11ef-a25c-0fd1d58ddb7b",
            "index": 63,
            "title": "The AI industry is at a major crossroads",
            "pub_date": "2025-10-09T15:55:00.000Z",
            "duration": "2642",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6482865214.mp3?updated=1760034384",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c383d570-d358-11ef-a25c-2bd99ce74081",
            "index": 64,
            "title": "Rivian CEO on CarPlay, Lidar, and affordable EVs",
            "pub_date": "2025-10-06T09:00:00.000Z",
            "duration": "3038",
            "duration_label": "50m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5970649447.mp3?updated=1759522727",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3615338-d358-11ef-a25c-5fb384be8efe",
            "index": 65,
            "title": "The good, the bad, and the future of AI agents",
            "pub_date": "2025-10-02T09:00:00.000Z",
            "duration": "2795",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 17,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agents",
              "agentic",
              "chatgpt",
              "openai",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5990158962.mp3?updated=1759358186",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c33e6bc0-d358-11ef-a25c-27fbc9b5fe94",
            "index": 66,
            "title": "Ford CEO Jim Farley on China, tariffs, and the quest for a $30,000 EV",
            "pub_date": "2025-09-29T09:00:00.000Z",
            "duration": "3802",
            "duration_label": "1h 3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1877577507.mp3?updated=1758900513",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c31beb2c-d358-11ef-a25c-a3ddd4f42fee",
            "index": 67,
            "title": "How AI safety took a backseat to military money",
            "pub_date": "2025-09-25T09:00:00.000Z",
            "duration": "2576",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai",
              "anthropic",
              "claude",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9468300181.mp3?updated=1758738418",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2f81648-d358-11ef-a25c-839971bcb265",
            "index": 68,
            "title": "Dropout CEO Sam Reich on business, comedy, and keeping culture weird",
            "pub_date": "2025-09-22T09:00:00.000Z",
            "duration": "3960",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5453645964.mp3?updated=1758226394",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 274,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c2d3e458-d358-11ef-a25c-e77e1e6ad87f",
            "index": 69,
            "title": "How chatbots — and their makers — are enabling AI psychosis",
            "pub_date": "2025-09-18T09:00:00.000Z",
            "duration": "3011",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7025631316.mp3?updated=1758135368",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2b044a8-d358-11ef-a25c-8f0a03b3ed24",
            "index": 70,
            "title": "How brands and creators are fighting for your attention — and your money",
            "pub_date": "2025-09-15T09:00:00.000Z",
            "duration": "3667",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4381241749.mp3?updated=1757700130",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c28d6168-d358-11ef-a25c-ef915483c895",
            "index": 71,
            "title": "Sierra CEO Bret Taylor on why the AI bubble feels like the dotcom boom",
            "pub_date": "2025-09-11T09:00:00.000Z",
            "duration": "3074",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "chatgpt",
              "openai",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1790330179.mp3?updated=1757522780",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c26ae124-d358-11ef-a25c-2bc628877e76",
            "index": 72,
            "title": "Sal Khan is hopeful that AI won't destroy education",
            "pub_date": "2025-09-08T09:00:00.000Z",
            "duration": "3813",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5455064511.mp3?updated=1756315644",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c24682a2-d358-11ef-a25c-8ba90a950981",
            "index": 73,
            "title": "The quest to keep OpenAI honest",
            "pub_date": "2025-09-04T09:00:00.000Z",
            "duration": "2412",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3074830219.mp3?updated=1756926816",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c22399ea-d358-11ef-a25c-67e556c882e7",
            "index": 74,
            "title": "Rewind: Bookshop CEO's crusade to save books from Amazon",
            "pub_date": "2025-08-28T09:00:00.000Z",
            "duration": "4033",
            "duration_label": "1h 7m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5914759889.mp3?updated=1756309900",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2013940-d358-11ef-a25c-0359d12d91be",
            "index": 75,
            "title": "Is ChatGPT killing higher education?",
            "pub_date": "2025-08-25T09:00:00.000Z",
            "duration": "3421",
            "duration_label": "57m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1957488854.mp3?updated=1755806061",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1deb5fa-d358-11ef-a25c-2315c26b1f35",
            "index": 76,
            "title": "Amazon is betting on agents to win the AI race",
            "pub_date": "2025-08-21T09:00:00.000Z",
            "duration": "3230",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "chatgpt",
              "openai",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1571552110.mp3?updated=1755712018",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 135,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c1bc17de-d358-11ef-a25c-af84b8e15617",
            "index": 77,
            "title": "How the head of Obsidian went from superfan to CEO",
            "pub_date": "2025-08-18T09:00:00.000Z",
            "duration": "3262",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1110392297.mp3?updated=1755281484",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 97,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c19a1e9a-d358-11ef-a25c-7b1dca07a154",
            "index": 78,
            "title": "ChatGPT chief Nick Turley doesn't want you too attached to AI",
            "pub_date": "2025-08-14T11:14:00.000Z",
            "duration": "3314",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "xai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3455949296.mp3?updated=1755170201",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 142,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c177feb4-d358-11ef-a25c-5f91a1b41dc7",
            "index": 79,
            "title": "Notion's CEO wants you to demand better from your tools",
            "pub_date": "2025-08-11T09:00:00.000Z",
            "duration": "3333",
            "duration_label": "55m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9042736044.mp3?updated=1754877662",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 174,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c15561c4-d358-11ef-a25c-876109a0ff2f",
            "index": 80,
            "title": "GitHub's CEO says AI coding is ‘here to stay’",
            "pub_date": "2025-08-07T09:00:00.000Z",
            "duration": "3674",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "cursor",
              "github copilot",
              "coding",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3212224333.mp3?updated=1754527494",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c132e1bc-d358-11ef-a25c-df101e7c9b58",
            "index": 81,
            "title": "Why tech is racing to adopt AI coding",
            "pub_date": "2025-08-04T09:00:00.000Z",
            "duration": "3359",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "cursor",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7798240949.mp3?updated=1753982340",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 123,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c1107230-d358-11ef-a25c-e355a590589a",
            "index": 82,
            "title": "Why AI researchers are getting paid like NBA All-Stars",
            "pub_date": "2025-07-31T09:00:00.000Z",
            "duration": "2384",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "cursor",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5996890511.mp3?updated=1753966791",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0ed94b8-d358-11ef-a25c-f3b1620ef908",
            "index": 83,
            "title": "Can we ever trust an AI lawyer?",
            "pub_date": "2025-07-28T09:00:00.000Z",
            "duration": "3293",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1909831554.mp3?updated=1753938844",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 120,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c0cb7356-d358-11ef-a25c-4fa688daff24",
            "index": 84,
            "title": "We are not ready for better deepfakes",
            "pub_date": "2025-07-24T09:00:00.000Z",
            "duration": "3416",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5117310679.mp3?updated=1753938833",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c0a95f64-d358-11ef-a25c-e3818ef31a6c",
            "index": 85,
            "title": "Why tech billionaires want a ‘corporate dictatorship’",
            "pub_date": "2025-07-21T09:00:00.000Z",
            "duration": "3735",
            "duration_label": "1h 2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8936274542.mp3?updated=1753938845",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c08673e6-d358-11ef-a25c-3f63437a60ff",
            "index": 86,
            "title": "Perplexity CEO on why the browser is AI's killer app",
            "pub_date": "2025-07-17T09:00:00.000Z",
            "duration": "2985",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8736420127.mp3?updated=1753938765",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 104,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c0635a6e-d358-11ef-a25c-3bc1135fef5e",
            "index": 87,
            "title": "How decision making will change when AI answers are cheap and (too) easy",
            "pub_date": "2025-07-14T09:00:00.000Z",
            "duration": "3808",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1040178731.mp3?updated=1752520126",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 126,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c0401072-d358-11ef-a25c-83d5210744e7",
            "index": 88,
            "title": "Inside the AI startup frenzy: ‘Everyone’s pivoting, then pivoting again’",
            "pub_date": "2025-07-10T09:00:00.000Z",
            "duration": "2922",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8270158537.mp3?updated=1751998453",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c01a61c4-d358-11ef-a25c-9ff5ade71a2d",
            "index": 89,
            "title": "How SharkNinja took over the home",
            "pub_date": "2025-07-07T09:00:00.000Z",
            "duration": "5041",
            "duration_label": "1h 24m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7056685530.mp3?updated=1751900380",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 174,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a3fb183c-801d-11ef-8ba6-57f777221806",
            "index": 90,
            "title": "Why Automattic CEO Matt Mullenweg went to war over WordPress",
            "pub_date": "2025-06-30T09:00:00.000Z",
            "duration": "4141",
            "duration_label": "1h 9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8494992027.mp3?updated=1751389156",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3e89ae0-801d-11ef-8ba6-8faae0d4b730",
            "index": 91,
            "title": "Hinge CEO Justin McLeod says dating AI chatbots is 'playing with fire'",
            "pub_date": "2025-06-23T09:00:00.000Z",
            "duration": "3808",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7427857214.mp3?updated=1750687199",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 182,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a39cff72-801d-11ef-8ba6-b7a11ebba01c",
            "index": 92,
            "title": "Monopoly isn’t a game (with Lina Khan)",
            "pub_date": "2025-06-12T09:00:00.000Z",
            "duration": "3636",
            "duration_label": "1h 0m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6984843549.mp3?updated=1750082789",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3c44758-801d-11ef-8ba6-8f1370b905e8",
            "index": 93,
            "title": "Taskrabbit CEO Ania Smith isn’t afraid of AI robots replacing human labor",
            "pub_date": "2025-06-09T09:00:00.000Z",
            "duration": "4065",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5880314504.mp3?updated=1749470886",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a38a2d52-801d-11ef-8ba6-7b0ad5d680fc",
            "index": 94,
            "title": "Why Runway CEO Cris Valenzuela thinks AI filmmaking is the future",
            "pub_date": "2025-06-05T09:00:00.000Z",
            "duration": "3174",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8233770381.mp3?updated=1749073050",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3777982-801d-11ef-8ba6-0b5a04662127",
            "index": 95,
            "title": "Airbnb CEO Brian Chesky wants to build the everything app",
            "pub_date": "2025-06-02T09:00:00.000Z",
            "duration": "4411",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4629648030.mp3?updated=1749043869",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 135,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a36434da-801d-11ef-8ba6-5facb428881e",
            "index": 96,
            "title": "How private equity kills companies and communities",
            "pub_date": "2025-05-29T09:00:00.000Z",
            "duration": "2961",
            "duration_label": "49m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1589361934.mp3?updated=1748468107",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c9748492-fe92-11ef-9f94-fb950e7bcd69",
            "index": 97,
            "title": "Google CEO Sundar Pichai on the next phase of AI",
            "pub_date": "2025-05-27T09:00:00.000Z",
            "duration": "2784",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3060521789.mp3?updated=1748384642",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 111,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a3511ad0-801d-11ef-8ba6-bf445f8b20d3",
            "index": 98,
            "title": "Why Uber's CEO is okay with reinventing the bus",
            "pub_date": "2025-05-22T09:00:00.000Z",
            "duration": "3808",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6634816882.mp3?updated=1750949582",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 186,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a32c4412-801d-11ef-8ba6-074404a5bd27",
            "index": 99,
            "title": "Microsoft CTO Kevin Scott on how AI can save the web, not destroy it",
            "pub_date": "2025-05-19T16:00:00.000Z",
            "duration": "4238",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "anthropic",
              "nvidia",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7017215304.mp3?updated=1747686816",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 129,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a33e6930-801d-11ef-8ba6-0b4daca3a86e",
            "index": 100,
            "title": "Workday's new product head hopes he can make you like Workday",
            "pub_date": "2025-05-15T09:00:00.000Z",
            "duration": "4416",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2250460144.mp3?updated=1750949496",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 139,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a307ac88-801d-11ef-8ba6-af72369116d4",
            "index": 101,
            "title": "Did Apple get too big for its own good?",
            "pub_date": "2025-05-12T09:00:00.000Z",
            "duration": "4745",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8740332958.mp3?updated=1746887521",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2f57e46-801d-11ef-8ba6-7fef10a6e3c3",
            "index": 102,
            "title": "Reuters is ready to stand up for the press — and embrace AI",
            "pub_date": "2025-05-08T09:00:00.000Z",
            "duration": "3968",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4338659162.mp3?updated=1750949235",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a31a005e-801d-11ef-8ba6-c3606e24260b",
            "index": 103,
            "title": "NYT publisher AG Sulzberger on Trump, OpenAI, and the economy",
            "pub_date": "2025-05-05T09:00:00.000Z",
            "duration": "4003",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1931257653.mp3?updated=1747311415",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2e32a7a-801d-11ef-8ba6-7763ebc5daef",
            "index": 104,
            "title": "What Trump has broken in 100 days",
            "pub_date": "2025-05-01T09:00:00.000Z",
            "duration": "2905",
            "duration_label": "48m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2890537745.mp3?updated=1746472983",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2d1305e-801d-11ef-8ba6-f3f316ba3c56",
            "index": 105,
            "title": "Decoder Live: Fired FTC commissioners fight back",
            "pub_date": "2025-04-28T13:59:00.000Z",
            "duration": "3299",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4059768676.mp3?updated=1745858449",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a28491ae-801d-11ef-8ba6-431cb3b5f109",
            "index": 106,
            "title": "The case for breaking up Google has never been stronger",
            "pub_date": "2025-04-24T09:00:00.000Z",
            "duration": "4098",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7647988924.mp3?updated=1745440340",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2bdcc44-801d-11ef-8ba6-3b2b8ad260b3",
            "index": 107,
            "title": "Verizon’s consumer chief: Net neutrality ‘went literally nowhere’",
            "pub_date": "2025-04-21T09:00:00.000Z",
            "duration": "4119",
            "duration_label": "1h 8m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1495708302.mp3?updated=1747150954",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a26f4bfa-801d-11ef-8ba6-6f80f4bccc2b",
            "index": 108,
            "title": "How Trump’s tariffs actually work on the ground",
            "pub_date": "2025-04-17T09:00:00.000Z",
            "duration": "3804",
            "duration_label": "1h 3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6291474935.mp3?updated=1744913562",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2aad044-801d-11ef-8ba6-ef0f79b62677",
            "index": 109,
            "title": "Are prediction markets gambling? Robinhood's Vlad Tenev is betting not",
            "pub_date": "2025-04-14T09:00:00.000Z",
            "duration": "4501",
            "duration_label": "1h 15m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "grok"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5814997301.mp3?updated=1744645086",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 141,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a25c520c-801d-11ef-8ba6-7b2847984974",
            "index": 110,
            "title": "Why DOGE is killing the agency that stops banks from ripping you off",
            "pub_date": "2025-04-10T13:28:00.000Z",
            "duration": "2905",
            "duration_label": "48m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6317559859.mp3?updated=1744291985",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2982e12-801d-11ef-8ba6-6744abdac488",
            "index": 111,
            "title": "UiPath CEO Daniel Dines on AI agents replacing our jobs",
            "pub_date": "2025-04-07T09:00:00.000Z",
            "duration": "3998",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2318844163.mp3?updated=1744035704",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 118,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a249cfec-801d-11ef-8ba6-7b6eb838ea69",
            "index": 112,
            "title": "What AI anime memes tell us about the future of art and humanity",
            "pub_date": "2025-04-03T15:23:00.000Z",
            "duration": "3354",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7629377084.mp3?updated=1743770046",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1e8f514-801d-11ef-8ba6-4b454417856d",
            "index": 113,
            "title": "How Unity CEO Matt Bromberg stopped the ‘war’ against its customers",
            "pub_date": "2025-03-31T15:45:00.000Z",
            "duration": "4221",
            "duration_label": "1h 10m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7032939532.mp3?updated=1743438251",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a23539ec-801d-11ef-8ba6-b7dea8bd7579",
            "index": 114,
            "title": "Capitalism vs. the bird flu",
            "pub_date": "2025-03-27T09:00:00.000Z",
            "duration": "2744",
            "duration_label": "45m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2278906831.mp3?updated=1743081243",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1c38770-801d-11ef-8ba6-2fe5424fc25b",
            "index": 115,
            "title": "Splice CEO Kakul Srivastava on why push-button AI is “insulting” to musicians",
            "pub_date": "2025-03-24T09:00:00.000Z",
            "duration": "3997",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8826206407.mp3?updated=1742833770",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 185,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a2217484-801d-11ef-8ba6-ff0dcc6bb90e",
            "index": 116,
            "title": "The movement to take down Tesla",
            "pub_date": "2025-03-20T09:00:00.000Z",
            "duration": "2825",
            "duration_label": "47m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5467043149.mp3?updated=1742567292",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1d6774a-801d-11ef-8ba6-0f9b5d288e17",
            "index": 117,
            "title": "How Trump's tariff chaos is already changing global trade",
            "pub_date": "2025-03-17T09:00:00.000Z",
            "duration": "4046",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9356489387.mp3?updated=1741988923",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a20f7202-801d-11ef-8ba6-030699879b15",
            "index": 118,
            "title": "Why the Take It Down Act is a not a law, but a weapon",
            "pub_date": "2025-03-13T09:00:00.000Z",
            "duration": "2894",
            "duration_label": "48m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2109087838.mp3?updated=1744438596",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1afd040-801d-11ef-8ba6-8be08f498edb",
            "index": 119,
            "title": "Dow Jones CEO Almar Latour on AI, press freedom, and the future of news",
            "pub_date": "2025-03-10T09:00:00.000Z",
            "duration": "3871",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9382884034.mp3?updated=1744438590",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 139,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a1fbb12c-801d-11ef-8ba6-3b2732cfba33",
            "index": 120,
            "title": "Flying is still safe, for now — but the FAA isn’t",
            "pub_date": "2025-03-06T10:00:00.000Z",
            "duration": "2443",
            "duration_label": "40m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "training",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6515230354.mp3?updated=1743931959",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a19c9c3c-801d-11ef-8ba6-77938d708683",
            "index": 121,
            "title": "Amazon’s Panos Panay on the long road to Alexa’s AI overhaul",
            "pub_date": "2025-03-03T14:02:00.000Z",
            "duration": "4181",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1454035352.mp3?updated=1741019976",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 260,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a188836e-801d-11ef-8ba6-df78c59fa0c0",
            "index": 122,
            "title": "Elon Musk's polarizing ascent in the MAGA movement",
            "pub_date": "2025-02-27T10:00:00.000Z",
            "duration": "2155",
            "duration_label": "35m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2791996534.mp3?updated=1740610184",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1140106-801d-11ef-8ba6-af3899d0198f",
            "index": 123,
            "title": "Vimeo CEO Philip Moyer is betting on the human touch — and AI",
            "pub_date": "2025-02-24T10:00:00.000Z",
            "duration": "4396",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4627361086.mp3?updated=1740361903",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 145,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a1769488-801d-11ef-8ba6-bfe684bc4fd6",
            "index": 124,
            "title": "Why gaming never had its Netflix moment",
            "pub_date": "2025-02-20T10:00:00.000Z",
            "duration": "3295",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9886770404.mp3?updated=1740018464",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a162c93a-801d-11ef-8ba6-fb62e3a09d0d",
            "index": 125,
            "title": "The FCC is a now a weapon in Trump’s war on free speech",
            "pub_date": "2025-02-13T15:59:00.000Z",
            "duration": "2821",
            "duration_label": "47m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8717905033.mp3?updated=1739462769",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a126ef14-801d-11ef-8ba6-8776b2f03a48",
            "index": 126,
            "title": "Sen. Ron Wyden is here to stop Elon Musk",
            "pub_date": "2025-02-10T10:00:00.000Z",
            "duration": "3516",
            "duration_label": "58m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1958426777.mp3?updated=1742112751",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a14f9c34-801d-11ef-8ba6-8fb19e39d049",
            "index": 127,
            "title": "Elon Musk's presidency is just getting started",
            "pub_date": "2025-02-06T15:26:00.000Z",
            "duration": "2462",
            "duration_label": "41m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7587959590.mp3?updated=1741503169",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a13b7466-801d-11ef-8ba6-03fc569acafb",
            "index": 128,
            "title": "Bookshop CEO Andy Hunter's crusade to save books from Amazon",
            "pub_date": "2025-02-03T10:00:00.000Z",
            "duration": "3984",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1010493783.mp3?updated=1738460757",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0ee082a-801d-11ef-8ba6-173b7659c60d",
            "index": 129,
            "title": "DeepSeek, Stargate, and the new AI arms race",
            "pub_date": "2025-01-30T10:00:00.000Z",
            "duration": "1764",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9475147158.mp3?updated=1738202411",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1019f5c-801d-11ef-8ba6-4b90389ffffb",
            "index": 130,
            "title": "How Ciena keeps the internet online, with CEO Gary Smith",
            "pub_date": "2025-01-27T10:00:00.000Z",
            "duration": "4405",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6435914077.mp3?updated=1737817906",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a0da191e-801d-11ef-8ba6-1bac60203c85",
            "index": 131,
            "title": "How Meta's MAGA heel turn is a play for global power",
            "pub_date": "2025-01-23T10:00:00.000Z",
            "duration": "3008",
            "duration_label": "50m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2268268960.mp3?updated=1737604135",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0c7e0f0-801d-11ef-8ba6-8b1a31ddc7a8",
            "index": 132,
            "title": "Why CEO Matt Garman is willing to bet AWS on AI",
            "pub_date": "2025-01-13T10:00:00.000Z",
            "duration": "3930",
            "duration_label": "1h 5m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "anthropic",
              "nvidia",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1155018731.mp3?updated=1736548375",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 184,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a08bf07c-801d-11ef-8ba6-9311fca51c81",
            "index": 133,
            "title": "Studying online bad behavior was hard. It's going to get harder in Trump 2.0",
            "pub_date": "2025-01-06T10:00:00.000Z",
            "duration": "3433",
            "duration_label": "57m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7401827752.mp3?updated=1738784837",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33862b30-99cf-11ee-b66d-2307bcef7739",
            "index": 134,
            "title": "Answering your biggest Decoder questions",
            "pub_date": "2024-12-20T10:00:00.000Z",
            "duration": "3197",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9183763960.mp3?updated=1734703357",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8e17ea02-7b4c-11ef-9ccc-238397871ee7",
            "index": 135,
            "title": "Tech antitrust is about to get really weird",
            "pub_date": "2024-12-18T10:00:00.000Z",
            "duration": "2188",
            "duration_label": "36m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3443736132.mp3?updated=1734478567",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "63fc8dfa-9eb0-11ee-9922-230727d4627b",
            "index": 136,
            "title": "Arm CEO Rene Haas on the AI chip race, Intel, and what Trump means for tech",
            "pub_date": "2024-12-16T10:00:00.000Z",
            "duration": "2497",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9708266587.mp3?updated=1734127481",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "33576408-99cf-11ee-b66d-c3eba31132b1",
            "index": 137,
            "title": "Platforms need the news, but they're killing it",
            "pub_date": "2024-12-13T10:00:00.000Z",
            "duration": "3227",
            "duration_label": "53m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2688868804.mp3?updated=1734045191",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8dd8be72-7b4c-11ef-9ccc-9350fa09ecfc",
            "index": 138,
            "title": "Why every company wants a podcast now",
            "pub_date": "2024-12-11T10:00:00.000Z",
            "duration": "2281",
            "duration_label": "38m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8637052197.mp3?updated=1738784858",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "63c57b94-9eb0-11ee-9922-d33a7e064dd0",
            "index": 139,
            "title": "Microsoft AI CEO Mustafa Suleyman says conversational AI is the next web browser",
            "pub_date": "2024-12-09T10:00:00.000Z",
            "duration": "4385",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "deepmind",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3665150620.mp3?updated=1733710548",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 131,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "332b854a-99cf-11ee-b66d-87de1d0502be",
            "index": 140,
            "title": "AI is a money pit — here’s why investors don’t mind",
            "pub_date": "2024-12-05T14:41:00.000Z",
            "duration": "2039",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2378540522.mp3?updated=1733438637",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "638a0b54-9eb0-11ee-9922-5308b4a58e38",
            "index": 141,
            "title": "Rewind: Bluesky CEO Jay Graber on the future of federated social media",
            "pub_date": "2024-12-02T10:00:00.000Z",
            "duration": "4246",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3745558271.mp3?updated=1733245161",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 155,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b2d36286-a2b6-11ef-be18-0f552333c1df",
            "index": 142,
            "title": "GoDaddy CEO Aman Bhutani on the enduring power of the website",
            "pub_date": "2024-11-25T12:04:00.000Z",
            "duration": "3196",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1525493538.mp3?updated=1732536523",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 143,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "32ffc7de-99cf-11ee-b66d-6305b8628b91",
            "index": 143,
            "title": "Remix: Google Zero is here — now what?",
            "pub_date": "2024-11-21T10:00:00.000Z",
            "duration": "1801",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4460392505.mp3?updated=1736662190",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 14,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "20c92c5a-9eb0-11ee-bcd3-abc671a110a3",
            "index": 144,
            "title": "Will the world end before I can retire?",
            "pub_date": "2024-11-18T10:00:00.000Z",
            "duration": "2462",
            "duration_label": "41m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9022379557.mp3?updated=1736662198",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "32d41cf6-99cf-11ee-b66d-6f8334f511f0",
            "index": 145,
            "title": "How Trump’s second term could be bad for EVs, but great for Tesla",
            "pub_date": "2024-11-14T10:00:00.000Z",
            "duration": "2156",
            "duration_label": "35m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5390607713.mp3?updated=1735459921",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "209b229c-9eb0-11ee-bcd3-77d451385d39",
            "index": 146,
            "title": "Why the Grammys need to change, with CEO Harvey Mason Jr.",
            "pub_date": "2024-11-11T10:00:00.000Z",
            "duration": "4259",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7036835573.mp3?updated=1731338776",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "32a7ea96-99cf-11ee-b66d-3f6560eef21e",
            "index": 147,
            "title": "Return-to-office mandates are more than \"backdoor layoffs\"",
            "pub_date": "2024-11-07T10:00:00.000Z",
            "duration": "2354",
            "duration_label": "39m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1134498401.mp3?updated=1730929879",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2069d868-9eb0-11ee-bcd3-675841437b83",
            "index": 148,
            "title": "Why GM ditched CarPlay, with software boss Baris Cetinok",
            "pub_date": "2024-11-04T10:00:00.000Z",
            "duration": "4235",
            "duration_label": "1h 10m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4070428648.mp3?updated=1730498601",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "327c041c-99cf-11ee-b66d-33ae1d8fece9",
            "index": 149,
            "title": "“It’s the First Amendment, stupid”",
            "pub_date": "2024-10-31T09:00:00.000Z",
            "duration": "2322",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1584058442.mp3?updated=1734240295",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4115000-9eaf-11ee-a873-93a9e6c35539",
            "index": 150,
            "title": "Airbnb CEO Brian Chesky on what founder mode really means",
            "pub_date": "2024-10-28T09:00:00.000Z",
            "duration": "4305",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1445283307.mp3?updated=1730140723",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 196,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "325010aa-99cf-11ee-b66d-2bbfb8b4b48b",
            "index": 151,
            "title": "The AI arms race to build digital god",
            "pub_date": "2024-10-24T09:00:00.000Z",
            "duration": "2578",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "openai",
              "anthropic",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7910696119.mp3?updated=1729779092",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3e1b688-9eaf-11ee-a873-a7fc9a0aa2a2",
            "index": 152,
            "title": "Intuit asked us to delete part of this Decoder episode",
            "pub_date": "2024-10-21T09:00:00.000Z",
            "duration": "3413",
            "duration_label": "56m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5086046739.mp3?updated=1734240309",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 108,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "322407da-99cf-11ee-b66d-0b6e00619f2c",
            "index": 153,
            "title": "How influencers are changing advertising with Digitas CEO Amy Lanzi",
            "pub_date": "2024-10-17T14:01:00.000Z",
            "duration": "3650",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9026769685.mp3?updated=1729173897",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "370cf766-867d-11ef-9711-a740bde94b41",
            "index": 154,
            "title": "Duolingo CEO Luis Von Ahn wants you addicted to learning",
            "pub_date": "2024-10-14T09:00:00.000Z",
            "duration": "4795",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://www.theverge.com/e/24031882",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4467255668.mp3?updated=1729016449",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 255,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "31f83132-99cf-11ee-b66d-1726734294b7",
            "index": 155,
            "title": "The impossible dream of good workplace software",
            "pub_date": "2024-10-10T09:00:00.000Z",
            "duration": "3022",
            "duration_label": "50m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3131158198.mp3?updated=1728521815",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3b2756c-9eaf-11ee-a873-9326cad30ba8",
            "index": 156,
            "title": "Rabbit CEO Jesse Lyu isn't thinking too far ahead",
            "pub_date": "2024-10-07T09:00:00.000Z",
            "duration": "4735",
            "duration_label": "1h 18m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7276434006.mp3?updated=1728517541",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 315,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "31cbff5e-99cf-11ee-b66d-03dd19561435",
            "index": 157,
            "title": "The toxic transformation of Warcraft maker Blizzard",
            "pub_date": "2024-10-03T09:00:00.000Z",
            "duration": "2976",
            "duration_label": "49m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3724210261.mp3?updated=1727905932",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6715cf0c-9eaf-11ee-bdec-8bcda1f49520",
            "index": 158,
            "title": "NBCU's streaming chief isn't worried about you canceling cable",
            "pub_date": "2024-09-30T09:00:00.000Z",
            "duration": "4294",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7146189365.mp3?updated=1727614145",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "31a00476-99cf-11ee-b66d-0fed62114e5f",
            "index": 159,
            "title": "Why Mark Zuckerberg wants to end the smartphone era",
            "pub_date": "2024-09-25T17:21:00.000Z",
            "duration": "4015",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llama",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2376649621.mp3?updated=1727288695",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 157,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "66e64854-9eaf-11ee-bdec-3f883bdc6486",
            "index": 160,
            "title": "Arc creator Josh Miller on why you need a better browser than Chrome",
            "pub_date": "2024-09-23T09:00:00.000Z",
            "duration": "4100",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3893514679.mp3?updated=1726873630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 229,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "31735156-99cf-11ee-b66d-0f7bc827cca8",
            "index": 161,
            "title": "Why Google is back in court for another monopoly showdown",
            "pub_date": "2024-09-19T13:10:00.000Z",
            "duration": "1888",
            "duration_label": "31m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8899353960.mp3?updated=1726751762",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66b71598-9eaf-11ee-bdec-57620c3c85e1",
            "index": 162,
            "title": "How Philips CEO Roy Jakobs is turning the company around after major recall",
            "pub_date": "2024-09-16T09:00:00.000Z",
            "duration": "4032",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1554696126.mp3?updated=1728473043",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 167,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3146ddce-99cf-11ee-b66d-47455fd3e2bf",
            "index": 163,
            "title": "Why AI image editing isn’t “just like Photoshop”",
            "pub_date": "2024-09-12T09:00:00.000Z",
            "duration": "2510",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "xai",
              "grok"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6456472736.mp3?updated=1726101483",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6686053e-9eaf-11ee-bdec-3f0e84dd5824",
            "index": 164,
            "title": "Anthropic’s Mike Krieger wants to build AI products that are worth the hype",
            "pub_date": "2024-09-09T09:00:00.000Z",
            "duration": "4759",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 15,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "claude",
              "perplexity",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4116751505.mp3?updated=1725838527",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 165,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "311a9944-99cf-11ee-b66d-ab377bfc5eda",
            "index": 165,
            "title": "How the Wayback Machine is fighting linkrot",
            "pub_date": "2024-09-05T09:00:00.000Z",
            "duration": "2401",
            "duration_label": "40m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9760484989.mp3?updated=1725492614",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "30ee54c4-99cf-11ee-b66d-63c162e94912",
            "index": 166,
            "title": "The AI election deepfakes have arrived",
            "pub_date": "2024-08-29T09:00:00.000Z",
            "duration": "2466",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "claude",
              "gemini",
              "grok",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2328273902.mp3?updated=1728473065",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1df4b388-9eaf-11ee-8f31-bba4e461a719",
            "index": 167,
            "title": "Disney Is a Tech Company?",
            "pub_date": "2024-08-26T09:00:00.000Z",
            "duration": "2303",
            "duration_label": "38m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2283906737.mp3?updated=1724420775",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "30c1eba0-99cf-11ee-b66d-0f4c6312179b",
            "index": 168,
            "title": "How The Onion is saving itself from the digital media death spiral",
            "pub_date": "2024-08-22T09:00:00.000Z",
            "duration": "3468",
            "duration_label": "57m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1322340922.mp3?updated=1724273809",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 186,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1db52222-9eaf-11ee-8f31-d7713b856fd8",
            "index": 169,
            "title": "GitHub CEO Thomas Dohmke says the AI industry needs competition to thrive",
            "pub_date": "2024-08-19T09:00:00.000Z",
            "duration": "4594",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "deepmind",
              "github copilot",
              "coding",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1337251400.mp3?updated=1723840776",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 175,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "30948278-99cf-11ee-b66d-03e32bd90515",
            "index": 170,
            "title": "What's next for the controversial 'child safety' internet bill",
            "pub_date": "2024-08-15T09:00:00.000Z",
            "duration": "2302",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5204812759.mp3?updated=1723684065",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d744b80-9eaf-11ee-8f31-eb90f30745c6",
            "index": 171,
            "title": "Replika CEO Eugenia Kuyda says it’s okay if we end up marrying AI chatbots",
            "pub_date": "2024-08-12T09:00:00.000Z",
            "duration": "4086",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1552766688.mp3?updated=1723562117",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 156,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "306772f6-99cf-11ee-b66d-77a37f7bfcca",
            "index": 172,
            "title": "DOJ antitrust chief is ‘overjoyed’ after Google monopoly verdict",
            "pub_date": "2024-08-08T15:58:50.000Z",
            "duration": "2627",
            "duration_label": "43m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1579685139.mp3?updated=1723133406",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 118,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1d2ef116-9eaf-11ee-8f31-2b8a0be4d7b8",
            "index": 173,
            "title": "Booking CEO Glenn Fogel wants you to take out your travel frustrations on AI chatbots",
            "pub_date": "2024-08-05T09:00:00.000Z",
            "duration": "4377",
            "duration_label": "1h 12m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1663880608.mp3?updated=1723231834",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 183,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "303b0efa-99cf-11ee-b66d-1f43014dd03f",
            "index": 174,
            "title": "AI has a climate problem — but so does all of tech",
            "pub_date": "2024-08-01T09:00:00.000Z",
            "duration": "1962",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8976523437.mp3?updated=1722480573",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c6374b92-9eae-11ee-9174-c7749a975248",
            "index": 175,
            "title": "Logitech CEO Hanneke Faber wants your next mouse to last forever",
            "pub_date": "2024-07-29T09:00:00.000Z",
            "duration": "3686",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4869587662.mp3?updated=1722023563",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 191,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "300f5d1e-99cf-11ee-b66d-0b21637317d7",
            "index": 176,
            "title": "The Supreme Court ruling that could kill net neutrality",
            "pub_date": "2024-07-25T09:00:00.000Z",
            "duration": "2289",
            "duration_label": "38m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5985802532.mp3?updated=1725764551",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c6031db8-9eae-11ee-9174-4f5d819755b3",
            "index": 177,
            "title": "Rivian CEO RJ Scaringe says too many carmakers are copying Tesla",
            "pub_date": "2024-07-22T09:00:00.000Z",
            "duration": "3828",
            "duration_label": "1h 3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6095454868.mp3?updated=1721423466",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2fe38266-99cf-11ee-b66d-6f9cd4712a7f",
            "index": 178,
            "title": "What happened to the metaverse?",
            "pub_date": "2024-07-18T09:00:00.000Z",
            "duration": "2657",
            "duration_label": "44m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7152737526.mp3?updated=1721308423",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5ce81fc-9eae-11ee-9174-2f53d8d196e3",
            "index": 179,
            "title": "Biden’s top tech advisor on why AI safety is a “today problem”",
            "pub_date": "2024-07-15T09:00:00.000Z",
            "duration": "3654",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "openai",
              "chips",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7332747822.mp3?updated=1721048067",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 119,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2fb73d00-99cf-11ee-b66d-63d1d997ecd4",
            "index": 180,
            "title": "Why The Atlantic signed a deal with OpenAI",
            "pub_date": "2024-07-11T09:00:00.000Z",
            "duration": "3088",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "perplexity",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9762163659.mp3?updated=1720705510",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c59a8744-9eae-11ee-9174-b793ab6a0840",
            "index": 181,
            "title": "Canva CEO Melanie Perkins is happy to provide designers alternatives to Adobe",
            "pub_date": "2024-07-08T09:00:00.000Z",
            "duration": "3989",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3326370713.mp3?updated=1724748569",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 171,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c5640d04-9eae-11ee-9174-93a3824dc0b0",
            "index": 182,
            "title": "How Big Green Egg CEO Dan Gertsacov is getting zoomers into the cult of kamado cooking",
            "pub_date": "2024-07-01T09:00:00.000Z",
            "duration": "4560",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1511703048.mp3?updated=1719607440",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 146,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 16,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "2f8b37fa-99cf-11ee-b66d-97d02638fc30",
            "index": 183,
            "title": "The rise of shadow lobbying and its influence on decades of US policy",
            "pub_date": "2024-06-27T09:00:00.000Z",
            "duration": "2753",
            "duration_label": "45m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8303981161.mp3?updated=1719418481",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6ca19c5e-9eae-11ee-b73c-53307db26e94",
            "index": 184,
            "title": "Netflix co-CEO Greg Peters on the streamer's shifting culture and where ads, AI, and games fit in",
            "pub_date": "2024-06-24T12:37:00.000Z",
            "duration": "4005",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7053933409.mp3?updated=1719233002",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 153,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1457471c-2ce6-11ef-9d7c-c7f31e58886b",
            "index": 185,
            "title": "Inside the players and politics of the AI industry",
            "pub_date": "2024-06-20T09:00:00.000Z",
            "duration": "2740",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "openai",
              "anthropic",
              "xai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4000471261.mp3?updated=1718730645",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c6f43c6-9eae-11ee-b73c-27dc0d527167",
            "index": 186,
            "title": "Why Tubi CEO Anjali Sud thinks free TV can win again",
            "pub_date": "2024-06-17T09:00:00.000Z",
            "duration": "4041",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3309174751.mp3?updated=1718645210",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 120,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2f5f9096-99cf-11ee-b66d-9f3dabea51a3",
            "index": 187,
            "title": "Remix: How private equity took over everything",
            "pub_date": "2024-06-13T09:00:00.000Z",
            "duration": "2347",
            "duration_label": "39m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4148642344.mp3?updated=1724755926",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c3d72c4-9eae-11ee-b73c-1b8f70a5c63e",
            "index": 188,
            "title": "AI will make money sooner than you think, says Cohere CEO Aidan Gomez",
            "pub_date": "2024-06-10T09:00:00.000Z",
            "duration": "4221",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "deepmind",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2798911276.mp3?updated=1724755933",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 156,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2f337bbe-99cf-11ee-b66d-fb7a4b606700",
            "index": 189,
            "title": "Why the video game industry is such a mess",
            "pub_date": "2024-06-06T09:00:00.000Z",
            "duration": "2271",
            "duration_label": "37m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9137823133.mp3?updated=1717619891",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c09719a-9eae-11ee-b73c-03c04f9b09a5",
            "index": 190,
            "title": "Zoom CEO Eric Yuan wants AI clones in meetings",
            "pub_date": "2024-06-03T09:00:00.000Z",
            "duration": "3682",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9682534565.mp3?updated=1717185497",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 139,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2f07c078-99cf-11ee-b66d-2be32e431c07",
            "index": 191,
            "title": "Google Zero is here. Now what?",
            "pub_date": "2024-05-30T09:00:00.000Z",
            "duration": "1677",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5635164199.mp3?updated=1717033911",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2edb8918-99cf-11ee-b66d-bb355b88a394",
            "index": 192,
            "title": "How the FBI built its own smartphone company to hack the criminal underworld",
            "pub_date": "2024-05-23T09:00:00.000Z",
            "duration": "2523",
            "duration_label": "42m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7120365046.mp3?updated=1716483978",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "26ad4ef0-9eae-11ee-ab8b-0f8d6f573202",
            "index": 193,
            "title": "Google's Sundar Pichai on AI-powered search and the future of the web",
            "pub_date": "2024-05-20T09:00:00.000Z",
            "duration": "2680",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1668861388.mp3?updated=1716166577",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 111,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2eaf9326-99cf-11ee-b66d-13620f506c76",
            "index": 194,
            "title": "TikTok's big bet to fight the ban bill",
            "pub_date": "2024-05-16T09:00:00.000Z",
            "duration": "2795",
            "duration_label": "46m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1241317430.mp3?updated=1715810702",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "267c4288-9eae-11ee-ab8b-6359ebbbeaa1",
            "index": 195,
            "title": "Why Adobe CEO Shantanu Narayen is confident we'll all adapt to AI",
            "pub_date": "2024-05-13T15:02:00.000Z",
            "duration": "3645",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5777384831.mp3?updated=1715612897",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 100,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2e8362ec-99cf-11ee-b66d-b791214402bf",
            "index": 196,
            "title": "Why the tech industry can’t crack the smart home",
            "pub_date": "2024-05-09T09:00:00.000Z",
            "duration": "2445",
            "duration_label": "40m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4426363578.mp3?updated=1720202901",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "264b818e-9eae-11ee-ab8b-ff91957719af",
            "index": 197,
            "title": "Polestar CEO Thomas Ingenlath on life after Volvo and weathering the EV slowdown",
            "pub_date": "2024-05-06T09:00:00.000Z",
            "duration": "3850",
            "duration_label": "1h 4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9895093280.mp3?updated=1714956382",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e565c8e-99cf-11ee-b66d-53428a5232d2",
            "index": 198,
            "title": "Understanding the chaos at Tesla",
            "pub_date": "2024-05-02T09:00:00.000Z",
            "duration": "2391",
            "duration_label": "39m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7185016793.mp3?updated=1714652940",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bebbe73e-9ead-11ee-b35f-1f1ae17ecc47",
            "index": 199,
            "title": "Mercedes-Benz CEO Ola Källenius explains why EVs are still the future — but Apple's next-gen CarPlay isn't",
            "pub_date": "2024-04-29T09:00:00.000Z",
            "duration": "4104",
            "duration_label": "1h 8m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7329808346.mp3?updated=1720202867",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e29c94e-99cf-11ee-b66d-678c328ab2a2",
            "index": 200,
            "title": "Why the TikTok ban won't solve the US's online privacy problems",
            "pub_date": "2024-04-25T16:11:00.000Z",
            "duration": "2850",
            "duration_label": "47m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3226851766.mp3?updated=1714061774",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be8b174e-9ead-11ee-b35f-275cfb433f5e",
            "index": 201,
            "title": "Discord CEO Jason Citron makes the case for a smaller, more private internet",
            "pub_date": "2024-04-22T09:00:00.000Z",
            "duration": "3513",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2694474455.mp3?updated=1713561446",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 130,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2dfde7d4-99cf-11ee-b66d-8faf4da88f0d",
            "index": 202,
            "title": "Disney just fought off a shareholder revolt — but the clock’s still ticking",
            "pub_date": "2024-04-18T09:00:00.000Z",
            "duration": "2577",
            "duration_label": "42m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3349553864.mp3?updated=1713449049",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be5a3638-9ead-11ee-b35f-8bbdd86947f3",
            "index": 203,
            "title": "Dropbox CEO Drew Houston wants you to embrace AI and remote work",
            "pub_date": "2024-04-15T09:00:00.000Z",
            "duration": "3896",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8728874067.mp3?updated=1712972267",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 150,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2dd1d266-99cf-11ee-b66d-035b264a4be8",
            "index": 204,
            "title": "The rise and fall of Vice Media",
            "pub_date": "2024-04-11T09:00:00.000Z",
            "duration": "2583",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1508179792.mp3?updated=1720202952",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be28e952-9ead-11ee-b35f-2f1c182f56f9",
            "index": 205,
            "title": "Why Cloudflare CEO Matthew Prince is the internet’s unlikely defender",
            "pub_date": "2024-04-08T09:00:00.000Z",
            "duration": "4760",
            "duration_label": "1h 19m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6668376609.mp3?updated=1712262499",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2da41e98-99cf-11ee-b66d-bbe116a93500",
            "index": 206,
            "title": "Why Nintendo sued a Switch emulator out of existence",
            "pub_date": "2024-04-04T09:00:00.000Z",
            "duration": "2580",
            "duration_label": "43m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6955084589.mp3?updated=1712196073",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bdf8dee2-9ead-11ee-b35f-c3372799f355",
            "index": 207,
            "title": "Mailchimp CEO Rania Succar on culture, acquisitions, and how big 'small business' really is",
            "pub_date": "2024-04-01T09:00:00.000Z",
            "duration": "3973",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3748296163.mp3?updated=1711979253",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 156,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "2d784ac0-99cf-11ee-b66d-83bbf990f687",
            "index": 208,
            "title": "Can you patent a pizza?",
            "pub_date": "2024-03-28T13:12:00.000Z",
            "duration": "3165",
            "duration_label": "52m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4629328258.mp3?updated=1711547719",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "30e99d84-9ead-11ee-bdf7-5bb4e5693a5a",
            "index": 209,
            "title": "Federation is the future of social media, says Bluesky CEO Jay Graber",
            "pub_date": "2024-03-25T09:00:00.000Z",
            "duration": "4248",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6535735176.mp3?updated=1711142636",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 155,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2d4be340-99cf-11ee-b66d-3fddc2ea0157",
            "index": 210,
            "title": "How Europe’s Digital Markets Act is reshaping Big Tech",
            "pub_date": "2024-03-21T09:00:00.000Z",
            "duration": "1950",
            "duration_label": "32m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1813924050.mp3?updated=1710971525",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "30b83488-9ead-11ee-bdf7-dba9bc2a6e79",
            "index": 211,
            "title": "Figma CEO Dylan Field is optimistic about the future and AI",
            "pub_date": "2024-03-18T09:00:00.000Z",
            "duration": "3229",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9254127659.mp3?updated=1715202907",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 146,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2d1ed580-99cf-11ee-b66d-ebdfd9e9cd1e",
            "index": 212,
            "title": "Why Google Search feels like it’s gotten worse",
            "pub_date": "2024-03-14T09:00:00.000Z",
            "duration": "2370",
            "duration_label": "39m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1717167074.mp3?updated=1710362540",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3087d054-9ead-11ee-bdf7-63c94ca35dd3",
            "index": 213,
            "title": "How to save culture from the algorithms, with Filterworld author Kyle Chayka",
            "pub_date": "2024-03-11T09:00:00.000Z",
            "duration": "4059",
            "duration_label": "1h 7m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2325750137.mp3?updated=1709925188",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2cf2a1b8-99cf-11ee-b66d-e7acb45c0b46",
            "index": 214,
            "title": "Why people are falling in love with AI chatbots",
            "pub_date": "2024-03-07T10:00:00.000Z",
            "duration": "2427",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3602587152.mp3?updated=1713280293",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "305679e6-9ead-11ee-bdf7-b7c082bfa2b6",
            "index": 215,
            "title": "Guest host Hank Green makes Nilay Patel explain why websites have a future",
            "pub_date": "2024-03-04T10:00:00.000Z",
            "duration": "3803",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7963266249.mp3?updated=1709753296",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 206,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2cc6ccfa-99cf-11ee-b66d-7fec62141ef8",
            "index": 216,
            "title": "AI deepfakes are cheap, easy, and coming for the 2024 election",
            "pub_date": "2024-02-29T10:00:00.000Z",
            "duration": "2476",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4593546518.mp3?updated=1713280280",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cb08f974-9eac-11ee-b113-8b4010d2819f",
            "index": 217,
            "title": "Crunchyroll President Rahul Purini on how anime took over the world",
            "pub_date": "2024-02-26T10:00:00.000Z",
            "duration": "4211",
            "duration_label": "1h 10m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8013862798.mp3?updated=1708727921",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2c9aec0c-99cf-11ee-b66d-7f06a3d46fca",
            "index": 218,
            "title": "Is the Apple Vision Pro All That?",
            "pub_date": "2024-02-22T10:00:00.000Z",
            "duration": "3889",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3648532775.mp3?updated=1708529581",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2c6dc740-99cf-11ee-b66d-fb430b901380",
            "index": 219,
            "title": "How AI copyright lawsuits could make the whole industry go extinct",
            "pub_date": "2024-02-15T10:00:00.000Z",
            "duration": "2402",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8227343508.mp3?updated=1707949809",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cad7c76e-9eac-11ee-b113-6bf981d31f79",
            "index": 220,
            "title": "DOJ’s Jonathan Kanter says the antitrust fight against Big Tech is just beginning",
            "pub_date": "2024-02-12T10:00:00.000Z",
            "duration": "2069",
            "duration_label": "34m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3899467556.mp3?updated=1707707750",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2c41c65e-99cf-11ee-b66d-bfd16305568e",
            "index": 221,
            "title": "Why EV adoption in the US has hit a roadblock",
            "pub_date": "2024-02-08T10:00:00.000Z",
            "duration": "2530",
            "duration_label": "42m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3698492284.mp3?updated=1707348826",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "caa3b29e-9eac-11ee-b113-03c9ad8f527f",
            "index": 222,
            "title": "Platformer’s Casey Newton on surviving the great media collapse and what comes next",
            "pub_date": "2024-02-05T10:00:00.000Z",
            "duration": "4127",
            "duration_label": "1h 8m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4521893340.mp3?updated=1706908172",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 176,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2688897c-613b-11ee-90e0-e3ab60533aeb",
            "index": 223,
            "title": "Why Sen. Brian Schatz thinks child safety bills can trump the First Amendment",
            "pub_date": "2024-01-30T10:00:00.000Z",
            "duration": "4170",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8538722190.mp3?updated=1706629322",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 111,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "265b967e-613b-11ee-90e0-0fb574dd9f0c",
            "index": 224,
            "title": "Rep. Ro Khanna on what it will take for Congress to regulate AI, privacy, and social media",
            "pub_date": "2024-01-23T10:00:00.000Z",
            "duration": "3241",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "anthropic",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4622943812.mp3?updated=1705962405",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 93,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "262b08d8-613b-11ee-90e0-f3be137f702a",
            "index": 225,
            "title": "How Adobe is managing the AI copyright dilemma, with general counsel Dana Rao",
            "pub_date": "2024-01-09T10:00:00.000Z",
            "duration": "5138",
            "duration_label": "1h 25m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7196991987.mp3?updated=1704742055",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 207,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8020034a-9faa-11ee-9ff0-f72d1d106f2f",
            "index": 226,
            "title": "How Donald Trump and Elon Musk killed Twitter, with Marty Baron and Zoe Schiffer",
            "pub_date": "2023-12-21T10:00:00.000Z",
            "duration": "2371",
            "duration_label": "39m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1404169795.mp3?updated=1710862542",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2f15b94c-350f-11ed-8d52-d790f696af83",
            "index": 227,
            "title": "Why Flexport CEO Ryan Petersen took his company back",
            "pub_date": "2023-12-19T10:00:00.000Z",
            "duration": "3960",
            "duration_label": "1h 6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2208387073.mp3?updated=1707762298",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2eff6b56-350f-11ed-8d52-b735f4374d5e",
            "index": 228,
            "title": "USDS head Mina Hsiang wants Big Tech’s best minds to help fix the government",
            "pub_date": "2023-12-12T10:00:00.000Z",
            "duration": "3886",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9992763271.mp3?updated=1702426207",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 129,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2ee64a4a-350f-11ed-8d52-3fb61862057d",
            "index": 229,
            "title": "IBM's Jerry Chow explains the next phase of quantum computing",
            "pub_date": "2023-12-05T10:00:00.000Z",
            "duration": "3355",
            "duration_label": "55m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6513371576.mp3?updated=1701796822",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 140,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2eb97f56-350f-11ed-8d52-d7536f93f753",
            "index": 230,
            "title": "Wix CEO Avishai Abrahami isn’t worried AI will kill the web",
            "pub_date": "2023-11-28T10:00:00.000Z",
            "duration": "4296",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7429168435.mp3?updated=1701126159",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 270,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2ecfdefe-350f-11ed-8d52-8307c4142735",
            "index": 231,
            "title": "Chaos at OpenAI: What happened to Sam Altman, and what's next",
            "pub_date": "2023-11-20T20:46:00.000Z",
            "duration": "4157",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7456853100.mp3?updated=1700518017",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ea3361a-350f-11ed-8d52-3730a9bb757c",
            "index": 232,
            "title": "Volvo CEO Jim Rowan thinks dropping CarPlay is a mistake",
            "pub_date": "2023-11-14T10:00:00.000Z",
            "duration": "4031",
            "duration_label": "1h 7m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9824683748.mp3?updated=1699922861",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e8ccb00-350f-11ed-8d52-e34e831b2fbb",
            "index": 233,
            "title": "Barack Obama on AI, free speech, and the future of the internet",
            "pub_date": "2023-11-07T10:00:00.000Z",
            "duration": "2868",
            "duration_label": "47m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "chatgpt",
              "openai",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4923322055.mp3?updated=1699319157",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 146,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2e5f4dce-350f-11ed-8d52-ff7110c149dc",
            "index": 234,
            "title": "AI is on a collision course with the music industry. Reservoir's Golnar Khosrowshahi thinks there’s a way through it",
            "pub_date": "2023-10-31T09:00:00.000Z",
            "duration": "3399",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7526387923.mp3?updated=1698759145",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 239,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2e765528-350f-11ed-8d52-bf85006e2bdc",
            "index": 235,
            "title": "Harvard professor Lawrence Lessig on why AI and social media are causing a free speech crisis for the internet",
            "pub_date": "2023-10-24T09:00:00.000Z",
            "duration": "3289",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP7845495358.mp3?updated=1698159174",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 124,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2e47f3fe-350f-11ed-8d52-a7446d6bec51",
            "index": 236,
            "title": "Clearview AI and the end of privacy, with author Kashmir Hill",
            "pub_date": "2023-10-17T09:00:00.000Z",
            "duration": "3709",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3486447209.mp3?updated=1697640136",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 147,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b86d1cc2-4287-11ee-84f6-c313b8134c83",
            "index": 237,
            "title": "CEO David Baszucki's mission to make Roblox a billion-player platform",
            "pub_date": "2023-10-12T09:00:00.000Z",
            "duration": "1914",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP6061381604.mp3?updated=1701794867",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 87,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2e30db6a-350f-11ed-8d52-3b6f1038f73c",
            "index": 238,
            "title": "Rivian CEO RJ Scaringe on ramping up R1T production and competing with the Cybertruck",
            "pub_date": "2023-10-10T09:00:00.000Z",
            "duration": "2412",
            "duration_label": "40m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP9694184656.mp3?updated=1696904013",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b846bc1c-4287-11ee-84f6-479398980580",
            "index": 239,
            "title": "Getty Images CEO Craig Peters has a plan to defend photography from AI",
            "pub_date": "2023-10-05T09:00:00.000Z",
            "duration": "2048",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2286825627.mp3?updated=1701794882",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 83,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2e19da50-350f-11ed-8d52-1b3b4c990275",
            "index": 240,
            "title": "Microsoft CTO Kevin Scott on how AI and art will coexist in the future",
            "pub_date": "2023-10-03T09:00:00.000Z",
            "duration": "2651",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "nvidia",
              "chips",
              "training"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP3068930806.mp3?updated=1701794730",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 109,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b7fd910e-4287-11ee-84f6-7b700edb5381",
            "index": 241,
            "title": "'The Android of agriculture': Monarch Tractor CEO Praveen Penmetsa on the future of farming",
            "pub_date": "2023-09-30T09:00:00.000Z",
            "duration": "1691",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chips"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1029167058.mp3?updated=1701794919",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 66,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b8224832-4287-11ee-84f6-17b2c770d928",
            "index": 242,
            "title": "AMD CEO Lisa Su on the AI revolution",
            "pub_date": "2023-09-29T14:00:00.000Z",
            "duration": "2145",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "gpu",
              "chip",
              "chips",
              "ai startup"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP8955394685.mp3?updated=1701794902",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 92,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "available",
              "cn_knowledge_insight_count": 20,
              "processing_next_action": "ready_for_reader",
              "blocking_reason": ""
            }
          },
          {
            "id": "d9791982-5e59-11ee-bf44-3fcf3edc778f",
            "index": 243,
            "title": "X CEO Linda Yaccarino defends Elon Musk, and herself, at Code 2023",
            "pub_date": "2023-09-29T09:00:00.000Z",
            "duration": "2540",
            "duration_label": "42m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4752247294.mp3?updated=1695958476",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2e039a42-350f-11ed-8d52-5795fe4d173f",
            "index": 244,
            "title": "Mark Zuckerberg on Threads, the future of AI, and Quest 3",
            "pub_date": "2023-09-27T18:00:00.000Z",
            "duration": "4280",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5383475692.mp3?updated=1695843792",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ded3e6e-350f-11ed-8d52-bf9126bc59eb",
            "index": 245,
            "title": "After 10 years covering startups, former TechCrunch EIC Matthew Panzarino tells us what's next",
            "pub_date": "2023-09-19T09:00:00.000Z",
            "duration": "3101",
            "duration_label": "51m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "artificial intelligence",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP1637653986.mp3?updated=1695131503",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2dd6f8fc-350f-11ed-8d52-a7e0e348a783",
            "index": 246,
            "title": "More than Sally Ride: Loren Grush explains how NASA’s first women astronauts changed space",
            "pub_date": "2023-09-12T09:00:00.000Z",
            "duration": "3467",
            "duration_label": "57m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2583139555.mp3?updated=1698246298",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2d9254fe-350f-11ed-8d52-d3d7335a6fe7",
            "index": 247,
            "title": "Biometrics? Bring it on: Why Okta’s Jameeka Green Aaron wants passwords to go away",
            "pub_date": "2023-08-29T09:00:00.000Z",
            "duration": "4392",
            "duration_label": "1h 13m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP4879525627.mp3?updated=1697649838",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2da88b5c-350f-11ed-8d52-c3d14cbfe981",
            "index": 248,
            "title": "Fandom runs some of the biggest communities on the web. Can CEO Perkins Miller keep them happy?",
            "pub_date": "2023-08-22T09:00:00.000Z",
            "duration": "4213",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2846504805.mp3?updated=1692670002",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2d7b5fa6-350f-11ed-8d52-8b6283751361",
            "index": 249,
            "title": "Land of the Giants: Tesla vs. The Competition",
            "pub_date": "2023-08-15T09:00:00.000Z",
            "duration": "2283",
            "duration_label": "38m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP2220847617.mp3?updated=1692050222",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2d643efc-350f-11ed-8d52-97387b7208ea",
            "index": 250,
            "title": "There's no AI without the cloud, says AWS CEO Adam Selipsky",
            "pub_date": "2023-08-08T09:00:00.000Z",
            "duration": "4147",
            "duration_label": "1h 9m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "agents",
              "chatgpt",
              "openai",
              "llama",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://www.podtrac.com/pts/redirect.mp3/pdst.fm/e/pscrb.fm/rss/p/mgln.ai/e/257/traffic.megaphone.fm/VMP5653585091.mp3?updated=1691524112",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 122,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          }
        ]
      },
      {
        "id": "unsupervised-learning",
        "title": "Unsupervised Learning",
        "feed_title": "Unsupervised Learning",
        "priority": "P2",
        "selection_mode": "keyword",
        "focus": [
          "AI security",
          "cybersecurity",
          "technology analysis"
        ],
        "feed_url": "https://www.omnycontent.com/d/playlist/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9/podcast.rss",
        "source_url": "https://www.omnycontent.com/d/playlist/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9/podcast.rss",
        "detail_path": "/podcasts/unsupervised-learning/",
        "episode_count": 250,
        "selected_episode_count": 144,
        "latest_episode_title": "AI Predicts the Text of Answers",
        "latest_pub_date": "2026-06-03T21:47:42.000Z",
        "latest_page_url": "https://omny.fm/shows/unsupervised-learning/ai-predicts-the-text-of-answers",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "76f8981c-380b-4fa2-9628-b45e0165b601",
            "index": 1,
            "title": "AI Predicts the Text of Answers",
            "pub_date": "2026-06-03T21:47:42.000Z",
            "duration": "494",
            "duration_label": "8m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ai-predicts-the-text-of-answers",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/76f8981c-380b-4fa2-9628-b45e0165b601/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17c737f1-5f38-4638-9a61-b43f01843823",
            "index": 2,
            "title": "Most Companies Aren't Anywhere Near Ready for AI",
            "pub_date": "2026-05-03T23:37:38.000Z",
            "duration": "318",
            "duration_label": "5m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/most-companies-arent-anywhere-near-ready-for-ai",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/17c737f1-5f38-4638-9a61-b43f01843823/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "833070aa-a5ac-4ca5-ae97-b42d017e78ef",
            "index": 3,
            "title": "We're All Building a Single Digital Assistant",
            "pub_date": "2026-04-15T23:41:03.000Z",
            "duration": "1936",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/were-all-building-a-single-digital-assistant",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/833070aa-a5ac-4ca5-ae97-b42d017e78ef/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8cb6b30b-5f75-4be2-a0d2-b414012e039f",
            "index": 4,
            "title": "Why AI  Will Replace Knowledge Workers",
            "pub_date": "2026-03-21T18:23:57.000Z",
            "duration": "4569",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/why-ai-will-replace-knowledge-workers",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8cb6b30b-5f75-4be2-a0d2-b414012e039f/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dd219477-893f-4047-be47-b40a0155f662",
            "index": 5,
            "title": "Why I Believe in SOTA Models Over Custom Ones",
            "pub_date": "2026-03-11T20:50:30.000Z",
            "duration": "108",
            "duration_label": "1m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/why-i-believe-in-sota-models-over-custom-ones",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/dd219477-893f-4047-be47-b40a0155f662/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "858ef0d5-3a47-4df2-88e8-b4050103f918",
            "index": 6,
            "title": "AI Quality Inversion",
            "pub_date": "2026-03-06T16:08:55.000Z",
            "duration": "62",
            "duration_label": "1m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ai-quality-inversion",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/858ef0d5-3a47-4df2-88e8-b4050103f918/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "01045894-05f5-4f7b-98b4-b3ff00062eb0",
            "index": 7,
            "title": "The Great Transition",
            "pub_date": "2026-02-28T00:43:19.000Z",
            "duration": "5060",
            "duration_label": "1h 24m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/the-great-transition",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/01045894-05f5-4f7b-98b4-b3ff00062eb0/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1279a115-e9ef-46c9-9797-b3e2016e90a4",
            "index": 8,
            "title": "Starting 2026",
            "pub_date": "2026-01-30T22:29:05.000Z",
            "duration": "1509",
            "duration_label": "25m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/starting-2026",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/1279a115-e9ef-46c9-9797-b3e2016e90a4/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "534211c5-f57b-4474-948e-b39d0165f728",
            "index": 9,
            "title": "Judge AI based on Output, Not Mechanism",
            "pub_date": "2025-11-22T21:45:26.000Z",
            "duration": "418",
            "duration_label": "6m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/judge-ai-based-on-output-not-mechanism",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/534211c5-f57b-4474-948e-b39d0165f728/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "157ff45e-4f22-4811-8565-b396016b98d9",
            "index": 10,
            "title": "Humans Need Entropy",
            "pub_date": "2025-11-16T16:15:00.000Z",
            "duration": "260",
            "duration_label": "4m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/humans-need-entropy",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/157ff45e-4f22-4811-8565-b396016b98d9/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cbeb8cdf-250f-4e40-82f6-b37c00ecd96b",
            "index": 11,
            "title": "Why I Think Karpathy is Wrong on the AGI Timeline",
            "pub_date": "2025-10-20T14:29:08.000Z",
            "duration": "594",
            "duration_label": "9m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "llm"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/why-i-think-karpathy-is-wrong-on-the-agi-timeline",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/cbeb8cdf-250f-4e40-82f6-b37c00ecd96b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46f8fcea-610d-4df4-b466-b37701604919",
            "index": 12,
            "title": "Novelty Exploration vs. Pattern Exploitation",
            "pub_date": "2025-10-15T21:37:08.000Z",
            "duration": "224",
            "duration_label": "3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/novelty-exploration-vs-pattern-exploitation",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/46f8fcea-610d-4df4-b466-b37701604919/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5eef7dd7-5879-4e21-a9af-b3760154054a",
            "index": 13,
            "title": "Magnifying Time",
            "pub_date": "2025-10-14T20:39:43.000Z",
            "duration": "390",
            "duration_label": "6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/magnifying-time",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/5eef7dd7-5879-4e21-a9af-b3760154054a/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e0352a6a-43e6-4b60-b359-b3560146f807",
            "index": 14,
            "title": "A Conversation With Harry Wetherald CO-Founder & CEO At Maze",
            "pub_date": "2025-09-22T18:56:26.000Z",
            "duration": "2103",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-harry-wetherald-co-founder-ceo-at-maze",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e0352a6a-43e6-4b60-b359-b3560146f807/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ef39b1a2-ad37-4aa0-8edb-b3560146e49a",
            "index": 15,
            "title": "A Conversation With Grant Lee CO-Founder & CEO At Gamma",
            "pub_date": "2025-09-18T22:59:09.000Z",
            "duration": "1308",
            "duration_label": "21m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-grant-lee-co-founder-ceo-at-gamma",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/ef39b1a2-ad37-4aa0-8edb-b3560146e49a/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75658782-b1e1-48c1-9540-b35401116a98",
            "index": 16,
            "title": "UL NO. 497: STANDARD EDITION | More NPM Shenanigans, I Open Sourced Kai, Blood Work Results, Finding Vulns in a 10-line Prompt, and more...",
            "pub_date": "2025-09-10T16:55:52.000Z",
            "duration": "2233",
            "duration_label": "37m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-497-standard-edition-more-npm-shenanigans-i-open-sourced-kai-blood-work-results-finding-vulns-in-a-10-line-prompt-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/75658782-b1e1-48c1-9540-b35401116a98/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aa20e9ef-41db-4afe-a292-b34f01574346",
            "index": 17,
            "title": "UL NO. 496: STANDARD EDITION | New Video on Building my Personal AI System, Anthropic Reveals One-person Hacking Company using Claude, Pentagon Says China Keeps Penetrating, and more...",
            "pub_date": "2025-09-05T21:49:05.000Z",
            "duration": "3769",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic",
              "claude"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-496-standard-edition-new-video-on-building-my-personal-ai-system-anthropic-reveals-one-person-hacking-company-using-claude-pentagon-says-china-keeps-penetrating-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/aa20e9ef-41db-4afe-a292-b34f01574346/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "650c1795-6ca4-45f7-8b1a-b3400159fd02",
            "index": 18,
            "title": "A Conversation with Michael Brown About Designing AI Systems",
            "pub_date": "2025-08-22T19:28:18.000Z",
            "duration": "3006",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-michael-brown",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/650c1795-6ca4-45f7-8b1a-b3400159fd02/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ad9e7619-85d1-47c8-a30d-b34000fdd851",
            "index": 19,
            "title": "UL NO. 494:  STANDARD EDITION | AI Finds a P1, I Missed Chartbeat So I Made My Own, XBow Open-Sources Their AI Bot, and more...",
            "pub_date": "2025-08-21T15:30:14.000Z",
            "duration": "5889",
            "duration_label": "1h 38m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-494-standard-edition-ai-finds-a-p1-i-missed-chartbeat-so-i-made-my-own-xbow-open-sources-their-ai-bot-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/ad9e7619-85d1-47c8-a30d-b34000fdd851/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "160b94c3-c102-4037-adff-b32101370c13",
            "index": 20,
            "title": "A Conversation With Sarit Tager from Prisma Cloud",
            "pub_date": "2025-07-29T15:00:00.000Z",
            "duration": "1531",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-sarit-tager-from-prisma-cloud",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/160b94c3-c102-4037-adff-b32101370c13/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "40e10bbf-305e-46ae-a409-b31d0077e548",
            "index": 21,
            "title": "UL NO. 489: STANDARD EDITION | My personal toolchain updates, Google tracking through DuckDuckGo, Anthropic’s Pentagon Deal, Grok4 NSFW, Substack Crushes WSJ, and more...",
            "pub_date": "2025-07-17T07:18:29.000Z",
            "duration": "1321",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "anthropic"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-489-standard-edition-my-personal-toolchain-updates-google-tracking-through-duckduckgo-anthropic-s-pentagon-deal-grok4-nsfw-substack-crushes-wsj-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/40e10bbf-305e-46ae-a409-b31d0077e548/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7bc657c-de05-4660-a7ef-b316014bd57b",
            "index": 22,
            "title": "UL NO. 488: STANDARD EDITION | Google Granting Confusing Access to Gemini, A New Favorite Creator, Russia's new Autonomous Drones, Claude Code Madness and Neovim Config, and more...",
            "pub_date": "2025-07-10T20:14:57.000Z",
            "duration": "1811",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "claude",
              "gemini"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-488-member-edition-google-granting-confusing-access-to-gemini-a-new-favorite-creator-russias-new-autonomous-drones-claude-code-madness-and-neovim-config-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/c7bc657c-de05-4660-a7ef-b316014bd57b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2c611786-c639-4a9f-8910-b30e01210e0b",
            "index": 23,
            "title": "UL NO. 487: STANDARD EDITION: Iranian Critical Infra Attacks, Insane Recent Productivity, A Chinese Mosquito Drone, Marcus's Response to Our AI Debate, \"Context Engineering\" Ain't It, and more...",
            "pub_date": "2025-07-02T17:36:42.000Z",
            "duration": "2491",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-487-standard-edition-iranian-critical-infra-attacks-insane-recent-productivity-a-chinese-mosquito-drone-marcuss-response-to-our-ai-debate-context-engineering-aint-it-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2c611786-c639-4a9f-8910-b30e01210e0b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f9635b1-3afb-4507-bdfd-b3060188acf9",
            "index": 24,
            "title": "An AI Debate with Marcus Hutchins",
            "pub_date": "2025-06-26T16:33:46.000Z",
            "duration": "7204",
            "duration_label": "2h 0m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/an-ai-debate-with-marcus-hutchins",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/0f9635b1-3afb-4507-bdfd-b3060188acf9/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b8a4a75-7443-4c99-9e8f-b308010d1818",
            "index": 25,
            "title": "UL NO. 486 STANDARD EDITION: Fully Automated AI Malware (Binary and Web), My Debate with Marcus Hutchins on AI and more",
            "pub_date": "2025-06-26T16:23:21.000Z",
            "duration": "3303",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-486-standard-edition-fully-automated-ai-malware-binary-and-web-my-debate-with-marcus-hutchins-on-ai-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/4b8a4a75-7443-4c99-9e8f-b308010d1818/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "94219e7b-35b1-43c2-b666-b3010007078b",
            "index": 26,
            "title": "UL NO. 485: STANDARD EDITION: Netflix RCE, My Current AI Stack, All-in on Claude Code, and more...",
            "pub_date": "2025-06-19T00:29:25.000Z",
            "duration": "2205",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-485-standard-edition-netflix-rce-my-current-ai-stack-all-in-on-claude-code-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/94219e7b-35b1-43c2-b666-b3010007078b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "84e8586d-d24b-4ef8-a557-b2fa001b9d1b",
            "index": 27,
            "title": "UL NO. 484: STANDARD EDITION: OpenAI's Malicious AI Report, Disappointed with WWDC, AI's First Actual Science Breakthrough, and more...",
            "pub_date": "2025-06-12T01:45:44.000Z",
            "duration": "2611",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-484-standard-edition-openais-malicious-ai-report-disappointed-with-wwdc-ais-first-actual-science-breakthrough-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/84e8586d-d24b-4ef8-a557-b2fa001b9d1b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f8f526b7-70cc-4678-8b82-b2f300e626e6",
            "index": 28,
            "title": "UL NO. 483 | STANDARD EDITION: A Chrome 0-Day, Meta Automates Security Assessments, New Essays, My New Video on Hacking with AI, Ukraine's Asymmetrical Attack, Thoughts on My AI Skeptical Friends, The Dangers of Winning the Wrong Game, and more...",
            "pub_date": "2025-06-05T14:04:40.000Z",
            "duration": "1899",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-483-standard-edition-a-chrome-0-day-meta-automates-security-assessments-new-essays-my-new-video-on-hacking-with-ai-ukraines-asymmetrical-attack-thoughts-on-my-ai-skeptical-friends-the-dangers-of-winning-the-wrong-game-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f8f526b7-70cc-4678-8b82-b2f300e626e6/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "88c9b1ad-5103-43bc-96a0-b2f10169507b",
            "index": 29,
            "title": "The Future of Hacking is Context",
            "pub_date": "2025-06-03T22:24:52.000Z",
            "duration": "2025",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/the-future-of-hacking-is-context",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/88c9b1ad-5103-43bc-96a0-b2f10169507b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5883803-190a-443a-9eff-b2ed01053122",
            "index": 30,
            "title": "UL NO. 482 | STANDARD EDITION: AI Finds an 0-Day!, Postman Leaking Secrets, High Agency Mental Model, My Unified Entity Context Video, Github MCP Leaks Private Repos, Google vs. OpenAI vs. Apple on AI Vision, and more...",
            "pub_date": "2025-05-30T16:02:40.000Z",
            "duration": "1893",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-482-standard-edition-ai-finds-an-0-day-postman-leaking-secrets-high-agency-mental-model-my-unified-entity-context-video-github-mcp-leaks-private-repos-google-vs-openai-vs-apple-on-ai-vision-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/c5883803-190a-443a-9eff-b2ed01053122/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba06b395-3c9e-4512-9725-b2de0015c9c2",
            "index": 31,
            "title": "Unified Entity Context",
            "pub_date": "2025-05-15T01:26:50.000Z",
            "duration": "1818",
            "duration_label": "30m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/unified-entity-context",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/ba06b395-3c9e-4512-9725-b2de0015c9c2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "364e98f1-9b0c-4153-bd66-b2d700384308",
            "index": 32,
            "title": "Reviewing RSA 2025 with Jason Haddix",
            "pub_date": "2025-05-08T14:30:00.000Z",
            "duration": "4862",
            "duration_label": "1h 21m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "reasoning",
              "evals"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/reviewing-rsa-2025-with-jason-haddix",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/364e98f1-9b0c-4153-bd66-b2d700384308/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8da7809c-e181-4e59-830b-b2d40166db65",
            "index": 33,
            "title": "A Conversation with Bar-El Tayouri from Mend.io",
            "pub_date": "2025-05-06T06:00:00.000Z",
            "duration": "2753",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-bar-el-tayouri-from-mend-io",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8da7809c-e181-4e59-830b-b2d40166db65/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7b609f09-0c7b-4917-9d08-b2c7000bad8a",
            "index": 34,
            "title": "The 4 AAAAs of the AI ECOSYSTEM: Assistants, APIs, Agents, and Augmented Reality",
            "pub_date": "2025-04-22T00:55:11.000Z",
            "duration": "1624",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/the-4-aaaas-of-the-ai-ecosystem-assistants-apis-agents-and-augmented-reality",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7b609f09-0c7b-4917-9d08-b2c7000bad8a/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a5bf7e7-84d2-4b9b-9080-b2c1013e0fd5",
            "index": 35,
            "title": "Using the Smartest AI to Rate Other AI",
            "pub_date": "2025-04-19T06:00:00.000Z",
            "duration": "575",
            "duration_label": "9m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/using-the-smartest-ai-to-rate-other-ai",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8a5bf7e7-84d2-4b9b-9080-b2c1013e0fd5/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eabe6af1-fb43-48e0-9840-b2c0001e9dba",
            "index": 36,
            "title": "A Conversation with Patrick Duffy from Material Security",
            "pub_date": "2025-04-15T06:00:00.000Z",
            "duration": "1607",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-patrick-duffy-from-material-security",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/eabe6af1-fb43-48e0-9840-b2c0001e9dba/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "043beea2-0cea-4506-be81-b2bd0174c590",
            "index": 37,
            "title": "AICAD: Artificial Intelligence Capabilities For Attack & Defense",
            "pub_date": "2025-04-12T22:51:48.000Z",
            "duration": "2572",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/aicad-artificial-intelligence-capabilities-for-attack-defense",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/043beea2-0cea-4506-be81-b2bd0174c590/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d05d8ebc-1da2-44f2-b859-b2b9017492b0",
            "index": 38,
            "title": "A Possible Path to ASI",
            "pub_date": "2025-04-08T22:48:44.000Z",
            "duration": "652",
            "duration_label": "10m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-possible-path-to-asi",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/d05d8ebc-1da2-44f2-b859-b2b9017492b0/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7f7a0de7-1629-4462-9ffb-b2b10132de44",
            "index": 39,
            "title": "A Conversation With Matt Muller From Tines",
            "pub_date": "2025-04-01T06:00:00.000Z",
            "duration": "2372",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-matt-muller-from-tines",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7f7a0de7-1629-4462-9ffb-b2b10132de44/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e6e569a5-c191-49a8-944f-b2b1012f5736",
            "index": 40,
            "title": "UL NO. 474 | Signal OPSEC, White-box Red-teaming LLMs, Unified Company Context (UCC), New Book Recommendations, Single Apple Note Technique, and much more...",
            "pub_date": "2025-03-31T18:31:02.000Z",
            "duration": "1104",
            "duration_label": "18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-474-signal-opsec-white-box-red-teaming-llms",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e6e569a5-c191-49a8-944f-b2b1012f5736/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "107d1419-46f8-4485-ba48-b2a4011a887e",
            "index": 41,
            "title": "A Conversation With Slava Konstantinov From ThreatLocker",
            "pub_date": "2025-03-18T17:28:53.000Z",
            "duration": "2010",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-slava-konstantinov-from-threat",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/107d1419-46f8-4485-ba48-b2a4011a887e/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e7cad002-03e3-4546-a7c8-b2a1000c9cfc",
            "index": 42,
            "title": "UL NO. 472 | STANDARD EDITION: 28 Open Cyber Jobs, Real-world AI Propaganda Poisoning, MCP Explained, Cline vs. Windsurf, and more...",
            "pub_date": "2025-03-15T01:23:12.000Z",
            "duration": "2371",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-472-standard-edition-28-open-cyber-jobs-real",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e7cad002-03e3-4546-a7c8-b2a1000c9cfc/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1654c25a-0eaf-47d2-ac66-b2a0015138f7",
            "index": 43,
            "title": "Raycast is a Must in 2025 - Action at the Speed of Thought",
            "pub_date": "2025-03-15T00:22:20.000Z",
            "duration": "2752",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/raycast-is-a-must-in-2025-the-future-of-productivi",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/1654c25a-0eaf-47d2-ac66-b2a0015138f7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f1db5a6-71aa-4d4a-823a-b29b004d1ad6",
            "index": 44,
            "title": "UL NO. 471 | STANDARD EDITION: Cyber Standing Down, China's Innovation Burst, PC vs. NPC, Why AI Can't Understand, and more...",
            "pub_date": "2025-03-09T06:00:00.000Z",
            "duration": "1540",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-471-standard-edition-cyber-standing-down-chi",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/3f1db5a6-71aa-4d4a-823a-b29b004d1ad6/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c62d039-758b-4a38-9834-b29601838cb6",
            "index": 45,
            "title": "UL NO. 470 | Attacking Signal, Blogging Getting MORE Important, AI's Final Form, Claude 3.7 vs. World, Censorship as a Service, and more...",
            "pub_date": "2025-03-04T23:45:55.000Z",
            "duration": "2485",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "claude"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-470-attacking-signal-blogging-getting-more-i",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/3c62d039-758b-4a38-9834-b29601838cb6/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c0ea74c-01f1-4882-85b4-b289013d377b",
            "index": 46,
            "title": "UL NO. 468 | TELOS Patterns, Apple 0-Day, Gumroad Replaces Developers with AI",
            "pub_date": "2025-02-19T19:27:39.000Z",
            "duration": "2960",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-468-telos-patterns-apple-0-day-gumroad-repla",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8c0ea74c-01f1-4882-85b4-b289013d377b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da2baeb4-e884-4778-a84a-b27d015fc5d8",
            "index": 47,
            "title": "UL NO. 467 | Why You Should Care About AGI (And a Definition)",
            "pub_date": "2025-02-07T21:29:51.000Z",
            "duration": "1542",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-467-why-you-should-care-about-agi-and-a-defi",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/da2baeb4-e884-4778-a84a-b27d015fc5d8/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b1c2af30-a2b4-4d7a-b77a-b27b00c7fd6d",
            "index": 48,
            "title": "Writing Fiction With AI",
            "pub_date": "2025-02-05T12:32:19.000Z",
            "duration": "1814",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-467-using-ai-for-fiction-writing",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b1c2af30-a2b4-4d7a-b77a-b27b00c7fd6d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2bba719-93fe-4517-9405-b279012353db",
            "index": 49,
            "title": "A Conversation with Alastair Paterson from Harmonic Security",
            "pub_date": "2025-02-04T06:00:00.000Z",
            "duration": "1772",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "training"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-alastair-paterson-from-harmoni",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f2bba719-93fe-4517-9405-b279012353db/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f73a7a27-cbf5-4d45-b85d-b275004a8ea1",
            "index": 50,
            "title": "UL NO. 466 | My Analysis and Prediction on the Deepseek Situation",
            "pub_date": "2025-01-30T04:45:57.000Z",
            "duration": "1981",
            "duration_label": "33m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-466-my-analysis-and-prediction-on-the-deepse",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f73a7a27-cbf5-4d45-b85d-b275004a8ea1/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bca5eb39-402e-413a-bca8-b27300445cd6",
            "index": 51,
            "title": "A Conversation with Faisal Khan from Vanta",
            "pub_date": "2025-01-28T06:00:00.000Z",
            "duration": "2341",
            "duration_label": "39m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-faisal-khan-from-vanta",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/bca5eb39-402e-413a-bca8-b27300445cd6/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2225ec0d-fd2c-424b-bf20-b271000c6c17",
            "index": 52,
            "title": "UL NO. 465 | The SaaS Attack Vector, Project Stargate, and Undersea Cable Drones",
            "pub_date": "2025-01-26T00:50:35.000Z",
            "duration": "1275",
            "duration_label": "21m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "perplexity"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-465-the-saas-attack-vector-project-stargate",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2225ec0d-fd2c-424b-bf20-b271000c6c17/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd79ea20-f217-4208-8bbb-b269002a4ece",
            "index": 53,
            "title": "UL NO. 464 | AI Phishing Matches Humans, Under Sea Cable Cutter Patents, and Siri is About to Not Suck",
            "pub_date": "2025-01-18T02:49:51.000Z",
            "duration": "1708",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-464-ai-phishing-matches-humans-under-sea-cab",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/cd79ea20-f217-4208-8bbb-b269002a4ece/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d4b4bf0f-235d-4a72-95bb-b262003925ab",
            "index": 54,
            "title": "UL NO. 463 | Launching 2025, US Soldier Data Leak, AI Agents Emerge, China's Global Spy Network, Robotaxis Now Safer Than Humans",
            "pub_date": "2025-01-11T03:33:55.000Z",
            "duration": "2687",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-463-launching-2025-us-soldier-data-leak-ai-a",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/d4b4bf0f-235d-4a72-95bb-b262003925ab/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "040a70b5-ce8a-4c81-b8c9-b24e016312eb",
            "index": 55,
            "title": "UL NO. 462: Full-Face Mask Deceptions, VS Code Tunnel Hacks, Quiet AI Emergence at Apple, and Tokyo’s Three-Day Weekend Gamble",
            "pub_date": "2024-12-22T21:36:33.000Z",
            "duration": "1656",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "claude",
              "coding"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-462-full-face-mask-deceptions-vs-code-tunnel",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/040a70b5-ce8a-4c81-b8c9-b24e016312eb/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eb4a208c-61bd-48c0-856a-b24201893fba",
            "index": 56,
            "title": "How Much AI Do We Need? - My AI Industry Prediction",
            "pub_date": "2024-12-11T00:01:39.000Z",
            "duration": "1696",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/how-much-ai-do-we-need-my-ai-industry-prediction",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/eb4a208c-61bd-48c0-856a-b24201893fba/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f7a872f3-f6b4-40f0-9090-b22f015ca822",
            "index": 57,
            "title": "UL NO. 459: New Active 0-day Exploitation, AI That Sees Your Open Apps, The RebootAI Project",
            "pub_date": "2024-11-21T21:19:36.000Z",
            "duration": "1438",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-459-new-active-0-day-exploitation-ai-that-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f7a872f3-f6b4-40f0-9090-b22f015ca822/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6584c3d5-d44d-4a37-82f7-b22c005a6109",
            "index": 58,
            "title": "A Conversation with Rob Allen from ThreatLocker",
            "pub_date": "2024-11-18T06:00:00.000Z",
            "duration": "1938",
            "duration_label": "32m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-rob-allen-from-threatlocker",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/6584c3d5-d44d-4a37-82f7-b22c005a6109/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "094a744c-9e33-4175-957d-b22b013da1d7",
            "index": 59,
            "title": "UL NO. 458: Ollama Vulnerabilities, Rating AI Using AI, The Mantis Hack-back Framework",
            "pub_date": "2024-11-17T19:45:16.000Z",
            "duration": "1966",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-458-ollama-vulnerabilities-rating-ai-using-a",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/094a744c-9e33-4175-957d-b22b013da1d7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7103eace-01f3-4545-a979-b225015b47c2",
            "index": 60,
            "title": "A Conversation with Jason Haddix from Flare",
            "pub_date": "2024-11-11T21:12:23.000Z",
            "duration": "1811",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-jason-haddix-from-flare",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7103eace-01f3-4545-a979-b225015b47c2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7556ca13-ca58-4e64-a1e3-b20d00f29b38",
            "index": 61,
            "title": "UL NO. 454: The First AI Breaches",
            "pub_date": "2024-10-18T15:38:00.000Z",
            "duration": "2101",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-454-the-first-ai-breaches",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7556ca13-ca58-4e64-a1e3-b20d00f29b38/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3fed08af-4b04-4629-a16a-b20a016fc8e0",
            "index": 62,
            "title": "How My Projects Fit Together (Substrate, Fabric, Telos, Daemon, and Human 3.0)",
            "pub_date": "2024-10-15T22:43:05.000Z",
            "duration": "3686",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/how-my-projects-fit-together-substrate-fabric-telo",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/3fed08af-4b04-4629-a16a-b20a016fc8e0/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "23ea20dd-6799-41dc-bc1c-b20400119103",
            "index": 63,
            "title": "Human 3.0—The Skills & Mental Frames Required To Thrive In An AI World",
            "pub_date": "2024-10-09T06:00:00.000Z",
            "duration": "1803",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/human-3-0-skills-mental-frames-audio",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/23ea20dd-6799-41dc-bc1c-b20400119103/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6204b061-3c4e-4bcf-9356-b20200fd34ae",
            "index": 64,
            "title": "UL NO. 452: The New Hotness: NotebookLM",
            "pub_date": "2024-10-07T15:42:46.000Z",
            "duration": "3013",
            "duration_label": "50m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-452-the-new-hotness-notebooklm",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/6204b061-3c4e-4bcf-9356-b20200fd34ae/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "72ec00ed-64af-43cb-9e69-b1fd0124f22a",
            "index": 65,
            "title": "NotebookLM Podcast: David Deutsch, Understanding, and AI",
            "pub_date": "2024-10-02T17:50:13.000Z",
            "duration": "769",
            "duration_label": "12m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/notebooklm-podcast-david-deusch-understanding-and",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/72ec00ed-64af-43cb-9e69-b1fd0124f22a/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fcbc3eeb-5214-4812-aefa-b1f50168f45c",
            "index": 66,
            "title": "Venture Capitalists Favor Risk-Takers: The Rise of Self-Made Billionaires and Tech Innovators",
            "pub_date": "2024-09-28T06:00:00.000Z",
            "duration": "302",
            "duration_label": "5m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/venture-capitalists-favor-risk-takers-the-rise-of",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fcbc3eeb-5214-4812-aefa-b1f50168f45c/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a18e0ff4-1778-4f42-806e-b1f50168f45c",
            "index": 67,
            "title": "AI Comedians by 2026? The Future of Comedy and the Turing Test for Laughter",
            "pub_date": "2024-09-27T06:00:00.000Z",
            "duration": "256",
            "duration_label": "4m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ai-comedians-by-2026-the-future-of-comedy-and-the",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a18e0ff4-1778-4f42-806e-b1f50168f45c/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "25be7efd-939c-41f2-883b-b1f5016a34f8",
            "index": 68,
            "title": "The Alarming Power of Deepfakes",
            "pub_date": "2024-09-26T06:00:00.000Z",
            "duration": "368",
            "duration_label": "6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/the-alarming-power-of-deepfakes",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/25be7efd-939c-41f2-883b-b1f5016a34f8/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f6546e4-db05-40ef-83f9-b1f7000254ec",
            "index": 69,
            "title": "UL NO. 451: Altman Says ASI in \"Thousands of Days\"",
            "pub_date": "2024-09-26T00:25:12.000Z",
            "duration": "1884",
            "duration_label": "31m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-451-altman-says-asi-in-thousands-of-days",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/6f6546e4-db05-40ef-83f9-b1f7000254ec/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cd1ae621-9ab0-48ba-a32a-b1f5015f4de2",
            "index": 70,
            "title": "Russia Is Paying Right Wing Influencers?",
            "pub_date": "2024-09-25T06:00:00.000Z",
            "duration": "447",
            "duration_label": "7m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/russia-is-paying-right-wing-influencers",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/cd1ae621-9ab0-48ba-a32a-b1f5015f4de2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7906417b-7add-4842-a4d5-b1f5015f4df1",
            "index": 71,
            "title": "This Is The Future Career For Creators - Virtual Realities, Economies, and Meaning",
            "pub_date": "2024-09-24T06:00:00.000Z",
            "duration": "516",
            "duration_label": "8m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/this-is-the-future-career-for-creators-virtual-rea",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7906417b-7add-4842-a4d5-b1f5015f4df1/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "520367db-9638-4b87-bac0-b1f00157c55f",
            "index": 72,
            "title": "My First Thoughts on New OpenAI Strawberry Model ( OpenAI o1-preview)",
            "pub_date": "2024-09-19T20:57:54.000Z",
            "duration": "1322",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/my-first-thoughts-on-new-openai-strawberry-model-o",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/520367db-9638-4b87-bac0-b1f00157c55f/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "295682b6-5d74-41f4-b8f5-b1ee01707902",
            "index": 73,
            "title": "UL NO. 450: Thoughts on o1-preview and the Path to AGI",
            "pub_date": "2024-09-17T22:44:07.000Z",
            "duration": "1457",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "agi",
              "rag"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-450-thoughts-on-o1-preview-and-the-path-to-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/295682b6-5d74-41f4-b8f5-b1ee01707902/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "940ac217-6e5d-4d71-9ec0-b1ee0025dc71",
            "index": 74,
            "title": "A Conversation with Shiladitya Sircar from BlackBerry on DeepFake Threats",
            "pub_date": "2024-09-17T02:29:55.000Z",
            "duration": "2684",
            "duration_label": "44m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-shiladitya-sircar-from-blackbe",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/940ac217-6e5d-4d71-9ec0-b1ee0025dc71/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17004765-ff90-4b42-8d66-b1ed00f03129",
            "index": 75,
            "title": "UL NO. 449: China Hits US ISPs, NIST CSF 2.0, Russian Intel Attacks, Stagnant Companies...",
            "pub_date": "2024-09-16T14:52:32.000Z",
            "duration": "3256",
            "duration_label": "54m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-449-china-hits-us-isps-nist-csf-2-0-russia-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/17004765-ff90-4b42-8d66-b1ed00f03129/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1ecbe35-7d02-401b-9436-b1d9012b472e",
            "index": 76,
            "title": "North Korea Strategy to “Infiltrate” Foreign Companies",
            "pub_date": "2024-09-10T06:00:00.000Z",
            "duration": "184",
            "duration_label": "3m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/north-korea-strategy-to-infiltrate-foreign-compani",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/c1ecbe35-7d02-401b-9436-b1d9012b472e/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3d8f7f8a-689d-4c6c-8dd6-b1d9012b475b",
            "index": 77,
            "title": "How To Find Great People to Work With - UBI & Talent Distribution",
            "pub_date": "2024-09-08T06:00:00.000Z",
            "duration": "571",
            "duration_label": "9m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/how-to-find-great-people-to-work-with-ubi-talent-d",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/3d8f7f8a-689d-4c6c-8dd6-b1d9012b475b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e1c42e82-0a30-4332-8188-b1d9012b51a2",
            "index": 78,
            "title": "Ambition & UBI - Why People Are Working Less",
            "pub_date": "2024-09-06T06:00:00.000Z",
            "duration": "441",
            "duration_label": "7m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ambition-ubi",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e1c42e82-0a30-4332-8188-b1d9012b51a2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e2af8813-baf4-4321-a09b-b1e3002c2c40",
            "index": 79,
            "title": "UL NO. 448: TSA SQLi, NYT Github, NK RPM, NVIDIA Mystery...",
            "pub_date": "2024-09-06T02:58:06.000Z",
            "duration": "1339",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "openai",
              "nvidia"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-448-tsa-sqli-nyt-github-nk-rpm-nvidia-myst-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e2af8813-baf4-4321-a09b-b1e3002c2c40/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b770a3a0-b9ef-4718-8670-b1d9012b51a4",
            "index": 80,
            "title": "Google Current State A Waste of Money & Talent",
            "pub_date": "2024-09-04T06:00:00.000Z",
            "duration": "173",
            "duration_label": "2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-google-current-state-a-waste-of-money-talent",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b770a3a0-b9ef-4718-8670-b1d9012b51a4/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d017ea2e-18a4-4f59-9843-b1d9012b51a7",
            "index": 81,
            "title": "How China is Winning The Energy War",
            "pub_date": "2024-09-02T06:00:00.000Z",
            "duration": "136",
            "duration_label": "2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/how-china-is-winning-the-energy-war",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/d017ea2e-18a4-4f59-9843-b1d9012b51a7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5773607c-3a6a-402a-a0c4-b1d9012b4721",
            "index": 82,
            "title": "AI The Creative Workflow & The Dangers of Groupthink",
            "pub_date": "2024-08-31T06:00:00.000Z",
            "duration": "338",
            "duration_label": "5m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ai-the-creative-workflow-the-dangers-of-groupthink",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/5773607c-3a6a-402a-a0c4-b1d9012b4721/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7e062b4-1fc8-4264-abac-b1dd0001f3e5",
            "index": 83,
            "title": "UL NO. 447: Sam Curry on Bug Bounty Careers, Slack Data Exfil, The Work Lie",
            "pub_date": "2024-08-31T00:14:59.000Z",
            "duration": "1954",
            "duration_label": "32m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-447-sam-curry-on-bug-bounty-careers-slack-da",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/d7e062b4-1fc8-4264-abac-b1dd0001f3e5/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1080d85e-53c2-4a8b-ada0-b1d9012b472f",
            "index": 84,
            "title": "Don’t Judge Yourself Based On What Companies Think of Your Skills",
            "pub_date": "2024-08-29T06:00:00.000Z",
            "duration": "272",
            "duration_label": "4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/don-t-judge-yourself-based-on-what-companies-think",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/1080d85e-53c2-4a8b-ada0-b1d9012b472f/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "317634fa-8a7c-48de-93d7-b1d9012b5225",
            "index": 85,
            "title": "Microsoft Fires DEI Team & The Correct Approach To Diversity",
            "pub_date": "2024-08-27T22:00:00.000Z",
            "duration": "161",
            "duration_label": "2m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/microsoft-fires-dei-team-the-correct-approach-to-d",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/317634fa-8a7c-48de-93d7-b1d9012b5225/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8964c00d-6251-4d19-8ed0-b1d40040ace2",
            "index": 86,
            "title": "UL NO. 446: AI Ecosystem Components, MS 0-Days, Iranian Campaign Hacks…",
            "pub_date": "2024-08-22T04:12:19.000Z",
            "duration": "2547",
            "duration_label": "42m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-446-ai-ecosystem-components-ms-0-days-irania",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8964c00d-6251-4d19-8ed0-b1d40040ace2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "41f2aafe-43bf-4a7a-a9c8-b1c30186a52f",
            "index": 87,
            "title": "Introducing Substrate—An Open-source Framework for Human Understanding, Meaning, and Progress",
            "pub_date": "2024-08-09T06:00:00.000Z",
            "duration": "2497",
            "duration_label": "41m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/introducing-substrate-an-open-source-framework-for",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/41f2aafe-43bf-4a7a-a9c8-b1c30186a52f/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2d8a4ef6-3984-4c84-8b3f-b1c700096d36",
            "index": 88,
            "title": "UL NO. 444: Pizza Meter Intelligence, China Bypasses Bans, Securing AWS Secrets…",
            "pub_date": "2024-08-09T00:46:47.000Z",
            "duration": "1487",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "openai",
              "llama"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-444-pizza-meter-intelligence-china-bypasse-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2d8a4ef6-3984-4c84-8b3f-b1c700096d36/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e73c3bf0-a9f3-4540-973c-b1c30186b1bc",
            "index": 89,
            "title": "Scaling Misinformation With AI",
            "pub_date": "2024-08-07T06:00:00.000Z",
            "duration": "347",
            "duration_label": "5m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/scaling-misinformation-with-ai",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e73c3bf0-a9f3-4540-973c-b1c30186b1bc/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5553d15f-755d-4d98-96d8-b1c3010eaa9a",
            "index": 90,
            "title": "UL NO. 443: North Korean Co-workers, UBI Failure?, AI-Groupthink, GPS Spoofing…",
            "pub_date": "2024-08-05T16:45:58.000Z",
            "duration": "2007",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-443-north-korean-co-workers-ubi-failure-ai-g",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/5553d15f-755d-4d98-96d8-b1c3010eaa9a/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "870f43b2-7382-4703-995a-b1c30063c317",
            "index": 91,
            "title": "A Conversation with Christine Gadsby from BlackBerry",
            "pub_date": "2024-08-05T06:20:27.000Z",
            "duration": "2503",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-christine-gadsby-from-blackber",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/870f43b2-7382-4703-995a-b1c30063c317/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9d42a5cd-4c1e-491a-bc10-b1b7016dcd45",
            "index": 92,
            "title": "UL NO. 442: Crowdstrike Analysis, Cannabis=Soma?, NK Github SE, AI Weaponry",
            "pub_date": "2024-07-24T22:26:31.000Z",
            "duration": "1947",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-442-crowdstrike-analysis-cannabis-soma-nk-gi",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9d42a5cd-4c1e-491a-bc10-b1b7016dcd45/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98d735f8-2154-486b-a052-b1b4004b71aa",
            "index": 93,
            "title": "UL NO. 441: Substrate, OpenAIs AGI Levels, US Literacy Rates",
            "pub_date": "2024-07-21T04:41:53.000Z",
            "duration": "1460",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-441-substrate-openais-agi-levels-us-literacy",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/98d735f8-2154-486b-a052-b1b4004b71aa/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "478c74a4-4846-4e2c-82d8-b1aa01199179",
            "index": 94,
            "title": "UL NO. 440: RAID (Real World AI Definitions)",
            "pub_date": "2024-07-11T17:19:06.000Z",
            "duration": "2146",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "retrieval"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-440-raid-real-world-ai-definitions-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/478c74a4-4846-4e2c-82d8-b1aa01199179/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fb2f0743-157f-4349-81d1-b1a30179125b",
            "index": 95,
            "title": "UL NO. 439: Humans vs. AI in Prediction Markets",
            "pub_date": "2024-07-04T23:07:21.000Z",
            "duration": "1090",
            "duration_label": "18m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-439-humans-vs-ai-in-prediction-markets",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fb2f0743-157f-4349-81d1-b1a30179125b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "512b1cab-dd7f-45b5-a296-b19c017f38c6",
            "index": 96,
            "title": "UL NO. 438: Confusion is a Muse",
            "pub_date": "2024-06-27T23:19:43.000Z",
            "duration": "2194",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-438-confusion-is-a-muse-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/512b1cab-dd7f-45b5-a296-b19c017f38c6/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a570da1a-40bf-44cd-b98a-b19600138cd4",
            "index": 97,
            "title": "UL NO. 437: My List of Hard-won Life Lessons",
            "pub_date": "2024-06-21T01:33:57.000Z",
            "duration": "1659",
            "duration_label": "27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-437-my-list-of-hard-won-life-lessons",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a570da1a-40bf-44cd-b98a-b19600138cd4/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7792d9d6-c930-46e5-8e5c-b18f00dd6761",
            "index": 98,
            "title": "UL NO. 436: Thoughts on the Future of AI & Societal Stability",
            "pub_date": "2024-06-14T13:39:47.000Z",
            "duration": "3211",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-436-thoughts-on-the-future-of-ai-societal-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7792d9d6-c930-46e5-8e5c-b18f00dd6761/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19a42403-fe0d-4514-8c30-b185000785a1",
            "index": 99,
            "title": "A Conversation with Abhishek Agrawal from Material Security",
            "pub_date": "2024-06-07T01:09:56.000Z",
            "duration": "3252",
            "duration_label": "54m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-with-abhishek-agrawal-from-mat",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/19a42403-fe0d-4514-8c30-b185000785a1/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac046083-9d4f-43ec-8763-b18800116a04",
            "index": 100,
            "title": "UL NO. 435: Making New Things is Post-AI Safety",
            "pub_date": "2024-06-07T01:06:36.000Z",
            "duration": "1489",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-435-making-new-things-is-post-ai-safety",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/ac046083-9d4f-43ec-8763-b18800116a04/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a08afdf7-9059-446a-aacb-b18201498924",
            "index": 101,
            "title": "UL NO. 434: Can You Articulate Yourself in 50 Words?",
            "pub_date": "2024-06-01T20:13:04.000Z",
            "duration": "1660",
            "duration_label": "27m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-434-can-you-articulate-yourself-in-50-words",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a08afdf7-9059-446a-aacb-b18201498924/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5a7a9fdf-964e-4dbd-9152-b17f0185d1ae",
            "index": 102,
            "title": "UL NO. 433: China's Flawed Strategy",
            "pub_date": "2024-05-29T23:41:33.000Z",
            "duration": "600",
            "duration_label": "10m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-433-chinas-flawed-strategy",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/5a7a9fdf-964e-4dbd-9152-b17f0185d1ae/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b391d8ed-7ae4-48a6-b28e-b17a000eccb9",
            "index": 103,
            "title": "A Conversation with Mike Privette from Return on Security",
            "pub_date": "2024-05-24T01:42:06.000Z",
            "duration": "2778",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-mike-privette-from-return-on-s",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b391d8ed-7ae4-48a6-b28e-b17a000eccb9/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9268c37-5e26-4131-9a86-b173017e158d",
            "index": 104,
            "title": "UL NO. 432: Can You Summarize Your Work in a Sentence?",
            "pub_date": "2024-05-24T00:39:49.000Z",
            "duration": "1677",
            "duration_label": "27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-432-can-you-summarize-your-work-in-a-sentenc",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a9268c37-5e26-4131-9a86-b173017e158d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3b4c84ee-2bb3-4b83-a9ba-b1720003721d",
            "index": 105,
            "title": "A Conversation on Maritime Security with BlackBerry Threat Intelligence",
            "pub_date": "2024-05-16T00:18:48.000Z",
            "duration": "2416",
            "duration_label": "40m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-on-maritime-security-with-blackberr",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/3b4c84ee-2bb3-4b83-a9ba-b1720003721d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d98ef94c-1fdb-4ec7-99cf-b16b01115225",
            "index": 106,
            "title": "UL NO. 431: Companies are Graphs of Algorithms",
            "pub_date": "2024-05-09T16:38:34.000Z",
            "duration": "709",
            "duration_label": "11m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-431-companies-are-graphs-of-algorithms",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/d98ef94c-1fdb-4ec7-99cf-b16b01115225/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "600d13eb-b0f4-4230-adc6-b165017057cd",
            "index": 107,
            "title": "UL NO. 430: The Courage to be Disliked",
            "pub_date": "2024-05-03T23:26:55.000Z",
            "duration": "1815",
            "duration_label": "30m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-430-the-courage-to-be-disliked",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/600d13eb-b0f4-4230-adc6-b165017057cd/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8a6f438d-c679-4731-b391-b15f0026315c",
            "index": 108,
            "title": "UL NO. 429: Build Your Career Around Problems",
            "pub_date": "2024-04-27T02:22:42.000Z",
            "duration": "1305",
            "duration_label": "21m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-429-build-your-career-around-problems",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8a6f438d-c679-4731-b391-b15f0026315c/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0bbbbbf-0b22-493c-a604-b15b0004c105",
            "index": 109,
            "title": "UL NO. 428: Reason to Fear; Reason to Build.",
            "pub_date": "2024-04-23T00:20:21.000Z",
            "duration": "976",
            "duration_label": "16m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-428-reason-to-fear-reason-to-build",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a0bbbbbf-0b22-493c-a604-b15b0004c105/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "921649fe-e325-4c18-b5ca-b14e017f9eac",
            "index": 110,
            "title": "UL NO. 427: AI's Predictable Future",
            "pub_date": "2024-04-10T23:31:56.000Z",
            "duration": "1317",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-427-ais-predictable-future",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/921649fe-e325-4c18-b5ca-b14e017f9eac/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7cbd8c9-b3f4-4bb7-8e83-b140010bb7c7",
            "index": 111,
            "title": "UL NO. 425: The Efficient Security Principle",
            "pub_date": "2024-03-27T16:18:17.000Z",
            "duration": "1272",
            "duration_label": "21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-425-the-efficient-security-principle",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/d7cbd8c9-b3f4-4bb7-8e83-b140010bb7c7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "55682b09-58bd-4d3d-8804-b13a01406f7b",
            "index": 112,
            "title": "UL NO. 424: Raising Security's Floor",
            "pub_date": "2024-03-21T19:33:14.000Z",
            "duration": "1600",
            "duration_label": "26m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-424-raising-securitys-floor",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/55682b09-58bd-4d3d-8804-b13a01406f7b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f9135e76-006c-4e76-acf0-b138010eaaae",
            "index": 113,
            "title": "A Conversation with Jason Meller of Kolide/1Password",
            "pub_date": "2024-03-19T16:30:12.000Z",
            "duration": "1305",
            "duration_label": "21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-jason-meller-of-kolide-1passwo",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f9135e76-006c-4e76-acf0-b138010eaaae/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fdb75d12-a6e1-4ceb-90f0-b131011021e4",
            "index": 114,
            "title": "UL NO. 423: AI is Becoming Like Reading",
            "pub_date": "2024-03-12T16:33:37.000Z",
            "duration": "1251",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "google ai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-423-ai-is-becoming-like-reading",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fdb75d12-a6e1-4ceb-90f0-b131011021e4/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f5416b3-3399-4826-89a6-b12b013c1038",
            "index": 115,
            "title": "UL NO. 422: To Survive AI, We Must Become Creators",
            "pub_date": "2024-03-06T21:58:42.000Z",
            "duration": "1240",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-422-to-survive-ai-we-must-become-creators",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9f5416b3-3399-4826-89a6-b12b013c1038/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7e4dcaac-d469-41ac-9660-b1290162ed05",
            "index": 116,
            "title": "A Conversation With Ismael Valenzuela About AI and Threat Intelligence",
            "pub_date": "2024-03-04T21:40:30.000Z",
            "duration": "2746",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-ismael-valenzuela-about-ai-and",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7e4dcaac-d469-41ac-9660-b1290162ed05/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d077e732-4542-4696-aea1-b1210076905d",
            "index": 117,
            "title": "UL NO. 420: APTs using ChatGPT, Bugs Putin, The good side of AI jobs loss?, AI Monitoring Culture, AI patents, and more…",
            "pub_date": "2024-02-25T07:14:35.000Z",
            "duration": "1420",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-420-apts-using-chatgpt-bugs-putin-the-good-s",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/d077e732-4542-4696-aea1-b1210076905d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa8940b8-ac90-47ab-a155-b1140164bc44",
            "index": 118,
            "title": "UL NO. 419: Problem Quality, 0-Day Spyware, LOTL, Ollama + OpenAI",
            "pub_date": "2024-02-12T21:46:09.000Z",
            "duration": "1819",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agent",
              "openai",
              "chips"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-419-problem-quality-0-day-spyware-lotl-ollam",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fa8940b8-ac90-47ab-a155-b1140164bc44/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "93524e97-b394-41cb-9041-b10f00201acd",
            "index": 119,
            "title": "UL NO. 418: DEFCON Moves, AnyCloudDesk, Ransomware Learnings, My Top AI Projects",
            "pub_date": "2024-02-08T17:42:57.000Z",
            "duration": "1658",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-418-defcon-moves-anyclouddesk-ransomware-lea",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/93524e97-b394-41cb-9041-b10f00201acd/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2206eb52-04c5-42c9-8714-b10f001e1364",
            "index": 120,
            "title": "UL NO. 417: NSA's Broker Buys, AI-Assisted Attacks, Companies Only Want Killers",
            "pub_date": "2024-02-08T17:36:36.000Z",
            "duration": "1424",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-417-nsas-broker-buys-ai-assisted-attacks-com",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2206eb52-04c5-42c9-8714-b10f001e1364/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a327d227-3f96-4ef9-a4ec-b106015799df",
            "index": 121,
            "title": "A Conversation with Shil Sircar from BlackBerry Data Science",
            "pub_date": "2024-01-29T20:55:43.000Z",
            "duration": "2247",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-shil-sircar-from-blackberry-da",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a327d227-3f96-4ef9-a4ec-b106015799df/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9108bba5-0540-46b3-89ed-b101016c4d48",
            "index": 122,
            "title": "UL NO. 416: Tracking AI Agent Activity, 400 SF Cameras, AI Sleeper Agents…",
            "pub_date": "2024-01-24T22:11:28.000Z",
            "duration": "1409",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "agents",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-414-tracking-ai-agent-activity-400-sf-camera",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9108bba5-0540-46b3-89ed-b101016c4d48/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "604851dd-1728-4172-bbc8-b0ff01527bd8",
            "index": 123,
            "title": "A Conversation with Jason Kikta from Automox",
            "pub_date": "2024-01-22T20:38:37.000Z",
            "duration": "2724",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-jason-kikta-from-automox",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/604851dd-1728-4172-bbc8-b0ff01527bd8/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ba8f2b7-88e0-4ad5-9966-b0fb017ecbee",
            "index": 124,
            "title": "UL NO. 415: It's Raining 9+ CVEs, 40% Job Loss from AI, Invisible Prompt Injection…",
            "pub_date": "2024-01-19T02:04:54.000Z",
            "duration": "1300",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-415-its-raining-9-cves-40-job-loss-from-ai-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2ba8f2b7-88e0-4ad5-9966-b0fb017ecbee/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "08bf7dc3-3983-4471-906f-b0f300b3f487",
            "index": 125,
            "title": "UL NO. 414: LastPass Settings Upgrade, Boosting ChatGPT Output, AI Adding Societal Transparency",
            "pub_date": "2024-01-10T15:23:05.000Z",
            "duration": "1546",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "chatgpt"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-414-lastpass-settings-upgrade-boosting-chatg",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/08bf7dc3-3983-4471-906f-b0f300b3f487/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8383bd7d-93f6-4244-8ded-b0ef0077d83a",
            "index": 126,
            "title": "UL NO. 413: 7 Things to Expect from AI in 2024+, Xi Going Stalin, SSH's Terrapin…",
            "pub_date": "2024-01-06T19:47:56.000Z",
            "duration": "1479",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-413-7-things-to-expect-from-ai-in-2024-xi-go",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8383bd7d-93f6-4244-8ded-b0ef0077d83a/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b2c9f8d-10fb-4491-9459-b0df000219d7",
            "index": 127,
            "title": "A Conversation with Gabe Bernadett-Shapiro on AI",
            "pub_date": "2023-12-21T00:17:50.000Z",
            "duration": "2238",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "safety",
              "retrieval",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-gabe-bernadett-shapiro-on-ai",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/0b2c9f8d-10fb-4491-9459-b0df000219d7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a034fd66-5950-4622-9178-b0de002958b5",
            "index": 128,
            "title": "UL NO. 412: OpenAI's Prompt Guide, My Neovim Overhaul, The UL Character Sheet, And…",
            "pub_date": "2023-12-20T17:17:44.000Z",
            "duration": "1740",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-412-openais-prompt-guide-my-neovim-overhaul",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a034fd66-5950-4622-9178-b0de002958b5/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2be409c-86b3-4e92-9d4c-b0d801572539",
            "index": 129,
            "title": "UL NO. 411: ChatGPT Repeat Vuln, A UL AI Course!, Revenge Code Deletion",
            "pub_date": "2023-12-14T21:21:36.000Z",
            "duration": "1189",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-411-chatgpt-repeat-vuln-a-ul-ai-course-reven",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/c2be409c-86b3-4e92-9d4c-b0d801572539/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7d0855ff-8097-42ee-ac3d-b0d0003272e5",
            "index": 130,
            "title": "UL NO. 410: The Immigration/Identity Security Risk, Super Soldier Pentagon Talk, Okta&Me Updates, Teachable Agents",
            "pub_date": "2023-12-06T19:32:13.000Z",
            "duration": "1544",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-410-the-immigration-identity-security-risk-s",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7d0855ff-8097-42ee-ac3d-b0d0003272e5/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c499d99-6a3f-481a-b0aa-b0c700d01010",
            "index": 131,
            "title": "UL NO. 408: OpenAI Coup Theory, SEC vs. SolarWinds Analysis, Deepfake D&D Summaries",
            "pub_date": "2023-11-27T16:36:45.000Z",
            "duration": "2155",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-408-openai-coup-theory-sec-vs-solarwinds-ana",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/3c499d99-6a3f-481a-b0aa-b0c700d01010/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a4e0c61e-7218-472d-801c-b0ba00200f5f",
            "index": 132,
            "title": "UL NO. 407: OpenAI Prompt Injection, Leaky GPTs, AGI by 2028, Huberman Routine AI",
            "pub_date": "2023-11-14T05:42:59.000Z",
            "duration": "2422",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "openai",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-407-openai-prompt-injection-leaky-gpts-agi-b",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a4e0c61e-7218-472d-801c-b0ba00200f5f/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8550c39a-188b-41ec-9650-b0b901711618",
            "index": 133,
            "title": "OpenAI's New Releases Are a Watershed Moment for Human Creativity—and Prompt Injection",
            "pub_date": "2023-11-13T22:25:02.000Z",
            "duration": "221",
            "duration_label": "3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/openais-new-releases-are-a-watershed-moment-for-hu",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8550c39a-188b-41ec-9650-b0b901711618/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83b94d3c-e34c-43cd-87bb-b0b9016ec6d6",
            "index": 134,
            "title": "Why I'm Not Getting the New Humane AI Pin",
            "pub_date": "2023-11-13T22:16:27.000Z",
            "duration": "213",
            "duration_label": "3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/why-im-not-getting-the-new-humane-ai-pin",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/83b94d3c-e34c-43cd-87bb-b0b9016ec6d6/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e94fbd8b-0b6d-44ea-a79e-b0b6001f7c56",
            "index": 135,
            "title": "UL NO. 406: OpenAI Launches Custom AIs, Okta's New Breach, EFF's Browser Privacy Checker",
            "pub_date": "2023-11-10T02:05:00.000Z",
            "duration": "1708",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agi",
              "openai",
              "deepmind"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-406-openai-launches-custom-ais-oktas-new-bre",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e94fbd8b-0b6d-44ea-a79e-b0b6001f7c56/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "010597c6-e3aa-4a91-adcf-b0a601788d4e",
            "index": 136,
            "title": "UL NO. 404: ServiceNow Widget Flaws, North Korean Infiltrators, and the New Top-performing Prompt String…",
            "pub_date": "2023-10-26T01:03:14.000Z",
            "duration": "1599",
            "duration_label": "26m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-404-servicenow-widget-flaws-north-korean-inf",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/010597c6-e3aa-4a91-adcf-b0a601788d4e/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed0d5521-a6a3-4860-b9da-b09d012303b3",
            "index": 137,
            "title": "UL NO. 403: Signal Investigates Rumored Zero-Day Bug, AI Predicts New COVID-19 Strains, Dwindling US-China Scientific Collaboration...",
            "pub_date": "2023-10-16T18:25:15.000Z",
            "duration": "1703",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-403-signal-investigates-rumored-zero-day-bug",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/ed0d5521-a6a3-4860-b9da-b09d012303b3/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "245d4e5e-d2b6-46af-877c-b09801379555",
            "index": 138,
            "title": "UL NO. 402: Israeli Footage & Analysis, WSFTP + MOVEIT, AI Explainability, Andreessen vs. Perell on Writing, and more…",
            "pub_date": "2023-10-11T19:12:22.000Z",
            "duration": "1578",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-402-israeli-footage-analysis-wsftp-moveit-ai",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/245d4e5e-d2b6-46af-877c-b09801379555/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8f141643-4b00-44cd-a2c7-b090016e0a54",
            "index": 139,
            "title": "UL NO. 401: Sony hit again?, Taiwan Disinformation, Corporations Demand Hardcore Workers, and GPTVision Examples…",
            "pub_date": "2023-10-03T22:51:55.000Z",
            "duration": "1518",
            "duration_label": "25m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-401-sony-hit-again-taiwan-disinformation-cor",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8f141643-4b00-44cd-a2c7-b090016e0a54/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19747150-2285-4990-8c32-b08b0023c48f",
            "index": 140,
            "title": "UL NO. 400: What Hiring Managers Want, CVE Farming, Hunt Forward Operations, and AI vs. B2B Services",
            "pub_date": "2023-09-28T02:56:09.000Z",
            "duration": "1865",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-400-what-hiring-managers-want-cve-farming-hu",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/19747150-2285-4990-8c32-b08b0023c48f/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "45bc0237-c574-4f85-9c4e-b082004496cd",
            "index": 141,
            "title": "UL NO. 399: Wisdom Extraction From Any Text, Vegas Gets Cyber Jesus, AI Creativity Performance, Pentagon Cyber Strategy…",
            "pub_date": "2023-09-19T05:54:28.000Z",
            "duration": "2313",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-399-wisdom-extraction-from-any-text-vegas-ge",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/45bc0237-c574-4f85-9c4e-b082004496cd/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e55d50d6-bc7f-4b12-975e-b07b0120c357",
            "index": 142,
            "title": "UL NO. 398: Storm Vuln Stacking, CloudRecon, The S-Tier Guide to AI Whispering, Full-body MRIs…",
            "pub_date": "2023-09-12T17:56:08.000Z",
            "duration": "1208",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-398-storm-vuln-stacking-cloudrecon-the-s-tie",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e55d50d6-bc7f-4b12-975e-b07b0120c357/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fb4e2899-9d1d-407e-bb6a-b07601215e78",
            "index": 143,
            "title": "UL NO. 397: Propaganda in a Box, Glacier-like Security, AGI by 2028?, Ancient Wisdom via AI, and Newsletter Differentiation",
            "pub_date": "2023-09-07T18:27:21.000Z",
            "duration": "1584",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ul-no-397-propaganda-in-a-box-glacier-like-securit",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fb4e2899-9d1d-407e-bb6a-b07601215e78/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa317b20-ea62-4402-a26a-b06d0108db23",
            "index": 144,
            "title": "No. 396 - Elon's Doxxing FSD, ATHI AI Threat Modeling Framework, Cardboard Drones, and GPT Enterprise…",
            "pub_date": "2023-08-29T16:18:36.000Z",
            "duration": "1589",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-396-elons-doxxing-fsd-athi-ai-threat-modeling-f",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fa317b20-ea62-4402-a26a-b06d0108db23/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29c405c8-d8d2-4c16-bf50-b0650143254c",
            "index": 145,
            "title": "What I'm Doing and How It's Going",
            "pub_date": "2023-08-21T19:39:44.000Z",
            "duration": "1376",
            "duration_label": "22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/what-im-doing-and-how-its-going",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/29c405c8-d8d2-4c16-bf50-b0650143254c/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2b922014-6bfe-45f8-9a07-b0650123a6a1",
            "index": 146,
            "title": "NO. 395 — How I Make Money as an Independent, Tesla's Insider Data Breach, Bots Beating CAPTCHAs, and Escaping the Maze…",
            "pub_date": "2023-08-21T17:46:21.000Z",
            "duration": "1936",
            "duration_label": "32m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-395-how-i-make-money-as-an-independent-teslas-i",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2b922014-6bfe-45f8-9a07-b0650123a6a1/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f228261e-36ff-42b4-9a9b-b06000eded6e",
            "index": 147,
            "title": "NO. 394 — Vegas Recap, CISA MS Alert, China/US AI Fight, Deceased Kid AI, Following vs. Leading…",
            "pub_date": "2023-08-16T14:28:50.000Z",
            "duration": "1141",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-394-vegas-recap-cisa-ms-alert-china-us-ai-fight",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f228261e-36ff-42b4-9a9b-b06000eded6e/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97c68d6e-959b-46e4-8019-b05a00dcb150",
            "index": 148,
            "title": "No. 393 - Hacker Week, Deleting Google Info, And Creating High-Entropy Content",
            "pub_date": "2023-08-10T15:13:35.000Z",
            "duration": "1831",
            "duration_label": "30m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-393-hacker-week-deleting-google-info-and-creati",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/97c68d6e-959b-46e4-8019-b05a00dcb150/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0ba13950-1392-49c0-92d6-b050013f6869",
            "index": 149,
            "title": "NO. 392 — Trail of Bits Testing Handbook, Startups Freefall, and Chinese Propaganda Escalation…",
            "pub_date": "2023-07-31T19:26:11.000Z",
            "duration": "1112",
            "duration_label": "18m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-392-trail-of-bits-testing-handbook-startups-fre",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/0ba13950-1392-49c0-92d6-b050013f6869/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "916b31ca-cb49-4fd8-95f9-b04901137b94",
            "index": 150,
            "title": "NO. 391 — AI Manipulation Defenders, .MIL Leak, And The NPC Phenomenon",
            "pub_date": "2023-07-24T16:45:24.000Z",
            "duration": "1324",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-391-ai-manipulation-defenders-mil-leak-and-the",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/916b31ca-cb49-4fd8-95f9-b04901137b94/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a601f02-933f-4ed2-90f5-b0420103d329",
            "index": 151,
            "title": "NO. 390 — Voice Scams, FrontView Mirrors, and Idea Molecules",
            "pub_date": "2023-07-17T15:49:15.000Z",
            "duration": "1248",
            "duration_label": "20m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-390-voice-scams-frontview-mirrors-and-idea-mole",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/1a601f02-933f-4ed2-90f5-b0420103d329/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "079d1605-79dc-46a4-88b1-b03b01409743",
            "index": 152,
            "title": "NO. 389 — The Creativity Friction Coefficient, Lockbit v TSMC, and Detecting Smart Errors",
            "pub_date": "2023-07-10T19:30:22.000Z",
            "duration": "1088",
            "duration_label": "18m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-389-the-creativity-friction-coefficient-lockbit",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/079d1605-79dc-46a4-88b1-b03b01409743/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "299f18b6-9f85-4b0c-bf14-b03b005651e5",
            "index": 153,
            "title": "Sponsored Interview: Pentera",
            "pub_date": "2023-07-10T05:20:28.000Z",
            "duration": "2783",
            "duration_label": "46m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/sponsored-interview-pentera",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/299f18b6-9f85-4b0c-bf14-b03b005651e5/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e4b7c59e-113d-4779-8021-b02d011b4829",
            "index": 154,
            "title": "NO. 388 — Context Reflections, Critical Thinking, China's Decline, and NFC",
            "pub_date": "2023-06-26T17:14:57.000Z",
            "duration": "963",
            "duration_label": "16m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "generative ai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-388-context-reflections-critical-thinking-china",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e4b7c59e-113d-4779-8021-b02d011b4829/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9649f25-7ba3-43fb-ba6a-b027010aebe5",
            "index": 155,
            "title": "NO. 387 — Modern Parenting and Narcissism?, New Russian Hacking Unit, McKinsey AI Predictions, and more…",
            "pub_date": "2023-06-20T16:14:57.000Z",
            "duration": "1447",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-387-modern-parenting-and-narcissism-new-russian",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e9649f25-7ba3-43fb-ba6a-b027010aebe5/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c1efe8e-f514-4c48-912d-b01f011c3fdf",
            "index": 156,
            "title": "NO. 386 — DBIR 2023, Vision, Smol-Developer, and more…",
            "pub_date": "2023-06-12T17:21:25.000Z",
            "duration": "1562",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-385-dbir-2023-vision-smol-developer-and-more",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8c1efe8e-f514-4c48-912d-b01f011c3fdf/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eab14f82-0b51-4943-b538-b016011e2f85",
            "index": 157,
            "title": "NO. 384 — World AI Coin, Russian Power Attacks, Guidance AI Workflow…",
            "pub_date": "2023-06-03T17:25:11.000Z",
            "duration": "1290",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-384-world-ai-coin-russian-power-attacks-guidanc",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/eab14f82-0b51-4943-b538-b016011e2f85/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eac116c6-4bc5-44d4-b484-b004013018de",
            "index": 158,
            "title": "NO. 382 — AI Attack Surface Map, Digital Assistants, Dragos Nope, Rogue AI Girlfriend…",
            "pub_date": "2023-05-16T18:34:22.000Z",
            "duration": "1033",
            "duration_label": "17m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-382-ai-attack-surface-map-digital-assistants-dr",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/eac116c6-4bc5-44d4-b484-b004013018de/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b48cdff5-36b8-4e5e-8ad8-afff00f09d74",
            "index": 159,
            "title": "The Right Amount of Trauma",
            "pub_date": "2023-05-11T14:37:38.000Z",
            "duration": "479",
            "duration_label": "7m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/the-right-amount-of-trauma",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b48cdff5-36b8-4e5e-8ad8-afff00f09d74/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fe657d88-e98b-47f1-a414-affd0105eb0a",
            "index": 160,
            "title": "NO: 381 — Reviving Conference Strategies, Nurturing High-Performers, AI Business Takeover, Cyber Threats, and Diversifying Production 🧠🏢🦈📱🚗",
            "pub_date": "2023-05-09T15:56:53.000Z",
            "duration": "697",
            "duration_label": "11m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-381-reviving-conference-strategies-nurturing-hi",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fe657d88-e98b-47f1-a414-affd0105eb0a/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b07e702-5f36-44f8-8c0e-aff6012723e7",
            "index": 161,
            "title": "NO. 380 — LLM-Mind-Reading, Automated War, Rusty Sudo, Eliezer Bitterness Theory...",
            "pub_date": "2023-05-02T18:01:58.000Z",
            "duration": "1083",
            "duration_label": "18m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-380-llm-mind-reading-automated-war-rusy-sudo-el",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9b07e702-5f36-44f8-8c0e-aff6012723e7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b539178c-7401-4283-b334-afe700960820",
            "index": 162,
            "title": "NO. 378 — AI Resilience Scale, Moloch The Demon, Ukraine Data Leak, and more...",
            "pub_date": "2023-04-17T09:11:00.000Z",
            "duration": "1501",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-378-ai-resilience-scale-moloch-the-demon-ukrain",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b539178c-7401-4283-b334-afe700960820/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e26318fe-a3e1-43c2-99ae-afd90160551c",
            "index": 163,
            "title": "NO. 376 | AI transforms security, existential risk, and how to stay in front…",
            "pub_date": "2023-04-03T21:25:35.000Z",
            "duration": "1254",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-376-ai-transforms-security-existential-risk-and",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e26318fe-a3e1-43c2-99ae-afd90160551c/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "488e7942-1bfa-473b-8df3-afd2010624be",
            "index": 164,
            "title": "NO. 375 — 6 Post-GPT Phases, Github's Private Key, New Assistant Interfaces",
            "pub_date": "2023-03-27T15:57:14.000Z",
            "duration": "1040",
            "duration_label": "17m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-375-6-post-gpt-phases-githubs-private-key-new-a",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/488e7942-1bfa-473b-8df3-afd2010624be/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b74dd5a-c5e6-4b53-8a62-afcc0115c820",
            "index": 165,
            "title": "NO. 374 — AI Response Shaping, SpaceX Blueprints, GPT-4 Innovation Explosion…",
            "pub_date": "2023-03-21T16:53:09.000Z",
            "duration": "736",
            "duration_label": "12m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-374-ai-response-shaping-spacex-blueprints-gpt-4",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/4b74dd5a-c5e6-4b53-8a62-afcc0115c820/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "53a98f8b-a68f-48aa-8fd4-afc4011776db",
            "index": 166,
            "title": "NO. 373 — SPQA Architecture, LLaMA on M1 Mac, Loved Ones Voice Scams…",
            "pub_date": "2023-03-13T17:00:32.000Z",
            "duration": "1047",
            "duration_label": "17m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "llama"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-373-spqa-architecture-llama-on-m1-mac-loved-one",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/53a98f8b-a68f-48aa-8fd4-afc4011776db/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "27620a89-a5a1-4c2a-b161-afc40066eb21",
            "index": 167,
            "title": "Sponsored Interview — Kolide",
            "pub_date": "2023-03-13T06:20:31.000Z",
            "duration": "2249",
            "duration_label": "37m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/sponsored-interview-kolide",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/27620a89-a5a1-4c2a-b161-afc40066eb21/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "33e49ccd-020a-4b36-89a8-afbe00184450",
            "index": 168,
            "title": "NO. 372 — LastPass Employee Hack, State AI Propaganda, Crowdstrike Report Analysis…",
            "pub_date": "2023-03-07T01:35:07.000Z",
            "duration": "1764",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-372-lastpass-employee-hack-state-ai-propaganda",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/33e49ccd-020a-4b36-89a8-afbe00184450/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8b4aaa63-5e53-4064-b2bd-afb6015c5336",
            "index": 169,
            "title": "NO. 371 | Covid Lab Leak, Military Server Exposed, OAI Foundry…",
            "pub_date": "2023-02-27T21:12:29.000Z",
            "duration": "1367",
            "duration_label": "22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-371-covid-lab-leak-military-server-exposed-oai",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8b4aaa63-5e53-4064-b2bd-afb6015c5336/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2afd52eb-777b-470a-a7e6-afb0017bc8cb",
            "index": 170,
            "title": "NO. 370 | GoDaddy Hack, EU Chinese APTs, Hacking with ChatGPT",
            "pub_date": "2023-02-21T23:06:30.000Z",
            "duration": "864",
            "duration_label": "14m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "chatgpt"
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-370-godaddy-hack-eu-chinese-apts-hacking-with-c",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2afd52eb-777b-470a-a7e6-afb0017bc8cb/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fb9efded-b52f-42c6-acf1-afa801525e36",
            "index": 171,
            "title": "NO. 369 | Reddit Hack, Deepfake Scams, Embracing Change…",
            "pub_date": "2023-02-13T20:35:39.000Z",
            "duration": "1336",
            "duration_label": "22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-369-reddit-hack-deepfake-scams-embracing-change",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fb9efded-b52f-42c6-acf1-afa801525e36/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1e5bb975-2a1f-412b-919c-afa10179db34",
            "index": 172,
            "title": "NO. 368 | China Balloons, CustomGPT, 90s++…",
            "pub_date": "2023-02-06T22:59:18.000Z",
            "duration": "1092",
            "duration_label": "18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-368-china-balloons-customgpt-90s",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/1e5bb975-2a1f-412b-919c-afa10179db34/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "227f21ed-c7b2-4aa8-a5e7-af9a0107afd7",
            "index": 173,
            "title": "NO. 367 | Hive Ransom, Anti-Google, Software 2.0…",
            "pub_date": "2023-01-30T16:05:25.000Z",
            "duration": "866",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-367-hive-ransom-anti-google-software-2-0",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/227f21ed-c7b2-4aa8-a5e7-af9a0107afd7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "71c95edb-1784-487e-bdca-af9301070ad6",
            "index": 174,
            "title": "NO. 366 | T-Breach, Siri++, Conception Ages…",
            "pub_date": "2023-01-23T16:01:15.000Z",
            "duration": "942",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-366-t-breach-siri-conception-ages",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/71c95edb-1784-487e-bdca-af9301070ad6/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "74fa0d09-d79a-49b8-abdb-af8d01138752",
            "index": 175,
            "title": "NO. 365 | China's Decline, MicrosoftAI, Creativity Ratio…",
            "pub_date": "2023-01-17T16:45:56.000Z",
            "duration": "669",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-365-chinas-decline-microsoftai-creativity-ratio",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/74fa0d09-d79a-49b8-abdb-af8d01138752/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "263f04be-9164-418c-8263-af850106ea1d",
            "index": 176,
            "title": "NO. 364 | Reality Headset, BingPT, AI+Cyber",
            "pub_date": "2023-01-09T16:00:11.000Z",
            "duration": "902",
            "duration_label": "15m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-364-reality-headset-bingpt-ai-cyber",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/263f04be-9164-418c-8263-af850106ea1d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "39d393e9-2886-4118-bcde-af7f00fa5aea",
            "index": 177,
            "title": "NO. 363 | NEWS, ANALYSIS, and DISCOVERY SERIES",
            "pub_date": "2023-01-03T15:13:29.000Z",
            "duration": "802",
            "duration_label": "13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/363",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/39d393e9-2886-4118-bcde-af7f00fa5aea/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19d7b2ca-ed38-476c-8444-af70012fe448",
            "index": 178,
            "title": "NO. 362 | Dependency Scanner, Citrix Attacks, AI Analysis…",
            "pub_date": "2022-12-19T18:28:08.000Z",
            "duration": "747",
            "duration_label": "12m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-362-dependency-scanner-citrix-attacks-ai-analys",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/19d7b2ca-ed38-476c-8444-af70012fe448/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "39b69612-feca-4862-aaa2-af690118a6bb",
            "index": 179,
            "title": "NO. 361 | GPT++, Apple Security, CISA Cuba…",
            "pub_date": "2022-12-12T17:03:43.000Z",
            "duration": "733",
            "duration_label": "12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-361-gpt-apple-security-cisa-cuba",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/39b69612-feca-4862-aaa2-af690118a6bb/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dad568c2-e1f5-4dfa-aaf3-af620113f6b2",
            "index": 180,
            "title": "NO. 360 | NEWS, ANALYSIS & DISCOVERY SERIES",
            "pub_date": "2022-12-05T16:46:46.000Z",
            "duration": "797",
            "duration_label": "13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-360-news-analysis-discovery-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/dad568c2-e1f5-4dfa-aaf3-af620113f6b2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f6f5c95a-73a2-4278-9d16-af600053aee1",
            "index": 181,
            "title": "Erkang Zheng of JupiterOne | SPONSORED INTERVIEW SERIES",
            "pub_date": "2022-12-03T05:09:19.000Z",
            "duration": "1637",
            "duration_label": "27m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/erkang-zheng-of-jupiterone-sponsored-interview-ser",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f6f5c95a-73a2-4278-9d16-af600053aee1/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f14ebb96-8ae6-4dfb-9a4b-af5b01180c58",
            "index": 182,
            "title": "NO. 359 | THE NEWS, ANALYSIS & DISCOVERY SERIES",
            "pub_date": "2022-11-28T17:01:42.000Z",
            "duration": "587",
            "duration_label": "9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-359-the-news-analysis-discovery-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f14ebb96-8ae6-4dfb-9a4b-af5b01180c58/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b0d2417b-f566-4dc4-80ca-af5b00487eb8",
            "index": 183,
            "title": "Scott Kuffer of Nucleus Security | SPONSORED INTERVIEW SERIES",
            "pub_date": "2022-11-28T04:35:05.000Z",
            "duration": "2851",
            "duration_label": "47m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/scott-kuffer-of-nucleus-security-sponsored-intervi",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b0d2417b-f566-4dc4-80ca-af5b00487eb8/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "73bc4b38-e94a-4b98-ac28-af5500905f64",
            "index": 184,
            "title": "NO. 358 | NEWS, ANALYSIS, & DISCOVERY SERIES",
            "pub_date": "2022-11-22T08:47:53.000Z",
            "duration": "896",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-358-news-analysis-discovery-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/73bc4b38-e94a-4b98-ac28-af5500905f64/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bef1aa9a-b747-4370-806d-af4d010ebf8b",
            "index": 185,
            "title": "NO. 357 | NEWS, ANALYSIS, & DISCOVERY SERIES",
            "pub_date": "2022-11-14T16:30:53.000Z",
            "duration": "759",
            "duration_label": "12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-357-news-analysis-discovery-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/bef1aa9a-b747-4370-806d-af4d010ebf8b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b5f7e450-ba4f-435f-a6c0-af46012fa71c",
            "index": 186,
            "title": "NO. 356 | NEWS, ANALYSIS & DISCOVERY SERIES",
            "pub_date": "2022-11-07T18:34:15.000Z",
            "duration": "674",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-356-news-analysis-discovery-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b5f7e450-ba4f-435f-a6c0-af46012fa71c/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e621cb15-3ee9-4379-a943-af3f007c5a71",
            "index": 187,
            "title": "NO. 355 | NEWS & ANALYSIS SERIES",
            "pub_date": "2022-10-31T07:36:05.000Z",
            "duration": "827",
            "duration_label": "13m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-355-news-analysis-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e621cb15-3ee9-4379-a943-af3f007c5a71/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c21b8ca-8648-42e7-8220-af3b0042dce2",
            "index": 188,
            "title": "Why Everyone Needs a Blog | THE IDEA SERIES",
            "pub_date": "2022-10-27T04:04:30.000Z",
            "duration": "243",
            "duration_label": "4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/why-everyone-needs-a-blog-the-idea-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/6c21b8ca-8648-42e7-8220-af3b0042dce2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2be888ca-ed7e-4161-85d5-af3a015c7157",
            "index": 189,
            "title": "Creativity Comes From Idleness | THE IDEA SERIES",
            "pub_date": "2022-10-26T21:09:24.000Z",
            "duration": "174",
            "duration_label": "2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/creativity-comes-from-idleness-the-idea-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2be888ca-ed7e-4161-85d5-af3a015c7157/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a87bdec5-15f7-49a7-ad7e-af39004528df",
            "index": 190,
            "title": "AI Art Will Push the Top 1% to Human Artists | THE IDEA SERIES",
            "pub_date": "2022-10-25T04:12:57.000Z",
            "duration": "245",
            "duration_label": "4m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://omny.fm/shows/unsupervised-learning/ai-art-will-push-the-top-1-to-human-artists",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a87bdec5-15f7-49a7-ad7e-af39004528df/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d6a3fed6-ffca-4ed4-845c-af3800e901b2",
            "index": 191,
            "title": "NO. 354 | THE NEWS & ANALYSIS SERIES",
            "pub_date": "2022-10-24T14:09:31.000Z",
            "duration": "1083",
            "duration_label": "18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/no-354-the-news-analysis-series",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/d6a3fed6-ffca-4ed4-845c-af3800e901b2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "53bd15b0-e83c-4033-9571-af35017434aa",
            "index": 192,
            "title": "Humiliation is Deadly | THE IDEA SERIES",
            "pub_date": "2022-10-21T22:36:49.000Z",
            "duration": "670",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/humiliation-is-deadly",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/53bd15b0-e83c-4033-9571-af35017434aa/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c888c41-6e36-4939-9cc8-af31010231c3",
            "index": 193,
            "title": "NO. 353 | THE NEWS & ANALYSIS SERIES",
            "pub_date": "2022-10-17T15:41:00.000Z",
            "duration": "540",
            "duration_label": "9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-353",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9c888c41-6e36-4939-9cc8-af31010231c3/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e6c7a15-7c3d-44df-98d3-af2c001e8490",
            "index": 194,
            "title": "News & Analysis | NO. 352",
            "pub_date": "2022-10-12T01:53:08.000Z",
            "duration": "785",
            "duration_label": "13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-352",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/6e6c7a15-7c3d-44df-98d3-af2c001e8490/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f01c5530-657f-4ecc-8788-af2300fd2544",
            "index": 195,
            "title": "News & Analysis | NO. 351",
            "pub_date": "2022-10-03T15:22:55.000Z",
            "duration": "1059",
            "duration_label": "17m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-351",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f01c5530-657f-4ecc-8788-af2300fd2544/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "64c72274-0f83-49a8-8359-af1c011797fa",
            "index": 196,
            "title": "News & Analysis | NO. 350",
            "pub_date": "2022-09-26T16:59:13.000Z",
            "duration": "916",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-350",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/64c72274-0f83-49a8-8359-af1c011797fa/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7aba5020-e312-47f2-b1fd-af1600ff097b",
            "index": 197,
            "title": "News & Analysis: NO. 349",
            "pub_date": "2022-09-20T15:31:35.000Z",
            "duration": "843",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-349",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/7aba5020-e312-47f2-b1fd-af1600ff097b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dedbc270-0600-4d30-bf91-af0e01028b6d",
            "index": 198,
            "title": "News & Analysis | NO. 348 | Spearmishing, Patreon Security, and Triple-Threat Ransomware",
            "pub_date": "2022-09-12T15:42:49.000Z",
            "duration": "1401",
            "duration_label": "23m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-348",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/dedbc270-0600-4d30-bf91-af0e01028b6d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ebb4174e-4b96-46ac-9d85-af090111239f",
            "index": 199,
            "title": "Metagaming: An Interview with Andrew Ringlein",
            "pub_date": "2022-09-07T16:38:05.000Z",
            "duration": "3206",
            "duration_label": "53m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/metagaming-an-interview-with-andrew-ringlein",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/ebb4174e-4b96-46ac-9d85-af090111239f/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "088c2fa9-94f3-4d2e-b042-af0800edf8f7",
            "index": 200,
            "title": "News & Analysis | NO. 347",
            "pub_date": "2022-09-06T14:27:32.000Z",
            "duration": "941",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-347",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/088c2fa9-94f3-4d2e-b042-af0800edf8f7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "766719f0-0570-4b7f-900a-af000107b3b6",
            "index": 201,
            "title": "News & Analysis | NO. 346",
            "pub_date": "2022-08-29T16:02:34.000Z",
            "duration": "1194",
            "duration_label": "19m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-346",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/766719f0-0570-4b7f-900a-af000107b3b6/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "431122dc-4478-46c9-bc1f-aef900f3248e",
            "index": 202,
            "title": "News & Analysis | NO. 345",
            "pub_date": "2022-08-22T14:46:25.000Z",
            "duration": "960",
            "duration_label": "16m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-345",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/431122dc-4478-46c9-bc1f-aef900f3248e/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "401b2d90-07d6-42a8-809a-aef40117ad92",
            "index": 203,
            "title": "News & Analysis | NO. 344",
            "pub_date": "2022-08-17T16:59:36.000Z",
            "duration": "799",
            "duration_label": "13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-344",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/401b2d90-07d6-42a8-809a-aef40117ad92/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e1ff0e8a-2560-4886-a0bd-aeeb00f04b5e",
            "index": 204,
            "title": "News & Analysis | NO. 343",
            "pub_date": "2022-08-08T14:36:24.000Z",
            "duration": "745",
            "duration_label": "12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-343",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e1ff0e8a-2560-4886-a0bd-aeeb00f04b5e/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "839fad44-d9e6-4039-b8bd-aee500e4808d",
            "index": 205,
            "title": "News & Analysis | NO. 342",
            "pub_date": "2022-08-02T13:55:00.000Z",
            "duration": "685",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-342",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/839fad44-d9e6-4039-b8bd-aee500e4808d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1c2162b1-3738-4779-a2e0-aedd00f4a9e4",
            "index": 206,
            "title": "News & Analysis | NO. 341",
            "pub_date": "2022-07-25T14:52:03.000Z",
            "duration": "952",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-341",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/1c2162b1-3738-4779-a2e0-aedd00f4a9e4/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b44610eb-146f-4fee-9dec-aed6009c407d",
            "index": 207,
            "title": "News & Analysis | NO. 340 | SF Surveillance, APTs vs. Journalists, TikTok Changes…",
            "pub_date": "2022-07-18T09:30:53.000Z",
            "duration": "1278",
            "duration_label": "21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-340-sf-surveillance-apts-vs-journ",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b44610eb-146f-4fee-9dec-aed6009c407d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c04bf73a-3f87-4d78-a076-aecf00f1cabf",
            "index": 208,
            "title": "News & Analysis | NO. 339",
            "pub_date": "2022-07-11T14:41:22.000Z",
            "duration": "1156",
            "duration_label": "19m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-339",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/c04bf73a-3f87-4d78-a076-aecf00f1cabf/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "241a78a8-81a6-4de1-ae2b-aecf00e3d991",
            "index": 209,
            "title": "Sponsored Lunch Interview: Keeper Security",
            "pub_date": "2022-07-11T13:53:04.000Z",
            "duration": "2000",
            "duration_label": "33m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/sponsored-lunch-interview-keeper-security",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/241a78a8-81a6-4de1-ae2b-aecf00e3d991/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bf1e75e0-dcad-4124-a277-aec9010ac528",
            "index": 210,
            "title": "News & Analysis | NO. 338 | Deepfake Interviews, China Leak, Hacker Services…",
            "pub_date": "2022-07-05T16:13:37.000Z",
            "duration": "1243",
            "duration_label": "20m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-338-deepfake-interviews-china-lea",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/bf1e75e0-dcad-4124-a277-aec9010ac528/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2c0c0763-82a5-4cb0-b3f1-aec1010668d9",
            "index": 211,
            "title": "News & Analysis | NO. 337",
            "pub_date": "2022-06-27T15:56:30.000Z",
            "duration": "1225",
            "duration_label": "20m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-337",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/2c0c0763-82a5-4cb0-b3f1-aec1010668d9/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cdc98c73-26c3-4786-99c1-aeba0146f288",
            "index": 212,
            "title": "News & Analysis | NO. 336",
            "pub_date": "2022-06-20T19:51:08.000Z",
            "duration": "909",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-336",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/cdc98c73-26c3-4786-99c1-aeba0146f288/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fda0f2c0-41ab-46b3-9e5b-aeb30118ab96",
            "index": 213,
            "title": "News & Analysis | NO. 335",
            "pub_date": "2022-06-13T17:02:50.000Z",
            "duration": "918",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-335",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/fda0f2c0-41ab-46b3-9e5b-aeb30118ab96/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "14e988c0-c24d-4d0d-a3bb-aea600feab5d",
            "index": 214,
            "title": "News & Analysis | NO. 333",
            "pub_date": "2022-05-31T15:28:18.000Z",
            "duration": "1288",
            "duration_label": "21m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-333",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/14e988c0-c24d-4d0d-a3bb-aea600feab5d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b55901c3-985d-466e-a480-ae97015c8872",
            "index": 215,
            "title": "News & Analysis | NO. 331",
            "pub_date": "2022-05-16T21:09:28.000Z",
            "duration": "76",
            "duration_label": "1m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-331",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/b55901c3-985d-466e-a480-ae97015c8872/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3ffc480c-4ad3-4bf6-bd84-ae90010ae193",
            "index": 216,
            "title": "News & Analysis | NO. 330",
            "pub_date": "2022-05-09T16:12:25.000Z",
            "duration": "845",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-330",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/3ffc480c-4ad3-4bf6-bd84-ae90010ae193/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e8f1c17-ff6b-46b5-9c6d-ae8900f93317",
            "index": 217,
            "title": "Why I'm Not Worried About Elon Musk Buying Twitter",
            "pub_date": "2022-05-02T15:08:18.000Z",
            "duration": "325",
            "duration_label": "5m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/why-im-not-worried-about-elon-musk-buying-twitter",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/4e8f1c17-ff6b-46b5-9c6d-ae8900f93317/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "30cad4d3-ef90-437b-aea4-ae8900f67f0b",
            "index": 218,
            "title": "News & Analysis: NO. 329",
            "pub_date": "2022-05-02T14:59:59.000Z",
            "duration": "668",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-329",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/30cad4d3-ef90-437b-aea4-ae8900f67f0b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9f6ce88c-290f-4017-bb7c-ae8900eb714e",
            "index": 219,
            "title": "A Conversation with Paul Zimski from Automox",
            "pub_date": "2022-05-02T14:22:36.000Z",
            "duration": "1768",
            "duration_label": "29m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-conversation-with-paul-zimski-from-automox",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9f6ce88c-290f-4017-bb7c-ae8900eb714e/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "73e8cc51-cfb1-452c-8e74-ae82010ff67b",
            "index": 220,
            "title": "News & Analysis | NO. 328",
            "pub_date": "2022-04-25T16:30:57.000Z",
            "duration": "807",
            "duration_label": "13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-328",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/73e8cc51-cfb1-452c-8e74-ae82010ff67b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5ea65c65-c77a-4b13-9878-ae7b010d7e49",
            "index": 221,
            "title": "News & Analysis | NO. 327",
            "pub_date": "2022-04-18T16:22:06.000Z",
            "duration": "721",
            "duration_label": "12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-327",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/5ea65c65-c77a-4b13-9878-ae7b010d7e49/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "481e3506-e49e-464c-b93c-ae7400f977e9",
            "index": 222,
            "title": "News & Analysis | NO. 326",
            "pub_date": "2022-04-11T15:09:02.000Z",
            "duration": "726",
            "duration_label": "12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-326",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/481e3506-e49e-464c-b93c-ae7400f977e9/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5e2aacb9-14b8-4f4a-87b4-ae6d00f8a37a",
            "index": 223,
            "title": "News & Analysis | NO. 325",
            "pub_date": "2022-04-04T15:05:53.000Z",
            "duration": "843",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-325",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/5e2aacb9-14b8-4f4a-87b4-ae6d00f8a37a/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9fdf0972-9c88-45b3-835c-ae660105e5f7",
            "index": 224,
            "title": "News & Analysis | NO. 324",
            "pub_date": "2022-03-28T15:54:20.000Z",
            "duration": "1131",
            "duration_label": "18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-324",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9fdf0972-9c88-45b3-835c-ae660105e5f7/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f3442079-10d6-413b-9c6b-ae5f0103e6fe",
            "index": 225,
            "title": "News & Analysis | NO. 323",
            "pub_date": "2022-03-21T15:46:54.000Z",
            "duration": "826",
            "duration_label": "13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-323",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f3442079-10d6-413b-9c6b-ae5f0103e6fe/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9063f983-b2c2-444c-ac46-ae5801105fef",
            "index": 226,
            "title": "News & Analysis | NO. 322",
            "pub_date": "2022-03-14T16:32:36.000Z",
            "duration": "931",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-322",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9063f983-b2c2-444c-ac46-ae5801105fef/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed661674-a5a4-48aa-b54b-ae53009d7094",
            "index": 227,
            "title": "News & Analysis | NO. 321",
            "pub_date": "2022-03-09T09:34:00.000Z",
            "duration": "879",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-321",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/ed661674-a5a4-48aa-b54b-ae53009d7094/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bc38e3ef-ee4b-4afa-bac5-ae51006221ea",
            "index": 228,
            "title": "Sponsored Conversation: Ev Kontsevoy from Teleport",
            "pub_date": "2022-03-07T06:04:39.000Z",
            "duration": "2459",
            "duration_label": "40m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/sponsored-conversation-ev-kontsevoy-from-teleport",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/bc38e3ef-ee4b-4afa-bac5-ae51006221ea/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e097e9d0-339b-4350-867f-ae5001487a55",
            "index": 229,
            "title": "Andrew Ringlein's 5 Crypto Accelerators in Gaming and Business",
            "pub_date": "2022-03-06T20:00:46.000Z",
            "duration": "3956",
            "duration_label": "1h 5m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/andrew-ringleins-5-crypto-accelerators-in-gaming-a",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e097e9d0-339b-4350-867f-ae5001487a55/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9bfd41a-7f04-4d28-b7fe-ae4a0108521e",
            "index": 230,
            "title": "News & Analysis | NO. 320",
            "pub_date": "2022-02-28T16:03:20.000Z",
            "duration": "1089",
            "duration_label": "18m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-320",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a9bfd41a-7f04-4d28-b7fe-ae4a0108521e/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1696503b-2d5e-4eef-bb40-ae440106dcaa",
            "index": 231,
            "title": "News & Analysis | NO. 319",
            "pub_date": "2022-02-22T15:57:37.000Z",
            "duration": "525",
            "duration_label": "8m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-319",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/1696503b-2d5e-4eef-bb40-ae440106dcaa/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "716a8381-0619-4709-8d51-ae3c01037385",
            "index": 232,
            "title": "News & Analysis | NO. 318",
            "pub_date": "2022-02-14T15:45:14.000Z",
            "duration": "665",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-318",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/716a8381-0619-4709-8d51-ae3c01037385/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8b005d46-f431-4ba0-8ad6-ae35014dfe8b",
            "index": 233,
            "title": "News & Analysis | NO. 317",
            "pub_date": "2022-02-07T20:16:53.000Z",
            "duration": "859",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-317",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8b005d46-f431-4ba0-8ad6-ae35014dfe8b/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6b1c4439-fb60-4ffb-90c0-ae2e0104fc74",
            "index": 234,
            "title": "News & Analysis | NO. 316",
            "pub_date": "2022-01-31T15:50:53.000Z",
            "duration": "723",
            "duration_label": "12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-316",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/6b1c4439-fb60-4ffb-90c0-ae2e0104fc74/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ebb063dc-3fe5-4d3f-8d55-ae2701073e40",
            "index": 235,
            "title": "News & Analysis | NO. 315",
            "pub_date": "2022-01-24T15:59:07.000Z",
            "duration": "570",
            "duration_label": "9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-315",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/ebb063dc-3fe5-4d3f-8d55-ae2701073e40/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6744e338-5e7f-4f49-95df-ae21011db90d",
            "index": 236,
            "title": "Your Value Comes from Your Output",
            "pub_date": "2022-01-18T17:24:29.000Z",
            "duration": "374",
            "duration_label": "6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/your-value-comes-from-your-output",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/6744e338-5e7f-4f49-95df-ae21011db90d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e20d91be-d61c-47aa-b3fc-ae21011948f9",
            "index": 237,
            "title": "News & Analysis: NO. 314",
            "pub_date": "2022-01-18T17:05:10.000Z",
            "duration": "671",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-314",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/e20d91be-d61c-47aa-b3fc-ae21011948f9/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "74d2b23d-71bc-4cc3-bd9c-ae1900f7cd41",
            "index": 238,
            "title": "News & Analysis: No. 313",
            "pub_date": "2022-01-10T15:02:55.000Z",
            "duration": "992",
            "duration_label": "16m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-313",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/74d2b23d-71bc-4cc3-bd9c-ae1900f7cd41/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a5252350-cf47-4e6f-9a0d-ae12010ac173",
            "index": 239,
            "title": "News & Analysis | No. 312",
            "pub_date": "2022-01-03T16:12:08.000Z",
            "duration": "925",
            "duration_label": "15m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-312",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a5252350-cf47-4e6f-9a0d-ae12010ac173/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3aad34d9-e277-4f45-ac2d-ae04010732d5",
            "index": 240,
            "title": "A Short Episode Before the Holidays",
            "pub_date": "2021-12-20T15:59:29.000Z",
            "duration": "283",
            "duration_label": "4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/a-short-episode-before-the-holidays",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/3aad34d9-e277-4f45-ac2d-ae04010732d5/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9a657f91-1a85-43fc-af91-adfd011259a2",
            "index": 241,
            "title": "The Vigilant",
            "pub_date": "2021-12-13T16:40:00.000Z",
            "duration": "141",
            "duration_label": "2m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/the-vigilant",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/9a657f91-1a85-43fc-af91-adfd011259a2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "af751df4-dd2a-48fe-b84c-adfd01005a71",
            "index": 242,
            "title": "News & Analysis | No. 311",
            "pub_date": "2021-12-13T15:34:10.000Z",
            "duration": "872",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-311",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/af751df4-dd2a-48fe-b84c-adfd01005a71/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f39224dc-6b3d-46e6-b5b7-adf601089409",
            "index": 243,
            "title": "News & Analysis | No. 310",
            "pub_date": "2021-12-06T16:04:01.000Z",
            "duration": "592",
            "duration_label": "9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-310",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f39224dc-6b3d-46e6-b5b7-adf601089409/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f114f84c-233d-4a4f-aa9c-adef010b2a97",
            "index": 244,
            "title": "News & Analysis | No. 309",
            "pub_date": "2021-11-29T16:13:00.000Z",
            "duration": "693",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-309",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/f114f84c-233d-4a4f-aa9c-adef010b2a97/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0fe5a3c4-f9d9-4703-89bb-ade8010c5977",
            "index": 245,
            "title": "News & Analysis | No. 308",
            "pub_date": "2021-11-22T16:17:39.000Z",
            "duration": "411",
            "duration_label": "6m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-308",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/0fe5a3c4-f9d9-4703-89bb-ade8010c5977/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8284f91c-2f7b-4fa8-aab2-ade100f012e2",
            "index": 246,
            "title": "Degrees and Credentials in InfoSec",
            "pub_date": "2021-11-15T14:35:00.000Z",
            "duration": "262",
            "duration_label": "4m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/degrees-and-credentials-in-infosec",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/8284f91c-2f7b-4fa8-aab2-ade100f012e2/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "86955297-abfa-47e7-8a6e-ade100ed321d",
            "index": 247,
            "title": "News & Analysis | No. 307",
            "pub_date": "2021-11-15T14:24:00.000Z",
            "duration": "1336",
            "duration_label": "22m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-307",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/86955297-abfa-47e7-8a6e-ade100ed321d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "43a52354-6b8a-4484-8cca-adda005edd0d",
            "index": 248,
            "title": "News & Analysis | No. 306",
            "pub_date": "2021-11-08T05:46:14.000Z",
            "duration": "962",
            "duration_label": "16m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-306",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/43a52354-6b8a-4484-8cca-adda005edd0d/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a208fe65-bc56-46cf-aa4d-add30104dd54",
            "index": 249,
            "title": "News & Analysis | No. 305",
            "pub_date": "2021-11-01T15:50:27.000Z",
            "duration": "540",
            "duration_label": "9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-305-1",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/a208fe65-bc56-46cf-aa4d-add30104dd54/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1a22b712-2adc-4040-9738-adcc0064510c",
            "index": 250,
            "title": "News & Analysis | No. 304",
            "pub_date": "2021-10-25T06:05:50.000Z",
            "duration": "233",
            "duration_label": "3m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://omny.fm/shows/unsupervised-learning/news-analysis-no-304",
            "audio_url": "https://mgln.ai/e/p5837/pscrb.fm/rss/p/traffic.omny.fm/d/clips/070af456-729b-4a0f-9c09-a6c100397b59/3b159371-276d-429e-ae86-a6c1003b01c4/1a22b712-2adc-4040-9738-adcc0064510c/audio.mp3?utm_source=Podcast&in_playlist=7b61d4e1-bd3d-4d3f-97c2-a6c1003b01c9",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "possible",
        "title": "Possible",
        "feed_title": "Possible",
        "priority": "P2",
        "selection_mode": "keyword",
        "focus": [
          "AI and society",
          "future work",
          "policy",
          "culture"
        ],
        "feed_url": "https://feeds.megaphone.fm/possible",
        "source_url": "https://feeds.megaphone.fm/possible",
        "detail_path": "/podcasts/possible/",
        "episode_count": 147,
        "selected_episode_count": 137,
        "latest_episode_title": "Satya Nadella on making human and token capital compound",
        "latest_pub_date": "2026-06-05T14:00:00.000Z",
        "latest_page_url": "",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "fd094580-60cb-11f1-b413-bfe53efedaf3",
            "index": 1,
            "title": "Satya Nadella on making human and token capital compound",
            "pub_date": "2026-06-05T14:00:00.000Z",
            "duration": "3691",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7403460710.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ebe042e6-5f08-11f1-994a-d728e3f08775",
            "index": 2,
            "title": "What it takes to trust AI | Kanjun Qiu",
            "pub_date": "2026-06-03T07:01:00.000Z",
            "duration": "3398",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "nvidia"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6644658282.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66ba12ee-595f-11f1-98f8-97957df6491b",
            "index": 3,
            "title": "AI’s hidden 20-year monopoly",
            "pub_date": "2026-05-27T07:00:00.000Z",
            "duration": "2066",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9658489236.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5ce3856-53e1-11f1-aefe-db02fdee5ece",
            "index": 4,
            "title": "How fast can you upskill in AI? We did a sprint to find out.",
            "pub_date": "2026-05-20T07:01:00.000Z",
            "duration": "2294",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT3415657721.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22b5acc0-4e7e-11f1-b656-db49fb93781a",
            "index": 5,
            "title": "Anthropic’s push into finance",
            "pub_date": "2026-05-13T07:00:00.000Z",
            "duration": "1956",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8107235207.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 57,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "afa03bf8-490d-11f1-ae0e-cf75e97bd73d",
            "index": 6,
            "title": "The artist AI can’t kill",
            "pub_date": "2026-05-06T07:01:00.000Z",
            "duration": "3823",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7885138487.mp3?updated=1778047373",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 174,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9d3a90d2-4389-11f1-adc3-afdbbb1c9908",
            "index": 7,
            "title": "Divine intervention in AI",
            "pub_date": "2026-04-29T07:01:00.000Z",
            "duration": "1647",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7444957112.mp3?updated=1777447022",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 43,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3f4dc6d8-3dfd-11f1-b31e-8b1c6f1be5cd",
            "index": 8,
            "title": "Netflix co-founder Reed Hastings: stories, schools, superpowers",
            "pub_date": "2026-04-22T07:01:00.000Z",
            "duration": "3685",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1497885631.mp3?updated=1776845334",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 183,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "db8d6e7c-388f-11f1-b41f-c3186e2b5dc7",
            "index": 9,
            "title": "The grid(lock) slowing AI down",
            "pub_date": "2026-04-15T07:01:00.000Z",
            "duration": "1670",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "gemini"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1384990980.mp3?updated=1776235173",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 41,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "fa1f3eb8-3305-11f1-8816-a70875ef2619",
            "index": 10,
            "title": "AI’s expanding attack surface",
            "pub_date": "2026-04-08T07:01:00.000Z",
            "duration": "1395",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chips",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9156009774.mp3?updated=1775627496",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 37,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e42f07f6-2d87-11f1-a8ef-4f51d17c43d9",
            "index": 11,
            "title": "Should we give AI a bank account?",
            "pub_date": "2026-04-01T07:01:00.000Z",
            "duration": "3512",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6171121521.mp3?updated=1775021232",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 146,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f185b640-27e0-11f1-8fcf-cf7f827faf7a",
            "index": 12,
            "title": "After SaaS",
            "pub_date": "2026-03-25T07:00:00.000Z",
            "duration": "1246",
            "duration_label": "20m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4933221311.mp3?updated=1774461500",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 37,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6619dd6c-2253-11f1-ba94-939004352ba3",
            "index": 13,
            "title": "Humans secretly prefer AI writing",
            "pub_date": "2026-03-18T07:00:00.000Z",
            "duration": "1462",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2094947999.mp3?updated=1773814465",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 12,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "368494f8-1d0c-11f1-ad0d-4bf0ba7cfafe",
            "index": 14,
            "title": "The AI Kept Choosing War",
            "pub_date": "2026-03-11T07:01:00.000Z",
            "duration": "2056",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "reasoning",
              "automation"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5483877270.mp3?updated=1773208254",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 55,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "65a3c7ce-179c-11f1-b828-2bb2d715f8c7",
            "index": 15,
            "title": "How Notion rebuilt for the age of AI",
            "pub_date": "2026-03-04T08:01:00.000Z",
            "duration": "3642",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8484687597.mp3?updated=1772610872",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 168,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "abe5c1a8-1213-11f1-aeaf-0ff35c155c1c",
            "index": 16,
            "title": "Network effects, AI medicine, and the fight for free speech",
            "pub_date": "2026-02-25T08:01:00.000Z",
            "duration": "1376",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8342751195.mp3?updated=1772008065",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 44,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6b559c0a-0c8a-11f1-829b-9bc4a7a3d8cf",
            "index": 17,
            "title": "Does AI really save time?",
            "pub_date": "2026-02-18T08:01:00.000Z",
            "duration": "1597",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5496229841.mp3?updated=1771393798",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 43,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "4c6c980c-0708-11f1-9806-93af51d6f68d",
            "index": 18,
            "title": "Making sense of the layoff wave",
            "pub_date": "2026-02-11T08:01:00.000Z",
            "duration": "1821",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5189482961.mp3?updated=1770791485",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 59,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a66bdda6-0161-11f1-8945-eb8dfdc3aa1b",
            "index": 19,
            "title": "CryptoPunks creators: from art experiment to cultural movement",
            "pub_date": "2026-02-04T08:01:00.000Z",
            "duration": "2961",
            "duration_label": "49m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8789970072.mp3?updated=1770167830",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "052d8048-fc07-11f0-8623-2ffdbfabfb81",
            "index": 20,
            "title": "Reid Riffs with Parth Patil on AI-Native Startups (Part 3 of 3)",
            "pub_date": "2026-01-28T08:01:00.000Z",
            "duration": "2070",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7499372021.mp3?updated=1769582747",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 84,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "2d9aab10-f693-11f0-b516-b7dbe3c43897",
            "index": 21,
            "title": "Reid Riffs with Parth Patil on Enterprise AI Integration (Part 2 of 3)",
            "pub_date": "2026-01-21T08:01:00.000Z",
            "duration": "2407",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "automation",
              "enterprise ai"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1698791345.mp3?updated=1768979787",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11d589e8-f10e-11f0-af8a-b7169e063784",
            "index": 22,
            "title": "Reid Riffs with Parth Patil on Individual AI Mastery (Part 1 of 3)",
            "pub_date": "2026-01-14T08:01:00.000Z",
            "duration": "2718",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "copilot"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5988953621.mp3?updated=1768371899",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5288588-eb89-11f0-8812-7b981c50366b",
            "index": 23,
            "title": "Amjad Masad on vibe coding, AI agents, and the end of boilerplate",
            "pub_date": "2026-01-07T08:01:00.000Z",
            "duration": "4760",
            "duration_label": "1h 19m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "replit",
              "safety",
              "coding"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9568214626.mp3?updated=1767765363",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70183de4-e5e1-11f0-bd31-efb17fa3ae9b",
            "index": 24,
            "title": "BONUS: Conversations with Coleman: Big Tech, Politics, and Trust in Institutions",
            "pub_date": "2025-12-31T08:01:00.000Z",
            "duration": "4065",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8729564918.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d28e9b8-e09b-11f0-b3af-6b636adb3f3f",
            "index": 25,
            "title": "Stephen Colbert on connection, discovery, and human nature",
            "pub_date": "2025-12-24T08:10:00.000Z",
            "duration": "3530",
            "duration_label": "58m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2733920105.mp3?updated=1766563695",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 137,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "37339982-db10-11f0-b99e-0f4c27928146",
            "index": 26,
            "title": "The power of AI, from curing cancer to ballot boxes",
            "pub_date": "2025-12-17T08:01:00.000Z",
            "duration": "1919",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4936501709.mp3?updated=1765953262",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 51,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e53cbd1e-d571-11f0-89e7-832f2be6f6dc",
            "index": 27,
            "title": "The AI energy war is here",
            "pub_date": "2025-12-10T08:01:00.000Z",
            "duration": "1091",
            "duration_label": "18m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "data center"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5170074647.mp3?updated=1765826190",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 34,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a766a79c-cfff-11f0-88f3-632467375c41",
            "index": 28,
            "title": "R.I.P. Computer Keyboard (1964 – 2025)",
            "pub_date": "2025-12-03T08:01:00.000Z",
            "duration": "2697",
            "duration_label": "44m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6472643818.mp3?updated=1765487482",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e2b80e76-ca82-11f0-b861-133cc9761b94",
            "index": 29,
            "title": "AI’s Influence On The Church, Cybersecurity, and Disney",
            "pub_date": "2025-11-26T08:00:00.000Z",
            "duration": "970",
            "duration_label": "16m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "anthropic"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1382539642.mp3?updated=1765391335",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f7c5fd54-c4e8-11f0-8fca-7712c93b66d5",
            "index": 30,
            "title": "Our AI blindspot: incentives over intentions",
            "pub_date": "2025-11-19T08:00:00.000Z",
            "duration": "4067",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1067180186.mp3?updated=1763517850",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 159,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8e681034-bf4a-11f0-86c5-63ba18f7db78",
            "index": 31,
            "title": "How we regulate AI could decide the next century",
            "pub_date": "2025-11-12T08:00:00.000Z",
            "duration": "2114",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9459216512.mp3?updated=1763155504",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "99c76224-b9ee-11f0-9487-f3e0fe6e3d4a",
            "index": 32,
            "title": "Reid riffs on NVIDIA's chips, China’s AI ambitions, and the push to pause AI",
            "pub_date": "2025-11-05T09:00:00.000Z",
            "duration": "1823",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 14,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "chip",
              "chips",
              "safety"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6369483200.mp3?updated=1762310925",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "268e63ba-b459-11f0-914d-ffed567da8d8",
            "index": 33,
            "title": "Steve Kerr and Kris Brown on Leadership, Purpose, and Innovation in Sport and Society",
            "pub_date": "2025-10-29T08:00:00.000Z",
            "duration": "3739",
            "duration_label": "1h 2m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "training",
              "robotics"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7980622985.mp3?updated=1761748830",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "fc9ef882-aecf-11f0-9757-a7bd5b92117f",
            "index": 34,
            "title": "Aza Raskin on interspecies communication, empathy, and AI’s next frontier",
            "pub_date": "2025-10-22T08:00:00.000Z",
            "duration": "1638",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6088202501.mp3?updated=1761087983",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "76c821a6-a953-11f0-8846-f3252f84ab9e",
            "index": 35,
            "title": "Reid riffs on fostering trust with founders, in boardrooms, and in AI",
            "pub_date": "2025-10-15T08:00:00.000Z",
            "duration": "2244",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4142509999.mp3?updated=1760485026",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1eec4c46-a3ef-11f0-ae0e-f38d0ef403b3",
            "index": 36,
            "title": "David Fajgenbaum on drug repurposing, AI, and saving his own life",
            "pub_date": "2025-10-08T01:00:00.000Z",
            "duration": "4069",
            "duration_label": "1h 7m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6666900835.mp3?updated=1760043456",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 169,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "26fe20aa-9e61-11f0-9a78-5f9f5e59f1b5",
            "index": 37,
            "title": "Reid riffs on Trump’s $100K visa fee, 3-day work weeks, and AI trust issues",
            "pub_date": "2025-10-01T08:00:00.000Z",
            "duration": "2120",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7135107016.mp3?updated=1759436384",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1a84f708-98a4-11f0-8b31-2feaced0ccaf",
            "index": 38,
            "title": "Lisa Su on semiconductors, compute, and big bets",
            "pub_date": "2025-09-24T08:00:00.000Z",
            "duration": "2635",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "nvidia",
              "chip",
              "chips",
              "coding"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7566310389.mp3?updated=1758649792",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "81b521c6-934c-11f0-b667-eba5cf21abfc",
            "index": 39,
            "title": "Reid Riffs on AI translations, Apple Intelligence, and OpenAI’s Critterz",
            "pub_date": "2025-09-17T08:00:00.000Z",
            "duration": "1239",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT3186200271.mp3?updated=1758062325",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d7a5531e-8dc3-11f0-b449-63655e5a3c20",
            "index": 40,
            "title": "Stephen Colbert on connection, discovery and human nature",
            "pub_date": "2025-09-10T08:00:00.000Z",
            "duration": "3395",
            "duration_label": "56m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6049366401.mp3?updated=1757453777",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "37e84202-880d-11f0-a49e-07133fcfb1c0",
            "index": 41,
            "title": "Reid riffs on AI adoption, NVIDIA, and AI’s impact on entry-level jobs",
            "pub_date": "2025-09-03T08:00:00.000Z",
            "duration": "1391",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1329410665.mp3?updated=1756825603",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f4afbc76-82b3-11f0-97e7-17497cc1ca95",
            "index": 42,
            "title": "MacKenzie Price on AI-Powered K-12 Schools",
            "pub_date": "2025-08-27T08:00:00.000Z",
            "duration": "3334",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7586218619.mp3?updated=1756417258",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f891ef70-7d37-11f0-8e60-d3279a983cde",
            "index": 43,
            "title": "Reid riffs on GPT-5, Figma's IPO, and the end of AOL dial-up",
            "pub_date": "2025-08-20T08:00:00.000Z",
            "duration": "1108",
            "duration_label": "18m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "perplexity"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT3451771969.mp3?updated=1755634429",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "4e1611a4-7475-11f0-94df-2b5c9339787c",
            "index": 44,
            "title": "Audrey Tang and Divya Siddarth on Outfitting Democracy for the AI Era",
            "pub_date": "2025-08-13T08:00:00.000Z",
            "duration": "3136",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "alignment"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8362136399.mp3?updated=1754672138",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ea747e36-7232-11f0-96e7-2fe59a09e0c5",
            "index": 45,
            "title": "Reid riffs on the energy arms race and AI addressing climate change",
            "pub_date": "2025-08-06T08:00:00.000Z",
            "duration": "1004",
            "duration_label": "16m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2130073602.mp3?updated=1754422981",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "229616cc-6c8d-11f0-be46-83b3883cae14",
            "index": 46,
            "title": "Tony Marx on the Future of Libraries, AI, and Trust",
            "pub_date": "2025-07-30T08:00:00.000Z",
            "duration": "3105",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8816626661.mp3?updated=1753919111",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1fc9afc2-670a-11f0-945d-b305f8594ca0",
            "index": 47,
            "title": "Reid riffs on AI adoption, sensitive data, and digital twins",
            "pub_date": "2025-07-23T08:00:00.000Z",
            "duration": "1461",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT3994491949.mp3?updated=1753918598",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a6bab4d0-61ac-11f0-b973-039223fda155",
            "index": 48,
            "title": "Reid riffs on acquihires, agents, and new startup norms",
            "pub_date": "2025-07-16T08:00:00.000Z",
            "duration": "2416",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2913593576.mp3?updated=1752606872",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 71,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8f30ce54-5c51-11f0-b7e0-d30283a33ac0",
            "index": 49,
            "title": "Reid riffs on cryptocurrency, stablecoins and regulation",
            "pub_date": "2025-07-09T08:00:00.000Z",
            "duration": "1684",
            "duration_label": "28m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1563412523.mp3?updated=1753933932",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8e035160-56bf-11f0-9c64-0b7110f483f5",
            "index": 50,
            "title": "David Autor on AI’s impact on jobs, expertise, and labor markets",
            "pub_date": "2025-07-02T08:00:00.000Z",
            "duration": "3875",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "automation"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9544014852.mp3?updated=1753933997",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5857867e-5144-11f0-aedd-b715ae44f9b1",
            "index": 51,
            "title": "Reid riffs on massive AI acquisitions, robotics, and headcount trimming",
            "pub_date": "2025-06-25T07:00:00.000Z",
            "duration": "1545",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9266628840.mp3?updated=1753926366",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 16,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e6f70454-4bb8-11f0-bc15-93d0944263ff",
            "index": 52,
            "title": "Hannah Fry on AI, Algorithms, and Human Nature",
            "pub_date": "2025-06-18T08:00:00.000Z",
            "duration": "3139",
            "duration_label": "52m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2837002897.mp3?updated=1753944008",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "308b8a28-4631-11f0-a687-0f645f55f9a4",
            "index": 53,
            "title": "Reid riffs on if AI can become conscious",
            "pub_date": "2025-06-16T03:02:00.000Z",
            "duration": "1166",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9729453257.mp3?updated=1753921142",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 22,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "31f23c96-40a9-11f0-864d-c725a6c64069",
            "index": 54,
            "title": "Yuval Noah Harari on trust, the dangers of AI, power, and revolutions",
            "pub_date": "2025-06-04T08:00:00.000Z",
            "duration": "3104",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4364796452.mp3?updated=1753920987",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "bbfaf87c-3b3d-11f0-a5c5-534e36481567",
            "index": 55,
            "title": "Reid riffs on AI companions, human friends, and age gates",
            "pub_date": "2025-05-28T08:00:00.000Z",
            "duration": "1217",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT3650458415.mp3?updated=1753938228",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6ca41da4-35bf-11f0-ba5b-4b6147970e9a",
            "index": 56,
            "title": "Alexis Ohanian on the future of online and offline communities",
            "pub_date": "2025-05-21T08:00:00.000Z",
            "duration": "3248",
            "duration_label": "54m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1071744295.mp3?updated=1753929592",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c2e18d42-302d-11f0-8e8e-83bc94576bf8",
            "index": 57,
            "title": "Reid riffs on PBCs, jobs and automation, and AI access for kids",
            "pub_date": "2025-05-14T08:00:00.000Z",
            "duration": "1126",
            "duration_label": "18m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "automation"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1449834152.mp3?updated=1753938837",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "da2d6718-2ac0-11f0-b7e0-472c94292569",
            "index": 58,
            "title": "Jane Goodall on Hope, AI, and the Natural World",
            "pub_date": "2025-05-07T08:00:00.000Z",
            "duration": "3557",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8911622415.mp3?updated=1747325840",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "aece1e56-253d-11f0-8502-57720c1899aa",
            "index": 59,
            "title": "Reid riffs on antitrust, AI coworkers, and Chinese manufacturing",
            "pub_date": "2025-04-30T08:00:00.000Z",
            "duration": "1335",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2198620900.mp3?updated=1745961236",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1c524a0e-1fc8-11f0-8939-d3ac0aaa1060",
            "index": 60,
            "title": "Derek Thompson on AI, abundance, and human progress",
            "pub_date": "2025-04-23T08:00:00.000Z",
            "duration": "3227",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6474339044.mp3?updated=1745361944",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f151c9a6-1a45-11f0-acb1-3bf52e96f114",
            "index": 61,
            "title": "Reid riffs on Tobi’s memo, AI and play, and the tweet that cost trillions",
            "pub_date": "2025-04-16T08:00:00.000Z",
            "duration": "893",
            "duration_label": "14m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8294488191.mp3?updated=1744755614",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8e2b9cc6-14be-11f0-93de-b72886c12791",
            "index": 62,
            "title": "Demis Hassabis on AI, game theory, multimodality, and the nature of creativity",
            "pub_date": "2025-04-09T08:00:00.000Z",
            "duration": "3400",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "deepmind"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9447761313.mp3?updated=1744148558",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "18e1a24a-0f13-11f0-9360-a35e9cf5e3f5",
            "index": 63,
            "title": "Reid riffs on Signal, AI for cancer detection, and GPT-4o image generation",
            "pub_date": "2025-04-02T08:00:00.000Z",
            "duration": "887",
            "duration_label": "14m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "nvidia"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1502128226.mp3?updated=1743524167",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e8c8bb68-0943-11f0-8ea6-4fea3e9a583e",
            "index": 64,
            "title": "Andrew Bosworth on AI, wearables, and mixed reality",
            "pub_date": "2025-03-26T12:41:00.000Z",
            "duration": "2969",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "safety"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6898381076.mp3?updated=1742969239",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "abb6da7c-05db-11f0-90af-c3f4604de388",
            "index": 65,
            "title": "Re-release of Trevor Noah | Celebrating two years of Possible!",
            "pub_date": "2025-03-21T08:00:00.000Z",
            "duration": "4606",
            "duration_label": "1h 16m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9087503552.mp3?updated=1742511192",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "46c35b6a-0467-11f0-a7c9-a75ddfa20c7f",
            "index": 66,
            "title": "Reid riffs on AI as “American Intelligence” and a prediction from Anthropic’s CEO",
            "pub_date": "2025-03-19T08:00:00.000Z",
            "duration": "1038",
            "duration_label": "17m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "anthropic"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1463252440.mp3?updated=1742350690",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "191a0b66-fecf-11ef-a801-4b140d89046a",
            "index": 67,
            "title": "Dana Griffin on AI, belonging, and intergenerational connection",
            "pub_date": "2025-03-12T08:00:00.000Z",
            "duration": "3355",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4851960928.mp3?updated=1744655749",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8ab35bb8-f968-11ef-a3e0-e71f7f8afeb6",
            "index": 68,
            "title": "Reid riffs on AI wearables, quantum, and Deep Research",
            "pub_date": "2025-03-05T09:00:00.000Z",
            "duration": "1604",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "coding"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8083699876.mp3?updated=1741148705",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "002ef67a-f3c1-11ef-95da-1bfab2509e82",
            "index": 69,
            "title": "Latanya Sweeney on AI, trust, and privacy",
            "pub_date": "2025-02-26T09:00:00.000Z",
            "duration": "3348",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5898198185.mp3?updated=1740520719",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c90be300-ee21-11ef-a924-9736699592d8",
            "index": 70,
            "title": "Reid riffs on the AI race with China and if the US should regulate AI",
            "pub_date": "2025-02-19T09:00:00.000Z",
            "duration": "809",
            "duration_label": "13m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9394800123.mp3?updated=1739925640",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a1a54008-ea17-11ef-948c-7f722b8d1983",
            "index": 71,
            "title": "BONUS: Pioneers of AI: Love in the Age of AI",
            "pub_date": "2025-02-14T09:00:00.000Z",
            "duration": "2996",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7208324121.mp3?updated=1739459828",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8716c90a-e8b9-11ef-bb4a-374848694f07",
            "index": 72,
            "title": "Anja Manuel on AI, China, and national security",
            "pub_date": "2025-02-12T09:00:00.000Z",
            "duration": "3651",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "safety"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7120742150.mp3?updated=1750105097",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c7b48e3e-e319-11ef-adee-7f122c2608c8",
            "index": 73,
            "title": "Reid and AIs riff on what could go right with AI",
            "pub_date": "2025-02-05T09:00:00.000Z",
            "duration": "1788",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9102307359.mp3?updated=1738689732",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "afeed990-dd9b-11ef-b6a3-a7720d22c93e",
            "index": 74,
            "title": "Greg Beato on superagency, AI, and the cognitive industrial revolution",
            "pub_date": "2025-01-29T09:00:00.000Z",
            "duration": "3413",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "safety"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6571453308.mp3?updated=1738085983",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0f51886a-d81a-11ef-bdea-e7fd53c51061",
            "index": 75,
            "title": "Bret Taylor on conversational AI, voice, and agents",
            "pub_date": "2025-01-22T09:00:00.000Z",
            "duration": "3974",
            "duration_label": "1h 6m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6233846561.mp3?updated=1737482385",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "3dd4903a-d29b-11ef-981c-778666ea992a",
            "index": 76,
            "title": "Fei-Fei Li on spatial intelligence and human-centered AI",
            "pub_date": "2025-01-15T09:00:00.000Z",
            "duration": "2593",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "agentic",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2533135314.mp3?updated=1737138662",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "983b91c0-befc-11ef-8757-0f7ff39b74f3",
            "index": 77,
            "title": "PRESENTING: Pioneers of AI with Dr. Rana El Kaliouby and Musician Taryn Southern",
            "pub_date": "2024-12-25T09:00:00.000Z",
            "duration": "2249",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8330345579.mp3?updated=1734718057",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "428c0986-b9ba-11ef-a1ba-6f2409d9a74c",
            "index": 78,
            "title": "Artful Intelligence | Ep 3: Paul Trillo on Music Video x AI",
            "pub_date": "2024-12-18T09:00:00.000Z",
            "duration": "3417",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7731726417.mp3?updated=1734141440",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0658d728-b749-11ef-8d1e-dbcae4ac6ad3",
            "index": 79,
            "title": "Artful Intelligence | Ep 2: Elise Swopes on Photography x AI",
            "pub_date": "2024-12-11T09:00:00.000Z",
            "duration": "2968",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1293119129.mp3?updated=1733872740",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2a47eac2-b18e-11ef-8bca-6f8b7c454fd4",
            "index": 80,
            "title": "Introducing: Artful Intelligence | Ep 1: Malick Lombion on Hyperlapse x AI",
            "pub_date": "2024-12-04T09:00:00.000Z",
            "duration": "3090",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7271015310.mp3?updated=1733261727",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3a7233d0-ac16-11ef-b969-9b870f11c629",
            "index": 81,
            "title": "Spencer Hyman on flavor and chocolate",
            "pub_date": "2024-11-27T09:00:00.000Z",
            "duration": "2664",
            "duration_label": "44m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1562814264.mp3?updated=1733767057",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c4f4f0b0-a68a-11ef-ada8-b7d84947c81d",
            "index": 82,
            "title": "Reid riffs on AI and public service technology",
            "pub_date": "2024-11-20T09:00:00.000Z",
            "duration": "766",
            "duration_label": "12m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4202661048.mp3?updated=1734040606",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "8f2c567e-a132-11ef-8526-bb6d8babb628",
            "index": 83,
            "title": "Devshi Mehrotra on AI, justice, and public defense",
            "pub_date": "2024-11-13T09:00:00.000Z",
            "duration": "2921",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1813505992.mp3?updated=1733844279",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "50bc231e-9b84-11ef-b24f-b3a665c4a616",
            "index": 84,
            "title": "Reid riffs on Bill Gates and promising technology developments",
            "pub_date": "2024-11-06T09:00:00.000Z",
            "duration": "557",
            "duration_label": "9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2074840312.mp3?updated=1734040619",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9e5f8d02-9b04-11ef-bc3b-4fe0d13590c4",
            "index": 85,
            "title": "Feed Drop: Reid Hoffman: Entrepreneurship, AI, and the Battle for Democracy",
            "pub_date": "2024-11-05T09:00:00.000Z",
            "duration": "2050",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6917687629.mp3?updated=1730811167",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9fd6e2d4-989d-11ef-84d2-5bbdcc013f36",
            "index": 86,
            "title": "Feed Drop: Masters of Scale: President Bill Clinton in conversation with Reid Hoffman",
            "pub_date": "2024-11-04T09:00:00.000Z",
            "duration": "2176",
            "duration_label": "36m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://mastersofscale.com/follow",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2566054119.mp3?updated=1730500071",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c6c6cb8-96c2-11ef-b4ec-537bf85131ee",
            "index": 87,
            "title": "Bill Gates on possibility, AI, and humanity",
            "pub_date": "2024-10-30T13:30:00.000Z",
            "duration": "4224",
            "duration_label": "1h 10m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5909969567.mp3?updated=1733844456",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ccd3da62-9091-11ef-ba49-abc79ba7a509",
            "index": 88,
            "title": "Reid riffs on iterative development and cultural differences",
            "pub_date": "2024-10-23T08:00:00.000Z",
            "duration": "821",
            "duration_label": "13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7871961131.mp3?updated=1734040675",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f0e9c4da-8b0e-11ef-a4a1-af105a06d94b",
            "index": 89,
            "title": "James Manyika on global AI and inclusion",
            "pub_date": "2024-10-16T08:00:00.000Z",
            "duration": "2779",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6691258709.mp3?updated=1733844411",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c79c9932-8581-11ef-9450-0f5a6bd58a60",
            "index": 90,
            "title": "Reid riffs on the next generation of LLMs",
            "pub_date": "2024-10-09T08:00:00.000Z",
            "duration": "745",
            "duration_label": "12m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9269964751.mp3?updated=1734040739",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "7c8ace3a-801f-11ef-a838-5777bd9a04eb",
            "index": 91,
            "title": "Sean White on Inflection and AI frontiers",
            "pub_date": "2024-10-02T08:00:00.000Z",
            "duration": "2455",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6960037988.mp3?updated=1733844443",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ed9a4f06-7ab1-11ef-9b36-e7970f074ed3",
            "index": 92,
            "title": "Reid riffs on Silicon Valley, politics, and the election",
            "pub_date": "2024-09-25T08:00:00.000Z",
            "duration": "1007",
            "duration_label": "16m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7873893095.mp3?updated=1734040779",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ee8ba176-752f-11ef-9eca-d30a0d7ad178",
            "index": 93,
            "title": "Sarah Longwell on politics, AI, and elections",
            "pub_date": "2024-09-18T08:00:00.000Z",
            "duration": "4269",
            "duration_label": "1h 11m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5140808613.mp3?updated=1733844574",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "34435db6-6faf-11ef-9219-ff16a6a42165",
            "index": 94,
            "title": "Reid riffs on his personal history with AI",
            "pub_date": "2024-09-11T08:00:00.000Z",
            "duration": "679",
            "duration_label": "11m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5115661868.mp3?updated=1734040808",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a6c1fd56-6a2e-11ef-8776-4f9408f32841",
            "index": 95,
            "title": "Daphne Koller on drug discovery and AI",
            "pub_date": "2024-09-04T08:00:00.000Z",
            "duration": "3587",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2176180952.mp3?updated=1733844664",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ac6c72a6-64af-11ef-b208-d32d13937e2e",
            "index": 96,
            "title": "Reid riffs on the future of human connectivity",
            "pub_date": "2024-08-28T08:00:00.000Z",
            "duration": "580",
            "duration_label": "9m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7107986862.mp3?updated=1734040844",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5725c250-5f3e-11ef-a6fd-efcd0fdfb39b",
            "index": 97,
            "title": "Nick Thompson on our AI future",
            "pub_date": "2024-08-21T08:00:00.000Z",
            "duration": "3181",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9293111801.mp3?updated=1733844677",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "4dae9b9e-59bb-11ef-b380-a3de130ec199",
            "index": 98,
            "title": "Reid riffs on AI regulation",
            "pub_date": "2024-08-14T08:00:00.000Z",
            "duration": "843",
            "duration_label": "14m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6295034761.mp3?updated=1734040921",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "7e7bad02-5425-11ef-ab64-679e84eb47a4",
            "index": 99,
            "title": "Gina Raimondo on AI, government, and commerce",
            "pub_date": "2024-08-07T08:00:00.000Z",
            "duration": "1987",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai",
              "chips",
              "safety"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5622841696.mp3?updated=1733844681",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d5e3e77a-4ea4-11ef-87b4-9f2076da2a12",
            "index": 100,
            "title": "Reid riffs on AI agents and investments",
            "pub_date": "2024-07-31T08:00:00.000Z",
            "duration": "895",
            "duration_label": "14m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7017447252.mp3?updated=1734040984",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d85502e6-4940-11ef-aa86-a7e200c4e6a0",
            "index": 101,
            "title": "Ashton Kutcher on AI and investing",
            "pub_date": "2024-07-24T08:00:00.000Z",
            "duration": "2487",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6951375198.mp3?updated=1733844790",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e92ff960-43ad-11ef-84ae-af472189d9d7",
            "index": 102,
            "title": "Reid riffs on building better cities",
            "pub_date": "2024-07-17T08:00:00.000Z",
            "duration": "686",
            "duration_label": "11m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5708215571.mp3?updated=1734043038",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1c820b4e-3e01-11ef-9dca-df2705ac9c33",
            "index": 103,
            "title": "Devon Zuegel on the future of cities and community",
            "pub_date": "2024-07-10T08:00:00.000Z",
            "duration": "3117",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2939263212.mp3?updated=1733844895",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "23246df4-389b-11ef-b709-cbaf3a3cfd94",
            "index": 104,
            "title": "Reid riffs on California Forever and housing",
            "pub_date": "2024-07-03T08:00:00.000Z",
            "duration": "833",
            "duration_label": "13m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7219116795.mp3?updated=1734043061",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "23620ae0-3325-11ef-aea7-336272323b0b",
            "index": 105,
            "title": "Jan Sramek on California Forever and the future of cities",
            "pub_date": "2024-06-26T08:00:00.000Z",
            "duration": "3090",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1406053305.mp3?updated=1733844934",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "448dec4e-2da7-11ef-8616-cbd685d00470",
            "index": 106,
            "title": "Reid riffs on going from idea to launch",
            "pub_date": "2024-06-19T08:00:00.000Z",
            "duration": "721",
            "duration_label": "12m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7229694394.mp3?updated=1734043092",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "0604ad0e-2826-11ef-83d0-57d544116242",
            "index": 107,
            "title": "Massimo Bottura on the future of food and creativity",
            "pub_date": "2024-06-12T08:00:00.000Z",
            "duration": "2796",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7160949949.mp3?updated=1733844966",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1a585898-227f-11ef-9afc-7f9eecf55f3e",
            "index": 108,
            "title": "Reid riffs on coding and K-12 education",
            "pub_date": "2024-06-05T08:00:00.000Z",
            "duration": "703",
            "duration_label": "11m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4664336009.mp3?updated=1734043118",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ff3a8e10-1d0a-11ef-abaa-7f90fd3efb09",
            "index": 109,
            "title": "Pat Yongpradit on AI literacy and computer science education",
            "pub_date": "2024-05-29T08:00:00.000Z",
            "duration": "2955",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "openai",
              "coding",
              "copilot"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8685080107.mp3?updated=1733845025",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f2b507a0-186f-11ef-be35-27e073ef689e",
            "index": 110,
            "title": "BONUS: Reid Hoffman’s speech: Humanity’s Hegelian Golden Braid",
            "pub_date": "2024-05-24T11:00:00.000Z",
            "duration": "1892",
            "duration_label": "31m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4692348794.mp3?updated=1733844972",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "681e8478-177e-11ef-a132-afbdff8eb923",
            "index": 111,
            "title": "Reid riffs on tech journalism and the TikTok ban",
            "pub_date": "2024-05-22T08:00:00.000Z",
            "duration": "886",
            "duration_label": "14m",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7777939594.mp3?updated=1734043168",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ac2fc84e-17d7-11ef-908b-afee475673a6",
            "index": 112,
            "title": "Feed Drop: On with Kara Swisher: Reid Hoffman talks Trump, Thiel & AI",
            "pub_date": "2024-05-22T07:55:00.000Z",
            "duration": "2603",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4149208110.mp3?updated=1716340355",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e7880b8-1219-11ef-85a3-8b804f13cc26",
            "index": 113,
            "title": "Kara Swisher on AI, media, and accountability",
            "pub_date": "2024-05-15T08:00:00.000Z",
            "duration": "3500",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "training"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1559141647.mp3?updated=1733845111",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "872e79d8-0cc8-11ef-89e4-c3f4595897eb",
            "index": 114,
            "title": "Reid riffs on AI milestones and AI efforts abroad",
            "pub_date": "2024-05-08T08:00:00.000Z",
            "duration": "1058",
            "duration_label": "17m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5378328234.mp3?updated=1734043239",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b290d1dc-0711-11ef-b2ae-5fa943d1ffa6",
            "index": 115,
            "title": "Kevin Scott on AI and humanism",
            "pub_date": "2024-05-01T08:00:00.000Z",
            "duration": "3803",
            "duration_label": "1h 3m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "openai",
              "copilot"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT3211635758.mp3?updated=1733846552",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1e2ce590-01b6-11ef-827d-8b8ddeba4a16",
            "index": 116,
            "title": "[BONUS + VIDEO] Reid interviews Reid AI, his AI avatar",
            "pub_date": "2024-04-24T08:00:00.000Z",
            "duration": "153",
            "duration_label": "2m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4909166406.mp3?updated=1713981335",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "36cfd246-010d-11ef-b6d2-5f6d1c1951da",
            "index": 117,
            "title": "Introducing: a new Possible",
            "pub_date": "2024-04-23T08:00:00.000Z",
            "duration": "199",
            "duration_label": "3m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT6388212069.mp3?updated=1715376127",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "82eeb7e6-bf7c-11ee-baa5-8316ed79afa0",
            "index": 118,
            "title": "Reflections on AI and season two",
            "pub_date": "2024-01-31T09:00:00.000Z",
            "duration": "3496",
            "duration_label": "58m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9618157129.mp3?updated=1715618882",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "5ee51ee6-ba11-11ee-9a6b-133f81014f7a",
            "index": 119,
            "title": "Katherine Maher on the future of trusted information",
            "pub_date": "2024-01-24T09:00:00.000Z",
            "duration": "3227",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt",
              "openai",
              "training"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7886610799.mp3?updated=1715618908",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e2baafb8-b4aa-11ee-a1b2-ff64da163a0e",
            "index": 120,
            "title": "Kerry Washington on connection, identity and AI",
            "pub_date": "2024-01-17T09:00:00.000Z",
            "duration": "3552",
            "duration_label": "59m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1040973907.mp3?updated=1715618924",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "789fe61a-af33-11ee-8cb7-875fe07795ae",
            "index": 121,
            "title": "Sal Khan on the future of K-12 education",
            "pub_date": "2024-01-10T09:00:00.000Z",
            "duration": "3338",
            "duration_label": "55m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9996900889.mp3?updated=1715618938",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e4ced57c-a9ba-11ee-9c6b-cbf412acad16",
            "index": 122,
            "title": "Van Jones on AI, disruption and inclusion",
            "pub_date": "2024-01-03T09:00:00.000Z",
            "duration": "3367",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/podcast/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5468855035.mp3?updated=1715618953",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48d6b240-9e91-11ee-8c62-d796ad6caccc",
            "index": 123,
            "title": "Phaedra Ellis-Lamkins on the future of social welfare",
            "pub_date": "2023-12-20T09:00:00.000Z",
            "duration": "2805",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8761167827.mp3?updated=1715618970",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "62579356-9928-11ee-acc2-e7ec3b6cc2db",
            "index": 124,
            "title": "Sarah Sze on the future of AI and art",
            "pub_date": "2023-12-13T09:00:00.000Z",
            "duration": "3406",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1633301440.mp3?updated=1715618984",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c552935a-9380-11ee-b448-bfcccd644c7d",
            "index": 125,
            "title": "Kim Stanley Robinson on narrative and civilization",
            "pub_date": "2023-12-06T09:00:00.000Z",
            "duration": "2953",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2135215179.mp3?updated=1715619004",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d2b9acd6-8e12-11ee-a90f-3b334dbe41a4",
            "index": 126,
            "title": "Peter Lee on the future of health and medicine",
            "pub_date": "2023-11-29T09:00:00.000Z",
            "duration": "2918",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "openai",
              "training",
              "copilot"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4314302242.mp3?updated=1715619021",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6e167c26-8563-11ee-ac0c-ff5f4883cbc1",
            "index": 127,
            "title": "Feed Drop: Masters of Scale | Reid Hoffman confronts the AI critics",
            "pub_date": "2023-11-22T09:00:00.000Z",
            "duration": "1552",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://listen.mastersofscale.com/Possible",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5399841564.mp3?updated=1715619049",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "22680562-8322-11ee-ae3c-efc1b1d59b29",
            "index": 128,
            "title": "Siddhartha Mukherjee on the future of disease and diagnostics",
            "pub_date": "2023-11-15T09:00:00.000Z",
            "duration": "3697",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2081518679.mp3?updated=1715619073",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "83572e68-7d99-11ee-8f5a-bb46bcc659c2",
            "index": 129,
            "title": "Condoleezza Rice on the future of war and geopolitics",
            "pub_date": "2023-11-08T09:00:00.000Z",
            "duration": "2906",
            "duration_label": "48m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "openai",
              "safety"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9856784880.mp3?updated=1715619093",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "7bdcb79e-783e-11ee-b6fb-0bc8e2bb8fc1",
            "index": 130,
            "title": "Anne-Marie Slaughter on the future of the care economy",
            "pub_date": "2023-11-01T08:00:00.000Z",
            "duration": "3410",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2556868702.mp3?updated=1715619114",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ad111176-72bb-11ee-9f2f-0f3f7808a886",
            "index": 131,
            "title": "Marques Brownlee on the future of creators",
            "pub_date": "2023-10-25T08:00:00.000Z",
            "duration": "2952",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8840374048.mp3?updated=1715619131",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 84,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "ac4ffa3a-6f88-11ee-88f8-dfd8c3956c10",
            "index": 132,
            "title": "Introducing: Possible season two",
            "pub_date": "2023-10-23T08:00:00.000Z",
            "duration": "190",
            "duration_label": "3m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT1992374491.mp3?updated=1715619844",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "a842f3ce-5300-11ee-9142-8f3434d9c2d1",
            "index": 133,
            "title": "BONUS: Reid Hoffman’s commencement speech at Bologna Business School",
            "pub_date": "2023-09-15T09:00:00.000Z",
            "duration": "1407",
            "duration_label": "23m",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8885463478.mp3?updated=1715619151",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "f03222f8-19d6-11ee-a566-872cb75ea911",
            "index": 134,
            "title": "Prompt and process with Ethan Mollick [AI miniseries]",
            "pub_date": "2023-07-05T08:30:00.000Z",
            "duration": "3412",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9199487990.mp3?updated=1715619225",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "19d7c5c8-153f-11ee-be23-dff13423ceae",
            "index": 135,
            "title": "Socially assistive robots with Maja Matarić [AI miniseries]",
            "pub_date": "2023-06-28T08:30:00.000Z",
            "duration": "2974",
            "duration_label": "49m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "robotics"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2998648774.mp3?updated=1715619245",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d3e934d0-0fcf-11ee-bab2-1b7050a07183",
            "index": 136,
            "title": "Personal intelligence with Mustafa Suleyman [AI miniseries]",
            "pub_date": "2023-06-21T08:30:00.000Z",
            "duration": "3233",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "deepmind"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5569857487.mp3?updated=1715619268",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "920328f4-f9b4-11ed-9daa-a3cd90eb0b27",
            "index": 137,
            "title": "Reflections on AI and season one",
            "pub_date": "2023-05-24T08:00:00.000Z",
            "duration": "1964",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm/podcast/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9856502773.mp3?updated=1715619457",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c0f3eaa-f421-11ed-a36a-3b9167ac45c7",
            "index": 138,
            "title": "Ariel Ekblaw on the future of space exploration",
            "pub_date": "2023-05-17T08:00:00.000Z",
            "duration": "3258",
            "duration_label": "54m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT9866018738.mp3?updated=1715619473",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 84,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9b9386fc-e924-11ed-a8ab-db3ba48986e8",
            "index": 139,
            "title": "Sam Altman and Greg Brockman on AI and the future",
            "pub_date": "2023-05-03T08:30:00.000Z",
            "duration": "3699",
            "duration_label": "1h 1m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT5550750458.mp3?updated=1715619515",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6113ffb4-e3d1-11ed-8235-833c22f83480",
            "index": 140,
            "title": "Jaime Teevan on the future of work",
            "pub_date": "2023-04-26T08:30:00.000Z",
            "duration": "3417",
            "duration_label": "56m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "openai",
              "copilot"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT7875221513.mp3?updated=1715619551",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "e0d7e252-de35-11ed-b858-bbbd1adcccfb",
            "index": 141,
            "title": "Bryan Stevenson on the future of criminal justice",
            "pub_date": "2023-04-19T08:00:00.000Z",
            "duration": "3630",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4417352735.mp3?updated=1715619586",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "710f1e6c-d8af-11ed-8716-9f926086c898",
            "index": 142,
            "title": "Janette Sadik-Khan on the future of cities",
            "pub_date": "2023-04-12T08:30:00.000Z",
            "duration": "3077",
            "duration_label": "51m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8001223210.mp3?updated=1715619605",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "d5c0568c-d2fb-11ed-a825-a3e9a077ba80",
            "index": 143,
            "title": "Ben Nelson on the future of higher education",
            "pub_date": "2023-04-05T08:30:00.000Z",
            "duration": "3212",
            "duration_label": "53m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2041578899.mp3?updated=1715619617",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "354cd90c-cd95-11ed-b0f0-4b0a99895820",
            "index": 144,
            "title": "Saul Griffith on a clean energy future",
            "pub_date": "2023-03-29T08:30:00.000Z",
            "duration": "3621",
            "duration_label": "1h 0m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2359691938.mp3?updated=1715619632",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "9e2538b4-c82e-11ed-b075-9bb24ee5567f",
            "index": 145,
            "title": "Dr. Kim Budil on the future of fusion",
            "pub_date": "2023-03-22T08:30:00.000Z",
            "duration": "3053",
            "duration_label": "50m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT2344295566.mp3?updated=1715619651",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "c7d6d70c-c2c6-11ed-84e1-bb191de4492b",
            "index": 146,
            "title": "Trevor Noah on the future of entertainment and AI",
            "pub_date": "2023-03-15T08:30:00.000Z",
            "duration": "3862",
            "duration_label": "1h 4m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai"
            ],
            "page_url": "https://www.possible.fm/",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT4595555067.mp3?updated=1715619670",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 82,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "b9e60bda-c28b-11ed-b49b-37acc178c514",
            "index": 147,
            "title": "Introducing: Possible",
            "pub_date": "2023-03-14T17:13:00.000Z",
            "duration": "99",
            "duration_label": "1m",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "openai"
            ],
            "page_url": "https://www.possible.fm",
            "audio_url": "https://pdrl.fm/8d0b55/pscrb.fm/rss/p/traffic.megaphone.fm/CONCENT8622189377.mp3?updated=1678825225",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 84,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          }
        ]
      },
      {
        "id": "me-myself-ai",
        "title": "Me, Myself, and AI",
        "feed_title": "Me, Myself, and AI",
        "priority": "P2",
        "selection_mode": "all_ai",
        "focus": [
          "enterprise adoption",
          "management",
          "organizational change"
        ],
        "feed_url": "https://feeds.megaphone.fm/TPG7603691495",
        "source_url": "https://feeds.megaphone.fm/TPG7603691495",
        "detail_path": "/podcasts/me-myself-ai/",
        "episode_count": 118,
        "selected_episode_count": 118,
        "latest_episode_title": "AI for Interoperability in Health Care: Philips’s Carla Goulart Peron",
        "latest_pub_date": "2026-06-01T04:00:00.000Z",
        "latest_page_url": "https://sloanreview.mit.edu/audio/ai-for-interoperability-in-health-care-philipss-carla-goulart-peron",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "499218be-4f0b-11f1-b37f-0b0591ec3021",
            "index": 1,
            "title": "AI for Interoperability in Health Care: Philips’s Carla Goulart Peron",
            "pub_date": "2026-06-01T04:00:00.000Z",
            "duration": "2035",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training",
              "safety",
              "robotics"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ai-for-interoperability-in-health-care-philipss-carla-goulart-peron",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4227354569.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4946921c-38c3-11f1-9a74-87d080231d66",
            "index": 2,
            "title": "A Need for Nuance: The Economist’s Andrew Palmer",
            "pub_date": "2026-05-19T04:00:00.000Z",
            "duration": "2440",
            "duration_label": "40m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/a-need-for-nuance-the-economists-andrew-palmer",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9868516943.mp3?updated=1776255913",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ec662e0c-2a23-11f1-a30d-c7e5cfc3e62d",
            "index": 3,
            "title": "Behind the AI in the Newsroom: The Washington Post’s Vineet Khosla",
            "pub_date": "2026-05-05T04:00:00.000Z",
            "duration": "2336",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/behind-the-ai-in-the-newsroom-the-washington-posts-vineet-khosla",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5497272734.mp3?updated=1777996866",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db1dfff2-341f-11f1-84af-639b75d0d399",
            "index": 4,
            "title": "Industrial AI for the Physical World: Siemens’s Peter Koerte",
            "pub_date": "2026-04-21T04:00:00.000Z",
            "duration": "1881",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/industrial-ai-for-the-physical-world-siemenss-peter-koerte",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6901452795.mp3?updated=1776868056",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a2d02c3e-1f15-11f1-b9f0-27e97a1d9a1b",
            "index": 5,
            "title": "Disintegrating the Org Chart: ServiceNow’s Jacqui Canney",
            "pub_date": "2026-04-07T04:00:00.000Z",
            "duration": "2074",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "agents",
              "training"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/disintegrating-the-org-chart-servicenows-jacqui-canney",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO8869951031.mp3?updated=1773432112",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f287460-137b-11f1-98c9-97c3a224eb1a",
            "index": 6,
            "title": "Shifting AI From Fear to Optimism: U.S. Department of Labor’s Taylor Stockton",
            "pub_date": "2026-03-24T04:00:00.000Z",
            "duration": "1820",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/shifting-ai-from-fear-to-optimism-u-s-department-of-labors-taylor-stockton",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO8817201608.mp3?updated=1772156150",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "92152620-0da8-11f1-96ba-3bd89207e3c8",
            "index": 7,
            "title": "An Industry Benchmark for Data Fairness: Sony’s Alice Xiang",
            "pub_date": "2026-03-10T04:00:00.000Z",
            "duration": "2046",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/an-industry-benchmark-for-data-fairness-sonys-alice-xiang",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1586791229.mp3?updated=1771516454",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "039276a2-004f-11f1-8e87-0fcf2984f494",
            "index": 8,
            "title": "AI Is Not Improving Productivity: Nobel Laureate Daron Acemoglu",
            "pub_date": "2026-02-24T05:00:00.000Z",
            "duration": "1979",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ai-is-not-improving-productivity-nobel-laureate-daron-acemoglu",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO3483293532.mp3?updated=1770048298",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f07bc71c-dd12-11f0-8fa6-6f5927b6997a",
            "index": 9,
            "title": "Connecting Language and (Artificial) Intelligence: Princeton’s Tom Griffiths",
            "pub_date": "2026-01-20T05:00:00.000Z",
            "duration": "2606",
            "duration_label": "43m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/connecting-language-and-artificial-intelligence-princetons-tom-griffiths",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6395383616.mp3?updated=1767920940",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b65de8a4-c975-11f0-960c-0f3d022d9580",
            "index": 10,
            "title": "Hungry for Learning: Wendy’s Will Croushorn",
            "pub_date": "2025-12-16T05:00:00.000Z",
            "duration": "1894",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "agent",
              "multimodal",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/hungry-for-learning-wendys-will-croushorn",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6776201568.mp3?updated=1765928876",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b67a268a-c976-11f0-9248-4f5b40dd9ed7",
            "index": 11,
            "title": "Science, Innovation, and Economic Growth: OpenAI’s Ronnie Chatterji",
            "pub_date": "2025-12-08T05:00:00.000Z",
            "duration": "1824",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "openai",
              "chips"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/science-innovation-and-economic-growth-openais-ronnie-chatterji",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO3964152121.mp3?updated=1764017804",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c404352-c3f9-11f0-ae84-0bb9b9c7d36c",
            "index": 12,
            "title": "Creating More, Not Less, With AI: GeekWire’s Todd Bishop",
            "pub_date": "2025-11-25T05:01:00.000Z",
            "duration": "1660",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/creating-more-not-less-with-ai-geekwires-todd-bishop",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4599877351.mp3?updated=1763414153",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e292ad84-a9e9-11f0-bdc9-0719802d3a36",
            "index": 13,
            "title": "From Rabbit Holes to Recommendations: Reddit’s Vishal Gupta",
            "pub_date": "2025-11-11T05:00:00.000Z",
            "duration": "1509",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "large language model",
              "deepmind",
              "training",
              "multimodal"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/from-rabbit-holes-to-recommendations-reddits-vishal-gupta",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO2062051372.mp3?updated=1760625469",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f12a63a0-9f0d-11f0-8322-339a9bff8429",
            "index": 14,
            "title": "Personalization and Innovation in a Regulated Industry: Experian’s Kathleen Peters",
            "pub_date": "2025-10-28T04:00:00.000Z",
            "duration": "1900",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/personalization-and-innovation-in-a-regulated-industry-experians-kathleen-peters",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO3578749822.mp3?updated=1759425812",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f125b696-9640-11f0-a5cb-a328a6616047",
            "index": 15,
            "title": "Never Fight a Megatrend: Cisco’s Jeetu Patel",
            "pub_date": "2025-10-14T04:00:00.000Z",
            "duration": "1977",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/never-fight-a-megatrend-ciscos-jeetu-patel",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO2253245277.mp3?updated=1758387587",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ce0acc2-7a13-11f0-a88e-971445e44701",
            "index": 16,
            "title": "Protection, Provenance, and Prompts: YouTube’s Angela Nakalembe",
            "pub_date": "2025-09-30T04:00:00.000Z",
            "duration": "1666",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "safety"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/protection-provenance-and-prompts-youtubes-angela-nakalembe",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9621140802.mp3?updated=1755289621",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ee6be904-786b-11f0-bfac-7365e3e451b2",
            "index": 17,
            "title": "Challenging the Average With Open-Source AI: Hugging Face’s Thomas Wolf",
            "pub_date": "2025-09-16T04:00:00.000Z",
            "duration": "2064",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "coding"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/challenging-the-average-with-open-source-ai-hugging-faces-thomas-wolf",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4681923289.mp3?updated=1755107534",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b349b8c2-5829-11f0-bc3e-efb477ff9451",
            "index": 18,
            "title": "Feed Drop: MIT CSAIL Alliances Podcast",
            "pub_date": "2025-07-15T04:00:00.000Z",
            "duration": "2798",
            "duration_label": "46m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chip"
            ],
            "page_url": "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4388401315.mp3?updated=1751845393",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ea3c84d8-2b72-11f0-aa47-237650847351",
            "index": 19,
            "title": "Training AI to Detect Disease: Stand Up To Cancer’s Julian Adams",
            "pub_date": "2025-06-11T04:00:00.000Z",
            "duration": "1840",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/training-ai-to-detect-disease-stand-up-to-cancers-julian-adams",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO7849587987.mp3?updated=1747410665",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7350ab40-30dd-11f0-9d44-b3ad9818a738",
            "index": 20,
            "title": "Delivering More Connected Care Through AI: CVS Health's Josh Weiner",
            "pub_date": "2025-05-27T04:01:00.000Z",
            "duration": "1642",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/delivering-more-connected-care-through-ai-cvs-healths-josh-weiner",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6329207939.mp3?updated=1747770186",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "21a16200-1a15-11f0-9a24-930ea5167863",
            "index": 21,
            "title": "Building Better Answers With AI Agents: SAP’s Walter Sun",
            "pub_date": "2025-05-13T07:00:00.000Z",
            "duration": "2033",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "automation",
              "copilot"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/building-better-answers-with-ai-agents-saps-walter-sun",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5887432010.mp3?updated=1747239860",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b06c98e-0a91-11f0-9a9c-931ff045392a",
            "index": 22,
            "title": "Upcycling and Upskilling With AI: Goodwill's Steve Preston",
            "pub_date": "2025-04-29T04:00:00.000Z",
            "duration": "1537",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/upcycling-and-upskilling-with-ai-goodwills-steve-preston",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4018371316.mp3?updated=1744210821",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c2f2dda2-e4d5-11ef-a951-b77393b26757",
            "index": 23,
            "title": "Overcoming AI Hallucinations: Truist’s Chandra Kapireddy",
            "pub_date": "2025-04-15T07:00:00.000Z",
            "duration": "2019",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/overcoming-ai-hallucinations-truists-chandra-kapireddy",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9701630217.mp3?updated=1743618544",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a9719b02-d2a6-11ef-9a83-8b063420be15",
            "index": 24,
            "title": "Speed, Ease, and Expertise With AI: Lenovo’s Linda Yao",
            "pub_date": "2025-04-01T07:00:00.000Z",
            "duration": "1919",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/speed-ease-and-expertise-with-ai-lenovos-linda-yao",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO8171796924.mp3?updated=1743618473",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4ffa9598-e943-11ef-bf44-636147cff460",
            "index": 25,
            "title": "Reskilling the Workforce With AI: Harvard Business School’s Raffaella Sadun",
            "pub_date": "2025-03-18T07:00:00.000Z",
            "duration": "1802",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/reskilling-the-workforce-with-ai",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9137332466.mp3?updated=1743618454",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aca5079c-cd46-11ef-b562-9f502bb5e839",
            "index": 26,
            "title": "Monetizing Data With AI: MIT CISR's Barb Wixom",
            "pub_date": "2025-02-18T05:00:00.000Z",
            "duration": "2071",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6917509339.mp3?updated=1743618656",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e1c42faa-d388-11ef-8284-b32a7e1550ee",
            "index": 27,
            "title": "Tackling Injuries With AI: The NFL's Jeff Miller",
            "pub_date": "2025-02-04T05:00:00.000Z",
            "duration": "1837",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "safety"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/tackling-injuries-with-ai-the-nfls-jeff-miller",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO7606679330.mp3?updated=1743618591",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "62f956f4-b8a4-11ef-8e60-b725580991ca",
            "index": 28,
            "title": "How a 160-Year-Old Startup Uses AI: The Heineken Company’s Ronald den Elzen",
            "pub_date": "2025-01-07T07:00:00.000Z",
            "duration": "1614",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5643444732.mp3?updated=1743618618",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19077d9c-b0bf-11ef-a3e5-ef615b05eb9d",
            "index": 29,
            "title": "Collective Learning With Generative AI",
            "pub_date": "2024-12-17T05:00:00.000Z",
            "duration": "1852",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/bonus-episode-collective-learning-with-generative-ai",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4281341411.mp3?updated=1743618693",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4b536c26-a84e-11ef-bfd9-3fe11069337c",
            "index": 30,
            "title": "Leveling the Playing Field With AI: Special Olympics's Mary Davis",
            "pub_date": "2024-12-03T08:00:00.000Z",
            "duration": "2308",
            "duration_label": "38m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/leveling-the-playing-field-with-ai-special-olympicss-mary-davis",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO7716254331.mp3?updated=1743618719",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c828c92-8b16-11ef-a3e9-cbe5e5b10f93",
            "index": 31,
            "title": "Bonus Episode: Lessons From Jobs in the Age of AI",
            "pub_date": "2024-11-26T08:00:00.000Z",
            "duration": "1524",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/bonus-episode-lessons-from-jobs-in-the-age-of-ai",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6338111830.mp3?updated=1730145055",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c55c8142-9624-11ef-a46c-33f3c9c8a60c",
            "index": 32,
            "title": "Sharing AI Mistakes: Partnership on AI’s Rebecca Finlay",
            "pub_date": "2024-11-12T08:00:00.000Z",
            "duration": "2486",
            "duration_label": "41m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "safety"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/sharing-ai-mistakes-partnership-on-ais-rebecca-finlay",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9813389164.mp3?updated=1736978133",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed958628-8b10-11ef-9f02-0f33e813f4d4",
            "index": 33,
            "title": "The Risks of Too Much AI: Fortune’s Jeremy Kahn",
            "pub_date": "2024-10-29T07:00:00.000Z",
            "duration": "2112",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/the-risks-of-too-much-ai-fortunes-jeremy-kahn",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO2314428384.mp3?updated=1729616078",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ed3c0ba-6edd-11ef-8dc6-936157a3c027",
            "index": 34,
            "title": "Never Too Much AI: Upwork's Andrew Rabinovich",
            "pub_date": "2024-10-15T07:00:00.000Z",
            "duration": "2137",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "multimodal",
              "robotics"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/never-too-much-ai-upworks-andrew-rabinovich",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO8130939138.mp3?updated=1729012973",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a0ab3216-7136-11ef-a343-8b8a19552d24",
            "index": 35,
            "title": "Ethically Sourced Creativity: Shutterstock's Alessandra Sala",
            "pub_date": "2024-10-01T07:00:00.000Z",
            "duration": "2150",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ethically-sourced-creativity-shutterstocks-alessandra-sala",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO3840719703.mp3?updated=1729012959",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "06d31792-5fdb-11ef-ac36-d741a40bd4f7",
            "index": 36,
            "title": "Meet Your New Teammate, AI: Asana’s Saket Srivastava",
            "pub_date": "2024-09-17T07:00:00.000Z",
            "duration": "2057",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/meet-your-new-teammate-ai-asanas-saket-srivastava/ ‎",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6477186147.mp3?updated=1725907890",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9796b0c-4dbe-11ef-b037-8b62db30aae6",
            "index": 37,
            "title": "Feed Drop: Why Only 10% of Companies Succeed With AI With Sam Ransbotham, Professor at Boston College",
            "pub_date": "2024-07-30T12:21:00.000Z",
            "duration": "2728",
            "duration_label": "45m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://moderncto.io/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO7096185780.mp3?updated=1731448351",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b0ad37e4-2754-11ef-9e47-276f6a2f4171",
            "index": 38,
            "title": "Building Connections Through Open Research: Meta’s Joelle Pineau",
            "pub_date": "2024-06-25T07:00:00.000Z",
            "duration": "1955",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents",
              "robotics"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/building-connections-through-open-research-metas-joelle-pineau",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4810589869.mp3?updated=1724258112",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "43782efa-138a-11ef-a247-0f8cbe9df89d",
            "index": 39,
            "title": "Authoring Creativity With AI: Researcher Patrick Hebron",
            "pub_date": "2024-06-12T07:00:00.000Z",
            "duration": "1732",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "nvidia"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/authoring-creativity-with-ai-researcher-patrick-hebron",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO7831829408.mp3?updated=1718216395",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29e3bcec-1228-11ef-8b23-d33f0612091d",
            "index": 40,
            "title": "If 10% of the World Were Developers: GitHub’s Mario Rodriguez",
            "pub_date": "2024-05-28T07:00:00.000Z",
            "duration": "1727",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "github copilot",
              "copilot"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/if-10-of-the-world-were-developers-githubs-mario-rodriguez",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4619445109.mp3?updated=1715966455",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e68004a4-ff73-11ee-bc6d-a7c9941bd76b",
            "index": 41,
            "title": "AI Hype and Skepticism: Economist Paul Romer",
            "pub_date": "2024-05-14T07:00:00.000Z",
            "duration": "1759",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ai-hype-and-skepticism-economist-paul-romer",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO3808690183.mp3?updated=1714669323",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "89233f24-ff73-11ee-a950-b3dfd8a30cb0",
            "index": 42,
            "title": "Lights, AI, Action: Wonder Dynamics's Tye Sheridan",
            "pub_date": "2024-04-30T07:00:00.000Z",
            "duration": "1663",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/lights-ai-action-wonder-dynamicss-tye-sheridan",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9433680688.mp3?updated=1714133525",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fb7fee04-e77d-11ee-87c9-8f8a163d2b56",
            "index": 43,
            "title": "Fashioning the Perfect Fit With AI: Stitch Fix’s Jeff Cooper",
            "pub_date": "2024-04-16T07:00:00.000Z",
            "duration": "2237",
            "duration_label": "37m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/fashioning-the-perfect-fit-with-ai-stitch-fixs-jeff-cooper",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9351197106.mp3?updated=1711654471",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5572d7bc-d5b0-11ee-888a-2b5ff2e9e082",
            "index": 44,
            "title": "Solving Real User Problems With Generative AI: Slack’s Jackie Rocca",
            "pub_date": "2024-04-02T07:00:00.000Z",
            "duration": "2002",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/solving-real-user-problems-with-generative-ai-slacks-jackie-rocca",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6567305237.mp3?updated=1711025450",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "679e7180-d501-11ee-8e92-df110760e65b",
            "index": 45,
            "title": "Driving Manufacturing Efficiency With AI: Pirelli’s Daniele Petecchi",
            "pub_date": "2024-03-19T07:00:00.000Z",
            "duration": "1530",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/driving-manufacturing-efficiency-with-ai-pirellis-daniele-petecchi",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO7295959391.mp3?updated=1710530978",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6e139ae0-d0e7-11ee-9175-3300439507be",
            "index": 46,
            "title": "Bonus Episode: How Can Organizations Better Measure and Manage Artificial Intelligence?",
            "pub_date": "2024-03-12T06:00:00.000Z",
            "duration": "1266",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5470376007.mp3?updated=1708540937",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6bca6faa-ca8b-11ee-b9a3-6faa74e3f5af",
            "index": 47,
            "title": "Bonus Episode: Artificial Intelligence Podcasts With Jennifer Strong",
            "pub_date": "2024-02-27T07:00:00.000Z",
            "duration": "1738",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/bonus-episode-artificial-intelligence-podcasts-with-jennifer-strong/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9649473383.mp3?updated=1727181277",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7c6fad9c-bc77-11ee-bde3-5f940cb47697",
            "index": 48,
            "title": "Bonus Episode: How Is Artificial Intelligence Transforming Manufacturing?",
            "pub_date": "2024-02-20T08:00:00.000Z",
            "duration": "1787",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6339125760.mp3?updated=1707841223",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "40faca38-bc8d-11ee-bed4-136aa09d5abc",
            "index": 49,
            "title": "Bonus Episode: Generative AI Trends for 2024 With Tom Davenport",
            "pub_date": "2024-02-06T08:00:00.000Z",
            "duration": "1789",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/bonus-episode-generative-ai-trends-for-2024-with-tom-davenport/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1155046100.mp3?updated=1726748753",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "81e01b52-b96d-11ee-bb99-a748d446c4cb",
            "index": 50,
            "title": "Bonus Episode: How Is Artificial Intelligence Transforming Retail Organizations?",
            "pub_date": "2024-01-30T08:00:00.000Z",
            "duration": "1510",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1448835369.mp3?updated=1706710665",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c2b5ca4-9544-11ee-a86b-7f6d7ce259dc",
            "index": 51,
            "title": "Punk Rock, the Peace Movement, and Open-Source AI: The Mozilla Foundation’s Mark Surman",
            "pub_date": "2024-01-17T08:00:00.000Z",
            "duration": "2071",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://mitsmr.com/3v67I3J",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1661897941.mp3?updated=1707842368",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "49110cc0-6f47-11ee-8b76-efb83a0aa285",
            "index": 52,
            "title": "Making Magic With Gen AI: Capital One’s Prem Natarajan",
            "pub_date": "2024-01-03T08:00:00.000Z",
            "duration": "1733",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "enterprise ai"
            ],
            "page_url": "https://mitsmr.com/3RgPDrb",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5081341755.mp3?updated=1702326154",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6c2fdb18-683b-11ee-b215-13b3b87a16d7",
            "index": 53,
            "title": "AI on Mars: NASA’s Vandi Verma",
            "pub_date": "2023-12-19T08:00:00.000Z",
            "duration": "1604",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "robotics",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ai-on-mars-nasas-vandi-verma",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO3808351988.mp3?updated=1700588139",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bac4aeee-7e4c-11ee-81c6-17d854ef392f",
            "index": 54,
            "title": "Operational Safety With AI: Chevron's Ellen Nielsen",
            "pub_date": "2023-12-05T08:00:00.000Z",
            "duration": "2113",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "safety"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/digital-twins-and-simulations-for-safety-chevrons-ellen-nielsen",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO7369004035.mp3?updated=1701826349",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ea1992ca-7741-11ee-8269-17b1a1f69ae8",
            "index": 55,
            "title": "Micro Utility With Gen AI: Shopify's Miqdad Jaffer",
            "pub_date": "2023-11-21T08:00:00.000Z",
            "duration": "2116",
            "duration_label": "35m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/micro-utility-with-gen-ai-shopifys-miqdad-jaffer",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5666421630.mp3?updated=1699477062",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5d94cd60-71d3-11ee-9357-cfd69188cf5c",
            "index": 56,
            "title": "Marketing With Generative AI: Harvard Business School’s Ayelet Israeli",
            "pub_date": "2023-11-07T08:00:00.000Z",
            "duration": "2073",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/marketing-with-generative-ai-harvard-business-schools-ayelet-israeli",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO8032532172.mp3?updated=1699382754",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f8a00002-5d67-11ee-b2cd-ab347bc8de5c",
            "index": 57,
            "title": "Entrepreneurial AI in the Enterprise: LG Nova's Shilpa Prasad",
            "pub_date": "2023-10-24T07:00:00.000Z",
            "duration": "1566",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/entrepreneurial-ai-in-the-enterprise-lg-novas-shilpa-prasad",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5624565631.mp3?updated=1697738051",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "888f351e-437a-11ee-bd3f-db9007d68fd9",
            "index": 58,
            "title": "Fueling Interdisciplinary Innovation With AI: Volvo’s Anders Sjögren",
            "pub_date": "2023-10-10T07:00:00.000Z",
            "duration": "1371",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "safety"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/fueling-interdisciplinary-innovation-with-ai-volvos-anders-sjogren",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO2268692623.mp3?updated=1695006108",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19456938-2a59-11ee-84be-4f89d860c209",
            "index": 59,
            "title": "Protecting Society From AI Harms: Amnesty International’s Matt Mahmoudi and Damini Satija (Part Two)",
            "pub_date": "2023-09-13T07:00:00.000Z",
            "duration": "1349",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/protecting-society-from-ai-harms-amnesty-internationals-matt-mahmoudi-and-damini-satija-part-two",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5758785906.mp3?updated=1694608054",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "776be0f6-2a4e-11ee-930b-eba02e8af7d2",
            "index": 60,
            "title": "Protecting Society From AI Harms: Amnesty International’s Matt Mahmoudi and Damini Satija (Part One)",
            "pub_date": "2023-08-29T07:00:00.000Z",
            "duration": "1699",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/protecting-society-from-ai-harms-amnesty-internationals-matt-mahmoudi-and-damini-satija-part-1",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO2523826598.mp3?updated=1690904711",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f6b5995c-2250-11ee-925b-57a18b77a494",
            "index": 61,
            "title": "Images and Inspiration With AI: Pinterest’s Jeremy King",
            "pub_date": "2023-08-15T07:00:00.000Z",
            "duration": "1220",
            "duration_label": "20m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/images-and-inspiration-with-ai-pinterests-jeremy-king",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1236412744.mp3?updated=1689344618",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a079ef90-0ee4-11ee-8628-8776634095b4",
            "index": 62,
            "title": "Learning From and With AI: Duolingo’s Zan Gilani",
            "pub_date": "2023-08-01T07:00:00.000Z",
            "duration": "1659",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/learning-from-and-with-ai-duolingos-zan-gilani",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO9869001210.mp3?updated=1689086469",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f00bc524-1b46-11ee-a556-97ae0f5a0f02",
            "index": 63,
            "title": "Detecting the Good and the Bad With AI: Airbnb’s Naba Banerjee",
            "pub_date": "2023-07-18T07:01:00.000Z",
            "duration": "2061",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/detecting-the-good-and-the-bad-with-ai-airbnbs-naba-banerjee",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO2800829280.mp3?updated=1688571104",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "767b7e74-eb63-11ed-b38b-db3f07c243e8",
            "index": 64,
            "title": "Regulating AI Innovation: Aboitiz Data Innovation’s David Hardoon",
            "pub_date": "2023-07-05T07:00:00.000Z",
            "duration": "1556",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/regulating-ai-innovation-aboitiz-data-innovations-david-hardoon",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6533851916.mp3?updated=1686587049",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fcea113e-e8f0-11ed-a748-b3eb47d04cc8",
            "index": 65,
            "title": "The Social Science of AI: Intel’s Elizabeth Anne Watkins",
            "pub_date": "2023-06-20T07:00:00.000Z",
            "duration": "2015",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "chip"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/the-social-science-of-ai-intels-elizabeth-anne-watkins",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO8284869784.mp3?updated=1684279628",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dff3c58e-f34a-11ed-97a5-bb6957dec3a0",
            "index": 66,
            "title": "Making Investments in AI: Samsung’s Hina Dixit",
            "pub_date": "2023-06-06T07:00:00.000Z",
            "duration": "1451",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "robotics"
            ],
            "page_url": "",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1051565829.mp3?updated=1684759203",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b1e42714-dad2-11ed-99f6-c3722e0fa733",
            "index": 67,
            "title": "Continuous Learning With AI: Aflac’s Shelia Anderson",
            "pub_date": "2023-05-23T07:00:00.000Z",
            "duration": "1341",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/continuous-learning-with-ai-aflacs-shelia-anderson",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4844803215.mp3?updated=1684243658",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac29620c-d2f4-11ed-b204-27a5fd00fca5",
            "index": 68,
            "title": "Trust and Fraud Detection at Scale: Instagram’s Stephanie Moyerman",
            "pub_date": "2023-05-09T07:00:00.000Z",
            "duration": "1691",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "safety"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/trust-and-fraud-detection-at-scale-instagrams-stephanie-moyerman",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO6280039252.mp3?updated=1683034928",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f63469f8-bcf3-11ed-b11b-a71e91e285d5",
            "index": 69,
            "title": "Partnerships in AI Drive Conservation Efforts: WWF’s Dave Thau",
            "pub_date": "2023-04-25T07:00:00.000Z",
            "duration": "1567",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/partnerships-in-ai-drive-conservation-efforts-wwfs-dave-thau",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1402129759.mp3?updated=1686678356",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "29d3967a-b859-11ed-8704-53f8783ae8f3",
            "index": 70,
            "title": "Making 600 Billion Decisions With AI: Expedia Group’s Rathi Murthy",
            "pub_date": "2023-04-11T07:00:00.000Z",
            "duration": "1993",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/making-600-billion-decisions-with-ai-expedia-groups-rathi-murthy",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5568186497.mp3?updated=1680617290",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "24094f6e-af17-11ed-893a-5fb27a12c51b",
            "index": 71,
            "title": "A One-Stop Data Shop: The Lego Group’s Anders Butzbach Christensen",
            "pub_date": "2023-03-28T07:00:00.000Z",
            "duration": "1466",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/a-one-stop-data-shop-the-lego-groups-anders-butzbach-christensen",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO7830281743.mp3?updated=1677073641",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "63697ace-8c55-11ed-9e17-57edbf799c14",
            "index": 72,
            "title": "A Third Path to Talent Development: Delta’s Michelle McCrackin",
            "pub_date": "2023-03-14T07:00:00.000Z",
            "duration": "1722",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "training"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/a-third-path-to-talent-development-deltas-michelle-mccrackin",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1385623440.mp3?updated=1674086102",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "346f76cc-9cf6-11ed-8601-7f5de014a9b1",
            "index": 73,
            "title": "Out of the Lab and Into a Product: Microsoft’s Eric Boyd",
            "pub_date": "2023-02-28T08:00:00.000Z",
            "duration": "1747",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "generative ai",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/out-of-the-lab-and-into-a-product-microsofts-eric-boyd",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO1946668261.mp3?updated=1678158851",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b071a528-8096-11ed-ba62-a3fabfa7610e",
            "index": 74,
            "title": "Helping Doctors Make Better Decisions With Data: UC Berkeley's Ziad Obermeyer",
            "pub_date": "2023-02-14T08:00:00.000Z",
            "duration": "1988",
            "duration_label": "33m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/helping-doctors-make-better-decisions-with-data-uc-berkeleys-ziad-obermeyer",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO4998268065.mp3?updated=1676039895",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1fc1fd00-7b20-11ed-a69d-af6f0040618e",
            "index": 75,
            "title": "Bonus Episode: How Encouraging AI Use Will Benefit Your Organization",
            "pub_date": "2023-01-10T08:00:00.000Z",
            "duration": "1365",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO3288377773.mp3?updated=1670961776",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "37de4bc2-725c-11ed-a707-a3a8b9b7d75a",
            "index": 76,
            "title": "Bonus Episode: Learn to Make the Most of Your Relationship With AI",
            "pub_date": "2022-12-06T09:00:00.000Z",
            "duration": "1511",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/AMMTO5115928320.mp3?updated=1669998023",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5bf0f9a-4722-11ed-8cda-9b328f07e86b",
            "index": 77,
            "title": "Digital First, Physical Second: Wayfair’s Fiona Tan",
            "pub_date": "2022-11-08T11:00:00.000Z",
            "duration": "1396",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/digital-first-physical-second-wayfairs-fiona-tan",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG6084392106.mp3?updated=1666792556",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "63ad275e-4008-11ed-9b78-676d7d28b461",
            "index": 78,
            "title": "Investing in the Last Mile: PayPal’s Khatereh Khodavirdi",
            "pub_date": "2022-10-25T10:00:00.000Z",
            "duration": "1764",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://www.sloanreview.mit.edu/audio/investing-in-the-last-mile-paypals-khatereh-khodavirdi",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG2492803889.mp3?updated=1666114765",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db572508-23c9-11ed-a4e5-873e49641731",
            "index": 79,
            "title": "Keeping Humans in the (Feedback) Loop: Orangetheory Fitness’s Ameen Kazerouni",
            "pub_date": "2022-10-11T10:00:00.000Z",
            "duration": "1445",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/keeping-humans-in-the-feedback-loop-orangetheory-fitnesss-ameen-kazerouni",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG3196094954.mp3?updated=1664994165",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "312f6bfa-1986-11ed-a6f9-2f34ce8db758",
            "index": 80,
            "title": "The Three Roles of the Chief Data Officer: ADP’s Jack Berkowitz",
            "pub_date": "2022-09-27T10:00:00.000Z",
            "duration": "1483",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/the-three-roles-of-the-chief-data-officer-adps-jack-berkowitz",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG9803030184.mp3?updated=1661367332",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7cfe3c8e-23c0-11ed-9d77-1760ff9fc74c",
            "index": 81,
            "title": "From Data to Wisdom: Novo Nordisk’s Tonia Sideri",
            "pub_date": "2022-09-13T10:00:00.000Z",
            "duration": "1610",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/from-data-to-wisdom-novo-nordisks-tonia-sideri",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG6036819562.mp3?updated=1662673574",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c1c5ac4e-12b3-11ed-a3b7-d3600d67e972",
            "index": 82,
            "title": "Big Data in Agriculture: Land O’Lakes’ Teddy Bekele",
            "pub_date": "2022-08-30T10:00:00.000Z",
            "duration": "1272",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/big-data-in-agriculture-land-olakes-teddy-bekele",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG8591833170.mp3?updated=1660069757",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0e6695cc-0ce7-11ed-9b8f-9311343b7963",
            "index": 83,
            "title": "Inventing the Beauty of the Future: L’Oréal’s Stéphane Lannuzel",
            "pub_date": "2022-08-16T10:00:00.000Z",
            "duration": "1164",
            "duration_label": "19m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/inventing-the-beauty-of-the-future-loreals-stephane-lannuzel",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG9720441911.mp3?updated=1659543812",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7570651a-fecb-11ec-8c4c-a7b391dc2dfd",
            "index": 84,
            "title": "Precision Medicine in Pharma: Sanofi’s Frank Nestle",
            "pub_date": "2022-08-02T10:00:00.000Z",
            "duration": "1482",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/precision-medicine-in-pharma-sanofis-frank-nestle/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG5210782183.mp3?updated=1659040025",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "64a41fe8-ff88-11ec-86d0-431af14501b0",
            "index": 85,
            "title": "Me, Myself, and AI Season 5 Trailer",
            "pub_date": "2022-07-19T06:00:00.000Z",
            "duration": "128",
            "duration_label": "2m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG5997317759.mp3?updated=1657372569",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d51c6c44-e36d-11ec-af30-6f41c90b98c1",
            "index": 86,
            "title": "The Beauty of AI: Estée Lauder's Sowmya Gottipati",
            "pub_date": "2022-06-14T10:00:00.000Z",
            "duration": "1411",
            "duration_label": "23m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/the-beauty-of-ai-estee-lauders-sowmya-gottipati",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG8136577494.mp3?updated=1654879259",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a738a91c-c96b-11ec-a159-8f3282bff5f5",
            "index": 87,
            "title": "AI in Aerospace: Boeing’s Helen Lee",
            "pub_date": "2022-05-31T10:00:00.000Z",
            "duration": "1450",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "safety"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ai-in-aerospace-boeings-helen-lee",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG8704567817.mp3?updated=1654282844",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2f2bd7b6-bff5-11ec-9c26-ef4a3add9a30",
            "index": 88,
            "title": "Transforming Transactions With Technology: eBay’s Nitzan Mekel-Bobrov",
            "pub_date": "2022-05-17T10:00:00.000Z",
            "duration": "1634",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/transforming-transactions-with-technology-ebays-nitzan-mekel-bobrov",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG3481601115.mp3?updated=1654282926",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7db4b792-bb70-11ec-ad5d-6372a2d33ff4",
            "index": 89,
            "title": "The Collaboration Muscle: LinkedIn’s Ya Xu",
            "pub_date": "2022-05-03T10:00:00.000Z",
            "duration": "1860",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/the-collaboration-muscle-linkedins-ya-xu",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG8719363419.mp3?updated=1654282990",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d93c186-a5ec-11ec-8b7f-9f673dc61ffb",
            "index": 90,
            "title": "Turning Sound Into Information: Warner Music Group's Kobi Abayomi",
            "pub_date": "2022-04-19T10:00:00.000Z",
            "duration": "1545",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/turning-sound-into-information-warner-music-groups-kobi-abayomi",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG8494396136.mp3?updated=1649958079",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "36b54b44-998e-11ec-8c8f-9f0a7b573ca6",
            "index": 91,
            "title": "From Journalism to Jeans: Levi Strauss & Co.’s Katia Walsh",
            "pub_date": "2022-04-05T10:00:00.000Z",
            "duration": "1785",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/from-journalism-to-jeans-levi-strauss-co-s-katia-walsh",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG7534920513.mp3?updated=1649958094",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "996ac600-95ac-11ec-882d-ef7799d1d6cc",
            "index": 92,
            "title": "AI in Your Living Room: Peloton’s Sanjay Nichani",
            "pub_date": "2022-03-22T10:00:00.000Z",
            "duration": "1317",
            "duration_label": "21m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "training"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ai-in-your-living-room-pelotons-sanjay-nichani",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG9025981534.mp3?updated=1649958105",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "036674da-8f51-11ec-8991-bbc341523433",
            "index": 93,
            "title": "Extreme Innovation With AI: Stanley Black and Decker's Mark Maybury",
            "pub_date": "2022-03-08T11:00:00.000Z",
            "duration": "1888",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/extreme-innovation-with-ai-stanley-black-deckers-mark-maybury",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG6905360231.mp3?updated=1649958116",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d6593260-82e0-11ec-bf26-afa07b92bec1",
            "index": 94,
            "title": "Choreographing Human-Machine Collaboration: Spotify's Sidney Madison Prescott",
            "pub_date": "2022-02-22T11:00:00.000Z",
            "duration": "1972",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "robotics",
              "automation"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/choreographing-human-machine-collaboration-spotifys-sidney-madison-prescott",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG3672968957.mp3?updated=1649958129",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "894bbec2-6367-11ec-b2ac-6f2125e98adc",
            "index": 95,
            "title": "Imagining Furniture (and the Future) With AI: IKEA Retail’s Barbara Martin Coppola",
            "pub_date": "2022-02-08T11:00:00.000Z",
            "duration": "1767",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/imagining-furniture-and-the-future-with-ai-ikea-retails-barbara-martin-coppola/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG6587888244.mp3?updated=1649958141",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e6184bf8-747d-11ec-b06f-17ade455be10",
            "index": 96,
            "title": "Transforming a Technology Organization for the Future: Starbucks’s Gerri Martin-Flickinger",
            "pub_date": "2022-01-25T11:00:00.000Z",
            "duration": "1704",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/transforming-a-technology-organization-for-the-future-starbucks-gerri-martin-flickinger",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG7436325075.mp3?updated=1649958152",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0264a712-628a-11ec-b3a1-bb2ca411c2de",
            "index": 97,
            "title": "AI in the Supply Chain: Cold Chain Technologies’ Ranjeet Banerjee",
            "pub_date": "2022-01-11T11:00:00.000Z",
            "duration": "2083",
            "duration_label": "34m",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ai-in-the-supply-chain-cold-chain-technologies-ranjeet-banerjee/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG8903376581.mp3?updated=1649958174",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77ac9304-31a7-11ec-9903-5716680bf843",
            "index": 98,
            "title": "Technology as a Force for Good: Salesforce’s Paula Goldman",
            "pub_date": "2021-11-30T11:00:00.000Z",
            "duration": "1655",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/technology-as-a-force-for-good-salesforces-paula-goldman/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG5822183449.mp3?updated=1649958191",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "84803aa4-26c1-11ec-a957-731ce683645f",
            "index": 99,
            "title": "Predicting Volatility and Risk: Nasdaq’s Doug Hamilton",
            "pub_date": "2021-11-16T11:00:00.000Z",
            "duration": "1551",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/predicting-volatility-and-risk-nasdaqs-doug-hamilton/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG7411733114.mp3?updated=1649958202",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "98532764-17fb-11ec-8a7c-2f6ec5e7bcd7",
            "index": 100,
            "title": "Developing an Appetite for AI: ExxonMobil’s Sarah Karthigan",
            "pub_date": "2021-11-02T10:00:00.000Z",
            "duration": "1806",
            "duration_label": "30m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/developing-an-appetite-for-ai-exxonmobils-sarah-karthigan/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG9081067501.mp3?updated=1649958215",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "961ee446-1243-11ec-9603-1f51b55f44fc",
            "index": 101,
            "title": "Democratizing Data in Hollywood: Jumpcut’s Kartik Hosanagar",
            "pub_date": "2021-10-19T10:00:00.000Z",
            "duration": "1721",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/democratizing-data-in-hollywood-jumpcuts-kartik-hosanagar/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG5347798632.mp3?updated=1647027399",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e4c931b2-1655-11ec-bae2-cb1bf4c43f80",
            "index": 102,
            "title": "Me, Myself, and AI Season 3 Trailer",
            "pub_date": "2021-09-30T10:00:00.000Z",
            "duration": "92",
            "duration_label": "1m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG2529026443.mp3?updated=1649958227",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "45eb8cc0-2054-45fc-b58c-ada0faf85473",
            "index": 103,
            "title": "AI and the COVID-19 Vaccine: Moderna’s Dave Johnson",
            "pub_date": "2021-07-13T08:00:00.000Z",
            "duration": "1473",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/ai-and-the-covid-19-vaccine-modernas-dave-johnson/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG1354722033.mp3?updated=1649958235",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8c4a17f6-8d40-4c6b-b329-aae5d4a97ef1",
            "index": 104,
            "title": "Starting Now On Technology Ethics: Elizabeth Renieris",
            "pub_date": "2021-06-22T08:00:00.000Z",
            "duration": "1778",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/starting-now-on-technology-ethics-elizabeth-renieris/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG1659976369.mp3?updated=1649958249",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0d049f87-8271-483a-9f31-4357821b592a",
            "index": 105,
            "title": "No Need for AI Unicorns: PepsiCo's Colin Lenaghan",
            "pub_date": "2021-06-08T08:00:00.000Z",
            "duration": "1731",
            "duration_label": "28m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/no-need-for-ai-unicorns-pepsicos-colin-lenaghan/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG5140978248.mp3?updated=1649958259",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "03d7580f-7dbf-442a-916f-a3776608ed00",
            "index": 106,
            "title": "DIY With AI: The Home Depot's Huiming Qu",
            "pub_date": "2021-05-25T08:00:00.000Z",
            "duration": "1608",
            "duration_label": "26m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/diy-with-ai-the-home-depots-huiming-qu/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG6094694471.mp3?updated=1649958269",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3ca4d306-704c-41d1-b64f-34203e3395f9",
            "index": 107,
            "title": "Prototypes, Pilots, and Polymers: Cooper Standard’s Chris Couch",
            "pub_date": "2021-05-11T08:00:00.000Z",
            "duration": "1919",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/prototypes-pilots-and-polymers-cooper-standards-chris-couch/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG2609704428.mp3?updated=1649958287",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0a9c4b32-8655-4bd4-9cc9-2b648cc2ad22",
            "index": 108,
            "title": "Designing a Better Future: Mastercard’s JoAnn Stonier",
            "pub_date": "2021-04-27T08:00:00.000Z",
            "duration": "1797",
            "duration_label": "29m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/designing-a-better-future-mastercards-joann-stonier/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG5614991741.mp3?updated=1649958299",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "137de2ae-5733-4d37-b244-78bb654e8936",
            "index": 109,
            "title": "Learning, Engagement, and Empowerment: 1-800-Flowers’ Amit Shah",
            "pub_date": "2021-04-13T08:00:00.000Z",
            "duration": "2217",
            "duration_label": "36m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/learning-engagement-and-empowerment-1-800-flowers-amit-shah/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG4209273147.mp3?updated=1649958319",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2601a12f-d54a-4a44-9a4c-f71e7bb5f3fa",
            "index": 110,
            "title": "Games, Teams, and Moonshots: Google Cloud’s Will Grannis",
            "pub_date": "2021-03-30T08:00:00.000Z",
            "duration": "1860",
            "duration_label": "31m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/games-teams-and-moonshots-google-clouds-will-grannis/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG1885232033.mp3?updated=1649958328",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3d113888-caa1-4935-86fc-c63c442a396b",
            "index": 111,
            "title": "Less Algorithm, More Application: Lyft’s Craig Martell",
            "pub_date": "2021-03-16T08:00:00.000Z",
            "duration": "1476",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/less-algorithm-more-application-lyfts-craig-martell/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG6907517455.mp3?updated=1649958341",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b2d3ed80-0f9d-4b67-8658-bba581d069e7",
            "index": 112,
            "title": "Tech and Ethics: The World Economic Forum’s Kay Firth-Butterfield on Doing the Right Thing in AI",
            "pub_date": "2020-11-17T09:00:00.000Z",
            "duration": "1922",
            "duration_label": "32m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/tech-and-ethics-the-world-economic-forums-kay-firth-butterfield-on-doing-the-right-thing-in-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG4205669586.mp3?updated=1649958351",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "afcd8847-7b9a-4836-837c-58f0e72ce609",
            "index": 113,
            "title": "Fashion Forecasting: Arti Zeighami on Implementing AI at H&M Group",
            "pub_date": "2020-11-10T09:00:00.000Z",
            "duration": "1332",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/fashion-forecasting-arti-zeighami-on-implementing-ai-at-hm-group/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG5065705517.mp3?updated=1649958365",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2163630a-c895-4542-9d0c-0c4f65c2c1cc",
            "index": 114,
            "title": "Better Together: Mattias Ulbrich on Combining Coffee, Business, and Technology at Porsche",
            "pub_date": "2020-11-03T09:00:00.000Z",
            "duration": "1674",
            "duration_label": "27m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/audio/better-together-mattias-ulbrich-on-combining-coffee-business-and-technology-at-porsche/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG6880877271.mp3?updated=1649958376",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e36357e3-a4b5-47bd-ad5b-ac4beadbf3c7",
            "index": 115,
            "title": "‘The First Day Is the Worst Day’: DHL’s Gina Chung on How AI Improves Over Time",
            "pub_date": "2020-10-27T08:00:00.000Z",
            "duration": "1447",
            "duration_label": "24m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "robotics"
            ],
            "page_url": "https://sloanreview.mit.edu/audio-series/me-myself-and-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG4870000126.mp3?updated=1649958387",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "09deb2dd-597c-44e9-81c9-9bbc7ec3a3a7",
            "index": 116,
            "title": "Advancing Health Care with AI: Humana’s Slawek Kierner Talks Synthetic Data and Real Lives",
            "pub_date": "2020-10-20T08:00:00.000Z",
            "duration": "1503",
            "duration_label": "25m",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/advancing-health-care-with-ai-humanas-slawek-kierner-talks-synthetic-data-and-real-lives/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG6055649633.mp3?updated=1649958402",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "167274b2-efc6-4dd9-a1fb-2e31733755a4",
            "index": 117,
            "title": "This Crazy Wave We’re Riding: Walmart’s Prakhar Mehrotra and the Ups and Downs of AI",
            "pub_date": "2020-10-20T08:00:00.000Z",
            "duration": "1377",
            "duration_label": "22m",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agents"
            ],
            "page_url": "https://sloanreview.mit.edu/audio/this-crazy-wave-were-riding-walmarts-prakhar-mehrotra-on-the-ups-and-downs-of-ai/",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG9970269223.mp3?updated=1649958412",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ffbef9e2-efd0-4c45-b9fe-f98806dba83b",
            "index": 118,
            "title": "Season 1 Trailer",
            "pub_date": "2020-09-23T17:03:00.000Z",
            "duration": "112",
            "duration_label": "1m",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://sloanreview.mit.edu/ai",
            "audio_url": "https://pdst.fm/e/traffic.megaphone.fm/TPG7110856727.mp3?updated=1649958423",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "data-skeptic",
        "title": "Data Skeptic",
        "feed_title": "Data Skeptic",
        "priority": "P2",
        "selection_mode": "keyword",
        "focus": [
          "data science",
          "statistics",
          "machine learning",
          "AI concepts"
        ],
        "feed_url": "https://rss.libsyn.com/shows/54799/destinations/201630.xml",
        "source_url": "https://rss.libsyn.com/shows/54799/destinations/201630.xml",
        "detail_path": "/podcasts/data-skeptic/",
        "episode_count": 250,
        "selected_episode_count": 70,
        "latest_episode_title": "Student Spotlight: Aaron Payne, Data Analyst",
        "latest_pub_date": "2026-05-01T15:25:00.000Z",
        "latest_page_url": "https://dataskeptic.com/blog/episodes/2026/student-spotlight-aaron-payne-data-analyst",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "70af689a-9a80-4e93-9f44-70376166cd6b",
            "index": 1,
            "title": "Student Spotlight: Aaron Payne, Data Analyst",
            "pub_date": "2026-05-01T15:25:00.000Z",
            "duration": "25:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2026/student-spotlight-aaron-payne-data-analyst",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Aaron_No_Ads_V3.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d2162e7b-02f2-475f-a353-e1041bcedd78",
            "index": 2,
            "title": "The Future is Agentic in Recommender Systems",
            "pub_date": "2026-04-25T18:00:00.000Z",
            "duration": "49:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2026/The-future-is-agentic-in-recommender-systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Yashar_No_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7a8f5ebd-814f-4f91-826c-381eef53c483",
            "index": 3,
            "title": "Book Ratings and Recommendations",
            "pub_date": "2026-03-27T15:31:00.000Z",
            "duration": "39:19",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2026/book-ratings-and-recomendations",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Hannes_No_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b293451c-46c4-49bb-b926-b03e948bf926",
            "index": 4,
            "title": "Disentanglement and Interpretability in Recommender Systems",
            "pub_date": "2026-03-10T13:56:00.000Z",
            "duration": "30:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2026/disentanglement-and-interpretability-in-recommender-systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Ervin_No_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a3c5a2fd-455b-4031-89e6-9caec7312300",
            "index": 5,
            "title": "Collective Altruism in Recommender Systems",
            "pub_date": "2026-02-27T16:49:00.000Z",
            "duration": "54:35",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2026/collective-altruism-in-recommender-systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Ekatrina_No_With_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0ec53f2c-516b-473b-9037-04a543684966",
            "index": 6,
            "title": "Niche vs Mainstream",
            "pub_date": "2026-02-18T16:02:00.000Z",
            "duration": "34:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2026/niche-vs-mainstream",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Anas_With_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "70f91d40-5610-4f4f-8aa5-d417fd8d669d",
            "index": 7,
            "title": "Healthy Friction in Job Recommender Systems",
            "pub_date": "2026-02-02T16:55:00.000Z",
            "duration": "26:37",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "inference"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2026/Healthy-Friction-in-Job-Recommender-Systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Roan_No_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d0a5874b-a15e-4006-97b0-8e3199705f56",
            "index": 8,
            "title": "Fairness in PCA-Based Recommenders",
            "pub_date": "2026-01-26T15:56:00.000Z",
            "duration": "49:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2026/fairness-in-PCA-based-recommenders",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/David_With_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "83af7fcf-8690-4912-8134-592bfb58c397",
            "index": 9,
            "title": "Video Recommendations in Industry",
            "pub_date": "2025-12-26T15:20:00.000Z",
            "duration": "38:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "retrieval"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/video-recommendations-in-industry",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Cory_With_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f94bdb7c-de91-4dc8-91c6-3193684d8bf6",
            "index": 10,
            "title": "Eye Tracking in Recommender Systems",
            "pub_date": "2025-12-18T14:48:00.000Z",
            "duration": "52:08",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/Eye-Tracking-in-Recommender-Systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Santiago_With_Ads_V2.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3ff399a8-16a0-42f2-971e-f482b4a49750",
            "index": 11,
            "title": "Cracking the Cold Start Problem",
            "pub_date": "2025-12-08T15:00:00.000Z",
            "duration": "39:57",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "embeddings"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/cracking-the-cold-start-problem",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Boya_No_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "941befc7-27c9-4879-9a5a-e7a75af82ac7",
            "index": 12,
            "title": "Designing Recommender Systems for Digital Humanities",
            "pub_date": "2025-11-23T16:50:00.000Z",
            "duration": "36:48",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "embedding"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/designing-recommender-systems-for-digital-humanities",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Florian_With_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3ec017b1-54a1-4ff6-ac9e-2f3e8859dc89",
            "index": 13,
            "title": "DataRec Library for Reproducible in Recommend Systems",
            "pub_date": "2025-11-13T21:41:00.000Z",
            "duration": "32:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/datarec-library-for-reproducible-in-recommend-systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Alberto_With_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6b5d50f8-4167-46a5-96c7-aff63d857e36",
            "index": 14,
            "title": "Shilling Attacks on Recommender Systems",
            "pub_date": "2025-11-05T14:11:00.000Z",
            "duration": "34:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/Shilling-Attacks-on-Recommender-Systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Aditya_With_Ads_Ad_segment_1_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "06d0d796-f6ed-4df1-99d9-31cceb5503af",
            "index": 15,
            "title": "Music Playlist Recommendations",
            "pub_date": "2025-10-29T14:00:00.000Z",
            "duration": "52:29",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "embeddings",
              "multimodal"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/music-playlist-recommendations",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/rebecca-with-ads.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d406d10-93a5-43cf-b328-3229ce95fd13",
            "index": 16,
            "title": "Bypassing the Popularity Bias",
            "pub_date": "2025-10-15T15:33:00.000Z",
            "duration": "34:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/bypassing-the-popularity-bias",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Vaclav_No_Ads_V1.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f53bcfa7-a6d3-4770-8ad1-e3e7ac9d3dc7",
            "index": 17,
            "title": "Sustainable Recommender Systems for Tourism",
            "pub_date": "2025-10-09T13:09:00.000Z",
            "duration": "38:02",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/sustainable-recommender-systems-for-tourism",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Ashmi_with_Ads_V2.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f52c3f85-23a5-4704-af44-35dd519508c5",
            "index": 18,
            "title": "Interpretable Real Estate Recommendations",
            "pub_date": "2025-09-22T21:45:00.000Z",
            "duration": "32:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/interpretable-real-estate-recommendations",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Kunal_With_Ads.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "057d683b-6e22-4ea0-acb9-1292436de5f1",
            "index": 19,
            "title": "Why Am I Seeing This?",
            "pub_date": "2025-09-08T20:11:00.000Z",
            "duration": "49:36",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/why-am-i-seeing-this",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Dimitri_Gregor_Sabrina_Podcast_with_Ads.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b114dbf2-db2e-4b14-92a8-b7c94d0538ab",
            "index": 20,
            "title": "Eco-aware GNN Recommenders",
            "pub_date": "2025-08-30T21:00:00.000Z",
            "duration": "44:42",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/eco-aware-gnn-recommenders",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/Antonio_Podcast_with_Ad_Mixdown.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13c30915-4bef-49a1-90b9-6106d75a2593",
            "index": 21,
            "title": "Networks and Recommender Systems",
            "pub_date": "2025-08-17T22:17:00.000Z",
            "duration": "17:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/networks-and-recommender-systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/networks-and-recommender-systems.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5650905a-ac46-4a91-bdce-308b32d2ca80",
            "index": 22,
            "title": "Network of Past Guests Collaborations",
            "pub_date": "2025-07-21T22:59:00.000Z",
            "duration": "34:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/network-of-past-guests-collaborations",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/network-of-past-guests-collaborations.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba2b06a2-7408-4370-9164-7b1dde87038b",
            "index": 23,
            "title": "The Network Diversion Problem",
            "pub_date": "2025-07-06T23:13:00.000Z",
            "duration": "46:14",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "http://dataskeptic.com/blog/episodes/2025/the-network-diversion-problem",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-network-diversion-problem.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cfc5b887-5bfb-43a9-8e4a-2a7b453a6fd1",
            "index": 24,
            "title": "Complex Dynamic in Networks",
            "pub_date": "2025-06-28T16:53:00.000Z",
            "duration": "56:00",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/complex-dynamics-in-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/complex-dynamics-in-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4920b703-5efc-4615-8fca-d92eb8513014",
            "index": 25,
            "title": "Github Network Analysis",
            "pub_date": "2025-06-22T03:41:00.000Z",
            "duration": "36:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "http://dataskeptic.com/blog/episodes/2025/github-network-analysis",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/github-network-analysis.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b7baf036-0cbf-40ef-a5af-df4fb3f1f3b7",
            "index": 26,
            "title": "Networks and Complexity",
            "pub_date": "2025-06-14T01:05:00.000Z",
            "duration": "17:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "http://dataskeptic.com/blog/episodes/2025/networks-and-complexity",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/networks-and-complexity.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5157c107-3b51-49be-84d0-5abee3e95a3d",
            "index": 27,
            "title": "Graphs for Causal AI",
            "pub_date": "2025-05-24T15:21:00.000Z",
            "duration": "41:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/graphs-for-causal-ai",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/graphs-for-causal-ai.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f5bce32-839d-4236-9ef3-4fd17e64fa7e",
            "index": 28,
            "title": "Power Networks",
            "pub_date": "2025-05-16T23:52:00.000Z",
            "duration": "41:50",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/power-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/power-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "720a127d-cfda-4395-8d63-95a81a38037e",
            "index": 29,
            "title": "Unveiling Graph Datasets",
            "pub_date": "2025-05-08T23:15:00.000Z",
            "duration": "44:12",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "http://dataskeptic.com/blog/episodes/2025/unveiling-graph-datasets",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/unveiling-graph-datasets.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "30ad53bd-7641-423b-a240-b8fcf792111f",
            "index": 30,
            "title": "Network Manipulation",
            "pub_date": "2025-04-30T00:52:00.000Z",
            "duration": "40:58",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "safety"
            ],
            "page_url": "http://dataskeptic.com/blog/episodes/2025/network-manipulation",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/network-manipulation.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "74d734c8-78dd-4f9d-a91e-eb030a108a58",
            "index": 31,
            "title": "The Small World Hypothesis",
            "pub_date": "2025-04-21T05:01:00.000Z",
            "duration": "17:25",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/the-small-world-hypothesis",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/small-world-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6509b7c3-1ce2-4494-bdd9-2e382ec6c8c0",
            "index": 32,
            "title": "Thinking in Networks",
            "pub_date": "2025-04-12T16:03:00.000Z",
            "duration": "33:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/thinking-in-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/thinking-in-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "342140b9-857b-479b-865d-d789c78b09d1",
            "index": 33,
            "title": "Fraud Networks",
            "pub_date": "2025-04-01T22:47:00.000Z",
            "duration": "42:55",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/fraud-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fraud-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04e721a6-f372-41b6-bd0a-79e336bbaa6c",
            "index": 34,
            "title": "Criminal Networks",
            "pub_date": "2025-03-17T15:00:00.000Z",
            "duration": "43:35",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/criminal-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/criminal-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65a93f93-fe65-44ef-9d76-e2c2e26287cc",
            "index": 35,
            "title": "Graph Bugs",
            "pub_date": "2025-03-10T15:00:00.000Z",
            "duration": "29:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/graph-bugs",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/graph-bugs.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46fb896a-1aa5-4a9a-8596-ad4f5c5b31ac",
            "index": 36,
            "title": "Organizational Network Analysis",
            "pub_date": "2025-03-03T15:00:00.000Z",
            "duration": "44:15",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/organizational-network-analysis",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/organizational-network-analysis.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c52c9562-eeb4-4b7a-9f4a-01da09e8f25b",
            "index": 37,
            "title": "Organizational Networks",
            "pub_date": "2025-02-25T13:00:00.000Z",
            "duration": "27:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/organizational-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/organizational-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2f6d800c-94c0-4e49-a5f2-1733a7d347f8",
            "index": 38,
            "title": "Networks of the Mind",
            "pub_date": "2025-02-18T20:13:00.000Z",
            "duration": "43:16",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "reasoning"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/networks-of-the-mind",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/networks-of-the-mind.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2514372e-18a2-45d5-ba55-a81b1b93e571",
            "index": 39,
            "title": "LLMs and Graphs Synergy",
            "pub_date": "2025-02-10T17:41:00.000Z",
            "duration": "34:47",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "reasoning",
              "retrieval"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/llms-and-graphs-synergy",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/llms-and-graphs-synergy.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "df75db9d-d598-4dff-970a-f5e02d004b8e",
            "index": 40,
            "title": "A Network of Networks",
            "pub_date": "2025-02-04T02:23:00.000Z",
            "duration": "46:27",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/a-network-of-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/a-network-of-networks-libsyn-sucks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "18d749f5-11b1-48f9-9c62-fb0420aa0082",
            "index": 41,
            "title": "Auditing LLMs and Twitter",
            "pub_date": "2025-01-29T18:53:00.000Z",
            "duration": "40:26",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "llm",
              "large language model",
              "training"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/auditing-llms-and-twitter",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/auditing-llms-and-twitter.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "216d5305-32ec-49ac-8dce-072701d513ea",
            "index": 42,
            "title": "Fraud Detection with Graphs",
            "pub_date": "2025-01-22T03:04:00.000Z",
            "duration": "37:23",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/fraud-detection-with-graphs",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fraud-detection-with-graphs.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4896f198-e404-4567-ae71-831a7a462427",
            "index": 43,
            "title": "Optimizing Supply Chains with GNN",
            "pub_date": "2025-01-15T15:34:00.000Z",
            "duration": "38:04",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2025/optimizing-supply-chains-with-gnn",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/optimizing-supply-chains-with-gnn.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f724a331-6d3c-4ce7-8626-a4604d8d4242",
            "index": 44,
            "title": "The Mystery Behind Large Graphs",
            "pub_date": "2025-01-10T01:49:00.000Z",
            "duration": "47:47",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/the-mystery-behind-large-graphs",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-mystery-behind-large-graphs.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "152891fe-8a20-40d9-88b4-00f6c06fdef9",
            "index": 45,
            "title": "Customizing a Graph Solution",
            "pub_date": "2024-12-16T23:03:00.000Z",
            "duration": "38:07",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/customizing-a-graph-solution",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/customizing-a-graph-solution.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ed251ca0-4ca5-4f2a-b40b-474cd417e3e3",
            "index": 46,
            "title": "Graph Transformations",
            "pub_date": "2024-12-09T06:10:00.000Z",
            "duration": "32:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/graph-transformations",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/graph-transformations.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c4dc0a10-958e-4517-9088-03f0b06e6f82",
            "index": 47,
            "title": "Networks for AB Testing",
            "pub_date": "2024-11-25T15:00:00.000Z",
            "duration": "36:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/networks-for-ab-testing",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/558-networks-for-ab-testing.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "297075ce-210c-46c0-a9fb-397d923ec2c0",
            "index": 48,
            "title": "Lessons from eGamer Networks",
            "pub_date": "2024-11-18T15:00:00.000Z",
            "duration": "37:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/lessons-from-egamer-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/lessons-from-egamer-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "94f1b8bc-3d9d-4ff4-9227-f01c42e51ef2",
            "index": 49,
            "title": "Github Collaboration Network",
            "pub_date": "2024-11-11T20:49:00.000Z",
            "duration": "42:24",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/github-collaboration-network",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/github-collaboration-network-fixed.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "494900cd-65f6-4d05-904a-efc1e0225e07",
            "index": 50,
            "title": "Graphs and ML for Robotics",
            "pub_date": "2024-11-04T14:00:00.000Z",
            "duration": "41:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/graphs-and-ml-for-robotics",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/graphs-and-ml-for-robotics.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "131ff57d-036e-478c-af3e-96c8b9045a85",
            "index": 51,
            "title": "Graphs for HPC and LLMs",
            "pub_date": "2024-10-29T15:13:00.000Z",
            "duration": "52:08",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/graphs-for-hpc-and-llms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/graphs-for-hpc-and-llms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e4260b92-c5df-4e9b-a70f-ccdaa007a5c5",
            "index": 52,
            "title": "Graph Databases and AI",
            "pub_date": "2024-10-21T13:24:00.000Z",
            "duration": "35:58",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/graph-databases-and-ai",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/graph-database-and-ai.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "37ff3dc4-cff3-4c79-8a25-23a120dcdc49",
            "index": 53,
            "title": "Network Analysis in Practice",
            "pub_date": "2024-10-14T14:45:00.000Z",
            "duration": "29:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/network-analysis-in-practice",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/network-analysis-in-practice.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5afcda57-f94b-4d9a-a61b-52cbfedc761d",
            "index": 54,
            "title": "Animal Intelligence Final Exam",
            "pub_date": "2024-10-07T16:16:00.000Z",
            "duration": "30:18",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/animal-intelligence-final-exam",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/animal-intelligence-final-exam.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d8a780d3-6443-4dc6-84c4-bd8add462e02",
            "index": 55,
            "title": "Process Mining with LLMs",
            "pub_date": "2024-09-24T15:08:00.000Z",
            "duration": "26:24",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "rag",
              "retrieval"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/process-mining-with-llms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/process-mining-with-llms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d604531a-cb92-4117-82fa-3533fb72b320",
            "index": 56,
            "title": "Open Animal Tracks",
            "pub_date": "2024-09-17T16:58:00.000Z",
            "duration": "22:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/open-animal-tracks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/open-animal-tracks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0780ebe3-1fbf-4635-9033-3bcf10800788",
            "index": 57,
            "title": "Bird Distribution Modeling with Satbird",
            "pub_date": "2024-09-10T20:58:00.000Z",
            "duration": "39:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/bird-distribution-modeling-with-satbird",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/bird-distribution-modeling-with-satbird.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b9f1457d-42d5-439f-a5ee-9abcefd83e73",
            "index": 58,
            "title": "Ant Encounters",
            "pub_date": "2024-08-26T14:01:00.000Z",
            "duration": "31:26",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/ant-encounters",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ant-encounters.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7ca4b2b-5732-468c-826f-408d7b6a1784",
            "index": 59,
            "title": "Computing Toolbox",
            "pub_date": "2024-08-19T14:25:00.000Z",
            "duration": "38:44",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/computing-toolbox",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/computing-toolbox.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52af78de-b630-4846-8ebb-7bccd44d563c",
            "index": 60,
            "title": "Biodiversity Monitoring",
            "pub_date": "2024-08-14T02:04:00.000Z",
            "duration": "32:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/biodiversity-monitoring",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/biodiversity-monitoring.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ca89bb35-e197-4045-b310-1c99fd526fb9",
            "index": 61,
            "title": "Hacking the Colony",
            "pub_date": "2024-08-08T15:13:00.000Z",
            "duration": "41:03",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/hacking-the-colony",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/hacking-the-colony.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b616c9d5-7c9d-4781-a4e7-3f61cd94bb92",
            "index": 62,
            "title": "Primate Poses",
            "pub_date": "2024-07-31T20:41:00.000Z",
            "duration": "32:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/primate-poses",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/primate-poses.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b2220127-3211-435b-971e-6907cbdb92de",
            "index": 63,
            "title": "Generating 3D Animals with YouDream",
            "pub_date": "2024-07-23T16:17:00.000Z",
            "duration": "01:00:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "training"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/generating-3d-animals",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/generating-3d-animals.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b4dcddd5-3e99-4336-9e3e-7a2b713239d8",
            "index": 64,
            "title": "Weird Communication",
            "pub_date": "2024-07-15T13:00:00.000Z",
            "duration": "38:29",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/weird-communication",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/weird-communication.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d5f9cda7-0a06-4088-af04-00253c71159b",
            "index": 65,
            "title": "Reducing the Impact of Ship Noise on Marine Mammals",
            "pub_date": "2024-07-01T12:00:00.000Z",
            "duration": "36:18",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/reducing-the-impact-of-ship-noise-on-marine-mammals",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/reducing-the-impact-of-ship-noise-on-marine-mammals.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b90c20f8-bc19-48e4-8a8c-4b4d3479c680",
            "index": 66,
            "title": "Analysis of Unstructured Data",
            "pub_date": "2024-06-28T18:50:00.000Z",
            "duration": "27:00",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/analysis-of-unstructured-data",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/analysis-of-unstructured-data.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cdb32b25-5873-4a03-b6d8-d65bb6b53ede",
            "index": 67,
            "title": "iNaturalist",
            "pub_date": "2024-06-24T20:58:00.000Z",
            "duration": "37:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/inaturalist",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/inaturalist.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "52c0ea20-2abf-43b0-a5a0-1788131a491b",
            "index": 68,
            "title": "Learn to Code",
            "pub_date": "2024-06-18T20:10:00.000Z",
            "duration": "49:31",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "coding"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/learn-to-code",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/learn-to-code.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7c3cc45c-b983-4ced-b275-0a38affc03a9",
            "index": 69,
            "title": "Animal Computer Interaction",
            "pub_date": "2024-06-10T13:19:00.000Z",
            "duration": "42:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/animal-computer-interaction",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/animal-computer-interaction.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "44be68bc-8c61-42f7-ada1-05cb9b153be2",
            "index": 70,
            "title": "Ape Gestures",
            "pub_date": "2024-06-03T13:00:00.000Z",
            "duration": "49:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/ape-gestures",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ape-gestures.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "07c9bd30-289b-4339-9560-4579093b3428",
            "index": 71,
            "title": "Evaluating AI Abilities",
            "pub_date": "2024-05-27T16:06:00.000Z",
            "duration": "49:40",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/evaluating-ai-abilities",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/evaluating-ai-abilities.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ba8c2e40-c1d4-461e-a2e2-f529e0258980",
            "index": 72,
            "title": "HMMs for Behavior",
            "pub_date": "2024-05-20T13:00:00.000Z",
            "duration": "45:11",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/hmm-for-behavior",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/hmm-for-behavior.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "76252e46-902c-4a4a-b264-029abed2fd21",
            "index": 73,
            "title": "Bioinspired Engineering",
            "pub_date": "2024-05-14T15:31:00.000Z",
            "duration": "38:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/bioinspired-engineering",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/bioinspired-engineering.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "66cea78c-3d48-40c1-96ea-31cf1a5fb3f6",
            "index": 74,
            "title": "Modelling Evolution",
            "pub_date": "2024-05-09T02:06:00.000Z",
            "duration": "41:25",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/modelling-evolution",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/modelling-evolution.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3743db4c-a67d-4e0f-b9c7-4c5620f4cb4b",
            "index": 75,
            "title": "Behavioral Genetics",
            "pub_date": "2024-04-30T13:57:00.000Z",
            "duration": "47:15",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/behavioral-genetics",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/behavioral-genetics.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a4ef67b1-b059-4e95-9f74-864c1ccd0021",
            "index": 76,
            "title": "Signal in the Noise",
            "pub_date": "2024-04-25T00:03:00.000Z",
            "duration": "41:58",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/signal-in-the-noise",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/signal-in-the-noise.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f67f740f-e40d-4813-9f42-8851513e5dd8",
            "index": 77,
            "title": "Pose Tracking",
            "pub_date": "2024-04-16T06:59:00.000Z",
            "duration": "50:51",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/pose-tracking",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/pose-tracking.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "db41b32e-e9d5-4b82-b4ea-2bd7b1dd4907",
            "index": 78,
            "title": "Modeling Group Behavior",
            "pub_date": "2024-04-08T13:00:00.000Z",
            "duration": "40:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/modeling-group-behavior",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/modeling-group-behavior.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2ee37533-d3ef-4fa0-a905-bd84bca4984a",
            "index": 79,
            "title": "Advances in Data Loggers",
            "pub_date": "2024-03-25T13:04:00.000Z",
            "duration": "35:34",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/advances-in-data-loggers",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/advances-in-data-loggers.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "998e367f-51fa-493c-9000-1ecf6cbb722c",
            "index": 80,
            "title": "What You Know About Intelligence is Wrong (fixed)",
            "pub_date": "2024-03-20T06:31:00.000Z",
            "duration": "41:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/what-you-know-about-intelligence-is-wrong",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/what-you-know-about-intelligence-is-wrong-fixed.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "91a8f956-1e12-4436-94aa-d7d02025c527",
            "index": 81,
            "title": "Animal Decision Making",
            "pub_date": "2024-03-12T21:55:00.000Z",
            "duration": "37:02",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/animal-decision-making",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/animal-decision-making.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c3917404-66d9-4e77-a5b4-d6cf286e2c74",
            "index": 82,
            "title": "Octopus Cognition",
            "pub_date": "2024-03-08T00:50:00.000Z",
            "duration": "38:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/octopus-cognition",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/octopus-cognition.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95b671ae-1b87-445c-bf4a-7ab892744f46",
            "index": 83,
            "title": "Optimal Foraging",
            "pub_date": "2024-02-28T23:02:00.000Z",
            "duration": "38:27",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/optimal-foraging",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/optimal-foraging.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c09e8792-700e-49fd-8413-52c188baf58c",
            "index": 84,
            "title": "Memory in Chess",
            "pub_date": "2024-02-12T17:33:00.000Z",
            "duration": "48:39",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/memory-in-chess",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/memory-and-chess.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "75217add-f899-4437-95ad-012560e7992d",
            "index": 85,
            "title": "OpenWorm",
            "pub_date": "2024-02-05T23:38:00.000Z",
            "duration": "34:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/openworm",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/openworm.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "841e0477-8172-4ce9-a501-ffa270d10719",
            "index": 86,
            "title": "What the Antlion Knows",
            "pub_date": "2024-01-30T00:13:00.000Z",
            "duration": "41:44",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/what-the-antlion-knows",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/what-the-antlion-knows.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "59e077fe-9454-4d6e-be8a-846fe2ba3aa5",
            "index": 87,
            "title": "AI Roundtable",
            "pub_date": "2024-01-17T21:52:00.000Z",
            "duration": "50:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2024/ai-roundtable",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ai-roundtable.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9c824276-35b6-431b-a410-6ae1a457f347",
            "index": 88,
            "title": "Uncontrollable AI Risks",
            "pub_date": "2023-12-27T19:05:00.000Z",
            "duration": "38:43",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/uncontrollable-ai-risks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/uncontrollable-ai-risks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "272fb31d-0889-4833-92df-0ed1622be088",
            "index": 89,
            "title": "I LLM and You Can Too",
            "pub_date": "2023-12-23T19:51:00.000Z",
            "duration": "23:52",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "llm"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/i-llm-and-you-can-too",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/i-llm-and-you-can-too.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff5a4e45-137d-42ca-86a3-6acbeb42c60a",
            "index": 90,
            "title": "Q&A with Kyle",
            "pub_date": "2023-12-19T04:55:00.000Z",
            "duration": "40:23",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/q-and-a-with-kyle",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/q-and-a-with-kyle.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "027a8efc-ccb2-4783-8b6e-6f3b7e431b84",
            "index": 91,
            "title": "LLMs for Data Analysis",
            "pub_date": "2023-12-12T06:03:00.000Z",
            "duration": "29:00",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "copilot"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/llms-for-data-analysis",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/llms-for-data-analysis.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ec4c7068-7285-454a-bcb7-e8c178d1c39e",
            "index": 92,
            "title": "AI Platforms",
            "pub_date": "2023-12-04T14:33:00.000Z",
            "duration": "33:54",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/ai-platforms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ai-platforms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "71b8eef7-71e7-492e-80c6-fb23d7231cda",
            "index": 93,
            "title": "Deploying LLMs",
            "pub_date": "2023-11-27T18:28:00.000Z",
            "duration": "35:00",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/deploying-llms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/deploying-llms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2b2756fd-19a5-4f94-b810-055134077b71",
            "index": 94,
            "title": "A Survey Assessing Github Copilot",
            "pub_date": "2023-11-20T19:11:00.000Z",
            "duration": "26:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "github copilot",
              "copilot"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/a-survey-assessing-github-copilot",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/a-survey-assessing-github-copilot.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6f07bec1-02fb-4e8f-8c8e-2fe21bb55e1d",
            "index": 95,
            "title": "Program Aided Language Models",
            "pub_date": "2023-11-13T15:00:00.000Z",
            "duration": "32:20",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "coding"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/program-aided-language-models",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/program-aided-language-models.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "34043335-e885-480d-9c82-c7f3703337e2",
            "index": 96,
            "title": "Which Programming Language is ChatGPT Best At",
            "pub_date": "2023-11-06T14:00:00.000Z",
            "duration": "40:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "chatgpt"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/which-programming-language-is-chatgpt-best-at",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/which-programming-language-is-chatgpt-best-at.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "597a3968-679a-4a59-9fcf-aea9fc7cc717",
            "index": 97,
            "title": "GraphText",
            "pub_date": "2023-10-31T18:33:00.000Z",
            "duration": "30:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/graph-text",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/graph-text.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0a28e188-97f1-4ee1-909a-66fa21ee5dd2",
            "index": 98,
            "title": "arXiv Publication Patterns",
            "pub_date": "2023-10-23T17:20:00.000Z",
            "duration": "28:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "llm",
              "openai"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/arxiv-publication-patterns",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/arxiv-publication-patterns.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c7d107ba-d713-425a-90d5-49bd09e73b8e",
            "index": 99,
            "title": "Do LLMs Make Ethical Choices",
            "pub_date": "2023-10-16T13:00:00.000Z",
            "duration": "29:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "safety"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/do-llms-make-ethical-choices",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/do-llms-make-ethical-choices.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95ab416a-8db3-4306-9b78-687272d9d62f",
            "index": 100,
            "title": "Emergent Deception in LLMs",
            "pub_date": "2023-10-09T15:26:00.000Z",
            "duration": "27:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/emergent-deception-in-llms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/emergent-deception-in-llms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fd6baa4b-e6c9-4f00-bb71-68139e232628",
            "index": 101,
            "title": "Agents with Theory of Mind Play Hanabi",
            "pub_date": "2023-10-02T13:58:00.000Z",
            "duration": "38:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "artificial intelligence",
              "agent",
              "agents",
              "reasoning"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/agents-with-theory-of-mind-play-hanabi",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/agents-with-theory-of-mind-play-hanabi.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5023b105-df69-4028-91a7-8c54b87f2ed2",
            "index": 102,
            "title": "LLMs for Evil",
            "pub_date": "2023-09-25T14:00:00.000Z",
            "duration": "26:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/llms-for-evil",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/llms-for-evil.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f1d29325-5481-4ff3-bf97-d15aee026685",
            "index": 103,
            "title": "The Defeat of the Winograd Schema Challenge",
            "pub_date": "2023-09-11T13:33:00.000Z",
            "duration": "31:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "training",
              "reasoning"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/the-defeat-of-the-winograd-schema-challenge",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-defeat-of-the-winograd-schema-challenge.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a5d34de3-c812-4e19-aace-170bb269afb4",
            "index": 104,
            "title": "LLMs in Social Science",
            "pub_date": "2023-09-04T16:25:00.000Z",
            "duration": "34:20",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "chatgpt"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/llms-in-social-science",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/llms-in-social-science.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "35025af9-08b7-4b60-8215-5cd3969e06be",
            "index": 105,
            "title": "LLMs in Music Composition",
            "pub_date": "2023-08-28T13:45:00.000Z",
            "duration": "33:39",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/llms-in-music-composition",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/llms-in-music-composition.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "455d9731-ed3f-47c1-9afd-772d76cb3efd",
            "index": 106,
            "title": "Cuttlefish Model Tuning",
            "pub_date": "2023-08-21T14:38:00.000Z",
            "duration": "27:08",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "training"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/cuddlefish-model-tuning",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/cuddlefish-model-tuning.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d9f5f61e-7073-43ef-a46a-98846f960fcf",
            "index": 107,
            "title": "Which Professions Are Threatened by LLMs",
            "pub_date": "2023-08-15T12:00:00.000Z",
            "duration": "38:48",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/which-professions-are-threatened-by-llms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/which-professions-are-threatened-by-llms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "77f98952-a4f8-41c1-9fdd-1753a845196b",
            "index": 108,
            "title": "Why Prompting is Hard",
            "pub_date": "2023-08-08T17:13:00.000Z",
            "duration": "48:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "llm"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/why-prompting-is-hard",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/why-prompting-is-hard.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d27f1d83-1b1e-499b-b8ba-c51e79a2de23",
            "index": 109,
            "title": "Automated Peer Review",
            "pub_date": "2023-07-31T14:00:00.000Z",
            "duration": "36:07",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/automated-peer-review",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/automated-peer-review.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f49d3c3c-2bf7-4500-9cfb-0e38dfcde9a7",
            "index": 110,
            "title": "Prompt Refusal",
            "pub_date": "2023-07-24T13:00:00.000Z",
            "duration": "44:18",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/prompt-refusal",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/prompt-refusal.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19f26ee1-1187-4476-aa6f-60e8444a0457",
            "index": 111,
            "title": "A Long Way Till AGI",
            "pub_date": "2023-07-18T11:00:00.000Z",
            "duration": "37:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/a-long-way-till-agi",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/a-long-way-till-agi.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9e7d4b48-4200-400d-8c59-f1e1fac35762",
            "index": 112,
            "title": "Brain Inspired AI",
            "pub_date": "2023-07-11T00:45:00.000Z",
            "duration": "36:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence",
              "agi",
              "alignment"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/brain-inspired-ai",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/brain-inspired-ai.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "527ca77d-bae0-40e3-b088-37a76d46c129",
            "index": 113,
            "title": "Computable AGI",
            "pub_date": "2023-07-03T13:00:00.000Z",
            "duration": "36:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "agi"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/computable-agi",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/computable-agi.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1d02acb7-9011-4f1e-8b5c-36847266a290",
            "index": 114,
            "title": "AGI Can Be Safe",
            "pub_date": "2023-06-26T20:09:00.000Z",
            "duration": "45:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "safety"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/agi-can-be-safe",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/agi-can-be-safe.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "60111f23-17a2-45bd-8027-f1e4755ba1d5",
            "index": 115,
            "title": "AI Fails on Theory of Mind Tasks",
            "pub_date": "2023-06-19T16:35:00.000Z",
            "duration": "52:21",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/ai-fails-on-theory-of-mind-tasks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ai-fails-on-theory-of-mind-tasks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5b0efc9d-4a25-4782-ba27-8cc7e7b89c69",
            "index": 116,
            "title": "AI for Mathematics Education",
            "pub_date": "2023-06-12T13:00:00.000Z",
            "duration": "35:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/ai-for-mathematics-education",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ai-for-mathematics-education.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "21d85153-858d-4105-8a93-2caa9e3934a2",
            "index": 117,
            "title": "Evaluating Jokes with LLMs",
            "pub_date": "2023-06-06T16:06:00.000Z",
            "duration": "43:11",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/evaluating-jokes-with-llms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/evaluating-jokes-with-llms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "21f0516c-04d4-4646-9a28-7e4757473492",
            "index": 118,
            "title": "Why Machines Will Never Rule the World",
            "pub_date": "2023-05-29T22:17:00.000Z",
            "duration": "55:15",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/why-machines-will-never-rule-the-world",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/why-machines-will-never-rule-the-world.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3317deb2-00dc-4b74-a62a-bd753eaa8bea",
            "index": 119,
            "title": "A Psychopathological Approach to Safety in AGI",
            "pub_date": "2023-05-23T06:59:00.000Z",
            "duration": "49:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "agi",
              "agents",
              "training",
              "safety"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/a-psychopathological-approach-to-safety-in-agi",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/a-psychopathological-approach-to-safety-in-agi.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "cbe91e58-d664-4c43-b88f-d58491fae2b5",
            "index": 120,
            "title": "The NLP Community Metasurvey",
            "pub_date": "2023-05-15T13:00:00.000Z",
            "duration": "49:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/the-nlp-community-metasurvey",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-nlp-community-metasurvey.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a535b17f-06a3-4547-a7e6-a4e285b6564a",
            "index": 121,
            "title": "Skeptical Survey Interpretation",
            "pub_date": "2023-05-10T00:10:00.000Z",
            "duration": "21:39",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/skeptical-survey-interpretation",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/skeptical-survey-interpretation.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c121119b-8ecd-42b0-b5af-da690a34f510",
            "index": 122,
            "title": "The Gallup Poll",
            "pub_date": "2023-05-01T16:49:00.000Z",
            "duration": "40:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/the-gallup-poll",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-gallup-poll.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da6a8683-11cb-446b-b043-32599cd51ab2",
            "index": 123,
            "title": "Inclusive Study Group Formation at Scale",
            "pub_date": "2023-04-25T04:34:00.000Z",
            "duration": "32:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/inclusive-study-group-formation-at-scale",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/inclusive-study-group-formation-at-scale.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b26e5807-aa08-458b-b0e2-22cb49fe04a2",
            "index": 124,
            "title": "The PhilPapers Survey",
            "pub_date": "2023-04-21T18:51:00.000Z",
            "duration": "31:36",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/the-phil-papers-survey",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-phil-papers-survey.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3690e991-ffe1-425b-9040-8ee11e0ccbd5",
            "index": 125,
            "title": "Non-Response Bias",
            "pub_date": "2023-04-10T17:00:00.000Z",
            "duration": "35:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/non-response-bias",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/non-response-bias.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d0f35309-37d4-4136-af1c-6aca2eb7b811",
            "index": 126,
            "title": "Measuring Trust in Robots with Likert Scales",
            "pub_date": "2023-04-03T18:05:00.000Z",
            "duration": "47:24",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/measuring-trust-in-robots-with-likert-scales",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/measuring-trust-in-robots-with-likert-scales.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d630c431-b315-4a8e-9247-5eee7353efe5",
            "index": 127,
            "title": "CAREER Prediction",
            "pub_date": "2023-03-27T15:36:00.000Z",
            "duration": "40:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/career-prediction",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/career-prediction.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "204ad2b7-96ad-494c-9e6b-4f7400533e21",
            "index": 128,
            "title": "The Panel Study of Income Dynamics",
            "pub_date": "2023-03-21T06:13:00.000Z",
            "duration": "34:03",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/the-panel-study-of-income-dynamics",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-panel-study-of-income-dynamics.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "921766e9-115c-4151-a1cd-45c461fced0b",
            "index": 129,
            "title": "Survey Design Working Session",
            "pub_date": "2023-03-14T18:10:00.000Z",
            "duration": "01:01:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/survey-design-working-session",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/survey-design-working-session.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04076c39-6e5f-4463-8fa2-379304081e2a",
            "index": 130,
            "title": "Bot Detection and Dyadic Surveys",
            "pub_date": "2023-03-06T18:08:00.000Z",
            "duration": "35:24",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/bot-detection-and-dyadic-surveys",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/bot-detection-and-dyadic-surveys.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11eac5c2-ca6f-4ce2-af51-15865484343d",
            "index": 131,
            "title": "Reproducible ESP Testing",
            "pub_date": "2023-02-20T14:00:00.000Z",
            "duration": "47:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/reproducible-esp-testing",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/reproducible-esp-testing.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0cbfcb95-04ab-43b0-8c9d-f0bfc50404ba",
            "index": 132,
            "title": "A Survey of Data Science Methodologies",
            "pub_date": "2023-02-13T17:43:00.000Z",
            "duration": "24:58",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/a-survey-of-data-science-methodologies",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/a-survey-of-data-science-methodologies.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f9f12874-e14e-4065-9043-6a9c4228bf6f",
            "index": 133,
            "title": "Opinion Dynamics Models",
            "pub_date": "2023-02-06T20:17:00.000Z",
            "duration": "35:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/opinion-dynamics-models",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/opinion-dynamics-models.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "833b3a34-f67a-421d-86f5-4d0503d084b7",
            "index": 134,
            "title": "Casual Affective Triggers",
            "pub_date": "2023-01-30T19:58:00.000Z",
            "duration": "35:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/casual-affective-triggers",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/causal-affective-triggers.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "11c954f4-73ee-4ae8-b4e4-ccebc508e137",
            "index": 135,
            "title": "Conversational Surveys",
            "pub_date": "2023-01-23T14:00:00.000Z",
            "duration": "39:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/conversational-surveys",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/conversational-surveys.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1c0f24b4-4f09-4284-b886-17685c3d9ae8",
            "index": 136,
            "title": "Do Results Generalize for Privacy and Security Surveys",
            "pub_date": "2023-01-17T20:39:00.000Z",
            "duration": "40:21",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/do-results-generalize-for-privacy-and-security-surveys",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/do-results-generalize-for-privacy-and-security-surveys.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "73b271d8-8991-471b-8f20-975d10faa5e9",
            "index": 137,
            "title": "4 out of 5 Data Scientists Agree",
            "pub_date": "2023-01-10T16:46:00.000Z",
            "duration": "28:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2023/4-out-of-5-data-scientists-agree",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/4-out-of-5-data-scientists-agree.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0a931026-6398-4f26-96c2-17492f076011",
            "index": 138,
            "title": "Crowdfunded Board Games",
            "pub_date": "2022-12-26T14:00:00.000Z",
            "duration": "34:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/crowdfunded-board-games",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/crowdfunded-board-games.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "2fedffdb-d8e4-4305-9bb6-56b9156c1dc3",
            "index": 139,
            "title": "Russian Election Interference Effectiveness",
            "pub_date": "2022-12-19T14:05:00.000Z",
            "duration": "41:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/russian-election-interference-effectiveness",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/russian-election-interference-effectiveness.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9c7c655-743e-43ce-8f31-c7ca7df37e3b",
            "index": 140,
            "title": "Placement Laundering Fraud",
            "pub_date": "2022-12-15T17:38:00.000Z",
            "duration": "32:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/placement-laundering-fraud",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/placement-laundering-fraud.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5cb3e69d-5b04-4d78-a9cc-2611b65a3616",
            "index": 141,
            "title": "Data Clean Rooms",
            "pub_date": "2022-12-12T17:54:00.000Z",
            "duration": "31:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/data-clean-rooms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/data-clean-rooms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da221fcf-4334-4478-b569-0d511c77a05b",
            "index": 142,
            "title": "Dark Patterns in Site Design",
            "pub_date": "2022-12-05T17:04:00.000Z",
            "duration": "34:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/dark-patterns-in-site-design",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/dark-patterns-in-site-design.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "76a2248a-7931-4f08-9b18-5b6e43bdc1ec",
            "index": 143,
            "title": "Internet Advertising Bureau Media Lab",
            "pub_date": "2022-12-03T17:19:00.000Z",
            "duration": "37:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/internet-advertising-bureau-media-lab",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/internet-advertising-bureau-media-lab.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "946b7dea-a651-4339-8f29-25dd68f78993",
            "index": 144,
            "title": "Your Mouse Reveals Your Gender and Age",
            "pub_date": "2022-11-28T14:00:00.000Z",
            "duration": "39:47",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/your-mouse-reveals-your-gender-and-age",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/your-mouse-reveals-your-gender-and-age.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "943c8e48-b532-45f4-90fc-beaf223d060f",
            "index": 145,
            "title": "Measuring Web Search Behavior",
            "pub_date": "2022-11-21T15:56:00.000Z",
            "duration": "36:08",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/measuring-web-search-behavior",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/measuring-web-search-behavior.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5bf75235-fea8-4b1c-ad09-84a17ecc4c50",
            "index": 146,
            "title": "StrategyQA and Big Bench",
            "pub_date": "2022-11-18T03:39:00.000Z",
            "duration": "41:56",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "artificial intelligence",
              "reasoning"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/big-bench",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/big-bench.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d7747453-d159-4f6a-864e-9b4571f235d8",
            "index": 147,
            "title": "Ad Blockers Effect on News Consumption",
            "pub_date": "2022-11-14T16:17:00.000Z",
            "duration": "38:59",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/ad-blockers-effect-on-news-consumption",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ad-blockers-effect-on-news-consumption.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bb91dacf-4b09-4430-9e16-ddea9c8bcd31",
            "index": 148,
            "title": "Your Consent is Worth 75 Euros a Year",
            "pub_date": "2022-11-07T15:00:00.000Z",
            "duration": "24:04",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/your-consent-is-worth-75-euros-a-year",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/your-consent-is-worth-75-euros-a-year.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "32ff71b1-9882-40fa-b545-3a89335bb3c1",
            "index": 149,
            "title": "Automated Email Generation for Targeted Attacks",
            "pub_date": "2022-10-31T15:52:00.000Z",
            "duration": "45:06",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/automated-email-generation-for-targeted-attacks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/automated-email-generation-for-targeted-attacks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e8d3ed3b-8256-49cd-b9a6-0ff042d933a0",
            "index": 150,
            "title": "Tribal Marketing",
            "pub_date": "2022-10-24T15:33:00.000Z",
            "duration": "37:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/tribal-marketing",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/tribal-marketing.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "95918bcd-b68a-4ded-bceb-fa15059da23a",
            "index": 151,
            "title": "Nano-targetted Facebook Ads",
            "pub_date": "2022-10-17T12:55:00.000Z",
            "duration": "44:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/nano-targetted-facebook-ads",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/nano-targetted-facebook-ads.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "be1e64c4-f746-4c6c-8c91-df8e55f8e3ff",
            "index": 152,
            "title": "Debiasing GPT-3 Job Ads",
            "pub_date": "2022-10-10T13:00:00.000Z",
            "duration": "48:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/debiasing-gpt3-job-ads",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/debiasing-gpt3-job-ads.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d253bba0-a012-4e08-8ad2-8e60e22027fc",
            "index": 153,
            "title": "ML Ops in Production",
            "pub_date": "2022-10-06T21:03:00.000Z",
            "duration": "41:58",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/ml-ops-in-production",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ml-ops-in-production.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6805395c-8bc4-4b94-9eef-2d177ea37547",
            "index": 154,
            "title": "Ad Network Tomography",
            "pub_date": "2022-10-03T13:00:00.000Z",
            "duration": "35:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/ad-network-tomography",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ad-network-tomography.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "58921f7e-3cf6-4afc-89d9-144aba4726a8",
            "index": 155,
            "title": "First Party Tracking Cookies",
            "pub_date": "2022-09-26T13:00:15.000Z",
            "duration": "35:06",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/first-party-tracking-cookies",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/first-party-tracking-cookies.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1bde98ee-a807-47ae-889a-12f94a02caef",
            "index": 156,
            "title": "The Harms of Targeted Weight Loss Ads",
            "pub_date": "2022-09-19T13:00:43.000Z",
            "duration": "34:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/the-harms-of-targeted-weight-loss-ads",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-harms-of-targeted-weight-loss-ads.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fa7e8ac0-ddfe-4cd2-983a-a7b3c3f823da",
            "index": 157,
            "title": "Podcast Advertising",
            "pub_date": "2022-09-12T13:00:30.000Z",
            "duration": "35:05",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/podcast-advertising",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/podcast-advertising.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ccd88d46-5f21-4b5a-92b5-ee6e144559cf",
            "index": 158,
            "title": "Fairness in e-Commerce Search",
            "pub_date": "2022-09-05T14:41:25.000Z",
            "duration": "40:46",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/fairness-in-e-commerce-search",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fairness-in-e-commerce-search.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4c9c0c0d-119e-4489-88a2-7a46f9946bc6",
            "index": 159,
            "title": "Fraudulent Amazon Reviewers",
            "pub_date": "2022-08-29T13:00:57.000Z",
            "duration": "41:18",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/fraudulent-amazon-reviewers",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fraudulent-amazon-reviewers.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bd5f607d-ad09-4e7a-b6c6-4b0b29ab37cd",
            "index": 160,
            "title": "Ad Targeting in Amazon Smart Speakers",
            "pub_date": "2022-08-22T13:14:12.000Z",
            "duration": "32:40",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/ad-targeting-in-amazon-smart-speakers",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ad-targeting-in-amazon-smart-speakers.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "17ddadeb-c20e-4089-87e1-111b6c3ddff8",
            "index": 161,
            "title": "Adwords with Unknown Budgets",
            "pub_date": "2022-08-15T13:00:39.000Z",
            "duration": "34:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/adwords-with-unknown-budgets",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/adwords-with-unknown-budgets.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "43cb7bb8-f02f-4c15-8b6f-129ba5dcc692",
            "index": 162,
            "title": "ML Ops Best Practices",
            "pub_date": "2022-08-12T12:00:46.000Z",
            "duration": "30:12",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/ml-ops-best-practices",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ml-ops-best-practices.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "65756cc3-3b4e-427b-923d-5d71d214fd04",
            "index": 163,
            "title": "Affiliate Marketing Rabbithole",
            "pub_date": "2022-08-08T12:46:04.000Z",
            "duration": "52:20",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/affiliate-marketing-rabbithole",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/affiliate-marketing-rabbithole.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "bcb78437-01f8-4e5d-ab53-8e2a7aadcd55",
            "index": 164,
            "title": "Monetization of Youtube Conspiracy Theorists",
            "pub_date": "2022-08-01T13:00:34.000Z",
            "duration": "54:06",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/monetization-of-youtube-conspiracy-theorists",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/monetization-of-youtube-conspiracy-theorists.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "360036d3-74a6-4d80-945d-46a011e54547",
            "index": 165,
            "title": "User Perceptions of Problematic Ads",
            "pub_date": "2022-07-25T13:00:42.000Z",
            "duration": "37:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/user-perceptions-of-problematic-ads",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/user-perceptions-of-problematic-ads.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f8863cfb-25b2-4c5c-918c-9974b91a97d2",
            "index": 166,
            "title": "Political Digital Advertising Analysis",
            "pub_date": "2022-07-21T18:15:14.000Z",
            "duration": "35:35",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/political-digital-advertising-analysis",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/political-digital-advertising-analysis.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b01f6df-9d33-4edc-bb14-73ab9ebb0d55",
            "index": 167,
            "title": "Fraud Detection in Crowdfunding Campaigns",
            "pub_date": "2022-07-18T15:13:04.000Z",
            "duration": "35:47",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/fraud-detection-in-crowdfunding-campaigns",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fraud-detection-in-crowdfunding-campaigns.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5795674e-7f1f-411b-b4c4-21c15efa3977",
            "index": 168,
            "title": "Artificial Intelligence and Auction Design",
            "pub_date": "2022-07-11T12:59:04.000Z",
            "duration": "43:13",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "artificial intelligence"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/artificial-intelligence-and-auction-design",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/artificial-intelligence-and-auction-design.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3fb69345-138c-4a1a-9888-2d1a7c3f910b",
            "index": 169,
            "title": "Privacy Preference Signals",
            "pub_date": "2022-07-04T13:00:16.000Z",
            "duration": "33:28",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/privacy-preference-signals",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/privacy-preference-signals.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7eee2332-388f-42d8-b383-f0cb331ca2cd",
            "index": 170,
            "title": "Neural Architecture Search for CTR Prediction",
            "pub_date": "2022-06-27T15:19:09.000Z",
            "duration": "28:02",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/neural-architecture-search-for-ctr-prediction",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/neural-architecture-search-for-ctr-prediction.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "27844797-5bc1-404c-90ed-c205d550986d",
            "index": 171,
            "title": "Algorithmic PPC Management",
            "pub_date": "2022-06-21T22:10:26.000Z",
            "duration": "43:56",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/algorithmic-ppc-management",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/algorithmic-ppc-management.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7a975410-ca54-470d-a30a-ac1439a5c0f5",
            "index": 172,
            "title": "Data Skeptic: Ad Tech",
            "pub_date": "2022-06-18T03:44:53.000Z",
            "duration": "42:24",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/ad-tech",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ad-tech.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b8290d54-cc39-43b6-bef8-84de261be82e",
            "index": 173,
            "title": "The Reliability of Mobile Phone Data",
            "pub_date": "2022-06-13T05:31:59.000Z",
            "duration": "49:32",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/the-reliability-of-mobile-phone-data",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-reliability-of-mobile-phone-data.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "860af144-c74d-4d8f-8630-a3e78d64f1ee",
            "index": 174,
            "title": "Haywire Algorithms",
            "pub_date": "2022-06-06T13:00:41.000Z",
            "duration": "33:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/haywire-algorithms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/haywire-algorithms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c5c3f37-405d-4025-8b5f-7114d7194587",
            "index": 175,
            "title": "School Reopening Analysis",
            "pub_date": "2022-05-30T14:00:39.000Z",
            "duration": "33:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/school-reopening-analysis",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/school-reopening-analysis.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "390f1101-9ca5-4f1c-8dae-e023b8c5cd81",
            "index": 176,
            "title": "Modern Data Stacks",
            "pub_date": "2022-05-26T14:00:45.000Z",
            "duration": "34:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/modern-data-stacks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/modern-data-stacks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4f648ef2-f0ac-4180-8e73-bdc7acc485d0",
            "index": 177,
            "title": "Emoji as a Predictor",
            "pub_date": "2022-05-23T14:25:34.000Z",
            "duration": "21:25",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/emoji-as-a-predictor",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/emoji-as-a-predictor.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "63ab8f67-9681-427e-a81f-64690e8a615d",
            "index": 178,
            "title": "Polarizing Trends in the Gig Economy",
            "pub_date": "2022-05-16T13:39:43.000Z",
            "duration": "46:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/polarizing-trends-in-the-gig-economy",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/polarizing-trends-in-the-gig-economy.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4a9f3bd6-f25e-4023-a899-94068924deb2",
            "index": 179,
            "title": "Remote Learning in Applied Engineering",
            "pub_date": "2022-05-12T12:29:25.000Z",
            "duration": "25:15",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/remote-learning-in-applied-engineering",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/remote-learning-in-applied-engineering.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1f5180c8-d360-4df6-af1f-16a7bbbf1bcd",
            "index": 180,
            "title": "Remote Productivity",
            "pub_date": "2022-05-09T12:45:44.000Z",
            "duration": "29:48",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/remote-productivity",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/remote-productivity.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "19a759cb-dd12-4292-8477-1f7bbbbbf3af",
            "index": 181,
            "title": "Does Remote Learning Work?",
            "pub_date": "2022-05-01T13:00:50.000Z",
            "duration": "48:10",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/does-remote-learning-work",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/does-remote-learning-work.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fbc58a39-200f-490b-9278-bc7f5131e218",
            "index": 182,
            "title": "Covid-19 Impact on Bicycle Usage",
            "pub_date": "2022-04-25T12:46:50.000Z",
            "duration": "31:12",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/covid-19-impact-on-bicycle-usage",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/covid-19-impact-on-bicycle-usage.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c131d65-e6ab-41d0-8565-ee3c2ea2fcf9",
            "index": 183,
            "title": "Learning Digital Fabrication Remotely",
            "pub_date": "2022-04-22T11:55:41.000Z",
            "duration": "33:31",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/learning-digital-fabrication-remotely",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/learning-digital-fabrication-remotely.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4721d0b5-adfb-42b3-9fa4-4fca5522a1f0",
            "index": 184,
            "title": "Remote Software Development",
            "pub_date": "2022-04-18T16:49:08.000Z",
            "duration": "37:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/remote-software-development",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/remote-software-development.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c146a421-8478-4fd8-997c-82579ae8bcad",
            "index": 185,
            "title": "Quantum K-Means",
            "pub_date": "2022-04-11T13:00:00.000Z",
            "duration": "39:52",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/quantum-k-means",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/quantum-k-means.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8135f8ed-a257-4a3d-9565-12f151a3756d",
            "index": 186,
            "title": "K-Means in Practice",
            "pub_date": "2022-04-04T13:00:37.000Z",
            "duration": "30:41",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/k-means-in-practice",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/k-means-in-practice.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8eae9047-9691-4af5-965c-754e8ac79b93",
            "index": 187,
            "title": "Fair Hierarchical Clustering",
            "pub_date": "2022-03-28T13:23:25.000Z",
            "duration": "34:26",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/fair-hierarchical-clustering",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fair-hierarchical-clustering.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "721ad75a-5240-4d4c-a273-762ab4675e5c",
            "index": 188,
            "title": "Matrix Factorization For k-Means",
            "pub_date": "2022-03-21T13:00:46.000Z",
            "duration": "30:07",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/matrix-factorization-for-k-means",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/matrix-factorization-for-k-means.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0b9d687e-9eef-4a69-8ea3-9bbc85d725a1",
            "index": 189,
            "title": "Breathing K-Means",
            "pub_date": "2022-03-14T13:00:15.000Z",
            "duration": "42:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/breathing-k-means",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/breathing-k-means.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d918b45d-2262-471e-84a3-2afc306b4511",
            "index": 190,
            "title": "Power K-Means",
            "pub_date": "2022-03-07T14:00:15.000Z",
            "duration": "32:38",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/power-k-means",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/power-k-means.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9782813d-d7c0-4fea-a52a-8cf70d501356",
            "index": 191,
            "title": "Explainable K-Means",
            "pub_date": "2022-03-03T14:17:44.000Z",
            "duration": "25:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/explainable-k-means",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/explainable-k-means.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f6cdf71a-baeb-4ba9-9591-d25469418895",
            "index": 192,
            "title": "Customer Clustering",
            "pub_date": "2022-02-28T14:00:00.000Z",
            "duration": "22:03",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/customer-clustering",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/customer-clustering.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aabcc384-d247-4bbf-979b-4ff0550e2932",
            "index": 193,
            "title": "k-means Image Segmentation",
            "pub_date": "2022-02-22T00:00:49.000Z",
            "duration": "23:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/k-means-image-segmentation",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/k-means-image-segmentation.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "27921b40-c0d9-4d00-8651-5e3ad7bf8034",
            "index": 194,
            "title": "Tracking Elephant Clusters",
            "pub_date": "2022-02-18T22:43:00.000Z",
            "duration": "26:27",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/tracking-elephant-clusters",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/tracking-elephant-clusters.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "eccbc657-0bb0-4cdb-a7b4-761a206bea27",
            "index": 195,
            "title": "k-means clustering",
            "pub_date": "2022-02-14T16:44:49.000Z",
            "duration": "24:22",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/k-means-clustering",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/k-means-clustering.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9cfca113-b85c-45e3-93ef-6cc56093fdd0",
            "index": 196,
            "title": "Snowflake Essentials",
            "pub_date": "2022-02-07T14:00:53.000Z",
            "duration": "46:43",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/snowflake-essentials",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/snowflake-essentials.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1c05f3f0-f923-4ca8-87c8-239fc5734c28",
            "index": 197,
            "title": "Explainable Climate Science",
            "pub_date": "2022-01-31T16:24:01.000Z",
            "duration": "34:50",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/explainable-climate-science",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/explainable-climate-science.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1666c574-03eb-4334-8bdf-ae01089267b1",
            "index": 198,
            "title": "Energy Forecasting Pipelines",
            "pub_date": "2022-01-24T14:00:00.000Z",
            "duration": "43:21",
            "duration_label": "",
            "selected": true,
            "confidence": "candidate",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/energy-forecasting-pipelines",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/energy-forecasting-pipelines.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3c67313d-1eb3-4773-93d2-bbb1d23c68d6",
            "index": 199,
            "title": "Matrix Profiles in Stumpy",
            "pub_date": "2022-01-17T14:00:00.000Z",
            "duration": "39:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/matrix-profiles-in-stumpy",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/matrix-profiles-in-stumpy.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3253aaa9-9ab2-4993-8685-4daddc85f73d",
            "index": 200,
            "title": "The Great Australian Prediction Project",
            "pub_date": "2022-01-14T02:30:00.000Z",
            "duration": "25:19",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/the-great-australian-prediction-project",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-great-australian-prediction-project.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "536e04c8-9d44-4410-bf46-c21c1b638df0",
            "index": 201,
            "title": "Water Demand Forecasting",
            "pub_date": "2022-01-10T17:30:44.000Z",
            "duration": "26:00",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2022/water-demand-forecasting",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/water-demand-forecasting.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0afca517-c107-435c-b6e2-47dd203b4417",
            "index": 202,
            "title": "Open Telemetry",
            "pub_date": "2022-01-03T14:00:00.000Z",
            "duration": "36:18",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/open-telemetry",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/open-telemetry.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "154cb9c1-a602-40f8-bfce-7cd3ace54bbc",
            "index": 203,
            "title": "Fashion Predictions",
            "pub_date": "2021-12-27T14:00:00.000Z",
            "duration": "34:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/fashion-predictions",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fashion-predictions.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3bb355f0-e829-4cbc-aaf1-106e69f999f2",
            "index": 204,
            "title": "Time Series Mini Episodes",
            "pub_date": "2021-12-25T08:02:09.000Z",
            "duration": "36:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/time-series-mini-episodes",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/time-series-mini-episodes.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "94acd2f8-43f2-4711-8547-5e7b292326d3",
            "index": 205,
            "title": "Forecasting Motor Vehicle Collision",
            "pub_date": "2021-12-20T14:00:00.000Z",
            "duration": "39:12",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/forecasting-motor-vehicle-collision-rates",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/forecasting-motor-vehicle-collision-rates.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "41f50ce2-bc02-41b5-adf4-196ff081ed4d",
            "index": 206,
            "title": "Deep Learning for Road Traffic Forecasting",
            "pub_date": "2021-12-13T14:00:00.000Z",
            "duration": "31:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/deep-learning-for-road-traffic-forecasting",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/deep-learning-for-road-traffic-forecasting.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7a76204c-15a2-488f-8a0a-35cafc95c8f7",
            "index": 207,
            "title": "Bike Share Demand Forecasting",
            "pub_date": "2021-12-06T14:00:00.000Z",
            "duration": "40:41",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/bike-share-demand-forecasting",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/bike-share-demand-forecasting.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a571c83-26db-41c6-affd-9aa31ddd88ad",
            "index": 208,
            "title": "Forecasting in Supply Chain",
            "pub_date": "2021-11-29T14:00:00.000Z",
            "duration": "36:05",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/forecasting-in-supply-chain",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/forecasting-in-supply-chain.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f5aba4c-bb70-4c33-9ecb-cc72d3fa43db",
            "index": 209,
            "title": "Black Friday",
            "pub_date": "2021-11-26T15:24:50.000Z",
            "duration": "44:55",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/black-friday",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/black-friday.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "79a5ec5c-a8cf-4945-80ae-05e8ca4e7b56",
            "index": 210,
            "title": "Aligning Time Series on Incomparable Spaces",
            "pub_date": "2021-11-22T14:00:00.000Z",
            "duration": "33:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/aligning-time-series-on-incomparable-spaces",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/aligning-time-series-on-incomparable-spaces.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "46625701-2f42-4cad-bda9-d8b381f28e72",
            "index": 211,
            "title": "Comparing Time Series with HCTSA",
            "pub_date": "2021-11-15T14:01:04.000Z",
            "duration": "42:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/comparing-time-series-with-hctsa",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/comparing-time-series-with-hctsa.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0f996b11-445d-4fe9-bfb8-18e6e6da172b",
            "index": 212,
            "title": "Change Point Detection Algorithms",
            "pub_date": "2021-11-08T14:14:45.000Z",
            "duration": "30:49",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/change-point-detection-algorithms",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/change-point-detection-algorithms.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8b6d0370-6581-4b1a-8935-a0b3ff66511d",
            "index": 213,
            "title": "Time Series for Good",
            "pub_date": "2021-11-01T13:00:00.000Z",
            "duration": "37:42",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/time-series-for-good",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/time-series-for-good.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4be7a67-9c5c-43d4-9d8a-bac0ff53d4f5",
            "index": 214,
            "title": "Long Term Time Series Forecasting",
            "pub_date": "2021-10-25T13:00:00.000Z",
            "duration": "37:45",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/long-term-time-series-forecasting",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/long-term-time-series-forecasting.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "02e0a78c-1056-4bc2-bb6f-2f0461b70236",
            "index": 215,
            "title": "Fast and Frugal Time Series Forecasting",
            "pub_date": "2021-10-17T20:13:49.000Z",
            "duration": "37:30",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/fast-and-frugal-time-series-forecasting",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fast-and-frugal-time-series-forecasting.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4858f0b8-7955-45e6-bf3c-a2009d97ca16",
            "index": 216,
            "title": "Causal Inference in Educational Systems",
            "pub_date": "2021-10-11T13:00:00.000Z",
            "duration": "41:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "inference"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/causal-inference-in-educational-systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/causal-inference-in-educational-systems.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9b5cf0e3-39f7-4fba-bc8b-2babe74bc651",
            "index": 217,
            "title": "Boosted Embeddings for Time Series",
            "pub_date": "2021-10-04T13:00:00.000Z",
            "duration": "28:59",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "embeddings"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/boosted-embeddings-for-time-series",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/boosted-embeddings-for-time-series.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d624e548-1210-402f-9f1d-0edecfb401b9",
            "index": 218,
            "title": "Change Point Detection in Continuous Integration Systems",
            "pub_date": "2021-09-27T13:00:00.000Z",
            "duration": "33:37",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/change-point-detection-in-continuous-integration-systems",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/change-point-detection-in-continuous-integration-systems.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ffbda165-35bd-43d8-a716-264d45596e23",
            "index": 219,
            "title": "Applying k-Nearest Neighbors to Time Series",
            "pub_date": "2021-09-20T13:00:00.000Z",
            "duration": "24:09",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/applying-k-nearest-neighbors-to-time-series",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/applying-k-nearest-neighbors-to-time-series.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a56cb2e4-764d-4d00-a09b-43e1d71e46b7",
            "index": 220,
            "title": "Ultra Long Time Series",
            "pub_date": "2021-09-13T13:00:00.000Z",
            "duration": "28:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/ultra-long-time-series",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/ultra-long-time-series.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c5b56597-2302-4ec4-bf7c-26977f6adb6e",
            "index": 221,
            "title": "MiniRocket",
            "pub_date": "2021-09-06T13:00:00.000Z",
            "duration": "25:31",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/minirocket",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/minirocket.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dcf86747-5f14-4acd-aea2-d117c37e34b3",
            "index": 222,
            "title": "ARiMA is not Sufficient",
            "pub_date": "2021-08-30T13:00:00.000Z",
            "duration": "22:35",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/arima-is-not-sufficient",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/arima-is-not-sufficient.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9153fc96-80c3-4088-9a4a-b870a0fb218e",
            "index": 223,
            "title": "Comp Engine",
            "pub_date": "2021-08-23T13:00:00.000Z",
            "duration": "36:04",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/comp-engine",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/comp-engine.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ccb998a8-79b3-4cc6-8d10-ebd51593eab4",
            "index": 224,
            "title": "Detecting Ransomware",
            "pub_date": "2021-08-16T13:00:00.000Z",
            "duration": "31:23",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/detecting-ransomware",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/detecting-ransomware.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2f6023a-74a5-4100-b989-65e225441542",
            "index": 225,
            "title": "GANs in Finance",
            "pub_date": "2021-08-09T13:00:00.000Z",
            "duration": "23:08",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/gans-in-finance",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/gans-in-finance.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "9ba1d23d-9390-44e0-a466-2e63c99d706c",
            "index": 226,
            "title": "Predicting Urban Land Use",
            "pub_date": "2021-08-02T13:00:00.000Z",
            "duration": "27:06",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/predicting-urban-land-use",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/predicting-urban-land-use.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d99e53b2-9028-4683-a0c1-a7008705402b",
            "index": 227,
            "title": "Opportunities for Skillful Weather Prediction",
            "pub_date": "2021-07-26T13:00:00.000Z",
            "duration": "34:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/opportunities-for-skillful-weather-prediction",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/opportunities-for-skillful-weather-prediction.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7170ceb7-9ad0-4745-a57b-f6b0c3a042be",
            "index": 228,
            "title": "Predicting Stock Prices",
            "pub_date": "2021-07-19T13:00:56.000Z",
            "duration": "34:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/predicting-stock-prices",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/predicting-stock-prices.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1ea17766-4fc0-475a-b2f1-5e5ff2096aab",
            "index": 229,
            "title": "N-Beats",
            "pub_date": "2021-07-12T15:04:59.000Z",
            "duration": "34:15",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/nbeats",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/nbeats.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "5f1d5951-e943-4d37-9552-16d027c8b825",
            "index": 230,
            "title": "Translation Automation",
            "pub_date": "2021-07-06T01:48:52.000Z",
            "duration": "36:07",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "ai",
              "a.i.",
              "automation"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/translation-automation",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/translation-automation.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac8deaef-10de-4ac5-966c-3b6d0b19ae39",
            "index": 231,
            "title": "Time Series at the Beach",
            "pub_date": "2021-06-28T13:00:00.000Z",
            "duration": "23:01",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/time-series-at-the-beach",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/time-series-at-the-beach.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8d1dde9f-b60a-4d1a-8e16-e8e06dc0b720",
            "index": 232,
            "title": "Automatic Identification of Outlier Galaxy Images",
            "pub_date": "2021-06-21T19:11:19.000Z",
            "duration": "36:19",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/automatic-identification-of-outlier-galaxy-images",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/automatic-identification-of-outlier-galaxy-images.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "de6588fe-bc89-4f87-8a33-6212c6673d56",
            "index": 233,
            "title": "Do We Need Deep Learning in Time Series",
            "pub_date": "2021-06-16T16:10:45.000Z",
            "duration": "29:19",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/do-we-need-deep-learning-in-time-series",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/do-we-need-deep-learning-in-time-series.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0677c67b-f5ee-4056-b8e0-4189924b6c0e",
            "index": 234,
            "title": "Detecting Drift",
            "pub_date": "2021-06-11T00:05:05.000Z",
            "duration": "27:19",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/detecting-drift",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/detecting-drift.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "48b7c0f6-1d20-4b48-a606-190d314060f1",
            "index": 235,
            "title": "Darts Library for Time Series",
            "pub_date": "2021-05-31T14:52:00.000Z",
            "duration": "25:12",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/darts-library-for-time-series",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/darts-library-for-time-series.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "deaf03c4-00ee-4e57-a6a5-b5abb446f4fe",
            "index": 236,
            "title": "Forecasting Principles and Practice",
            "pub_date": "2021-05-24T14:57:25.000Z",
            "duration": "31:40",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/forecasting-principles-and-practice",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/forecasting-principles-and-practice.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "b117c763-6d6d-4c21-a913-7b4bae951578",
            "index": 237,
            "title": "Prequisites for Time Series",
            "pub_date": "2021-05-21T18:36:25.000Z",
            "duration": "08:41",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/prerequisites-for-time-series",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/prequisites-for-time-series.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "d412b683-f6e7-4a54-86c2-903ff826aacc",
            "index": 238,
            "title": "Orders of Magnitude",
            "pub_date": "2021-05-07T18:55:10.000Z",
            "duration": "33:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/orders-of-magnitude",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/oom.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "97cad4cd-7bc9-494f-a896-3f1f1853266f",
            "index": 239,
            "title": "They're Coming for Our Jobs",
            "pub_date": "2021-05-03T16:00:00.000Z",
            "duration": "43:42",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "automation"
            ],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/theyre-coming-for-our-jobs",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/theyre-coming-for-our-jobs.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6a14158d-9792-4e82-80b3-ce930f3481dd",
            "index": 240,
            "title": "Pandemic Machine Learning Pitfalls",
            "pub_date": "2021-04-26T07:00:00.000Z",
            "duration": "40:17",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/pandemic-machine-learning-pitfalls",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/pandemic-machine-learning-pitfalls.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "c55894f9-78bb-4cdc-845b-813a8fc3d5d4",
            "index": 241,
            "title": "Flesch Kincaid Readability Tests",
            "pub_date": "2021-04-19T07:50:59.000Z",
            "duration": "20:25",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/flesch-kincaid-readability-tests",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/flesch-kincaid-readability-tests.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "aab7ac26-1e1c-45b5-84d7-a3366a996539",
            "index": 242,
            "title": "Fairness Aware Outlier Detection",
            "pub_date": "2021-04-09T15:30:00.000Z",
            "duration": "39:33",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/fairness-aware-outlier-detection",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fairness-aware-outlier-detection.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "62fb4485-caa1-4f8c-9240-aae43c3a05ef",
            "index": 243,
            "title": "Life May be Rare",
            "pub_date": "2021-04-05T14:24:29.000Z",
            "duration": "43:13",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/life-may-be-rare",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/life-may-be-rare.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "803ceba1-3442-4fb7-9803-2a1546d6b6f0",
            "index": 244,
            "title": "Social Networks",
            "pub_date": "2021-03-29T14:21:20.000Z",
            "duration": "49:51",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/social-networks",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/social-networks.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f4ccae62-6426-4bfc-a5b9-9518c6775b79",
            "index": 245,
            "title": "The QAnon Conspiracy",
            "pub_date": "2021-03-22T14:39:29.000Z",
            "duration": "43:54",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/the-qanon-conspiracy",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/the-qanon-conspiracy.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "03bef7c4-6f56-4dfd-ad3c-db98b6401764",
            "index": 246,
            "title": "Benchmarking Vision on Edge vs Cloud",
            "pub_date": "2021-03-15T12:00:00.000Z",
            "duration": "47:53",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/benchmarking-vision-on-edge-vs-cloud",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/benchmarking-vision-on-edge-vs-cloud.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e5a8bd9a-de77-4441-a1a5-f98b8785ffa0",
            "index": 247,
            "title": "Goodhart's Law in Reinforcement Learning",
            "pub_date": "2021-03-05T13:00:00.000Z",
            "duration": "37:11",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/goodharts-law-in-reinforcement-learning",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/goodharts-law-in-reinforcement-learning.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "538ea61f-9e29-4202-96bc-e84d000f761a",
            "index": 248,
            "title": "Video Anomaly Detection",
            "pub_date": "2021-03-01T14:00:00.000Z",
            "duration": "24:06",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/video-anomaly-detection",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/video-anomaly-detection.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7a150b5c-7cb2-4a63-bde7-4872cec2afbe",
            "index": 249,
            "title": "Fault Tolerant Distributed Gradient Descent",
            "pub_date": "2021-02-22T14:30:00.000Z",
            "duration": "36:06",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/fault-tolerant-distributed-gradient-descent",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/fault-tolerant-distributed-gradient-descent.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dcb9dfb0-92af-4a2e-9447-2c1433e798ab",
            "index": 250,
            "title": "Decentralized Information Gathering",
            "pub_date": "2021-02-15T13:30:00.000Z",
            "duration": "32:57",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://dataskeptic.com/blog/episodes/2021/decentralized-information-gathering",
            "audio_url": "https://pscrb.fm/rss/p/mgln.ai/e/35/traffic.libsyn.com/secure/dataskeptic/decentralized-information-gathering.mp3?dest-id=201630",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "ted-ai-show",
        "title": "The TED AI Show",
        "feed_title": "The TED AI Show",
        "priority": "P2",
        "selection_mode": "all_ai",
        "focus": [
          "society",
          "creativity",
          "future of work",
          "public understanding"
        ],
        "feed_url": "https://feeds.acast.com/public/shows/6758564a102e6d4448d19589",
        "source_url": "https://feeds.acast.com/public/shows/6758564a102e6d4448d19589",
        "detail_path": "/podcasts/ted-ai-show/",
        "episode_count": 36,
        "selected_episode_count": 36,
        "latest_episode_title": "Trends for 2025: AI x Crypto - From Agents in Games & DePIN to Proof of Personhood and More | web3 with a16z crypto",
        "latest_pub_date": "2025-04-15T04:00:00.000Z",
        "latest_page_url": "https://audiocollective.ted.com",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "67f7e9bfbb8fcfee75cafd9d",
            "index": 1,
            "title": "Trends for 2025: AI x Crypto - From Agents in Games & DePIN to Proof of Personhood and More | web3 with a16z crypto",
            "pub_date": "2025-04-15T04:00:00.000Z",
            "duration": "41:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/67f7e9bfbb8fcfee75cafd9d/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "67f01e45d4b40d7b30b861f5",
            "index": 2,
            "title": "The magic intelligence in the sky | Good Robot",
            "pub_date": "2025-04-11T04:00:00.000Z",
            "duration": "46:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/67f01e45d4b40d7b30b861f5/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "678fe5f2d186489b148af8a4",
            "index": 3,
            "title": "How Pokemon Go and augmented reality are transforming how we’ll navigate the world w/ Niantic's Brian McClendon",
            "pub_date": "2025-01-21T22:06:16.000Z",
            "duration": "1:09:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/678fe5f2d186489b148af8a4/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "6760c9f027740406d8387653",
            "index": 4,
            "title": "How AI digital doppelgängers could change the way we communicate w/ Synthesia CEO Victor Riparbelli",
            "pub_date": "2024-12-17T05:00:00.000Z",
            "duration": "50:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/6760c9f027740406d8387653/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000679819911",
            "index": 5,
            "title": "Could AI really achieve consciousness? w/ neuroscientist Anil Seth",
            "pub_date": "2024-12-10T05:00:00.000Z",
            "duration": "56:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000679819911/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000678966760",
            "index": 6,
            "title": "How AI robots learn just like babies — but a million times faster w/ NVIDIA’s Rev Lebaredian",
            "pub_date": "2024-12-03T05:00:00.000Z",
            "duration": "53:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000678966760/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000678208313",
            "index": 7,
            "title": "How to stop doom scrolling – and have a better experience online with Jay Van Bavel (from ReThinking)",
            "pub_date": "2024-11-26T05:00:00.000Z",
            "duration": "34:48",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com?rss",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000678208313/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1000677370904",
            "index": 8,
            "title": "Building an AI creator community w/ Civitai founders Justin Maier and Maxfield Hulker",
            "pub_date": "2024-11-19T05:00:00.000Z",
            "duration": "49:45",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000677370904/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000676550420",
            "index": 9,
            "title": "An AI chatbot that talks back w/ ChatGPT’s Advanced Voice Mode",
            "pub_date": "2024-11-12T05:00:00.000Z",
            "duration": "30:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000676550420/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000675674639",
            "index": 10,
            "title": "How AI is changing national security w/ Kathleen Fisher",
            "pub_date": "2024-11-05T05:00:00.000Z",
            "duration": "55:01",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000675674639/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000674764468",
            "index": 11,
            "title": "How open-source AI will reshape power dynamics in tech w/ Hugging Face CSO Thomas Wolf",
            "pub_date": "2024-10-29T04:00:00.000Z",
            "duration": "40:11",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000674764468/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000673921443",
            "index": 12,
            "title": "How AI is changing who gets hired – and who doesn’t w/ Hilke Schellmann",
            "pub_date": "2024-10-22T09:00:00.000Z",
            "duration": "39:06",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000673921443/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000673080771",
            "index": 13,
            "title": "How Meta wants to shape our digital future with open source AI w/ Ragavan Srinivasan",
            "pub_date": "2024-10-15T04:00:00.000Z",
            "duration": "50:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "large language model",
              "llama"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000673080771/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000672142618",
            "index": 14,
            "title": "Is Google’s reign over? The future of AI search w/ Perplexity CEO Aravind Srinivas",
            "pub_date": "2024-10-08T04:00:00.000Z",
            "duration": "35:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "perplexity"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000672142618/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000671352075",
            "index": 15,
            "title": "How AI will transform dubbing in Hollywood w/ Scott Mann",
            "pub_date": "2024-10-01T04:00:00.000Z",
            "duration": "40:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000671352075/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000670438780",
            "index": 16,
            "title": "Your right to mental privacy in the age of brain-sensing tech (from TED Talks Daily)",
            "pub_date": "2024-09-24T04:00:00.000Z",
            "duration": "13:51",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000670438780/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000670059144",
            "index": 17,
            "title": "The UN is speaking up about AI — here’s what they’re saying (w/ Ian Bremmer)",
            "pub_date": "2024-09-19T14:56:02.000Z",
            "duration": "53:56",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000670059144/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000669737018",
            "index": 18,
            "title": "Humanity’s first AI election w/ WIRED's Vittoria Elliott",
            "pub_date": "2024-09-17T04:00:00.000Z",
            "duration": "38:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000669737018/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000668932233",
            "index": 19,
            "title": "Can AI read your mind? The battle for your brain w/ Nita Farahany",
            "pub_date": "2024-09-10T04:00:00.000Z",
            "duration": "35:22",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000668932233/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000667517653",
            "index": 20,
            "title": "Can AI predict (and control) the weather? w/ Dion Harris and Tapio Schneider",
            "pub_date": "2024-09-03T09:00:00.000Z",
            "duration": "36:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "nvidia",
              "data center"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000667517653/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000666668757",
            "index": 21,
            "title": "Sal Khan says AI won’t destroy education — but there’s a catch",
            "pub_date": "2024-08-27T09:00:00.000Z",
            "duration": "36:05",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt"
            ],
            "page_url": "https://play.prx.org/listen?ge=1000666668757&uf=https%3A%2F%2Fpodcasts.ted.com%2FtheTEDAIshow",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000666668757/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 55,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000665930678",
            "index": 22,
            "title": "Why Google search isn’t going anywhere anytime soon (from The Next Wave)",
            "pub_date": "2024-08-20T09:00:00.000Z",
            "duration": "50:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 3,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "http://go.ted.com/abdoulayediabate?rss",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000665930678/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "1000665071399",
            "index": 23,
            "title": "How to make yourself more human in an automated world (from How to Be a Better Human)",
            "pub_date": "2024-08-13T04:00:00.000Z",
            "duration": "34:23",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "coding"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000665071399/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000664407700",
            "index": 24,
            "title": "Why AI needs a \"nutrition label\" (from TED Talks Daily)",
            "pub_date": "2024-08-06T04:00:00.000Z",
            "duration": "14:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "artificial intelligence"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000664407700/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000663721027",
            "index": 25,
            "title": "will.i.am on AI – and the future of creativity (from ReThinking with Adam Grant)",
            "pub_date": "2024-07-30T04:00:00.000Z",
            "duration": "31:57",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000663721027/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000663022739",
            "index": 26,
            "title": "Will AI replace me? with AJ. Jacobs (from Fixable)",
            "pub_date": "2024-07-23T04:00:00.000Z",
            "duration": "33:36",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000663022739/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000662040933",
            "index": 27,
            "title": "The AI-powered tools supercharging your imagination",
            "pub_date": "2024-07-16T04:00:00.000Z",
            "duration": "18:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000662040933/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000661575998",
            "index": 28,
            "title": "Is AI just all hype? w/ Gary Marcus",
            "pub_date": "2024-07-09T04:00:00.000Z",
            "duration": "39:04",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai",
              "chatgpt"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000661575998/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000660919730",
            "index": 29,
            "title": "Will AI “eat software” — and what’ll happen to coders? w/ GitHub CEO Thomas Dohmke",
            "pub_date": "2024-07-02T04:00:00.000Z",
            "duration": "29:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000660919730/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000660096361",
            "index": 30,
            "title": "AI therapy is here. What does it mean for you? w/ Dr. Alison Darcy and Brian Chandler",
            "pub_date": "2024-06-25T04:00:00.000Z",
            "duration": "40:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000660096361/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000659301098",
            "index": 31,
            "title": "Your next best friend may be 100% AI w/ Purnendu Mukherjee",
            "pub_date": "2024-06-18T04:00:00.000Z",
            "duration": "30:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000659301098/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000658491012",
            "index": 32,
            "title": "Why we can't fix bias with more AI w/ Patrick Lin",
            "pub_date": "2024-06-11T04:00:00.000Z",
            "duration": "34:00",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000658491012/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000657694855",
            "index": 33,
            "title": "AI may take jobs – but not our creativity w/ artist Claire Silver",
            "pub_date": "2024-06-04T04:00:00.000Z",
            "duration": "31:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000657694855/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000657049960",
            "index": 34,
            "title": "What really went down at OpenAI and the future of regulation w/ Helen Toner",
            "pub_date": "2024-05-28T09:00:00.000Z",
            "duration": "40:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "chatgpt",
              "openai"
            ],
            "page_url": "https://audiocollective.ted.com",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000657049960/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 105,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "1000655951231",
            "index": 35,
            "title": "Is AI destroying our sense of reality? with Sam Gregory",
            "pub_date": "2024-05-21T09:00:00.000Z",
            "duration": "27:25",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "generative ai"
            ],
            "page_url": "https://www.ted.com/podcasts/the-ted-ai-show",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/1000655951231/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "available",
              "transcript_source_kind": "official_web_transcript",
              "transcript_record_count": 27,
              "transcript_promoted_to_radar": true,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "generate_cn_knowledge_optional",
              "blocking_reason": ""
            }
          },
          {
            "id": "prx_6792_fcfd0498-0228-4969-92c2-3fe2e31598b1",
            "index": 36,
            "title": "The TED AI Show - Coming May 21st",
            "pub_date": "2024-04-16T06:39:59.000Z",
            "duration": "1:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://play.prx.org/listen?ge=prx_6792_fcfd0498-0228-4969-92c2-3fe2e31598b1&uf=https%3A%2F%2Fpodcasts.ted.com%2FtheTEDAIshow",
            "audio_url": "https://sphinx.acast.com/p/open/s/6758564a102e6d4448d19589/e/prx_6792_fcfd0498-0228-4969-92c2-3fe2e31598b1/media.mp3",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "google-ai-release-notes",
        "title": "Google AI: Release Notes",
        "feed_title": "Google AI: Release Notes",
        "priority": "P2",
        "selection_mode": "all_ai",
        "focus": [
          "Gemini",
          "Google AI Studio",
          "developer APIs",
          "model releases"
        ],
        "feed_url": "https://feeds.simplecast.com/niac4zV1",
        "source_url": "https://feeds.simplecast.com/niac4zV1",
        "detail_path": "/podcasts/google-ai-release-notes/",
        "episode_count": 27,
        "selected_episode_count": 27,
        "latest_episode_title": "Google Maps Leaders Talk About Its Biggest Update in 10 Years",
        "latest_pub_date": "2026-03-12T21:48:45.000Z",
        "latest_page_url": "https://google-ai-release-notes.simplecast.com/episodes/google-maps-leaders-talk-about-its-biggest-update-in-10-years-M_I_dRoD",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "269e2f7b-0b2e-4105-a58c-f629619e1f18",
            "index": 1,
            "title": "Google Maps Leaders Talk About Its Biggest Update in 10 Years",
            "pub_date": "2026-03-12T21:48:45.000Z",
            "duration": "00:36:03",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "gemini"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/google-maps-leaders-talk-about-its-biggest-update-in-10-years-M_I_dRoD",
            "audio_url": "https://cdn.simplecast.com/media/audio/transcoded/8d1b89f9-c362-4126-8d8a-b028e80680d5/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/audio/group/b9637e84-6834-498d-bf98-81a198bd6e16/group-item/3ef0f1dc-a18b-46c8-bc25-16941eb6da37/128_default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e9644482-008a-4348-9e3d-583605e2de0e",
            "index": 2,
            "title": "Gemini in Workspace: New Ways to Create Faster",
            "pub_date": "2026-03-12T21:38:45.000Z",
            "duration": "00:40:12",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "coding"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/gemini-in-workspace-new-ways-to-create-faster-qRvYkgg_",
            "audio_url": "https://cdn.simplecast.com/media/audio/transcoded/8d1b89f9-c362-4126-8d8a-b028e80680d5/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/audio/group/7703263d-73a1-46ca-85b4-8b12f8ad4250/group-item/74cf9b16-36c0-41e6-bb77-130c45ff0190/128_default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "da9de9f0-f9fa-43ea-84af-2203de6fc7d4",
            "index": 3,
            "title": "Gemini in Chrome: Your agentic browsing assistant",
            "pub_date": "2026-03-12T21:36:09.000Z",
            "duration": "00:48:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "gemini",
              "alignment",
              "safety"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/gemini-in-chrome-your-agentic-browsing-assistant-L2qv6wiW",
            "audio_url": "https://cdn.simplecast.com/media/audio/transcoded/8d1b89f9-c362-4126-8d8a-b028e80680d5/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/audio/group/88cf3912-00a7-4610-ba94-c20c2d4df55e/group-item/d5688c41-92b7-4dbe-be9f-2baa0b824785/128_default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f2a23fd9-0a40-486f-a529-4b6a1830e168",
            "index": 4,
            "title": "Inside Lyria 3, Google's music generation model",
            "pub_date": "2026-02-18T20:00:00.000Z",
            "duration": "00:36:38",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "ai",
              "a.i."
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/inside-lyria-3-googles-music-generation-model-xNnOLgIN",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/a97f1cb1-01c2-44e5-a473-cf08720564bc/audio/edefe902-b569-4cf5-a7f8-19dd11047af7/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0c40e5ef-d79f-4cc5-b5c5-fb80c694965b",
            "index": 5,
            "title": "Project Genie: Create and explore worlds",
            "pub_date": "2026-01-30T17:45:09.000Z",
            "duration": "00:42:31",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 1,
            "matched_keywords": [
              "robotics"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/project-genie-create-and-explore-worlds-_52W_tRH",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/dfe2e6e9-dfdb-47a1-8021-4acf953c35db/audio/ed97fe8d-1c33-4535-8ebb-ced52ae6732a/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "91b818e6-b496-4f04-a9d3-403b05210b4b",
            "index": 6,
            "title": "Gemini 3 and Gen UI in Google Search",
            "pub_date": "2025-12-18T21:44:43.000Z",
            "duration": "00:21:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "gemini"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/gemini-3-and-gen-ui-in-google-search-PQhbsQbN",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/ef5c3ebf-469f-4e77-a6d0-0cee88182cde/audio/c5fe31bd-5841-411d-bffd-04f937c9bd3b/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "6942404f-d92b-4cf5-94f6-40e45310bbb3",
            "index": 7,
            "title": "Sundar Pichai: Gemini 3, Vibe Coding and Google's Full Stack Strategy",
            "pub_date": "2025-11-26T22:26:20.000Z",
            "duration": "00:27:34",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "gemini",
              "coding"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/sundar-pichai-gemini-3-vibe-coding-and-googles-full-stack-strategy-OFkDXDVG",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/49d9e29b-f4b0-46c0-9fac-80781c13b1ab/audio/1b4cd561-6c5d-4267-a7e9-841208c95a7e/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13c99014-8008-4025-95e3-5e21fe92a516",
            "index": 8,
            "title": "Nano Banana Pro: Hands-on with the World’s Most Powerful Image Model",
            "pub_date": "2025-11-26T22:19:51.000Z",
            "duration": "00:36:24",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "gemini",
              "reasoning"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/nano-banana-pro-hands-on-with-the-worlds-most-powerful-image-model-EZxl7d1V",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/c868b2b7-a544-4fe8-be61-4afdb7e04490/audio/2903b099-82c0-4250-9747-3268e03f12da/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f1cadf7-b4ee-4199-9b8a-b1fe0d12d485",
            "index": 9,
            "title": "Koray Kavukcuoglu: “This Is How We Are Going to Build AGI”",
            "pub_date": "2025-11-25T00:45:59.000Z",
            "duration": "00:48:44",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind",
              "gemini"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/koray-kavukcuoglu-this-is-how-we-are-going-to-build-agi-VEzpyLmh",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/c0b9db3e-d0cb-49fc-a7b1-210bff72db1c/audio/09f25ef5-6e77-4adf-95eb-ee21f2e52891/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "7fb5e1bd-2751-4b5a-bfba-2f389aee39a4",
            "index": 10,
            "title": "Google Antigravity: Hands on with our new agentic development platform",
            "pub_date": "2025-11-25T00:45:48.000Z",
            "duration": "00:44:49",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 12,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agent",
              "agents",
              "agentic",
              "deepmind",
              "gemini",
              "multimodal"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/google-antigravity-hands-on-with-our-new-agentic-development-platform-Dd6xd5WJ",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/6cb83c74-8a4f-4f92-834e-606bd54874d6/audio/bedece0e-22c6-48ba-af2d-4c83a16afc70/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "e117ad94-703e-4b3b-a545-fc8700897bbc",
            "index": 11,
            "title": "Gemini 3: Launch day reactions",
            "pub_date": "2025-11-25T00:44:47.000Z",
            "duration": "00:42:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "gemini",
              "multimodal"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/gemini-3-launch-day-reactions-WCnzR2Y8",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/aaf441cf-a3ee-43c0-ab65-4419d01380a4/audio/6939ef3f-ccef-4f71-91dd-cfdac82889b0/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ff188317-1bab-4375-ae9c-02913bee662a",
            "index": 12,
            "title": "How a Moonshot Led to Google DeepMind's Veo 3",
            "pub_date": "2025-10-16T01:26:13.000Z",
            "duration": "00:48:10",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "robotics"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/how-a-moonshot-led-to-google-deepminds-veo-3-pcCVL5KH",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/6a37974a-5a0f-40ce-a90a-babff358ec9e/audio/d5660c23-224b-45b2-a4c0-9f7a5ec44e4f/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "13b03199-0804-4398-8ec9-e23bdda4f558",
            "index": 13,
            "title": "GDM’s Pushmeet Kohli on solving science's biggest challenges with AI",
            "pub_date": "2025-09-15T16:31:39.000Z",
            "duration": "00:37:28",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "deepmind"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/gdms-pushmeet-kohli-on-solving-sciences-biggest-challenges-with-ai-U3BB6k5G",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/70884187-1185-4658-a007-fb05e691b983/audio/ba6c7525-afd5-49f8-bb9c-77c96383d3a2/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "04cbfa67-b6b8-4d02-8403-cb57bc4ed5d2",
            "index": 14,
            "title": "Behind the scenes of Google's state-of-the-art \"nano-banana\" image model",
            "pub_date": "2025-08-27T00:45:00.000Z",
            "duration": "00:30:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 2,
            "matched_keywords": [
              "gemini",
              "evals"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/behind-the-scenes-of-googles-state-of-the-art-nano-banana-image-model-_Jtmi3CW",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/ef9d25a5-d83d-4376-9c6f-72982ca5a1f5/audio/ca1fa06c-8943-4d96-a998-8370da173931/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3aaac72e-3b3c-45b1-8e85-1ac01aefffcf",
            "index": 15,
            "title": "Demis Hassabis on shipping momentum, better evals and world models",
            "pub_date": "2025-08-11T17:03:31.000Z",
            "duration": "00:31:09",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 8,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agi",
              "agent",
              "deepmind",
              "evals"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/demis-hassabis-on-shipping-momentum-better-evals-and-world-models-AkZcL0Oe",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/28c1f7fe-ee23-40b5-a937-c6b120005ead/audio/be22d7c4-9400-43fc-8687-487447f0c3d7/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "fdc2a6f5-50dc-4c4a-957d-4e44beea84bc",
            "index": 16,
            "title": "Building real-time voice applications with Live API",
            "pub_date": "2025-08-06T07:22:26.000Z",
            "duration": "00:40:14",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "multimodal"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/building-real-time-voice-applications-with-live-api-brFoE9Wa",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/1196d0a1-db50-4a87-ae0a-fdf90ef149ad/audio/4bbcb459-3d5e-4807-82a1-51ed6fd7e3ed/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3f38dca8-1795-4206-921f-5e69fc32e8d7",
            "index": 17,
            "title": "Building a frontier AI search experience",
            "pub_date": "2025-07-23T19:05:00.000Z",
            "duration": "00:43:16",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "agentic",
              "deepmind",
              "gemini",
              "multimodal"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/building-a-frontier-ai-search-experience-mrw0fgtZ",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/c91f6af2-539b-4577-8bd5-f5344316d20e/audio/2e7ed2b7-8b2f-426c-9693-17a4ee5a3007/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc287686-de49-4e52-9f8b-55e3fd021431",
            "index": 18,
            "title": "Gemini's Multimodality",
            "pub_date": "2025-07-02T22:27:37.000Z",
            "duration": "00:44:17",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 6,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "multimodal"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/geminis-multimodality-VctGtJJi",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/7d5d0c57-f399-42f4-9dc6-42212886fa05/audio/0abe674e-0782-4637-9edf-a792e707e2fd/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "0a196801-c8f1-4a67-bb64-b50a1803df99",
            "index": 19,
            "title": "Building Gemini's Coding Capabilities",
            "pub_date": "2025-06-16T19:44:55.000Z",
            "duration": "01:00:27",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 10,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "gemini",
              "reasoning",
              "coding"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/building-geminis-coding-capabilities-epaqJzYi",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/487caaf8-2fa3-4df9-9fc2-637b4a3fc0ed/audio/9a9fec6a-abab-4490-a3dd-ea96ddb7b4bf/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "dc38a14e-2ebc-44de-9b88-6aa37b58717f",
            "index": 20,
            "title": "Sergey Brin on the Future of AI & Gemini",
            "pub_date": "2025-06-16T19:38:55.000Z",
            "duration": "00:27:19",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 11,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "training",
              "reasoning"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/sergey-brin-on-the-future-of-ai-gemini-iZX8C2km",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/0418899f-549c-4c3e-8f71-c8a56f273560/audio/33ac83dc-0739-49d7-9720-ebf4a28c6a95/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ecb94ef7-3a48-4fe2-803f-3498a6fdb742",
            "index": 21,
            "title": "Google I/O 2025 Recap with Josh Woodward and Tulsee Doshi",
            "pub_date": "2025-05-22T17:39:16.000Z",
            "duration": "00:40:15",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "deepmind",
              "gemini"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/google-i-o-2025-recap-with-josh-woodward-and-tulsee-doshi-4sL_YsLo",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/b45a48fe-f192-4477-a9ae-760e2552f72f/audio/5d635fae-d1ff-4f30-af68-420cd295f0c0/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "3eb40761-aad7-4180-a4d5-86b8c1272ac8",
            "index": 22,
            "title": "Deep Dive into Long Context",
            "pub_date": "2025-05-02T15:24:03.000Z",
            "duration": "00:59:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agents",
              "deepmind",
              "reasoning",
              "rag",
              "retrieval"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/deep-dive-into-long-context-QTFUO7xf",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/65c9ced4-9f3a-40a5-89fe-2ff0e5124c82/audio/7a5dab51-34de-4405-b4f2-3bc9ccc4844b/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "a39707a5-1662-4da7-8f8f-a1f0ad69db12",
            "index": 23,
            "title": "Launching Gemini 2.5",
            "pub_date": "2025-03-28T21:12:22.000Z",
            "duration": "00:27:55",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 13,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agentic",
              "gemini",
              "google ai",
              "training",
              "reasoning",
              "safety"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/launching-gemini-25-CsDOk7Xw",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/5f339b6e-00d1-4b39-9883-bce0fc931f15/audio/7c741811-586d-44a1-a552-3d4afda68c09/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "58ae1e4a-83ce-40d7-b401-f6eb41011c99",
            "index": 24,
            "title": "Gemini app: Canvas, Deep Research and Personalization",
            "pub_date": "2025-03-20T16:00:00.000Z",
            "duration": "00:36:53",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "agentic",
              "gemini"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/gemini-app-canvas-deep-research-and-personalization-2_rBtEHE",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/7e5e8c65-c258-4523-b922-66cc2ae1a953/audio/049c55a5-bdd0-41e1-aca7-e222070200f9/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "8be68878-54fb-4ad3-b020-60232049c7f5",
            "index": 25,
            "title": "Developing Google DeepMind's Thinking Models",
            "pub_date": "2025-02-24T20:19:25.000Z",
            "duration": "01:03:32",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 7,
            "matched_keywords": [
              "ai",
              "a.i.",
              "agents",
              "deepmind",
              "evals"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/developing-google-deepminds-thinking-models-n2Z_GX_J",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/533d25a8-8c4f-46a8-be45-d6fb9b33a358/audio/d960b18f-193f-4cd0-9d38-855c0f1aa3b9/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "20396b74-ef68-4bf4-ac89-1332d518915e",
            "index": 26,
            "title": "Behind the Scenes of Gemini 2.0",
            "pub_date": "2024-12-11T16:01:54.000Z",
            "duration": "00:35:18",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 5,
            "matched_keywords": [
              "agents",
              "gemini",
              "multimodal"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/behind-the-scenes-of-gemini-20-kVTO2UT5",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/059bb440-65d9-4cca-931a-afc1a2d4cd47/audio/93e65703-8c2c-40ed-aff8-a7adf3d1c4a9/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "f96ca290-889e-4f12-824c-40c92508380e",
            "index": 27,
            "title": "Smaller, Faster, Cheaper & The Story of Flash 8B",
            "pub_date": "2024-12-05T22:55:01.000Z",
            "duration": "00:43:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 4,
            "matched_keywords": [
              "ai",
              "a.i.",
              "gemini",
              "training"
            ],
            "page_url": "https://google-ai-release-notes.simplecast.com/episodes/smaller-faster-cheaper-the-story-of-flash-8b-61azQD2P",
            "audio_url": "https://cdn.simplecast.com/audio/c68ffadd-1655-4420-a3c1-6df8dd507951/episodes/010cc18e-36df-488a-97f2-d2d085c6637d/audio/1acc344f-c58f-4293-974d-2ab2f12f9289/default_tc.mp3?aid=rss_feed&feed=niac4zV1",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      },
      {
        "id": "hard-fork",
        "title": "Hard Fork",
        "feed_title": "Hard Fork",
        "priority": "P2",
        "selection_mode": "keyword",
        "focus": [
          "AI news",
          "big tech",
          "consumer products"
        ],
        "feed_url": "https://feeds.simplecast.com/6HKOhNgS",
        "source_url": "https://feeds.simplecast.com/6HKOhNgS",
        "detail_path": "/podcasts/hard-fork/",
        "episode_count": 3,
        "selected_episode_count": 1,
        "latest_episode_title": "Hot I.P.O Summer + What Is A.I. Doing to Math? + HatGPT",
        "latest_pub_date": "2026-06-05T11:00:00.000Z",
        "latest_page_url": "https://www.nytimes.com/column/hard-fork",
        "has_play_count_data": false,
        "episodes": [
          {
            "id": "0235c1af-ecf6-4d7e-ad5a-6d8319398a2c",
            "index": 1,
            "title": "Hot I.P.O Summer + What Is A.I. Doing to Math? + HatGPT",
            "pub_date": "2026-06-05T11:00:00.000Z",
            "duration": "01:04:20",
            "duration_label": "",
            "selected": true,
            "confidence": "high",
            "score": 9,
            "matched_keywords": [
              "ai",
              "a.i.",
              "openai",
              "anthropic",
              "meta ai"
            ],
            "page_url": "https://www.nytimes.com/column/hard-fork",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pdst.fm/e/pfx.vpixl.com/6qj4J/pscrb.fm/rss/p/nyt.simplecastaudio.com/3e43d072-f8a5-430f-bc8e-4c70aafdf3c7/episodes/251f62fd-3b1d-4f8b-a5b0-0966414c7f74/audio/128/default.mp3?aid=rss_feed&awCollectionId=3e43d072-f8a5-430f-bc8e-4c70aafdf3c7&awEpisodeId=251f62fd-3b1d-4f8b-a5b0-0966414c7f74&feed=6HKOhNgS",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "ac9b5539-ffff-4492-8fb3-912754ec9cdd",
            "index": 2,
            "title": "Interesting Times: Why Are We Still Driving?",
            "pub_date": "2026-05-29T11:00:00.000Z",
            "duration": "00:58:39",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.nytimes.com/column/hard-fork",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pdst.fm/e/pfx.vpixl.com/6qj4J/pscrb.fm/rss/p/nyt.simplecastaudio.com/3e43d072-f8a5-430f-bc8e-4c70aafdf3c7/episodes/897baa98-204a-4e26-b77f-b979c4b8f93e/audio/128/default.mp3?aid=rss_feed&awCollectionId=3e43d072-f8a5-430f-bc8e-4c70aafdf3c7&awEpisodeId=897baa98-204a-4e26-b77f-b979c4b8f93e&feed=6HKOhNgS",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          },
          {
            "id": "4e573fc5-f8ff-404c-af6e-a003d8835d31",
            "index": 3,
            "title": "What’s a Hard Fork?",
            "pub_date": "2022-09-27T14:00:00.000Z",
            "duration": "00:01:24",
            "duration_label": "",
            "selected": false,
            "confidence": "candidate",
            "score": 0,
            "matched_keywords": [],
            "page_url": "https://www.nytimes.com/2022/10/04/podcasts/hard-fork-technology.html",
            "audio_url": "https://dts.podtrac.com/redirect.mp3/pdst.fm/e/pfx.vpixl.com/6qj4J/pscrb.fm/rss/p/nyt.simplecastaudio.com/3e43d072-f8a5-430f-bc8e-4c70aafdf3c7/episodes/e8ace451-6d90-460a-acca-9e715422ea13/audio/128/default.mp3?aid=rss_feed&awCollectionId=3e43d072-f8a5-430f-bc8e-4c70aafdf3c7&awEpisodeId=e8ace451-6d90-460a-acca-9e715422ea13&feed=6HKOhNgS",
            "play_count": null,
            "show_notes_text": "",
            "show_notes_source": "",
            "show_notes_links": [],
            "readiness": {
              "audio_status": "available",
              "audio_local_file_present": false,
              "transcript_status": "missing",
              "transcript_source_kind": "",
              "transcript_record_count": 0,
              "transcript_promoted_to_radar": false,
              "cn_knowledge_status": "missing",
              "cn_knowledge_insight_count": 0,
              "processing_next_action": "wait_for_transcript_or_asr_enabled",
              "blocking_reason": "asr_not_enabled"
            }
          }
        ]
      }
    ]
  },
  "items": [
    {
      "id": "case-anthropic-model-change-testing",
      "type": "case",
      "title": "Anthropic 用全流程测试和早期客户验证控制模型改动副作用",
      "person": "Dario Amodei, Anthropic CEO",
      "org_or_role": "Anthropic",
      "summary": "Dario Amodei, Anthropic CEO · Anthropic",
      "episode_id": "452-dario-amodei-anthropic-ceo-on-claude-agi-the-future-of-ai-humanity",
      "episode_label": "Dario Amodei Anthropic Ceo On Claude",
      "tags": [
        "model-ops",
        "evaluation",
        "customer-testing"
      ],
      "quote": "It’s difficult from an inference perspective and it’s actually hard to control all the consequences of changing the weights of the model.",
      "timestamp": "00:43:09",
      "claim": "把模型改动纳入正式流程，并结合内部测试和 early customer user testing。"
    },
    {
      "id": "insight-scaling-laws-need-all-three-reagents",
      "type": "insight",
      "title": "Dario Amodei 把 scaling law 讲成三个试剂必须一起放大",
      "person": "Dario Amodei",
      "org_or_role": "Anthropic CEO",
      "summary": "Dario Amodei · Anthropic CEO",
      "episode_id": "452-dario-amodei-anthropic-ceo-on-claude-agi-the-future-of-ai-humanity",
      "episode_label": "Dario Amodei Anthropic Ceo On Claude",
      "tags": [
        "scaling-laws",
        "training",
        "infrastructure"
      ],
      "quote": "you have three ingredients in the chemical reaction and you need to linearly scale up the three ingredients. If you scale up one, not the others, you run out of the other reagents and the reaction stops.",
      "timestamp": "00:07:17",
      "claim": "更大的网络、更多训练时间和更多数据必须协同放大，单独拉一项会先撞到其他瓶颈。"
    },
    {
      "id": "insight-agi-timeline-extrapolation",
      "type": "insight",
      "title": "Dario Amodei 认为按现有能力曲线外推，强 AI 可能在 2026 或 2027 抵达",
      "person": "Dario Amodei",
      "org_or_role": "Anthropic CEO",
      "summary": "Dario Amodei · Anthropic CEO",
      "episode_id": "452-dario-amodei-anthropic-ceo-on-claude-agi-the-future-of-ai-humanity",
      "episode_label": "Dario Amodei Anthropic Ceo On Claude",
      "tags": [
        "forecasting",
        "capability-scaling",
        "agi"
      ],
      "quote": "If you just kind of eyeball the rate at which these capabilities are increasing, it does make you think that we’ll get there by 2026 or 2027.",
      "timestamp": "00:00:00",
      "claim": "如果按当前模型能力增长速度粗略外推，接近 PhD 级别的强 AI 可能在 2026 或 2027 到来。"
    },
    {
      "id": "insight-model-dumbing-down-is-often-a-perception-problem",
      "type": "insight",
      "title": "Dario Amodei 认为模型“变笨”投诉常混杂 A/B 测试、系统提示词和心理基线变化",
      "person": "Dario Amodei",
      "org_or_role": "Anthropic CEO",
      "summary": "Dario Amodei · Anthropic CEO",
      "episode_id": "452-dario-amodei-anthropic-ceo-on-claude-agi-the-future-of-ai-humanity",
      "episode_label": "Dario Amodei Anthropic Ceo On Claude",
      "tags": [
        "model-behavior",
        "ab-testing",
        "product-perception"
      ],
      "quote": "You actually end up changing 100 things as well. So we have a whole process for it and we have a whole process for modifying the model.",
      "timestamp": "00:43:09",
      "claim": "用户感知到的模型“变笨”并不等于权重被随机改坏，很多时候是实验流量、系统提示词变化或用户预期抬高造成的。"
    },
    {
      "id": "case-openclaw-self-modifying-agent",
      "type": "case",
      "title": "OpenClaw 把 agent 做成可自我修改的软件体",
      "person": "Peter Steinberger, OpenClaw creator",
      "org_or_role": "OpenClaw",
      "summary": "Peter Steinberger, OpenClaw creator · OpenClaw",
      "episode_id": "491-openclaw-the-viral-ai-agent-that-broke-the-internet-peter-steinberger",
      "episode_label": "Openclaw The Viral AI Agent That",
      "tags": [
        "ai-coding",
        "agent",
        "harness"
      ],
      "quote": "It understands its own system that made it very easy for an agent to… Oh, you don’t like anything? You just prompted it to existence, and then the agent would just modify its own software.",
      "timestamp": "00:00:00",
      "claim": "把 source code、harness、documentation 和 model 信息暴露给 agent，让它能修改自己的软件。"
    },
    {
      "id": "insight-agentic-engineering-over-wipe-coding",
      "type": "insight",
      "title": "Peter Steinberger 把持续可维护的做法叫做 agentic engineering",
      "person": "Peter Steinberger",
      "org_or_role": "OpenClaw creator and agent builder",
      "summary": "Peter Steinberger · OpenClaw creator and agent builder",
      "episode_id": "491-openclaw-the-viral-ai-agent-that-broke-the-internet-peter-steinberger",
      "episode_label": "Openclaw The Viral AI Agent That",
      "tags": [
        "agent",
        "engineering",
        "workflow"
      ],
      "quote": "I do agentic engineering, and then maybe after 3:00 AM, I switch to wipe coding, and then I have regrets on the next day.",
      "timestamp": "00:00:33",
      "claim": "更合理的工作方式是 agentic engineering；凌晨失控式的 wipe coding 往往会带来第二天的返工后悔。"
    },
    {
      "id": "case-photoai-nsfw-guardrail",
      "type": "case",
      "title": "Photo AI 用 prompt 约束和 Vision 审核压住 NSFW 风险",
      "person": "Pieter Levels, indie founder",
      "org_or_role": "Photo AI",
      "summary": "Pieter Levels, indie founder · Photo AI",
      "episode_id": "440-pieter-levels-programming-viral-ai-startups-and-digital-nomad-life",
      "episode_label": "Pieter Levels Programming Viral AI Startups",
      "tags": [
        "imaging",
        "safety",
        "guardrails"
      ],
      "quote": "everybody needs to do this with AI startups, with imaging, you need to prompt out the naked stuff.",
      "timestamp": "00:00:00",
      "claim": "在 prompt 层明确排除裸露内容，并在展示前用 Google Vision 做 NSFW 检测。"
    },
    {
      "id": "insight-founders-should-stay-builders",
      "type": "insight",
      "title": "Pieter Levels 认为很多创业者更适合持续做 builder 而不是变成 manager",
      "person": "Pieter Levels",
      "org_or_role": "indie founder with 40+ shipped startups",
      "summary": "Pieter Levels · indie founder with 40+ shipped startups",
      "episode_id": "440-pieter-levels-programming-viral-ai-startups-and-digital-nomad-life",
      "episode_label": "Pieter Levels Programming Viral AI Startups",
      "tags": [
        "founders",
        "career",
        "indie"
      ],
      "quote": "they tell me, “Next time, if I’m going to do it, I’m going to do it like you, because it’s more fun, it’s more indie, it’s more chill, it’s more creative.”",
      "timestamp": "00:07:32",
      "claim": "不少创业者并不喜欢成为 CEO/manager，他们真正喜欢的是写代码和做 ground work。"
    },
    {
      "id": "case-viptunnel-zig-refactor",
      "type": "case",
      "title": "Viptunnel 用 Codex 隔夜完成高内存架构段重写",
      "person": "Peter Steinberger, Viptunnel builder",
      "org_or_role": "Viptunnel",
      "summary": "Peter Steinberger, Viptunnel builder · Viptunnel",
      "episode_id": "491-openclaw-the-viral-ai-agent-that-broke-the-internet-peter-steinberger",
      "episode_label": "Openclaw The Viral AI Agent That",
      "tags": [
        "ai-coding",
        "refactoring",
        "performance"
      ],
      "quote": "Every terminal used like a node. And I wanted to change it to Rust and… I mean, I can do it. I can, I can manually figure it all out, but all my automated attempts failed miserably.",
      "timestamp": "00:09:41",
      "claim": "直接让 Codex 把高内存部分转换到更实验性的实现路径，并长时间自主运行。"
    },
    {
      "id": "case-whatsapp-cli-prototype",
      "type": "case",
      "title": "WhatsApp + cloud code 一小时做出可对话原型",
      "person": "Peter Steinberger, prototype builder",
      "org_or_role": "OpenClaw prototype",
      "summary": "Peter Steinberger, prototype builder · OpenClaw prototype",
      "episode_id": "491-openclaw-the-viral-ai-agent-that-broke-the-internet-peter-steinberger",
      "episode_label": "Openclaw The Viral AI Agent That",
      "tags": [
        "agent",
        "harness-smoke",
        "messaging",
        "prototype"
      ],
      "quote": "my search bar was literally just hooking up WhatsApp to cloud code. One shot. The CLI message comes in. I call the CLI with -p. It does its magic, I get the string back and I send it back to WhatsApp.",
      "timestamp": "00:10:52",
      "claim": "把 WhatsApp 输入直接接到 CLI `-p`，拿回字符串结果再发回 WhatsApp。"
    }
  ]
};
